import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _text: any;
  _uuid: any;
  bigint: any;
  date: any;
  json: any;
  jsonb: any;
  numeric: any;
  smallint: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};


/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};




/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};


/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: Maybe<Scalars['json']>;
  _gt?: Maybe<Scalars['json']>;
  _gte?: Maybe<Scalars['json']>;
  _in?: Maybe<Array<Scalars['json']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['json']>;
  _lte?: Maybe<Scalars['json']>;
  _neq?: Maybe<Scalars['json']>;
  _nin?: Maybe<Array<Scalars['json']>>;
};


export type Jsonb_Cast_Exp = {
  String?: Maybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: Maybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "risolto.account_number_type" */
  delete_risolto_account_number_type?: Maybe<Risolto_Account_Number_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.account_number_type" */
  delete_risolto_account_number_type_by_pk?: Maybe<Risolto_Account_Number_Type>;
  /** delete data from the table: "risolto.action" */
  delete_risolto_action?: Maybe<Risolto_Action_Mutation_Response>;
  /** delete single row from the table: "risolto.action" */
  delete_risolto_action_by_pk?: Maybe<Risolto_Action>;
  /** delete data from the table: "risolto.action_execution_type" */
  delete_risolto_action_execution_type?: Maybe<Risolto_Action_Execution_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.action_execution_type" */
  delete_risolto_action_execution_type_by_pk?: Maybe<Risolto_Action_Execution_Type>;
  /** delete data from the table: "risolto.action_interchange" */
  delete_risolto_action_interchange?: Maybe<Risolto_Action_Interchange_Mutation_Response>;
  /** delete single row from the table: "risolto.action_interchange" */
  delete_risolto_action_interchange_by_pk?: Maybe<Risolto_Action_Interchange>;
  /** delete data from the table: "risolto.action_invoice" */
  delete_risolto_action_invoice?: Maybe<Risolto_Action_Invoice_Mutation_Response>;
  /** delete single row from the table: "risolto.action_invoice" */
  delete_risolto_action_invoice_by_pk?: Maybe<Risolto_Action_Invoice>;
  /** delete data from the table: "risolto.action_source" */
  delete_risolto_action_source?: Maybe<Risolto_Action_Source_Mutation_Response>;
  /** delete single row from the table: "risolto.action_source" */
  delete_risolto_action_source_by_pk?: Maybe<Risolto_Action_Source>;
  /** delete data from the table: "risolto.action_status" */
  delete_risolto_action_status?: Maybe<Risolto_Action_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.action_status" */
  delete_risolto_action_status_by_pk?: Maybe<Risolto_Action_Status>;
  /** delete data from the table: "risolto.analytics_company_score" */
  delete_risolto_analytics_company_score?: Maybe<Risolto_Analytics_Company_Score_Mutation_Response>;
  /** delete single row from the table: "risolto.analytics_company_score" */
  delete_risolto_analytics_company_score_by_pk?: Maybe<Risolto_Analytics_Company_Score>;
  /** delete data from the table: "risolto.analytics_invoice_features" */
  delete_risolto_analytics_invoice_features?: Maybe<Risolto_Analytics_Invoice_Features_Mutation_Response>;
  /** delete single row from the table: "risolto.analytics_invoice_features" */
  delete_risolto_analytics_invoice_features_by_pk?: Maybe<Risolto_Analytics_Invoice_Features>;
  /** delete data from the table: "risolto.analytics_invoice_prediction" */
  delete_risolto_analytics_invoice_prediction?: Maybe<Risolto_Analytics_Invoice_Prediction_Mutation_Response>;
  /** delete single row from the table: "risolto.analytics_invoice_prediction" */
  delete_risolto_analytics_invoice_prediction_by_pk?: Maybe<Risolto_Analytics_Invoice_Prediction>;
  /** delete data from the table: "risolto.analytics_test" */
  delete_risolto_analytics_test?: Maybe<Risolto_Analytics_Test_Mutation_Response>;
  /** delete single row from the table: "risolto.analytics_test" */
  delete_risolto_analytics_test_by_pk?: Maybe<Risolto_Analytics_Test>;
  /** delete data from the table: "risolto.analytics_test_result" */
  delete_risolto_analytics_test_result?: Maybe<Risolto_Analytics_Test_Result_Mutation_Response>;
  /** delete single row from the table: "risolto.analytics_test_result" */
  delete_risolto_analytics_test_result_by_pk?: Maybe<Risolto_Analytics_Test_Result>;
  /** delete data from the table: "risolto.api_app_client" */
  delete_risolto_api_app_client?: Maybe<Risolto_Api_App_Client_Mutation_Response>;
  /** delete single row from the table: "risolto.api_app_client" */
  delete_risolto_api_app_client_by_pk?: Maybe<Risolto_Api_App_Client>;
  /** delete data from the table: "risolto.attachment" */
  delete_risolto_attachment?: Maybe<Risolto_Attachment_Mutation_Response>;
  /** delete single row from the table: "risolto.attachment" */
  delete_risolto_attachment_by_pk?: Maybe<Risolto_Attachment>;
  /** delete data from the table: "risolto.attachment_scheme" */
  delete_risolto_attachment_scheme?: Maybe<Risolto_Attachment_Scheme_Mutation_Response>;
  /** delete single row from the table: "risolto.attachment_scheme" */
  delete_risolto_attachment_scheme_by_pk?: Maybe<Risolto_Attachment_Scheme>;
  /** delete data from the table: "risolto.bank_account" */
  delete_risolto_bank_account?: Maybe<Risolto_Bank_Account_Mutation_Response>;
  /** delete single row from the table: "risolto.bank_account" */
  delete_risolto_bank_account_by_pk?: Maybe<Risolto_Bank_Account>;
  /** delete data from the table: "risolto.bank_identifier_type" */
  delete_risolto_bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.bank_identifier_type" */
  delete_risolto_bank_identifier_type_by_pk?: Maybe<Risolto_Bank_Identifier_Type>;
  /** delete data from the table: "risolto.blacklist" */
  delete_risolto_blacklist?: Maybe<Risolto_Blacklist_Mutation_Response>;
  /** delete single row from the table: "risolto.blacklist" */
  delete_risolto_blacklist_by_pk?: Maybe<Risolto_Blacklist>;
  /** delete data from the table: "risolto.channel" */
  delete_risolto_channel?: Maybe<Risolto_Channel_Mutation_Response>;
  /** delete single row from the table: "risolto.channel" */
  delete_risolto_channel_by_pk?: Maybe<Risolto_Channel>;
  /** delete data from the table: "risolto.channel_endpoint" */
  delete_risolto_channel_endpoint?: Maybe<Risolto_Channel_Endpoint_Mutation_Response>;
  /** delete single row from the table: "risolto.channel_endpoint" */
  delete_risolto_channel_endpoint_by_pk?: Maybe<Risolto_Channel_Endpoint>;
  /** delete data from the table: "risolto.communication" */
  delete_risolto_communication?: Maybe<Risolto_Communication_Mutation_Response>;
  /** delete single row from the table: "risolto.communication" */
  delete_risolto_communication_by_pk?: Maybe<Risolto_Communication>;
  /** delete data from the table: "risolto.communication_template" */
  delete_risolto_communication_template?: Maybe<Risolto_Communication_Template_Mutation_Response>;
  /** delete single row from the table: "risolto.communication_template" */
  delete_risolto_communication_template_by_pk?: Maybe<Risolto_Communication_Template>;
  /** delete data from the table: "risolto.communication_template_type" */
  delete_risolto_communication_template_type?: Maybe<Risolto_Communication_Template_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.communication_template_type" */
  delete_risolto_communication_template_type_by_pk?: Maybe<Risolto_Communication_Template_Type>;
  /** delete data from the table: "risolto.contact" */
  delete_risolto_contact?: Maybe<Risolto_Contact_Mutation_Response>;
  /** delete data from the table: "risolto.contact_address" */
  delete_risolto_contact_address?: Maybe<Risolto_Contact_Address_Mutation_Response>;
  /** delete single row from the table: "risolto.contact" */
  delete_risolto_contact_by_pk?: Maybe<Risolto_Contact>;
  /** delete data from the table: "risolto.contact_type" */
  delete_risolto_contact_type?: Maybe<Risolto_Contact_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.contact_type" */
  delete_risolto_contact_type_by_pk?: Maybe<Risolto_Contact_Type>;
  /** delete data from the table: "risolto.content_disposition" */
  delete_risolto_content_disposition?: Maybe<Risolto_Content_Disposition_Mutation_Response>;
  /** delete single row from the table: "risolto.content_disposition" */
  delete_risolto_content_disposition_by_pk?: Maybe<Risolto_Content_Disposition>;
  /** delete data from the table: "risolto.credit_limit" */
  delete_risolto_credit_limit?: Maybe<Risolto_Credit_Limit_Mutation_Response>;
  /** delete single row from the table: "risolto.credit_limit" */
  delete_risolto_credit_limit_by_pk?: Maybe<Risolto_Credit_Limit>;
  /** delete data from the table: "risolto.credit_note" */
  delete_risolto_credit_note?: Maybe<Risolto_Credit_Note_Mutation_Response>;
  /** delete data from the table: "risolto.credit_note_attachment" */
  delete_risolto_credit_note_attachment?: Maybe<Risolto_Credit_Note_Attachment_Mutation_Response>;
  /** delete single row from the table: "risolto.credit_note_attachment" */
  delete_risolto_credit_note_attachment_by_pk?: Maybe<Risolto_Credit_Note_Attachment>;
  /** delete single row from the table: "risolto.credit_note" */
  delete_risolto_credit_note_by_pk?: Maybe<Risolto_Credit_Note>;
  /** delete data from the table: "risolto.currency" */
  delete_risolto_currency?: Maybe<Risolto_Currency_Mutation_Response>;
  /** delete single row from the table: "risolto.currency" */
  delete_risolto_currency_by_pk?: Maybe<Risolto_Currency>;
  /** delete data from the table: "risolto.debit_note" */
  delete_risolto_debit_note?: Maybe<Risolto_Debit_Note_Mutation_Response>;
  /** delete data from the table: "risolto.debit_note_attachment" */
  delete_risolto_debit_note_attachment?: Maybe<Risolto_Debit_Note_Attachment_Mutation_Response>;
  /** delete single row from the table: "risolto.debit_note_attachment" */
  delete_risolto_debit_note_attachment_by_pk?: Maybe<Risolto_Debit_Note_Attachment>;
  /** delete single row from the table: "risolto.debit_note" */
  delete_risolto_debit_note_by_pk?: Maybe<Risolto_Debit_Note>;
  /** delete data from the table: "risolto.direct_debit_mandate" */
  delete_risolto_direct_debit_mandate?: Maybe<Risolto_Direct_Debit_Mandate_Mutation_Response>;
  /** delete single row from the table: "risolto.direct_debit_mandate" */
  delete_risolto_direct_debit_mandate_by_pk?: Maybe<Risolto_Direct_Debit_Mandate>;
  /** delete data from the table: "risolto.direct_debit_provider" */
  delete_risolto_direct_debit_provider?: Maybe<Risolto_Direct_Debit_Provider_Mutation_Response>;
  /** delete single row from the table: "risolto.direct_debit_provider" */
  delete_risolto_direct_debit_provider_by_pk?: Maybe<Risolto_Direct_Debit_Provider>;
  /** delete data from the table: "risolto.direct_debit_scheme" */
  delete_risolto_direct_debit_scheme?: Maybe<Risolto_Direct_Debit_Scheme_Mutation_Response>;
  /** delete single row from the table: "risolto.direct_debit_scheme" */
  delete_risolto_direct_debit_scheme_by_pk?: Maybe<Risolto_Direct_Debit_Scheme>;
  /** delete data from the table: "risolto.direct_debit_sequence_type" */
  delete_risolto_direct_debit_sequence_type?: Maybe<Risolto_Direct_Debit_Sequence_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.direct_debit_sequence_type" */
  delete_risolto_direct_debit_sequence_type_by_pk?: Maybe<Risolto_Direct_Debit_Sequence_Type>;
  /** delete data from the table: "risolto.direct_debit_transaction" */
  delete_risolto_direct_debit_transaction?: Maybe<Risolto_Direct_Debit_Transaction_Mutation_Response>;
  /** delete single row from the table: "risolto.direct_debit_transaction" */
  delete_risolto_direct_debit_transaction_by_pk?: Maybe<Risolto_Direct_Debit_Transaction>;
  /** delete data from the table: "risolto.dispute_code" */
  delete_risolto_dispute_code?: Maybe<Risolto_Dispute_Code_Mutation_Response>;
  /** delete single row from the table: "risolto.dispute_code" */
  delete_risolto_dispute_code_by_pk?: Maybe<Risolto_Dispute_Code>;
  /** delete data from the table: "risolto.document_attachment_type" */
  delete_risolto_document_attachment_type?: Maybe<Risolto_Document_Attachment_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.document_attachment_type" */
  delete_risolto_document_attachment_type_by_pk?: Maybe<Risolto_Document_Attachment_Type>;
  /** delete data from the table: "risolto.document_interchange" */
  delete_risolto_document_interchange?: Maybe<Risolto_Document_Interchange_Mutation_Response>;
  /** delete data from the table: "risolto.document_interchange_attachment" */
  delete_risolto_document_interchange_attachment?: Maybe<Risolto_Document_Interchange_Attachment_Mutation_Response>;
  /** delete single row from the table: "risolto.document_interchange_attachment" */
  delete_risolto_document_interchange_attachment_by_pk?: Maybe<Risolto_Document_Interchange_Attachment>;
  /** delete single row from the table: "risolto.document_interchange" */
  delete_risolto_document_interchange_by_pk?: Maybe<Risolto_Document_Interchange>;
  /** delete data from the table: "risolto.document_interchange_direction" */
  delete_risolto_document_interchange_direction?: Maybe<Risolto_Document_Interchange_Direction_Mutation_Response>;
  /** delete single row from the table: "risolto.document_interchange_direction" */
  delete_risolto_document_interchange_direction_by_pk?: Maybe<Risolto_Document_Interchange_Direction>;
  /** delete data from the table: "risolto.document_interchange_event" */
  delete_risolto_document_interchange_event?: Maybe<Risolto_Document_Interchange_Event_Mutation_Response>;
  /** delete single row from the table: "risolto.document_interchange_event" */
  delete_risolto_document_interchange_event_by_pk?: Maybe<Risolto_Document_Interchange_Event>;
  /** delete data from the table: "risolto.document_interchange_link" */
  delete_risolto_document_interchange_link?: Maybe<Risolto_Document_Interchange_Link_Mutation_Response>;
  /** delete single row from the table: "risolto.document_interchange_link" */
  delete_risolto_document_interchange_link_by_pk?: Maybe<Risolto_Document_Interchange_Link>;
  /** delete data from the table: "risolto.dunning_notice" */
  delete_risolto_dunning_notice?: Maybe<Risolto_Dunning_Notice_Mutation_Response>;
  /** delete single row from the table: "risolto.dunning_notice" */
  delete_risolto_dunning_notice_by_pk?: Maybe<Risolto_Dunning_Notice>;
  /** delete data from the table: "risolto.dunning_notice_invoice" */
  delete_risolto_dunning_notice_invoice?: Maybe<Risolto_Dunning_Notice_Invoice_Mutation_Response>;
  /** delete single row from the table: "risolto.dunning_notice_invoice" */
  delete_risolto_dunning_notice_invoice_by_pk?: Maybe<Risolto_Dunning_Notice_Invoice>;
  /** delete data from the table: "risolto.dunning_notice_invoice_relation" */
  delete_risolto_dunning_notice_invoice_relation?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Mutation_Response>;
  /** delete single row from the table: "risolto.dunning_notice_invoice_relation" */
  delete_risolto_dunning_notice_invoice_relation_by_pk?: Maybe<Risolto_Dunning_Notice_Invoice_Relation>;
  /** delete data from the table: "risolto.dunning_notice_status" */
  delete_risolto_dunning_notice_status?: Maybe<Risolto_Dunning_Notice_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.dunning_notice_status" */
  delete_risolto_dunning_notice_status_by_pk?: Maybe<Risolto_Dunning_Notice_Status>;
  /** delete data from the table: "risolto.dunning_notice_type_code" */
  delete_risolto_dunning_notice_type_code?: Maybe<Risolto_Dunning_Notice_Type_Code_Mutation_Response>;
  /** delete single row from the table: "risolto.dunning_notice_type_code" */
  delete_risolto_dunning_notice_type_code_by_pk?: Maybe<Risolto_Dunning_Notice_Type_Code>;
  /** delete data from the table: "risolto.frequency" */
  delete_risolto_frequency?: Maybe<Risolto_Frequency_Mutation_Response>;
  /** delete single row from the table: "risolto.frequency" */
  delete_risolto_frequency_by_pk?: Maybe<Risolto_Frequency>;
  /** delete data from the table: "risolto.grant_type" */
  delete_risolto_grant_type?: Maybe<Risolto_Grant_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.grant_type" */
  delete_risolto_grant_type_by_pk?: Maybe<Risolto_Grant_Type>;
  /** delete data from the table: "risolto.invoice_collection" */
  delete_risolto_invoice_collection?: Maybe<Risolto_Invoice_Collection_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_collection" */
  delete_risolto_invoice_collection_by_pk?: Maybe<Risolto_Invoice_Collection>;
  /** delete data from the table: "risolto.invoice_dispute" */
  delete_risolto_invoice_dispute?: Maybe<Risolto_Invoice_Dispute_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_dispute" */
  delete_risolto_invoice_dispute_by_pk?: Maybe<Risolto_Invoice_Dispute>;
  /** delete data from the table: "risolto.invoice_document" */
  delete_risolto_invoice_document?: Maybe<Risolto_Invoice_Document_Mutation_Response>;
  /** delete data from the table: "risolto.invoice_document_attachment" */
  delete_risolto_invoice_document_attachment?: Maybe<Risolto_Invoice_Document_Attachment_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_document_attachment" */
  delete_risolto_invoice_document_attachment_by_pk?: Maybe<Risolto_Invoice_Document_Attachment>;
  /** delete single row from the table: "risolto.invoice_document" */
  delete_risolto_invoice_document_by_pk?: Maybe<Risolto_Invoice_Document>;
  /** delete data from the table: "risolto.invoice_document_status" */
  delete_risolto_invoice_document_status?: Maybe<Risolto_Invoice_Document_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_document_status" */
  delete_risolto_invoice_document_status_by_pk?: Maybe<Risolto_Invoice_Document_Status>;
  /** delete data from the table: "risolto.invoice_group" */
  delete_risolto_invoice_group?: Maybe<Risolto_Invoice_Group_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_group" */
  delete_risolto_invoice_group_by_pk?: Maybe<Risolto_Invoice_Group>;
  /** delete data from the table: "risolto.invoice_group_credit_note" */
  delete_risolto_invoice_group_credit_note?: Maybe<Risolto_Invoice_Group_Credit_Note_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_group_credit_note" */
  delete_risolto_invoice_group_credit_note_by_pk?: Maybe<Risolto_Invoice_Group_Credit_Note>;
  /** delete data from the table: "risolto.invoice_group_debit_note" */
  delete_risolto_invoice_group_debit_note?: Maybe<Risolto_Invoice_Group_Debit_Note_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_group_debit_note" */
  delete_risolto_invoice_group_debit_note_by_pk?: Maybe<Risolto_Invoice_Group_Debit_Note>;
  /** delete data from the table: "risolto.invoice_group_dunning_run" */
  delete_risolto_invoice_group_dunning_run?: Maybe<Risolto_Invoice_Group_Dunning_Run_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_group_dunning_run" */
  delete_risolto_invoice_group_dunning_run_by_pk?: Maybe<Risolto_Invoice_Group_Dunning_Run>;
  /** delete data from the table: "risolto.invoice_group_invoice" */
  delete_risolto_invoice_group_invoice?: Maybe<Risolto_Invoice_Group_Invoice_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_group_invoice" */
  delete_risolto_invoice_group_invoice_by_pk?: Maybe<Risolto_Invoice_Group_Invoice>;
  /** delete data from the table: "risolto.invoice_group_payment" */
  delete_risolto_invoice_group_payment?: Maybe<Risolto_Invoice_Group_Payment_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_group_payment" */
  delete_risolto_invoice_group_payment_by_pk?: Maybe<Risolto_Invoice_Group_Payment>;
  /** delete data from the table: "risolto.invoice_group_payment_promise" */
  delete_risolto_invoice_group_payment_promise?: Maybe<Risolto_Invoice_Group_Payment_Promise_Mutation_Response>;
  /** delete single row from the table: "risolto.invoice_group_payment_promise" */
  delete_risolto_invoice_group_payment_promise_by_pk?: Maybe<Risolto_Invoice_Group_Payment_Promise>;
  /** delete data from the table: "risolto.iso_country_code" */
  delete_risolto_iso_country_code?: Maybe<Risolto_Iso_Country_Code_Mutation_Response>;
  /** delete single row from the table: "risolto.iso_country_code" */
  delete_risolto_iso_country_code_by_pk?: Maybe<Risolto_Iso_Country_Code>;
  /** delete data from the table: "risolto.job" */
  delete_risolto_job?: Maybe<Risolto_Job_Mutation_Response>;
  /** delete single row from the table: "risolto.job" */
  delete_risolto_job_by_pk?: Maybe<Risolto_Job>;
  /** delete data from the table: "risolto.language_code" */
  delete_risolto_language_code?: Maybe<Risolto_Language_Code_Mutation_Response>;
  /** delete single row from the table: "risolto.language_code" */
  delete_risolto_language_code_by_pk?: Maybe<Risolto_Language_Code>;
  /** delete data from the table: "risolto.legal_entity" */
  delete_risolto_legal_entity?: Maybe<Risolto_Legal_Entity_Mutation_Response>;
  /** delete single row from the table: "risolto.legal_entity" */
  delete_risolto_legal_entity_by_pk?: Maybe<Risolto_Legal_Entity>;
  /** delete data from the table: "risolto.locale" */
  delete_risolto_locale?: Maybe<Risolto_Locale_Mutation_Response>;
  /** delete single row from the table: "risolto.locale" */
  delete_risolto_locale_by_pk?: Maybe<Risolto_Locale>;
  /** delete data from the table: "risolto.magda_cache" */
  delete_risolto_magda_cache?: Maybe<Risolto_Magda_Cache_Mutation_Response>;
  /** delete single row from the table: "risolto.magda_cache" */
  delete_risolto_magda_cache_by_pk?: Maybe<Risolto_Magda_Cache>;
  /** delete data from the table: "risolto.magda_service_audit_log" */
  delete_risolto_magda_service_audit_log?: Maybe<Risolto_Magda_Service_Audit_Log_Mutation_Response>;
  /** delete single row from the table: "risolto.magda_service_audit_log" */
  delete_risolto_magda_service_audit_log_by_pk?: Maybe<Risolto_Magda_Service_Audit_Log>;
  /** delete data from the table: "risolto.materialized_view_definition" */
  delete_risolto_materialized_view_definition?: Maybe<Risolto_Materialized_View_Definition_Mutation_Response>;
  /** delete single row from the table: "risolto.materialized_view_definition" */
  delete_risolto_materialized_view_definition_by_pk?: Maybe<Risolto_Materialized_View_Definition>;
  /** delete data from the table: "risolto.message" */
  delete_risolto_message?: Maybe<Risolto_Message_Mutation_Response>;
  /** delete data from the table: "risolto.message_assignee" */
  delete_risolto_message_assignee?: Maybe<Risolto_Message_Assignee_Mutation_Response>;
  /** delete single row from the table: "risolto.message_assignee" */
  delete_risolto_message_assignee_by_pk?: Maybe<Risolto_Message_Assignee>;
  /** delete data from the table: "risolto.message_attachment" */
  delete_risolto_message_attachment?: Maybe<Risolto_Message_Attachment_Mutation_Response>;
  /** delete single row from the table: "risolto.message_attachment" */
  delete_risolto_message_attachment_by_pk?: Maybe<Risolto_Message_Attachment>;
  /** delete single row from the table: "risolto.message" */
  delete_risolto_message_by_pk?: Maybe<Risolto_Message>;
  /** delete data from the table: "risolto.message_label" */
  delete_risolto_message_label?: Maybe<Risolto_Message_Label_Mutation_Response>;
  /** delete single row from the table: "risolto.message_label" */
  delete_risolto_message_label_by_pk?: Maybe<Risolto_Message_Label>;
  /** delete data from the table: "risolto.message_message_label" */
  delete_risolto_message_message_label?: Maybe<Risolto_Message_Message_Label_Mutation_Response>;
  /** delete single row from the table: "risolto.message_message_label" */
  delete_risolto_message_message_label_by_pk?: Maybe<Risolto_Message_Message_Label>;
  /** delete data from the table: "risolto.message_recipient" */
  delete_risolto_message_recipient?: Maybe<Risolto_Message_Recipient_Mutation_Response>;
  /** delete single row from the table: "risolto.message_recipient" */
  delete_risolto_message_recipient_by_pk?: Maybe<Risolto_Message_Recipient>;
  /** delete data from the table: "risolto.mime_type" */
  delete_risolto_mime_type?: Maybe<Risolto_Mime_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.mime_type" */
  delete_risolto_mime_type_by_pk?: Maybe<Risolto_Mime_Type>;
  /** delete data from the table: "risolto.note" */
  delete_risolto_note?: Maybe<Risolto_Note_Mutation_Response>;
  /** delete single row from the table: "risolto.note" */
  delete_risolto_note_by_pk?: Maybe<Risolto_Note>;
  /** delete data from the table: "risolto.note_category" */
  delete_risolto_note_category?: Maybe<Risolto_Note_Category_Mutation_Response>;
  /** delete single row from the table: "risolto.note_category" */
  delete_risolto_note_category_by_pk?: Maybe<Risolto_Note_Category>;
  /** delete data from the table: "risolto.note_invoice" */
  delete_risolto_note_invoice?: Maybe<Risolto_Note_Invoice_Mutation_Response>;
  /** delete single row from the table: "risolto.note_invoice" */
  delete_risolto_note_invoice_by_pk?: Maybe<Risolto_Note_Invoice>;
  /** delete data from the table: "risolto.open_balance" */
  delete_risolto_open_balance?: Maybe<Risolto_Open_Balance_Mutation_Response>;
  /** delete single row from the table: "risolto.open_balance" */
  delete_risolto_open_balance_by_pk?: Maybe<Risolto_Open_Balance>;
  /** delete data from the table: "risolto.open_balance_record" */
  delete_risolto_open_balance_record?: Maybe<Risolto_Open_Balance_Record_Mutation_Response>;
  /** delete single row from the table: "risolto.open_balance_record" */
  delete_risolto_open_balance_record_by_pk?: Maybe<Risolto_Open_Balance_Record>;
  /** delete data from the table: "risolto.origin" */
  delete_risolto_origin?: Maybe<Risolto_Origin_Mutation_Response>;
  /** delete single row from the table: "risolto.origin" */
  delete_risolto_origin_by_pk?: Maybe<Risolto_Origin>;
  /** delete data from the table: "risolto.participant" */
  delete_risolto_participant?: Maybe<Risolto_Participant_Mutation_Response>;
  /** delete data from the table: "risolto.participant_api_app_client" */
  delete_risolto_participant_api_app_client?: Maybe<Risolto_Participant_Api_App_Client_Mutation_Response>;
  /** delete single row from the table: "risolto.participant_api_app_client" */
  delete_risolto_participant_api_app_client_by_pk?: Maybe<Risolto_Participant_Api_App_Client>;
  /** delete single row from the table: "risolto.participant" */
  delete_risolto_participant_by_pk?: Maybe<Risolto_Participant>;
  /** delete data from the table: "risolto.participant_dunning_run" */
  delete_risolto_participant_dunning_run?: Maybe<Risolto_Participant_Dunning_Run_Mutation_Response>;
  /** delete single row from the table: "risolto.participant_dunning_run" */
  delete_risolto_participant_dunning_run_by_pk?: Maybe<Risolto_Participant_Dunning_Run>;
  /** delete data from the table: "risolto.participant_user" */
  delete_risolto_participant_user?: Maybe<Risolto_Participant_User_Mutation_Response>;
  /** delete single row from the table: "risolto.participant_user" */
  delete_risolto_participant_user_by_pk?: Maybe<Risolto_Participant_User>;
  /** delete data from the table: "risolto.participant_user_role" */
  delete_risolto_participant_user_role?: Maybe<Risolto_Participant_User_Role_Mutation_Response>;
  /** delete single row from the table: "risolto.participant_user_role" */
  delete_risolto_participant_user_role_by_pk?: Maybe<Risolto_Participant_User_Role>;
  /** delete data from the table: "risolto.payment" */
  delete_risolto_payment?: Maybe<Risolto_Payment_Mutation_Response>;
  /** delete single row from the table: "risolto.payment" */
  delete_risolto_payment_by_pk?: Maybe<Risolto_Payment>;
  /** delete data from the table: "risolto.payment_document" */
  delete_risolto_payment_document?: Maybe<Risolto_Payment_Document_Mutation_Response>;
  /** delete single row from the table: "risolto.payment_document" */
  delete_risolto_payment_document_by_pk?: Maybe<Risolto_Payment_Document>;
  /** delete data from the table: "risolto.payment_link" */
  delete_risolto_payment_link?: Maybe<Risolto_Payment_Link_Mutation_Response>;
  /** delete single row from the table: "risolto.payment_link" */
  delete_risolto_payment_link_by_pk?: Maybe<Risolto_Payment_Link>;
  /** delete data from the table: "risolto.payment_plan" */
  delete_risolto_payment_plan?: Maybe<Risolto_Payment_Plan_Mutation_Response>;
  /** delete single row from the table: "risolto.payment_plan" */
  delete_risolto_payment_plan_by_pk?: Maybe<Risolto_Payment_Plan>;
  /** delete data from the table: "risolto.payment_promise" */
  delete_risolto_payment_promise?: Maybe<Risolto_Payment_Promise_Mutation_Response>;
  /** delete single row from the table: "risolto.payment_promise" */
  delete_risolto_payment_promise_by_pk?: Maybe<Risolto_Payment_Promise>;
  /** delete data from the table: "risolto.payment_transfer" */
  delete_risolto_payment_transfer?: Maybe<Risolto_Payment_Transfer_Mutation_Response>;
  /** delete data from the table: "risolto.payment_transfer_bulk_payment" */
  delete_risolto_payment_transfer_bulk_payment?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Mutation_Response>;
  /** delete single row from the table: "risolto.payment_transfer_bulk_payment" */
  delete_risolto_payment_transfer_bulk_payment_by_pk?: Maybe<Risolto_Payment_Transfer_Bulk_Payment>;
  /** delete single row from the table: "risolto.payment_transfer" */
  delete_risolto_payment_transfer_by_pk?: Maybe<Risolto_Payment_Transfer>;
  /** delete data from the table: "risolto.payment_transfer_line" */
  delete_risolto_payment_transfer_line?: Maybe<Risolto_Payment_Transfer_Line_Mutation_Response>;
  /** delete single row from the table: "risolto.payment_transfer_line" */
  delete_risolto_payment_transfer_line_by_pk?: Maybe<Risolto_Payment_Transfer_Line>;
  /** delete data from the table: "risolto.payment_transfer_line_type" */
  delete_risolto_payment_transfer_line_type?: Maybe<Risolto_Payment_Transfer_Line_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.payment_transfer_line_type" */
  delete_risolto_payment_transfer_line_type_by_pk?: Maybe<Risolto_Payment_Transfer_Line_Type>;
  /** delete data from the table: "risolto.payment_transfer_status" */
  delete_risolto_payment_transfer_status?: Maybe<Risolto_Payment_Transfer_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.payment_transfer_status" */
  delete_risolto_payment_transfer_status_by_pk?: Maybe<Risolto_Payment_Transfer_Status>;
  /** delete data from the table: "risolto.person" */
  delete_risolto_person?: Maybe<Risolto_Person_Mutation_Response>;
  /** delete single row from the table: "risolto.person" */
  delete_risolto_person_by_pk?: Maybe<Risolto_Person>;
  /** delete data from the table: "risolto.platform_license_module" */
  delete_risolto_platform_license_module?: Maybe<Risolto_Platform_License_Module_Mutation_Response>;
  /** delete single row from the table: "risolto.platform_license_module" */
  delete_risolto_platform_license_module_by_pk?: Maybe<Risolto_Platform_License_Module>;
  /** delete data from the table: "risolto.platform_participant_license" */
  delete_risolto_platform_participant_license?: Maybe<Risolto_Platform_Participant_License_Mutation_Response>;
  /** delete single row from the table: "risolto.platform_participant_license" */
  delete_risolto_platform_participant_license_by_pk?: Maybe<Risolto_Platform_Participant_License>;
  /** delete data from the table: "risolto.platform_permission" */
  delete_risolto_platform_permission?: Maybe<Risolto_Platform_Permission_Mutation_Response>;
  /** delete single row from the table: "risolto.platform_permission" */
  delete_risolto_platform_permission_by_pk?: Maybe<Risolto_Platform_Permission>;
  /** delete data from the table: "risolto.platform_role" */
  delete_risolto_platform_role?: Maybe<Risolto_Platform_Role_Mutation_Response>;
  /** delete single row from the table: "risolto.platform_role" */
  delete_risolto_platform_role_by_pk?: Maybe<Risolto_Platform_Role>;
  /** delete data from the table: "risolto.platform_role_permission" */
  delete_risolto_platform_role_permission?: Maybe<Risolto_Platform_Role_Permission_Mutation_Response>;
  /** delete single row from the table: "risolto.platform_role_permission" */
  delete_risolto_platform_role_permission_by_pk?: Maybe<Risolto_Platform_Role_Permission>;
  /** delete data from the table: "risolto.platform_usage" */
  delete_risolto_platform_usage?: Maybe<Risolto_Platform_Usage_Mutation_Response>;
  /** delete single row from the table: "risolto.platform_usage" */
  delete_risolto_platform_usage_by_pk?: Maybe<Risolto_Platform_Usage>;
  /** delete data from the table: "risolto.recipient" */
  delete_risolto_recipient?: Maybe<Risolto_Recipient_Mutation_Response>;
  /** delete data from the table: "risolto.recipient_address" */
  delete_risolto_recipient_address?: Maybe<Risolto_Recipient_Address_Mutation_Response>;
  /** delete data from the table: "risolto.recipient_attachment" */
  delete_risolto_recipient_attachment?: Maybe<Risolto_Recipient_Attachment_Mutation_Response>;
  /** delete single row from the table: "risolto.recipient_attachment" */
  delete_risolto_recipient_attachment_by_pk?: Maybe<Risolto_Recipient_Attachment>;
  /** delete single row from the table: "risolto.recipient" */
  delete_risolto_recipient_by_pk?: Maybe<Risolto_Recipient>;
  /** delete data from the table: "risolto.recipient_collection" */
  delete_risolto_recipient_collection?: Maybe<Risolto_Recipient_Collection_Mutation_Response>;
  /** delete single row from the table: "risolto.recipient_collection" */
  delete_risolto_recipient_collection_by_pk?: Maybe<Risolto_Recipient_Collection>;
  /** delete data from the table: "risolto.recipient_communication" */
  delete_risolto_recipient_communication?: Maybe<Risolto_Recipient_Communication_Mutation_Response>;
  /** delete single row from the table: "risolto.recipient_communication" */
  delete_risolto_recipient_communication_by_pk?: Maybe<Risolto_Recipient_Communication>;
  /** delete data from the table: "risolto.recipient_dunning_exclude" */
  delete_risolto_recipient_dunning_exclude?: Maybe<Risolto_Recipient_Dunning_Exclude_Mutation_Response>;
  /** delete single row from the table: "risolto.recipient_dunning_exclude" */
  delete_risolto_recipient_dunning_exclude_by_pk?: Maybe<Risolto_Recipient_Dunning_Exclude>;
  /** delete data from the table: "risolto.recipient_dunning_run" */
  delete_risolto_recipient_dunning_run?: Maybe<Risolto_Recipient_Dunning_Run_Mutation_Response>;
  /** delete single row from the table: "risolto.recipient_dunning_run" */
  delete_risolto_recipient_dunning_run_by_pk?: Maybe<Risolto_Recipient_Dunning_Run>;
  /** delete data from the table: "risolto.recipient_merge" */
  delete_risolto_recipient_merge?: Maybe<Risolto_Recipient_Merge_Mutation_Response>;
  /** delete single row from the table: "risolto.recipient_merge" */
  delete_risolto_recipient_merge_by_pk?: Maybe<Risolto_Recipient_Merge>;
  /** delete data from the table: "risolto.recipient_tag" */
  delete_risolto_recipient_tag?: Maybe<Risolto_Recipient_Tag_Mutation_Response>;
  /** delete single row from the table: "risolto.recipient_tag" */
  delete_risolto_recipient_tag_by_pk?: Maybe<Risolto_Recipient_Tag>;
  /** delete data from the table: "risolto.recipient_user" */
  delete_risolto_recipient_user?: Maybe<Risolto_Recipient_User_Mutation_Response>;
  /** delete single row from the table: "risolto.recipient_user" */
  delete_risolto_recipient_user_by_pk?: Maybe<Risolto_Recipient_User>;
  /** delete data from the table: "risolto.reference_data" */
  delete_risolto_reference_data?: Maybe<Risolto_Reference_Data_Mutation_Response>;
  /** delete single row from the table: "risolto.reference_data" */
  delete_risolto_reference_data_by_pk?: Maybe<Risolto_Reference_Data>;
  /** delete data from the table: "risolto.report_definition" */
  delete_risolto_report_definition?: Maybe<Risolto_Report_Definition_Mutation_Response>;
  /** delete single row from the table: "risolto.report_definition" */
  delete_risolto_report_definition_by_pk?: Maybe<Risolto_Report_Definition>;
  /** delete data from the table: "risolto.report_execution" */
  delete_risolto_report_execution?: Maybe<Risolto_Report_Execution_Mutation_Response>;
  /** delete single row from the table: "risolto.report_execution" */
  delete_risolto_report_execution_by_pk?: Maybe<Risolto_Report_Execution>;
  /** delete data from the table: "risolto.report_execution_user" */
  delete_risolto_report_execution_user?: Maybe<Risolto_Report_Execution_User_Mutation_Response>;
  /** delete single row from the table: "risolto.report_execution_user" */
  delete_risolto_report_execution_user_by_pk?: Maybe<Risolto_Report_Execution_User>;
  /** delete data from the table: "risolto.report_template_type" */
  delete_risolto_report_template_type?: Maybe<Risolto_Report_Template_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.report_template_type" */
  delete_risolto_report_template_type_by_pk?: Maybe<Risolto_Report_Template_Type>;
  /** delete data from the table: "risolto.report_type" */
  delete_risolto_report_type?: Maybe<Risolto_Report_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.report_type" */
  delete_risolto_report_type_by_pk?: Maybe<Risolto_Report_Type>;
  /** delete data from the table: "risolto.report_user" */
  delete_risolto_report_user?: Maybe<Risolto_Report_User_Mutation_Response>;
  /** delete single row from the table: "risolto.report_user" */
  delete_risolto_report_user_by_pk?: Maybe<Risolto_Report_User>;
  /** delete data from the table: "risolto.run_processing_status" */
  delete_risolto_run_processing_status?: Maybe<Risolto_Run_Processing_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.run_processing_status" */
  delete_risolto_run_processing_status_by_pk?: Maybe<Risolto_Run_Processing_Status>;
  /** delete data from the table: "risolto.single_sign_on" */
  delete_risolto_single_sign_on?: Maybe<Risolto_Single_Sign_On_Mutation_Response>;
  /** delete single row from the table: "risolto.single_sign_on" */
  delete_risolto_single_sign_on_by_pk?: Maybe<Risolto_Single_Sign_On>;
  /** delete data from the table: "risolto.statement" */
  delete_risolto_statement?: Maybe<Risolto_Statement_Mutation_Response>;
  /** delete data from the table: "risolto.statement_account" */
  delete_risolto_statement_account?: Maybe<Risolto_Statement_Account_Mutation_Response>;
  /** delete single row from the table: "risolto.statement_account" */
  delete_risolto_statement_account_by_pk?: Maybe<Risolto_Statement_Account>;
  /** delete single row from the table: "risolto.statement" */
  delete_risolto_statement_by_pk?: Maybe<Risolto_Statement>;
  /** delete data from the table: "risolto.statement_line" */
  delete_risolto_statement_line?: Maybe<Risolto_Statement_Line_Mutation_Response>;
  /** delete single row from the table: "risolto.statement_line" */
  delete_risolto_statement_line_by_pk?: Maybe<Risolto_Statement_Line>;
  /** delete data from the table: "risolto.statement_line_dunning_notice" */
  delete_risolto_statement_line_dunning_notice?: Maybe<Risolto_Statement_Line_Dunning_Notice_Mutation_Response>;
  /** delete single row from the table: "risolto.statement_line_dunning_notice" */
  delete_risolto_statement_line_dunning_notice_by_pk?: Maybe<Risolto_Statement_Line_Dunning_Notice>;
  /** delete data from the table: "risolto.statement_line_invoice" */
  delete_risolto_statement_line_invoice?: Maybe<Risolto_Statement_Line_Invoice_Mutation_Response>;
  /** delete single row from the table: "risolto.statement_line_invoice" */
  delete_risolto_statement_line_invoice_by_pk?: Maybe<Risolto_Statement_Line_Invoice>;
  /** delete data from the table: "risolto.statement_line_payment_promise" */
  delete_risolto_statement_line_payment_promise?: Maybe<Risolto_Statement_Line_Payment_Promise_Mutation_Response>;
  /** delete single row from the table: "risolto.statement_line_payment_promise" */
  delete_risolto_statement_line_payment_promise_by_pk?: Maybe<Risolto_Statement_Line_Payment_Promise>;
  /** delete data from the table: "risolto.statement_line_status" */
  delete_risolto_statement_line_status?: Maybe<Risolto_Statement_Line_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.statement_line_status" */
  delete_risolto_statement_line_status_by_pk?: Maybe<Risolto_Statement_Line_Status>;
  /** delete data from the table: "risolto.strigil_nbb" */
  delete_risolto_strigil_nbb?: Maybe<Risolto_Strigil_Nbb_Mutation_Response>;
  /** delete single row from the table: "risolto.strigil_nbb" */
  delete_risolto_strigil_nbb_by_pk?: Maybe<Risolto_Strigil_Nbb>;
  /** delete data from the table: "risolto.strigil_nbb_processing_status" */
  delete_risolto_strigil_nbb_processing_status?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.strigil_nbb_processing_status" */
  delete_risolto_strigil_nbb_processing_status_by_pk?: Maybe<Risolto_Strigil_Nbb_Processing_Status>;
  /** delete data from the table: "risolto.system_integration" */
  delete_risolto_system_integration?: Maybe<Risolto_System_Integration_Mutation_Response>;
  /** delete single row from the table: "risolto.system_integration" */
  delete_risolto_system_integration_by_pk?: Maybe<Risolto_System_Integration>;
  /** delete data from the table: "risolto.tag" */
  delete_risolto_tag?: Maybe<Risolto_Tag_Mutation_Response>;
  /** delete single row from the table: "risolto.tag" */
  delete_risolto_tag_by_pk?: Maybe<Risolto_Tag>;
  /** delete data from the table: "risolto.task" */
  delete_risolto_task?: Maybe<Risolto_Task_Mutation_Response>;
  /** delete single row from the table: "risolto.task" */
  delete_risolto_task_by_pk?: Maybe<Risolto_Task>;
  /** delete data from the table: "risolto.task_source" */
  delete_risolto_task_source?: Maybe<Risolto_Task_Source_Mutation_Response>;
  /** delete single row from the table: "risolto.task_source" */
  delete_risolto_task_source_by_pk?: Maybe<Risolto_Task_Source>;
  /** delete data from the table: "risolto.task_status" */
  delete_risolto_task_status?: Maybe<Risolto_Task_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.task_status" */
  delete_risolto_task_status_by_pk?: Maybe<Risolto_Task_Status>;
  /** delete data from the table: "risolto.task_type" */
  delete_risolto_task_type?: Maybe<Risolto_Task_Type_Mutation_Response>;
  /** delete single row from the table: "risolto.task_type" */
  delete_risolto_task_type_by_pk?: Maybe<Risolto_Task_Type>;
  /** delete data from the table: "risolto.tone_of_voice" */
  delete_risolto_tone_of_voice?: Maybe<Risolto_Tone_Of_Voice_Mutation_Response>;
  /** delete single row from the table: "risolto.tone_of_voice" */
  delete_risolto_tone_of_voice_by_pk?: Maybe<Risolto_Tone_Of_Voice>;
  /** delete data from the table: "risolto.virtual_action_and_note" */
  delete_risolto_virtual_action_and_note?: Maybe<Risolto_Virtual_Action_And_Note_Mutation_Response>;
  /** delete data from the table: "risolto.virtual_action_and_note_and_dispute" */
  delete_risolto_virtual_action_and_note_and_dispute?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Mutation_Response>;
  /** delete data from the table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  delete_risolto_virtual_action_and_note_and_dispute_and_message?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_action_and_note_and_dispute" */
  delete_risolto_virtual_action_and_note_and_dispute_by_pk?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** delete single row from the table: "risolto.virtual_action_and_note" */
  delete_risolto_virtual_action_and_note_by_pk?: Maybe<Risolto_Virtual_Action_And_Note>;
  /** delete data from the table: "risolto.virtual_action_group" */
  delete_risolto_virtual_action_group?: Maybe<Risolto_Virtual_Action_Group_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_action_group" */
  delete_risolto_virtual_action_group_by_pk?: Maybe<Risolto_Virtual_Action_Group>;
  /** delete data from the table: "risolto.virtual_dashboard_action_stats" */
  delete_risolto_virtual_dashboard_action_stats?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_dashboard_action_stats" */
  delete_risolto_virtual_dashboard_action_stats_by_pk?: Maybe<Risolto_Virtual_Dashboard_Action_Stats>;
  /** delete data from the table: "risolto.virtual_dashboard_outstanding_debt" */
  delete_risolto_virtual_dashboard_outstanding_debt?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_dashboard_outstanding_debt" */
  delete_risolto_virtual_dashboard_outstanding_debt_by_pk?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** delete data from the table: "risolto.virtual_demo_action_report_1" */
  delete_risolto_virtual_demo_action_report_1?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_demo_action_report_1" */
  delete_risolto_virtual_demo_action_report_1_by_pk?: Maybe<Risolto_Virtual_Demo_Action_Report_1>;
  /** delete data from the table: "risolto.virtual_dunning_action" */
  delete_risolto_virtual_dunning_action?: Maybe<Risolto_Virtual_Dunning_Action_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_dunning_action" */
  delete_risolto_virtual_dunning_action_by_pk?: Maybe<Risolto_Virtual_Dunning_Action>;
  /** delete data from the table: "risolto.virtual_interchange_event" */
  delete_risolto_virtual_interchange_event?: Maybe<Risolto_Virtual_Interchange_Event_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_interchange_event" */
  delete_risolto_virtual_interchange_event_by_pk?: Maybe<Risolto_Virtual_Interchange_Event>;
  /** delete data from the table: "risolto.virtual_invoice_derived_payment_information" */
  delete_risolto_virtual_invoice_derived_payment_information?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_invoice_derived_payment_information" */
  delete_risolto_virtual_invoice_derived_payment_information_by_pk?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information>;
  /** delete data from the table: "risolto.virtual_invoicing_channel_endpoint" */
  delete_risolto_virtual_invoicing_channel_endpoint?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_invoicing_channel_endpoint" */
  delete_risolto_virtual_invoicing_channel_endpoint_by_pk?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** delete data from the table: "risolto.virtual_json" */
  delete_risolto_virtual_json?: Maybe<Risolto_Virtual_Json_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_json" */
  delete_risolto_virtual_json_by_pk?: Maybe<Risolto_Virtual_Json>;
  /** delete data from the table: "risolto.virtual_report_delivery" */
  delete_risolto_virtual_report_delivery?: Maybe<Risolto_Virtual_Report_Delivery_Mutation_Response>;
  /** delete single row from the table: "risolto.virtual_report_delivery" */
  delete_risolto_virtual_report_delivery_by_pk?: Maybe<Risolto_Virtual_Report_Delivery>;
  /** delete data from the table: "risolto.webhook" */
  delete_risolto_webhook?: Maybe<Risolto_Webhook_Mutation_Response>;
  /** delete single row from the table: "risolto.webhook" */
  delete_risolto_webhook_by_pk?: Maybe<Risolto_Webhook>;
  /** delete data from the table: "risolto.webhook_processing_status" */
  delete_risolto_webhook_processing_status?: Maybe<Risolto_Webhook_Processing_Status_Mutation_Response>;
  /** delete single row from the table: "risolto.webhook_processing_status" */
  delete_risolto_webhook_processing_status_by_pk?: Maybe<Risolto_Webhook_Processing_Status>;
  /** delete data from the table: "risolto.webhook_subscription" */
  delete_risolto_webhook_subscription?: Maybe<Risolto_Webhook_Subscription_Mutation_Response>;
  /** delete single row from the table: "risolto.webhook_subscription" */
  delete_risolto_webhook_subscription_by_pk?: Maybe<Risolto_Webhook_Subscription>;
  /** insert data into the table: "risolto.account_number_type" */
  insert_risolto_account_number_type?: Maybe<Risolto_Account_Number_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.account_number_type" */
  insert_risolto_account_number_type_one?: Maybe<Risolto_Account_Number_Type>;
  /** insert data into the table: "risolto.action" */
  insert_risolto_action?: Maybe<Risolto_Action_Mutation_Response>;
  /** insert data into the table: "risolto.action_execution_type" */
  insert_risolto_action_execution_type?: Maybe<Risolto_Action_Execution_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.action_execution_type" */
  insert_risolto_action_execution_type_one?: Maybe<Risolto_Action_Execution_Type>;
  /** insert data into the table: "risolto.action_interchange" */
  insert_risolto_action_interchange?: Maybe<Risolto_Action_Interchange_Mutation_Response>;
  /** insert a single row into the table: "risolto.action_interchange" */
  insert_risolto_action_interchange_one?: Maybe<Risolto_Action_Interchange>;
  /** insert data into the table: "risolto.action_invoice" */
  insert_risolto_action_invoice?: Maybe<Risolto_Action_Invoice_Mutation_Response>;
  /** insert a single row into the table: "risolto.action_invoice" */
  insert_risolto_action_invoice_one?: Maybe<Risolto_Action_Invoice>;
  /** insert a single row into the table: "risolto.action" */
  insert_risolto_action_one?: Maybe<Risolto_Action>;
  /** insert data into the table: "risolto.action_source" */
  insert_risolto_action_source?: Maybe<Risolto_Action_Source_Mutation_Response>;
  /** insert a single row into the table: "risolto.action_source" */
  insert_risolto_action_source_one?: Maybe<Risolto_Action_Source>;
  /** insert data into the table: "risolto.action_status" */
  insert_risolto_action_status?: Maybe<Risolto_Action_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.action_status" */
  insert_risolto_action_status_one?: Maybe<Risolto_Action_Status>;
  /** insert data into the table: "risolto.analytics_company_score" */
  insert_risolto_analytics_company_score?: Maybe<Risolto_Analytics_Company_Score_Mutation_Response>;
  /** insert a single row into the table: "risolto.analytics_company_score" */
  insert_risolto_analytics_company_score_one?: Maybe<Risolto_Analytics_Company_Score>;
  /** insert data into the table: "risolto.analytics_invoice_features" */
  insert_risolto_analytics_invoice_features?: Maybe<Risolto_Analytics_Invoice_Features_Mutation_Response>;
  /** insert a single row into the table: "risolto.analytics_invoice_features" */
  insert_risolto_analytics_invoice_features_one?: Maybe<Risolto_Analytics_Invoice_Features>;
  /** insert data into the table: "risolto.analytics_invoice_prediction" */
  insert_risolto_analytics_invoice_prediction?: Maybe<Risolto_Analytics_Invoice_Prediction_Mutation_Response>;
  /** insert a single row into the table: "risolto.analytics_invoice_prediction" */
  insert_risolto_analytics_invoice_prediction_one?: Maybe<Risolto_Analytics_Invoice_Prediction>;
  /** insert data into the table: "risolto.analytics_test" */
  insert_risolto_analytics_test?: Maybe<Risolto_Analytics_Test_Mutation_Response>;
  /** insert a single row into the table: "risolto.analytics_test" */
  insert_risolto_analytics_test_one?: Maybe<Risolto_Analytics_Test>;
  /** insert data into the table: "risolto.analytics_test_result" */
  insert_risolto_analytics_test_result?: Maybe<Risolto_Analytics_Test_Result_Mutation_Response>;
  /** insert a single row into the table: "risolto.analytics_test_result" */
  insert_risolto_analytics_test_result_one?: Maybe<Risolto_Analytics_Test_Result>;
  /** insert data into the table: "risolto.api_app_client" */
  insert_risolto_api_app_client?: Maybe<Risolto_Api_App_Client_Mutation_Response>;
  /** insert a single row into the table: "risolto.api_app_client" */
  insert_risolto_api_app_client_one?: Maybe<Risolto_Api_App_Client>;
  /** insert data into the table: "risolto.attachment" */
  insert_risolto_attachment?: Maybe<Risolto_Attachment_Mutation_Response>;
  /** insert a single row into the table: "risolto.attachment" */
  insert_risolto_attachment_one?: Maybe<Risolto_Attachment>;
  /** insert data into the table: "risolto.attachment_scheme" */
  insert_risolto_attachment_scheme?: Maybe<Risolto_Attachment_Scheme_Mutation_Response>;
  /** insert a single row into the table: "risolto.attachment_scheme" */
  insert_risolto_attachment_scheme_one?: Maybe<Risolto_Attachment_Scheme>;
  /** insert data into the table: "risolto.bank_account" */
  insert_risolto_bank_account?: Maybe<Risolto_Bank_Account_Mutation_Response>;
  /** insert a single row into the table: "risolto.bank_account" */
  insert_risolto_bank_account_one?: Maybe<Risolto_Bank_Account>;
  /** insert data into the table: "risolto.bank_identifier_type" */
  insert_risolto_bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.bank_identifier_type" */
  insert_risolto_bank_identifier_type_one?: Maybe<Risolto_Bank_Identifier_Type>;
  /** insert data into the table: "risolto.blacklist" */
  insert_risolto_blacklist?: Maybe<Risolto_Blacklist_Mutation_Response>;
  /** insert a single row into the table: "risolto.blacklist" */
  insert_risolto_blacklist_one?: Maybe<Risolto_Blacklist>;
  /** insert data into the table: "risolto.channel" */
  insert_risolto_channel?: Maybe<Risolto_Channel_Mutation_Response>;
  /** insert data into the table: "risolto.channel_endpoint" */
  insert_risolto_channel_endpoint?: Maybe<Risolto_Channel_Endpoint_Mutation_Response>;
  /** insert a single row into the table: "risolto.channel_endpoint" */
  insert_risolto_channel_endpoint_one?: Maybe<Risolto_Channel_Endpoint>;
  /** insert a single row into the table: "risolto.channel" */
  insert_risolto_channel_one?: Maybe<Risolto_Channel>;
  /** insert data into the table: "risolto.communication" */
  insert_risolto_communication?: Maybe<Risolto_Communication_Mutation_Response>;
  /** insert a single row into the table: "risolto.communication" */
  insert_risolto_communication_one?: Maybe<Risolto_Communication>;
  /** insert data into the table: "risolto.communication_template" */
  insert_risolto_communication_template?: Maybe<Risolto_Communication_Template_Mutation_Response>;
  /** insert a single row into the table: "risolto.communication_template" */
  insert_risolto_communication_template_one?: Maybe<Risolto_Communication_Template>;
  /** insert data into the table: "risolto.communication_template_type" */
  insert_risolto_communication_template_type?: Maybe<Risolto_Communication_Template_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.communication_template_type" */
  insert_risolto_communication_template_type_one?: Maybe<Risolto_Communication_Template_Type>;
  /** insert data into the table: "risolto.contact" */
  insert_risolto_contact?: Maybe<Risolto_Contact_Mutation_Response>;
  /** insert data into the table: "risolto.contact_address" */
  insert_risolto_contact_address?: Maybe<Risolto_Contact_Address_Mutation_Response>;
  /** insert a single row into the table: "risolto.contact_address" */
  insert_risolto_contact_address_one?: Maybe<Risolto_Contact_Address>;
  /** insert a single row into the table: "risolto.contact" */
  insert_risolto_contact_one?: Maybe<Risolto_Contact>;
  /** insert data into the table: "risolto.contact_type" */
  insert_risolto_contact_type?: Maybe<Risolto_Contact_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.contact_type" */
  insert_risolto_contact_type_one?: Maybe<Risolto_Contact_Type>;
  /** insert data into the table: "risolto.content_disposition" */
  insert_risolto_content_disposition?: Maybe<Risolto_Content_Disposition_Mutation_Response>;
  /** insert a single row into the table: "risolto.content_disposition" */
  insert_risolto_content_disposition_one?: Maybe<Risolto_Content_Disposition>;
  /** insert data into the table: "risolto.credit_limit" */
  insert_risolto_credit_limit?: Maybe<Risolto_Credit_Limit_Mutation_Response>;
  /** insert a single row into the table: "risolto.credit_limit" */
  insert_risolto_credit_limit_one?: Maybe<Risolto_Credit_Limit>;
  /** insert data into the table: "risolto.credit_note" */
  insert_risolto_credit_note?: Maybe<Risolto_Credit_Note_Mutation_Response>;
  /** insert data into the table: "risolto.credit_note_attachment" */
  insert_risolto_credit_note_attachment?: Maybe<Risolto_Credit_Note_Attachment_Mutation_Response>;
  /** insert a single row into the table: "risolto.credit_note_attachment" */
  insert_risolto_credit_note_attachment_one?: Maybe<Risolto_Credit_Note_Attachment>;
  /** insert a single row into the table: "risolto.credit_note" */
  insert_risolto_credit_note_one?: Maybe<Risolto_Credit_Note>;
  /** insert data into the table: "risolto.currency" */
  insert_risolto_currency?: Maybe<Risolto_Currency_Mutation_Response>;
  /** insert a single row into the table: "risolto.currency" */
  insert_risolto_currency_one?: Maybe<Risolto_Currency>;
  /** insert data into the table: "risolto.debit_note" */
  insert_risolto_debit_note?: Maybe<Risolto_Debit_Note_Mutation_Response>;
  /** insert data into the table: "risolto.debit_note_attachment" */
  insert_risolto_debit_note_attachment?: Maybe<Risolto_Debit_Note_Attachment_Mutation_Response>;
  /** insert a single row into the table: "risolto.debit_note_attachment" */
  insert_risolto_debit_note_attachment_one?: Maybe<Risolto_Debit_Note_Attachment>;
  /** insert a single row into the table: "risolto.debit_note" */
  insert_risolto_debit_note_one?: Maybe<Risolto_Debit_Note>;
  /** insert data into the table: "risolto.direct_debit_mandate" */
  insert_risolto_direct_debit_mandate?: Maybe<Risolto_Direct_Debit_Mandate_Mutation_Response>;
  /** insert a single row into the table: "risolto.direct_debit_mandate" */
  insert_risolto_direct_debit_mandate_one?: Maybe<Risolto_Direct_Debit_Mandate>;
  /** insert data into the table: "risolto.direct_debit_provider" */
  insert_risolto_direct_debit_provider?: Maybe<Risolto_Direct_Debit_Provider_Mutation_Response>;
  /** insert a single row into the table: "risolto.direct_debit_provider" */
  insert_risolto_direct_debit_provider_one?: Maybe<Risolto_Direct_Debit_Provider>;
  /** insert data into the table: "risolto.direct_debit_scheme" */
  insert_risolto_direct_debit_scheme?: Maybe<Risolto_Direct_Debit_Scheme_Mutation_Response>;
  /** insert a single row into the table: "risolto.direct_debit_scheme" */
  insert_risolto_direct_debit_scheme_one?: Maybe<Risolto_Direct_Debit_Scheme>;
  /** insert data into the table: "risolto.direct_debit_sequence_type" */
  insert_risolto_direct_debit_sequence_type?: Maybe<Risolto_Direct_Debit_Sequence_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.direct_debit_sequence_type" */
  insert_risolto_direct_debit_sequence_type_one?: Maybe<Risolto_Direct_Debit_Sequence_Type>;
  /** insert data into the table: "risolto.direct_debit_transaction" */
  insert_risolto_direct_debit_transaction?: Maybe<Risolto_Direct_Debit_Transaction_Mutation_Response>;
  /** insert a single row into the table: "risolto.direct_debit_transaction" */
  insert_risolto_direct_debit_transaction_one?: Maybe<Risolto_Direct_Debit_Transaction>;
  /** insert data into the table: "risolto.dispute_code" */
  insert_risolto_dispute_code?: Maybe<Risolto_Dispute_Code_Mutation_Response>;
  /** insert a single row into the table: "risolto.dispute_code" */
  insert_risolto_dispute_code_one?: Maybe<Risolto_Dispute_Code>;
  /** insert data into the table: "risolto.document_attachment_type" */
  insert_risolto_document_attachment_type?: Maybe<Risolto_Document_Attachment_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.document_attachment_type" */
  insert_risolto_document_attachment_type_one?: Maybe<Risolto_Document_Attachment_Type>;
  /** insert data into the table: "risolto.document_interchange" */
  insert_risolto_document_interchange?: Maybe<Risolto_Document_Interchange_Mutation_Response>;
  /** insert data into the table: "risolto.document_interchange_attachment" */
  insert_risolto_document_interchange_attachment?: Maybe<Risolto_Document_Interchange_Attachment_Mutation_Response>;
  /** insert a single row into the table: "risolto.document_interchange_attachment" */
  insert_risolto_document_interchange_attachment_one?: Maybe<Risolto_Document_Interchange_Attachment>;
  /** insert data into the table: "risolto.document_interchange_direction" */
  insert_risolto_document_interchange_direction?: Maybe<Risolto_Document_Interchange_Direction_Mutation_Response>;
  /** insert a single row into the table: "risolto.document_interchange_direction" */
  insert_risolto_document_interchange_direction_one?: Maybe<Risolto_Document_Interchange_Direction>;
  /** insert data into the table: "risolto.document_interchange_event" */
  insert_risolto_document_interchange_event?: Maybe<Risolto_Document_Interchange_Event_Mutation_Response>;
  /** insert a single row into the table: "risolto.document_interchange_event" */
  insert_risolto_document_interchange_event_one?: Maybe<Risolto_Document_Interchange_Event>;
  /** insert data into the table: "risolto.document_interchange_link" */
  insert_risolto_document_interchange_link?: Maybe<Risolto_Document_Interchange_Link_Mutation_Response>;
  /** insert a single row into the table: "risolto.document_interchange_link" */
  insert_risolto_document_interchange_link_one?: Maybe<Risolto_Document_Interchange_Link>;
  /** insert a single row into the table: "risolto.document_interchange" */
  insert_risolto_document_interchange_one?: Maybe<Risolto_Document_Interchange>;
  /** insert data into the table: "risolto.dunning_notice" */
  insert_risolto_dunning_notice?: Maybe<Risolto_Dunning_Notice_Mutation_Response>;
  /** insert data into the table: "risolto.dunning_notice_invoice" */
  insert_risolto_dunning_notice_invoice?: Maybe<Risolto_Dunning_Notice_Invoice_Mutation_Response>;
  /** insert a single row into the table: "risolto.dunning_notice_invoice" */
  insert_risolto_dunning_notice_invoice_one?: Maybe<Risolto_Dunning_Notice_Invoice>;
  /** insert data into the table: "risolto.dunning_notice_invoice_relation" */
  insert_risolto_dunning_notice_invoice_relation?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Mutation_Response>;
  /** insert a single row into the table: "risolto.dunning_notice_invoice_relation" */
  insert_risolto_dunning_notice_invoice_relation_one?: Maybe<Risolto_Dunning_Notice_Invoice_Relation>;
  /** insert a single row into the table: "risolto.dunning_notice" */
  insert_risolto_dunning_notice_one?: Maybe<Risolto_Dunning_Notice>;
  /** insert data into the table: "risolto.dunning_notice_status" */
  insert_risolto_dunning_notice_status?: Maybe<Risolto_Dunning_Notice_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.dunning_notice_status" */
  insert_risolto_dunning_notice_status_one?: Maybe<Risolto_Dunning_Notice_Status>;
  /** insert data into the table: "risolto.dunning_notice_type_code" */
  insert_risolto_dunning_notice_type_code?: Maybe<Risolto_Dunning_Notice_Type_Code_Mutation_Response>;
  /** insert a single row into the table: "risolto.dunning_notice_type_code" */
  insert_risolto_dunning_notice_type_code_one?: Maybe<Risolto_Dunning_Notice_Type_Code>;
  /** insert data into the table: "risolto.frequency" */
  insert_risolto_frequency?: Maybe<Risolto_Frequency_Mutation_Response>;
  /** insert a single row into the table: "risolto.frequency" */
  insert_risolto_frequency_one?: Maybe<Risolto_Frequency>;
  /** insert data into the table: "risolto.grant_type" */
  insert_risolto_grant_type?: Maybe<Risolto_Grant_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.grant_type" */
  insert_risolto_grant_type_one?: Maybe<Risolto_Grant_Type>;
  /** insert data into the table: "risolto.invoice_collection" */
  insert_risolto_invoice_collection?: Maybe<Risolto_Invoice_Collection_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_collection" */
  insert_risolto_invoice_collection_one?: Maybe<Risolto_Invoice_Collection>;
  /** insert data into the table: "risolto.invoice_dispute" */
  insert_risolto_invoice_dispute?: Maybe<Risolto_Invoice_Dispute_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_dispute" */
  insert_risolto_invoice_dispute_one?: Maybe<Risolto_Invoice_Dispute>;
  /** insert data into the table: "risolto.invoice_document" */
  insert_risolto_invoice_document?: Maybe<Risolto_Invoice_Document_Mutation_Response>;
  /** insert data into the table: "risolto.invoice_document_attachment" */
  insert_risolto_invoice_document_attachment?: Maybe<Risolto_Invoice_Document_Attachment_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_document_attachment" */
  insert_risolto_invoice_document_attachment_one?: Maybe<Risolto_Invoice_Document_Attachment>;
  /** insert a single row into the table: "risolto.invoice_document" */
  insert_risolto_invoice_document_one?: Maybe<Risolto_Invoice_Document>;
  /** insert data into the table: "risolto.invoice_document_status" */
  insert_risolto_invoice_document_status?: Maybe<Risolto_Invoice_Document_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_document_status" */
  insert_risolto_invoice_document_status_one?: Maybe<Risolto_Invoice_Document_Status>;
  /** insert data into the table: "risolto.invoice_group" */
  insert_risolto_invoice_group?: Maybe<Risolto_Invoice_Group_Mutation_Response>;
  /** insert data into the table: "risolto.invoice_group_credit_note" */
  insert_risolto_invoice_group_credit_note?: Maybe<Risolto_Invoice_Group_Credit_Note_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_group_credit_note" */
  insert_risolto_invoice_group_credit_note_one?: Maybe<Risolto_Invoice_Group_Credit_Note>;
  /** insert data into the table: "risolto.invoice_group_debit_note" */
  insert_risolto_invoice_group_debit_note?: Maybe<Risolto_Invoice_Group_Debit_Note_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_group_debit_note" */
  insert_risolto_invoice_group_debit_note_one?: Maybe<Risolto_Invoice_Group_Debit_Note>;
  /** insert data into the table: "risolto.invoice_group_dunning_run" */
  insert_risolto_invoice_group_dunning_run?: Maybe<Risolto_Invoice_Group_Dunning_Run_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_group_dunning_run" */
  insert_risolto_invoice_group_dunning_run_one?: Maybe<Risolto_Invoice_Group_Dunning_Run>;
  /** insert data into the table: "risolto.invoice_group_invoice" */
  insert_risolto_invoice_group_invoice?: Maybe<Risolto_Invoice_Group_Invoice_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_group_invoice" */
  insert_risolto_invoice_group_invoice_one?: Maybe<Risolto_Invoice_Group_Invoice>;
  /** insert a single row into the table: "risolto.invoice_group" */
  insert_risolto_invoice_group_one?: Maybe<Risolto_Invoice_Group>;
  /** insert data into the table: "risolto.invoice_group_payment" */
  insert_risolto_invoice_group_payment?: Maybe<Risolto_Invoice_Group_Payment_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_group_payment" */
  insert_risolto_invoice_group_payment_one?: Maybe<Risolto_Invoice_Group_Payment>;
  /** insert data into the table: "risolto.invoice_group_payment_promise" */
  insert_risolto_invoice_group_payment_promise?: Maybe<Risolto_Invoice_Group_Payment_Promise_Mutation_Response>;
  /** insert a single row into the table: "risolto.invoice_group_payment_promise" */
  insert_risolto_invoice_group_payment_promise_one?: Maybe<Risolto_Invoice_Group_Payment_Promise>;
  /** insert data into the table: "risolto.iso_country_code" */
  insert_risolto_iso_country_code?: Maybe<Risolto_Iso_Country_Code_Mutation_Response>;
  /** insert a single row into the table: "risolto.iso_country_code" */
  insert_risolto_iso_country_code_one?: Maybe<Risolto_Iso_Country_Code>;
  /** insert data into the table: "risolto.job" */
  insert_risolto_job?: Maybe<Risolto_Job_Mutation_Response>;
  /** insert a single row into the table: "risolto.job" */
  insert_risolto_job_one?: Maybe<Risolto_Job>;
  /** insert data into the table: "risolto.language_code" */
  insert_risolto_language_code?: Maybe<Risolto_Language_Code_Mutation_Response>;
  /** insert a single row into the table: "risolto.language_code" */
  insert_risolto_language_code_one?: Maybe<Risolto_Language_Code>;
  /** insert data into the table: "risolto.legal_entity" */
  insert_risolto_legal_entity?: Maybe<Risolto_Legal_Entity_Mutation_Response>;
  /** insert a single row into the table: "risolto.legal_entity" */
  insert_risolto_legal_entity_one?: Maybe<Risolto_Legal_Entity>;
  /** insert data into the table: "risolto.locale" */
  insert_risolto_locale?: Maybe<Risolto_Locale_Mutation_Response>;
  /** insert a single row into the table: "risolto.locale" */
  insert_risolto_locale_one?: Maybe<Risolto_Locale>;
  /** insert data into the table: "risolto.magda_cache" */
  insert_risolto_magda_cache?: Maybe<Risolto_Magda_Cache_Mutation_Response>;
  /** insert a single row into the table: "risolto.magda_cache" */
  insert_risolto_magda_cache_one?: Maybe<Risolto_Magda_Cache>;
  /** insert data into the table: "risolto.magda_service_audit_log" */
  insert_risolto_magda_service_audit_log?: Maybe<Risolto_Magda_Service_Audit_Log_Mutation_Response>;
  /** insert a single row into the table: "risolto.magda_service_audit_log" */
  insert_risolto_magda_service_audit_log_one?: Maybe<Risolto_Magda_Service_Audit_Log>;
  /** insert data into the table: "risolto.materialized_view_definition" */
  insert_risolto_materialized_view_definition?: Maybe<Risolto_Materialized_View_Definition_Mutation_Response>;
  /** insert a single row into the table: "risolto.materialized_view_definition" */
  insert_risolto_materialized_view_definition_one?: Maybe<Risolto_Materialized_View_Definition>;
  /** insert data into the table: "risolto.message" */
  insert_risolto_message?: Maybe<Risolto_Message_Mutation_Response>;
  /** insert data into the table: "risolto.message_assignee" */
  insert_risolto_message_assignee?: Maybe<Risolto_Message_Assignee_Mutation_Response>;
  /** insert a single row into the table: "risolto.message_assignee" */
  insert_risolto_message_assignee_one?: Maybe<Risolto_Message_Assignee>;
  /** insert data into the table: "risolto.message_attachment" */
  insert_risolto_message_attachment?: Maybe<Risolto_Message_Attachment_Mutation_Response>;
  /** insert a single row into the table: "risolto.message_attachment" */
  insert_risolto_message_attachment_one?: Maybe<Risolto_Message_Attachment>;
  /** insert data into the table: "risolto.message_label" */
  insert_risolto_message_label?: Maybe<Risolto_Message_Label_Mutation_Response>;
  /** insert a single row into the table: "risolto.message_label" */
  insert_risolto_message_label_one?: Maybe<Risolto_Message_Label>;
  /** insert data into the table: "risolto.message_message_label" */
  insert_risolto_message_message_label?: Maybe<Risolto_Message_Message_Label_Mutation_Response>;
  /** insert a single row into the table: "risolto.message_message_label" */
  insert_risolto_message_message_label_one?: Maybe<Risolto_Message_Message_Label>;
  /** insert a single row into the table: "risolto.message" */
  insert_risolto_message_one?: Maybe<Risolto_Message>;
  /** insert data into the table: "risolto.message_recipient" */
  insert_risolto_message_recipient?: Maybe<Risolto_Message_Recipient_Mutation_Response>;
  /** insert a single row into the table: "risolto.message_recipient" */
  insert_risolto_message_recipient_one?: Maybe<Risolto_Message_Recipient>;
  /** insert data into the table: "risolto.mime_type" */
  insert_risolto_mime_type?: Maybe<Risolto_Mime_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.mime_type" */
  insert_risolto_mime_type_one?: Maybe<Risolto_Mime_Type>;
  /** insert data into the table: "risolto.note" */
  insert_risolto_note?: Maybe<Risolto_Note_Mutation_Response>;
  /** insert data into the table: "risolto.note_category" */
  insert_risolto_note_category?: Maybe<Risolto_Note_Category_Mutation_Response>;
  /** insert a single row into the table: "risolto.note_category" */
  insert_risolto_note_category_one?: Maybe<Risolto_Note_Category>;
  /** insert data into the table: "risolto.note_invoice" */
  insert_risolto_note_invoice?: Maybe<Risolto_Note_Invoice_Mutation_Response>;
  /** insert a single row into the table: "risolto.note_invoice" */
  insert_risolto_note_invoice_one?: Maybe<Risolto_Note_Invoice>;
  /** insert a single row into the table: "risolto.note" */
  insert_risolto_note_one?: Maybe<Risolto_Note>;
  /** insert data into the table: "risolto.open_balance" */
  insert_risolto_open_balance?: Maybe<Risolto_Open_Balance_Mutation_Response>;
  /** insert a single row into the table: "risolto.open_balance" */
  insert_risolto_open_balance_one?: Maybe<Risolto_Open_Balance>;
  /** insert data into the table: "risolto.open_balance_record" */
  insert_risolto_open_balance_record?: Maybe<Risolto_Open_Balance_Record_Mutation_Response>;
  /** insert a single row into the table: "risolto.open_balance_record" */
  insert_risolto_open_balance_record_one?: Maybe<Risolto_Open_Balance_Record>;
  /** insert data into the table: "risolto.origin" */
  insert_risolto_origin?: Maybe<Risolto_Origin_Mutation_Response>;
  /** insert a single row into the table: "risolto.origin" */
  insert_risolto_origin_one?: Maybe<Risolto_Origin>;
  /** insert data into the table: "risolto.participant" */
  insert_risolto_participant?: Maybe<Risolto_Participant_Mutation_Response>;
  /** insert data into the table: "risolto.participant_api_app_client" */
  insert_risolto_participant_api_app_client?: Maybe<Risolto_Participant_Api_App_Client_Mutation_Response>;
  /** insert a single row into the table: "risolto.participant_api_app_client" */
  insert_risolto_participant_api_app_client_one?: Maybe<Risolto_Participant_Api_App_Client>;
  /** insert data into the table: "risolto.participant_dunning_run" */
  insert_risolto_participant_dunning_run?: Maybe<Risolto_Participant_Dunning_Run_Mutation_Response>;
  /** insert a single row into the table: "risolto.participant_dunning_run" */
  insert_risolto_participant_dunning_run_one?: Maybe<Risolto_Participant_Dunning_Run>;
  /** insert a single row into the table: "risolto.participant" */
  insert_risolto_participant_one?: Maybe<Risolto_Participant>;
  /** insert data into the table: "risolto.participant_user" */
  insert_risolto_participant_user?: Maybe<Risolto_Participant_User_Mutation_Response>;
  /** insert a single row into the table: "risolto.participant_user" */
  insert_risolto_participant_user_one?: Maybe<Risolto_Participant_User>;
  /** insert data into the table: "risolto.participant_user_role" */
  insert_risolto_participant_user_role?: Maybe<Risolto_Participant_User_Role_Mutation_Response>;
  /** insert a single row into the table: "risolto.participant_user_role" */
  insert_risolto_participant_user_role_one?: Maybe<Risolto_Participant_User_Role>;
  /** insert data into the table: "risolto.payment" */
  insert_risolto_payment?: Maybe<Risolto_Payment_Mutation_Response>;
  /** insert data into the table: "risolto.payment_document" */
  insert_risolto_payment_document?: Maybe<Risolto_Payment_Document_Mutation_Response>;
  /** insert a single row into the table: "risolto.payment_document" */
  insert_risolto_payment_document_one?: Maybe<Risolto_Payment_Document>;
  /** insert data into the table: "risolto.payment_link" */
  insert_risolto_payment_link?: Maybe<Risolto_Payment_Link_Mutation_Response>;
  /** insert a single row into the table: "risolto.payment_link" */
  insert_risolto_payment_link_one?: Maybe<Risolto_Payment_Link>;
  /** insert a single row into the table: "risolto.payment" */
  insert_risolto_payment_one?: Maybe<Risolto_Payment>;
  /** insert data into the table: "risolto.payment_plan" */
  insert_risolto_payment_plan?: Maybe<Risolto_Payment_Plan_Mutation_Response>;
  /** insert a single row into the table: "risolto.payment_plan" */
  insert_risolto_payment_plan_one?: Maybe<Risolto_Payment_Plan>;
  /** insert data into the table: "risolto.payment_promise" */
  insert_risolto_payment_promise?: Maybe<Risolto_Payment_Promise_Mutation_Response>;
  /** insert a single row into the table: "risolto.payment_promise" */
  insert_risolto_payment_promise_one?: Maybe<Risolto_Payment_Promise>;
  /** insert data into the table: "risolto.payment_transfer" */
  insert_risolto_payment_transfer?: Maybe<Risolto_Payment_Transfer_Mutation_Response>;
  /** insert data into the table: "risolto.payment_transfer_bulk_payment" */
  insert_risolto_payment_transfer_bulk_payment?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Mutation_Response>;
  /** insert a single row into the table: "risolto.payment_transfer_bulk_payment" */
  insert_risolto_payment_transfer_bulk_payment_one?: Maybe<Risolto_Payment_Transfer_Bulk_Payment>;
  /** insert data into the table: "risolto.payment_transfer_line" */
  insert_risolto_payment_transfer_line?: Maybe<Risolto_Payment_Transfer_Line_Mutation_Response>;
  /** insert a single row into the table: "risolto.payment_transfer_line" */
  insert_risolto_payment_transfer_line_one?: Maybe<Risolto_Payment_Transfer_Line>;
  /** insert data into the table: "risolto.payment_transfer_line_type" */
  insert_risolto_payment_transfer_line_type?: Maybe<Risolto_Payment_Transfer_Line_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.payment_transfer_line_type" */
  insert_risolto_payment_transfer_line_type_one?: Maybe<Risolto_Payment_Transfer_Line_Type>;
  /** insert a single row into the table: "risolto.payment_transfer" */
  insert_risolto_payment_transfer_one?: Maybe<Risolto_Payment_Transfer>;
  /** insert data into the table: "risolto.payment_transfer_status" */
  insert_risolto_payment_transfer_status?: Maybe<Risolto_Payment_Transfer_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.payment_transfer_status" */
  insert_risolto_payment_transfer_status_one?: Maybe<Risolto_Payment_Transfer_Status>;
  /** insert data into the table: "risolto.person" */
  insert_risolto_person?: Maybe<Risolto_Person_Mutation_Response>;
  /** insert a single row into the table: "risolto.person" */
  insert_risolto_person_one?: Maybe<Risolto_Person>;
  /** insert data into the table: "risolto.platform_license_module" */
  insert_risolto_platform_license_module?: Maybe<Risolto_Platform_License_Module_Mutation_Response>;
  /** insert a single row into the table: "risolto.platform_license_module" */
  insert_risolto_platform_license_module_one?: Maybe<Risolto_Platform_License_Module>;
  /** insert data into the table: "risolto.platform_participant_license" */
  insert_risolto_platform_participant_license?: Maybe<Risolto_Platform_Participant_License_Mutation_Response>;
  /** insert a single row into the table: "risolto.platform_participant_license" */
  insert_risolto_platform_participant_license_one?: Maybe<Risolto_Platform_Participant_License>;
  /** insert data into the table: "risolto.platform_permission" */
  insert_risolto_platform_permission?: Maybe<Risolto_Platform_Permission_Mutation_Response>;
  /** insert a single row into the table: "risolto.platform_permission" */
  insert_risolto_platform_permission_one?: Maybe<Risolto_Platform_Permission>;
  /** insert data into the table: "risolto.platform_role" */
  insert_risolto_platform_role?: Maybe<Risolto_Platform_Role_Mutation_Response>;
  /** insert a single row into the table: "risolto.platform_role" */
  insert_risolto_platform_role_one?: Maybe<Risolto_Platform_Role>;
  /** insert data into the table: "risolto.platform_role_permission" */
  insert_risolto_platform_role_permission?: Maybe<Risolto_Platform_Role_Permission_Mutation_Response>;
  /** insert a single row into the table: "risolto.platform_role_permission" */
  insert_risolto_platform_role_permission_one?: Maybe<Risolto_Platform_Role_Permission>;
  /** insert data into the table: "risolto.platform_usage" */
  insert_risolto_platform_usage?: Maybe<Risolto_Platform_Usage_Mutation_Response>;
  /** insert a single row into the table: "risolto.platform_usage" */
  insert_risolto_platform_usage_one?: Maybe<Risolto_Platform_Usage>;
  /** insert data into the table: "risolto.recipient" */
  insert_risolto_recipient?: Maybe<Risolto_Recipient_Mutation_Response>;
  /** insert data into the table: "risolto.recipient_address" */
  insert_risolto_recipient_address?: Maybe<Risolto_Recipient_Address_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_address" */
  insert_risolto_recipient_address_one?: Maybe<Risolto_Recipient_Address>;
  /** insert data into the table: "risolto.recipient_attachment" */
  insert_risolto_recipient_attachment?: Maybe<Risolto_Recipient_Attachment_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_attachment" */
  insert_risolto_recipient_attachment_one?: Maybe<Risolto_Recipient_Attachment>;
  /** insert data into the table: "risolto.recipient_collection" */
  insert_risolto_recipient_collection?: Maybe<Risolto_Recipient_Collection_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_collection" */
  insert_risolto_recipient_collection_one?: Maybe<Risolto_Recipient_Collection>;
  /** insert data into the table: "risolto.recipient_communication" */
  insert_risolto_recipient_communication?: Maybe<Risolto_Recipient_Communication_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_communication" */
  insert_risolto_recipient_communication_one?: Maybe<Risolto_Recipient_Communication>;
  /** insert data into the table: "risolto.recipient_dunning_exclude" */
  insert_risolto_recipient_dunning_exclude?: Maybe<Risolto_Recipient_Dunning_Exclude_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_dunning_exclude" */
  insert_risolto_recipient_dunning_exclude_one?: Maybe<Risolto_Recipient_Dunning_Exclude>;
  /** insert data into the table: "risolto.recipient_dunning_run" */
  insert_risolto_recipient_dunning_run?: Maybe<Risolto_Recipient_Dunning_Run_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_dunning_run" */
  insert_risolto_recipient_dunning_run_one?: Maybe<Risolto_Recipient_Dunning_Run>;
  /** insert data into the table: "risolto.recipient_merge" */
  insert_risolto_recipient_merge?: Maybe<Risolto_Recipient_Merge_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_merge" */
  insert_risolto_recipient_merge_one?: Maybe<Risolto_Recipient_Merge>;
  /** insert a single row into the table: "risolto.recipient" */
  insert_risolto_recipient_one?: Maybe<Risolto_Recipient>;
  /** insert data into the table: "risolto.recipient_tag" */
  insert_risolto_recipient_tag?: Maybe<Risolto_Recipient_Tag_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_tag" */
  insert_risolto_recipient_tag_one?: Maybe<Risolto_Recipient_Tag>;
  /** insert data into the table: "risolto.recipient_user" */
  insert_risolto_recipient_user?: Maybe<Risolto_Recipient_User_Mutation_Response>;
  /** insert a single row into the table: "risolto.recipient_user" */
  insert_risolto_recipient_user_one?: Maybe<Risolto_Recipient_User>;
  /** insert data into the table: "risolto.reference_data" */
  insert_risolto_reference_data?: Maybe<Risolto_Reference_Data_Mutation_Response>;
  /** insert a single row into the table: "risolto.reference_data" */
  insert_risolto_reference_data_one?: Maybe<Risolto_Reference_Data>;
  /** insert data into the table: "risolto.report_definition" */
  insert_risolto_report_definition?: Maybe<Risolto_Report_Definition_Mutation_Response>;
  /** insert a single row into the table: "risolto.report_definition" */
  insert_risolto_report_definition_one?: Maybe<Risolto_Report_Definition>;
  /** insert data into the table: "risolto.report_execution" */
  insert_risolto_report_execution?: Maybe<Risolto_Report_Execution_Mutation_Response>;
  /** insert a single row into the table: "risolto.report_execution" */
  insert_risolto_report_execution_one?: Maybe<Risolto_Report_Execution>;
  /** insert data into the table: "risolto.report_execution_user" */
  insert_risolto_report_execution_user?: Maybe<Risolto_Report_Execution_User_Mutation_Response>;
  /** insert a single row into the table: "risolto.report_execution_user" */
  insert_risolto_report_execution_user_one?: Maybe<Risolto_Report_Execution_User>;
  /** insert data into the table: "risolto.report_template_type" */
  insert_risolto_report_template_type?: Maybe<Risolto_Report_Template_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.report_template_type" */
  insert_risolto_report_template_type_one?: Maybe<Risolto_Report_Template_Type>;
  /** insert data into the table: "risolto.report_type" */
  insert_risolto_report_type?: Maybe<Risolto_Report_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.report_type" */
  insert_risolto_report_type_one?: Maybe<Risolto_Report_Type>;
  /** insert data into the table: "risolto.report_user" */
  insert_risolto_report_user?: Maybe<Risolto_Report_User_Mutation_Response>;
  /** insert a single row into the table: "risolto.report_user" */
  insert_risolto_report_user_one?: Maybe<Risolto_Report_User>;
  /** insert data into the table: "risolto.run_processing_status" */
  insert_risolto_run_processing_status?: Maybe<Risolto_Run_Processing_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.run_processing_status" */
  insert_risolto_run_processing_status_one?: Maybe<Risolto_Run_Processing_Status>;
  /** insert data into the table: "risolto.single_sign_on" */
  insert_risolto_single_sign_on?: Maybe<Risolto_Single_Sign_On_Mutation_Response>;
  /** insert a single row into the table: "risolto.single_sign_on" */
  insert_risolto_single_sign_on_one?: Maybe<Risolto_Single_Sign_On>;
  /** insert data into the table: "risolto.statement" */
  insert_risolto_statement?: Maybe<Risolto_Statement_Mutation_Response>;
  /** insert data into the table: "risolto.statement_account" */
  insert_risolto_statement_account?: Maybe<Risolto_Statement_Account_Mutation_Response>;
  /** insert a single row into the table: "risolto.statement_account" */
  insert_risolto_statement_account_one?: Maybe<Risolto_Statement_Account>;
  /** insert data into the table: "risolto.statement_line" */
  insert_risolto_statement_line?: Maybe<Risolto_Statement_Line_Mutation_Response>;
  /** insert data into the table: "risolto.statement_line_dunning_notice" */
  insert_risolto_statement_line_dunning_notice?: Maybe<Risolto_Statement_Line_Dunning_Notice_Mutation_Response>;
  /** insert a single row into the table: "risolto.statement_line_dunning_notice" */
  insert_risolto_statement_line_dunning_notice_one?: Maybe<Risolto_Statement_Line_Dunning_Notice>;
  /** insert data into the table: "risolto.statement_line_invoice" */
  insert_risolto_statement_line_invoice?: Maybe<Risolto_Statement_Line_Invoice_Mutation_Response>;
  /** insert a single row into the table: "risolto.statement_line_invoice" */
  insert_risolto_statement_line_invoice_one?: Maybe<Risolto_Statement_Line_Invoice>;
  /** insert a single row into the table: "risolto.statement_line" */
  insert_risolto_statement_line_one?: Maybe<Risolto_Statement_Line>;
  /** insert data into the table: "risolto.statement_line_payment_promise" */
  insert_risolto_statement_line_payment_promise?: Maybe<Risolto_Statement_Line_Payment_Promise_Mutation_Response>;
  /** insert a single row into the table: "risolto.statement_line_payment_promise" */
  insert_risolto_statement_line_payment_promise_one?: Maybe<Risolto_Statement_Line_Payment_Promise>;
  /** insert data into the table: "risolto.statement_line_status" */
  insert_risolto_statement_line_status?: Maybe<Risolto_Statement_Line_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.statement_line_status" */
  insert_risolto_statement_line_status_one?: Maybe<Risolto_Statement_Line_Status>;
  /** insert a single row into the table: "risolto.statement" */
  insert_risolto_statement_one?: Maybe<Risolto_Statement>;
  /** insert data into the table: "risolto.strigil_nbb" */
  insert_risolto_strigil_nbb?: Maybe<Risolto_Strigil_Nbb_Mutation_Response>;
  /** insert a single row into the table: "risolto.strigil_nbb" */
  insert_risolto_strigil_nbb_one?: Maybe<Risolto_Strigil_Nbb>;
  /** insert data into the table: "risolto.strigil_nbb_processing_status" */
  insert_risolto_strigil_nbb_processing_status?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.strigil_nbb_processing_status" */
  insert_risolto_strigil_nbb_processing_status_one?: Maybe<Risolto_Strigil_Nbb_Processing_Status>;
  /** insert data into the table: "risolto.system_integration" */
  insert_risolto_system_integration?: Maybe<Risolto_System_Integration_Mutation_Response>;
  /** insert a single row into the table: "risolto.system_integration" */
  insert_risolto_system_integration_one?: Maybe<Risolto_System_Integration>;
  /** insert data into the table: "risolto.tag" */
  insert_risolto_tag?: Maybe<Risolto_Tag_Mutation_Response>;
  /** insert a single row into the table: "risolto.tag" */
  insert_risolto_tag_one?: Maybe<Risolto_Tag>;
  /** insert data into the table: "risolto.task" */
  insert_risolto_task?: Maybe<Risolto_Task_Mutation_Response>;
  /** insert a single row into the table: "risolto.task" */
  insert_risolto_task_one?: Maybe<Risolto_Task>;
  /** insert data into the table: "risolto.task_source" */
  insert_risolto_task_source?: Maybe<Risolto_Task_Source_Mutation_Response>;
  /** insert a single row into the table: "risolto.task_source" */
  insert_risolto_task_source_one?: Maybe<Risolto_Task_Source>;
  /** insert data into the table: "risolto.task_status" */
  insert_risolto_task_status?: Maybe<Risolto_Task_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.task_status" */
  insert_risolto_task_status_one?: Maybe<Risolto_Task_Status>;
  /** insert data into the table: "risolto.task_type" */
  insert_risolto_task_type?: Maybe<Risolto_Task_Type_Mutation_Response>;
  /** insert a single row into the table: "risolto.task_type" */
  insert_risolto_task_type_one?: Maybe<Risolto_Task_Type>;
  /** insert data into the table: "risolto.tone_of_voice" */
  insert_risolto_tone_of_voice?: Maybe<Risolto_Tone_Of_Voice_Mutation_Response>;
  /** insert a single row into the table: "risolto.tone_of_voice" */
  insert_risolto_tone_of_voice_one?: Maybe<Risolto_Tone_Of_Voice>;
  /** insert data into the table: "risolto.virtual_action_and_note" */
  insert_risolto_virtual_action_and_note?: Maybe<Risolto_Virtual_Action_And_Note_Mutation_Response>;
  /** insert data into the table: "risolto.virtual_action_and_note_and_dispute" */
  insert_risolto_virtual_action_and_note_and_dispute?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Mutation_Response>;
  /** insert data into the table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  insert_risolto_virtual_action_and_note_and_dispute_and_message?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  insert_risolto_virtual_action_and_note_and_dispute_and_message_one?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message>;
  /** insert a single row into the table: "risolto.virtual_action_and_note_and_dispute" */
  insert_risolto_virtual_action_and_note_and_dispute_one?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** insert a single row into the table: "risolto.virtual_action_and_note" */
  insert_risolto_virtual_action_and_note_one?: Maybe<Risolto_Virtual_Action_And_Note>;
  /** insert data into the table: "risolto.virtual_action_group" */
  insert_risolto_virtual_action_group?: Maybe<Risolto_Virtual_Action_Group_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_action_group" */
  insert_risolto_virtual_action_group_one?: Maybe<Risolto_Virtual_Action_Group>;
  /** insert data into the table: "risolto.virtual_dashboard_action_stats" */
  insert_risolto_virtual_dashboard_action_stats?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_dashboard_action_stats" */
  insert_risolto_virtual_dashboard_action_stats_one?: Maybe<Risolto_Virtual_Dashboard_Action_Stats>;
  /** insert data into the table: "risolto.virtual_dashboard_outstanding_debt" */
  insert_risolto_virtual_dashboard_outstanding_debt?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_dashboard_outstanding_debt" */
  insert_risolto_virtual_dashboard_outstanding_debt_one?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** insert data into the table: "risolto.virtual_demo_action_report_1" */
  insert_risolto_virtual_demo_action_report_1?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_demo_action_report_1" */
  insert_risolto_virtual_demo_action_report_1_one?: Maybe<Risolto_Virtual_Demo_Action_Report_1>;
  /** insert data into the table: "risolto.virtual_dunning_action" */
  insert_risolto_virtual_dunning_action?: Maybe<Risolto_Virtual_Dunning_Action_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_dunning_action" */
  insert_risolto_virtual_dunning_action_one?: Maybe<Risolto_Virtual_Dunning_Action>;
  /** insert data into the table: "risolto.virtual_interchange_event" */
  insert_risolto_virtual_interchange_event?: Maybe<Risolto_Virtual_Interchange_Event_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_interchange_event" */
  insert_risolto_virtual_interchange_event_one?: Maybe<Risolto_Virtual_Interchange_Event>;
  /** insert data into the table: "risolto.virtual_invoice_derived_payment_information" */
  insert_risolto_virtual_invoice_derived_payment_information?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_invoice_derived_payment_information" */
  insert_risolto_virtual_invoice_derived_payment_information_one?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information>;
  /** insert data into the table: "risolto.virtual_invoicing_channel_endpoint" */
  insert_risolto_virtual_invoicing_channel_endpoint?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_invoicing_channel_endpoint" */
  insert_risolto_virtual_invoicing_channel_endpoint_one?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** insert data into the table: "risolto.virtual_json" */
  insert_risolto_virtual_json?: Maybe<Risolto_Virtual_Json_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_json" */
  insert_risolto_virtual_json_one?: Maybe<Risolto_Virtual_Json>;
  /** insert data into the table: "risolto.virtual_report_delivery" */
  insert_risolto_virtual_report_delivery?: Maybe<Risolto_Virtual_Report_Delivery_Mutation_Response>;
  /** insert a single row into the table: "risolto.virtual_report_delivery" */
  insert_risolto_virtual_report_delivery_one?: Maybe<Risolto_Virtual_Report_Delivery>;
  /** insert data into the table: "risolto.webhook" */
  insert_risolto_webhook?: Maybe<Risolto_Webhook_Mutation_Response>;
  /** insert a single row into the table: "risolto.webhook" */
  insert_risolto_webhook_one?: Maybe<Risolto_Webhook>;
  /** insert data into the table: "risolto.webhook_processing_status" */
  insert_risolto_webhook_processing_status?: Maybe<Risolto_Webhook_Processing_Status_Mutation_Response>;
  /** insert a single row into the table: "risolto.webhook_processing_status" */
  insert_risolto_webhook_processing_status_one?: Maybe<Risolto_Webhook_Processing_Status>;
  /** insert data into the table: "risolto.webhook_subscription" */
  insert_risolto_webhook_subscription?: Maybe<Risolto_Webhook_Subscription_Mutation_Response>;
  /** insert a single row into the table: "risolto.webhook_subscription" */
  insert_risolto_webhook_subscription_one?: Maybe<Risolto_Webhook_Subscription>;
  /** execute VOLATILE function "risolto.move_credit_note" which returns "risolto.credit_note" */
  risolto_move_credit_note?: Maybe<Risolto_Credit_Note>;
  /** execute VOLATILE function "risolto.move_debit_note" which returns "risolto.debit_note" */
  risolto_move_debit_note?: Maybe<Risolto_Debit_Note>;
  /** execute VOLATILE function "risolto.move_invoice" which returns "risolto.invoice_document" */
  risolto_move_invoice?: Maybe<Risolto_Invoice_Document>;
  /** execute VOLATILE function "risolto.move_payment" which returns "risolto.payment_document" */
  risolto_move_payment?: Maybe<Risolto_Payment_Document>;
  /** execute VOLATILE function "risolto.platform_usage_export" which returns "risolto.virtual_json" */
  risolto_platform_usage_export: Array<Risolto_Virtual_Json>;
  /** update data of the table: "risolto.account_number_type" */
  update_risolto_account_number_type?: Maybe<Risolto_Account_Number_Type_Mutation_Response>;
  /** update single row of the table: "risolto.account_number_type" */
  update_risolto_account_number_type_by_pk?: Maybe<Risolto_Account_Number_Type>;
  /** update multiples rows of table: "risolto.account_number_type" */
  update_risolto_account_number_type_many?: Maybe<Array<Maybe<Risolto_Account_Number_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.action" */
  update_risolto_action?: Maybe<Risolto_Action_Mutation_Response>;
  /** update single row of the table: "risolto.action" */
  update_risolto_action_by_pk?: Maybe<Risolto_Action>;
  /** update data of the table: "risolto.action_execution_type" */
  update_risolto_action_execution_type?: Maybe<Risolto_Action_Execution_Type_Mutation_Response>;
  /** update single row of the table: "risolto.action_execution_type" */
  update_risolto_action_execution_type_by_pk?: Maybe<Risolto_Action_Execution_Type>;
  /** update multiples rows of table: "risolto.action_execution_type" */
  update_risolto_action_execution_type_many?: Maybe<Array<Maybe<Risolto_Action_Execution_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.action_interchange" */
  update_risolto_action_interchange?: Maybe<Risolto_Action_Interchange_Mutation_Response>;
  /** update single row of the table: "risolto.action_interchange" */
  update_risolto_action_interchange_by_pk?: Maybe<Risolto_Action_Interchange>;
  /** update multiples rows of table: "risolto.action_interchange" */
  update_risolto_action_interchange_many?: Maybe<Array<Maybe<Risolto_Action_Interchange_Mutation_Response>>>;
  /** update data of the table: "risolto.action_invoice" */
  update_risolto_action_invoice?: Maybe<Risolto_Action_Invoice_Mutation_Response>;
  /** update single row of the table: "risolto.action_invoice" */
  update_risolto_action_invoice_by_pk?: Maybe<Risolto_Action_Invoice>;
  /** update multiples rows of table: "risolto.action_invoice" */
  update_risolto_action_invoice_many?: Maybe<Array<Maybe<Risolto_Action_Invoice_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.action" */
  update_risolto_action_many?: Maybe<Array<Maybe<Risolto_Action_Mutation_Response>>>;
  /** update data of the table: "risolto.action_source" */
  update_risolto_action_source?: Maybe<Risolto_Action_Source_Mutation_Response>;
  /** update single row of the table: "risolto.action_source" */
  update_risolto_action_source_by_pk?: Maybe<Risolto_Action_Source>;
  /** update multiples rows of table: "risolto.action_source" */
  update_risolto_action_source_many?: Maybe<Array<Maybe<Risolto_Action_Source_Mutation_Response>>>;
  /** update data of the table: "risolto.action_status" */
  update_risolto_action_status?: Maybe<Risolto_Action_Status_Mutation_Response>;
  /** update single row of the table: "risolto.action_status" */
  update_risolto_action_status_by_pk?: Maybe<Risolto_Action_Status>;
  /** update multiples rows of table: "risolto.action_status" */
  update_risolto_action_status_many?: Maybe<Array<Maybe<Risolto_Action_Status_Mutation_Response>>>;
  /** update data of the table: "risolto.analytics_company_score" */
  update_risolto_analytics_company_score?: Maybe<Risolto_Analytics_Company_Score_Mutation_Response>;
  /** update single row of the table: "risolto.analytics_company_score" */
  update_risolto_analytics_company_score_by_pk?: Maybe<Risolto_Analytics_Company_Score>;
  /** update multiples rows of table: "risolto.analytics_company_score" */
  update_risolto_analytics_company_score_many?: Maybe<Array<Maybe<Risolto_Analytics_Company_Score_Mutation_Response>>>;
  /** update data of the table: "risolto.analytics_invoice_features" */
  update_risolto_analytics_invoice_features?: Maybe<Risolto_Analytics_Invoice_Features_Mutation_Response>;
  /** update single row of the table: "risolto.analytics_invoice_features" */
  update_risolto_analytics_invoice_features_by_pk?: Maybe<Risolto_Analytics_Invoice_Features>;
  /** update multiples rows of table: "risolto.analytics_invoice_features" */
  update_risolto_analytics_invoice_features_many?: Maybe<Array<Maybe<Risolto_Analytics_Invoice_Features_Mutation_Response>>>;
  /** update data of the table: "risolto.analytics_invoice_prediction" */
  update_risolto_analytics_invoice_prediction?: Maybe<Risolto_Analytics_Invoice_Prediction_Mutation_Response>;
  /** update single row of the table: "risolto.analytics_invoice_prediction" */
  update_risolto_analytics_invoice_prediction_by_pk?: Maybe<Risolto_Analytics_Invoice_Prediction>;
  /** update multiples rows of table: "risolto.analytics_invoice_prediction" */
  update_risolto_analytics_invoice_prediction_many?: Maybe<Array<Maybe<Risolto_Analytics_Invoice_Prediction_Mutation_Response>>>;
  /** update data of the table: "risolto.analytics_test" */
  update_risolto_analytics_test?: Maybe<Risolto_Analytics_Test_Mutation_Response>;
  /** update single row of the table: "risolto.analytics_test" */
  update_risolto_analytics_test_by_pk?: Maybe<Risolto_Analytics_Test>;
  /** update multiples rows of table: "risolto.analytics_test" */
  update_risolto_analytics_test_many?: Maybe<Array<Maybe<Risolto_Analytics_Test_Mutation_Response>>>;
  /** update data of the table: "risolto.analytics_test_result" */
  update_risolto_analytics_test_result?: Maybe<Risolto_Analytics_Test_Result_Mutation_Response>;
  /** update single row of the table: "risolto.analytics_test_result" */
  update_risolto_analytics_test_result_by_pk?: Maybe<Risolto_Analytics_Test_Result>;
  /** update multiples rows of table: "risolto.analytics_test_result" */
  update_risolto_analytics_test_result_many?: Maybe<Array<Maybe<Risolto_Analytics_Test_Result_Mutation_Response>>>;
  /** update data of the table: "risolto.api_app_client" */
  update_risolto_api_app_client?: Maybe<Risolto_Api_App_Client_Mutation_Response>;
  /** update single row of the table: "risolto.api_app_client" */
  update_risolto_api_app_client_by_pk?: Maybe<Risolto_Api_App_Client>;
  /** update multiples rows of table: "risolto.api_app_client" */
  update_risolto_api_app_client_many?: Maybe<Array<Maybe<Risolto_Api_App_Client_Mutation_Response>>>;
  /** update data of the table: "risolto.attachment" */
  update_risolto_attachment?: Maybe<Risolto_Attachment_Mutation_Response>;
  /** update single row of the table: "risolto.attachment" */
  update_risolto_attachment_by_pk?: Maybe<Risolto_Attachment>;
  /** update multiples rows of table: "risolto.attachment" */
  update_risolto_attachment_many?: Maybe<Array<Maybe<Risolto_Attachment_Mutation_Response>>>;
  /** update data of the table: "risolto.attachment_scheme" */
  update_risolto_attachment_scheme?: Maybe<Risolto_Attachment_Scheme_Mutation_Response>;
  /** update single row of the table: "risolto.attachment_scheme" */
  update_risolto_attachment_scheme_by_pk?: Maybe<Risolto_Attachment_Scheme>;
  /** update multiples rows of table: "risolto.attachment_scheme" */
  update_risolto_attachment_scheme_many?: Maybe<Array<Maybe<Risolto_Attachment_Scheme_Mutation_Response>>>;
  /** update data of the table: "risolto.bank_account" */
  update_risolto_bank_account?: Maybe<Risolto_Bank_Account_Mutation_Response>;
  /** update single row of the table: "risolto.bank_account" */
  update_risolto_bank_account_by_pk?: Maybe<Risolto_Bank_Account>;
  /** update multiples rows of table: "risolto.bank_account" */
  update_risolto_bank_account_many?: Maybe<Array<Maybe<Risolto_Bank_Account_Mutation_Response>>>;
  /** update data of the table: "risolto.bank_identifier_type" */
  update_risolto_bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Mutation_Response>;
  /** update single row of the table: "risolto.bank_identifier_type" */
  update_risolto_bank_identifier_type_by_pk?: Maybe<Risolto_Bank_Identifier_Type>;
  /** update multiples rows of table: "risolto.bank_identifier_type" */
  update_risolto_bank_identifier_type_many?: Maybe<Array<Maybe<Risolto_Bank_Identifier_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.blacklist" */
  update_risolto_blacklist?: Maybe<Risolto_Blacklist_Mutation_Response>;
  /** update single row of the table: "risolto.blacklist" */
  update_risolto_blacklist_by_pk?: Maybe<Risolto_Blacklist>;
  /** update multiples rows of table: "risolto.blacklist" */
  update_risolto_blacklist_many?: Maybe<Array<Maybe<Risolto_Blacklist_Mutation_Response>>>;
  /** update data of the table: "risolto.channel" */
  update_risolto_channel?: Maybe<Risolto_Channel_Mutation_Response>;
  /** update single row of the table: "risolto.channel" */
  update_risolto_channel_by_pk?: Maybe<Risolto_Channel>;
  /** update data of the table: "risolto.channel_endpoint" */
  update_risolto_channel_endpoint?: Maybe<Risolto_Channel_Endpoint_Mutation_Response>;
  /** update single row of the table: "risolto.channel_endpoint" */
  update_risolto_channel_endpoint_by_pk?: Maybe<Risolto_Channel_Endpoint>;
  /** update multiples rows of table: "risolto.channel_endpoint" */
  update_risolto_channel_endpoint_many?: Maybe<Array<Maybe<Risolto_Channel_Endpoint_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.channel" */
  update_risolto_channel_many?: Maybe<Array<Maybe<Risolto_Channel_Mutation_Response>>>;
  /** update data of the table: "risolto.communication" */
  update_risolto_communication?: Maybe<Risolto_Communication_Mutation_Response>;
  /** update single row of the table: "risolto.communication" */
  update_risolto_communication_by_pk?: Maybe<Risolto_Communication>;
  /** update multiples rows of table: "risolto.communication" */
  update_risolto_communication_many?: Maybe<Array<Maybe<Risolto_Communication_Mutation_Response>>>;
  /** update data of the table: "risolto.communication_template" */
  update_risolto_communication_template?: Maybe<Risolto_Communication_Template_Mutation_Response>;
  /** update single row of the table: "risolto.communication_template" */
  update_risolto_communication_template_by_pk?: Maybe<Risolto_Communication_Template>;
  /** update multiples rows of table: "risolto.communication_template" */
  update_risolto_communication_template_many?: Maybe<Array<Maybe<Risolto_Communication_Template_Mutation_Response>>>;
  /** update data of the table: "risolto.communication_template_type" */
  update_risolto_communication_template_type?: Maybe<Risolto_Communication_Template_Type_Mutation_Response>;
  /** update single row of the table: "risolto.communication_template_type" */
  update_risolto_communication_template_type_by_pk?: Maybe<Risolto_Communication_Template_Type>;
  /** update multiples rows of table: "risolto.communication_template_type" */
  update_risolto_communication_template_type_many?: Maybe<Array<Maybe<Risolto_Communication_Template_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.contact" */
  update_risolto_contact?: Maybe<Risolto_Contact_Mutation_Response>;
  /** update data of the table: "risolto.contact_address" */
  update_risolto_contact_address?: Maybe<Risolto_Contact_Address_Mutation_Response>;
  /** update multiples rows of table: "risolto.contact_address" */
  update_risolto_contact_address_many?: Maybe<Array<Maybe<Risolto_Contact_Address_Mutation_Response>>>;
  /** update single row of the table: "risolto.contact" */
  update_risolto_contact_by_pk?: Maybe<Risolto_Contact>;
  /** update multiples rows of table: "risolto.contact" */
  update_risolto_contact_many?: Maybe<Array<Maybe<Risolto_Contact_Mutation_Response>>>;
  /** update data of the table: "risolto.contact_type" */
  update_risolto_contact_type?: Maybe<Risolto_Contact_Type_Mutation_Response>;
  /** update single row of the table: "risolto.contact_type" */
  update_risolto_contact_type_by_pk?: Maybe<Risolto_Contact_Type>;
  /** update multiples rows of table: "risolto.contact_type" */
  update_risolto_contact_type_many?: Maybe<Array<Maybe<Risolto_Contact_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.content_disposition" */
  update_risolto_content_disposition?: Maybe<Risolto_Content_Disposition_Mutation_Response>;
  /** update single row of the table: "risolto.content_disposition" */
  update_risolto_content_disposition_by_pk?: Maybe<Risolto_Content_Disposition>;
  /** update multiples rows of table: "risolto.content_disposition" */
  update_risolto_content_disposition_many?: Maybe<Array<Maybe<Risolto_Content_Disposition_Mutation_Response>>>;
  /** update data of the table: "risolto.credit_limit" */
  update_risolto_credit_limit?: Maybe<Risolto_Credit_Limit_Mutation_Response>;
  /** update single row of the table: "risolto.credit_limit" */
  update_risolto_credit_limit_by_pk?: Maybe<Risolto_Credit_Limit>;
  /** update multiples rows of table: "risolto.credit_limit" */
  update_risolto_credit_limit_many?: Maybe<Array<Maybe<Risolto_Credit_Limit_Mutation_Response>>>;
  /** update data of the table: "risolto.credit_note" */
  update_risolto_credit_note?: Maybe<Risolto_Credit_Note_Mutation_Response>;
  /** update data of the table: "risolto.credit_note_attachment" */
  update_risolto_credit_note_attachment?: Maybe<Risolto_Credit_Note_Attachment_Mutation_Response>;
  /** update single row of the table: "risolto.credit_note_attachment" */
  update_risolto_credit_note_attachment_by_pk?: Maybe<Risolto_Credit_Note_Attachment>;
  /** update multiples rows of table: "risolto.credit_note_attachment" */
  update_risolto_credit_note_attachment_many?: Maybe<Array<Maybe<Risolto_Credit_Note_Attachment_Mutation_Response>>>;
  /** update single row of the table: "risolto.credit_note" */
  update_risolto_credit_note_by_pk?: Maybe<Risolto_Credit_Note>;
  /** update multiples rows of table: "risolto.credit_note" */
  update_risolto_credit_note_many?: Maybe<Array<Maybe<Risolto_Credit_Note_Mutation_Response>>>;
  /** update data of the table: "risolto.currency" */
  update_risolto_currency?: Maybe<Risolto_Currency_Mutation_Response>;
  /** update single row of the table: "risolto.currency" */
  update_risolto_currency_by_pk?: Maybe<Risolto_Currency>;
  /** update multiples rows of table: "risolto.currency" */
  update_risolto_currency_many?: Maybe<Array<Maybe<Risolto_Currency_Mutation_Response>>>;
  /** update data of the table: "risolto.debit_note" */
  update_risolto_debit_note?: Maybe<Risolto_Debit_Note_Mutation_Response>;
  /** update data of the table: "risolto.debit_note_attachment" */
  update_risolto_debit_note_attachment?: Maybe<Risolto_Debit_Note_Attachment_Mutation_Response>;
  /** update single row of the table: "risolto.debit_note_attachment" */
  update_risolto_debit_note_attachment_by_pk?: Maybe<Risolto_Debit_Note_Attachment>;
  /** update multiples rows of table: "risolto.debit_note_attachment" */
  update_risolto_debit_note_attachment_many?: Maybe<Array<Maybe<Risolto_Debit_Note_Attachment_Mutation_Response>>>;
  /** update single row of the table: "risolto.debit_note" */
  update_risolto_debit_note_by_pk?: Maybe<Risolto_Debit_Note>;
  /** update multiples rows of table: "risolto.debit_note" */
  update_risolto_debit_note_many?: Maybe<Array<Maybe<Risolto_Debit_Note_Mutation_Response>>>;
  /** update data of the table: "risolto.direct_debit_mandate" */
  update_risolto_direct_debit_mandate?: Maybe<Risolto_Direct_Debit_Mandate_Mutation_Response>;
  /** update single row of the table: "risolto.direct_debit_mandate" */
  update_risolto_direct_debit_mandate_by_pk?: Maybe<Risolto_Direct_Debit_Mandate>;
  /** update multiples rows of table: "risolto.direct_debit_mandate" */
  update_risolto_direct_debit_mandate_many?: Maybe<Array<Maybe<Risolto_Direct_Debit_Mandate_Mutation_Response>>>;
  /** update data of the table: "risolto.direct_debit_provider" */
  update_risolto_direct_debit_provider?: Maybe<Risolto_Direct_Debit_Provider_Mutation_Response>;
  /** update single row of the table: "risolto.direct_debit_provider" */
  update_risolto_direct_debit_provider_by_pk?: Maybe<Risolto_Direct_Debit_Provider>;
  /** update multiples rows of table: "risolto.direct_debit_provider" */
  update_risolto_direct_debit_provider_many?: Maybe<Array<Maybe<Risolto_Direct_Debit_Provider_Mutation_Response>>>;
  /** update data of the table: "risolto.direct_debit_scheme" */
  update_risolto_direct_debit_scheme?: Maybe<Risolto_Direct_Debit_Scheme_Mutation_Response>;
  /** update single row of the table: "risolto.direct_debit_scheme" */
  update_risolto_direct_debit_scheme_by_pk?: Maybe<Risolto_Direct_Debit_Scheme>;
  /** update multiples rows of table: "risolto.direct_debit_scheme" */
  update_risolto_direct_debit_scheme_many?: Maybe<Array<Maybe<Risolto_Direct_Debit_Scheme_Mutation_Response>>>;
  /** update data of the table: "risolto.direct_debit_sequence_type" */
  update_risolto_direct_debit_sequence_type?: Maybe<Risolto_Direct_Debit_Sequence_Type_Mutation_Response>;
  /** update single row of the table: "risolto.direct_debit_sequence_type" */
  update_risolto_direct_debit_sequence_type_by_pk?: Maybe<Risolto_Direct_Debit_Sequence_Type>;
  /** update multiples rows of table: "risolto.direct_debit_sequence_type" */
  update_risolto_direct_debit_sequence_type_many?: Maybe<Array<Maybe<Risolto_Direct_Debit_Sequence_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.direct_debit_transaction" */
  update_risolto_direct_debit_transaction?: Maybe<Risolto_Direct_Debit_Transaction_Mutation_Response>;
  /** update single row of the table: "risolto.direct_debit_transaction" */
  update_risolto_direct_debit_transaction_by_pk?: Maybe<Risolto_Direct_Debit_Transaction>;
  /** update multiples rows of table: "risolto.direct_debit_transaction" */
  update_risolto_direct_debit_transaction_many?: Maybe<Array<Maybe<Risolto_Direct_Debit_Transaction_Mutation_Response>>>;
  /** update data of the table: "risolto.dispute_code" */
  update_risolto_dispute_code?: Maybe<Risolto_Dispute_Code_Mutation_Response>;
  /** update single row of the table: "risolto.dispute_code" */
  update_risolto_dispute_code_by_pk?: Maybe<Risolto_Dispute_Code>;
  /** update multiples rows of table: "risolto.dispute_code" */
  update_risolto_dispute_code_many?: Maybe<Array<Maybe<Risolto_Dispute_Code_Mutation_Response>>>;
  /** update data of the table: "risolto.document_attachment_type" */
  update_risolto_document_attachment_type?: Maybe<Risolto_Document_Attachment_Type_Mutation_Response>;
  /** update single row of the table: "risolto.document_attachment_type" */
  update_risolto_document_attachment_type_by_pk?: Maybe<Risolto_Document_Attachment_Type>;
  /** update multiples rows of table: "risolto.document_attachment_type" */
  update_risolto_document_attachment_type_many?: Maybe<Array<Maybe<Risolto_Document_Attachment_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.document_interchange" */
  update_risolto_document_interchange?: Maybe<Risolto_Document_Interchange_Mutation_Response>;
  /** update data of the table: "risolto.document_interchange_attachment" */
  update_risolto_document_interchange_attachment?: Maybe<Risolto_Document_Interchange_Attachment_Mutation_Response>;
  /** update single row of the table: "risolto.document_interchange_attachment" */
  update_risolto_document_interchange_attachment_by_pk?: Maybe<Risolto_Document_Interchange_Attachment>;
  /** update multiples rows of table: "risolto.document_interchange_attachment" */
  update_risolto_document_interchange_attachment_many?: Maybe<Array<Maybe<Risolto_Document_Interchange_Attachment_Mutation_Response>>>;
  /** update single row of the table: "risolto.document_interchange" */
  update_risolto_document_interchange_by_pk?: Maybe<Risolto_Document_Interchange>;
  /** update data of the table: "risolto.document_interchange_direction" */
  update_risolto_document_interchange_direction?: Maybe<Risolto_Document_Interchange_Direction_Mutation_Response>;
  /** update single row of the table: "risolto.document_interchange_direction" */
  update_risolto_document_interchange_direction_by_pk?: Maybe<Risolto_Document_Interchange_Direction>;
  /** update multiples rows of table: "risolto.document_interchange_direction" */
  update_risolto_document_interchange_direction_many?: Maybe<Array<Maybe<Risolto_Document_Interchange_Direction_Mutation_Response>>>;
  /** update data of the table: "risolto.document_interchange_event" */
  update_risolto_document_interchange_event?: Maybe<Risolto_Document_Interchange_Event_Mutation_Response>;
  /** update single row of the table: "risolto.document_interchange_event" */
  update_risolto_document_interchange_event_by_pk?: Maybe<Risolto_Document_Interchange_Event>;
  /** update multiples rows of table: "risolto.document_interchange_event" */
  update_risolto_document_interchange_event_many?: Maybe<Array<Maybe<Risolto_Document_Interchange_Event_Mutation_Response>>>;
  /** update data of the table: "risolto.document_interchange_link" */
  update_risolto_document_interchange_link?: Maybe<Risolto_Document_Interchange_Link_Mutation_Response>;
  /** update single row of the table: "risolto.document_interchange_link" */
  update_risolto_document_interchange_link_by_pk?: Maybe<Risolto_Document_Interchange_Link>;
  /** update multiples rows of table: "risolto.document_interchange_link" */
  update_risolto_document_interchange_link_many?: Maybe<Array<Maybe<Risolto_Document_Interchange_Link_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.document_interchange" */
  update_risolto_document_interchange_many?: Maybe<Array<Maybe<Risolto_Document_Interchange_Mutation_Response>>>;
  /** update data of the table: "risolto.dunning_notice" */
  update_risolto_dunning_notice?: Maybe<Risolto_Dunning_Notice_Mutation_Response>;
  /** update single row of the table: "risolto.dunning_notice" */
  update_risolto_dunning_notice_by_pk?: Maybe<Risolto_Dunning_Notice>;
  /** update data of the table: "risolto.dunning_notice_invoice" */
  update_risolto_dunning_notice_invoice?: Maybe<Risolto_Dunning_Notice_Invoice_Mutation_Response>;
  /** update single row of the table: "risolto.dunning_notice_invoice" */
  update_risolto_dunning_notice_invoice_by_pk?: Maybe<Risolto_Dunning_Notice_Invoice>;
  /** update multiples rows of table: "risolto.dunning_notice_invoice" */
  update_risolto_dunning_notice_invoice_many?: Maybe<Array<Maybe<Risolto_Dunning_Notice_Invoice_Mutation_Response>>>;
  /** update data of the table: "risolto.dunning_notice_invoice_relation" */
  update_risolto_dunning_notice_invoice_relation?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Mutation_Response>;
  /** update single row of the table: "risolto.dunning_notice_invoice_relation" */
  update_risolto_dunning_notice_invoice_relation_by_pk?: Maybe<Risolto_Dunning_Notice_Invoice_Relation>;
  /** update multiples rows of table: "risolto.dunning_notice_invoice_relation" */
  update_risolto_dunning_notice_invoice_relation_many?: Maybe<Array<Maybe<Risolto_Dunning_Notice_Invoice_Relation_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.dunning_notice" */
  update_risolto_dunning_notice_many?: Maybe<Array<Maybe<Risolto_Dunning_Notice_Mutation_Response>>>;
  /** update data of the table: "risolto.dunning_notice_status" */
  update_risolto_dunning_notice_status?: Maybe<Risolto_Dunning_Notice_Status_Mutation_Response>;
  /** update single row of the table: "risolto.dunning_notice_status" */
  update_risolto_dunning_notice_status_by_pk?: Maybe<Risolto_Dunning_Notice_Status>;
  /** update multiples rows of table: "risolto.dunning_notice_status" */
  update_risolto_dunning_notice_status_many?: Maybe<Array<Maybe<Risolto_Dunning_Notice_Status_Mutation_Response>>>;
  /** update data of the table: "risolto.dunning_notice_type_code" */
  update_risolto_dunning_notice_type_code?: Maybe<Risolto_Dunning_Notice_Type_Code_Mutation_Response>;
  /** update single row of the table: "risolto.dunning_notice_type_code" */
  update_risolto_dunning_notice_type_code_by_pk?: Maybe<Risolto_Dunning_Notice_Type_Code>;
  /** update multiples rows of table: "risolto.dunning_notice_type_code" */
  update_risolto_dunning_notice_type_code_many?: Maybe<Array<Maybe<Risolto_Dunning_Notice_Type_Code_Mutation_Response>>>;
  /** update data of the table: "risolto.frequency" */
  update_risolto_frequency?: Maybe<Risolto_Frequency_Mutation_Response>;
  /** update single row of the table: "risolto.frequency" */
  update_risolto_frequency_by_pk?: Maybe<Risolto_Frequency>;
  /** update multiples rows of table: "risolto.frequency" */
  update_risolto_frequency_many?: Maybe<Array<Maybe<Risolto_Frequency_Mutation_Response>>>;
  /** update data of the table: "risolto.grant_type" */
  update_risolto_grant_type?: Maybe<Risolto_Grant_Type_Mutation_Response>;
  /** update single row of the table: "risolto.grant_type" */
  update_risolto_grant_type_by_pk?: Maybe<Risolto_Grant_Type>;
  /** update multiples rows of table: "risolto.grant_type" */
  update_risolto_grant_type_many?: Maybe<Array<Maybe<Risolto_Grant_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_collection" */
  update_risolto_invoice_collection?: Maybe<Risolto_Invoice_Collection_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_collection" */
  update_risolto_invoice_collection_by_pk?: Maybe<Risolto_Invoice_Collection>;
  /** update multiples rows of table: "risolto.invoice_collection" */
  update_risolto_invoice_collection_many?: Maybe<Array<Maybe<Risolto_Invoice_Collection_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_dispute" */
  update_risolto_invoice_dispute?: Maybe<Risolto_Invoice_Dispute_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_dispute" */
  update_risolto_invoice_dispute_by_pk?: Maybe<Risolto_Invoice_Dispute>;
  /** update multiples rows of table: "risolto.invoice_dispute" */
  update_risolto_invoice_dispute_many?: Maybe<Array<Maybe<Risolto_Invoice_Dispute_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_document" */
  update_risolto_invoice_document?: Maybe<Risolto_Invoice_Document_Mutation_Response>;
  /** update data of the table: "risolto.invoice_document_attachment" */
  update_risolto_invoice_document_attachment?: Maybe<Risolto_Invoice_Document_Attachment_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_document_attachment" */
  update_risolto_invoice_document_attachment_by_pk?: Maybe<Risolto_Invoice_Document_Attachment>;
  /** update multiples rows of table: "risolto.invoice_document_attachment" */
  update_risolto_invoice_document_attachment_many?: Maybe<Array<Maybe<Risolto_Invoice_Document_Attachment_Mutation_Response>>>;
  /** update single row of the table: "risolto.invoice_document" */
  update_risolto_invoice_document_by_pk?: Maybe<Risolto_Invoice_Document>;
  /** update multiples rows of table: "risolto.invoice_document" */
  update_risolto_invoice_document_many?: Maybe<Array<Maybe<Risolto_Invoice_Document_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_document_status" */
  update_risolto_invoice_document_status?: Maybe<Risolto_Invoice_Document_Status_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_document_status" */
  update_risolto_invoice_document_status_by_pk?: Maybe<Risolto_Invoice_Document_Status>;
  /** update multiples rows of table: "risolto.invoice_document_status" */
  update_risolto_invoice_document_status_many?: Maybe<Array<Maybe<Risolto_Invoice_Document_Status_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_group" */
  update_risolto_invoice_group?: Maybe<Risolto_Invoice_Group_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_group" */
  update_risolto_invoice_group_by_pk?: Maybe<Risolto_Invoice_Group>;
  /** update data of the table: "risolto.invoice_group_credit_note" */
  update_risolto_invoice_group_credit_note?: Maybe<Risolto_Invoice_Group_Credit_Note_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_group_credit_note" */
  update_risolto_invoice_group_credit_note_by_pk?: Maybe<Risolto_Invoice_Group_Credit_Note>;
  /** update multiples rows of table: "risolto.invoice_group_credit_note" */
  update_risolto_invoice_group_credit_note_many?: Maybe<Array<Maybe<Risolto_Invoice_Group_Credit_Note_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_group_debit_note" */
  update_risolto_invoice_group_debit_note?: Maybe<Risolto_Invoice_Group_Debit_Note_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_group_debit_note" */
  update_risolto_invoice_group_debit_note_by_pk?: Maybe<Risolto_Invoice_Group_Debit_Note>;
  /** update multiples rows of table: "risolto.invoice_group_debit_note" */
  update_risolto_invoice_group_debit_note_many?: Maybe<Array<Maybe<Risolto_Invoice_Group_Debit_Note_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_group_dunning_run" */
  update_risolto_invoice_group_dunning_run?: Maybe<Risolto_Invoice_Group_Dunning_Run_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_group_dunning_run" */
  update_risolto_invoice_group_dunning_run_by_pk?: Maybe<Risolto_Invoice_Group_Dunning_Run>;
  /** update multiples rows of table: "risolto.invoice_group_dunning_run" */
  update_risolto_invoice_group_dunning_run_many?: Maybe<Array<Maybe<Risolto_Invoice_Group_Dunning_Run_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_group_invoice" */
  update_risolto_invoice_group_invoice?: Maybe<Risolto_Invoice_Group_Invoice_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_group_invoice" */
  update_risolto_invoice_group_invoice_by_pk?: Maybe<Risolto_Invoice_Group_Invoice>;
  /** update multiples rows of table: "risolto.invoice_group_invoice" */
  update_risolto_invoice_group_invoice_many?: Maybe<Array<Maybe<Risolto_Invoice_Group_Invoice_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.invoice_group" */
  update_risolto_invoice_group_many?: Maybe<Array<Maybe<Risolto_Invoice_Group_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_group_payment" */
  update_risolto_invoice_group_payment?: Maybe<Risolto_Invoice_Group_Payment_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_group_payment" */
  update_risolto_invoice_group_payment_by_pk?: Maybe<Risolto_Invoice_Group_Payment>;
  /** update multiples rows of table: "risolto.invoice_group_payment" */
  update_risolto_invoice_group_payment_many?: Maybe<Array<Maybe<Risolto_Invoice_Group_Payment_Mutation_Response>>>;
  /** update data of the table: "risolto.invoice_group_payment_promise" */
  update_risolto_invoice_group_payment_promise?: Maybe<Risolto_Invoice_Group_Payment_Promise_Mutation_Response>;
  /** update single row of the table: "risolto.invoice_group_payment_promise" */
  update_risolto_invoice_group_payment_promise_by_pk?: Maybe<Risolto_Invoice_Group_Payment_Promise>;
  /** update multiples rows of table: "risolto.invoice_group_payment_promise" */
  update_risolto_invoice_group_payment_promise_many?: Maybe<Array<Maybe<Risolto_Invoice_Group_Payment_Promise_Mutation_Response>>>;
  /** update data of the table: "risolto.iso_country_code" */
  update_risolto_iso_country_code?: Maybe<Risolto_Iso_Country_Code_Mutation_Response>;
  /** update single row of the table: "risolto.iso_country_code" */
  update_risolto_iso_country_code_by_pk?: Maybe<Risolto_Iso_Country_Code>;
  /** update multiples rows of table: "risolto.iso_country_code" */
  update_risolto_iso_country_code_many?: Maybe<Array<Maybe<Risolto_Iso_Country_Code_Mutation_Response>>>;
  /** update data of the table: "risolto.job" */
  update_risolto_job?: Maybe<Risolto_Job_Mutation_Response>;
  /** update single row of the table: "risolto.job" */
  update_risolto_job_by_pk?: Maybe<Risolto_Job>;
  /** update multiples rows of table: "risolto.job" */
  update_risolto_job_many?: Maybe<Array<Maybe<Risolto_Job_Mutation_Response>>>;
  /** update data of the table: "risolto.language_code" */
  update_risolto_language_code?: Maybe<Risolto_Language_Code_Mutation_Response>;
  /** update single row of the table: "risolto.language_code" */
  update_risolto_language_code_by_pk?: Maybe<Risolto_Language_Code>;
  /** update multiples rows of table: "risolto.language_code" */
  update_risolto_language_code_many?: Maybe<Array<Maybe<Risolto_Language_Code_Mutation_Response>>>;
  /** update data of the table: "risolto.legal_entity" */
  update_risolto_legal_entity?: Maybe<Risolto_Legal_Entity_Mutation_Response>;
  /** update single row of the table: "risolto.legal_entity" */
  update_risolto_legal_entity_by_pk?: Maybe<Risolto_Legal_Entity>;
  /** update multiples rows of table: "risolto.legal_entity" */
  update_risolto_legal_entity_many?: Maybe<Array<Maybe<Risolto_Legal_Entity_Mutation_Response>>>;
  /** update data of the table: "risolto.locale" */
  update_risolto_locale?: Maybe<Risolto_Locale_Mutation_Response>;
  /** update single row of the table: "risolto.locale" */
  update_risolto_locale_by_pk?: Maybe<Risolto_Locale>;
  /** update multiples rows of table: "risolto.locale" */
  update_risolto_locale_many?: Maybe<Array<Maybe<Risolto_Locale_Mutation_Response>>>;
  /** update data of the table: "risolto.magda_cache" */
  update_risolto_magda_cache?: Maybe<Risolto_Magda_Cache_Mutation_Response>;
  /** update single row of the table: "risolto.magda_cache" */
  update_risolto_magda_cache_by_pk?: Maybe<Risolto_Magda_Cache>;
  /** update multiples rows of table: "risolto.magda_cache" */
  update_risolto_magda_cache_many?: Maybe<Array<Maybe<Risolto_Magda_Cache_Mutation_Response>>>;
  /** update data of the table: "risolto.magda_service_audit_log" */
  update_risolto_magda_service_audit_log?: Maybe<Risolto_Magda_Service_Audit_Log_Mutation_Response>;
  /** update single row of the table: "risolto.magda_service_audit_log" */
  update_risolto_magda_service_audit_log_by_pk?: Maybe<Risolto_Magda_Service_Audit_Log>;
  /** update multiples rows of table: "risolto.magda_service_audit_log" */
  update_risolto_magda_service_audit_log_many?: Maybe<Array<Maybe<Risolto_Magda_Service_Audit_Log_Mutation_Response>>>;
  /** update data of the table: "risolto.materialized_view_definition" */
  update_risolto_materialized_view_definition?: Maybe<Risolto_Materialized_View_Definition_Mutation_Response>;
  /** update single row of the table: "risolto.materialized_view_definition" */
  update_risolto_materialized_view_definition_by_pk?: Maybe<Risolto_Materialized_View_Definition>;
  /** update multiples rows of table: "risolto.materialized_view_definition" */
  update_risolto_materialized_view_definition_many?: Maybe<Array<Maybe<Risolto_Materialized_View_Definition_Mutation_Response>>>;
  /** update data of the table: "risolto.message" */
  update_risolto_message?: Maybe<Risolto_Message_Mutation_Response>;
  /** update data of the table: "risolto.message_assignee" */
  update_risolto_message_assignee?: Maybe<Risolto_Message_Assignee_Mutation_Response>;
  /** update single row of the table: "risolto.message_assignee" */
  update_risolto_message_assignee_by_pk?: Maybe<Risolto_Message_Assignee>;
  /** update multiples rows of table: "risolto.message_assignee" */
  update_risolto_message_assignee_many?: Maybe<Array<Maybe<Risolto_Message_Assignee_Mutation_Response>>>;
  /** update data of the table: "risolto.message_attachment" */
  update_risolto_message_attachment?: Maybe<Risolto_Message_Attachment_Mutation_Response>;
  /** update single row of the table: "risolto.message_attachment" */
  update_risolto_message_attachment_by_pk?: Maybe<Risolto_Message_Attachment>;
  /** update multiples rows of table: "risolto.message_attachment" */
  update_risolto_message_attachment_many?: Maybe<Array<Maybe<Risolto_Message_Attachment_Mutation_Response>>>;
  /** update single row of the table: "risolto.message" */
  update_risolto_message_by_pk?: Maybe<Risolto_Message>;
  /** update data of the table: "risolto.message_label" */
  update_risolto_message_label?: Maybe<Risolto_Message_Label_Mutation_Response>;
  /** update single row of the table: "risolto.message_label" */
  update_risolto_message_label_by_pk?: Maybe<Risolto_Message_Label>;
  /** update multiples rows of table: "risolto.message_label" */
  update_risolto_message_label_many?: Maybe<Array<Maybe<Risolto_Message_Label_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.message" */
  update_risolto_message_many?: Maybe<Array<Maybe<Risolto_Message_Mutation_Response>>>;
  /** update data of the table: "risolto.message_message_label" */
  update_risolto_message_message_label?: Maybe<Risolto_Message_Message_Label_Mutation_Response>;
  /** update single row of the table: "risolto.message_message_label" */
  update_risolto_message_message_label_by_pk?: Maybe<Risolto_Message_Message_Label>;
  /** update multiples rows of table: "risolto.message_message_label" */
  update_risolto_message_message_label_many?: Maybe<Array<Maybe<Risolto_Message_Message_Label_Mutation_Response>>>;
  /** update data of the table: "risolto.message_recipient" */
  update_risolto_message_recipient?: Maybe<Risolto_Message_Recipient_Mutation_Response>;
  /** update single row of the table: "risolto.message_recipient" */
  update_risolto_message_recipient_by_pk?: Maybe<Risolto_Message_Recipient>;
  /** update multiples rows of table: "risolto.message_recipient" */
  update_risolto_message_recipient_many?: Maybe<Array<Maybe<Risolto_Message_Recipient_Mutation_Response>>>;
  /** update data of the table: "risolto.mime_type" */
  update_risolto_mime_type?: Maybe<Risolto_Mime_Type_Mutation_Response>;
  /** update single row of the table: "risolto.mime_type" */
  update_risolto_mime_type_by_pk?: Maybe<Risolto_Mime_Type>;
  /** update multiples rows of table: "risolto.mime_type" */
  update_risolto_mime_type_many?: Maybe<Array<Maybe<Risolto_Mime_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.note" */
  update_risolto_note?: Maybe<Risolto_Note_Mutation_Response>;
  /** update single row of the table: "risolto.note" */
  update_risolto_note_by_pk?: Maybe<Risolto_Note>;
  /** update data of the table: "risolto.note_category" */
  update_risolto_note_category?: Maybe<Risolto_Note_Category_Mutation_Response>;
  /** update single row of the table: "risolto.note_category" */
  update_risolto_note_category_by_pk?: Maybe<Risolto_Note_Category>;
  /** update multiples rows of table: "risolto.note_category" */
  update_risolto_note_category_many?: Maybe<Array<Maybe<Risolto_Note_Category_Mutation_Response>>>;
  /** update data of the table: "risolto.note_invoice" */
  update_risolto_note_invoice?: Maybe<Risolto_Note_Invoice_Mutation_Response>;
  /** update single row of the table: "risolto.note_invoice" */
  update_risolto_note_invoice_by_pk?: Maybe<Risolto_Note_Invoice>;
  /** update multiples rows of table: "risolto.note_invoice" */
  update_risolto_note_invoice_many?: Maybe<Array<Maybe<Risolto_Note_Invoice_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.note" */
  update_risolto_note_many?: Maybe<Array<Maybe<Risolto_Note_Mutation_Response>>>;
  /** update data of the table: "risolto.open_balance" */
  update_risolto_open_balance?: Maybe<Risolto_Open_Balance_Mutation_Response>;
  /** update single row of the table: "risolto.open_balance" */
  update_risolto_open_balance_by_pk?: Maybe<Risolto_Open_Balance>;
  /** update multiples rows of table: "risolto.open_balance" */
  update_risolto_open_balance_many?: Maybe<Array<Maybe<Risolto_Open_Balance_Mutation_Response>>>;
  /** update data of the table: "risolto.open_balance_record" */
  update_risolto_open_balance_record?: Maybe<Risolto_Open_Balance_Record_Mutation_Response>;
  /** update single row of the table: "risolto.open_balance_record" */
  update_risolto_open_balance_record_by_pk?: Maybe<Risolto_Open_Balance_Record>;
  /** update multiples rows of table: "risolto.open_balance_record" */
  update_risolto_open_balance_record_many?: Maybe<Array<Maybe<Risolto_Open_Balance_Record_Mutation_Response>>>;
  /** update data of the table: "risolto.origin" */
  update_risolto_origin?: Maybe<Risolto_Origin_Mutation_Response>;
  /** update single row of the table: "risolto.origin" */
  update_risolto_origin_by_pk?: Maybe<Risolto_Origin>;
  /** update multiples rows of table: "risolto.origin" */
  update_risolto_origin_many?: Maybe<Array<Maybe<Risolto_Origin_Mutation_Response>>>;
  /** update data of the table: "risolto.participant" */
  update_risolto_participant?: Maybe<Risolto_Participant_Mutation_Response>;
  /** update data of the table: "risolto.participant_api_app_client" */
  update_risolto_participant_api_app_client?: Maybe<Risolto_Participant_Api_App_Client_Mutation_Response>;
  /** update single row of the table: "risolto.participant_api_app_client" */
  update_risolto_participant_api_app_client_by_pk?: Maybe<Risolto_Participant_Api_App_Client>;
  /** update multiples rows of table: "risolto.participant_api_app_client" */
  update_risolto_participant_api_app_client_many?: Maybe<Array<Maybe<Risolto_Participant_Api_App_Client_Mutation_Response>>>;
  /** update single row of the table: "risolto.participant" */
  update_risolto_participant_by_pk?: Maybe<Risolto_Participant>;
  /** update data of the table: "risolto.participant_dunning_run" */
  update_risolto_participant_dunning_run?: Maybe<Risolto_Participant_Dunning_Run_Mutation_Response>;
  /** update single row of the table: "risolto.participant_dunning_run" */
  update_risolto_participant_dunning_run_by_pk?: Maybe<Risolto_Participant_Dunning_Run>;
  /** update multiples rows of table: "risolto.participant_dunning_run" */
  update_risolto_participant_dunning_run_many?: Maybe<Array<Maybe<Risolto_Participant_Dunning_Run_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.participant" */
  update_risolto_participant_many?: Maybe<Array<Maybe<Risolto_Participant_Mutation_Response>>>;
  /** update data of the table: "risolto.participant_user" */
  update_risolto_participant_user?: Maybe<Risolto_Participant_User_Mutation_Response>;
  /** update single row of the table: "risolto.participant_user" */
  update_risolto_participant_user_by_pk?: Maybe<Risolto_Participant_User>;
  /** update multiples rows of table: "risolto.participant_user" */
  update_risolto_participant_user_many?: Maybe<Array<Maybe<Risolto_Participant_User_Mutation_Response>>>;
  /** update data of the table: "risolto.participant_user_role" */
  update_risolto_participant_user_role?: Maybe<Risolto_Participant_User_Role_Mutation_Response>;
  /** update single row of the table: "risolto.participant_user_role" */
  update_risolto_participant_user_role_by_pk?: Maybe<Risolto_Participant_User_Role>;
  /** update multiples rows of table: "risolto.participant_user_role" */
  update_risolto_participant_user_role_many?: Maybe<Array<Maybe<Risolto_Participant_User_Role_Mutation_Response>>>;
  /** update data of the table: "risolto.payment" */
  update_risolto_payment?: Maybe<Risolto_Payment_Mutation_Response>;
  /** update single row of the table: "risolto.payment" */
  update_risolto_payment_by_pk?: Maybe<Risolto_Payment>;
  /** update data of the table: "risolto.payment_document" */
  update_risolto_payment_document?: Maybe<Risolto_Payment_Document_Mutation_Response>;
  /** update single row of the table: "risolto.payment_document" */
  update_risolto_payment_document_by_pk?: Maybe<Risolto_Payment_Document>;
  /** update multiples rows of table: "risolto.payment_document" */
  update_risolto_payment_document_many?: Maybe<Array<Maybe<Risolto_Payment_Document_Mutation_Response>>>;
  /** update data of the table: "risolto.payment_link" */
  update_risolto_payment_link?: Maybe<Risolto_Payment_Link_Mutation_Response>;
  /** update single row of the table: "risolto.payment_link" */
  update_risolto_payment_link_by_pk?: Maybe<Risolto_Payment_Link>;
  /** update multiples rows of table: "risolto.payment_link" */
  update_risolto_payment_link_many?: Maybe<Array<Maybe<Risolto_Payment_Link_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.payment" */
  update_risolto_payment_many?: Maybe<Array<Maybe<Risolto_Payment_Mutation_Response>>>;
  /** update data of the table: "risolto.payment_plan" */
  update_risolto_payment_plan?: Maybe<Risolto_Payment_Plan_Mutation_Response>;
  /** update single row of the table: "risolto.payment_plan" */
  update_risolto_payment_plan_by_pk?: Maybe<Risolto_Payment_Plan>;
  /** update multiples rows of table: "risolto.payment_plan" */
  update_risolto_payment_plan_many?: Maybe<Array<Maybe<Risolto_Payment_Plan_Mutation_Response>>>;
  /** update data of the table: "risolto.payment_promise" */
  update_risolto_payment_promise?: Maybe<Risolto_Payment_Promise_Mutation_Response>;
  /** update single row of the table: "risolto.payment_promise" */
  update_risolto_payment_promise_by_pk?: Maybe<Risolto_Payment_Promise>;
  /** update multiples rows of table: "risolto.payment_promise" */
  update_risolto_payment_promise_many?: Maybe<Array<Maybe<Risolto_Payment_Promise_Mutation_Response>>>;
  /** update data of the table: "risolto.payment_transfer" */
  update_risolto_payment_transfer?: Maybe<Risolto_Payment_Transfer_Mutation_Response>;
  /** update data of the table: "risolto.payment_transfer_bulk_payment" */
  update_risolto_payment_transfer_bulk_payment?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Mutation_Response>;
  /** update single row of the table: "risolto.payment_transfer_bulk_payment" */
  update_risolto_payment_transfer_bulk_payment_by_pk?: Maybe<Risolto_Payment_Transfer_Bulk_Payment>;
  /** update multiples rows of table: "risolto.payment_transfer_bulk_payment" */
  update_risolto_payment_transfer_bulk_payment_many?: Maybe<Array<Maybe<Risolto_Payment_Transfer_Bulk_Payment_Mutation_Response>>>;
  /** update single row of the table: "risolto.payment_transfer" */
  update_risolto_payment_transfer_by_pk?: Maybe<Risolto_Payment_Transfer>;
  /** update data of the table: "risolto.payment_transfer_line" */
  update_risolto_payment_transfer_line?: Maybe<Risolto_Payment_Transfer_Line_Mutation_Response>;
  /** update single row of the table: "risolto.payment_transfer_line" */
  update_risolto_payment_transfer_line_by_pk?: Maybe<Risolto_Payment_Transfer_Line>;
  /** update multiples rows of table: "risolto.payment_transfer_line" */
  update_risolto_payment_transfer_line_many?: Maybe<Array<Maybe<Risolto_Payment_Transfer_Line_Mutation_Response>>>;
  /** update data of the table: "risolto.payment_transfer_line_type" */
  update_risolto_payment_transfer_line_type?: Maybe<Risolto_Payment_Transfer_Line_Type_Mutation_Response>;
  /** update single row of the table: "risolto.payment_transfer_line_type" */
  update_risolto_payment_transfer_line_type_by_pk?: Maybe<Risolto_Payment_Transfer_Line_Type>;
  /** update multiples rows of table: "risolto.payment_transfer_line_type" */
  update_risolto_payment_transfer_line_type_many?: Maybe<Array<Maybe<Risolto_Payment_Transfer_Line_Type_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.payment_transfer" */
  update_risolto_payment_transfer_many?: Maybe<Array<Maybe<Risolto_Payment_Transfer_Mutation_Response>>>;
  /** update data of the table: "risolto.payment_transfer_status" */
  update_risolto_payment_transfer_status?: Maybe<Risolto_Payment_Transfer_Status_Mutation_Response>;
  /** update single row of the table: "risolto.payment_transfer_status" */
  update_risolto_payment_transfer_status_by_pk?: Maybe<Risolto_Payment_Transfer_Status>;
  /** update multiples rows of table: "risolto.payment_transfer_status" */
  update_risolto_payment_transfer_status_many?: Maybe<Array<Maybe<Risolto_Payment_Transfer_Status_Mutation_Response>>>;
  /** update data of the table: "risolto.person" */
  update_risolto_person?: Maybe<Risolto_Person_Mutation_Response>;
  /** update single row of the table: "risolto.person" */
  update_risolto_person_by_pk?: Maybe<Risolto_Person>;
  /** update multiples rows of table: "risolto.person" */
  update_risolto_person_many?: Maybe<Array<Maybe<Risolto_Person_Mutation_Response>>>;
  /** update data of the table: "risolto.platform_license_module" */
  update_risolto_platform_license_module?: Maybe<Risolto_Platform_License_Module_Mutation_Response>;
  /** update single row of the table: "risolto.platform_license_module" */
  update_risolto_platform_license_module_by_pk?: Maybe<Risolto_Platform_License_Module>;
  /** update multiples rows of table: "risolto.platform_license_module" */
  update_risolto_platform_license_module_many?: Maybe<Array<Maybe<Risolto_Platform_License_Module_Mutation_Response>>>;
  /** update data of the table: "risolto.platform_participant_license" */
  update_risolto_platform_participant_license?: Maybe<Risolto_Platform_Participant_License_Mutation_Response>;
  /** update single row of the table: "risolto.platform_participant_license" */
  update_risolto_platform_participant_license_by_pk?: Maybe<Risolto_Platform_Participant_License>;
  /** update multiples rows of table: "risolto.platform_participant_license" */
  update_risolto_platform_participant_license_many?: Maybe<Array<Maybe<Risolto_Platform_Participant_License_Mutation_Response>>>;
  /** update data of the table: "risolto.platform_permission" */
  update_risolto_platform_permission?: Maybe<Risolto_Platform_Permission_Mutation_Response>;
  /** update single row of the table: "risolto.platform_permission" */
  update_risolto_platform_permission_by_pk?: Maybe<Risolto_Platform_Permission>;
  /** update multiples rows of table: "risolto.platform_permission" */
  update_risolto_platform_permission_many?: Maybe<Array<Maybe<Risolto_Platform_Permission_Mutation_Response>>>;
  /** update data of the table: "risolto.platform_role" */
  update_risolto_platform_role?: Maybe<Risolto_Platform_Role_Mutation_Response>;
  /** update single row of the table: "risolto.platform_role" */
  update_risolto_platform_role_by_pk?: Maybe<Risolto_Platform_Role>;
  /** update multiples rows of table: "risolto.platform_role" */
  update_risolto_platform_role_many?: Maybe<Array<Maybe<Risolto_Platform_Role_Mutation_Response>>>;
  /** update data of the table: "risolto.platform_role_permission" */
  update_risolto_platform_role_permission?: Maybe<Risolto_Platform_Role_Permission_Mutation_Response>;
  /** update single row of the table: "risolto.platform_role_permission" */
  update_risolto_platform_role_permission_by_pk?: Maybe<Risolto_Platform_Role_Permission>;
  /** update multiples rows of table: "risolto.platform_role_permission" */
  update_risolto_platform_role_permission_many?: Maybe<Array<Maybe<Risolto_Platform_Role_Permission_Mutation_Response>>>;
  /** update data of the table: "risolto.platform_usage" */
  update_risolto_platform_usage?: Maybe<Risolto_Platform_Usage_Mutation_Response>;
  /** update single row of the table: "risolto.platform_usage" */
  update_risolto_platform_usage_by_pk?: Maybe<Risolto_Platform_Usage>;
  /** update multiples rows of table: "risolto.platform_usage" */
  update_risolto_platform_usage_many?: Maybe<Array<Maybe<Risolto_Platform_Usage_Mutation_Response>>>;
  /** update data of the table: "risolto.recipient" */
  update_risolto_recipient?: Maybe<Risolto_Recipient_Mutation_Response>;
  /** update data of the table: "risolto.recipient_address" */
  update_risolto_recipient_address?: Maybe<Risolto_Recipient_Address_Mutation_Response>;
  /** update multiples rows of table: "risolto.recipient_address" */
  update_risolto_recipient_address_many?: Maybe<Array<Maybe<Risolto_Recipient_Address_Mutation_Response>>>;
  /** update data of the table: "risolto.recipient_attachment" */
  update_risolto_recipient_attachment?: Maybe<Risolto_Recipient_Attachment_Mutation_Response>;
  /** update single row of the table: "risolto.recipient_attachment" */
  update_risolto_recipient_attachment_by_pk?: Maybe<Risolto_Recipient_Attachment>;
  /** update multiples rows of table: "risolto.recipient_attachment" */
  update_risolto_recipient_attachment_many?: Maybe<Array<Maybe<Risolto_Recipient_Attachment_Mutation_Response>>>;
  /** update single row of the table: "risolto.recipient" */
  update_risolto_recipient_by_pk?: Maybe<Risolto_Recipient>;
  /** update data of the table: "risolto.recipient_collection" */
  update_risolto_recipient_collection?: Maybe<Risolto_Recipient_Collection_Mutation_Response>;
  /** update single row of the table: "risolto.recipient_collection" */
  update_risolto_recipient_collection_by_pk?: Maybe<Risolto_Recipient_Collection>;
  /** update multiples rows of table: "risolto.recipient_collection" */
  update_risolto_recipient_collection_many?: Maybe<Array<Maybe<Risolto_Recipient_Collection_Mutation_Response>>>;
  /** update data of the table: "risolto.recipient_communication" */
  update_risolto_recipient_communication?: Maybe<Risolto_Recipient_Communication_Mutation_Response>;
  /** update single row of the table: "risolto.recipient_communication" */
  update_risolto_recipient_communication_by_pk?: Maybe<Risolto_Recipient_Communication>;
  /** update multiples rows of table: "risolto.recipient_communication" */
  update_risolto_recipient_communication_many?: Maybe<Array<Maybe<Risolto_Recipient_Communication_Mutation_Response>>>;
  /** update data of the table: "risolto.recipient_dunning_exclude" */
  update_risolto_recipient_dunning_exclude?: Maybe<Risolto_Recipient_Dunning_Exclude_Mutation_Response>;
  /** update single row of the table: "risolto.recipient_dunning_exclude" */
  update_risolto_recipient_dunning_exclude_by_pk?: Maybe<Risolto_Recipient_Dunning_Exclude>;
  /** update multiples rows of table: "risolto.recipient_dunning_exclude" */
  update_risolto_recipient_dunning_exclude_many?: Maybe<Array<Maybe<Risolto_Recipient_Dunning_Exclude_Mutation_Response>>>;
  /** update data of the table: "risolto.recipient_dunning_run" */
  update_risolto_recipient_dunning_run?: Maybe<Risolto_Recipient_Dunning_Run_Mutation_Response>;
  /** update single row of the table: "risolto.recipient_dunning_run" */
  update_risolto_recipient_dunning_run_by_pk?: Maybe<Risolto_Recipient_Dunning_Run>;
  /** update multiples rows of table: "risolto.recipient_dunning_run" */
  update_risolto_recipient_dunning_run_many?: Maybe<Array<Maybe<Risolto_Recipient_Dunning_Run_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.recipient" */
  update_risolto_recipient_many?: Maybe<Array<Maybe<Risolto_Recipient_Mutation_Response>>>;
  /** update data of the table: "risolto.recipient_merge" */
  update_risolto_recipient_merge?: Maybe<Risolto_Recipient_Merge_Mutation_Response>;
  /** update single row of the table: "risolto.recipient_merge" */
  update_risolto_recipient_merge_by_pk?: Maybe<Risolto_Recipient_Merge>;
  /** update multiples rows of table: "risolto.recipient_merge" */
  update_risolto_recipient_merge_many?: Maybe<Array<Maybe<Risolto_Recipient_Merge_Mutation_Response>>>;
  /** update data of the table: "risolto.recipient_tag" */
  update_risolto_recipient_tag?: Maybe<Risolto_Recipient_Tag_Mutation_Response>;
  /** update single row of the table: "risolto.recipient_tag" */
  update_risolto_recipient_tag_by_pk?: Maybe<Risolto_Recipient_Tag>;
  /** update multiples rows of table: "risolto.recipient_tag" */
  update_risolto_recipient_tag_many?: Maybe<Array<Maybe<Risolto_Recipient_Tag_Mutation_Response>>>;
  /** update data of the table: "risolto.recipient_user" */
  update_risolto_recipient_user?: Maybe<Risolto_Recipient_User_Mutation_Response>;
  /** update single row of the table: "risolto.recipient_user" */
  update_risolto_recipient_user_by_pk?: Maybe<Risolto_Recipient_User>;
  /** update multiples rows of table: "risolto.recipient_user" */
  update_risolto_recipient_user_many?: Maybe<Array<Maybe<Risolto_Recipient_User_Mutation_Response>>>;
  /** update data of the table: "risolto.reference_data" */
  update_risolto_reference_data?: Maybe<Risolto_Reference_Data_Mutation_Response>;
  /** update single row of the table: "risolto.reference_data" */
  update_risolto_reference_data_by_pk?: Maybe<Risolto_Reference_Data>;
  /** update multiples rows of table: "risolto.reference_data" */
  update_risolto_reference_data_many?: Maybe<Array<Maybe<Risolto_Reference_Data_Mutation_Response>>>;
  /** update data of the table: "risolto.report_definition" */
  update_risolto_report_definition?: Maybe<Risolto_Report_Definition_Mutation_Response>;
  /** update single row of the table: "risolto.report_definition" */
  update_risolto_report_definition_by_pk?: Maybe<Risolto_Report_Definition>;
  /** update multiples rows of table: "risolto.report_definition" */
  update_risolto_report_definition_many?: Maybe<Array<Maybe<Risolto_Report_Definition_Mutation_Response>>>;
  /** update data of the table: "risolto.report_execution" */
  update_risolto_report_execution?: Maybe<Risolto_Report_Execution_Mutation_Response>;
  /** update single row of the table: "risolto.report_execution" */
  update_risolto_report_execution_by_pk?: Maybe<Risolto_Report_Execution>;
  /** update multiples rows of table: "risolto.report_execution" */
  update_risolto_report_execution_many?: Maybe<Array<Maybe<Risolto_Report_Execution_Mutation_Response>>>;
  /** update data of the table: "risolto.report_execution_user" */
  update_risolto_report_execution_user?: Maybe<Risolto_Report_Execution_User_Mutation_Response>;
  /** update single row of the table: "risolto.report_execution_user" */
  update_risolto_report_execution_user_by_pk?: Maybe<Risolto_Report_Execution_User>;
  /** update multiples rows of table: "risolto.report_execution_user" */
  update_risolto_report_execution_user_many?: Maybe<Array<Maybe<Risolto_Report_Execution_User_Mutation_Response>>>;
  /** update data of the table: "risolto.report_template_type" */
  update_risolto_report_template_type?: Maybe<Risolto_Report_Template_Type_Mutation_Response>;
  /** update single row of the table: "risolto.report_template_type" */
  update_risolto_report_template_type_by_pk?: Maybe<Risolto_Report_Template_Type>;
  /** update multiples rows of table: "risolto.report_template_type" */
  update_risolto_report_template_type_many?: Maybe<Array<Maybe<Risolto_Report_Template_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.report_type" */
  update_risolto_report_type?: Maybe<Risolto_Report_Type_Mutation_Response>;
  /** update single row of the table: "risolto.report_type" */
  update_risolto_report_type_by_pk?: Maybe<Risolto_Report_Type>;
  /** update multiples rows of table: "risolto.report_type" */
  update_risolto_report_type_many?: Maybe<Array<Maybe<Risolto_Report_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.report_user" */
  update_risolto_report_user?: Maybe<Risolto_Report_User_Mutation_Response>;
  /** update single row of the table: "risolto.report_user" */
  update_risolto_report_user_by_pk?: Maybe<Risolto_Report_User>;
  /** update multiples rows of table: "risolto.report_user" */
  update_risolto_report_user_many?: Maybe<Array<Maybe<Risolto_Report_User_Mutation_Response>>>;
  /** update data of the table: "risolto.run_processing_status" */
  update_risolto_run_processing_status?: Maybe<Risolto_Run_Processing_Status_Mutation_Response>;
  /** update single row of the table: "risolto.run_processing_status" */
  update_risolto_run_processing_status_by_pk?: Maybe<Risolto_Run_Processing_Status>;
  /** update multiples rows of table: "risolto.run_processing_status" */
  update_risolto_run_processing_status_many?: Maybe<Array<Maybe<Risolto_Run_Processing_Status_Mutation_Response>>>;
  /** update data of the table: "risolto.single_sign_on" */
  update_risolto_single_sign_on?: Maybe<Risolto_Single_Sign_On_Mutation_Response>;
  /** update single row of the table: "risolto.single_sign_on" */
  update_risolto_single_sign_on_by_pk?: Maybe<Risolto_Single_Sign_On>;
  /** update multiples rows of table: "risolto.single_sign_on" */
  update_risolto_single_sign_on_many?: Maybe<Array<Maybe<Risolto_Single_Sign_On_Mutation_Response>>>;
  /** update data of the table: "risolto.statement" */
  update_risolto_statement?: Maybe<Risolto_Statement_Mutation_Response>;
  /** update data of the table: "risolto.statement_account" */
  update_risolto_statement_account?: Maybe<Risolto_Statement_Account_Mutation_Response>;
  /** update single row of the table: "risolto.statement_account" */
  update_risolto_statement_account_by_pk?: Maybe<Risolto_Statement_Account>;
  /** update multiples rows of table: "risolto.statement_account" */
  update_risolto_statement_account_many?: Maybe<Array<Maybe<Risolto_Statement_Account_Mutation_Response>>>;
  /** update single row of the table: "risolto.statement" */
  update_risolto_statement_by_pk?: Maybe<Risolto_Statement>;
  /** update data of the table: "risolto.statement_line" */
  update_risolto_statement_line?: Maybe<Risolto_Statement_Line_Mutation_Response>;
  /** update single row of the table: "risolto.statement_line" */
  update_risolto_statement_line_by_pk?: Maybe<Risolto_Statement_Line>;
  /** update data of the table: "risolto.statement_line_dunning_notice" */
  update_risolto_statement_line_dunning_notice?: Maybe<Risolto_Statement_Line_Dunning_Notice_Mutation_Response>;
  /** update single row of the table: "risolto.statement_line_dunning_notice" */
  update_risolto_statement_line_dunning_notice_by_pk?: Maybe<Risolto_Statement_Line_Dunning_Notice>;
  /** update multiples rows of table: "risolto.statement_line_dunning_notice" */
  update_risolto_statement_line_dunning_notice_many?: Maybe<Array<Maybe<Risolto_Statement_Line_Dunning_Notice_Mutation_Response>>>;
  /** update data of the table: "risolto.statement_line_invoice" */
  update_risolto_statement_line_invoice?: Maybe<Risolto_Statement_Line_Invoice_Mutation_Response>;
  /** update single row of the table: "risolto.statement_line_invoice" */
  update_risolto_statement_line_invoice_by_pk?: Maybe<Risolto_Statement_Line_Invoice>;
  /** update multiples rows of table: "risolto.statement_line_invoice" */
  update_risolto_statement_line_invoice_many?: Maybe<Array<Maybe<Risolto_Statement_Line_Invoice_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.statement_line" */
  update_risolto_statement_line_many?: Maybe<Array<Maybe<Risolto_Statement_Line_Mutation_Response>>>;
  /** update data of the table: "risolto.statement_line_payment_promise" */
  update_risolto_statement_line_payment_promise?: Maybe<Risolto_Statement_Line_Payment_Promise_Mutation_Response>;
  /** update single row of the table: "risolto.statement_line_payment_promise" */
  update_risolto_statement_line_payment_promise_by_pk?: Maybe<Risolto_Statement_Line_Payment_Promise>;
  /** update multiples rows of table: "risolto.statement_line_payment_promise" */
  update_risolto_statement_line_payment_promise_many?: Maybe<Array<Maybe<Risolto_Statement_Line_Payment_Promise_Mutation_Response>>>;
  /** update data of the table: "risolto.statement_line_status" */
  update_risolto_statement_line_status?: Maybe<Risolto_Statement_Line_Status_Mutation_Response>;
  /** update single row of the table: "risolto.statement_line_status" */
  update_risolto_statement_line_status_by_pk?: Maybe<Risolto_Statement_Line_Status>;
  /** update multiples rows of table: "risolto.statement_line_status" */
  update_risolto_statement_line_status_many?: Maybe<Array<Maybe<Risolto_Statement_Line_Status_Mutation_Response>>>;
  /** update multiples rows of table: "risolto.statement" */
  update_risolto_statement_many?: Maybe<Array<Maybe<Risolto_Statement_Mutation_Response>>>;
  /** update data of the table: "risolto.strigil_nbb" */
  update_risolto_strigil_nbb?: Maybe<Risolto_Strigil_Nbb_Mutation_Response>;
  /** update single row of the table: "risolto.strigil_nbb" */
  update_risolto_strigil_nbb_by_pk?: Maybe<Risolto_Strigil_Nbb>;
  /** update multiples rows of table: "risolto.strigil_nbb" */
  update_risolto_strigil_nbb_many?: Maybe<Array<Maybe<Risolto_Strigil_Nbb_Mutation_Response>>>;
  /** update data of the table: "risolto.strigil_nbb_processing_status" */
  update_risolto_strigil_nbb_processing_status?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Mutation_Response>;
  /** update single row of the table: "risolto.strigil_nbb_processing_status" */
  update_risolto_strigil_nbb_processing_status_by_pk?: Maybe<Risolto_Strigil_Nbb_Processing_Status>;
  /** update multiples rows of table: "risolto.strigil_nbb_processing_status" */
  update_risolto_strigil_nbb_processing_status_many?: Maybe<Array<Maybe<Risolto_Strigil_Nbb_Processing_Status_Mutation_Response>>>;
  /** update data of the table: "risolto.system_integration" */
  update_risolto_system_integration?: Maybe<Risolto_System_Integration_Mutation_Response>;
  /** update single row of the table: "risolto.system_integration" */
  update_risolto_system_integration_by_pk?: Maybe<Risolto_System_Integration>;
  /** update multiples rows of table: "risolto.system_integration" */
  update_risolto_system_integration_many?: Maybe<Array<Maybe<Risolto_System_Integration_Mutation_Response>>>;
  /** update data of the table: "risolto.tag" */
  update_risolto_tag?: Maybe<Risolto_Tag_Mutation_Response>;
  /** update single row of the table: "risolto.tag" */
  update_risolto_tag_by_pk?: Maybe<Risolto_Tag>;
  /** update multiples rows of table: "risolto.tag" */
  update_risolto_tag_many?: Maybe<Array<Maybe<Risolto_Tag_Mutation_Response>>>;
  /** update data of the table: "risolto.task" */
  update_risolto_task?: Maybe<Risolto_Task_Mutation_Response>;
  /** update single row of the table: "risolto.task" */
  update_risolto_task_by_pk?: Maybe<Risolto_Task>;
  /** update multiples rows of table: "risolto.task" */
  update_risolto_task_many?: Maybe<Array<Maybe<Risolto_Task_Mutation_Response>>>;
  /** update data of the table: "risolto.task_source" */
  update_risolto_task_source?: Maybe<Risolto_Task_Source_Mutation_Response>;
  /** update single row of the table: "risolto.task_source" */
  update_risolto_task_source_by_pk?: Maybe<Risolto_Task_Source>;
  /** update multiples rows of table: "risolto.task_source" */
  update_risolto_task_source_many?: Maybe<Array<Maybe<Risolto_Task_Source_Mutation_Response>>>;
  /** update data of the table: "risolto.task_status" */
  update_risolto_task_status?: Maybe<Risolto_Task_Status_Mutation_Response>;
  /** update single row of the table: "risolto.task_status" */
  update_risolto_task_status_by_pk?: Maybe<Risolto_Task_Status>;
  /** update multiples rows of table: "risolto.task_status" */
  update_risolto_task_status_many?: Maybe<Array<Maybe<Risolto_Task_Status_Mutation_Response>>>;
  /** update data of the table: "risolto.task_type" */
  update_risolto_task_type?: Maybe<Risolto_Task_Type_Mutation_Response>;
  /** update single row of the table: "risolto.task_type" */
  update_risolto_task_type_by_pk?: Maybe<Risolto_Task_Type>;
  /** update multiples rows of table: "risolto.task_type" */
  update_risolto_task_type_many?: Maybe<Array<Maybe<Risolto_Task_Type_Mutation_Response>>>;
  /** update data of the table: "risolto.tone_of_voice" */
  update_risolto_tone_of_voice?: Maybe<Risolto_Tone_Of_Voice_Mutation_Response>;
  /** update single row of the table: "risolto.tone_of_voice" */
  update_risolto_tone_of_voice_by_pk?: Maybe<Risolto_Tone_Of_Voice>;
  /** update multiples rows of table: "risolto.tone_of_voice" */
  update_risolto_tone_of_voice_many?: Maybe<Array<Maybe<Risolto_Tone_Of_Voice_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_action_and_note" */
  update_risolto_virtual_action_and_note?: Maybe<Risolto_Virtual_Action_And_Note_Mutation_Response>;
  /** update data of the table: "risolto.virtual_action_and_note_and_dispute" */
  update_risolto_virtual_action_and_note_and_dispute?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Mutation_Response>;
  /** update data of the table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  update_risolto_virtual_action_and_note_and_dispute_and_message?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Mutation_Response>;
  /** update multiples rows of table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  update_risolto_virtual_action_and_note_and_dispute_and_message_many?: Maybe<Array<Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Mutation_Response>>>;
  /** update single row of the table: "risolto.virtual_action_and_note_and_dispute" */
  update_risolto_virtual_action_and_note_and_dispute_by_pk?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** update multiples rows of table: "risolto.virtual_action_and_note_and_dispute" */
  update_risolto_virtual_action_and_note_and_dispute_many?: Maybe<Array<Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Mutation_Response>>>;
  /** update single row of the table: "risolto.virtual_action_and_note" */
  update_risolto_virtual_action_and_note_by_pk?: Maybe<Risolto_Virtual_Action_And_Note>;
  /** update multiples rows of table: "risolto.virtual_action_and_note" */
  update_risolto_virtual_action_and_note_many?: Maybe<Array<Maybe<Risolto_Virtual_Action_And_Note_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_action_group" */
  update_risolto_virtual_action_group?: Maybe<Risolto_Virtual_Action_Group_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_action_group" */
  update_risolto_virtual_action_group_by_pk?: Maybe<Risolto_Virtual_Action_Group>;
  /** update multiples rows of table: "risolto.virtual_action_group" */
  update_risolto_virtual_action_group_many?: Maybe<Array<Maybe<Risolto_Virtual_Action_Group_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_dashboard_action_stats" */
  update_risolto_virtual_dashboard_action_stats?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_dashboard_action_stats" */
  update_risolto_virtual_dashboard_action_stats_by_pk?: Maybe<Risolto_Virtual_Dashboard_Action_Stats>;
  /** update multiples rows of table: "risolto.virtual_dashboard_action_stats" */
  update_risolto_virtual_dashboard_action_stats_many?: Maybe<Array<Maybe<Risolto_Virtual_Dashboard_Action_Stats_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_dashboard_outstanding_debt" */
  update_risolto_virtual_dashboard_outstanding_debt?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_dashboard_outstanding_debt" */
  update_risolto_virtual_dashboard_outstanding_debt_by_pk?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** update multiples rows of table: "risolto.virtual_dashboard_outstanding_debt" */
  update_risolto_virtual_dashboard_outstanding_debt_many?: Maybe<Array<Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_demo_action_report_1" */
  update_risolto_virtual_demo_action_report_1?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_demo_action_report_1" */
  update_risolto_virtual_demo_action_report_1_by_pk?: Maybe<Risolto_Virtual_Demo_Action_Report_1>;
  /** update multiples rows of table: "risolto.virtual_demo_action_report_1" */
  update_risolto_virtual_demo_action_report_1_many?: Maybe<Array<Maybe<Risolto_Virtual_Demo_Action_Report_1_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_dunning_action" */
  update_risolto_virtual_dunning_action?: Maybe<Risolto_Virtual_Dunning_Action_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_dunning_action" */
  update_risolto_virtual_dunning_action_by_pk?: Maybe<Risolto_Virtual_Dunning_Action>;
  /** update multiples rows of table: "risolto.virtual_dunning_action" */
  update_risolto_virtual_dunning_action_many?: Maybe<Array<Maybe<Risolto_Virtual_Dunning_Action_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_interchange_event" */
  update_risolto_virtual_interchange_event?: Maybe<Risolto_Virtual_Interchange_Event_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_interchange_event" */
  update_risolto_virtual_interchange_event_by_pk?: Maybe<Risolto_Virtual_Interchange_Event>;
  /** update multiples rows of table: "risolto.virtual_interchange_event" */
  update_risolto_virtual_interchange_event_many?: Maybe<Array<Maybe<Risolto_Virtual_Interchange_Event_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_invoice_derived_payment_information" */
  update_risolto_virtual_invoice_derived_payment_information?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_invoice_derived_payment_information" */
  update_risolto_virtual_invoice_derived_payment_information_by_pk?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information>;
  /** update multiples rows of table: "risolto.virtual_invoice_derived_payment_information" */
  update_risolto_virtual_invoice_derived_payment_information_many?: Maybe<Array<Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_invoicing_channel_endpoint" */
  update_risolto_virtual_invoicing_channel_endpoint?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_invoicing_channel_endpoint" */
  update_risolto_virtual_invoicing_channel_endpoint_by_pk?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** update multiples rows of table: "risolto.virtual_invoicing_channel_endpoint" */
  update_risolto_virtual_invoicing_channel_endpoint_many?: Maybe<Array<Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_json" */
  update_risolto_virtual_json?: Maybe<Risolto_Virtual_Json_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_json" */
  update_risolto_virtual_json_by_pk?: Maybe<Risolto_Virtual_Json>;
  /** update multiples rows of table: "risolto.virtual_json" */
  update_risolto_virtual_json_many?: Maybe<Array<Maybe<Risolto_Virtual_Json_Mutation_Response>>>;
  /** update data of the table: "risolto.virtual_report_delivery" */
  update_risolto_virtual_report_delivery?: Maybe<Risolto_Virtual_Report_Delivery_Mutation_Response>;
  /** update single row of the table: "risolto.virtual_report_delivery" */
  update_risolto_virtual_report_delivery_by_pk?: Maybe<Risolto_Virtual_Report_Delivery>;
  /** update multiples rows of table: "risolto.virtual_report_delivery" */
  update_risolto_virtual_report_delivery_many?: Maybe<Array<Maybe<Risolto_Virtual_Report_Delivery_Mutation_Response>>>;
  /** update data of the table: "risolto.webhook" */
  update_risolto_webhook?: Maybe<Risolto_Webhook_Mutation_Response>;
  /** update single row of the table: "risolto.webhook" */
  update_risolto_webhook_by_pk?: Maybe<Risolto_Webhook>;
  /** update multiples rows of table: "risolto.webhook" */
  update_risolto_webhook_many?: Maybe<Array<Maybe<Risolto_Webhook_Mutation_Response>>>;
  /** update data of the table: "risolto.webhook_processing_status" */
  update_risolto_webhook_processing_status?: Maybe<Risolto_Webhook_Processing_Status_Mutation_Response>;
  /** update single row of the table: "risolto.webhook_processing_status" */
  update_risolto_webhook_processing_status_by_pk?: Maybe<Risolto_Webhook_Processing_Status>;
  /** update multiples rows of table: "risolto.webhook_processing_status" */
  update_risolto_webhook_processing_status_many?: Maybe<Array<Maybe<Risolto_Webhook_Processing_Status_Mutation_Response>>>;
  /** update data of the table: "risolto.webhook_subscription" */
  update_risolto_webhook_subscription?: Maybe<Risolto_Webhook_Subscription_Mutation_Response>;
  /** update single row of the table: "risolto.webhook_subscription" */
  update_risolto_webhook_subscription_by_pk?: Maybe<Risolto_Webhook_Subscription>;
  /** update multiples rows of table: "risolto.webhook_subscription" */
  update_risolto_webhook_subscription_many?: Maybe<Array<Maybe<Risolto_Webhook_Subscription_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Account_Number_TypeArgs = {
  where: Risolto_Account_Number_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Account_Number_Type_By_PkArgs = {
  account_number_type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_ActionArgs = {
  where: Risolto_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_Execution_TypeArgs = {
  where: Risolto_Action_Execution_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_Execution_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_InterchangeArgs = {
  where: Risolto_Action_Interchange_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_Interchange_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_InvoiceArgs = {
  where: Risolto_Action_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_SourceArgs = {
  where: Risolto_Action_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_Source_By_PkArgs = {
  source: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_StatusArgs = {
  where: Risolto_Action_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Action_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Company_ScoreArgs = {
  where: Risolto_Analytics_Company_Score_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Company_Score_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Invoice_FeaturesArgs = {
  where: Risolto_Analytics_Invoice_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Invoice_Features_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Invoice_PredictionArgs = {
  where: Risolto_Analytics_Invoice_Prediction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Invoice_Prediction_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_TestArgs = {
  where: Risolto_Analytics_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Test_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Test_ResultArgs = {
  where: Risolto_Analytics_Test_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Analytics_Test_Result_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Api_App_ClientArgs = {
  where: Risolto_Api_App_Client_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Api_App_Client_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_AttachmentArgs = {
  where: Risolto_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Attachment_SchemeArgs = {
  where: Risolto_Attachment_Scheme_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Attachment_Scheme_By_PkArgs = {
  scheme: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Bank_AccountArgs = {
  where: Risolto_Bank_Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Bank_Account_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Bank_Identifier_TypeArgs = {
  where: Risolto_Bank_Identifier_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Bank_Identifier_Type_By_PkArgs = {
  bank_identifier_type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_BlacklistArgs = {
  where: Risolto_Blacklist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Blacklist_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_ChannelArgs = {
  where: Risolto_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Channel_By_PkArgs = {
  channel: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Channel_EndpointArgs = {
  where: Risolto_Channel_Endpoint_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Channel_Endpoint_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_CommunicationArgs = {
  where: Risolto_Communication_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Communication_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Communication_TemplateArgs = {
  where: Risolto_Communication_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Communication_Template_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Communication_Template_TypeArgs = {
  where: Risolto_Communication_Template_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Communication_Template_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_ContactArgs = {
  where: Risolto_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Contact_AddressArgs = {
  where: Risolto_Contact_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Contact_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Contact_TypeArgs = {
  where: Risolto_Contact_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Contact_Type_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Content_DispositionArgs = {
  where: Risolto_Content_Disposition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Content_Disposition_By_PkArgs = {
  content_disposition: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Credit_LimitArgs = {
  where: Risolto_Credit_Limit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Credit_Limit_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Credit_NoteArgs = {
  where: Risolto_Credit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Credit_Note_AttachmentArgs = {
  where: Risolto_Credit_Note_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Credit_Note_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Credit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_CurrencyArgs = {
  where: Risolto_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Currency_By_PkArgs = {
  currency: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Debit_NoteArgs = {
  where: Risolto_Debit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Debit_Note_AttachmentArgs = {
  where: Risolto_Debit_Note_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Debit_Note_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Debit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_MandateArgs = {
  where: Risolto_Direct_Debit_Mandate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_Mandate_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_ProviderArgs = {
  where: Risolto_Direct_Debit_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_Provider_By_PkArgs = {
  provider: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_SchemeArgs = {
  where: Risolto_Direct_Debit_Scheme_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_Scheme_By_PkArgs = {
  scheme: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_Sequence_TypeArgs = {
  where: Risolto_Direct_Debit_Sequence_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_Sequence_Type_By_PkArgs = {
  sequence_type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_TransactionArgs = {
  where: Risolto_Direct_Debit_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Direct_Debit_Transaction_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dispute_CodeArgs = {
  where: Risolto_Dispute_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dispute_Code_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Attachment_TypeArgs = {
  where: Risolto_Document_Attachment_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Attachment_Type_By_PkArgs = {
  attachment_type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_InterchangeArgs = {
  where: Risolto_Document_Interchange_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_AttachmentArgs = {
  where: Risolto_Document_Interchange_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_DirectionArgs = {
  where: Risolto_Document_Interchange_Direction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_Direction_By_PkArgs = {
  direction: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_EventArgs = {
  where: Risolto_Document_Interchange_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_Event_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_LinkArgs = {
  where: Risolto_Document_Interchange_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Document_Interchange_Link_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_NoticeArgs = {
  where: Risolto_Dunning_Notice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_InvoiceArgs = {
  where: Risolto_Dunning_Notice_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_Invoice_RelationArgs = {
  where: Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_Invoice_Relation_By_PkArgs = {
  relation: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_StatusArgs = {
  where: Risolto_Dunning_Notice_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_Type_CodeArgs = {
  where: Risolto_Dunning_Notice_Type_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Dunning_Notice_Type_Code_By_PkArgs = {
  type_code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_FrequencyArgs = {
  where: Risolto_Frequency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Frequency_By_PkArgs = {
  frequency: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Grant_TypeArgs = {
  where: Risolto_Grant_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Grant_Type_By_PkArgs = {
  grant_type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_CollectionArgs = {
  where: Risolto_Invoice_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Collection_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_DisputeArgs = {
  where: Risolto_Invoice_Dispute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Dispute_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_DocumentArgs = {
  where: Risolto_Invoice_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Document_AttachmentArgs = {
  where: Risolto_Invoice_Document_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Document_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Document_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Document_StatusArgs = {
  where: Risolto_Invoice_Document_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Document_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_GroupArgs = {
  where: Risolto_Invoice_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Credit_NoteArgs = {
  where: Risolto_Invoice_Group_Credit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Credit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Debit_NoteArgs = {
  where: Risolto_Invoice_Group_Debit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Debit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Dunning_RunArgs = {
  where: Risolto_Invoice_Group_Dunning_Run_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_InvoiceArgs = {
  where: Risolto_Invoice_Group_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_PaymentArgs = {
  where: Risolto_Invoice_Group_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Payment_PromiseArgs = {
  where: Risolto_Invoice_Group_Payment_Promise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Invoice_Group_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Iso_Country_CodeArgs = {
  where: Risolto_Iso_Country_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Iso_Country_Code_By_PkArgs = {
  country_code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_JobArgs = {
  where: Risolto_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Job_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Language_CodeArgs = {
  where: Risolto_Language_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Language_Code_By_PkArgs = {
  language_code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Legal_EntityArgs = {
  where: Risolto_Legal_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Legal_Entity_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_LocaleArgs = {
  where: Risolto_Locale_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Locale_By_PkArgs = {
  locale: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Magda_CacheArgs = {
  where: Risolto_Magda_Cache_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Magda_Cache_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Magda_Service_Audit_LogArgs = {
  where: Risolto_Magda_Service_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Magda_Service_Audit_Log_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Materialized_View_DefinitionArgs = {
  where: Risolto_Materialized_View_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Materialized_View_Definition_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_MessageArgs = {
  where: Risolto_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_AssigneeArgs = {
  where: Risolto_Message_Assignee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_Assignee_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_AttachmentArgs = {
  where: Risolto_Message_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_LabelArgs = {
  where: Risolto_Message_Label_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_Label_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_Message_LabelArgs = {
  where: Risolto_Message_Message_Label_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_Message_Label_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_RecipientArgs = {
  where: Risolto_Message_Recipient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Message_Recipient_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Mime_TypeArgs = {
  where: Risolto_Mime_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Mime_Type_By_PkArgs = {
  mime_type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_NoteArgs = {
  where: Risolto_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Note_CategoryArgs = {
  where: Risolto_Note_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Note_Category_By_PkArgs = {
  category: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Note_InvoiceArgs = {
  where: Risolto_Note_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Note_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Open_BalanceArgs = {
  where: Risolto_Open_Balance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Open_Balance_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Open_Balance_RecordArgs = {
  where: Risolto_Open_Balance_Record_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Open_Balance_Record_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_OriginArgs = {
  where: Risolto_Origin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Origin_By_PkArgs = {
  origin: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_ParticipantArgs = {
  where: Risolto_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_Api_App_ClientArgs = {
  where: Risolto_Participant_Api_App_Client_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_Api_App_Client_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_Dunning_RunArgs = {
  where: Risolto_Participant_Dunning_Run_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_UserArgs = {
  where: Risolto_Participant_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_User_RoleArgs = {
  where: Risolto_Participant_User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Participant_User_Role_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_PaymentArgs = {
  where: Risolto_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_DocumentArgs = {
  where: Risolto_Payment_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Document_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_LinkArgs = {
  where: Risolto_Payment_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Link_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_PlanArgs = {
  where: Risolto_Payment_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Plan_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_PromiseArgs = {
  where: Risolto_Payment_Promise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_TransferArgs = {
  where: Risolto_Payment_Transfer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_Bulk_PaymentArgs = {
  where: Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_Bulk_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_LineArgs = {
  where: Risolto_Payment_Transfer_Line_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_Line_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_Line_TypeArgs = {
  where: Risolto_Payment_Transfer_Line_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_Line_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_StatusArgs = {
  where: Risolto_Payment_Transfer_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Payment_Transfer_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_PersonArgs = {
  where: Risolto_Person_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Person_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_License_ModuleArgs = {
  where: Risolto_Platform_License_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_License_Module_By_PkArgs = {
  platform_license_module: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_Participant_LicenseArgs = {
  where: Risolto_Platform_Participant_License_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_Participant_License_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_PermissionArgs = {
  where: Risolto_Platform_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_Permission_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_RoleArgs = {
  where: Risolto_Platform_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_Role_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_Role_PermissionArgs = {
  where: Risolto_Platform_Role_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_Role_Permission_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_UsageArgs = {
  where: Risolto_Platform_Usage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Platform_Usage_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_RecipientArgs = {
  where: Risolto_Recipient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_AddressArgs = {
  where: Risolto_Recipient_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_AttachmentArgs = {
  where: Risolto_Recipient_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_CollectionArgs = {
  where: Risolto_Recipient_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Collection_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_CommunicationArgs = {
  where: Risolto_Recipient_Communication_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Communication_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Dunning_ExcludeArgs = {
  where: Risolto_Recipient_Dunning_Exclude_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Dunning_Exclude_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Dunning_RunArgs = {
  where: Risolto_Recipient_Dunning_Run_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_MergeArgs = {
  where: Risolto_Recipient_Merge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Merge_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_TagArgs = {
  where: Risolto_Recipient_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_Tag_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_UserArgs = {
  where: Risolto_Recipient_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Recipient_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Reference_DataArgs = {
  where: Risolto_Reference_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Reference_Data_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_DefinitionArgs = {
  where: Risolto_Report_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_Definition_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_ExecutionArgs = {
  where: Risolto_Report_Execution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_Execution_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_Execution_UserArgs = {
  where: Risolto_Report_Execution_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_Execution_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_Template_TypeArgs = {
  where: Risolto_Report_Template_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_Template_Type_By_PkArgs = {
  report_template_type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_TypeArgs = {
  where: Risolto_Report_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_Type_By_PkArgs = {
  report_type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_UserArgs = {
  where: Risolto_Report_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Report_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Run_Processing_StatusArgs = {
  where: Risolto_Run_Processing_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Run_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Single_Sign_OnArgs = {
  where: Risolto_Single_Sign_On_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Single_Sign_On_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_StatementArgs = {
  where: Risolto_Statement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_AccountArgs = {
  where: Risolto_Statement_Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Account_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_LineArgs = {
  where: Risolto_Statement_Line_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_Dunning_NoticeArgs = {
  where: Risolto_Statement_Line_Dunning_Notice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_Dunning_Notice_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_InvoiceArgs = {
  where: Risolto_Statement_Line_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_Payment_PromiseArgs = {
  where: Risolto_Statement_Line_Payment_Promise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_StatusArgs = {
  where: Risolto_Statement_Line_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Statement_Line_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Strigil_NbbArgs = {
  where: Risolto_Strigil_Nbb_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Strigil_Nbb_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Strigil_Nbb_Processing_StatusArgs = {
  where: Risolto_Strigil_Nbb_Processing_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Strigil_Nbb_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_System_IntegrationArgs = {
  where: Risolto_System_Integration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_System_Integration_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_TagArgs = {
  where: Risolto_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Tag_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_TaskArgs = {
  where: Risolto_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Task_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Task_SourceArgs = {
  where: Risolto_Task_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Task_Source_By_PkArgs = {
  source: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Task_StatusArgs = {
  where: Risolto_Task_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Task_Status_By_PkArgs = {
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Task_TypeArgs = {
  where: Risolto_Task_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Task_Type_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Tone_Of_VoiceArgs = {
  where: Risolto_Tone_Of_Voice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Tone_Of_Voice_By_PkArgs = {
  tone_of_voice: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Action_And_NoteArgs = {
  where: Risolto_Virtual_Action_And_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Action_And_Note_And_DisputeArgs = {
  where: Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Action_And_Note_And_Dispute_And_MessageArgs = {
  where: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Action_And_Note_And_Dispute_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Action_And_Note_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Action_GroupArgs = {
  where: Risolto_Virtual_Action_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Action_Group_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Dashboard_Action_StatsArgs = {
  where: Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Dashboard_Action_Stats_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Dashboard_Outstanding_DebtArgs = {
  where: Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Dashboard_Outstanding_Debt_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Demo_Action_Report_1Args = {
  where: Risolto_Virtual_Demo_Action_Report_1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Demo_Action_Report_1_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Dunning_ActionArgs = {
  where: Risolto_Virtual_Dunning_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Dunning_Action_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Interchange_EventArgs = {
  where: Risolto_Virtual_Interchange_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Interchange_Event_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Invoice_Derived_Payment_InformationArgs = {
  where: Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Invoice_Derived_Payment_Information_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Invoicing_Channel_EndpointArgs = {
  where: Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Invoicing_Channel_Endpoint_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_JsonArgs = {
  where: Risolto_Virtual_Json_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Json_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Report_DeliveryArgs = {
  where: Risolto_Virtual_Report_Delivery_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Virtual_Report_Delivery_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_WebhookArgs = {
  where: Risolto_Webhook_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Webhook_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Webhook_Processing_StatusArgs = {
  where: Risolto_Webhook_Processing_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Webhook_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Webhook_SubscriptionArgs = {
  where: Risolto_Webhook_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risolto_Webhook_Subscription_By_PkArgs = {
  reference: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Account_Number_TypeArgs = {
  objects: Array<Risolto_Account_Number_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Account_Number_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Account_Number_Type_OneArgs = {
  object: Risolto_Account_Number_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Account_Number_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_ActionArgs = {
  objects: Array<Risolto_Action_Insert_Input>;
  on_conflict?: Maybe<Risolto_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_Execution_TypeArgs = {
  objects: Array<Risolto_Action_Execution_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Action_Execution_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_Execution_Type_OneArgs = {
  object: Risolto_Action_Execution_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Action_Execution_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_InterchangeArgs = {
  objects: Array<Risolto_Action_Interchange_Insert_Input>;
  on_conflict?: Maybe<Risolto_Action_Interchange_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_Interchange_OneArgs = {
  object: Risolto_Action_Interchange_Insert_Input;
  on_conflict?: Maybe<Risolto_Action_Interchange_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_InvoiceArgs = {
  objects: Array<Risolto_Action_Invoice_Insert_Input>;
  on_conflict?: Maybe<Risolto_Action_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_Invoice_OneArgs = {
  object: Risolto_Action_Invoice_Insert_Input;
  on_conflict?: Maybe<Risolto_Action_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_OneArgs = {
  object: Risolto_Action_Insert_Input;
  on_conflict?: Maybe<Risolto_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_SourceArgs = {
  objects: Array<Risolto_Action_Source_Insert_Input>;
  on_conflict?: Maybe<Risolto_Action_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_Source_OneArgs = {
  object: Risolto_Action_Source_Insert_Input;
  on_conflict?: Maybe<Risolto_Action_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_StatusArgs = {
  objects: Array<Risolto_Action_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Action_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Action_Status_OneArgs = {
  object: Risolto_Action_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Action_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Company_ScoreArgs = {
  objects: Array<Risolto_Analytics_Company_Score_Insert_Input>;
  on_conflict?: Maybe<Risolto_Analytics_Company_Score_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Company_Score_OneArgs = {
  object: Risolto_Analytics_Company_Score_Insert_Input;
  on_conflict?: Maybe<Risolto_Analytics_Company_Score_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Invoice_FeaturesArgs = {
  objects: Array<Risolto_Analytics_Invoice_Features_Insert_Input>;
  on_conflict?: Maybe<Risolto_Analytics_Invoice_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Invoice_Features_OneArgs = {
  object: Risolto_Analytics_Invoice_Features_Insert_Input;
  on_conflict?: Maybe<Risolto_Analytics_Invoice_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Invoice_PredictionArgs = {
  objects: Array<Risolto_Analytics_Invoice_Prediction_Insert_Input>;
  on_conflict?: Maybe<Risolto_Analytics_Invoice_Prediction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Invoice_Prediction_OneArgs = {
  object: Risolto_Analytics_Invoice_Prediction_Insert_Input;
  on_conflict?: Maybe<Risolto_Analytics_Invoice_Prediction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_TestArgs = {
  objects: Array<Risolto_Analytics_Test_Insert_Input>;
  on_conflict?: Maybe<Risolto_Analytics_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Test_OneArgs = {
  object: Risolto_Analytics_Test_Insert_Input;
  on_conflict?: Maybe<Risolto_Analytics_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Test_ResultArgs = {
  objects: Array<Risolto_Analytics_Test_Result_Insert_Input>;
  on_conflict?: Maybe<Risolto_Analytics_Test_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Analytics_Test_Result_OneArgs = {
  object: Risolto_Analytics_Test_Result_Insert_Input;
  on_conflict?: Maybe<Risolto_Analytics_Test_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Api_App_ClientArgs = {
  objects: Array<Risolto_Api_App_Client_Insert_Input>;
  on_conflict?: Maybe<Risolto_Api_App_Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Api_App_Client_OneArgs = {
  object: Risolto_Api_App_Client_Insert_Input;
  on_conflict?: Maybe<Risolto_Api_App_Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_AttachmentArgs = {
  objects: Array<Risolto_Attachment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Attachment_OneArgs = {
  object: Risolto_Attachment_Insert_Input;
  on_conflict?: Maybe<Risolto_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Attachment_SchemeArgs = {
  objects: Array<Risolto_Attachment_Scheme_Insert_Input>;
  on_conflict?: Maybe<Risolto_Attachment_Scheme_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Attachment_Scheme_OneArgs = {
  object: Risolto_Attachment_Scheme_Insert_Input;
  on_conflict?: Maybe<Risolto_Attachment_Scheme_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Bank_AccountArgs = {
  objects: Array<Risolto_Bank_Account_Insert_Input>;
  on_conflict?: Maybe<Risolto_Bank_Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Bank_Account_OneArgs = {
  object: Risolto_Bank_Account_Insert_Input;
  on_conflict?: Maybe<Risolto_Bank_Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Bank_Identifier_TypeArgs = {
  objects: Array<Risolto_Bank_Identifier_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Bank_Identifier_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Bank_Identifier_Type_OneArgs = {
  object: Risolto_Bank_Identifier_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Bank_Identifier_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_BlacklistArgs = {
  objects: Array<Risolto_Blacklist_Insert_Input>;
  on_conflict?: Maybe<Risolto_Blacklist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Blacklist_OneArgs = {
  object: Risolto_Blacklist_Insert_Input;
  on_conflict?: Maybe<Risolto_Blacklist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_ChannelArgs = {
  objects: Array<Risolto_Channel_Insert_Input>;
  on_conflict?: Maybe<Risolto_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Channel_EndpointArgs = {
  objects: Array<Risolto_Channel_Endpoint_Insert_Input>;
  on_conflict?: Maybe<Risolto_Channel_Endpoint_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Channel_Endpoint_OneArgs = {
  object: Risolto_Channel_Endpoint_Insert_Input;
  on_conflict?: Maybe<Risolto_Channel_Endpoint_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Channel_OneArgs = {
  object: Risolto_Channel_Insert_Input;
  on_conflict?: Maybe<Risolto_Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_CommunicationArgs = {
  objects: Array<Risolto_Communication_Insert_Input>;
  on_conflict?: Maybe<Risolto_Communication_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Communication_OneArgs = {
  object: Risolto_Communication_Insert_Input;
  on_conflict?: Maybe<Risolto_Communication_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Communication_TemplateArgs = {
  objects: Array<Risolto_Communication_Template_Insert_Input>;
  on_conflict?: Maybe<Risolto_Communication_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Communication_Template_OneArgs = {
  object: Risolto_Communication_Template_Insert_Input;
  on_conflict?: Maybe<Risolto_Communication_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Communication_Template_TypeArgs = {
  objects: Array<Risolto_Communication_Template_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Communication_Template_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Communication_Template_Type_OneArgs = {
  object: Risolto_Communication_Template_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Communication_Template_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_ContactArgs = {
  objects: Array<Risolto_Contact_Insert_Input>;
  on_conflict?: Maybe<Risolto_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Contact_AddressArgs = {
  objects: Array<Risolto_Contact_Address_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Contact_Address_OneArgs = {
  object: Risolto_Contact_Address_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Contact_OneArgs = {
  object: Risolto_Contact_Insert_Input;
  on_conflict?: Maybe<Risolto_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Contact_TypeArgs = {
  objects: Array<Risolto_Contact_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Contact_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Contact_Type_OneArgs = {
  object: Risolto_Contact_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Contact_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Content_DispositionArgs = {
  objects: Array<Risolto_Content_Disposition_Insert_Input>;
  on_conflict?: Maybe<Risolto_Content_Disposition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Content_Disposition_OneArgs = {
  object: Risolto_Content_Disposition_Insert_Input;
  on_conflict?: Maybe<Risolto_Content_Disposition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Credit_LimitArgs = {
  objects: Array<Risolto_Credit_Limit_Insert_Input>;
  on_conflict?: Maybe<Risolto_Credit_Limit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Credit_Limit_OneArgs = {
  object: Risolto_Credit_Limit_Insert_Input;
  on_conflict?: Maybe<Risolto_Credit_Limit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Credit_NoteArgs = {
  objects: Array<Risolto_Credit_Note_Insert_Input>;
  on_conflict?: Maybe<Risolto_Credit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Credit_Note_AttachmentArgs = {
  objects: Array<Risolto_Credit_Note_Attachment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Credit_Note_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Credit_Note_Attachment_OneArgs = {
  object: Risolto_Credit_Note_Attachment_Insert_Input;
  on_conflict?: Maybe<Risolto_Credit_Note_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Credit_Note_OneArgs = {
  object: Risolto_Credit_Note_Insert_Input;
  on_conflict?: Maybe<Risolto_Credit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_CurrencyArgs = {
  objects: Array<Risolto_Currency_Insert_Input>;
  on_conflict?: Maybe<Risolto_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Currency_OneArgs = {
  object: Risolto_Currency_Insert_Input;
  on_conflict?: Maybe<Risolto_Currency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Debit_NoteArgs = {
  objects: Array<Risolto_Debit_Note_Insert_Input>;
  on_conflict?: Maybe<Risolto_Debit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Debit_Note_AttachmentArgs = {
  objects: Array<Risolto_Debit_Note_Attachment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Debit_Note_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Debit_Note_Attachment_OneArgs = {
  object: Risolto_Debit_Note_Attachment_Insert_Input;
  on_conflict?: Maybe<Risolto_Debit_Note_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Debit_Note_OneArgs = {
  object: Risolto_Debit_Note_Insert_Input;
  on_conflict?: Maybe<Risolto_Debit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_MandateArgs = {
  objects: Array<Risolto_Direct_Debit_Mandate_Insert_Input>;
  on_conflict?: Maybe<Risolto_Direct_Debit_Mandate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_Mandate_OneArgs = {
  object: Risolto_Direct_Debit_Mandate_Insert_Input;
  on_conflict?: Maybe<Risolto_Direct_Debit_Mandate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_ProviderArgs = {
  objects: Array<Risolto_Direct_Debit_Provider_Insert_Input>;
  on_conflict?: Maybe<Risolto_Direct_Debit_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_Provider_OneArgs = {
  object: Risolto_Direct_Debit_Provider_Insert_Input;
  on_conflict?: Maybe<Risolto_Direct_Debit_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_SchemeArgs = {
  objects: Array<Risolto_Direct_Debit_Scheme_Insert_Input>;
  on_conflict?: Maybe<Risolto_Direct_Debit_Scheme_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_Scheme_OneArgs = {
  object: Risolto_Direct_Debit_Scheme_Insert_Input;
  on_conflict?: Maybe<Risolto_Direct_Debit_Scheme_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_Sequence_TypeArgs = {
  objects: Array<Risolto_Direct_Debit_Sequence_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Direct_Debit_Sequence_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_Sequence_Type_OneArgs = {
  object: Risolto_Direct_Debit_Sequence_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Direct_Debit_Sequence_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_TransactionArgs = {
  objects: Array<Risolto_Direct_Debit_Transaction_Insert_Input>;
  on_conflict?: Maybe<Risolto_Direct_Debit_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Direct_Debit_Transaction_OneArgs = {
  object: Risolto_Direct_Debit_Transaction_Insert_Input;
  on_conflict?: Maybe<Risolto_Direct_Debit_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dispute_CodeArgs = {
  objects: Array<Risolto_Dispute_Code_Insert_Input>;
  on_conflict?: Maybe<Risolto_Dispute_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dispute_Code_OneArgs = {
  object: Risolto_Dispute_Code_Insert_Input;
  on_conflict?: Maybe<Risolto_Dispute_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Attachment_TypeArgs = {
  objects: Array<Risolto_Document_Attachment_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Document_Attachment_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Attachment_Type_OneArgs = {
  object: Risolto_Document_Attachment_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Document_Attachment_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_InterchangeArgs = {
  objects: Array<Risolto_Document_Interchange_Insert_Input>;
  on_conflict?: Maybe<Risolto_Document_Interchange_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_AttachmentArgs = {
  objects: Array<Risolto_Document_Interchange_Attachment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Document_Interchange_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_Attachment_OneArgs = {
  object: Risolto_Document_Interchange_Attachment_Insert_Input;
  on_conflict?: Maybe<Risolto_Document_Interchange_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_DirectionArgs = {
  objects: Array<Risolto_Document_Interchange_Direction_Insert_Input>;
  on_conflict?: Maybe<Risolto_Document_Interchange_Direction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_Direction_OneArgs = {
  object: Risolto_Document_Interchange_Direction_Insert_Input;
  on_conflict?: Maybe<Risolto_Document_Interchange_Direction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_EventArgs = {
  objects: Array<Risolto_Document_Interchange_Event_Insert_Input>;
  on_conflict?: Maybe<Risolto_Document_Interchange_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_Event_OneArgs = {
  object: Risolto_Document_Interchange_Event_Insert_Input;
  on_conflict?: Maybe<Risolto_Document_Interchange_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_LinkArgs = {
  objects: Array<Risolto_Document_Interchange_Link_Insert_Input>;
  on_conflict?: Maybe<Risolto_Document_Interchange_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_Link_OneArgs = {
  object: Risolto_Document_Interchange_Link_Insert_Input;
  on_conflict?: Maybe<Risolto_Document_Interchange_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Document_Interchange_OneArgs = {
  object: Risolto_Document_Interchange_Insert_Input;
  on_conflict?: Maybe<Risolto_Document_Interchange_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_NoticeArgs = {
  objects: Array<Risolto_Dunning_Notice_Insert_Input>;
  on_conflict?: Maybe<Risolto_Dunning_Notice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_InvoiceArgs = {
  objects: Array<Risolto_Dunning_Notice_Invoice_Insert_Input>;
  on_conflict?: Maybe<Risolto_Dunning_Notice_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_Invoice_OneArgs = {
  object: Risolto_Dunning_Notice_Invoice_Insert_Input;
  on_conflict?: Maybe<Risolto_Dunning_Notice_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_Invoice_RelationArgs = {
  objects: Array<Risolto_Dunning_Notice_Invoice_Relation_Insert_Input>;
  on_conflict?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_Invoice_Relation_OneArgs = {
  object: Risolto_Dunning_Notice_Invoice_Relation_Insert_Input;
  on_conflict?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_OneArgs = {
  object: Risolto_Dunning_Notice_Insert_Input;
  on_conflict?: Maybe<Risolto_Dunning_Notice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_StatusArgs = {
  objects: Array<Risolto_Dunning_Notice_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Dunning_Notice_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_Status_OneArgs = {
  object: Risolto_Dunning_Notice_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Dunning_Notice_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_Type_CodeArgs = {
  objects: Array<Risolto_Dunning_Notice_Type_Code_Insert_Input>;
  on_conflict?: Maybe<Risolto_Dunning_Notice_Type_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Dunning_Notice_Type_Code_OneArgs = {
  object: Risolto_Dunning_Notice_Type_Code_Insert_Input;
  on_conflict?: Maybe<Risolto_Dunning_Notice_Type_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_FrequencyArgs = {
  objects: Array<Risolto_Frequency_Insert_Input>;
  on_conflict?: Maybe<Risolto_Frequency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Frequency_OneArgs = {
  object: Risolto_Frequency_Insert_Input;
  on_conflict?: Maybe<Risolto_Frequency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Grant_TypeArgs = {
  objects: Array<Risolto_Grant_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Grant_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Grant_Type_OneArgs = {
  object: Risolto_Grant_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Grant_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_CollectionArgs = {
  objects: Array<Risolto_Invoice_Collection_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Collection_OneArgs = {
  object: Risolto_Invoice_Collection_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_DisputeArgs = {
  objects: Array<Risolto_Invoice_Dispute_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Dispute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Dispute_OneArgs = {
  object: Risolto_Invoice_Dispute_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Dispute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_DocumentArgs = {
  objects: Array<Risolto_Invoice_Document_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Document_AttachmentArgs = {
  objects: Array<Risolto_Invoice_Document_Attachment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Document_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Document_Attachment_OneArgs = {
  object: Risolto_Invoice_Document_Attachment_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Document_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Document_OneArgs = {
  object: Risolto_Invoice_Document_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Document_StatusArgs = {
  objects: Array<Risolto_Invoice_Document_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Document_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Document_Status_OneArgs = {
  object: Risolto_Invoice_Document_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Document_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_GroupArgs = {
  objects: Array<Risolto_Invoice_Group_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Credit_NoteArgs = {
  objects: Array<Risolto_Invoice_Group_Credit_Note_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Group_Credit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Credit_Note_OneArgs = {
  object: Risolto_Invoice_Group_Credit_Note_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Group_Credit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Debit_NoteArgs = {
  objects: Array<Risolto_Invoice_Group_Debit_Note_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Group_Debit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Debit_Note_OneArgs = {
  object: Risolto_Invoice_Group_Debit_Note_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Group_Debit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Dunning_RunArgs = {
  objects: Array<Risolto_Invoice_Group_Dunning_Run_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Group_Dunning_Run_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Dunning_Run_OneArgs = {
  object: Risolto_Invoice_Group_Dunning_Run_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Group_Dunning_Run_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_InvoiceArgs = {
  objects: Array<Risolto_Invoice_Group_Invoice_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Group_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Invoice_OneArgs = {
  object: Risolto_Invoice_Group_Invoice_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Group_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_OneArgs = {
  object: Risolto_Invoice_Group_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_PaymentArgs = {
  objects: Array<Risolto_Invoice_Group_Payment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Group_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Payment_OneArgs = {
  object: Risolto_Invoice_Group_Payment_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Group_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Payment_PromiseArgs = {
  objects: Array<Risolto_Invoice_Group_Payment_Promise_Insert_Input>;
  on_conflict?: Maybe<Risolto_Invoice_Group_Payment_Promise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Invoice_Group_Payment_Promise_OneArgs = {
  object: Risolto_Invoice_Group_Payment_Promise_Insert_Input;
  on_conflict?: Maybe<Risolto_Invoice_Group_Payment_Promise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Iso_Country_CodeArgs = {
  objects: Array<Risolto_Iso_Country_Code_Insert_Input>;
  on_conflict?: Maybe<Risolto_Iso_Country_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Iso_Country_Code_OneArgs = {
  object: Risolto_Iso_Country_Code_Insert_Input;
  on_conflict?: Maybe<Risolto_Iso_Country_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_JobArgs = {
  objects: Array<Risolto_Job_Insert_Input>;
  on_conflict?: Maybe<Risolto_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Job_OneArgs = {
  object: Risolto_Job_Insert_Input;
  on_conflict?: Maybe<Risolto_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Language_CodeArgs = {
  objects: Array<Risolto_Language_Code_Insert_Input>;
  on_conflict?: Maybe<Risolto_Language_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Language_Code_OneArgs = {
  object: Risolto_Language_Code_Insert_Input;
  on_conflict?: Maybe<Risolto_Language_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Legal_EntityArgs = {
  objects: Array<Risolto_Legal_Entity_Insert_Input>;
  on_conflict?: Maybe<Risolto_Legal_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Legal_Entity_OneArgs = {
  object: Risolto_Legal_Entity_Insert_Input;
  on_conflict?: Maybe<Risolto_Legal_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_LocaleArgs = {
  objects: Array<Risolto_Locale_Insert_Input>;
  on_conflict?: Maybe<Risolto_Locale_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Locale_OneArgs = {
  object: Risolto_Locale_Insert_Input;
  on_conflict?: Maybe<Risolto_Locale_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Magda_CacheArgs = {
  objects: Array<Risolto_Magda_Cache_Insert_Input>;
  on_conflict?: Maybe<Risolto_Magda_Cache_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Magda_Cache_OneArgs = {
  object: Risolto_Magda_Cache_Insert_Input;
  on_conflict?: Maybe<Risolto_Magda_Cache_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Magda_Service_Audit_LogArgs = {
  objects: Array<Risolto_Magda_Service_Audit_Log_Insert_Input>;
  on_conflict?: Maybe<Risolto_Magda_Service_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Magda_Service_Audit_Log_OneArgs = {
  object: Risolto_Magda_Service_Audit_Log_Insert_Input;
  on_conflict?: Maybe<Risolto_Magda_Service_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Materialized_View_DefinitionArgs = {
  objects: Array<Risolto_Materialized_View_Definition_Insert_Input>;
  on_conflict?: Maybe<Risolto_Materialized_View_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Materialized_View_Definition_OneArgs = {
  object: Risolto_Materialized_View_Definition_Insert_Input;
  on_conflict?: Maybe<Risolto_Materialized_View_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_MessageArgs = {
  objects: Array<Risolto_Message_Insert_Input>;
  on_conflict?: Maybe<Risolto_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_AssigneeArgs = {
  objects: Array<Risolto_Message_Assignee_Insert_Input>;
  on_conflict?: Maybe<Risolto_Message_Assignee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_Assignee_OneArgs = {
  object: Risolto_Message_Assignee_Insert_Input;
  on_conflict?: Maybe<Risolto_Message_Assignee_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_AttachmentArgs = {
  objects: Array<Risolto_Message_Attachment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Message_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_Attachment_OneArgs = {
  object: Risolto_Message_Attachment_Insert_Input;
  on_conflict?: Maybe<Risolto_Message_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_LabelArgs = {
  objects: Array<Risolto_Message_Label_Insert_Input>;
  on_conflict?: Maybe<Risolto_Message_Label_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_Label_OneArgs = {
  object: Risolto_Message_Label_Insert_Input;
  on_conflict?: Maybe<Risolto_Message_Label_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_Message_LabelArgs = {
  objects: Array<Risolto_Message_Message_Label_Insert_Input>;
  on_conflict?: Maybe<Risolto_Message_Message_Label_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_Message_Label_OneArgs = {
  object: Risolto_Message_Message_Label_Insert_Input;
  on_conflict?: Maybe<Risolto_Message_Message_Label_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_OneArgs = {
  object: Risolto_Message_Insert_Input;
  on_conflict?: Maybe<Risolto_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_RecipientArgs = {
  objects: Array<Risolto_Message_Recipient_Insert_Input>;
  on_conflict?: Maybe<Risolto_Message_Recipient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Message_Recipient_OneArgs = {
  object: Risolto_Message_Recipient_Insert_Input;
  on_conflict?: Maybe<Risolto_Message_Recipient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Mime_TypeArgs = {
  objects: Array<Risolto_Mime_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Mime_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Mime_Type_OneArgs = {
  object: Risolto_Mime_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Mime_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_NoteArgs = {
  objects: Array<Risolto_Note_Insert_Input>;
  on_conflict?: Maybe<Risolto_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Note_CategoryArgs = {
  objects: Array<Risolto_Note_Category_Insert_Input>;
  on_conflict?: Maybe<Risolto_Note_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Note_Category_OneArgs = {
  object: Risolto_Note_Category_Insert_Input;
  on_conflict?: Maybe<Risolto_Note_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Note_InvoiceArgs = {
  objects: Array<Risolto_Note_Invoice_Insert_Input>;
  on_conflict?: Maybe<Risolto_Note_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Note_Invoice_OneArgs = {
  object: Risolto_Note_Invoice_Insert_Input;
  on_conflict?: Maybe<Risolto_Note_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Note_OneArgs = {
  object: Risolto_Note_Insert_Input;
  on_conflict?: Maybe<Risolto_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Open_BalanceArgs = {
  objects: Array<Risolto_Open_Balance_Insert_Input>;
  on_conflict?: Maybe<Risolto_Open_Balance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Open_Balance_OneArgs = {
  object: Risolto_Open_Balance_Insert_Input;
  on_conflict?: Maybe<Risolto_Open_Balance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Open_Balance_RecordArgs = {
  objects: Array<Risolto_Open_Balance_Record_Insert_Input>;
  on_conflict?: Maybe<Risolto_Open_Balance_Record_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Open_Balance_Record_OneArgs = {
  object: Risolto_Open_Balance_Record_Insert_Input;
  on_conflict?: Maybe<Risolto_Open_Balance_Record_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_OriginArgs = {
  objects: Array<Risolto_Origin_Insert_Input>;
  on_conflict?: Maybe<Risolto_Origin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Origin_OneArgs = {
  object: Risolto_Origin_Insert_Input;
  on_conflict?: Maybe<Risolto_Origin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_ParticipantArgs = {
  objects: Array<Risolto_Participant_Insert_Input>;
  on_conflict?: Maybe<Risolto_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_Api_App_ClientArgs = {
  objects: Array<Risolto_Participant_Api_App_Client_Insert_Input>;
  on_conflict?: Maybe<Risolto_Participant_Api_App_Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_Api_App_Client_OneArgs = {
  object: Risolto_Participant_Api_App_Client_Insert_Input;
  on_conflict?: Maybe<Risolto_Participant_Api_App_Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_Dunning_RunArgs = {
  objects: Array<Risolto_Participant_Dunning_Run_Insert_Input>;
  on_conflict?: Maybe<Risolto_Participant_Dunning_Run_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_Dunning_Run_OneArgs = {
  object: Risolto_Participant_Dunning_Run_Insert_Input;
  on_conflict?: Maybe<Risolto_Participant_Dunning_Run_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_OneArgs = {
  object: Risolto_Participant_Insert_Input;
  on_conflict?: Maybe<Risolto_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_UserArgs = {
  objects: Array<Risolto_Participant_User_Insert_Input>;
  on_conflict?: Maybe<Risolto_Participant_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_User_OneArgs = {
  object: Risolto_Participant_User_Insert_Input;
  on_conflict?: Maybe<Risolto_Participant_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_User_RoleArgs = {
  objects: Array<Risolto_Participant_User_Role_Insert_Input>;
  on_conflict?: Maybe<Risolto_Participant_User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Participant_User_Role_OneArgs = {
  object: Risolto_Participant_User_Role_Insert_Input;
  on_conflict?: Maybe<Risolto_Participant_User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_PaymentArgs = {
  objects: Array<Risolto_Payment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_DocumentArgs = {
  objects: Array<Risolto_Payment_Document_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Document_OneArgs = {
  object: Risolto_Payment_Document_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_LinkArgs = {
  objects: Array<Risolto_Payment_Link_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Link_OneArgs = {
  object: Risolto_Payment_Link_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_OneArgs = {
  object: Risolto_Payment_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_PlanArgs = {
  objects: Array<Risolto_Payment_Plan_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Plan_OneArgs = {
  object: Risolto_Payment_Plan_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_PromiseArgs = {
  objects: Array<Risolto_Payment_Promise_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Promise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Promise_OneArgs = {
  object: Risolto_Payment_Promise_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Promise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_TransferArgs = {
  objects: Array<Risolto_Payment_Transfer_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Transfer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_Bulk_PaymentArgs = {
  objects: Array<Risolto_Payment_Transfer_Bulk_Payment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_Bulk_Payment_OneArgs = {
  object: Risolto_Payment_Transfer_Bulk_Payment_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_LineArgs = {
  objects: Array<Risolto_Payment_Transfer_Line_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Transfer_Line_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_Line_OneArgs = {
  object: Risolto_Payment_Transfer_Line_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Transfer_Line_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_Line_TypeArgs = {
  objects: Array<Risolto_Payment_Transfer_Line_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Transfer_Line_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_Line_Type_OneArgs = {
  object: Risolto_Payment_Transfer_Line_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Transfer_Line_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_OneArgs = {
  object: Risolto_Payment_Transfer_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Transfer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_StatusArgs = {
  objects: Array<Risolto_Payment_Transfer_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Payment_Transfer_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Payment_Transfer_Status_OneArgs = {
  object: Risolto_Payment_Transfer_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Payment_Transfer_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_PersonArgs = {
  objects: Array<Risolto_Person_Insert_Input>;
  on_conflict?: Maybe<Risolto_Person_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Person_OneArgs = {
  object: Risolto_Person_Insert_Input;
  on_conflict?: Maybe<Risolto_Person_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_License_ModuleArgs = {
  objects: Array<Risolto_Platform_License_Module_Insert_Input>;
  on_conflict?: Maybe<Risolto_Platform_License_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_License_Module_OneArgs = {
  object: Risolto_Platform_License_Module_Insert_Input;
  on_conflict?: Maybe<Risolto_Platform_License_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_Participant_LicenseArgs = {
  objects: Array<Risolto_Platform_Participant_License_Insert_Input>;
  on_conflict?: Maybe<Risolto_Platform_Participant_License_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_Participant_License_OneArgs = {
  object: Risolto_Platform_Participant_License_Insert_Input;
  on_conflict?: Maybe<Risolto_Platform_Participant_License_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_PermissionArgs = {
  objects: Array<Risolto_Platform_Permission_Insert_Input>;
  on_conflict?: Maybe<Risolto_Platform_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_Permission_OneArgs = {
  object: Risolto_Platform_Permission_Insert_Input;
  on_conflict?: Maybe<Risolto_Platform_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_RoleArgs = {
  objects: Array<Risolto_Platform_Role_Insert_Input>;
  on_conflict?: Maybe<Risolto_Platform_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_Role_OneArgs = {
  object: Risolto_Platform_Role_Insert_Input;
  on_conflict?: Maybe<Risolto_Platform_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_Role_PermissionArgs = {
  objects: Array<Risolto_Platform_Role_Permission_Insert_Input>;
  on_conflict?: Maybe<Risolto_Platform_Role_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_Role_Permission_OneArgs = {
  object: Risolto_Platform_Role_Permission_Insert_Input;
  on_conflict?: Maybe<Risolto_Platform_Role_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_UsageArgs = {
  objects: Array<Risolto_Platform_Usage_Insert_Input>;
  on_conflict?: Maybe<Risolto_Platform_Usage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Platform_Usage_OneArgs = {
  object: Risolto_Platform_Usage_Insert_Input;
  on_conflict?: Maybe<Risolto_Platform_Usage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_RecipientArgs = {
  objects: Array<Risolto_Recipient_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_AddressArgs = {
  objects: Array<Risolto_Recipient_Address_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Address_OneArgs = {
  object: Risolto_Recipient_Address_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_AttachmentArgs = {
  objects: Array<Risolto_Recipient_Attachment_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Attachment_OneArgs = {
  object: Risolto_Recipient_Attachment_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_CollectionArgs = {
  objects: Array<Risolto_Recipient_Collection_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Collection_OneArgs = {
  object: Risolto_Recipient_Collection_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_CommunicationArgs = {
  objects: Array<Risolto_Recipient_Communication_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_Communication_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Communication_OneArgs = {
  object: Risolto_Recipient_Communication_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_Communication_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Dunning_ExcludeArgs = {
  objects: Array<Risolto_Recipient_Dunning_Exclude_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_Dunning_Exclude_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Dunning_Exclude_OneArgs = {
  object: Risolto_Recipient_Dunning_Exclude_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_Dunning_Exclude_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Dunning_RunArgs = {
  objects: Array<Risolto_Recipient_Dunning_Run_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_Dunning_Run_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Dunning_Run_OneArgs = {
  object: Risolto_Recipient_Dunning_Run_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_Dunning_Run_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_MergeArgs = {
  objects: Array<Risolto_Recipient_Merge_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_Merge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Merge_OneArgs = {
  object: Risolto_Recipient_Merge_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_Merge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_OneArgs = {
  object: Risolto_Recipient_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_TagArgs = {
  objects: Array<Risolto_Recipient_Tag_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_Tag_OneArgs = {
  object: Risolto_Recipient_Tag_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_UserArgs = {
  objects: Array<Risolto_Recipient_User_Insert_Input>;
  on_conflict?: Maybe<Risolto_Recipient_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Recipient_User_OneArgs = {
  object: Risolto_Recipient_User_Insert_Input;
  on_conflict?: Maybe<Risolto_Recipient_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Reference_DataArgs = {
  objects: Array<Risolto_Reference_Data_Insert_Input>;
  on_conflict?: Maybe<Risolto_Reference_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Reference_Data_OneArgs = {
  object: Risolto_Reference_Data_Insert_Input;
  on_conflict?: Maybe<Risolto_Reference_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_DefinitionArgs = {
  objects: Array<Risolto_Report_Definition_Insert_Input>;
  on_conflict?: Maybe<Risolto_Report_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_Definition_OneArgs = {
  object: Risolto_Report_Definition_Insert_Input;
  on_conflict?: Maybe<Risolto_Report_Definition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_ExecutionArgs = {
  objects: Array<Risolto_Report_Execution_Insert_Input>;
  on_conflict?: Maybe<Risolto_Report_Execution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_Execution_OneArgs = {
  object: Risolto_Report_Execution_Insert_Input;
  on_conflict?: Maybe<Risolto_Report_Execution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_Execution_UserArgs = {
  objects: Array<Risolto_Report_Execution_User_Insert_Input>;
  on_conflict?: Maybe<Risolto_Report_Execution_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_Execution_User_OneArgs = {
  object: Risolto_Report_Execution_User_Insert_Input;
  on_conflict?: Maybe<Risolto_Report_Execution_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_Template_TypeArgs = {
  objects: Array<Risolto_Report_Template_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Report_Template_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_Template_Type_OneArgs = {
  object: Risolto_Report_Template_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Report_Template_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_TypeArgs = {
  objects: Array<Risolto_Report_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Report_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_Type_OneArgs = {
  object: Risolto_Report_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Report_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_UserArgs = {
  objects: Array<Risolto_Report_User_Insert_Input>;
  on_conflict?: Maybe<Risolto_Report_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Report_User_OneArgs = {
  object: Risolto_Report_User_Insert_Input;
  on_conflict?: Maybe<Risolto_Report_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Run_Processing_StatusArgs = {
  objects: Array<Risolto_Run_Processing_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Run_Processing_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Run_Processing_Status_OneArgs = {
  object: Risolto_Run_Processing_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Run_Processing_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Single_Sign_OnArgs = {
  objects: Array<Risolto_Single_Sign_On_Insert_Input>;
  on_conflict?: Maybe<Risolto_Single_Sign_On_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Single_Sign_On_OneArgs = {
  object: Risolto_Single_Sign_On_Insert_Input;
  on_conflict?: Maybe<Risolto_Single_Sign_On_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_StatementArgs = {
  objects: Array<Risolto_Statement_Insert_Input>;
  on_conflict?: Maybe<Risolto_Statement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_AccountArgs = {
  objects: Array<Risolto_Statement_Account_Insert_Input>;
  on_conflict?: Maybe<Risolto_Statement_Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Account_OneArgs = {
  object: Risolto_Statement_Account_Insert_Input;
  on_conflict?: Maybe<Risolto_Statement_Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_LineArgs = {
  objects: Array<Risolto_Statement_Line_Insert_Input>;
  on_conflict?: Maybe<Risolto_Statement_Line_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_Dunning_NoticeArgs = {
  objects: Array<Risolto_Statement_Line_Dunning_Notice_Insert_Input>;
  on_conflict?: Maybe<Risolto_Statement_Line_Dunning_Notice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_Dunning_Notice_OneArgs = {
  object: Risolto_Statement_Line_Dunning_Notice_Insert_Input;
  on_conflict?: Maybe<Risolto_Statement_Line_Dunning_Notice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_InvoiceArgs = {
  objects: Array<Risolto_Statement_Line_Invoice_Insert_Input>;
  on_conflict?: Maybe<Risolto_Statement_Line_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_Invoice_OneArgs = {
  object: Risolto_Statement_Line_Invoice_Insert_Input;
  on_conflict?: Maybe<Risolto_Statement_Line_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_OneArgs = {
  object: Risolto_Statement_Line_Insert_Input;
  on_conflict?: Maybe<Risolto_Statement_Line_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_Payment_PromiseArgs = {
  objects: Array<Risolto_Statement_Line_Payment_Promise_Insert_Input>;
  on_conflict?: Maybe<Risolto_Statement_Line_Payment_Promise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_Payment_Promise_OneArgs = {
  object: Risolto_Statement_Line_Payment_Promise_Insert_Input;
  on_conflict?: Maybe<Risolto_Statement_Line_Payment_Promise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_StatusArgs = {
  objects: Array<Risolto_Statement_Line_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Statement_Line_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_Line_Status_OneArgs = {
  object: Risolto_Statement_Line_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Statement_Line_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Statement_OneArgs = {
  object: Risolto_Statement_Insert_Input;
  on_conflict?: Maybe<Risolto_Statement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Strigil_NbbArgs = {
  objects: Array<Risolto_Strigil_Nbb_Insert_Input>;
  on_conflict?: Maybe<Risolto_Strigil_Nbb_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Strigil_Nbb_OneArgs = {
  object: Risolto_Strigil_Nbb_Insert_Input;
  on_conflict?: Maybe<Risolto_Strigil_Nbb_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Strigil_Nbb_Processing_StatusArgs = {
  objects: Array<Risolto_Strigil_Nbb_Processing_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Strigil_Nbb_Processing_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Strigil_Nbb_Processing_Status_OneArgs = {
  object: Risolto_Strigil_Nbb_Processing_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Strigil_Nbb_Processing_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_System_IntegrationArgs = {
  objects: Array<Risolto_System_Integration_Insert_Input>;
  on_conflict?: Maybe<Risolto_System_Integration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_System_Integration_OneArgs = {
  object: Risolto_System_Integration_Insert_Input;
  on_conflict?: Maybe<Risolto_System_Integration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_TagArgs = {
  objects: Array<Risolto_Tag_Insert_Input>;
  on_conflict?: Maybe<Risolto_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Tag_OneArgs = {
  object: Risolto_Tag_Insert_Input;
  on_conflict?: Maybe<Risolto_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_TaskArgs = {
  objects: Array<Risolto_Task_Insert_Input>;
  on_conflict?: Maybe<Risolto_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Task_OneArgs = {
  object: Risolto_Task_Insert_Input;
  on_conflict?: Maybe<Risolto_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Task_SourceArgs = {
  objects: Array<Risolto_Task_Source_Insert_Input>;
  on_conflict?: Maybe<Risolto_Task_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Task_Source_OneArgs = {
  object: Risolto_Task_Source_Insert_Input;
  on_conflict?: Maybe<Risolto_Task_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Task_StatusArgs = {
  objects: Array<Risolto_Task_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Task_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Task_Status_OneArgs = {
  object: Risolto_Task_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Task_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Task_TypeArgs = {
  objects: Array<Risolto_Task_Type_Insert_Input>;
  on_conflict?: Maybe<Risolto_Task_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Task_Type_OneArgs = {
  object: Risolto_Task_Type_Insert_Input;
  on_conflict?: Maybe<Risolto_Task_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Tone_Of_VoiceArgs = {
  objects: Array<Risolto_Tone_Of_Voice_Insert_Input>;
  on_conflict?: Maybe<Risolto_Tone_Of_Voice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Tone_Of_Voice_OneArgs = {
  object: Risolto_Tone_Of_Voice_Insert_Input;
  on_conflict?: Maybe<Risolto_Tone_Of_Voice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Action_And_NoteArgs = {
  objects: Array<Risolto_Virtual_Action_And_Note_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Action_And_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Action_And_Note_And_DisputeArgs = {
  objects: Array<Risolto_Virtual_Action_And_Note_And_Dispute_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Action_And_Note_And_Dispute_And_MessageArgs = {
  objects: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_OneArgs = {
  object: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Action_And_Note_And_Dispute_OneArgs = {
  object: Risolto_Virtual_Action_And_Note_And_Dispute_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Action_And_Note_OneArgs = {
  object: Risolto_Virtual_Action_And_Note_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Action_And_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Action_GroupArgs = {
  objects: Array<Risolto_Virtual_Action_Group_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Action_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Action_Group_OneArgs = {
  object: Risolto_Virtual_Action_Group_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Action_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Dashboard_Action_StatsArgs = {
  objects: Array<Risolto_Virtual_Dashboard_Action_Stats_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Dashboard_Action_Stats_OneArgs = {
  object: Risolto_Virtual_Dashboard_Action_Stats_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Dashboard_Outstanding_DebtArgs = {
  objects: Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Dashboard_Outstanding_Debt_OneArgs = {
  object: Risolto_Virtual_Dashboard_Outstanding_Debt_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Demo_Action_Report_1Args = {
  objects: Array<Risolto_Virtual_Demo_Action_Report_1_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Demo_Action_Report_1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Demo_Action_Report_1_OneArgs = {
  object: Risolto_Virtual_Demo_Action_Report_1_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Demo_Action_Report_1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Dunning_ActionArgs = {
  objects: Array<Risolto_Virtual_Dunning_Action_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Dunning_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Dunning_Action_OneArgs = {
  object: Risolto_Virtual_Dunning_Action_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Dunning_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Interchange_EventArgs = {
  objects: Array<Risolto_Virtual_Interchange_Event_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Interchange_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Interchange_Event_OneArgs = {
  object: Risolto_Virtual_Interchange_Event_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Interchange_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Invoice_Derived_Payment_InformationArgs = {
  objects: Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Invoice_Derived_Payment_Information_OneArgs = {
  object: Risolto_Virtual_Invoice_Derived_Payment_Information_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Invoicing_Channel_EndpointArgs = {
  objects: Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Invoicing_Channel_Endpoint_OneArgs = {
  object: Risolto_Virtual_Invoicing_Channel_Endpoint_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_JsonArgs = {
  objects: Array<Risolto_Virtual_Json_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Json_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Json_OneArgs = {
  object: Risolto_Virtual_Json_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Json_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Report_DeliveryArgs = {
  objects: Array<Risolto_Virtual_Report_Delivery_Insert_Input>;
  on_conflict?: Maybe<Risolto_Virtual_Report_Delivery_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Virtual_Report_Delivery_OneArgs = {
  object: Risolto_Virtual_Report_Delivery_Insert_Input;
  on_conflict?: Maybe<Risolto_Virtual_Report_Delivery_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_WebhookArgs = {
  objects: Array<Risolto_Webhook_Insert_Input>;
  on_conflict?: Maybe<Risolto_Webhook_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Webhook_OneArgs = {
  object: Risolto_Webhook_Insert_Input;
  on_conflict?: Maybe<Risolto_Webhook_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Webhook_Processing_StatusArgs = {
  objects: Array<Risolto_Webhook_Processing_Status_Insert_Input>;
  on_conflict?: Maybe<Risolto_Webhook_Processing_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Webhook_Processing_Status_OneArgs = {
  object: Risolto_Webhook_Processing_Status_Insert_Input;
  on_conflict?: Maybe<Risolto_Webhook_Processing_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Webhook_SubscriptionArgs = {
  objects: Array<Risolto_Webhook_Subscription_Insert_Input>;
  on_conflict?: Maybe<Risolto_Webhook_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risolto_Webhook_Subscription_OneArgs = {
  object: Risolto_Webhook_Subscription_Insert_Input;
  on_conflict?: Maybe<Risolto_Webhook_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootRisolto_Move_Credit_NoteArgs = {
  args: Risolto_Move_Credit_Note_Args;
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRisolto_Move_Debit_NoteArgs = {
  args: Risolto_Move_Debit_Note_Args;
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRisolto_Move_InvoiceArgs = {
  args: Risolto_Move_Invoice_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRisolto_Move_PaymentArgs = {
  args: Risolto_Move_Payment_Args;
  distinct_on?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Document_Order_By>>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootRisolto_Platform_Usage_ExportArgs = {
  args: Risolto_Platform_Usage_Export_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Account_Number_TypeArgs = {
  _set?: Maybe<Risolto_Account_Number_Type_Set_Input>;
  where: Risolto_Account_Number_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Account_Number_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Account_Number_Type_Set_Input>;
  pk_columns: Risolto_Account_Number_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Account_Number_Type_ManyArgs = {
  updates: Array<Risolto_Account_Number_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_ActionArgs = {
  _append?: Maybe<Risolto_Action_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Action_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Action_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Action_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Action_Inc_Input>;
  _prepend?: Maybe<Risolto_Action_Prepend_Input>;
  _set?: Maybe<Risolto_Action_Set_Input>;
  where: Risolto_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_By_PkArgs = {
  _append?: Maybe<Risolto_Action_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Action_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Action_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Action_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Action_Inc_Input>;
  _prepend?: Maybe<Risolto_Action_Prepend_Input>;
  _set?: Maybe<Risolto_Action_Set_Input>;
  pk_columns: Risolto_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Execution_TypeArgs = {
  _set?: Maybe<Risolto_Action_Execution_Type_Set_Input>;
  where: Risolto_Action_Execution_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Execution_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Action_Execution_Type_Set_Input>;
  pk_columns: Risolto_Action_Execution_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Execution_Type_ManyArgs = {
  updates: Array<Risolto_Action_Execution_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_InterchangeArgs = {
  _set?: Maybe<Risolto_Action_Interchange_Set_Input>;
  where: Risolto_Action_Interchange_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Interchange_By_PkArgs = {
  _set?: Maybe<Risolto_Action_Interchange_Set_Input>;
  pk_columns: Risolto_Action_Interchange_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Interchange_ManyArgs = {
  updates: Array<Risolto_Action_Interchange_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_InvoiceArgs = {
  _set?: Maybe<Risolto_Action_Invoice_Set_Input>;
  where: Risolto_Action_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Invoice_By_PkArgs = {
  _set?: Maybe<Risolto_Action_Invoice_Set_Input>;
  pk_columns: Risolto_Action_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Invoice_ManyArgs = {
  updates: Array<Risolto_Action_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_ManyArgs = {
  updates: Array<Risolto_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_SourceArgs = {
  _set?: Maybe<Risolto_Action_Source_Set_Input>;
  where: Risolto_Action_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Source_By_PkArgs = {
  _set?: Maybe<Risolto_Action_Source_Set_Input>;
  pk_columns: Risolto_Action_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Source_ManyArgs = {
  updates: Array<Risolto_Action_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_StatusArgs = {
  _set?: Maybe<Risolto_Action_Status_Set_Input>;
  where: Risolto_Action_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Action_Status_Set_Input>;
  pk_columns: Risolto_Action_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Action_Status_ManyArgs = {
  updates: Array<Risolto_Action_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Company_ScoreArgs = {
  _inc?: Maybe<Risolto_Analytics_Company_Score_Inc_Input>;
  _set?: Maybe<Risolto_Analytics_Company_Score_Set_Input>;
  where: Risolto_Analytics_Company_Score_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Company_Score_By_PkArgs = {
  _inc?: Maybe<Risolto_Analytics_Company_Score_Inc_Input>;
  _set?: Maybe<Risolto_Analytics_Company_Score_Set_Input>;
  pk_columns: Risolto_Analytics_Company_Score_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Company_Score_ManyArgs = {
  updates: Array<Risolto_Analytics_Company_Score_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Invoice_FeaturesArgs = {
  _inc?: Maybe<Risolto_Analytics_Invoice_Features_Inc_Input>;
  _set?: Maybe<Risolto_Analytics_Invoice_Features_Set_Input>;
  where: Risolto_Analytics_Invoice_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Invoice_Features_By_PkArgs = {
  _inc?: Maybe<Risolto_Analytics_Invoice_Features_Inc_Input>;
  _set?: Maybe<Risolto_Analytics_Invoice_Features_Set_Input>;
  pk_columns: Risolto_Analytics_Invoice_Features_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Invoice_Features_ManyArgs = {
  updates: Array<Risolto_Analytics_Invoice_Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Invoice_PredictionArgs = {
  _append?: Maybe<Risolto_Analytics_Invoice_Prediction_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Analytics_Invoice_Prediction_Prepend_Input>;
  _set?: Maybe<Risolto_Analytics_Invoice_Prediction_Set_Input>;
  where: Risolto_Analytics_Invoice_Prediction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Invoice_Prediction_By_PkArgs = {
  _append?: Maybe<Risolto_Analytics_Invoice_Prediction_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Analytics_Invoice_Prediction_Prepend_Input>;
  _set?: Maybe<Risolto_Analytics_Invoice_Prediction_Set_Input>;
  pk_columns: Risolto_Analytics_Invoice_Prediction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Invoice_Prediction_ManyArgs = {
  updates: Array<Risolto_Analytics_Invoice_Prediction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_TestArgs = {
  _append?: Maybe<Risolto_Analytics_Test_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Analytics_Test_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Analytics_Test_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Analytics_Test_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Analytics_Test_Prepend_Input>;
  _set?: Maybe<Risolto_Analytics_Test_Set_Input>;
  where: Risolto_Analytics_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Test_By_PkArgs = {
  _append?: Maybe<Risolto_Analytics_Test_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Analytics_Test_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Analytics_Test_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Analytics_Test_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Analytics_Test_Prepend_Input>;
  _set?: Maybe<Risolto_Analytics_Test_Set_Input>;
  pk_columns: Risolto_Analytics_Test_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Test_ManyArgs = {
  updates: Array<Risolto_Analytics_Test_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Test_ResultArgs = {
  _append?: Maybe<Risolto_Analytics_Test_Result_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Analytics_Test_Result_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Analytics_Test_Result_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Analytics_Test_Result_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Analytics_Test_Result_Prepend_Input>;
  _set?: Maybe<Risolto_Analytics_Test_Result_Set_Input>;
  where: Risolto_Analytics_Test_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Test_Result_By_PkArgs = {
  _append?: Maybe<Risolto_Analytics_Test_Result_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Analytics_Test_Result_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Analytics_Test_Result_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Analytics_Test_Result_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Analytics_Test_Result_Prepend_Input>;
  _set?: Maybe<Risolto_Analytics_Test_Result_Set_Input>;
  pk_columns: Risolto_Analytics_Test_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Analytics_Test_Result_ManyArgs = {
  updates: Array<Risolto_Analytics_Test_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Api_App_ClientArgs = {
  _set?: Maybe<Risolto_Api_App_Client_Set_Input>;
  where: Risolto_Api_App_Client_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Api_App_Client_By_PkArgs = {
  _set?: Maybe<Risolto_Api_App_Client_Set_Input>;
  pk_columns: Risolto_Api_App_Client_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Api_App_Client_ManyArgs = {
  updates: Array<Risolto_Api_App_Client_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_AttachmentArgs = {
  _append?: Maybe<Risolto_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Attachment_Set_Input>;
  where: Risolto_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Attachment_By_PkArgs = {
  _append?: Maybe<Risolto_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Attachment_Set_Input>;
  pk_columns: Risolto_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Attachment_ManyArgs = {
  updates: Array<Risolto_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Attachment_SchemeArgs = {
  _set?: Maybe<Risolto_Attachment_Scheme_Set_Input>;
  where: Risolto_Attachment_Scheme_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Attachment_Scheme_By_PkArgs = {
  _set?: Maybe<Risolto_Attachment_Scheme_Set_Input>;
  pk_columns: Risolto_Attachment_Scheme_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Attachment_Scheme_ManyArgs = {
  updates: Array<Risolto_Attachment_Scheme_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Bank_AccountArgs = {
  _set?: Maybe<Risolto_Bank_Account_Set_Input>;
  where: Risolto_Bank_Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Bank_Account_By_PkArgs = {
  _set?: Maybe<Risolto_Bank_Account_Set_Input>;
  pk_columns: Risolto_Bank_Account_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Bank_Account_ManyArgs = {
  updates: Array<Risolto_Bank_Account_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Bank_Identifier_TypeArgs = {
  _set?: Maybe<Risolto_Bank_Identifier_Type_Set_Input>;
  where: Risolto_Bank_Identifier_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Bank_Identifier_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Bank_Identifier_Type_Set_Input>;
  pk_columns: Risolto_Bank_Identifier_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Bank_Identifier_Type_ManyArgs = {
  updates: Array<Risolto_Bank_Identifier_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_BlacklistArgs = {
  _append?: Maybe<Risolto_Blacklist_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Blacklist_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Blacklist_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Blacklist_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Blacklist_Prepend_Input>;
  _set?: Maybe<Risolto_Blacklist_Set_Input>;
  where: Risolto_Blacklist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Blacklist_By_PkArgs = {
  _append?: Maybe<Risolto_Blacklist_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Blacklist_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Blacklist_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Blacklist_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Blacklist_Prepend_Input>;
  _set?: Maybe<Risolto_Blacklist_Set_Input>;
  pk_columns: Risolto_Blacklist_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Blacklist_ManyArgs = {
  updates: Array<Risolto_Blacklist_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_ChannelArgs = {
  _set?: Maybe<Risolto_Channel_Set_Input>;
  where: Risolto_Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Channel_By_PkArgs = {
  _set?: Maybe<Risolto_Channel_Set_Input>;
  pk_columns: Risolto_Channel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Channel_EndpointArgs = {
  _append?: Maybe<Risolto_Channel_Endpoint_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Channel_Endpoint_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Channel_Endpoint_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Channel_Endpoint_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Channel_Endpoint_Inc_Input>;
  _prepend?: Maybe<Risolto_Channel_Endpoint_Prepend_Input>;
  _set?: Maybe<Risolto_Channel_Endpoint_Set_Input>;
  where: Risolto_Channel_Endpoint_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Channel_Endpoint_By_PkArgs = {
  _append?: Maybe<Risolto_Channel_Endpoint_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Channel_Endpoint_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Channel_Endpoint_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Channel_Endpoint_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Channel_Endpoint_Inc_Input>;
  _prepend?: Maybe<Risolto_Channel_Endpoint_Prepend_Input>;
  _set?: Maybe<Risolto_Channel_Endpoint_Set_Input>;
  pk_columns: Risolto_Channel_Endpoint_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Channel_Endpoint_ManyArgs = {
  updates: Array<Risolto_Channel_Endpoint_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Channel_ManyArgs = {
  updates: Array<Risolto_Channel_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_CommunicationArgs = {
  _set?: Maybe<Risolto_Communication_Set_Input>;
  where: Risolto_Communication_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Communication_By_PkArgs = {
  _set?: Maybe<Risolto_Communication_Set_Input>;
  pk_columns: Risolto_Communication_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Communication_ManyArgs = {
  updates: Array<Risolto_Communication_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Communication_TemplateArgs = {
  _append?: Maybe<Risolto_Communication_Template_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Communication_Template_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Communication_Template_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Communication_Template_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Communication_Template_Prepend_Input>;
  _set?: Maybe<Risolto_Communication_Template_Set_Input>;
  where: Risolto_Communication_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Communication_Template_By_PkArgs = {
  _append?: Maybe<Risolto_Communication_Template_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Communication_Template_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Communication_Template_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Communication_Template_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Communication_Template_Prepend_Input>;
  _set?: Maybe<Risolto_Communication_Template_Set_Input>;
  pk_columns: Risolto_Communication_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Communication_Template_ManyArgs = {
  updates: Array<Risolto_Communication_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Communication_Template_TypeArgs = {
  _set?: Maybe<Risolto_Communication_Template_Type_Set_Input>;
  where: Risolto_Communication_Template_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Communication_Template_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Communication_Template_Type_Set_Input>;
  pk_columns: Risolto_Communication_Template_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Communication_Template_Type_ManyArgs = {
  updates: Array<Risolto_Communication_Template_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_ContactArgs = {
  _append?: Maybe<Risolto_Contact_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Contact_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Contact_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Contact_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Contact_Prepend_Input>;
  _set?: Maybe<Risolto_Contact_Set_Input>;
  where: Risolto_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Contact_AddressArgs = {
  _append?: Maybe<Risolto_Contact_Address_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Contact_Address_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Contact_Address_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Contact_Address_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Contact_Address_Prepend_Input>;
  _set?: Maybe<Risolto_Contact_Address_Set_Input>;
  where: Risolto_Contact_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Contact_Address_ManyArgs = {
  updates: Array<Risolto_Contact_Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Contact_By_PkArgs = {
  _append?: Maybe<Risolto_Contact_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Contact_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Contact_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Contact_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Contact_Prepend_Input>;
  _set?: Maybe<Risolto_Contact_Set_Input>;
  pk_columns: Risolto_Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Contact_ManyArgs = {
  updates: Array<Risolto_Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Contact_TypeArgs = {
  _set?: Maybe<Risolto_Contact_Type_Set_Input>;
  where: Risolto_Contact_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Contact_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Contact_Type_Set_Input>;
  pk_columns: Risolto_Contact_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Contact_Type_ManyArgs = {
  updates: Array<Risolto_Contact_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Content_DispositionArgs = {
  _set?: Maybe<Risolto_Content_Disposition_Set_Input>;
  where: Risolto_Content_Disposition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Content_Disposition_By_PkArgs = {
  _set?: Maybe<Risolto_Content_Disposition_Set_Input>;
  pk_columns: Risolto_Content_Disposition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Content_Disposition_ManyArgs = {
  updates: Array<Risolto_Content_Disposition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_LimitArgs = {
  _append?: Maybe<Risolto_Credit_Limit_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Credit_Limit_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Credit_Limit_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Credit_Limit_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Credit_Limit_Inc_Input>;
  _prepend?: Maybe<Risolto_Credit_Limit_Prepend_Input>;
  _set?: Maybe<Risolto_Credit_Limit_Set_Input>;
  where: Risolto_Credit_Limit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_Limit_By_PkArgs = {
  _append?: Maybe<Risolto_Credit_Limit_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Credit_Limit_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Credit_Limit_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Credit_Limit_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Credit_Limit_Inc_Input>;
  _prepend?: Maybe<Risolto_Credit_Limit_Prepend_Input>;
  _set?: Maybe<Risolto_Credit_Limit_Set_Input>;
  pk_columns: Risolto_Credit_Limit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_Limit_ManyArgs = {
  updates: Array<Risolto_Credit_Limit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_NoteArgs = {
  _append?: Maybe<Risolto_Credit_Note_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Credit_Note_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Credit_Note_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Credit_Note_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Credit_Note_Inc_Input>;
  _prepend?: Maybe<Risolto_Credit_Note_Prepend_Input>;
  _set?: Maybe<Risolto_Credit_Note_Set_Input>;
  where: Risolto_Credit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_Note_AttachmentArgs = {
  _append?: Maybe<Risolto_Credit_Note_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Credit_Note_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Credit_Note_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Credit_Note_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Credit_Note_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Credit_Note_Attachment_Set_Input>;
  where: Risolto_Credit_Note_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_Note_Attachment_By_PkArgs = {
  _append?: Maybe<Risolto_Credit_Note_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Credit_Note_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Credit_Note_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Credit_Note_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Credit_Note_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Credit_Note_Attachment_Set_Input>;
  pk_columns: Risolto_Credit_Note_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_Note_Attachment_ManyArgs = {
  updates: Array<Risolto_Credit_Note_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_Note_By_PkArgs = {
  _append?: Maybe<Risolto_Credit_Note_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Credit_Note_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Credit_Note_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Credit_Note_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Credit_Note_Inc_Input>;
  _prepend?: Maybe<Risolto_Credit_Note_Prepend_Input>;
  _set?: Maybe<Risolto_Credit_Note_Set_Input>;
  pk_columns: Risolto_Credit_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Credit_Note_ManyArgs = {
  updates: Array<Risolto_Credit_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_CurrencyArgs = {
  _set?: Maybe<Risolto_Currency_Set_Input>;
  where: Risolto_Currency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Currency_By_PkArgs = {
  _set?: Maybe<Risolto_Currency_Set_Input>;
  pk_columns: Risolto_Currency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Currency_ManyArgs = {
  updates: Array<Risolto_Currency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Debit_NoteArgs = {
  _append?: Maybe<Risolto_Debit_Note_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Debit_Note_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Debit_Note_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Debit_Note_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Debit_Note_Inc_Input>;
  _prepend?: Maybe<Risolto_Debit_Note_Prepend_Input>;
  _set?: Maybe<Risolto_Debit_Note_Set_Input>;
  where: Risolto_Debit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Debit_Note_AttachmentArgs = {
  _set?: Maybe<Risolto_Debit_Note_Attachment_Set_Input>;
  where: Risolto_Debit_Note_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Debit_Note_Attachment_By_PkArgs = {
  _set?: Maybe<Risolto_Debit_Note_Attachment_Set_Input>;
  pk_columns: Risolto_Debit_Note_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Debit_Note_Attachment_ManyArgs = {
  updates: Array<Risolto_Debit_Note_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Debit_Note_By_PkArgs = {
  _append?: Maybe<Risolto_Debit_Note_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Debit_Note_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Debit_Note_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Debit_Note_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Debit_Note_Inc_Input>;
  _prepend?: Maybe<Risolto_Debit_Note_Prepend_Input>;
  _set?: Maybe<Risolto_Debit_Note_Set_Input>;
  pk_columns: Risolto_Debit_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Debit_Note_ManyArgs = {
  updates: Array<Risolto_Debit_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_MandateArgs = {
  _append?: Maybe<Risolto_Direct_Debit_Mandate_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Direct_Debit_Mandate_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Direct_Debit_Mandate_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Direct_Debit_Mandate_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Direct_Debit_Mandate_Prepend_Input>;
  _set?: Maybe<Risolto_Direct_Debit_Mandate_Set_Input>;
  where: Risolto_Direct_Debit_Mandate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Mandate_By_PkArgs = {
  _append?: Maybe<Risolto_Direct_Debit_Mandate_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Direct_Debit_Mandate_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Direct_Debit_Mandate_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Direct_Debit_Mandate_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Direct_Debit_Mandate_Prepend_Input>;
  _set?: Maybe<Risolto_Direct_Debit_Mandate_Set_Input>;
  pk_columns: Risolto_Direct_Debit_Mandate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Mandate_ManyArgs = {
  updates: Array<Risolto_Direct_Debit_Mandate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_ProviderArgs = {
  _set?: Maybe<Risolto_Direct_Debit_Provider_Set_Input>;
  where: Risolto_Direct_Debit_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Provider_By_PkArgs = {
  _set?: Maybe<Risolto_Direct_Debit_Provider_Set_Input>;
  pk_columns: Risolto_Direct_Debit_Provider_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Provider_ManyArgs = {
  updates: Array<Risolto_Direct_Debit_Provider_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_SchemeArgs = {
  _set?: Maybe<Risolto_Direct_Debit_Scheme_Set_Input>;
  where: Risolto_Direct_Debit_Scheme_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Scheme_By_PkArgs = {
  _set?: Maybe<Risolto_Direct_Debit_Scheme_Set_Input>;
  pk_columns: Risolto_Direct_Debit_Scheme_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Scheme_ManyArgs = {
  updates: Array<Risolto_Direct_Debit_Scheme_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Sequence_TypeArgs = {
  _set?: Maybe<Risolto_Direct_Debit_Sequence_Type_Set_Input>;
  where: Risolto_Direct_Debit_Sequence_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Sequence_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Direct_Debit_Sequence_Type_Set_Input>;
  pk_columns: Risolto_Direct_Debit_Sequence_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Sequence_Type_ManyArgs = {
  updates: Array<Risolto_Direct_Debit_Sequence_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_TransactionArgs = {
  _append?: Maybe<Risolto_Direct_Debit_Transaction_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Direct_Debit_Transaction_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Direct_Debit_Transaction_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Direct_Debit_Transaction_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Direct_Debit_Transaction_Inc_Input>;
  _prepend?: Maybe<Risolto_Direct_Debit_Transaction_Prepend_Input>;
  _set?: Maybe<Risolto_Direct_Debit_Transaction_Set_Input>;
  where: Risolto_Direct_Debit_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Transaction_By_PkArgs = {
  _append?: Maybe<Risolto_Direct_Debit_Transaction_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Direct_Debit_Transaction_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Direct_Debit_Transaction_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Direct_Debit_Transaction_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Direct_Debit_Transaction_Inc_Input>;
  _prepend?: Maybe<Risolto_Direct_Debit_Transaction_Prepend_Input>;
  _set?: Maybe<Risolto_Direct_Debit_Transaction_Set_Input>;
  pk_columns: Risolto_Direct_Debit_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Direct_Debit_Transaction_ManyArgs = {
  updates: Array<Risolto_Direct_Debit_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dispute_CodeArgs = {
  _inc?: Maybe<Risolto_Dispute_Code_Inc_Input>;
  _set?: Maybe<Risolto_Dispute_Code_Set_Input>;
  where: Risolto_Dispute_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dispute_Code_By_PkArgs = {
  _inc?: Maybe<Risolto_Dispute_Code_Inc_Input>;
  _set?: Maybe<Risolto_Dispute_Code_Set_Input>;
  pk_columns: Risolto_Dispute_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dispute_Code_ManyArgs = {
  updates: Array<Risolto_Dispute_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Attachment_TypeArgs = {
  _set?: Maybe<Risolto_Document_Attachment_Type_Set_Input>;
  where: Risolto_Document_Attachment_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Attachment_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Document_Attachment_Type_Set_Input>;
  pk_columns: Risolto_Document_Attachment_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Attachment_Type_ManyArgs = {
  updates: Array<Risolto_Document_Attachment_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_InterchangeArgs = {
  _append?: Maybe<Risolto_Document_Interchange_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Document_Interchange_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Document_Interchange_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Document_Interchange_Prepend_Input>;
  _set?: Maybe<Risolto_Document_Interchange_Set_Input>;
  where: Risolto_Document_Interchange_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_AttachmentArgs = {
  _append?: Maybe<Risolto_Document_Interchange_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Document_Interchange_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Document_Interchange_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Document_Interchange_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Document_Interchange_Attachment_Set_Input>;
  where: Risolto_Document_Interchange_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_Attachment_By_PkArgs = {
  _append?: Maybe<Risolto_Document_Interchange_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Document_Interchange_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Document_Interchange_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Document_Interchange_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Document_Interchange_Attachment_Set_Input>;
  pk_columns: Risolto_Document_Interchange_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_Attachment_ManyArgs = {
  updates: Array<Risolto_Document_Interchange_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_By_PkArgs = {
  _append?: Maybe<Risolto_Document_Interchange_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Document_Interchange_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Document_Interchange_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Document_Interchange_Prepend_Input>;
  _set?: Maybe<Risolto_Document_Interchange_Set_Input>;
  pk_columns: Risolto_Document_Interchange_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_DirectionArgs = {
  _set?: Maybe<Risolto_Document_Interchange_Direction_Set_Input>;
  where: Risolto_Document_Interchange_Direction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_Direction_By_PkArgs = {
  _set?: Maybe<Risolto_Document_Interchange_Direction_Set_Input>;
  pk_columns: Risolto_Document_Interchange_Direction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_Direction_ManyArgs = {
  updates: Array<Risolto_Document_Interchange_Direction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_EventArgs = {
  _append?: Maybe<Risolto_Document_Interchange_Event_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Event_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Document_Interchange_Event_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Document_Interchange_Event_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Document_Interchange_Event_Prepend_Input>;
  _set?: Maybe<Risolto_Document_Interchange_Event_Set_Input>;
  where: Risolto_Document_Interchange_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_Event_By_PkArgs = {
  _append?: Maybe<Risolto_Document_Interchange_Event_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Event_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Document_Interchange_Event_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Document_Interchange_Event_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Document_Interchange_Event_Prepend_Input>;
  _set?: Maybe<Risolto_Document_Interchange_Event_Set_Input>;
  pk_columns: Risolto_Document_Interchange_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_Event_ManyArgs = {
  updates: Array<Risolto_Document_Interchange_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_LinkArgs = {
  _set?: Maybe<Risolto_Document_Interchange_Link_Set_Input>;
  where: Risolto_Document_Interchange_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_Link_By_PkArgs = {
  _set?: Maybe<Risolto_Document_Interchange_Link_Set_Input>;
  pk_columns: Risolto_Document_Interchange_Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_Link_ManyArgs = {
  updates: Array<Risolto_Document_Interchange_Link_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Document_Interchange_ManyArgs = {
  updates: Array<Risolto_Document_Interchange_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_NoticeArgs = {
  _append?: Maybe<Risolto_Dunning_Notice_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Dunning_Notice_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Dunning_Notice_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Dunning_Notice_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Dunning_Notice_Inc_Input>;
  _prepend?: Maybe<Risolto_Dunning_Notice_Prepend_Input>;
  _set?: Maybe<Risolto_Dunning_Notice_Set_Input>;
  where: Risolto_Dunning_Notice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_By_PkArgs = {
  _append?: Maybe<Risolto_Dunning_Notice_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Dunning_Notice_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Dunning_Notice_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Dunning_Notice_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Dunning_Notice_Inc_Input>;
  _prepend?: Maybe<Risolto_Dunning_Notice_Prepend_Input>;
  _set?: Maybe<Risolto_Dunning_Notice_Set_Input>;
  pk_columns: Risolto_Dunning_Notice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_InvoiceArgs = {
  _set?: Maybe<Risolto_Dunning_Notice_Invoice_Set_Input>;
  where: Risolto_Dunning_Notice_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Invoice_By_PkArgs = {
  _set?: Maybe<Risolto_Dunning_Notice_Invoice_Set_Input>;
  pk_columns: Risolto_Dunning_Notice_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Invoice_ManyArgs = {
  updates: Array<Risolto_Dunning_Notice_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Invoice_RelationArgs = {
  _set?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Set_Input>;
  where: Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Invoice_Relation_By_PkArgs = {
  _set?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Set_Input>;
  pk_columns: Risolto_Dunning_Notice_Invoice_Relation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Invoice_Relation_ManyArgs = {
  updates: Array<Risolto_Dunning_Notice_Invoice_Relation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_ManyArgs = {
  updates: Array<Risolto_Dunning_Notice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_StatusArgs = {
  _set?: Maybe<Risolto_Dunning_Notice_Status_Set_Input>;
  where: Risolto_Dunning_Notice_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Dunning_Notice_Status_Set_Input>;
  pk_columns: Risolto_Dunning_Notice_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Status_ManyArgs = {
  updates: Array<Risolto_Dunning_Notice_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Type_CodeArgs = {
  _set?: Maybe<Risolto_Dunning_Notice_Type_Code_Set_Input>;
  where: Risolto_Dunning_Notice_Type_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Type_Code_By_PkArgs = {
  _set?: Maybe<Risolto_Dunning_Notice_Type_Code_Set_Input>;
  pk_columns: Risolto_Dunning_Notice_Type_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Dunning_Notice_Type_Code_ManyArgs = {
  updates: Array<Risolto_Dunning_Notice_Type_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_FrequencyArgs = {
  _set?: Maybe<Risolto_Frequency_Set_Input>;
  where: Risolto_Frequency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Frequency_By_PkArgs = {
  _set?: Maybe<Risolto_Frequency_Set_Input>;
  pk_columns: Risolto_Frequency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Frequency_ManyArgs = {
  updates: Array<Risolto_Frequency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Grant_TypeArgs = {
  _set?: Maybe<Risolto_Grant_Type_Set_Input>;
  where: Risolto_Grant_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Grant_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Grant_Type_Set_Input>;
  pk_columns: Risolto_Grant_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Grant_Type_ManyArgs = {
  updates: Array<Risolto_Grant_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_CollectionArgs = {
  _set?: Maybe<Risolto_Invoice_Collection_Set_Input>;
  where: Risolto_Invoice_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Collection_By_PkArgs = {
  _set?: Maybe<Risolto_Invoice_Collection_Set_Input>;
  pk_columns: Risolto_Invoice_Collection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Collection_ManyArgs = {
  updates: Array<Risolto_Invoice_Collection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_DisputeArgs = {
  _set?: Maybe<Risolto_Invoice_Dispute_Set_Input>;
  where: Risolto_Invoice_Dispute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Dispute_By_PkArgs = {
  _set?: Maybe<Risolto_Invoice_Dispute_Set_Input>;
  pk_columns: Risolto_Invoice_Dispute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Dispute_ManyArgs = {
  updates: Array<Risolto_Invoice_Dispute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_DocumentArgs = {
  _append?: Maybe<Risolto_Invoice_Document_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Invoice_Document_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Invoice_Document_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Invoice_Document_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Invoice_Document_Inc_Input>;
  _prepend?: Maybe<Risolto_Invoice_Document_Prepend_Input>;
  _set?: Maybe<Risolto_Invoice_Document_Set_Input>;
  where: Risolto_Invoice_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Document_AttachmentArgs = {
  _append?: Maybe<Risolto_Invoice_Document_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Invoice_Document_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Invoice_Document_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Invoice_Document_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Invoice_Document_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Invoice_Document_Attachment_Set_Input>;
  where: Risolto_Invoice_Document_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Document_Attachment_By_PkArgs = {
  _append?: Maybe<Risolto_Invoice_Document_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Invoice_Document_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Invoice_Document_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Invoice_Document_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Invoice_Document_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Invoice_Document_Attachment_Set_Input>;
  pk_columns: Risolto_Invoice_Document_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Document_Attachment_ManyArgs = {
  updates: Array<Risolto_Invoice_Document_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Document_By_PkArgs = {
  _append?: Maybe<Risolto_Invoice_Document_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Invoice_Document_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Invoice_Document_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Invoice_Document_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Invoice_Document_Inc_Input>;
  _prepend?: Maybe<Risolto_Invoice_Document_Prepend_Input>;
  _set?: Maybe<Risolto_Invoice_Document_Set_Input>;
  pk_columns: Risolto_Invoice_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Document_ManyArgs = {
  updates: Array<Risolto_Invoice_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Document_StatusArgs = {
  _set?: Maybe<Risolto_Invoice_Document_Status_Set_Input>;
  where: Risolto_Invoice_Document_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Document_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Invoice_Document_Status_Set_Input>;
  pk_columns: Risolto_Invoice_Document_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Document_Status_ManyArgs = {
  updates: Array<Risolto_Invoice_Document_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_GroupArgs = {
  _set?: Maybe<Risolto_Invoice_Group_Set_Input>;
  where: Risolto_Invoice_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_By_PkArgs = {
  _set?: Maybe<Risolto_Invoice_Group_Set_Input>;
  pk_columns: Risolto_Invoice_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Credit_NoteArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Credit_Note_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Credit_Note_Set_Input>;
  where: Risolto_Invoice_Group_Credit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Credit_Note_By_PkArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Credit_Note_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Credit_Note_Set_Input>;
  pk_columns: Risolto_Invoice_Group_Credit_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Credit_Note_ManyArgs = {
  updates: Array<Risolto_Invoice_Group_Credit_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Debit_NoteArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Debit_Note_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Debit_Note_Set_Input>;
  where: Risolto_Invoice_Group_Debit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Debit_Note_By_PkArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Debit_Note_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Debit_Note_Set_Input>;
  pk_columns: Risolto_Invoice_Group_Debit_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Debit_Note_ManyArgs = {
  updates: Array<Risolto_Invoice_Group_Debit_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Dunning_RunArgs = {
  _append?: Maybe<Risolto_Invoice_Group_Dunning_Run_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Invoice_Group_Dunning_Run_Prepend_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Dunning_Run_Set_Input>;
  where: Risolto_Invoice_Group_Dunning_Run_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Dunning_Run_By_PkArgs = {
  _append?: Maybe<Risolto_Invoice_Group_Dunning_Run_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Invoice_Group_Dunning_Run_Prepend_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Dunning_Run_Set_Input>;
  pk_columns: Risolto_Invoice_Group_Dunning_Run_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Dunning_Run_ManyArgs = {
  updates: Array<Risolto_Invoice_Group_Dunning_Run_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_InvoiceArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Invoice_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Invoice_Set_Input>;
  where: Risolto_Invoice_Group_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Invoice_By_PkArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Invoice_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Invoice_Set_Input>;
  pk_columns: Risolto_Invoice_Group_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Invoice_ManyArgs = {
  updates: Array<Risolto_Invoice_Group_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_ManyArgs = {
  updates: Array<Risolto_Invoice_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_PaymentArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Payment_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Payment_Set_Input>;
  where: Risolto_Invoice_Group_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Payment_By_PkArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Payment_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Payment_Set_Input>;
  pk_columns: Risolto_Invoice_Group_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Payment_ManyArgs = {
  updates: Array<Risolto_Invoice_Group_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Payment_PromiseArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Payment_Promise_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Payment_Promise_Set_Input>;
  where: Risolto_Invoice_Group_Payment_Promise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Payment_Promise_By_PkArgs = {
  _inc?: Maybe<Risolto_Invoice_Group_Payment_Promise_Inc_Input>;
  _set?: Maybe<Risolto_Invoice_Group_Payment_Promise_Set_Input>;
  pk_columns: Risolto_Invoice_Group_Payment_Promise_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Invoice_Group_Payment_Promise_ManyArgs = {
  updates: Array<Risolto_Invoice_Group_Payment_Promise_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Iso_Country_CodeArgs = {
  _set?: Maybe<Risolto_Iso_Country_Code_Set_Input>;
  where: Risolto_Iso_Country_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Iso_Country_Code_By_PkArgs = {
  _set?: Maybe<Risolto_Iso_Country_Code_Set_Input>;
  pk_columns: Risolto_Iso_Country_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Iso_Country_Code_ManyArgs = {
  updates: Array<Risolto_Iso_Country_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_JobArgs = {
  _append?: Maybe<Risolto_Job_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Job_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Job_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Job_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Job_Prepend_Input>;
  _set?: Maybe<Risolto_Job_Set_Input>;
  where: Risolto_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Job_By_PkArgs = {
  _append?: Maybe<Risolto_Job_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Job_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Job_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Job_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Job_Prepend_Input>;
  _set?: Maybe<Risolto_Job_Set_Input>;
  pk_columns: Risolto_Job_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Job_ManyArgs = {
  updates: Array<Risolto_Job_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Language_CodeArgs = {
  _set?: Maybe<Risolto_Language_Code_Set_Input>;
  where: Risolto_Language_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Language_Code_By_PkArgs = {
  _set?: Maybe<Risolto_Language_Code_Set_Input>;
  pk_columns: Risolto_Language_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Language_Code_ManyArgs = {
  updates: Array<Risolto_Language_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Legal_EntityArgs = {
  _append?: Maybe<Risolto_Legal_Entity_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Legal_Entity_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Legal_Entity_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Legal_Entity_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Legal_Entity_Prepend_Input>;
  _set?: Maybe<Risolto_Legal_Entity_Set_Input>;
  where: Risolto_Legal_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Legal_Entity_By_PkArgs = {
  _append?: Maybe<Risolto_Legal_Entity_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Legal_Entity_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Legal_Entity_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Legal_Entity_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Legal_Entity_Prepend_Input>;
  _set?: Maybe<Risolto_Legal_Entity_Set_Input>;
  pk_columns: Risolto_Legal_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Legal_Entity_ManyArgs = {
  updates: Array<Risolto_Legal_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_LocaleArgs = {
  _set?: Maybe<Risolto_Locale_Set_Input>;
  where: Risolto_Locale_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Locale_By_PkArgs = {
  _set?: Maybe<Risolto_Locale_Set_Input>;
  pk_columns: Risolto_Locale_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Locale_ManyArgs = {
  updates: Array<Risolto_Locale_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Magda_CacheArgs = {
  _append?: Maybe<Risolto_Magda_Cache_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Magda_Cache_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Magda_Cache_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Magda_Cache_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Magda_Cache_Prepend_Input>;
  _set?: Maybe<Risolto_Magda_Cache_Set_Input>;
  where: Risolto_Magda_Cache_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Magda_Cache_By_PkArgs = {
  _append?: Maybe<Risolto_Magda_Cache_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Magda_Cache_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Magda_Cache_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Magda_Cache_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Magda_Cache_Prepend_Input>;
  _set?: Maybe<Risolto_Magda_Cache_Set_Input>;
  pk_columns: Risolto_Magda_Cache_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Magda_Cache_ManyArgs = {
  updates: Array<Risolto_Magda_Cache_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Magda_Service_Audit_LogArgs = {
  _append?: Maybe<Risolto_Magda_Service_Audit_Log_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Magda_Service_Audit_Log_Prepend_Input>;
  _set?: Maybe<Risolto_Magda_Service_Audit_Log_Set_Input>;
  where: Risolto_Magda_Service_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Magda_Service_Audit_Log_By_PkArgs = {
  _append?: Maybe<Risolto_Magda_Service_Audit_Log_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Magda_Service_Audit_Log_Prepend_Input>;
  _set?: Maybe<Risolto_Magda_Service_Audit_Log_Set_Input>;
  pk_columns: Risolto_Magda_Service_Audit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Magda_Service_Audit_Log_ManyArgs = {
  updates: Array<Risolto_Magda_Service_Audit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Materialized_View_DefinitionArgs = {
  _set?: Maybe<Risolto_Materialized_View_Definition_Set_Input>;
  where: Risolto_Materialized_View_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Materialized_View_Definition_By_PkArgs = {
  _set?: Maybe<Risolto_Materialized_View_Definition_Set_Input>;
  pk_columns: Risolto_Materialized_View_Definition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Materialized_View_Definition_ManyArgs = {
  updates: Array<Risolto_Materialized_View_Definition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_MessageArgs = {
  _append?: Maybe<Risolto_Message_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Message_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Message_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Message_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Message_Prepend_Input>;
  _set?: Maybe<Risolto_Message_Set_Input>;
  where: Risolto_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_AssigneeArgs = {
  _set?: Maybe<Risolto_Message_Assignee_Set_Input>;
  where: Risolto_Message_Assignee_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Assignee_By_PkArgs = {
  _set?: Maybe<Risolto_Message_Assignee_Set_Input>;
  pk_columns: Risolto_Message_Assignee_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Assignee_ManyArgs = {
  updates: Array<Risolto_Message_Assignee_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_AttachmentArgs = {
  _set?: Maybe<Risolto_Message_Attachment_Set_Input>;
  where: Risolto_Message_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Attachment_By_PkArgs = {
  _set?: Maybe<Risolto_Message_Attachment_Set_Input>;
  pk_columns: Risolto_Message_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Attachment_ManyArgs = {
  updates: Array<Risolto_Message_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_By_PkArgs = {
  _append?: Maybe<Risolto_Message_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Message_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Message_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Message_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Message_Prepend_Input>;
  _set?: Maybe<Risolto_Message_Set_Input>;
  pk_columns: Risolto_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_LabelArgs = {
  _set?: Maybe<Risolto_Message_Label_Set_Input>;
  where: Risolto_Message_Label_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Label_By_PkArgs = {
  _set?: Maybe<Risolto_Message_Label_Set_Input>;
  pk_columns: Risolto_Message_Label_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Label_ManyArgs = {
  updates: Array<Risolto_Message_Label_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_ManyArgs = {
  updates: Array<Risolto_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Message_LabelArgs = {
  _set?: Maybe<Risolto_Message_Message_Label_Set_Input>;
  where: Risolto_Message_Message_Label_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Message_Label_By_PkArgs = {
  _set?: Maybe<Risolto_Message_Message_Label_Set_Input>;
  pk_columns: Risolto_Message_Message_Label_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Message_Label_ManyArgs = {
  updates: Array<Risolto_Message_Message_Label_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_RecipientArgs = {
  _set?: Maybe<Risolto_Message_Recipient_Set_Input>;
  where: Risolto_Message_Recipient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Recipient_By_PkArgs = {
  _set?: Maybe<Risolto_Message_Recipient_Set_Input>;
  pk_columns: Risolto_Message_Recipient_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Message_Recipient_ManyArgs = {
  updates: Array<Risolto_Message_Recipient_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Mime_TypeArgs = {
  _set?: Maybe<Risolto_Mime_Type_Set_Input>;
  where: Risolto_Mime_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Mime_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Mime_Type_Set_Input>;
  pk_columns: Risolto_Mime_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Mime_Type_ManyArgs = {
  updates: Array<Risolto_Mime_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_NoteArgs = {
  _append?: Maybe<Risolto_Note_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Note_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Note_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Note_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Note_Prepend_Input>;
  _set?: Maybe<Risolto_Note_Set_Input>;
  where: Risolto_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Note_By_PkArgs = {
  _append?: Maybe<Risolto_Note_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Note_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Note_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Note_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Note_Prepend_Input>;
  _set?: Maybe<Risolto_Note_Set_Input>;
  pk_columns: Risolto_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Note_CategoryArgs = {
  _set?: Maybe<Risolto_Note_Category_Set_Input>;
  where: Risolto_Note_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Note_Category_By_PkArgs = {
  _set?: Maybe<Risolto_Note_Category_Set_Input>;
  pk_columns: Risolto_Note_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Note_Category_ManyArgs = {
  updates: Array<Risolto_Note_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Note_InvoiceArgs = {
  _set?: Maybe<Risolto_Note_Invoice_Set_Input>;
  where: Risolto_Note_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Note_Invoice_By_PkArgs = {
  _set?: Maybe<Risolto_Note_Invoice_Set_Input>;
  pk_columns: Risolto_Note_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Note_Invoice_ManyArgs = {
  updates: Array<Risolto_Note_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Note_ManyArgs = {
  updates: Array<Risolto_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Open_BalanceArgs = {
  _inc?: Maybe<Risolto_Open_Balance_Inc_Input>;
  _set?: Maybe<Risolto_Open_Balance_Set_Input>;
  where: Risolto_Open_Balance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Open_Balance_By_PkArgs = {
  _inc?: Maybe<Risolto_Open_Balance_Inc_Input>;
  _set?: Maybe<Risolto_Open_Balance_Set_Input>;
  pk_columns: Risolto_Open_Balance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Open_Balance_ManyArgs = {
  updates: Array<Risolto_Open_Balance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Open_Balance_RecordArgs = {
  _append?: Maybe<Risolto_Open_Balance_Record_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Open_Balance_Record_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Open_Balance_Record_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Open_Balance_Record_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Open_Balance_Record_Inc_Input>;
  _prepend?: Maybe<Risolto_Open_Balance_Record_Prepend_Input>;
  _set?: Maybe<Risolto_Open_Balance_Record_Set_Input>;
  where: Risolto_Open_Balance_Record_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Open_Balance_Record_By_PkArgs = {
  _append?: Maybe<Risolto_Open_Balance_Record_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Open_Balance_Record_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Open_Balance_Record_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Open_Balance_Record_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Open_Balance_Record_Inc_Input>;
  _prepend?: Maybe<Risolto_Open_Balance_Record_Prepend_Input>;
  _set?: Maybe<Risolto_Open_Balance_Record_Set_Input>;
  pk_columns: Risolto_Open_Balance_Record_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Open_Balance_Record_ManyArgs = {
  updates: Array<Risolto_Open_Balance_Record_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_OriginArgs = {
  _set?: Maybe<Risolto_Origin_Set_Input>;
  where: Risolto_Origin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Origin_By_PkArgs = {
  _set?: Maybe<Risolto_Origin_Set_Input>;
  pk_columns: Risolto_Origin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Origin_ManyArgs = {
  updates: Array<Risolto_Origin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_ParticipantArgs = {
  _append?: Maybe<Risolto_Participant_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Participant_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Participant_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Participant_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Participant_Prepend_Input>;
  _set?: Maybe<Risolto_Participant_Set_Input>;
  where: Risolto_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_Api_App_ClientArgs = {
  _set?: Maybe<Risolto_Participant_Api_App_Client_Set_Input>;
  where: Risolto_Participant_Api_App_Client_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_Api_App_Client_By_PkArgs = {
  _set?: Maybe<Risolto_Participant_Api_App_Client_Set_Input>;
  pk_columns: Risolto_Participant_Api_App_Client_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_Api_App_Client_ManyArgs = {
  updates: Array<Risolto_Participant_Api_App_Client_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_By_PkArgs = {
  _append?: Maybe<Risolto_Participant_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Participant_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Participant_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Participant_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Participant_Prepend_Input>;
  _set?: Maybe<Risolto_Participant_Set_Input>;
  pk_columns: Risolto_Participant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_Dunning_RunArgs = {
  _set?: Maybe<Risolto_Participant_Dunning_Run_Set_Input>;
  where: Risolto_Participant_Dunning_Run_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_Dunning_Run_By_PkArgs = {
  _set?: Maybe<Risolto_Participant_Dunning_Run_Set_Input>;
  pk_columns: Risolto_Participant_Dunning_Run_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_Dunning_Run_ManyArgs = {
  updates: Array<Risolto_Participant_Dunning_Run_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_ManyArgs = {
  updates: Array<Risolto_Participant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_UserArgs = {
  _set?: Maybe<Risolto_Participant_User_Set_Input>;
  where: Risolto_Participant_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_User_By_PkArgs = {
  _set?: Maybe<Risolto_Participant_User_Set_Input>;
  pk_columns: Risolto_Participant_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_User_ManyArgs = {
  updates: Array<Risolto_Participant_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_User_RoleArgs = {
  _set?: Maybe<Risolto_Participant_User_Role_Set_Input>;
  where: Risolto_Participant_User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_User_Role_By_PkArgs = {
  _set?: Maybe<Risolto_Participant_User_Role_Set_Input>;
  pk_columns: Risolto_Participant_User_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Participant_User_Role_ManyArgs = {
  updates: Array<Risolto_Participant_User_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_PaymentArgs = {
  _append?: Maybe<Risolto_Payment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Payment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Payment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Payment_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Payment_Inc_Input>;
  _prepend?: Maybe<Risolto_Payment_Prepend_Input>;
  _set?: Maybe<Risolto_Payment_Set_Input>;
  where: Risolto_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_By_PkArgs = {
  _append?: Maybe<Risolto_Payment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Payment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Payment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Payment_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Payment_Inc_Input>;
  _prepend?: Maybe<Risolto_Payment_Prepend_Input>;
  _set?: Maybe<Risolto_Payment_Set_Input>;
  pk_columns: Risolto_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_DocumentArgs = {
  _append?: Maybe<Risolto_Payment_Document_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Payment_Document_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Payment_Document_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Payment_Document_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Payment_Document_Inc_Input>;
  _prepend?: Maybe<Risolto_Payment_Document_Prepend_Input>;
  _set?: Maybe<Risolto_Payment_Document_Set_Input>;
  where: Risolto_Payment_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Document_By_PkArgs = {
  _append?: Maybe<Risolto_Payment_Document_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Payment_Document_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Payment_Document_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Payment_Document_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Payment_Document_Inc_Input>;
  _prepend?: Maybe<Risolto_Payment_Document_Prepend_Input>;
  _set?: Maybe<Risolto_Payment_Document_Set_Input>;
  pk_columns: Risolto_Payment_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Document_ManyArgs = {
  updates: Array<Risolto_Payment_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_LinkArgs = {
  _append?: Maybe<Risolto_Payment_Link_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Payment_Link_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Payment_Link_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Payment_Link_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Payment_Link_Prepend_Input>;
  _set?: Maybe<Risolto_Payment_Link_Set_Input>;
  where: Risolto_Payment_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Link_By_PkArgs = {
  _append?: Maybe<Risolto_Payment_Link_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Payment_Link_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Payment_Link_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Payment_Link_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Payment_Link_Prepend_Input>;
  _set?: Maybe<Risolto_Payment_Link_Set_Input>;
  pk_columns: Risolto_Payment_Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Link_ManyArgs = {
  updates: Array<Risolto_Payment_Link_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_ManyArgs = {
  updates: Array<Risolto_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_PlanArgs = {
  _append?: Maybe<Risolto_Payment_Plan_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Payment_Plan_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Payment_Plan_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Payment_Plan_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Payment_Plan_Inc_Input>;
  _prepend?: Maybe<Risolto_Payment_Plan_Prepend_Input>;
  _set?: Maybe<Risolto_Payment_Plan_Set_Input>;
  where: Risolto_Payment_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Plan_By_PkArgs = {
  _append?: Maybe<Risolto_Payment_Plan_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Payment_Plan_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Payment_Plan_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Payment_Plan_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Payment_Plan_Inc_Input>;
  _prepend?: Maybe<Risolto_Payment_Plan_Prepend_Input>;
  _set?: Maybe<Risolto_Payment_Plan_Set_Input>;
  pk_columns: Risolto_Payment_Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Plan_ManyArgs = {
  updates: Array<Risolto_Payment_Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_PromiseArgs = {
  _inc?: Maybe<Risolto_Payment_Promise_Inc_Input>;
  _set?: Maybe<Risolto_Payment_Promise_Set_Input>;
  where: Risolto_Payment_Promise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Promise_By_PkArgs = {
  _inc?: Maybe<Risolto_Payment_Promise_Inc_Input>;
  _set?: Maybe<Risolto_Payment_Promise_Set_Input>;
  pk_columns: Risolto_Payment_Promise_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Promise_ManyArgs = {
  updates: Array<Risolto_Payment_Promise_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_TransferArgs = {
  _set?: Maybe<Risolto_Payment_Transfer_Set_Input>;
  where: Risolto_Payment_Transfer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Bulk_PaymentArgs = {
  _set?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Set_Input>;
  where: Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Bulk_Payment_By_PkArgs = {
  _set?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Set_Input>;
  pk_columns: Risolto_Payment_Transfer_Bulk_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Bulk_Payment_ManyArgs = {
  updates: Array<Risolto_Payment_Transfer_Bulk_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_By_PkArgs = {
  _set?: Maybe<Risolto_Payment_Transfer_Set_Input>;
  pk_columns: Risolto_Payment_Transfer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_LineArgs = {
  _inc?: Maybe<Risolto_Payment_Transfer_Line_Inc_Input>;
  _set?: Maybe<Risolto_Payment_Transfer_Line_Set_Input>;
  where: Risolto_Payment_Transfer_Line_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Line_By_PkArgs = {
  _inc?: Maybe<Risolto_Payment_Transfer_Line_Inc_Input>;
  _set?: Maybe<Risolto_Payment_Transfer_Line_Set_Input>;
  pk_columns: Risolto_Payment_Transfer_Line_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Line_ManyArgs = {
  updates: Array<Risolto_Payment_Transfer_Line_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Line_TypeArgs = {
  _set?: Maybe<Risolto_Payment_Transfer_Line_Type_Set_Input>;
  where: Risolto_Payment_Transfer_Line_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Line_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Payment_Transfer_Line_Type_Set_Input>;
  pk_columns: Risolto_Payment_Transfer_Line_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Line_Type_ManyArgs = {
  updates: Array<Risolto_Payment_Transfer_Line_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_ManyArgs = {
  updates: Array<Risolto_Payment_Transfer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_StatusArgs = {
  _set?: Maybe<Risolto_Payment_Transfer_Status_Set_Input>;
  where: Risolto_Payment_Transfer_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Payment_Transfer_Status_Set_Input>;
  pk_columns: Risolto_Payment_Transfer_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Payment_Transfer_Status_ManyArgs = {
  updates: Array<Risolto_Payment_Transfer_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_PersonArgs = {
  _set?: Maybe<Risolto_Person_Set_Input>;
  where: Risolto_Person_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Person_By_PkArgs = {
  _set?: Maybe<Risolto_Person_Set_Input>;
  pk_columns: Risolto_Person_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Person_ManyArgs = {
  updates: Array<Risolto_Person_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_License_ModuleArgs = {
  _set?: Maybe<Risolto_Platform_License_Module_Set_Input>;
  where: Risolto_Platform_License_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_License_Module_By_PkArgs = {
  _set?: Maybe<Risolto_Platform_License_Module_Set_Input>;
  pk_columns: Risolto_Platform_License_Module_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_License_Module_ManyArgs = {
  updates: Array<Risolto_Platform_License_Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Participant_LicenseArgs = {
  _set?: Maybe<Risolto_Platform_Participant_License_Set_Input>;
  where: Risolto_Platform_Participant_License_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Participant_License_By_PkArgs = {
  _set?: Maybe<Risolto_Platform_Participant_License_Set_Input>;
  pk_columns: Risolto_Platform_Participant_License_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Participant_License_ManyArgs = {
  updates: Array<Risolto_Platform_Participant_License_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_PermissionArgs = {
  _set?: Maybe<Risolto_Platform_Permission_Set_Input>;
  where: Risolto_Platform_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Permission_By_PkArgs = {
  _set?: Maybe<Risolto_Platform_Permission_Set_Input>;
  pk_columns: Risolto_Platform_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Permission_ManyArgs = {
  updates: Array<Risolto_Platform_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_RoleArgs = {
  _set?: Maybe<Risolto_Platform_Role_Set_Input>;
  where: Risolto_Platform_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Role_By_PkArgs = {
  _set?: Maybe<Risolto_Platform_Role_Set_Input>;
  pk_columns: Risolto_Platform_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Role_ManyArgs = {
  updates: Array<Risolto_Platform_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Role_PermissionArgs = {
  _set?: Maybe<Risolto_Platform_Role_Permission_Set_Input>;
  where: Risolto_Platform_Role_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Role_Permission_By_PkArgs = {
  _set?: Maybe<Risolto_Platform_Role_Permission_Set_Input>;
  pk_columns: Risolto_Platform_Role_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Role_Permission_ManyArgs = {
  updates: Array<Risolto_Platform_Role_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_UsageArgs = {
  _set?: Maybe<Risolto_Platform_Usage_Set_Input>;
  where: Risolto_Platform_Usage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Usage_By_PkArgs = {
  _set?: Maybe<Risolto_Platform_Usage_Set_Input>;
  pk_columns: Risolto_Platform_Usage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Platform_Usage_ManyArgs = {
  updates: Array<Risolto_Platform_Usage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_RecipientArgs = {
  _append?: Maybe<Risolto_Recipient_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Recipient_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Recipient_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Recipient_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Recipient_Prepend_Input>;
  _set?: Maybe<Risolto_Recipient_Set_Input>;
  where: Risolto_Recipient_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_AddressArgs = {
  _append?: Maybe<Risolto_Recipient_Address_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Recipient_Address_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Recipient_Address_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Recipient_Address_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Recipient_Address_Prepend_Input>;
  _set?: Maybe<Risolto_Recipient_Address_Set_Input>;
  where: Risolto_Recipient_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Address_ManyArgs = {
  updates: Array<Risolto_Recipient_Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_AttachmentArgs = {
  _append?: Maybe<Risolto_Recipient_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Recipient_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Recipient_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Recipient_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Recipient_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Recipient_Attachment_Set_Input>;
  where: Risolto_Recipient_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Attachment_By_PkArgs = {
  _append?: Maybe<Risolto_Recipient_Attachment_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Recipient_Attachment_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Recipient_Attachment_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Recipient_Attachment_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Recipient_Attachment_Prepend_Input>;
  _set?: Maybe<Risolto_Recipient_Attachment_Set_Input>;
  pk_columns: Risolto_Recipient_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Attachment_ManyArgs = {
  updates: Array<Risolto_Recipient_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_By_PkArgs = {
  _append?: Maybe<Risolto_Recipient_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Recipient_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Recipient_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Recipient_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Recipient_Prepend_Input>;
  _set?: Maybe<Risolto_Recipient_Set_Input>;
  pk_columns: Risolto_Recipient_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_CollectionArgs = {
  _append?: Maybe<Risolto_Recipient_Collection_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Recipient_Collection_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Recipient_Collection_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Recipient_Collection_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Recipient_Collection_Prepend_Input>;
  _set?: Maybe<Risolto_Recipient_Collection_Set_Input>;
  where: Risolto_Recipient_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Collection_By_PkArgs = {
  _append?: Maybe<Risolto_Recipient_Collection_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Recipient_Collection_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Recipient_Collection_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Recipient_Collection_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Recipient_Collection_Prepend_Input>;
  _set?: Maybe<Risolto_Recipient_Collection_Set_Input>;
  pk_columns: Risolto_Recipient_Collection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Collection_ManyArgs = {
  updates: Array<Risolto_Recipient_Collection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_CommunicationArgs = {
  _set?: Maybe<Risolto_Recipient_Communication_Set_Input>;
  where: Risolto_Recipient_Communication_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Communication_By_PkArgs = {
  _set?: Maybe<Risolto_Recipient_Communication_Set_Input>;
  pk_columns: Risolto_Recipient_Communication_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Communication_ManyArgs = {
  updates: Array<Risolto_Recipient_Communication_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Dunning_ExcludeArgs = {
  _set?: Maybe<Risolto_Recipient_Dunning_Exclude_Set_Input>;
  where: Risolto_Recipient_Dunning_Exclude_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Dunning_Exclude_By_PkArgs = {
  _set?: Maybe<Risolto_Recipient_Dunning_Exclude_Set_Input>;
  pk_columns: Risolto_Recipient_Dunning_Exclude_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Dunning_Exclude_ManyArgs = {
  updates: Array<Risolto_Recipient_Dunning_Exclude_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Dunning_RunArgs = {
  _set?: Maybe<Risolto_Recipient_Dunning_Run_Set_Input>;
  where: Risolto_Recipient_Dunning_Run_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Dunning_Run_By_PkArgs = {
  _set?: Maybe<Risolto_Recipient_Dunning_Run_Set_Input>;
  pk_columns: Risolto_Recipient_Dunning_Run_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Dunning_Run_ManyArgs = {
  updates: Array<Risolto_Recipient_Dunning_Run_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_ManyArgs = {
  updates: Array<Risolto_Recipient_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_MergeArgs = {
  _set?: Maybe<Risolto_Recipient_Merge_Set_Input>;
  where: Risolto_Recipient_Merge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Merge_By_PkArgs = {
  _set?: Maybe<Risolto_Recipient_Merge_Set_Input>;
  pk_columns: Risolto_Recipient_Merge_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Merge_ManyArgs = {
  updates: Array<Risolto_Recipient_Merge_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_TagArgs = {
  _set?: Maybe<Risolto_Recipient_Tag_Set_Input>;
  where: Risolto_Recipient_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Tag_By_PkArgs = {
  _set?: Maybe<Risolto_Recipient_Tag_Set_Input>;
  pk_columns: Risolto_Recipient_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_Tag_ManyArgs = {
  updates: Array<Risolto_Recipient_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_UserArgs = {
  _set?: Maybe<Risolto_Recipient_User_Set_Input>;
  where: Risolto_Recipient_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_User_By_PkArgs = {
  _set?: Maybe<Risolto_Recipient_User_Set_Input>;
  pk_columns: Risolto_Recipient_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Recipient_User_ManyArgs = {
  updates: Array<Risolto_Recipient_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Reference_DataArgs = {
  _append?: Maybe<Risolto_Reference_Data_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Reference_Data_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Reference_Data_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Reference_Data_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Reference_Data_Prepend_Input>;
  _set?: Maybe<Risolto_Reference_Data_Set_Input>;
  where: Risolto_Reference_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Reference_Data_By_PkArgs = {
  _append?: Maybe<Risolto_Reference_Data_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Reference_Data_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Reference_Data_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Reference_Data_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Reference_Data_Prepend_Input>;
  _set?: Maybe<Risolto_Reference_Data_Set_Input>;
  pk_columns: Risolto_Reference_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Reference_Data_ManyArgs = {
  updates: Array<Risolto_Reference_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_DefinitionArgs = {
  _append?: Maybe<Risolto_Report_Definition_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Report_Definition_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Report_Definition_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Report_Definition_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Report_Definition_Prepend_Input>;
  _set?: Maybe<Risolto_Report_Definition_Set_Input>;
  where: Risolto_Report_Definition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Definition_By_PkArgs = {
  _append?: Maybe<Risolto_Report_Definition_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Report_Definition_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Report_Definition_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Report_Definition_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Report_Definition_Prepend_Input>;
  _set?: Maybe<Risolto_Report_Definition_Set_Input>;
  pk_columns: Risolto_Report_Definition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Definition_ManyArgs = {
  updates: Array<Risolto_Report_Definition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_ExecutionArgs = {
  _set?: Maybe<Risolto_Report_Execution_Set_Input>;
  where: Risolto_Report_Execution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Execution_By_PkArgs = {
  _set?: Maybe<Risolto_Report_Execution_Set_Input>;
  pk_columns: Risolto_Report_Execution_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Execution_ManyArgs = {
  updates: Array<Risolto_Report_Execution_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Execution_UserArgs = {
  _set?: Maybe<Risolto_Report_Execution_User_Set_Input>;
  where: Risolto_Report_Execution_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Execution_User_By_PkArgs = {
  _set?: Maybe<Risolto_Report_Execution_User_Set_Input>;
  pk_columns: Risolto_Report_Execution_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Execution_User_ManyArgs = {
  updates: Array<Risolto_Report_Execution_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Template_TypeArgs = {
  _set?: Maybe<Risolto_Report_Template_Type_Set_Input>;
  where: Risolto_Report_Template_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Template_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Report_Template_Type_Set_Input>;
  pk_columns: Risolto_Report_Template_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Template_Type_ManyArgs = {
  updates: Array<Risolto_Report_Template_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_TypeArgs = {
  _set?: Maybe<Risolto_Report_Type_Set_Input>;
  where: Risolto_Report_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Report_Type_Set_Input>;
  pk_columns: Risolto_Report_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_Type_ManyArgs = {
  updates: Array<Risolto_Report_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_UserArgs = {
  _set?: Maybe<Risolto_Report_User_Set_Input>;
  where: Risolto_Report_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_User_By_PkArgs = {
  _set?: Maybe<Risolto_Report_User_Set_Input>;
  pk_columns: Risolto_Report_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Report_User_ManyArgs = {
  updates: Array<Risolto_Report_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Run_Processing_StatusArgs = {
  _set?: Maybe<Risolto_Run_Processing_Status_Set_Input>;
  where: Risolto_Run_Processing_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Run_Processing_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Run_Processing_Status_Set_Input>;
  pk_columns: Risolto_Run_Processing_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Run_Processing_Status_ManyArgs = {
  updates: Array<Risolto_Run_Processing_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Single_Sign_OnArgs = {
  _append?: Maybe<Risolto_Single_Sign_On_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Single_Sign_On_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Single_Sign_On_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Single_Sign_On_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Single_Sign_On_Prepend_Input>;
  _set?: Maybe<Risolto_Single_Sign_On_Set_Input>;
  where: Risolto_Single_Sign_On_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Single_Sign_On_By_PkArgs = {
  _append?: Maybe<Risolto_Single_Sign_On_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Single_Sign_On_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Single_Sign_On_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Single_Sign_On_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Single_Sign_On_Prepend_Input>;
  _set?: Maybe<Risolto_Single_Sign_On_Set_Input>;
  pk_columns: Risolto_Single_Sign_On_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Single_Sign_On_ManyArgs = {
  updates: Array<Risolto_Single_Sign_On_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_StatementArgs = {
  _set?: Maybe<Risolto_Statement_Set_Input>;
  where: Risolto_Statement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_AccountArgs = {
  _append?: Maybe<Risolto_Statement_Account_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Statement_Account_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Statement_Account_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Statement_Account_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Statement_Account_Inc_Input>;
  _prepend?: Maybe<Risolto_Statement_Account_Prepend_Input>;
  _set?: Maybe<Risolto_Statement_Account_Set_Input>;
  where: Risolto_Statement_Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Account_By_PkArgs = {
  _append?: Maybe<Risolto_Statement_Account_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Statement_Account_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Statement_Account_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Statement_Account_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Statement_Account_Inc_Input>;
  _prepend?: Maybe<Risolto_Statement_Account_Prepend_Input>;
  _set?: Maybe<Risolto_Statement_Account_Set_Input>;
  pk_columns: Risolto_Statement_Account_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Account_ManyArgs = {
  updates: Array<Risolto_Statement_Account_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_By_PkArgs = {
  _set?: Maybe<Risolto_Statement_Set_Input>;
  pk_columns: Risolto_Statement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_LineArgs = {
  _append?: Maybe<Risolto_Statement_Line_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Statement_Line_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Statement_Line_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Statement_Line_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Statement_Line_Inc_Input>;
  _prepend?: Maybe<Risolto_Statement_Line_Prepend_Input>;
  _set?: Maybe<Risolto_Statement_Line_Set_Input>;
  where: Risolto_Statement_Line_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_By_PkArgs = {
  _append?: Maybe<Risolto_Statement_Line_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Statement_Line_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Statement_Line_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Statement_Line_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Statement_Line_Inc_Input>;
  _prepend?: Maybe<Risolto_Statement_Line_Prepend_Input>;
  _set?: Maybe<Risolto_Statement_Line_Set_Input>;
  pk_columns: Risolto_Statement_Line_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Dunning_NoticeArgs = {
  _inc?: Maybe<Risolto_Statement_Line_Dunning_Notice_Inc_Input>;
  _set?: Maybe<Risolto_Statement_Line_Dunning_Notice_Set_Input>;
  where: Risolto_Statement_Line_Dunning_Notice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Dunning_Notice_By_PkArgs = {
  _inc?: Maybe<Risolto_Statement_Line_Dunning_Notice_Inc_Input>;
  _set?: Maybe<Risolto_Statement_Line_Dunning_Notice_Set_Input>;
  pk_columns: Risolto_Statement_Line_Dunning_Notice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Dunning_Notice_ManyArgs = {
  updates: Array<Risolto_Statement_Line_Dunning_Notice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_InvoiceArgs = {
  _inc?: Maybe<Risolto_Statement_Line_Invoice_Inc_Input>;
  _set?: Maybe<Risolto_Statement_Line_Invoice_Set_Input>;
  where: Risolto_Statement_Line_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Invoice_By_PkArgs = {
  _inc?: Maybe<Risolto_Statement_Line_Invoice_Inc_Input>;
  _set?: Maybe<Risolto_Statement_Line_Invoice_Set_Input>;
  pk_columns: Risolto_Statement_Line_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Invoice_ManyArgs = {
  updates: Array<Risolto_Statement_Line_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_ManyArgs = {
  updates: Array<Risolto_Statement_Line_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Payment_PromiseArgs = {
  _inc?: Maybe<Risolto_Statement_Line_Payment_Promise_Inc_Input>;
  _set?: Maybe<Risolto_Statement_Line_Payment_Promise_Set_Input>;
  where: Risolto_Statement_Line_Payment_Promise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Payment_Promise_By_PkArgs = {
  _inc?: Maybe<Risolto_Statement_Line_Payment_Promise_Inc_Input>;
  _set?: Maybe<Risolto_Statement_Line_Payment_Promise_Set_Input>;
  pk_columns: Risolto_Statement_Line_Payment_Promise_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Payment_Promise_ManyArgs = {
  updates: Array<Risolto_Statement_Line_Payment_Promise_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_StatusArgs = {
  _set?: Maybe<Risolto_Statement_Line_Status_Set_Input>;
  where: Risolto_Statement_Line_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Statement_Line_Status_Set_Input>;
  pk_columns: Risolto_Statement_Line_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_Line_Status_ManyArgs = {
  updates: Array<Risolto_Statement_Line_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Statement_ManyArgs = {
  updates: Array<Risolto_Statement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Strigil_NbbArgs = {
  _append?: Maybe<Risolto_Strigil_Nbb_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Strigil_Nbb_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Strigil_Nbb_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Strigil_Nbb_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Strigil_Nbb_Inc_Input>;
  _prepend?: Maybe<Risolto_Strigil_Nbb_Prepend_Input>;
  _set?: Maybe<Risolto_Strigil_Nbb_Set_Input>;
  where: Risolto_Strigil_Nbb_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Strigil_Nbb_By_PkArgs = {
  _append?: Maybe<Risolto_Strigil_Nbb_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Strigil_Nbb_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Strigil_Nbb_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Strigil_Nbb_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Strigil_Nbb_Inc_Input>;
  _prepend?: Maybe<Risolto_Strigil_Nbb_Prepend_Input>;
  _set?: Maybe<Risolto_Strigil_Nbb_Set_Input>;
  pk_columns: Risolto_Strigil_Nbb_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Strigil_Nbb_ManyArgs = {
  updates: Array<Risolto_Strigil_Nbb_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Strigil_Nbb_Processing_StatusArgs = {
  _set?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Set_Input>;
  where: Risolto_Strigil_Nbb_Processing_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Strigil_Nbb_Processing_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Set_Input>;
  pk_columns: Risolto_Strigil_Nbb_Processing_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Strigil_Nbb_Processing_Status_ManyArgs = {
  updates: Array<Risolto_Strigil_Nbb_Processing_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_System_IntegrationArgs = {
  _set?: Maybe<Risolto_System_Integration_Set_Input>;
  where: Risolto_System_Integration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_System_Integration_By_PkArgs = {
  _set?: Maybe<Risolto_System_Integration_Set_Input>;
  pk_columns: Risolto_System_Integration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_System_Integration_ManyArgs = {
  updates: Array<Risolto_System_Integration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_TagArgs = {
  _set?: Maybe<Risolto_Tag_Set_Input>;
  where: Risolto_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Tag_By_PkArgs = {
  _set?: Maybe<Risolto_Tag_Set_Input>;
  pk_columns: Risolto_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Tag_ManyArgs = {
  updates: Array<Risolto_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_TaskArgs = {
  _set?: Maybe<Risolto_Task_Set_Input>;
  where: Risolto_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_By_PkArgs = {
  _set?: Maybe<Risolto_Task_Set_Input>;
  pk_columns: Risolto_Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_ManyArgs = {
  updates: Array<Risolto_Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_SourceArgs = {
  _set?: Maybe<Risolto_Task_Source_Set_Input>;
  where: Risolto_Task_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_Source_By_PkArgs = {
  _set?: Maybe<Risolto_Task_Source_Set_Input>;
  pk_columns: Risolto_Task_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_Source_ManyArgs = {
  updates: Array<Risolto_Task_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_StatusArgs = {
  _set?: Maybe<Risolto_Task_Status_Set_Input>;
  where: Risolto_Task_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Task_Status_Set_Input>;
  pk_columns: Risolto_Task_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_Status_ManyArgs = {
  updates: Array<Risolto_Task_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_TypeArgs = {
  _set?: Maybe<Risolto_Task_Type_Set_Input>;
  where: Risolto_Task_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_Type_By_PkArgs = {
  _set?: Maybe<Risolto_Task_Type_Set_Input>;
  pk_columns: Risolto_Task_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Task_Type_ManyArgs = {
  updates: Array<Risolto_Task_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Tone_Of_VoiceArgs = {
  _set?: Maybe<Risolto_Tone_Of_Voice_Set_Input>;
  where: Risolto_Tone_Of_Voice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Tone_Of_Voice_By_PkArgs = {
  _set?: Maybe<Risolto_Tone_Of_Voice_Set_Input>;
  pk_columns: Risolto_Tone_Of_Voice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Tone_Of_Voice_ManyArgs = {
  updates: Array<Risolto_Tone_Of_Voice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_And_NoteArgs = {
  _append?: Maybe<Risolto_Virtual_Action_And_Note_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Action_And_Note_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Action_And_Note_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Action_And_Note_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Virtual_Action_And_Note_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Action_And_Note_Set_Input>;
  where: Risolto_Virtual_Action_And_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_And_Note_And_DisputeArgs = {
  _append?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Set_Input>;
  where: Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_And_Note_And_Dispute_And_MessageArgs = {
  _append?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Set_Input>;
  where: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_ManyArgs = {
  updates: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_And_Note_And_Dispute_By_PkArgs = {
  _append?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Set_Input>;
  pk_columns: Risolto_Virtual_Action_And_Note_And_Dispute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_And_Note_And_Dispute_ManyArgs = {
  updates: Array<Risolto_Virtual_Action_And_Note_And_Dispute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_And_Note_By_PkArgs = {
  _append?: Maybe<Risolto_Virtual_Action_And_Note_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Action_And_Note_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Action_And_Note_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Action_And_Note_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Virtual_Action_And_Note_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Action_And_Note_Set_Input>;
  pk_columns: Risolto_Virtual_Action_And_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_And_Note_ManyArgs = {
  updates: Array<Risolto_Virtual_Action_And_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_GroupArgs = {
  _inc?: Maybe<Risolto_Virtual_Action_Group_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Action_Group_Set_Input>;
  where: Risolto_Virtual_Action_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_Group_By_PkArgs = {
  _inc?: Maybe<Risolto_Virtual_Action_Group_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Action_Group_Set_Input>;
  pk_columns: Risolto_Virtual_Action_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Action_Group_ManyArgs = {
  updates: Array<Risolto_Virtual_Action_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dashboard_Action_StatsArgs = {
  _inc?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Set_Input>;
  where: Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dashboard_Action_Stats_By_PkArgs = {
  _inc?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Set_Input>;
  pk_columns: Risolto_Virtual_Dashboard_Action_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dashboard_Action_Stats_ManyArgs = {
  updates: Array<Risolto_Virtual_Dashboard_Action_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dashboard_Outstanding_DebtArgs = {
  _inc?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Set_Input>;
  where: Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dashboard_Outstanding_Debt_By_PkArgs = {
  _inc?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Set_Input>;
  pk_columns: Risolto_Virtual_Dashboard_Outstanding_Debt_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dashboard_Outstanding_Debt_ManyArgs = {
  updates: Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Demo_Action_Report_1Args = {
  _inc?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Set_Input>;
  where: Risolto_Virtual_Demo_Action_Report_1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Demo_Action_Report_1_By_PkArgs = {
  _inc?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Set_Input>;
  pk_columns: Risolto_Virtual_Demo_Action_Report_1_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Demo_Action_Report_1_ManyArgs = {
  updates: Array<Risolto_Virtual_Demo_Action_Report_1_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dunning_ActionArgs = {
  _set?: Maybe<Risolto_Virtual_Dunning_Action_Set_Input>;
  where: Risolto_Virtual_Dunning_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dunning_Action_By_PkArgs = {
  _set?: Maybe<Risolto_Virtual_Dunning_Action_Set_Input>;
  pk_columns: Risolto_Virtual_Dunning_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Dunning_Action_ManyArgs = {
  updates: Array<Risolto_Virtual_Dunning_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Interchange_EventArgs = {
  _append?: Maybe<Risolto_Virtual_Interchange_Event_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Interchange_Event_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Interchange_Event_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Interchange_Event_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Virtual_Interchange_Event_Inc_Input>;
  _prepend?: Maybe<Risolto_Virtual_Interchange_Event_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Interchange_Event_Set_Input>;
  where: Risolto_Virtual_Interchange_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Interchange_Event_By_PkArgs = {
  _append?: Maybe<Risolto_Virtual_Interchange_Event_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Interchange_Event_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Interchange_Event_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Interchange_Event_Delete_Key_Input>;
  _inc?: Maybe<Risolto_Virtual_Interchange_Event_Inc_Input>;
  _prepend?: Maybe<Risolto_Virtual_Interchange_Event_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Interchange_Event_Set_Input>;
  pk_columns: Risolto_Virtual_Interchange_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Interchange_Event_ManyArgs = {
  updates: Array<Risolto_Virtual_Interchange_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Invoice_Derived_Payment_InformationArgs = {
  _inc?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Set_Input>;
  where: Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Invoice_Derived_Payment_Information_By_PkArgs = {
  _inc?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Set_Input>;
  pk_columns: Risolto_Virtual_Invoice_Derived_Payment_Information_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Invoice_Derived_Payment_Information_ManyArgs = {
  updates: Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Invoicing_Channel_EndpointArgs = {
  _set?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Set_Input>;
  where: Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Invoicing_Channel_Endpoint_By_PkArgs = {
  _set?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Set_Input>;
  pk_columns: Risolto_Virtual_Invoicing_Channel_Endpoint_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Invoicing_Channel_Endpoint_ManyArgs = {
  updates: Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_JsonArgs = {
  _append?: Maybe<Risolto_Virtual_Json_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Json_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Json_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Json_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Virtual_Json_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Json_Set_Input>;
  where: Risolto_Virtual_Json_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Json_By_PkArgs = {
  _append?: Maybe<Risolto_Virtual_Json_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Virtual_Json_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Virtual_Json_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Virtual_Json_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Virtual_Json_Prepend_Input>;
  _set?: Maybe<Risolto_Virtual_Json_Set_Input>;
  pk_columns: Risolto_Virtual_Json_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Json_ManyArgs = {
  updates: Array<Risolto_Virtual_Json_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Report_DeliveryArgs = {
  _inc?: Maybe<Risolto_Virtual_Report_Delivery_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Report_Delivery_Set_Input>;
  where: Risolto_Virtual_Report_Delivery_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Report_Delivery_By_PkArgs = {
  _inc?: Maybe<Risolto_Virtual_Report_Delivery_Inc_Input>;
  _set?: Maybe<Risolto_Virtual_Report_Delivery_Set_Input>;
  pk_columns: Risolto_Virtual_Report_Delivery_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Virtual_Report_Delivery_ManyArgs = {
  updates: Array<Risolto_Virtual_Report_Delivery_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_WebhookArgs = {
  _append?: Maybe<Risolto_Webhook_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Webhook_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Webhook_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Webhook_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Webhook_Prepend_Input>;
  _set?: Maybe<Risolto_Webhook_Set_Input>;
  where: Risolto_Webhook_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Webhook_By_PkArgs = {
  _append?: Maybe<Risolto_Webhook_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Webhook_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Webhook_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Webhook_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Webhook_Prepend_Input>;
  _set?: Maybe<Risolto_Webhook_Set_Input>;
  pk_columns: Risolto_Webhook_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Webhook_ManyArgs = {
  updates: Array<Risolto_Webhook_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Webhook_Processing_StatusArgs = {
  _set?: Maybe<Risolto_Webhook_Processing_Status_Set_Input>;
  where: Risolto_Webhook_Processing_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Webhook_Processing_Status_By_PkArgs = {
  _set?: Maybe<Risolto_Webhook_Processing_Status_Set_Input>;
  pk_columns: Risolto_Webhook_Processing_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Webhook_Processing_Status_ManyArgs = {
  updates: Array<Risolto_Webhook_Processing_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Webhook_SubscriptionArgs = {
  _append?: Maybe<Risolto_Webhook_Subscription_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Webhook_Subscription_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Webhook_Subscription_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Webhook_Subscription_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Webhook_Subscription_Prepend_Input>;
  _set?: Maybe<Risolto_Webhook_Subscription_Set_Input>;
  where: Risolto_Webhook_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Webhook_Subscription_By_PkArgs = {
  _append?: Maybe<Risolto_Webhook_Subscription_Append_Input>;
  _delete_at_path?: Maybe<Risolto_Webhook_Subscription_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Risolto_Webhook_Subscription_Delete_Elem_Input>;
  _delete_key?: Maybe<Risolto_Webhook_Subscription_Delete_Key_Input>;
  _prepend?: Maybe<Risolto_Webhook_Subscription_Prepend_Input>;
  _set?: Maybe<Risolto_Webhook_Subscription_Set_Input>;
  pk_columns: Risolto_Webhook_Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risolto_Webhook_Subscription_ManyArgs = {
  updates: Array<Risolto_Webhook_Subscription_Updates>;
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "risolto.account_number_type" */
  risolto_account_number_type: Array<Risolto_Account_Number_Type>;
  /** fetch aggregated fields from the table: "risolto.account_number_type" */
  risolto_account_number_type_aggregate: Risolto_Account_Number_Type_Aggregate;
  /** fetch data from the table: "risolto.account_number_type" using primary key columns */
  risolto_account_number_type_by_pk?: Maybe<Risolto_Account_Number_Type>;
  /** fetch data from the table: "risolto.accounting_document" */
  risolto_accounting_document: Array<Risolto_Accounting_Document>;
  /** fetch aggregated fields from the table: "risolto.accounting_document" */
  risolto_accounting_document_aggregate: Risolto_Accounting_Document_Aggregate;
  /** fetch data from the table: "risolto.action" */
  risolto_action: Array<Risolto_Action>;
  /** fetch aggregated fields from the table: "risolto.action" */
  risolto_action_aggregate: Risolto_Action_Aggregate;
  /** fetch data from the table: "risolto.action" using primary key columns */
  risolto_action_by_pk?: Maybe<Risolto_Action>;
  /** fetch data from the table: "risolto.action_execution_type" */
  risolto_action_execution_type: Array<Risolto_Action_Execution_Type>;
  /** fetch aggregated fields from the table: "risolto.action_execution_type" */
  risolto_action_execution_type_aggregate: Risolto_Action_Execution_Type_Aggregate;
  /** fetch data from the table: "risolto.action_execution_type" using primary key columns */
  risolto_action_execution_type_by_pk?: Maybe<Risolto_Action_Execution_Type>;
  /** execute function "risolto.action_group_v10" which returns "risolto.virtual_action_group" */
  risolto_action_group_v10: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v10" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v10_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v11" which returns "risolto.virtual_action_group" */
  risolto_action_group_v11: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v11" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v11_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v12" which returns "risolto.virtual_action_group" */
  risolto_action_group_v12: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v12" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v12_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v2" which returns "risolto.virtual_action_group" */
  risolto_action_group_v2: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v2" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v2_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v5" which returns "risolto.virtual_action_group" */
  risolto_action_group_v5: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v5" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v5_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v6" which returns "risolto.virtual_action_group" */
  risolto_action_group_v6: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v6" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v6_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v7" which returns "risolto.virtual_action_group" */
  risolto_action_group_v7: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v7" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v7_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v8" which returns "risolto.virtual_action_group" */
  risolto_action_group_v8: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v8" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v8_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v9" which returns "risolto.virtual_action_group" */
  risolto_action_group_v9: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v9" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v9_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** fetch data from the table: "risolto.action_interchange" */
  risolto_action_interchange: Array<Risolto_Action_Interchange>;
  /** fetch aggregated fields from the table: "risolto.action_interchange" */
  risolto_action_interchange_aggregate: Risolto_Action_Interchange_Aggregate;
  /** fetch data from the table: "risolto.action_interchange" using primary key columns */
  risolto_action_interchange_by_pk?: Maybe<Risolto_Action_Interchange>;
  /** fetch data from the table: "risolto.action_invoice" */
  risolto_action_invoice: Array<Risolto_Action_Invoice>;
  /** fetch aggregated fields from the table: "risolto.action_invoice" */
  risolto_action_invoice_aggregate: Risolto_Action_Invoice_Aggregate;
  /** fetch data from the table: "risolto.action_invoice" using primary key columns */
  risolto_action_invoice_by_pk?: Maybe<Risolto_Action_Invoice>;
  /** fetch data from the table: "risolto.action_source" */
  risolto_action_source: Array<Risolto_Action_Source>;
  /** fetch aggregated fields from the table: "risolto.action_source" */
  risolto_action_source_aggregate: Risolto_Action_Source_Aggregate;
  /** fetch data from the table: "risolto.action_source" using primary key columns */
  risolto_action_source_by_pk?: Maybe<Risolto_Action_Source>;
  /** fetch data from the table: "risolto.action_status" */
  risolto_action_status: Array<Risolto_Action_Status>;
  /** fetch aggregated fields from the table: "risolto.action_status" */
  risolto_action_status_aggregate: Risolto_Action_Status_Aggregate;
  /** fetch data from the table: "risolto.action_status" using primary key columns */
  risolto_action_status_by_pk?: Maybe<Risolto_Action_Status>;
  /** fetch data from the table: "risolto.analytics_company_score" */
  risolto_analytics_company_score: Array<Risolto_Analytics_Company_Score>;
  /** fetch aggregated fields from the table: "risolto.analytics_company_score" */
  risolto_analytics_company_score_aggregate: Risolto_Analytics_Company_Score_Aggregate;
  /** fetch data from the table: "risolto.analytics_company_score" using primary key columns */
  risolto_analytics_company_score_by_pk?: Maybe<Risolto_Analytics_Company_Score>;
  /** fetch data from the table: "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features: Array<Risolto_Analytics_Invoice_Features>;
  /** fetch aggregated fields from the table: "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features_aggregate: Risolto_Analytics_Invoice_Features_Aggregate;
  /** execute function "risolto.analytics_invoice_features_by_date" which returns "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features_by_date: Array<Risolto_Analytics_Invoice_Features>;
  /** execute function "risolto.analytics_invoice_features_by_date" and query aggregates on result of table type "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features_by_date_aggregate: Risolto_Analytics_Invoice_Features_Aggregate;
  /** fetch data from the table: "risolto.analytics_invoice_features" using primary key columns */
  risolto_analytics_invoice_features_by_pk?: Maybe<Risolto_Analytics_Invoice_Features>;
  /** fetch data from the table: "risolto.analytics_invoice_prediction" */
  risolto_analytics_invoice_prediction: Array<Risolto_Analytics_Invoice_Prediction>;
  /** fetch aggregated fields from the table: "risolto.analytics_invoice_prediction" */
  risolto_analytics_invoice_prediction_aggregate: Risolto_Analytics_Invoice_Prediction_Aggregate;
  /** fetch data from the table: "risolto.analytics_invoice_prediction" using primary key columns */
  risolto_analytics_invoice_prediction_by_pk?: Maybe<Risolto_Analytics_Invoice_Prediction>;
  /** fetch data from the table: "risolto.analytics_test" */
  risolto_analytics_test: Array<Risolto_Analytics_Test>;
  /** fetch aggregated fields from the table: "risolto.analytics_test" */
  risolto_analytics_test_aggregate: Risolto_Analytics_Test_Aggregate;
  /** fetch data from the table: "risolto.analytics_test" using primary key columns */
  risolto_analytics_test_by_pk?: Maybe<Risolto_Analytics_Test>;
  /** fetch data from the table: "risolto.analytics_test_result" */
  risolto_analytics_test_result: Array<Risolto_Analytics_Test_Result>;
  /** fetch aggregated fields from the table: "risolto.analytics_test_result" */
  risolto_analytics_test_result_aggregate: Risolto_Analytics_Test_Result_Aggregate;
  /** fetch data from the table: "risolto.analytics_test_result" using primary key columns */
  risolto_analytics_test_result_by_pk?: Maybe<Risolto_Analytics_Test_Result>;
  /** fetch data from the table: "risolto.api_accounting_document" */
  risolto_api_accounting_document: Array<Risolto_Api_Accounting_Document>;
  /** fetch aggregated fields from the table: "risolto.api_accounting_document" */
  risolto_api_accounting_document_aggregate: Risolto_Api_Accounting_Document_Aggregate;
  /** fetch data from the table: "risolto.api_app_client" */
  risolto_api_app_client: Array<Risolto_Api_App_Client>;
  /** fetch aggregated fields from the table: "risolto.api_app_client" */
  risolto_api_app_client_aggregate: Risolto_Api_App_Client_Aggregate;
  /** fetch data from the table: "risolto.api_app_client" using primary key columns */
  risolto_api_app_client_by_pk?: Maybe<Risolto_Api_App_Client>;
  /** fetch data from the table: "risolto.api_payment_plan" */
  risolto_api_payment_plan: Array<Risolto_Api_Payment_Plan>;
  /** fetch aggregated fields from the table: "risolto.api_payment_plan" */
  risolto_api_payment_plan_aggregate: Risolto_Api_Payment_Plan_Aggregate;
  /** fetch data from the table: "risolto.api_payment_promise" */
  risolto_api_payment_promise: Array<Risolto_Api_Payment_Promise>;
  /** fetch aggregated fields from the table: "risolto.api_payment_promise" */
  risolto_api_payment_promise_aggregate: Risolto_Api_Payment_Promise_Aggregate;
  /** fetch data from the table: "risolto.attachment" */
  risolto_attachment: Array<Risolto_Attachment>;
  /** fetch aggregated fields from the table: "risolto.attachment" */
  risolto_attachment_aggregate: Risolto_Attachment_Aggregate;
  /** fetch data from the table: "risolto.attachment" using primary key columns */
  risolto_attachment_by_pk?: Maybe<Risolto_Attachment>;
  /** fetch data from the table: "risolto.attachment_scheme" */
  risolto_attachment_scheme: Array<Risolto_Attachment_Scheme>;
  /** fetch aggregated fields from the table: "risolto.attachment_scheme" */
  risolto_attachment_scheme_aggregate: Risolto_Attachment_Scheme_Aggregate;
  /** fetch data from the table: "risolto.attachment_scheme" using primary key columns */
  risolto_attachment_scheme_by_pk?: Maybe<Risolto_Attachment_Scheme>;
  /** fetch data from the table: "risolto.bank_account" */
  risolto_bank_account: Array<Risolto_Bank_Account>;
  /** fetch aggregated fields from the table: "risolto.bank_account" */
  risolto_bank_account_aggregate: Risolto_Bank_Account_Aggregate;
  /** fetch data from the table: "risolto.bank_account" using primary key columns */
  risolto_bank_account_by_pk?: Maybe<Risolto_Bank_Account>;
  /** fetch data from the table: "risolto.bank_identifier_type" */
  risolto_bank_identifier_type: Array<Risolto_Bank_Identifier_Type>;
  /** fetch aggregated fields from the table: "risolto.bank_identifier_type" */
  risolto_bank_identifier_type_aggregate: Risolto_Bank_Identifier_Type_Aggregate;
  /** fetch data from the table: "risolto.bank_identifier_type" using primary key columns */
  risolto_bank_identifier_type_by_pk?: Maybe<Risolto_Bank_Identifier_Type>;
  /** fetch data from the table: "risolto.blacklist" */
  risolto_blacklist: Array<Risolto_Blacklist>;
  /** fetch aggregated fields from the table: "risolto.blacklist" */
  risolto_blacklist_aggregate: Risolto_Blacklist_Aggregate;
  /** fetch data from the table: "risolto.blacklist" using primary key columns */
  risolto_blacklist_by_pk?: Maybe<Risolto_Blacklist>;
  /** fetch data from the table: "risolto.channel" */
  risolto_channel: Array<Risolto_Channel>;
  /** fetch aggregated fields from the table: "risolto.channel" */
  risolto_channel_aggregate: Risolto_Channel_Aggregate;
  /** fetch data from the table: "risolto.channel" using primary key columns */
  risolto_channel_by_pk?: Maybe<Risolto_Channel>;
  /** fetch data from the table: "risolto.channel_endpoint" */
  risolto_channel_endpoint: Array<Risolto_Channel_Endpoint>;
  /** fetch aggregated fields from the table: "risolto.channel_endpoint" */
  risolto_channel_endpoint_aggregate: Risolto_Channel_Endpoint_Aggregate;
  /** fetch data from the table: "risolto.channel_endpoint" using primary key columns */
  risolto_channel_endpoint_by_pk?: Maybe<Risolto_Channel_Endpoint>;
  /** execute function "risolto.clid2recid" which returns "risolto.recipient" */
  risolto_clid2recid: Array<Risolto_Recipient>;
  /** execute function "risolto.clid2recid" and query aggregates on result of table type "risolto.recipient" */
  risolto_clid2recid_aggregate: Risolto_Recipient_Aggregate;
  /** execute function "risolto.clip2recid" which returns "risolto.channel_endpoint" */
  risolto_clip2recid: Array<Risolto_Channel_Endpoint>;
  /** execute function "risolto.clip2recid" and query aggregates on result of table type "risolto.channel_endpoint" */
  risolto_clip2recid_aggregate: Risolto_Channel_Endpoint_Aggregate;
  /** fetch data from the table: "risolto.communication" */
  risolto_communication: Array<Risolto_Communication>;
  /** fetch aggregated fields from the table: "risolto.communication" */
  risolto_communication_aggregate: Risolto_Communication_Aggregate;
  /** fetch data from the table: "risolto.communication" using primary key columns */
  risolto_communication_by_pk?: Maybe<Risolto_Communication>;
  /** fetch data from the table: "risolto.communication_template" */
  risolto_communication_template: Array<Risolto_Communication_Template>;
  /** fetch aggregated fields from the table: "risolto.communication_template" */
  risolto_communication_template_aggregate: Risolto_Communication_Template_Aggregate;
  /** fetch data from the table: "risolto.communication_template" using primary key columns */
  risolto_communication_template_by_pk?: Maybe<Risolto_Communication_Template>;
  /** fetch data from the table: "risolto.communication_template_type" */
  risolto_communication_template_type: Array<Risolto_Communication_Template_Type>;
  /** fetch aggregated fields from the table: "risolto.communication_template_type" */
  risolto_communication_template_type_aggregate: Risolto_Communication_Template_Type_Aggregate;
  /** fetch data from the table: "risolto.communication_template_type" using primary key columns */
  risolto_communication_template_type_by_pk?: Maybe<Risolto_Communication_Template_Type>;
  /** fetch data from the table: "risolto.contact" */
  risolto_contact: Array<Risolto_Contact>;
  /** fetch data from the table: "risolto.contact_address" */
  risolto_contact_address: Array<Risolto_Contact_Address>;
  /** fetch aggregated fields from the table: "risolto.contact_address" */
  risolto_contact_address_aggregate: Risolto_Contact_Address_Aggregate;
  /** fetch aggregated fields from the table: "risolto.contact" */
  risolto_contact_aggregate: Risolto_Contact_Aggregate;
  /** fetch data from the table: "risolto.contact" using primary key columns */
  risolto_contact_by_pk?: Maybe<Risolto_Contact>;
  /** fetch data from the table: "risolto.contact_type" */
  risolto_contact_type: Array<Risolto_Contact_Type>;
  /** fetch aggregated fields from the table: "risolto.contact_type" */
  risolto_contact_type_aggregate: Risolto_Contact_Type_Aggregate;
  /** fetch data from the table: "risolto.contact_type" using primary key columns */
  risolto_contact_type_by_pk?: Maybe<Risolto_Contact_Type>;
  /** fetch data from the table: "risolto.content_disposition" */
  risolto_content_disposition: Array<Risolto_Content_Disposition>;
  /** fetch aggregated fields from the table: "risolto.content_disposition" */
  risolto_content_disposition_aggregate: Risolto_Content_Disposition_Aggregate;
  /** fetch data from the table: "risolto.content_disposition" using primary key columns */
  risolto_content_disposition_by_pk?: Maybe<Risolto_Content_Disposition>;
  /** fetch data from the table: "risolto.credit_limit" */
  risolto_credit_limit: Array<Risolto_Credit_Limit>;
  /** fetch aggregated fields from the table: "risolto.credit_limit" */
  risolto_credit_limit_aggregate: Risolto_Credit_Limit_Aggregate;
  /** fetch data from the table: "risolto.credit_limit" using primary key columns */
  risolto_credit_limit_by_pk?: Maybe<Risolto_Credit_Limit>;
  /** fetch data from the table: "risolto.credit_note" */
  risolto_credit_note: Array<Risolto_Credit_Note>;
  /** fetch aggregated fields from the table: "risolto.credit_note" */
  risolto_credit_note_aggregate: Risolto_Credit_Note_Aggregate;
  /** fetch data from the table: "risolto.credit_note_attachment" */
  risolto_credit_note_attachment: Array<Risolto_Credit_Note_Attachment>;
  /** fetch aggregated fields from the table: "risolto.credit_note_attachment" */
  risolto_credit_note_attachment_aggregate: Risolto_Credit_Note_Attachment_Aggregate;
  /** fetch data from the table: "risolto.credit_note_attachment" using primary key columns */
  risolto_credit_note_attachment_by_pk?: Maybe<Risolto_Credit_Note_Attachment>;
  /** fetch data from the table: "risolto.credit_note" using primary key columns */
  risolto_credit_note_by_pk?: Maybe<Risolto_Credit_Note>;
  /** fetch data from the table: "risolto.currency" */
  risolto_currency: Array<Risolto_Currency>;
  /** fetch aggregated fields from the table: "risolto.currency" */
  risolto_currency_aggregate: Risolto_Currency_Aggregate;
  /** fetch data from the table: "risolto.currency" using primary key columns */
  risolto_currency_by_pk?: Maybe<Risolto_Currency>;
  /** execute function "risolto.dashboard_actions_by_channel_and_status_count_v1" which returns "risolto.virtual_dashboard_action_stats" */
  risolto_dashboard_actions_by_channel_and_status_count_v1: Array<Risolto_Virtual_Dashboard_Action_Stats>;
  /** execute function "risolto.dashboard_actions_by_channel_and_status_count_v1" and query aggregates on result of table type "risolto.virtual_dashboard_action_stats" */
  risolto_dashboard_actions_by_channel_and_status_count_v1_aggregate: Risolto_Virtual_Dashboard_Action_Stats_Aggregate;
  /** execute function "risolto.dashboard_outstanding_debt" which returns "risolto.virtual_dashboard_outstanding_debt" */
  risolto_dashboard_outstanding_debt: Array<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** execute function "risolto.dashboard_outstanding_debt" and query aggregates on result of table type "risolto.virtual_dashboard_outstanding_debt" */
  risolto_dashboard_outstanding_debt_aggregate: Risolto_Virtual_Dashboard_Outstanding_Debt_Aggregate;
  /** execute function "risolto.dashboard_totals" which returns "risolto.virtual_json" */
  risolto_dashboard_totals: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.dashboard_totals" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_dashboard_totals_aggregate: Risolto_Virtual_Json_Aggregate;
  /** execute function "risolto.dashboard_totals_v2" which returns "risolto.virtual_json" */
  risolto_dashboard_totals_v2: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.dashboard_totals_v2" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_dashboard_totals_v2_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.debit_note" */
  risolto_debit_note: Array<Risolto_Debit_Note>;
  /** fetch aggregated fields from the table: "risolto.debit_note" */
  risolto_debit_note_aggregate: Risolto_Debit_Note_Aggregate;
  /** fetch data from the table: "risolto.debit_note_attachment" */
  risolto_debit_note_attachment: Array<Risolto_Debit_Note_Attachment>;
  /** fetch aggregated fields from the table: "risolto.debit_note_attachment" */
  risolto_debit_note_attachment_aggregate: Risolto_Debit_Note_Attachment_Aggregate;
  /** fetch data from the table: "risolto.debit_note_attachment" using primary key columns */
  risolto_debit_note_attachment_by_pk?: Maybe<Risolto_Debit_Note_Attachment>;
  /** fetch data from the table: "risolto.debit_note" using primary key columns */
  risolto_debit_note_by_pk?: Maybe<Risolto_Debit_Note>;
  /** execute function "risolto.demo_action_report_1_v1" which returns "risolto.virtual_demo_action_report_1" */
  risolto_demo_action_report_1_v1: Array<Risolto_Virtual_Demo_Action_Report_1>;
  /** execute function "risolto.demo_action_report_1_v1" and query aggregates on result of table type "risolto.virtual_demo_action_report_1" */
  risolto_demo_action_report_1_v1_aggregate: Risolto_Virtual_Demo_Action_Report_1_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_mandate" */
  risolto_direct_debit_mandate: Array<Risolto_Direct_Debit_Mandate>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_mandate" */
  risolto_direct_debit_mandate_aggregate: Risolto_Direct_Debit_Mandate_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_mandate" using primary key columns */
  risolto_direct_debit_mandate_by_pk?: Maybe<Risolto_Direct_Debit_Mandate>;
  /** fetch data from the table: "risolto.direct_debit_provider" */
  risolto_direct_debit_provider: Array<Risolto_Direct_Debit_Provider>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_provider" */
  risolto_direct_debit_provider_aggregate: Risolto_Direct_Debit_Provider_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_provider" using primary key columns */
  risolto_direct_debit_provider_by_pk?: Maybe<Risolto_Direct_Debit_Provider>;
  /** fetch data from the table: "risolto.direct_debit_scheme" */
  risolto_direct_debit_scheme: Array<Risolto_Direct_Debit_Scheme>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_scheme" */
  risolto_direct_debit_scheme_aggregate: Risolto_Direct_Debit_Scheme_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_scheme" using primary key columns */
  risolto_direct_debit_scheme_by_pk?: Maybe<Risolto_Direct_Debit_Scheme>;
  /** fetch data from the table: "risolto.direct_debit_sequence_type" */
  risolto_direct_debit_sequence_type: Array<Risolto_Direct_Debit_Sequence_Type>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_sequence_type" */
  risolto_direct_debit_sequence_type_aggregate: Risolto_Direct_Debit_Sequence_Type_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_sequence_type" using primary key columns */
  risolto_direct_debit_sequence_type_by_pk?: Maybe<Risolto_Direct_Debit_Sequence_Type>;
  /** fetch data from the table: "risolto.direct_debit_transaction" */
  risolto_direct_debit_transaction: Array<Risolto_Direct_Debit_Transaction>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_transaction" */
  risolto_direct_debit_transaction_aggregate: Risolto_Direct_Debit_Transaction_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_transaction" using primary key columns */
  risolto_direct_debit_transaction_by_pk?: Maybe<Risolto_Direct_Debit_Transaction>;
  /** fetch data from the table: "risolto.dispute_code" */
  risolto_dispute_code: Array<Risolto_Dispute_Code>;
  /** fetch aggregated fields from the table: "risolto.dispute_code" */
  risolto_dispute_code_aggregate: Risolto_Dispute_Code_Aggregate;
  /** fetch data from the table: "risolto.dispute_code" using primary key columns */
  risolto_dispute_code_by_pk?: Maybe<Risolto_Dispute_Code>;
  /** fetch data from the table: "risolto.document_attachment_type" */
  risolto_document_attachment_type: Array<Risolto_Document_Attachment_Type>;
  /** fetch aggregated fields from the table: "risolto.document_attachment_type" */
  risolto_document_attachment_type_aggregate: Risolto_Document_Attachment_Type_Aggregate;
  /** fetch data from the table: "risolto.document_attachment_type" using primary key columns */
  risolto_document_attachment_type_by_pk?: Maybe<Risolto_Document_Attachment_Type>;
  /** fetch data from the table: "risolto.document_interchange" */
  risolto_document_interchange: Array<Risolto_Document_Interchange>;
  /** fetch aggregated fields from the table: "risolto.document_interchange" */
  risolto_document_interchange_aggregate: Risolto_Document_Interchange_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_attachment" */
  risolto_document_interchange_attachment: Array<Risolto_Document_Interchange_Attachment>;
  /** fetch aggregated fields from the table: "risolto.document_interchange_attachment" */
  risolto_document_interchange_attachment_aggregate: Risolto_Document_Interchange_Attachment_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_attachment" using primary key columns */
  risolto_document_interchange_attachment_by_pk?: Maybe<Risolto_Document_Interchange_Attachment>;
  /** fetch data from the table: "risolto.document_interchange" using primary key columns */
  risolto_document_interchange_by_pk?: Maybe<Risolto_Document_Interchange>;
  /** fetch data from the table: "risolto.document_interchange_direction" */
  risolto_document_interchange_direction: Array<Risolto_Document_Interchange_Direction>;
  /** fetch aggregated fields from the table: "risolto.document_interchange_direction" */
  risolto_document_interchange_direction_aggregate: Risolto_Document_Interchange_Direction_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_direction" using primary key columns */
  risolto_document_interchange_direction_by_pk?: Maybe<Risolto_Document_Interchange_Direction>;
  /** fetch data from the table: "risolto.document_interchange_event" */
  risolto_document_interchange_event: Array<Risolto_Document_Interchange_Event>;
  /** fetch aggregated fields from the table: "risolto.document_interchange_event" */
  risolto_document_interchange_event_aggregate: Risolto_Document_Interchange_Event_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_event" using primary key columns */
  risolto_document_interchange_event_by_pk?: Maybe<Risolto_Document_Interchange_Event>;
  /** fetch data from the table: "risolto.document_interchange_link" */
  risolto_document_interchange_link: Array<Risolto_Document_Interchange_Link>;
  /** fetch aggregated fields from the table: "risolto.document_interchange_link" */
  risolto_document_interchange_link_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_link" using primary key columns */
  risolto_document_interchange_link_by_pk?: Maybe<Risolto_Document_Interchange_Link>;
  /** fetch data from the table: "risolto.dunning_notice" */
  risolto_dunning_notice: Array<Risolto_Dunning_Notice>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice" */
  risolto_dunning_notice_aggregate: Risolto_Dunning_Notice_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice" using primary key columns */
  risolto_dunning_notice_by_pk?: Maybe<Risolto_Dunning_Notice>;
  /** fetch data from the table: "risolto.dunning_notice_invoice" */
  risolto_dunning_notice_invoice: Array<Risolto_Dunning_Notice_Invoice>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice_invoice" */
  risolto_dunning_notice_invoice_aggregate: Risolto_Dunning_Notice_Invoice_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice_invoice" using primary key columns */
  risolto_dunning_notice_invoice_by_pk?: Maybe<Risolto_Dunning_Notice_Invoice>;
  /** fetch data from the table: "risolto.dunning_notice_invoice_relation" */
  risolto_dunning_notice_invoice_relation: Array<Risolto_Dunning_Notice_Invoice_Relation>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice_invoice_relation" */
  risolto_dunning_notice_invoice_relation_aggregate: Risolto_Dunning_Notice_Invoice_Relation_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice_invoice_relation" using primary key columns */
  risolto_dunning_notice_invoice_relation_by_pk?: Maybe<Risolto_Dunning_Notice_Invoice_Relation>;
  /** fetch data from the table: "risolto.dunning_notice_status" */
  risolto_dunning_notice_status: Array<Risolto_Dunning_Notice_Status>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice_status" */
  risolto_dunning_notice_status_aggregate: Risolto_Dunning_Notice_Status_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice_status" using primary key columns */
  risolto_dunning_notice_status_by_pk?: Maybe<Risolto_Dunning_Notice_Status>;
  /** fetch data from the table: "risolto.dunning_notice_type_code" */
  risolto_dunning_notice_type_code: Array<Risolto_Dunning_Notice_Type_Code>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice_type_code" */
  risolto_dunning_notice_type_code_aggregate: Risolto_Dunning_Notice_Type_Code_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice_type_code" using primary key columns */
  risolto_dunning_notice_type_code_by_pk?: Maybe<Risolto_Dunning_Notice_Type_Code>;
  /** execute function "risolto.fe_recipient_accounting_document" which returns "risolto.virtual_json" */
  risolto_fe_recipient_accounting_document: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.fe_recipient_accounting_document" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_fe_recipient_accounting_document_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.frequency" */
  risolto_frequency: Array<Risolto_Frequency>;
  /** fetch aggregated fields from the table: "risolto.frequency" */
  risolto_frequency_aggregate: Risolto_Frequency_Aggregate;
  /** fetch data from the table: "risolto.frequency" using primary key columns */
  risolto_frequency_by_pk?: Maybe<Risolto_Frequency>;
  /** fetch data from the table: "risolto.grant_type" */
  risolto_grant_type: Array<Risolto_Grant_Type>;
  /** fetch aggregated fields from the table: "risolto.grant_type" */
  risolto_grant_type_aggregate: Risolto_Grant_Type_Aggregate;
  /** fetch data from the table: "risolto.grant_type" using primary key columns */
  risolto_grant_type_by_pk?: Maybe<Risolto_Grant_Type>;
  /** execute function "risolto.hohr_cvt_list_data" which returns "risolto.virtual_json" */
  risolto_hohr_cvt_list_data: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.hohr_cvt_list_data" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_hohr_cvt_list_data_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.invoice_collection" */
  risolto_invoice_collection: Array<Risolto_Invoice_Collection>;
  /** fetch aggregated fields from the table: "risolto.invoice_collection" */
  risolto_invoice_collection_aggregate: Risolto_Invoice_Collection_Aggregate;
  /** fetch data from the table: "risolto.invoice_collection" using primary key columns */
  risolto_invoice_collection_by_pk?: Maybe<Risolto_Invoice_Collection>;
  /** fetch data from the table: "risolto.invoice_dispute" */
  risolto_invoice_dispute: Array<Risolto_Invoice_Dispute>;
  /** fetch aggregated fields from the table: "risolto.invoice_dispute" */
  risolto_invoice_dispute_aggregate: Risolto_Invoice_Dispute_Aggregate;
  /** fetch data from the table: "risolto.invoice_dispute" using primary key columns */
  risolto_invoice_dispute_by_pk?: Maybe<Risolto_Invoice_Dispute>;
  /** fetch data from the table: "risolto.invoice_document" */
  risolto_invoice_document: Array<Risolto_Invoice_Document>;
  /** fetch aggregated fields from the table: "risolto.invoice_document" */
  risolto_invoice_document_aggregate: Risolto_Invoice_Document_Aggregate;
  /** fetch data from the table: "risolto.invoice_document_attachment" */
  risolto_invoice_document_attachment: Array<Risolto_Invoice_Document_Attachment>;
  /** fetch aggregated fields from the table: "risolto.invoice_document_attachment" */
  risolto_invoice_document_attachment_aggregate: Risolto_Invoice_Document_Attachment_Aggregate;
  /** fetch data from the table: "risolto.invoice_document_attachment" using primary key columns */
  risolto_invoice_document_attachment_by_pk?: Maybe<Risolto_Invoice_Document_Attachment>;
  /** fetch data from the table: "risolto.invoice_document" using primary key columns */
  risolto_invoice_document_by_pk?: Maybe<Risolto_Invoice_Document>;
  /** execute function "risolto.invoice_document_details_search" which returns "risolto.invoice_document" */
  risolto_invoice_document_details_search: Array<Risolto_Invoice_Document>;
  /** execute function "risolto.invoice_document_details_search10" which returns "risolto.invoice_document" */
  risolto_invoice_document_details_search10: Array<Risolto_Invoice_Document>;
  /** execute function "risolto.invoice_document_details_search100" which returns "risolto.invoice_document" */
  risolto_invoice_document_details_search100: Array<Risolto_Invoice_Document>;
  /** execute function "risolto.invoice_document_details_search100" and query aggregates on result of table type "risolto.invoice_document" */
  risolto_invoice_document_details_search100_aggregate: Risolto_Invoice_Document_Aggregate;
  /** execute function "risolto.invoice_document_details_search10" and query aggregates on result of table type "risolto.invoice_document" */
  risolto_invoice_document_details_search10_aggregate: Risolto_Invoice_Document_Aggregate;
  /** execute function "risolto.invoice_document_details_search" and query aggregates on result of table type "risolto.invoice_document" */
  risolto_invoice_document_details_search_aggregate: Risolto_Invoice_Document_Aggregate;
  /** fetch data from the table: "risolto.invoice_document_status" */
  risolto_invoice_document_status: Array<Risolto_Invoice_Document_Status>;
  /** fetch aggregated fields from the table: "risolto.invoice_document_status" */
  risolto_invoice_document_status_aggregate: Risolto_Invoice_Document_Status_Aggregate;
  /** fetch data from the table: "risolto.invoice_document_status" using primary key columns */
  risolto_invoice_document_status_by_pk?: Maybe<Risolto_Invoice_Document_Status>;
  /** fetch data from the table: "risolto.invoice_group" */
  risolto_invoice_group: Array<Risolto_Invoice_Group>;
  /** fetch aggregated fields from the table: "risolto.invoice_group" */
  risolto_invoice_group_aggregate: Risolto_Invoice_Group_Aggregate;
  /** fetch data from the table: "risolto.invoice_group" using primary key columns */
  risolto_invoice_group_by_pk?: Maybe<Risolto_Invoice_Group>;
  /** fetch data from the table: "risolto.invoice_group_credit_note" */
  risolto_invoice_group_credit_note: Array<Risolto_Invoice_Group_Credit_Note>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_credit_note" */
  risolto_invoice_group_credit_note_aggregate: Risolto_Invoice_Group_Credit_Note_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_credit_note" using primary key columns */
  risolto_invoice_group_credit_note_by_pk?: Maybe<Risolto_Invoice_Group_Credit_Note>;
  /** fetch data from the table: "risolto.invoice_group_debit_note" */
  risolto_invoice_group_debit_note: Array<Risolto_Invoice_Group_Debit_Note>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_debit_note" */
  risolto_invoice_group_debit_note_aggregate: Risolto_Invoice_Group_Debit_Note_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_debit_note" using primary key columns */
  risolto_invoice_group_debit_note_by_pk?: Maybe<Risolto_Invoice_Group_Debit_Note>;
  /** fetch data from the table: "risolto.invoice_group_dunning_run" */
  risolto_invoice_group_dunning_run: Array<Risolto_Invoice_Group_Dunning_Run>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_dunning_run" */
  risolto_invoice_group_dunning_run_aggregate: Risolto_Invoice_Group_Dunning_Run_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_dunning_run" using primary key columns */
  risolto_invoice_group_dunning_run_by_pk?: Maybe<Risolto_Invoice_Group_Dunning_Run>;
  /** fetch data from the table: "risolto.invoice_group_invoice" */
  risolto_invoice_group_invoice: Array<Risolto_Invoice_Group_Invoice>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_invoice" */
  risolto_invoice_group_invoice_aggregate: Risolto_Invoice_Group_Invoice_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_invoice" using primary key columns */
  risolto_invoice_group_invoice_by_pk?: Maybe<Risolto_Invoice_Group_Invoice>;
  /** fetch data from the table: "risolto.invoice_group_payment" */
  risolto_invoice_group_payment: Array<Risolto_Invoice_Group_Payment>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_payment" */
  risolto_invoice_group_payment_aggregate: Risolto_Invoice_Group_Payment_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_payment" using primary key columns */
  risolto_invoice_group_payment_by_pk?: Maybe<Risolto_Invoice_Group_Payment>;
  /** fetch data from the table: "risolto.invoice_group_payment_promise" */
  risolto_invoice_group_payment_promise: Array<Risolto_Invoice_Group_Payment_Promise>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_payment_promise" */
  risolto_invoice_group_payment_promise_aggregate: Risolto_Invoice_Group_Payment_Promise_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_payment_promise" using primary key columns */
  risolto_invoice_group_payment_promise_by_pk?: Maybe<Risolto_Invoice_Group_Payment_Promise>;
  /** execute function "risolto.invoicing_channel_endpoints_v1" which returns "risolto.virtual_invoicing_channel_endpoint" */
  risolto_invoicing_channel_endpoints_v1: Array<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** execute function "risolto.invoicing_channel_endpoints_v1" and query aggregates on result of table type "risolto.virtual_invoicing_channel_endpoint" */
  risolto_invoicing_channel_endpoints_v1_aggregate: Risolto_Virtual_Invoicing_Channel_Endpoint_Aggregate;
  /** execute function "risolto.invoicing_channel_endpoints_v2" which returns "risolto.channel_endpoint" */
  risolto_invoicing_channel_endpoints_v2: Array<Risolto_Channel_Endpoint>;
  /** execute function "risolto.invoicing_channel_endpoints_v2" and query aggregates on result of table type "risolto.channel_endpoint" */
  risolto_invoicing_channel_endpoints_v2_aggregate: Risolto_Channel_Endpoint_Aggregate;
  /** fetch data from the table: "risolto.iso_country_code" */
  risolto_iso_country_code: Array<Risolto_Iso_Country_Code>;
  /** fetch aggregated fields from the table: "risolto.iso_country_code" */
  risolto_iso_country_code_aggregate: Risolto_Iso_Country_Code_Aggregate;
  /** fetch data from the table: "risolto.iso_country_code" using primary key columns */
  risolto_iso_country_code_by_pk?: Maybe<Risolto_Iso_Country_Code>;
  /** fetch data from the table: "risolto.job" */
  risolto_job: Array<Risolto_Job>;
  /** fetch aggregated fields from the table: "risolto.job" */
  risolto_job_aggregate: Risolto_Job_Aggregate;
  /** fetch data from the table: "risolto.job" using primary key columns */
  risolto_job_by_pk?: Maybe<Risolto_Job>;
  /** fetch data from the table: "risolto.language_code" */
  risolto_language_code: Array<Risolto_Language_Code>;
  /** fetch aggregated fields from the table: "risolto.language_code" */
  risolto_language_code_aggregate: Risolto_Language_Code_Aggregate;
  /** fetch data from the table: "risolto.language_code" using primary key columns */
  risolto_language_code_by_pk?: Maybe<Risolto_Language_Code>;
  /** fetch data from the table: "risolto.legal_entity" */
  risolto_legal_entity: Array<Risolto_Legal_Entity>;
  /** fetch aggregated fields from the table: "risolto.legal_entity" */
  risolto_legal_entity_aggregate: Risolto_Legal_Entity_Aggregate;
  /** fetch data from the table: "risolto.legal_entity" using primary key columns */
  risolto_legal_entity_by_pk?: Maybe<Risolto_Legal_Entity>;
  /** fetch data from the table: "risolto.locale" */
  risolto_locale: Array<Risolto_Locale>;
  /** fetch aggregated fields from the table: "risolto.locale" */
  risolto_locale_aggregate: Risolto_Locale_Aggregate;
  /** fetch data from the table: "risolto.locale" using primary key columns */
  risolto_locale_by_pk?: Maybe<Risolto_Locale>;
  /** fetch data from the table: "risolto.magda_cache" */
  risolto_magda_cache: Array<Risolto_Magda_Cache>;
  /** fetch aggregated fields from the table: "risolto.magda_cache" */
  risolto_magda_cache_aggregate: Risolto_Magda_Cache_Aggregate;
  /** fetch data from the table: "risolto.magda_cache" using primary key columns */
  risolto_magda_cache_by_pk?: Maybe<Risolto_Magda_Cache>;
  /** fetch data from the table: "risolto.magda_service_audit_log" */
  risolto_magda_service_audit_log: Array<Risolto_Magda_Service_Audit_Log>;
  /** fetch aggregated fields from the table: "risolto.magda_service_audit_log" */
  risolto_magda_service_audit_log_aggregate: Risolto_Magda_Service_Audit_Log_Aggregate;
  /** fetch data from the table: "risolto.magda_service_audit_log" using primary key columns */
  risolto_magda_service_audit_log_by_pk?: Maybe<Risolto_Magda_Service_Audit_Log>;
  /** execute function "risolto.mailbox_actions_and_messages" which returns "risolto.view_action_and_message" */
  risolto_mailbox_actions_and_messages: Array<Risolto_View_Action_And_Message>;
  /** execute function "risolto.mailbox_actions_and_messages" and query aggregates on result of table type "risolto.view_action_and_message" */
  risolto_mailbox_actions_and_messages_aggregate: Risolto_View_Action_And_Message_Aggregate;
  /** fetch data from the table: "risolto.materialized_view_definition" */
  risolto_materialized_view_definition: Array<Risolto_Materialized_View_Definition>;
  /** fetch aggregated fields from the table: "risolto.materialized_view_definition" */
  risolto_materialized_view_definition_aggregate: Risolto_Materialized_View_Definition_Aggregate;
  /** fetch data from the table: "risolto.materialized_view_definition" using primary key columns */
  risolto_materialized_view_definition_by_pk?: Maybe<Risolto_Materialized_View_Definition>;
  /** fetch data from the table: "risolto.message" */
  risolto_message: Array<Risolto_Message>;
  /** fetch aggregated fields from the table: "risolto.message" */
  risolto_message_aggregate: Risolto_Message_Aggregate;
  /** fetch data from the table: "risolto.message_assignee" */
  risolto_message_assignee: Array<Risolto_Message_Assignee>;
  /** fetch aggregated fields from the table: "risolto.message_assignee" */
  risolto_message_assignee_aggregate: Risolto_Message_Assignee_Aggregate;
  /** fetch data from the table: "risolto.message_assignee" using primary key columns */
  risolto_message_assignee_by_pk?: Maybe<Risolto_Message_Assignee>;
  /** fetch data from the table: "risolto.message_attachment" */
  risolto_message_attachment: Array<Risolto_Message_Attachment>;
  /** fetch aggregated fields from the table: "risolto.message_attachment" */
  risolto_message_attachment_aggregate: Risolto_Message_Attachment_Aggregate;
  /** fetch data from the table: "risolto.message_attachment" using primary key columns */
  risolto_message_attachment_by_pk?: Maybe<Risolto_Message_Attachment>;
  /** fetch data from the table: "risolto.message" using primary key columns */
  risolto_message_by_pk?: Maybe<Risolto_Message>;
  /** fetch data from the table: "risolto.message_label" */
  risolto_message_label: Array<Risolto_Message_Label>;
  /** fetch aggregated fields from the table: "risolto.message_label" */
  risolto_message_label_aggregate: Risolto_Message_Label_Aggregate;
  /** fetch data from the table: "risolto.message_label" using primary key columns */
  risolto_message_label_by_pk?: Maybe<Risolto_Message_Label>;
  /** fetch data from the table: "risolto.message_message_label" */
  risolto_message_message_label: Array<Risolto_Message_Message_Label>;
  /** fetch aggregated fields from the table: "risolto.message_message_label" */
  risolto_message_message_label_aggregate: Risolto_Message_Message_Label_Aggregate;
  /** fetch data from the table: "risolto.message_message_label" using primary key columns */
  risolto_message_message_label_by_pk?: Maybe<Risolto_Message_Message_Label>;
  /** fetch data from the table: "risolto.message_recipient" */
  risolto_message_recipient: Array<Risolto_Message_Recipient>;
  /** fetch aggregated fields from the table: "risolto.message_recipient" */
  risolto_message_recipient_aggregate: Risolto_Message_Recipient_Aggregate;
  /** fetch data from the table: "risolto.message_recipient" using primary key columns */
  risolto_message_recipient_by_pk?: Maybe<Risolto_Message_Recipient>;
  /** fetch data from the table: "risolto.mime_type" */
  risolto_mime_type: Array<Risolto_Mime_Type>;
  /** fetch aggregated fields from the table: "risolto.mime_type" */
  risolto_mime_type_aggregate: Risolto_Mime_Type_Aggregate;
  /** fetch data from the table: "risolto.mime_type" using primary key columns */
  risolto_mime_type_by_pk?: Maybe<Risolto_Mime_Type>;
  /** fetch data from the table: "risolto.note" */
  risolto_note: Array<Risolto_Note>;
  /** fetch aggregated fields from the table: "risolto.note" */
  risolto_note_aggregate: Risolto_Note_Aggregate;
  /** fetch data from the table: "risolto.note" using primary key columns */
  risolto_note_by_pk?: Maybe<Risolto_Note>;
  /** fetch data from the table: "risolto.note_category" */
  risolto_note_category: Array<Risolto_Note_Category>;
  /** fetch aggregated fields from the table: "risolto.note_category" */
  risolto_note_category_aggregate: Risolto_Note_Category_Aggregate;
  /** fetch data from the table: "risolto.note_category" using primary key columns */
  risolto_note_category_by_pk?: Maybe<Risolto_Note_Category>;
  /** fetch data from the table: "risolto.note_invoice" */
  risolto_note_invoice: Array<Risolto_Note_Invoice>;
  /** fetch aggregated fields from the table: "risolto.note_invoice" */
  risolto_note_invoice_aggregate: Risolto_Note_Invoice_Aggregate;
  /** fetch data from the table: "risolto.note_invoice" using primary key columns */
  risolto_note_invoice_by_pk?: Maybe<Risolto_Note_Invoice>;
  /** fetch data from the table: "risolto.open_balance" */
  risolto_open_balance: Array<Risolto_Open_Balance>;
  /** fetch aggregated fields from the table: "risolto.open_balance" */
  risolto_open_balance_aggregate: Risolto_Open_Balance_Aggregate;
  /** fetch data from the table: "risolto.open_balance" using primary key columns */
  risolto_open_balance_by_pk?: Maybe<Risolto_Open_Balance>;
  /** fetch data from the table: "risolto.open_balance_record" */
  risolto_open_balance_record: Array<Risolto_Open_Balance_Record>;
  /** fetch aggregated fields from the table: "risolto.open_balance_record" */
  risolto_open_balance_record_aggregate: Risolto_Open_Balance_Record_Aggregate;
  /** fetch data from the table: "risolto.open_balance_record" using primary key columns */
  risolto_open_balance_record_by_pk?: Maybe<Risolto_Open_Balance_Record>;
  /** fetch data from the table: "risolto.origin" */
  risolto_origin: Array<Risolto_Origin>;
  /** fetch aggregated fields from the table: "risolto.origin" */
  risolto_origin_aggregate: Risolto_Origin_Aggregate;
  /** fetch data from the table: "risolto.origin" using primary key columns */
  risolto_origin_by_pk?: Maybe<Risolto_Origin>;
  /** fetch data from the table: "risolto.participant" */
  risolto_participant: Array<Risolto_Participant>;
  /** fetch aggregated fields from the table: "risolto.participant" */
  risolto_participant_aggregate: Risolto_Participant_Aggregate;
  /** fetch data from the table: "risolto.participant_api_app_client" */
  risolto_participant_api_app_client: Array<Risolto_Participant_Api_App_Client>;
  /** fetch aggregated fields from the table: "risolto.participant_api_app_client" */
  risolto_participant_api_app_client_aggregate: Risolto_Participant_Api_App_Client_Aggregate;
  /** fetch data from the table: "risolto.participant_api_app_client" using primary key columns */
  risolto_participant_api_app_client_by_pk?: Maybe<Risolto_Participant_Api_App_Client>;
  /** fetch data from the table: "risolto.participant" using primary key columns */
  risolto_participant_by_pk?: Maybe<Risolto_Participant>;
  /** fetch data from the table: "risolto.participant_dunning_run" */
  risolto_participant_dunning_run: Array<Risolto_Participant_Dunning_Run>;
  /** fetch aggregated fields from the table: "risolto.participant_dunning_run" */
  risolto_participant_dunning_run_aggregate: Risolto_Participant_Dunning_Run_Aggregate;
  /** fetch data from the table: "risolto.participant_dunning_run" using primary key columns */
  risolto_participant_dunning_run_by_pk?: Maybe<Risolto_Participant_Dunning_Run>;
  /** fetch data from the table: "risolto.participant_user" */
  risolto_participant_user: Array<Risolto_Participant_User>;
  /** fetch aggregated fields from the table: "risolto.participant_user" */
  risolto_participant_user_aggregate: Risolto_Participant_User_Aggregate;
  /** fetch data from the table: "risolto.participant_user" using primary key columns */
  risolto_participant_user_by_pk?: Maybe<Risolto_Participant_User>;
  /** fetch data from the table: "risolto.participant_user_role" */
  risolto_participant_user_role: Array<Risolto_Participant_User_Role>;
  /** fetch aggregated fields from the table: "risolto.participant_user_role" */
  risolto_participant_user_role_aggregate: Risolto_Participant_User_Role_Aggregate;
  /** fetch data from the table: "risolto.participant_user_role" using primary key columns */
  risolto_participant_user_role_by_pk?: Maybe<Risolto_Participant_User_Role>;
  /** fetch data from the table: "risolto.payment" */
  risolto_payment: Array<Risolto_Payment>;
  /** fetch aggregated fields from the table: "risolto.payment" */
  risolto_payment_aggregate: Risolto_Payment_Aggregate;
  /** fetch data from the table: "risolto.payment" using primary key columns */
  risolto_payment_by_pk?: Maybe<Risolto_Payment>;
  /** fetch data from the table: "risolto.payment_document" */
  risolto_payment_document: Array<Risolto_Payment_Document>;
  /** fetch aggregated fields from the table: "risolto.payment_document" */
  risolto_payment_document_aggregate: Risolto_Payment_Document_Aggregate;
  /** fetch data from the table: "risolto.payment_document" using primary key columns */
  risolto_payment_document_by_pk?: Maybe<Risolto_Payment_Document>;
  /** fetch data from the table: "risolto.payment_link" */
  risolto_payment_link: Array<Risolto_Payment_Link>;
  /** fetch aggregated fields from the table: "risolto.payment_link" */
  risolto_payment_link_aggregate: Risolto_Payment_Link_Aggregate;
  /** fetch data from the table: "risolto.payment_link" using primary key columns */
  risolto_payment_link_by_pk?: Maybe<Risolto_Payment_Link>;
  /** fetch data from the table: "risolto.payment_plan" */
  risolto_payment_plan: Array<Risolto_Payment_Plan>;
  /** fetch aggregated fields from the table: "risolto.payment_plan" */
  risolto_payment_plan_aggregate: Risolto_Payment_Plan_Aggregate;
  /** fetch data from the table: "risolto.payment_plan" using primary key columns */
  risolto_payment_plan_by_pk?: Maybe<Risolto_Payment_Plan>;
  /** fetch data from the table: "risolto.payment_promise" */
  risolto_payment_promise: Array<Risolto_Payment_Promise>;
  /** fetch aggregated fields from the table: "risolto.payment_promise" */
  risolto_payment_promise_aggregate: Risolto_Payment_Promise_Aggregate;
  /** fetch data from the table: "risolto.payment_promise" using primary key columns */
  risolto_payment_promise_by_pk?: Maybe<Risolto_Payment_Promise>;
  /** fetch data from the table: "risolto.payment_transfer" */
  risolto_payment_transfer: Array<Risolto_Payment_Transfer>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer" */
  risolto_payment_transfer_aggregate: Risolto_Payment_Transfer_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_bulk_payment" */
  risolto_payment_transfer_bulk_payment: Array<Risolto_Payment_Transfer_Bulk_Payment>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer_bulk_payment" */
  risolto_payment_transfer_bulk_payment_aggregate: Risolto_Payment_Transfer_Bulk_Payment_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_bulk_payment" using primary key columns */
  risolto_payment_transfer_bulk_payment_by_pk?: Maybe<Risolto_Payment_Transfer_Bulk_Payment>;
  /** fetch data from the table: "risolto.payment_transfer" using primary key columns */
  risolto_payment_transfer_by_pk?: Maybe<Risolto_Payment_Transfer>;
  /** fetch data from the table: "risolto.payment_transfer_line" */
  risolto_payment_transfer_line: Array<Risolto_Payment_Transfer_Line>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer_line" */
  risolto_payment_transfer_line_aggregate: Risolto_Payment_Transfer_Line_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_line" using primary key columns */
  risolto_payment_transfer_line_by_pk?: Maybe<Risolto_Payment_Transfer_Line>;
  /** fetch data from the table: "risolto.payment_transfer_line_type" */
  risolto_payment_transfer_line_type: Array<Risolto_Payment_Transfer_Line_Type>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer_line_type" */
  risolto_payment_transfer_line_type_aggregate: Risolto_Payment_Transfer_Line_Type_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_line_type" using primary key columns */
  risolto_payment_transfer_line_type_by_pk?: Maybe<Risolto_Payment_Transfer_Line_Type>;
  /** fetch data from the table: "risolto.payment_transfer_status" */
  risolto_payment_transfer_status: Array<Risolto_Payment_Transfer_Status>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer_status" */
  risolto_payment_transfer_status_aggregate: Risolto_Payment_Transfer_Status_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_status" using primary key columns */
  risolto_payment_transfer_status_by_pk?: Maybe<Risolto_Payment_Transfer_Status>;
  /** fetch data from the table: "risolto.person" */
  risolto_person: Array<Risolto_Person>;
  /** fetch aggregated fields from the table: "risolto.person" */
  risolto_person_aggregate: Risolto_Person_Aggregate;
  /** fetch data from the table: "risolto.person" using primary key columns */
  risolto_person_by_pk?: Maybe<Risolto_Person>;
  /** fetch data from the table: "risolto.platform_license_module" */
  risolto_platform_license_module: Array<Risolto_Platform_License_Module>;
  /** fetch aggregated fields from the table: "risolto.platform_license_module" */
  risolto_platform_license_module_aggregate: Risolto_Platform_License_Module_Aggregate;
  /** fetch data from the table: "risolto.platform_license_module" using primary key columns */
  risolto_platform_license_module_by_pk?: Maybe<Risolto_Platform_License_Module>;
  /** fetch data from the table: "risolto.platform_participant_license" */
  risolto_platform_participant_license: Array<Risolto_Platform_Participant_License>;
  /** fetch aggregated fields from the table: "risolto.platform_participant_license" */
  risolto_platform_participant_license_aggregate: Risolto_Platform_Participant_License_Aggregate;
  /** fetch data from the table: "risolto.platform_participant_license" using primary key columns */
  risolto_platform_participant_license_by_pk?: Maybe<Risolto_Platform_Participant_License>;
  /** fetch data from the table: "risolto.platform_permission" */
  risolto_platform_permission: Array<Risolto_Platform_Permission>;
  /** fetch aggregated fields from the table: "risolto.platform_permission" */
  risolto_platform_permission_aggregate: Risolto_Platform_Permission_Aggregate;
  /** fetch data from the table: "risolto.platform_permission" using primary key columns */
  risolto_platform_permission_by_pk?: Maybe<Risolto_Platform_Permission>;
  /** fetch data from the table: "risolto.platform_role" */
  risolto_platform_role: Array<Risolto_Platform_Role>;
  /** fetch aggregated fields from the table: "risolto.platform_role" */
  risolto_platform_role_aggregate: Risolto_Platform_Role_Aggregate;
  /** fetch data from the table: "risolto.platform_role" using primary key columns */
  risolto_platform_role_by_pk?: Maybe<Risolto_Platform_Role>;
  /** fetch data from the table: "risolto.platform_role_permission" */
  risolto_platform_role_permission: Array<Risolto_Platform_Role_Permission>;
  /** fetch aggregated fields from the table: "risolto.platform_role_permission" */
  risolto_platform_role_permission_aggregate: Risolto_Platform_Role_Permission_Aggregate;
  /** fetch data from the table: "risolto.platform_role_permission" using primary key columns */
  risolto_platform_role_permission_by_pk?: Maybe<Risolto_Platform_Role_Permission>;
  /** fetch data from the table: "risolto.platform_usage" */
  risolto_platform_usage: Array<Risolto_Platform_Usage>;
  /** fetch aggregated fields from the table: "risolto.platform_usage" */
  risolto_platform_usage_aggregate: Risolto_Platform_Usage_Aggregate;
  /** fetch data from the table: "risolto.platform_usage" using primary key columns */
  risolto_platform_usage_by_pk?: Maybe<Risolto_Platform_Usage>;
  /** execute function "risolto.proof_of_delivery_barcode" which returns "risolto.virtual_json" */
  risolto_proof_of_delivery_barcode: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.proof_of_delivery_barcode" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_proof_of_delivery_barcode_aggregate: Risolto_Virtual_Json_Aggregate;
  /** execute function "risolto.proof_of_delivery_barcode_v2" which returns "risolto.virtual_json" */
  risolto_proof_of_delivery_barcode_v2: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.proof_of_delivery_barcode_v2" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_proof_of_delivery_barcode_v2_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.recipient" */
  risolto_recipient: Array<Risolto_Recipient>;
  /** fetch data from the table: "risolto.recipient_address" */
  risolto_recipient_address: Array<Risolto_Recipient_Address>;
  /** fetch aggregated fields from the table: "risolto.recipient_address" */
  risolto_recipient_address_aggregate: Risolto_Recipient_Address_Aggregate;
  /** fetch aggregated fields from the table: "risolto.recipient" */
  risolto_recipient_aggregate: Risolto_Recipient_Aggregate;
  /** fetch data from the table: "risolto.recipient_attachment" */
  risolto_recipient_attachment: Array<Risolto_Recipient_Attachment>;
  /** fetch aggregated fields from the table: "risolto.recipient_attachment" */
  risolto_recipient_attachment_aggregate: Risolto_Recipient_Attachment_Aggregate;
  /** fetch data from the table: "risolto.recipient_attachment" using primary key columns */
  risolto_recipient_attachment_by_pk?: Maybe<Risolto_Recipient_Attachment>;
  /** fetch data from the table: "risolto.recipient" using primary key columns */
  risolto_recipient_by_pk?: Maybe<Risolto_Recipient>;
  /** fetch data from the table: "risolto.recipient_collection" */
  risolto_recipient_collection: Array<Risolto_Recipient_Collection>;
  /** fetch aggregated fields from the table: "risolto.recipient_collection" */
  risolto_recipient_collection_aggregate: Risolto_Recipient_Collection_Aggregate;
  /** fetch data from the table: "risolto.recipient_collection" using primary key columns */
  risolto_recipient_collection_by_pk?: Maybe<Risolto_Recipient_Collection>;
  /** fetch data from the table: "risolto.recipient_communication" */
  risolto_recipient_communication: Array<Risolto_Recipient_Communication>;
  /** fetch aggregated fields from the table: "risolto.recipient_communication" */
  risolto_recipient_communication_aggregate: Risolto_Recipient_Communication_Aggregate;
  /** fetch data from the table: "risolto.recipient_communication" using primary key columns */
  risolto_recipient_communication_by_pk?: Maybe<Risolto_Recipient_Communication>;
  /** fetch data from the table: "risolto.recipient_dunning_exclude" */
  risolto_recipient_dunning_exclude: Array<Risolto_Recipient_Dunning_Exclude>;
  /** fetch aggregated fields from the table: "risolto.recipient_dunning_exclude" */
  risolto_recipient_dunning_exclude_aggregate: Risolto_Recipient_Dunning_Exclude_Aggregate;
  /** fetch data from the table: "risolto.recipient_dunning_exclude" using primary key columns */
  risolto_recipient_dunning_exclude_by_pk?: Maybe<Risolto_Recipient_Dunning_Exclude>;
  /** fetch data from the table: "risolto.recipient_dunning_run" */
  risolto_recipient_dunning_run: Array<Risolto_Recipient_Dunning_Run>;
  /** fetch aggregated fields from the table: "risolto.recipient_dunning_run" */
  risolto_recipient_dunning_run_aggregate: Risolto_Recipient_Dunning_Run_Aggregate;
  /** fetch data from the table: "risolto.recipient_dunning_run" using primary key columns */
  risolto_recipient_dunning_run_by_pk?: Maybe<Risolto_Recipient_Dunning_Run>;
  /** execute function "risolto.recipient_find_similar_by_name" which returns "risolto.virtual_json" */
  risolto_recipient_find_similar_by_name: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.recipient_find_similar_by_name" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_recipient_find_similar_by_name_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.recipient_merge" */
  risolto_recipient_merge: Array<Risolto_Recipient_Merge>;
  /** fetch aggregated fields from the table: "risolto.recipient_merge" */
  risolto_recipient_merge_aggregate: Risolto_Recipient_Merge_Aggregate;
  /** fetch data from the table: "risolto.recipient_merge" using primary key columns */
  risolto_recipient_merge_by_pk?: Maybe<Risolto_Recipient_Merge>;
  /** fetch data from the table: "risolto.recipient_tag" */
  risolto_recipient_tag: Array<Risolto_Recipient_Tag>;
  /** fetch aggregated fields from the table: "risolto.recipient_tag" */
  risolto_recipient_tag_aggregate: Risolto_Recipient_Tag_Aggregate;
  /** fetch data from the table: "risolto.recipient_tag" using primary key columns */
  risolto_recipient_tag_by_pk?: Maybe<Risolto_Recipient_Tag>;
  /** fetch data from the table: "risolto.recipient_user" */
  risolto_recipient_user: Array<Risolto_Recipient_User>;
  /** fetch aggregated fields from the table: "risolto.recipient_user" */
  risolto_recipient_user_aggregate: Risolto_Recipient_User_Aggregate;
  /** fetch data from the table: "risolto.recipient_user" using primary key columns */
  risolto_recipient_user_by_pk?: Maybe<Risolto_Recipient_User>;
  /** fetch data from the table: "risolto.reference_data" */
  risolto_reference_data: Array<Risolto_Reference_Data>;
  /** fetch aggregated fields from the table: "risolto.reference_data" */
  risolto_reference_data_aggregate: Risolto_Reference_Data_Aggregate;
  /** fetch data from the table: "risolto.reference_data" using primary key columns */
  risolto_reference_data_by_pk?: Maybe<Risolto_Reference_Data>;
  /** execute function "risolto.report_action_events" which returns "risolto.virtual_report_delivery" */
  risolto_report_action_events: Array<Risolto_Virtual_Report_Delivery>;
  /** execute function "risolto.report_action_events" and query aggregates on result of table type "risolto.virtual_report_delivery" */
  risolto_report_action_events_aggregate: Risolto_Virtual_Report_Delivery_Aggregate;
  /** execute function "risolto.report_action_events_v2" which returns "risolto.virtual_report_delivery" */
  risolto_report_action_events_v2: Array<Risolto_Virtual_Report_Delivery>;
  /** execute function "risolto.report_action_events_v2" and query aggregates on result of table type "risolto.virtual_report_delivery" */
  risolto_report_action_events_v2_aggregate: Risolto_Virtual_Report_Delivery_Aggregate;
  /** fetch data from the table: "risolto.report_definition" */
  risolto_report_definition: Array<Risolto_Report_Definition>;
  /** fetch aggregated fields from the table: "risolto.report_definition" */
  risolto_report_definition_aggregate: Risolto_Report_Definition_Aggregate;
  /** fetch data from the table: "risolto.report_definition" using primary key columns */
  risolto_report_definition_by_pk?: Maybe<Risolto_Report_Definition>;
  /** fetch data from the table: "risolto.report_execution" */
  risolto_report_execution: Array<Risolto_Report_Execution>;
  /** fetch aggregated fields from the table: "risolto.report_execution" */
  risolto_report_execution_aggregate: Risolto_Report_Execution_Aggregate;
  /** fetch data from the table: "risolto.report_execution" using primary key columns */
  risolto_report_execution_by_pk?: Maybe<Risolto_Report_Execution>;
  /** fetch data from the table: "risolto.report_execution_user" */
  risolto_report_execution_user: Array<Risolto_Report_Execution_User>;
  /** fetch aggregated fields from the table: "risolto.report_execution_user" */
  risolto_report_execution_user_aggregate: Risolto_Report_Execution_User_Aggregate;
  /** fetch data from the table: "risolto.report_execution_user" using primary key columns */
  risolto_report_execution_user_by_pk?: Maybe<Risolto_Report_Execution_User>;
  /** execute function "risolto.report_monthly_delivery_v1" which returns "risolto.virtual_report_delivery" */
  risolto_report_monthly_delivery_v1: Array<Risolto_Virtual_Report_Delivery>;
  /** execute function "risolto.report_monthly_delivery_v1" and query aggregates on result of table type "risolto.virtual_report_delivery" */
  risolto_report_monthly_delivery_v1_aggregate: Risolto_Virtual_Report_Delivery_Aggregate;
  /** fetch data from the table: "risolto.report_template_type" */
  risolto_report_template_type: Array<Risolto_Report_Template_Type>;
  /** fetch aggregated fields from the table: "risolto.report_template_type" */
  risolto_report_template_type_aggregate: Risolto_Report_Template_Type_Aggregate;
  /** fetch data from the table: "risolto.report_template_type" using primary key columns */
  risolto_report_template_type_by_pk?: Maybe<Risolto_Report_Template_Type>;
  /** fetch data from the table: "risolto.report_type" */
  risolto_report_type: Array<Risolto_Report_Type>;
  /** fetch aggregated fields from the table: "risolto.report_type" */
  risolto_report_type_aggregate: Risolto_Report_Type_Aggregate;
  /** fetch data from the table: "risolto.report_type" using primary key columns */
  risolto_report_type_by_pk?: Maybe<Risolto_Report_Type>;
  /** fetch data from the table: "risolto.report_user" */
  risolto_report_user: Array<Risolto_Report_User>;
  /** fetch aggregated fields from the table: "risolto.report_user" */
  risolto_report_user_aggregate: Risolto_Report_User_Aggregate;
  /** fetch data from the table: "risolto.report_user" using primary key columns */
  risolto_report_user_by_pk?: Maybe<Risolto_Report_User>;
  /** fetch data from the table: "risolto.run_processing_status" */
  risolto_run_processing_status: Array<Risolto_Run_Processing_Status>;
  /** fetch aggregated fields from the table: "risolto.run_processing_status" */
  risolto_run_processing_status_aggregate: Risolto_Run_Processing_Status_Aggregate;
  /** fetch data from the table: "risolto.run_processing_status" using primary key columns */
  risolto_run_processing_status_by_pk?: Maybe<Risolto_Run_Processing_Status>;
  /** execute function "risolto.search2recid" which returns "risolto.recipient" */
  risolto_search2recid: Array<Risolto_Recipient>;
  /** execute function "risolto.search2recid" and query aggregates on result of table type "risolto.recipient" */
  risolto_search2recid_aggregate: Risolto_Recipient_Aggregate;
  /** fetch data from the table: "risolto.single_sign_on" */
  risolto_single_sign_on: Array<Risolto_Single_Sign_On>;
  /** fetch aggregated fields from the table: "risolto.single_sign_on" */
  risolto_single_sign_on_aggregate: Risolto_Single_Sign_On_Aggregate;
  /** fetch data from the table: "risolto.single_sign_on" using primary key columns */
  risolto_single_sign_on_by_pk?: Maybe<Risolto_Single_Sign_On>;
  /** fetch data from the table: "risolto.statement" */
  risolto_statement: Array<Risolto_Statement>;
  /** fetch data from the table: "risolto.statement_account" */
  risolto_statement_account: Array<Risolto_Statement_Account>;
  /** fetch aggregated fields from the table: "risolto.statement_account" */
  risolto_statement_account_aggregate: Risolto_Statement_Account_Aggregate;
  /** fetch data from the table: "risolto.statement_account" using primary key columns */
  risolto_statement_account_by_pk?: Maybe<Risolto_Statement_Account>;
  /** fetch aggregated fields from the table: "risolto.statement" */
  risolto_statement_aggregate: Risolto_Statement_Aggregate;
  /** fetch data from the table: "risolto.statement" using primary key columns */
  risolto_statement_by_pk?: Maybe<Risolto_Statement>;
  /** fetch data from the table: "risolto.statement_line" */
  risolto_statement_line: Array<Risolto_Statement_Line>;
  /** fetch aggregated fields from the table: "risolto.statement_line" */
  risolto_statement_line_aggregate: Risolto_Statement_Line_Aggregate;
  /** fetch data from the table: "risolto.statement_line" using primary key columns */
  risolto_statement_line_by_pk?: Maybe<Risolto_Statement_Line>;
  /** fetch data from the table: "risolto.statement_line_dunning_notice" */
  risolto_statement_line_dunning_notice: Array<Risolto_Statement_Line_Dunning_Notice>;
  /** fetch aggregated fields from the table: "risolto.statement_line_dunning_notice" */
  risolto_statement_line_dunning_notice_aggregate: Risolto_Statement_Line_Dunning_Notice_Aggregate;
  /** fetch data from the table: "risolto.statement_line_dunning_notice" using primary key columns */
  risolto_statement_line_dunning_notice_by_pk?: Maybe<Risolto_Statement_Line_Dunning_Notice>;
  /** fetch data from the table: "risolto.statement_line_invoice" */
  risolto_statement_line_invoice: Array<Risolto_Statement_Line_Invoice>;
  /** fetch aggregated fields from the table: "risolto.statement_line_invoice" */
  risolto_statement_line_invoice_aggregate: Risolto_Statement_Line_Invoice_Aggregate;
  /** fetch data from the table: "risolto.statement_line_invoice" using primary key columns */
  risolto_statement_line_invoice_by_pk?: Maybe<Risolto_Statement_Line_Invoice>;
  /** fetch data from the table: "risolto.statement_line_payment_promise" */
  risolto_statement_line_payment_promise: Array<Risolto_Statement_Line_Payment_Promise>;
  /** fetch aggregated fields from the table: "risolto.statement_line_payment_promise" */
  risolto_statement_line_payment_promise_aggregate: Risolto_Statement_Line_Payment_Promise_Aggregate;
  /** fetch data from the table: "risolto.statement_line_payment_promise" using primary key columns */
  risolto_statement_line_payment_promise_by_pk?: Maybe<Risolto_Statement_Line_Payment_Promise>;
  /** fetch data from the table: "risolto.statement_line_status" */
  risolto_statement_line_status: Array<Risolto_Statement_Line_Status>;
  /** fetch aggregated fields from the table: "risolto.statement_line_status" */
  risolto_statement_line_status_aggregate: Risolto_Statement_Line_Status_Aggregate;
  /** fetch data from the table: "risolto.statement_line_status" using primary key columns */
  risolto_statement_line_status_by_pk?: Maybe<Risolto_Statement_Line_Status>;
  /** execute function "risolto.statement_line_structured_match" which returns "risolto.virtual_json" */
  risolto_statement_line_structured_match: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.statement_line_structured_match" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_statement_line_structured_match_aggregate: Risolto_Virtual_Json_Aggregate;
  /** execute function "risolto.statement_line_unstructured_match" which returns "risolto.virtual_json" */
  risolto_statement_line_unstructured_match: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.statement_line_unstructured_match" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_statement_line_unstructured_match_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.strigil_nbb" */
  risolto_strigil_nbb: Array<Risolto_Strigil_Nbb>;
  /** fetch aggregated fields from the table: "risolto.strigil_nbb" */
  risolto_strigil_nbb_aggregate: Risolto_Strigil_Nbb_Aggregate;
  /** fetch data from the table: "risolto.strigil_nbb" using primary key columns */
  risolto_strigil_nbb_by_pk?: Maybe<Risolto_Strigil_Nbb>;
  /** fetch data from the table: "risolto.strigil_nbb_processing_status" */
  risolto_strigil_nbb_processing_status: Array<Risolto_Strigil_Nbb_Processing_Status>;
  /** fetch aggregated fields from the table: "risolto.strigil_nbb_processing_status" */
  risolto_strigil_nbb_processing_status_aggregate: Risolto_Strigil_Nbb_Processing_Status_Aggregate;
  /** fetch data from the table: "risolto.strigil_nbb_processing_status" using primary key columns */
  risolto_strigil_nbb_processing_status_by_pk?: Maybe<Risolto_Strigil_Nbb_Processing_Status>;
  /** fetch data from the table: "risolto.system_integration" */
  risolto_system_integration: Array<Risolto_System_Integration>;
  /** fetch aggregated fields from the table: "risolto.system_integration" */
  risolto_system_integration_aggregate: Risolto_System_Integration_Aggregate;
  /** fetch data from the table: "risolto.system_integration" using primary key columns */
  risolto_system_integration_by_pk?: Maybe<Risolto_System_Integration>;
  /** fetch data from the table: "risolto.tag" */
  risolto_tag: Array<Risolto_Tag>;
  /** fetch aggregated fields from the table: "risolto.tag" */
  risolto_tag_aggregate: Risolto_Tag_Aggregate;
  /** fetch data from the table: "risolto.tag" using primary key columns */
  risolto_tag_by_pk?: Maybe<Risolto_Tag>;
  /** fetch data from the table: "risolto.task" */
  risolto_task: Array<Risolto_Task>;
  /** fetch aggregated fields from the table: "risolto.task" */
  risolto_task_aggregate: Risolto_Task_Aggregate;
  /** fetch data from the table: "risolto.task" using primary key columns */
  risolto_task_by_pk?: Maybe<Risolto_Task>;
  /** fetch data from the table: "risolto.task_source" */
  risolto_task_source: Array<Risolto_Task_Source>;
  /** fetch aggregated fields from the table: "risolto.task_source" */
  risolto_task_source_aggregate: Risolto_Task_Source_Aggregate;
  /** fetch data from the table: "risolto.task_source" using primary key columns */
  risolto_task_source_by_pk?: Maybe<Risolto_Task_Source>;
  /** fetch data from the table: "risolto.task_status" */
  risolto_task_status: Array<Risolto_Task_Status>;
  /** fetch aggregated fields from the table: "risolto.task_status" */
  risolto_task_status_aggregate: Risolto_Task_Status_Aggregate;
  /** fetch data from the table: "risolto.task_status" using primary key columns */
  risolto_task_status_by_pk?: Maybe<Risolto_Task_Status>;
  /** fetch data from the table: "risolto.task_type" */
  risolto_task_type: Array<Risolto_Task_Type>;
  /** fetch aggregated fields from the table: "risolto.task_type" */
  risolto_task_type_aggregate: Risolto_Task_Type_Aggregate;
  /** fetch data from the table: "risolto.task_type" using primary key columns */
  risolto_task_type_by_pk?: Maybe<Risolto_Task_Type>;
  /** fetch data from the table: "risolto.tone_of_voice" */
  risolto_tone_of_voice: Array<Risolto_Tone_Of_Voice>;
  /** fetch aggregated fields from the table: "risolto.tone_of_voice" */
  risolto_tone_of_voice_aggregate: Risolto_Tone_Of_Voice_Aggregate;
  /** fetch data from the table: "risolto.tone_of_voice" using primary key columns */
  risolto_tone_of_voice_by_pk?: Maybe<Risolto_Tone_Of_Voice>;
  /** fetch data from the table: "risolto.view_action_and_message" */
  risolto_view_action_and_message: Array<Risolto_View_Action_And_Message>;
  /** fetch aggregated fields from the table: "risolto.view_action_and_message" */
  risolto_view_action_and_message_aggregate: Risolto_View_Action_And_Message_Aggregate;
  /** fetch data from the table: "risolto.view_credit_limit" */
  risolto_view_credit_limit: Array<Risolto_View_Credit_Limit>;
  /** fetch aggregated fields from the table: "risolto.view_credit_limit" */
  risolto_view_credit_limit_aggregate: Risolto_View_Credit_Limit_Aggregate;
  /** fetch data from the table: "risolto.view_dashboard_aging_debt" */
  risolto_view_dashboard_aging_debt: Array<Risolto_View_Dashboard_Aging_Debt>;
  /** fetch aggregated fields from the table: "risolto.view_dashboard_aging_debt" */
  risolto_view_dashboard_aging_debt_aggregate: Risolto_View_Dashboard_Aging_Debt_Aggregate;
  /** fetch data from the table: "risolto.view_dashboard_percentage_paying_within_30_days" */
  risolto_view_dashboard_percentage_paying_within_30_days: Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days>;
  /** fetch aggregated fields from the table: "risolto.view_dashboard_percentage_paying_within_30_days" */
  risolto_view_dashboard_percentage_paying_within_30_days_aggregate: Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Aggregate;
  /** fetch data from the table: "risolto.view_dunning_notice_action_6m" */
  risolto_view_dunning_notice_action_6m: Array<Risolto_View_Dunning_Notice_Action_6m>;
  /** fetch aggregated fields from the table: "risolto.view_dunning_notice_action_6m" */
  risolto_view_dunning_notice_action_6m_aggregate: Risolto_View_Dunning_Notice_Action_6m_Aggregate;
  /** fetch data from the table: "risolto.view_invoice_features" */
  risolto_view_invoice_features: Array<Risolto_View_Invoice_Features>;
  /** fetch aggregated fields from the table: "risolto.view_invoice_features" */
  risolto_view_invoice_features_aggregate: Risolto_View_Invoice_Features_Aggregate;
  /** fetch data from the table: "risolto.view_legal_entity_template" */
  risolto_view_legal_entity_template: Array<Risolto_View_Legal_Entity_Template>;
  /** fetch aggregated fields from the table: "risolto.view_legal_entity_template" */
  risolto_view_legal_entity_template_aggregate: Risolto_View_Legal_Entity_Template_Aggregate;
  /** fetch data from the table: "risolto.view_platform_licence_permission" */
  risolto_view_platform_licence_permission: Array<Risolto_View_Platform_Licence_Permission>;
  /** fetch aggregated fields from the table: "risolto.view_platform_licence_permission" */
  risolto_view_platform_licence_permission_aggregate: Risolto_View_Platform_Licence_Permission_Aggregate;
  /** fetch data from the table: "risolto.view_recipient_tag" */
  risolto_view_recipient_tag: Array<Risolto_View_Recipient_Tag>;
  /** fetch aggregated fields from the table: "risolto.view_recipient_tag" */
  risolto_view_recipient_tag_aggregate: Risolto_View_Recipient_Tag_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note: Array<Risolto_Virtual_Action_And_Note>;
  /** fetch aggregated fields from the table: "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_aggregate: Risolto_Virtual_Action_And_Note_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_and_dispute: Array<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** fetch aggregated fields from the table: "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_and_dispute_aggregate: Risolto_Virtual_Action_And_Note_And_Dispute_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_and_dispute_and_message: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message>;
  /** fetch aggregated fields from the table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_and_dispute_and_message_aggregate: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_and_note_and_dispute" using primary key columns */
  risolto_virtual_action_and_note_and_dispute_by_pk?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** fetch data from the table: "risolto.virtual_action_and_note" using primary key columns */
  risolto_virtual_action_and_note_by_pk?: Maybe<Risolto_Virtual_Action_And_Note>;
  /** execute function "risolto.virtual_action_and_note_v1" which returns "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_v1: Array<Risolto_Virtual_Action_And_Note>;
  /** execute function "risolto.virtual_action_and_note_v1" and query aggregates on result of table type "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_v1_aggregate: Risolto_Virtual_Action_And_Note_Aggregate;
  /** execute function "risolto.virtual_action_and_note_v3" which returns "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_v3: Array<Risolto_Virtual_Action_And_Note>;
  /** execute function "risolto.virtual_action_and_note_v3" and query aggregates on result of table type "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_v3_aggregate: Risolto_Virtual_Action_And_Note_Aggregate;
  /** execute function "risolto.virtual_action_and_note_v4" which returns "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_v4: Array<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** execute function "risolto.virtual_action_and_note_v4" and query aggregates on result of table type "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_v4_aggregate: Risolto_Virtual_Action_And_Note_And_Dispute_Aggregate;
  /** execute function "risolto.virtual_action_and_note_v5" which returns "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_v5: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message>;
  /** execute function "risolto.virtual_action_and_note_v5" and query aggregates on result of table type "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_v5_aggregate: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_group" */
  risolto_virtual_action_group: Array<Risolto_Virtual_Action_Group>;
  /** fetch aggregated fields from the table: "risolto.virtual_action_group" */
  risolto_virtual_action_group_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_group" using primary key columns */
  risolto_virtual_action_group_by_pk?: Maybe<Risolto_Virtual_Action_Group>;
  /** fetch data from the table: "risolto.virtual_dashboard_action_stats" */
  risolto_virtual_dashboard_action_stats: Array<Risolto_Virtual_Dashboard_Action_Stats>;
  /** fetch aggregated fields from the table: "risolto.virtual_dashboard_action_stats" */
  risolto_virtual_dashboard_action_stats_aggregate: Risolto_Virtual_Dashboard_Action_Stats_Aggregate;
  /** fetch data from the table: "risolto.virtual_dashboard_action_stats" using primary key columns */
  risolto_virtual_dashboard_action_stats_by_pk?: Maybe<Risolto_Virtual_Dashboard_Action_Stats>;
  /** fetch data from the table: "risolto.virtual_dashboard_outstanding_debt" */
  risolto_virtual_dashboard_outstanding_debt: Array<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** fetch aggregated fields from the table: "risolto.virtual_dashboard_outstanding_debt" */
  risolto_virtual_dashboard_outstanding_debt_aggregate: Risolto_Virtual_Dashboard_Outstanding_Debt_Aggregate;
  /** fetch data from the table: "risolto.virtual_dashboard_outstanding_debt" using primary key columns */
  risolto_virtual_dashboard_outstanding_debt_by_pk?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** fetch data from the table: "risolto.virtual_demo_action_report_1" */
  risolto_virtual_demo_action_report_1: Array<Risolto_Virtual_Demo_Action_Report_1>;
  /** fetch aggregated fields from the table: "risolto.virtual_demo_action_report_1" */
  risolto_virtual_demo_action_report_1_aggregate: Risolto_Virtual_Demo_Action_Report_1_Aggregate;
  /** fetch data from the table: "risolto.virtual_demo_action_report_1" using primary key columns */
  risolto_virtual_demo_action_report_1_by_pk?: Maybe<Risolto_Virtual_Demo_Action_Report_1>;
  /** fetch data from the table: "risolto.virtual_dunning_action" */
  risolto_virtual_dunning_action: Array<Risolto_Virtual_Dunning_Action>;
  /** fetch aggregated fields from the table: "risolto.virtual_dunning_action" */
  risolto_virtual_dunning_action_aggregate: Risolto_Virtual_Dunning_Action_Aggregate;
  /** fetch data from the table: "risolto.virtual_dunning_action" using primary key columns */
  risolto_virtual_dunning_action_by_pk?: Maybe<Risolto_Virtual_Dunning_Action>;
  /** fetch data from the table: "risolto.virtual_interchange_event" */
  risolto_virtual_interchange_event: Array<Risolto_Virtual_Interchange_Event>;
  /** fetch aggregated fields from the table: "risolto.virtual_interchange_event" */
  risolto_virtual_interchange_event_aggregate: Risolto_Virtual_Interchange_Event_Aggregate;
  /** fetch data from the table: "risolto.virtual_interchange_event" using primary key columns */
  risolto_virtual_interchange_event_by_pk?: Maybe<Risolto_Virtual_Interchange_Event>;
  /** fetch data from the table: "risolto.virtual_invoice_derived_payment_information" */
  risolto_virtual_invoice_derived_payment_information: Array<Risolto_Virtual_Invoice_Derived_Payment_Information>;
  /** fetch aggregated fields from the table: "risolto.virtual_invoice_derived_payment_information" */
  risolto_virtual_invoice_derived_payment_information_aggregate: Risolto_Virtual_Invoice_Derived_Payment_Information_Aggregate;
  /** fetch data from the table: "risolto.virtual_invoice_derived_payment_information" using primary key columns */
  risolto_virtual_invoice_derived_payment_information_by_pk?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information>;
  /** fetch data from the table: "risolto.virtual_invoicing_channel_endpoint" */
  risolto_virtual_invoicing_channel_endpoint: Array<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** fetch aggregated fields from the table: "risolto.virtual_invoicing_channel_endpoint" */
  risolto_virtual_invoicing_channel_endpoint_aggregate: Risolto_Virtual_Invoicing_Channel_Endpoint_Aggregate;
  /** fetch data from the table: "risolto.virtual_invoicing_channel_endpoint" using primary key columns */
  risolto_virtual_invoicing_channel_endpoint_by_pk?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** fetch data from the table: "risolto.virtual_json" */
  risolto_virtual_json: Array<Risolto_Virtual_Json>;
  /** fetch aggregated fields from the table: "risolto.virtual_json" */
  risolto_virtual_json_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.virtual_json" using primary key columns */
  risolto_virtual_json_by_pk?: Maybe<Risolto_Virtual_Json>;
  /** fetch data from the table: "risolto.virtual_report_delivery" */
  risolto_virtual_report_delivery: Array<Risolto_Virtual_Report_Delivery>;
  /** fetch aggregated fields from the table: "risolto.virtual_report_delivery" */
  risolto_virtual_report_delivery_aggregate: Risolto_Virtual_Report_Delivery_Aggregate;
  /** fetch data from the table: "risolto.virtual_report_delivery" using primary key columns */
  risolto_virtual_report_delivery_by_pk?: Maybe<Risolto_Virtual_Report_Delivery>;
  /** fetch data from the table: "risolto.webhook" */
  risolto_webhook: Array<Risolto_Webhook>;
  /** fetch aggregated fields from the table: "risolto.webhook" */
  risolto_webhook_aggregate: Risolto_Webhook_Aggregate;
  /** fetch data from the table: "risolto.webhook" using primary key columns */
  risolto_webhook_by_pk?: Maybe<Risolto_Webhook>;
  /** fetch data from the table: "risolto.webhook_processing_status" */
  risolto_webhook_processing_status: Array<Risolto_Webhook_Processing_Status>;
  /** fetch aggregated fields from the table: "risolto.webhook_processing_status" */
  risolto_webhook_processing_status_aggregate: Risolto_Webhook_Processing_Status_Aggregate;
  /** fetch data from the table: "risolto.webhook_processing_status" using primary key columns */
  risolto_webhook_processing_status_by_pk?: Maybe<Risolto_Webhook_Processing_Status>;
  /** fetch data from the table: "risolto.webhook_subscription" */
  risolto_webhook_subscription: Array<Risolto_Webhook_Subscription>;
  /** fetch aggregated fields from the table: "risolto.webhook_subscription" */
  risolto_webhook_subscription_aggregate: Risolto_Webhook_Subscription_Aggregate;
  /** fetch data from the table: "risolto.webhook_subscription" using primary key columns */
  risolto_webhook_subscription_by_pk?: Maybe<Risolto_Webhook_Subscription>;
};


export type Query_RootRisolto_Account_Number_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Account_Number_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Account_Number_Type_Order_By>>;
  where?: Maybe<Risolto_Account_Number_Type_Bool_Exp>;
};


export type Query_RootRisolto_Account_Number_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Account_Number_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Account_Number_Type_Order_By>>;
  where?: Maybe<Risolto_Account_Number_Type_Bool_Exp>;
};


export type Query_RootRisolto_Account_Number_Type_By_PkArgs = {
  account_number_type: Scalars['String'];
};


export type Query_RootRisolto_Accounting_DocumentArgs = {
  distinct_on?: Maybe<Array<Risolto_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
};


export type Query_RootRisolto_Accounting_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
};


export type Query_RootRisolto_ActionArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


export type Query_RootRisolto_Action_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


export type Query_RootRisolto_Action_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Action_Execution_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Execution_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Execution_Type_Order_By>>;
  where?: Maybe<Risolto_Action_Execution_Type_Bool_Exp>;
};


export type Query_RootRisolto_Action_Execution_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Execution_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Execution_Type_Order_By>>;
  where?: Maybe<Risolto_Action_Execution_Type_Bool_Exp>;
};


export type Query_RootRisolto_Action_Execution_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootRisolto_Action_Group_V10Args = {
  args: Risolto_Action_Group_V10_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V10_AggregateArgs = {
  args: Risolto_Action_Group_V10_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V11Args = {
  args: Risolto_Action_Group_V11_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V11_AggregateArgs = {
  args: Risolto_Action_Group_V11_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V12Args = {
  args: Risolto_Action_Group_V12_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V12_AggregateArgs = {
  args: Risolto_Action_Group_V12_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V2Args = {
  args: Risolto_Action_Group_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V2_AggregateArgs = {
  args: Risolto_Action_Group_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V5Args = {
  args: Risolto_Action_Group_V5_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V5_AggregateArgs = {
  args: Risolto_Action_Group_V5_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V6Args = {
  args: Risolto_Action_Group_V6_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V6_AggregateArgs = {
  args: Risolto_Action_Group_V6_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V7Args = {
  args: Risolto_Action_Group_V7_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V7_AggregateArgs = {
  args: Risolto_Action_Group_V7_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V8Args = {
  args: Risolto_Action_Group_V8_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V8_AggregateArgs = {
  args: Risolto_Action_Group_V8_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V9Args = {
  args: Risolto_Action_Group_V9_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_Group_V9_AggregateArgs = {
  args: Risolto_Action_Group_V9_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Action_InterchangeArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Interchange_Order_By>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


export type Query_RootRisolto_Action_Interchange_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Interchange_Order_By>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


export type Query_RootRisolto_Action_Interchange_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Action_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Invoice_Order_By>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Action_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Invoice_Order_By>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Action_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Action_SourceArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Source_Order_By>>;
  where?: Maybe<Risolto_Action_Source_Bool_Exp>;
};


export type Query_RootRisolto_Action_Source_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Source_Order_By>>;
  where?: Maybe<Risolto_Action_Source_Bool_Exp>;
};


export type Query_RootRisolto_Action_Source_By_PkArgs = {
  source: Scalars['String'];
};


export type Query_RootRisolto_Action_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Status_Order_By>>;
  where?: Maybe<Risolto_Action_Status_Bool_Exp>;
};


export type Query_RootRisolto_Action_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Status_Order_By>>;
  where?: Maybe<Risolto_Action_Status_Bool_Exp>;
};


export type Query_RootRisolto_Action_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootRisolto_Analytics_Company_ScoreArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Company_Score_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Company_Score_Order_By>>;
  where?: Maybe<Risolto_Analytics_Company_Score_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Company_Score_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Company_Score_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Company_Score_Order_By>>;
  where?: Maybe<Risolto_Analytics_Company_Score_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Company_Score_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Analytics_Invoice_FeaturesArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Invoice_Features_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Invoice_Features_By_DateArgs = {
  args: Risolto_Analytics_Invoice_Features_By_Date_Args;
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Invoice_Features_By_Date_AggregateArgs = {
  args: Risolto_Analytics_Invoice_Features_By_Date_Args;
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Invoice_Features_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Analytics_Invoice_PredictionArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Invoice_Prediction_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Invoice_Prediction_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Analytics_TestArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Test_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Test_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Analytics_Test_ResultArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Result_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Result_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Test_Result_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Result_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Result_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
};


export type Query_RootRisolto_Analytics_Test_Result_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Api_Accounting_DocumentArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Api_Accounting_Document_Bool_Exp>;
};


export type Query_RootRisolto_Api_Accounting_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Api_Accounting_Document_Bool_Exp>;
};


export type Query_RootRisolto_Api_App_ClientArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Api_App_Client_Bool_Exp>;
};


export type Query_RootRisolto_Api_App_Client_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Api_App_Client_Bool_Exp>;
};


export type Query_RootRisolto_Api_App_Client_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Api_Payment_PlanArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Plan_Bool_Exp>;
};


export type Query_RootRisolto_Api_Payment_Plan_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Plan_Bool_Exp>;
};


export type Query_RootRisolto_Api_Payment_PromiseArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
};


export type Query_RootRisolto_Api_Payment_Promise_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
};


export type Query_RootRisolto_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Attachment_Order_By>>;
  where?: Maybe<Risolto_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Attachment_Order_By>>;
  where?: Maybe<Risolto_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Attachment_SchemeArgs = {
  distinct_on?: Maybe<Array<Risolto_Attachment_Scheme_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Attachment_Scheme_Order_By>>;
  where?: Maybe<Risolto_Attachment_Scheme_Bool_Exp>;
};


export type Query_RootRisolto_Attachment_Scheme_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Attachment_Scheme_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Attachment_Scheme_Order_By>>;
  where?: Maybe<Risolto_Attachment_Scheme_Bool_Exp>;
};


export type Query_RootRisolto_Attachment_Scheme_By_PkArgs = {
  scheme: Scalars['String'];
};


export type Query_RootRisolto_Bank_AccountArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Account_Order_By>>;
  where?: Maybe<Risolto_Bank_Account_Bool_Exp>;
};


export type Query_RootRisolto_Bank_Account_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Account_Order_By>>;
  where?: Maybe<Risolto_Bank_Account_Bool_Exp>;
};


export type Query_RootRisolto_Bank_Account_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Bank_Identifier_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Identifier_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Identifier_Type_Order_By>>;
  where?: Maybe<Risolto_Bank_Identifier_Type_Bool_Exp>;
};


export type Query_RootRisolto_Bank_Identifier_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Identifier_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Identifier_Type_Order_By>>;
  where?: Maybe<Risolto_Bank_Identifier_Type_Bool_Exp>;
};


export type Query_RootRisolto_Bank_Identifier_Type_By_PkArgs = {
  bank_identifier_type: Scalars['String'];
};


export type Query_RootRisolto_BlacklistArgs = {
  distinct_on?: Maybe<Array<Risolto_Blacklist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Blacklist_Order_By>>;
  where?: Maybe<Risolto_Blacklist_Bool_Exp>;
};


export type Query_RootRisolto_Blacklist_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Blacklist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Blacklist_Order_By>>;
  where?: Maybe<Risolto_Blacklist_Bool_Exp>;
};


export type Query_RootRisolto_Blacklist_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_ChannelArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Order_By>>;
  where?: Maybe<Risolto_Channel_Bool_Exp>;
};


export type Query_RootRisolto_Channel_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Order_By>>;
  where?: Maybe<Risolto_Channel_Bool_Exp>;
};


export type Query_RootRisolto_Channel_By_PkArgs = {
  channel: Scalars['String'];
};


export type Query_RootRisolto_Channel_EndpointArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Channel_Endpoint_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Channel_Endpoint_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Clid2recidArgs = {
  args: Risolto_Clid2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Query_RootRisolto_Clid2recid_AggregateArgs = {
  args: Risolto_Clid2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Query_RootRisolto_Clip2recidArgs = {
  args: Risolto_Clip2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Clip2recid_AggregateArgs = {
  args: Risolto_Clip2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_CommunicationArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Order_By>>;
  where?: Maybe<Risolto_Communication_Bool_Exp>;
};


export type Query_RootRisolto_Communication_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Order_By>>;
  where?: Maybe<Risolto_Communication_Bool_Exp>;
};


export type Query_RootRisolto_Communication_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Communication_TemplateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Bool_Exp>;
};


export type Query_RootRisolto_Communication_Template_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Bool_Exp>;
};


export type Query_RootRisolto_Communication_Template_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Communication_Template_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Type_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Type_Bool_Exp>;
};


export type Query_RootRisolto_Communication_Template_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Type_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Type_Bool_Exp>;
};


export type Query_RootRisolto_Communication_Template_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootRisolto_ContactArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Order_By>>;
  where?: Maybe<Risolto_Contact_Bool_Exp>;
};


export type Query_RootRisolto_Contact_AddressArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Address_Order_By>>;
  where?: Maybe<Risolto_Contact_Address_Bool_Exp>;
};


export type Query_RootRisolto_Contact_Address_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Address_Order_By>>;
  where?: Maybe<Risolto_Contact_Address_Bool_Exp>;
};


export type Query_RootRisolto_Contact_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Order_By>>;
  where?: Maybe<Risolto_Contact_Bool_Exp>;
};


export type Query_RootRisolto_Contact_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Contact_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Type_Order_By>>;
  where?: Maybe<Risolto_Contact_Type_Bool_Exp>;
};


export type Query_RootRisolto_Contact_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Type_Order_By>>;
  where?: Maybe<Risolto_Contact_Type_Bool_Exp>;
};


export type Query_RootRisolto_Contact_Type_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Content_DispositionArgs = {
  distinct_on?: Maybe<Array<Risolto_Content_Disposition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Content_Disposition_Order_By>>;
  where?: Maybe<Risolto_Content_Disposition_Bool_Exp>;
};


export type Query_RootRisolto_Content_Disposition_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Content_Disposition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Content_Disposition_Order_By>>;
  where?: Maybe<Risolto_Content_Disposition_Bool_Exp>;
};


export type Query_RootRisolto_Content_Disposition_By_PkArgs = {
  content_disposition: Scalars['String'];
};


export type Query_RootRisolto_Credit_LimitArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
};


export type Query_RootRisolto_Credit_Limit_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
};


export type Query_RootRisolto_Credit_Limit_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Credit_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};


export type Query_RootRisolto_Credit_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};


export type Query_RootRisolto_Credit_Note_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Attachment_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Credit_Note_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Attachment_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Credit_Note_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Credit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_CurrencyArgs = {
  distinct_on?: Maybe<Array<Risolto_Currency_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Currency_Order_By>>;
  where?: Maybe<Risolto_Currency_Bool_Exp>;
};


export type Query_RootRisolto_Currency_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Currency_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Currency_Order_By>>;
  where?: Maybe<Risolto_Currency_Bool_Exp>;
};


export type Query_RootRisolto_Currency_By_PkArgs = {
  currency: Scalars['String'];
};


export type Query_RootRisolto_Dashboard_Actions_By_Channel_And_Status_Count_V1Args = {
  args: Risolto_Dashboard_Actions_By_Channel_And_Status_Count_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Query_RootRisolto_Dashboard_Actions_By_Channel_And_Status_Count_V1_AggregateArgs = {
  args: Risolto_Dashboard_Actions_By_Channel_And_Status_Count_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Query_RootRisolto_Dashboard_Outstanding_DebtArgs = {
  args: Risolto_Dashboard_Outstanding_Debt_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Query_RootRisolto_Dashboard_Outstanding_Debt_AggregateArgs = {
  args: Risolto_Dashboard_Outstanding_Debt_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Query_RootRisolto_Dashboard_TotalsArgs = {
  args: Risolto_Dashboard_Totals_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Dashboard_Totals_AggregateArgs = {
  args: Risolto_Dashboard_Totals_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Dashboard_Totals_V2Args = {
  args: Risolto_Dashboard_Totals_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Dashboard_Totals_V2_AggregateArgs = {
  args: Risolto_Dashboard_Totals_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Debit_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};


export type Query_RootRisolto_Debit_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};


export type Query_RootRisolto_Debit_Note_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Attachment_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Debit_Note_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Attachment_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Debit_Note_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Debit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Demo_Action_Report_1_V1Args = {
  args: Risolto_Demo_Action_Report_1_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Order_By>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Query_RootRisolto_Demo_Action_Report_1_V1_AggregateArgs = {
  args: Risolto_Demo_Action_Report_1_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Order_By>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_MandateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Mandate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Mandate_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Mandate_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Mandate_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Mandate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Mandate_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Mandate_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Mandate_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Direct_Debit_ProviderArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Provider_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Provider_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Provider_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Provider_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Provider_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Provider_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Provider_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Provider_By_PkArgs = {
  provider: Scalars['String'];
};


export type Query_RootRisolto_Direct_Debit_SchemeArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Scheme_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Scheme_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Scheme_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Scheme_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Scheme_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Scheme_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Scheme_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Scheme_By_PkArgs = {
  scheme: Scalars['String'];
};


export type Query_RootRisolto_Direct_Debit_Sequence_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Sequence_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Sequence_Type_By_PkArgs = {
  sequence_type: Scalars['String'];
};


export type Query_RootRisolto_Direct_Debit_TransactionArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Transaction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Transaction_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Transaction_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Transaction_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Transaction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Transaction_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Transaction_Bool_Exp>;
};


export type Query_RootRisolto_Direct_Debit_Transaction_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Dispute_CodeArgs = {
  distinct_on?: Maybe<Array<Risolto_Dispute_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dispute_Code_Order_By>>;
  where?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
};


export type Query_RootRisolto_Dispute_Code_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dispute_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dispute_Code_Order_By>>;
  where?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
};


export type Query_RootRisolto_Dispute_Code_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Document_Attachment_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Attachment_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Attachment_Type_Order_By>>;
  where?: Maybe<Risolto_Document_Attachment_Type_Bool_Exp>;
};


export type Query_RootRisolto_Document_Attachment_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Attachment_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Attachment_Type_Order_By>>;
  where?: Maybe<Risolto_Document_Attachment_Type_Bool_Exp>;
};


export type Query_RootRisolto_Document_Attachment_Type_By_PkArgs = {
  attachment_type: Scalars['String'];
};


export type Query_RootRisolto_Document_InterchangeArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Attachment_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Attachment_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Document_Interchange_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Document_Interchange_DirectionArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Direction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Direction_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Direction_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_Direction_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Direction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Direction_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Direction_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_Direction_By_PkArgs = {
  direction: Scalars['String'];
};


export type Query_RootRisolto_Document_Interchange_EventArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_Event_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_Event_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Document_Interchange_LinkArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_Link_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


export type Query_RootRisolto_Document_Interchange_Link_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Dunning_NoticeArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Dunning_Notice_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Dunning_Notice_Invoice_RelationArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_Invoice_Relation_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_Invoice_Relation_By_PkArgs = {
  relation: Scalars['String'];
};


export type Query_RootRisolto_Dunning_Notice_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Status_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Status_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Status_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Status_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootRisolto_Dunning_Notice_Type_CodeArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Type_Code_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_Type_Code_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Type_Code_Bool_Exp>;
};


export type Query_RootRisolto_Dunning_Notice_Type_Code_By_PkArgs = {
  type_code: Scalars['String'];
};


export type Query_RootRisolto_Fe_Recipient_Accounting_DocumentArgs = {
  args: Risolto_Fe_Recipient_Accounting_Document_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Fe_Recipient_Accounting_Document_AggregateArgs = {
  args: Risolto_Fe_Recipient_Accounting_Document_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_FrequencyArgs = {
  distinct_on?: Maybe<Array<Risolto_Frequency_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Frequency_Order_By>>;
  where?: Maybe<Risolto_Frequency_Bool_Exp>;
};


export type Query_RootRisolto_Frequency_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Frequency_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Frequency_Order_By>>;
  where?: Maybe<Risolto_Frequency_Bool_Exp>;
};


export type Query_RootRisolto_Frequency_By_PkArgs = {
  frequency: Scalars['String'];
};


export type Query_RootRisolto_Grant_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Grant_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Grant_Type_Order_By>>;
  where?: Maybe<Risolto_Grant_Type_Bool_Exp>;
};


export type Query_RootRisolto_Grant_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Grant_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Grant_Type_Order_By>>;
  where?: Maybe<Risolto_Grant_Type_Bool_Exp>;
};


export type Query_RootRisolto_Grant_Type_By_PkArgs = {
  grant_type: Scalars['String'];
};


export type Query_RootRisolto_Hohr_Cvt_List_DataArgs = {
  args: Risolto_Hohr_Cvt_List_Data_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Hohr_Cvt_List_Data_AggregateArgs = {
  args: Risolto_Hohr_Cvt_List_Data_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_CollectionArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Collection_Order_By>>;
  where?: Maybe<Risolto_Invoice_Collection_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Collection_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Collection_Order_By>>;
  where?: Maybe<Risolto_Invoice_Collection_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Collection_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_DisputeArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Dispute_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Dispute_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_DocumentArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Attachment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Attachment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_Document_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_Document_Details_SearchArgs = {
  args: Risolto_Invoice_Document_Details_Search_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Details_Search10Args = {
  args: Risolto_Invoice_Document_Details_Search10_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Details_Search100Args = {
  args: Risolto_Invoice_Document_Details_Search100_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Details_Search100_AggregateArgs = {
  args: Risolto_Invoice_Document_Details_Search100_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Details_Search10_AggregateArgs = {
  args: Risolto_Invoice_Document_Details_Search10_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Details_Search_AggregateArgs = {
  args: Risolto_Invoice_Document_Details_Search_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Status_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Status_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Status_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Status_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Document_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootRisolto_Invoice_GroupArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_Group_Credit_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Credit_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Credit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_Group_Debit_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Debit_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Debit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_Group_Dunning_RunArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Dunning_Run_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_Group_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_Group_PaymentArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Payment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoice_Group_Payment_PromiseArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Payment_Promise_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


export type Query_RootRisolto_Invoice_Group_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Invoicing_Channel_Endpoints_V1Args = {
  args: Risolto_Invoicing_Channel_Endpoints_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Invoicing_Channel_Endpoints_V1_AggregateArgs = {
  args: Risolto_Invoicing_Channel_Endpoints_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Invoicing_Channel_Endpoints_V2Args = {
  args: Risolto_Invoicing_Channel_Endpoints_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Invoicing_Channel_Endpoints_V2_AggregateArgs = {
  args: Risolto_Invoicing_Channel_Endpoints_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Iso_Country_CodeArgs = {
  distinct_on?: Maybe<Array<Risolto_Iso_Country_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Iso_Country_Code_Order_By>>;
  where?: Maybe<Risolto_Iso_Country_Code_Bool_Exp>;
};


export type Query_RootRisolto_Iso_Country_Code_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Iso_Country_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Iso_Country_Code_Order_By>>;
  where?: Maybe<Risolto_Iso_Country_Code_Bool_Exp>;
};


export type Query_RootRisolto_Iso_Country_Code_By_PkArgs = {
  country_code: Scalars['String'];
};


export type Query_RootRisolto_JobArgs = {
  distinct_on?: Maybe<Array<Risolto_Job_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Job_Order_By>>;
  where?: Maybe<Risolto_Job_Bool_Exp>;
};


export type Query_RootRisolto_Job_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Job_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Job_Order_By>>;
  where?: Maybe<Risolto_Job_Bool_Exp>;
};


export type Query_RootRisolto_Job_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Language_CodeArgs = {
  distinct_on?: Maybe<Array<Risolto_Language_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Language_Code_Order_By>>;
  where?: Maybe<Risolto_Language_Code_Bool_Exp>;
};


export type Query_RootRisolto_Language_Code_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Language_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Language_Code_Order_By>>;
  where?: Maybe<Risolto_Language_Code_Bool_Exp>;
};


export type Query_RootRisolto_Language_Code_By_PkArgs = {
  language_code: Scalars['String'];
};


export type Query_RootRisolto_Legal_EntityArgs = {
  distinct_on?: Maybe<Array<Risolto_Legal_Entity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Legal_Entity_Order_By>>;
  where?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
};


export type Query_RootRisolto_Legal_Entity_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Legal_Entity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Legal_Entity_Order_By>>;
  where?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
};


export type Query_RootRisolto_Legal_Entity_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_LocaleArgs = {
  distinct_on?: Maybe<Array<Risolto_Locale_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Locale_Order_By>>;
  where?: Maybe<Risolto_Locale_Bool_Exp>;
};


export type Query_RootRisolto_Locale_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Locale_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Locale_Order_By>>;
  where?: Maybe<Risolto_Locale_Bool_Exp>;
};


export type Query_RootRisolto_Locale_By_PkArgs = {
  locale: Scalars['String'];
};


export type Query_RootRisolto_Magda_CacheArgs = {
  distinct_on?: Maybe<Array<Risolto_Magda_Cache_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Magda_Cache_Order_By>>;
  where?: Maybe<Risolto_Magda_Cache_Bool_Exp>;
};


export type Query_RootRisolto_Magda_Cache_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Magda_Cache_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Magda_Cache_Order_By>>;
  where?: Maybe<Risolto_Magda_Cache_Bool_Exp>;
};


export type Query_RootRisolto_Magda_Cache_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Magda_Service_Audit_LogArgs = {
  distinct_on?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Order_By>>;
  where?: Maybe<Risolto_Magda_Service_Audit_Log_Bool_Exp>;
};


export type Query_RootRisolto_Magda_Service_Audit_Log_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Order_By>>;
  where?: Maybe<Risolto_Magda_Service_Audit_Log_Bool_Exp>;
};


export type Query_RootRisolto_Magda_Service_Audit_Log_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Mailbox_Actions_And_MessagesArgs = {
  args: Risolto_Mailbox_Actions_And_Messages_Args;
  distinct_on?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Action_And_Message_Order_By>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Query_RootRisolto_Mailbox_Actions_And_Messages_AggregateArgs = {
  args: Risolto_Mailbox_Actions_And_Messages_Args;
  distinct_on?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Action_And_Message_Order_By>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Query_RootRisolto_Materialized_View_DefinitionArgs = {
  distinct_on?: Maybe<Array<Risolto_Materialized_View_Definition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Materialized_View_Definition_Order_By>>;
  where?: Maybe<Risolto_Materialized_View_Definition_Bool_Exp>;
};


export type Query_RootRisolto_Materialized_View_Definition_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Materialized_View_Definition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Materialized_View_Definition_Order_By>>;
  where?: Maybe<Risolto_Materialized_View_Definition_Bool_Exp>;
};


export type Query_RootRisolto_Materialized_View_Definition_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_MessageArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Order_By>>;
  where?: Maybe<Risolto_Message_Bool_Exp>;
};


export type Query_RootRisolto_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Order_By>>;
  where?: Maybe<Risolto_Message_Bool_Exp>;
};


export type Query_RootRisolto_Message_AssigneeArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Assignee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Assignee_Order_By>>;
  where?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
};


export type Query_RootRisolto_Message_Assignee_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Assignee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Assignee_Order_By>>;
  where?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
};


export type Query_RootRisolto_Message_Assignee_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Message_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Attachment_Order_By>>;
  where?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Message_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Attachment_Order_By>>;
  where?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Message_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Message_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Message_LabelArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Label_Bool_Exp>;
};


export type Query_RootRisolto_Message_Label_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Label_Bool_Exp>;
};


export type Query_RootRisolto_Message_Label_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Message_Message_LabelArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
};


export type Query_RootRisolto_Message_Message_Label_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
};


export type Query_RootRisolto_Message_Message_Label_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Message_RecipientArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Recipient_Order_By>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


export type Query_RootRisolto_Message_Recipient_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Recipient_Order_By>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


export type Query_RootRisolto_Message_Recipient_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Mime_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Mime_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Mime_Type_Order_By>>;
  where?: Maybe<Risolto_Mime_Type_Bool_Exp>;
};


export type Query_RootRisolto_Mime_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Mime_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Mime_Type_Order_By>>;
  where?: Maybe<Risolto_Mime_Type_Bool_Exp>;
};


export type Query_RootRisolto_Mime_Type_By_PkArgs = {
  mime_type: Scalars['String'];
};


export type Query_RootRisolto_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


export type Query_RootRisolto_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


export type Query_RootRisolto_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Note_CategoryArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Category_Order_By>>;
  where?: Maybe<Risolto_Note_Category_Bool_Exp>;
};


export type Query_RootRisolto_Note_Category_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Category_Order_By>>;
  where?: Maybe<Risolto_Note_Category_Bool_Exp>;
};


export type Query_RootRisolto_Note_Category_By_PkArgs = {
  category: Scalars['String'];
};


export type Query_RootRisolto_Note_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Invoice_Order_By>>;
  where?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Note_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Invoice_Order_By>>;
  where?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Note_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Open_BalanceArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Bool_Exp>;
};


export type Query_RootRisolto_Open_Balance_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Bool_Exp>;
};


export type Query_RootRisolto_Open_Balance_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Open_Balance_RecordArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


export type Query_RootRisolto_Open_Balance_Record_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


export type Query_RootRisolto_Open_Balance_Record_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_OriginArgs = {
  distinct_on?: Maybe<Array<Risolto_Origin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Origin_Order_By>>;
  where?: Maybe<Risolto_Origin_Bool_Exp>;
};


export type Query_RootRisolto_Origin_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Origin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Origin_Order_By>>;
  where?: Maybe<Risolto_Origin_Bool_Exp>;
};


export type Query_RootRisolto_Origin_By_PkArgs = {
  origin: Scalars['String'];
};


export type Query_RootRisolto_ParticipantArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Order_By>>;
  where?: Maybe<Risolto_Participant_Bool_Exp>;
};


export type Query_RootRisolto_Participant_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Order_By>>;
  where?: Maybe<Risolto_Participant_Bool_Exp>;
};


export type Query_RootRisolto_Participant_Api_App_ClientArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


export type Query_RootRisolto_Participant_Api_App_Client_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


export type Query_RootRisolto_Participant_Api_App_Client_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Participant_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Participant_Dunning_RunArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
};


export type Query_RootRisolto_Participant_Dunning_Run_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
};


export type Query_RootRisolto_Participant_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Participant_UserArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


export type Query_RootRisolto_Participant_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


export type Query_RootRisolto_Participant_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Participant_User_RoleArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Role_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
};


export type Query_RootRisolto_Participant_User_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Role_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
};


export type Query_RootRisolto_Participant_User_Role_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_PaymentArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


export type Query_RootRisolto_Payment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


export type Query_RootRisolto_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Payment_DocumentArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Document_Order_By>>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Document_Order_By>>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Document_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Payment_LinkArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Link_Order_By>>;
  where?: Maybe<Risolto_Payment_Link_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Link_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Link_Order_By>>;
  where?: Maybe<Risolto_Payment_Link_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Link_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Payment_PlanArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Plan_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Plan_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Payment_PromiseArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Promise_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Payment_TransferArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Bulk_PaymentArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Bulk_Payment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Bulk_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Payment_Transfer_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Payment_Transfer_LineArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Line_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Line_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Payment_Transfer_Line_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Type_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Line_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Type_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Line_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootRisolto_Payment_Transfer_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Status_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Status_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Status_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Status_Bool_Exp>;
};


export type Query_RootRisolto_Payment_Transfer_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootRisolto_PersonArgs = {
  distinct_on?: Maybe<Array<Risolto_Person_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Person_Order_By>>;
  where?: Maybe<Risolto_Person_Bool_Exp>;
};


export type Query_RootRisolto_Person_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Person_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Person_Order_By>>;
  where?: Maybe<Risolto_Person_Bool_Exp>;
};


export type Query_RootRisolto_Person_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Platform_License_ModuleArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_License_Module_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_License_Module_Order_By>>;
  where?: Maybe<Risolto_Platform_License_Module_Bool_Exp>;
};


export type Query_RootRisolto_Platform_License_Module_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_License_Module_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_License_Module_Order_By>>;
  where?: Maybe<Risolto_Platform_License_Module_Bool_Exp>;
};


export type Query_RootRisolto_Platform_License_Module_By_PkArgs = {
  platform_license_module: Scalars['String'];
};


export type Query_RootRisolto_Platform_Participant_LicenseArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Participant_License_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Participant_License_Order_By>>;
  where?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Participant_License_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Participant_License_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Participant_License_Order_By>>;
  where?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Participant_License_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Platform_PermissionArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Permission_Order_By>>;
  where?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Permission_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Permission_Order_By>>;
  where?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Permission_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Platform_RoleArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Role_Order_By>>;
  where?: Maybe<Risolto_Platform_Role_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Role_Order_By>>;
  where?: Maybe<Risolto_Platform_Role_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Role_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Platform_Role_PermissionArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Role_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Role_Permission_Order_By>>;
  where?: Maybe<Risolto_Platform_Role_Permission_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Role_Permission_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Role_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Role_Permission_Order_By>>;
  where?: Maybe<Risolto_Platform_Role_Permission_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Role_Permission_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Platform_UsageArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Usage_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Usage_Order_By>>;
  where?: Maybe<Risolto_Platform_Usage_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Usage_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Usage_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Usage_Order_By>>;
  where?: Maybe<Risolto_Platform_Usage_Bool_Exp>;
};


export type Query_RootRisolto_Platform_Usage_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Proof_Of_Delivery_BarcodeArgs = {
  args: Risolto_Proof_Of_Delivery_Barcode_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Proof_Of_Delivery_Barcode_AggregateArgs = {
  args: Risolto_Proof_Of_Delivery_Barcode_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Proof_Of_Delivery_Barcode_V2Args = {
  args: Risolto_Proof_Of_Delivery_Barcode_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Proof_Of_Delivery_Barcode_V2_AggregateArgs = {
  args: Risolto_Proof_Of_Delivery_Barcode_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_RecipientArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_AddressArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Address_Order_By>>;
  where?: Maybe<Risolto_Recipient_Address_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Address_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Address_Order_By>>;
  where?: Maybe<Risolto_Recipient_Address_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Attachment_Order_By>>;
  where?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Attachment_Order_By>>;
  where?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Recipient_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Recipient_CollectionArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Collection_Order_By>>;
  where?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Collection_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Collection_Order_By>>;
  where?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Collection_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Recipient_CommunicationArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Communication_Order_By>>;
  where?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Communication_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Communication_Order_By>>;
  where?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Communication_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Recipient_Dunning_ExcludeArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Dunning_Exclude_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Dunning_Exclude_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Recipient_Dunning_RunArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Dunning_Run_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Recipient_Find_Similar_By_NameArgs = {
  args: Risolto_Recipient_Find_Similar_By_Name_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Find_Similar_By_Name_AggregateArgs = {
  args: Risolto_Recipient_Find_Similar_By_Name_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_MergeArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Merge_Order_By>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Merge_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Merge_Order_By>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Merge_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Recipient_TagArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_Tag_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Recipient_UserArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_User_Order_By>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_User_Order_By>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};


export type Query_RootRisolto_Recipient_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Reference_DataArgs = {
  distinct_on?: Maybe<Array<Risolto_Reference_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Reference_Data_Order_By>>;
  where?: Maybe<Risolto_Reference_Data_Bool_Exp>;
};


export type Query_RootRisolto_Reference_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Reference_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Reference_Data_Order_By>>;
  where?: Maybe<Risolto_Reference_Data_Bool_Exp>;
};


export type Query_RootRisolto_Reference_Data_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Report_Action_EventsArgs = {
  args: Risolto_Report_Action_Events_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Query_RootRisolto_Report_Action_Events_AggregateArgs = {
  args: Risolto_Report_Action_Events_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Query_RootRisolto_Report_Action_Events_V2Args = {
  args: Risolto_Report_Action_Events_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Query_RootRisolto_Report_Action_Events_V2_AggregateArgs = {
  args: Risolto_Report_Action_Events_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Query_RootRisolto_Report_DefinitionArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Definition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Definition_Order_By>>;
  where?: Maybe<Risolto_Report_Definition_Bool_Exp>;
};


export type Query_RootRisolto_Report_Definition_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Definition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Definition_Order_By>>;
  where?: Maybe<Risolto_Report_Definition_Bool_Exp>;
};


export type Query_RootRisolto_Report_Definition_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Report_ExecutionArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_Bool_Exp>;
};


export type Query_RootRisolto_Report_Execution_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_Bool_Exp>;
};


export type Query_RootRisolto_Report_Execution_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Report_Execution_UserArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_User_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_User_Bool_Exp>;
};


export type Query_RootRisolto_Report_Execution_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_User_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_User_Bool_Exp>;
};


export type Query_RootRisolto_Report_Execution_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Report_Monthly_Delivery_V1Args = {
  args: Risolto_Report_Monthly_Delivery_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Query_RootRisolto_Report_Monthly_Delivery_V1_AggregateArgs = {
  args: Risolto_Report_Monthly_Delivery_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Query_RootRisolto_Report_Template_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Template_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Template_Type_Order_By>>;
  where?: Maybe<Risolto_Report_Template_Type_Bool_Exp>;
};


export type Query_RootRisolto_Report_Template_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Template_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Template_Type_Order_By>>;
  where?: Maybe<Risolto_Report_Template_Type_Bool_Exp>;
};


export type Query_RootRisolto_Report_Template_Type_By_PkArgs = {
  report_template_type: Scalars['String'];
};


export type Query_RootRisolto_Report_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Type_Order_By>>;
  where?: Maybe<Risolto_Report_Type_Bool_Exp>;
};


export type Query_RootRisolto_Report_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Type_Order_By>>;
  where?: Maybe<Risolto_Report_Type_Bool_Exp>;
};


export type Query_RootRisolto_Report_Type_By_PkArgs = {
  report_type: Scalars['String'];
};


export type Query_RootRisolto_Report_UserArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_User_Order_By>>;
  where?: Maybe<Risolto_Report_User_Bool_Exp>;
};


export type Query_RootRisolto_Report_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_User_Order_By>>;
  where?: Maybe<Risolto_Report_User_Bool_Exp>;
};


export type Query_RootRisolto_Report_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Run_Processing_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Run_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Run_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Run_Processing_Status_Bool_Exp>;
};


export type Query_RootRisolto_Run_Processing_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Run_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Run_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Run_Processing_Status_Bool_Exp>;
};


export type Query_RootRisolto_Run_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


export type Query_RootRisolto_Search2recidArgs = {
  args: Risolto_Search2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Query_RootRisolto_Search2recid_AggregateArgs = {
  args: Risolto_Search2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Query_RootRisolto_Single_Sign_OnArgs = {
  distinct_on?: Maybe<Array<Risolto_Single_Sign_On_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Single_Sign_On_Order_By>>;
  where?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
};


export type Query_RootRisolto_Single_Sign_On_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Single_Sign_On_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Single_Sign_On_Order_By>>;
  where?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
};


export type Query_RootRisolto_Single_Sign_On_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_StatementArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Order_By>>;
  where?: Maybe<Risolto_Statement_Bool_Exp>;
};


export type Query_RootRisolto_Statement_AccountArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Account_Order_By>>;
  where?: Maybe<Risolto_Statement_Account_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Account_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Account_Order_By>>;
  where?: Maybe<Risolto_Statement_Account_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Account_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Statement_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Order_By>>;
  where?: Maybe<Risolto_Statement_Bool_Exp>;
};


export type Query_RootRisolto_Statement_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Statement_LineArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Statement_Line_Dunning_NoticeArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Dunning_Notice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Dunning_Notice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Statement_Line_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Invoice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Invoice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Statement_Line_Payment_PromiseArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Payment_Promise_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Statement_Line_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Status_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Status_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Status_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Status_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootRisolto_Statement_Line_Structured_MatchArgs = {
  args: Risolto_Statement_Line_Structured_Match_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Structured_Match_AggregateArgs = {
  args: Risolto_Statement_Line_Structured_Match_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Unstructured_MatchArgs = {
  args: Risolto_Statement_Line_Unstructured_Match_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Statement_Line_Unstructured_Match_AggregateArgs = {
  args: Risolto_Statement_Line_Unstructured_Match_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Strigil_NbbArgs = {
  distinct_on?: Maybe<Array<Risolto_Strigil_Nbb_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Strigil_Nbb_Order_By>>;
  where?: Maybe<Risolto_Strigil_Nbb_Bool_Exp>;
};


export type Query_RootRisolto_Strigil_Nbb_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Strigil_Nbb_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Strigil_Nbb_Order_By>>;
  where?: Maybe<Risolto_Strigil_Nbb_Bool_Exp>;
};


export type Query_RootRisolto_Strigil_Nbb_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Strigil_Nbb_Processing_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>;
};


export type Query_RootRisolto_Strigil_Nbb_Processing_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>;
};


export type Query_RootRisolto_Strigil_Nbb_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


export type Query_RootRisolto_System_IntegrationArgs = {
  distinct_on?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_System_Integration_Order_By>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};


export type Query_RootRisolto_System_Integration_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_System_Integration_Order_By>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};


export type Query_RootRisolto_System_Integration_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_TagArgs = {
  distinct_on?: Maybe<Array<Risolto_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tag_Order_By>>;
  where?: Maybe<Risolto_Tag_Bool_Exp>;
};


export type Query_RootRisolto_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tag_Order_By>>;
  where?: Maybe<Risolto_Tag_Bool_Exp>;
};


export type Query_RootRisolto_Tag_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_TaskArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Order_By>>;
  where?: Maybe<Risolto_Task_Bool_Exp>;
};


export type Query_RootRisolto_Task_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Order_By>>;
  where?: Maybe<Risolto_Task_Bool_Exp>;
};


export type Query_RootRisolto_Task_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Task_SourceArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Source_Order_By>>;
  where?: Maybe<Risolto_Task_Source_Bool_Exp>;
};


export type Query_RootRisolto_Task_Source_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Source_Order_By>>;
  where?: Maybe<Risolto_Task_Source_Bool_Exp>;
};


export type Query_RootRisolto_Task_Source_By_PkArgs = {
  source: Scalars['String'];
};


export type Query_RootRisolto_Task_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Status_Order_By>>;
  where?: Maybe<Risolto_Task_Status_Bool_Exp>;
};


export type Query_RootRisolto_Task_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Status_Order_By>>;
  where?: Maybe<Risolto_Task_Status_Bool_Exp>;
};


export type Query_RootRisolto_Task_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Query_RootRisolto_Task_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Type_Order_By>>;
  where?: Maybe<Risolto_Task_Type_Bool_Exp>;
};


export type Query_RootRisolto_Task_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Type_Order_By>>;
  where?: Maybe<Risolto_Task_Type_Bool_Exp>;
};


export type Query_RootRisolto_Task_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootRisolto_Tone_Of_VoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Tone_Of_Voice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tone_Of_Voice_Order_By>>;
  where?: Maybe<Risolto_Tone_Of_Voice_Bool_Exp>;
};


export type Query_RootRisolto_Tone_Of_Voice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Tone_Of_Voice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tone_Of_Voice_Order_By>>;
  where?: Maybe<Risolto_Tone_Of_Voice_Bool_Exp>;
};


export type Query_RootRisolto_Tone_Of_Voice_By_PkArgs = {
  tone_of_voice: Scalars['String'];
};


export type Query_RootRisolto_View_Action_And_MessageArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Action_And_Message_Order_By>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Query_RootRisolto_View_Action_And_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Action_And_Message_Order_By>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Query_RootRisolto_View_Credit_LimitArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_View_Credit_Limit_Bool_Exp>;
};


export type Query_RootRisolto_View_Credit_Limit_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_View_Credit_Limit_Bool_Exp>;
};


export type Query_RootRisolto_View_Dashboard_Aging_DebtArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Order_By>>;
  where?: Maybe<Risolto_View_Dashboard_Aging_Debt_Bool_Exp>;
};


export type Query_RootRisolto_View_Dashboard_Aging_Debt_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Order_By>>;
  where?: Maybe<Risolto_View_Dashboard_Aging_Debt_Bool_Exp>;
};


export type Query_RootRisolto_View_Dashboard_Percentage_Paying_Within_30_DaysArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Order_By>>;
  where?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp>;
};


export type Query_RootRisolto_View_Dashboard_Percentage_Paying_Within_30_Days_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Order_By>>;
  where?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp>;
};


export type Query_RootRisolto_View_Dunning_Notice_Action_6mArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Order_By>>;
  where?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Bool_Exp>;
};


export type Query_RootRisolto_View_Dunning_Notice_Action_6m_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Order_By>>;
  where?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Bool_Exp>;
};


export type Query_RootRisolto_View_Invoice_FeaturesArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_View_Invoice_Features_Bool_Exp>;
};


export type Query_RootRisolto_View_Invoice_Features_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_View_Invoice_Features_Bool_Exp>;
};


export type Query_RootRisolto_View_Legal_Entity_TemplateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Legal_Entity_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Legal_Entity_Template_Order_By>>;
  where?: Maybe<Risolto_View_Legal_Entity_Template_Bool_Exp>;
};


export type Query_RootRisolto_View_Legal_Entity_Template_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Legal_Entity_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Legal_Entity_Template_Order_By>>;
  where?: Maybe<Risolto_View_Legal_Entity_Template_Bool_Exp>;
};


export type Query_RootRisolto_View_Platform_Licence_PermissionArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Order_By>>;
  where?: Maybe<Risolto_View_Platform_Licence_Permission_Bool_Exp>;
};


export type Query_RootRisolto_View_Platform_Licence_Permission_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Order_By>>;
  where?: Maybe<Risolto_View_Platform_Licence_Permission_Bool_Exp>;
};


export type Query_RootRisolto_View_Recipient_TagArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
};


export type Query_RootRisolto_View_Recipient_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_And_DisputeArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_And_Dispute_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_And_Dispute_And_MessageArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_And_Dispute_And_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_And_Dispute_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Action_And_Note_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Action_And_Note_V1Args = {
  args: Risolto_Virtual_Action_And_Note_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_V1_AggregateArgs = {
  args: Risolto_Virtual_Action_And_Note_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_V3Args = {
  args: Risolto_Virtual_Action_And_Note_V3_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_V3_AggregateArgs = {
  args: Risolto_Virtual_Action_And_Note_V3_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_V4Args = {
  args: Risolto_Virtual_Action_And_Note_V4_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_V4_AggregateArgs = {
  args: Risolto_Virtual_Action_And_Note_V4_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_V5Args = {
  args: Risolto_Virtual_Action_And_Note_V5_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_And_Note_V5_AggregateArgs = {
  args: Risolto_Virtual_Action_And_Note_V5_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_GroupArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Action_Group_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Dashboard_Action_StatsArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Dashboard_Action_Stats_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Dashboard_Action_Stats_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Dashboard_Outstanding_DebtArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Dashboard_Outstanding_Debt_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Dashboard_Outstanding_Debt_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Demo_Action_Report_1Args = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Order_By>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Demo_Action_Report_1_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Order_By>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Demo_Action_Report_1_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Dunning_ActionArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Dunning_Action_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Dunning_Action_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Interchange_EventArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Interchange_Event_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Interchange_Event_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Invoice_Derived_Payment_InformationArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Invoice_Derived_Payment_Information_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Invoice_Derived_Payment_Information_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Invoicing_Channel_EndpointArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Invoicing_Channel_Endpoint_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Invoicing_Channel_Endpoint_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_JsonArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Json_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Json_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_Virtual_Report_DeliveryArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Report_Delivery_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Query_RootRisolto_Virtual_Report_Delivery_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Query_RootRisolto_WebhookArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Order_By>>;
  where?: Maybe<Risolto_Webhook_Bool_Exp>;
};


export type Query_RootRisolto_Webhook_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Order_By>>;
  where?: Maybe<Risolto_Webhook_Bool_Exp>;
};


export type Query_RootRisolto_Webhook_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Query_RootRisolto_Webhook_Processing_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Webhook_Processing_Status_Bool_Exp>;
};


export type Query_RootRisolto_Webhook_Processing_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Webhook_Processing_Status_Bool_Exp>;
};


export type Query_RootRisolto_Webhook_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


export type Query_RootRisolto_Webhook_SubscriptionArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Subscription_Order_By>>;
  where?: Maybe<Risolto_Webhook_Subscription_Bool_Exp>;
};


export type Query_RootRisolto_Webhook_Subscription_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Subscription_Order_By>>;
  where?: Maybe<Risolto_Webhook_Subscription_Bool_Exp>;
};


export type Query_RootRisolto_Webhook_Subscription_By_PkArgs = {
  reference: Scalars['uuid'];
};

/** columns and relationships of "risolto.account_number_type" */
export type Risolto_Account_Number_Type = {
  __typename?: 'risolto_account_number_type';
  account_number_type: Scalars['String'];
};

/** aggregated selection of "risolto.account_number_type" */
export type Risolto_Account_Number_Type_Aggregate = {
  __typename?: 'risolto_account_number_type_aggregate';
  aggregate?: Maybe<Risolto_Account_Number_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Account_Number_Type>;
};

/** aggregate fields of "risolto.account_number_type" */
export type Risolto_Account_Number_Type_Aggregate_Fields = {
  __typename?: 'risolto_account_number_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Account_Number_Type_Max_Fields>;
  min?: Maybe<Risolto_Account_Number_Type_Min_Fields>;
};


/** aggregate fields of "risolto.account_number_type" */
export type Risolto_Account_Number_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Account_Number_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.account_number_type". All fields are combined with a logical 'AND'. */
export type Risolto_Account_Number_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Account_Number_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Account_Number_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Account_Number_Type_Bool_Exp>>;
  account_number_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.account_number_type" */
export enum Risolto_Account_Number_Type_Constraint {
  /** unique or primary key constraint on columns "account_number_type" */
  AccountNumberTypePkey = 'account_number_type_pkey'
}

export enum Risolto_Account_Number_Type_Enum {
  Iban = 'IBAN',
  Journal = 'JOURNAL'
}

/** Boolean expression to compare columns of type "risolto_account_number_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Account_Number_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Account_Number_Type_Enum>;
  _in?: Maybe<Array<Risolto_Account_Number_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Account_Number_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Account_Number_Type_Enum>>;
};

/** input type for inserting data into table "risolto.account_number_type" */
export type Risolto_Account_Number_Type_Insert_Input = {
  account_number_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Account_Number_Type_Max_Fields = {
  __typename?: 'risolto_account_number_type_max_fields';
  account_number_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Account_Number_Type_Min_Fields = {
  __typename?: 'risolto_account_number_type_min_fields';
  account_number_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.account_number_type" */
export type Risolto_Account_Number_Type_Mutation_Response = {
  __typename?: 'risolto_account_number_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Account_Number_Type>;
};

/** on_conflict condition type for table "risolto.account_number_type" */
export type Risolto_Account_Number_Type_On_Conflict = {
  constraint: Risolto_Account_Number_Type_Constraint;
  update_columns?: Array<Risolto_Account_Number_Type_Update_Column>;
  where?: Maybe<Risolto_Account_Number_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.account_number_type". */
export type Risolto_Account_Number_Type_Order_By = {
  account_number_type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.account_number_type */
export type Risolto_Account_Number_Type_Pk_Columns_Input = {
  account_number_type: Scalars['String'];
};

/** select columns of table "risolto.account_number_type" */
export enum Risolto_Account_Number_Type_Select_Column {
  /** column name */
  AccountNumberType = 'account_number_type'
}

/** input type for updating data in table "risolto.account_number_type" */
export type Risolto_Account_Number_Type_Set_Input = {
  account_number_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_account_number_type" */
export type Risolto_Account_Number_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Account_Number_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Account_Number_Type_Stream_Cursor_Value_Input = {
  account_number_type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.account_number_type" */
export enum Risolto_Account_Number_Type_Update_Column {
  /** column name */
  AccountNumberType = 'account_number_type'
}

export type Risolto_Account_Number_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Account_Number_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Account_Number_Type_Bool_Exp;
};

/** columns and relationships of "risolto.accounting_document" */
export type Risolto_Accounting_Document = {
  __typename?: 'risolto_accounting_document';
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  has_inbound_communication?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  /** An array relationship */
  recipient_users: Array<Risolto_Recipient_User>;
  /** An aggregate relationship */
  recipient_users_aggregate: Risolto_Recipient_User_Aggregate;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.accounting_document" */
export type Risolto_Accounting_DocumentCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.accounting_document" */
export type Risolto_Accounting_DocumentFile_ReferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.accounting_document" */
export type Risolto_Accounting_DocumentRecipient_UsersArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_User_Order_By>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};


/** columns and relationships of "risolto.accounting_document" */
export type Risolto_Accounting_DocumentRecipient_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_User_Order_By>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};

/** aggregated selection of "risolto.accounting_document" */
export type Risolto_Accounting_Document_Aggregate = {
  __typename?: 'risolto_accounting_document_aggregate';
  aggregate?: Maybe<Risolto_Accounting_Document_Aggregate_Fields>;
  nodes: Array<Risolto_Accounting_Document>;
};

export type Risolto_Accounting_Document_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Accounting_Document_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Accounting_Document_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Accounting_Document_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Accounting_Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Accounting_Document_Select_Column_Risolto_Accounting_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Accounting_Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Accounting_Document_Select_Column_Risolto_Accounting_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Accounting_Document_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Accounting_Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.accounting_document" */
export type Risolto_Accounting_Document_Aggregate_Fields = {
  __typename?: 'risolto_accounting_document_aggregate_fields';
  avg?: Maybe<Risolto_Accounting_Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Accounting_Document_Max_Fields>;
  min?: Maybe<Risolto_Accounting_Document_Min_Fields>;
  stddev?: Maybe<Risolto_Accounting_Document_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Accounting_Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Accounting_Document_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Accounting_Document_Sum_Fields>;
  var_pop?: Maybe<Risolto_Accounting_Document_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Accounting_Document_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Accounting_Document_Variance_Fields>;
};


/** aggregate fields of "risolto.accounting_document" */
export type Risolto_Accounting_Document_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Accounting_Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Accounting_Document_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Accounting_Document_Max_Order_By>;
  min?: Maybe<Risolto_Accounting_Document_Min_Order_By>;
  stddev?: Maybe<Risolto_Accounting_Document_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Accounting_Document_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Accounting_Document_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Accounting_Document_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Accounting_Document_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Accounting_Document_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Accounting_Document_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Accounting_Document_Insert_Input>;
};

/** aggregate avg on columns */
export type Risolto_Accounting_Document_Avg_Fields = {
  __typename?: 'risolto_accounting_document_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.accounting_document". All fields are combined with a logical 'AND'. */
export type Risolto_Accounting_Document_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Accounting_Document_Bool_Exp>>;
  _not?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Accounting_Document_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  document_number?: Maybe<String_Comparison_Exp>;
  document_type?: Maybe<String_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  file_references?: Maybe<Jsonb_Comparison_Exp>;
  has_inbound_communication?: Maybe<Boolean_Comparison_Exp>;
  issue_date?: Maybe<Date_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  origin?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  recipient_users?: Maybe<Risolto_Recipient_User_Bool_Exp>;
  recipient_users_aggregate?: Maybe<Risolto_Recipient_User_Aggregate_Bool_Exp>;
  short_code?: Maybe<String_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Insert_Input = {
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  has_inbound_communication?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  recipient_users?: Maybe<Risolto_Recipient_User_Arr_Rel_Insert_Input>;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Accounting_Document_Max_Fields = {
  __typename?: 'risolto_accounting_document_max_fields';
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Max_Order_By = {
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_number?: Maybe<Order_By>;
  document_type?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  short_code?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Accounting_Document_Min_Fields = {
  __typename?: 'risolto_accounting_document_min_fields';
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Min_Order_By = {
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_number?: Maybe<Order_By>;
  document_type?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  short_code?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** Ordering options when selecting data from "risolto.accounting_document". */
export type Risolto_Accounting_Document_Order_By = {
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  document_number?: Maybe<Order_By>;
  document_type?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  file_references?: Maybe<Order_By>;
  has_inbound_communication?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  recipient_users_aggregate?: Maybe<Risolto_Recipient_User_Aggregate_Order_By>;
  short_code?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "risolto.accounting_document" */
export enum Risolto_Accounting_Document_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DocumentNumber = 'document_number',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  HasInboundCommunication = 'has_inbound_communication',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  ShortCode = 'short_code',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_accounting_document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.accounting_document" */
export enum Risolto_Accounting_Document_Select_Column_Risolto_Accounting_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasInboundCommunication = 'has_inbound_communication'
}

/** select "risolto_accounting_document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.accounting_document" */
export enum Risolto_Accounting_Document_Select_Column_Risolto_Accounting_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasInboundCommunication = 'has_inbound_communication'
}

/** aggregate stddev on columns */
export type Risolto_Accounting_Document_Stddev_Fields = {
  __typename?: 'risolto_accounting_document_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Accounting_Document_Stddev_Pop_Fields = {
  __typename?: 'risolto_accounting_document_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Accounting_Document_Stddev_Samp_Fields = {
  __typename?: 'risolto_accounting_document_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_accounting_document" */
export type Risolto_Accounting_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Accounting_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Accounting_Document_Stream_Cursor_Value_Input = {
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  has_inbound_communication?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Accounting_Document_Sum_Fields = {
  __typename?: 'risolto_accounting_document_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Risolto_Accounting_Document_Var_Pop_Fields = {
  __typename?: 'risolto_accounting_document_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Accounting_Document_Var_Samp_Fields = {
  __typename?: 'risolto_accounting_document_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Accounting_Document_Variance_Fields = {
  __typename?: 'risolto_accounting_document_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.accounting_document" */
export type Risolto_Accounting_Document_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.action" */
export type Risolto_Action = {
  __typename?: 'risolto_action';
  /** An array relationship */
  action_interchanges: Array<Risolto_Action_Interchange>;
  /** An aggregate relationship */
  action_interchanges_aggregate: Risolto_Action_Interchange_Aggregate;
  /** An array relationship */
  action_invoices: Array<Risolto_Action_Invoice>;
  /** An aggregate relationship */
  action_invoices_aggregate: Risolto_Action_Invoice_Aggregate;
  assignee?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  assignee_by_reference?: Maybe<Risolto_Person>;
  /** User-provided text explaining why the action was canceled */
  cancel_reason?: Maybe<Scalars['String']>;
  /** Timestamp when the user (canceled_by) canceled the action due to cancel_reason */
  canceled_at?: Maybe<Scalars['timestamptz']>;
  /** Reference to the user who canceled the action */
  canceled_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  canceler_by_reference?: Maybe<Risolto_Person>;
  /** null */
  channel?: Maybe<Risolto_Channel_Enum>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  channel_endpoint_by_reference?: Maybe<Risolto_Channel_Endpoint>;
  channel_metadata: Scalars['jsonb'];
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  credit_note?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  credit_note_by_reference?: Maybe<Risolto_Credit_Note>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** null */
  due_date?: Maybe<Scalars['date']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice>;
  /** Timestamp when the system executed the action */
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  executed_by_reference?: Maybe<Risolto_Person>;
  /** MANUAL | SEMI-AUTOMATED | AUTOMATED */
  execution_type: Risolto_Action_Execution_Type_Enum;
  has_bounces?: Maybe<Scalars['Boolean']>;
  has_more_recent?: Maybe<Scalars['Boolean']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group>;
  is_retry?: Maybe<Scalars['Boolean']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  /** Code for the UI to render the action message. Example: fix_unreconciled */
  message_code: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  notes: Array<Risolto_Note>;
  /** An aggregate relationship */
  notes_aggregate: Risolto_Note_Aggregate;
  /** null */
  original_action?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  original_action_by_reference?: Maybe<Risolto_Action>;
  /** An array relationship */
  original_actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  original_actions_aggregate: Risolto_Action_Aggregate;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_plan?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_plan_by_reference?: Maybe<Risolto_Payment_Plan>;
  payment_promise?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  primary_invoice_by_reference?: Maybe<Risolto_Invoice_Document>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference: Scalars['uuid'];
  retry_count: Scalars['numeric'];
  /** Example: open_balance_reconciliation */
  source: Risolto_Action_Source_Enum;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** DRAFT | OPEN | DONE | CANCELED */
  status: Risolto_Action_Status_Enum;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionAction_InterchangesArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Interchange_Order_By>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionAction_Interchanges_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Interchange_Order_By>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionAction_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Invoice_Order_By>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionAction_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Invoice_Order_By>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionChannel_MetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionNotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionNotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionOriginal_ActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.action" */
export type Risolto_ActionOriginal_Actions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};

/** aggregated selection of "risolto.action" */
export type Risolto_Action_Aggregate = {
  __typename?: 'risolto_action_aggregate';
  aggregate?: Maybe<Risolto_Action_Aggregate_Fields>;
  nodes: Array<Risolto_Action>;
};

export type Risolto_Action_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Action_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Action_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Action_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Action_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.action" */
export type Risolto_Action_Aggregate_Fields = {
  __typename?: 'risolto_action_aggregate_fields';
  avg?: Maybe<Risolto_Action_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Action_Max_Fields>;
  min?: Maybe<Risolto_Action_Min_Fields>;
  stddev?: Maybe<Risolto_Action_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Action_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Action_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Action_Sum_Fields>;
  var_pop?: Maybe<Risolto_Action_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Action_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Action_Variance_Fields>;
};


/** aggregate fields of "risolto.action" */
export type Risolto_Action_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Action_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.action" */
export type Risolto_Action_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Action_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Action_Max_Order_By>;
  min?: Maybe<Risolto_Action_Min_Order_By>;
  stddev?: Maybe<Risolto_Action_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Action_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Action_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Action_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Action_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Action_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Action_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Action_Append_Input = {
  channel_metadata?: Maybe<Scalars['jsonb']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.action" */
export type Risolto_Action_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Action_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Action_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Action_Avg_Fields = {
  __typename?: 'risolto_action_avg_fields';
  retry_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.action" */
export type Risolto_Action_Avg_Order_By = {
  retry_count?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.action". All fields are combined with a logical 'AND'. */
export type Risolto_Action_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Action_Bool_Exp>>;
  _not?: Maybe<Risolto_Action_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Action_Bool_Exp>>;
  action_interchanges?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
  action_interchanges_aggregate?: Maybe<Risolto_Action_Interchange_Aggregate_Bool_Exp>;
  action_invoices?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
  action_invoices_aggregate?: Maybe<Risolto_Action_Invoice_Aggregate_Bool_Exp>;
  assignee?: Maybe<Uuid_Comparison_Exp>;
  assignee_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  cancel_reason?: Maybe<String_Comparison_Exp>;
  canceled_at?: Maybe<Timestamptz_Comparison_Exp>;
  canceled_by?: Maybe<Uuid_Comparison_Exp>;
  canceler_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  channel?: Maybe<Risolto_Channel_Enum_Comparison_Exp>;
  channel_endpoint?: Maybe<Uuid_Comparison_Exp>;
  channel_endpoint_by_reference?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
  channel_metadata?: Maybe<Jsonb_Comparison_Exp>;
  confirmed_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  credit_note?: Maybe<Uuid_Comparison_Exp>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Bool_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  dunning_notice?: Maybe<Uuid_Comparison_Exp>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  executed_at?: Maybe<Timestamptz_Comparison_Exp>;
  executed_by?: Maybe<Uuid_Comparison_Exp>;
  executed_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  execution_type?: Maybe<Risolto_Action_Execution_Type_Enum_Comparison_Exp>;
  has_bounces?: Maybe<Boolean_Comparison_Exp>;
  has_more_recent?: Maybe<Boolean_Comparison_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  is_retry?: Maybe<Boolean_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message_code?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  notes?: Maybe<Risolto_Note_Bool_Exp>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Bool_Exp>;
  original_action?: Maybe<Uuid_Comparison_Exp>;
  original_action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  original_actions?: Maybe<Risolto_Action_Bool_Exp>;
  original_actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_plan?: Maybe<Uuid_Comparison_Exp>;
  payment_plan_by_reference?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  payment_promise?: Maybe<Uuid_Comparison_Exp>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  primary_invoice?: Maybe<Uuid_Comparison_Exp>;
  primary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  retry_count?: Maybe<Numeric_Comparison_Exp>;
  source?: Maybe<Risolto_Action_Source_Enum_Comparison_Exp>;
  start_time?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<Risolto_Action_Status_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.action" */
export enum Risolto_Action_Constraint {
  /** unique or primary key constraint on columns "reference" */
  ActionPkey = 'action_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Action_Delete_At_Path_Input = {
  channel_metadata?: Maybe<Array<Scalars['String']>>;
  custom_fields?: Maybe<Array<Scalars['String']>>;
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Action_Delete_Elem_Input = {
  channel_metadata?: Maybe<Scalars['Int']>;
  custom_fields?: Maybe<Scalars['Int']>;
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Action_Delete_Key_Input = {
  channel_metadata?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.action_execution_type" */
export type Risolto_Action_Execution_Type = {
  __typename?: 'risolto_action_execution_type';
  type: Scalars['String'];
};

/** aggregated selection of "risolto.action_execution_type" */
export type Risolto_Action_Execution_Type_Aggregate = {
  __typename?: 'risolto_action_execution_type_aggregate';
  aggregate?: Maybe<Risolto_Action_Execution_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Action_Execution_Type>;
};

/** aggregate fields of "risolto.action_execution_type" */
export type Risolto_Action_Execution_Type_Aggregate_Fields = {
  __typename?: 'risolto_action_execution_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Action_Execution_Type_Max_Fields>;
  min?: Maybe<Risolto_Action_Execution_Type_Min_Fields>;
};


/** aggregate fields of "risolto.action_execution_type" */
export type Risolto_Action_Execution_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Action_Execution_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.action_execution_type". All fields are combined with a logical 'AND'. */
export type Risolto_Action_Execution_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Action_Execution_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Action_Execution_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Action_Execution_Type_Bool_Exp>>;
  type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.action_execution_type" */
export enum Risolto_Action_Execution_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  ActionTypePkey = 'action_type_pkey'
}

export enum Risolto_Action_Execution_Type_Enum {
  Automated = 'AUTOMATED',
  Manual = 'MANUAL',
  SemiAutomated = 'SEMI_AUTOMATED'
}

/** Boolean expression to compare columns of type "risolto_action_execution_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Action_Execution_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Action_Execution_Type_Enum>;
  _in?: Maybe<Array<Risolto_Action_Execution_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Action_Execution_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Action_Execution_Type_Enum>>;
};

/** input type for inserting data into table "risolto.action_execution_type" */
export type Risolto_Action_Execution_Type_Insert_Input = {
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Action_Execution_Type_Max_Fields = {
  __typename?: 'risolto_action_execution_type_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Action_Execution_Type_Min_Fields = {
  __typename?: 'risolto_action_execution_type_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.action_execution_type" */
export type Risolto_Action_Execution_Type_Mutation_Response = {
  __typename?: 'risolto_action_execution_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Action_Execution_Type>;
};

/** on_conflict condition type for table "risolto.action_execution_type" */
export type Risolto_Action_Execution_Type_On_Conflict = {
  constraint: Risolto_Action_Execution_Type_Constraint;
  update_columns?: Array<Risolto_Action_Execution_Type_Update_Column>;
  where?: Maybe<Risolto_Action_Execution_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.action_execution_type". */
export type Risolto_Action_Execution_Type_Order_By = {
  type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.action_execution_type */
export type Risolto_Action_Execution_Type_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "risolto.action_execution_type" */
export enum Risolto_Action_Execution_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "risolto.action_execution_type" */
export type Risolto_Action_Execution_Type_Set_Input = {
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_action_execution_type" */
export type Risolto_Action_Execution_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Action_Execution_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Action_Execution_Type_Stream_Cursor_Value_Input = {
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.action_execution_type" */
export enum Risolto_Action_Execution_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Risolto_Action_Execution_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Action_Execution_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Action_Execution_Type_Bool_Exp;
};

export type Risolto_Action_Group_V10_Args = {
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
  group_start_time?: Maybe<Scalars['Boolean']>;
  participants?: Maybe<Scalars['_uuid']>;
  search_term?: Maybe<Scalars['String']>;
  start_time_from?: Maybe<Scalars['timestamp']>;
  start_time_until?: Maybe<Scalars['timestamp']>;
  statuses?: Maybe<Scalars['_text']>;
};

export type Risolto_Action_Group_V11_Args = {
  execution_types?: Maybe<Scalars['_text']>;
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
  group_start_time?: Maybe<Scalars['Boolean']>;
  participants?: Maybe<Scalars['_uuid']>;
  search_term?: Maybe<Scalars['String']>;
  start_time_from?: Maybe<Scalars['timestamp']>;
  start_time_until?: Maybe<Scalars['timestamp']>;
  statuses?: Maybe<Scalars['_text']>;
};

export type Risolto_Action_Group_V12_Args = {
  execution_types?: Maybe<Scalars['_text']>;
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
  group_start_time?: Maybe<Scalars['Boolean']>;
  legal_entities?: Maybe<Scalars['_uuid']>;
  participants?: Maybe<Scalars['_uuid']>;
  search_term?: Maybe<Scalars['String']>;
  start_time_from?: Maybe<Scalars['timestamp']>;
  start_time_until?: Maybe<Scalars['timestamp']>;
  statuses?: Maybe<Scalars['_text']>;
};

export type Risolto_Action_Group_V2_Args = {
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
};

export type Risolto_Action_Group_V5_Args = {
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
  search_term?: Maybe<Scalars['String']>;
};

export type Risolto_Action_Group_V6_Args = {
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
  search_term?: Maybe<Scalars['String']>;
  statuses?: Maybe<Scalars['_text']>;
};

export type Risolto_Action_Group_V7_Args = {
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
  participants?: Maybe<Scalars['_uuid']>;
  search_term?: Maybe<Scalars['String']>;
  statuses?: Maybe<Scalars['_text']>;
};

export type Risolto_Action_Group_V8_Args = {
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
  group_start_date?: Maybe<Scalars['Boolean']>;
  participants?: Maybe<Scalars['_uuid']>;
  search_term?: Maybe<Scalars['String']>;
  statuses?: Maybe<Scalars['_text']>;
};

export type Risolto_Action_Group_V9_Args = {
  group_assignee?: Maybe<Scalars['Boolean']>;
  group_channel?: Maybe<Scalars['Boolean']>;
  group_due_date?: Maybe<Scalars['Boolean']>;
  group_message_code?: Maybe<Scalars['Boolean']>;
  group_recipient?: Maybe<Scalars['Boolean']>;
  group_reference?: Maybe<Scalars['Boolean']>;
  group_start_time?: Maybe<Scalars['Boolean']>;
  participants?: Maybe<Scalars['_uuid']>;
  search_term?: Maybe<Scalars['String']>;
  statuses?: Maybe<Scalars['_text']>;
};

/** input type for incrementing numeric columns in table "risolto.action" */
export type Risolto_Action_Inc_Input = {
  retry_count?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.action" */
export type Risolto_Action_Insert_Input = {
  action_interchanges?: Maybe<Risolto_Action_Interchange_Arr_Rel_Insert_Input>;
  action_invoices?: Maybe<Risolto_Action_Invoice_Arr_Rel_Insert_Input>;
  assignee?: Maybe<Scalars['uuid']>;
  assignee_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  /** User-provided text explaining why the action was canceled */
  cancel_reason?: Maybe<Scalars['String']>;
  /** Timestamp when the user (canceled_by) canceled the action due to cancel_reason */
  canceled_at?: Maybe<Scalars['timestamptz']>;
  /** Reference to the user who canceled the action */
  canceled_by?: Maybe<Scalars['uuid']>;
  canceler_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  /** null */
  channel?: Maybe<Risolto_Channel_Enum>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  channel_endpoint_by_reference?: Maybe<Risolto_Channel_Endpoint_Obj_Rel_Insert_Input>;
  channel_metadata?: Maybe<Scalars['jsonb']>;
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Obj_Rel_Insert_Input>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** null */
  due_date?: Maybe<Scalars['date']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Obj_Rel_Insert_Input>;
  /** Timestamp when the system executed the action */
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  executed_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  /** MANUAL | SEMI-AUTOMATED | AUTOMATED */
  execution_type?: Maybe<Risolto_Action_Execution_Type_Enum>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  /** Code for the UI to render the action message. Example: fix_unreconciled */
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  notes?: Maybe<Risolto_Note_Arr_Rel_Insert_Input>;
  /** null */
  original_action?: Maybe<Scalars['uuid']>;
  original_action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  original_actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_plan_by_reference?: Maybe<Risolto_Payment_Plan_Obj_Rel_Insert_Input>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Obj_Rel_Insert_Input>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  primary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  retry_count?: Maybe<Scalars['numeric']>;
  /** Example: open_balance_reconciliation */
  source?: Maybe<Risolto_Action_Source_Enum>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** DRAFT | OPEN | DONE | CANCELED */
  status?: Maybe<Risolto_Action_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.action_interchange" */
export type Risolto_Action_Interchange = {
  __typename?: 'risolto_action_interchange';
  action: Scalars['uuid'];
  /** An object relationship */
  action_by_reference: Risolto_Action;
  created_at: Scalars['timestamptz'];
  interchange: Scalars['uuid'];
  /** An object relationship */
  interchange_by_reference: Risolto_Document_Interchange;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.action_interchange" */
export type Risolto_Action_Interchange_Aggregate = {
  __typename?: 'risolto_action_interchange_aggregate';
  aggregate?: Maybe<Risolto_Action_Interchange_Aggregate_Fields>;
  nodes: Array<Risolto_Action_Interchange>;
};

export type Risolto_Action_Interchange_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Action_Interchange_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Action_Interchange_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.action_interchange" */
export type Risolto_Action_Interchange_Aggregate_Fields = {
  __typename?: 'risolto_action_interchange_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Action_Interchange_Max_Fields>;
  min?: Maybe<Risolto_Action_Interchange_Min_Fields>;
};


/** aggregate fields of "risolto.action_interchange" */
export type Risolto_Action_Interchange_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.action_interchange" */
export type Risolto_Action_Interchange_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Action_Interchange_Max_Order_By>;
  min?: Maybe<Risolto_Action_Interchange_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.action_interchange" */
export type Risolto_Action_Interchange_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Action_Interchange_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Action_Interchange_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.action_interchange". All fields are combined with a logical 'AND'. */
export type Risolto_Action_Interchange_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Action_Interchange_Bool_Exp>>;
  _not?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Action_Interchange_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  interchange?: Maybe<Uuid_Comparison_Exp>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.action_interchange" */
export enum Risolto_Action_Interchange_Constraint {
  /** unique or primary key constraint on columns "action", "interchange" */
  ActionInterchangeActionInterchangeKey = 'action_interchange_action_interchange_key',
  /** unique or primary key constraint on columns "reference" */
  ActionInterchangePkey = 'action_interchange_pkey'
}

/** input type for inserting data into table "risolto.action_interchange" */
export type Risolto_Action_Interchange_Insert_Input = {
  action?: Maybe<Scalars['uuid']>;
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Action_Interchange_Max_Fields = {
  __typename?: 'risolto_action_interchange_max_fields';
  action?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.action_interchange" */
export type Risolto_Action_Interchange_Max_Order_By = {
  action?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Action_Interchange_Min_Fields = {
  __typename?: 'risolto_action_interchange_min_fields';
  action?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.action_interchange" */
export type Risolto_Action_Interchange_Min_Order_By = {
  action?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.action_interchange" */
export type Risolto_Action_Interchange_Mutation_Response = {
  __typename?: 'risolto_action_interchange_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Action_Interchange>;
};

/** on_conflict condition type for table "risolto.action_interchange" */
export type Risolto_Action_Interchange_On_Conflict = {
  constraint: Risolto_Action_Interchange_Constraint;
  update_columns?: Array<Risolto_Action_Interchange_Update_Column>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.action_interchange". */
export type Risolto_Action_Interchange_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  created_at?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.action_interchange */
export type Risolto_Action_Interchange_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.action_interchange" */
export enum Risolto_Action_Interchange_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.action_interchange" */
export type Risolto_Action_Interchange_Set_Input = {
  action?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_action_interchange" */
export type Risolto_Action_Interchange_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Action_Interchange_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Action_Interchange_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.action_interchange" */
export enum Risolto_Action_Interchange_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Action_Interchange_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Action_Interchange_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Action_Interchange_Bool_Exp;
};

/** DEPRECATED */
export type Risolto_Action_Invoice = {
  __typename?: 'risolto_action_invoice';
  action: Scalars['uuid'];
  /** An object relationship */
  action_by_reference: Risolto_Action;
  /** null */
  created_at: Scalars['timestamptz'];
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  legal_entity: Scalars['uuid'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** null */
  reference: Scalars['uuid'];
  /** PRIMARY | SECONDARY */
  relation: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "risolto.action_invoice" */
export type Risolto_Action_Invoice_Aggregate = {
  __typename?: 'risolto_action_invoice_aggregate';
  aggregate?: Maybe<Risolto_Action_Invoice_Aggregate_Fields>;
  nodes: Array<Risolto_Action_Invoice>;
};

export type Risolto_Action_Invoice_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Action_Invoice_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Action_Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.action_invoice" */
export type Risolto_Action_Invoice_Aggregate_Fields = {
  __typename?: 'risolto_action_invoice_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Action_Invoice_Max_Fields>;
  min?: Maybe<Risolto_Action_Invoice_Min_Fields>;
};


/** aggregate fields of "risolto.action_invoice" */
export type Risolto_Action_Invoice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.action_invoice" */
export type Risolto_Action_Invoice_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Action_Invoice_Max_Order_By>;
  min?: Maybe<Risolto_Action_Invoice_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.action_invoice" */
export type Risolto_Action_Invoice_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Action_Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Action_Invoice_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.action_invoice". All fields are combined with a logical 'AND'. */
export type Risolto_Action_Invoice_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Action_Invoice_Bool_Exp>>;
  _not?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Action_Invoice_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  relation?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.action_invoice" */
export enum Risolto_Action_Invoice_Constraint {
  /** unique or primary key constraint on columns "action", "invoice" */
  ActionInvoiceActionInvoiceKey = 'action_invoice_action_invoice_key',
  /** unique or primary key constraint on columns "reference" */
  ActionInvoicePkey = 'action_invoice_pkey'
}

/** input type for inserting data into table "risolto.action_invoice" */
export type Risolto_Action_Invoice_Insert_Input = {
  action?: Maybe<Scalars['uuid']>;
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  /** null */
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  /** null */
  reference?: Maybe<Scalars['uuid']>;
  /** PRIMARY | SECONDARY */
  relation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Action_Invoice_Max_Fields = {
  __typename?: 'risolto_action_invoice_max_fields';
  action?: Maybe<Scalars['uuid']>;
  /** null */
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  /** null */
  reference?: Maybe<Scalars['uuid']>;
  /** PRIMARY | SECONDARY */
  relation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.action_invoice" */
export type Risolto_Action_Invoice_Max_Order_By = {
  action?: Maybe<Order_By>;
  /** null */
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  /** null */
  reference?: Maybe<Order_By>;
  /** PRIMARY | SECONDARY */
  relation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Action_Invoice_Min_Fields = {
  __typename?: 'risolto_action_invoice_min_fields';
  action?: Maybe<Scalars['uuid']>;
  /** null */
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  /** null */
  reference?: Maybe<Scalars['uuid']>;
  /** PRIMARY | SECONDARY */
  relation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.action_invoice" */
export type Risolto_Action_Invoice_Min_Order_By = {
  action?: Maybe<Order_By>;
  /** null */
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  /** null */
  reference?: Maybe<Order_By>;
  /** PRIMARY | SECONDARY */
  relation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.action_invoice" */
export type Risolto_Action_Invoice_Mutation_Response = {
  __typename?: 'risolto_action_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Action_Invoice>;
};

/** on_conflict condition type for table "risolto.action_invoice" */
export type Risolto_Action_Invoice_On_Conflict = {
  constraint: Risolto_Action_Invoice_Constraint;
  update_columns?: Array<Risolto_Action_Invoice_Update_Column>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.action_invoice". */
export type Risolto_Action_Invoice_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  relation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.action_invoice */
export type Risolto_Action_Invoice_Pk_Columns_Input = {
  /** null */
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.action_invoice" */
export enum Risolto_Action_Invoice_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Relation = 'relation',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.action_invoice" */
export type Risolto_Action_Invoice_Set_Input = {
  action?: Maybe<Scalars['uuid']>;
  /** null */
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  /** null */
  reference?: Maybe<Scalars['uuid']>;
  /** PRIMARY | SECONDARY */
  relation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_action_invoice" */
export type Risolto_Action_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Action_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Action_Invoice_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  /** null */
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  /** null */
  reference?: Maybe<Scalars['uuid']>;
  /** PRIMARY | SECONDARY */
  relation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.action_invoice" */
export enum Risolto_Action_Invoice_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Relation = 'relation',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Action_Invoice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Action_Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Action_Invoice_Bool_Exp;
};

/** aggregate max on columns */
export type Risolto_Action_Max_Fields = {
  __typename?: 'risolto_action_max_fields';
  assignee?: Maybe<Scalars['uuid']>;
  /** User-provided text explaining why the action was canceled */
  cancel_reason?: Maybe<Scalars['String']>;
  /** Timestamp when the user (canceled_by) canceled the action due to cancel_reason */
  canceled_at?: Maybe<Scalars['timestamptz']>;
  /** Reference to the user who canceled the action */
  canceled_by?: Maybe<Scalars['uuid']>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  /** null */
  due_date?: Maybe<Scalars['date']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  /** Timestamp when the system executed the action */
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  /** Code for the UI to render the action message. Example: fix_unreconciled */
  message_code?: Maybe<Scalars['String']>;
  /** null */
  original_action?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  retry_count?: Maybe<Scalars['numeric']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.action" */
export type Risolto_Action_Max_Order_By = {
  assignee?: Maybe<Order_By>;
  /** User-provided text explaining why the action was canceled */
  cancel_reason?: Maybe<Order_By>;
  /** Timestamp when the user (canceled_by) canceled the action due to cancel_reason */
  canceled_at?: Maybe<Order_By>;
  /** Reference to the user who canceled the action */
  canceled_by?: Maybe<Order_By>;
  channel_endpoint?: Maybe<Order_By>;
  confirmed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  /** null */
  due_date?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  /** Timestamp when the system executed the action */
  executed_at?: Maybe<Order_By>;
  executed_by?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  /** null */
  legal_entity?: Maybe<Order_By>;
  /** Code for the UI to render the action message. Example: fix_unreconciled */
  message_code?: Maybe<Order_By>;
  /** null */
  original_action?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  primary_invoice?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  retry_count?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Action_Min_Fields = {
  __typename?: 'risolto_action_min_fields';
  assignee?: Maybe<Scalars['uuid']>;
  /** User-provided text explaining why the action was canceled */
  cancel_reason?: Maybe<Scalars['String']>;
  /** Timestamp when the user (canceled_by) canceled the action due to cancel_reason */
  canceled_at?: Maybe<Scalars['timestamptz']>;
  /** Reference to the user who canceled the action */
  canceled_by?: Maybe<Scalars['uuid']>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  /** null */
  due_date?: Maybe<Scalars['date']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  /** Timestamp when the system executed the action */
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  /** Code for the UI to render the action message. Example: fix_unreconciled */
  message_code?: Maybe<Scalars['String']>;
  /** null */
  original_action?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  retry_count?: Maybe<Scalars['numeric']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.action" */
export type Risolto_Action_Min_Order_By = {
  assignee?: Maybe<Order_By>;
  /** User-provided text explaining why the action was canceled */
  cancel_reason?: Maybe<Order_By>;
  /** Timestamp when the user (canceled_by) canceled the action due to cancel_reason */
  canceled_at?: Maybe<Order_By>;
  /** Reference to the user who canceled the action */
  canceled_by?: Maybe<Order_By>;
  channel_endpoint?: Maybe<Order_By>;
  confirmed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  /** null */
  due_date?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  /** Timestamp when the system executed the action */
  executed_at?: Maybe<Order_By>;
  executed_by?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  /** null */
  legal_entity?: Maybe<Order_By>;
  /** Code for the UI to render the action message. Example: fix_unreconciled */
  message_code?: Maybe<Order_By>;
  /** null */
  original_action?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  primary_invoice?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  retry_count?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.action" */
export type Risolto_Action_Mutation_Response = {
  __typename?: 'risolto_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Action>;
};

/** input type for inserting object relation for remote table "risolto.action" */
export type Risolto_Action_Obj_Rel_Insert_Input = {
  data: Risolto_Action_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Action_On_Conflict>;
};

/** on_conflict condition type for table "risolto.action" */
export type Risolto_Action_On_Conflict = {
  constraint: Risolto_Action_Constraint;
  update_columns?: Array<Risolto_Action_Update_Column>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.action". */
export type Risolto_Action_Order_By = {
  action_interchanges_aggregate?: Maybe<Risolto_Action_Interchange_Aggregate_Order_By>;
  action_invoices_aggregate?: Maybe<Risolto_Action_Invoice_Aggregate_Order_By>;
  assignee?: Maybe<Order_By>;
  assignee_by_reference?: Maybe<Risolto_Person_Order_By>;
  cancel_reason?: Maybe<Order_By>;
  canceled_at?: Maybe<Order_By>;
  canceled_by?: Maybe<Order_By>;
  canceler_by_reference?: Maybe<Risolto_Person_Order_By>;
  channel?: Maybe<Order_By>;
  channel_endpoint?: Maybe<Order_By>;
  channel_endpoint_by_reference?: Maybe<Risolto_Channel_Endpoint_Order_By>;
  channel_metadata?: Maybe<Order_By>;
  confirmed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Order_By>;
  custom_fields?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Order_By>;
  executed_at?: Maybe<Order_By>;
  executed_by?: Maybe<Order_By>;
  executed_by_reference?: Maybe<Risolto_Person_Order_By>;
  execution_type?: Maybe<Order_By>;
  has_bounces?: Maybe<Order_By>;
  has_more_recent?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  is_retry?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message_code?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Order_By>;
  original_action?: Maybe<Order_By>;
  original_action_by_reference?: Maybe<Risolto_Action_Order_By>;
  original_actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_plan_by_reference?: Maybe<Risolto_Payment_Plan_Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Order_By>;
  primary_invoice?: Maybe<Order_By>;
  primary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  retry_count?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.action */
export type Risolto_Action_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Action_Prepend_Input = {
  channel_metadata?: Maybe<Scalars['jsonb']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.action" */
export enum Risolto_Action_Select_Column {
  /** column name */
  Assignee = 'assignee',
  /** column name */
  CancelReason = 'cancel_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledBy = 'canceled_by',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  ChannelMetadata = 'channel_metadata',
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  ExecutedAt = 'executed_at',
  /** column name */
  ExecutedBy = 'executed_by',
  /** column name */
  ExecutionType = 'execution_type',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OriginalAction = 'original_action',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPlan = 'payment_plan',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  PrimaryInvoice = 'primary_invoice',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  RetryCount = 'retry_count',
  /** column name */
  Source = 'source',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.action" */
export type Risolto_Action_Set_Input = {
  assignee?: Maybe<Scalars['uuid']>;
  /** User-provided text explaining why the action was canceled */
  cancel_reason?: Maybe<Scalars['String']>;
  /** Timestamp when the user (canceled_by) canceled the action due to cancel_reason */
  canceled_at?: Maybe<Scalars['timestamptz']>;
  /** Reference to the user who canceled the action */
  canceled_by?: Maybe<Scalars['uuid']>;
  /** null */
  channel?: Maybe<Risolto_Channel_Enum>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  channel_metadata?: Maybe<Scalars['jsonb']>;
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** null */
  due_date?: Maybe<Scalars['date']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  /** Timestamp when the system executed the action */
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  /** MANUAL | SEMI-AUTOMATED | AUTOMATED */
  execution_type?: Maybe<Risolto_Action_Execution_Type_Enum>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  /** Code for the UI to render the action message. Example: fix_unreconciled */
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  /** null */
  original_action?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  retry_count?: Maybe<Scalars['numeric']>;
  /** Example: open_balance_reconciliation */
  source?: Maybe<Risolto_Action_Source_Enum>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** DRAFT | OPEN | DONE | CANCELED */
  status?: Maybe<Risolto_Action_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.action_source" */
export type Risolto_Action_Source = {
  __typename?: 'risolto_action_source';
  source: Scalars['String'];
};

/** aggregated selection of "risolto.action_source" */
export type Risolto_Action_Source_Aggregate = {
  __typename?: 'risolto_action_source_aggregate';
  aggregate?: Maybe<Risolto_Action_Source_Aggregate_Fields>;
  nodes: Array<Risolto_Action_Source>;
};

/** aggregate fields of "risolto.action_source" */
export type Risolto_Action_Source_Aggregate_Fields = {
  __typename?: 'risolto_action_source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Action_Source_Max_Fields>;
  min?: Maybe<Risolto_Action_Source_Min_Fields>;
};


/** aggregate fields of "risolto.action_source" */
export type Risolto_Action_Source_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Action_Source_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.action_source". All fields are combined with a logical 'AND'. */
export type Risolto_Action_Source_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Action_Source_Bool_Exp>>;
  _not?: Maybe<Risolto_Action_Source_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Action_Source_Bool_Exp>>;
  source?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.action_source" */
export enum Risolto_Action_Source_Constraint {
  /** unique or primary key constraint on columns "source" */
  ActionSourcePkey = 'action_source_pkey'
}

export enum Risolto_Action_Source_Enum {
  Collection = 'COLLECTION',
  Dunning = 'DUNNING',
  InboundCommunication = 'INBOUND_COMMUNICATION',
  InboundInvoice = 'INBOUND_INVOICE',
  InboundOpenBalance = 'INBOUND_OPEN_BALANCE',
  InboundRecipient = 'INBOUND_RECIPIENT',
  InboundStatement = 'INBOUND_STATEMENT',
  IntegrationTest = 'INTEGRATION_TEST',
  Manual = 'MANUAL',
  PaymentPlan = 'PAYMENT_PLAN',
  ManuallyCreated = 'manually_created'
}

/** Boolean expression to compare columns of type "risolto_action_source_enum". All fields are combined with logical 'AND'. */
export type Risolto_Action_Source_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Action_Source_Enum>;
  _in?: Maybe<Array<Risolto_Action_Source_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Action_Source_Enum>;
  _nin?: Maybe<Array<Risolto_Action_Source_Enum>>;
};

/** input type for inserting data into table "risolto.action_source" */
export type Risolto_Action_Source_Insert_Input = {
  source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Action_Source_Max_Fields = {
  __typename?: 'risolto_action_source_max_fields';
  source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Action_Source_Min_Fields = {
  __typename?: 'risolto_action_source_min_fields';
  source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.action_source" */
export type Risolto_Action_Source_Mutation_Response = {
  __typename?: 'risolto_action_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Action_Source>;
};

/** on_conflict condition type for table "risolto.action_source" */
export type Risolto_Action_Source_On_Conflict = {
  constraint: Risolto_Action_Source_Constraint;
  update_columns?: Array<Risolto_Action_Source_Update_Column>;
  where?: Maybe<Risolto_Action_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.action_source". */
export type Risolto_Action_Source_Order_By = {
  source?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.action_source */
export type Risolto_Action_Source_Pk_Columns_Input = {
  source: Scalars['String'];
};

/** select columns of table "risolto.action_source" */
export enum Risolto_Action_Source_Select_Column {
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "risolto.action_source" */
export type Risolto_Action_Source_Set_Input = {
  source?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_action_source" */
export type Risolto_Action_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Action_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Action_Source_Stream_Cursor_Value_Input = {
  source?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.action_source" */
export enum Risolto_Action_Source_Update_Column {
  /** column name */
  Source = 'source'
}

export type Risolto_Action_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Action_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Action_Source_Bool_Exp;
};

/** columns and relationships of "risolto.action_status" */
export type Risolto_Action_Status = {
  __typename?: 'risolto_action_status';
  status: Scalars['String'];
};

/** aggregated selection of "risolto.action_status" */
export type Risolto_Action_Status_Aggregate = {
  __typename?: 'risolto_action_status_aggregate';
  aggregate?: Maybe<Risolto_Action_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Action_Status>;
};

/** aggregate fields of "risolto.action_status" */
export type Risolto_Action_Status_Aggregate_Fields = {
  __typename?: 'risolto_action_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Action_Status_Max_Fields>;
  min?: Maybe<Risolto_Action_Status_Min_Fields>;
};


/** aggregate fields of "risolto.action_status" */
export type Risolto_Action_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Action_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.action_status". All fields are combined with a logical 'AND'. */
export type Risolto_Action_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Action_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Action_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Action_Status_Bool_Exp>>;
  status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.action_status" */
export enum Risolto_Action_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  ActionStatusPkey = 'action_status_pkey'
}

export enum Risolto_Action_Status_Enum {
  Canceled = 'CANCELED',
  Done = 'DONE',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Logged = 'LOGGED',
  Open = 'OPEN',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED'
}

/** Boolean expression to compare columns of type "risolto_action_status_enum". All fields are combined with logical 'AND'. */
export type Risolto_Action_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Action_Status_Enum>;
  _in?: Maybe<Array<Risolto_Action_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Action_Status_Enum>;
  _nin?: Maybe<Array<Risolto_Action_Status_Enum>>;
};

/** input type for inserting data into table "risolto.action_status" */
export type Risolto_Action_Status_Insert_Input = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Action_Status_Max_Fields = {
  __typename?: 'risolto_action_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Action_Status_Min_Fields = {
  __typename?: 'risolto_action_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.action_status" */
export type Risolto_Action_Status_Mutation_Response = {
  __typename?: 'risolto_action_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Action_Status>;
};

/** on_conflict condition type for table "risolto.action_status" */
export type Risolto_Action_Status_On_Conflict = {
  constraint: Risolto_Action_Status_Constraint;
  update_columns?: Array<Risolto_Action_Status_Update_Column>;
  where?: Maybe<Risolto_Action_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.action_status". */
export type Risolto_Action_Status_Order_By = {
  status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.action_status */
export type Risolto_Action_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "risolto.action_status" */
export enum Risolto_Action_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "risolto.action_status" */
export type Risolto_Action_Status_Set_Input = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_action_status" */
export type Risolto_Action_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Action_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Action_Status_Stream_Cursor_Value_Input = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.action_status" */
export enum Risolto_Action_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Risolto_Action_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Action_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Action_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Risolto_Action_Stddev_Fields = {
  __typename?: 'risolto_action_stddev_fields';
  retry_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.action" */
export type Risolto_Action_Stddev_Order_By = {
  retry_count?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Action_Stddev_Pop_Fields = {
  __typename?: 'risolto_action_stddev_pop_fields';
  retry_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.action" */
export type Risolto_Action_Stddev_Pop_Order_By = {
  retry_count?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Action_Stddev_Samp_Fields = {
  __typename?: 'risolto_action_stddev_samp_fields';
  retry_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.action" */
export type Risolto_Action_Stddev_Samp_Order_By = {
  retry_count?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_action" */
export type Risolto_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Action_Stream_Cursor_Value_Input = {
  assignee?: Maybe<Scalars['uuid']>;
  /** User-provided text explaining why the action was canceled */
  cancel_reason?: Maybe<Scalars['String']>;
  /** Timestamp when the user (canceled_by) canceled the action due to cancel_reason */
  canceled_at?: Maybe<Scalars['timestamptz']>;
  /** Reference to the user who canceled the action */
  canceled_by?: Maybe<Scalars['uuid']>;
  /** null */
  channel?: Maybe<Risolto_Channel_Enum>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  channel_metadata?: Maybe<Scalars['jsonb']>;
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** null */
  due_date?: Maybe<Scalars['date']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  /** Timestamp when the system executed the action */
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  /** MANUAL | SEMI-AUTOMATED | AUTOMATED */
  execution_type?: Maybe<Risolto_Action_Execution_Type_Enum>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  /** Code for the UI to render the action message. Example: fix_unreconciled */
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  /** null */
  original_action?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  retry_count?: Maybe<Scalars['numeric']>;
  /** Example: open_balance_reconciliation */
  source?: Maybe<Risolto_Action_Source_Enum>;
  start_time?: Maybe<Scalars['timestamptz']>;
  /** DRAFT | OPEN | DONE | CANCELED */
  status?: Maybe<Risolto_Action_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Action_Sum_Fields = {
  __typename?: 'risolto_action_sum_fields';
  retry_count?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.action" */
export type Risolto_Action_Sum_Order_By = {
  retry_count?: Maybe<Order_By>;
};

/** update columns of table "risolto.action" */
export enum Risolto_Action_Update_Column {
  /** column name */
  Assignee = 'assignee',
  /** column name */
  CancelReason = 'cancel_reason',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledBy = 'canceled_by',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  ChannelMetadata = 'channel_metadata',
  /** column name */
  ConfirmedAt = 'confirmed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  ExecutedAt = 'executed_at',
  /** column name */
  ExecutedBy = 'executed_by',
  /** column name */
  ExecutionType = 'execution_type',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OriginalAction = 'original_action',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPlan = 'payment_plan',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  PrimaryInvoice = 'primary_invoice',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  RetryCount = 'retry_count',
  /** column name */
  Source = 'source',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Action_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Action_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Action_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Action_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Action_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Action_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Action_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Action_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Action_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Action_Var_Pop_Fields = {
  __typename?: 'risolto_action_var_pop_fields';
  retry_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.action" */
export type Risolto_Action_Var_Pop_Order_By = {
  retry_count?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Action_Var_Samp_Fields = {
  __typename?: 'risolto_action_var_samp_fields';
  retry_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.action" */
export type Risolto_Action_Var_Samp_Order_By = {
  retry_count?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Action_Variance_Fields = {
  __typename?: 'risolto_action_variance_fields';
  retry_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.action" */
export type Risolto_Action_Variance_Order_By = {
  retry_count?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score = {
  __typename?: 'risolto_analytics_company_score';
  approval_date?: Maybe<Scalars['date']>;
  average_score?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  end_date?: Maybe<Scalars['date']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['numeric']>;
  legal_form?: Maybe<Scalars['String']>;
  legal_id: Scalars['String'];
  legal_id_type: Scalars['String'];
  legal_name?: Maybe<Scalars['String']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_employee?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  ratio_cashflow_debt?: Maybe<Scalars['numeric']>;
  ratio_days_customer_credit?: Maybe<Scalars['numeric']>;
  ratio_days_supplier_credit?: Maybe<Scalars['numeric']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_financial_independence?: Maybe<Scalars['numeric']>;
  ratio_gross_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  ratio_liquidity_broad?: Maybe<Scalars['numeric']>;
  ratio_liquidity_narrow?: Maybe<Scalars['numeric']>;
  ratio_net_cash?: Maybe<Scalars['numeric']>;
  ratio_net_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_equity?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_short_term_debt?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  reference: Scalars['uuid'];
  schema?: Maybe<Scalars['String']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  score_added_value_per_employee?: Maybe<Scalars['numeric']>;
  score_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  score_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  score_cashflow_debt?: Maybe<Scalars['numeric']>;
  score_days_customer_credit?: Maybe<Scalars['numeric']>;
  score_days_supplier_credit?: Maybe<Scalars['numeric']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  score_financial_independence?: Maybe<Scalars['numeric']>;
  score_gross_operating_margin?: Maybe<Scalars['numeric']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  score_liquidity_broad?: Maybe<Scalars['numeric']>;
  score_liquidity_narrow?: Maybe<Scalars['numeric']>;
  score_net_cash?: Maybe<Scalars['numeric']>;
  score_net_operating_margin?: Maybe<Scalars['numeric']>;
  score_net_return_on_equity?: Maybe<Scalars['numeric']>;
  score_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  score_short_term_debt?: Maybe<Scalars['numeric']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  state_debt?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score_Aggregate = {
  __typename?: 'risolto_analytics_company_score_aggregate';
  aggregate?: Maybe<Risolto_Analytics_Company_Score_Aggregate_Fields>;
  nodes: Array<Risolto_Analytics_Company_Score>;
};

/** aggregate fields of "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score_Aggregate_Fields = {
  __typename?: 'risolto_analytics_company_score_aggregate_fields';
  avg?: Maybe<Risolto_Analytics_Company_Score_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Analytics_Company_Score_Max_Fields>;
  min?: Maybe<Risolto_Analytics_Company_Score_Min_Fields>;
  stddev?: Maybe<Risolto_Analytics_Company_Score_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Analytics_Company_Score_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Analytics_Company_Score_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Analytics_Company_Score_Sum_Fields>;
  var_pop?: Maybe<Risolto_Analytics_Company_Score_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Analytics_Company_Score_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Analytics_Company_Score_Variance_Fields>;
};


/** aggregate fields of "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Analytics_Company_Score_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Analytics_Company_Score_Avg_Fields = {
  __typename?: 'risolto_analytics_company_score_avg_fields';
  average_score?: Maybe<Scalars['Float']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['Float']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  ratio_added_value_per_employee?: Maybe<Scalars['Float']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  ratio_cashflow_debt?: Maybe<Scalars['Float']>;
  ratio_days_customer_credit?: Maybe<Scalars['Float']>;
  ratio_days_supplier_credit?: Maybe<Scalars['Float']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  ratio_financial_independence?: Maybe<Scalars['Float']>;
  ratio_gross_operating_margin?: Maybe<Scalars['Float']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  ratio_liquidity_broad?: Maybe<Scalars['Float']>;
  ratio_liquidity_narrow?: Maybe<Scalars['Float']>;
  ratio_net_cash?: Maybe<Scalars['Float']>;
  ratio_net_operating_margin?: Maybe<Scalars['Float']>;
  ratio_net_return_on_equity?: Maybe<Scalars['Float']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_short_term_debt?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  score_added_value_per_employee?: Maybe<Scalars['Float']>;
  score_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  score_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  score_cashflow_debt?: Maybe<Scalars['Float']>;
  score_days_customer_credit?: Maybe<Scalars['Float']>;
  score_days_supplier_credit?: Maybe<Scalars['Float']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  score_financial_independence?: Maybe<Scalars['Float']>;
  score_gross_operating_margin?: Maybe<Scalars['Float']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  score_liquidity_broad?: Maybe<Scalars['Float']>;
  score_liquidity_narrow?: Maybe<Scalars['Float']>;
  score_net_cash?: Maybe<Scalars['Float']>;
  score_net_operating_margin?: Maybe<Scalars['Float']>;
  score_net_return_on_equity?: Maybe<Scalars['Float']>;
  score_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  score_short_term_debt?: Maybe<Scalars['Float']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  state_debt?: Maybe<Scalars['numeric']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "risolto.analytics_company_score". All fields are combined with a logical 'AND'. */
export type Risolto_Analytics_Company_Score_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Analytics_Company_Score_Bool_Exp>>;
  _not?: Maybe<Risolto_Analytics_Company_Score_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Analytics_Company_Score_Bool_Exp>>;
  approval_date?: Maybe<Date_Comparison_Exp>;
  average_score?: Maybe<Numeric_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  general_score?: Maybe<Numeric_Comparison_Exp>;
  legal_form?: Maybe<String_Comparison_Exp>;
  legal_id?: Maybe<String_Comparison_Exp>;
  legal_id_type?: Maybe<String_Comparison_Exp>;
  legal_name?: Maybe<String_Comparison_Exp>;
  liquidity?: Maybe<Numeric_Comparison_Exp>;
  profitability?: Maybe<Numeric_Comparison_Exp>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Numeric_Comparison_Exp>;
  ratio_added_value_per_employee?: Maybe<Numeric_Comparison_Exp>;
  ratio_added_value_per_operating_income?: Maybe<Numeric_Comparison_Exp>;
  ratio_added_value_per_personnel_charges?: Maybe<Numeric_Comparison_Exp>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Numeric_Comparison_Exp>;
  ratio_cash_flow_per_equity?: Maybe<Numeric_Comparison_Exp>;
  ratio_cashflow_debt?: Maybe<Numeric_Comparison_Exp>;
  ratio_days_customer_credit?: Maybe<Numeric_Comparison_Exp>;
  ratio_days_supplier_credit?: Maybe<Numeric_Comparison_Exp>;
  ratio_debt_charges_per_added_value?: Maybe<Numeric_Comparison_Exp>;
  ratio_depreciation_per_added_value?: Maybe<Numeric_Comparison_Exp>;
  ratio_financial_independence?: Maybe<Numeric_Comparison_Exp>;
  ratio_gross_operating_margin?: Maybe<Numeric_Comparison_Exp>;
  ratio_gross_return_on_total_assets?: Maybe<Numeric_Comparison_Exp>;
  ratio_level_of_equity_capitalisation?: Maybe<Numeric_Comparison_Exp>;
  ratio_liquidity_broad?: Maybe<Numeric_Comparison_Exp>;
  ratio_liquidity_narrow?: Maybe<Numeric_Comparison_Exp>;
  ratio_net_cash?: Maybe<Numeric_Comparison_Exp>;
  ratio_net_operating_margin?: Maybe<Numeric_Comparison_Exp>;
  ratio_net_return_on_equity?: Maybe<Numeric_Comparison_Exp>;
  ratio_net_return_on_total_assets?: Maybe<Numeric_Comparison_Exp>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Numeric_Comparison_Exp>;
  ratio_personnel_charges_per_added_value?: Maybe<Numeric_Comparison_Exp>;
  ratio_renewal_rate_fixed_assets?: Maybe<Numeric_Comparison_Exp>;
  ratio_short_term_debt?: Maybe<Numeric_Comparison_Exp>;
  ratio_stock_turnover_processed_goods?: Maybe<Numeric_Comparison_Exp>;
  ratio_stock_turnover_raw_material?: Maybe<Numeric_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  schema?: Maybe<String_Comparison_Exp>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Numeric_Comparison_Exp>;
  score_added_value_per_employee?: Maybe<Numeric_Comparison_Exp>;
  score_added_value_per_operating_income?: Maybe<Numeric_Comparison_Exp>;
  score_added_value_per_personnel_charges?: Maybe<Numeric_Comparison_Exp>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Numeric_Comparison_Exp>;
  score_cash_flow_per_equity?: Maybe<Numeric_Comparison_Exp>;
  score_cashflow_debt?: Maybe<Numeric_Comparison_Exp>;
  score_days_customer_credit?: Maybe<Numeric_Comparison_Exp>;
  score_days_supplier_credit?: Maybe<Numeric_Comparison_Exp>;
  score_debt_charges_per_added_value?: Maybe<Numeric_Comparison_Exp>;
  score_depreciation_per_added_value?: Maybe<Numeric_Comparison_Exp>;
  score_financial_independence?: Maybe<Numeric_Comparison_Exp>;
  score_gross_operating_margin?: Maybe<Numeric_Comparison_Exp>;
  score_gross_return_on_total_assets?: Maybe<Numeric_Comparison_Exp>;
  score_level_of_equity_capitalisation?: Maybe<Numeric_Comparison_Exp>;
  score_liquidity_broad?: Maybe<Numeric_Comparison_Exp>;
  score_liquidity_narrow?: Maybe<Numeric_Comparison_Exp>;
  score_net_cash?: Maybe<Numeric_Comparison_Exp>;
  score_net_operating_margin?: Maybe<Numeric_Comparison_Exp>;
  score_net_return_on_equity?: Maybe<Numeric_Comparison_Exp>;
  score_net_return_on_total_assets?: Maybe<Numeric_Comparison_Exp>;
  score_overdue_tax_and_social_security_debt?: Maybe<Numeric_Comparison_Exp>;
  score_personnel_charges_per_added_value?: Maybe<Numeric_Comparison_Exp>;
  score_renewal_rate_fixed_assets?: Maybe<Numeric_Comparison_Exp>;
  score_short_term_debt?: Maybe<Numeric_Comparison_Exp>;
  score_stock_turnover_processed_goods?: Maybe<Numeric_Comparison_Exp>;
  score_stock_turnover_raw_material?: Maybe<Numeric_Comparison_Exp>;
  short_term_financial_debt?: Maybe<Numeric_Comparison_Exp>;
  solvency?: Maybe<Numeric_Comparison_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  state_debt?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  weighted_average_score?: Maybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.analytics_company_score" */
export enum Risolto_Analytics_Company_Score_Constraint {
  /** unique or primary key constraint on columns "legal_id_type", "legal_id" */
  AnalyticsCompanyScoreLegalIdLegalIdTypeKey = 'analytics_company_score_legal_id_legal_id_type_key',
  /** unique or primary key constraint on columns "reference" */
  AnalyticsCompanyScorePkey = 'analytics_company_score_pkey'
}

/** input type for incrementing numeric columns in table "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score_Inc_Input = {
  average_score?: Maybe<Scalars['numeric']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_employee?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  ratio_cashflow_debt?: Maybe<Scalars['numeric']>;
  ratio_days_customer_credit?: Maybe<Scalars['numeric']>;
  ratio_days_supplier_credit?: Maybe<Scalars['numeric']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_financial_independence?: Maybe<Scalars['numeric']>;
  ratio_gross_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  ratio_liquidity_broad?: Maybe<Scalars['numeric']>;
  ratio_liquidity_narrow?: Maybe<Scalars['numeric']>;
  ratio_net_cash?: Maybe<Scalars['numeric']>;
  ratio_net_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_equity?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_short_term_debt?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  score_added_value_per_employee?: Maybe<Scalars['numeric']>;
  score_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  score_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  score_cashflow_debt?: Maybe<Scalars['numeric']>;
  score_days_customer_credit?: Maybe<Scalars['numeric']>;
  score_days_supplier_credit?: Maybe<Scalars['numeric']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  score_financial_independence?: Maybe<Scalars['numeric']>;
  score_gross_operating_margin?: Maybe<Scalars['numeric']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  score_liquidity_broad?: Maybe<Scalars['numeric']>;
  score_liquidity_narrow?: Maybe<Scalars['numeric']>;
  score_net_cash?: Maybe<Scalars['numeric']>;
  score_net_operating_margin?: Maybe<Scalars['numeric']>;
  score_net_return_on_equity?: Maybe<Scalars['numeric']>;
  score_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  score_short_term_debt?: Maybe<Scalars['numeric']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score_Insert_Input = {
  approval_date?: Maybe<Scalars['date']>;
  average_score?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['numeric']>;
  legal_form?: Maybe<Scalars['String']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_employee?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  ratio_cashflow_debt?: Maybe<Scalars['numeric']>;
  ratio_days_customer_credit?: Maybe<Scalars['numeric']>;
  ratio_days_supplier_credit?: Maybe<Scalars['numeric']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_financial_independence?: Maybe<Scalars['numeric']>;
  ratio_gross_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  ratio_liquidity_broad?: Maybe<Scalars['numeric']>;
  ratio_liquidity_narrow?: Maybe<Scalars['numeric']>;
  ratio_net_cash?: Maybe<Scalars['numeric']>;
  ratio_net_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_equity?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_short_term_debt?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  reference?: Maybe<Scalars['uuid']>;
  schema?: Maybe<Scalars['String']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  score_added_value_per_employee?: Maybe<Scalars['numeric']>;
  score_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  score_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  score_cashflow_debt?: Maybe<Scalars['numeric']>;
  score_days_customer_credit?: Maybe<Scalars['numeric']>;
  score_days_supplier_credit?: Maybe<Scalars['numeric']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  score_financial_independence?: Maybe<Scalars['numeric']>;
  score_gross_operating_margin?: Maybe<Scalars['numeric']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  score_liquidity_broad?: Maybe<Scalars['numeric']>;
  score_liquidity_narrow?: Maybe<Scalars['numeric']>;
  score_net_cash?: Maybe<Scalars['numeric']>;
  score_net_operating_margin?: Maybe<Scalars['numeric']>;
  score_net_return_on_equity?: Maybe<Scalars['numeric']>;
  score_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  score_short_term_debt?: Maybe<Scalars['numeric']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Analytics_Company_Score_Max_Fields = {
  __typename?: 'risolto_analytics_company_score_max_fields';
  approval_date?: Maybe<Scalars['date']>;
  average_score?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['numeric']>;
  legal_form?: Maybe<Scalars['String']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_employee?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  ratio_cashflow_debt?: Maybe<Scalars['numeric']>;
  ratio_days_customer_credit?: Maybe<Scalars['numeric']>;
  ratio_days_supplier_credit?: Maybe<Scalars['numeric']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_financial_independence?: Maybe<Scalars['numeric']>;
  ratio_gross_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  ratio_liquidity_broad?: Maybe<Scalars['numeric']>;
  ratio_liquidity_narrow?: Maybe<Scalars['numeric']>;
  ratio_net_cash?: Maybe<Scalars['numeric']>;
  ratio_net_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_equity?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_short_term_debt?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  reference?: Maybe<Scalars['uuid']>;
  schema?: Maybe<Scalars['String']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  score_added_value_per_employee?: Maybe<Scalars['numeric']>;
  score_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  score_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  score_cashflow_debt?: Maybe<Scalars['numeric']>;
  score_days_customer_credit?: Maybe<Scalars['numeric']>;
  score_days_supplier_credit?: Maybe<Scalars['numeric']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  score_financial_independence?: Maybe<Scalars['numeric']>;
  score_gross_operating_margin?: Maybe<Scalars['numeric']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  score_liquidity_broad?: Maybe<Scalars['numeric']>;
  score_liquidity_narrow?: Maybe<Scalars['numeric']>;
  score_net_cash?: Maybe<Scalars['numeric']>;
  score_net_operating_margin?: Maybe<Scalars['numeric']>;
  score_net_return_on_equity?: Maybe<Scalars['numeric']>;
  score_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  score_short_term_debt?: Maybe<Scalars['numeric']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  state_debt?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Risolto_Analytics_Company_Score_Min_Fields = {
  __typename?: 'risolto_analytics_company_score_min_fields';
  approval_date?: Maybe<Scalars['date']>;
  average_score?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['numeric']>;
  legal_form?: Maybe<Scalars['String']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_employee?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  ratio_cashflow_debt?: Maybe<Scalars['numeric']>;
  ratio_days_customer_credit?: Maybe<Scalars['numeric']>;
  ratio_days_supplier_credit?: Maybe<Scalars['numeric']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_financial_independence?: Maybe<Scalars['numeric']>;
  ratio_gross_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  ratio_liquidity_broad?: Maybe<Scalars['numeric']>;
  ratio_liquidity_narrow?: Maybe<Scalars['numeric']>;
  ratio_net_cash?: Maybe<Scalars['numeric']>;
  ratio_net_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_equity?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_short_term_debt?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  reference?: Maybe<Scalars['uuid']>;
  schema?: Maybe<Scalars['String']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  score_added_value_per_employee?: Maybe<Scalars['numeric']>;
  score_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  score_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  score_cashflow_debt?: Maybe<Scalars['numeric']>;
  score_days_customer_credit?: Maybe<Scalars['numeric']>;
  score_days_supplier_credit?: Maybe<Scalars['numeric']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  score_financial_independence?: Maybe<Scalars['numeric']>;
  score_gross_operating_margin?: Maybe<Scalars['numeric']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  score_liquidity_broad?: Maybe<Scalars['numeric']>;
  score_liquidity_narrow?: Maybe<Scalars['numeric']>;
  score_net_cash?: Maybe<Scalars['numeric']>;
  score_net_operating_margin?: Maybe<Scalars['numeric']>;
  score_net_return_on_equity?: Maybe<Scalars['numeric']>;
  score_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  score_short_term_debt?: Maybe<Scalars['numeric']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  state_debt?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score_Mutation_Response = {
  __typename?: 'risolto_analytics_company_score_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Analytics_Company_Score>;
};

/** on_conflict condition type for table "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score_On_Conflict = {
  constraint: Risolto_Analytics_Company_Score_Constraint;
  update_columns?: Array<Risolto_Analytics_Company_Score_Update_Column>;
  where?: Maybe<Risolto_Analytics_Company_Score_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.analytics_company_score". */
export type Risolto_Analytics_Company_Score_Order_By = {
  approval_date?: Maybe<Order_By>;
  average_score?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  general_score?: Maybe<Order_By>;
  legal_form?: Maybe<Order_By>;
  legal_id?: Maybe<Order_By>;
  legal_id_type?: Maybe<Order_By>;
  legal_name?: Maybe<Order_By>;
  liquidity?: Maybe<Order_By>;
  profitability?: Maybe<Order_By>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Order_By>;
  ratio_added_value_per_employee?: Maybe<Order_By>;
  ratio_added_value_per_operating_income?: Maybe<Order_By>;
  ratio_added_value_per_personnel_charges?: Maybe<Order_By>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Order_By>;
  ratio_cash_flow_per_equity?: Maybe<Order_By>;
  ratio_cashflow_debt?: Maybe<Order_By>;
  ratio_days_customer_credit?: Maybe<Order_By>;
  ratio_days_supplier_credit?: Maybe<Order_By>;
  ratio_debt_charges_per_added_value?: Maybe<Order_By>;
  ratio_depreciation_per_added_value?: Maybe<Order_By>;
  ratio_financial_independence?: Maybe<Order_By>;
  ratio_gross_operating_margin?: Maybe<Order_By>;
  ratio_gross_return_on_total_assets?: Maybe<Order_By>;
  ratio_level_of_equity_capitalisation?: Maybe<Order_By>;
  ratio_liquidity_broad?: Maybe<Order_By>;
  ratio_liquidity_narrow?: Maybe<Order_By>;
  ratio_net_cash?: Maybe<Order_By>;
  ratio_net_operating_margin?: Maybe<Order_By>;
  ratio_net_return_on_equity?: Maybe<Order_By>;
  ratio_net_return_on_total_assets?: Maybe<Order_By>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Order_By>;
  ratio_personnel_charges_per_added_value?: Maybe<Order_By>;
  ratio_renewal_rate_fixed_assets?: Maybe<Order_By>;
  ratio_short_term_debt?: Maybe<Order_By>;
  ratio_stock_turnover_processed_goods?: Maybe<Order_By>;
  ratio_stock_turnover_raw_material?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  schema?: Maybe<Order_By>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Order_By>;
  score_added_value_per_employee?: Maybe<Order_By>;
  score_added_value_per_operating_income?: Maybe<Order_By>;
  score_added_value_per_personnel_charges?: Maybe<Order_By>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Order_By>;
  score_cash_flow_per_equity?: Maybe<Order_By>;
  score_cashflow_debt?: Maybe<Order_By>;
  score_days_customer_credit?: Maybe<Order_By>;
  score_days_supplier_credit?: Maybe<Order_By>;
  score_debt_charges_per_added_value?: Maybe<Order_By>;
  score_depreciation_per_added_value?: Maybe<Order_By>;
  score_financial_independence?: Maybe<Order_By>;
  score_gross_operating_margin?: Maybe<Order_By>;
  score_gross_return_on_total_assets?: Maybe<Order_By>;
  score_level_of_equity_capitalisation?: Maybe<Order_By>;
  score_liquidity_broad?: Maybe<Order_By>;
  score_liquidity_narrow?: Maybe<Order_By>;
  score_net_cash?: Maybe<Order_By>;
  score_net_operating_margin?: Maybe<Order_By>;
  score_net_return_on_equity?: Maybe<Order_By>;
  score_net_return_on_total_assets?: Maybe<Order_By>;
  score_overdue_tax_and_social_security_debt?: Maybe<Order_By>;
  score_personnel_charges_per_added_value?: Maybe<Order_By>;
  score_renewal_rate_fixed_assets?: Maybe<Order_By>;
  score_short_term_debt?: Maybe<Order_By>;
  score_stock_turnover_processed_goods?: Maybe<Order_By>;
  score_stock_turnover_raw_material?: Maybe<Order_By>;
  short_term_financial_debt?: Maybe<Order_By>;
  solvency?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state_debt?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  weighted_average_score?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.analytics_company_score */
export type Risolto_Analytics_Company_Score_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.analytics_company_score" */
export enum Risolto_Analytics_Company_Score_Select_Column {
  /** column name */
  ApprovalDate = 'approval_date',
  /** column name */
  AverageScore = 'average_score',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  GeneralScore = 'general_score',
  /** column name */
  LegalForm = 'legal_form',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  LegalIdType = 'legal_id_type',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  RatioAcquisitionFixedAssetsPerAddedValue = 'ratio_acquisition_fixed_assets_per_added_value',
  /** column name */
  RatioAddedValuePerEmployee = 'ratio_added_value_per_employee',
  /** column name */
  RatioAddedValuePerOperatingIncome = 'ratio_added_value_per_operating_income',
  /** column name */
  RatioAddedValuePerPersonnelCharges = 'ratio_added_value_per_personnel_charges',
  /** column name */
  RatioAddedValuePerTangibleFixedAssets = 'ratio_added_value_per_tangible_fixed_assets',
  /** column name */
  RatioCashFlowPerEquity = 'ratio_cash_flow_per_equity',
  /** column name */
  RatioCashflowDebt = 'ratio_cashflow_debt',
  /** column name */
  RatioDaysCustomerCredit = 'ratio_days_customer_credit',
  /** column name */
  RatioDaysSupplierCredit = 'ratio_days_supplier_credit',
  /** column name */
  RatioDebtChargesPerAddedValue = 'ratio_debt_charges_per_added_value',
  /** column name */
  RatioDepreciationPerAddedValue = 'ratio_depreciation_per_added_value',
  /** column name */
  RatioFinancialIndependence = 'ratio_financial_independence',
  /** column name */
  RatioGrossOperatingMargin = 'ratio_gross_operating_margin',
  /** column name */
  RatioGrossReturnOnTotalAssets = 'ratio_gross_return_on_total_assets',
  /** column name */
  RatioLevelOfEquityCapitalisation = 'ratio_level_of_equity_capitalisation',
  /** column name */
  RatioLiquidityBroad = 'ratio_liquidity_broad',
  /** column name */
  RatioLiquidityNarrow = 'ratio_liquidity_narrow',
  /** column name */
  RatioNetCash = 'ratio_net_cash',
  /** column name */
  RatioNetOperatingMargin = 'ratio_net_operating_margin',
  /** column name */
  RatioNetReturnOnEquity = 'ratio_net_return_on_equity',
  /** column name */
  RatioNetReturnOnTotalAssets = 'ratio_net_return_on_total_assets',
  /** column name */
  RatioOverdueTaxAndSocialSecurityDebt = 'ratio_overdue_tax_and_social_security_debt',
  /** column name */
  RatioPersonnelChargesPerAddedValue = 'ratio_personnel_charges_per_added_value',
  /** column name */
  RatioRenewalRateFixedAssets = 'ratio_renewal_rate_fixed_assets',
  /** column name */
  RatioShortTermDebt = 'ratio_short_term_debt',
  /** column name */
  RatioStockTurnoverProcessedGoods = 'ratio_stock_turnover_processed_goods',
  /** column name */
  RatioStockTurnoverRawMaterial = 'ratio_stock_turnover_raw_material',
  /** column name */
  Reference = 'reference',
  /** column name */
  Schema = 'schema',
  /** column name */
  ScoreAcquisitionFixedAssetsPerAddedValue = 'score_acquisition_fixed_assets_per_added_value',
  /** column name */
  ScoreAddedValuePerEmployee = 'score_added_value_per_employee',
  /** column name */
  ScoreAddedValuePerOperatingIncome = 'score_added_value_per_operating_income',
  /** column name */
  ScoreAddedValuePerPersonnelCharges = 'score_added_value_per_personnel_charges',
  /** column name */
  ScoreAddedValuePerTangibleFixedAssets = 'score_added_value_per_tangible_fixed_assets',
  /** column name */
  ScoreCashFlowPerEquity = 'score_cash_flow_per_equity',
  /** column name */
  ScoreCashflowDebt = 'score_cashflow_debt',
  /** column name */
  ScoreDaysCustomerCredit = 'score_days_customer_credit',
  /** column name */
  ScoreDaysSupplierCredit = 'score_days_supplier_credit',
  /** column name */
  ScoreDebtChargesPerAddedValue = 'score_debt_charges_per_added_value',
  /** column name */
  ScoreDepreciationPerAddedValue = 'score_depreciation_per_added_value',
  /** column name */
  ScoreFinancialIndependence = 'score_financial_independence',
  /** column name */
  ScoreGrossOperatingMargin = 'score_gross_operating_margin',
  /** column name */
  ScoreGrossReturnOnTotalAssets = 'score_gross_return_on_total_assets',
  /** column name */
  ScoreLevelOfEquityCapitalisation = 'score_level_of_equity_capitalisation',
  /** column name */
  ScoreLiquidityBroad = 'score_liquidity_broad',
  /** column name */
  ScoreLiquidityNarrow = 'score_liquidity_narrow',
  /** column name */
  ScoreNetCash = 'score_net_cash',
  /** column name */
  ScoreNetOperatingMargin = 'score_net_operating_margin',
  /** column name */
  ScoreNetReturnOnEquity = 'score_net_return_on_equity',
  /** column name */
  ScoreNetReturnOnTotalAssets = 'score_net_return_on_total_assets',
  /** column name */
  ScoreOverdueTaxAndSocialSecurityDebt = 'score_overdue_tax_and_social_security_debt',
  /** column name */
  ScorePersonnelChargesPerAddedValue = 'score_personnel_charges_per_added_value',
  /** column name */
  ScoreRenewalRateFixedAssets = 'score_renewal_rate_fixed_assets',
  /** column name */
  ScoreShortTermDebt = 'score_short_term_debt',
  /** column name */
  ScoreStockTurnoverProcessedGoods = 'score_stock_turnover_processed_goods',
  /** column name */
  ScoreStockTurnoverRawMaterial = 'score_stock_turnover_raw_material',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.analytics_company_score" */
export type Risolto_Analytics_Company_Score_Set_Input = {
  approval_date?: Maybe<Scalars['date']>;
  average_score?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['numeric']>;
  legal_form?: Maybe<Scalars['String']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_employee?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  ratio_cashflow_debt?: Maybe<Scalars['numeric']>;
  ratio_days_customer_credit?: Maybe<Scalars['numeric']>;
  ratio_days_supplier_credit?: Maybe<Scalars['numeric']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_financial_independence?: Maybe<Scalars['numeric']>;
  ratio_gross_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  ratio_liquidity_broad?: Maybe<Scalars['numeric']>;
  ratio_liquidity_narrow?: Maybe<Scalars['numeric']>;
  ratio_net_cash?: Maybe<Scalars['numeric']>;
  ratio_net_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_equity?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_short_term_debt?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  reference?: Maybe<Scalars['uuid']>;
  schema?: Maybe<Scalars['String']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  score_added_value_per_employee?: Maybe<Scalars['numeric']>;
  score_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  score_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  score_cashflow_debt?: Maybe<Scalars['numeric']>;
  score_days_customer_credit?: Maybe<Scalars['numeric']>;
  score_days_supplier_credit?: Maybe<Scalars['numeric']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  score_financial_independence?: Maybe<Scalars['numeric']>;
  score_gross_operating_margin?: Maybe<Scalars['numeric']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  score_liquidity_broad?: Maybe<Scalars['numeric']>;
  score_liquidity_narrow?: Maybe<Scalars['numeric']>;
  score_net_cash?: Maybe<Scalars['numeric']>;
  score_net_operating_margin?: Maybe<Scalars['numeric']>;
  score_net_return_on_equity?: Maybe<Scalars['numeric']>;
  score_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  score_short_term_debt?: Maybe<Scalars['numeric']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Analytics_Company_Score_Stddev_Fields = {
  __typename?: 'risolto_analytics_company_score_stddev_fields';
  average_score?: Maybe<Scalars['Float']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['Float']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  ratio_added_value_per_employee?: Maybe<Scalars['Float']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  ratio_cashflow_debt?: Maybe<Scalars['Float']>;
  ratio_days_customer_credit?: Maybe<Scalars['Float']>;
  ratio_days_supplier_credit?: Maybe<Scalars['Float']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  ratio_financial_independence?: Maybe<Scalars['Float']>;
  ratio_gross_operating_margin?: Maybe<Scalars['Float']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  ratio_liquidity_broad?: Maybe<Scalars['Float']>;
  ratio_liquidity_narrow?: Maybe<Scalars['Float']>;
  ratio_net_cash?: Maybe<Scalars['Float']>;
  ratio_net_operating_margin?: Maybe<Scalars['Float']>;
  ratio_net_return_on_equity?: Maybe<Scalars['Float']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_short_term_debt?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  score_added_value_per_employee?: Maybe<Scalars['Float']>;
  score_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  score_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  score_cashflow_debt?: Maybe<Scalars['Float']>;
  score_days_customer_credit?: Maybe<Scalars['Float']>;
  score_days_supplier_credit?: Maybe<Scalars['Float']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  score_financial_independence?: Maybe<Scalars['Float']>;
  score_gross_operating_margin?: Maybe<Scalars['Float']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  score_liquidity_broad?: Maybe<Scalars['Float']>;
  score_liquidity_narrow?: Maybe<Scalars['Float']>;
  score_net_cash?: Maybe<Scalars['Float']>;
  score_net_operating_margin?: Maybe<Scalars['Float']>;
  score_net_return_on_equity?: Maybe<Scalars['Float']>;
  score_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  score_short_term_debt?: Maybe<Scalars['Float']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  state_debt?: Maybe<Scalars['numeric']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Analytics_Company_Score_Stddev_Pop_Fields = {
  __typename?: 'risolto_analytics_company_score_stddev_pop_fields';
  average_score?: Maybe<Scalars['Float']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['Float']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  ratio_added_value_per_employee?: Maybe<Scalars['Float']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  ratio_cashflow_debt?: Maybe<Scalars['Float']>;
  ratio_days_customer_credit?: Maybe<Scalars['Float']>;
  ratio_days_supplier_credit?: Maybe<Scalars['Float']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  ratio_financial_independence?: Maybe<Scalars['Float']>;
  ratio_gross_operating_margin?: Maybe<Scalars['Float']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  ratio_liquidity_broad?: Maybe<Scalars['Float']>;
  ratio_liquidity_narrow?: Maybe<Scalars['Float']>;
  ratio_net_cash?: Maybe<Scalars['Float']>;
  ratio_net_operating_margin?: Maybe<Scalars['Float']>;
  ratio_net_return_on_equity?: Maybe<Scalars['Float']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_short_term_debt?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  score_added_value_per_employee?: Maybe<Scalars['Float']>;
  score_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  score_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  score_cashflow_debt?: Maybe<Scalars['Float']>;
  score_days_customer_credit?: Maybe<Scalars['Float']>;
  score_days_supplier_credit?: Maybe<Scalars['Float']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  score_financial_independence?: Maybe<Scalars['Float']>;
  score_gross_operating_margin?: Maybe<Scalars['Float']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  score_liquidity_broad?: Maybe<Scalars['Float']>;
  score_liquidity_narrow?: Maybe<Scalars['Float']>;
  score_net_cash?: Maybe<Scalars['Float']>;
  score_net_operating_margin?: Maybe<Scalars['Float']>;
  score_net_return_on_equity?: Maybe<Scalars['Float']>;
  score_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  score_short_term_debt?: Maybe<Scalars['Float']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  state_debt?: Maybe<Scalars['numeric']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Analytics_Company_Score_Stddev_Samp_Fields = {
  __typename?: 'risolto_analytics_company_score_stddev_samp_fields';
  average_score?: Maybe<Scalars['Float']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['Float']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  ratio_added_value_per_employee?: Maybe<Scalars['Float']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  ratio_cashflow_debt?: Maybe<Scalars['Float']>;
  ratio_days_customer_credit?: Maybe<Scalars['Float']>;
  ratio_days_supplier_credit?: Maybe<Scalars['Float']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  ratio_financial_independence?: Maybe<Scalars['Float']>;
  ratio_gross_operating_margin?: Maybe<Scalars['Float']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  ratio_liquidity_broad?: Maybe<Scalars['Float']>;
  ratio_liquidity_narrow?: Maybe<Scalars['Float']>;
  ratio_net_cash?: Maybe<Scalars['Float']>;
  ratio_net_operating_margin?: Maybe<Scalars['Float']>;
  ratio_net_return_on_equity?: Maybe<Scalars['Float']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_short_term_debt?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  score_added_value_per_employee?: Maybe<Scalars['Float']>;
  score_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  score_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  score_cashflow_debt?: Maybe<Scalars['Float']>;
  score_days_customer_credit?: Maybe<Scalars['Float']>;
  score_days_supplier_credit?: Maybe<Scalars['Float']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  score_financial_independence?: Maybe<Scalars['Float']>;
  score_gross_operating_margin?: Maybe<Scalars['Float']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  score_liquidity_broad?: Maybe<Scalars['Float']>;
  score_liquidity_narrow?: Maybe<Scalars['Float']>;
  score_net_cash?: Maybe<Scalars['Float']>;
  score_net_operating_margin?: Maybe<Scalars['Float']>;
  score_net_return_on_equity?: Maybe<Scalars['Float']>;
  score_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  score_short_term_debt?: Maybe<Scalars['Float']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  state_debt?: Maybe<Scalars['numeric']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "risolto_analytics_company_score" */
export type Risolto_Analytics_Company_Score_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Analytics_Company_Score_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Analytics_Company_Score_Stream_Cursor_Value_Input = {
  approval_date?: Maybe<Scalars['date']>;
  average_score?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['numeric']>;
  legal_form?: Maybe<Scalars['String']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  legal_name?: Maybe<Scalars['String']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_employee?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  ratio_cashflow_debt?: Maybe<Scalars['numeric']>;
  ratio_days_customer_credit?: Maybe<Scalars['numeric']>;
  ratio_days_supplier_credit?: Maybe<Scalars['numeric']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_financial_independence?: Maybe<Scalars['numeric']>;
  ratio_gross_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  ratio_liquidity_broad?: Maybe<Scalars['numeric']>;
  ratio_liquidity_narrow?: Maybe<Scalars['numeric']>;
  ratio_net_cash?: Maybe<Scalars['numeric']>;
  ratio_net_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_equity?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_short_term_debt?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  reference?: Maybe<Scalars['uuid']>;
  schema?: Maybe<Scalars['String']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  score_added_value_per_employee?: Maybe<Scalars['numeric']>;
  score_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  score_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  score_cashflow_debt?: Maybe<Scalars['numeric']>;
  score_days_customer_credit?: Maybe<Scalars['numeric']>;
  score_days_supplier_credit?: Maybe<Scalars['numeric']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  score_financial_independence?: Maybe<Scalars['numeric']>;
  score_gross_operating_margin?: Maybe<Scalars['numeric']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  score_liquidity_broad?: Maybe<Scalars['numeric']>;
  score_liquidity_narrow?: Maybe<Scalars['numeric']>;
  score_net_cash?: Maybe<Scalars['numeric']>;
  score_net_operating_margin?: Maybe<Scalars['numeric']>;
  score_net_return_on_equity?: Maybe<Scalars['numeric']>;
  score_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  score_short_term_debt?: Maybe<Scalars['numeric']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Analytics_Company_Score_Sum_Fields = {
  __typename?: 'risolto_analytics_company_score_sum_fields';
  average_score?: Maybe<Scalars['numeric']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['numeric']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_employee?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  ratio_cashflow_debt?: Maybe<Scalars['numeric']>;
  ratio_days_customer_credit?: Maybe<Scalars['numeric']>;
  ratio_days_supplier_credit?: Maybe<Scalars['numeric']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_financial_independence?: Maybe<Scalars['numeric']>;
  ratio_gross_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  ratio_liquidity_broad?: Maybe<Scalars['numeric']>;
  ratio_liquidity_narrow?: Maybe<Scalars['numeric']>;
  ratio_net_cash?: Maybe<Scalars['numeric']>;
  ratio_net_operating_margin?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_equity?: Maybe<Scalars['numeric']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  ratio_short_term_debt?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['numeric']>;
  score_added_value_per_employee?: Maybe<Scalars['numeric']>;
  score_added_value_per_operating_income?: Maybe<Scalars['numeric']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['numeric']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['numeric']>;
  score_cash_flow_per_equity?: Maybe<Scalars['numeric']>;
  score_cashflow_debt?: Maybe<Scalars['numeric']>;
  score_days_customer_credit?: Maybe<Scalars['numeric']>;
  score_days_supplier_credit?: Maybe<Scalars['numeric']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_depreciation_per_added_value?: Maybe<Scalars['numeric']>;
  score_financial_independence?: Maybe<Scalars['numeric']>;
  score_gross_operating_margin?: Maybe<Scalars['numeric']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['numeric']>;
  score_liquidity_broad?: Maybe<Scalars['numeric']>;
  score_liquidity_narrow?: Maybe<Scalars['numeric']>;
  score_net_cash?: Maybe<Scalars['numeric']>;
  score_net_operating_margin?: Maybe<Scalars['numeric']>;
  score_net_return_on_equity?: Maybe<Scalars['numeric']>;
  score_net_return_on_total_assets?: Maybe<Scalars['numeric']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['numeric']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['numeric']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['numeric']>;
  score_short_term_debt?: Maybe<Scalars['numeric']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['numeric']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['numeric']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  state_debt?: Maybe<Scalars['numeric']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** update columns of table "risolto.analytics_company_score" */
export enum Risolto_Analytics_Company_Score_Update_Column {
  /** column name */
  ApprovalDate = 'approval_date',
  /** column name */
  AverageScore = 'average_score',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  GeneralScore = 'general_score',
  /** column name */
  LegalForm = 'legal_form',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  LegalIdType = 'legal_id_type',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  RatioAcquisitionFixedAssetsPerAddedValue = 'ratio_acquisition_fixed_assets_per_added_value',
  /** column name */
  RatioAddedValuePerEmployee = 'ratio_added_value_per_employee',
  /** column name */
  RatioAddedValuePerOperatingIncome = 'ratio_added_value_per_operating_income',
  /** column name */
  RatioAddedValuePerPersonnelCharges = 'ratio_added_value_per_personnel_charges',
  /** column name */
  RatioAddedValuePerTangibleFixedAssets = 'ratio_added_value_per_tangible_fixed_assets',
  /** column name */
  RatioCashFlowPerEquity = 'ratio_cash_flow_per_equity',
  /** column name */
  RatioCashflowDebt = 'ratio_cashflow_debt',
  /** column name */
  RatioDaysCustomerCredit = 'ratio_days_customer_credit',
  /** column name */
  RatioDaysSupplierCredit = 'ratio_days_supplier_credit',
  /** column name */
  RatioDebtChargesPerAddedValue = 'ratio_debt_charges_per_added_value',
  /** column name */
  RatioDepreciationPerAddedValue = 'ratio_depreciation_per_added_value',
  /** column name */
  RatioFinancialIndependence = 'ratio_financial_independence',
  /** column name */
  RatioGrossOperatingMargin = 'ratio_gross_operating_margin',
  /** column name */
  RatioGrossReturnOnTotalAssets = 'ratio_gross_return_on_total_assets',
  /** column name */
  RatioLevelOfEquityCapitalisation = 'ratio_level_of_equity_capitalisation',
  /** column name */
  RatioLiquidityBroad = 'ratio_liquidity_broad',
  /** column name */
  RatioLiquidityNarrow = 'ratio_liquidity_narrow',
  /** column name */
  RatioNetCash = 'ratio_net_cash',
  /** column name */
  RatioNetOperatingMargin = 'ratio_net_operating_margin',
  /** column name */
  RatioNetReturnOnEquity = 'ratio_net_return_on_equity',
  /** column name */
  RatioNetReturnOnTotalAssets = 'ratio_net_return_on_total_assets',
  /** column name */
  RatioOverdueTaxAndSocialSecurityDebt = 'ratio_overdue_tax_and_social_security_debt',
  /** column name */
  RatioPersonnelChargesPerAddedValue = 'ratio_personnel_charges_per_added_value',
  /** column name */
  RatioRenewalRateFixedAssets = 'ratio_renewal_rate_fixed_assets',
  /** column name */
  RatioShortTermDebt = 'ratio_short_term_debt',
  /** column name */
  RatioStockTurnoverProcessedGoods = 'ratio_stock_turnover_processed_goods',
  /** column name */
  RatioStockTurnoverRawMaterial = 'ratio_stock_turnover_raw_material',
  /** column name */
  Reference = 'reference',
  /** column name */
  Schema = 'schema',
  /** column name */
  ScoreAcquisitionFixedAssetsPerAddedValue = 'score_acquisition_fixed_assets_per_added_value',
  /** column name */
  ScoreAddedValuePerEmployee = 'score_added_value_per_employee',
  /** column name */
  ScoreAddedValuePerOperatingIncome = 'score_added_value_per_operating_income',
  /** column name */
  ScoreAddedValuePerPersonnelCharges = 'score_added_value_per_personnel_charges',
  /** column name */
  ScoreAddedValuePerTangibleFixedAssets = 'score_added_value_per_tangible_fixed_assets',
  /** column name */
  ScoreCashFlowPerEquity = 'score_cash_flow_per_equity',
  /** column name */
  ScoreCashflowDebt = 'score_cashflow_debt',
  /** column name */
  ScoreDaysCustomerCredit = 'score_days_customer_credit',
  /** column name */
  ScoreDaysSupplierCredit = 'score_days_supplier_credit',
  /** column name */
  ScoreDebtChargesPerAddedValue = 'score_debt_charges_per_added_value',
  /** column name */
  ScoreDepreciationPerAddedValue = 'score_depreciation_per_added_value',
  /** column name */
  ScoreFinancialIndependence = 'score_financial_independence',
  /** column name */
  ScoreGrossOperatingMargin = 'score_gross_operating_margin',
  /** column name */
  ScoreGrossReturnOnTotalAssets = 'score_gross_return_on_total_assets',
  /** column name */
  ScoreLevelOfEquityCapitalisation = 'score_level_of_equity_capitalisation',
  /** column name */
  ScoreLiquidityBroad = 'score_liquidity_broad',
  /** column name */
  ScoreLiquidityNarrow = 'score_liquidity_narrow',
  /** column name */
  ScoreNetCash = 'score_net_cash',
  /** column name */
  ScoreNetOperatingMargin = 'score_net_operating_margin',
  /** column name */
  ScoreNetReturnOnEquity = 'score_net_return_on_equity',
  /** column name */
  ScoreNetReturnOnTotalAssets = 'score_net_return_on_total_assets',
  /** column name */
  ScoreOverdueTaxAndSocialSecurityDebt = 'score_overdue_tax_and_social_security_debt',
  /** column name */
  ScorePersonnelChargesPerAddedValue = 'score_personnel_charges_per_added_value',
  /** column name */
  ScoreRenewalRateFixedAssets = 'score_renewal_rate_fixed_assets',
  /** column name */
  ScoreShortTermDebt = 'score_short_term_debt',
  /** column name */
  ScoreStockTurnoverProcessedGoods = 'score_stock_turnover_processed_goods',
  /** column name */
  ScoreStockTurnoverRawMaterial = 'score_stock_turnover_raw_material',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Analytics_Company_Score_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Analytics_Company_Score_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Analytics_Company_Score_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Analytics_Company_Score_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Analytics_Company_Score_Var_Pop_Fields = {
  __typename?: 'risolto_analytics_company_score_var_pop_fields';
  average_score?: Maybe<Scalars['Float']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['Float']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  ratio_added_value_per_employee?: Maybe<Scalars['Float']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  ratio_cashflow_debt?: Maybe<Scalars['Float']>;
  ratio_days_customer_credit?: Maybe<Scalars['Float']>;
  ratio_days_supplier_credit?: Maybe<Scalars['Float']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  ratio_financial_independence?: Maybe<Scalars['Float']>;
  ratio_gross_operating_margin?: Maybe<Scalars['Float']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  ratio_liquidity_broad?: Maybe<Scalars['Float']>;
  ratio_liquidity_narrow?: Maybe<Scalars['Float']>;
  ratio_net_cash?: Maybe<Scalars['Float']>;
  ratio_net_operating_margin?: Maybe<Scalars['Float']>;
  ratio_net_return_on_equity?: Maybe<Scalars['Float']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_short_term_debt?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  score_added_value_per_employee?: Maybe<Scalars['Float']>;
  score_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  score_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  score_cashflow_debt?: Maybe<Scalars['Float']>;
  score_days_customer_credit?: Maybe<Scalars['Float']>;
  score_days_supplier_credit?: Maybe<Scalars['Float']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  score_financial_independence?: Maybe<Scalars['Float']>;
  score_gross_operating_margin?: Maybe<Scalars['Float']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  score_liquidity_broad?: Maybe<Scalars['Float']>;
  score_liquidity_narrow?: Maybe<Scalars['Float']>;
  score_net_cash?: Maybe<Scalars['Float']>;
  score_net_operating_margin?: Maybe<Scalars['Float']>;
  score_net_return_on_equity?: Maybe<Scalars['Float']>;
  score_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  score_short_term_debt?: Maybe<Scalars['Float']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  state_debt?: Maybe<Scalars['numeric']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** aggregate var_samp on columns */
export type Risolto_Analytics_Company_Score_Var_Samp_Fields = {
  __typename?: 'risolto_analytics_company_score_var_samp_fields';
  average_score?: Maybe<Scalars['Float']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['Float']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  ratio_added_value_per_employee?: Maybe<Scalars['Float']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  ratio_cashflow_debt?: Maybe<Scalars['Float']>;
  ratio_days_customer_credit?: Maybe<Scalars['Float']>;
  ratio_days_supplier_credit?: Maybe<Scalars['Float']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  ratio_financial_independence?: Maybe<Scalars['Float']>;
  ratio_gross_operating_margin?: Maybe<Scalars['Float']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  ratio_liquidity_broad?: Maybe<Scalars['Float']>;
  ratio_liquidity_narrow?: Maybe<Scalars['Float']>;
  ratio_net_cash?: Maybe<Scalars['Float']>;
  ratio_net_operating_margin?: Maybe<Scalars['Float']>;
  ratio_net_return_on_equity?: Maybe<Scalars['Float']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_short_term_debt?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  score_added_value_per_employee?: Maybe<Scalars['Float']>;
  score_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  score_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  score_cashflow_debt?: Maybe<Scalars['Float']>;
  score_days_customer_credit?: Maybe<Scalars['Float']>;
  score_days_supplier_credit?: Maybe<Scalars['Float']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  score_financial_independence?: Maybe<Scalars['Float']>;
  score_gross_operating_margin?: Maybe<Scalars['Float']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  score_liquidity_broad?: Maybe<Scalars['Float']>;
  score_liquidity_narrow?: Maybe<Scalars['Float']>;
  score_net_cash?: Maybe<Scalars['Float']>;
  score_net_operating_margin?: Maybe<Scalars['Float']>;
  score_net_return_on_equity?: Maybe<Scalars['Float']>;
  score_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  score_short_term_debt?: Maybe<Scalars['Float']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  state_debt?: Maybe<Scalars['numeric']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** aggregate variance on columns */
export type Risolto_Analytics_Company_Score_Variance_Fields = {
  __typename?: 'risolto_analytics_company_score_variance_fields';
  average_score?: Maybe<Scalars['Float']>;
  /** The general score takes into account previous information (on liquidity, solvency and profitability) and also adds information on short term debt towards the parties with the highest power to collect it: the banks, the taxman and the social security services. */
  general_score?: Maybe<Scalars['Float']>;
  /** The liquidity of a firm gives an idea on how liquid its assets are, and thus how easily assets can be converted into liquid means (cash) to pay off its debts. */
  liquidity?: Maybe<Scalars['numeric']>;
  /** The profitability score gives an indication on both the profitability (before/after taxes and interests) versus the total assets, as well as the profitability versus the equity. */
  profitability?: Maybe<Scalars['numeric']>;
  ratio_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  ratio_added_value_per_employee?: Maybe<Scalars['Float']>;
  ratio_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  ratio_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  ratio_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  ratio_cashflow_debt?: Maybe<Scalars['Float']>;
  ratio_days_customer_credit?: Maybe<Scalars['Float']>;
  ratio_days_supplier_credit?: Maybe<Scalars['Float']>;
  ratio_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  ratio_financial_independence?: Maybe<Scalars['Float']>;
  ratio_gross_operating_margin?: Maybe<Scalars['Float']>;
  ratio_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  ratio_liquidity_broad?: Maybe<Scalars['Float']>;
  ratio_liquidity_narrow?: Maybe<Scalars['Float']>;
  ratio_net_cash?: Maybe<Scalars['Float']>;
  ratio_net_operating_margin?: Maybe<Scalars['Float']>;
  ratio_net_return_on_equity?: Maybe<Scalars['Float']>;
  ratio_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  ratio_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  ratio_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  ratio_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  ratio_short_term_debt?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  ratio_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  score_acquisition_fixed_assets_per_added_value?: Maybe<Scalars['Float']>;
  score_added_value_per_employee?: Maybe<Scalars['Float']>;
  score_added_value_per_operating_income?: Maybe<Scalars['Float']>;
  score_added_value_per_personnel_charges?: Maybe<Scalars['Float']>;
  score_added_value_per_tangible_fixed_assets?: Maybe<Scalars['Float']>;
  score_cash_flow_per_equity?: Maybe<Scalars['Float']>;
  score_cashflow_debt?: Maybe<Scalars['Float']>;
  score_days_customer_credit?: Maybe<Scalars['Float']>;
  score_days_supplier_credit?: Maybe<Scalars['Float']>;
  score_debt_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_depreciation_per_added_value?: Maybe<Scalars['Float']>;
  score_financial_independence?: Maybe<Scalars['Float']>;
  score_gross_operating_margin?: Maybe<Scalars['Float']>;
  score_gross_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_level_of_equity_capitalisation?: Maybe<Scalars['Float']>;
  score_liquidity_broad?: Maybe<Scalars['Float']>;
  score_liquidity_narrow?: Maybe<Scalars['Float']>;
  score_net_cash?: Maybe<Scalars['Float']>;
  score_net_operating_margin?: Maybe<Scalars['Float']>;
  score_net_return_on_equity?: Maybe<Scalars['Float']>;
  score_net_return_on_total_assets?: Maybe<Scalars['Float']>;
  score_overdue_tax_and_social_security_debt?: Maybe<Scalars['Float']>;
  score_personnel_charges_per_added_value?: Maybe<Scalars['Float']>;
  score_renewal_rate_fixed_assets?: Maybe<Scalars['Float']>;
  score_short_term_debt?: Maybe<Scalars['Float']>;
  score_stock_turnover_processed_goods?: Maybe<Scalars['Float']>;
  score_stock_turnover_raw_material?: Maybe<Scalars['Float']>;
  short_term_financial_debt?: Maybe<Scalars['numeric']>;
  /** The solvency of a firm gives an indication on the relationship between its debt and its equity. The score takes into account some of the traditional solvency scores, as well as an indication on how easily the debt can be repaid with the company’s cash flow. Debt-rich companies with low cash flows will have the lowest solvency scores. */
  solvency?: Maybe<Scalars['numeric']>;
  state_debt?: Maybe<Scalars['numeric']>;
  weighted_average_score?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features = {
  __typename?: 'risolto_analytics_invoice_features';
  amount_multiplier: Scalars['numeric'];
  avg_days_late: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  days_under_contract: Scalars['bigint'];
  default_rate: Scalars['numeric'];
  direct_debit: Scalars['Boolean'];
  hist_amount_late: Scalars['numeric'];
  hist_amount_on_time: Scalars['numeric'];
  hist_avg_amount_late: Scalars['numeric'];
  hist_avg_amount_on_time: Scalars['numeric'];
  hist_avg_days_late: Scalars['numeric'];
  hist_days_late: Scalars['bigint'];
  hist_number_late: Scalars['bigint'];
  hist_number_on_time: Scalars['bigint'];
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  issue_date_day_of_week: Scalars['String'];
  late_rate: Scalars['numeric'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nr_of_default_communications: Scalars['bigint'];
  open_amount_late: Scalars['numeric'];
  open_amount_on_time: Scalars['numeric'];
  open_avg_amount_late: Scalars['numeric'];
  open_avg_amount_on_time: Scalars['numeric'];
  open_avg_days_late: Scalars['numeric'];
  open_days_late: Scalars['bigint'];
  open_number_late: Scalars['bigint'];
  open_number_on_time: Scalars['bigint'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Aggregate = {
  __typename?: 'risolto_analytics_invoice_features_aggregate';
  aggregate?: Maybe<Risolto_Analytics_Invoice_Features_Aggregate_Fields>;
  nodes: Array<Risolto_Analytics_Invoice_Features>;
};

/** aggregate fields of "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Aggregate_Fields = {
  __typename?: 'risolto_analytics_invoice_features_aggregate_fields';
  avg?: Maybe<Risolto_Analytics_Invoice_Features_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Analytics_Invoice_Features_Max_Fields>;
  min?: Maybe<Risolto_Analytics_Invoice_Features_Min_Fields>;
  stddev?: Maybe<Risolto_Analytics_Invoice_Features_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Analytics_Invoice_Features_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Analytics_Invoice_Features_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Analytics_Invoice_Features_Sum_Fields>;
  var_pop?: Maybe<Risolto_Analytics_Invoice_Features_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Analytics_Invoice_Features_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Analytics_Invoice_Features_Variance_Fields>;
};


/** aggregate fields of "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Analytics_Invoice_Features_Avg_Fields = {
  __typename?: 'risolto_analytics_invoice_features_avg_fields';
  amount_multiplier?: Maybe<Scalars['Float']>;
  avg_days_late?: Maybe<Scalars['Float']>;
  days_under_contract?: Maybe<Scalars['Float']>;
  default_rate?: Maybe<Scalars['Float']>;
  hist_amount_late?: Maybe<Scalars['Float']>;
  hist_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_amount_late?: Maybe<Scalars['Float']>;
  hist_avg_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_days_late?: Maybe<Scalars['Float']>;
  hist_days_late?: Maybe<Scalars['Float']>;
  hist_number_late?: Maybe<Scalars['Float']>;
  hist_number_on_time?: Maybe<Scalars['Float']>;
  late_rate?: Maybe<Scalars['Float']>;
  nr_of_default_communications?: Maybe<Scalars['Float']>;
  open_amount_late?: Maybe<Scalars['Float']>;
  open_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_amount_late?: Maybe<Scalars['Float']>;
  open_avg_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_days_late?: Maybe<Scalars['Float']>;
  open_days_late?: Maybe<Scalars['Float']>;
  open_number_late?: Maybe<Scalars['Float']>;
  open_number_on_time?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.analytics_invoice_features". All fields are combined with a logical 'AND'. */
export type Risolto_Analytics_Invoice_Features_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Analytics_Invoice_Features_Bool_Exp>>;
  _not?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Analytics_Invoice_Features_Bool_Exp>>;
  amount_multiplier?: Maybe<Numeric_Comparison_Exp>;
  avg_days_late?: Maybe<Numeric_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  days_under_contract?: Maybe<Bigint_Comparison_Exp>;
  default_rate?: Maybe<Numeric_Comparison_Exp>;
  direct_debit?: Maybe<Boolean_Comparison_Exp>;
  hist_amount_late?: Maybe<Numeric_Comparison_Exp>;
  hist_amount_on_time?: Maybe<Numeric_Comparison_Exp>;
  hist_avg_amount_late?: Maybe<Numeric_Comparison_Exp>;
  hist_avg_amount_on_time?: Maybe<Numeric_Comparison_Exp>;
  hist_avg_days_late?: Maybe<Numeric_Comparison_Exp>;
  hist_days_late?: Maybe<Bigint_Comparison_Exp>;
  hist_number_late?: Maybe<Bigint_Comparison_Exp>;
  hist_number_on_time?: Maybe<Bigint_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  issue_date_day_of_week?: Maybe<String_Comparison_Exp>;
  late_rate?: Maybe<Numeric_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  legal_id?: Maybe<String_Comparison_Exp>;
  legal_id_type?: Maybe<String_Comparison_Exp>;
  nr_of_default_communications?: Maybe<Bigint_Comparison_Exp>;
  open_amount_late?: Maybe<Numeric_Comparison_Exp>;
  open_amount_on_time?: Maybe<Numeric_Comparison_Exp>;
  open_avg_amount_late?: Maybe<Numeric_Comparison_Exp>;
  open_avg_amount_on_time?: Maybe<Numeric_Comparison_Exp>;
  open_avg_days_late?: Maybe<Numeric_Comparison_Exp>;
  open_days_late?: Maybe<Bigint_Comparison_Exp>;
  open_number_late?: Maybe<Bigint_Comparison_Exp>;
  open_number_on_time?: Maybe<Bigint_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  zip_code?: Maybe<String_Comparison_Exp>;
};

export type Risolto_Analytics_Invoice_Features_By_Date_Args = {
  q_invoice?: Maybe<Scalars['uuid']>;
  q_paydate_margin?: Maybe<Scalars['Int']>;
};

/** unique or primary key constraints on table "risolto.analytics_invoice_features" */
export enum Risolto_Analytics_Invoice_Features_Constraint {
  /** unique or primary key constraint on columns "invoice" */
  AnalyticsInvoiceFeaturesInvoiceKey = 'analytics_invoice_features_invoice_key',
  /** unique or primary key constraint on columns "reference" */
  AnalyticsInvoiceFeaturesPkey = 'analytics_invoice_features_pkey'
}

/** input type for incrementing numeric columns in table "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Inc_Input = {
  amount_multiplier?: Maybe<Scalars['numeric']>;
  avg_days_late?: Maybe<Scalars['numeric']>;
  days_under_contract?: Maybe<Scalars['bigint']>;
  default_rate?: Maybe<Scalars['numeric']>;
  hist_amount_late?: Maybe<Scalars['numeric']>;
  hist_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_amount_late?: Maybe<Scalars['numeric']>;
  hist_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_days_late?: Maybe<Scalars['numeric']>;
  hist_days_late?: Maybe<Scalars['bigint']>;
  hist_number_late?: Maybe<Scalars['bigint']>;
  hist_number_on_time?: Maybe<Scalars['bigint']>;
  late_rate?: Maybe<Scalars['numeric']>;
  nr_of_default_communications?: Maybe<Scalars['bigint']>;
  open_amount_late?: Maybe<Scalars['numeric']>;
  open_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_amount_late?: Maybe<Scalars['numeric']>;
  open_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_days_late?: Maybe<Scalars['numeric']>;
  open_days_late?: Maybe<Scalars['bigint']>;
  open_number_late?: Maybe<Scalars['bigint']>;
  open_number_on_time?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Insert_Input = {
  amount_multiplier?: Maybe<Scalars['numeric']>;
  avg_days_late?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  days_under_contract?: Maybe<Scalars['bigint']>;
  default_rate?: Maybe<Scalars['numeric']>;
  direct_debit?: Maybe<Scalars['Boolean']>;
  hist_amount_late?: Maybe<Scalars['numeric']>;
  hist_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_amount_late?: Maybe<Scalars['numeric']>;
  hist_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_days_late?: Maybe<Scalars['numeric']>;
  hist_days_late?: Maybe<Scalars['bigint']>;
  hist_number_late?: Maybe<Scalars['bigint']>;
  hist_number_on_time?: Maybe<Scalars['bigint']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  issue_date_day_of_week?: Maybe<Scalars['String']>;
  late_rate?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nr_of_default_communications?: Maybe<Scalars['bigint']>;
  open_amount_late?: Maybe<Scalars['numeric']>;
  open_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_amount_late?: Maybe<Scalars['numeric']>;
  open_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_days_late?: Maybe<Scalars['numeric']>;
  open_days_late?: Maybe<Scalars['bigint']>;
  open_number_late?: Maybe<Scalars['bigint']>;
  open_number_on_time?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Analytics_Invoice_Features_Max_Fields = {
  __typename?: 'risolto_analytics_invoice_features_max_fields';
  amount_multiplier?: Maybe<Scalars['numeric']>;
  avg_days_late?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  days_under_contract?: Maybe<Scalars['bigint']>;
  default_rate?: Maybe<Scalars['numeric']>;
  hist_amount_late?: Maybe<Scalars['numeric']>;
  hist_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_amount_late?: Maybe<Scalars['numeric']>;
  hist_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_days_late?: Maybe<Scalars['numeric']>;
  hist_days_late?: Maybe<Scalars['bigint']>;
  hist_number_late?: Maybe<Scalars['bigint']>;
  hist_number_on_time?: Maybe<Scalars['bigint']>;
  invoice?: Maybe<Scalars['uuid']>;
  issue_date_day_of_week?: Maybe<Scalars['String']>;
  late_rate?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nr_of_default_communications?: Maybe<Scalars['bigint']>;
  open_amount_late?: Maybe<Scalars['numeric']>;
  open_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_amount_late?: Maybe<Scalars['numeric']>;
  open_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_days_late?: Maybe<Scalars['numeric']>;
  open_days_late?: Maybe<Scalars['bigint']>;
  open_number_late?: Maybe<Scalars['bigint']>;
  open_number_on_time?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Analytics_Invoice_Features_Min_Fields = {
  __typename?: 'risolto_analytics_invoice_features_min_fields';
  amount_multiplier?: Maybe<Scalars['numeric']>;
  avg_days_late?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  days_under_contract?: Maybe<Scalars['bigint']>;
  default_rate?: Maybe<Scalars['numeric']>;
  hist_amount_late?: Maybe<Scalars['numeric']>;
  hist_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_amount_late?: Maybe<Scalars['numeric']>;
  hist_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_days_late?: Maybe<Scalars['numeric']>;
  hist_days_late?: Maybe<Scalars['bigint']>;
  hist_number_late?: Maybe<Scalars['bigint']>;
  hist_number_on_time?: Maybe<Scalars['bigint']>;
  invoice?: Maybe<Scalars['uuid']>;
  issue_date_day_of_week?: Maybe<Scalars['String']>;
  late_rate?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nr_of_default_communications?: Maybe<Scalars['bigint']>;
  open_amount_late?: Maybe<Scalars['numeric']>;
  open_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_amount_late?: Maybe<Scalars['numeric']>;
  open_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_days_late?: Maybe<Scalars['numeric']>;
  open_days_late?: Maybe<Scalars['bigint']>;
  open_number_late?: Maybe<Scalars['bigint']>;
  open_number_on_time?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Mutation_Response = {
  __typename?: 'risolto_analytics_invoice_features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Analytics_Invoice_Features>;
};

/** input type for inserting object relation for remote table "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Obj_Rel_Insert_Input = {
  data: Risolto_Analytics_Invoice_Features_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Analytics_Invoice_Features_On_Conflict>;
};

/** on_conflict condition type for table "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_On_Conflict = {
  constraint: Risolto_Analytics_Invoice_Features_Constraint;
  update_columns?: Array<Risolto_Analytics_Invoice_Features_Update_Column>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.analytics_invoice_features". */
export type Risolto_Analytics_Invoice_Features_Order_By = {
  amount_multiplier?: Maybe<Order_By>;
  avg_days_late?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  days_under_contract?: Maybe<Order_By>;
  default_rate?: Maybe<Order_By>;
  direct_debit?: Maybe<Order_By>;
  hist_amount_late?: Maybe<Order_By>;
  hist_amount_on_time?: Maybe<Order_By>;
  hist_avg_amount_late?: Maybe<Order_By>;
  hist_avg_amount_on_time?: Maybe<Order_By>;
  hist_avg_days_late?: Maybe<Order_By>;
  hist_days_late?: Maybe<Order_By>;
  hist_number_late?: Maybe<Order_By>;
  hist_number_on_time?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  issue_date_day_of_week?: Maybe<Order_By>;
  late_rate?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  legal_id?: Maybe<Order_By>;
  legal_id_type?: Maybe<Order_By>;
  nr_of_default_communications?: Maybe<Order_By>;
  open_amount_late?: Maybe<Order_By>;
  open_amount_on_time?: Maybe<Order_By>;
  open_avg_amount_late?: Maybe<Order_By>;
  open_avg_amount_on_time?: Maybe<Order_By>;
  open_avg_days_late?: Maybe<Order_By>;
  open_days_late?: Maybe<Order_By>;
  open_number_late?: Maybe<Order_By>;
  open_number_on_time?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  zip_code?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.analytics_invoice_features */
export type Risolto_Analytics_Invoice_Features_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.analytics_invoice_features" */
export enum Risolto_Analytics_Invoice_Features_Select_Column {
  /** column name */
  AmountMultiplier = 'amount_multiplier',
  /** column name */
  AvgDaysLate = 'avg_days_late',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DaysUnderContract = 'days_under_contract',
  /** column name */
  DefaultRate = 'default_rate',
  /** column name */
  DirectDebit = 'direct_debit',
  /** column name */
  HistAmountLate = 'hist_amount_late',
  /** column name */
  HistAmountOnTime = 'hist_amount_on_time',
  /** column name */
  HistAvgAmountLate = 'hist_avg_amount_late',
  /** column name */
  HistAvgAmountOnTime = 'hist_avg_amount_on_time',
  /** column name */
  HistAvgDaysLate = 'hist_avg_days_late',
  /** column name */
  HistDaysLate = 'hist_days_late',
  /** column name */
  HistNumberLate = 'hist_number_late',
  /** column name */
  HistNumberOnTime = 'hist_number_on_time',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  IssueDateDayOfWeek = 'issue_date_day_of_week',
  /** column name */
  LateRate = 'late_rate',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  LegalIdType = 'legal_id_type',
  /** column name */
  NrOfDefaultCommunications = 'nr_of_default_communications',
  /** column name */
  OpenAmountLate = 'open_amount_late',
  /** column name */
  OpenAmountOnTime = 'open_amount_on_time',
  /** column name */
  OpenAvgAmountLate = 'open_avg_amount_late',
  /** column name */
  OpenAvgAmountOnTime = 'open_avg_amount_on_time',
  /** column name */
  OpenAvgDaysLate = 'open_avg_days_late',
  /** column name */
  OpenDaysLate = 'open_days_late',
  /** column name */
  OpenNumberLate = 'open_number_late',
  /** column name */
  OpenNumberOnTime = 'open_number_on_time',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZipCode = 'zip_code'
}

/** input type for updating data in table "risolto.analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Set_Input = {
  amount_multiplier?: Maybe<Scalars['numeric']>;
  avg_days_late?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  days_under_contract?: Maybe<Scalars['bigint']>;
  default_rate?: Maybe<Scalars['numeric']>;
  direct_debit?: Maybe<Scalars['Boolean']>;
  hist_amount_late?: Maybe<Scalars['numeric']>;
  hist_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_amount_late?: Maybe<Scalars['numeric']>;
  hist_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_days_late?: Maybe<Scalars['numeric']>;
  hist_days_late?: Maybe<Scalars['bigint']>;
  hist_number_late?: Maybe<Scalars['bigint']>;
  hist_number_on_time?: Maybe<Scalars['bigint']>;
  invoice?: Maybe<Scalars['uuid']>;
  issue_date_day_of_week?: Maybe<Scalars['String']>;
  late_rate?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nr_of_default_communications?: Maybe<Scalars['bigint']>;
  open_amount_late?: Maybe<Scalars['numeric']>;
  open_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_amount_late?: Maybe<Scalars['numeric']>;
  open_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_days_late?: Maybe<Scalars['numeric']>;
  open_days_late?: Maybe<Scalars['bigint']>;
  open_number_late?: Maybe<Scalars['bigint']>;
  open_number_on_time?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Risolto_Analytics_Invoice_Features_Stddev_Fields = {
  __typename?: 'risolto_analytics_invoice_features_stddev_fields';
  amount_multiplier?: Maybe<Scalars['Float']>;
  avg_days_late?: Maybe<Scalars['Float']>;
  days_under_contract?: Maybe<Scalars['Float']>;
  default_rate?: Maybe<Scalars['Float']>;
  hist_amount_late?: Maybe<Scalars['Float']>;
  hist_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_amount_late?: Maybe<Scalars['Float']>;
  hist_avg_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_days_late?: Maybe<Scalars['Float']>;
  hist_days_late?: Maybe<Scalars['Float']>;
  hist_number_late?: Maybe<Scalars['Float']>;
  hist_number_on_time?: Maybe<Scalars['Float']>;
  late_rate?: Maybe<Scalars['Float']>;
  nr_of_default_communications?: Maybe<Scalars['Float']>;
  open_amount_late?: Maybe<Scalars['Float']>;
  open_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_amount_late?: Maybe<Scalars['Float']>;
  open_avg_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_days_late?: Maybe<Scalars['Float']>;
  open_days_late?: Maybe<Scalars['Float']>;
  open_number_late?: Maybe<Scalars['Float']>;
  open_number_on_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Analytics_Invoice_Features_Stddev_Pop_Fields = {
  __typename?: 'risolto_analytics_invoice_features_stddev_pop_fields';
  amount_multiplier?: Maybe<Scalars['Float']>;
  avg_days_late?: Maybe<Scalars['Float']>;
  days_under_contract?: Maybe<Scalars['Float']>;
  default_rate?: Maybe<Scalars['Float']>;
  hist_amount_late?: Maybe<Scalars['Float']>;
  hist_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_amount_late?: Maybe<Scalars['Float']>;
  hist_avg_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_days_late?: Maybe<Scalars['Float']>;
  hist_days_late?: Maybe<Scalars['Float']>;
  hist_number_late?: Maybe<Scalars['Float']>;
  hist_number_on_time?: Maybe<Scalars['Float']>;
  late_rate?: Maybe<Scalars['Float']>;
  nr_of_default_communications?: Maybe<Scalars['Float']>;
  open_amount_late?: Maybe<Scalars['Float']>;
  open_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_amount_late?: Maybe<Scalars['Float']>;
  open_avg_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_days_late?: Maybe<Scalars['Float']>;
  open_days_late?: Maybe<Scalars['Float']>;
  open_number_late?: Maybe<Scalars['Float']>;
  open_number_on_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Analytics_Invoice_Features_Stddev_Samp_Fields = {
  __typename?: 'risolto_analytics_invoice_features_stddev_samp_fields';
  amount_multiplier?: Maybe<Scalars['Float']>;
  avg_days_late?: Maybe<Scalars['Float']>;
  days_under_contract?: Maybe<Scalars['Float']>;
  default_rate?: Maybe<Scalars['Float']>;
  hist_amount_late?: Maybe<Scalars['Float']>;
  hist_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_amount_late?: Maybe<Scalars['Float']>;
  hist_avg_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_days_late?: Maybe<Scalars['Float']>;
  hist_days_late?: Maybe<Scalars['Float']>;
  hist_number_late?: Maybe<Scalars['Float']>;
  hist_number_on_time?: Maybe<Scalars['Float']>;
  late_rate?: Maybe<Scalars['Float']>;
  nr_of_default_communications?: Maybe<Scalars['Float']>;
  open_amount_late?: Maybe<Scalars['Float']>;
  open_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_amount_late?: Maybe<Scalars['Float']>;
  open_avg_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_days_late?: Maybe<Scalars['Float']>;
  open_days_late?: Maybe<Scalars['Float']>;
  open_number_late?: Maybe<Scalars['Float']>;
  open_number_on_time?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_analytics_invoice_features" */
export type Risolto_Analytics_Invoice_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Analytics_Invoice_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Analytics_Invoice_Features_Stream_Cursor_Value_Input = {
  amount_multiplier?: Maybe<Scalars['numeric']>;
  avg_days_late?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  days_under_contract?: Maybe<Scalars['bigint']>;
  default_rate?: Maybe<Scalars['numeric']>;
  direct_debit?: Maybe<Scalars['Boolean']>;
  hist_amount_late?: Maybe<Scalars['numeric']>;
  hist_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_amount_late?: Maybe<Scalars['numeric']>;
  hist_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_days_late?: Maybe<Scalars['numeric']>;
  hist_days_late?: Maybe<Scalars['bigint']>;
  hist_number_late?: Maybe<Scalars['bigint']>;
  hist_number_on_time?: Maybe<Scalars['bigint']>;
  invoice?: Maybe<Scalars['uuid']>;
  issue_date_day_of_week?: Maybe<Scalars['String']>;
  late_rate?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nr_of_default_communications?: Maybe<Scalars['bigint']>;
  open_amount_late?: Maybe<Scalars['numeric']>;
  open_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_amount_late?: Maybe<Scalars['numeric']>;
  open_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_days_late?: Maybe<Scalars['numeric']>;
  open_days_late?: Maybe<Scalars['bigint']>;
  open_number_late?: Maybe<Scalars['bigint']>;
  open_number_on_time?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Risolto_Analytics_Invoice_Features_Sum_Fields = {
  __typename?: 'risolto_analytics_invoice_features_sum_fields';
  amount_multiplier?: Maybe<Scalars['numeric']>;
  avg_days_late?: Maybe<Scalars['numeric']>;
  days_under_contract?: Maybe<Scalars['bigint']>;
  default_rate?: Maybe<Scalars['numeric']>;
  hist_amount_late?: Maybe<Scalars['numeric']>;
  hist_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_amount_late?: Maybe<Scalars['numeric']>;
  hist_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  hist_avg_days_late?: Maybe<Scalars['numeric']>;
  hist_days_late?: Maybe<Scalars['bigint']>;
  hist_number_late?: Maybe<Scalars['bigint']>;
  hist_number_on_time?: Maybe<Scalars['bigint']>;
  late_rate?: Maybe<Scalars['numeric']>;
  nr_of_default_communications?: Maybe<Scalars['bigint']>;
  open_amount_late?: Maybe<Scalars['numeric']>;
  open_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_amount_late?: Maybe<Scalars['numeric']>;
  open_avg_amount_on_time?: Maybe<Scalars['numeric']>;
  open_avg_days_late?: Maybe<Scalars['numeric']>;
  open_days_late?: Maybe<Scalars['bigint']>;
  open_number_late?: Maybe<Scalars['bigint']>;
  open_number_on_time?: Maybe<Scalars['bigint']>;
};

/** update columns of table "risolto.analytics_invoice_features" */
export enum Risolto_Analytics_Invoice_Features_Update_Column {
  /** column name */
  AmountMultiplier = 'amount_multiplier',
  /** column name */
  AvgDaysLate = 'avg_days_late',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DaysUnderContract = 'days_under_contract',
  /** column name */
  DefaultRate = 'default_rate',
  /** column name */
  DirectDebit = 'direct_debit',
  /** column name */
  HistAmountLate = 'hist_amount_late',
  /** column name */
  HistAmountOnTime = 'hist_amount_on_time',
  /** column name */
  HistAvgAmountLate = 'hist_avg_amount_late',
  /** column name */
  HistAvgAmountOnTime = 'hist_avg_amount_on_time',
  /** column name */
  HistAvgDaysLate = 'hist_avg_days_late',
  /** column name */
  HistDaysLate = 'hist_days_late',
  /** column name */
  HistNumberLate = 'hist_number_late',
  /** column name */
  HistNumberOnTime = 'hist_number_on_time',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  IssueDateDayOfWeek = 'issue_date_day_of_week',
  /** column name */
  LateRate = 'late_rate',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  LegalIdType = 'legal_id_type',
  /** column name */
  NrOfDefaultCommunications = 'nr_of_default_communications',
  /** column name */
  OpenAmountLate = 'open_amount_late',
  /** column name */
  OpenAmountOnTime = 'open_amount_on_time',
  /** column name */
  OpenAvgAmountLate = 'open_avg_amount_late',
  /** column name */
  OpenAvgAmountOnTime = 'open_avg_amount_on_time',
  /** column name */
  OpenAvgDaysLate = 'open_avg_days_late',
  /** column name */
  OpenDaysLate = 'open_days_late',
  /** column name */
  OpenNumberLate = 'open_number_late',
  /** column name */
  OpenNumberOnTime = 'open_number_on_time',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZipCode = 'zip_code'
}

export type Risolto_Analytics_Invoice_Features_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Analytics_Invoice_Features_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Analytics_Invoice_Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Analytics_Invoice_Features_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Analytics_Invoice_Features_Var_Pop_Fields = {
  __typename?: 'risolto_analytics_invoice_features_var_pop_fields';
  amount_multiplier?: Maybe<Scalars['Float']>;
  avg_days_late?: Maybe<Scalars['Float']>;
  days_under_contract?: Maybe<Scalars['Float']>;
  default_rate?: Maybe<Scalars['Float']>;
  hist_amount_late?: Maybe<Scalars['Float']>;
  hist_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_amount_late?: Maybe<Scalars['Float']>;
  hist_avg_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_days_late?: Maybe<Scalars['Float']>;
  hist_days_late?: Maybe<Scalars['Float']>;
  hist_number_late?: Maybe<Scalars['Float']>;
  hist_number_on_time?: Maybe<Scalars['Float']>;
  late_rate?: Maybe<Scalars['Float']>;
  nr_of_default_communications?: Maybe<Scalars['Float']>;
  open_amount_late?: Maybe<Scalars['Float']>;
  open_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_amount_late?: Maybe<Scalars['Float']>;
  open_avg_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_days_late?: Maybe<Scalars['Float']>;
  open_days_late?: Maybe<Scalars['Float']>;
  open_number_late?: Maybe<Scalars['Float']>;
  open_number_on_time?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Analytics_Invoice_Features_Var_Samp_Fields = {
  __typename?: 'risolto_analytics_invoice_features_var_samp_fields';
  amount_multiplier?: Maybe<Scalars['Float']>;
  avg_days_late?: Maybe<Scalars['Float']>;
  days_under_contract?: Maybe<Scalars['Float']>;
  default_rate?: Maybe<Scalars['Float']>;
  hist_amount_late?: Maybe<Scalars['Float']>;
  hist_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_amount_late?: Maybe<Scalars['Float']>;
  hist_avg_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_days_late?: Maybe<Scalars['Float']>;
  hist_days_late?: Maybe<Scalars['Float']>;
  hist_number_late?: Maybe<Scalars['Float']>;
  hist_number_on_time?: Maybe<Scalars['Float']>;
  late_rate?: Maybe<Scalars['Float']>;
  nr_of_default_communications?: Maybe<Scalars['Float']>;
  open_amount_late?: Maybe<Scalars['Float']>;
  open_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_amount_late?: Maybe<Scalars['Float']>;
  open_avg_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_days_late?: Maybe<Scalars['Float']>;
  open_days_late?: Maybe<Scalars['Float']>;
  open_number_late?: Maybe<Scalars['Float']>;
  open_number_on_time?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Analytics_Invoice_Features_Variance_Fields = {
  __typename?: 'risolto_analytics_invoice_features_variance_fields';
  amount_multiplier?: Maybe<Scalars['Float']>;
  avg_days_late?: Maybe<Scalars['Float']>;
  days_under_contract?: Maybe<Scalars['Float']>;
  default_rate?: Maybe<Scalars['Float']>;
  hist_amount_late?: Maybe<Scalars['Float']>;
  hist_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_amount_late?: Maybe<Scalars['Float']>;
  hist_avg_amount_on_time?: Maybe<Scalars['Float']>;
  hist_avg_days_late?: Maybe<Scalars['Float']>;
  hist_days_late?: Maybe<Scalars['Float']>;
  hist_number_late?: Maybe<Scalars['Float']>;
  hist_number_on_time?: Maybe<Scalars['Float']>;
  late_rate?: Maybe<Scalars['Float']>;
  nr_of_default_communications?: Maybe<Scalars['Float']>;
  open_amount_late?: Maybe<Scalars['Float']>;
  open_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_amount_late?: Maybe<Scalars['Float']>;
  open_avg_amount_on_time?: Maybe<Scalars['Float']>;
  open_avg_days_late?: Maybe<Scalars['Float']>;
  open_days_late?: Maybe<Scalars['Float']>;
  open_number_late?: Maybe<Scalars['Float']>;
  open_number_on_time?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction = {
  __typename?: 'risolto_analytics_invoice_prediction';
  category: Scalars['String'];
  created_at: Scalars['timestamptz'];
  custom_fields: Scalars['jsonb'];
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  prediction_stars?: Maybe<Scalars['numeric']>;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  risk?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_PredictionCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Aggregate = {
  __typename?: 'risolto_analytics_invoice_prediction_aggregate';
  aggregate?: Maybe<Risolto_Analytics_Invoice_Prediction_Aggregate_Fields>;
  nodes: Array<Risolto_Analytics_Invoice_Prediction>;
};

export type Risolto_Analytics_Invoice_Prediction_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Analytics_Invoice_Prediction_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Analytics_Invoice_Prediction_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Aggregate_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_aggregate_fields';
  avg?: Maybe<Risolto_Analytics_Invoice_Prediction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Analytics_Invoice_Prediction_Max_Fields>;
  min?: Maybe<Risolto_Analytics_Invoice_Prediction_Min_Fields>;
  stddev?: Maybe<Risolto_Analytics_Invoice_Prediction_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Analytics_Invoice_Prediction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Analytics_Invoice_Prediction_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Analytics_Invoice_Prediction_Sum_Fields>;
  var_pop?: Maybe<Risolto_Analytics_Invoice_Prediction_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Analytics_Invoice_Prediction_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Analytics_Invoice_Prediction_Variance_Fields>;
};


/** aggregate fields of "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Analytics_Invoice_Prediction_Max_Order_By>;
  min?: Maybe<Risolto_Analytics_Invoice_Prediction_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Analytics_Invoice_Prediction_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Analytics_Invoice_Prediction_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Analytics_Invoice_Prediction_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Analytics_Invoice_Prediction_Avg_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_avg_fields';
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "risolto.analytics_invoice_prediction". All fields are combined with a logical 'AND'. */
export type Risolto_Analytics_Invoice_Prediction_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Bool_Exp>>;
  _not?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Bool_Exp>>;
  category?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  prediction_stars?: Maybe<Numeric_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  risk?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.analytics_invoice_prediction" */
export enum Risolto_Analytics_Invoice_Prediction_Constraint {
  /** unique or primary key constraint on columns "participant", "recipient", "invoice" */
  AnalyticsInvoicePredictionParticipantRecipientInvoiceKey = 'analytics_invoice_prediction_participant_recipient_invoice_key',
  /** unique or primary key constraint on columns "reference" */
  AnalyticsInvoicePredictionPkey = 'analytics_invoice_prediction_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Analytics_Invoice_Prediction_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Analytics_Invoice_Prediction_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Analytics_Invoice_Prediction_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Insert_Input = {
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  risk?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Analytics_Invoice_Prediction_Max_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_max_fields';
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  risk?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Max_Order_By = {
  category?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  risk?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Analytics_Invoice_Prediction_Min_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_min_fields';
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  risk?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Min_Order_By = {
  category?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  risk?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Mutation_Response = {
  __typename?: 'risolto_analytics_invoice_prediction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Analytics_Invoice_Prediction>;
};

/** on_conflict condition type for table "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_On_Conflict = {
  constraint: Risolto_Analytics_Invoice_Prediction_Constraint;
  update_columns?: Array<Risolto_Analytics_Invoice_Prediction_Update_Column>;
  where?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.analytics_invoice_prediction". */
export type Risolto_Analytics_Invoice_Prediction_Order_By = {
  category?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  prediction_stars?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  risk?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.analytics_invoice_prediction */
export type Risolto_Analytics_Invoice_Prediction_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Analytics_Invoice_Prediction_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.analytics_invoice_prediction" */
export enum Risolto_Analytics_Invoice_Prediction_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Risk = 'risk',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Set_Input = {
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  risk?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Analytics_Invoice_Prediction_Stddev_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_stddev_fields';
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Analytics_Invoice_Prediction_Stddev_Pop_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_stddev_pop_fields';
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Analytics_Invoice_Prediction_Stddev_Samp_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_stddev_samp_fields';
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "risolto_analytics_invoice_prediction" */
export type Risolto_Analytics_Invoice_Prediction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Analytics_Invoice_Prediction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Analytics_Invoice_Prediction_Stream_Cursor_Value_Input = {
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  risk?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Analytics_Invoice_Prediction_Sum_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_sum_fields';
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** update columns of table "risolto.analytics_invoice_prediction" */
export enum Risolto_Analytics_Invoice_Prediction_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Risk = 'risk',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Analytics_Invoice_Prediction_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Analytics_Invoice_Prediction_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Analytics_Invoice_Prediction_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Analytics_Invoice_Prediction_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Analytics_Invoice_Prediction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Analytics_Invoice_Prediction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Analytics_Invoice_Prediction_Var_Pop_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_var_pop_fields';
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** aggregate var_samp on columns */
export type Risolto_Analytics_Invoice_Prediction_Var_Samp_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_var_samp_fields';
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** aggregate variance on columns */
export type Risolto_Analytics_Invoice_Prediction_Variance_Fields = {
  __typename?: 'risolto_analytics_invoice_prediction_variance_fields';
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "risolto.analytics_test" */
export type Risolto_Analytics_Test = {
  __typename?: 'risolto_analytics_test';
  created_at: Scalars['timestamptz'];
  custom_fields: Scalars['jsonb'];
  default_result: Scalars['String'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  name: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.analytics_test" */
export type Risolto_Analytics_TestCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.analytics_test" */
export type Risolto_Analytics_Test_Aggregate = {
  __typename?: 'risolto_analytics_test_aggregate';
  aggregate?: Maybe<Risolto_Analytics_Test_Aggregate_Fields>;
  nodes: Array<Risolto_Analytics_Test>;
};

/** aggregate fields of "risolto.analytics_test" */
export type Risolto_Analytics_Test_Aggregate_Fields = {
  __typename?: 'risolto_analytics_test_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Analytics_Test_Max_Fields>;
  min?: Maybe<Risolto_Analytics_Test_Min_Fields>;
};


/** aggregate fields of "risolto.analytics_test" */
export type Risolto_Analytics_Test_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Analytics_Test_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Analytics_Test_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.analytics_test". All fields are combined with a logical 'AND'. */
export type Risolto_Analytics_Test_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Analytics_Test_Bool_Exp>>;
  _not?: Maybe<Risolto_Analytics_Test_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Analytics_Test_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  default_result?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.analytics_test" */
export enum Risolto_Analytics_Test_Constraint {
  /** unique or primary key constraint on columns "participant", "name" */
  AnalyticsTestParticipantNameKey = 'analytics_test_participant_name_key',
  /** unique or primary key constraint on columns "reference" */
  AnalyticsTestPkey = 'analytics_test_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Analytics_Test_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Analytics_Test_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Analytics_Test_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.analytics_test" */
export type Risolto_Analytics_Test_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  default_result?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Analytics_Test_Max_Fields = {
  __typename?: 'risolto_analytics_test_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  default_result?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Analytics_Test_Min_Fields = {
  __typename?: 'risolto_analytics_test_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  default_result?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.analytics_test" */
export type Risolto_Analytics_Test_Mutation_Response = {
  __typename?: 'risolto_analytics_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Analytics_Test>;
};

/** input type for inserting object relation for remote table "risolto.analytics_test" */
export type Risolto_Analytics_Test_Obj_Rel_Insert_Input = {
  data: Risolto_Analytics_Test_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Analytics_Test_On_Conflict>;
};

/** on_conflict condition type for table "risolto.analytics_test" */
export type Risolto_Analytics_Test_On_Conflict = {
  constraint: Risolto_Analytics_Test_Constraint;
  update_columns?: Array<Risolto_Analytics_Test_Update_Column>;
  where?: Maybe<Risolto_Analytics_Test_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.analytics_test". */
export type Risolto_Analytics_Test_Order_By = {
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  default_result?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.analytics_test */
export type Risolto_Analytics_Test_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Analytics_Test_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result = {
  __typename?: 'risolto_analytics_test_result';
  created_at: Scalars['timestamptz'];
  custom_fields: Scalars['jsonb'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  result: Scalars['String'];
  test: Scalars['uuid'];
  /** An object relationship */
  test_by_reference: Risolto_Analytics_Test;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_ResultCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Aggregate = {
  __typename?: 'risolto_analytics_test_result_aggregate';
  aggregate?: Maybe<Risolto_Analytics_Test_Result_Aggregate_Fields>;
  nodes: Array<Risolto_Analytics_Test_Result>;
};

export type Risolto_Analytics_Test_Result_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Analytics_Test_Result_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Analytics_Test_Result_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Analytics_Test_Result_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Aggregate_Fields = {
  __typename?: 'risolto_analytics_test_result_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Analytics_Test_Result_Max_Fields>;
  min?: Maybe<Risolto_Analytics_Test_Result_Min_Fields>;
};


/** aggregate fields of "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Analytics_Test_Result_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Analytics_Test_Result_Max_Order_By>;
  min?: Maybe<Risolto_Analytics_Test_Result_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Analytics_Test_Result_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Analytics_Test_Result_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Analytics_Test_Result_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.analytics_test_result". All fields are combined with a logical 'AND'. */
export type Risolto_Analytics_Test_Result_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Analytics_Test_Result_Bool_Exp>>;
  _not?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Analytics_Test_Result_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  result?: Maybe<String_Comparison_Exp>;
  test?: Maybe<Uuid_Comparison_Exp>;
  test_by_reference?: Maybe<Risolto_Analytics_Test_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.analytics_test_result" */
export enum Risolto_Analytics_Test_Result_Constraint {
  /** unique or primary key constraint on columns "participant", "test", "recipient" */
  AnalyticsTestResultParticipantRecipientTestKey = 'analytics_test_result_participant_recipient_test_key',
  /** unique or primary key constraint on columns "reference" */
  AnalyticsTestResultPkey = 'analytics_test_result_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Analytics_Test_Result_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Analytics_Test_Result_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Analytics_Test_Result_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  test?: Maybe<Scalars['uuid']>;
  test_by_reference?: Maybe<Risolto_Analytics_Test_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Analytics_Test_Result_Max_Fields = {
  __typename?: 'risolto_analytics_test_result_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  test?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  result?: Maybe<Order_By>;
  test?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Analytics_Test_Result_Min_Fields = {
  __typename?: 'risolto_analytics_test_result_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  test?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  result?: Maybe<Order_By>;
  test?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Mutation_Response = {
  __typename?: 'risolto_analytics_test_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Analytics_Test_Result>;
};

/** on_conflict condition type for table "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_On_Conflict = {
  constraint: Risolto_Analytics_Test_Result_Constraint;
  update_columns?: Array<Risolto_Analytics_Test_Result_Update_Column>;
  where?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.analytics_test_result". */
export type Risolto_Analytics_Test_Result_Order_By = {
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  result?: Maybe<Order_By>;
  test?: Maybe<Order_By>;
  test_by_reference?: Maybe<Risolto_Analytics_Test_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.analytics_test_result */
export type Risolto_Analytics_Test_Result_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Analytics_Test_Result_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.analytics_test_result" */
export enum Risolto_Analytics_Test_Result_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Result = 'result',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.analytics_test_result" */
export type Risolto_Analytics_Test_Result_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  test?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_analytics_test_result" */
export type Risolto_Analytics_Test_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Analytics_Test_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Analytics_Test_Result_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  test?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.analytics_test_result" */
export enum Risolto_Analytics_Test_Result_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Result = 'result',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Analytics_Test_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Analytics_Test_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Analytics_Test_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Analytics_Test_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Analytics_Test_Result_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Analytics_Test_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Analytics_Test_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Analytics_Test_Result_Bool_Exp;
};

/** select columns of table "risolto.analytics_test" */
export enum Risolto_Analytics_Test_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DefaultResult = 'default_result',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.analytics_test" */
export type Risolto_Analytics_Test_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  default_result?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_analytics_test" */
export type Risolto_Analytics_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Analytics_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Analytics_Test_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  default_result?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.analytics_test" */
export enum Risolto_Analytics_Test_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DefaultResult = 'default_result',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Analytics_Test_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Analytics_Test_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Analytics_Test_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Analytics_Test_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Analytics_Test_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Analytics_Test_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Analytics_Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Analytics_Test_Bool_Exp;
};

/** columns and relationships of "risolto.api_accounting_document" */
export type Risolto_Api_Accounting_Document = {
  __typename?: 'risolto_api_accounting_document';
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  has_inbound_communication?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.api_accounting_document" */
export type Risolto_Api_Accounting_DocumentCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.api_accounting_document" */
export type Risolto_Api_Accounting_DocumentFile_ReferencesArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.api_accounting_document" */
export type Risolto_Api_Accounting_Document_Aggregate = {
  __typename?: 'risolto_api_accounting_document_aggregate';
  aggregate?: Maybe<Risolto_Api_Accounting_Document_Aggregate_Fields>;
  nodes: Array<Risolto_Api_Accounting_Document>;
};

/** aggregate fields of "risolto.api_accounting_document" */
export type Risolto_Api_Accounting_Document_Aggregate_Fields = {
  __typename?: 'risolto_api_accounting_document_aggregate_fields';
  avg?: Maybe<Risolto_Api_Accounting_Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Api_Accounting_Document_Max_Fields>;
  min?: Maybe<Risolto_Api_Accounting_Document_Min_Fields>;
  stddev?: Maybe<Risolto_Api_Accounting_Document_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Api_Accounting_Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Api_Accounting_Document_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Api_Accounting_Document_Sum_Fields>;
  var_pop?: Maybe<Risolto_Api_Accounting_Document_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Api_Accounting_Document_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Api_Accounting_Document_Variance_Fields>;
};


/** aggregate fields of "risolto.api_accounting_document" */
export type Risolto_Api_Accounting_Document_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Api_Accounting_Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Api_Accounting_Document_Avg_Fields = {
  __typename?: 'risolto_api_accounting_document_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.api_accounting_document". All fields are combined with a logical 'AND'. */
export type Risolto_Api_Accounting_Document_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Api_Accounting_Document_Bool_Exp>>;
  _not?: Maybe<Risolto_Api_Accounting_Document_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Api_Accounting_Document_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  document_number?: Maybe<String_Comparison_Exp>;
  document_type?: Maybe<String_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  file_references?: Maybe<Jsonb_Comparison_Exp>;
  has_inbound_communication?: Maybe<Boolean_Comparison_Exp>;
  issue_date?: Maybe<Date_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  origin?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  short_code?: Maybe<String_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_Api_Accounting_Document_Max_Fields = {
  __typename?: 'risolto_api_accounting_document_max_fields';
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Api_Accounting_Document_Min_Fields = {
  __typename?: 'risolto_api_accounting_document_min_fields';
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "risolto.api_accounting_document". */
export type Risolto_Api_Accounting_Document_Order_By = {
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  document_number?: Maybe<Order_By>;
  document_type?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  file_references?: Maybe<Order_By>;
  has_inbound_communication?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  short_code?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "risolto.api_accounting_document" */
export enum Risolto_Api_Accounting_Document_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DocumentNumber = 'document_number',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  HasInboundCommunication = 'has_inbound_communication',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  ShortCode = 'short_code',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Risolto_Api_Accounting_Document_Stddev_Fields = {
  __typename?: 'risolto_api_accounting_document_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Api_Accounting_Document_Stddev_Pop_Fields = {
  __typename?: 'risolto_api_accounting_document_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Api_Accounting_Document_Stddev_Samp_Fields = {
  __typename?: 'risolto_api_accounting_document_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_api_accounting_document" */
export type Risolto_Api_Accounting_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Api_Accounting_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Api_Accounting_Document_Stream_Cursor_Value_Input = {
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  document_number?: Maybe<Scalars['String']>;
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  has_inbound_communication?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  short_code?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Api_Accounting_Document_Sum_Fields = {
  __typename?: 'risolto_api_accounting_document_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Risolto_Api_Accounting_Document_Var_Pop_Fields = {
  __typename?: 'risolto_api_accounting_document_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Api_Accounting_Document_Var_Samp_Fields = {
  __typename?: 'risolto_api_accounting_document_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Api_Accounting_Document_Variance_Fields = {
  __typename?: 'risolto_api_accounting_document_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.api_app_client" */
export type Risolto_Api_App_Client = {
  __typename?: 'risolto_api_app_client';
  client_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  last_connection?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  participant_api_app_clients: Array<Risolto_Participant_Api_App_Client>;
  /** An aggregate relationship */
  participant_api_app_clients_aggregate: Risolto_Participant_Api_App_Client_Aggregate;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.api_app_client" */
export type Risolto_Api_App_ClientParticipant_Api_App_ClientsArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


/** columns and relationships of "risolto.api_app_client" */
export type Risolto_Api_App_ClientParticipant_Api_App_Clients_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};

/** aggregated selection of "risolto.api_app_client" */
export type Risolto_Api_App_Client_Aggregate = {
  __typename?: 'risolto_api_app_client_aggregate';
  aggregate?: Maybe<Risolto_Api_App_Client_Aggregate_Fields>;
  nodes: Array<Risolto_Api_App_Client>;
};

/** aggregate fields of "risolto.api_app_client" */
export type Risolto_Api_App_Client_Aggregate_Fields = {
  __typename?: 'risolto_api_app_client_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Api_App_Client_Max_Fields>;
  min?: Maybe<Risolto_Api_App_Client_Min_Fields>;
};


/** aggregate fields of "risolto.api_app_client" */
export type Risolto_Api_App_Client_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Api_App_Client_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.api_app_client". All fields are combined with a logical 'AND'. */
export type Risolto_Api_App_Client_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Api_App_Client_Bool_Exp>>;
  _not?: Maybe<Risolto_Api_App_Client_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Api_App_Client_Bool_Exp>>;
  client_id?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  last_connection?: Maybe<Timestamptz_Comparison_Exp>;
  participant_api_app_clients?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
  participant_api_app_clients_aggregate?: Maybe<Risolto_Participant_Api_App_Client_Aggregate_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.api_app_client" */
export enum Risolto_Api_App_Client_Constraint {
  /** unique or primary key constraint on columns "client_id" */
  ApiAppClientClientIdKey = 'api_app_client_client_id_key',
  /** unique or primary key constraint on columns "reference" */
  ApiAppClientPkey = 'api_app_client_pkey'
}

/** input type for inserting data into table "risolto.api_app_client" */
export type Risolto_Api_App_Client_Insert_Input = {
  client_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  last_connection?: Maybe<Scalars['timestamptz']>;
  participant_api_app_clients?: Maybe<Risolto_Participant_Api_App_Client_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Api_App_Client_Max_Fields = {
  __typename?: 'risolto_api_app_client_max_fields';
  client_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  last_connection?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Api_App_Client_Min_Fields = {
  __typename?: 'risolto_api_app_client_min_fields';
  client_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  last_connection?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.api_app_client" */
export type Risolto_Api_App_Client_Mutation_Response = {
  __typename?: 'risolto_api_app_client_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Api_App_Client>;
};

/** input type for inserting object relation for remote table "risolto.api_app_client" */
export type Risolto_Api_App_Client_Obj_Rel_Insert_Input = {
  data: Risolto_Api_App_Client_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Api_App_Client_On_Conflict>;
};

/** on_conflict condition type for table "risolto.api_app_client" */
export type Risolto_Api_App_Client_On_Conflict = {
  constraint: Risolto_Api_App_Client_Constraint;
  update_columns?: Array<Risolto_Api_App_Client_Update_Column>;
  where?: Maybe<Risolto_Api_App_Client_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.api_app_client". */
export type Risolto_Api_App_Client_Order_By = {
  client_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  last_connection?: Maybe<Order_By>;
  participant_api_app_clients_aggregate?: Maybe<Risolto_Participant_Api_App_Client_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.api_app_client */
export type Risolto_Api_App_Client_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.api_app_client" */
export enum Risolto_Api_App_Client_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LastConnection = 'last_connection',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.api_app_client" */
export type Risolto_Api_App_Client_Set_Input = {
  client_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  last_connection?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_api_app_client" */
export type Risolto_Api_App_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Api_App_Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Api_App_Client_Stream_Cursor_Value_Input = {
  client_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  last_connection?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.api_app_client" */
export enum Risolto_Api_App_Client_Update_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LastConnection = 'last_connection',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Api_App_Client_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Api_App_Client_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Api_App_Client_Bool_Exp;
};

/** columns and relationships of "risolto.api_payment_plan" */
export type Risolto_Api_Payment_Plan = {
  __typename?: 'risolto_api_payment_plan';
  account_id?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by_email?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_id_type?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_name?: Maybe<Scalars['String']>;
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  interest?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  payment_plan?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  payment_promises: Array<Risolto_Api_Payment_Promise>;
  /** An aggregate relationship */
  payment_promises_aggregate: Risolto_Api_Payment_Promise_Aggregate;
  recipient?: Maybe<Scalars['uuid']>;
  registration_name?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "risolto.api_payment_plan" */
export type Risolto_Api_Payment_PlanConditionsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.api_payment_plan" */
export type Risolto_Api_Payment_PlanPayment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.api_payment_plan" */
export type Risolto_Api_Payment_PlanPayment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
};

/** aggregated selection of "risolto.api_payment_plan" */
export type Risolto_Api_Payment_Plan_Aggregate = {
  __typename?: 'risolto_api_payment_plan_aggregate';
  aggregate?: Maybe<Risolto_Api_Payment_Plan_Aggregate_Fields>;
  nodes: Array<Risolto_Api_Payment_Plan>;
};

/** aggregate fields of "risolto.api_payment_plan" */
export type Risolto_Api_Payment_Plan_Aggregate_Fields = {
  __typename?: 'risolto_api_payment_plan_aggregate_fields';
  avg?: Maybe<Risolto_Api_Payment_Plan_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Api_Payment_Plan_Max_Fields>;
  min?: Maybe<Risolto_Api_Payment_Plan_Min_Fields>;
  stddev?: Maybe<Risolto_Api_Payment_Plan_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Api_Payment_Plan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Api_Payment_Plan_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Api_Payment_Plan_Sum_Fields>;
  var_pop?: Maybe<Risolto_Api_Payment_Plan_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Api_Payment_Plan_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Api_Payment_Plan_Variance_Fields>;
};


/** aggregate fields of "risolto.api_payment_plan" */
export type Risolto_Api_Payment_Plan_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Api_Payment_Plan_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Api_Payment_Plan_Avg_Fields = {
  __typename?: 'risolto_api_payment_plan_avg_fields';
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.api_payment_plan". All fields are combined with a logical 'AND'. */
export type Risolto_Api_Payment_Plan_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Api_Payment_Plan_Bool_Exp>>;
  _not?: Maybe<Risolto_Api_Payment_Plan_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Api_Payment_Plan_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  approved_at?: Maybe<Timestamptz_Comparison_Exp>;
  approved_by_email?: Maybe<String_Comparison_Exp>;
  company_id?: Maybe<String_Comparison_Exp>;
  company_id_type?: Maybe<String_Comparison_Exp>;
  conditions?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  customer_name?: Maybe<String_Comparison_Exp>;
  indemnification?: Maybe<Numeric_Comparison_Exp>;
  installment_amount?: Maybe<Numeric_Comparison_Exp>;
  installments?: Maybe<Int_Comparison_Exp>;
  interest?: Maybe<Numeric_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_plan?: Maybe<Uuid_Comparison_Exp>;
  payment_promises?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
  payment_promises_aggregate?: Maybe<Risolto_Api_Payment_Promise_Aggregate_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  registration_name?: Maybe<String_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_Api_Payment_Plan_Max_Fields = {
  __typename?: 'risolto_api_payment_plan_max_fields';
  account_id?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by_email?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_id_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_name?: Maybe<Scalars['String']>;
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  interest?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  registration_name?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Risolto_Api_Payment_Plan_Min_Fields = {
  __typename?: 'risolto_api_payment_plan_min_fields';
  account_id?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by_email?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_id_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_name?: Maybe<Scalars['String']>;
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  interest?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  registration_name?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "risolto.api_payment_plan". */
export type Risolto_Api_Payment_Plan_Order_By = {
  account_id?: Maybe<Order_By>;
  approved_at?: Maybe<Order_By>;
  approved_by_email?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  company_id_type?: Maybe<Order_By>;
  conditions?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  customer_name?: Maybe<Order_By>;
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  interest?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_promises_aggregate?: Maybe<Risolto_Api_Payment_Promise_Aggregate_Order_By>;
  recipient?: Maybe<Order_By>;
  registration_name?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** select columns of table "risolto.api_payment_plan" */
export enum Risolto_Api_Payment_Plan_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedByEmail = 'approved_by_email',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyIdType = 'company_id_type',
  /** column name */
  Conditions = 'conditions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  Indemnification = 'indemnification',
  /** column name */
  InstallmentAmount = 'installment_amount',
  /** column name */
  Installments = 'installments',
  /** column name */
  Interest = 'interest',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPlan = 'payment_plan',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RegistrationName = 'registration_name',
  /** column name */
  TotalAmount = 'total_amount'
}

/** aggregate stddev on columns */
export type Risolto_Api_Payment_Plan_Stddev_Fields = {
  __typename?: 'risolto_api_payment_plan_stddev_fields';
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Api_Payment_Plan_Stddev_Pop_Fields = {
  __typename?: 'risolto_api_payment_plan_stddev_pop_fields';
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Api_Payment_Plan_Stddev_Samp_Fields = {
  __typename?: 'risolto_api_payment_plan_stddev_samp_fields';
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_api_payment_plan" */
export type Risolto_Api_Payment_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Api_Payment_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Api_Payment_Plan_Stream_Cursor_Value_Input = {
  account_id?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by_email?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_id_type?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_name?: Maybe<Scalars['String']>;
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  interest?: Maybe<Scalars['numeric']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  registration_name?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Risolto_Api_Payment_Plan_Sum_Fields = {
  __typename?: 'risolto_api_payment_plan_sum_fields';
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  interest?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Risolto_Api_Payment_Plan_Var_Pop_Fields = {
  __typename?: 'risolto_api_payment_plan_var_pop_fields';
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Api_Payment_Plan_Var_Samp_Fields = {
  __typename?: 'risolto_api_payment_plan_var_samp_fields';
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Api_Payment_Plan_Variance_Fields = {
  __typename?: 'risolto_api_payment_plan_variance_fields';
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise = {
  __typename?: 'risolto_api_payment_promise';
  account_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_id_type?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  payment_plan?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_plan_by_reference?: Maybe<Risolto_Api_Payment_Plan>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  qr_codes?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  registration_name?: Maybe<Scalars['String']>;
  short_url?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.api_payment_promise" */
export type Risolto_Api_Payment_PromiseQr_CodesArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Aggregate = {
  __typename?: 'risolto_api_payment_promise_aggregate';
  aggregate?: Maybe<Risolto_Api_Payment_Promise_Aggregate_Fields>;
  nodes: Array<Risolto_Api_Payment_Promise>;
};

export type Risolto_Api_Payment_Promise_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Api_Payment_Promise_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Api_Payment_Promise_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Api_Payment_Promise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Aggregate_Fields = {
  __typename?: 'risolto_api_payment_promise_aggregate_fields';
  avg?: Maybe<Risolto_Api_Payment_Promise_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Api_Payment_Promise_Max_Fields>;
  min?: Maybe<Risolto_Api_Payment_Promise_Min_Fields>;
  stddev?: Maybe<Risolto_Api_Payment_Promise_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Api_Payment_Promise_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Api_Payment_Promise_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Api_Payment_Promise_Sum_Fields>;
  var_pop?: Maybe<Risolto_Api_Payment_Promise_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Api_Payment_Promise_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Api_Payment_Promise_Variance_Fields>;
};


/** aggregate fields of "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Api_Payment_Promise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Api_Payment_Promise_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Api_Payment_Promise_Max_Order_By>;
  min?: Maybe<Risolto_Api_Payment_Promise_Min_Order_By>;
  stddev?: Maybe<Risolto_Api_Payment_Promise_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Api_Payment_Promise_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Api_Payment_Promise_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Api_Payment_Promise_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Api_Payment_Promise_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Api_Payment_Promise_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Api_Payment_Promise_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Risolto_Api_Payment_Promise_Avg_Fields = {
  __typename?: 'risolto_api_payment_promise_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.api_payment_promise". All fields are combined with a logical 'AND'. */
export type Risolto_Api_Payment_Promise_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Api_Payment_Promise_Bool_Exp>>;
  _not?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Api_Payment_Promise_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  company_id?: Maybe<String_Comparison_Exp>;
  company_id_type?: Maybe<String_Comparison_Exp>;
  customer_name?: Maybe<String_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_plan?: Maybe<Uuid_Comparison_Exp>;
  payment_plan_by_reference?: Maybe<Risolto_Api_Payment_Plan_Bool_Exp>;
  payment_promise?: Maybe<Uuid_Comparison_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  qr_codes?: Maybe<Jsonb_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  registration_name?: Maybe<String_Comparison_Exp>;
  short_url?: Maybe<String_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  url?: Maybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_Api_Payment_Promise_Max_Fields = {
  __typename?: 'risolto_api_payment_promise_max_fields';
  account_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_id_type?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  registration_name?: Maybe<Scalars['String']>;
  short_url?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Max_Order_By = {
  account_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  company_id_type?: Maybe<Order_By>;
  customer_name?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  registration_name?: Maybe<Order_By>;
  short_url?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Api_Payment_Promise_Min_Fields = {
  __typename?: 'risolto_api_payment_promise_min_fields';
  account_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_id_type?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  registration_name?: Maybe<Scalars['String']>;
  short_url?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Min_Order_By = {
  account_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  company_id_type?: Maybe<Order_By>;
  customer_name?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  registration_name?: Maybe<Order_By>;
  short_url?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** Ordering options when selecting data from "risolto.api_payment_promise". */
export type Risolto_Api_Payment_Promise_Order_By = {
  account_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  company_id_type?: Maybe<Order_By>;
  customer_name?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_plan_by_reference?: Maybe<Risolto_Api_Payment_Plan_Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  qr_codes?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  registration_name?: Maybe<Order_By>;
  short_url?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** select columns of table "risolto.api_payment_promise" */
export enum Risolto_Api_Payment_Promise_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyIdType = 'company_id_type',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPlan = 'payment_plan',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  QrCodes = 'qr_codes',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RegistrationName = 'registration_name',
  /** column name */
  ShortUrl = 'short_url',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  Url = 'url'
}

/** aggregate stddev on columns */
export type Risolto_Api_Payment_Promise_Stddev_Fields = {
  __typename?: 'risolto_api_payment_promise_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Api_Payment_Promise_Stddev_Pop_Fields = {
  __typename?: 'risolto_api_payment_promise_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Api_Payment_Promise_Stddev_Samp_Fields = {
  __typename?: 'risolto_api_payment_promise_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_api_payment_promise" */
export type Risolto_Api_Payment_Promise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Api_Payment_Promise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Api_Payment_Promise_Stream_Cursor_Value_Input = {
  account_id?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  company_id_type?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  qr_codes?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  registration_name?: Maybe<Scalars['String']>;
  short_url?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Risolto_Api_Payment_Promise_Sum_Fields = {
  __typename?: 'risolto_api_payment_promise_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Risolto_Api_Payment_Promise_Var_Pop_Fields = {
  __typename?: 'risolto_api_payment_promise_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Api_Payment_Promise_Var_Samp_Fields = {
  __typename?: 'risolto_api_payment_promise_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Api_Payment_Promise_Variance_Fields = {
  __typename?: 'risolto_api_payment_promise_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.api_payment_promise" */
export type Risolto_Api_Payment_Promise_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** DEPRECATED */
export type Risolto_Attachment = {
  __typename?: 'risolto_attachment';
  created_at: Scalars['timestamptz'];
  expected_expiration_date: Scalars['date'];
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata: Scalars['jsonb'];
  mime_type: Scalars['String'];
  name: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  scheme: Risolto_Attachment_Scheme_Enum;
  updated_at: Scalars['timestamptz'];
  uri?: Maybe<Scalars['String']>;
};


/** DEPRECATED */
export type Risolto_AttachmentMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.attachment" */
export type Risolto_Attachment_Aggregate = {
  __typename?: 'risolto_attachment_aggregate';
  aggregate?: Maybe<Risolto_Attachment_Aggregate_Fields>;
  nodes: Array<Risolto_Attachment>;
};

/** aggregate fields of "risolto.attachment" */
export type Risolto_Attachment_Aggregate_Fields = {
  __typename?: 'risolto_attachment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Attachment_Max_Fields>;
  min?: Maybe<Risolto_Attachment_Min_Fields>;
};


/** aggregate fields of "risolto.attachment" */
export type Risolto_Attachment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Attachment_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.attachment". All fields are combined with a logical 'AND'. */
export type Risolto_Attachment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Attachment_Bool_Exp>>;
  _not?: Maybe<Risolto_Attachment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Attachment_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  expected_expiration_date?: Maybe<Date_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  mime_type?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  scheme?: Maybe<Risolto_Attachment_Scheme_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  uri?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.attachment" */
export enum Risolto_Attachment_Constraint {
  /** unique or primary key constraint on columns "reference" */
  AttachmentPkey = 'attachment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Attachment_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Attachment_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Attachment_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.attachment" */
export type Risolto_Attachment_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expected_expiration_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  mime_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  scheme?: Maybe<Risolto_Attachment_Scheme_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uri?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Attachment_Max_Fields = {
  __typename?: 'risolto_attachment_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expected_expiration_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mime_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uri?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Attachment_Min_Fields = {
  __typename?: 'risolto_attachment_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expected_expiration_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mime_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uri?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.attachment" */
export type Risolto_Attachment_Mutation_Response = {
  __typename?: 'risolto_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Attachment>;
};

/** input type for inserting object relation for remote table "risolto.attachment" */
export type Risolto_Attachment_Obj_Rel_Insert_Input = {
  data: Risolto_Attachment_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Attachment_On_Conflict>;
};

/** on_conflict condition type for table "risolto.attachment" */
export type Risolto_Attachment_On_Conflict = {
  constraint: Risolto_Attachment_Constraint;
  update_columns?: Array<Risolto_Attachment_Update_Column>;
  where?: Maybe<Risolto_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.attachment". */
export type Risolto_Attachment_Order_By = {
  created_at?: Maybe<Order_By>;
  expected_expiration_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  mime_type?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  scheme?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uri?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.attachment */
export type Risolto_Attachment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Attachment_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "risolto.attachment_scheme" */
export type Risolto_Attachment_Scheme = {
  __typename?: 'risolto_attachment_scheme';
  scheme: Scalars['String'];
};

/** aggregated selection of "risolto.attachment_scheme" */
export type Risolto_Attachment_Scheme_Aggregate = {
  __typename?: 'risolto_attachment_scheme_aggregate';
  aggregate?: Maybe<Risolto_Attachment_Scheme_Aggregate_Fields>;
  nodes: Array<Risolto_Attachment_Scheme>;
};

/** aggregate fields of "risolto.attachment_scheme" */
export type Risolto_Attachment_Scheme_Aggregate_Fields = {
  __typename?: 'risolto_attachment_scheme_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Attachment_Scheme_Max_Fields>;
  min?: Maybe<Risolto_Attachment_Scheme_Min_Fields>;
};


/** aggregate fields of "risolto.attachment_scheme" */
export type Risolto_Attachment_Scheme_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Attachment_Scheme_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.attachment_scheme". All fields are combined with a logical 'AND'. */
export type Risolto_Attachment_Scheme_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Attachment_Scheme_Bool_Exp>>;
  _not?: Maybe<Risolto_Attachment_Scheme_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Attachment_Scheme_Bool_Exp>>;
  scheme?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.attachment_scheme" */
export enum Risolto_Attachment_Scheme_Constraint {
  /** unique or primary key constraint on columns "scheme" */
  AttachmentSchemePkey = 'attachment_scheme_pkey'
}

export enum Risolto_Attachment_Scheme_Enum {
  S3 = 's3',
  Uri = 'uri'
}

/** Boolean expression to compare columns of type "risolto_attachment_scheme_enum". All fields are combined with logical 'AND'. */
export type Risolto_Attachment_Scheme_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Attachment_Scheme_Enum>;
  _in?: Maybe<Array<Risolto_Attachment_Scheme_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Attachment_Scheme_Enum>;
  _nin?: Maybe<Array<Risolto_Attachment_Scheme_Enum>>;
};

/** input type for inserting data into table "risolto.attachment_scheme" */
export type Risolto_Attachment_Scheme_Insert_Input = {
  scheme?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Attachment_Scheme_Max_Fields = {
  __typename?: 'risolto_attachment_scheme_max_fields';
  scheme?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Attachment_Scheme_Min_Fields = {
  __typename?: 'risolto_attachment_scheme_min_fields';
  scheme?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.attachment_scheme" */
export type Risolto_Attachment_Scheme_Mutation_Response = {
  __typename?: 'risolto_attachment_scheme_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Attachment_Scheme>;
};

/** on_conflict condition type for table "risolto.attachment_scheme" */
export type Risolto_Attachment_Scheme_On_Conflict = {
  constraint: Risolto_Attachment_Scheme_Constraint;
  update_columns?: Array<Risolto_Attachment_Scheme_Update_Column>;
  where?: Maybe<Risolto_Attachment_Scheme_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.attachment_scheme". */
export type Risolto_Attachment_Scheme_Order_By = {
  scheme?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.attachment_scheme */
export type Risolto_Attachment_Scheme_Pk_Columns_Input = {
  scheme: Scalars['String'];
};

/** select columns of table "risolto.attachment_scheme" */
export enum Risolto_Attachment_Scheme_Select_Column {
  /** column name */
  Scheme = 'scheme'
}

/** input type for updating data in table "risolto.attachment_scheme" */
export type Risolto_Attachment_Scheme_Set_Input = {
  scheme?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_attachment_scheme" */
export type Risolto_Attachment_Scheme_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Attachment_Scheme_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Attachment_Scheme_Stream_Cursor_Value_Input = {
  scheme?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.attachment_scheme" */
export enum Risolto_Attachment_Scheme_Update_Column {
  /** column name */
  Scheme = 'scheme'
}

export type Risolto_Attachment_Scheme_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Attachment_Scheme_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Attachment_Scheme_Bool_Exp;
};

/** select columns of table "risolto.attachment" */
export enum Risolto_Attachment_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpectedExpirationDate = 'expected_expiration_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Scheme = 'scheme',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uri = 'uri'
}

/** input type for updating data in table "risolto.attachment" */
export type Risolto_Attachment_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expected_expiration_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  mime_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  scheme?: Maybe<Risolto_Attachment_Scheme_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uri?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_attachment" */
export type Risolto_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Attachment_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expected_expiration_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  mime_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  scheme?: Maybe<Risolto_Attachment_Scheme_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uri?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.attachment" */
export enum Risolto_Attachment_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpectedExpirationDate = 'expected_expiration_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Scheme = 'scheme',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uri = 'uri'
}

export type Risolto_Attachment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Attachment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Attachment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Attachment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Attachment_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Attachment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Attachment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Attachment_Bool_Exp;
};

/** columns and relationships of "risolto.bank_account" */
export type Risolto_Bank_Account = {
  __typename?: 'risolto_bank_account';
  account_number: Scalars['String'];
  account_number_type: Scalars['String'];
  bank_identifier: Scalars['String'];
  bank_identifier_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.bank_account" */
export type Risolto_Bank_Account_Aggregate = {
  __typename?: 'risolto_bank_account_aggregate';
  aggregate?: Maybe<Risolto_Bank_Account_Aggregate_Fields>;
  nodes: Array<Risolto_Bank_Account>;
};

export type Risolto_Bank_Account_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Bank_Account_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Bank_Account_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Bank_Account_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Bank_Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.bank_account" */
export type Risolto_Bank_Account_Aggregate_Fields = {
  __typename?: 'risolto_bank_account_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Bank_Account_Max_Fields>;
  min?: Maybe<Risolto_Bank_Account_Min_Fields>;
};


/** aggregate fields of "risolto.bank_account" */
export type Risolto_Bank_Account_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Bank_Account_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.bank_account" */
export type Risolto_Bank_Account_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Bank_Account_Max_Order_By>;
  min?: Maybe<Risolto_Bank_Account_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.bank_account" */
export type Risolto_Bank_Account_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Bank_Account_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Bank_Account_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.bank_account". All fields are combined with a logical 'AND'. */
export type Risolto_Bank_Account_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Bank_Account_Bool_Exp>>;
  _not?: Maybe<Risolto_Bank_Account_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Bank_Account_Bool_Exp>>;
  account_number?: Maybe<String_Comparison_Exp>;
  account_number_type?: Maybe<String_Comparison_Exp>;
  bank_identifier?: Maybe<String_Comparison_Exp>;
  bank_identifier_type?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.bank_account" */
export enum Risolto_Bank_Account_Constraint {
  /** unique or primary key constraint on columns "account_number_type", "participant", "bank_identifier_type", "recipient", "bank_identifier", "legal_entity", "account_number" */
  BankAccountParticipantLegalEntityAccountNumberAccountNu = 'bank_account_participant_legal_entity_account_number_account_nu',
  /** unique or primary key constraint on columns "reference" */
  BankAccountPkey = 'bank_account_pkey'
}

/** input type for inserting data into table "risolto.bank_account" */
export type Risolto_Bank_Account_Insert_Input = {
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Bank_Account_Max_Fields = {
  __typename?: 'risolto_bank_account_max_fields';
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.bank_account" */
export type Risolto_Bank_Account_Max_Order_By = {
  account_number?: Maybe<Order_By>;
  account_number_type?: Maybe<Order_By>;
  bank_identifier?: Maybe<Order_By>;
  bank_identifier_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Bank_Account_Min_Fields = {
  __typename?: 'risolto_bank_account_min_fields';
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.bank_account" */
export type Risolto_Bank_Account_Min_Order_By = {
  account_number?: Maybe<Order_By>;
  account_number_type?: Maybe<Order_By>;
  bank_identifier?: Maybe<Order_By>;
  bank_identifier_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.bank_account" */
export type Risolto_Bank_Account_Mutation_Response = {
  __typename?: 'risolto_bank_account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Bank_Account>;
};

/** on_conflict condition type for table "risolto.bank_account" */
export type Risolto_Bank_Account_On_Conflict = {
  constraint: Risolto_Bank_Account_Constraint;
  update_columns?: Array<Risolto_Bank_Account_Update_Column>;
  where?: Maybe<Risolto_Bank_Account_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.bank_account". */
export type Risolto_Bank_Account_Order_By = {
  account_number?: Maybe<Order_By>;
  account_number_type?: Maybe<Order_By>;
  bank_identifier?: Maybe<Order_By>;
  bank_identifier_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.bank_account */
export type Risolto_Bank_Account_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.bank_account" */
export enum Risolto_Bank_Account_Select_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AccountNumberType = 'account_number_type',
  /** column name */
  BankIdentifier = 'bank_identifier',
  /** column name */
  BankIdentifierType = 'bank_identifier_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.bank_account" */
export type Risolto_Bank_Account_Set_Input = {
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_bank_account" */
export type Risolto_Bank_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Bank_Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Bank_Account_Stream_Cursor_Value_Input = {
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.bank_account" */
export enum Risolto_Bank_Account_Update_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AccountNumberType = 'account_number_type',
  /** column name */
  BankIdentifier = 'bank_identifier',
  /** column name */
  BankIdentifierType = 'bank_identifier_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Bank_Account_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Bank_Account_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Bank_Account_Bool_Exp;
};

/** columns and relationships of "risolto.bank_identifier_type" */
export type Risolto_Bank_Identifier_Type = {
  __typename?: 'risolto_bank_identifier_type';
  bank_identifier_type: Scalars['String'];
};

/** aggregated selection of "risolto.bank_identifier_type" */
export type Risolto_Bank_Identifier_Type_Aggregate = {
  __typename?: 'risolto_bank_identifier_type_aggregate';
  aggregate?: Maybe<Risolto_Bank_Identifier_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Bank_Identifier_Type>;
};

/** aggregate fields of "risolto.bank_identifier_type" */
export type Risolto_Bank_Identifier_Type_Aggregate_Fields = {
  __typename?: 'risolto_bank_identifier_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Bank_Identifier_Type_Max_Fields>;
  min?: Maybe<Risolto_Bank_Identifier_Type_Min_Fields>;
};


/** aggregate fields of "risolto.bank_identifier_type" */
export type Risolto_Bank_Identifier_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Bank_Identifier_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.bank_identifier_type". All fields are combined with a logical 'AND'. */
export type Risolto_Bank_Identifier_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Bank_Identifier_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Bank_Identifier_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Bank_Identifier_Type_Bool_Exp>>;
  bank_identifier_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.bank_identifier_type" */
export enum Risolto_Bank_Identifier_Type_Constraint {
  /** unique or primary key constraint on columns "bank_identifier_type" */
  BankIdentifierTypePkey = 'bank_identifier_type_pkey'
}

export enum Risolto_Bank_Identifier_Type_Enum {
  Bic = 'BIC',
  Journal = 'JOURNAL'
}

/** Boolean expression to compare columns of type "risolto_bank_identifier_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Bank_Identifier_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  _in?: Maybe<Array<Risolto_Bank_Identifier_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Bank_Identifier_Type_Enum>>;
};

/** input type for inserting data into table "risolto.bank_identifier_type" */
export type Risolto_Bank_Identifier_Type_Insert_Input = {
  bank_identifier_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Bank_Identifier_Type_Max_Fields = {
  __typename?: 'risolto_bank_identifier_type_max_fields';
  bank_identifier_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Bank_Identifier_Type_Min_Fields = {
  __typename?: 'risolto_bank_identifier_type_min_fields';
  bank_identifier_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.bank_identifier_type" */
export type Risolto_Bank_Identifier_Type_Mutation_Response = {
  __typename?: 'risolto_bank_identifier_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Bank_Identifier_Type>;
};

/** on_conflict condition type for table "risolto.bank_identifier_type" */
export type Risolto_Bank_Identifier_Type_On_Conflict = {
  constraint: Risolto_Bank_Identifier_Type_Constraint;
  update_columns?: Array<Risolto_Bank_Identifier_Type_Update_Column>;
  where?: Maybe<Risolto_Bank_Identifier_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.bank_identifier_type". */
export type Risolto_Bank_Identifier_Type_Order_By = {
  bank_identifier_type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.bank_identifier_type */
export type Risolto_Bank_Identifier_Type_Pk_Columns_Input = {
  bank_identifier_type: Scalars['String'];
};

/** select columns of table "risolto.bank_identifier_type" */
export enum Risolto_Bank_Identifier_Type_Select_Column {
  /** column name */
  BankIdentifierType = 'bank_identifier_type'
}

/** input type for updating data in table "risolto.bank_identifier_type" */
export type Risolto_Bank_Identifier_Type_Set_Input = {
  bank_identifier_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_bank_identifier_type" */
export type Risolto_Bank_Identifier_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Bank_Identifier_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Bank_Identifier_Type_Stream_Cursor_Value_Input = {
  bank_identifier_type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.bank_identifier_type" */
export enum Risolto_Bank_Identifier_Type_Update_Column {
  /** column name */
  BankIdentifierType = 'bank_identifier_type'
}

export type Risolto_Bank_Identifier_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Bank_Identifier_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Bank_Identifier_Type_Bool_Exp;
};

/** columns and relationships of "risolto.blacklist" */
export type Risolto_Blacklist = {
  __typename?: 'risolto_blacklist';
  channel: Risolto_Channel_Enum;
  created_at: Scalars['timestamptz'];
  endpoint: Scalars['String'];
  endpoint_details?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.blacklist" */
export type Risolto_BlacklistEndpoint_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.blacklist" */
export type Risolto_Blacklist_Aggregate = {
  __typename?: 'risolto_blacklist_aggregate';
  aggregate?: Maybe<Risolto_Blacklist_Aggregate_Fields>;
  nodes: Array<Risolto_Blacklist>;
};

/** aggregate fields of "risolto.blacklist" */
export type Risolto_Blacklist_Aggregate_Fields = {
  __typename?: 'risolto_blacklist_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Blacklist_Max_Fields>;
  min?: Maybe<Risolto_Blacklist_Min_Fields>;
};


/** aggregate fields of "risolto.blacklist" */
export type Risolto_Blacklist_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Blacklist_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Blacklist_Append_Input = {
  endpoint_details?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.blacklist". All fields are combined with a logical 'AND'. */
export type Risolto_Blacklist_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Blacklist_Bool_Exp>>;
  _not?: Maybe<Risolto_Blacklist_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Blacklist_Bool_Exp>>;
  channel?: Maybe<Risolto_Channel_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  endpoint?: Maybe<String_Comparison_Exp>;
  endpoint_details?: Maybe<Jsonb_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.blacklist" */
export enum Risolto_Blacklist_Constraint {
  /** unique or primary key constraint on columns "participant", "endpoint" */
  BlacklistParticipantEndpointKey = 'blacklist_participant_endpoint_key',
  /** unique or primary key constraint on columns "reference" */
  EmailBlacklistPkey = 'email_blacklist_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Blacklist_Delete_At_Path_Input = {
  endpoint_details?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Blacklist_Delete_Elem_Input = {
  endpoint_details?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Blacklist_Delete_Key_Input = {
  endpoint_details?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.blacklist" */
export type Risolto_Blacklist_Insert_Input = {
  channel?: Maybe<Risolto_Channel_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Blacklist_Max_Fields = {
  __typename?: 'risolto_blacklist_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Blacklist_Min_Fields = {
  __typename?: 'risolto_blacklist_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.blacklist" */
export type Risolto_Blacklist_Mutation_Response = {
  __typename?: 'risolto_blacklist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Blacklist>;
};

/** on_conflict condition type for table "risolto.blacklist" */
export type Risolto_Blacklist_On_Conflict = {
  constraint: Risolto_Blacklist_Constraint;
  update_columns?: Array<Risolto_Blacklist_Update_Column>;
  where?: Maybe<Risolto_Blacklist_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.blacklist". */
export type Risolto_Blacklist_Order_By = {
  channel?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  endpoint?: Maybe<Order_By>;
  endpoint_details?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.blacklist */
export type Risolto_Blacklist_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Blacklist_Prepend_Input = {
  endpoint_details?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.blacklist" */
export enum Risolto_Blacklist_Select_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  EndpointDetails = 'endpoint_details',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.blacklist" */
export type Risolto_Blacklist_Set_Input = {
  channel?: Maybe<Risolto_Channel_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_blacklist" */
export type Risolto_Blacklist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Blacklist_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Blacklist_Stream_Cursor_Value_Input = {
  channel?: Maybe<Risolto_Channel_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.blacklist" */
export enum Risolto_Blacklist_Update_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  EndpointDetails = 'endpoint_details',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Blacklist_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Blacklist_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Blacklist_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Blacklist_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Blacklist_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Blacklist_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Blacklist_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Blacklist_Bool_Exp;
};

/** Channel Enum */
export type Risolto_Channel = {
  __typename?: 'risolto_channel';
  channel: Scalars['String'];
};

/** aggregated selection of "risolto.channel" */
export type Risolto_Channel_Aggregate = {
  __typename?: 'risolto_channel_aggregate';
  aggregate?: Maybe<Risolto_Channel_Aggregate_Fields>;
  nodes: Array<Risolto_Channel>;
};

/** aggregate fields of "risolto.channel" */
export type Risolto_Channel_Aggregate_Fields = {
  __typename?: 'risolto_channel_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Channel_Max_Fields>;
  min?: Maybe<Risolto_Channel_Min_Fields>;
};


/** aggregate fields of "risolto.channel" */
export type Risolto_Channel_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Channel_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.channel". All fields are combined with a logical 'AND'. */
export type Risolto_Channel_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Channel_Bool_Exp>>;
  _not?: Maybe<Risolto_Channel_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Channel_Bool_Exp>>;
  channel?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.channel" */
export enum Risolto_Channel_Constraint {
  /** unique or primary key constraint on columns "channel" */
  ChannelPkey = 'channel_pkey'
}

/** columns and relationships of "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint = {
  __typename?: 'risolto_channel_endpoint';
  channel: Scalars['String'];
  contact?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contact_by_reference?: Maybe<Risolto_Contact>;
  created_at: Scalars['timestamptz'];
  /** null */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  endpoint: Scalars['String'];
  /** null */
  endpoint_details: Scalars['jsonb'];
  external_id?: Maybe<Scalars['String']>;
  in_action?: Maybe<Scalars['Boolean']>;
  last_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_type?: Maybe<Scalars['String']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  locale: Scalars['String'];
  origin?: Maybe<Risolto_Origin_Enum>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  priority: Scalars['Int'];
  raw: Scalars['String'];
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.channel_endpoint" */
export type Risolto_Channel_EndpointEndpoint_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Aggregate = {
  __typename?: 'risolto_channel_endpoint_aggregate';
  aggregate?: Maybe<Risolto_Channel_Endpoint_Aggregate_Fields>;
  nodes: Array<Risolto_Channel_Endpoint>;
};

export type Risolto_Channel_Endpoint_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Channel_Endpoint_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Channel_Endpoint_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Aggregate_Fields = {
  __typename?: 'risolto_channel_endpoint_aggregate_fields';
  avg?: Maybe<Risolto_Channel_Endpoint_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Channel_Endpoint_Max_Fields>;
  min?: Maybe<Risolto_Channel_Endpoint_Min_Fields>;
  stddev?: Maybe<Risolto_Channel_Endpoint_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Channel_Endpoint_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Channel_Endpoint_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Channel_Endpoint_Sum_Fields>;
  var_pop?: Maybe<Risolto_Channel_Endpoint_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Channel_Endpoint_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Channel_Endpoint_Variance_Fields>;
};


/** aggregate fields of "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Channel_Endpoint_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Channel_Endpoint_Max_Order_By>;
  min?: Maybe<Risolto_Channel_Endpoint_Min_Order_By>;
  stddev?: Maybe<Risolto_Channel_Endpoint_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Channel_Endpoint_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Channel_Endpoint_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Channel_Endpoint_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Channel_Endpoint_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Channel_Endpoint_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Channel_Endpoint_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Channel_Endpoint_Append_Input = {
  /** null */
  endpoint_details?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Channel_Endpoint_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Channel_Endpoint_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Channel_Endpoint_Avg_Fields = {
  __typename?: 'risolto_channel_endpoint_avg_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Avg_Order_By = {
  priority?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.channel_endpoint". All fields are combined with a logical 'AND'. */
export type Risolto_Channel_Endpoint_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Channel_Endpoint_Bool_Exp>>;
  _not?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Channel_Endpoint_Bool_Exp>>;
  channel?: Maybe<String_Comparison_Exp>;
  contact?: Maybe<Uuid_Comparison_Exp>;
  contact_by_reference?: Maybe<Risolto_Contact_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: Maybe<Timestamptz_Comparison_Exp>;
  deactivated_by?: Maybe<String_Comparison_Exp>;
  endpoint?: Maybe<String_Comparison_Exp>;
  endpoint_details?: Maybe<Jsonb_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  in_action?: Maybe<Boolean_Comparison_Exp>;
  last_delivery_at?: Maybe<Timestamptz_Comparison_Exp>;
  last_failed_delivery_at?: Maybe<Timestamptz_Comparison_Exp>;
  last_failed_delivery_type?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  locale?: Maybe<String_Comparison_Exp>;
  origin?: Maybe<Risolto_Origin_Enum_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  priority?: Maybe<Int_Comparison_Exp>;
  raw?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.channel_endpoint" */
export enum Risolto_Channel_Endpoint_Constraint {
  /** unique or primary key constraint on columns "reference" */
  ChannelEndpointPkey = 'channel_endpoint_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Channel_Endpoint_Delete_At_Path_Input = {
  /** null */
  endpoint_details?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Channel_Endpoint_Delete_Elem_Input = {
  /** null */
  endpoint_details?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Channel_Endpoint_Delete_Key_Input = {
  /** null */
  endpoint_details?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Inc_Input = {
  priority?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Insert_Input = {
  channel?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  contact_by_reference?: Maybe<Risolto_Contact_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  /** null */
  endpoint_details?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  last_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  locale?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  priority?: Maybe<Scalars['Int']>;
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Channel_Endpoint_Max_Fields = {
  __typename?: 'risolto_channel_endpoint_max_fields';
  channel?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  last_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Max_Order_By = {
  channel?: Maybe<Order_By>;
  contact?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  /** null */
  deactivated_at?: Maybe<Order_By>;
  deactivated_by?: Maybe<Order_By>;
  endpoint?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  last_delivery_at?: Maybe<Order_By>;
  last_failed_delivery_at?: Maybe<Order_By>;
  last_failed_delivery_type?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  raw?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Channel_Endpoint_Min_Fields = {
  __typename?: 'risolto_channel_endpoint_min_fields';
  channel?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  last_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Min_Order_By = {
  channel?: Maybe<Order_By>;
  contact?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  /** null */
  deactivated_at?: Maybe<Order_By>;
  deactivated_by?: Maybe<Order_By>;
  endpoint?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  last_delivery_at?: Maybe<Order_By>;
  last_failed_delivery_at?: Maybe<Order_By>;
  last_failed_delivery_type?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  raw?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Mutation_Response = {
  __typename?: 'risolto_channel_endpoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Channel_Endpoint>;
};

/** input type for inserting object relation for remote table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Obj_Rel_Insert_Input = {
  data: Risolto_Channel_Endpoint_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Channel_Endpoint_On_Conflict>;
};

/** on_conflict condition type for table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_On_Conflict = {
  constraint: Risolto_Channel_Endpoint_Constraint;
  update_columns?: Array<Risolto_Channel_Endpoint_Update_Column>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.channel_endpoint". */
export type Risolto_Channel_Endpoint_Order_By = {
  channel?: Maybe<Order_By>;
  contact?: Maybe<Order_By>;
  contact_by_reference?: Maybe<Risolto_Contact_Order_By>;
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  deactivated_by?: Maybe<Order_By>;
  endpoint?: Maybe<Order_By>;
  endpoint_details?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  in_action?: Maybe<Order_By>;
  last_delivery_at?: Maybe<Order_By>;
  last_failed_delivery_at?: Maybe<Order_By>;
  last_failed_delivery_type?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  locale?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  priority?: Maybe<Order_By>;
  raw?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.channel_endpoint */
export type Risolto_Channel_Endpoint_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Channel_Endpoint_Prepend_Input = {
  /** null */
  endpoint_details?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.channel_endpoint" */
export enum Risolto_Channel_Endpoint_Select_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Contact = 'contact',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DeactivatedBy = 'deactivated_by',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  EndpointDetails = 'endpoint_details',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  LastDeliveryAt = 'last_delivery_at',
  /** column name */
  LastFailedDeliveryAt = 'last_failed_delivery_at',
  /** column name */
  LastFailedDeliveryType = 'last_failed_delivery_type',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Locale = 'locale',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  Priority = 'priority',
  /** column name */
  Raw = 'raw',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Set_Input = {
  channel?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  /** null */
  endpoint_details?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  last_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Channel_Endpoint_Stddev_Fields = {
  __typename?: 'risolto_channel_endpoint_stddev_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Stddev_Order_By = {
  priority?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Channel_Endpoint_Stddev_Pop_Fields = {
  __typename?: 'risolto_channel_endpoint_stddev_pop_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Stddev_Pop_Order_By = {
  priority?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Channel_Endpoint_Stddev_Samp_Fields = {
  __typename?: 'risolto_channel_endpoint_stddev_samp_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Stddev_Samp_Order_By = {
  priority?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_channel_endpoint" */
export type Risolto_Channel_Endpoint_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Channel_Endpoint_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Channel_Endpoint_Stream_Cursor_Value_Input = {
  channel?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  /** null */
  endpoint_details?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  last_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_at?: Maybe<Scalars['timestamptz']>;
  last_failed_delivery_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Channel_Endpoint_Sum_Fields = {
  __typename?: 'risolto_channel_endpoint_sum_fields';
  priority?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Sum_Order_By = {
  priority?: Maybe<Order_By>;
};

/** update columns of table "risolto.channel_endpoint" */
export enum Risolto_Channel_Endpoint_Update_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Contact = 'contact',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DeactivatedBy = 'deactivated_by',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  EndpointDetails = 'endpoint_details',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  LastDeliveryAt = 'last_delivery_at',
  /** column name */
  LastFailedDeliveryAt = 'last_failed_delivery_at',
  /** column name */
  LastFailedDeliveryType = 'last_failed_delivery_type',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Locale = 'locale',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  Priority = 'priority',
  /** column name */
  Raw = 'raw',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Channel_Endpoint_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Channel_Endpoint_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Channel_Endpoint_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Channel_Endpoint_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Channel_Endpoint_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Channel_Endpoint_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Channel_Endpoint_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Channel_Endpoint_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Channel_Endpoint_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Channel_Endpoint_Var_Pop_Fields = {
  __typename?: 'risolto_channel_endpoint_var_pop_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Var_Pop_Order_By = {
  priority?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Channel_Endpoint_Var_Samp_Fields = {
  __typename?: 'risolto_channel_endpoint_var_samp_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Var_Samp_Order_By = {
  priority?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Channel_Endpoint_Variance_Fields = {
  __typename?: 'risolto_channel_endpoint_variance_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.channel_endpoint" */
export type Risolto_Channel_Endpoint_Variance_Order_By = {
  priority?: Maybe<Order_By>;
};

export enum Risolto_Channel_Enum {
  Doccle = 'DOCCLE',
  Ebox = 'EBOX',
  Email = 'EMAIL',
  FacebookChat = 'FACEBOOK_CHAT',
  FacebookMessenger = 'FACEBOOK_MESSENGER',
  Mail = 'MAIL',
  None = 'NONE',
  Other = 'OTHER',
  Peppol = 'PEPPOL',
  Phone = 'PHONE',
  Rest = 'REST',
  Sftp = 'SFTP',
  Sms = 'SMS',
  Soap = 'SOAP',
  Teamleader = 'TEAMLEADER',
  Webhook = 'WEBHOOK',
  Whatsapp = 'WHATSAPP',
  Zoomit = 'ZOOMIT'
}

/** Boolean expression to compare columns of type "risolto_channel_enum". All fields are combined with logical 'AND'. */
export type Risolto_Channel_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Channel_Enum>;
  _in?: Maybe<Array<Risolto_Channel_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Channel_Enum>;
  _nin?: Maybe<Array<Risolto_Channel_Enum>>;
};

/** input type for inserting data into table "risolto.channel" */
export type Risolto_Channel_Insert_Input = {
  channel?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Channel_Max_Fields = {
  __typename?: 'risolto_channel_max_fields';
  channel?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Channel_Min_Fields = {
  __typename?: 'risolto_channel_min_fields';
  channel?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.channel" */
export type Risolto_Channel_Mutation_Response = {
  __typename?: 'risolto_channel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Channel>;
};

/** on_conflict condition type for table "risolto.channel" */
export type Risolto_Channel_On_Conflict = {
  constraint: Risolto_Channel_Constraint;
  update_columns?: Array<Risolto_Channel_Update_Column>;
  where?: Maybe<Risolto_Channel_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.channel". */
export type Risolto_Channel_Order_By = {
  channel?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.channel */
export type Risolto_Channel_Pk_Columns_Input = {
  channel: Scalars['String'];
};

/** select columns of table "risolto.channel" */
export enum Risolto_Channel_Select_Column {
  /** column name */
  Channel = 'channel'
}

/** input type for updating data in table "risolto.channel" */
export type Risolto_Channel_Set_Input = {
  channel?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_channel" */
export type Risolto_Channel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Channel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Channel_Stream_Cursor_Value_Input = {
  channel?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.channel" */
export enum Risolto_Channel_Update_Column {
  /** column name */
  Channel = 'channel'
}

export type Risolto_Channel_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Channel_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Channel_Bool_Exp;
};

export type Risolto_Clid2recid_Args = {
  clid?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
};

export type Risolto_Clip2recid_Args = {
  clip?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.communication" */
export type Risolto_Communication = {
  __typename?: 'risolto_communication';
  created_at: Scalars['timestamptz'];
  data_uri?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  received_at: Scalars['timestamptz'];
  /** An array relationship */
  recipient_communications: Array<Risolto_Recipient_Communication>;
  /** An aggregate relationship */
  recipient_communications_aggregate: Risolto_Recipient_Communication_Aggregate;
  reference: Scalars['uuid'];
  subject?: Maybe<Scalars['String']>;
  to: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.communication" */
export type Risolto_CommunicationRecipient_CommunicationsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Communication_Order_By>>;
  where?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
};


/** columns and relationships of "risolto.communication" */
export type Risolto_CommunicationRecipient_Communications_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Communication_Order_By>>;
  where?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
};

/** aggregated selection of "risolto.communication" */
export type Risolto_Communication_Aggregate = {
  __typename?: 'risolto_communication_aggregate';
  aggregate?: Maybe<Risolto_Communication_Aggregate_Fields>;
  nodes: Array<Risolto_Communication>;
};

/** aggregate fields of "risolto.communication" */
export type Risolto_Communication_Aggregate_Fields = {
  __typename?: 'risolto_communication_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Communication_Max_Fields>;
  min?: Maybe<Risolto_Communication_Min_Fields>;
};


/** aggregate fields of "risolto.communication" */
export type Risolto_Communication_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Communication_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.communication". All fields are combined with a logical 'AND'. */
export type Risolto_Communication_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Communication_Bool_Exp>>;
  _not?: Maybe<Risolto_Communication_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Communication_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  data_uri?: Maybe<String_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  from?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  received_at?: Maybe<Timestamptz_Comparison_Exp>;
  recipient_communications?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
  recipient_communications_aggregate?: Maybe<Risolto_Recipient_Communication_Aggregate_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  subject?: Maybe<String_Comparison_Exp>;
  to?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.communication" */
export enum Risolto_Communication_Constraint {
  /** unique or primary key constraint on columns "reference" */
  CommunicationPkey = 'communication_pkey'
}

/** input type for inserting data into table "risolto.communication" */
export type Risolto_Communication_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  data_uri?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  received_at?: Maybe<Scalars['timestamptz']>;
  recipient_communications?: Maybe<Risolto_Recipient_Communication_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Communication_Max_Fields = {
  __typename?: 'risolto_communication_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  data_uri?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Communication_Min_Fields = {
  __typename?: 'risolto_communication_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  data_uri?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.communication" */
export type Risolto_Communication_Mutation_Response = {
  __typename?: 'risolto_communication_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Communication>;
};

/** input type for inserting object relation for remote table "risolto.communication" */
export type Risolto_Communication_Obj_Rel_Insert_Input = {
  data: Risolto_Communication_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Communication_On_Conflict>;
};

/** on_conflict condition type for table "risolto.communication" */
export type Risolto_Communication_On_Conflict = {
  constraint: Risolto_Communication_Constraint;
  update_columns?: Array<Risolto_Communication_Update_Column>;
  where?: Maybe<Risolto_Communication_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.communication". */
export type Risolto_Communication_Order_By = {
  created_at?: Maybe<Order_By>;
  data_uri?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  from?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  received_at?: Maybe<Order_By>;
  recipient_communications_aggregate?: Maybe<Risolto_Recipient_Communication_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  to?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.communication */
export type Risolto_Communication_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.communication" */
export enum Risolto_Communication_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataUri = 'data_uri',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  From = 'from',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Reference = 'reference',
  /** column name */
  Subject = 'subject',
  /** column name */
  To = 'to',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.communication" */
export type Risolto_Communication_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  data_uri?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_communication" */
export type Risolto_Communication_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Communication_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Communication_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  data_uri?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Communication template for email, letter, SMS, ... */
export type Risolto_Communication_Template = {
  __typename?: 'risolto_communication_template';
  /** null */
  channel?: Maybe<Risolto_Channel_Enum>;
  /** COVER_LETTER or ATTACHMENT */
  content_disposition: Risolto_Content_Disposition_Enum;
  created_at: Scalars['timestamptz'];
  document_name?: Maybe<Scalars['String']>;
  document_template: Scalars['jsonb'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  locale: Scalars['String'];
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  reference: Scalars['uuid'];
  sample_data: Scalars['jsonb'];
  subject_template?: Maybe<Scalars['String']>;
  /** Must be unique within a legal entity of a participant */
  template_id: Scalars['String'];
  /** GraphQL query to fetch the template data */
  template_query?: Maybe<Scalars['String']>;
  template_renderer_version?: Maybe<Scalars['String']>;
  tone_of_voice: Risolto_Tone_Of_Voice_Enum;
  /** One of 'LIQUID' | 'PYTHON_TEMPLATE' | ... (see communication_template_type enum) */
  type: Risolto_Communication_Template_Type_Enum;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
};


/** Communication template for email, letter, SMS, ... */
export type Risolto_Communication_TemplateDocument_TemplateArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Communication template for email, letter, SMS, ... */
export type Risolto_Communication_TemplateSample_DataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Communication template for email, letter, SMS, ... */
export type Risolto_Communication_TemplateUi_Template_ConfigurationArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.communication_template" */
export type Risolto_Communication_Template_Aggregate = {
  __typename?: 'risolto_communication_template_aggregate';
  aggregate?: Maybe<Risolto_Communication_Template_Aggregate_Fields>;
  nodes: Array<Risolto_Communication_Template>;
};

export type Risolto_Communication_Template_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Communication_Template_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Communication_Template_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Communication_Template_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Communication_Template_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.communication_template" */
export type Risolto_Communication_Template_Aggregate_Fields = {
  __typename?: 'risolto_communication_template_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Communication_Template_Max_Fields>;
  min?: Maybe<Risolto_Communication_Template_Min_Fields>;
};


/** aggregate fields of "risolto.communication_template" */
export type Risolto_Communication_Template_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Communication_Template_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.communication_template" */
export type Risolto_Communication_Template_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Communication_Template_Max_Order_By>;
  min?: Maybe<Risolto_Communication_Template_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Communication_Template_Append_Input = {
  document_template?: Maybe<Scalars['jsonb']>;
  sample_data?: Maybe<Scalars['jsonb']>;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.communication_template" */
export type Risolto_Communication_Template_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Communication_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Communication_Template_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.communication_template". All fields are combined with a logical 'AND'. */
export type Risolto_Communication_Template_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Communication_Template_Bool_Exp>>;
  _not?: Maybe<Risolto_Communication_Template_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Communication_Template_Bool_Exp>>;
  channel?: Maybe<Risolto_Channel_Enum_Comparison_Exp>;
  content_disposition?: Maybe<Risolto_Content_Disposition_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  document_name?: Maybe<String_Comparison_Exp>;
  document_template?: Maybe<Jsonb_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  locale?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  sample_data?: Maybe<Jsonb_Comparison_Exp>;
  subject_template?: Maybe<String_Comparison_Exp>;
  template_id?: Maybe<String_Comparison_Exp>;
  template_query?: Maybe<String_Comparison_Exp>;
  template_renderer_version?: Maybe<String_Comparison_Exp>;
  tone_of_voice?: Maybe<Risolto_Tone_Of_Voice_Enum_Comparison_Exp>;
  type?: Maybe<Risolto_Communication_Template_Type_Enum_Comparison_Exp>;
  ui_template_configuration?: Maybe<Jsonb_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.communication_template" */
export enum Risolto_Communication_Template_Constraint {
  /** unique or primary key constraint on columns "reference" */
  CommunicationTemplatePkey = 'communication_template_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Communication_Template_Delete_At_Path_Input = {
  document_template?: Maybe<Array<Scalars['String']>>;
  sample_data?: Maybe<Array<Scalars['String']>>;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Communication_Template_Delete_Elem_Input = {
  document_template?: Maybe<Scalars['Int']>;
  sample_data?: Maybe<Scalars['Int']>;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Communication_Template_Delete_Key_Input = {
  document_template?: Maybe<Scalars['String']>;
  sample_data?: Maybe<Scalars['String']>;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.communication_template" */
export type Risolto_Communication_Template_Insert_Input = {
  /** null */
  channel?: Maybe<Risolto_Channel_Enum>;
  /** COVER_LETTER or ATTACHMENT */
  content_disposition?: Maybe<Risolto_Content_Disposition_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_name?: Maybe<Scalars['String']>;
  document_template?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  locale?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  sample_data?: Maybe<Scalars['jsonb']>;
  subject_template?: Maybe<Scalars['String']>;
  /** Must be unique within a legal entity of a participant */
  template_id?: Maybe<Scalars['String']>;
  /** GraphQL query to fetch the template data */
  template_query?: Maybe<Scalars['String']>;
  template_renderer_version?: Maybe<Scalars['String']>;
  tone_of_voice?: Maybe<Risolto_Tone_Of_Voice_Enum>;
  /** One of 'LIQUID' | 'PYTHON_TEMPLATE' | ... (see communication_template_type enum) */
  type?: Maybe<Risolto_Communication_Template_Type_Enum>;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Communication_Template_Max_Fields = {
  __typename?: 'risolto_communication_template_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_name?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  subject_template?: Maybe<Scalars['String']>;
  /** Must be unique within a legal entity of a participant */
  template_id?: Maybe<Scalars['String']>;
  /** GraphQL query to fetch the template data */
  template_query?: Maybe<Scalars['String']>;
  template_renderer_version?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.communication_template" */
export type Risolto_Communication_Template_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  document_name?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  subject_template?: Maybe<Order_By>;
  /** Must be unique within a legal entity of a participant */
  template_id?: Maybe<Order_By>;
  /** GraphQL query to fetch the template data */
  template_query?: Maybe<Order_By>;
  template_renderer_version?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Communication_Template_Min_Fields = {
  __typename?: 'risolto_communication_template_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_name?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  subject_template?: Maybe<Scalars['String']>;
  /** Must be unique within a legal entity of a participant */
  template_id?: Maybe<Scalars['String']>;
  /** GraphQL query to fetch the template data */
  template_query?: Maybe<Scalars['String']>;
  template_renderer_version?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.communication_template" */
export type Risolto_Communication_Template_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  document_name?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  subject_template?: Maybe<Order_By>;
  /** Must be unique within a legal entity of a participant */
  template_id?: Maybe<Order_By>;
  /** GraphQL query to fetch the template data */
  template_query?: Maybe<Order_By>;
  template_renderer_version?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.communication_template" */
export type Risolto_Communication_Template_Mutation_Response = {
  __typename?: 'risolto_communication_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Communication_Template>;
};

/** on_conflict condition type for table "risolto.communication_template" */
export type Risolto_Communication_Template_On_Conflict = {
  constraint: Risolto_Communication_Template_Constraint;
  update_columns?: Array<Risolto_Communication_Template_Update_Column>;
  where?: Maybe<Risolto_Communication_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.communication_template". */
export type Risolto_Communication_Template_Order_By = {
  channel?: Maybe<Order_By>;
  content_disposition?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_name?: Maybe<Order_By>;
  document_template?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  locale?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  sample_data?: Maybe<Order_By>;
  subject_template?: Maybe<Order_By>;
  template_id?: Maybe<Order_By>;
  template_query?: Maybe<Order_By>;
  template_renderer_version?: Maybe<Order_By>;
  tone_of_voice?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  ui_template_configuration?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.communication_template */
export type Risolto_Communication_Template_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Communication_Template_Prepend_Input = {
  document_template?: Maybe<Scalars['jsonb']>;
  sample_data?: Maybe<Scalars['jsonb']>;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.communication_template" */
export enum Risolto_Communication_Template_Select_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  ContentDisposition = 'content_disposition',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentTemplate = 'document_template',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Locale = 'locale',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  SampleData = 'sample_data',
  /** column name */
  SubjectTemplate = 'subject_template',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateQuery = 'template_query',
  /** column name */
  TemplateRendererVersion = 'template_renderer_version',
  /** column name */
  ToneOfVoice = 'tone_of_voice',
  /** column name */
  Type = 'type',
  /** column name */
  UiTemplateConfiguration = 'ui_template_configuration',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.communication_template" */
export type Risolto_Communication_Template_Set_Input = {
  /** null */
  channel?: Maybe<Risolto_Channel_Enum>;
  /** COVER_LETTER or ATTACHMENT */
  content_disposition?: Maybe<Risolto_Content_Disposition_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_name?: Maybe<Scalars['String']>;
  document_template?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  sample_data?: Maybe<Scalars['jsonb']>;
  subject_template?: Maybe<Scalars['String']>;
  /** Must be unique within a legal entity of a participant */
  template_id?: Maybe<Scalars['String']>;
  /** GraphQL query to fetch the template data */
  template_query?: Maybe<Scalars['String']>;
  template_renderer_version?: Maybe<Scalars['String']>;
  tone_of_voice?: Maybe<Risolto_Tone_Of_Voice_Enum>;
  /** One of 'LIQUID' | 'PYTHON_TEMPLATE' | ... (see communication_template_type enum) */
  type?: Maybe<Risolto_Communication_Template_Type_Enum>;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_communication_template" */
export type Risolto_Communication_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Communication_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Communication_Template_Stream_Cursor_Value_Input = {
  /** null */
  channel?: Maybe<Risolto_Channel_Enum>;
  /** COVER_LETTER or ATTACHMENT */
  content_disposition?: Maybe<Risolto_Content_Disposition_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_name?: Maybe<Scalars['String']>;
  document_template?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  sample_data?: Maybe<Scalars['jsonb']>;
  subject_template?: Maybe<Scalars['String']>;
  /** Must be unique within a legal entity of a participant */
  template_id?: Maybe<Scalars['String']>;
  /** GraphQL query to fetch the template data */
  template_query?: Maybe<Scalars['String']>;
  template_renderer_version?: Maybe<Scalars['String']>;
  tone_of_voice?: Maybe<Risolto_Tone_Of_Voice_Enum>;
  /** One of 'LIQUID' | 'PYTHON_TEMPLATE' | ... (see communication_template_type enum) */
  type?: Maybe<Risolto_Communication_Template_Type_Enum>;
  /** Indicates whether the template can be used in the UI (directly) and any related configuration for the UI */
  ui_template_configuration?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.communication_template_type" */
export type Risolto_Communication_Template_Type = {
  __typename?: 'risolto_communication_template_type';
  type: Scalars['String'];
};

/** aggregated selection of "risolto.communication_template_type" */
export type Risolto_Communication_Template_Type_Aggregate = {
  __typename?: 'risolto_communication_template_type_aggregate';
  aggregate?: Maybe<Risolto_Communication_Template_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Communication_Template_Type>;
};

/** aggregate fields of "risolto.communication_template_type" */
export type Risolto_Communication_Template_Type_Aggregate_Fields = {
  __typename?: 'risolto_communication_template_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Communication_Template_Type_Max_Fields>;
  min?: Maybe<Risolto_Communication_Template_Type_Min_Fields>;
};


/** aggregate fields of "risolto.communication_template_type" */
export type Risolto_Communication_Template_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Communication_Template_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.communication_template_type". All fields are combined with a logical 'AND'. */
export type Risolto_Communication_Template_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Communication_Template_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Communication_Template_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Communication_Template_Type_Bool_Exp>>;
  type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.communication_template_type" */
export enum Risolto_Communication_Template_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  CommunicationTemplateTypePkey = 'communication_template_type_pkey'
}

export enum Risolto_Communication_Template_Type_Enum {
  Liquid = 'LIQUID',
  PythonTemplate = 'PYTHON_TEMPLATE',
  Word2 = 'WORD2'
}

/** Boolean expression to compare columns of type "risolto_communication_template_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Communication_Template_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Communication_Template_Type_Enum>;
  _in?: Maybe<Array<Risolto_Communication_Template_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Communication_Template_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Communication_Template_Type_Enum>>;
};

/** input type for inserting data into table "risolto.communication_template_type" */
export type Risolto_Communication_Template_Type_Insert_Input = {
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Communication_Template_Type_Max_Fields = {
  __typename?: 'risolto_communication_template_type_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Communication_Template_Type_Min_Fields = {
  __typename?: 'risolto_communication_template_type_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.communication_template_type" */
export type Risolto_Communication_Template_Type_Mutation_Response = {
  __typename?: 'risolto_communication_template_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Communication_Template_Type>;
};

/** on_conflict condition type for table "risolto.communication_template_type" */
export type Risolto_Communication_Template_Type_On_Conflict = {
  constraint: Risolto_Communication_Template_Type_Constraint;
  update_columns?: Array<Risolto_Communication_Template_Type_Update_Column>;
  where?: Maybe<Risolto_Communication_Template_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.communication_template_type". */
export type Risolto_Communication_Template_Type_Order_By = {
  type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.communication_template_type */
export type Risolto_Communication_Template_Type_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "risolto.communication_template_type" */
export enum Risolto_Communication_Template_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "risolto.communication_template_type" */
export type Risolto_Communication_Template_Type_Set_Input = {
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_communication_template_type" */
export type Risolto_Communication_Template_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Communication_Template_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Communication_Template_Type_Stream_Cursor_Value_Input = {
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.communication_template_type" */
export enum Risolto_Communication_Template_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Risolto_Communication_Template_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Communication_Template_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Communication_Template_Type_Bool_Exp;
};

/** update columns of table "risolto.communication_template" */
export enum Risolto_Communication_Template_Update_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  ContentDisposition = 'content_disposition',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentTemplate = 'document_template',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Locale = 'locale',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  SampleData = 'sample_data',
  /** column name */
  SubjectTemplate = 'subject_template',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateQuery = 'template_query',
  /** column name */
  TemplateRendererVersion = 'template_renderer_version',
  /** column name */
  ToneOfVoice = 'tone_of_voice',
  /** column name */
  Type = 'type',
  /** column name */
  UiTemplateConfiguration = 'ui_template_configuration',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Communication_Template_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Communication_Template_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Communication_Template_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Communication_Template_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Communication_Template_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Communication_Template_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Communication_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Communication_Template_Bool_Exp;
};

/** update columns of table "risolto.communication" */
export enum Risolto_Communication_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataUri = 'data_uri',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  From = 'from',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Reference = 'reference',
  /** column name */
  Subject = 'subject',
  /** column name */
  To = 'to',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Communication_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Communication_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Communication_Bool_Exp;
};

/** columns and relationships of "risolto.contact" */
export type Risolto_Contact = {
  __typename?: 'risolto_contact';
  /** An array relationship */
  channel_endpoints: Array<Risolto_Channel_Endpoint>;
  /** An aggregate relationship */
  channel_endpoints_aggregate: Risolto_Channel_Endpoint_Aggregate;
  contact_type?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contact_type_by_reference?: Maybe<Risolto_Contact_Type>;
  created_at: Scalars['timestamptz'];
  custom_fields?: Maybe<Scalars['jsonb']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  dunning: Scalars['Boolean'];
  external_id?: Maybe<Scalars['String']>;
  /** null */
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** null */
  identifier: Scalars['String'];
  invoicing: Scalars['Boolean'];
  /** null */
  last_name?: Maybe<Scalars['String']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  locale: Scalars['String'];
  middle_names?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** null */
  raw: Scalars['String'];
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  /** null */
  salutation?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.contact" */
export type Risolto_ContactChannel_EndpointsArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


/** columns and relationships of "risolto.contact" */
export type Risolto_ContactChannel_Endpoints_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


/** columns and relationships of "risolto.contact" */
export type Risolto_ContactCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.contact_address" */
export type Risolto_Contact_Address = {
  __typename?: 'risolto_contact_address';
  city?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.contact_address" */
export type Risolto_Contact_AddressEndpoint_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.contact_address" */
export type Risolto_Contact_Address_Aggregate = {
  __typename?: 'risolto_contact_address_aggregate';
  aggregate?: Maybe<Risolto_Contact_Address_Aggregate_Fields>;
  nodes: Array<Risolto_Contact_Address>;
};

/** aggregate fields of "risolto.contact_address" */
export type Risolto_Contact_Address_Aggregate_Fields = {
  __typename?: 'risolto_contact_address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Contact_Address_Max_Fields>;
  min?: Maybe<Risolto_Contact_Address_Min_Fields>;
};


/** aggregate fields of "risolto.contact_address" */
export type Risolto_Contact_Address_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Contact_Address_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Contact_Address_Append_Input = {
  endpoint_details?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.contact_address". All fields are combined with a logical 'AND'. */
export type Risolto_Contact_Address_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Contact_Address_Bool_Exp>>;
  _not?: Maybe<Risolto_Contact_Address_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Contact_Address_Bool_Exp>>;
  city?: Maybe<String_Comparison_Exp>;
  contact?: Maybe<Uuid_Comparison_Exp>;
  endpoint_details?: Maybe<Jsonb_Comparison_Exp>;
  iso_country_code?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  street_box?: Maybe<String_Comparison_Exp>;
  street_name?: Maybe<String_Comparison_Exp>;
  street_name_number_box?: Maybe<String_Comparison_Exp>;
  street_number?: Maybe<String_Comparison_Exp>;
  zip?: Maybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Contact_Address_Delete_At_Path_Input = {
  endpoint_details?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Contact_Address_Delete_Elem_Input = {
  endpoint_details?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Contact_Address_Delete_Key_Input = {
  endpoint_details?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.contact_address" */
export type Risolto_Contact_Address_Insert_Input = {
  city?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Contact_Address_Max_Fields = {
  __typename?: 'risolto_contact_address_max_fields';
  city?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Contact_Address_Min_Fields = {
  __typename?: 'risolto_contact_address_min_fields';
  city?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.contact_address" */
export type Risolto_Contact_Address_Mutation_Response = {
  __typename?: 'risolto_contact_address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Contact_Address>;
};

/** Ordering options when selecting data from "risolto.contact_address". */
export type Risolto_Contact_Address_Order_By = {
  city?: Maybe<Order_By>;
  contact?: Maybe<Order_By>;
  endpoint_details?: Maybe<Order_By>;
  iso_country_code?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  street_box?: Maybe<Order_By>;
  street_name?: Maybe<Order_By>;
  street_name_number_box?: Maybe<Order_By>;
  street_number?: Maybe<Order_By>;
  zip?: Maybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Contact_Address_Prepend_Input = {
  endpoint_details?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.contact_address" */
export enum Risolto_Contact_Address_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Contact = 'contact',
  /** column name */
  EndpointDetails = 'endpoint_details',
  /** column name */
  IsoCountryCode = 'iso_country_code',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  StreetBox = 'street_box',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNameNumberBox = 'street_name_number_box',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "risolto.contact_address" */
export type Risolto_Contact_Address_Set_Input = {
  city?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_contact_address" */
export type Risolto_Contact_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Contact_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Contact_Address_Stream_Cursor_Value_Input = {
  city?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['uuid']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Risolto_Contact_Address_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Contact_Address_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Contact_Address_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Contact_Address_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Contact_Address_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Contact_Address_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Contact_Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Contact_Address_Bool_Exp;
};

/** aggregated selection of "risolto.contact" */
export type Risolto_Contact_Aggregate = {
  __typename?: 'risolto_contact_aggregate';
  aggregate?: Maybe<Risolto_Contact_Aggregate_Fields>;
  nodes: Array<Risolto_Contact>;
};

export type Risolto_Contact_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Contact_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Contact_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Contact_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Contact_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Contact_Select_Column_Risolto_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Contact_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Contact_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Contact_Select_Column_Risolto_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Contact_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Contact_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Contact_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Contact_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.contact" */
export type Risolto_Contact_Aggregate_Fields = {
  __typename?: 'risolto_contact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Contact_Max_Fields>;
  min?: Maybe<Risolto_Contact_Min_Fields>;
};


/** aggregate fields of "risolto.contact" */
export type Risolto_Contact_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Contact_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.contact" */
export type Risolto_Contact_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Contact_Max_Order_By>;
  min?: Maybe<Risolto_Contact_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Contact_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.contact" */
export type Risolto_Contact_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Contact_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Contact_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.contact". All fields are combined with a logical 'AND'. */
export type Risolto_Contact_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Contact_Bool_Exp>>;
  _not?: Maybe<Risolto_Contact_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Contact_Bool_Exp>>;
  channel_endpoints?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
  channel_endpoints_aggregate?: Maybe<Risolto_Channel_Endpoint_Aggregate_Bool_Exp>;
  contact_type?: Maybe<Uuid_Comparison_Exp>;
  contact_type_by_reference?: Maybe<Risolto_Contact_Type_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  deactivated_at?: Maybe<Timestamptz_Comparison_Exp>;
  deactivated_by?: Maybe<String_Comparison_Exp>;
  dunning?: Maybe<Boolean_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  first_name?: Maybe<String_Comparison_Exp>;
  full_name?: Maybe<String_Comparison_Exp>;
  identifier?: Maybe<String_Comparison_Exp>;
  invoicing?: Maybe<Boolean_Comparison_Exp>;
  last_name?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  locale?: Maybe<String_Comparison_Exp>;
  middle_names?: Maybe<String_Comparison_Exp>;
  origin?: Maybe<Risolto_Origin_Enum_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  raw?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  salutation?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.contact" */
export enum Risolto_Contact_Constraint {
  /** unique or primary key constraint on columns "reference" */
  ContactPkey = 'contact_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Contact_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Contact_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Contact_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.contact" */
export type Risolto_Contact_Insert_Input = {
  channel_endpoints?: Maybe<Risolto_Channel_Endpoint_Arr_Rel_Insert_Input>;
  contact_type?: Maybe<Scalars['uuid']>;
  contact_type_by_reference?: Maybe<Risolto_Contact_Type_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  dunning?: Maybe<Scalars['Boolean']>;
  external_id?: Maybe<Scalars['String']>;
  /** null */
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** null */
  identifier?: Maybe<Scalars['String']>;
  invoicing?: Maybe<Scalars['Boolean']>;
  /** null */
  last_name?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  locale?: Maybe<Scalars['String']>;
  middle_names?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  /** null */
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  /** null */
  salutation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Contact_Max_Fields = {
  __typename?: 'risolto_contact_max_fields';
  contact_type?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  /** null */
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** null */
  identifier?: Maybe<Scalars['String']>;
  /** null */
  last_name?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  middle_names?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  /** null */
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** null */
  salutation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.contact" */
export type Risolto_Contact_Max_Order_By = {
  contact_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  deactivated_by?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  /** null */
  first_name?: Maybe<Order_By>;
  full_name?: Maybe<Order_By>;
  /** null */
  identifier?: Maybe<Order_By>;
  /** null */
  last_name?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  middle_names?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  /** null */
  raw?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** null */
  salutation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Contact_Min_Fields = {
  __typename?: 'risolto_contact_min_fields';
  contact_type?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  /** null */
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** null */
  identifier?: Maybe<Scalars['String']>;
  /** null */
  last_name?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  middle_names?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  /** null */
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** null */
  salutation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.contact" */
export type Risolto_Contact_Min_Order_By = {
  contact_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  deactivated_by?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  /** null */
  first_name?: Maybe<Order_By>;
  full_name?: Maybe<Order_By>;
  /** null */
  identifier?: Maybe<Order_By>;
  /** null */
  last_name?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  middle_names?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  /** null */
  raw?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** null */
  salutation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.contact" */
export type Risolto_Contact_Mutation_Response = {
  __typename?: 'risolto_contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Contact>;
};

/** input type for inserting object relation for remote table "risolto.contact" */
export type Risolto_Contact_Obj_Rel_Insert_Input = {
  data: Risolto_Contact_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Contact_On_Conflict>;
};

/** on_conflict condition type for table "risolto.contact" */
export type Risolto_Contact_On_Conflict = {
  constraint: Risolto_Contact_Constraint;
  update_columns?: Array<Risolto_Contact_Update_Column>;
  where?: Maybe<Risolto_Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.contact". */
export type Risolto_Contact_Order_By = {
  channel_endpoints_aggregate?: Maybe<Risolto_Channel_Endpoint_Aggregate_Order_By>;
  contact_type?: Maybe<Order_By>;
  contact_type_by_reference?: Maybe<Risolto_Contact_Type_Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  deactivated_by?: Maybe<Order_By>;
  dunning?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  first_name?: Maybe<Order_By>;
  full_name?: Maybe<Order_By>;
  identifier?: Maybe<Order_By>;
  invoicing?: Maybe<Order_By>;
  last_name?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  locale?: Maybe<Order_By>;
  middle_names?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  raw?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  salutation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.contact */
export type Risolto_Contact_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Contact_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.contact" */
export enum Risolto_Contact_Select_Column {
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DeactivatedBy = 'deactivated_by',
  /** column name */
  Dunning = 'dunning',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  Invoicing = 'invoicing',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Locale = 'locale',
  /** column name */
  MiddleNames = 'middle_names',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  Raw = 'raw',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Salutation = 'salutation',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_contact_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.contact" */
export enum Risolto_Contact_Select_Column_Risolto_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Dunning = 'dunning',
  /** column name */
  Invoicing = 'invoicing'
}

/** select "risolto_contact_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.contact" */
export enum Risolto_Contact_Select_Column_Risolto_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Dunning = 'dunning',
  /** column name */
  Invoicing = 'invoicing'
}

/** input type for updating data in table "risolto.contact" */
export type Risolto_Contact_Set_Input = {
  contact_type?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  dunning?: Maybe<Scalars['Boolean']>;
  external_id?: Maybe<Scalars['String']>;
  /** null */
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** null */
  identifier?: Maybe<Scalars['String']>;
  invoicing?: Maybe<Scalars['Boolean']>;
  /** null */
  last_name?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  middle_names?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  /** null */
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** null */
  salutation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_contact" */
export type Risolto_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Contact_Stream_Cursor_Value_Input = {
  contact_type?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  deactivated_by?: Maybe<Scalars['String']>;
  dunning?: Maybe<Scalars['Boolean']>;
  external_id?: Maybe<Scalars['String']>;
  /** null */
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  /** null */
  identifier?: Maybe<Scalars['String']>;
  invoicing?: Maybe<Scalars['Boolean']>;
  /** null */
  last_name?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  locale?: Maybe<Scalars['String']>;
  middle_names?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  /** null */
  raw?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** null */
  salutation?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Customer specific contact types */
export type Risolto_Contact_Type = {
  __typename?: 'risolto_contact_type';
  contact_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.contact_type" */
export type Risolto_Contact_Type_Aggregate = {
  __typename?: 'risolto_contact_type_aggregate';
  aggregate?: Maybe<Risolto_Contact_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Contact_Type>;
};

/** aggregate fields of "risolto.contact_type" */
export type Risolto_Contact_Type_Aggregate_Fields = {
  __typename?: 'risolto_contact_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Contact_Type_Max_Fields>;
  min?: Maybe<Risolto_Contact_Type_Min_Fields>;
};


/** aggregate fields of "risolto.contact_type" */
export type Risolto_Contact_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Contact_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.contact_type". All fields are combined with a logical 'AND'. */
export type Risolto_Contact_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Contact_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Contact_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Contact_Type_Bool_Exp>>;
  contact_type?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.contact_type" */
export enum Risolto_Contact_Type_Constraint {
  /** unique or primary key constraint on columns "participant", "contact_type", "legal_entity" */
  ContactTypeParticipantLegalEntityContactTypeKey = 'contact_type_participant_legal_entity_contact_type_key',
  /** unique or primary key constraint on columns "reference" */
  ContactTypePkey = 'contact_type_pkey'
}

/** input type for inserting data into table "risolto.contact_type" */
export type Risolto_Contact_Type_Insert_Input = {
  contact_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Contact_Type_Max_Fields = {
  __typename?: 'risolto_contact_type_max_fields';
  contact_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Contact_Type_Min_Fields = {
  __typename?: 'risolto_contact_type_min_fields';
  contact_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.contact_type" */
export type Risolto_Contact_Type_Mutation_Response = {
  __typename?: 'risolto_contact_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Contact_Type>;
};

/** input type for inserting object relation for remote table "risolto.contact_type" */
export type Risolto_Contact_Type_Obj_Rel_Insert_Input = {
  data: Risolto_Contact_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Contact_Type_On_Conflict>;
};

/** on_conflict condition type for table "risolto.contact_type" */
export type Risolto_Contact_Type_On_Conflict = {
  constraint: Risolto_Contact_Type_Constraint;
  update_columns?: Array<Risolto_Contact_Type_Update_Column>;
  where?: Maybe<Risolto_Contact_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.contact_type". */
export type Risolto_Contact_Type_Order_By = {
  contact_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.contact_type */
export type Risolto_Contact_Type_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.contact_type" */
export enum Risolto_Contact_Type_Select_Column {
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.contact_type" */
export type Risolto_Contact_Type_Set_Input = {
  contact_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_contact_type" */
export type Risolto_Contact_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Contact_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Contact_Type_Stream_Cursor_Value_Input = {
  contact_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.contact_type" */
export enum Risolto_Contact_Type_Update_Column {
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Contact_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Contact_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Contact_Type_Bool_Exp;
};

/** update columns of table "risolto.contact" */
export enum Risolto_Contact_Update_Column {
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DeactivatedBy = 'deactivated_by',
  /** column name */
  Dunning = 'dunning',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  Invoicing = 'invoicing',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Locale = 'locale',
  /** column name */
  MiddleNames = 'middle_names',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  Raw = 'raw',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Salutation = 'salutation',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Contact_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Contact_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Contact_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Contact_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Contact_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Contact_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Contact_Bool_Exp;
};

/** columns and relationships of "risolto.content_disposition" */
export type Risolto_Content_Disposition = {
  __typename?: 'risolto_content_disposition';
  content_disposition: Scalars['String'];
};

/** aggregated selection of "risolto.content_disposition" */
export type Risolto_Content_Disposition_Aggregate = {
  __typename?: 'risolto_content_disposition_aggregate';
  aggregate?: Maybe<Risolto_Content_Disposition_Aggregate_Fields>;
  nodes: Array<Risolto_Content_Disposition>;
};

/** aggregate fields of "risolto.content_disposition" */
export type Risolto_Content_Disposition_Aggregate_Fields = {
  __typename?: 'risolto_content_disposition_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Content_Disposition_Max_Fields>;
  min?: Maybe<Risolto_Content_Disposition_Min_Fields>;
};


/** aggregate fields of "risolto.content_disposition" */
export type Risolto_Content_Disposition_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Content_Disposition_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.content_disposition". All fields are combined with a logical 'AND'. */
export type Risolto_Content_Disposition_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Content_Disposition_Bool_Exp>>;
  _not?: Maybe<Risolto_Content_Disposition_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Content_Disposition_Bool_Exp>>;
  content_disposition?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.content_disposition" */
export enum Risolto_Content_Disposition_Constraint {
  /** unique or primary key constraint on columns "content_disposition" */
  ContentDispositionPkey = 'content_disposition_pkey'
}

export enum Risolto_Content_Disposition_Enum {
  Attachment = 'ATTACHMENT',
  CoverLetter = 'COVER_LETTER',
  Include = 'INCLUDE'
}

/** Boolean expression to compare columns of type "risolto_content_disposition_enum". All fields are combined with logical 'AND'. */
export type Risolto_Content_Disposition_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Content_Disposition_Enum>;
  _in?: Maybe<Array<Risolto_Content_Disposition_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Content_Disposition_Enum>;
  _nin?: Maybe<Array<Risolto_Content_Disposition_Enum>>;
};

/** input type for inserting data into table "risolto.content_disposition" */
export type Risolto_Content_Disposition_Insert_Input = {
  content_disposition?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Content_Disposition_Max_Fields = {
  __typename?: 'risolto_content_disposition_max_fields';
  content_disposition?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Content_Disposition_Min_Fields = {
  __typename?: 'risolto_content_disposition_min_fields';
  content_disposition?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.content_disposition" */
export type Risolto_Content_Disposition_Mutation_Response = {
  __typename?: 'risolto_content_disposition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Content_Disposition>;
};

/** on_conflict condition type for table "risolto.content_disposition" */
export type Risolto_Content_Disposition_On_Conflict = {
  constraint: Risolto_Content_Disposition_Constraint;
  update_columns?: Array<Risolto_Content_Disposition_Update_Column>;
  where?: Maybe<Risolto_Content_Disposition_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.content_disposition". */
export type Risolto_Content_Disposition_Order_By = {
  content_disposition?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.content_disposition */
export type Risolto_Content_Disposition_Pk_Columns_Input = {
  content_disposition: Scalars['String'];
};

/** select columns of table "risolto.content_disposition" */
export enum Risolto_Content_Disposition_Select_Column {
  /** column name */
  ContentDisposition = 'content_disposition'
}

/** input type for updating data in table "risolto.content_disposition" */
export type Risolto_Content_Disposition_Set_Input = {
  content_disposition?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_content_disposition" */
export type Risolto_Content_Disposition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Content_Disposition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Content_Disposition_Stream_Cursor_Value_Input = {
  content_disposition?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.content_disposition" */
export enum Risolto_Content_Disposition_Update_Column {
  /** column name */
  ContentDisposition = 'content_disposition'
}

export type Risolto_Content_Disposition_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Content_Disposition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Content_Disposition_Bool_Exp;
};

/** Table to track external credit limit */
export type Risolto_Credit_Limit = {
  __typename?: 'risolto_credit_limit';
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at: Scalars['timestamptz'];
  created_by: Scalars['uuid'];
  credit_limit: Scalars['numeric'];
  credit_limit_type: Scalars['String'];
  custom_fields: Scalars['jsonb'];
  customer_external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An object relationship */
  person_by_reference: Risolto_Person;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  until?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};


/** Table to track external credit limit */
export type Risolto_Credit_LimitCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.credit_limit" */
export type Risolto_Credit_Limit_Aggregate = {
  __typename?: 'risolto_credit_limit_aggregate';
  aggregate?: Maybe<Risolto_Credit_Limit_Aggregate_Fields>;
  nodes: Array<Risolto_Credit_Limit>;
};

export type Risolto_Credit_Limit_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Credit_Limit_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Credit_Limit_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Credit_Limit_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.credit_limit" */
export type Risolto_Credit_Limit_Aggregate_Fields = {
  __typename?: 'risolto_credit_limit_aggregate_fields';
  avg?: Maybe<Risolto_Credit_Limit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Credit_Limit_Max_Fields>;
  min?: Maybe<Risolto_Credit_Limit_Min_Fields>;
  stddev?: Maybe<Risolto_Credit_Limit_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Credit_Limit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Credit_Limit_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Credit_Limit_Sum_Fields>;
  var_pop?: Maybe<Risolto_Credit_Limit_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Credit_Limit_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Credit_Limit_Variance_Fields>;
};


/** aggregate fields of "risolto.credit_limit" */
export type Risolto_Credit_Limit_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Credit_Limit_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Credit_Limit_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Credit_Limit_Max_Order_By>;
  min?: Maybe<Risolto_Credit_Limit_Min_Order_By>;
  stddev?: Maybe<Risolto_Credit_Limit_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Credit_Limit_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Credit_Limit_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Credit_Limit_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Credit_Limit_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Credit_Limit_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Credit_Limit_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Credit_Limit_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Credit_Limit_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Credit_Limit_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Credit_Limit_Avg_Fields = {
  __typename?: 'risolto_credit_limit_avg_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Avg_Order_By = {
  credit_limit?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.credit_limit". All fields are combined with a logical 'AND'. */
export type Risolto_Credit_Limit_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Credit_Limit_Bool_Exp>>;
  _not?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Credit_Limit_Bool_Exp>>;
  amount_currency?: Maybe<Risolto_Currency_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  credit_limit?: Maybe<Numeric_Comparison_Exp>;
  credit_limit_type?: Maybe<String_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  customer_external_id?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  until?: Maybe<Timestamptz_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.credit_limit" */
export enum Risolto_Credit_Limit_Constraint {
  /** unique or primary key constraint on columns "participant", "credit_limit", "until", "credit_limit_type", "recipient", "legal_entity" */
  CreditLimitParticipantLegalEntityRecipientCreditLimiKey = 'credit_limit_participant_legal_entity_recipient_credit_limi_key',
  /** unique or primary key constraint on columns "reference" */
  CreditLimitPkey = 'credit_limit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Credit_Limit_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Credit_Limit_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Credit_Limit_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Inc_Input = {
  credit_limit?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Insert_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  customer_external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Credit_Limit_Max_Fields = {
  __typename?: 'risolto_credit_limit_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  customer_external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  credit_limit?: Maybe<Order_By>;
  credit_limit_type?: Maybe<Order_By>;
  customer_external_id?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  until?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Credit_Limit_Min_Fields = {
  __typename?: 'risolto_credit_limit_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  customer_external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  credit_limit?: Maybe<Order_By>;
  credit_limit_type?: Maybe<Order_By>;
  customer_external_id?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  until?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Mutation_Response = {
  __typename?: 'risolto_credit_limit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Credit_Limit>;
};

/** on_conflict condition type for table "risolto.credit_limit" */
export type Risolto_Credit_Limit_On_Conflict = {
  constraint: Risolto_Credit_Limit_Constraint;
  update_columns?: Array<Risolto_Credit_Limit_Update_Column>;
  where?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.credit_limit". */
export type Risolto_Credit_Limit_Order_By = {
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  credit_limit?: Maybe<Order_By>;
  credit_limit_type?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  customer_external_id?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  until?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.credit_limit */
export type Risolto_Credit_Limit_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Credit_Limit_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.credit_limit" */
export enum Risolto_Credit_Limit_Select_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreditLimit = 'credit_limit',
  /** column name */
  CreditLimitType = 'credit_limit_type',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  CustomerExternalId = 'customer_external_id',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Until = 'until',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Set_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  customer_external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Credit_Limit_Stddev_Fields = {
  __typename?: 'risolto_credit_limit_stddev_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Stddev_Order_By = {
  credit_limit?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Credit_Limit_Stddev_Pop_Fields = {
  __typename?: 'risolto_credit_limit_stddev_pop_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Stddev_Pop_Order_By = {
  credit_limit?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Credit_Limit_Stddev_Samp_Fields = {
  __typename?: 'risolto_credit_limit_stddev_samp_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Stddev_Samp_Order_By = {
  credit_limit?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_credit_limit" */
export type Risolto_Credit_Limit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Credit_Limit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Credit_Limit_Stream_Cursor_Value_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  customer_external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Credit_Limit_Sum_Fields = {
  __typename?: 'risolto_credit_limit_sum_fields';
  credit_limit?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Sum_Order_By = {
  credit_limit?: Maybe<Order_By>;
};

/** update columns of table "risolto.credit_limit" */
export enum Risolto_Credit_Limit_Update_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreditLimit = 'credit_limit',
  /** column name */
  CreditLimitType = 'credit_limit_type',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  CustomerExternalId = 'customer_external_id',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Until = 'until',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Credit_Limit_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Credit_Limit_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Credit_Limit_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Credit_Limit_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Credit_Limit_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Credit_Limit_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Credit_Limit_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Credit_Limit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Credit_Limit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Credit_Limit_Var_Pop_Fields = {
  __typename?: 'risolto_credit_limit_var_pop_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Var_Pop_Order_By = {
  credit_limit?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Credit_Limit_Var_Samp_Fields = {
  __typename?: 'risolto_credit_limit_var_samp_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Var_Samp_Order_By = {
  credit_limit?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Credit_Limit_Variance_Fields = {
  __typename?: 'risolto_credit_limit_variance_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.credit_limit" */
export type Risolto_Credit_Limit_Variance_Order_By = {
  credit_limit?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_Note = {
  __typename?: 'risolto_credit_note';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency: Scalars['String'];
  created_at: Scalars['timestamptz'];
  credit_note_number: Scalars['String'];
  custom_fields: Scalars['jsonb'];
  /** Same as credit_note_number but using a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** CREDIT_NOTE */
  document_type?: Maybe<Scalars['String']>;
  due_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "risolto.credit_note_dunning_status" */
  dunning_status?: Maybe<Scalars['jsonb']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  has_inbound_communication?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  interchange_links: Array<Risolto_Document_Interchange_Link>;
  /** An aggregate relationship */
  interchange_links_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  /** True if open_amount > 0.00 false otherwise */
  is_open?: Maybe<Scalars['Boolean']>;
  issue_date: Scalars['date'];
  /** A computed field, executes function "risolto.credit_note_last_dunning_actions" */
  last_dunning_actions?: Maybe<Array<Risolto_Virtual_Dunning_Action>>;
  last_inbound_communication_at?: Maybe<Scalars['timestamptz']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  open_amount: Scalars['numeric'];
  origin: Risolto_Origin_Enum;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  processing_status: Scalars['String'];
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  status?: Maybe<Scalars['String']>;
  total_amount: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_NoteActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_NoteActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_NoteCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_NoteDunning_StatusArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_NoteFile_ReferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_NoteInterchange_LinksArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_NoteInterchange_Links_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.credit_note" */
export type Risolto_Credit_NoteLast_Dunning_ActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};

/** aggregated selection of "risolto.credit_note" */
export type Risolto_Credit_Note_Aggregate = {
  __typename?: 'risolto_credit_note_aggregate';
  aggregate?: Maybe<Risolto_Credit_Note_Aggregate_Fields>;
  nodes: Array<Risolto_Credit_Note>;
};

export type Risolto_Credit_Note_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Credit_Note_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Credit_Note_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Credit_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.credit_note" */
export type Risolto_Credit_Note_Aggregate_Fields = {
  __typename?: 'risolto_credit_note_aggregate_fields';
  avg?: Maybe<Risolto_Credit_Note_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Credit_Note_Max_Fields>;
  min?: Maybe<Risolto_Credit_Note_Min_Fields>;
  stddev?: Maybe<Risolto_Credit_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Credit_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Credit_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Credit_Note_Sum_Fields>;
  var_pop?: Maybe<Risolto_Credit_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Credit_Note_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Credit_Note_Variance_Fields>;
};


/** aggregate fields of "risolto.credit_note" */
export type Risolto_Credit_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.credit_note" */
export type Risolto_Credit_Note_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Credit_Note_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Credit_Note_Max_Order_By>;
  min?: Maybe<Risolto_Credit_Note_Min_Order_By>;
  stddev?: Maybe<Risolto_Credit_Note_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Credit_Note_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Credit_Note_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Credit_Note_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Credit_Note_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Credit_Note_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Credit_Note_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Credit_Note_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
  file_references?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.credit_note" */
export type Risolto_Credit_Note_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Credit_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Credit_Note_On_Conflict>;
};

/** columns and relationships of "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_Attachment = {
  __typename?: 'risolto_credit_note_attachment';
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type: Risolto_Document_Attachment_Type_Enum;
  created_at: Scalars['timestamptz'];
  credit_note: Scalars['uuid'];
  legal_entity: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_AttachmentMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_Attachment_Aggregate = {
  __typename?: 'risolto_credit_note_attachment_aggregate';
  aggregate?: Maybe<Risolto_Credit_Note_Attachment_Aggregate_Fields>;
  nodes: Array<Risolto_Credit_Note_Attachment>;
};

/** aggregate fields of "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_Attachment_Aggregate_Fields = {
  __typename?: 'risolto_credit_note_attachment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Credit_Note_Attachment_Max_Fields>;
  min?: Maybe<Risolto_Credit_Note_Attachment_Min_Fields>;
};


/** aggregate fields of "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_Attachment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Credit_Note_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Credit_Note_Attachment_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.credit_note_attachment". All fields are combined with a logical 'AND'. */
export type Risolto_Credit_Note_Attachment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Credit_Note_Attachment_Bool_Exp>>;
  _not?: Maybe<Risolto_Credit_Note_Attachment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Credit_Note_Attachment_Bool_Exp>>;
  attachment?: Maybe<Uuid_Comparison_Exp>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  credit_note?: Maybe<Uuid_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.credit_note_attachment" */
export enum Risolto_Credit_Note_Attachment_Constraint {
  /** unique or primary key constraint on columns "participant", "credit_note", "legal_entity", "name" */
  CreditNoteAttachmentParticipantLegalEntityCreditNoteNam = 'credit_note_attachment_participant_legal_entity_credit_note_nam',
  /** unique or primary key constraint on columns "reference" */
  CreditNoteAttachmentPkey = 'credit_note_attachment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Credit_Note_Attachment_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Credit_Note_Attachment_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Credit_Note_Attachment_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_Attachment_Insert_Input = {
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Credit_Note_Attachment_Max_Fields = {
  __typename?: 'risolto_credit_note_attachment_max_fields';
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Credit_Note_Attachment_Min_Fields = {
  __typename?: 'risolto_credit_note_attachment_min_fields';
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_Attachment_Mutation_Response = {
  __typename?: 'risolto_credit_note_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Credit_Note_Attachment>;
};

/** on_conflict condition type for table "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_Attachment_On_Conflict = {
  constraint: Risolto_Credit_Note_Attachment_Constraint;
  update_columns?: Array<Risolto_Credit_Note_Attachment_Update_Column>;
  where?: Maybe<Risolto_Credit_Note_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.credit_note_attachment". */
export type Risolto_Credit_Note_Attachment_Order_By = {
  attachment?: Maybe<Order_By>;
  attachment_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.credit_note_attachment */
export type Risolto_Credit_Note_Attachment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Credit_Note_Attachment_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.credit_note_attachment" */
export enum Risolto_Credit_Note_Attachment_Select_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  AttachmentType = 'attachment_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.credit_note_attachment" */
export type Risolto_Credit_Note_Attachment_Set_Input = {
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_credit_note_attachment" */
export type Risolto_Credit_Note_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Credit_Note_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Credit_Note_Attachment_Stream_Cursor_Value_Input = {
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.credit_note_attachment" */
export enum Risolto_Credit_Note_Attachment_Update_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  AttachmentType = 'attachment_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Credit_Note_Attachment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Credit_Note_Attachment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Credit_Note_Attachment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Credit_Note_Attachment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Credit_Note_Attachment_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Credit_Note_Attachment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Credit_Note_Attachment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Credit_Note_Attachment_Bool_Exp;
};

/** aggregate avg on columns */
export type Risolto_Credit_Note_Avg_Fields = {
  __typename?: 'risolto_credit_note_avg_fields';
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.credit_note". All fields are combined with a logical 'AND'. */
export type Risolto_Credit_Note_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Credit_Note_Bool_Exp>>;
  _not?: Maybe<Risolto_Credit_Note_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Credit_Note_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  active_payment_plan?: Maybe<Uuid_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  credit_note_number?: Maybe<String_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  document_number?: Maybe<String_Comparison_Exp>;
  document_open_amount?: Maybe<Numeric_Comparison_Exp>;
  document_total_amount?: Maybe<Numeric_Comparison_Exp>;
  document_type?: Maybe<String_Comparison_Exp>;
  due_amount?: Maybe<Numeric_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  dunning_status?: Maybe<Jsonb_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  file_references?: Maybe<Jsonb_Comparison_Exp>;
  has_inbound_communication?: Maybe<Boolean_Comparison_Exp>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp>;
  is_open?: Maybe<Boolean_Comparison_Exp>;
  issue_date?: Maybe<Date_Comparison_Exp>;
  last_dunning_actions?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
  last_inbound_communication_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  origin?: Maybe<Risolto_Origin_Enum_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  processing_status?: Maybe<String_Comparison_Exp>;
  raw_input?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.credit_note" */
export enum Risolto_Credit_Note_Constraint {
  /** unique or primary key constraint on columns "participant", "credit_note_number", "legal_entity" */
  CreditNoteParticipantCreditNoteNumberOriginKey = 'credit_note_participant_credit_note_number_origin_key',
  /** unique or primary key constraint on columns "participant", "credit_note_number", "recipient", "legal_entity" */
  CreditNoteParticipantLegalEntityRecipientCnNr = 'credit_note_participant_legal_entity_recipient_cn_nr',
  /** unique or primary key constraint on columns "participant", "external_id", "recipient", "legal_entity" */
  CreditNoteParticipantLegalEntityRecipientExternalIdKey = 'credit_note_participant_legal_entity_recipient_external_id_key',
  /** unique or primary key constraint on columns "reference" */
  CreditNotePkey = 'credit_note_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Credit_Note_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
  file_references?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Credit_Note_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
  file_references?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Credit_Note_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.credit_note" */
export type Risolto_Credit_Note_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.credit_note" */
export type Risolto_Credit_Note_Insert_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note_number?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Credit_Note_Max_Fields = {
  __typename?: 'risolto_credit_note_max_fields';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note_number?: Maybe<Scalars['String']>;
  /** Same as credit_note_number but using a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** CREDIT_NOTE */
  document_type?: Maybe<Scalars['String']>;
  due_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  last_inbound_communication_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Max_Order_By = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note_number?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Credit_Note_Min_Fields = {
  __typename?: 'risolto_credit_note_min_fields';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note_number?: Maybe<Scalars['String']>;
  /** Same as credit_note_number but using a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** CREDIT_NOTE */
  document_type?: Maybe<Scalars['String']>;
  due_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  last_inbound_communication_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Min_Order_By = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note_number?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.credit_note" */
export type Risolto_Credit_Note_Mutation_Response = {
  __typename?: 'risolto_credit_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Credit_Note>;
};

/** input type for inserting object relation for remote table "risolto.credit_note" */
export type Risolto_Credit_Note_Obj_Rel_Insert_Input = {
  data: Risolto_Credit_Note_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Credit_Note_On_Conflict>;
};

/** on_conflict condition type for table "risolto.credit_note" */
export type Risolto_Credit_Note_On_Conflict = {
  constraint: Risolto_Credit_Note_Constraint;
  update_columns?: Array<Risolto_Credit_Note_Update_Column>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.credit_note". */
export type Risolto_Credit_Note_Order_By = {
  account_id?: Maybe<Order_By>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  active_payment_plan?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note_number?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  document_number?: Maybe<Order_By>;
  document_open_amount?: Maybe<Order_By>;
  document_total_amount?: Maybe<Order_By>;
  document_type?: Maybe<Order_By>;
  due_amount?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  dunning_status?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  file_references?: Maybe<Order_By>;
  has_inbound_communication?: Maybe<Order_By>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Order_By>;
  is_open?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  last_dunning_actions_aggregate?: Maybe<Risolto_Virtual_Dunning_Action_Aggregate_Order_By>;
  last_inbound_communication_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  processing_status?: Maybe<Order_By>;
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.credit_note */
export type Risolto_Credit_Note_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Credit_Note_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
  file_references?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.credit_note" */
export enum Risolto_Credit_Note_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNoteNumber = 'credit_note_number',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.credit_note" */
export type Risolto_Credit_Note_Set_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note_number?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Credit_Note_Stddev_Fields = {
  __typename?: 'risolto_credit_note_stddev_fields';
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Credit_Note_Stddev_Pop_Fields = {
  __typename?: 'risolto_credit_note_stddev_pop_fields';
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Credit_Note_Stddev_Samp_Fields = {
  __typename?: 'risolto_credit_note_stddev_samp_fields';
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_credit_note" */
export type Risolto_Credit_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Credit_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Credit_Note_Stream_Cursor_Value_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note_number?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Credit_Note_Sum_Fields = {
  __typename?: 'risolto_credit_note_sum_fields';
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.credit_note" */
export enum Risolto_Credit_Note_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNoteNumber = 'credit_note_number',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Credit_Note_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Credit_Note_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Credit_Note_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Credit_Note_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Credit_Note_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Credit_Note_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Credit_Note_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Credit_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Credit_Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Credit_Note_Var_Pop_Fields = {
  __typename?: 'risolto_credit_note_var_pop_fields';
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Credit_Note_Var_Samp_Fields = {
  __typename?: 'risolto_credit_note_var_samp_fields';
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Credit_Note_Variance_Fields = {
  __typename?: 'risolto_credit_note_variance_fields';
  /** Open_amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total_amount represented as a 'negative' (credit) amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.credit_note" */
export type Risolto_Credit_Note_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Currency enum table */
export type Risolto_Currency = {
  __typename?: 'risolto_currency';
  currency: Scalars['String'];
};

/** aggregated selection of "risolto.currency" */
export type Risolto_Currency_Aggregate = {
  __typename?: 'risolto_currency_aggregate';
  aggregate?: Maybe<Risolto_Currency_Aggregate_Fields>;
  nodes: Array<Risolto_Currency>;
};

/** aggregate fields of "risolto.currency" */
export type Risolto_Currency_Aggregate_Fields = {
  __typename?: 'risolto_currency_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Currency_Max_Fields>;
  min?: Maybe<Risolto_Currency_Min_Fields>;
};


/** aggregate fields of "risolto.currency" */
export type Risolto_Currency_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Currency_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.currency". All fields are combined with a logical 'AND'. */
export type Risolto_Currency_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Currency_Bool_Exp>>;
  _not?: Maybe<Risolto_Currency_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Currency_Bool_Exp>>;
  currency?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.currency" */
export enum Risolto_Currency_Constraint {
  /** unique or primary key constraint on columns "currency" */
  CurrencyPkey = 'currency_pkey'
}

export enum Risolto_Currency_Enum {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

/** Boolean expression to compare columns of type "risolto_currency_enum". All fields are combined with logical 'AND'. */
export type Risolto_Currency_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Currency_Enum>;
  _in?: Maybe<Array<Risolto_Currency_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Currency_Enum>;
  _nin?: Maybe<Array<Risolto_Currency_Enum>>;
};

/** input type for inserting data into table "risolto.currency" */
export type Risolto_Currency_Insert_Input = {
  currency?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Currency_Max_Fields = {
  __typename?: 'risolto_currency_max_fields';
  currency?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Currency_Min_Fields = {
  __typename?: 'risolto_currency_min_fields';
  currency?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.currency" */
export type Risolto_Currency_Mutation_Response = {
  __typename?: 'risolto_currency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Currency>;
};

/** on_conflict condition type for table "risolto.currency" */
export type Risolto_Currency_On_Conflict = {
  constraint: Risolto_Currency_Constraint;
  update_columns?: Array<Risolto_Currency_Update_Column>;
  where?: Maybe<Risolto_Currency_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.currency". */
export type Risolto_Currency_Order_By = {
  currency?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.currency */
export type Risolto_Currency_Pk_Columns_Input = {
  currency: Scalars['String'];
};

/** select columns of table "risolto.currency" */
export enum Risolto_Currency_Select_Column {
  /** column name */
  Currency = 'currency'
}

/** input type for updating data in table "risolto.currency" */
export type Risolto_Currency_Set_Input = {
  currency?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_currency" */
export type Risolto_Currency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Currency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Currency_Stream_Cursor_Value_Input = {
  currency?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.currency" */
export enum Risolto_Currency_Update_Column {
  /** column name */
  Currency = 'currency'
}

export type Risolto_Currency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Currency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Currency_Bool_Exp;
};

export type Risolto_Dashboard_Actions_By_Channel_And_Status_Count_V1_Args = {
  q_date_from?: Maybe<Scalars['date']>;
  q_date_to?: Maybe<Scalars['date']>;
  q_legal_entity?: Maybe<Scalars['uuid']>;
  q_participant?: Maybe<Scalars['uuid']>;
};

export type Risolto_Dashboard_Outstanding_Debt_Args = {
  q_participant?: Maybe<Scalars['uuid']>;
};

export type Risolto_Dashboard_Totals_Args = {
  q_issue_date_from?: Maybe<Scalars['date']>;
  q_issue_date_until?: Maybe<Scalars['date']>;
  q_participant?: Maybe<Scalars['uuid']>;
};

export type Risolto_Dashboard_Totals_V2_Args = {
  q_issue_date_from?: Maybe<Scalars['date']>;
  q_issue_date_until?: Maybe<Scalars['date']>;
  q_legal_entity?: Maybe<Scalars['uuid']>;
  q_participant?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "risolto.debit_note" */
export type Risolto_Debit_Note = {
  __typename?: 'risolto_debit_note';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency: Scalars['String'];
  created_at: Scalars['timestamptz'];
  custom_fields: Scalars['jsonb'];
  debit_note_number: Scalars['String'];
  /** Same as debit_note_number but with a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** DEBIT_NOTE */
  document_type?: Maybe<Scalars['String']>;
  due_date: Scalars['date'];
  /** A computed field, executes function "risolto.debit_note_dunning_status" */
  dunning_status?: Maybe<Scalars['jsonb']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  interchange_links: Array<Risolto_Document_Interchange_Link>;
  /** An aggregate relationship */
  interchange_links_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  /** True if open_amount > 0.00 false otherwise */
  is_open?: Maybe<Scalars['Boolean']>;
  issue_date: Scalars['date'];
  /** A computed field, executes function "risolto.debit_note_last_dunning_actions" */
  last_dunning_actions?: Maybe<Array<Risolto_Virtual_Dunning_Action>>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount: Scalars['numeric'];
  origin: Risolto_Origin_Enum;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  processing_status: Scalars['String'];
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  total_amount: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.debit_note" */
export type Risolto_Debit_NoteCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.debit_note" */
export type Risolto_Debit_NoteDunning_StatusArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.debit_note" */
export type Risolto_Debit_NoteFile_ReferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.debit_note" */
export type Risolto_Debit_NoteInterchange_LinksArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.debit_note" */
export type Risolto_Debit_NoteInterchange_Links_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.debit_note" */
export type Risolto_Debit_NoteLast_Dunning_ActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};

/** aggregated selection of "risolto.debit_note" */
export type Risolto_Debit_Note_Aggregate = {
  __typename?: 'risolto_debit_note_aggregate';
  aggregate?: Maybe<Risolto_Debit_Note_Aggregate_Fields>;
  nodes: Array<Risolto_Debit_Note>;
};

export type Risolto_Debit_Note_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Debit_Note_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Debit_Note_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Debit_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.debit_note" */
export type Risolto_Debit_Note_Aggregate_Fields = {
  __typename?: 'risolto_debit_note_aggregate_fields';
  avg?: Maybe<Risolto_Debit_Note_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Debit_Note_Max_Fields>;
  min?: Maybe<Risolto_Debit_Note_Min_Fields>;
  stddev?: Maybe<Risolto_Debit_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Debit_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Debit_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Debit_Note_Sum_Fields>;
  var_pop?: Maybe<Risolto_Debit_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Debit_Note_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Debit_Note_Variance_Fields>;
};


/** aggregate fields of "risolto.debit_note" */
export type Risolto_Debit_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.debit_note" */
export type Risolto_Debit_Note_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Debit_Note_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Debit_Note_Max_Order_By>;
  min?: Maybe<Risolto_Debit_Note_Min_Order_By>;
  stddev?: Maybe<Risolto_Debit_Note_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Debit_Note_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Debit_Note_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Debit_Note_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Debit_Note_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Debit_Note_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Debit_Note_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Debit_Note_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
  file_references?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.debit_note" */
export type Risolto_Debit_Note_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Debit_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Debit_Note_On_Conflict>;
};

/** columns and relationships of "risolto.debit_note_attachment" */
export type Risolto_Debit_Note_Attachment = {
  __typename?: 'risolto_debit_note_attachment';
  attachment: Scalars['uuid'];
  attachment_type: Risolto_Document_Attachment_Type_Enum;
  created_at: Scalars['timestamptz'];
  debit_note: Scalars['uuid'];
  legal_entity?: Maybe<Scalars['uuid']>;
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.debit_note_attachment" */
export type Risolto_Debit_Note_Attachment_Aggregate = {
  __typename?: 'risolto_debit_note_attachment_aggregate';
  aggregate?: Maybe<Risolto_Debit_Note_Attachment_Aggregate_Fields>;
  nodes: Array<Risolto_Debit_Note_Attachment>;
};

/** aggregate fields of "risolto.debit_note_attachment" */
export type Risolto_Debit_Note_Attachment_Aggregate_Fields = {
  __typename?: 'risolto_debit_note_attachment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Debit_Note_Attachment_Max_Fields>;
  min?: Maybe<Risolto_Debit_Note_Attachment_Min_Fields>;
};


/** aggregate fields of "risolto.debit_note_attachment" */
export type Risolto_Debit_Note_Attachment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Debit_Note_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.debit_note_attachment". All fields are combined with a logical 'AND'. */
export type Risolto_Debit_Note_Attachment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Debit_Note_Attachment_Bool_Exp>>;
  _not?: Maybe<Risolto_Debit_Note_Attachment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Debit_Note_Attachment_Bool_Exp>>;
  attachment?: Maybe<Uuid_Comparison_Exp>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  debit_note?: Maybe<Uuid_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.debit_note_attachment" */
export enum Risolto_Debit_Note_Attachment_Constraint {
  /** unique or primary key constraint on columns "reference" */
  DebitNoteAttachmentPkey = 'debit_note_attachment_pkey'
}

/** input type for inserting data into table "risolto.debit_note_attachment" */
export type Risolto_Debit_Note_Attachment_Insert_Input = {
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Debit_Note_Attachment_Max_Fields = {
  __typename?: 'risolto_debit_note_attachment_max_fields';
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Debit_Note_Attachment_Min_Fields = {
  __typename?: 'risolto_debit_note_attachment_min_fields';
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.debit_note_attachment" */
export type Risolto_Debit_Note_Attachment_Mutation_Response = {
  __typename?: 'risolto_debit_note_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Debit_Note_Attachment>;
};

/** on_conflict condition type for table "risolto.debit_note_attachment" */
export type Risolto_Debit_Note_Attachment_On_Conflict = {
  constraint: Risolto_Debit_Note_Attachment_Constraint;
  update_columns?: Array<Risolto_Debit_Note_Attachment_Update_Column>;
  where?: Maybe<Risolto_Debit_Note_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.debit_note_attachment". */
export type Risolto_Debit_Note_Attachment_Order_By = {
  attachment?: Maybe<Order_By>;
  attachment_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.debit_note_attachment */
export type Risolto_Debit_Note_Attachment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.debit_note_attachment" */
export enum Risolto_Debit_Note_Attachment_Select_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  AttachmentType = 'attachment_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebitNote = 'debit_note',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.debit_note_attachment" */
export type Risolto_Debit_Note_Attachment_Set_Input = {
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_debit_note_attachment" */
export type Risolto_Debit_Note_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Debit_Note_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Debit_Note_Attachment_Stream_Cursor_Value_Input = {
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.debit_note_attachment" */
export enum Risolto_Debit_Note_Attachment_Update_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  AttachmentType = 'attachment_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebitNote = 'debit_note',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Debit_Note_Attachment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Debit_Note_Attachment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Debit_Note_Attachment_Bool_Exp;
};

/** aggregate avg on columns */
export type Risolto_Debit_Note_Avg_Fields = {
  __typename?: 'risolto_debit_note_avg_fields';
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.debit_note". All fields are combined with a logical 'AND'. */
export type Risolto_Debit_Note_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Debit_Note_Bool_Exp>>;
  _not?: Maybe<Risolto_Debit_Note_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Debit_Note_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  active_payment_plan?: Maybe<Uuid_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  debit_note_number?: Maybe<String_Comparison_Exp>;
  document_number?: Maybe<String_Comparison_Exp>;
  document_open_amount?: Maybe<Numeric_Comparison_Exp>;
  document_total_amount?: Maybe<Numeric_Comparison_Exp>;
  document_type?: Maybe<String_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  dunning_status?: Maybe<Jsonb_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  file_references?: Maybe<Jsonb_Comparison_Exp>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp>;
  is_open?: Maybe<Boolean_Comparison_Exp>;
  issue_date?: Maybe<Date_Comparison_Exp>;
  last_dunning_actions?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  origin?: Maybe<Risolto_Origin_Enum_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  processing_status?: Maybe<String_Comparison_Exp>;
  raw_input?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.debit_note" */
export enum Risolto_Debit_Note_Constraint {
  /** unique or primary key constraint on columns "participant", "debit_note_number", "legal_entity" */
  DebitNoteParticipantDebitNoteNumberOriginKey = 'debit_note_participant_debit_note_number_origin_key',
  /** unique or primary key constraint on columns "participant", "external_id", "recipient", "legal_entity" */
  DebitNoteParticipantLegalEntityRecipientExternalIdKey = 'debit_note_participant_legal_entity_recipient_external_id_key',
  /** unique or primary key constraint on columns "reference" */
  DebitNotePkey = 'debit_note_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Debit_Note_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
  file_references?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Debit_Note_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
  file_references?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Debit_Note_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.debit_note" */
export type Risolto_Debit_Note_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.debit_note" */
export type Risolto_Debit_Note_Insert_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debit_note_number?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Debit_Note_Max_Fields = {
  __typename?: 'risolto_debit_note_max_fields';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note_number?: Maybe<Scalars['String']>;
  /** Same as debit_note_number but with a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** DEBIT_NOTE */
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Max_Order_By = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debit_note_number?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Debit_Note_Min_Fields = {
  __typename?: 'risolto_debit_note_min_fields';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note_number?: Maybe<Scalars['String']>;
  /** Same as debit_note_number but with a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** DEBIT_NOTE */
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Min_Order_By = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debit_note_number?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.debit_note" */
export type Risolto_Debit_Note_Mutation_Response = {
  __typename?: 'risolto_debit_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Debit_Note>;
};

/** input type for inserting object relation for remote table "risolto.debit_note" */
export type Risolto_Debit_Note_Obj_Rel_Insert_Input = {
  data: Risolto_Debit_Note_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Debit_Note_On_Conflict>;
};

/** on_conflict condition type for table "risolto.debit_note" */
export type Risolto_Debit_Note_On_Conflict = {
  constraint: Risolto_Debit_Note_Constraint;
  update_columns?: Array<Risolto_Debit_Note_Update_Column>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.debit_note". */
export type Risolto_Debit_Note_Order_By = {
  account_id?: Maybe<Order_By>;
  active_payment_plan?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  debit_note_number?: Maybe<Order_By>;
  document_number?: Maybe<Order_By>;
  document_open_amount?: Maybe<Order_By>;
  document_total_amount?: Maybe<Order_By>;
  document_type?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  dunning_status?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  file_references?: Maybe<Order_By>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Order_By>;
  is_open?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  last_dunning_actions_aggregate?: Maybe<Risolto_Virtual_Dunning_Action_Aggregate_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  processing_status?: Maybe<Order_By>;
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.debit_note */
export type Risolto_Debit_Note_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Debit_Note_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
  file_references?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.debit_note" */
export enum Risolto_Debit_Note_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DebitNoteNumber = 'debit_note_number',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.debit_note" */
export type Risolto_Debit_Note_Set_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debit_note_number?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Debit_Note_Stddev_Fields = {
  __typename?: 'risolto_debit_note_stddev_fields';
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Debit_Note_Stddev_Pop_Fields = {
  __typename?: 'risolto_debit_note_stddev_pop_fields';
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Debit_Note_Stddev_Samp_Fields = {
  __typename?: 'risolto_debit_note_stddev_samp_fields';
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_debit_note" */
export type Risolto_Debit_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Debit_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Debit_Note_Stream_Cursor_Value_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debit_note_number?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Debit_Note_Sum_Fields = {
  __typename?: 'risolto_debit_note_sum_fields';
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.debit_note" */
export enum Risolto_Debit_Note_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DebitNoteNumber = 'debit_note_number',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Debit_Note_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Debit_Note_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Debit_Note_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Debit_Note_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Debit_Note_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Debit_Note_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Debit_Note_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Debit_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Debit_Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Debit_Note_Var_Pop_Fields = {
  __typename?: 'risolto_debit_note_var_pop_fields';
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Debit_Note_Var_Samp_Fields = {
  __typename?: 'risolto_debit_note_var_samp_fields';
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Debit_Note_Variance_Fields = {
  __typename?: 'risolto_debit_note_variance_fields';
  /** Same as open_amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.debit_note" */
export type Risolto_Debit_Note_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

export type Risolto_Demo_Action_Report_1_V1_Args = {
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** Direct Debit Mandate Information */
export type Risolto_Direct_Debit_Mandate = {
  __typename?: 'risolto_direct_debit_mandate';
  created_at: Scalars['timestamptz'];
  custom_fields: Scalars['jsonb'];
  debtor_agent_bicfi?: Maybe<Scalars['String']>;
  debtor_iban: Scalars['String'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  mandate_id: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  provider: Risolto_Direct_Debit_Provider_Enum;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  scheme: Risolto_Direct_Debit_Scheme_Enum;
  sequence_type: Risolto_Direct_Debit_Sequence_Type_Enum;
  signature_date: Scalars['date'];
  updated_at: Scalars['timestamptz'];
};


/** Direct Debit Mandate Information */
export type Risolto_Direct_Debit_MandateCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.direct_debit_mandate" */
export type Risolto_Direct_Debit_Mandate_Aggregate = {
  __typename?: 'risolto_direct_debit_mandate_aggregate';
  aggregate?: Maybe<Risolto_Direct_Debit_Mandate_Aggregate_Fields>;
  nodes: Array<Risolto_Direct_Debit_Mandate>;
};

/** aggregate fields of "risolto.direct_debit_mandate" */
export type Risolto_Direct_Debit_Mandate_Aggregate_Fields = {
  __typename?: 'risolto_direct_debit_mandate_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Direct_Debit_Mandate_Max_Fields>;
  min?: Maybe<Risolto_Direct_Debit_Mandate_Min_Fields>;
};


/** aggregate fields of "risolto.direct_debit_mandate" */
export type Risolto_Direct_Debit_Mandate_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Direct_Debit_Mandate_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Direct_Debit_Mandate_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.direct_debit_mandate". All fields are combined with a logical 'AND'. */
export type Risolto_Direct_Debit_Mandate_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Direct_Debit_Mandate_Bool_Exp>>;
  _not?: Maybe<Risolto_Direct_Debit_Mandate_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Direct_Debit_Mandate_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  debtor_agent_bicfi?: Maybe<String_Comparison_Exp>;
  debtor_iban?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  mandate_id?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  provider?: Maybe<Risolto_Direct_Debit_Provider_Enum_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  scheme?: Maybe<Risolto_Direct_Debit_Scheme_Enum_Comparison_Exp>;
  sequence_type?: Maybe<Risolto_Direct_Debit_Sequence_Type_Enum_Comparison_Exp>;
  signature_date?: Maybe<Date_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.direct_debit_mandate" */
export enum Risolto_Direct_Debit_Mandate_Constraint {
  /** unique or primary key constraint on columns "participant", "provider", "mandate_id", "recipient", "legal_entity" */
  DirectDebitMandateParticipantLegalEntityRecipientProvide = 'direct_debit_mandate_participant_legal_entity_recipient_provide',
  /** unique or primary key constraint on columns "reference" */
  DirectDebitMandatePkey = 'direct_debit_mandate_pkey',
  /** unique or primary key constraint on columns "participant", "mandate_id", "recipient", "legal_entity" */
  DirectDebitUniqueMandateId = 'direct_debit_unique_mandate_id'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Direct_Debit_Mandate_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Direct_Debit_Mandate_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Direct_Debit_Mandate_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.direct_debit_mandate" */
export type Risolto_Direct_Debit_Mandate_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debtor_agent_bicfi?: Maybe<Scalars['String']>;
  debtor_iban?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  mandate_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  provider?: Maybe<Risolto_Direct_Debit_Provider_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  scheme?: Maybe<Risolto_Direct_Debit_Scheme_Enum>;
  sequence_type?: Maybe<Risolto_Direct_Debit_Sequence_Type_Enum>;
  signature_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Direct_Debit_Mandate_Max_Fields = {
  __typename?: 'risolto_direct_debit_mandate_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  debtor_agent_bicfi?: Maybe<Scalars['String']>;
  debtor_iban?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mandate_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  signature_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Direct_Debit_Mandate_Min_Fields = {
  __typename?: 'risolto_direct_debit_mandate_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  debtor_agent_bicfi?: Maybe<Scalars['String']>;
  debtor_iban?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mandate_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  signature_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.direct_debit_mandate" */
export type Risolto_Direct_Debit_Mandate_Mutation_Response = {
  __typename?: 'risolto_direct_debit_mandate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Direct_Debit_Mandate>;
};

/** on_conflict condition type for table "risolto.direct_debit_mandate" */
export type Risolto_Direct_Debit_Mandate_On_Conflict = {
  constraint: Risolto_Direct_Debit_Mandate_Constraint;
  update_columns?: Array<Risolto_Direct_Debit_Mandate_Update_Column>;
  where?: Maybe<Risolto_Direct_Debit_Mandate_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.direct_debit_mandate". */
export type Risolto_Direct_Debit_Mandate_Order_By = {
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  debtor_agent_bicfi?: Maybe<Order_By>;
  debtor_iban?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  mandate_id?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  provider?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  scheme?: Maybe<Order_By>;
  sequence_type?: Maybe<Order_By>;
  signature_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.direct_debit_mandate */
export type Risolto_Direct_Debit_Mandate_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Direct_Debit_Mandate_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.direct_debit_mandate" */
export enum Risolto_Direct_Debit_Mandate_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DebtorAgentBicfi = 'debtor_agent_bicfi',
  /** column name */
  DebtorIban = 'debtor_iban',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MandateId = 'mandate_id',
  /** column name */
  Participant = 'participant',
  /** column name */
  Provider = 'provider',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Scheme = 'scheme',
  /** column name */
  SequenceType = 'sequence_type',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.direct_debit_mandate" */
export type Risolto_Direct_Debit_Mandate_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debtor_agent_bicfi?: Maybe<Scalars['String']>;
  debtor_iban?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mandate_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Risolto_Direct_Debit_Provider_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  scheme?: Maybe<Risolto_Direct_Debit_Scheme_Enum>;
  sequence_type?: Maybe<Risolto_Direct_Debit_Sequence_Type_Enum>;
  signature_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_direct_debit_mandate" */
export type Risolto_Direct_Debit_Mandate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Direct_Debit_Mandate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Direct_Debit_Mandate_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debtor_agent_bicfi?: Maybe<Scalars['String']>;
  debtor_iban?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mandate_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Risolto_Direct_Debit_Provider_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  scheme?: Maybe<Risolto_Direct_Debit_Scheme_Enum>;
  sequence_type?: Maybe<Risolto_Direct_Debit_Sequence_Type_Enum>;
  signature_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.direct_debit_mandate" */
export enum Risolto_Direct_Debit_Mandate_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DebtorAgentBicfi = 'debtor_agent_bicfi',
  /** column name */
  DebtorIban = 'debtor_iban',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MandateId = 'mandate_id',
  /** column name */
  Participant = 'participant',
  /** column name */
  Provider = 'provider',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Scheme = 'scheme',
  /** column name */
  SequenceType = 'sequence_type',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Direct_Debit_Mandate_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Direct_Debit_Mandate_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Direct_Debit_Mandate_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Direct_Debit_Mandate_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Direct_Debit_Mandate_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Direct_Debit_Mandate_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Direct_Debit_Mandate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Direct_Debit_Mandate_Bool_Exp;
};

/** Direct debit provider enum table */
export type Risolto_Direct_Debit_Provider = {
  __typename?: 'risolto_direct_debit_provider';
  provider: Scalars['String'];
};

/** aggregated selection of "risolto.direct_debit_provider" */
export type Risolto_Direct_Debit_Provider_Aggregate = {
  __typename?: 'risolto_direct_debit_provider_aggregate';
  aggregate?: Maybe<Risolto_Direct_Debit_Provider_Aggregate_Fields>;
  nodes: Array<Risolto_Direct_Debit_Provider>;
};

/** aggregate fields of "risolto.direct_debit_provider" */
export type Risolto_Direct_Debit_Provider_Aggregate_Fields = {
  __typename?: 'risolto_direct_debit_provider_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Direct_Debit_Provider_Max_Fields>;
  min?: Maybe<Risolto_Direct_Debit_Provider_Min_Fields>;
};


/** aggregate fields of "risolto.direct_debit_provider" */
export type Risolto_Direct_Debit_Provider_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Direct_Debit_Provider_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.direct_debit_provider". All fields are combined with a logical 'AND'. */
export type Risolto_Direct_Debit_Provider_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Direct_Debit_Provider_Bool_Exp>>;
  _not?: Maybe<Risolto_Direct_Debit_Provider_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Direct_Debit_Provider_Bool_Exp>>;
  provider?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.direct_debit_provider" */
export enum Risolto_Direct_Debit_Provider_Constraint {
  /** unique or primary key constraint on columns "provider" */
  DirectDebitProviderPkey = 'direct_debit_provider_pkey'
}

export enum Risolto_Direct_Debit_Provider_Enum {
  Twikey = 'TWIKEY'
}

/** Boolean expression to compare columns of type "risolto_direct_debit_provider_enum". All fields are combined with logical 'AND'. */
export type Risolto_Direct_Debit_Provider_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Direct_Debit_Provider_Enum>;
  _in?: Maybe<Array<Risolto_Direct_Debit_Provider_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Direct_Debit_Provider_Enum>;
  _nin?: Maybe<Array<Risolto_Direct_Debit_Provider_Enum>>;
};

/** input type for inserting data into table "risolto.direct_debit_provider" */
export type Risolto_Direct_Debit_Provider_Insert_Input = {
  provider?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Direct_Debit_Provider_Max_Fields = {
  __typename?: 'risolto_direct_debit_provider_max_fields';
  provider?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Direct_Debit_Provider_Min_Fields = {
  __typename?: 'risolto_direct_debit_provider_min_fields';
  provider?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.direct_debit_provider" */
export type Risolto_Direct_Debit_Provider_Mutation_Response = {
  __typename?: 'risolto_direct_debit_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Direct_Debit_Provider>;
};

/** on_conflict condition type for table "risolto.direct_debit_provider" */
export type Risolto_Direct_Debit_Provider_On_Conflict = {
  constraint: Risolto_Direct_Debit_Provider_Constraint;
  update_columns?: Array<Risolto_Direct_Debit_Provider_Update_Column>;
  where?: Maybe<Risolto_Direct_Debit_Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.direct_debit_provider". */
export type Risolto_Direct_Debit_Provider_Order_By = {
  provider?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.direct_debit_provider */
export type Risolto_Direct_Debit_Provider_Pk_Columns_Input = {
  provider: Scalars['String'];
};

/** select columns of table "risolto.direct_debit_provider" */
export enum Risolto_Direct_Debit_Provider_Select_Column {
  /** column name */
  Provider = 'provider'
}

/** input type for updating data in table "risolto.direct_debit_provider" */
export type Risolto_Direct_Debit_Provider_Set_Input = {
  provider?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_direct_debit_provider" */
export type Risolto_Direct_Debit_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Direct_Debit_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Direct_Debit_Provider_Stream_Cursor_Value_Input = {
  provider?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.direct_debit_provider" */
export enum Risolto_Direct_Debit_Provider_Update_Column {
  /** column name */
  Provider = 'provider'
}

export type Risolto_Direct_Debit_Provider_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Direct_Debit_Provider_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Direct_Debit_Provider_Bool_Exp;
};

/** Direct debit scheme enum table */
export type Risolto_Direct_Debit_Scheme = {
  __typename?: 'risolto_direct_debit_scheme';
  scheme: Scalars['String'];
};

/** aggregated selection of "risolto.direct_debit_scheme" */
export type Risolto_Direct_Debit_Scheme_Aggregate = {
  __typename?: 'risolto_direct_debit_scheme_aggregate';
  aggregate?: Maybe<Risolto_Direct_Debit_Scheme_Aggregate_Fields>;
  nodes: Array<Risolto_Direct_Debit_Scheme>;
};

/** aggregate fields of "risolto.direct_debit_scheme" */
export type Risolto_Direct_Debit_Scheme_Aggregate_Fields = {
  __typename?: 'risolto_direct_debit_scheme_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Direct_Debit_Scheme_Max_Fields>;
  min?: Maybe<Risolto_Direct_Debit_Scheme_Min_Fields>;
};


/** aggregate fields of "risolto.direct_debit_scheme" */
export type Risolto_Direct_Debit_Scheme_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Direct_Debit_Scheme_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.direct_debit_scheme". All fields are combined with a logical 'AND'. */
export type Risolto_Direct_Debit_Scheme_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Direct_Debit_Scheme_Bool_Exp>>;
  _not?: Maybe<Risolto_Direct_Debit_Scheme_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Direct_Debit_Scheme_Bool_Exp>>;
  scheme?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.direct_debit_scheme" */
export enum Risolto_Direct_Debit_Scheme_Constraint {
  /** unique or primary key constraint on columns "scheme" */
  DirectDebitSchemePkey = 'direct_debit_scheme_pkey'
}

export enum Risolto_Direct_Debit_Scheme_Enum {
  B2B = 'B2B',
  Core = 'CORE'
}

/** Boolean expression to compare columns of type "risolto_direct_debit_scheme_enum". All fields are combined with logical 'AND'. */
export type Risolto_Direct_Debit_Scheme_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Direct_Debit_Scheme_Enum>;
  _in?: Maybe<Array<Risolto_Direct_Debit_Scheme_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Direct_Debit_Scheme_Enum>;
  _nin?: Maybe<Array<Risolto_Direct_Debit_Scheme_Enum>>;
};

/** input type for inserting data into table "risolto.direct_debit_scheme" */
export type Risolto_Direct_Debit_Scheme_Insert_Input = {
  scheme?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Direct_Debit_Scheme_Max_Fields = {
  __typename?: 'risolto_direct_debit_scheme_max_fields';
  scheme?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Direct_Debit_Scheme_Min_Fields = {
  __typename?: 'risolto_direct_debit_scheme_min_fields';
  scheme?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.direct_debit_scheme" */
export type Risolto_Direct_Debit_Scheme_Mutation_Response = {
  __typename?: 'risolto_direct_debit_scheme_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Direct_Debit_Scheme>;
};

/** on_conflict condition type for table "risolto.direct_debit_scheme" */
export type Risolto_Direct_Debit_Scheme_On_Conflict = {
  constraint: Risolto_Direct_Debit_Scheme_Constraint;
  update_columns?: Array<Risolto_Direct_Debit_Scheme_Update_Column>;
  where?: Maybe<Risolto_Direct_Debit_Scheme_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.direct_debit_scheme". */
export type Risolto_Direct_Debit_Scheme_Order_By = {
  scheme?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.direct_debit_scheme */
export type Risolto_Direct_Debit_Scheme_Pk_Columns_Input = {
  scheme: Scalars['String'];
};

/** select columns of table "risolto.direct_debit_scheme" */
export enum Risolto_Direct_Debit_Scheme_Select_Column {
  /** column name */
  Scheme = 'scheme'
}

/** input type for updating data in table "risolto.direct_debit_scheme" */
export type Risolto_Direct_Debit_Scheme_Set_Input = {
  scheme?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_direct_debit_scheme" */
export type Risolto_Direct_Debit_Scheme_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Direct_Debit_Scheme_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Direct_Debit_Scheme_Stream_Cursor_Value_Input = {
  scheme?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.direct_debit_scheme" */
export enum Risolto_Direct_Debit_Scheme_Update_Column {
  /** column name */
  Scheme = 'scheme'
}

export type Risolto_Direct_Debit_Scheme_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Direct_Debit_Scheme_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Direct_Debit_Scheme_Bool_Exp;
};

/** Direct debit sequence_type enum table */
export type Risolto_Direct_Debit_Sequence_Type = {
  __typename?: 'risolto_direct_debit_sequence_type';
  sequence_type: Scalars['String'];
};

/** aggregated selection of "risolto.direct_debit_sequence_type" */
export type Risolto_Direct_Debit_Sequence_Type_Aggregate = {
  __typename?: 'risolto_direct_debit_sequence_type_aggregate';
  aggregate?: Maybe<Risolto_Direct_Debit_Sequence_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Direct_Debit_Sequence_Type>;
};

/** aggregate fields of "risolto.direct_debit_sequence_type" */
export type Risolto_Direct_Debit_Sequence_Type_Aggregate_Fields = {
  __typename?: 'risolto_direct_debit_sequence_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Direct_Debit_Sequence_Type_Max_Fields>;
  min?: Maybe<Risolto_Direct_Debit_Sequence_Type_Min_Fields>;
};


/** aggregate fields of "risolto.direct_debit_sequence_type" */
export type Risolto_Direct_Debit_Sequence_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.direct_debit_sequence_type". All fields are combined with a logical 'AND'. */
export type Risolto_Direct_Debit_Sequence_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>>;
  sequence_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.direct_debit_sequence_type" */
export enum Risolto_Direct_Debit_Sequence_Type_Constraint {
  /** unique or primary key constraint on columns "sequence_type" */
  DirectDebitSequenceTypePkey = 'direct_debit_sequence_type_pkey'
}

export enum Risolto_Direct_Debit_Sequence_Type_Enum {
  Fnal = 'FNAL',
  Frst = 'FRST',
  Ooff = 'OOFF',
  Rcur = 'RCUR'
}

/** Boolean expression to compare columns of type "risolto_direct_debit_sequence_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Direct_Debit_Sequence_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Direct_Debit_Sequence_Type_Enum>;
  _in?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Direct_Debit_Sequence_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Enum>>;
};

/** input type for inserting data into table "risolto.direct_debit_sequence_type" */
export type Risolto_Direct_Debit_Sequence_Type_Insert_Input = {
  sequence_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Direct_Debit_Sequence_Type_Max_Fields = {
  __typename?: 'risolto_direct_debit_sequence_type_max_fields';
  sequence_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Direct_Debit_Sequence_Type_Min_Fields = {
  __typename?: 'risolto_direct_debit_sequence_type_min_fields';
  sequence_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.direct_debit_sequence_type" */
export type Risolto_Direct_Debit_Sequence_Type_Mutation_Response = {
  __typename?: 'risolto_direct_debit_sequence_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Direct_Debit_Sequence_Type>;
};

/** on_conflict condition type for table "risolto.direct_debit_sequence_type" */
export type Risolto_Direct_Debit_Sequence_Type_On_Conflict = {
  constraint: Risolto_Direct_Debit_Sequence_Type_Constraint;
  update_columns?: Array<Risolto_Direct_Debit_Sequence_Type_Update_Column>;
  where?: Maybe<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.direct_debit_sequence_type". */
export type Risolto_Direct_Debit_Sequence_Type_Order_By = {
  sequence_type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.direct_debit_sequence_type */
export type Risolto_Direct_Debit_Sequence_Type_Pk_Columns_Input = {
  sequence_type: Scalars['String'];
};

/** select columns of table "risolto.direct_debit_sequence_type" */
export enum Risolto_Direct_Debit_Sequence_Type_Select_Column {
  /** column name */
  SequenceType = 'sequence_type'
}

/** input type for updating data in table "risolto.direct_debit_sequence_type" */
export type Risolto_Direct_Debit_Sequence_Type_Set_Input = {
  sequence_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_direct_debit_sequence_type" */
export type Risolto_Direct_Debit_Sequence_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Direct_Debit_Sequence_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Direct_Debit_Sequence_Type_Stream_Cursor_Value_Input = {
  sequence_type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.direct_debit_sequence_type" */
export enum Risolto_Direct_Debit_Sequence_Type_Update_Column {
  /** column name */
  SequenceType = 'sequence_type'
}

export type Risolto_Direct_Debit_Sequence_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Direct_Debit_Sequence_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Direct_Debit_Sequence_Type_Bool_Exp;
};

/** SEPA Direct Debit Transaction */
export type Risolto_Direct_Debit_Transaction = {
  __typename?: 'risolto_direct_debit_transaction';
  amount: Scalars['numeric'];
  amount_currency: Scalars['String'];
  created_at: Scalars['timestamptz'];
  custom_fields: Scalars['jsonb'];
  end_to_end_id: Scalars['String'];
  invoice_group: Scalars['uuid'];
  /** An object relationship */
  invoice_group_by_reference: Risolto_Invoice_Group;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  mandate: Scalars['uuid'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  provider: Risolto_Direct_Debit_Provider_Enum;
  provider_transaction_id: Scalars['String'];
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  remittance_information: Scalars['String'];
  requested_collection_date: Scalars['date'];
  updated_at: Scalars['timestamptz'];
};


/** SEPA Direct Debit Transaction */
export type Risolto_Direct_Debit_TransactionCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_Aggregate = {
  __typename?: 'risolto_direct_debit_transaction_aggregate';
  aggregate?: Maybe<Risolto_Direct_Debit_Transaction_Aggregate_Fields>;
  nodes: Array<Risolto_Direct_Debit_Transaction>;
};

/** aggregate fields of "risolto.direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_Aggregate_Fields = {
  __typename?: 'risolto_direct_debit_transaction_aggregate_fields';
  avg?: Maybe<Risolto_Direct_Debit_Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Direct_Debit_Transaction_Max_Fields>;
  min?: Maybe<Risolto_Direct_Debit_Transaction_Min_Fields>;
  stddev?: Maybe<Risolto_Direct_Debit_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Direct_Debit_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Direct_Debit_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Direct_Debit_Transaction_Sum_Fields>;
  var_pop?: Maybe<Risolto_Direct_Debit_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Direct_Debit_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Direct_Debit_Transaction_Variance_Fields>;
};


/** aggregate fields of "risolto.direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Direct_Debit_Transaction_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Direct_Debit_Transaction_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Risolto_Direct_Debit_Transaction_Avg_Fields = {
  __typename?: 'risolto_direct_debit_transaction_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.direct_debit_transaction". All fields are combined with a logical 'AND'. */
export type Risolto_Direct_Debit_Transaction_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Direct_Debit_Transaction_Bool_Exp>>;
  _not?: Maybe<Risolto_Direct_Debit_Transaction_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Direct_Debit_Transaction_Bool_Exp>>;
  amount?: Maybe<Numeric_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  end_to_end_id?: Maybe<String_Comparison_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  mandate?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  provider?: Maybe<Risolto_Direct_Debit_Provider_Enum_Comparison_Exp>;
  provider_transaction_id?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  remittance_information?: Maybe<String_Comparison_Exp>;
  requested_collection_date?: Maybe<Date_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.direct_debit_transaction" */
export enum Risolto_Direct_Debit_Transaction_Constraint {
  /** unique or primary key constraint on columns "participant", "provider", "end_to_end_id", "legal_entity" */
  DirectDebitTransactionParticipantLegalEntityProviderEnd = 'direct_debit_transaction_participant_legal_entity_provider_end_',
  /** unique or primary key constraint on columns "participant", "provider", "recipient", "provider_transaction_id", "legal_entity" */
  DirectDebitTransactionParticipantLegalEntityRecipientPro = 'direct_debit_transaction_participant_legal_entity_recipient_pro',
  /** unique or primary key constraint on columns "reference" */
  DirectDebitTransactionPkey = 'direct_debit_transaction_pkey',
  /** unique or primary key constraint on columns "participant", "mandate", "recipient", "provider_transaction_id", "legal_entity" */
  DirectDebitUniqueEndToEndId = 'direct_debit_unique_end_to_end_id',
  /** unique or primary key constraint on columns "participant", "mandate", "end_to_end_id", "recipient", "legal_entity" */
  DirectDebitUniqueTransasctionId = 'direct_debit_unique_transasction_id'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Direct_Debit_Transaction_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Direct_Debit_Transaction_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Direct_Debit_Transaction_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_Inc_Input = {
  amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_Insert_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  end_to_end_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  mandate?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  provider?: Maybe<Risolto_Direct_Debit_Provider_Enum>;
  provider_transaction_id?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  remittance_information?: Maybe<Scalars['String']>;
  requested_collection_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Direct_Debit_Transaction_Max_Fields = {
  __typename?: 'risolto_direct_debit_transaction_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_to_end_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mandate?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  provider_transaction_id?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  remittance_information?: Maybe<Scalars['String']>;
  requested_collection_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Direct_Debit_Transaction_Min_Fields = {
  __typename?: 'risolto_direct_debit_transaction_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_to_end_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mandate?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  provider_transaction_id?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  remittance_information?: Maybe<Scalars['String']>;
  requested_collection_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_Mutation_Response = {
  __typename?: 'risolto_direct_debit_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Direct_Debit_Transaction>;
};

/** on_conflict condition type for table "risolto.direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_On_Conflict = {
  constraint: Risolto_Direct_Debit_Transaction_Constraint;
  update_columns?: Array<Risolto_Direct_Debit_Transaction_Update_Column>;
  where?: Maybe<Risolto_Direct_Debit_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.direct_debit_transaction". */
export type Risolto_Direct_Debit_Transaction_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  end_to_end_id?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  mandate?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  provider?: Maybe<Order_By>;
  provider_transaction_id?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  remittance_information?: Maybe<Order_By>;
  requested_collection_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.direct_debit_transaction */
export type Risolto_Direct_Debit_Transaction_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Direct_Debit_Transaction_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.direct_debit_transaction" */
export enum Risolto_Direct_Debit_Transaction_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  EndToEndId = 'end_to_end_id',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Mandate = 'mandate',
  /** column name */
  Participant = 'participant',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderTransactionId = 'provider_transaction_id',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  RemittanceInformation = 'remittance_information',
  /** column name */
  RequestedCollectionDate = 'requested_collection_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_Set_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  end_to_end_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mandate?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Risolto_Direct_Debit_Provider_Enum>;
  provider_transaction_id?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  remittance_information?: Maybe<Scalars['String']>;
  requested_collection_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Direct_Debit_Transaction_Stddev_Fields = {
  __typename?: 'risolto_direct_debit_transaction_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Direct_Debit_Transaction_Stddev_Pop_Fields = {
  __typename?: 'risolto_direct_debit_transaction_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Direct_Debit_Transaction_Stddev_Samp_Fields = {
  __typename?: 'risolto_direct_debit_transaction_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_direct_debit_transaction" */
export type Risolto_Direct_Debit_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Direct_Debit_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Direct_Debit_Transaction_Stream_Cursor_Value_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  end_to_end_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  mandate?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Risolto_Direct_Debit_Provider_Enum>;
  provider_transaction_id?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  remittance_information?: Maybe<Scalars['String']>;
  requested_collection_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Direct_Debit_Transaction_Sum_Fields = {
  __typename?: 'risolto_direct_debit_transaction_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "risolto.direct_debit_transaction" */
export enum Risolto_Direct_Debit_Transaction_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  EndToEndId = 'end_to_end_id',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Mandate = 'mandate',
  /** column name */
  Participant = 'participant',
  /** column name */
  Provider = 'provider',
  /** column name */
  ProviderTransactionId = 'provider_transaction_id',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  RemittanceInformation = 'remittance_information',
  /** column name */
  RequestedCollectionDate = 'requested_collection_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Direct_Debit_Transaction_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Direct_Debit_Transaction_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Direct_Debit_Transaction_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Direct_Debit_Transaction_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Direct_Debit_Transaction_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Direct_Debit_Transaction_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Direct_Debit_Transaction_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Direct_Debit_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Direct_Debit_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Direct_Debit_Transaction_Var_Pop_Fields = {
  __typename?: 'risolto_direct_debit_transaction_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Direct_Debit_Transaction_Var_Samp_Fields = {
  __typename?: 'risolto_direct_debit_transaction_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Direct_Debit_Transaction_Variance_Fields = {
  __typename?: 'risolto_direct_debit_transaction_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.dispute_code" */
export type Risolto_Dispute_Code = {
  __typename?: 'risolto_dispute_code';
  code: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  default_assignee?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  default_assignee_by_reference?: Maybe<Risolto_Person>;
  default_days_to_suspend: Scalars['Int'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  reference: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "risolto.dispute_code" */
export type Risolto_Dispute_Code_Aggregate = {
  __typename?: 'risolto_dispute_code_aggregate';
  aggregate?: Maybe<Risolto_Dispute_Code_Aggregate_Fields>;
  nodes: Array<Risolto_Dispute_Code>;
};

export type Risolto_Dispute_Code_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Dispute_Code_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Dispute_Code_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Dispute_Code_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.dispute_code" */
export type Risolto_Dispute_Code_Aggregate_Fields = {
  __typename?: 'risolto_dispute_code_aggregate_fields';
  avg?: Maybe<Risolto_Dispute_Code_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Dispute_Code_Max_Fields>;
  min?: Maybe<Risolto_Dispute_Code_Min_Fields>;
  stddev?: Maybe<Risolto_Dispute_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Dispute_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Dispute_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Dispute_Code_Sum_Fields>;
  var_pop?: Maybe<Risolto_Dispute_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Dispute_Code_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Dispute_Code_Variance_Fields>;
};


/** aggregate fields of "risolto.dispute_code" */
export type Risolto_Dispute_Code_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Dispute_Code_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Dispute_Code_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Dispute_Code_Max_Order_By>;
  min?: Maybe<Risolto_Dispute_Code_Min_Order_By>;
  stddev?: Maybe<Risolto_Dispute_Code_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Dispute_Code_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Dispute_Code_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Dispute_Code_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Dispute_Code_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Dispute_Code_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Dispute_Code_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Dispute_Code_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Dispute_Code_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Dispute_Code_Avg_Fields = {
  __typename?: 'risolto_dispute_code_avg_fields';
  default_days_to_suspend?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Avg_Order_By = {
  default_days_to_suspend?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.dispute_code". All fields are combined with a logical 'AND'. */
export type Risolto_Dispute_Code_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Dispute_Code_Bool_Exp>>;
  _not?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Dispute_Code_Bool_Exp>>;
  code?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  default_assignee?: Maybe<Uuid_Comparison_Exp>;
  default_assignee_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  default_days_to_suspend?: Maybe<Int_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.dispute_code" */
export enum Risolto_Dispute_Code_Constraint {
  /** unique or primary key constraint on columns "participant", "code", "legal_entity" */
  DisputeCodeParticipantLegalEntityCodeKey = 'dispute_code_participant_legal_entity_code_key',
  /** unique or primary key constraint on columns "reference" */
  DisputeCodePkey = 'dispute_code_pkey'
}

/** input type for incrementing numeric columns in table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Inc_Input = {
  default_days_to_suspend?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Insert_Input = {
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_assignee?: Maybe<Scalars['uuid']>;
  default_assignee_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  default_days_to_suspend?: Maybe<Scalars['Int']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Dispute_Code_Max_Fields = {
  __typename?: 'risolto_dispute_code_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_assignee?: Maybe<Scalars['uuid']>;
  default_days_to_suspend?: Maybe<Scalars['Int']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Max_Order_By = {
  code?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  default_assignee?: Maybe<Order_By>;
  default_days_to_suspend?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Dispute_Code_Min_Fields = {
  __typename?: 'risolto_dispute_code_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_assignee?: Maybe<Scalars['uuid']>;
  default_days_to_suspend?: Maybe<Scalars['Int']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Min_Order_By = {
  code?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  default_assignee?: Maybe<Order_By>;
  default_days_to_suspend?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Mutation_Response = {
  __typename?: 'risolto_dispute_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Dispute_Code>;
};

/** input type for inserting object relation for remote table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Obj_Rel_Insert_Input = {
  data: Risolto_Dispute_Code_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Dispute_Code_On_Conflict>;
};

/** on_conflict condition type for table "risolto.dispute_code" */
export type Risolto_Dispute_Code_On_Conflict = {
  constraint: Risolto_Dispute_Code_Constraint;
  update_columns?: Array<Risolto_Dispute_Code_Update_Column>;
  where?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.dispute_code". */
export type Risolto_Dispute_Code_Order_By = {
  code?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  default_assignee?: Maybe<Order_By>;
  default_assignee_by_reference?: Maybe<Risolto_Person_Order_By>;
  default_days_to_suspend?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.dispute_code */
export type Risolto_Dispute_Code_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.dispute_code" */
export enum Risolto_Dispute_Code_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultAssignee = 'default_assignee',
  /** column name */
  DefaultDaysToSuspend = 'default_days_to_suspend',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Set_Input = {
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_assignee?: Maybe<Scalars['uuid']>;
  default_days_to_suspend?: Maybe<Scalars['Int']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Dispute_Code_Stddev_Fields = {
  __typename?: 'risolto_dispute_code_stddev_fields';
  default_days_to_suspend?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Stddev_Order_By = {
  default_days_to_suspend?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Dispute_Code_Stddev_Pop_Fields = {
  __typename?: 'risolto_dispute_code_stddev_pop_fields';
  default_days_to_suspend?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Stddev_Pop_Order_By = {
  default_days_to_suspend?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Dispute_Code_Stddev_Samp_Fields = {
  __typename?: 'risolto_dispute_code_stddev_samp_fields';
  default_days_to_suspend?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Stddev_Samp_Order_By = {
  default_days_to_suspend?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_dispute_code" */
export type Risolto_Dispute_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Dispute_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Dispute_Code_Stream_Cursor_Value_Input = {
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_assignee?: Maybe<Scalars['uuid']>;
  default_days_to_suspend?: Maybe<Scalars['Int']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Dispute_Code_Sum_Fields = {
  __typename?: 'risolto_dispute_code_sum_fields';
  default_days_to_suspend?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Sum_Order_By = {
  default_days_to_suspend?: Maybe<Order_By>;
};

/** update columns of table "risolto.dispute_code" */
export enum Risolto_Dispute_Code_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultAssignee = 'default_assignee',
  /** column name */
  DefaultDaysToSuspend = 'default_days_to_suspend',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Dispute_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Dispute_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Dispute_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Dispute_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Dispute_Code_Var_Pop_Fields = {
  __typename?: 'risolto_dispute_code_var_pop_fields';
  default_days_to_suspend?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Var_Pop_Order_By = {
  default_days_to_suspend?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Dispute_Code_Var_Samp_Fields = {
  __typename?: 'risolto_dispute_code_var_samp_fields';
  default_days_to_suspend?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Var_Samp_Order_By = {
  default_days_to_suspend?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Dispute_Code_Variance_Fields = {
  __typename?: 'risolto_dispute_code_variance_fields';
  default_days_to_suspend?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.dispute_code" */
export type Risolto_Dispute_Code_Variance_Order_By = {
  default_days_to_suspend?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.document_attachment_type" */
export type Risolto_Document_Attachment_Type = {
  __typename?: 'risolto_document_attachment_type';
  attachment_type: Scalars['String'];
};

/** aggregated selection of "risolto.document_attachment_type" */
export type Risolto_Document_Attachment_Type_Aggregate = {
  __typename?: 'risolto_document_attachment_type_aggregate';
  aggregate?: Maybe<Risolto_Document_Attachment_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Document_Attachment_Type>;
};

/** aggregate fields of "risolto.document_attachment_type" */
export type Risolto_Document_Attachment_Type_Aggregate_Fields = {
  __typename?: 'risolto_document_attachment_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Document_Attachment_Type_Max_Fields>;
  min?: Maybe<Risolto_Document_Attachment_Type_Min_Fields>;
};


/** aggregate fields of "risolto.document_attachment_type" */
export type Risolto_Document_Attachment_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Document_Attachment_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.document_attachment_type". All fields are combined with a logical 'AND'. */
export type Risolto_Document_Attachment_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Document_Attachment_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Document_Attachment_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Document_Attachment_Type_Bool_Exp>>;
  attachment_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.document_attachment_type" */
export enum Risolto_Document_Attachment_Type_Constraint {
  /** unique or primary key constraint on columns "attachment_type" */
  DocumentAttachmentTypePkey = 'document_attachment_type_pkey'
}

export enum Risolto_Document_Attachment_Type_Enum {
  Gri = 'GRI',
  Other = 'OTHER',
  Pdf = 'PDF',
  Ubl = 'UBL',
  Xml = 'XML'
}

/** Boolean expression to compare columns of type "risolto_document_attachment_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Document_Attachment_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  _in?: Maybe<Array<Risolto_Document_Attachment_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Document_Attachment_Type_Enum>>;
};

/** input type for inserting data into table "risolto.document_attachment_type" */
export type Risolto_Document_Attachment_Type_Insert_Input = {
  attachment_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Document_Attachment_Type_Max_Fields = {
  __typename?: 'risolto_document_attachment_type_max_fields';
  attachment_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Document_Attachment_Type_Min_Fields = {
  __typename?: 'risolto_document_attachment_type_min_fields';
  attachment_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.document_attachment_type" */
export type Risolto_Document_Attachment_Type_Mutation_Response = {
  __typename?: 'risolto_document_attachment_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Document_Attachment_Type>;
};

/** on_conflict condition type for table "risolto.document_attachment_type" */
export type Risolto_Document_Attachment_Type_On_Conflict = {
  constraint: Risolto_Document_Attachment_Type_Constraint;
  update_columns?: Array<Risolto_Document_Attachment_Type_Update_Column>;
  where?: Maybe<Risolto_Document_Attachment_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.document_attachment_type". */
export type Risolto_Document_Attachment_Type_Order_By = {
  attachment_type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.document_attachment_type */
export type Risolto_Document_Attachment_Type_Pk_Columns_Input = {
  attachment_type: Scalars['String'];
};

/** select columns of table "risolto.document_attachment_type" */
export enum Risolto_Document_Attachment_Type_Select_Column {
  /** column name */
  AttachmentType = 'attachment_type'
}

/** input type for updating data in table "risolto.document_attachment_type" */
export type Risolto_Document_Attachment_Type_Set_Input = {
  attachment_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_document_attachment_type" */
export type Risolto_Document_Attachment_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Document_Attachment_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Document_Attachment_Type_Stream_Cursor_Value_Input = {
  attachment_type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.document_attachment_type" */
export enum Risolto_Document_Attachment_Type_Update_Column {
  /** column name */
  AttachmentType = 'attachment_type'
}

export type Risolto_Document_Attachment_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Document_Attachment_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Document_Attachment_Type_Bool_Exp;
};

/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_Interchange = {
  __typename?: 'risolto_document_interchange';
  /** An array relationship */
  action_interchanges: Array<Risolto_Action_Interchange>;
  /** An aggregate relationship */
  action_interchanges_aggregate: Risolto_Action_Interchange_Aggregate;
  /** Applicable for Postal Mail. Either the Mail ID or Registered Mail Barcode */
  barcode?: Maybe<Scalars['String']>;
  channel: Risolto_Channel_Enum;
  channel_endpoint?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  delivery_details?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. See document_interchange_event */
  delivery_failure_at?: Maybe<Scalars['timestamptz']>;
  delivery_failure_type?: Maybe<Scalars['String']>;
  direction: Risolto_Document_Interchange_Direction_Enum;
  /** Indicates that a communication has been simulated. */
  dry_run?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  interchange_attachments: Array<Risolto_Document_Interchange_Attachment>;
  /** An aggregate relationship */
  interchange_attachments_aggregate: Risolto_Document_Interchange_Attachment_Aggregate;
  /** An array relationship */
  interchange_event: Array<Risolto_Document_Interchange_Event>;
  /** An aggregate relationship */
  interchange_event_aggregate: Risolto_Document_Interchange_Event_Aggregate;
  interchange_events?: Maybe<Array<Risolto_Virtual_Interchange_Event>>;
  /** An array relationship */
  interchange_links: Array<Risolto_Document_Interchange_Link>;
  /** An aggregate relationship */
  interchange_links_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  message_code?: Maybe<Scalars['String']>;
  /** Correlation identifier. For outgoing interchanges this is typically the id generated by the external system. For incoming interchanges this groups a number of individual files received in a batch. */
  message_id?: Maybe<Scalars['String']>;
  message_parameters?: Maybe<Scalars['jsonb']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  /** DEPRECATED */
  outcome?: Maybe<Scalars['jsonb']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** The process id or batch id is used to indicate that one or more interchanges were processed in the same batch or process. */
  process_id: Scalars['uuid'];
  reference: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeAction_InterchangesArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Interchange_Order_By>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeAction_Interchanges_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Interchange_Order_By>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeDelivery_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeInterchange_AttachmentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Attachment_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeInterchange_Attachments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Attachment_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeInterchange_EventArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeInterchange_Event_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeInterchange_EventsArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeInterchange_LinksArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeInterchange_Links_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeMessage_ParametersArgs = {
  path?: Maybe<Scalars['String']>;
};


/** A Document Interchange captures the technical details on the exchange of a Document without any details about the Document itself. */
export type Risolto_Document_InterchangeOutcomeArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.document_interchange" */
export type Risolto_Document_Interchange_Aggregate = {
  __typename?: 'risolto_document_interchange_aggregate';
  aggregate?: Maybe<Risolto_Document_Interchange_Aggregate_Fields>;
  nodes: Array<Risolto_Document_Interchange>;
};

export type Risolto_Document_Interchange_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Document_Interchange_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Document_Interchange_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Document_Interchange_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Document_Interchange_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Document_Interchange_Select_Column_Risolto_Document_Interchange_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Document_Interchange_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Document_Interchange_Select_Column_Risolto_Document_Interchange_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Document_Interchange_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.document_interchange" */
export type Risolto_Document_Interchange_Aggregate_Fields = {
  __typename?: 'risolto_document_interchange_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Document_Interchange_Max_Fields>;
  min?: Maybe<Risolto_Document_Interchange_Min_Fields>;
};


/** aggregate fields of "risolto.document_interchange" */
export type Risolto_Document_Interchange_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.document_interchange" */
export type Risolto_Document_Interchange_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Document_Interchange_Max_Order_By>;
  min?: Maybe<Risolto_Document_Interchange_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Document_Interchange_Append_Input = {
  /** null */
  delivery_details?: Maybe<Scalars['jsonb']>;
  message_parameters?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  outcome?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.document_interchange" */
export type Risolto_Document_Interchange_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Document_Interchange_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Document_Interchange_On_Conflict>;
};

/** columns and relationships of "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment = {
  __typename?: 'risolto_document_interchange_attachment';
  /** Should be *mime-type* */
  content_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  interchange: Scalars['uuid'];
  /** An object relationship */
  interchange_by_reference: Risolto_Document_Interchange;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata: Scalars['jsonb'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  /** S3 | URI */
  scheme: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_AttachmentMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Aggregate = {
  __typename?: 'risolto_document_interchange_attachment_aggregate';
  aggregate?: Maybe<Risolto_Document_Interchange_Attachment_Aggregate_Fields>;
  nodes: Array<Risolto_Document_Interchange_Attachment>;
};

export type Risolto_Document_Interchange_Attachment_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Document_Interchange_Attachment_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Document_Interchange_Attachment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Document_Interchange_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Aggregate_Fields = {
  __typename?: 'risolto_document_interchange_attachment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Document_Interchange_Attachment_Max_Fields>;
  min?: Maybe<Risolto_Document_Interchange_Attachment_Min_Fields>;
};


/** aggregate fields of "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Document_Interchange_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Document_Interchange_Attachment_Max_Order_By>;
  min?: Maybe<Risolto_Document_Interchange_Attachment_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Document_Interchange_Attachment_Append_Input = {
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Document_Interchange_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Document_Interchange_Attachment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.document_interchange_attachment". All fields are combined with a logical 'AND'. */
export type Risolto_Document_Interchange_Attachment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Document_Interchange_Attachment_Bool_Exp>>;
  _not?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Document_Interchange_Attachment_Bool_Exp>>;
  content_type?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  interchange?: Maybe<Uuid_Comparison_Exp>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  scheme?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.document_interchange_attachment" */
export enum Risolto_Document_Interchange_Attachment_Constraint {
  /** unique or primary key constraint on columns "reference" */
  DocumentInterchangeAttachmentPkey = 'document_interchange_attachment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Document_Interchange_Attachment_Delete_At_Path_Input = {
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Document_Interchange_Attachment_Delete_Elem_Input = {
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Document_Interchange_Attachment_Delete_Key_Input = {
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Insert_Input = {
  /** Should be *mime-type* */
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  /** S3 | URI */
  scheme?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Document_Interchange_Attachment_Max_Fields = {
  __typename?: 'risolto_document_interchange_attachment_max_fields';
  /** Should be *mime-type* */
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** S3 | URI */
  scheme?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Max_Order_By = {
  /** Should be *mime-type* */
  content_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** S3 | URI */
  scheme?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Document_Interchange_Attachment_Min_Fields = {
  __typename?: 'risolto_document_interchange_attachment_min_fields';
  /** Should be *mime-type* */
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** S3 | URI */
  scheme?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Min_Order_By = {
  /** Should be *mime-type* */
  content_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** S3 | URI */
  scheme?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Mutation_Response = {
  __typename?: 'risolto_document_interchange_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Document_Interchange_Attachment>;
};

/** on_conflict condition type for table "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_On_Conflict = {
  constraint: Risolto_Document_Interchange_Attachment_Constraint;
  update_columns?: Array<Risolto_Document_Interchange_Attachment_Update_Column>;
  where?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.document_interchange_attachment". */
export type Risolto_Document_Interchange_Attachment_Order_By = {
  content_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  metadata?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  scheme?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.document_interchange_attachment */
export type Risolto_Document_Interchange_Attachment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Document_Interchange_Attachment_Prepend_Input = {
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.document_interchange_attachment" */
export enum Risolto_Document_Interchange_Attachment_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Scheme = 'scheme',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Set_Input = {
  /** Should be *mime-type* */
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** S3 | URI */
  scheme?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_document_interchange_attachment" */
export type Risolto_Document_Interchange_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Document_Interchange_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Document_Interchange_Attachment_Stream_Cursor_Value_Input = {
  /** Should be *mime-type* */
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** Attachment metadata (HTTP URI; S3 Bucket + Key; Filename; ...) */
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** S3 | URI */
  scheme?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.document_interchange_attachment" */
export enum Risolto_Document_Interchange_Attachment_Update_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Scheme = 'scheme',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Document_Interchange_Attachment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Document_Interchange_Attachment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Attachment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Document_Interchange_Attachment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Document_Interchange_Attachment_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Document_Interchange_Attachment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Document_Interchange_Attachment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Document_Interchange_Attachment_Bool_Exp;
};

/** Boolean expression to filter rows from the table "risolto.document_interchange". All fields are combined with a logical 'AND'. */
export type Risolto_Document_Interchange_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Document_Interchange_Bool_Exp>>;
  _not?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Document_Interchange_Bool_Exp>>;
  action_interchanges?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
  action_interchanges_aggregate?: Maybe<Risolto_Action_Interchange_Aggregate_Bool_Exp>;
  barcode?: Maybe<String_Comparison_Exp>;
  channel?: Maybe<Risolto_Channel_Enum_Comparison_Exp>;
  channel_endpoint?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  delivered_at?: Maybe<Timestamptz_Comparison_Exp>;
  delivery_details?: Maybe<Jsonb_Comparison_Exp>;
  delivery_failure_at?: Maybe<Timestamptz_Comparison_Exp>;
  delivery_failure_type?: Maybe<String_Comparison_Exp>;
  direction?: Maybe<Risolto_Document_Interchange_Direction_Enum_Comparison_Exp>;
  dry_run?: Maybe<Boolean_Comparison_Exp>;
  interchange_attachments?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
  interchange_attachments_aggregate?: Maybe<Risolto_Document_Interchange_Attachment_Aggregate_Bool_Exp>;
  interchange_event?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
  interchange_event_aggregate?: Maybe<Risolto_Document_Interchange_Event_Aggregate_Bool_Exp>;
  interchange_events?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message_code?: Maybe<String_Comparison_Exp>;
  message_id?: Maybe<String_Comparison_Exp>;
  message_parameters?: Maybe<Jsonb_Comparison_Exp>;
  origin?: Maybe<Risolto_Origin_Enum_Comparison_Exp>;
  outcome?: Maybe<Jsonb_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  process_id?: Maybe<Uuid_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.document_interchange" */
export enum Risolto_Document_Interchange_Constraint {
  /** unique or primary key constraint on columns "reference" */
  DocumentInterchangePkey = 'document_interchange_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Document_Interchange_Delete_At_Path_Input = {
  /** null */
  delivery_details?: Maybe<Array<Scalars['String']>>;
  message_parameters?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED */
  outcome?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Document_Interchange_Delete_Elem_Input = {
  /** null */
  delivery_details?: Maybe<Scalars['Int']>;
  message_parameters?: Maybe<Scalars['Int']>;
  /** DEPRECATED */
  outcome?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Document_Interchange_Delete_Key_Input = {
  /** null */
  delivery_details?: Maybe<Scalars['String']>;
  message_parameters?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  outcome?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.document_interchange_direction" */
export type Risolto_Document_Interchange_Direction = {
  __typename?: 'risolto_document_interchange_direction';
  direction: Scalars['String'];
};

/** aggregated selection of "risolto.document_interchange_direction" */
export type Risolto_Document_Interchange_Direction_Aggregate = {
  __typename?: 'risolto_document_interchange_direction_aggregate';
  aggregate?: Maybe<Risolto_Document_Interchange_Direction_Aggregate_Fields>;
  nodes: Array<Risolto_Document_Interchange_Direction>;
};

/** aggregate fields of "risolto.document_interchange_direction" */
export type Risolto_Document_Interchange_Direction_Aggregate_Fields = {
  __typename?: 'risolto_document_interchange_direction_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Document_Interchange_Direction_Max_Fields>;
  min?: Maybe<Risolto_Document_Interchange_Direction_Min_Fields>;
};


/** aggregate fields of "risolto.document_interchange_direction" */
export type Risolto_Document_Interchange_Direction_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Document_Interchange_Direction_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.document_interchange_direction". All fields are combined with a logical 'AND'. */
export type Risolto_Document_Interchange_Direction_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Document_Interchange_Direction_Bool_Exp>>;
  _not?: Maybe<Risolto_Document_Interchange_Direction_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Document_Interchange_Direction_Bool_Exp>>;
  direction?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.document_interchange_direction" */
export enum Risolto_Document_Interchange_Direction_Constraint {
  /** unique or primary key constraint on columns "direction" */
  DocumentInterchangeDirectionPkey = 'document_interchange_direction_pkey'
}

export enum Risolto_Document_Interchange_Direction_Enum {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

/** Boolean expression to compare columns of type "risolto_document_interchange_direction_enum". All fields are combined with logical 'AND'. */
export type Risolto_Document_Interchange_Direction_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Document_Interchange_Direction_Enum>;
  _in?: Maybe<Array<Risolto_Document_Interchange_Direction_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Document_Interchange_Direction_Enum>;
  _nin?: Maybe<Array<Risolto_Document_Interchange_Direction_Enum>>;
};

/** input type for inserting data into table "risolto.document_interchange_direction" */
export type Risolto_Document_Interchange_Direction_Insert_Input = {
  direction?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Document_Interchange_Direction_Max_Fields = {
  __typename?: 'risolto_document_interchange_direction_max_fields';
  direction?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Document_Interchange_Direction_Min_Fields = {
  __typename?: 'risolto_document_interchange_direction_min_fields';
  direction?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.document_interchange_direction" */
export type Risolto_Document_Interchange_Direction_Mutation_Response = {
  __typename?: 'risolto_document_interchange_direction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Document_Interchange_Direction>;
};

/** on_conflict condition type for table "risolto.document_interchange_direction" */
export type Risolto_Document_Interchange_Direction_On_Conflict = {
  constraint: Risolto_Document_Interchange_Direction_Constraint;
  update_columns?: Array<Risolto_Document_Interchange_Direction_Update_Column>;
  where?: Maybe<Risolto_Document_Interchange_Direction_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.document_interchange_direction". */
export type Risolto_Document_Interchange_Direction_Order_By = {
  direction?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.document_interchange_direction */
export type Risolto_Document_Interchange_Direction_Pk_Columns_Input = {
  direction: Scalars['String'];
};

/** select columns of table "risolto.document_interchange_direction" */
export enum Risolto_Document_Interchange_Direction_Select_Column {
  /** column name */
  Direction = 'direction'
}

/** input type for updating data in table "risolto.document_interchange_direction" */
export type Risolto_Document_Interchange_Direction_Set_Input = {
  direction?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_document_interchange_direction" */
export type Risolto_Document_Interchange_Direction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Document_Interchange_Direction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Document_Interchange_Direction_Stream_Cursor_Value_Input = {
  direction?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.document_interchange_direction" */
export enum Risolto_Document_Interchange_Direction_Update_Column {
  /** column name */
  Direction = 'direction'
}

export type Risolto_Document_Interchange_Direction_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Document_Interchange_Direction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Document_Interchange_Direction_Bool_Exp;
};

/** columns and relationships of "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event = {
  __typename?: 'risolto_document_interchange_event';
  channel_endpoint: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  event_subtype?: Maybe<Scalars['String']>;
  event_type: Scalars['String'];
  failure: Scalars['Boolean'];
  interchange: Scalars['uuid'];
  /** An object relationship */
  interchange_by_reference: Risolto_Document_Interchange;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  raw_data: Scalars['jsonb'];
  reference: Scalars['uuid'];
  timestamp: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_EventChannel_EndpointArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_EventRaw_DataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Aggregate = {
  __typename?: 'risolto_document_interchange_event_aggregate';
  aggregate?: Maybe<Risolto_Document_Interchange_Event_Aggregate_Fields>;
  nodes: Array<Risolto_Document_Interchange_Event>;
};

export type Risolto_Document_Interchange_Event_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Document_Interchange_Event_Select_Column_Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Document_Interchange_Event_Select_Column_Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Document_Interchange_Event_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Aggregate_Fields = {
  __typename?: 'risolto_document_interchange_event_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Document_Interchange_Event_Max_Fields>;
  min?: Maybe<Risolto_Document_Interchange_Event_Min_Fields>;
};


/** aggregate fields of "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Document_Interchange_Event_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Document_Interchange_Event_Max_Order_By>;
  min?: Maybe<Risolto_Document_Interchange_Event_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Document_Interchange_Event_Append_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
  raw_data?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Document_Interchange_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Document_Interchange_Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.document_interchange_event". All fields are combined with a logical 'AND'. */
export type Risolto_Document_Interchange_Event_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Document_Interchange_Event_Bool_Exp>>;
  _not?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Document_Interchange_Event_Bool_Exp>>;
  channel_endpoint?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  event_subtype?: Maybe<String_Comparison_Exp>;
  event_type?: Maybe<String_Comparison_Exp>;
  failure?: Maybe<Boolean_Comparison_Exp>;
  interchange?: Maybe<Uuid_Comparison_Exp>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  raw_data?: Maybe<Jsonb_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  timestamp?: Maybe<Timestamptz_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.document_interchange_event" */
export enum Risolto_Document_Interchange_Event_Constraint {
  /** unique or primary key constraint on columns "reference" */
  DocumentInterchangeDeliveryDetailsPkey = 'document_interchange_delivery_details_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Document_Interchange_Event_Delete_At_Path_Input = {
  channel_endpoint?: Maybe<Array<Scalars['String']>>;
  raw_data?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Document_Interchange_Event_Delete_Elem_Input = {
  channel_endpoint?: Maybe<Scalars['Int']>;
  raw_data?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Document_Interchange_Event_Delete_Key_Input = {
  channel_endpoint?: Maybe<Scalars['String']>;
  raw_data?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Insert_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_subtype?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  failure?: Maybe<Scalars['Boolean']>;
  interchange?: Maybe<Scalars['uuid']>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  raw_data?: Maybe<Scalars['jsonb']>;
  reference?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Document_Interchange_Event_Max_Fields = {
  __typename?: 'risolto_document_interchange_event_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_subtype?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  event_subtype?: Maybe<Order_By>;
  event_type?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Document_Interchange_Event_Min_Fields = {
  __typename?: 'risolto_document_interchange_event_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_subtype?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  event_subtype?: Maybe<Order_By>;
  event_type?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Mutation_Response = {
  __typename?: 'risolto_document_interchange_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Document_Interchange_Event>;
};

/** on_conflict condition type for table "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_On_Conflict = {
  constraint: Risolto_Document_Interchange_Event_Constraint;
  update_columns?: Array<Risolto_Document_Interchange_Event_Update_Column>;
  where?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.document_interchange_event". */
export type Risolto_Document_Interchange_Event_Order_By = {
  channel_endpoint?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  event_subtype?: Maybe<Order_By>;
  event_type?: Maybe<Order_By>;
  failure?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  raw_data?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.document_interchange_event */
export type Risolto_Document_Interchange_Event_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Document_Interchange_Event_Prepend_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
  raw_data?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.document_interchange_event" */
export enum Risolto_Document_Interchange_Event_Select_Column {
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventSubtype = 'event_subtype',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Failure = 'failure',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Reference = 'reference',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_document_interchange_event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.document_interchange_event" */
export enum Risolto_Document_Interchange_Event_Select_Column_Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Failure = 'failure'
}

/** select "risolto_document_interchange_event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.document_interchange_event" */
export enum Risolto_Document_Interchange_Event_Select_Column_Risolto_Document_Interchange_Event_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Failure = 'failure'
}

/** input type for updating data in table "risolto.document_interchange_event" */
export type Risolto_Document_Interchange_Event_Set_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_subtype?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  failure?: Maybe<Scalars['Boolean']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  raw_data?: Maybe<Scalars['jsonb']>;
  reference?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_document_interchange_event" */
export type Risolto_Document_Interchange_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Document_Interchange_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Document_Interchange_Event_Stream_Cursor_Value_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_subtype?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  failure?: Maybe<Scalars['Boolean']>;
  interchange?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  raw_data?: Maybe<Scalars['jsonb']>;
  reference?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.document_interchange_event" */
export enum Risolto_Document_Interchange_Event_Update_Column {
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventSubtype = 'event_subtype',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Failure = 'failure',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Reference = 'reference',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Document_Interchange_Event_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Document_Interchange_Event_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Event_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Document_Interchange_Event_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Document_Interchange_Event_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Document_Interchange_Event_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Document_Interchange_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Document_Interchange_Event_Bool_Exp;
};

/** input type for inserting data into table "risolto.document_interchange" */
export type Risolto_Document_Interchange_Insert_Input = {
  action_interchanges?: Maybe<Risolto_Action_Interchange_Arr_Rel_Insert_Input>;
  channel?: Maybe<Risolto_Channel_Enum>;
  channel_endpoint?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  delivery_details?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. See document_interchange_event */
  delivery_failure_at?: Maybe<Scalars['timestamptz']>;
  delivery_failure_type?: Maybe<Scalars['String']>;
  direction?: Maybe<Risolto_Document_Interchange_Direction_Enum>;
  /** Indicates that a communication has been simulated. */
  dry_run?: Maybe<Scalars['Boolean']>;
  interchange_attachments?: Maybe<Risolto_Document_Interchange_Attachment_Arr_Rel_Insert_Input>;
  interchange_event?: Maybe<Risolto_Document_Interchange_Event_Arr_Rel_Insert_Input>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message_code?: Maybe<Scalars['String']>;
  /** Correlation identifier. For outgoing interchanges this is typically the id generated by the external system. For incoming interchanges this groups a number of individual files received in a batch. */
  message_id?: Maybe<Scalars['String']>;
  message_parameters?: Maybe<Scalars['jsonb']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  /** DEPRECATED */
  outcome?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  /** The process id or batch id is used to indicate that one or more interchanges were processed in the same batch or process. */
  process_id?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link = {
  __typename?: 'risolto_document_interchange_link';
  created_at: Scalars['timestamptz'];
  credit_note?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  credit_note_by_reference?: Maybe<Risolto_Credit_Note>;
  debit_note?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  debit_note_by_reference?: Maybe<Risolto_Debit_Note>;
  direction: Risolto_Document_Interchange_Direction_Enum;
  interchange: Scalars['uuid'];
  /** An object relationship */
  interchange_by_reference: Risolto_Document_Interchange;
  /** null */
  invoice_document?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice_document_by_reference?: Maybe<Risolto_Invoice_Document>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  open_balance?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  open_balance_by_reference?: Maybe<Risolto_Open_Balance>;
  /** null */
  open_balance_record?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  open_balance_record_by_reference?: Maybe<Risolto_Open_Balance_Record>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_document?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_document_by_reference?: Maybe<Risolto_Payment_Document>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference: Scalars['uuid'];
  statement_line?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  statement_line_by_reference?: Maybe<Risolto_Statement_Line>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Aggregate = {
  __typename?: 'risolto_document_interchange_link_aggregate';
  aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Fields>;
  nodes: Array<Risolto_Document_Interchange_Link>;
};

export type Risolto_Document_Interchange_Link_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Document_Interchange_Link_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Aggregate_Fields = {
  __typename?: 'risolto_document_interchange_link_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Document_Interchange_Link_Max_Fields>;
  min?: Maybe<Risolto_Document_Interchange_Link_Min_Fields>;
};


/** aggregate fields of "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Document_Interchange_Link_Max_Order_By>;
  min?: Maybe<Risolto_Document_Interchange_Link_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Document_Interchange_Link_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Document_Interchange_Link_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.document_interchange_link". All fields are combined with a logical 'AND'. */
export type Risolto_Document_Interchange_Link_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Document_Interchange_Link_Bool_Exp>>;
  _not?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Document_Interchange_Link_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  credit_note?: Maybe<Uuid_Comparison_Exp>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Bool_Exp>;
  debit_note?: Maybe<Uuid_Comparison_Exp>;
  debit_note_by_reference?: Maybe<Risolto_Debit_Note_Bool_Exp>;
  direction?: Maybe<Risolto_Document_Interchange_Direction_Enum_Comparison_Exp>;
  interchange?: Maybe<Uuid_Comparison_Exp>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  invoice_document?: Maybe<Uuid_Comparison_Exp>;
  invoice_document_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_balance?: Maybe<Uuid_Comparison_Exp>;
  open_balance_by_reference?: Maybe<Risolto_Open_Balance_Bool_Exp>;
  open_balance_record?: Maybe<Uuid_Comparison_Exp>;
  open_balance_record_by_reference?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_document?: Maybe<Uuid_Comparison_Exp>;
  payment_document_by_reference?: Maybe<Risolto_Payment_Document_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  statement_line?: Maybe<Uuid_Comparison_Exp>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.document_interchange_link" */
export enum Risolto_Document_Interchange_Link_Constraint {
  /** unique or primary key constraint on columns "participant", "direction", "interchange", "invoice_document" */
  DocumentInterchangeLinkDirectionInvoiceDocumentParticipan = 'document_interchange_link_direction_invoice_document_participan',
  /** unique or primary key constraint on columns "reference" */
  DocumentInterchangeLinkPkey = 'document_interchange_link_pkey'
}

/** input type for inserting data into table "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Obj_Rel_Insert_Input>;
  debit_note?: Maybe<Scalars['uuid']>;
  debit_note_by_reference?: Maybe<Risolto_Debit_Note_Obj_Rel_Insert_Input>;
  direction?: Maybe<Risolto_Document_Interchange_Direction_Enum>;
  interchange?: Maybe<Scalars['uuid']>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Obj_Rel_Insert_Input>;
  /** null */
  invoice_document?: Maybe<Scalars['uuid']>;
  invoice_document_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_balance?: Maybe<Scalars['uuid']>;
  open_balance_by_reference?: Maybe<Risolto_Open_Balance_Obj_Rel_Insert_Input>;
  /** null */
  open_balance_record?: Maybe<Scalars['uuid']>;
  open_balance_record_by_reference?: Maybe<Risolto_Open_Balance_Record_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_document?: Maybe<Scalars['uuid']>;
  payment_document_by_reference?: Maybe<Risolto_Payment_Document_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Document_Interchange_Link_Max_Fields = {
  __typename?: 'risolto_document_interchange_link_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  interchange?: Maybe<Scalars['uuid']>;
  /** null */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_balance?: Maybe<Scalars['uuid']>;
  /** null */
  open_balance_record?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  /** null */
  invoice_document?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_balance?: Maybe<Order_By>;
  /** null */
  open_balance_record?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_document?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Document_Interchange_Link_Min_Fields = {
  __typename?: 'risolto_document_interchange_link_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  interchange?: Maybe<Scalars['uuid']>;
  /** null */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_balance?: Maybe<Scalars['uuid']>;
  /** null */
  open_balance_record?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  /** null */
  invoice_document?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_balance?: Maybe<Order_By>;
  /** null */
  open_balance_record?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_document?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Mutation_Response = {
  __typename?: 'risolto_document_interchange_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Document_Interchange_Link>;
};

/** on_conflict condition type for table "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_On_Conflict = {
  constraint: Risolto_Document_Interchange_Link_Constraint;
  update_columns?: Array<Risolto_Document_Interchange_Link_Update_Column>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.document_interchange_link". */
export type Risolto_Document_Interchange_Link_Order_By = {
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Order_By>;
  debit_note?: Maybe<Order_By>;
  debit_note_by_reference?: Maybe<Risolto_Debit_Note_Order_By>;
  direction?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Order_By>;
  invoice_document?: Maybe<Order_By>;
  invoice_document_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_balance?: Maybe<Order_By>;
  open_balance_by_reference?: Maybe<Risolto_Open_Balance_Order_By>;
  open_balance_record?: Maybe<Order_By>;
  open_balance_record_by_reference?: Maybe<Risolto_Open_Balance_Record_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_document?: Maybe<Order_By>;
  payment_document_by_reference?: Maybe<Risolto_Payment_Document_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.document_interchange_link */
export type Risolto_Document_Interchange_Link_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.document_interchange_link" */
export enum Risolto_Document_Interchange_Link_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  DebitNote = 'debit_note',
  /** column name */
  Direction = 'direction',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  InvoiceDocument = 'invoice_document',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenBalance = 'open_balance',
  /** column name */
  OpenBalanceRecord = 'open_balance_record',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentDocument = 'payment_document',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.document_interchange_link" */
export type Risolto_Document_Interchange_Link_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  direction?: Maybe<Risolto_Document_Interchange_Direction_Enum>;
  interchange?: Maybe<Scalars['uuid']>;
  /** null */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_balance?: Maybe<Scalars['uuid']>;
  /** null */
  open_balance_record?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_document_interchange_link" */
export type Risolto_Document_Interchange_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Document_Interchange_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Document_Interchange_Link_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  direction?: Maybe<Risolto_Document_Interchange_Direction_Enum>;
  interchange?: Maybe<Scalars['uuid']>;
  /** null */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_balance?: Maybe<Scalars['uuid']>;
  /** null */
  open_balance_record?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.document_interchange_link" */
export enum Risolto_Document_Interchange_Link_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  DebitNote = 'debit_note',
  /** column name */
  Direction = 'direction',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  InvoiceDocument = 'invoice_document',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenBalance = 'open_balance',
  /** column name */
  OpenBalanceRecord = 'open_balance_record',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentDocument = 'payment_document',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Document_Interchange_Link_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Document_Interchange_Link_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Document_Interchange_Link_Bool_Exp;
};

/** aggregate max on columns */
export type Risolto_Document_Interchange_Max_Fields = {
  __typename?: 'risolto_document_interchange_max_fields';
  /** Applicable for Postal Mail. Either the Mail ID or Registered Mail Barcode */
  barcode?: Maybe<Scalars['String']>;
  channel_endpoint?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED. See document_interchange_event */
  delivery_failure_at?: Maybe<Scalars['timestamptz']>;
  delivery_failure_type?: Maybe<Scalars['String']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  /** Correlation identifier. For outgoing interchanges this is typically the id generated by the external system. For incoming interchanges this groups a number of individual files received in a batch. */
  message_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  /** The process id or batch id is used to indicate that one or more interchanges were processed in the same batch or process. */
  process_id?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "risolto.document_interchange" */
export type Risolto_Document_Interchange_Max_Order_By = {
  channel_endpoint?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  /** DEPRECATED. See document_interchange_event */
  delivery_failure_at?: Maybe<Order_By>;
  delivery_failure_type?: Maybe<Order_By>;
  /** null */
  legal_entity?: Maybe<Order_By>;
  message_code?: Maybe<Order_By>;
  /** Correlation identifier. For outgoing interchanges this is typically the id generated by the external system. For incoming interchanges this groups a number of individual files received in a batch. */
  message_id?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  /** The process id or batch id is used to indicate that one or more interchanges were processed in the same batch or process. */
  process_id?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Document_Interchange_Min_Fields = {
  __typename?: 'risolto_document_interchange_min_fields';
  /** Applicable for Postal Mail. Either the Mail ID or Registered Mail Barcode */
  barcode?: Maybe<Scalars['String']>;
  channel_endpoint?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED. See document_interchange_event */
  delivery_failure_at?: Maybe<Scalars['timestamptz']>;
  delivery_failure_type?: Maybe<Scalars['String']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  /** Correlation identifier. For outgoing interchanges this is typically the id generated by the external system. For incoming interchanges this groups a number of individual files received in a batch. */
  message_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  /** The process id or batch id is used to indicate that one or more interchanges were processed in the same batch or process. */
  process_id?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "risolto.document_interchange" */
export type Risolto_Document_Interchange_Min_Order_By = {
  channel_endpoint?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  /** DEPRECATED. See document_interchange_event */
  delivery_failure_at?: Maybe<Order_By>;
  delivery_failure_type?: Maybe<Order_By>;
  /** null */
  legal_entity?: Maybe<Order_By>;
  message_code?: Maybe<Order_By>;
  /** Correlation identifier. For outgoing interchanges this is typically the id generated by the external system. For incoming interchanges this groups a number of individual files received in a batch. */
  message_id?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  /** The process id or batch id is used to indicate that one or more interchanges were processed in the same batch or process. */
  process_id?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.document_interchange" */
export type Risolto_Document_Interchange_Mutation_Response = {
  __typename?: 'risolto_document_interchange_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Document_Interchange>;
};

/** input type for inserting object relation for remote table "risolto.document_interchange" */
export type Risolto_Document_Interchange_Obj_Rel_Insert_Input = {
  data: Risolto_Document_Interchange_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Document_Interchange_On_Conflict>;
};

/** on_conflict condition type for table "risolto.document_interchange" */
export type Risolto_Document_Interchange_On_Conflict = {
  constraint: Risolto_Document_Interchange_Constraint;
  update_columns?: Array<Risolto_Document_Interchange_Update_Column>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.document_interchange". */
export type Risolto_Document_Interchange_Order_By = {
  action_interchanges_aggregate?: Maybe<Risolto_Action_Interchange_Aggregate_Order_By>;
  barcode?: Maybe<Order_By>;
  channel?: Maybe<Order_By>;
  channel_endpoint?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  delivery_details?: Maybe<Order_By>;
  delivery_failure_at?: Maybe<Order_By>;
  delivery_failure_type?: Maybe<Order_By>;
  direction?: Maybe<Order_By>;
  dry_run?: Maybe<Order_By>;
  interchange_attachments_aggregate?: Maybe<Risolto_Document_Interchange_Attachment_Aggregate_Order_By>;
  interchange_event_aggregate?: Maybe<Risolto_Document_Interchange_Event_Aggregate_Order_By>;
  interchange_events_aggregate?: Maybe<Risolto_Virtual_Interchange_Event_Aggregate_Order_By>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message_code?: Maybe<Order_By>;
  message_id?: Maybe<Order_By>;
  message_parameters?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  outcome?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  process_id?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.document_interchange */
export type Risolto_Document_Interchange_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Document_Interchange_Prepend_Input = {
  /** null */
  delivery_details?: Maybe<Scalars['jsonb']>;
  message_parameters?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  outcome?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.document_interchange" */
export enum Risolto_Document_Interchange_Select_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  DeliveryDetails = 'delivery_details',
  /** column name */
  DeliveryFailureAt = 'delivery_failure_at',
  /** column name */
  DeliveryFailureType = 'delivery_failure_type',
  /** column name */
  Direction = 'direction',
  /** column name */
  DryRun = 'dry_run',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  MessageParameters = 'message_parameters',
  /** column name */
  Origin = 'origin',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** select "risolto_document_interchange_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.document_interchange" */
export enum Risolto_Document_Interchange_Select_Column_Risolto_Document_Interchange_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DryRun = 'dry_run'
}

/** select "risolto_document_interchange_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.document_interchange" */
export enum Risolto_Document_Interchange_Select_Column_Risolto_Document_Interchange_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DryRun = 'dry_run'
}

/** input type for updating data in table "risolto.document_interchange" */
export type Risolto_Document_Interchange_Set_Input = {
  channel?: Maybe<Risolto_Channel_Enum>;
  channel_endpoint?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  delivery_details?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. See document_interchange_event */
  delivery_failure_at?: Maybe<Scalars['timestamptz']>;
  delivery_failure_type?: Maybe<Scalars['String']>;
  direction?: Maybe<Risolto_Document_Interchange_Direction_Enum>;
  /** Indicates that a communication has been simulated. */
  dry_run?: Maybe<Scalars['Boolean']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  /** Correlation identifier. For outgoing interchanges this is typically the id generated by the external system. For incoming interchanges this groups a number of individual files received in a batch. */
  message_id?: Maybe<Scalars['String']>;
  message_parameters?: Maybe<Scalars['jsonb']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  /** DEPRECATED */
  outcome?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  /** The process id or batch id is used to indicate that one or more interchanges were processed in the same batch or process. */
  process_id?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_document_interchange" */
export type Risolto_Document_Interchange_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Document_Interchange_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Document_Interchange_Stream_Cursor_Value_Input = {
  channel?: Maybe<Risolto_Channel_Enum>;
  channel_endpoint?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  /** null */
  delivery_details?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. See document_interchange_event */
  delivery_failure_at?: Maybe<Scalars['timestamptz']>;
  delivery_failure_type?: Maybe<Scalars['String']>;
  direction?: Maybe<Risolto_Document_Interchange_Direction_Enum>;
  /** Indicates that a communication has been simulated. */
  dry_run?: Maybe<Scalars['Boolean']>;
  /** null */
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  /** Correlation identifier. For outgoing interchanges this is typically the id generated by the external system. For incoming interchanges this groups a number of individual files received in a batch. */
  message_id?: Maybe<Scalars['String']>;
  message_parameters?: Maybe<Scalars['jsonb']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  /** DEPRECATED */
  outcome?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  /** The process id or batch id is used to indicate that one or more interchanges were processed in the same batch or process. */
  process_id?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.document_interchange" */
export enum Risolto_Document_Interchange_Update_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  DeliveryDetails = 'delivery_details',
  /** column name */
  DeliveryFailureAt = 'delivery_failure_at',
  /** column name */
  DeliveryFailureType = 'delivery_failure_type',
  /** column name */
  Direction = 'direction',
  /** column name */
  DryRun = 'dry_run',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  MessageParameters = 'message_parameters',
  /** column name */
  Origin = 'origin',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Risolto_Document_Interchange_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Document_Interchange_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Document_Interchange_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Document_Interchange_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Document_Interchange_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Document_Interchange_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Document_Interchange_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Document_Interchange_Bool_Exp;
};

/** A document used to remind a customer of payments past due. */
export type Risolto_Dunning_Notice = {
  __typename?: 'risolto_dunning_notice';
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  charges: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  credit_amount?: Maybe<Scalars['numeric']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action.due_date */
  due_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  dunning_notice_invoices: Array<Risolto_Dunning_Notice_Invoice>;
  /** An aggregate relationship */
  dunning_notice_invoices_aggregate: Risolto_Dunning_Notice_Invoice_Aggregate;
  /** null */
  interest: Scalars['numeric'];
  invoice_group?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group>;
  /** DEPRECATED. See action.start_time */
  issue_date?: Maybe<Scalars['date']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  /** DEPRECATED */
  level?: Maybe<Scalars['Int']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_link?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_link_by_reference?: Maybe<Risolto_Payment_Link>;
  payment_reference: Scalars['String'];
  /** An array relationship */
  payments: Array<Risolto_Payment>;
  /** An aggregate relationship */
  payments_aggregate: Risolto_Payment_Aggregate;
  principal_amount: Scalars['numeric'];
  /** DEPRECATED. See action status. DRAFT or SENT */
  processing_status?: Maybe<Risolto_Dunning_Notice_Status_Enum>;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
  /** A code signifying the type of the Reminder. E.g. 'dunning_reminder', 'notice_of_default' */
  type_code: Risolto_Dunning_Notice_Type_Code_Enum;
  updated_at: Scalars['timestamptz'];
};


/** A document used to remind a customer of payments past due. */
export type Risolto_Dunning_NoticeActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** A document used to remind a customer of payments past due. */
export type Risolto_Dunning_NoticeActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** A document used to remind a customer of payments past due. */
export type Risolto_Dunning_NoticeCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** A document used to remind a customer of payments past due. */
export type Risolto_Dunning_NoticeDunning_Notice_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


/** A document used to remind a customer of payments past due. */
export type Risolto_Dunning_NoticeDunning_Notice_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


/** A document used to remind a customer of payments past due. */
export type Risolto_Dunning_NoticePaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


/** A document used to remind a customer of payments past due. */
export type Risolto_Dunning_NoticePayments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};

/** aggregated selection of "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Aggregate = {
  __typename?: 'risolto_dunning_notice_aggregate';
  aggregate?: Maybe<Risolto_Dunning_Notice_Aggregate_Fields>;
  nodes: Array<Risolto_Dunning_Notice>;
};

export type Risolto_Dunning_Notice_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Dunning_Notice_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Dunning_Notice_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Aggregate_Fields = {
  __typename?: 'risolto_dunning_notice_aggregate_fields';
  avg?: Maybe<Risolto_Dunning_Notice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Dunning_Notice_Max_Fields>;
  min?: Maybe<Risolto_Dunning_Notice_Min_Fields>;
  stddev?: Maybe<Risolto_Dunning_Notice_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Dunning_Notice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Dunning_Notice_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Dunning_Notice_Sum_Fields>;
  var_pop?: Maybe<Risolto_Dunning_Notice_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Dunning_Notice_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Dunning_Notice_Variance_Fields>;
};


/** aggregate fields of "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Dunning_Notice_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Dunning_Notice_Max_Order_By>;
  min?: Maybe<Risolto_Dunning_Notice_Min_Order_By>;
  stddev?: Maybe<Risolto_Dunning_Notice_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Dunning_Notice_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Dunning_Notice_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Dunning_Notice_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Dunning_Notice_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Dunning_Notice_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Dunning_Notice_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Dunning_Notice_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Dunning_Notice_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Dunning_Notice_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Dunning_Notice_Avg_Fields = {
  __typename?: 'risolto_dunning_notice_avg_fields';
  charges?: Maybe<Scalars['Float']>;
  credit_amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['Float']>;
  /** null */
  interest?: Maybe<Scalars['Float']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Float']>;
  principal_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
};

/** order by avg() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Avg_Order_By = {
  charges?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.dunning_notice". All fields are combined with a logical 'AND'. */
export type Risolto_Dunning_Notice_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Dunning_Notice_Bool_Exp>>;
  _not?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Dunning_Notice_Bool_Exp>>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  amount_currency?: Maybe<Risolto_Currency_Enum_Comparison_Exp>;
  charges?: Maybe<Numeric_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  credit_amount?: Maybe<Numeric_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  damage_clause?: Maybe<Numeric_Comparison_Exp>;
  debit_amount?: Maybe<Numeric_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  dunning_notice_invoices?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
  dunning_notice_invoices_aggregate?: Maybe<Risolto_Dunning_Notice_Invoice_Aggregate_Bool_Exp>;
  interest?: Maybe<Numeric_Comparison_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  issue_date?: Maybe<Date_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  level?: Maybe<Int_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_link?: Maybe<Uuid_Comparison_Exp>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Bool_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  payments?: Maybe<Risolto_Payment_Bool_Exp>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Bool_Exp>;
  principal_amount?: Maybe<Numeric_Comparison_Exp>;
  processing_status?: Maybe<Risolto_Dunning_Notice_Status_Enum_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  total_amount_without_charges?: Maybe<Numeric_Comparison_Exp>;
  total_costs?: Maybe<Numeric_Comparison_Exp>;
  type_code?: Maybe<Risolto_Dunning_Notice_Type_Code_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.dunning_notice" */
export enum Risolto_Dunning_Notice_Constraint {
  /** unique or primary key constraint on columns "participant", "invoice_group", "type_code", "recipient" */
  DunningNoticeParticipantRecipientTypeCodeInvoiceGroupKe = 'dunning_notice_participant_recipient_type_code_invoice_group_ke',
  /** unique or primary key constraint on columns "reference" */
  DunningReminderPkey = 'dunning_reminder_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Dunning_Notice_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Dunning_Notice_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Dunning_Notice_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Inc_Input = {
  charges?: Maybe<Scalars['numeric']>;
  credit_amount?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['numeric']>;
  /** null */
  interest?: Maybe<Scalars['numeric']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Int']>;
  principal_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Insert_Input = {
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  charges?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_amount?: Maybe<Scalars['numeric']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debit_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action.due_date */
  due_date?: Maybe<Scalars['date']>;
  dunning_notice_invoices?: Maybe<Risolto_Dunning_Notice_Invoice_Arr_Rel_Insert_Input>;
  /** null */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  /** DEPRECATED. See action.start_time */
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Obj_Rel_Insert_Input>;
  payment_reference?: Maybe<Scalars['String']>;
  payments?: Maybe<Risolto_Payment_Arr_Rel_Insert_Input>;
  principal_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action status. DRAFT or SENT */
  processing_status?: Maybe<Risolto_Dunning_Notice_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  /** A code signifying the type of the Reminder. E.g. 'dunning_reminder', 'notice_of_default' */
  type_code?: Maybe<Risolto_Dunning_Notice_Type_Code_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** DEPRECATED */
export type Risolto_Dunning_Notice_Invoice = {
  __typename?: 'risolto_dunning_notice_invoice';
  /** null */
  dunning_notice: Scalars['uuid'];
  /** An object relationship */
  dunning_notice_by_reference: Risolto_Dunning_Notice;
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_document_by_reference: Risolto_Invoice_Document;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  /** Formal or Informal */
  relation: Risolto_Dunning_Notice_Invoice_Relation_Enum;
};

/** aggregated selection of "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Aggregate = {
  __typename?: 'risolto_dunning_notice_invoice_aggregate';
  aggregate?: Maybe<Risolto_Dunning_Notice_Invoice_Aggregate_Fields>;
  nodes: Array<Risolto_Dunning_Notice_Invoice>;
};

export type Risolto_Dunning_Notice_Invoice_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Dunning_Notice_Invoice_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Dunning_Notice_Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Aggregate_Fields = {
  __typename?: 'risolto_dunning_notice_invoice_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Dunning_Notice_Invoice_Max_Fields>;
  min?: Maybe<Risolto_Dunning_Notice_Invoice_Min_Fields>;
};


/** aggregate fields of "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Dunning_Notice_Invoice_Max_Order_By>;
  min?: Maybe<Risolto_Dunning_Notice_Invoice_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Dunning_Notice_Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Dunning_Notice_Invoice_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.dunning_notice_invoice". All fields are combined with a logical 'AND'. */
export type Risolto_Dunning_Notice_Invoice_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Bool_Exp>>;
  _not?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Bool_Exp>>;
  dunning_notice?: Maybe<Uuid_Comparison_Exp>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_document_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  relation?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.dunning_notice_invoice" */
export enum Risolto_Dunning_Notice_Invoice_Constraint {
  /** unique or primary key constraint on columns "participant", "dunning_notice", "invoice" */
  DunningReminderInvoiceParticipantDunningReminderInvoiKey = 'dunning_reminder_invoice_participant_dunning_reminder_invoi_key',
  /** unique or primary key constraint on columns "reference" */
  DunningReminderInvoicePkey = 'dunning_reminder_invoice_pkey'
}

/** input type for inserting data into table "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Insert_Input = {
  /** null */
  dunning_notice?: Maybe<Scalars['uuid']>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Obj_Rel_Insert_Input>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_document_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  /** Formal or Informal */
  relation?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Enum>;
};

/** aggregate max on columns */
export type Risolto_Dunning_Notice_Invoice_Max_Fields = {
  __typename?: 'risolto_dunning_notice_invoice_max_fields';
  /** null */
  dunning_notice?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Max_Order_By = {
  /** null */
  dunning_notice?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Dunning_Notice_Invoice_Min_Fields = {
  __typename?: 'risolto_dunning_notice_invoice_min_fields';
  /** null */
  dunning_notice?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Min_Order_By = {
  /** null */
  dunning_notice?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Mutation_Response = {
  __typename?: 'risolto_dunning_notice_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Dunning_Notice_Invoice>;
};

/** on_conflict condition type for table "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_On_Conflict = {
  constraint: Risolto_Dunning_Notice_Invoice_Constraint;
  update_columns?: Array<Risolto_Dunning_Notice_Invoice_Update_Column>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.dunning_notice_invoice". */
export type Risolto_Dunning_Notice_Invoice_Order_By = {
  dunning_notice?: Maybe<Order_By>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_document_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  relation?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.dunning_notice_invoice */
export type Risolto_Dunning_Notice_Invoice_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** columns and relationships of "risolto.dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation = {
  __typename?: 'risolto_dunning_notice_invoice_relation';
  relation: Scalars['String'];
};

/** aggregated selection of "risolto.dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation_Aggregate = {
  __typename?: 'risolto_dunning_notice_invoice_relation_aggregate';
  aggregate?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Aggregate_Fields>;
  nodes: Array<Risolto_Dunning_Notice_Invoice_Relation>;
};

/** aggregate fields of "risolto.dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation_Aggregate_Fields = {
  __typename?: 'risolto_dunning_notice_invoice_relation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Max_Fields>;
  min?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Min_Fields>;
};


/** aggregate fields of "risolto.dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.dunning_notice_invoice_relation". All fields are combined with a logical 'AND'. */
export type Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>>;
  _not?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>>;
  relation?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.dunning_notice_invoice_relation" */
export enum Risolto_Dunning_Notice_Invoice_Relation_Constraint {
  /** unique or primary key constraint on columns "relation" */
  DunningReminderInvoiceRelationPkey = 'dunning_reminder_invoice_relation_pkey'
}

export enum Risolto_Dunning_Notice_Invoice_Relation_Enum {
  Formal = 'FORMAL',
  Informal = 'INFORMAL'
}

/** Boolean expression to compare columns of type "risolto_dunning_notice_invoice_relation_enum". All fields are combined with logical 'AND'. */
export type Risolto_Dunning_Notice_Invoice_Relation_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Enum>;
  _in?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Enum>;
  _nin?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Enum>>;
};

/** input type for inserting data into table "risolto.dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation_Insert_Input = {
  relation?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Dunning_Notice_Invoice_Relation_Max_Fields = {
  __typename?: 'risolto_dunning_notice_invoice_relation_max_fields';
  relation?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Dunning_Notice_Invoice_Relation_Min_Fields = {
  __typename?: 'risolto_dunning_notice_invoice_relation_min_fields';
  relation?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation_Mutation_Response = {
  __typename?: 'risolto_dunning_notice_invoice_relation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Dunning_Notice_Invoice_Relation>;
};

/** on_conflict condition type for table "risolto.dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation_On_Conflict = {
  constraint: Risolto_Dunning_Notice_Invoice_Relation_Constraint;
  update_columns?: Array<Risolto_Dunning_Notice_Invoice_Relation_Update_Column>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.dunning_notice_invoice_relation". */
export type Risolto_Dunning_Notice_Invoice_Relation_Order_By = {
  relation?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.dunning_notice_invoice_relation */
export type Risolto_Dunning_Notice_Invoice_Relation_Pk_Columns_Input = {
  relation: Scalars['String'];
};

/** select columns of table "risolto.dunning_notice_invoice_relation" */
export enum Risolto_Dunning_Notice_Invoice_Relation_Select_Column {
  /** column name */
  Relation = 'relation'
}

/** input type for updating data in table "risolto.dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation_Set_Input = {
  relation?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_dunning_notice_invoice_relation" */
export type Risolto_Dunning_Notice_Invoice_Relation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Dunning_Notice_Invoice_Relation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Dunning_Notice_Invoice_Relation_Stream_Cursor_Value_Input = {
  relation?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.dunning_notice_invoice_relation" */
export enum Risolto_Dunning_Notice_Invoice_Relation_Update_Column {
  /** column name */
  Relation = 'relation'
}

export type Risolto_Dunning_Notice_Invoice_Relation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp;
};

/** select columns of table "risolto.dunning_notice_invoice" */
export enum Risolto_Dunning_Notice_Invoice_Select_Column {
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Relation = 'relation'
}

/** input type for updating data in table "risolto.dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Set_Input = {
  /** null */
  dunning_notice?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** Formal or Informal */
  relation?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Enum>;
};

/** Streaming cursor of the table "risolto_dunning_notice_invoice" */
export type Risolto_Dunning_Notice_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Dunning_Notice_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Dunning_Notice_Invoice_Stream_Cursor_Value_Input = {
  /** null */
  dunning_notice?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** Formal or Informal */
  relation?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Enum>;
};

/** update columns of table "risolto.dunning_notice_invoice" */
export enum Risolto_Dunning_Notice_Invoice_Update_Column {
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Relation = 'relation'
}

export type Risolto_Dunning_Notice_Invoice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Dunning_Notice_Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Dunning_Notice_Invoice_Bool_Exp;
};

/** aggregate max on columns */
export type Risolto_Dunning_Notice_Max_Fields = {
  __typename?: 'risolto_dunning_notice_max_fields';
  charges?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_amount?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action.due_date */
  due_date?: Maybe<Scalars['date']>;
  /** null */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. See action.start_time */
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  principal_amount?: Maybe<Scalars['numeric']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Max_Order_By = {
  charges?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** DEPRECATED. See action.due_date */
  due_date?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  /** DEPRECATED. See action.start_time */
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Dunning_Notice_Min_Fields = {
  __typename?: 'risolto_dunning_notice_min_fields';
  charges?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_amount?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action.due_date */
  due_date?: Maybe<Scalars['date']>;
  /** null */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. See action.start_time */
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  principal_amount?: Maybe<Scalars['numeric']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Min_Order_By = {
  charges?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** DEPRECATED. See action.due_date */
  due_date?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  /** DEPRECATED. See action.start_time */
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Mutation_Response = {
  __typename?: 'risolto_dunning_notice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Dunning_Notice>;
};

/** input type for inserting object relation for remote table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Obj_Rel_Insert_Input = {
  data: Risolto_Dunning_Notice_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Dunning_Notice_On_Conflict>;
};

/** on_conflict condition type for table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_On_Conflict = {
  constraint: Risolto_Dunning_Notice_Constraint;
  update_columns?: Array<Risolto_Dunning_Notice_Update_Column>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.dunning_notice". */
export type Risolto_Dunning_Notice_Order_By = {
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  amount_currency?: Maybe<Order_By>;
  charges?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  damage_clause?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  dunning_notice_invoices_aggregate?: Maybe<Risolto_Dunning_Notice_Invoice_Aggregate_Order_By>;
  interest?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  level?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Order_By>;
  payment_reference?: Maybe<Order_By>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Order_By>;
  principal_amount?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_amount_without_charges?: Maybe<Order_By>;
  total_costs?: Maybe<Order_By>;
  type_code?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.dunning_notice */
export type Risolto_Dunning_Notice_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Dunning_Notice_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.dunning_notice" */
export enum Risolto_Dunning_Notice_Select_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  Charges = 'charges',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditAmount = 'credit_amount',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DebitAmount = 'debit_amount',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Interest = 'interest',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Level = 'level',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentLink = 'payment_link',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  PrincipalAmount = 'principal_amount',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TypeCode = 'type_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Set_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  charges?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_amount?: Maybe<Scalars['numeric']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debit_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action.due_date */
  due_date?: Maybe<Scalars['date']>;
  /** null */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. See action.start_time */
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  principal_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action status. DRAFT or SENT */
  processing_status?: Maybe<Risolto_Dunning_Notice_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** A code signifying the type of the Reminder. E.g. 'dunning_reminder', 'notice_of_default' */
  type_code?: Maybe<Risolto_Dunning_Notice_Type_Code_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.dunning_notice_status" */
export type Risolto_Dunning_Notice_Status = {
  __typename?: 'risolto_dunning_notice_status';
  status: Scalars['String'];
};

/** aggregated selection of "risolto.dunning_notice_status" */
export type Risolto_Dunning_Notice_Status_Aggregate = {
  __typename?: 'risolto_dunning_notice_status_aggregate';
  aggregate?: Maybe<Risolto_Dunning_Notice_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Dunning_Notice_Status>;
};

/** aggregate fields of "risolto.dunning_notice_status" */
export type Risolto_Dunning_Notice_Status_Aggregate_Fields = {
  __typename?: 'risolto_dunning_notice_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Dunning_Notice_Status_Max_Fields>;
  min?: Maybe<Risolto_Dunning_Notice_Status_Min_Fields>;
};


/** aggregate fields of "risolto.dunning_notice_status" */
export type Risolto_Dunning_Notice_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Dunning_Notice_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.dunning_notice_status". All fields are combined with a logical 'AND'. */
export type Risolto_Dunning_Notice_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Dunning_Notice_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Dunning_Notice_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Dunning_Notice_Status_Bool_Exp>>;
  status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.dunning_notice_status" */
export enum Risolto_Dunning_Notice_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  DunningNoticeStatusPkey = 'dunning_notice_status_pkey'
}

export enum Risolto_Dunning_Notice_Status_Enum {
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Sent = 'SENT'
}

/** Boolean expression to compare columns of type "risolto_dunning_notice_status_enum". All fields are combined with logical 'AND'. */
export type Risolto_Dunning_Notice_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Dunning_Notice_Status_Enum>;
  _in?: Maybe<Array<Risolto_Dunning_Notice_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Dunning_Notice_Status_Enum>;
  _nin?: Maybe<Array<Risolto_Dunning_Notice_Status_Enum>>;
};

/** input type for inserting data into table "risolto.dunning_notice_status" */
export type Risolto_Dunning_Notice_Status_Insert_Input = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Dunning_Notice_Status_Max_Fields = {
  __typename?: 'risolto_dunning_notice_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Dunning_Notice_Status_Min_Fields = {
  __typename?: 'risolto_dunning_notice_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.dunning_notice_status" */
export type Risolto_Dunning_Notice_Status_Mutation_Response = {
  __typename?: 'risolto_dunning_notice_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Dunning_Notice_Status>;
};

/** on_conflict condition type for table "risolto.dunning_notice_status" */
export type Risolto_Dunning_Notice_Status_On_Conflict = {
  constraint: Risolto_Dunning_Notice_Status_Constraint;
  update_columns?: Array<Risolto_Dunning_Notice_Status_Update_Column>;
  where?: Maybe<Risolto_Dunning_Notice_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.dunning_notice_status". */
export type Risolto_Dunning_Notice_Status_Order_By = {
  status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.dunning_notice_status */
export type Risolto_Dunning_Notice_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "risolto.dunning_notice_status" */
export enum Risolto_Dunning_Notice_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "risolto.dunning_notice_status" */
export type Risolto_Dunning_Notice_Status_Set_Input = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_dunning_notice_status" */
export type Risolto_Dunning_Notice_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Dunning_Notice_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Dunning_Notice_Status_Stream_Cursor_Value_Input = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.dunning_notice_status" */
export enum Risolto_Dunning_Notice_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Risolto_Dunning_Notice_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Dunning_Notice_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Dunning_Notice_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Risolto_Dunning_Notice_Stddev_Fields = {
  __typename?: 'risolto_dunning_notice_stddev_fields';
  charges?: Maybe<Scalars['Float']>;
  credit_amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['Float']>;
  /** null */
  interest?: Maybe<Scalars['Float']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Float']>;
  principal_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Stddev_Order_By = {
  charges?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Dunning_Notice_Stddev_Pop_Fields = {
  __typename?: 'risolto_dunning_notice_stddev_pop_fields';
  charges?: Maybe<Scalars['Float']>;
  credit_amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['Float']>;
  /** null */
  interest?: Maybe<Scalars['Float']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Float']>;
  principal_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
};

/** order by stddev_pop() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Stddev_Pop_Order_By = {
  charges?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Dunning_Notice_Stddev_Samp_Fields = {
  __typename?: 'risolto_dunning_notice_stddev_samp_fields';
  charges?: Maybe<Scalars['Float']>;
  credit_amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['Float']>;
  /** null */
  interest?: Maybe<Scalars['Float']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Float']>;
  principal_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
};

/** order by stddev_samp() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Stddev_Samp_Order_By = {
  charges?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_dunning_notice" */
export type Risolto_Dunning_Notice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Dunning_Notice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Dunning_Notice_Stream_Cursor_Value_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  charges?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_amount?: Maybe<Scalars['numeric']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  debit_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action.due_date */
  due_date?: Maybe<Scalars['date']>;
  /** null */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. See action.start_time */
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  principal_amount?: Maybe<Scalars['numeric']>;
  /** DEPRECATED. See action status. DRAFT or SENT */
  processing_status?: Maybe<Risolto_Dunning_Notice_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** A code signifying the type of the Reminder. E.g. 'dunning_reminder', 'notice_of_default' */
  type_code?: Maybe<Risolto_Dunning_Notice_Type_Code_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Dunning_Notice_Sum_Fields = {
  __typename?: 'risolto_dunning_notice_sum_fields';
  charges?: Maybe<Scalars['numeric']>;
  credit_amount?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['numeric']>;
  /** null */
  interest?: Maybe<Scalars['numeric']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Int']>;
  principal_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Sum_Order_By = {
  charges?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code = {
  __typename?: 'risolto_dunning_notice_type_code';
  type_code: Scalars['String'];
};

/** aggregated selection of "risolto.dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code_Aggregate = {
  __typename?: 'risolto_dunning_notice_type_code_aggregate';
  aggregate?: Maybe<Risolto_Dunning_Notice_Type_Code_Aggregate_Fields>;
  nodes: Array<Risolto_Dunning_Notice_Type_Code>;
};

/** aggregate fields of "risolto.dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code_Aggregate_Fields = {
  __typename?: 'risolto_dunning_notice_type_code_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Dunning_Notice_Type_Code_Max_Fields>;
  min?: Maybe<Risolto_Dunning_Notice_Type_Code_Min_Fields>;
};


/** aggregate fields of "risolto.dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.dunning_notice_type_code". All fields are combined with a logical 'AND'. */
export type Risolto_Dunning_Notice_Type_Code_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Bool_Exp>>;
  _not?: Maybe<Risolto_Dunning_Notice_Type_Code_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Bool_Exp>>;
  type_code?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.dunning_notice_type_code" */
export enum Risolto_Dunning_Notice_Type_Code_Constraint {
  /** unique or primary key constraint on columns "type_code" */
  DunningReminderTypeCodePkey = 'dunning_reminder_type_code_pkey'
}

export enum Risolto_Dunning_Notice_Type_Code_Enum {
  DunningReminder = 'DUNNING_REMINDER',
  NoticeOfDefault = 'NOTICE_OF_DEFAULT',
  '1000Collection' = '_1000_COLLECTION',
  '100Reminder' = '_100_REMINDER',
  '200DunningReminder' = '_200_DUNNING_REMINDER',
  '300NoticeOfDefault' = '_300_NOTICE_OF_DEFAULT',
  '900PreCollection' = '_900_PRE_COLLECTION'
}

/** Boolean expression to compare columns of type "risolto_dunning_notice_type_code_enum". All fields are combined with logical 'AND'. */
export type Risolto_Dunning_Notice_Type_Code_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Dunning_Notice_Type_Code_Enum>;
  _in?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Dunning_Notice_Type_Code_Enum>;
  _nin?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Enum>>;
};

/** input type for inserting data into table "risolto.dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code_Insert_Input = {
  type_code?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Dunning_Notice_Type_Code_Max_Fields = {
  __typename?: 'risolto_dunning_notice_type_code_max_fields';
  type_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Dunning_Notice_Type_Code_Min_Fields = {
  __typename?: 'risolto_dunning_notice_type_code_min_fields';
  type_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code_Mutation_Response = {
  __typename?: 'risolto_dunning_notice_type_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Dunning_Notice_Type_Code>;
};

/** on_conflict condition type for table "risolto.dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code_On_Conflict = {
  constraint: Risolto_Dunning_Notice_Type_Code_Constraint;
  update_columns?: Array<Risolto_Dunning_Notice_Type_Code_Update_Column>;
  where?: Maybe<Risolto_Dunning_Notice_Type_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.dunning_notice_type_code". */
export type Risolto_Dunning_Notice_Type_Code_Order_By = {
  type_code?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.dunning_notice_type_code */
export type Risolto_Dunning_Notice_Type_Code_Pk_Columns_Input = {
  type_code: Scalars['String'];
};

/** select columns of table "risolto.dunning_notice_type_code" */
export enum Risolto_Dunning_Notice_Type_Code_Select_Column {
  /** column name */
  TypeCode = 'type_code'
}

/** input type for updating data in table "risolto.dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code_Set_Input = {
  type_code?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_dunning_notice_type_code" */
export type Risolto_Dunning_Notice_Type_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Dunning_Notice_Type_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Dunning_Notice_Type_Code_Stream_Cursor_Value_Input = {
  type_code?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.dunning_notice_type_code" */
export enum Risolto_Dunning_Notice_Type_Code_Update_Column {
  /** column name */
  TypeCode = 'type_code'
}

export type Risolto_Dunning_Notice_Type_Code_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Dunning_Notice_Type_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Dunning_Notice_Type_Code_Bool_Exp;
};

/** update columns of table "risolto.dunning_notice" */
export enum Risolto_Dunning_Notice_Update_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  Charges = 'charges',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditAmount = 'credit_amount',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DebitAmount = 'debit_amount',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Interest = 'interest',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Level = 'level',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentLink = 'payment_link',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  PrincipalAmount = 'principal_amount',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TypeCode = 'type_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Dunning_Notice_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Dunning_Notice_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Dunning_Notice_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Dunning_Notice_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Dunning_Notice_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Dunning_Notice_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Dunning_Notice_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Dunning_Notice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Dunning_Notice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Dunning_Notice_Var_Pop_Fields = {
  __typename?: 'risolto_dunning_notice_var_pop_fields';
  charges?: Maybe<Scalars['Float']>;
  credit_amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['Float']>;
  /** null */
  interest?: Maybe<Scalars['Float']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Float']>;
  principal_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
};

/** order by var_pop() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Var_Pop_Order_By = {
  charges?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Dunning_Notice_Var_Samp_Fields = {
  __typename?: 'risolto_dunning_notice_var_samp_fields';
  charges?: Maybe<Scalars['Float']>;
  credit_amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['Float']>;
  /** null */
  interest?: Maybe<Scalars['Float']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Float']>;
  principal_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
};

/** order by var_samp() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Var_Samp_Order_By = {
  charges?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Dunning_Notice_Variance_Fields = {
  __typename?: 'risolto_dunning_notice_variance_fields';
  charges?: Maybe<Scalars['Float']>;
  credit_amount?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "risolto.dunning_notice_damage_clause" */
  damage_clause?: Maybe<Scalars['numeric']>;
  debit_amount?: Maybe<Scalars['Float']>;
  /** null */
  interest?: Maybe<Scalars['Float']>;
  /** DEPRECATED */
  level?: Maybe<Scalars['Float']>;
  principal_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_without_charges?: Maybe<Scalars['numeric']>;
  total_costs?: Maybe<Scalars['numeric']>;
};

/** order by variance() on columns of table "risolto.dunning_notice" */
export type Risolto_Dunning_Notice_Variance_Order_By = {
  charges?: Maybe<Order_By>;
  credit_amount?: Maybe<Order_By>;
  debit_amount?: Maybe<Order_By>;
  /** null */
  interest?: Maybe<Order_By>;
  /** DEPRECATED */
  level?: Maybe<Order_By>;
  principal_amount?: Maybe<Order_By>;
};

export type Risolto_Fe_Recipient_Accounting_Document_Args = {
  p_legal_entity?: Maybe<Scalars['uuid']>;
  p_participant?: Maybe<Scalars['uuid']>;
  p_recipient?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "risolto.frequency" */
export type Risolto_Frequency = {
  __typename?: 'risolto_frequency';
  frequency: Scalars['String'];
};

/** aggregated selection of "risolto.frequency" */
export type Risolto_Frequency_Aggregate = {
  __typename?: 'risolto_frequency_aggregate';
  aggregate?: Maybe<Risolto_Frequency_Aggregate_Fields>;
  nodes: Array<Risolto_Frequency>;
};

/** aggregate fields of "risolto.frequency" */
export type Risolto_Frequency_Aggregate_Fields = {
  __typename?: 'risolto_frequency_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Frequency_Max_Fields>;
  min?: Maybe<Risolto_Frequency_Min_Fields>;
};


/** aggregate fields of "risolto.frequency" */
export type Risolto_Frequency_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Frequency_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.frequency". All fields are combined with a logical 'AND'. */
export type Risolto_Frequency_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Frequency_Bool_Exp>>;
  _not?: Maybe<Risolto_Frequency_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Frequency_Bool_Exp>>;
  frequency?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.frequency" */
export enum Risolto_Frequency_Constraint {
  /** unique or primary key constraint on columns "frequency" */
  FrequencyPkey = 'frequency_pkey'
}

export enum Risolto_Frequency_Enum {
  Daily = 'DAILY',
  Expression = 'EXPRESSION',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

/** Boolean expression to compare columns of type "risolto_frequency_enum". All fields are combined with logical 'AND'. */
export type Risolto_Frequency_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Frequency_Enum>;
  _in?: Maybe<Array<Risolto_Frequency_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Frequency_Enum>;
  _nin?: Maybe<Array<Risolto_Frequency_Enum>>;
};

/** input type for inserting data into table "risolto.frequency" */
export type Risolto_Frequency_Insert_Input = {
  frequency?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Frequency_Max_Fields = {
  __typename?: 'risolto_frequency_max_fields';
  frequency?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Frequency_Min_Fields = {
  __typename?: 'risolto_frequency_min_fields';
  frequency?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.frequency" */
export type Risolto_Frequency_Mutation_Response = {
  __typename?: 'risolto_frequency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Frequency>;
};

/** on_conflict condition type for table "risolto.frequency" */
export type Risolto_Frequency_On_Conflict = {
  constraint: Risolto_Frequency_Constraint;
  update_columns?: Array<Risolto_Frequency_Update_Column>;
  where?: Maybe<Risolto_Frequency_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.frequency". */
export type Risolto_Frequency_Order_By = {
  frequency?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.frequency */
export type Risolto_Frequency_Pk_Columns_Input = {
  frequency: Scalars['String'];
};

/** select columns of table "risolto.frequency" */
export enum Risolto_Frequency_Select_Column {
  /** column name */
  Frequency = 'frequency'
}

/** input type for updating data in table "risolto.frequency" */
export type Risolto_Frequency_Set_Input = {
  frequency?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_frequency" */
export type Risolto_Frequency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Frequency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Frequency_Stream_Cursor_Value_Input = {
  frequency?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.frequency" */
export enum Risolto_Frequency_Update_Column {
  /** column name */
  Frequency = 'frequency'
}

export type Risolto_Frequency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Frequency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Frequency_Bool_Exp;
};

/** ALLOW | DENY */
export type Risolto_Grant_Type = {
  __typename?: 'risolto_grant_type';
  grant_type: Scalars['String'];
};

/** aggregated selection of "risolto.grant_type" */
export type Risolto_Grant_Type_Aggregate = {
  __typename?: 'risolto_grant_type_aggregate';
  aggregate?: Maybe<Risolto_Grant_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Grant_Type>;
};

/** aggregate fields of "risolto.grant_type" */
export type Risolto_Grant_Type_Aggregate_Fields = {
  __typename?: 'risolto_grant_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Grant_Type_Max_Fields>;
  min?: Maybe<Risolto_Grant_Type_Min_Fields>;
};


/** aggregate fields of "risolto.grant_type" */
export type Risolto_Grant_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Grant_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.grant_type". All fields are combined with a logical 'AND'. */
export type Risolto_Grant_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Grant_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Grant_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Grant_Type_Bool_Exp>>;
  grant_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.grant_type" */
export enum Risolto_Grant_Type_Constraint {
  /** unique or primary key constraint on columns "grant_type" */
  GrantTypePkey = 'grant_type_pkey'
}

export enum Risolto_Grant_Type_Enum {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

/** Boolean expression to compare columns of type "risolto_grant_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Grant_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Grant_Type_Enum>;
  _in?: Maybe<Array<Risolto_Grant_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Grant_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Grant_Type_Enum>>;
};

/** input type for inserting data into table "risolto.grant_type" */
export type Risolto_Grant_Type_Insert_Input = {
  grant_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Grant_Type_Max_Fields = {
  __typename?: 'risolto_grant_type_max_fields';
  grant_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Grant_Type_Min_Fields = {
  __typename?: 'risolto_grant_type_min_fields';
  grant_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.grant_type" */
export type Risolto_Grant_Type_Mutation_Response = {
  __typename?: 'risolto_grant_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Grant_Type>;
};

/** on_conflict condition type for table "risolto.grant_type" */
export type Risolto_Grant_Type_On_Conflict = {
  constraint: Risolto_Grant_Type_Constraint;
  update_columns?: Array<Risolto_Grant_Type_Update_Column>;
  where?: Maybe<Risolto_Grant_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.grant_type". */
export type Risolto_Grant_Type_Order_By = {
  grant_type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.grant_type */
export type Risolto_Grant_Type_Pk_Columns_Input = {
  grant_type: Scalars['String'];
};

/** select columns of table "risolto.grant_type" */
export enum Risolto_Grant_Type_Select_Column {
  /** column name */
  GrantType = 'grant_type'
}

/** input type for updating data in table "risolto.grant_type" */
export type Risolto_Grant_Type_Set_Input = {
  grant_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_grant_type" */
export type Risolto_Grant_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Grant_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Grant_Type_Stream_Cursor_Value_Input = {
  grant_type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.grant_type" */
export enum Risolto_Grant_Type_Update_Column {
  /** column name */
  GrantType = 'grant_type'
}

export type Risolto_Grant_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Grant_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Grant_Type_Bool_Exp;
};

export type Risolto_Hohr_Cvt_List_Data_Args = {
  p_legal_entity?: Maybe<Scalars['uuid']>;
  p_participant?: Maybe<Scalars['uuid']>;
  p_recipient?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "risolto.invoice_collection" */
export type Risolto_Invoice_Collection = {
  __typename?: 'risolto_invoice_collection';
  created_at: Scalars['timestamptz'];
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.invoice_collection" */
export type Risolto_Invoice_Collection_Aggregate = {
  __typename?: 'risolto_invoice_collection_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Collection_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Collection>;
};

/** aggregate fields of "risolto.invoice_collection" */
export type Risolto_Invoice_Collection_Aggregate_Fields = {
  __typename?: 'risolto_invoice_collection_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Collection_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Collection_Min_Fields>;
};


/** aggregate fields of "risolto.invoice_collection" */
export type Risolto_Invoice_Collection_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Collection_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_collection". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Collection_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Collection_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Collection_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Collection_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_collection" */
export enum Risolto_Invoice_Collection_Constraint {
  /** unique or primary key constraint on columns "reference" */
  InvoiceCollectionPkey = 'invoice_collection_pkey'
}

/** input type for inserting data into table "risolto.invoice_collection" */
export type Risolto_Invoice_Collection_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Collection_Max_Fields = {
  __typename?: 'risolto_invoice_collection_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Collection_Min_Fields = {
  __typename?: 'risolto_invoice_collection_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.invoice_collection" */
export type Risolto_Invoice_Collection_Mutation_Response = {
  __typename?: 'risolto_invoice_collection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Collection>;
};

/** on_conflict condition type for table "risolto.invoice_collection" */
export type Risolto_Invoice_Collection_On_Conflict = {
  constraint: Risolto_Invoice_Collection_Constraint;
  update_columns?: Array<Risolto_Invoice_Collection_Update_Column>;
  where?: Maybe<Risolto_Invoice_Collection_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_collection". */
export type Risolto_Invoice_Collection_Order_By = {
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_collection */
export type Risolto_Invoice_Collection_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.invoice_collection" */
export enum Risolto_Invoice_Collection_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.invoice_collection" */
export type Risolto_Invoice_Collection_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_invoice_collection" */
export type Risolto_Invoice_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Collection_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.invoice_collection" */
export enum Risolto_Invoice_Collection_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Collection_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Collection_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Collection_Bool_Exp;
};

/** columns and relationships of "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute = {
  __typename?: 'risolto_invoice_dispute';
  auto_resolved?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  dispute_code: Scalars['uuid'];
  /** An object relationship */
  dispute_code_by_reference: Risolto_Dispute_Code;
  from: Scalars['date'];
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  resolved_at?: Maybe<Scalars['timestamptz']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  resolved_by_by_reference?: Maybe<Risolto_Person>;
  /** An array relationship */
  tasks: Array<Risolto_Task>;
  /** An aggregate relationship */
  tasks_aggregate: Risolto_Task_Aggregate;
  until?: Maybe<Scalars['date']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.invoice_dispute" */
export type Risolto_Invoice_DisputeTasksArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Order_By>>;
  where?: Maybe<Risolto_Task_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_dispute" */
export type Risolto_Invoice_DisputeTasks_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Order_By>>;
  where?: Maybe<Risolto_Task_Bool_Exp>;
};

/** aggregated selection of "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Aggregate = {
  __typename?: 'risolto_invoice_dispute_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Dispute_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Dispute>;
};

export type Risolto_Invoice_Dispute_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Invoice_Dispute_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Dispute_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Aggregate_Fields = {
  __typename?: 'risolto_invoice_dispute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Dispute_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Dispute_Min_Fields>;
};


/** aggregate fields of "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Dispute_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Dispute_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Dispute_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Dispute_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_dispute". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Dispute_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Dispute_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Dispute_Bool_Exp>>;
  auto_resolved?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  dispute_code?: Maybe<Uuid_Comparison_Exp>;
  dispute_code_by_reference?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
  from?: Maybe<Date_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  resolved_at?: Maybe<Timestamptz_Comparison_Exp>;
  resolved_by?: Maybe<Uuid_Comparison_Exp>;
  resolved_by_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  tasks?: Maybe<Risolto_Task_Bool_Exp>;
  tasks_aggregate?: Maybe<Risolto_Task_Aggregate_Bool_Exp>;
  until?: Maybe<Date_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_dispute" */
export enum Risolto_Invoice_Dispute_Constraint {
  /** unique or primary key constraint on columns "reference" */
  InvoiceDisputePkey = 'invoice_dispute_pkey'
}

/** input type for inserting data into table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  dispute_code?: Maybe<Scalars['uuid']>;
  dispute_code_by_reference?: Maybe<Risolto_Dispute_Code_Obj_Rel_Insert_Input>;
  from?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  resolved_at?: Maybe<Scalars['timestamptz']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  resolved_by_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  tasks?: Maybe<Risolto_Task_Arr_Rel_Insert_Input>;
  until?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Dispute_Max_Fields = {
  __typename?: 'risolto_invoice_dispute_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dispute_code?: Maybe<Scalars['uuid']>;
  from?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  resolved_at?: Maybe<Scalars['timestamptz']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  dispute_code?: Maybe<Order_By>;
  from?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  resolved_at?: Maybe<Order_By>;
  resolved_by?: Maybe<Order_By>;
  until?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Dispute_Min_Fields = {
  __typename?: 'risolto_invoice_dispute_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dispute_code?: Maybe<Scalars['uuid']>;
  from?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  resolved_at?: Maybe<Scalars['timestamptz']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  dispute_code?: Maybe<Order_By>;
  from?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  resolved_at?: Maybe<Order_By>;
  resolved_by?: Maybe<Order_By>;
  until?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Mutation_Response = {
  __typename?: 'risolto_invoice_dispute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Dispute>;
};

/** input type for inserting object relation for remote table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Obj_Rel_Insert_Input = {
  data: Risolto_Invoice_Dispute_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Dispute_On_Conflict>;
};

/** on_conflict condition type for table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_On_Conflict = {
  constraint: Risolto_Invoice_Dispute_Constraint;
  update_columns?: Array<Risolto_Invoice_Dispute_Update_Column>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_dispute". */
export type Risolto_Invoice_Dispute_Order_By = {
  auto_resolved?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  dispute_code?: Maybe<Order_By>;
  dispute_code_by_reference?: Maybe<Risolto_Dispute_Code_Order_By>;
  from?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  resolved_at?: Maybe<Order_By>;
  resolved_by?: Maybe<Order_By>;
  resolved_by_by_reference?: Maybe<Risolto_Person_Order_By>;
  tasks_aggregate?: Maybe<Risolto_Task_Aggregate_Order_By>;
  until?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_dispute */
export type Risolto_Invoice_Dispute_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.invoice_dispute" */
export enum Risolto_Invoice_Dispute_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisputeCode = 'dispute_code',
  /** column name */
  From = 'from',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedBy = 'resolved_by',
  /** column name */
  Until = 'until',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.invoice_dispute" */
export type Risolto_Invoice_Dispute_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  dispute_code?: Maybe<Scalars['uuid']>;
  from?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  resolved_at?: Maybe<Scalars['timestamptz']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_invoice_dispute" */
export type Risolto_Invoice_Dispute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Dispute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Dispute_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  dispute_code?: Maybe<Scalars['uuid']>;
  from?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  resolved_at?: Maybe<Scalars['timestamptz']>;
  resolved_by?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.invoice_dispute" */
export enum Risolto_Invoice_Dispute_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisputeCode = 'dispute_code',
  /** column name */
  From = 'from',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResolvedBy = 'resolved_by',
  /** column name */
  Until = 'until',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Dispute_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Dispute_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Dispute_Bool_Exp;
};

/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_Document = {
  __typename?: 'risolto_invoice_document';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id: Scalars['String'];
  /** An array relationship */
  action_invoices: Array<Risolto_Action_Invoice>;
  /** An aggregate relationship */
  action_invoices_aggregate: Risolto_Action_Invoice_Aggregate;
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  /** The currency of the amounts. */
  amount_currency: Scalars['String'];
  /** An object relationship */
  analytics_invoice_features?: Maybe<Risolto_Analytics_Invoice_Features>;
  /** Aggregate the invoice file_references and attachments */
  attachments?: Maybe<Scalars['jsonb']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields: Scalars['jsonb'];
  custom_status?: Maybe<Scalars['String']>;
  derived_paid_at?: Maybe<Scalars['timestamptz']>;
  derived_payment_information?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information>>;
  /** An array relationship */
  disputes: Array<Risolto_Invoice_Dispute>;
  /** An aggregate relationship */
  disputes_aggregate: Risolto_Invoice_Dispute_Aggregate;
  /** Same as invoice_number but using a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** INVOICE */
  document_type?: Maybe<Scalars['String']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The date on which Invoice is due. */
  due_date: Scalars['date'];
  /** A computed field, executes function "risolto.invoice_dunning_level" */
  dunning_level?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  dunning_notices: Array<Risolto_Dunning_Notice_Invoice>;
  /** An aggregate relationship */
  dunning_notices_aggregate: Risolto_Dunning_Notice_Invoice_Aggregate;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Scalars['jsonb']>;
  /** DEPRECTAED. True when the invoice is being tracked in the dunning process */
  dunning_started: Scalars['Boolean'];
  /** A computed field, executes function "risolto.invoice_dunning_status" */
  dunning_status?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  earliest_dunning_time?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  earliest_submission_time: Scalars['timestamptz'];
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Scalars['jsonb']>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references: Scalars['jsonb'];
  has_inbound_communication?: Maybe<Scalars['Boolean']>;
  in_collection?: Maybe<Scalars['Boolean']>;
  in_dispute?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  interchange_links: Array<Risolto_Document_Interchange_Link>;
  /** An aggregate relationship */
  interchange_links_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  /** An array relationship */
  invoice_attachments: Array<Risolto_Invoice_Document_Attachment>;
  /** An aggregate relationship */
  invoice_attachments_aggregate: Risolto_Invoice_Document_Attachment_Aggregate;
  /** An object relationship */
  invoice_document_status: Risolto_Invoice_Document_Status;
  /** An array relationship */
  invoice_group_invoices: Array<Risolto_Invoice_Group_Invoice>;
  /** An aggregate relationship */
  invoice_group_invoices_aggregate: Risolto_Invoice_Group_Invoice_Aggregate;
  /** An identifier for this document, assigned by the sender. */
  invoice_number: Scalars['String'];
  /** An array relationship */
  invoice_predictions: Array<Risolto_Analytics_Invoice_Prediction>;
  /** An aggregate relationship */
  invoice_predictions_aggregate: Risolto_Analytics_Invoice_Prediction_Aggregate;
  /** A computed field, executes function "risolto.invoice_document_is_first" */
  is_first?: Maybe<Scalars['Boolean']>;
  /** True if open_amount > 0.00 false otherwise */
  is_open?: Maybe<Scalars['Boolean']>;
  /** The date, assigned by the sender, on which this document was issued. */
  issue_date: Scalars['date'];
  last_action?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_code?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_datetime?: Maybe<Scalars['timestamptz']>;
  /** Last damage clause amount, interest and total_amount for the invoice */
  last_damage_clause?: Maybe<Scalars['jsonb']>;
  last_dunning_actions?: Maybe<Array<Risolto_Virtual_Dunning_Action>>;
  last_dunning_notice?: Maybe<Scalars['String']>;
  last_inbound_communication_at?: Maybe<Scalars['timestamptz']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  /** An array relationship */
  notes: Array<Risolto_Note>;
  /** An aggregate relationship */
  notes_aggregate: Risolto_Note_Aggregate;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount: Scalars['numeric'];
  /** An array relationship */
  open_balance_records: Array<Risolto_Open_Balance_Record>;
  /** An aggregate relationship */
  open_balance_records_aggregate: Risolto_Open_Balance_Record_Aggregate;
  origin: Risolto_Origin_Enum;
  paid_at?: Maybe<Scalars['date']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_link?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_link_by_reference?: Maybe<Risolto_Payment_Link>;
  /** An array relationship */
  payment_promises: Array<Risolto_Payment_Promise>;
  /** An aggregate relationship */
  payment_promises_aggregate: Risolto_Payment_Promise_Aggregate;
  payment_reference?: Maybe<Scalars['String']>;
  /** An array relationship */
  payments: Array<Risolto_Payment>;
  /** An aggregate relationship */
  payments_aggregate: Risolto_Payment_Aggregate;
  /** DEPRECATED */
  phase?: Maybe<Scalars['String']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  processing_due_date?: Maybe<Scalars['date']>;
  /** The raw input record (e.g. a CSV line) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference: Scalars['uuid'];
  /** A computed field, executes function "risolto.invoice_short_code" */
  short_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  statement_line_invoices: Array<Risolto_Statement_Line_Invoice>;
  /** An aggregate relationship */
  statement_line_invoices_aggregate: Risolto_Statement_Line_Invoice_Aggregate;
  status: Risolto_Invoice_Document_Status_Enum;
  /** True when the invoice has been submitted */
  submitted: Scalars['Boolean'];
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount: Scalars['numeric'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentAction_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Invoice_Order_By>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentAction_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Invoice_Order_By>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentAttachmentsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentDerived_Payment_InformationArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentDisputesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentDisputes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentDunning_LevelArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentDunning_NoticesArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentDunning_Notices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentDunning_Process_MetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentDunning_StatusArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentFile_ReferenceArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentFile_ReferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentInterchange_LinksArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentInterchange_Links_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentInvoice_AttachmentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Attachment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentInvoice_Attachments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Attachment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentInvoice_Group_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentInvoice_Group_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentInvoice_PredictionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentInvoice_Predictions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentLast_Damage_ClauseArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentLast_Dunning_ActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentNotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentNotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentOpen_Balance_RecordsArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentOpen_Balance_Records_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentPayment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentPayment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentPaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentPayments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentStatement_Line_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Invoice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_document" */
export type Risolto_Invoice_DocumentStatement_Line_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Invoice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};

/** aggregated selection of "risolto.invoice_document" */
export type Risolto_Invoice_Document_Aggregate = {
  __typename?: 'risolto_invoice_document_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Document_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Document>;
};

export type Risolto_Invoice_Document_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Invoice_Document_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Invoice_Document_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Invoice_Document_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Invoice_Document_Select_Column_Risolto_Invoice_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Invoice_Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Invoice_Document_Select_Column_Risolto_Invoice_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Invoice_Document_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_document" */
export type Risolto_Invoice_Document_Aggregate_Fields = {
  __typename?: 'risolto_invoice_document_aggregate_fields';
  avg?: Maybe<Risolto_Invoice_Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Document_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Document_Min_Fields>;
  stddev?: Maybe<Risolto_Invoice_Document_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Invoice_Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Invoice_Document_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Invoice_Document_Sum_Fields>;
  var_pop?: Maybe<Risolto_Invoice_Document_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Invoice_Document_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Invoice_Document_Variance_Fields>;
};


/** aggregate fields of "risolto.invoice_document" */
export type Risolto_Invoice_Document_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Invoice_Document_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Document_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Document_Min_Order_By>;
  stddev?: Maybe<Risolto_Invoice_Document_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Invoice_Document_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Invoice_Document_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Invoice_Document_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Invoice_Document_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Invoice_Document_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Invoice_Document_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Invoice_Document_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Scalars['jsonb']>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Document_On_Conflict>;
};

/** columns and relationships of "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment = {
  __typename?: 'risolto_invoice_document_attachment';
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type: Risolto_Document_Attachment_Type_Enum;
  created_at: Scalars['timestamptz'];
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_AttachmentMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Aggregate = {
  __typename?: 'risolto_invoice_document_attachment_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Document_Attachment_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Document_Attachment>;
};

export type Risolto_Invoice_Document_Attachment_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Invoice_Document_Attachment_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Document_Attachment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Document_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Aggregate_Fields = {
  __typename?: 'risolto_invoice_document_attachment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Document_Attachment_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Document_Attachment_Min_Fields>;
};


/** aggregate fields of "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Document_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Document_Attachment_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Document_Attachment_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Invoice_Document_Attachment_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Document_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Document_Attachment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_document_attachment". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Document_Attachment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Document_Attachment_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Document_Attachment_Bool_Exp>>;
  attachment?: Maybe<Uuid_Comparison_Exp>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_document_attachment" */
export enum Risolto_Invoice_Document_Attachment_Constraint {
  /** unique or primary key constraint on columns "participant", "invoice", "name" */
  InvoiceDocumentAttachmentParticipantInvoiceNameKey = 'invoice_document_attachment_participant_invoice_name_key',
  /** unique or primary key constraint on columns "participant", "invoice", "legal_entity", "name" */
  InvoiceDocumentAttachmentParticipantLegalEntityInvoiceNa = 'invoice_document_attachment_participant_legal_entity_invoice_na',
  /** unique or primary key constraint on columns "reference" */
  InvoiceDocumentAttachmentPkey = 'invoice_document_attachment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Invoice_Document_Attachment_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Invoice_Document_Attachment_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Invoice_Document_Attachment_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Insert_Input = {
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Document_Attachment_Max_Fields = {
  __typename?: 'risolto_invoice_document_attachment_max_fields';
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Max_Order_By = {
  /** DEPRECATED */
  attachment?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Document_Attachment_Min_Fields = {
  __typename?: 'risolto_invoice_document_attachment_min_fields';
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Min_Order_By = {
  /** DEPRECATED */
  attachment?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Mutation_Response = {
  __typename?: 'risolto_invoice_document_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Document_Attachment>;
};

/** on_conflict condition type for table "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_On_Conflict = {
  constraint: Risolto_Invoice_Document_Attachment_Constraint;
  update_columns?: Array<Risolto_Invoice_Document_Attachment_Update_Column>;
  where?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_document_attachment". */
export type Risolto_Invoice_Document_Attachment_Order_By = {
  attachment?: Maybe<Order_By>;
  attachment_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  metadata?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_document_attachment */
export type Risolto_Invoice_Document_Attachment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Invoice_Document_Attachment_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.invoice_document_attachment" */
export enum Risolto_Invoice_Document_Attachment_Select_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  AttachmentType = 'attachment_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Set_Input = {
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_invoice_document_attachment" */
export type Risolto_Invoice_Document_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Document_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Document_Attachment_Stream_Cursor_Value_Input = {
  /** DEPRECATED */
  attachment?: Maybe<Scalars['uuid']>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.invoice_document_attachment" */
export enum Risolto_Invoice_Document_Attachment_Update_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  AttachmentType = 'attachment_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Document_Attachment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Invoice_Document_Attachment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Invoice_Document_Attachment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Invoice_Document_Attachment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Invoice_Document_Attachment_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Invoice_Document_Attachment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Document_Attachment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Document_Attachment_Bool_Exp;
};

/** aggregate avg on columns */
export type Risolto_Invoice_Document_Avg_Fields = {
  __typename?: 'risolto_invoice_document_avg_fields';
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['Float']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Avg_Order_By = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_document". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Document_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Document_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Document_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  action_invoices?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
  action_invoices_aggregate?: Maybe<Risolto_Action_Invoice_Aggregate_Bool_Exp>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  active_payment_plan?: Maybe<Uuid_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  analytics_invoice_features?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
  attachments?: Maybe<Jsonb_Comparison_Exp>;
  category?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  custom_status?: Maybe<String_Comparison_Exp>;
  derived_paid_at?: Maybe<Timestamptz_Comparison_Exp>;
  derived_payment_information?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
  disputes?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
  disputes_aggregate?: Maybe<Risolto_Invoice_Dispute_Aggregate_Bool_Exp>;
  document_number?: Maybe<String_Comparison_Exp>;
  document_open_amount?: Maybe<Numeric_Comparison_Exp>;
  document_total_amount?: Maybe<Numeric_Comparison_Exp>;
  document_type?: Maybe<String_Comparison_Exp>;
  due_amount?: Maybe<Numeric_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  dunning_level?: Maybe<Jsonb_Comparison_Exp>;
  dunning_notices?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
  dunning_notices_aggregate?: Maybe<Risolto_Dunning_Notice_Invoice_Aggregate_Bool_Exp>;
  dunning_process_metadata?: Maybe<Jsonb_Comparison_Exp>;
  dunning_started?: Maybe<Boolean_Comparison_Exp>;
  dunning_status?: Maybe<Jsonb_Comparison_Exp>;
  earliest_dunning_time?: Maybe<Timestamptz_Comparison_Exp>;
  earliest_submission_time?: Maybe<Timestamptz_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  file_reference?: Maybe<Jsonb_Comparison_Exp>;
  file_references?: Maybe<Jsonb_Comparison_Exp>;
  has_inbound_communication?: Maybe<Boolean_Comparison_Exp>;
  in_collection?: Maybe<Boolean_Comparison_Exp>;
  in_dispute?: Maybe<Boolean_Comparison_Exp>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp>;
  invoice_attachments?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
  invoice_attachments_aggregate?: Maybe<Risolto_Invoice_Document_Attachment_Aggregate_Bool_Exp>;
  invoice_document_status?: Maybe<Risolto_Invoice_Document_Status_Bool_Exp>;
  invoice_group_invoices?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
  invoice_group_invoices_aggregate?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp>;
  invoice_number?: Maybe<String_Comparison_Exp>;
  invoice_predictions?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
  invoice_predictions_aggregate?: Maybe<Risolto_Analytics_Invoice_Prediction_Aggregate_Bool_Exp>;
  is_first?: Maybe<Boolean_Comparison_Exp>;
  is_open?: Maybe<Boolean_Comparison_Exp>;
  issue_date?: Maybe<Date_Comparison_Exp>;
  last_action?: Maybe<String_Comparison_Exp>;
  last_action_code?: Maybe<String_Comparison_Exp>;
  last_action_datetime?: Maybe<Timestamptz_Comparison_Exp>;
  last_damage_clause?: Maybe<Jsonb_Comparison_Exp>;
  last_dunning_actions?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
  last_dunning_notice?: Maybe<String_Comparison_Exp>;
  last_inbound_communication_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  notes?: Maybe<Risolto_Note_Bool_Exp>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Bool_Exp>;
  origin?: Maybe<Risolto_Origin_Enum_Comparison_Exp>;
  paid_at?: Maybe<Date_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_link?: Maybe<Uuid_Comparison_Exp>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Bool_Exp>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Bool_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  payments?: Maybe<Risolto_Payment_Bool_Exp>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Bool_Exp>;
  phase?: Maybe<String_Comparison_Exp>;
  prediction_stars?: Maybe<Numeric_Comparison_Exp>;
  processing_due_date?: Maybe<Date_Comparison_Exp>;
  raw_input?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  short_code?: Maybe<String_Comparison_Exp>;
  statement_line_invoices?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
  statement_line_invoices_aggregate?: Maybe<Risolto_Statement_Line_Invoice_Aggregate_Bool_Exp>;
  status?: Maybe<Risolto_Invoice_Document_Status_Enum_Comparison_Exp>;
  submitted?: Maybe<Boolean_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_document" */
export enum Risolto_Invoice_Document_Constraint {
  /** unique or primary key constraint on columns "reference" */
  DocumentPkey = 'Document_pkey',
  /** unique or primary key constraint on columns "participant", "invoice_number", "legal_entity" */
  InvoiceDocumentParticipantInvoiceReferenceKey = 'invoice_document_participant_invoice_reference_key',
  /** unique or primary key constraint on columns "participant", "external_id", "recipient", "legal_entity" */
  InvoiceDocumentParticipantLegalEntityRecipientExternalId = 'invoice_document_participant_legal_entity_recipient_external_id',
  /** unique or primary key constraint on columns "participant", "recipient", "invoice_number", "legal_entity" */
  InvoiceParticipantLegalEntityRecipientInvoiceNr = 'invoice_participant_legal_entity_recipient_invoice_nr'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Invoice_Document_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Array<Scalars['String']>>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Invoice_Document_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Scalars['Int']>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Scalars['Int']>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Invoice_Document_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Scalars['String']>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references?: Maybe<Scalars['String']>;
};

export type Risolto_Invoice_Document_Details_Search100_Args = {
  search?: Maybe<Scalars['String']>;
};

export type Risolto_Invoice_Document_Details_Search10_Args = {
  search?: Maybe<Scalars['String']>;
};

export type Risolto_Invoice_Document_Details_Search_Args = {
  search?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Inc_Input = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Insert_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  action_invoices?: Maybe<Risolto_Action_Invoice_Arr_Rel_Insert_Input>;
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  /** The currency of the amounts. */
  amount_currency?: Maybe<Scalars['String']>;
  analytics_invoice_features?: Maybe<Risolto_Analytics_Invoice_Features_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  disputes?: Maybe<Risolto_Invoice_Dispute_Arr_Rel_Insert_Input>;
  /** The date on which Invoice is due. */
  due_date?: Maybe<Scalars['date']>;
  dunning_notices?: Maybe<Risolto_Dunning_Notice_Invoice_Arr_Rel_Insert_Input>;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Scalars['jsonb']>;
  /** DEPRECTAED. True when the invoice is being tracked in the dunning process */
  dunning_started?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED */
  earliest_dunning_time?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  earliest_submission_time?: Maybe<Scalars['timestamptz']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Scalars['jsonb']>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references?: Maybe<Scalars['jsonb']>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input>;
  invoice_attachments?: Maybe<Risolto_Invoice_Document_Attachment_Arr_Rel_Insert_Input>;
  invoice_document_status?: Maybe<Risolto_Invoice_Document_Status_Obj_Rel_Insert_Input>;
  invoice_group_invoices?: Maybe<Risolto_Invoice_Group_Invoice_Arr_Rel_Insert_Input>;
  /** An identifier for this document, assigned by the sender. */
  invoice_number?: Maybe<Scalars['String']>;
  invoice_predictions?: Maybe<Risolto_Analytics_Invoice_Prediction_Arr_Rel_Insert_Input>;
  /** The date, assigned by the sender, on which this document was issued. */
  issue_date?: Maybe<Scalars['date']>;
  /** DEPRECATED */
  last_action_code?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_datetime?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  notes?: Maybe<Risolto_Note_Arr_Rel_Insert_Input>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['numeric']>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Arr_Rel_Insert_Input>;
  origin?: Maybe<Risolto_Origin_Enum>;
  paid_at?: Maybe<Scalars['date']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Obj_Rel_Insert_Input>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Arr_Rel_Insert_Input>;
  payment_reference?: Maybe<Scalars['String']>;
  payments?: Maybe<Risolto_Payment_Arr_Rel_Insert_Input>;
  /** DEPRECATED */
  phase?: Maybe<Scalars['String']>;
  processing_due_date?: Maybe<Scalars['date']>;
  /** The raw input record (e.g. a CSV line) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line_invoices?: Maybe<Risolto_Statement_Line_Invoice_Arr_Rel_Insert_Input>;
  status?: Maybe<Risolto_Invoice_Document_Status_Enum>;
  /** True when the invoice has been submitted */
  submitted?: Maybe<Scalars['Boolean']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Document_Max_Fields = {
  __typename?: 'risolto_invoice_document_max_fields';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  /** The currency of the amounts. */
  amount_currency?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_status?: Maybe<Scalars['String']>;
  derived_paid_at?: Maybe<Scalars['timestamptz']>;
  /** Same as invoice_number but using a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** INVOICE */
  document_type?: Maybe<Scalars['String']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The date on which Invoice is due. */
  due_date?: Maybe<Scalars['date']>;
  /** DEPRECATED */
  earliest_dunning_time?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  earliest_submission_time?: Maybe<Scalars['timestamptz']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  /** An identifier for this document, assigned by the sender. */
  invoice_number?: Maybe<Scalars['String']>;
  /** The date, assigned by the sender, on which this document was issued. */
  issue_date?: Maybe<Scalars['date']>;
  last_action?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_code?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_datetime?: Maybe<Scalars['timestamptz']>;
  last_dunning_notice?: Maybe<Scalars['String']>;
  last_inbound_communication_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['numeric']>;
  paid_at?: Maybe<Scalars['date']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  phase?: Maybe<Scalars['String']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  processing_due_date?: Maybe<Scalars['date']>;
  /** The raw input record (e.g. a CSV line) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "risolto.invoice_short_code" */
  short_code?: Maybe<Scalars['String']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Max_Order_By = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Order_By>;
  /** The currency of the amounts. */
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  /** The date on which Invoice is due. */
  due_date?: Maybe<Order_By>;
  /** DEPRECATED */
  earliest_dunning_time?: Maybe<Order_By>;
  /** DEPRECATED */
  earliest_submission_time?: Maybe<Order_By>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Order_By>;
  /** An identifier for this document, assigned by the sender. */
  invoice_number?: Maybe<Order_By>;
  /** The date, assigned by the sender, on which this document was issued. */
  issue_date?: Maybe<Order_By>;
  /** DEPRECATED */
  last_action_code?: Maybe<Order_By>;
  /** DEPRECATED */
  last_action_datetime?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  paid_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  /** DEPRECATED */
  phase?: Maybe<Order_By>;
  processing_due_date?: Maybe<Order_By>;
  /** The raw input record (e.g. a CSV line) */
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Document_Min_Fields = {
  __typename?: 'risolto_invoice_document_min_fields';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  /** The currency of the amounts. */
  amount_currency?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_status?: Maybe<Scalars['String']>;
  derived_paid_at?: Maybe<Scalars['timestamptz']>;
  /** Same as invoice_number but using a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** INVOICE */
  document_type?: Maybe<Scalars['String']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The date on which Invoice is due. */
  due_date?: Maybe<Scalars['date']>;
  /** DEPRECATED */
  earliest_dunning_time?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  earliest_submission_time?: Maybe<Scalars['timestamptz']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  /** An identifier for this document, assigned by the sender. */
  invoice_number?: Maybe<Scalars['String']>;
  /** The date, assigned by the sender, on which this document was issued. */
  issue_date?: Maybe<Scalars['date']>;
  last_action?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_code?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_datetime?: Maybe<Scalars['timestamptz']>;
  last_dunning_notice?: Maybe<Scalars['String']>;
  last_inbound_communication_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['numeric']>;
  paid_at?: Maybe<Scalars['date']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  phase?: Maybe<Scalars['String']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  processing_due_date?: Maybe<Scalars['date']>;
  /** The raw input record (e.g. a CSV line) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "risolto.invoice_short_code" */
  short_code?: Maybe<Scalars['String']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Min_Order_By = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Order_By>;
  /** The currency of the amounts. */
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  /** The date on which Invoice is due. */
  due_date?: Maybe<Order_By>;
  /** DEPRECATED */
  earliest_dunning_time?: Maybe<Order_By>;
  /** DEPRECATED */
  earliest_submission_time?: Maybe<Order_By>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Order_By>;
  /** An identifier for this document, assigned by the sender. */
  invoice_number?: Maybe<Order_By>;
  /** The date, assigned by the sender, on which this document was issued. */
  issue_date?: Maybe<Order_By>;
  /** DEPRECATED */
  last_action_code?: Maybe<Order_By>;
  /** DEPRECATED */
  last_action_datetime?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  paid_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  /** DEPRECATED */
  phase?: Maybe<Order_By>;
  processing_due_date?: Maybe<Order_By>;
  /** The raw input record (e.g. a CSV line) */
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Mutation_Response = {
  __typename?: 'risolto_invoice_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Document>;
};

/** input type for inserting object relation for remote table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Obj_Rel_Insert_Input = {
  data: Risolto_Invoice_Document_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Document_On_Conflict>;
};

/** on_conflict condition type for table "risolto.invoice_document" */
export type Risolto_Invoice_Document_On_Conflict = {
  constraint: Risolto_Invoice_Document_Constraint;
  update_columns?: Array<Risolto_Invoice_Document_Update_Column>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_document". */
export type Risolto_Invoice_Document_Order_By = {
  account_id?: Maybe<Order_By>;
  action_invoices_aggregate?: Maybe<Risolto_Action_Invoice_Aggregate_Order_By>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  active_payment_plan?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  analytics_invoice_features?: Maybe<Risolto_Analytics_Invoice_Features_Order_By>;
  attachments?: Maybe<Order_By>;
  category?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  custom_status?: Maybe<Order_By>;
  derived_paid_at?: Maybe<Order_By>;
  derived_payment_information_aggregate?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Aggregate_Order_By>;
  disputes_aggregate?: Maybe<Risolto_Invoice_Dispute_Aggregate_Order_By>;
  document_number?: Maybe<Order_By>;
  document_open_amount?: Maybe<Order_By>;
  document_total_amount?: Maybe<Order_By>;
  document_type?: Maybe<Order_By>;
  due_amount?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  dunning_level?: Maybe<Order_By>;
  dunning_notices_aggregate?: Maybe<Risolto_Dunning_Notice_Invoice_Aggregate_Order_By>;
  dunning_process_metadata?: Maybe<Order_By>;
  dunning_started?: Maybe<Order_By>;
  dunning_status?: Maybe<Order_By>;
  earliest_dunning_time?: Maybe<Order_By>;
  earliest_submission_time?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  file_reference?: Maybe<Order_By>;
  file_references?: Maybe<Order_By>;
  has_inbound_communication?: Maybe<Order_By>;
  in_collection?: Maybe<Order_By>;
  in_dispute?: Maybe<Order_By>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Order_By>;
  invoice_attachments_aggregate?: Maybe<Risolto_Invoice_Document_Attachment_Aggregate_Order_By>;
  invoice_document_status?: Maybe<Risolto_Invoice_Document_Status_Order_By>;
  invoice_group_invoices_aggregate?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Order_By>;
  invoice_number?: Maybe<Order_By>;
  invoice_predictions_aggregate?: Maybe<Risolto_Analytics_Invoice_Prediction_Aggregate_Order_By>;
  is_first?: Maybe<Order_By>;
  is_open?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  last_action?: Maybe<Order_By>;
  last_action_code?: Maybe<Order_By>;
  last_action_datetime?: Maybe<Order_By>;
  last_damage_clause?: Maybe<Order_By>;
  last_dunning_actions_aggregate?: Maybe<Risolto_Virtual_Dunning_Action_Aggregate_Order_By>;
  last_dunning_notice?: Maybe<Order_By>;
  last_inbound_communication_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Order_By>;
  open_amount?: Maybe<Order_By>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Order_By>;
  origin?: Maybe<Order_By>;
  paid_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Order_By>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Order_By>;
  payment_reference?: Maybe<Order_By>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Order_By>;
  phase?: Maybe<Order_By>;
  prediction_stars?: Maybe<Order_By>;
  processing_due_date?: Maybe<Order_By>;
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  short_code?: Maybe<Order_By>;
  statement_line_invoices_aggregate?: Maybe<Risolto_Statement_Line_Invoice_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  submitted?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_document */
export type Risolto_Invoice_Document_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Invoice_Document_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Scalars['jsonb']>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.invoice_document" */
export enum Risolto_Invoice_Document_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  DunningProcessMetadata = 'dunning_process_metadata',
  /** column name */
  DunningStarted = 'dunning_started',
  /** column name */
  EarliestDunningTime = 'earliest_dunning_time',
  /** column name */
  EarliestSubmissionTime = 'earliest_submission_time',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReference = 'file_reference',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LastActionCode = 'last_action_code',
  /** column name */
  LastActionDatetime = 'last_action_datetime',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentLink = 'payment_link',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  Phase = 'phase',
  /** column name */
  ProcessingDueDate = 'processing_due_date',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Status = 'status',
  /** column name */
  Submitted = 'submitted',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_invoice_document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.invoice_document" */
export enum Risolto_Invoice_Document_Select_Column_Risolto_Invoice_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DunningStarted = 'dunning_started',
  /** column name */
  Submitted = 'submitted'
}

/** select "risolto_invoice_document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.invoice_document" */
export enum Risolto_Invoice_Document_Select_Column_Risolto_Invoice_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DunningStarted = 'dunning_started',
  /** column name */
  Submitted = 'submitted'
}

/** input type for updating data in table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Set_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  /** The currency of the amounts. */
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** The date on which Invoice is due. */
  due_date?: Maybe<Scalars['date']>;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Scalars['jsonb']>;
  /** DEPRECTAED. True when the invoice is being tracked in the dunning process */
  dunning_started?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED */
  earliest_dunning_time?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  earliest_submission_time?: Maybe<Scalars['timestamptz']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Scalars['jsonb']>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references?: Maybe<Scalars['jsonb']>;
  /** An identifier for this document, assigned by the sender. */
  invoice_number?: Maybe<Scalars['String']>;
  /** The date, assigned by the sender, on which this document was issued. */
  issue_date?: Maybe<Scalars['date']>;
  /** DEPRECATED */
  last_action_code?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_datetime?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  paid_at?: Maybe<Scalars['date']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  phase?: Maybe<Scalars['String']>;
  processing_due_date?: Maybe<Scalars['date']>;
  /** The raw input record (e.g. a CSV line) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  status?: Maybe<Risolto_Invoice_Document_Status_Enum>;
  /** True when the invoice has been submitted */
  submitted?: Maybe<Scalars['Boolean']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status = {
  __typename?: 'risolto_invoice_document_status';
  status: Scalars['String'];
};

/** aggregated selection of "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status_Aggregate = {
  __typename?: 'risolto_invoice_document_status_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Document_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Document_Status>;
};

/** aggregate fields of "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status_Aggregate_Fields = {
  __typename?: 'risolto_invoice_document_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Document_Status_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Document_Status_Min_Fields>;
};


/** aggregate fields of "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Document_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_document_status". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Document_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Document_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Document_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Document_Status_Bool_Exp>>;
  status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_document_status" */
export enum Risolto_Invoice_Document_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  InvoiceDocumentStatusPkey = 'invoice_document_status_pkey',
  /** unique or primary key constraint on columns "status" */
  InvoiceDocumentStatusReferenceKey = 'invoice_document_status_reference_key'
}

export enum Risolto_Invoice_Document_Status_Enum {
  Closed = 'CLOSED',
  Failed = 'FAILED',
  InReview = 'IN_REVIEW',
  Loaded = 'LOADED',
  Open = 'OPEN',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Parsed = 'PARSED',
  ReadyForSubmission = 'READY_FOR_SUBMISSION',
  SubmissionPlanned = 'SUBMISSION_PLANNED'
}

/** Boolean expression to compare columns of type "risolto_invoice_document_status_enum". All fields are combined with logical 'AND'. */
export type Risolto_Invoice_Document_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Invoice_Document_Status_Enum>;
  _in?: Maybe<Array<Risolto_Invoice_Document_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Invoice_Document_Status_Enum>;
  _nin?: Maybe<Array<Risolto_Invoice_Document_Status_Enum>>;
};

/** input type for inserting data into table "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status_Insert_Input = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Document_Status_Max_Fields = {
  __typename?: 'risolto_invoice_document_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Document_Status_Min_Fields = {
  __typename?: 'risolto_invoice_document_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status_Mutation_Response = {
  __typename?: 'risolto_invoice_document_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Document_Status>;
};

/** input type for inserting object relation for remote table "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status_Obj_Rel_Insert_Input = {
  data: Risolto_Invoice_Document_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Document_Status_On_Conflict>;
};

/** on_conflict condition type for table "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status_On_Conflict = {
  constraint: Risolto_Invoice_Document_Status_Constraint;
  update_columns?: Array<Risolto_Invoice_Document_Status_Update_Column>;
  where?: Maybe<Risolto_Invoice_Document_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_document_status". */
export type Risolto_Invoice_Document_Status_Order_By = {
  status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_document_status */
export type Risolto_Invoice_Document_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "risolto.invoice_document_status" */
export enum Risolto_Invoice_Document_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "risolto.invoice_document_status" */
export type Risolto_Invoice_Document_Status_Set_Input = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_invoice_document_status" */
export type Risolto_Invoice_Document_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Document_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Document_Status_Stream_Cursor_Value_Input = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.invoice_document_status" */
export enum Risolto_Invoice_Document_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Risolto_Invoice_Document_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Document_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Document_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Risolto_Invoice_Document_Stddev_Fields = {
  __typename?: 'risolto_invoice_document_stddev_fields';
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['Float']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Stddev_Order_By = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Invoice_Document_Stddev_Pop_Fields = {
  __typename?: 'risolto_invoice_document_stddev_pop_fields';
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['Float']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Stddev_Pop_Order_By = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Invoice_Document_Stddev_Samp_Fields = {
  __typename?: 'risolto_invoice_document_stddev_samp_fields';
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['Float']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Stddev_Samp_Order_By = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_invoice_document" */
export type Risolto_Invoice_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Document_Stream_Cursor_Value_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  /** The currency of the amounts. */
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** The date on which Invoice is due. */
  due_date?: Maybe<Scalars['date']>;
  /** DEPRECATED */
  dunning_process_metadata?: Maybe<Scalars['jsonb']>;
  /** DEPRECTAED. True when the invoice is being tracked in the dunning process */
  dunning_started?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED */
  earliest_dunning_time?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  earliest_submission_time?: Maybe<Scalars['timestamptz']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in 2.0 */
  file_reference?: Maybe<Scalars['jsonb']>;
  /** Internal or external links to documents such as the invoice document itself (Link to S3, an external portal, ...) */
  file_references?: Maybe<Scalars['jsonb']>;
  /** An identifier for this document, assigned by the sender. */
  invoice_number?: Maybe<Scalars['String']>;
  /** The date, assigned by the sender, on which this document was issued. */
  issue_date?: Maybe<Scalars['date']>;
  /** DEPRECATED */
  last_action_code?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  last_action_datetime?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  paid_at?: Maybe<Scalars['date']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  phase?: Maybe<Scalars['String']>;
  processing_due_date?: Maybe<Scalars['date']>;
  /** The raw input record (e.g. a CSV line) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  status?: Maybe<Risolto_Invoice_Document_Status_Enum>;
  /** True when the invoice has been submitted */
  submitted?: Maybe<Scalars['Boolean']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Invoice_Document_Sum_Fields = {
  __typename?: 'risolto_invoice_document_sum_fields';
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Sum_Order_By = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.invoice_document" */
export enum Risolto_Invoice_Document_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  DunningProcessMetadata = 'dunning_process_metadata',
  /** column name */
  DunningStarted = 'dunning_started',
  /** column name */
  EarliestDunningTime = 'earliest_dunning_time',
  /** column name */
  EarliestSubmissionTime = 'earliest_submission_time',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReference = 'file_reference',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LastActionCode = 'last_action_code',
  /** column name */
  LastActionDatetime = 'last_action_datetime',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentLink = 'payment_link',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  Phase = 'phase',
  /** column name */
  ProcessingDueDate = 'processing_due_date',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Status = 'status',
  /** column name */
  Submitted = 'submitted',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Document_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Invoice_Document_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Invoice_Document_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Invoice_Document_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Invoice_Document_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Invoice_Document_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Invoice_Document_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Document_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Invoice_Document_Var_Pop_Fields = {
  __typename?: 'risolto_invoice_document_var_pop_fields';
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['Float']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Var_Pop_Order_By = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Invoice_Document_Var_Samp_Fields = {
  __typename?: 'risolto_invoice_document_var_samp_fields';
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['Float']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Var_Samp_Order_By = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Invoice_Document_Variance_Fields = {
  __typename?: 'risolto_invoice_document_variance_fields';
  /** Same as open_amount but using a more generic name */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Same as total_amount but using a more generic name */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** Computed field. due = total - open */
  due_amount?: Maybe<Scalars['numeric']>;
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Scalars['Float']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.invoice_document" */
export type Risolto_Invoice_Document_Variance_Order_By = {
  /** The open amount payable on the Invoice: total_amount - (pre)payments */
  open_amount?: Maybe<Order_By>;
  /** The total amount payable on the Invoice, including Taxes. Not including additional late fees, etc. */
  total_amount?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_Group = {
  __typename?: 'risolto_invoice_group';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  dunning_notices: Array<Risolto_Dunning_Notice>;
  /** An aggregate relationship */
  dunning_notices_aggregate: Risolto_Dunning_Notice_Aggregate;
  /** An array relationship */
  invoice_group_credit_notes: Array<Risolto_Invoice_Group_Credit_Note>;
  /** An aggregate relationship */
  invoice_group_credit_notes_aggregate: Risolto_Invoice_Group_Credit_Note_Aggregate;
  /** An array relationship */
  invoice_group_debit_notes: Array<Risolto_Invoice_Group_Debit_Note>;
  /** An aggregate relationship */
  invoice_group_debit_notes_aggregate: Risolto_Invoice_Group_Debit_Note_Aggregate;
  /** An array relationship */
  invoice_group_dunning_runs: Array<Risolto_Invoice_Group_Dunning_Run>;
  /** An aggregate relationship */
  invoice_group_dunning_runs_aggregate: Risolto_Invoice_Group_Dunning_Run_Aggregate;
  /** An array relationship */
  invoice_group_invoices: Array<Risolto_Invoice_Group_Invoice>;
  /** An aggregate relationship */
  invoice_group_invoices_aggregate: Risolto_Invoice_Group_Invoice_Aggregate;
  /** An array relationship */
  invoice_group_payment_promises: Array<Risolto_Invoice_Group_Payment_Promise>;
  /** An aggregate relationship */
  invoice_group_payment_promises_aggregate: Risolto_Invoice_Group_Payment_Promise_Aggregate;
  /** An array relationship */
  invoice_group_payments: Array<Risolto_Invoice_Group_Payment>;
  /** An aggregate relationship */
  invoice_group_payments_aggregate: Risolto_Invoice_Group_Payment_Aggregate;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_plan_status?: Maybe<Scalars['String']>;
  /** An array relationship */
  payment_plans: Array<Risolto_Payment_Plan>;
  /** An aggregate relationship */
  payment_plans_aggregate: Risolto_Payment_Plan_Aggregate;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupDunning_NoticesArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupDunning_Notices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Credit_NotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Credit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Debit_NotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Debit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Dunning_RunsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Dunning_Runs_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Payment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Payment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_PaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupInvoice_Group_Payments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupPayment_PlansArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


/** columns and relationships of "risolto.invoice_group" */
export type Risolto_Invoice_GroupPayment_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};

/** aggregated selection of "risolto.invoice_group" */
export type Risolto_Invoice_Group_Aggregate = {
  __typename?: 'risolto_invoice_group_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Group_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Group>;
};

export type Risolto_Invoice_Group_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Invoice_Group_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Group_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_group" */
export type Risolto_Invoice_Group_Aggregate_Fields = {
  __typename?: 'risolto_invoice_group_aggregate_fields';
  avg?: Maybe<Risolto_Invoice_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Group_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Group_Min_Fields>;
  stddev?: Maybe<Risolto_Invoice_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Invoice_Group_Sum_Fields>;
  var_pop?: Maybe<Risolto_Invoice_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Invoice_Group_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Invoice_Group_Variance_Fields>;
};


/** aggregate fields of "risolto.invoice_group" */
export type Risolto_Invoice_Group_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_group" */
export type Risolto_Invoice_Group_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Group_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Group_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.invoice_group" */
export type Risolto_Invoice_Group_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Invoice_Group_Avg_Fields = {
  __typename?: 'risolto_invoice_group_avg_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_group". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Group_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Group_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Group_Bool_Exp>>;
  balance_amount?: Maybe<Numeric_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  dunning_notices?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  dunning_notices_aggregate?: Maybe<Risolto_Dunning_Notice_Aggregate_Bool_Exp>;
  invoice_group_credit_notes?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
  invoice_group_credit_notes_aggregate?: Maybe<Risolto_Invoice_Group_Credit_Note_Aggregate_Bool_Exp>;
  invoice_group_debit_notes?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
  invoice_group_debit_notes_aggregate?: Maybe<Risolto_Invoice_Group_Debit_Note_Aggregate_Bool_Exp>;
  invoice_group_dunning_runs?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
  invoice_group_dunning_runs_aggregate?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp>;
  invoice_group_invoices?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
  invoice_group_invoices_aggregate?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp>;
  invoice_group_payment_promises?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
  invoice_group_payment_promises_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Promise_Aggregate_Bool_Exp>;
  invoice_group_payments?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
  invoice_group_payments_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Aggregate_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  other_balance_amount?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_plan_status?: Maybe<String_Comparison_Exp>;
  payment_plans?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  payment_plans_aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_group" */
export enum Risolto_Invoice_Group_Constraint {
  /** unique or primary key constraint on columns "reference" */
  InvoiceGroupPkey = 'invoice_group_pkey'
}

/** columns and relationships of "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note = {
  __typename?: 'risolto_invoice_group_credit_note';
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at: Scalars['timestamptz'];
  credit_note: Scalars['uuid'];
  /** An object relationship */
  credit_note_by_reference: Risolto_Credit_Note;
  invoice_group: Scalars['uuid'];
  /** An object relationship */
  invoice_group_by_reference: Risolto_Invoice_Group;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Aggregate = {
  __typename?: 'risolto_invoice_group_credit_note_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Group_Credit_Note_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Group_Credit_Note>;
};

export type Risolto_Invoice_Group_Credit_Note_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Invoice_Group_Credit_Note_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Group_Credit_Note_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Aggregate_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_aggregate_fields';
  avg?: Maybe<Risolto_Invoice_Group_Credit_Note_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Group_Credit_Note_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Group_Credit_Note_Min_Fields>;
  stddev?: Maybe<Risolto_Invoice_Group_Credit_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Credit_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Credit_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Invoice_Group_Credit_Note_Sum_Fields>;
  var_pop?: Maybe<Risolto_Invoice_Group_Credit_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Invoice_Group_Credit_Note_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Invoice_Group_Credit_Note_Variance_Fields>;
};


/** aggregate fields of "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Invoice_Group_Credit_Note_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Group_Credit_Note_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Group_Credit_Note_Min_Order_By>;
  stddev?: Maybe<Risolto_Invoice_Group_Credit_Note_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Credit_Note_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Credit_Note_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Invoice_Group_Credit_Note_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Invoice_Group_Credit_Note_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Invoice_Group_Credit_Note_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Invoice_Group_Credit_Note_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Group_Credit_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Group_Credit_Note_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Invoice_Group_Credit_Note_Avg_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_group_credit_note". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Group_Credit_Note_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Bool_Exp>>;
  amount_currency?: Maybe<Risolto_Currency_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  credit_note?: Maybe<Uuid_Comparison_Exp>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Bool_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_group_credit_note" */
export enum Risolto_Invoice_Group_Credit_Note_Constraint {
  /** unique or primary key constraint on columns "participant", "invoice_group", "recipient", "credit_note" */
  InvoiceGroupCreditNoteParticipantRecipientInvoiceGroupC = 'invoice_group_credit_note_participant_recipient_invoice_group_c',
  /** unique or primary key constraint on columns "reference" */
  InvoiceGroupCreditNotePkey = 'invoice_group_credit_note_pkey'
}

/** input type for incrementing numeric columns in table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Insert_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Obj_Rel_Insert_Input>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Group_Credit_Note_Max_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Group_Credit_Note_Min_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Mutation_Response = {
  __typename?: 'risolto_invoice_group_credit_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Group_Credit_Note>;
};

/** on_conflict condition type for table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_On_Conflict = {
  constraint: Risolto_Invoice_Group_Credit_Note_Constraint;
  update_columns?: Array<Risolto_Invoice_Group_Credit_Note_Update_Column>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_group_credit_note". */
export type Risolto_Invoice_Group_Credit_Note_Order_By = {
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  credit_note_by_reference?: Maybe<Risolto_Credit_Note_Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_group_credit_note */
export type Risolto_Invoice_Group_Credit_Note_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.invoice_group_credit_note" */
export enum Risolto_Invoice_Group_Credit_Note_Select_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Set_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Invoice_Group_Credit_Note_Stddev_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Invoice_Group_Credit_Note_Stddev_Pop_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Invoice_Group_Credit_Note_Stddev_Samp_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Group_Credit_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Group_Credit_Note_Stream_Cursor_Value_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Invoice_Group_Credit_Note_Sum_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.invoice_group_credit_note" */
export enum Risolto_Invoice_Group_Credit_Note_Update_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Group_Credit_Note_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Invoice_Group_Credit_Note_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Group_Credit_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Group_Credit_Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Invoice_Group_Credit_Note_Var_Pop_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Invoice_Group_Credit_Note_Var_Samp_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Invoice_Group_Credit_Note_Variance_Fields = {
  __typename?: 'risolto_invoice_group_credit_note_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.invoice_group_credit_note" */
export type Risolto_Invoice_Group_Credit_Note_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note = {
  __typename?: 'risolto_invoice_group_debit_note';
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at: Scalars['timestamptz'];
  debit_note: Scalars['uuid'];
  /** An object relationship */
  debit_note_by_reference: Risolto_Debit_Note;
  invoice_group: Scalars['uuid'];
  /** An object relationship */
  invoice_group_by_reference: Risolto_Invoice_Group;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Aggregate = {
  __typename?: 'risolto_invoice_group_debit_note_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Group_Debit_Note_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Group_Debit_Note>;
};

export type Risolto_Invoice_Group_Debit_Note_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Invoice_Group_Debit_Note_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Group_Debit_Note_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Aggregate_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_aggregate_fields';
  avg?: Maybe<Risolto_Invoice_Group_Debit_Note_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Group_Debit_Note_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Group_Debit_Note_Min_Fields>;
  stddev?: Maybe<Risolto_Invoice_Group_Debit_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Debit_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Debit_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Invoice_Group_Debit_Note_Sum_Fields>;
  var_pop?: Maybe<Risolto_Invoice_Group_Debit_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Invoice_Group_Debit_Note_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Invoice_Group_Debit_Note_Variance_Fields>;
};


/** aggregate fields of "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Invoice_Group_Debit_Note_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Group_Debit_Note_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Group_Debit_Note_Min_Order_By>;
  stddev?: Maybe<Risolto_Invoice_Group_Debit_Note_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Debit_Note_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Debit_Note_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Invoice_Group_Debit_Note_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Invoice_Group_Debit_Note_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Invoice_Group_Debit_Note_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Invoice_Group_Debit_Note_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Group_Debit_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Group_Debit_Note_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Invoice_Group_Debit_Note_Avg_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_group_debit_note". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Group_Debit_Note_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Bool_Exp>>;
  amount_currency?: Maybe<Risolto_Currency_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  debit_note?: Maybe<Uuid_Comparison_Exp>;
  debit_note_by_reference?: Maybe<Risolto_Debit_Note_Bool_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_group_debit_note" */
export enum Risolto_Invoice_Group_Debit_Note_Constraint {
  /** unique or primary key constraint on columns "participant", "invoice_group", "debit_note", "recipient" */
  InvoiceGroupDebitNoteParticipantRecipientInvoiceGroupDe = 'invoice_group_debit_note_participant_recipient_invoice_group_de',
  /** unique or primary key constraint on columns "reference" */
  InvoiceGroupDebitNotePkey = 'invoice_group_debit_note_pkey'
}

/** input type for incrementing numeric columns in table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Insert_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  debit_note_by_reference?: Maybe<Risolto_Debit_Note_Obj_Rel_Insert_Input>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Group_Debit_Note_Max_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Group_Debit_Note_Min_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Mutation_Response = {
  __typename?: 'risolto_invoice_group_debit_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Group_Debit_Note>;
};

/** on_conflict condition type for table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_On_Conflict = {
  constraint: Risolto_Invoice_Group_Debit_Note_Constraint;
  update_columns?: Array<Risolto_Invoice_Group_Debit_Note_Update_Column>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_group_debit_note". */
export type Risolto_Invoice_Group_Debit_Note_Order_By = {
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  debit_note_by_reference?: Maybe<Risolto_Debit_Note_Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_group_debit_note */
export type Risolto_Invoice_Group_Debit_Note_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.invoice_group_debit_note" */
export enum Risolto_Invoice_Group_Debit_Note_Select_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebitNote = 'debit_note',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Set_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Invoice_Group_Debit_Note_Stddev_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Invoice_Group_Debit_Note_Stddev_Pop_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Invoice_Group_Debit_Note_Stddev_Samp_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Group_Debit_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Group_Debit_Note_Stream_Cursor_Value_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Invoice_Group_Debit_Note_Sum_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.invoice_group_debit_note" */
export enum Risolto_Invoice_Group_Debit_Note_Update_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebitNote = 'debit_note',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Group_Debit_Note_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Invoice_Group_Debit_Note_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Group_Debit_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Group_Debit_Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Invoice_Group_Debit_Note_Var_Pop_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Invoice_Group_Debit_Note_Var_Samp_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Invoice_Group_Debit_Note_Variance_Fields = {
  __typename?: 'risolto_invoice_group_debit_note_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.invoice_group_debit_note" */
export type Risolto_Invoice_Group_Debit_Note_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run = {
  __typename?: 'risolto_invoice_group_dunning_run';
  created_at: Scalars['timestamptz'];
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Scalars['jsonb']>;
  dunning_group_configuration_id: Scalars['String'];
  invoice_group: Scalars['uuid'];
  /** An object relationship */
  invoice_group_by_reference: Risolto_Invoice_Group;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_dunning_run_by_reference?: Maybe<Risolto_Participant_Dunning_Run>;
  processing_status: Risolto_Run_Processing_Status_Enum;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  recipient_dunning_run?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_dunning_run_by_reference?: Maybe<Risolto_Recipient_Dunning_Run>;
  reference: Scalars['uuid'];
  test: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_RunDunning_Group_ConfigurationArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Aggregate = {
  __typename?: 'risolto_invoice_group_dunning_run_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Group_Dunning_Run>;
};

export type Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Invoice_Group_Dunning_Run_Select_Column_Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Invoice_Group_Dunning_Run_Select_Column_Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Aggregate_Fields = {
  __typename?: 'risolto_invoice_group_dunning_run_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Group_Dunning_Run_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Group_Dunning_Run_Min_Fields>;
};


/** aggregate fields of "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Group_Dunning_Run_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Group_Dunning_Run_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Invoice_Group_Dunning_Run_Append_Input = {
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Group_Dunning_Run_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Group_Dunning_Run_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_group_dunning_run". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Group_Dunning_Run_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  dunning_group_configuration?: Maybe<Jsonb_Comparison_Exp>;
  dunning_group_configuration_id?: Maybe<String_Comparison_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  participant_dunning_run?: Maybe<Uuid_Comparison_Exp>;
  participant_dunning_run_by_reference?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  recipient_dunning_run?: Maybe<Uuid_Comparison_Exp>;
  recipient_dunning_run_by_reference?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  test?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_group_dunning_run" */
export enum Risolto_Invoice_Group_Dunning_Run_Constraint {
  /** unique or primary key constraint on columns "reference" */
  InvoiceGroupDunningRunPkey = 'invoice_group_dunning_run_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Invoice_Group_Dunning_Run_Delete_At_Path_Input = {
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Invoice_Group_Dunning_Run_Delete_Elem_Input = {
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Invoice_Group_Dunning_Run_Delete_Key_Input = {
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Scalars['jsonb']>;
  dunning_group_configuration_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  participant_dunning_run_by_reference?: Maybe<Risolto_Participant_Dunning_Run_Obj_Rel_Insert_Input>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  recipient_dunning_run?: Maybe<Scalars['uuid']>;
  recipient_dunning_run_by_reference?: Maybe<Risolto_Recipient_Dunning_Run_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Group_Dunning_Run_Max_Fields = {
  __typename?: 'risolto_invoice_group_dunning_run_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_group_configuration_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_dunning_run?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  dunning_group_configuration_id?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_dunning_run?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_dunning_run?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Group_Dunning_Run_Min_Fields = {
  __typename?: 'risolto_invoice_group_dunning_run_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_group_configuration_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_dunning_run?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  dunning_group_configuration_id?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_dunning_run?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_dunning_run?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Mutation_Response = {
  __typename?: 'risolto_invoice_group_dunning_run_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Group_Dunning_Run>;
};

/** on_conflict condition type for table "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_On_Conflict = {
  constraint: Risolto_Invoice_Group_Dunning_Run_Constraint;
  update_columns?: Array<Risolto_Invoice_Group_Dunning_Run_Update_Column>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_group_dunning_run". */
export type Risolto_Invoice_Group_Dunning_Run_Order_By = {
  created_at?: Maybe<Order_By>;
  dunning_group_configuration?: Maybe<Order_By>;
  dunning_group_configuration_id?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  participant_dunning_run?: Maybe<Order_By>;
  participant_dunning_run_by_reference?: Maybe<Risolto_Participant_Dunning_Run_Order_By>;
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  recipient_dunning_run?: Maybe<Order_By>;
  recipient_dunning_run_by_reference?: Maybe<Risolto_Recipient_Dunning_Run_Order_By>;
  reference?: Maybe<Order_By>;
  test?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_group_dunning_run */
export type Risolto_Invoice_Group_Dunning_Run_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Invoice_Group_Dunning_Run_Prepend_Input = {
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.invoice_group_dunning_run" */
export enum Risolto_Invoice_Group_Dunning_Run_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DunningGroupConfiguration = 'dunning_group_configuration',
  /** column name */
  DunningGroupConfigurationId = 'dunning_group_configuration_id',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantDunningRun = 'participant_dunning_run',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RecipientDunningRun = 'recipient_dunning_run',
  /** column name */
  Reference = 'reference',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_invoice_group_dunning_run_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.invoice_group_dunning_run" */
export enum Risolto_Invoice_Group_Dunning_Run_Select_Column_Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Test = 'test'
}

/** select "risolto_invoice_group_dunning_run_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.invoice_group_dunning_run" */
export enum Risolto_Invoice_Group_Dunning_Run_Select_Column_Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Test = 'test'
}

/** input type for updating data in table "risolto.invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Scalars['jsonb']>;
  dunning_group_configuration_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_dunning_run?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_invoice_group_dunning_run" */
export type Risolto_Invoice_Group_Dunning_Run_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Group_Dunning_Run_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Group_Dunning_Run_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED */
  dunning_group_configuration?: Maybe<Scalars['jsonb']>;
  dunning_group_configuration_id?: Maybe<Scalars['String']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_dunning_run?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.invoice_group_dunning_run" */
export enum Risolto_Invoice_Group_Dunning_Run_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DunningGroupConfiguration = 'dunning_group_configuration',
  /** column name */
  DunningGroupConfigurationId = 'dunning_group_configuration_id',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantDunningRun = 'participant_dunning_run',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RecipientDunningRun = 'recipient_dunning_run',
  /** column name */
  Reference = 'reference',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Group_Dunning_Run_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Invoice_Group_Dunning_Run_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Invoice_Group_Dunning_Run_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Invoice_Group_Dunning_Run_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Group_Dunning_Run_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Group_Dunning_Run_Bool_Exp;
};

/** input type for inserting data into table "risolto.invoice_group" */
export type Risolto_Invoice_Group_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  dunning_notices?: Maybe<Risolto_Dunning_Notice_Arr_Rel_Insert_Input>;
  invoice_group_credit_notes?: Maybe<Risolto_Invoice_Group_Credit_Note_Arr_Rel_Insert_Input>;
  invoice_group_debit_notes?: Maybe<Risolto_Invoice_Group_Debit_Note_Arr_Rel_Insert_Input>;
  invoice_group_dunning_runs?: Maybe<Risolto_Invoice_Group_Dunning_Run_Arr_Rel_Insert_Input>;
  invoice_group_invoices?: Maybe<Risolto_Invoice_Group_Invoice_Arr_Rel_Insert_Input>;
  invoice_group_payment_promises?: Maybe<Risolto_Invoice_Group_Payment_Promise_Arr_Rel_Insert_Input>;
  invoice_group_payments?: Maybe<Risolto_Invoice_Group_Payment_Arr_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_plans?: Maybe<Risolto_Payment_Plan_Arr_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice = {
  __typename?: 'risolto_invoice_group_invoice';
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at: Scalars['timestamptz'];
  damage_clause_amount?: Maybe<Scalars['numeric']>;
  damage_clause_interest?: Maybe<Scalars['numeric']>;
  damage_clause_simulated?: Maybe<Scalars['Boolean']>;
  damage_clause_total_amount?: Maybe<Scalars['numeric']>;
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  invoice_group: Scalars['uuid'];
  /** An object relationship */
  invoice_group_by_reference: Risolto_Invoice_Group;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Aggregate = {
  __typename?: 'risolto_invoice_group_invoice_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Group_Invoice>;
};

export type Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Invoice_Group_Invoice_Select_Column_Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Invoice_Group_Invoice_Select_Column_Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Aggregate_Fields = {
  __typename?: 'risolto_invoice_group_invoice_aggregate_fields';
  avg?: Maybe<Risolto_Invoice_Group_Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Group_Invoice_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Group_Invoice_Min_Fields>;
  stddev?: Maybe<Risolto_Invoice_Group_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Invoice_Group_Invoice_Sum_Fields>;
  var_pop?: Maybe<Risolto_Invoice_Group_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Invoice_Group_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Invoice_Group_Invoice_Variance_Fields>;
};


/** aggregate fields of "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Invoice_Group_Invoice_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Group_Invoice_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Group_Invoice_Min_Order_By>;
  stddev?: Maybe<Risolto_Invoice_Group_Invoice_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Invoice_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Invoice_Group_Invoice_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Invoice_Group_Invoice_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Invoice_Group_Invoice_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Invoice_Group_Invoice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Group_Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Group_Invoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Invoice_Group_Invoice_Avg_Fields = {
  __typename?: 'risolto_invoice_group_invoice_avg_fields';
  damage_clause_amount?: Maybe<Scalars['Float']>;
  damage_clause_interest?: Maybe<Scalars['Float']>;
  damage_clause_total_amount?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
};

/** order by avg() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Avg_Order_By = {
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_group_invoice". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Group_Invoice_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Group_Invoice_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Group_Invoice_Bool_Exp>>;
  amount_currency?: Maybe<Risolto_Currency_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  damage_clause_amount?: Maybe<Numeric_Comparison_Exp>;
  damage_clause_interest?: Maybe<Numeric_Comparison_Exp>;
  damage_clause_simulated?: Maybe<Boolean_Comparison_Exp>;
  damage_clause_total_amount?: Maybe<Numeric_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  open_amount_with_proportional_costs?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_group_invoice" */
export enum Risolto_Invoice_Group_Invoice_Constraint {
  /** unique or primary key constraint on columns "participant", "invoice_group", "recipient", "invoice" */
  InvoiceGroupInvoiceParticipantRecipientInvoiceGroupInvoi = 'invoice_group_invoice_participant_recipient_invoice_group_invoi',
  /** unique or primary key constraint on columns "reference" */
  InvoiceGroupInvoicePkey = 'invoice_group_invoice_pkey'
}

/** input type for incrementing numeric columns in table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Inc_Input = {
  damage_clause_amount?: Maybe<Scalars['numeric']>;
  damage_clause_interest?: Maybe<Scalars['numeric']>;
  damage_clause_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Insert_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  damage_clause_amount?: Maybe<Scalars['numeric']>;
  damage_clause_interest?: Maybe<Scalars['numeric']>;
  damage_clause_simulated?: Maybe<Scalars['Boolean']>;
  damage_clause_total_amount?: Maybe<Scalars['numeric']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Group_Invoice_Max_Fields = {
  __typename?: 'risolto_invoice_group_invoice_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  damage_clause_amount?: Maybe<Scalars['numeric']>;
  damage_clause_interest?: Maybe<Scalars['numeric']>;
  damage_clause_total_amount?: Maybe<Scalars['numeric']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Group_Invoice_Min_Fields = {
  __typename?: 'risolto_invoice_group_invoice_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  damage_clause_amount?: Maybe<Scalars['numeric']>;
  damage_clause_interest?: Maybe<Scalars['numeric']>;
  damage_clause_total_amount?: Maybe<Scalars['numeric']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Mutation_Response = {
  __typename?: 'risolto_invoice_group_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Group_Invoice>;
};

/** on_conflict condition type for table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_On_Conflict = {
  constraint: Risolto_Invoice_Group_Invoice_Constraint;
  update_columns?: Array<Risolto_Invoice_Group_Invoice_Update_Column>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_group_invoice". */
export type Risolto_Invoice_Group_Invoice_Order_By = {
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_simulated?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  open_amount_with_proportional_costs?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_group_invoice */
export type Risolto_Invoice_Group_Invoice_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.invoice_group_invoice" */
export enum Risolto_Invoice_Group_Invoice_Select_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DamageClauseAmount = 'damage_clause_amount',
  /** column name */
  DamageClauseInterest = 'damage_clause_interest',
  /** column name */
  DamageClauseSimulated = 'damage_clause_simulated',
  /** column name */
  DamageClauseTotalAmount = 'damage_clause_total_amount',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_invoice_group_invoice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.invoice_group_invoice" */
export enum Risolto_Invoice_Group_Invoice_Select_Column_Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DamageClauseSimulated = 'damage_clause_simulated'
}

/** select "risolto_invoice_group_invoice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.invoice_group_invoice" */
export enum Risolto_Invoice_Group_Invoice_Select_Column_Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DamageClauseSimulated = 'damage_clause_simulated'
}

/** input type for updating data in table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Set_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  damage_clause_amount?: Maybe<Scalars['numeric']>;
  damage_clause_interest?: Maybe<Scalars['numeric']>;
  damage_clause_simulated?: Maybe<Scalars['Boolean']>;
  damage_clause_total_amount?: Maybe<Scalars['numeric']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Invoice_Group_Invoice_Stddev_Fields = {
  __typename?: 'risolto_invoice_group_invoice_stddev_fields';
  damage_clause_amount?: Maybe<Scalars['Float']>;
  damage_clause_interest?: Maybe<Scalars['Float']>;
  damage_clause_total_amount?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Stddev_Order_By = {
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Invoice_Group_Invoice_Stddev_Pop_Fields = {
  __typename?: 'risolto_invoice_group_invoice_stddev_pop_fields';
  damage_clause_amount?: Maybe<Scalars['Float']>;
  damage_clause_interest?: Maybe<Scalars['Float']>;
  damage_clause_total_amount?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
};

/** order by stddev_pop() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Stddev_Pop_Order_By = {
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Invoice_Group_Invoice_Stddev_Samp_Fields = {
  __typename?: 'risolto_invoice_group_invoice_stddev_samp_fields';
  damage_clause_amount?: Maybe<Scalars['Float']>;
  damage_clause_interest?: Maybe<Scalars['Float']>;
  damage_clause_total_amount?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
};

/** order by stddev_samp() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Stddev_Samp_Order_By = {
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Group_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Group_Invoice_Stream_Cursor_Value_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  damage_clause_amount?: Maybe<Scalars['numeric']>;
  damage_clause_interest?: Maybe<Scalars['numeric']>;
  damage_clause_simulated?: Maybe<Scalars['Boolean']>;
  damage_clause_total_amount?: Maybe<Scalars['numeric']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Invoice_Group_Invoice_Sum_Fields = {
  __typename?: 'risolto_invoice_group_invoice_sum_fields';
  damage_clause_amount?: Maybe<Scalars['numeric']>;
  damage_clause_interest?: Maybe<Scalars['numeric']>;
  damage_clause_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Sum_Order_By = {
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.invoice_group_invoice" */
export enum Risolto_Invoice_Group_Invoice_Update_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DamageClauseAmount = 'damage_clause_amount',
  /** column name */
  DamageClauseInterest = 'damage_clause_interest',
  /** column name */
  DamageClauseSimulated = 'damage_clause_simulated',
  /** column name */
  DamageClauseTotalAmount = 'damage_clause_total_amount',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Group_Invoice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Invoice_Group_Invoice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Group_Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Group_Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Invoice_Group_Invoice_Var_Pop_Fields = {
  __typename?: 'risolto_invoice_group_invoice_var_pop_fields';
  damage_clause_amount?: Maybe<Scalars['Float']>;
  damage_clause_interest?: Maybe<Scalars['Float']>;
  damage_clause_total_amount?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
};

/** order by var_pop() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Var_Pop_Order_By = {
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Invoice_Group_Invoice_Var_Samp_Fields = {
  __typename?: 'risolto_invoice_group_invoice_var_samp_fields';
  damage_clause_amount?: Maybe<Scalars['Float']>;
  damage_clause_interest?: Maybe<Scalars['Float']>;
  damage_clause_total_amount?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
};

/** order by var_samp() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Var_Samp_Order_By = {
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Invoice_Group_Invoice_Variance_Fields = {
  __typename?: 'risolto_invoice_group_invoice_variance_fields';
  damage_clause_amount?: Maybe<Scalars['Float']>;
  damage_clause_interest?: Maybe<Scalars['Float']>;
  damage_clause_total_amount?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['Float']>;
  open_amount_with_proportional_costs?: Maybe<Scalars['numeric']>;
};

/** order by variance() on columns of table "risolto.invoice_group_invoice" */
export type Risolto_Invoice_Group_Invoice_Variance_Order_By = {
  damage_clause_amount?: Maybe<Order_By>;
  damage_clause_interest?: Maybe<Order_By>;
  damage_clause_total_amount?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Group_Max_Fields = {
  __typename?: 'risolto_invoice_group_max_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_group" */
export type Risolto_Invoice_Group_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Group_Min_Fields = {
  __typename?: 'risolto_invoice_group_min_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_group" */
export type Risolto_Invoice_Group_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_group" */
export type Risolto_Invoice_Group_Mutation_Response = {
  __typename?: 'risolto_invoice_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Group>;
};

/** input type for inserting object relation for remote table "risolto.invoice_group" */
export type Risolto_Invoice_Group_Obj_Rel_Insert_Input = {
  data: Risolto_Invoice_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Group_On_Conflict>;
};

/** on_conflict condition type for table "risolto.invoice_group" */
export type Risolto_Invoice_Group_On_Conflict = {
  constraint: Risolto_Invoice_Group_Constraint;
  update_columns?: Array<Risolto_Invoice_Group_Update_Column>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_group". */
export type Risolto_Invoice_Group_Order_By = {
  balance_amount?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  dunning_notices_aggregate?: Maybe<Risolto_Dunning_Notice_Aggregate_Order_By>;
  invoice_group_credit_notes_aggregate?: Maybe<Risolto_Invoice_Group_Credit_Note_Aggregate_Order_By>;
  invoice_group_debit_notes_aggregate?: Maybe<Risolto_Invoice_Group_Debit_Note_Aggregate_Order_By>;
  invoice_group_dunning_runs_aggregate?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Order_By>;
  invoice_group_invoices_aggregate?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Order_By>;
  invoice_group_payment_promises_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Promise_Aggregate_Order_By>;
  invoice_group_payments_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Aggregate_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  other_balance_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_plan_status?: Maybe<Order_By>;
  payment_plans_aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment = {
  __typename?: 'risolto_invoice_group_payment';
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at: Scalars['timestamptz'];
  invoice_group: Scalars['uuid'];
  /** An object relationship */
  invoice_group_by_reference: Risolto_Invoice_Group;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment: Scalars['uuid'];
  /** An object relationship */
  payment_by_reference: Risolto_Payment_Document;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Aggregate = {
  __typename?: 'risolto_invoice_group_payment_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Group_Payment_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Group_Payment>;
};

export type Risolto_Invoice_Group_Payment_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Invoice_Group_Payment_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Group_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Aggregate_Fields = {
  __typename?: 'risolto_invoice_group_payment_aggregate_fields';
  avg?: Maybe<Risolto_Invoice_Group_Payment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Group_Payment_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Group_Payment_Min_Fields>;
  stddev?: Maybe<Risolto_Invoice_Group_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Invoice_Group_Payment_Sum_Fields>;
  var_pop?: Maybe<Risolto_Invoice_Group_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Invoice_Group_Payment_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Invoice_Group_Payment_Variance_Fields>;
};


/** aggregate fields of "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Invoice_Group_Payment_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Group_Payment_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Group_Payment_Min_Order_By>;
  stddev?: Maybe<Risolto_Invoice_Group_Payment_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Payment_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Invoice_Group_Payment_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Invoice_Group_Payment_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Invoice_Group_Payment_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Invoice_Group_Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Group_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Group_Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Invoice_Group_Payment_Avg_Fields = {
  __typename?: 'risolto_invoice_group_payment_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_group_payment". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Group_Payment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Group_Payment_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Group_Payment_Bool_Exp>>;
  amount_currency?: Maybe<Risolto_Currency_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment?: Maybe<Uuid_Comparison_Exp>;
  payment_by_reference?: Maybe<Risolto_Payment_Document_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_group_payment" */
export enum Risolto_Invoice_Group_Payment_Constraint {
  /** unique or primary key constraint on columns "reference" */
  InvoiceGroupPaymentPkey = 'invoice_group_payment_pkey'
}

/** input type for incrementing numeric columns in table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Insert_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment?: Maybe<Scalars['uuid']>;
  payment_by_reference?: Maybe<Risolto_Payment_Document_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Group_Payment_Max_Fields = {
  __typename?: 'risolto_invoice_group_payment_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Group_Payment_Min_Fields = {
  __typename?: 'risolto_invoice_group_payment_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Mutation_Response = {
  __typename?: 'risolto_invoice_group_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Group_Payment>;
};

/** on_conflict condition type for table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_On_Conflict = {
  constraint: Risolto_Invoice_Group_Payment_Constraint;
  update_columns?: Array<Risolto_Invoice_Group_Payment_Update_Column>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_group_payment". */
export type Risolto_Invoice_Group_Payment_Order_By = {
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment?: Maybe<Order_By>;
  payment_by_reference?: Maybe<Risolto_Payment_Document_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_group_payment */
export type Risolto_Invoice_Group_Payment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** columns and relationships of "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise = {
  __typename?: 'risolto_invoice_group_payment_promise';
  created_at: Scalars['timestamptz'];
  invoice_group: Scalars['uuid'];
  /** An object relationship */
  invoice_group_by_reference: Risolto_Invoice_Group;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_promise: Scalars['uuid'];
  /** An object relationship */
  payment_promise_by_reference: Risolto_Payment_Promise;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Aggregate = {
  __typename?: 'risolto_invoice_group_payment_promise_aggregate';
  aggregate?: Maybe<Risolto_Invoice_Group_Payment_Promise_Aggregate_Fields>;
  nodes: Array<Risolto_Invoice_Group_Payment_Promise>;
};

export type Risolto_Invoice_Group_Payment_Promise_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Invoice_Group_Payment_Promise_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Invoice_Group_Payment_Promise_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Aggregate_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_aggregate_fields';
  avg?: Maybe<Risolto_Invoice_Group_Payment_Promise_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Invoice_Group_Payment_Promise_Max_Fields>;
  min?: Maybe<Risolto_Invoice_Group_Payment_Promise_Min_Fields>;
  stddev?: Maybe<Risolto_Invoice_Group_Payment_Promise_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Payment_Promise_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Payment_Promise_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Invoice_Group_Payment_Promise_Sum_Fields>;
  var_pop?: Maybe<Risolto_Invoice_Group_Payment_Promise_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Invoice_Group_Payment_Promise_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Invoice_Group_Payment_Promise_Variance_Fields>;
};


/** aggregate fields of "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Invoice_Group_Payment_Promise_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Invoice_Group_Payment_Promise_Max_Order_By>;
  min?: Maybe<Risolto_Invoice_Group_Payment_Promise_Min_Order_By>;
  stddev?: Maybe<Risolto_Invoice_Group_Payment_Promise_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Invoice_Group_Payment_Promise_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Invoice_Group_Payment_Promise_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Invoice_Group_Payment_Promise_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Invoice_Group_Payment_Promise_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Invoice_Group_Payment_Promise_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Invoice_Group_Payment_Promise_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Invoice_Group_Payment_Promise_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Invoice_Group_Payment_Promise_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Invoice_Group_Payment_Promise_Avg_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.invoice_group_payment_promise". All fields are combined with a logical 'AND'. */
export type Risolto_Invoice_Group_Payment_Promise_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>>;
  _not?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_promise?: Maybe<Uuid_Comparison_Exp>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.invoice_group_payment_promise" */
export enum Risolto_Invoice_Group_Payment_Promise_Constraint {
  /** unique or primary key constraint on columns "reference" */
  InvoiceGroupPaymentPromisePkey = 'invoice_group_payment_promise_pkey'
}

/** input type for incrementing numeric columns in table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Invoice_Group_Payment_Promise_Max_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Invoice_Group_Payment_Promise_Min_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Mutation_Response = {
  __typename?: 'risolto_invoice_group_payment_promise_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Invoice_Group_Payment_Promise>;
};

/** on_conflict condition type for table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_On_Conflict = {
  constraint: Risolto_Invoice_Group_Payment_Promise_Constraint;
  update_columns?: Array<Risolto_Invoice_Group_Payment_Promise_Update_Column>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.invoice_group_payment_promise". */
export type Risolto_Invoice_Group_Payment_Promise_Order_By = {
  created_at?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_group_payment_promise */
export type Risolto_Invoice_Group_Payment_Promise_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.invoice_group_payment_promise" */
export enum Risolto_Invoice_Group_Payment_Promise_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Invoice_Group_Payment_Promise_Stddev_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Invoice_Group_Payment_Promise_Stddev_Pop_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Invoice_Group_Payment_Promise_Stddev_Samp_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Group_Payment_Promise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Group_Payment_Promise_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Invoice_Group_Payment_Promise_Sum_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.invoice_group_payment_promise" */
export enum Risolto_Invoice_Group_Payment_Promise_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Group_Payment_Promise_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Invoice_Group_Payment_Promise_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Group_Payment_Promise_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Group_Payment_Promise_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Invoice_Group_Payment_Promise_Var_Pop_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Invoice_Group_Payment_Promise_Var_Samp_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Invoice_Group_Payment_Promise_Variance_Fields = {
  __typename?: 'risolto_invoice_group_payment_promise_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.invoice_group_payment_promise" */
export type Risolto_Invoice_Group_Payment_Promise_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** select columns of table "risolto.invoice_group_payment" */
export enum Risolto_Invoice_Group_Payment_Select_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  Payment = 'payment',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Set_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Invoice_Group_Payment_Stddev_Fields = {
  __typename?: 'risolto_invoice_group_payment_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Invoice_Group_Payment_Stddev_Pop_Fields = {
  __typename?: 'risolto_invoice_group_payment_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Invoice_Group_Payment_Stddev_Samp_Fields = {
  __typename?: 'risolto_invoice_group_payment_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Group_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Group_Payment_Stream_Cursor_Value_Input = {
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Invoice_Group_Payment_Sum_Fields = {
  __typename?: 'risolto_invoice_group_payment_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.invoice_group_payment" */
export enum Risolto_Invoice_Group_Payment_Update_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  Payment = 'payment',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Group_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Invoice_Group_Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Group_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Group_Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Invoice_Group_Payment_Var_Pop_Fields = {
  __typename?: 'risolto_invoice_group_payment_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Invoice_Group_Payment_Var_Samp_Fields = {
  __typename?: 'risolto_invoice_group_payment_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Invoice_Group_Payment_Variance_Fields = {
  __typename?: 'risolto_invoice_group_payment_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.invoice_group_payment" */
export type Risolto_Invoice_Group_Payment_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.invoice_group */
export type Risolto_Invoice_Group_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.invoice_group" */
export enum Risolto_Invoice_Group_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.invoice_group" */
export type Risolto_Invoice_Group_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Invoice_Group_Stddev_Fields = {
  __typename?: 'risolto_invoice_group_stddev_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Invoice_Group_Stddev_Pop_Fields = {
  __typename?: 'risolto_invoice_group_stddev_pop_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Invoice_Group_Stddev_Samp_Fields = {
  __typename?: 'risolto_invoice_group_stddev_samp_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "risolto_invoice_group" */
export type Risolto_Invoice_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Invoice_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Invoice_Group_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Invoice_Group_Sum_Fields = {
  __typename?: 'risolto_invoice_group_sum_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "risolto.invoice_group" */
export enum Risolto_Invoice_Group_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Invoice_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Invoice_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Invoice_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Invoice_Group_Var_Pop_Fields = {
  __typename?: 'risolto_invoice_group_var_pop_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_samp on columns */
export type Risolto_Invoice_Group_Var_Samp_Fields = {
  __typename?: 'risolto_invoice_group_var_samp_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate variance on columns */
export type Risolto_Invoice_Group_Variance_Fields = {
  __typename?: 'risolto_invoice_group_variance_fields';
  /** invoices - credit notes + debit notes - payments */
  balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* open amount */
  open_amount?: Maybe<Scalars['numeric']>;
  /** credit_notes - debit notes + payments */
  other_balance_amount?: Maybe<Scalars['numeric']>;
  /** *invoice* total amount */
  total_amount?: Maybe<Scalars['numeric']>;
};

export type Risolto_Invoicing_Channel_Endpoints_V1_Args = {
  q_channels?: Maybe<Scalars['_text']>;
  q_legal_entity?: Maybe<Scalars['uuid']>;
  q_participant?: Maybe<Scalars['uuid']>;
  q_recipient?: Maybe<Scalars['uuid']>;
};

export type Risolto_Invoicing_Channel_Endpoints_V2_Args = {
  q_contacts_first?: Maybe<Scalars['Boolean']>;
  q_dunning?: Maybe<Scalars['Boolean']>;
  q_invoicing?: Maybe<Scalars['Boolean']>;
  q_participant?: Maybe<Scalars['uuid']>;
  q_recipient?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "risolto.iso_country_code" */
export type Risolto_Iso_Country_Code = {
  __typename?: 'risolto_iso_country_code';
  country_code: Scalars['String'];
};

/** aggregated selection of "risolto.iso_country_code" */
export type Risolto_Iso_Country_Code_Aggregate = {
  __typename?: 'risolto_iso_country_code_aggregate';
  aggregate?: Maybe<Risolto_Iso_Country_Code_Aggregate_Fields>;
  nodes: Array<Risolto_Iso_Country_Code>;
};

/** aggregate fields of "risolto.iso_country_code" */
export type Risolto_Iso_Country_Code_Aggregate_Fields = {
  __typename?: 'risolto_iso_country_code_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Iso_Country_Code_Max_Fields>;
  min?: Maybe<Risolto_Iso_Country_Code_Min_Fields>;
};


/** aggregate fields of "risolto.iso_country_code" */
export type Risolto_Iso_Country_Code_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Iso_Country_Code_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.iso_country_code". All fields are combined with a logical 'AND'. */
export type Risolto_Iso_Country_Code_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Iso_Country_Code_Bool_Exp>>;
  _not?: Maybe<Risolto_Iso_Country_Code_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Iso_Country_Code_Bool_Exp>>;
  country_code?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.iso_country_code" */
export enum Risolto_Iso_Country_Code_Constraint {
  /** unique or primary key constraint on columns "country_code" */
  IsoCountryCodePkey = 'iso_country_code_pkey'
}

export enum Risolto_Iso_Country_Code_Enum {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cs = 'CS',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xe = 'XE',
  Xk = 'XK',
  Xx = 'XX',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

/** Boolean expression to compare columns of type "risolto_iso_country_code_enum". All fields are combined with logical 'AND'. */
export type Risolto_Iso_Country_Code_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Iso_Country_Code_Enum>;
  _in?: Maybe<Array<Risolto_Iso_Country_Code_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Iso_Country_Code_Enum>;
  _nin?: Maybe<Array<Risolto_Iso_Country_Code_Enum>>;
};

/** input type for inserting data into table "risolto.iso_country_code" */
export type Risolto_Iso_Country_Code_Insert_Input = {
  country_code?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Iso_Country_Code_Max_Fields = {
  __typename?: 'risolto_iso_country_code_max_fields';
  country_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Iso_Country_Code_Min_Fields = {
  __typename?: 'risolto_iso_country_code_min_fields';
  country_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.iso_country_code" */
export type Risolto_Iso_Country_Code_Mutation_Response = {
  __typename?: 'risolto_iso_country_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Iso_Country_Code>;
};

/** on_conflict condition type for table "risolto.iso_country_code" */
export type Risolto_Iso_Country_Code_On_Conflict = {
  constraint: Risolto_Iso_Country_Code_Constraint;
  update_columns?: Array<Risolto_Iso_Country_Code_Update_Column>;
  where?: Maybe<Risolto_Iso_Country_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.iso_country_code". */
export type Risolto_Iso_Country_Code_Order_By = {
  country_code?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.iso_country_code */
export type Risolto_Iso_Country_Code_Pk_Columns_Input = {
  country_code: Scalars['String'];
};

/** select columns of table "risolto.iso_country_code" */
export enum Risolto_Iso_Country_Code_Select_Column {
  /** column name */
  CountryCode = 'country_code'
}

/** input type for updating data in table "risolto.iso_country_code" */
export type Risolto_Iso_Country_Code_Set_Input = {
  country_code?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_iso_country_code" */
export type Risolto_Iso_Country_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Iso_Country_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Iso_Country_Code_Stream_Cursor_Value_Input = {
  country_code?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.iso_country_code" */
export enum Risolto_Iso_Country_Code_Update_Column {
  /** column name */
  CountryCode = 'country_code'
}

export type Risolto_Iso_Country_Code_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Iso_Country_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Iso_Country_Code_Bool_Exp;
};

/** columns and relationships of "risolto.job" */
export type Risolto_Job = {
  __typename?: 'risolto_job';
  created_at: Scalars['timestamptz'];
  job_id: Scalars['String'];
  job_type: Scalars['String'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  processing_status: Scalars['String'];
  progress?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  raw_data?: Maybe<Scalars['String']>;
  reference: Scalars['uuid'];
  request_data?: Maybe<Scalars['jsonb']>;
  response_data?: Maybe<Scalars['jsonb']>;
  stopped_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.job" */
export type Risolto_JobRequest_DataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.job" */
export type Risolto_JobResponse_DataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.job" */
export type Risolto_Job_Aggregate = {
  __typename?: 'risolto_job_aggregate';
  aggregate?: Maybe<Risolto_Job_Aggregate_Fields>;
  nodes: Array<Risolto_Job>;
};

/** aggregate fields of "risolto.job" */
export type Risolto_Job_Aggregate_Fields = {
  __typename?: 'risolto_job_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Job_Max_Fields>;
  min?: Maybe<Risolto_Job_Min_Fields>;
};


/** aggregate fields of "risolto.job" */
export type Risolto_Job_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Job_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Job_Append_Input = {
  request_data?: Maybe<Scalars['jsonb']>;
  response_data?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.job". All fields are combined with a logical 'AND'. */
export type Risolto_Job_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Job_Bool_Exp>>;
  _not?: Maybe<Risolto_Job_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Job_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  job_id?: Maybe<String_Comparison_Exp>;
  job_type?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  processing_status?: Maybe<String_Comparison_Exp>;
  progress?: Maybe<String_Comparison_Exp>;
  raw_data?: Maybe<String_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  request_data?: Maybe<Jsonb_Comparison_Exp>;
  response_data?: Maybe<Jsonb_Comparison_Exp>;
  stopped_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.job" */
export enum Risolto_Job_Constraint {
  /** unique or primary key constraint on columns "reference" */
  JobPkey = 'job_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Job_Delete_At_Path_Input = {
  request_data?: Maybe<Array<Scalars['String']>>;
  response_data?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Job_Delete_Elem_Input = {
  request_data?: Maybe<Scalars['Int']>;
  response_data?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Job_Delete_Key_Input = {
  request_data?: Maybe<Scalars['String']>;
  response_data?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.job" */
export type Risolto_Job_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  job_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  processing_status?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  request_data?: Maybe<Scalars['jsonb']>;
  response_data?: Maybe<Scalars['jsonb']>;
  stopped_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Job_Max_Fields = {
  __typename?: 'risolto_job_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  job_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  stopped_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Job_Min_Fields = {
  __typename?: 'risolto_job_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  job_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  stopped_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.job" */
export type Risolto_Job_Mutation_Response = {
  __typename?: 'risolto_job_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Job>;
};

/** on_conflict condition type for table "risolto.job" */
export type Risolto_Job_On_Conflict = {
  constraint: Risolto_Job_Constraint;
  update_columns?: Array<Risolto_Job_Update_Column>;
  where?: Maybe<Risolto_Job_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.job". */
export type Risolto_Job_Order_By = {
  created_at?: Maybe<Order_By>;
  job_id?: Maybe<Order_By>;
  job_type?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  processing_status?: Maybe<Order_By>;
  progress?: Maybe<Order_By>;
  raw_data?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  request_data?: Maybe<Order_By>;
  response_data?: Maybe<Order_By>;
  stopped_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.job */
export type Risolto_Job_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Job_Prepend_Input = {
  request_data?: Maybe<Scalars['jsonb']>;
  response_data?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.job" */
export enum Risolto_Job_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  JobId = 'job_id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Progress = 'progress',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Reference = 'reference',
  /** column name */
  RequestData = 'request_data',
  /** column name */
  ResponseData = 'response_data',
  /** column name */
  StoppedAt = 'stopped_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.job" */
export type Risolto_Job_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  job_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  request_data?: Maybe<Scalars['jsonb']>;
  response_data?: Maybe<Scalars['jsonb']>;
  stopped_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_job" */
export type Risolto_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Job_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Job_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  job_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  request_data?: Maybe<Scalars['jsonb']>;
  response_data?: Maybe<Scalars['jsonb']>;
  stopped_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.job" */
export enum Risolto_Job_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  JobId = 'job_id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Progress = 'progress',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Reference = 'reference',
  /** column name */
  RequestData = 'request_data',
  /** column name */
  ResponseData = 'response_data',
  /** column name */
  StoppedAt = 'stopped_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Job_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Job_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Job_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Job_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Job_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Job_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Job_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Job_Bool_Exp;
};

/** ISO 639-1:2002 - 2-letter language code */
export type Risolto_Language_Code = {
  __typename?: 'risolto_language_code';
  language_code: Scalars['String'];
};

/** aggregated selection of "risolto.language_code" */
export type Risolto_Language_Code_Aggregate = {
  __typename?: 'risolto_language_code_aggregate';
  aggregate?: Maybe<Risolto_Language_Code_Aggregate_Fields>;
  nodes: Array<Risolto_Language_Code>;
};

/** aggregate fields of "risolto.language_code" */
export type Risolto_Language_Code_Aggregate_Fields = {
  __typename?: 'risolto_language_code_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Language_Code_Max_Fields>;
  min?: Maybe<Risolto_Language_Code_Min_Fields>;
};


/** aggregate fields of "risolto.language_code" */
export type Risolto_Language_Code_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Language_Code_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.language_code". All fields are combined with a logical 'AND'. */
export type Risolto_Language_Code_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Language_Code_Bool_Exp>>;
  _not?: Maybe<Risolto_Language_Code_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Language_Code_Bool_Exp>>;
  language_code?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.language_code" */
export enum Risolto_Language_Code_Constraint {
  /** unique or primary key constraint on columns "language_code" */
  LanguageCodePkey = 'language_code_pkey'
}

export enum Risolto_Language_Code_Enum {
  Aa = 'aa',
  Ab = 'ab',
  Ae = 'ae',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  As = 'as',
  Av = 'av',
  Ay = 'ay',
  Az = 'az',
  Ba = 'ba',
  Be = 'be',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Br = 'br',
  Bs = 'bs',
  Ca = 'ca',
  Ce = 'ce',
  Ch = 'ch',
  Co = 'co',
  Cr = 'cr',
  Cs = 'cs',
  Cu = 'cu',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  De = 'de',
  Dp = 'dp',
  Dv = 'dv',
  Dz = 'dz',
  Ee = 'ee',
  El = 'el',
  En = 'en',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Ff = 'ff',
  Fi = 'fi',
  Fj = 'fj',
  Fo = 'fo',
  Fr = 'fr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gu = 'gu',
  Gv = 'gv',
  Ha = 'ha',
  He = 'he',
  Hi = 'hi',
  Ho = 'ho',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Hz = 'hz',
  Ia = 'ia',
  Id = 'id',
  Ie = 'ie',
  Ig = 'ig',
  Ii = 'ii',
  Ik = 'ik',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Iu = 'iu',
  Ja = 'ja',
  Jv = 'jv',
  Ka = 'ka',
  Kg = 'kg',
  Ki = 'ki',
  Kj = 'kj',
  Kk = 'kk',
  Kl = 'kl',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Kr = 'kr',
  Ks = 'ks',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lg = 'lg',
  Li = 'li',
  Ln = 'ln',
  Lo = 'lo',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Mg = 'mg',
  Mh = 'mh',
  Mi = 'mi',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mo = 'mo',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  My = 'my',
  Na = 'na',
  Nb = 'nb',
  Nd = 'nd',
  Ne = 'ne',
  Ng = 'ng',
  Nl = 'nl',
  Nn = 'nn',
  No = 'no',
  Nr = 'nr',
  Nv = 'nv',
  Ny = 'ny',
  Oc = 'oc',
  Oj = 'oj',
  Om = 'om',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Pi = 'pi',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  Qu = 'qu',
  Rm = 'rm',
  Rn = 'rn',
  Ro = 'ro',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Te = 'te',
  Tg = 'tg',
  Th = 'th',
  Ti = 'ti',
  Tk = 'tk',
  Tl = 'tl',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Ts = 'ts',
  Tt = 'tt',
  Tw = 'tw',
  Ty = 'ty',
  Ug = 'ug',
  Uk = 'uk',
  Un = 'un',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  Vi = 'vi',
  Vo = 'vo',
  Wa = 'wa',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Za = 'za',
  Zh = 'zh',
  Zu = 'zu'
}

/** Boolean expression to compare columns of type "risolto_language_code_enum". All fields are combined with logical 'AND'. */
export type Risolto_Language_Code_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Language_Code_Enum>;
  _in?: Maybe<Array<Risolto_Language_Code_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Language_Code_Enum>;
  _nin?: Maybe<Array<Risolto_Language_Code_Enum>>;
};

/** input type for inserting data into table "risolto.language_code" */
export type Risolto_Language_Code_Insert_Input = {
  language_code?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Language_Code_Max_Fields = {
  __typename?: 'risolto_language_code_max_fields';
  language_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Language_Code_Min_Fields = {
  __typename?: 'risolto_language_code_min_fields';
  language_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.language_code" */
export type Risolto_Language_Code_Mutation_Response = {
  __typename?: 'risolto_language_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Language_Code>;
};

/** on_conflict condition type for table "risolto.language_code" */
export type Risolto_Language_Code_On_Conflict = {
  constraint: Risolto_Language_Code_Constraint;
  update_columns?: Array<Risolto_Language_Code_Update_Column>;
  where?: Maybe<Risolto_Language_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.language_code". */
export type Risolto_Language_Code_Order_By = {
  language_code?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.language_code */
export type Risolto_Language_Code_Pk_Columns_Input = {
  language_code: Scalars['String'];
};

/** select columns of table "risolto.language_code" */
export enum Risolto_Language_Code_Select_Column {
  /** column name */
  LanguageCode = 'language_code'
}

/** input type for updating data in table "risolto.language_code" */
export type Risolto_Language_Code_Set_Input = {
  language_code?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_language_code" */
export type Risolto_Language_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Language_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Language_Code_Stream_Cursor_Value_Input = {
  language_code?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.language_code" */
export enum Risolto_Language_Code_Update_Column {
  /** column name */
  LanguageCode = 'language_code'
}

export type Risolto_Language_Code_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Language_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Language_Code_Bool_Exp;
};

/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_Entity = {
  __typename?: 'risolto_legal_entity';
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  /** DEPRECATED */
  address: Scalars['jsonb'];
  allow_automated_execution?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED. DON'T USE. */
  branding: Scalars['jsonb'];
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  communication_templates: Array<Risolto_Communication_Template>;
  /** An aggregate relationship */
  communication_templates_aggregate: Risolto_Communication_Template_Aggregate;
  /** The name of the party as registered with the relevant legal authority. */
  company_id: Scalars['String'];
  /** Type of the company_id. E.g. VAT, SIREN, ... */
  company_id_type: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields: Scalars['jsonb'];
  /** Debtor Portal identifier */
  debtor_portal_id?: Maybe<Scalars['String']>;
  default: Scalars['Boolean'];
  display_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  document_interchanges: Array<Risolto_Document_Interchange>;
  /** An aggregate relationship */
  document_interchanges_aggregate: Risolto_Document_Interchange_Aggregate;
  general_email_address?: Maybe<Scalars['String']>;
  /** An array relationship */
  invoice_documents: Array<Risolto_Invoice_Document>;
  /** An aggregate relationship */
  invoice_documents_aggregate: Risolto_Invoice_Document_Aggregate;
  /** DEPRECATED. DON'T USE. */
  invoicing_email_address?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  notes: Array<Risolto_Note>;
  /** An aggregate relationship */
  notes_aggregate: Risolto_Note_Aggregate;
  /** An array relationship */
  open_balance_records: Array<Risolto_Open_Balance_Record>;
  /** An aggregate relationship */
  open_balance_records_aggregate: Risolto_Open_Balance_Record_Aggregate;
  participant: Scalars['uuid'];
  /** An array relationship */
  participant_api_app_clients: Array<Risolto_Participant_Api_App_Client>;
  /** An aggregate relationship */
  participant_api_app_clients_aggregate: Risolto_Participant_Api_App_Client_Aggregate;
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An array relationship */
  participant_users: Array<Risolto_Participant_User>;
  /** An aggregate relationship */
  participant_users_aggregate: Risolto_Participant_User_Aggregate;
  /** An array relationship */
  payment_plans: Array<Risolto_Payment_Plan>;
  /** An aggregate relationship */
  payment_plans_aggregate: Risolto_Payment_Plan_Aggregate;
  /** An array relationship */
  payment_promises: Array<Risolto_Payment_Promise>;
  /** An aggregate relationship */
  payment_promises_aggregate: Risolto_Payment_Promise_Aggregate;
  /** DEPRECATED */
  phones: Scalars['jsonb'];
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Scalars['jsonb']>;
  processing_details_version?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  recipients: Array<Risolto_Recipient>;
  /** An aggregate relationship */
  recipients_aggregate: Risolto_Recipient_Aggregate;
  reference: Scalars['uuid'];
  /** The name of the party as registered with the relevant legal authority. */
  registration_name: Scalars['String'];
  /** An array relationship */
  single_sign_ons: Array<Risolto_Single_Sign_On>;
  /** An aggregate relationship */
  single_sign_ons_aggregate: Risolto_Single_Sign_On_Aggregate;
  /** DEPRECATED. DON'T USE. */
  support_email_address?: Maybe<Scalars['String']>;
  /** An array relationship */
  system_integrations: Array<Risolto_System_Integration>;
  /** An aggregate relationship */
  system_integrations_aggregate: Risolto_System_Integration_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityAddressArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityBrandingArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityChannel_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityCommunication_TemplatesArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityCommunication_Templates_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityDocument_InterchangesArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityDocument_Interchanges_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityInvoice_DocumentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityInvoice_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityNotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityNotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityOpen_Balance_RecordsArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityOpen_Balance_Records_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityParticipant_Api_App_ClientsArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityParticipant_Api_App_Clients_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityParticipant_UsersArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityParticipant_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityPayment_PlansArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityPayment_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityPayment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityPayment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityPhonesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityProcessing_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityRecipientsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntityRecipients_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntitySingle_Sign_OnsArgs = {
  distinct_on?: Maybe<Array<Risolto_Single_Sign_On_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Single_Sign_On_Order_By>>;
  where?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntitySingle_Sign_Ons_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Single_Sign_On_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Single_Sign_On_Order_By>>;
  where?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntitySystem_IntegrationsArgs = {
  distinct_on?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_System_Integration_Order_By>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};


/** columns and relationships of "risolto.legal_entity" */
export type Risolto_Legal_EntitySystem_Integrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_System_Integration_Order_By>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};

/** aggregated selection of "risolto.legal_entity" */
export type Risolto_Legal_Entity_Aggregate = {
  __typename?: 'risolto_legal_entity_aggregate';
  aggregate?: Maybe<Risolto_Legal_Entity_Aggregate_Fields>;
  nodes: Array<Risolto_Legal_Entity>;
};

export type Risolto_Legal_Entity_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Legal_Entity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Legal_Entity_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Legal_Entity_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Legal_Entity_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Legal_Entity_Select_Column_Risolto_Legal_Entity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Legal_Entity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Legal_Entity_Select_Column_Risolto_Legal_Entity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Legal_Entity_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Legal_Entity_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.legal_entity" */
export type Risolto_Legal_Entity_Aggregate_Fields = {
  __typename?: 'risolto_legal_entity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Legal_Entity_Max_Fields>;
  min?: Maybe<Risolto_Legal_Entity_Min_Fields>;
};


/** aggregate fields of "risolto.legal_entity" */
export type Risolto_Legal_Entity_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Legal_Entity_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.legal_entity" */
export type Risolto_Legal_Entity_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Legal_Entity_Max_Order_By>;
  min?: Maybe<Risolto_Legal_Entity_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Legal_Entity_Append_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. DON'T USE. */
  branding?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Scalars['jsonb']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  phones?: Maybe<Scalars['jsonb']>;
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.legal_entity" */
export type Risolto_Legal_Entity_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Legal_Entity_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Legal_Entity_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.legal_entity". All fields are combined with a logical 'AND'. */
export type Risolto_Legal_Entity_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Legal_Entity_Bool_Exp>>;
  _not?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Legal_Entity_Bool_Exp>>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  address?: Maybe<Jsonb_Comparison_Exp>;
  allow_automated_execution?: Maybe<Boolean_Comparison_Exp>;
  branding?: Maybe<Jsonb_Comparison_Exp>;
  channel_details?: Maybe<Jsonb_Comparison_Exp>;
  communication_templates?: Maybe<Risolto_Communication_Template_Bool_Exp>;
  communication_templates_aggregate?: Maybe<Risolto_Communication_Template_Aggregate_Bool_Exp>;
  company_id?: Maybe<String_Comparison_Exp>;
  company_id_type?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  debtor_portal_id?: Maybe<String_Comparison_Exp>;
  default?: Maybe<Boolean_Comparison_Exp>;
  display_name?: Maybe<String_Comparison_Exp>;
  document_interchanges?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  document_interchanges_aggregate?: Maybe<Risolto_Document_Interchange_Aggregate_Bool_Exp>;
  general_email_address?: Maybe<String_Comparison_Exp>;
  invoice_documents?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  invoice_documents_aggregate?: Maybe<Risolto_Invoice_Document_Aggregate_Bool_Exp>;
  invoicing_email_address?: Maybe<String_Comparison_Exp>;
  logical_id?: Maybe<String_Comparison_Exp>;
  notes?: Maybe<Risolto_Note_Bool_Exp>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Bool_Exp>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_api_app_clients?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
  participant_api_app_clients_aggregate?: Maybe<Risolto_Participant_Api_App_Client_Aggregate_Bool_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  participant_users?: Maybe<Risolto_Participant_User_Bool_Exp>;
  participant_users_aggregate?: Maybe<Risolto_Participant_User_Aggregate_Bool_Exp>;
  payment_plans?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  payment_plans_aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Bool_Exp>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Bool_Exp>;
  phones?: Maybe<Jsonb_Comparison_Exp>;
  processing_details?: Maybe<Jsonb_Comparison_Exp>;
  processing_details_version?: Maybe<Uuid_Comparison_Exp>;
  recipients?: Maybe<Risolto_Recipient_Bool_Exp>;
  recipients_aggregate?: Maybe<Risolto_Recipient_Aggregate_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  registration_name?: Maybe<String_Comparison_Exp>;
  single_sign_ons?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
  single_sign_ons_aggregate?: Maybe<Risolto_Single_Sign_On_Aggregate_Bool_Exp>;
  support_email_address?: Maybe<String_Comparison_Exp>;
  system_integrations?: Maybe<Risolto_System_Integration_Bool_Exp>;
  system_integrations_aggregate?: Maybe<Risolto_System_Integration_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.legal_entity" */
export enum Risolto_Legal_Entity_Constraint {
  /** unique or primary key constraint on columns "logical_id" */
  LegalEntityLogicalIdKey = 'legal_entity_logical_id_key',
  /** unique or primary key constraint on columns "reference" */
  LegalEntityPkey = 'legal_entity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Legal_Entity_Delete_At_Path_Input = {
  /** DEPRECATED */
  address?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED. DON'T USE. */
  branding?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Array<Scalars['String']>>;
  custom_fields?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED */
  phones?: Maybe<Array<Scalars['String']>>;
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Legal_Entity_Delete_Elem_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['Int']>;
  /** DEPRECATED. DON'T USE. */
  branding?: Maybe<Scalars['Int']>;
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Scalars['Int']>;
  custom_fields?: Maybe<Scalars['Int']>;
  /** DEPRECATED */
  phones?: Maybe<Scalars['Int']>;
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Legal_Entity_Delete_Key_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  branding?: Maybe<Scalars['String']>;
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  phones?: Maybe<Scalars['String']>;
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.legal_entity" */
export type Risolto_Legal_Entity_Insert_Input = {
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  allow_automated_execution?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED. DON'T USE. */
  branding?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Scalars['jsonb']>;
  communication_templates?: Maybe<Risolto_Communication_Template_Arr_Rel_Insert_Input>;
  /** The name of the party as registered with the relevant legal authority. */
  company_id?: Maybe<Scalars['String']>;
  /** Type of the company_id. E.g. VAT, SIREN, ... */
  company_id_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** Debtor Portal identifier */
  debtor_portal_id?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  display_name?: Maybe<Scalars['String']>;
  document_interchanges?: Maybe<Risolto_Document_Interchange_Arr_Rel_Insert_Input>;
  general_email_address?: Maybe<Scalars['String']>;
  invoice_documents?: Maybe<Risolto_Invoice_Document_Arr_Rel_Insert_Input>;
  /** DEPRECATED. DON'T USE. */
  invoicing_email_address?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  notes?: Maybe<Risolto_Note_Arr_Rel_Insert_Input>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Arr_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_api_app_clients?: Maybe<Risolto_Participant_Api_App_Client_Arr_Rel_Insert_Input>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  participant_users?: Maybe<Risolto_Participant_User_Arr_Rel_Insert_Input>;
  payment_plans?: Maybe<Risolto_Payment_Plan_Arr_Rel_Insert_Input>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Arr_Rel_Insert_Input>;
  /** DEPRECATED */
  phones?: Maybe<Scalars['jsonb']>;
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Scalars['jsonb']>;
  processing_details_version?: Maybe<Scalars['uuid']>;
  recipients?: Maybe<Risolto_Recipient_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  /** The name of the party as registered with the relevant legal authority. */
  registration_name?: Maybe<Scalars['String']>;
  single_sign_ons?: Maybe<Risolto_Single_Sign_On_Arr_Rel_Insert_Input>;
  /** DEPRECATED. DON'T USE. */
  support_email_address?: Maybe<Scalars['String']>;
  system_integrations?: Maybe<Risolto_System_Integration_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Legal_Entity_Max_Fields = {
  __typename?: 'risolto_legal_entity_max_fields';
  /** The name of the party as registered with the relevant legal authority. */
  company_id?: Maybe<Scalars['String']>;
  /** Type of the company_id. E.g. VAT, SIREN, ... */
  company_id_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Debtor Portal identifier */
  debtor_portal_id?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  general_email_address?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  invoicing_email_address?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_details_version?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** The name of the party as registered with the relevant legal authority. */
  registration_name?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  support_email_address?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.legal_entity" */
export type Risolto_Legal_Entity_Max_Order_By = {
  /** The name of the party as registered with the relevant legal authority. */
  company_id?: Maybe<Order_By>;
  /** Type of the company_id. E.g. VAT, SIREN, ... */
  company_id_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  /** Debtor Portal identifier */
  debtor_portal_id?: Maybe<Order_By>;
  display_name?: Maybe<Order_By>;
  general_email_address?: Maybe<Order_By>;
  /** DEPRECATED. DON'T USE. */
  invoicing_email_address?: Maybe<Order_By>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  processing_details_version?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** The name of the party as registered with the relevant legal authority. */
  registration_name?: Maybe<Order_By>;
  /** DEPRECATED. DON'T USE. */
  support_email_address?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Legal_Entity_Min_Fields = {
  __typename?: 'risolto_legal_entity_min_fields';
  /** The name of the party as registered with the relevant legal authority. */
  company_id?: Maybe<Scalars['String']>;
  /** Type of the company_id. E.g. VAT, SIREN, ... */
  company_id_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Debtor Portal identifier */
  debtor_portal_id?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  general_email_address?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  invoicing_email_address?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_details_version?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** The name of the party as registered with the relevant legal authority. */
  registration_name?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  support_email_address?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.legal_entity" */
export type Risolto_Legal_Entity_Min_Order_By = {
  /** The name of the party as registered with the relevant legal authority. */
  company_id?: Maybe<Order_By>;
  /** Type of the company_id. E.g. VAT, SIREN, ... */
  company_id_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  /** Debtor Portal identifier */
  debtor_portal_id?: Maybe<Order_By>;
  display_name?: Maybe<Order_By>;
  general_email_address?: Maybe<Order_By>;
  /** DEPRECATED. DON'T USE. */
  invoicing_email_address?: Maybe<Order_By>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  processing_details_version?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** The name of the party as registered with the relevant legal authority. */
  registration_name?: Maybe<Order_By>;
  /** DEPRECATED. DON'T USE. */
  support_email_address?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.legal_entity" */
export type Risolto_Legal_Entity_Mutation_Response = {
  __typename?: 'risolto_legal_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Legal_Entity>;
};

/** input type for inserting object relation for remote table "risolto.legal_entity" */
export type Risolto_Legal_Entity_Obj_Rel_Insert_Input = {
  data: Risolto_Legal_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Legal_Entity_On_Conflict>;
};

/** on_conflict condition type for table "risolto.legal_entity" */
export type Risolto_Legal_Entity_On_Conflict = {
  constraint: Risolto_Legal_Entity_Constraint;
  update_columns?: Array<Risolto_Legal_Entity_Update_Column>;
  where?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.legal_entity". */
export type Risolto_Legal_Entity_Order_By = {
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  address?: Maybe<Order_By>;
  allow_automated_execution?: Maybe<Order_By>;
  branding?: Maybe<Order_By>;
  channel_details?: Maybe<Order_By>;
  communication_templates_aggregate?: Maybe<Risolto_Communication_Template_Aggregate_Order_By>;
  company_id?: Maybe<Order_By>;
  company_id_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  debtor_portal_id?: Maybe<Order_By>;
  default?: Maybe<Order_By>;
  display_name?: Maybe<Order_By>;
  document_interchanges_aggregate?: Maybe<Risolto_Document_Interchange_Aggregate_Order_By>;
  general_email_address?: Maybe<Order_By>;
  invoice_documents_aggregate?: Maybe<Risolto_Invoice_Document_Aggregate_Order_By>;
  invoicing_email_address?: Maybe<Order_By>;
  logical_id?: Maybe<Order_By>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Order_By>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Order_By>;
  participant?: Maybe<Order_By>;
  participant_api_app_clients_aggregate?: Maybe<Risolto_Participant_Api_App_Client_Aggregate_Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  participant_users_aggregate?: Maybe<Risolto_Participant_User_Aggregate_Order_By>;
  payment_plans_aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Order_By>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Order_By>;
  phones?: Maybe<Order_By>;
  processing_details?: Maybe<Order_By>;
  processing_details_version?: Maybe<Order_By>;
  recipients_aggregate?: Maybe<Risolto_Recipient_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  registration_name?: Maybe<Order_By>;
  single_sign_ons_aggregate?: Maybe<Risolto_Single_Sign_On_Aggregate_Order_By>;
  support_email_address?: Maybe<Order_By>;
  system_integrations_aggregate?: Maybe<Risolto_System_Integration_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.legal_entity */
export type Risolto_Legal_Entity_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Legal_Entity_Prepend_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. DON'T USE. */
  branding?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Scalars['jsonb']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  phones?: Maybe<Scalars['jsonb']>;
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.legal_entity" */
export enum Risolto_Legal_Entity_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AllowAutomatedExecution = 'allow_automated_execution',
  /** column name */
  Branding = 'branding',
  /** column name */
  ChannelDetails = 'channel_details',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyIdType = 'company_id_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DebtorPortalId = 'debtor_portal_id',
  /** column name */
  Default = 'default',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GeneralEmailAddress = 'general_email_address',
  /** column name */
  InvoicingEmailAddress = 'invoicing_email_address',
  /** column name */
  LogicalId = 'logical_id',
  /** column name */
  Participant = 'participant',
  /** column name */
  Phones = 'phones',
  /** column name */
  ProcessingDetails = 'processing_details',
  /** column name */
  ProcessingDetailsVersion = 'processing_details_version',
  /** column name */
  Reference = 'reference',
  /** column name */
  RegistrationName = 'registration_name',
  /** column name */
  SupportEmailAddress = 'support_email_address',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_legal_entity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.legal_entity" */
export enum Risolto_Legal_Entity_Select_Column_Risolto_Legal_Entity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowAutomatedExecution = 'allow_automated_execution',
  /** column name */
  Default = 'default'
}

/** select "risolto_legal_entity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.legal_entity" */
export enum Risolto_Legal_Entity_Select_Column_Risolto_Legal_Entity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowAutomatedExecution = 'allow_automated_execution',
  /** column name */
  Default = 'default'
}

/** input type for updating data in table "risolto.legal_entity" */
export type Risolto_Legal_Entity_Set_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  allow_automated_execution?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED. DON'T USE. */
  branding?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Scalars['jsonb']>;
  /** The name of the party as registered with the relevant legal authority. */
  company_id?: Maybe<Scalars['String']>;
  /** Type of the company_id. E.g. VAT, SIREN, ... */
  company_id_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** Debtor Portal identifier */
  debtor_portal_id?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  display_name?: Maybe<Scalars['String']>;
  general_email_address?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  invoicing_email_address?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  phones?: Maybe<Scalars['jsonb']>;
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Scalars['jsonb']>;
  processing_details_version?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** The name of the party as registered with the relevant legal authority. */
  registration_name?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  support_email_address?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_legal_entity" */
export type Risolto_Legal_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Legal_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Legal_Entity_Stream_Cursor_Value_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  allow_automated_execution?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED. DON'T USE. */
  branding?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED. Internal configuration containing email_domains, REST client id, … used for Participant Determination */
  channel_details?: Maybe<Scalars['jsonb']>;
  /** The name of the party as registered with the relevant legal authority. */
  company_id?: Maybe<Scalars['String']>;
  /** Type of the company_id. E.g. VAT, SIREN, ... */
  company_id_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** Debtor Portal identifier */
  debtor_portal_id?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  display_name?: Maybe<Scalars['String']>;
  general_email_address?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  invoicing_email_address?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  phones?: Maybe<Scalars['jsonb']>;
  /** Internal configuration containing parser information for this legal entity */
  processing_details?: Maybe<Scalars['jsonb']>;
  processing_details_version?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** The name of the party as registered with the relevant legal authority. */
  registration_name?: Maybe<Scalars['String']>;
  /** DEPRECATED. DON'T USE. */
  support_email_address?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.legal_entity" */
export enum Risolto_Legal_Entity_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AllowAutomatedExecution = 'allow_automated_execution',
  /** column name */
  Branding = 'branding',
  /** column name */
  ChannelDetails = 'channel_details',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyIdType = 'company_id_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DebtorPortalId = 'debtor_portal_id',
  /** column name */
  Default = 'default',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  GeneralEmailAddress = 'general_email_address',
  /** column name */
  InvoicingEmailAddress = 'invoicing_email_address',
  /** column name */
  LogicalId = 'logical_id',
  /** column name */
  Participant = 'participant',
  /** column name */
  Phones = 'phones',
  /** column name */
  ProcessingDetails = 'processing_details',
  /** column name */
  ProcessingDetailsVersion = 'processing_details_version',
  /** column name */
  Reference = 'reference',
  /** column name */
  RegistrationName = 'registration_name',
  /** column name */
  SupportEmailAddress = 'support_email_address',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Legal_Entity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Legal_Entity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Legal_Entity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Legal_Entity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Legal_Entity_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Legal_Entity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Legal_Entity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Legal_Entity_Bool_Exp;
};

/** columns and relationships of "risolto.locale" */
export type Risolto_Locale = {
  __typename?: 'risolto_locale';
  locale: Scalars['String'];
};

/** aggregated selection of "risolto.locale" */
export type Risolto_Locale_Aggregate = {
  __typename?: 'risolto_locale_aggregate';
  aggregate?: Maybe<Risolto_Locale_Aggregate_Fields>;
  nodes: Array<Risolto_Locale>;
};

/** aggregate fields of "risolto.locale" */
export type Risolto_Locale_Aggregate_Fields = {
  __typename?: 'risolto_locale_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Locale_Max_Fields>;
  min?: Maybe<Risolto_Locale_Min_Fields>;
};


/** aggregate fields of "risolto.locale" */
export type Risolto_Locale_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Locale_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.locale". All fields are combined with a logical 'AND'. */
export type Risolto_Locale_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Locale_Bool_Exp>>;
  _not?: Maybe<Risolto_Locale_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Locale_Bool_Exp>>;
  locale?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.locale" */
export enum Risolto_Locale_Constraint {
  /** unique or primary key constraint on columns "locale" */
  LocalePkey = 'locale_pkey'
}

/** input type for inserting data into table "risolto.locale" */
export type Risolto_Locale_Insert_Input = {
  locale?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Locale_Max_Fields = {
  __typename?: 'risolto_locale_max_fields';
  locale?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Locale_Min_Fields = {
  __typename?: 'risolto_locale_min_fields';
  locale?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.locale" */
export type Risolto_Locale_Mutation_Response = {
  __typename?: 'risolto_locale_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Locale>;
};

/** on_conflict condition type for table "risolto.locale" */
export type Risolto_Locale_On_Conflict = {
  constraint: Risolto_Locale_Constraint;
  update_columns?: Array<Risolto_Locale_Update_Column>;
  where?: Maybe<Risolto_Locale_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.locale". */
export type Risolto_Locale_Order_By = {
  locale?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.locale */
export type Risolto_Locale_Pk_Columns_Input = {
  locale: Scalars['String'];
};

/** select columns of table "risolto.locale" */
export enum Risolto_Locale_Select_Column {
  /** column name */
  Locale = 'locale'
}

/** input type for updating data in table "risolto.locale" */
export type Risolto_Locale_Set_Input = {
  locale?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_locale" */
export type Risolto_Locale_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Locale_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Locale_Stream_Cursor_Value_Input = {
  locale?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.locale" */
export enum Risolto_Locale_Update_Column {
  /** column name */
  Locale = 'locale'
}

export type Risolto_Locale_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Locale_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Locale_Bool_Exp;
};

/** Local cache of Magda Address Data */
export type Risolto_Magda_Cache = {
  __typename?: 'risolto_magda_cache';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  deceased_at?: Maybe<Scalars['date']>;
  error_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  error_type?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  is_valid: Scalars['Boolean'];
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  legal_id?: Maybe<Scalars['String']>;
  municipality_name?: Maybe<Scalars['String']>;
  nis_country_code?: Maybe<Scalars['String']>;
  nis_municipality_code?: Maybe<Scalars['String']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  post_box?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  street_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** Local cache of Magda Address Data */
export type Risolto_Magda_CacheCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.magda_cache" */
export type Risolto_Magda_Cache_Aggregate = {
  __typename?: 'risolto_magda_cache_aggregate';
  aggregate?: Maybe<Risolto_Magda_Cache_Aggregate_Fields>;
  nodes: Array<Risolto_Magda_Cache>;
};

/** aggregate fields of "risolto.magda_cache" */
export type Risolto_Magda_Cache_Aggregate_Fields = {
  __typename?: 'risolto_magda_cache_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Magda_Cache_Max_Fields>;
  min?: Maybe<Risolto_Magda_Cache_Min_Fields>;
};


/** aggregate fields of "risolto.magda_cache" */
export type Risolto_Magda_Cache_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Magda_Cache_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Magda_Cache_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.magda_cache". All fields are combined with a logical 'AND'. */
export type Risolto_Magda_Cache_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Magda_Cache_Bool_Exp>>;
  _not?: Maybe<Risolto_Magda_Cache_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Magda_Cache_Bool_Exp>>;
  city?: Maybe<String_Comparison_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  deceased_at?: Maybe<Date_Comparison_Exp>;
  error_id?: Maybe<String_Comparison_Exp>;
  error_message?: Maybe<String_Comparison_Exp>;
  error_type?: Maybe<String_Comparison_Exp>;
  house_number?: Maybe<String_Comparison_Exp>;
  is_valid?: Maybe<Boolean_Comparison_Exp>;
  iso_country_code?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  legal_id?: Maybe<String_Comparison_Exp>;
  municipality_name?: Maybe<String_Comparison_Exp>;
  nis_country_code?: Maybe<String_Comparison_Exp>;
  nis_municipality_code?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  post_box?: Maybe<String_Comparison_Exp>;
  postal_code?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  street_name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.magda_cache" */
export enum Risolto_Magda_Cache_Constraint {
  /** unique or primary key constraint on columns "participant", "legal_id" */
  MagdaAddressLegalIdParticipantKey = 'magda_address_legal_id_participant_key',
  /** unique or primary key constraint on columns "reference" */
  MagdaAddressPkey = 'magda_address_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Magda_Cache_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Magda_Cache_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Magda_Cache_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.magda_cache" */
export type Risolto_Magda_Cache_Insert_Input = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  deceased_at?: Maybe<Scalars['date']>;
  error_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  error_type?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  is_valid?: Maybe<Scalars['Boolean']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  legal_id?: Maybe<Scalars['String']>;
  municipality_name?: Maybe<Scalars['String']>;
  nis_country_code?: Maybe<Scalars['String']>;
  nis_municipality_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  post_box?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  street_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Magda_Cache_Max_Fields = {
  __typename?: 'risolto_magda_cache_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deceased_at?: Maybe<Scalars['date']>;
  error_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  error_type?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_id?: Maybe<Scalars['String']>;
  municipality_name?: Maybe<Scalars['String']>;
  nis_country_code?: Maybe<Scalars['String']>;
  nis_municipality_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  post_box?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  street_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Magda_Cache_Min_Fields = {
  __typename?: 'risolto_magda_cache_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deceased_at?: Maybe<Scalars['date']>;
  error_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  error_type?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_id?: Maybe<Scalars['String']>;
  municipality_name?: Maybe<Scalars['String']>;
  nis_country_code?: Maybe<Scalars['String']>;
  nis_municipality_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  post_box?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  street_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.magda_cache" */
export type Risolto_Magda_Cache_Mutation_Response = {
  __typename?: 'risolto_magda_cache_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Magda_Cache>;
};

/** on_conflict condition type for table "risolto.magda_cache" */
export type Risolto_Magda_Cache_On_Conflict = {
  constraint: Risolto_Magda_Cache_Constraint;
  update_columns?: Array<Risolto_Magda_Cache_Update_Column>;
  where?: Maybe<Risolto_Magda_Cache_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.magda_cache". */
export type Risolto_Magda_Cache_Order_By = {
  city?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  deceased_at?: Maybe<Order_By>;
  error_id?: Maybe<Order_By>;
  error_message?: Maybe<Order_By>;
  error_type?: Maybe<Order_By>;
  house_number?: Maybe<Order_By>;
  is_valid?: Maybe<Order_By>;
  iso_country_code?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  legal_id?: Maybe<Order_By>;
  municipality_name?: Maybe<Order_By>;
  nis_country_code?: Maybe<Order_By>;
  nis_municipality_code?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  post_box?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  street_name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.magda_cache */
export type Risolto_Magda_Cache_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Magda_Cache_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.magda_cache" */
export enum Risolto_Magda_Cache_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DeceasedAt = 'deceased_at',
  /** column name */
  ErrorId = 'error_id',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  ErrorType = 'error_type',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  IsoCountryCode = 'iso_country_code',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  MunicipalityName = 'municipality_name',
  /** column name */
  NisCountryCode = 'nis_country_code',
  /** column name */
  NisMunicipalityCode = 'nis_municipality_code',
  /** column name */
  Participant = 'participant',
  /** column name */
  PostBox = 'post_box',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.magda_cache" */
export type Risolto_Magda_Cache_Set_Input = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  deceased_at?: Maybe<Scalars['date']>;
  error_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  error_type?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  is_valid?: Maybe<Scalars['Boolean']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_id?: Maybe<Scalars['String']>;
  municipality_name?: Maybe<Scalars['String']>;
  nis_country_code?: Maybe<Scalars['String']>;
  nis_municipality_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  post_box?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  street_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_magda_cache" */
export type Risolto_Magda_Cache_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Magda_Cache_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Magda_Cache_Stream_Cursor_Value_Input = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  deceased_at?: Maybe<Scalars['date']>;
  error_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  error_type?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  is_valid?: Maybe<Scalars['Boolean']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_id?: Maybe<Scalars['String']>;
  municipality_name?: Maybe<Scalars['String']>;
  nis_country_code?: Maybe<Scalars['String']>;
  nis_municipality_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  post_box?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  street_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.magda_cache" */
export enum Risolto_Magda_Cache_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DeceasedAt = 'deceased_at',
  /** column name */
  ErrorId = 'error_id',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  ErrorType = 'error_type',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  IsoCountryCode = 'iso_country_code',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  MunicipalityName = 'municipality_name',
  /** column name */
  NisCountryCode = 'nis_country_code',
  /** column name */
  NisMunicipalityCode = 'nis_municipality_code',
  /** column name */
  Participant = 'participant',
  /** column name */
  PostBox = 'post_box',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Magda_Cache_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Magda_Cache_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Magda_Cache_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Magda_Cache_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Magda_Cache_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Magda_Cache_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Magda_Cache_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Magda_Cache_Bool_Exp;
};

/** columns and relationships of "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log = {
  __typename?: 'risolto_magda_service_audit_log';
  created_at: Scalars['timestamp'];
  direction: Scalars['String'];
  legal_entity?: Maybe<Scalars['uuid']>;
  magda_service: Scalars['String'];
  magda_service_usage: Scalars['String'];
  participant: Scalars['uuid'];
  participant_user?: Maybe<Scalars['uuid']>;
  recipient: Scalars['uuid'];
  recipient_legal_id: Scalars['String'];
  reference: Scalars['uuid'];
  request_id?: Maybe<Scalars['uuid']>;
  search_criteria?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_LogSearch_CriteriaArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log_Aggregate = {
  __typename?: 'risolto_magda_service_audit_log_aggregate';
  aggregate?: Maybe<Risolto_Magda_Service_Audit_Log_Aggregate_Fields>;
  nodes: Array<Risolto_Magda_Service_Audit_Log>;
};

/** aggregate fields of "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log_Aggregate_Fields = {
  __typename?: 'risolto_magda_service_audit_log_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Magda_Service_Audit_Log_Max_Fields>;
  min?: Maybe<Risolto_Magda_Service_Audit_Log_Min_Fields>;
};


/** aggregate fields of "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Magda_Service_Audit_Log_Append_Input = {
  search_criteria?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.magda_service_audit_log". All fields are combined with a logical 'AND'. */
export type Risolto_Magda_Service_Audit_Log_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Bool_Exp>>;
  _not?: Maybe<Risolto_Magda_Service_Audit_Log_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Bool_Exp>>;
  created_at?: Maybe<Timestamp_Comparison_Exp>;
  direction?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  magda_service?: Maybe<String_Comparison_Exp>;
  magda_service_usage?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_user?: Maybe<Uuid_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_legal_id?: Maybe<String_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  request_id?: Maybe<Uuid_Comparison_Exp>;
  search_criteria?: Maybe<Jsonb_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.magda_service_audit_log" */
export enum Risolto_Magda_Service_Audit_Log_Constraint {
  /** unique or primary key constraint on columns "reference" */
  MagdaServiceAuditLogPkey = 'magda_service_audit_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Magda_Service_Audit_Log_Delete_At_Path_Input = {
  search_criteria?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Magda_Service_Audit_Log_Delete_Elem_Input = {
  search_criteria?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Magda_Service_Audit_Log_Delete_Key_Input = {
  search_criteria?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log_Insert_Input = {
  created_at?: Maybe<Scalars['timestamp']>;
  direction?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  magda_service?: Maybe<Scalars['String']>;
  magda_service_usage?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_legal_id?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  request_id?: Maybe<Scalars['uuid']>;
  search_criteria?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Magda_Service_Audit_Log_Max_Fields = {
  __typename?: 'risolto_magda_service_audit_log_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  direction?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  magda_service?: Maybe<Scalars['String']>;
  magda_service_usage?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_legal_id?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  request_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Magda_Service_Audit_Log_Min_Fields = {
  __typename?: 'risolto_magda_service_audit_log_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  direction?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  magda_service?: Maybe<Scalars['String']>;
  magda_service_usage?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_legal_id?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  request_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log_Mutation_Response = {
  __typename?: 'risolto_magda_service_audit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Magda_Service_Audit_Log>;
};

/** on_conflict condition type for table "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log_On_Conflict = {
  constraint: Risolto_Magda_Service_Audit_Log_Constraint;
  update_columns?: Array<Risolto_Magda_Service_Audit_Log_Update_Column>;
  where?: Maybe<Risolto_Magda_Service_Audit_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.magda_service_audit_log". */
export type Risolto_Magda_Service_Audit_Log_Order_By = {
  created_at?: Maybe<Order_By>;
  direction?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  magda_service?: Maybe<Order_By>;
  magda_service_usage?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_user?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_legal_id?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  request_id?: Maybe<Order_By>;
  search_criteria?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.magda_service_audit_log */
export type Risolto_Magda_Service_Audit_Log_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Magda_Service_Audit_Log_Prepend_Input = {
  search_criteria?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.magda_service_audit_log" */
export enum Risolto_Magda_Service_Audit_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Direction = 'direction',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MagdaService = 'magda_service',
  /** column name */
  MagdaServiceUsage = 'magda_service_usage',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RecipientLegalId = 'recipient_legal_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  SearchCriteria = 'search_criteria',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log_Set_Input = {
  created_at?: Maybe<Scalars['timestamp']>;
  direction?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  magda_service?: Maybe<Scalars['String']>;
  magda_service_usage?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_legal_id?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  request_id?: Maybe<Scalars['uuid']>;
  search_criteria?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_magda_service_audit_log" */
export type Risolto_Magda_Service_Audit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Magda_Service_Audit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Magda_Service_Audit_Log_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamp']>;
  direction?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  magda_service?: Maybe<Scalars['String']>;
  magda_service_usage?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_legal_id?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  request_id?: Maybe<Scalars['uuid']>;
  search_criteria?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.magda_service_audit_log" */
export enum Risolto_Magda_Service_Audit_Log_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Direction = 'direction',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MagdaService = 'magda_service',
  /** column name */
  MagdaServiceUsage = 'magda_service_usage',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RecipientLegalId = 'recipient_legal_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  SearchCriteria = 'search_criteria',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Magda_Service_Audit_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Magda_Service_Audit_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Magda_Service_Audit_Log_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Magda_Service_Audit_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Magda_Service_Audit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Magda_Service_Audit_Log_Bool_Exp;
};

export type Risolto_Mailbox_Actions_And_Messages_Args = {
  p_archived_is_null?: Maybe<Scalars['Boolean']>;
  p_assignees?: Maybe<Scalars['_uuid']>;
  p_date_end?: Maybe<Scalars['timestamptz']>;
  p_date_start?: Maybe<Scalars['timestamptz']>;
  p_direction?: Maybe<Scalars['String']>;
  p_is_linked?: Maybe<Scalars['Boolean']>;
  p_legal_entity?: Maybe<Scalars['uuid']>;
  p_limit?: Maybe<Scalars['Int']>;
  p_offset?: Maybe<Scalars['Int']>;
  p_participant?: Maybe<Scalars['uuid']>;
  p_recipient?: Maybe<Scalars['uuid']>;
  p_search_term?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.materialized_view_definition" */
export type Risolto_Materialized_View_Definition = {
  __typename?: 'risolto_materialized_view_definition';
  created_at: Scalars['timestamptz'];
  frequency_expression: Scalars['String'];
  last_refreshed_at: Scalars['timestamptz'];
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  view_id: Scalars['String'];
  view_name: Scalars['String'];
};

/** aggregated selection of "risolto.materialized_view_definition" */
export type Risolto_Materialized_View_Definition_Aggregate = {
  __typename?: 'risolto_materialized_view_definition_aggregate';
  aggregate?: Maybe<Risolto_Materialized_View_Definition_Aggregate_Fields>;
  nodes: Array<Risolto_Materialized_View_Definition>;
};

/** aggregate fields of "risolto.materialized_view_definition" */
export type Risolto_Materialized_View_Definition_Aggregate_Fields = {
  __typename?: 'risolto_materialized_view_definition_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Materialized_View_Definition_Max_Fields>;
  min?: Maybe<Risolto_Materialized_View_Definition_Min_Fields>;
};


/** aggregate fields of "risolto.materialized_view_definition" */
export type Risolto_Materialized_View_Definition_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Materialized_View_Definition_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.materialized_view_definition". All fields are combined with a logical 'AND'. */
export type Risolto_Materialized_View_Definition_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Materialized_View_Definition_Bool_Exp>>;
  _not?: Maybe<Risolto_Materialized_View_Definition_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Materialized_View_Definition_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  frequency_expression?: Maybe<String_Comparison_Exp>;
  last_refreshed_at?: Maybe<Timestamptz_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  view_id?: Maybe<String_Comparison_Exp>;
  view_name?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.materialized_view_definition" */
export enum Risolto_Materialized_View_Definition_Constraint {
  /** unique or primary key constraint on columns "reference" */
  MaterializedViewDefinitionPkey = 'materialized_view_definition_pkey'
}

/** input type for inserting data into table "risolto.materialized_view_definition" */
export type Risolto_Materialized_View_Definition_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  frequency_expression?: Maybe<Scalars['String']>;
  last_refreshed_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  view_id?: Maybe<Scalars['String']>;
  view_name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Materialized_View_Definition_Max_Fields = {
  __typename?: 'risolto_materialized_view_definition_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  frequency_expression?: Maybe<Scalars['String']>;
  last_refreshed_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  view_id?: Maybe<Scalars['String']>;
  view_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Materialized_View_Definition_Min_Fields = {
  __typename?: 'risolto_materialized_view_definition_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  frequency_expression?: Maybe<Scalars['String']>;
  last_refreshed_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  view_id?: Maybe<Scalars['String']>;
  view_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.materialized_view_definition" */
export type Risolto_Materialized_View_Definition_Mutation_Response = {
  __typename?: 'risolto_materialized_view_definition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Materialized_View_Definition>;
};

/** on_conflict condition type for table "risolto.materialized_view_definition" */
export type Risolto_Materialized_View_Definition_On_Conflict = {
  constraint: Risolto_Materialized_View_Definition_Constraint;
  update_columns?: Array<Risolto_Materialized_View_Definition_Update_Column>;
  where?: Maybe<Risolto_Materialized_View_Definition_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.materialized_view_definition". */
export type Risolto_Materialized_View_Definition_Order_By = {
  created_at?: Maybe<Order_By>;
  frequency_expression?: Maybe<Order_By>;
  last_refreshed_at?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  view_id?: Maybe<Order_By>;
  view_name?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.materialized_view_definition */
export type Risolto_Materialized_View_Definition_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.materialized_view_definition" */
export enum Risolto_Materialized_View_Definition_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FrequencyExpression = 'frequency_expression',
  /** column name */
  LastRefreshedAt = 'last_refreshed_at',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewId = 'view_id',
  /** column name */
  ViewName = 'view_name'
}

/** input type for updating data in table "risolto.materialized_view_definition" */
export type Risolto_Materialized_View_Definition_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  frequency_expression?: Maybe<Scalars['String']>;
  last_refreshed_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  view_id?: Maybe<Scalars['String']>;
  view_name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_materialized_view_definition" */
export type Risolto_Materialized_View_Definition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Materialized_View_Definition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Materialized_View_Definition_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  frequency_expression?: Maybe<Scalars['String']>;
  last_refreshed_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  view_id?: Maybe<Scalars['String']>;
  view_name?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.materialized_view_definition" */
export enum Risolto_Materialized_View_Definition_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FrequencyExpression = 'frequency_expression',
  /** column name */
  LastRefreshedAt = 'last_refreshed_at',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewId = 'view_id',
  /** column name */
  ViewName = 'view_name'
}

export type Risolto_Materialized_View_Definition_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Materialized_View_Definition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Materialized_View_Definition_Bool_Exp;
};

/** columns and relationships of "risolto.message" */
export type Risolto_Message = {
  __typename?: 'risolto_message';
  archived_at?: Maybe<Scalars['timestamptz']>;
  archived_by?: Maybe<Scalars['uuid']>;
  channel: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  from_: Scalars['String'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  /** An array relationship */
  message_assignees: Array<Risolto_Message_Assignee>;
  /** An aggregate relationship */
  message_assignees_aggregate: Risolto_Message_Assignee_Aggregate;
  /** An array relationship */
  message_attachments: Array<Risolto_Message_Attachment>;
  /** An aggregate relationship */
  message_attachments_aggregate: Risolto_Message_Attachment_Aggregate;
  message_id: Scalars['String'];
  /** An array relationship */
  message_labels: Array<Risolto_Message_Message_Label>;
  /** An aggregate relationship */
  message_labels_aggregate: Risolto_Message_Message_Label_Aggregate;
  /** An array relationship */
  message_recipients: Array<Risolto_Message_Recipient>;
  /** An aggregate relationship */
  message_recipients_aggregate: Risolto_Message_Recipient_Aggregate;
  messagebox: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An object relationship */
  person_by_reference?: Maybe<Risolto_Person>;
  received_at: Scalars['timestamptz'];
  reference: Scalars['uuid'];
  subject: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMessage_AssigneesArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Assignee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Assignee_Order_By>>;
  where?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMessage_Assignees_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Assignee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Assignee_Order_By>>;
  where?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMessage_AttachmentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Attachment_Order_By>>;
  where?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMessage_Attachments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Attachment_Order_By>>;
  where?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMessage_LabelsArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMessage_Labels_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMessage_RecipientsArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Recipient_Order_By>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMessage_Recipients_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Recipient_Order_By>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


/** columns and relationships of "risolto.message" */
export type Risolto_MessageMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.message" */
export type Risolto_Message_Aggregate = {
  __typename?: 'risolto_message_aggregate';
  aggregate?: Maybe<Risolto_Message_Aggregate_Fields>;
  nodes: Array<Risolto_Message>;
};

/** aggregate fields of "risolto.message" */
export type Risolto_Message_Aggregate_Fields = {
  __typename?: 'risolto_message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Message_Max_Fields>;
  min?: Maybe<Risolto_Message_Min_Fields>;
};


/** aggregate fields of "risolto.message" */
export type Risolto_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Message_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "risolto.message_assignee" */
export type Risolto_Message_Assignee = {
  __typename?: 'risolto_message_assignee';
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  message: Scalars['uuid'];
  /** An object relationship */
  message_by_reference: Risolto_Message;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  person: Scalars['uuid'];
  /** An object relationship */
  person_by_reference: Risolto_Person;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.message_assignee" */
export type Risolto_Message_Assignee_Aggregate = {
  __typename?: 'risolto_message_assignee_aggregate';
  aggregate?: Maybe<Risolto_Message_Assignee_Aggregate_Fields>;
  nodes: Array<Risolto_Message_Assignee>;
};

export type Risolto_Message_Assignee_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Message_Assignee_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Message_Assignee_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Message_Assignee_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.message_assignee" */
export type Risolto_Message_Assignee_Aggregate_Fields = {
  __typename?: 'risolto_message_assignee_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Message_Assignee_Max_Fields>;
  min?: Maybe<Risolto_Message_Assignee_Min_Fields>;
};


/** aggregate fields of "risolto.message_assignee" */
export type Risolto_Message_Assignee_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Message_Assignee_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.message_assignee" */
export type Risolto_Message_Assignee_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Message_Assignee_Max_Order_By>;
  min?: Maybe<Risolto_Message_Assignee_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.message_assignee" */
export type Risolto_Message_Assignee_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Message_Assignee_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Message_Assignee_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.message_assignee". All fields are combined with a logical 'AND'. */
export type Risolto_Message_Assignee_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Message_Assignee_Bool_Exp>>;
  _not?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Message_Assignee_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message?: Maybe<Uuid_Comparison_Exp>;
  message_by_reference?: Maybe<Risolto_Message_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person?: Maybe<Uuid_Comparison_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.message_assignee" */
export enum Risolto_Message_Assignee_Constraint {
  /** unique or primary key constraint on columns "reference" */
  MessageAssigneePkey = 'message_assignee_pkey'
}

/** input type for inserting data into table "risolto.message_assignee" */
export type Risolto_Message_Assignee_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message?: Maybe<Scalars['uuid']>;
  message_by_reference?: Maybe<Risolto_Message_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person?: Maybe<Scalars['uuid']>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Message_Assignee_Max_Fields = {
  __typename?: 'risolto_message_assignee_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.message_assignee" */
export type Risolto_Message_Assignee_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  person?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Message_Assignee_Min_Fields = {
  __typename?: 'risolto_message_assignee_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.message_assignee" */
export type Risolto_Message_Assignee_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  person?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.message_assignee" */
export type Risolto_Message_Assignee_Mutation_Response = {
  __typename?: 'risolto_message_assignee_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Message_Assignee>;
};

/** on_conflict condition type for table "risolto.message_assignee" */
export type Risolto_Message_Assignee_On_Conflict = {
  constraint: Risolto_Message_Assignee_Constraint;
  update_columns?: Array<Risolto_Message_Assignee_Update_Column>;
  where?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.message_assignee". */
export type Risolto_Message_Assignee_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message?: Maybe<Order_By>;
  message_by_reference?: Maybe<Risolto_Message_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person?: Maybe<Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.message_assignee */
export type Risolto_Message_Assignee_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.message_assignee" */
export enum Risolto_Message_Assignee_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  Participant = 'participant',
  /** column name */
  Person = 'person',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.message_assignee" */
export type Risolto_Message_Assignee_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_message_assignee" */
export type Risolto_Message_Assignee_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Message_Assignee_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Message_Assignee_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.message_assignee" */
export enum Risolto_Message_Assignee_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  Participant = 'participant',
  /** column name */
  Person = 'person',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Message_Assignee_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Message_Assignee_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Message_Assignee_Bool_Exp;
};

/** columns and relationships of "risolto.message_attachment" */
export type Risolto_Message_Attachment = {
  __typename?: 'risolto_message_attachment';
  attachment: Scalars['uuid'];
  /** An object relationship */
  attachment_by_reference: Risolto_Attachment;
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  message: Scalars['uuid'];
  /** An object relationship */
  message_by_reference: Risolto_Message;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.message_attachment" */
export type Risolto_Message_Attachment_Aggregate = {
  __typename?: 'risolto_message_attachment_aggregate';
  aggregate?: Maybe<Risolto_Message_Attachment_Aggregate_Fields>;
  nodes: Array<Risolto_Message_Attachment>;
};

export type Risolto_Message_Attachment_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Message_Attachment_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Message_Attachment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Message_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.message_attachment" */
export type Risolto_Message_Attachment_Aggregate_Fields = {
  __typename?: 'risolto_message_attachment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Message_Attachment_Max_Fields>;
  min?: Maybe<Risolto_Message_Attachment_Min_Fields>;
};


/** aggregate fields of "risolto.message_attachment" */
export type Risolto_Message_Attachment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Message_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.message_attachment" */
export type Risolto_Message_Attachment_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Message_Attachment_Max_Order_By>;
  min?: Maybe<Risolto_Message_Attachment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.message_attachment" */
export type Risolto_Message_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Message_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Message_Attachment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.message_attachment". All fields are combined with a logical 'AND'. */
export type Risolto_Message_Attachment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Message_Attachment_Bool_Exp>>;
  _not?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Message_Attachment_Bool_Exp>>;
  attachment?: Maybe<Uuid_Comparison_Exp>;
  attachment_by_reference?: Maybe<Risolto_Attachment_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message?: Maybe<Uuid_Comparison_Exp>;
  message_by_reference?: Maybe<Risolto_Message_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.message_attachment" */
export enum Risolto_Message_Attachment_Constraint {
  /** unique or primary key constraint on columns "reference" */
  MessageAttachmentPkey = 'message_attachment_pkey'
}

/** input type for inserting data into table "risolto.message_attachment" */
export type Risolto_Message_Attachment_Insert_Input = {
  attachment?: Maybe<Scalars['uuid']>;
  attachment_by_reference?: Maybe<Risolto_Attachment_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message?: Maybe<Scalars['uuid']>;
  message_by_reference?: Maybe<Risolto_Message_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Message_Attachment_Max_Fields = {
  __typename?: 'risolto_message_attachment_max_fields';
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.message_attachment" */
export type Risolto_Message_Attachment_Max_Order_By = {
  attachment?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Message_Attachment_Min_Fields = {
  __typename?: 'risolto_message_attachment_min_fields';
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.message_attachment" */
export type Risolto_Message_Attachment_Min_Order_By = {
  attachment?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.message_attachment" */
export type Risolto_Message_Attachment_Mutation_Response = {
  __typename?: 'risolto_message_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Message_Attachment>;
};

/** on_conflict condition type for table "risolto.message_attachment" */
export type Risolto_Message_Attachment_On_Conflict = {
  constraint: Risolto_Message_Attachment_Constraint;
  update_columns?: Array<Risolto_Message_Attachment_Update_Column>;
  where?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.message_attachment". */
export type Risolto_Message_Attachment_Order_By = {
  attachment?: Maybe<Order_By>;
  attachment_by_reference?: Maybe<Risolto_Attachment_Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message?: Maybe<Order_By>;
  message_by_reference?: Maybe<Risolto_Message_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.message_attachment */
export type Risolto_Message_Attachment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.message_attachment" */
export enum Risolto_Message_Attachment_Select_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.message_attachment" */
export type Risolto_Message_Attachment_Set_Input = {
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_message_attachment" */
export type Risolto_Message_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Message_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Message_Attachment_Stream_Cursor_Value_Input = {
  attachment?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.message_attachment" */
export enum Risolto_Message_Attachment_Update_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Message_Attachment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Message_Attachment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Message_Attachment_Bool_Exp;
};

/** Boolean expression to filter rows from the table "risolto.message". All fields are combined with a logical 'AND'. */
export type Risolto_Message_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Message_Bool_Exp>>;
  _not?: Maybe<Risolto_Message_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Message_Bool_Exp>>;
  archived_at?: Maybe<Timestamptz_Comparison_Exp>;
  archived_by?: Maybe<Uuid_Comparison_Exp>;
  channel?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  from_?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message_assignees?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
  message_assignees_aggregate?: Maybe<Risolto_Message_Assignee_Aggregate_Bool_Exp>;
  message_attachments?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
  message_attachments_aggregate?: Maybe<Risolto_Message_Attachment_Aggregate_Bool_Exp>;
  message_id?: Maybe<String_Comparison_Exp>;
  message_labels?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
  message_labels_aggregate?: Maybe<Risolto_Message_Message_Label_Aggregate_Bool_Exp>;
  message_recipients?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
  message_recipients_aggregate?: Maybe<Risolto_Message_Recipient_Aggregate_Bool_Exp>;
  messagebox?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  received_at?: Maybe<Timestamptz_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  subject?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.message" */
export enum Risolto_Message_Constraint {
  /** unique or primary key constraint on columns "participant", "messagebox", "message_id", "legal_entity" */
  MessageParticipantLegalEntityMessageboxMessageIdKey = 'message_participant_legal_entity_messagebox_message_id_key',
  /** unique or primary key constraint on columns "reference" */
  MessagePkey = 'message_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Message_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Message_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Message_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.message" */
export type Risolto_Message_Insert_Input = {
  archived_at?: Maybe<Scalars['timestamptz']>;
  archived_by?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message_assignees?: Maybe<Risolto_Message_Assignee_Arr_Rel_Insert_Input>;
  message_attachments?: Maybe<Risolto_Message_Attachment_Arr_Rel_Insert_Input>;
  message_id?: Maybe<Scalars['String']>;
  message_labels?: Maybe<Risolto_Message_Message_Label_Arr_Rel_Insert_Input>;
  message_recipients?: Maybe<Risolto_Message_Recipient_Arr_Rel_Insert_Input>;
  messagebox?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.message_label" */
export type Risolto_Message_Label = {
  __typename?: 'risolto_message_label';
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  message_label: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.message_label" */
export type Risolto_Message_Label_Aggregate = {
  __typename?: 'risolto_message_label_aggregate';
  aggregate?: Maybe<Risolto_Message_Label_Aggregate_Fields>;
  nodes: Array<Risolto_Message_Label>;
};

/** aggregate fields of "risolto.message_label" */
export type Risolto_Message_Label_Aggregate_Fields = {
  __typename?: 'risolto_message_label_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Message_Label_Max_Fields>;
  min?: Maybe<Risolto_Message_Label_Min_Fields>;
};


/** aggregate fields of "risolto.message_label" */
export type Risolto_Message_Label_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Message_Label_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.message_label". All fields are combined with a logical 'AND'. */
export type Risolto_Message_Label_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Message_Label_Bool_Exp>>;
  _not?: Maybe<Risolto_Message_Label_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Message_Label_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message_label?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.message_label" */
export enum Risolto_Message_Label_Constraint {
  /** unique or primary key constraint on columns "reference" */
  MessageLabelPkey = 'message_label_pkey'
}

/** input type for inserting data into table "risolto.message_label" */
export type Risolto_Message_Label_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Message_Label_Max_Fields = {
  __typename?: 'risolto_message_label_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Message_Label_Min_Fields = {
  __typename?: 'risolto_message_label_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.message_label" */
export type Risolto_Message_Label_Mutation_Response = {
  __typename?: 'risolto_message_label_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Message_Label>;
};

/** on_conflict condition type for table "risolto.message_label" */
export type Risolto_Message_Label_On_Conflict = {
  constraint: Risolto_Message_Label_Constraint;
  update_columns?: Array<Risolto_Message_Label_Update_Column>;
  where?: Maybe<Risolto_Message_Label_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.message_label". */
export type Risolto_Message_Label_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message_label?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.message_label */
export type Risolto_Message_Label_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.message_label" */
export enum Risolto_Message_Label_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageLabel = 'message_label',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.message_label" */
export type Risolto_Message_Label_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_message_label" */
export type Risolto_Message_Label_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Message_Label_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Message_Label_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.message_label" */
export enum Risolto_Message_Label_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageLabel = 'message_label',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Message_Label_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Message_Label_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Message_Label_Bool_Exp;
};

/** aggregate max on columns */
export type Risolto_Message_Max_Fields = {
  __typename?: 'risolto_message_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  archived_by?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  messagebox?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.message_message_label" */
export type Risolto_Message_Message_Label = {
  __typename?: 'risolto_message_message_label';
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  message: Scalars['uuid'];
  /** An object relationship */
  message_by_reference: Risolto_Message;
  message_label: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Aggregate = {
  __typename?: 'risolto_message_message_label_aggregate';
  aggregate?: Maybe<Risolto_Message_Message_Label_Aggregate_Fields>;
  nodes: Array<Risolto_Message_Message_Label>;
};

export type Risolto_Message_Message_Label_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Message_Message_Label_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Message_Message_Label_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Message_Message_Label_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Aggregate_Fields = {
  __typename?: 'risolto_message_message_label_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Message_Message_Label_Max_Fields>;
  min?: Maybe<Risolto_Message_Message_Label_Min_Fields>;
};


/** aggregate fields of "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Message_Message_Label_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Message_Message_Label_Max_Order_By>;
  min?: Maybe<Risolto_Message_Message_Label_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Message_Message_Label_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Message_Message_Label_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.message_message_label". All fields are combined with a logical 'AND'. */
export type Risolto_Message_Message_Label_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Message_Message_Label_Bool_Exp>>;
  _not?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Message_Message_Label_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message?: Maybe<Uuid_Comparison_Exp>;
  message_by_reference?: Maybe<Risolto_Message_Bool_Exp>;
  message_label?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.message_message_label" */
export enum Risolto_Message_Message_Label_Constraint {
  /** unique or primary key constraint on columns "reference" */
  MessageMessageLabelPkey = 'message_message_label_pkey'
}

/** input type for inserting data into table "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message?: Maybe<Scalars['uuid']>;
  message_by_reference?: Maybe<Risolto_Message_Obj_Rel_Insert_Input>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Message_Message_Label_Max_Fields = {
  __typename?: 'risolto_message_message_label_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  message_label?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Message_Message_Label_Min_Fields = {
  __typename?: 'risolto_message_message_label_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  message_label?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Mutation_Response = {
  __typename?: 'risolto_message_message_label_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Message_Message_Label>;
};

/** on_conflict condition type for table "risolto.message_message_label" */
export type Risolto_Message_Message_Label_On_Conflict = {
  constraint: Risolto_Message_Message_Label_Constraint;
  update_columns?: Array<Risolto_Message_Message_Label_Update_Column>;
  where?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.message_message_label". */
export type Risolto_Message_Message_Label_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message?: Maybe<Order_By>;
  message_by_reference?: Maybe<Risolto_Message_Order_By>;
  message_label?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.message_message_label */
export type Risolto_Message_Message_Label_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.message_message_label" */
export enum Risolto_Message_Message_Label_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  MessageLabel = 'message_label',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.message_message_label" */
export type Risolto_Message_Message_Label_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_message_message_label" */
export type Risolto_Message_Message_Label_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Message_Message_Label_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Message_Message_Label_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  message_label?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.message_message_label" */
export enum Risolto_Message_Message_Label_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  MessageLabel = 'message_label',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Message_Message_Label_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Message_Message_Label_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Message_Message_Label_Bool_Exp;
};

/** aggregate min on columns */
export type Risolto_Message_Min_Fields = {
  __typename?: 'risolto_message_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  archived_by?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  messagebox?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.message" */
export type Risolto_Message_Mutation_Response = {
  __typename?: 'risolto_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Message>;
};

/** input type for inserting object relation for remote table "risolto.message" */
export type Risolto_Message_Obj_Rel_Insert_Input = {
  data: Risolto_Message_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Message_On_Conflict>;
};

/** on_conflict condition type for table "risolto.message" */
export type Risolto_Message_On_Conflict = {
  constraint: Risolto_Message_Constraint;
  update_columns?: Array<Risolto_Message_Update_Column>;
  where?: Maybe<Risolto_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.message". */
export type Risolto_Message_Order_By = {
  archived_at?: Maybe<Order_By>;
  archived_by?: Maybe<Order_By>;
  channel?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  from_?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message_assignees_aggregate?: Maybe<Risolto_Message_Assignee_Aggregate_Order_By>;
  message_attachments_aggregate?: Maybe<Risolto_Message_Attachment_Aggregate_Order_By>;
  message_id?: Maybe<Order_By>;
  message_labels_aggregate?: Maybe<Risolto_Message_Message_Label_Aggregate_Order_By>;
  message_recipients_aggregate?: Maybe<Risolto_Message_Recipient_Aggregate_Order_By>;
  messagebox?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  received_at?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.message */
export type Risolto_Message_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Message_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "risolto.message_recipient" */
export type Risolto_Message_Recipient = {
  __typename?: 'risolto_message_recipient';
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  message: Scalars['uuid'];
  /** An object relationship */
  message_by_reference: Risolto_Message;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.message_recipient" */
export type Risolto_Message_Recipient_Aggregate = {
  __typename?: 'risolto_message_recipient_aggregate';
  aggregate?: Maybe<Risolto_Message_Recipient_Aggregate_Fields>;
  nodes: Array<Risolto_Message_Recipient>;
};

export type Risolto_Message_Recipient_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Message_Recipient_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Message_Recipient_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.message_recipient" */
export type Risolto_Message_Recipient_Aggregate_Fields = {
  __typename?: 'risolto_message_recipient_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Message_Recipient_Max_Fields>;
  min?: Maybe<Risolto_Message_Recipient_Min_Fields>;
};


/** aggregate fields of "risolto.message_recipient" */
export type Risolto_Message_Recipient_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.message_recipient" */
export type Risolto_Message_Recipient_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Message_Recipient_Max_Order_By>;
  min?: Maybe<Risolto_Message_Recipient_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.message_recipient" */
export type Risolto_Message_Recipient_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Message_Recipient_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Message_Recipient_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.message_recipient". All fields are combined with a logical 'AND'. */
export type Risolto_Message_Recipient_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Message_Recipient_Bool_Exp>>;
  _not?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Message_Recipient_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message?: Maybe<Uuid_Comparison_Exp>;
  message_by_reference?: Maybe<Risolto_Message_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.message_recipient" */
export enum Risolto_Message_Recipient_Constraint {
  /** unique or primary key constraint on columns "participant", "message", "recipient", "legal_entity" */
  MessageRecipientParticipantLegalEntityMessageRecipientKe = 'message_recipient_participant_legal_entity_message_recipient_ke',
  /** unique or primary key constraint on columns "reference" */
  MessageRecipientPkey = 'message_recipient_pkey'
}

/** input type for inserting data into table "risolto.message_recipient" */
export type Risolto_Message_Recipient_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message?: Maybe<Scalars['uuid']>;
  message_by_reference?: Maybe<Risolto_Message_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Message_Recipient_Max_Fields = {
  __typename?: 'risolto_message_recipient_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.message_recipient" */
export type Risolto_Message_Recipient_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Message_Recipient_Min_Fields = {
  __typename?: 'risolto_message_recipient_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.message_recipient" */
export type Risolto_Message_Recipient_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.message_recipient" */
export type Risolto_Message_Recipient_Mutation_Response = {
  __typename?: 'risolto_message_recipient_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Message_Recipient>;
};

/** on_conflict condition type for table "risolto.message_recipient" */
export type Risolto_Message_Recipient_On_Conflict = {
  constraint: Risolto_Message_Recipient_Constraint;
  update_columns?: Array<Risolto_Message_Recipient_Update_Column>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.message_recipient". */
export type Risolto_Message_Recipient_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message?: Maybe<Order_By>;
  message_by_reference?: Maybe<Risolto_Message_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.message_recipient */
export type Risolto_Message_Recipient_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.message_recipient" */
export enum Risolto_Message_Recipient_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.message_recipient" */
export type Risolto_Message_Recipient_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_message_recipient" */
export type Risolto_Message_Recipient_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Message_Recipient_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Message_Recipient_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.message_recipient" */
export enum Risolto_Message_Recipient_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Message_Recipient_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Message_Recipient_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Message_Recipient_Bool_Exp;
};

/** select columns of table "risolto.message" */
export enum Risolto_Message_Select_Column {
  /** column name */
  ArchivedAt = 'archived_at',
  /** column name */
  ArchivedBy = 'archived_by',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  From = 'from_',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Messagebox = 'messagebox',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Participant = 'participant',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Reference = 'reference',
  /** column name */
  Subject = 'subject',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.message" */
export type Risolto_Message_Set_Input = {
  archived_at?: Maybe<Scalars['timestamptz']>;
  archived_by?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  messagebox?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_message" */
export type Risolto_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Message_Stream_Cursor_Value_Input = {
  archived_at?: Maybe<Scalars['timestamptz']>;
  archived_by?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  messagebox?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.message" */
export enum Risolto_Message_Update_Column {
  /** column name */
  ArchivedAt = 'archived_at',
  /** column name */
  ArchivedBy = 'archived_by',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  From = 'from_',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Messagebox = 'messagebox',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Participant = 'participant',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Reference = 'reference',
  /** column name */
  Subject = 'subject',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Message_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Message_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Message_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Message_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Message_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Message_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Message_Bool_Exp;
};

/** columns and relationships of "risolto.mime_type" */
export type Risolto_Mime_Type = {
  __typename?: 'risolto_mime_type';
  mime_type: Scalars['String'];
};

/** aggregated selection of "risolto.mime_type" */
export type Risolto_Mime_Type_Aggregate = {
  __typename?: 'risolto_mime_type_aggregate';
  aggregate?: Maybe<Risolto_Mime_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Mime_Type>;
};

/** aggregate fields of "risolto.mime_type" */
export type Risolto_Mime_Type_Aggregate_Fields = {
  __typename?: 'risolto_mime_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Mime_Type_Max_Fields>;
  min?: Maybe<Risolto_Mime_Type_Min_Fields>;
};


/** aggregate fields of "risolto.mime_type" */
export type Risolto_Mime_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Mime_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.mime_type". All fields are combined with a logical 'AND'. */
export type Risolto_Mime_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Mime_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Mime_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Mime_Type_Bool_Exp>>;
  mime_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.mime_type" */
export enum Risolto_Mime_Type_Constraint {
  /** unique or primary key constraint on columns "mime_type" */
  ContentTypePkey = 'content_type_pkey'
}

/** input type for inserting data into table "risolto.mime_type" */
export type Risolto_Mime_Type_Insert_Input = {
  mime_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Mime_Type_Max_Fields = {
  __typename?: 'risolto_mime_type_max_fields';
  mime_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Mime_Type_Min_Fields = {
  __typename?: 'risolto_mime_type_min_fields';
  mime_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.mime_type" */
export type Risolto_Mime_Type_Mutation_Response = {
  __typename?: 'risolto_mime_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Mime_Type>;
};

/** on_conflict condition type for table "risolto.mime_type" */
export type Risolto_Mime_Type_On_Conflict = {
  constraint: Risolto_Mime_Type_Constraint;
  update_columns?: Array<Risolto_Mime_Type_Update_Column>;
  where?: Maybe<Risolto_Mime_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.mime_type". */
export type Risolto_Mime_Type_Order_By = {
  mime_type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.mime_type */
export type Risolto_Mime_Type_Pk_Columns_Input = {
  mime_type: Scalars['String'];
};

/** select columns of table "risolto.mime_type" */
export enum Risolto_Mime_Type_Select_Column {
  /** column name */
  MimeType = 'mime_type'
}

/** input type for updating data in table "risolto.mime_type" */
export type Risolto_Mime_Type_Set_Input = {
  mime_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_mime_type" */
export type Risolto_Mime_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Mime_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Mime_Type_Stream_Cursor_Value_Input = {
  mime_type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.mime_type" */
export enum Risolto_Mime_Type_Update_Column {
  /** column name */
  MimeType = 'mime_type'
}

export type Risolto_Mime_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Mime_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Mime_Type_Bool_Exp;
};

export type Risolto_Move_Credit_Note_Args = {
  p_credit_note_to_move?: Maybe<Scalars['uuid']>;
  p_move_from_recipient?: Maybe<Scalars['uuid']>;
  p_move_to_recipient?: Maybe<Scalars['uuid']>;
  p_participant?: Maybe<Scalars['uuid']>;
};

export type Risolto_Move_Debit_Note_Args = {
  p_debit_note_to_move?: Maybe<Scalars['uuid']>;
  p_move_from_recipient?: Maybe<Scalars['uuid']>;
  p_move_to_recipient?: Maybe<Scalars['uuid']>;
  p_participant?: Maybe<Scalars['uuid']>;
};

export type Risolto_Move_Invoice_Args = {
  p_invoice_to_move?: Maybe<Scalars['uuid']>;
  p_move_from_recipient?: Maybe<Scalars['uuid']>;
  p_move_to_recipient?: Maybe<Scalars['uuid']>;
  p_participant?: Maybe<Scalars['uuid']>;
};

export type Risolto_Move_Payment_Args = {
  p_move_from_recipient?: Maybe<Scalars['uuid']>;
  p_move_to_recipient?: Maybe<Scalars['uuid']>;
  p_participant?: Maybe<Scalars['uuid']>;
  p_payment_to_move?: Maybe<Scalars['uuid']>;
};

/** Notes and comments for invoices, recipients, etc. */
export type Risolto_Note = {
  __typename?: 'risolto_note';
  action?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  action_by_reference?: Maybe<Risolto_Action>;
  category?: Maybe<Risolto_Note_Category_Enum>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. Will be removed in 1.1 */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  note: Scalars['String'];
  note_i18n?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  note_invoices: Array<Risolto_Note_Invoice>;
  /** An aggregate relationship */
  note_invoices_aggregate: Risolto_Note_Invoice_Aggregate;
  original_note?: Maybe<Scalars['String']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An object relationship */
  person_by_reference?: Maybe<Risolto_Person>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference: Scalars['uuid'];
  system_note: Scalars['Boolean'];
  task?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  task_by_reference?: Maybe<Risolto_Task>;
  updated_at: Scalars['timestamptz'];
};


/** Notes and comments for invoices, recipients, etc. */
export type Risolto_NoteNote_I18nArgs = {
  path?: Maybe<Scalars['String']>;
};


/** Notes and comments for invoices, recipients, etc. */
export type Risolto_NoteNote_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Invoice_Order_By>>;
  where?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
};


/** Notes and comments for invoices, recipients, etc. */
export type Risolto_NoteNote_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Invoice_Order_By>>;
  where?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
};

/** aggregated selection of "risolto.note" */
export type Risolto_Note_Aggregate = {
  __typename?: 'risolto_note_aggregate';
  aggregate?: Maybe<Risolto_Note_Aggregate_Fields>;
  nodes: Array<Risolto_Note>;
};

export type Risolto_Note_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Note_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Note_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Note_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Note_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Note_Select_Column_Risolto_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Note_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Note_Select_Column_Risolto_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Note_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.note" */
export type Risolto_Note_Aggregate_Fields = {
  __typename?: 'risolto_note_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Note_Max_Fields>;
  min?: Maybe<Risolto_Note_Min_Fields>;
};


/** aggregate fields of "risolto.note" */
export type Risolto_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.note" */
export type Risolto_Note_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Note_Max_Order_By>;
  min?: Maybe<Risolto_Note_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Note_Append_Input = {
  note_i18n?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.note" */
export type Risolto_Note_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.note". All fields are combined with a logical 'AND'. */
export type Risolto_Note_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Note_Bool_Exp>>;
  _not?: Maybe<Risolto_Note_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Note_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  category?: Maybe<Risolto_Note_Category_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  invoice_document?: Maybe<Uuid_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  note?: Maybe<String_Comparison_Exp>;
  note_i18n?: Maybe<Jsonb_Comparison_Exp>;
  note_invoices?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
  note_invoices_aggregate?: Maybe<Risolto_Note_Invoice_Aggregate_Bool_Exp>;
  original_note?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  system_note?: Maybe<Boolean_Comparison_Exp>;
  task?: Maybe<Uuid_Comparison_Exp>;
  task_by_reference?: Maybe<Risolto_Task_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "risolto.note_category" */
export type Risolto_Note_Category = {
  __typename?: 'risolto_note_category';
  category: Scalars['String'];
};

/** aggregated selection of "risolto.note_category" */
export type Risolto_Note_Category_Aggregate = {
  __typename?: 'risolto_note_category_aggregate';
  aggregate?: Maybe<Risolto_Note_Category_Aggregate_Fields>;
  nodes: Array<Risolto_Note_Category>;
};

/** aggregate fields of "risolto.note_category" */
export type Risolto_Note_Category_Aggregate_Fields = {
  __typename?: 'risolto_note_category_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Note_Category_Max_Fields>;
  min?: Maybe<Risolto_Note_Category_Min_Fields>;
};


/** aggregate fields of "risolto.note_category" */
export type Risolto_Note_Category_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Note_Category_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.note_category". All fields are combined with a logical 'AND'. */
export type Risolto_Note_Category_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Note_Category_Bool_Exp>>;
  _not?: Maybe<Risolto_Note_Category_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Note_Category_Bool_Exp>>;
  category?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.note_category" */
export enum Risolto_Note_Category_Constraint {
  /** unique or primary key constraint on columns "category" */
  NoteCategoryPkey = 'note_category_pkey'
}

export enum Risolto_Note_Category_Enum {
  Dispute = 'DISPUTE',
  Inbound = 'INBOUND',
  IncorrectNumber = 'INCORRECT_NUMBER',
  Other = 'OTHER',
  PaymentPlan = 'PAYMENT_PLAN',
  PaymentPromise = 'PAYMENT_PROMISE',
  Unreachable = 'UNREACHABLE',
  Voicemail = 'VOICEMAIL'
}

/** Boolean expression to compare columns of type "risolto_note_category_enum". All fields are combined with logical 'AND'. */
export type Risolto_Note_Category_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Note_Category_Enum>;
  _in?: Maybe<Array<Risolto_Note_Category_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Note_Category_Enum>;
  _nin?: Maybe<Array<Risolto_Note_Category_Enum>>;
};

/** input type for inserting data into table "risolto.note_category" */
export type Risolto_Note_Category_Insert_Input = {
  category?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Note_Category_Max_Fields = {
  __typename?: 'risolto_note_category_max_fields';
  category?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Note_Category_Min_Fields = {
  __typename?: 'risolto_note_category_min_fields';
  category?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.note_category" */
export type Risolto_Note_Category_Mutation_Response = {
  __typename?: 'risolto_note_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Note_Category>;
};

/** on_conflict condition type for table "risolto.note_category" */
export type Risolto_Note_Category_On_Conflict = {
  constraint: Risolto_Note_Category_Constraint;
  update_columns?: Array<Risolto_Note_Category_Update_Column>;
  where?: Maybe<Risolto_Note_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.note_category". */
export type Risolto_Note_Category_Order_By = {
  category?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.note_category */
export type Risolto_Note_Category_Pk_Columns_Input = {
  category: Scalars['String'];
};

/** select columns of table "risolto.note_category" */
export enum Risolto_Note_Category_Select_Column {
  /** column name */
  Category = 'category'
}

/** input type for updating data in table "risolto.note_category" */
export type Risolto_Note_Category_Set_Input = {
  category?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_note_category" */
export type Risolto_Note_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Note_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Note_Category_Stream_Cursor_Value_Input = {
  category?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.note_category" */
export enum Risolto_Note_Category_Update_Column {
  /** column name */
  Category = 'category'
}

export type Risolto_Note_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Note_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Note_Category_Bool_Exp;
};

/** unique or primary key constraints on table "risolto.note" */
export enum Risolto_Note_Constraint {
  /** unique or primary key constraint on columns "reference" */
  NotesPkey = 'notes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Note_Delete_At_Path_Input = {
  note_i18n?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Note_Delete_Elem_Input = {
  note_i18n?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Note_Delete_Key_Input = {
  note_i18n?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.note" */
export type Risolto_Note_Insert_Input = {
  action?: Maybe<Scalars['uuid']>;
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  category?: Maybe<Risolto_Note_Category_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. Will be removed in 1.1 */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  note?: Maybe<Scalars['String']>;
  note_i18n?: Maybe<Scalars['jsonb']>;
  note_invoices?: Maybe<Risolto_Note_Invoice_Arr_Rel_Insert_Input>;
  original_note?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  system_note?: Maybe<Scalars['Boolean']>;
  task?: Maybe<Scalars['uuid']>;
  task_by_reference?: Maybe<Risolto_Task_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.note_invoice" */
export type Risolto_Note_Invoice = {
  __typename?: 'risolto_note_invoice';
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  note: Scalars['uuid'];
  /** An object relationship */
  note_by_reference: Risolto_Note;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
};

/** aggregated selection of "risolto.note_invoice" */
export type Risolto_Note_Invoice_Aggregate = {
  __typename?: 'risolto_note_invoice_aggregate';
  aggregate?: Maybe<Risolto_Note_Invoice_Aggregate_Fields>;
  nodes: Array<Risolto_Note_Invoice>;
};

export type Risolto_Note_Invoice_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Note_Invoice_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Note_Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Note_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.note_invoice" */
export type Risolto_Note_Invoice_Aggregate_Fields = {
  __typename?: 'risolto_note_invoice_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Note_Invoice_Max_Fields>;
  min?: Maybe<Risolto_Note_Invoice_Min_Fields>;
};


/** aggregate fields of "risolto.note_invoice" */
export type Risolto_Note_Invoice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Note_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.note_invoice" */
export type Risolto_Note_Invoice_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Note_Invoice_Max_Order_By>;
  min?: Maybe<Risolto_Note_Invoice_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.note_invoice" */
export type Risolto_Note_Invoice_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Note_Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Note_Invoice_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.note_invoice". All fields are combined with a logical 'AND'. */
export type Risolto_Note_Invoice_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Note_Invoice_Bool_Exp>>;
  _not?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Note_Invoice_Bool_Exp>>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  note?: Maybe<Uuid_Comparison_Exp>;
  note_by_reference?: Maybe<Risolto_Note_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.note_invoice" */
export enum Risolto_Note_Invoice_Constraint {
  /** unique or primary key constraint on columns "reference" */
  NoteInvoicePkey = 'note_invoice_pkey'
}

/** input type for inserting data into table "risolto.note_invoice" */
export type Risolto_Note_Invoice_Insert_Input = {
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  note?: Maybe<Scalars['uuid']>;
  note_by_reference?: Maybe<Risolto_Note_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Note_Invoice_Max_Fields = {
  __typename?: 'risolto_note_invoice_max_fields';
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "risolto.note_invoice" */
export type Risolto_Note_Invoice_Max_Order_By = {
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Note_Invoice_Min_Fields = {
  __typename?: 'risolto_note_invoice_min_fields';
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "risolto.note_invoice" */
export type Risolto_Note_Invoice_Min_Order_By = {
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.note_invoice" */
export type Risolto_Note_Invoice_Mutation_Response = {
  __typename?: 'risolto_note_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Note_Invoice>;
};

/** on_conflict condition type for table "risolto.note_invoice" */
export type Risolto_Note_Invoice_On_Conflict = {
  constraint: Risolto_Note_Invoice_Constraint;
  update_columns?: Array<Risolto_Note_Invoice_Update_Column>;
  where?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.note_invoice". */
export type Risolto_Note_Invoice_Order_By = {
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  note?: Maybe<Order_By>;
  note_by_reference?: Maybe<Risolto_Note_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.note_invoice */
export type Risolto_Note_Invoice_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.note_invoice" */
export enum Risolto_Note_Invoice_Select_Column {
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Note = 'note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference'
}

/** input type for updating data in table "risolto.note_invoice" */
export type Risolto_Note_Invoice_Set_Input = {
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "risolto_note_invoice" */
export type Risolto_Note_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Note_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Note_Invoice_Stream_Cursor_Value_Input = {
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** update columns of table "risolto.note_invoice" */
export enum Risolto_Note_Invoice_Update_Column {
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Note = 'note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference'
}

export type Risolto_Note_Invoice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Note_Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Note_Invoice_Bool_Exp;
};

/** aggregate max on columns */
export type Risolto_Note_Max_Fields = {
  __typename?: 'risolto_note_max_fields';
  action?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. Will be removed in 1.1 */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  original_note?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  task?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.note" */
export type Risolto_Note_Max_Order_By = {
  action?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  /** DEPRECATED. Will be removed in 1.1 */
  invoice_document?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  original_note?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  task?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Note_Min_Fields = {
  __typename?: 'risolto_note_min_fields';
  action?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. Will be removed in 1.1 */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  original_note?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  task?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.note" */
export type Risolto_Note_Min_Order_By = {
  action?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  /** DEPRECATED. Will be removed in 1.1 */
  invoice_document?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  original_note?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  task?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.note" */
export type Risolto_Note_Mutation_Response = {
  __typename?: 'risolto_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Note>;
};

/** input type for inserting object relation for remote table "risolto.note" */
export type Risolto_Note_Obj_Rel_Insert_Input = {
  data: Risolto_Note_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Note_On_Conflict>;
};

/** on_conflict condition type for table "risolto.note" */
export type Risolto_Note_On_Conflict = {
  constraint: Risolto_Note_Constraint;
  update_columns?: Array<Risolto_Note_Update_Column>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.note". */
export type Risolto_Note_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  category?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  invoice_document?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  note?: Maybe<Order_By>;
  note_i18n?: Maybe<Order_By>;
  note_invoices_aggregate?: Maybe<Risolto_Note_Invoice_Aggregate_Order_By>;
  original_note?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  system_note?: Maybe<Order_By>;
  task?: Maybe<Order_By>;
  task_by_reference?: Maybe<Risolto_Task_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.note */
export type Risolto_Note_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Note_Prepend_Input = {
  note_i18n?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.note" */
export enum Risolto_Note_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  InvoiceDocument = 'invoice_document',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Note = 'note',
  /** column name */
  NoteI18n = 'note_i18n',
  /** column name */
  OriginalNote = 'original_note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  SystemNote = 'system_note',
  /** column name */
  Task = 'task',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_note_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.note" */
export enum Risolto_Note_Select_Column_Risolto_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SystemNote = 'system_note'
}

/** select "risolto_note_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.note" */
export enum Risolto_Note_Select_Column_Risolto_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SystemNote = 'system_note'
}

/** input type for updating data in table "risolto.note" */
export type Risolto_Note_Set_Input = {
  action?: Maybe<Scalars['uuid']>;
  category?: Maybe<Risolto_Note_Category_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. Will be removed in 1.1 */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  note_i18n?: Maybe<Scalars['jsonb']>;
  original_note?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  system_note?: Maybe<Scalars['Boolean']>;
  task?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_note" */
export type Risolto_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Note_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  category?: Maybe<Risolto_Note_Category_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. Will be removed in 1.1 */
  invoice_document?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  note_i18n?: Maybe<Scalars['jsonb']>;
  original_note?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  system_note?: Maybe<Scalars['Boolean']>;
  task?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.note" */
export enum Risolto_Note_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  InvoiceDocument = 'invoice_document',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Note = 'note',
  /** column name */
  NoteI18n = 'note_i18n',
  /** column name */
  OriginalNote = 'original_note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  SystemNote = 'system_note',
  /** column name */
  Task = 'task',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Note_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Note_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Note_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Note_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Note_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Note_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Note_Bool_Exp;
};

/** columns and relationships of "risolto.open_balance" */
export type Risolto_Open_Balance = {
  __typename?: 'risolto_open_balance';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  interchange_links: Array<Risolto_Document_Interchange_Link>;
  /** An aggregate relationship */
  interchange_links_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount_after?: Maybe<Scalars['numeric']>;
  open_amount_before: Scalars['numeric'];
  /** An array relationship */
  open_balance_records: Array<Risolto_Open_Balance_Record>;
  /** An aggregate relationship */
  open_balance_records_aggregate: Risolto_Open_Balance_Record_Aggregate;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  total_amount_after?: Maybe<Scalars['numeric']>;
  total_amount_before: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.open_balance" */
export type Risolto_Open_BalanceInterchange_LinksArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.open_balance" */
export type Risolto_Open_BalanceInterchange_Links_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.open_balance" */
export type Risolto_Open_BalanceOpen_Balance_RecordsArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.open_balance" */
export type Risolto_Open_BalanceOpen_Balance_Records_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};

/** aggregated selection of "risolto.open_balance" */
export type Risolto_Open_Balance_Aggregate = {
  __typename?: 'risolto_open_balance_aggregate';
  aggregate?: Maybe<Risolto_Open_Balance_Aggregate_Fields>;
  nodes: Array<Risolto_Open_Balance>;
};

/** aggregate fields of "risolto.open_balance" */
export type Risolto_Open_Balance_Aggregate_Fields = {
  __typename?: 'risolto_open_balance_aggregate_fields';
  avg?: Maybe<Risolto_Open_Balance_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Open_Balance_Max_Fields>;
  min?: Maybe<Risolto_Open_Balance_Min_Fields>;
  stddev?: Maybe<Risolto_Open_Balance_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Open_Balance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Open_Balance_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Open_Balance_Sum_Fields>;
  var_pop?: Maybe<Risolto_Open_Balance_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Open_Balance_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Open_Balance_Variance_Fields>;
};


/** aggregate fields of "risolto.open_balance" */
export type Risolto_Open_Balance_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Open_Balance_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Open_Balance_Avg_Fields = {
  __typename?: 'risolto_open_balance_avg_fields';
  open_amount_after?: Maybe<Scalars['Float']>;
  open_amount_before?: Maybe<Scalars['Float']>;
  total_amount_after?: Maybe<Scalars['Float']>;
  total_amount_before?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.open_balance". All fields are combined with a logical 'AND'. */
export type Risolto_Open_Balance_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Open_Balance_Bool_Exp>>;
  _not?: Maybe<Risolto_Open_Balance_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Open_Balance_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount_after?: Maybe<Numeric_Comparison_Exp>;
  open_amount_before?: Maybe<Numeric_Comparison_Exp>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  total_amount_after?: Maybe<Numeric_Comparison_Exp>;
  total_amount_before?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.open_balance" */
export enum Risolto_Open_Balance_Constraint {
  /** unique or primary key constraint on columns "reference" */
  OpenBalancePkey = 'open_balance_pkey'
}

/** input type for incrementing numeric columns in table "risolto.open_balance" */
export type Risolto_Open_Balance_Inc_Input = {
  open_amount_after?: Maybe<Scalars['numeric']>;
  open_amount_before?: Maybe<Scalars['numeric']>;
  total_amount_after?: Maybe<Scalars['numeric']>;
  total_amount_before?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.open_balance" */
export type Risolto_Open_Balance_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount_after?: Maybe<Scalars['numeric']>;
  open_amount_before?: Maybe<Scalars['numeric']>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Arr_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount_after?: Maybe<Scalars['numeric']>;
  total_amount_before?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Open_Balance_Max_Fields = {
  __typename?: 'risolto_open_balance_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount_after?: Maybe<Scalars['numeric']>;
  open_amount_before?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount_after?: Maybe<Scalars['numeric']>;
  total_amount_before?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Open_Balance_Min_Fields = {
  __typename?: 'risolto_open_balance_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount_after?: Maybe<Scalars['numeric']>;
  open_amount_before?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount_after?: Maybe<Scalars['numeric']>;
  total_amount_before?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.open_balance" */
export type Risolto_Open_Balance_Mutation_Response = {
  __typename?: 'risolto_open_balance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Open_Balance>;
};

/** input type for inserting object relation for remote table "risolto.open_balance" */
export type Risolto_Open_Balance_Obj_Rel_Insert_Input = {
  data: Risolto_Open_Balance_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Open_Balance_On_Conflict>;
};

/** on_conflict condition type for table "risolto.open_balance" */
export type Risolto_Open_Balance_On_Conflict = {
  constraint: Risolto_Open_Balance_Constraint;
  update_columns?: Array<Risolto_Open_Balance_Update_Column>;
  where?: Maybe<Risolto_Open_Balance_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.open_balance". */
export type Risolto_Open_Balance_Order_By = {
  created_at?: Maybe<Order_By>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount_after?: Maybe<Order_By>;
  open_amount_before?: Maybe<Order_By>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  total_amount_after?: Maybe<Order_By>;
  total_amount_before?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.open_balance */
export type Risolto_Open_Balance_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** columns and relationships of "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record = {
  __typename?: 'risolto_open_balance_record';
  /** null */
  account_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice_by_reference?: Maybe<Risolto_Invoice_Document>;
  invoice_document?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  invoice_number: Scalars['String'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  open_amount: Scalars['numeric'];
  open_balance?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  open_balance_by_reference?: Maybe<Risolto_Open_Balance>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_document?: Maybe<Scalars['uuid']>;
  raw_input?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.open_balance_record" */
export type Risolto_Open_Balance_RecordRaw_InputArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Aggregate = {
  __typename?: 'risolto_open_balance_record_aggregate';
  aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Fields>;
  nodes: Array<Risolto_Open_Balance_Record>;
};

export type Risolto_Open_Balance_Record_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Open_Balance_Record_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Open_Balance_Record_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Aggregate_Fields = {
  __typename?: 'risolto_open_balance_record_aggregate_fields';
  avg?: Maybe<Risolto_Open_Balance_Record_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Open_Balance_Record_Max_Fields>;
  min?: Maybe<Risolto_Open_Balance_Record_Min_Fields>;
  stddev?: Maybe<Risolto_Open_Balance_Record_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Open_Balance_Record_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Open_Balance_Record_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Open_Balance_Record_Sum_Fields>;
  var_pop?: Maybe<Risolto_Open_Balance_Record_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Open_Balance_Record_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Open_Balance_Record_Variance_Fields>;
};


/** aggregate fields of "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Open_Balance_Record_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Open_Balance_Record_Max_Order_By>;
  min?: Maybe<Risolto_Open_Balance_Record_Min_Order_By>;
  stddev?: Maybe<Risolto_Open_Balance_Record_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Open_Balance_Record_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Open_Balance_Record_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Open_Balance_Record_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Open_Balance_Record_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Open_Balance_Record_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Open_Balance_Record_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Open_Balance_Record_Append_Input = {
  raw_input?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Open_Balance_Record_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Open_Balance_Record_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Open_Balance_Record_Avg_Fields = {
  __typename?: 'risolto_open_balance_record_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.open_balance_record". All fields are combined with a logical 'AND'. */
export type Risolto_Open_Balance_Record_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Open_Balance_Record_Bool_Exp>>;
  _not?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Open_Balance_Record_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  credit_note?: Maybe<Uuid_Comparison_Exp>;
  debit_note?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  invoice_document?: Maybe<Uuid_Comparison_Exp>;
  invoice_number?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  open_balance?: Maybe<Uuid_Comparison_Exp>;
  open_balance_by_reference?: Maybe<Risolto_Open_Balance_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_document?: Maybe<Uuid_Comparison_Exp>;
  raw_input?: Maybe<Jsonb_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.open_balance_record" */
export enum Risolto_Open_Balance_Record_Constraint {
  /** unique or primary key constraint on columns "reference" */
  OpenBalanceImportPkey = 'open_balance_import_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Open_Balance_Record_Delete_At_Path_Input = {
  raw_input?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Open_Balance_Record_Delete_Elem_Input = {
  raw_input?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Open_Balance_Record_Delete_Key_Input = {
  raw_input?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Insert_Input = {
  /** null */
  account_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  invoice_document?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  invoice_number?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_balance?: Maybe<Scalars['uuid']>;
  open_balance_by_reference?: Maybe<Risolto_Open_Balance_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_document?: Maybe<Scalars['uuid']>;
  raw_input?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Open_Balance_Record_Max_Fields = {
  __typename?: 'risolto_open_balance_record_max_fields';
  /** null */
  account_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_document?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  invoice_number?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_balance?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Max_Order_By = {
  /** null */
  account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  invoice_document?: Maybe<Order_By>;
  /** DEPRECATED */
  invoice_number?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  open_balance?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_document?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Open_Balance_Record_Min_Fields = {
  __typename?: 'risolto_open_balance_record_min_fields';
  /** null */
  account_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_document?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  invoice_number?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_balance?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Min_Order_By = {
  /** null */
  account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  invoice_document?: Maybe<Order_By>;
  /** DEPRECATED */
  invoice_number?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  open_balance?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_document?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Mutation_Response = {
  __typename?: 'risolto_open_balance_record_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Open_Balance_Record>;
};

/** input type for inserting object relation for remote table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Obj_Rel_Insert_Input = {
  data: Risolto_Open_Balance_Record_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Open_Balance_Record_On_Conflict>;
};

/** on_conflict condition type for table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_On_Conflict = {
  constraint: Risolto_Open_Balance_Record_Constraint;
  update_columns?: Array<Risolto_Open_Balance_Record_Update_Column>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.open_balance_record". */
export type Risolto_Open_Balance_Record_Order_By = {
  account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_note?: Maybe<Order_By>;
  debit_note?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  invoice_document?: Maybe<Order_By>;
  invoice_number?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  open_balance?: Maybe<Order_By>;
  open_balance_by_reference?: Maybe<Risolto_Open_Balance_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_document?: Maybe<Order_By>;
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.open_balance_record */
export type Risolto_Open_Balance_Record_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Open_Balance_Record_Prepend_Input = {
  raw_input?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.open_balance_record" */
export enum Risolto_Open_Balance_Record_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  DebitNote = 'debit_note',
  /** column name */
  InvoiceDocument = 'invoice_document',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  OpenBalance = 'open_balance',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentDocument = 'payment_document',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Set_Input = {
  /** null */
  account_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_document?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  invoice_number?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_balance?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  raw_input?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Open_Balance_Record_Stddev_Fields = {
  __typename?: 'risolto_open_balance_record_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Open_Balance_Record_Stddev_Pop_Fields = {
  __typename?: 'risolto_open_balance_record_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Open_Balance_Record_Stddev_Samp_Fields = {
  __typename?: 'risolto_open_balance_record_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_open_balance_record" */
export type Risolto_Open_Balance_Record_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Open_Balance_Record_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Open_Balance_Record_Stream_Cursor_Value_Input = {
  /** null */
  account_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_note?: Maybe<Scalars['uuid']>;
  debit_note?: Maybe<Scalars['uuid']>;
  invoice_document?: Maybe<Scalars['uuid']>;
  /** DEPRECATED */
  invoice_number?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  open_balance?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  raw_input?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Open_Balance_Record_Sum_Fields = {
  __typename?: 'risolto_open_balance_record_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.open_balance_record" */
export enum Risolto_Open_Balance_Record_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditNote = 'credit_note',
  /** column name */
  DebitNote = 'debit_note',
  /** column name */
  InvoiceDocument = 'invoice_document',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  OpenBalance = 'open_balance',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentDocument = 'payment_document',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Open_Balance_Record_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Open_Balance_Record_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Open_Balance_Record_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Open_Balance_Record_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Open_Balance_Record_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Open_Balance_Record_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Open_Balance_Record_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Open_Balance_Record_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Open_Balance_Record_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Open_Balance_Record_Var_Pop_Fields = {
  __typename?: 'risolto_open_balance_record_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Open_Balance_Record_Var_Samp_Fields = {
  __typename?: 'risolto_open_balance_record_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Open_Balance_Record_Variance_Fields = {
  __typename?: 'risolto_open_balance_record_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.open_balance_record" */
export type Risolto_Open_Balance_Record_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
};

/** select columns of table "risolto.open_balance" */
export enum Risolto_Open_Balance_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmountAfter = 'open_amount_after',
  /** column name */
  OpenAmountBefore = 'open_amount_before',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmountAfter = 'total_amount_after',
  /** column name */
  TotalAmountBefore = 'total_amount_before',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.open_balance" */
export type Risolto_Open_Balance_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount_after?: Maybe<Scalars['numeric']>;
  open_amount_before?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount_after?: Maybe<Scalars['numeric']>;
  total_amount_before?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Open_Balance_Stddev_Fields = {
  __typename?: 'risolto_open_balance_stddev_fields';
  open_amount_after?: Maybe<Scalars['Float']>;
  open_amount_before?: Maybe<Scalars['Float']>;
  total_amount_after?: Maybe<Scalars['Float']>;
  total_amount_before?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Open_Balance_Stddev_Pop_Fields = {
  __typename?: 'risolto_open_balance_stddev_pop_fields';
  open_amount_after?: Maybe<Scalars['Float']>;
  open_amount_before?: Maybe<Scalars['Float']>;
  total_amount_after?: Maybe<Scalars['Float']>;
  total_amount_before?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Open_Balance_Stddev_Samp_Fields = {
  __typename?: 'risolto_open_balance_stddev_samp_fields';
  open_amount_after?: Maybe<Scalars['Float']>;
  open_amount_before?: Maybe<Scalars['Float']>;
  total_amount_after?: Maybe<Scalars['Float']>;
  total_amount_before?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_open_balance" */
export type Risolto_Open_Balance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Open_Balance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Open_Balance_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount_after?: Maybe<Scalars['numeric']>;
  open_amount_before?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount_after?: Maybe<Scalars['numeric']>;
  total_amount_before?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Open_Balance_Sum_Fields = {
  __typename?: 'risolto_open_balance_sum_fields';
  open_amount_after?: Maybe<Scalars['numeric']>;
  open_amount_before?: Maybe<Scalars['numeric']>;
  total_amount_after?: Maybe<Scalars['numeric']>;
  total_amount_before?: Maybe<Scalars['numeric']>;
};

/** update columns of table "risolto.open_balance" */
export enum Risolto_Open_Balance_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmountAfter = 'open_amount_after',
  /** column name */
  OpenAmountBefore = 'open_amount_before',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmountAfter = 'total_amount_after',
  /** column name */
  TotalAmountBefore = 'total_amount_before',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Open_Balance_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Open_Balance_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Open_Balance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Open_Balance_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Open_Balance_Var_Pop_Fields = {
  __typename?: 'risolto_open_balance_var_pop_fields';
  open_amount_after?: Maybe<Scalars['Float']>;
  open_amount_before?: Maybe<Scalars['Float']>;
  total_amount_after?: Maybe<Scalars['Float']>;
  total_amount_before?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Open_Balance_Var_Samp_Fields = {
  __typename?: 'risolto_open_balance_var_samp_fields';
  open_amount_after?: Maybe<Scalars['Float']>;
  open_amount_before?: Maybe<Scalars['Float']>;
  total_amount_after?: Maybe<Scalars['Float']>;
  total_amount_before?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Open_Balance_Variance_Fields = {
  __typename?: 'risolto_open_balance_variance_fields';
  open_amount_after?: Maybe<Scalars['Float']>;
  open_amount_before?: Maybe<Scalars['Float']>;
  total_amount_after?: Maybe<Scalars['Float']>;
  total_amount_before?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.origin" */
export type Risolto_Origin = {
  __typename?: 'risolto_origin';
  origin: Scalars['String'];
};

/** aggregated selection of "risolto.origin" */
export type Risolto_Origin_Aggregate = {
  __typename?: 'risolto_origin_aggregate';
  aggregate?: Maybe<Risolto_Origin_Aggregate_Fields>;
  nodes: Array<Risolto_Origin>;
};

/** aggregate fields of "risolto.origin" */
export type Risolto_Origin_Aggregate_Fields = {
  __typename?: 'risolto_origin_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Origin_Max_Fields>;
  min?: Maybe<Risolto_Origin_Min_Fields>;
};


/** aggregate fields of "risolto.origin" */
export type Risolto_Origin_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Origin_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.origin". All fields are combined with a logical 'AND'. */
export type Risolto_Origin_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Origin_Bool_Exp>>;
  _not?: Maybe<Risolto_Origin_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Origin_Bool_Exp>>;
  origin?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.origin" */
export enum Risolto_Origin_Constraint {
  /** unique or primary key constraint on columns "origin" */
  OriginPkey = 'origin_pkey'
}

export enum Risolto_Origin_Enum {
  Accounting = 'ACCOUNTING',
  AdminConsult = 'ADMIN_CONSULT',
  Api = 'API',
  Communication = 'COMMUNICATION',
  Crm = 'CRM',
  ExactOnline = 'EXACT_ONLINE',
  FilemakerVds = 'FILEMAKER_VDS',
  Invoicing = 'INVOICING',
  Magda = 'MAGDA',
  Manual = 'MANUAL',
  Mercator = 'MERCATOR',
  Mollie = 'MOLLIE',
  Octopus = 'OCTOPUS',
  Other = 'OTHER',
  PaymentPlan = 'PAYMENT_PLAN',
  Pom = 'POM',
  Risolto = 'RISOLTO',
  Teamleader = 'TEAMLEADER',
  Test = 'TEST',
  Yuki = 'YUKI'
}

/** Boolean expression to compare columns of type "risolto_origin_enum". All fields are combined with logical 'AND'. */
export type Risolto_Origin_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Origin_Enum>;
  _in?: Maybe<Array<Risolto_Origin_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Origin_Enum>;
  _nin?: Maybe<Array<Risolto_Origin_Enum>>;
};

/** input type for inserting data into table "risolto.origin" */
export type Risolto_Origin_Insert_Input = {
  origin?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Origin_Max_Fields = {
  __typename?: 'risolto_origin_max_fields';
  origin?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Origin_Min_Fields = {
  __typename?: 'risolto_origin_min_fields';
  origin?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.origin" */
export type Risolto_Origin_Mutation_Response = {
  __typename?: 'risolto_origin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Origin>;
};

/** on_conflict condition type for table "risolto.origin" */
export type Risolto_Origin_On_Conflict = {
  constraint: Risolto_Origin_Constraint;
  update_columns?: Array<Risolto_Origin_Update_Column>;
  where?: Maybe<Risolto_Origin_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.origin". */
export type Risolto_Origin_Order_By = {
  origin?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.origin */
export type Risolto_Origin_Pk_Columns_Input = {
  origin: Scalars['String'];
};

/** select columns of table "risolto.origin" */
export enum Risolto_Origin_Select_Column {
  /** column name */
  Origin = 'origin'
}

/** input type for updating data in table "risolto.origin" */
export type Risolto_Origin_Set_Input = {
  origin?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_origin" */
export type Risolto_Origin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Origin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Origin_Stream_Cursor_Value_Input = {
  origin?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.origin" */
export enum Risolto_Origin_Update_Column {
  /** column name */
  Origin = 'origin'
}

export type Risolto_Origin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Origin_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Origin_Bool_Exp;
};

/** columns and relationships of "risolto.participant" */
export type Risolto_Participant = {
  __typename?: 'risolto_participant';
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  dispute_codes: Array<Risolto_Dispute_Code>;
  /** An aggregate relationship */
  dispute_codes_aggregate: Risolto_Dispute_Code_Aggregate;
  /** An array relationship */
  document_interchanges: Array<Risolto_Document_Interchange>;
  /** An aggregate relationship */
  document_interchanges_aggregate: Risolto_Document_Interchange_Aggregate;
  /** An array relationship */
  documents: Array<Risolto_Invoice_Document>;
  /** An aggregate relationship */
  documents_aggregate: Risolto_Invoice_Document_Aggregate;
  dunning_version: Scalars['String'];
  /** An array relationship */
  invoice_groups: Array<Risolto_Invoice_Group>;
  /** An aggregate relationship */
  invoice_groups_aggregate: Risolto_Invoice_Group_Aggregate;
  /** An array relationship */
  legal_entities: Array<Risolto_Legal_Entity>;
  /** An aggregate relationship */
  legal_entities_aggregate: Risolto_Legal_Entity_Aggregate;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An array relationship */
  notes: Array<Risolto_Note>;
  /** An aggregate relationship */
  notes_aggregate: Risolto_Note_Aggregate;
  /** An array relationship */
  open_balance_records: Array<Risolto_Open_Balance_Record>;
  /** An aggregate relationship */
  open_balance_records_aggregate: Risolto_Open_Balance_Record_Aggregate;
  /** An array relationship */
  participant_api_app_clients: Array<Risolto_Participant_Api_App_Client>;
  /** An aggregate relationship */
  participant_api_app_clients_aggregate: Risolto_Participant_Api_App_Client_Aggregate;
  /** An array relationship */
  participant_users: Array<Risolto_Participant_User>;
  /** An aggregate relationship */
  participant_users_aggregate: Risolto_Participant_User_Aggregate;
  /** An array relationship */
  payment_plans: Array<Risolto_Payment_Plan>;
  /** An aggregate relationship */
  payment_plans_aggregate: Risolto_Payment_Plan_Aggregate;
  /** An array relationship */
  payment_promises: Array<Risolto_Payment_Promise>;
  /** An aggregate relationship */
  payment_promises_aggregate: Risolto_Payment_Promise_Aggregate;
  /** An array relationship */
  platform_participant_licenses: Array<Risolto_Platform_Participant_License>;
  /** An aggregate relationship */
  platform_participant_licenses_aggregate: Risolto_Platform_Participant_License_Aggregate;
  /** An array relationship */
  recipients: Array<Risolto_Recipient>;
  /** An aggregate relationship */
  recipients_aggregate: Risolto_Recipient_Aggregate;
  reference: Scalars['uuid'];
  /** An array relationship */
  system_integrations: Array<Risolto_System_Integration>;
  /** An aggregate relationship */
  system_integrations_aggregate: Risolto_System_Integration_Aggregate;
  /** An array relationship */
  tags: Array<Risolto_Tag>;
  /** An aggregate relationship */
  tags_aggregate: Risolto_Tag_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_interface_details?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantDispute_CodesArgs = {
  distinct_on?: Maybe<Array<Risolto_Dispute_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dispute_Code_Order_By>>;
  where?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantDispute_Codes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dispute_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dispute_Code_Order_By>>;
  where?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantDocument_InterchangesArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantDocument_Interchanges_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantDocumentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantInvoice_GroupsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantInvoice_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantLegal_EntitiesArgs = {
  distinct_on?: Maybe<Array<Risolto_Legal_Entity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Legal_Entity_Order_By>>;
  where?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantLegal_Entities_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Legal_Entity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Legal_Entity_Order_By>>;
  where?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantNotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantNotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantOpen_Balance_RecordsArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantOpen_Balance_Records_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantParticipant_Api_App_ClientsArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantParticipant_Api_App_Clients_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantParticipant_UsersArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantParticipant_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantPayment_PlansArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantPayment_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantPayment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantPayment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantPlatform_Participant_LicensesArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Participant_License_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Participant_License_Order_By>>;
  where?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantPlatform_Participant_Licenses_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Participant_License_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Participant_License_Order_By>>;
  where?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantRecipientsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantRecipients_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantSystem_IntegrationsArgs = {
  distinct_on?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_System_Integration_Order_By>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantSystem_Integrations_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_System_Integration_Order_By>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantTagsArgs = {
  distinct_on?: Maybe<Array<Risolto_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tag_Order_By>>;
  where?: Maybe<Risolto_Tag_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantTags_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tag_Order_By>>;
  where?: Maybe<Risolto_Tag_Bool_Exp>;
};


/** columns and relationships of "risolto.participant" */
export type Risolto_ParticipantUser_Interface_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.participant" */
export type Risolto_Participant_Aggregate = {
  __typename?: 'risolto_participant_aggregate';
  aggregate?: Maybe<Risolto_Participant_Aggregate_Fields>;
  nodes: Array<Risolto_Participant>;
};

/** aggregate fields of "risolto.participant" */
export type Risolto_Participant_Aggregate_Fields = {
  __typename?: 'risolto_participant_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Participant_Max_Fields>;
  min?: Maybe<Risolto_Participant_Min_Fields>;
};


/** aggregate fields of "risolto.participant" */
export type Risolto_Participant_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Participant_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** columns and relationships of "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client = {
  __typename?: 'risolto_participant_api_app_client';
  api_app_client: Scalars['uuid'];
  /** An object relationship */
  api_app_client_by_reference: Risolto_Api_App_Client;
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Aggregate = {
  __typename?: 'risolto_participant_api_app_client_aggregate';
  aggregate?: Maybe<Risolto_Participant_Api_App_Client_Aggregate_Fields>;
  nodes: Array<Risolto_Participant_Api_App_Client>;
};

export type Risolto_Participant_Api_App_Client_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Participant_Api_App_Client_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Participant_Api_App_Client_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Aggregate_Fields = {
  __typename?: 'risolto_participant_api_app_client_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Participant_Api_App_Client_Max_Fields>;
  min?: Maybe<Risolto_Participant_Api_App_Client_Min_Fields>;
};


/** aggregate fields of "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Participant_Api_App_Client_Max_Order_By>;
  min?: Maybe<Risolto_Participant_Api_App_Client_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Participant_Api_App_Client_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Participant_Api_App_Client_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.participant_api_app_client". All fields are combined with a logical 'AND'. */
export type Risolto_Participant_Api_App_Client_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Participant_Api_App_Client_Bool_Exp>>;
  _not?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Participant_Api_App_Client_Bool_Exp>>;
  api_app_client?: Maybe<Uuid_Comparison_Exp>;
  api_app_client_by_reference?: Maybe<Risolto_Api_App_Client_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.participant_api_app_client" */
export enum Risolto_Participant_Api_App_Client_Constraint {
  /** unique or primary key constraint on columns "reference" */
  ParticipantApiAppClientPkey = 'participant_api_app_client_pkey',
  /** unique or primary key constraint on columns "participant", "api_app_client" */
  UniqueParticipantApiAppClient = 'unique_participant_api_app_client',
  /** unique or primary key constraint on columns "participant", "api_app_client", "legal_entity" */
  UniqueParticipantLegalEntityApiAppClient = 'unique_participant_legal_entity_api_app_client'
}

/** input type for inserting data into table "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Insert_Input = {
  api_app_client?: Maybe<Scalars['uuid']>;
  api_app_client_by_reference?: Maybe<Risolto_Api_App_Client_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Participant_Api_App_Client_Max_Fields = {
  __typename?: 'risolto_participant_api_app_client_max_fields';
  api_app_client?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Max_Order_By = {
  api_app_client?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Participant_Api_App_Client_Min_Fields = {
  __typename?: 'risolto_participant_api_app_client_min_fields';
  api_app_client?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Min_Order_By = {
  api_app_client?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Mutation_Response = {
  __typename?: 'risolto_participant_api_app_client_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Participant_Api_App_Client>;
};

/** on_conflict condition type for table "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_On_Conflict = {
  constraint: Risolto_Participant_Api_App_Client_Constraint;
  update_columns?: Array<Risolto_Participant_Api_App_Client_Update_Column>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.participant_api_app_client". */
export type Risolto_Participant_Api_App_Client_Order_By = {
  api_app_client?: Maybe<Order_By>;
  api_app_client_by_reference?: Maybe<Risolto_Api_App_Client_Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.participant_api_app_client */
export type Risolto_Participant_Api_App_Client_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.participant_api_app_client" */
export enum Risolto_Participant_Api_App_Client_Select_Column {
  /** column name */
  ApiAppClient = 'api_app_client',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Set_Input = {
  api_app_client?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_participant_api_app_client" */
export type Risolto_Participant_Api_App_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Participant_Api_App_Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Participant_Api_App_Client_Stream_Cursor_Value_Input = {
  api_app_client?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.participant_api_app_client" */
export enum Risolto_Participant_Api_App_Client_Update_Column {
  /** column name */
  ApiAppClient = 'api_app_client',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Participant_Api_App_Client_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Participant_Api_App_Client_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Participant_Api_App_Client_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Participant_Append_Input = {
  user_interface_details?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.participant". All fields are combined with a logical 'AND'. */
export type Risolto_Participant_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Participant_Bool_Exp>>;
  _not?: Maybe<Risolto_Participant_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Participant_Bool_Exp>>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  dispute_codes?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
  dispute_codes_aggregate?: Maybe<Risolto_Dispute_Code_Aggregate_Bool_Exp>;
  document_interchanges?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  document_interchanges_aggregate?: Maybe<Risolto_Document_Interchange_Aggregate_Bool_Exp>;
  documents?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  documents_aggregate?: Maybe<Risolto_Invoice_Document_Aggregate_Bool_Exp>;
  dunning_version?: Maybe<String_Comparison_Exp>;
  invoice_groups?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  invoice_groups_aggregate?: Maybe<Risolto_Invoice_Group_Aggregate_Bool_Exp>;
  legal_entities?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  legal_entities_aggregate?: Maybe<Risolto_Legal_Entity_Aggregate_Bool_Exp>;
  logical_id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  notes?: Maybe<Risolto_Note_Bool_Exp>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Bool_Exp>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Bool_Exp>;
  participant_api_app_clients?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
  participant_api_app_clients_aggregate?: Maybe<Risolto_Participant_Api_App_Client_Aggregate_Bool_Exp>;
  participant_users?: Maybe<Risolto_Participant_User_Bool_Exp>;
  participant_users_aggregate?: Maybe<Risolto_Participant_User_Aggregate_Bool_Exp>;
  payment_plans?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  payment_plans_aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Bool_Exp>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Bool_Exp>;
  platform_participant_licenses?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
  platform_participant_licenses_aggregate?: Maybe<Risolto_Platform_Participant_License_Aggregate_Bool_Exp>;
  recipients?: Maybe<Risolto_Recipient_Bool_Exp>;
  recipients_aggregate?: Maybe<Risolto_Recipient_Aggregate_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  system_integrations?: Maybe<Risolto_System_Integration_Bool_Exp>;
  system_integrations_aggregate?: Maybe<Risolto_System_Integration_Aggregate_Bool_Exp>;
  tags?: Maybe<Risolto_Tag_Bool_Exp>;
  tags_aggregate?: Maybe<Risolto_Tag_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_interface_details?: Maybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.participant" */
export enum Risolto_Participant_Constraint {
  /** unique or primary key constraint on columns "reference" */
  ParticipantPkey = 'Participant_pkey',
  /** unique or primary key constraint on columns "reference" */
  ParticipantReferenceKey = 'Participant_reference_key',
  /** unique or primary key constraint on columns "logical_id" */
  ParticipantLogicalIdKey = 'participant_logical_id_key',
  /** unique or primary key constraint on columns "name" */
  ParticipantNameKey = 'participant_name_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Participant_Delete_At_Path_Input = {
  user_interface_details?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Participant_Delete_Elem_Input = {
  user_interface_details?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Participant_Delete_Key_Input = {
  user_interface_details?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run = {
  __typename?: 'risolto_participant_dunning_run';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  failed_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  invoice_group_dunning_runs: Array<Risolto_Invoice_Group_Dunning_Run>;
  /** An aggregate relationship */
  invoice_group_dunning_runs_aggregate: Risolto_Invoice_Group_Dunning_Run_Aggregate;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  processing_status: Risolto_Run_Processing_Status_Enum;
  /** An array relationship */
  recipient_dunning_runs: Array<Risolto_Recipient_Dunning_Run>;
  /** An aggregate relationship */
  recipient_dunning_runs_aggregate: Risolto_Recipient_Dunning_Run_Aggregate;
  reference: Scalars['uuid'];
  test: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_RunInvoice_Group_Dunning_RunsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


/** columns and relationships of "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_RunInvoice_Group_Dunning_Runs_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


/** columns and relationships of "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_RunRecipient_Dunning_RunsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};


/** columns and relationships of "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_RunRecipient_Dunning_Runs_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};

/** aggregated selection of "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_Aggregate = {
  __typename?: 'risolto_participant_dunning_run_aggregate';
  aggregate?: Maybe<Risolto_Participant_Dunning_Run_Aggregate_Fields>;
  nodes: Array<Risolto_Participant_Dunning_Run>;
};

/** aggregate fields of "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_Aggregate_Fields = {
  __typename?: 'risolto_participant_dunning_run_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Participant_Dunning_Run_Max_Fields>;
  min?: Maybe<Risolto_Participant_Dunning_Run_Min_Fields>;
};


/** aggregate fields of "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Participant_Dunning_Run_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.participant_dunning_run". All fields are combined with a logical 'AND'. */
export type Risolto_Participant_Dunning_Run_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Participant_Dunning_Run_Bool_Exp>>;
  _not?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Participant_Dunning_Run_Bool_Exp>>;
  completed_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  failed_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice_group_dunning_runs?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
  invoice_group_dunning_runs_aggregate?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum_Comparison_Exp>;
  recipient_dunning_runs?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
  recipient_dunning_runs_aggregate?: Maybe<Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  test?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.participant_dunning_run" */
export enum Risolto_Participant_Dunning_Run_Constraint {
  /** unique or primary key constraint on columns "reference" */
  ParticipantDunningRunPkey = 'ParticipantDunningRun_pkey'
}

/** input type for inserting data into table "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_Insert_Input = {
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  failed_at?: Maybe<Scalars['timestamptz']>;
  invoice_group_dunning_runs?: Maybe<Risolto_Invoice_Group_Dunning_Run_Arr_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  recipient_dunning_runs?: Maybe<Risolto_Recipient_Dunning_Run_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Participant_Dunning_Run_Max_Fields = {
  __typename?: 'risolto_participant_dunning_run_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  failed_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Participant_Dunning_Run_Min_Fields = {
  __typename?: 'risolto_participant_dunning_run_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  failed_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_Mutation_Response = {
  __typename?: 'risolto_participant_dunning_run_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Participant_Dunning_Run>;
};

/** input type for inserting object relation for remote table "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_Obj_Rel_Insert_Input = {
  data: Risolto_Participant_Dunning_Run_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Participant_Dunning_Run_On_Conflict>;
};

/** on_conflict condition type for table "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_On_Conflict = {
  constraint: Risolto_Participant_Dunning_Run_Constraint;
  update_columns?: Array<Risolto_Participant_Dunning_Run_Update_Column>;
  where?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.participant_dunning_run". */
export type Risolto_Participant_Dunning_Run_Order_By = {
  completed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  failed_at?: Maybe<Order_By>;
  invoice_group_dunning_runs_aggregate?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  processing_status?: Maybe<Order_By>;
  recipient_dunning_runs_aggregate?: Maybe<Risolto_Recipient_Dunning_Run_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  test?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.participant_dunning_run */
export type Risolto_Participant_Dunning_Run_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.participant_dunning_run" */
export enum Risolto_Participant_Dunning_Run_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Reference = 'reference',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_Set_Input = {
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  failed_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_participant_dunning_run" */
export type Risolto_Participant_Dunning_Run_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Participant_Dunning_Run_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Participant_Dunning_Run_Stream_Cursor_Value_Input = {
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  failed_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.participant_dunning_run" */
export enum Risolto_Participant_Dunning_Run_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailedAt = 'failed_at',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Reference = 'reference',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Participant_Dunning_Run_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Participant_Dunning_Run_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Participant_Dunning_Run_Bool_Exp;
};

/** input type for inserting data into table "risolto.participant" */
export type Risolto_Participant_Insert_Input = {
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dispute_codes?: Maybe<Risolto_Dispute_Code_Arr_Rel_Insert_Input>;
  document_interchanges?: Maybe<Risolto_Document_Interchange_Arr_Rel_Insert_Input>;
  documents?: Maybe<Risolto_Invoice_Document_Arr_Rel_Insert_Input>;
  dunning_version?: Maybe<Scalars['String']>;
  invoice_groups?: Maybe<Risolto_Invoice_Group_Arr_Rel_Insert_Input>;
  legal_entities?: Maybe<Risolto_Legal_Entity_Arr_Rel_Insert_Input>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Risolto_Note_Arr_Rel_Insert_Input>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Arr_Rel_Insert_Input>;
  participant_api_app_clients?: Maybe<Risolto_Participant_Api_App_Client_Arr_Rel_Insert_Input>;
  participant_users?: Maybe<Risolto_Participant_User_Arr_Rel_Insert_Input>;
  payment_plans?: Maybe<Risolto_Payment_Plan_Arr_Rel_Insert_Input>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Arr_Rel_Insert_Input>;
  platform_participant_licenses?: Maybe<Risolto_Platform_Participant_License_Arr_Rel_Insert_Input>;
  recipients?: Maybe<Risolto_Recipient_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  system_integrations?: Maybe<Risolto_System_Integration_Arr_Rel_Insert_Input>;
  tags?: Maybe<Risolto_Tag_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_interface_details?: Maybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Risolto_Participant_Max_Fields = {
  __typename?: 'risolto_participant_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_version?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Participant_Min_Fields = {
  __typename?: 'risolto_participant_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_version?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.participant" */
export type Risolto_Participant_Mutation_Response = {
  __typename?: 'risolto_participant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Participant>;
};

/** input type for inserting object relation for remote table "risolto.participant" */
export type Risolto_Participant_Obj_Rel_Insert_Input = {
  data: Risolto_Participant_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Participant_On_Conflict>;
};

/** on_conflict condition type for table "risolto.participant" */
export type Risolto_Participant_On_Conflict = {
  constraint: Risolto_Participant_Constraint;
  update_columns?: Array<Risolto_Participant_Update_Column>;
  where?: Maybe<Risolto_Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.participant". */
export type Risolto_Participant_Order_By = {
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  dispute_codes_aggregate?: Maybe<Risolto_Dispute_Code_Aggregate_Order_By>;
  document_interchanges_aggregate?: Maybe<Risolto_Document_Interchange_Aggregate_Order_By>;
  documents_aggregate?: Maybe<Risolto_Invoice_Document_Aggregate_Order_By>;
  dunning_version?: Maybe<Order_By>;
  invoice_groups_aggregate?: Maybe<Risolto_Invoice_Group_Aggregate_Order_By>;
  legal_entities_aggregate?: Maybe<Risolto_Legal_Entity_Aggregate_Order_By>;
  logical_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Order_By>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Order_By>;
  participant_api_app_clients_aggregate?: Maybe<Risolto_Participant_Api_App_Client_Aggregate_Order_By>;
  participant_users_aggregate?: Maybe<Risolto_Participant_User_Aggregate_Order_By>;
  payment_plans_aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Order_By>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Order_By>;
  platform_participant_licenses_aggregate?: Maybe<Risolto_Platform_Participant_License_Aggregate_Order_By>;
  recipients_aggregate?: Maybe<Risolto_Recipient_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  system_integrations_aggregate?: Maybe<Risolto_System_Integration_Aggregate_Order_By>;
  tags_aggregate?: Maybe<Risolto_Tag_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user_interface_details?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.participant */
export type Risolto_Participant_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Participant_Prepend_Input = {
  user_interface_details?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.participant" */
export enum Risolto_Participant_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DunningVersion = 'dunning_version',
  /** column name */
  LogicalId = 'logical_id',
  /** column name */
  Name = 'name',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserInterfaceDetails = 'user_interface_details'
}

/** input type for updating data in table "risolto.participant" */
export type Risolto_Participant_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_version?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_interface_details?: Maybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "risolto_participant" */
export type Risolto_Participant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Participant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Participant_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_version?: Maybe<Scalars['String']>;
  /** Logical technical identifier (no spaces, only underscore) which is unique across the system. Do not show this ID in the UI, except upon creation. */
  logical_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_interface_details?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "risolto.participant" */
export enum Risolto_Participant_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DunningVersion = 'dunning_version',
  /** column name */
  LogicalId = 'logical_id',
  /** column name */
  Name = 'name',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserInterfaceDetails = 'user_interface_details'
}

export type Risolto_Participant_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Participant_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Participant_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Participant_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Participant_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Participant_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Participant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Participant_Bool_Exp;
};

/** columns and relationships of "risolto.participant_user" */
export type Risolto_Participant_User = {
  __typename?: 'risolto_participant_user';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Date at which this participant_user got deactivated */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who disabled this participant_user */
  deactivated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  deactivated_by_reference?: Maybe<Risolto_Person>;
  /** Internal users don't show up in UI lists (e.g. assignees) */
  internal?: Maybe<Scalars['Boolean']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An array relationship */
  participant_user_roles: Array<Risolto_Participant_User_Role>;
  /** An aggregate relationship */
  participant_user_roles_aggregate: Risolto_Participant_User_Role_Aggregate;
  person: Scalars['uuid'];
  /** An object relationship */
  person_by_reference?: Maybe<Risolto_Person>;
  /** Date at which this participant_user got reactivated */
  reactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who reactivated this participant_user */
  reactivated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  reactivated_by_reference?: Maybe<Risolto_Person>;
  /** When true, the participant user data will be filtered by recipient_user */
  recipient_restriction?: Maybe<Scalars['Boolean']>;
  reference: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.participant_user" */
export type Risolto_Participant_UserParticipant_User_RolesArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Role_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
};


/** columns and relationships of "risolto.participant_user" */
export type Risolto_Participant_UserParticipant_User_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Role_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
};

/** aggregated selection of "risolto.participant_user" */
export type Risolto_Participant_User_Aggregate = {
  __typename?: 'risolto_participant_user_aggregate';
  aggregate?: Maybe<Risolto_Participant_User_Aggregate_Fields>;
  nodes: Array<Risolto_Participant_User>;
};

export type Risolto_Participant_User_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Participant_User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Participant_User_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Participant_User_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Participant_User_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Participant_User_Select_Column_Risolto_Participant_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Participant_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Participant_User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Participant_User_Select_Column_Risolto_Participant_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Participant_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Participant_User_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Participant_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.participant_user" */
export type Risolto_Participant_User_Aggregate_Fields = {
  __typename?: 'risolto_participant_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Participant_User_Max_Fields>;
  min?: Maybe<Risolto_Participant_User_Min_Fields>;
};


/** aggregate fields of "risolto.participant_user" */
export type Risolto_Participant_User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.participant_user" */
export type Risolto_Participant_User_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Participant_User_Max_Order_By>;
  min?: Maybe<Risolto_Participant_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.participant_user" */
export type Risolto_Participant_User_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Participant_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Participant_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.participant_user". All fields are combined with a logical 'AND'. */
export type Risolto_Participant_User_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Participant_User_Bool_Exp>>;
  _not?: Maybe<Risolto_Participant_User_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Participant_User_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: Maybe<Timestamptz_Comparison_Exp>;
  deactivated_by?: Maybe<Uuid_Comparison_Exp>;
  deactivated_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  internal?: Maybe<Boolean_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  participant_user_roles?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
  participant_user_roles_aggregate?: Maybe<Risolto_Participant_User_Role_Aggregate_Bool_Exp>;
  person?: Maybe<Uuid_Comparison_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  reactivated_at?: Maybe<Timestamptz_Comparison_Exp>;
  reactivated_by?: Maybe<Uuid_Comparison_Exp>;
  reactivated_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  recipient_restriction?: Maybe<Boolean_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.participant_user" */
export enum Risolto_Participant_User_Constraint {
  /** unique or primary key constraint on columns "participant", "person", "legal_entity" */
  ParticipantUserParticipantPersonKey = 'participant_user_participant_person_key',
  /** unique or primary key constraint on columns "reference" */
  ParticipantUserPkey = 'participant_user_pkey'
}

/** input type for inserting data into table "risolto.participant_user" */
export type Risolto_Participant_User_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Date at which this participant_user got deactivated */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who disabled this participant_user */
  deactivated_by?: Maybe<Scalars['uuid']>;
  deactivated_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  /** Internal users don't show up in UI lists (e.g. assignees) */
  internal?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  participant_user_roles?: Maybe<Risolto_Participant_User_Role_Arr_Rel_Insert_Input>;
  person?: Maybe<Scalars['uuid']>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  /** Date at which this participant_user got reactivated */
  reactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who reactivated this participant_user */
  reactivated_by?: Maybe<Scalars['uuid']>;
  reactivated_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  /** When true, the participant user data will be filtered by recipient_user */
  recipient_restriction?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Participant_User_Max_Fields = {
  __typename?: 'risolto_participant_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Date at which this participant_user got deactivated */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who disabled this participant_user */
  deactivated_by?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  /** Date at which this participant_user got reactivated */
  reactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who reactivated this participant_user */
  reactivated_by?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "risolto.participant_user" */
export type Risolto_Participant_User_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  /** Date at which this participant_user got deactivated */
  deactivated_at?: Maybe<Order_By>;
  /** UUID of person who disabled this participant_user */
  deactivated_by?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  person?: Maybe<Order_By>;
  /** Date at which this participant_user got reactivated */
  reactivated_at?: Maybe<Order_By>;
  /** UUID of person who reactivated this participant_user */
  reactivated_by?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Participant_User_Min_Fields = {
  __typename?: 'risolto_participant_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Date at which this participant_user got deactivated */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who disabled this participant_user */
  deactivated_by?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  /** Date at which this participant_user got reactivated */
  reactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who reactivated this participant_user */
  reactivated_by?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "risolto.participant_user" */
export type Risolto_Participant_User_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  /** Date at which this participant_user got deactivated */
  deactivated_at?: Maybe<Order_By>;
  /** UUID of person who disabled this participant_user */
  deactivated_by?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  person?: Maybe<Order_By>;
  /** Date at which this participant_user got reactivated */
  reactivated_at?: Maybe<Order_By>;
  /** UUID of person who reactivated this participant_user */
  reactivated_by?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.participant_user" */
export type Risolto_Participant_User_Mutation_Response = {
  __typename?: 'risolto_participant_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Participant_User>;
};

/** input type for inserting object relation for remote table "risolto.participant_user" */
export type Risolto_Participant_User_Obj_Rel_Insert_Input = {
  data: Risolto_Participant_User_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Participant_User_On_Conflict>;
};

/** on_conflict condition type for table "risolto.participant_user" */
export type Risolto_Participant_User_On_Conflict = {
  constraint: Risolto_Participant_User_Constraint;
  update_columns?: Array<Risolto_Participant_User_Update_Column>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.participant_user". */
export type Risolto_Participant_User_Order_By = {
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  deactivated_by?: Maybe<Order_By>;
  deactivated_by_reference?: Maybe<Risolto_Person_Order_By>;
  internal?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  participant_user_roles_aggregate?: Maybe<Risolto_Participant_User_Role_Aggregate_Order_By>;
  person?: Maybe<Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  reactivated_at?: Maybe<Order_By>;
  reactivated_by?: Maybe<Order_By>;
  reactivated_by_reference?: Maybe<Risolto_Person_Order_By>;
  recipient_restriction?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.participant_user */
export type Risolto_Participant_User_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** Defines the role for a user within a participant */
export type Risolto_Participant_User_Role = {
  __typename?: 'risolto_participant_user_role';
  created_at: Scalars['timestamptz'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  participant_user: Scalars['uuid'];
  /** An object relationship */
  participant_user_by_reference: Risolto_Participant_User;
  platform_role: Scalars['uuid'];
  /** An object relationship */
  platform_role_by_reference: Risolto_Platform_Role;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Aggregate = {
  __typename?: 'risolto_participant_user_role_aggregate';
  aggregate?: Maybe<Risolto_Participant_User_Role_Aggregate_Fields>;
  nodes: Array<Risolto_Participant_User_Role>;
};

export type Risolto_Participant_User_Role_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Participant_User_Role_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Participant_User_Role_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Participant_User_Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Aggregate_Fields = {
  __typename?: 'risolto_participant_user_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Participant_User_Role_Max_Fields>;
  min?: Maybe<Risolto_Participant_User_Role_Min_Fields>;
};


/** aggregate fields of "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Participant_User_Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Participant_User_Role_Max_Order_By>;
  min?: Maybe<Risolto_Participant_User_Role_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Participant_User_Role_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Participant_User_Role_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.participant_user_role". All fields are combined with a logical 'AND'. */
export type Risolto_Participant_User_Role_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Participant_User_Role_Bool_Exp>>;
  _not?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Participant_User_Role_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  participant_user?: Maybe<Uuid_Comparison_Exp>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Bool_Exp>;
  platform_role?: Maybe<Uuid_Comparison_Exp>;
  platform_role_by_reference?: Maybe<Risolto_Platform_Role_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.participant_user_role" */
export enum Risolto_Participant_User_Role_Constraint {
  /** unique or primary key constraint on columns "platform_role", "participant", "participant_user" */
  ParticipantUserRoleParticipantPlatformRoleParticipantKey = 'participant_user_role_participant_platform_role_participant_key',
  /** unique or primary key constraint on columns "reference" */
  ParticipantUserRolePkey = 'participant_user_role_pkey'
}

/** input type for inserting data into table "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  participant_user?: Maybe<Scalars['uuid']>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Obj_Rel_Insert_Input>;
  platform_role?: Maybe<Scalars['uuid']>;
  platform_role_by_reference?: Maybe<Risolto_Platform_Role_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Participant_User_Role_Max_Fields = {
  __typename?: 'risolto_participant_user_role_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  platform_role?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_user?: Maybe<Order_By>;
  platform_role?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Participant_User_Role_Min_Fields = {
  __typename?: 'risolto_participant_user_role_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  platform_role?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_user?: Maybe<Order_By>;
  platform_role?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Mutation_Response = {
  __typename?: 'risolto_participant_user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Participant_User_Role>;
};

/** on_conflict condition type for table "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_On_Conflict = {
  constraint: Risolto_Participant_User_Role_Constraint;
  update_columns?: Array<Risolto_Participant_User_Role_Update_Column>;
  where?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.participant_user_role". */
export type Risolto_Participant_User_Role_Order_By = {
  created_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  participant_user?: Maybe<Order_By>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Order_By>;
  platform_role?: Maybe<Order_By>;
  platform_role_by_reference?: Maybe<Risolto_Platform_Role_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.participant_user_role */
export type Risolto_Participant_User_Role_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.participant_user_role" */
export enum Risolto_Participant_User_Role_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  PlatformRole = 'platform_role',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.participant_user_role" */
export type Risolto_Participant_User_Role_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  platform_role?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_participant_user_role" */
export type Risolto_Participant_User_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Participant_User_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Participant_User_Role_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  platform_role?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.participant_user_role" */
export enum Risolto_Participant_User_Role_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  PlatformRole = 'platform_role',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Participant_User_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Participant_User_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Participant_User_Role_Bool_Exp;
};

/** select columns of table "risolto.participant_user" */
export enum Risolto_Participant_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DeactivatedBy = 'deactivated_by',
  /** column name */
  Internal = 'internal',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Person = 'person',
  /** column name */
  ReactivatedAt = 'reactivated_at',
  /** column name */
  ReactivatedBy = 'reactivated_by',
  /** column name */
  RecipientRestriction = 'recipient_restriction',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** select "risolto_participant_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.participant_user" */
export enum Risolto_Participant_User_Select_Column_Risolto_Participant_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Internal = 'internal',
  /** column name */
  RecipientRestriction = 'recipient_restriction'
}

/** select "risolto_participant_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.participant_user" */
export enum Risolto_Participant_User_Select_Column_Risolto_Participant_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Internal = 'internal',
  /** column name */
  RecipientRestriction = 'recipient_restriction'
}

/** input type for updating data in table "risolto.participant_user" */
export type Risolto_Participant_User_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Date at which this participant_user got deactivated */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who disabled this participant_user */
  deactivated_by?: Maybe<Scalars['uuid']>;
  /** Internal users don't show up in UI lists (e.g. assignees) */
  internal?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  /** Date at which this participant_user got reactivated */
  reactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who reactivated this participant_user */
  reactivated_by?: Maybe<Scalars['uuid']>;
  /** When true, the participant user data will be filtered by recipient_user */
  recipient_restriction?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_participant_user" */
export type Risolto_Participant_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Participant_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Participant_User_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Date at which this participant_user got deactivated */
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who disabled this participant_user */
  deactivated_by?: Maybe<Scalars['uuid']>;
  /** Internal users don't show up in UI lists (e.g. assignees) */
  internal?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  /** Date at which this participant_user got reactivated */
  reactivated_at?: Maybe<Scalars['timestamptz']>;
  /** UUID of person who reactivated this participant_user */
  reactivated_by?: Maybe<Scalars['uuid']>;
  /** When true, the participant user data will be filtered by recipient_user */
  recipient_restriction?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.participant_user" */
export enum Risolto_Participant_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  DeactivatedBy = 'deactivated_by',
  /** column name */
  Internal = 'internal',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Person = 'person',
  /** column name */
  ReactivatedAt = 'reactivated_at',
  /** column name */
  ReactivatedBy = 'reactivated_by',
  /** column name */
  RecipientRestriction = 'recipient_restriction',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Risolto_Participant_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Participant_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Participant_User_Bool_Exp;
};

/** columns and relationships of "risolto.payment" */
export type Risolto_Payment = {
  __typename?: 'risolto_payment';
  amount_paid: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  currency: Scalars['String'];
  custom_fields: Scalars['jsonb'];
  dunning_notice?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice>;
  invoice?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice_by_reference?: Maybe<Risolto_Invoice_Document>;
  is_refund: Scalars['Boolean'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  method: Scalars['String'];
  origin: Risolto_Origin_Enum;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_document?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_document_by_reference?: Maybe<Risolto_Payment_Document>;
  payment_number: Scalars['String'];
  payment_promise?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise>;
  payment_reference: Scalars['String'];
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.payment" */
export type Risolto_PaymentCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.payment" */
export type Risolto_Payment_Aggregate = {
  __typename?: 'risolto_payment_aggregate';
  aggregate?: Maybe<Risolto_Payment_Aggregate_Fields>;
  nodes: Array<Risolto_Payment>;
};

export type Risolto_Payment_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Payment_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Payment_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Payment_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Payment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Payment_Select_Column_Risolto_Payment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Payment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Payment_Select_Column_Risolto_Payment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Payment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.payment" */
export type Risolto_Payment_Aggregate_Fields = {
  __typename?: 'risolto_payment_aggregate_fields';
  avg?: Maybe<Risolto_Payment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Max_Fields>;
  min?: Maybe<Risolto_Payment_Min_Fields>;
  stddev?: Maybe<Risolto_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Payment_Sum_Fields>;
  var_pop?: Maybe<Risolto_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Payment_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Payment_Variance_Fields>;
};


/** aggregate fields of "risolto.payment" */
export type Risolto_Payment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.payment" */
export type Risolto_Payment_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Payment_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Payment_Max_Order_By>;
  min?: Maybe<Risolto_Payment_Min_Order_By>;
  stddev?: Maybe<Risolto_Payment_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Payment_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Payment_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Payment_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Payment_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Payment_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Payment_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.payment" */
export type Risolto_Payment_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Payment_Avg_Fields = {
  __typename?: 'risolto_payment_avg_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.payment" */
export type Risolto_Payment_Avg_Order_By = {
  amount_paid?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.payment". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Bool_Exp>>;
  amount_paid?: Maybe<Numeric_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency?: Maybe<String_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  dunning_notice?: Maybe<Uuid_Comparison_Exp>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  is_refund?: Maybe<Boolean_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  method?: Maybe<String_Comparison_Exp>;
  origin?: Maybe<Risolto_Origin_Enum_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_document?: Maybe<Uuid_Comparison_Exp>;
  payment_document_by_reference?: Maybe<Risolto_Payment_Document_Bool_Exp>;
  payment_number?: Maybe<String_Comparison_Exp>;
  payment_promise?: Maybe<Uuid_Comparison_Exp>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment" */
export enum Risolto_Payment_Constraint {
  /** unique or primary key constraint on columns "participant", "origin", "payment_number" */
  PaymentParticipantOriginPaymentNumberKey = 'payment_participant_origin_payment_number_key',
  /** unique or primary key constraint on columns "reference" */
  PaymentPkey = 'payment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Payment_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Payment_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Payment_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_Document = {
  __typename?: 'risolto_payment_document';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency: Scalars['String'];
  created_at: Scalars['timestamptz'];
  custom_fields: Scalars['jsonb'];
  /** Same as payment_number but with a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** PAYMENT */
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "risolto.payment_document_dunning_status" */
  dunning_status?: Maybe<Scalars['jsonb']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  interchange_links: Array<Risolto_Document_Interchange_Link>;
  /** An aggregate relationship */
  interchange_links_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  /** An array relationship */
  invoice_group_payments: Array<Risolto_Invoice_Group_Payment>;
  /** An aggregate relationship */
  invoice_group_payments_aggregate: Risolto_Invoice_Group_Payment_Aggregate;
  /** True if the document has an open amount > 0.00 false otherwise. */
  is_open?: Maybe<Scalars['Boolean']>;
  issue_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "risolto.payment_last_dunning_actions" */
  last_dunning_actions?: Maybe<Array<Risolto_Virtual_Dunning_Action>>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  open_amount: Scalars['numeric'];
  origin: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_number: Scalars['String'];
  /** An array relationship */
  payments: Array<Risolto_Payment>;
  /** An aggregate relationship */
  payments_aggregate: Risolto_Payment_Aggregate;
  processing_status: Scalars['String'];
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  total_amount: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentDunning_StatusArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentFile_ReferencesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentInterchange_LinksArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentInterchange_Links_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentInvoice_Group_PaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentInvoice_Group_Payments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentLast_Dunning_ActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentPaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_document" */
export type Risolto_Payment_DocumentPayments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};

/** aggregated selection of "risolto.payment_document" */
export type Risolto_Payment_Document_Aggregate = {
  __typename?: 'risolto_payment_document_aggregate';
  aggregate?: Maybe<Risolto_Payment_Document_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Document>;
};

export type Risolto_Payment_Document_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Payment_Document_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Payment_Document_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.payment_document" */
export type Risolto_Payment_Document_Aggregate_Fields = {
  __typename?: 'risolto_payment_document_aggregate_fields';
  avg?: Maybe<Risolto_Payment_Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Document_Max_Fields>;
  min?: Maybe<Risolto_Payment_Document_Min_Fields>;
  stddev?: Maybe<Risolto_Payment_Document_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Payment_Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Payment_Document_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Payment_Document_Sum_Fields>;
  var_pop?: Maybe<Risolto_Payment_Document_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Payment_Document_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Payment_Document_Variance_Fields>;
};


/** aggregate fields of "risolto.payment_document" */
export type Risolto_Payment_Document_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.payment_document" */
export type Risolto_Payment_Document_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Payment_Document_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Payment_Document_Max_Order_By>;
  min?: Maybe<Risolto_Payment_Document_Min_Order_By>;
  stddev?: Maybe<Risolto_Payment_Document_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Payment_Document_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Payment_Document_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Payment_Document_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Payment_Document_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Payment_Document_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Payment_Document_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Payment_Document_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
  file_references?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.payment_document" */
export type Risolto_Payment_Document_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Payment_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Document_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Payment_Document_Avg_Fields = {
  __typename?: 'risolto_payment_document_avg_fields';
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.payment_document". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Document_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Document_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Document_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Document_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  active_payment_plan?: Maybe<Uuid_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  document_number?: Maybe<String_Comparison_Exp>;
  document_open_amount?: Maybe<Numeric_Comparison_Exp>;
  document_total_amount?: Maybe<Numeric_Comparison_Exp>;
  document_type?: Maybe<String_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  dunning_status?: Maybe<Jsonb_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  file_references?: Maybe<Jsonb_Comparison_Exp>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp>;
  invoice_group_payments?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
  invoice_group_payments_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Aggregate_Bool_Exp>;
  is_open?: Maybe<Boolean_Comparison_Exp>;
  issue_date?: Maybe<Date_Comparison_Exp>;
  last_dunning_actions?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  origin?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_number?: Maybe<String_Comparison_Exp>;
  payments?: Maybe<Risolto_Payment_Bool_Exp>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Bool_Exp>;
  processing_status?: Maybe<String_Comparison_Exp>;
  raw_input?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment_document" */
export enum Risolto_Payment_Document_Constraint {
  /** unique or primary key constraint on columns "participant", "payment_number", "legal_entity" */
  PaymentDocumentParticipantLegalEntityPaymentNumberKey = 'payment_document_participant_legal_entity_payment_number_key',
  /** unique or primary key constraint on columns "participant", "external_id", "recipient", "legal_entity" */
  PaymentDocumentParticipantLegalEntityRecipientExternalId = 'payment_document_participant_legal_entity_recipient_external_id',
  /** unique or primary key constraint on columns "reference" */
  PaymentDocumentPkey = 'payment_document_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Payment_Document_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
  file_references?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Payment_Document_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
  file_references?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Payment_Document_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.payment_document" */
export type Risolto_Payment_Document_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.payment_document" */
export type Risolto_Payment_Document_Insert_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  interchange_links?: Maybe<Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input>;
  invoice_group_payments?: Maybe<Risolto_Invoice_Group_Payment_Arr_Rel_Insert_Input>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_number?: Maybe<Scalars['String']>;
  payments?: Maybe<Risolto_Payment_Arr_Rel_Insert_Input>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Payment_Document_Max_Fields = {
  __typename?: 'risolto_payment_document_max_fields';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Same as payment_number but with a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** PAYMENT */
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_number?: Maybe<Scalars['String']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Max_Order_By = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_number?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Payment_Document_Min_Fields = {
  __typename?: 'risolto_payment_document_min_fields';
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  active_payment_plan?: Maybe<Scalars['uuid']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Same as payment_number but with a more generic name */
  document_number?: Maybe<Scalars['String']>;
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  /** PAYMENT */
  document_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_number?: Maybe<Scalars['String']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Min_Order_By = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_number?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.payment_document" */
export type Risolto_Payment_Document_Mutation_Response = {
  __typename?: 'risolto_payment_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Document>;
};

/** input type for inserting object relation for remote table "risolto.payment_document" */
export type Risolto_Payment_Document_Obj_Rel_Insert_Input = {
  data: Risolto_Payment_Document_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Document_On_Conflict>;
};

/** on_conflict condition type for table "risolto.payment_document" */
export type Risolto_Payment_Document_On_Conflict = {
  constraint: Risolto_Payment_Document_Constraint;
  update_columns?: Array<Risolto_Payment_Document_Update_Column>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_document". */
export type Risolto_Payment_Document_Order_By = {
  account_id?: Maybe<Order_By>;
  active_payment_plan?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  document_number?: Maybe<Order_By>;
  document_open_amount?: Maybe<Order_By>;
  document_total_amount?: Maybe<Order_By>;
  document_type?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  dunning_status?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  file_references?: Maybe<Order_By>;
  interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Order_By>;
  invoice_group_payments_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Aggregate_Order_By>;
  is_open?: Maybe<Order_By>;
  issue_date?: Maybe<Order_By>;
  last_dunning_actions_aggregate?: Maybe<Risolto_Virtual_Dunning_Action_Aggregate_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  open_amount?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_number?: Maybe<Order_By>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Order_By>;
  processing_status?: Maybe<Order_By>;
  raw_input?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_document */
export type Risolto_Payment_Document_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Payment_Document_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
  file_references?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.payment_document" */
export enum Risolto_Payment_Document_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentNumber = 'payment_number',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.payment_document" */
export type Risolto_Payment_Document_Set_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_number?: Maybe<Scalars['String']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Payment_Document_Stddev_Fields = {
  __typename?: 'risolto_payment_document_stddev_fields';
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Payment_Document_Stddev_Pop_Fields = {
  __typename?: 'risolto_payment_document_stddev_pop_fields';
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Payment_Document_Stddev_Samp_Fields = {
  __typename?: 'risolto_payment_document_stddev_samp_fields';
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_payment_document" */
export type Risolto_Payment_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Document_Stream_Cursor_Value_Input = {
  /** Human readable account_id for the recipient, corresponding to recipient.account_id (*not* the internal PK, GUID) */
  account_id?: Maybe<Scalars['String']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  due_date?: Maybe<Scalars['date']>;
  /** Reference to the *internal* identifier from the *external* system. E.g. the primary key in the source system. */
  external_id?: Maybe<Scalars['String']>;
  file_references?: Maybe<Scalars['jsonb']>;
  issue_date?: Maybe<Scalars['date']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  origin?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_number?: Maybe<Scalars['String']>;
  processing_status?: Maybe<Scalars['String']>;
  /** The raw input record (e.g. a CSV line, XML or JSON entry) */
  raw_input?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Payment_Document_Sum_Fields = {
  __typename?: 'risolto_payment_document_sum_fields';
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.payment_document" */
export enum Risolto_Payment_Document_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FileReferences = 'file_references',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentNumber = 'payment_number',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  RawInput = 'raw_input',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Payment_Document_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Payment_Document_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Payment_Document_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Payment_Document_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Payment_Document_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Payment_Document_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Payment_Document_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Document_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Payment_Document_Var_Pop_Fields = {
  __typename?: 'risolto_payment_document_var_pop_fields';
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Payment_Document_Var_Samp_Fields = {
  __typename?: 'risolto_payment_document_var_samp_fields';
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Payment_Document_Variance_Fields = {
  __typename?: 'risolto_payment_document_variance_fields';
  /** Open amount represented as a 'negative' (credit) amount */
  document_open_amount?: Maybe<Scalars['numeric']>;
  /** Total amount represented as a 'negative' (credit) amount. */
  document_total_amount?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.payment_document" */
export type Risolto_Payment_Document_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** input type for incrementing numeric columns in table "risolto.payment" */
export type Risolto_Payment_Inc_Input = {
  amount_paid?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.payment" */
export type Risolto_Payment_Insert_Input = {
  amount_paid?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Obj_Rel_Insert_Input>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  is_refund?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  method?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_document?: Maybe<Scalars['uuid']>;
  payment_document_by_reference?: Maybe<Risolto_Payment_Document_Obj_Rel_Insert_Input>;
  payment_number?: Maybe<Scalars['String']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Obj_Rel_Insert_Input>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.payment_link" */
export type Risolto_Payment_Link = {
  __typename?: 'risolto_payment_link';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  dunning_notices: Array<Risolto_Dunning_Notice>;
  /** An aggregate relationship */
  dunning_notices_aggregate: Risolto_Dunning_Notice_Aggregate;
  /** DEPRECATED. See payment_link on invoice */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** DEPRECATED. See payment_link on payment_promise */
  payment_promise?: Maybe<Scalars['uuid']>;
  /** Payment reference to be used for the payment. Not necessarily unique */
  payment_reference?: Maybe<Scalars['String']>;
  qr_codes: Scalars['jsonb'];
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  /** Unique payment link reconciliation key */
  reconciliation_key: Scalars['String'];
  reference: Scalars['uuid'];
  short_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url: Scalars['String'];
};


/** columns and relationships of "risolto.payment_link" */
export type Risolto_Payment_LinkDunning_NoticesArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_link" */
export type Risolto_Payment_LinkDunning_Notices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_link" */
export type Risolto_Payment_LinkQr_CodesArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.payment_link" */
export type Risolto_Payment_Link_Aggregate = {
  __typename?: 'risolto_payment_link_aggregate';
  aggregate?: Maybe<Risolto_Payment_Link_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Link>;
};

/** aggregate fields of "risolto.payment_link" */
export type Risolto_Payment_Link_Aggregate_Fields = {
  __typename?: 'risolto_payment_link_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Link_Max_Fields>;
  min?: Maybe<Risolto_Payment_Link_Min_Fields>;
};


/** aggregate fields of "risolto.payment_link" */
export type Risolto_Payment_Link_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Link_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Payment_Link_Append_Input = {
  qr_codes?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.payment_link". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Link_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Link_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Link_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Link_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  dunning_notices?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  dunning_notices_aggregate?: Maybe<Risolto_Dunning_Notice_Aggregate_Bool_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_promise?: Maybe<Uuid_Comparison_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  qr_codes?: Maybe<Jsonb_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reconciliation_key?: Maybe<String_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  short_url?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  url?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment_link" */
export enum Risolto_Payment_Link_Constraint {
  /** unique or primary key constraint on columns "reference" */
  PaymentLinkPkey = 'payment_link_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Payment_Link_Delete_At_Path_Input = {
  qr_codes?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Payment_Link_Delete_Elem_Input = {
  qr_codes?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Payment_Link_Delete_Key_Input = {
  qr_codes?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.payment_link" */
export type Risolto_Payment_Link_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_notices?: Maybe<Risolto_Dunning_Notice_Arr_Rel_Insert_Input>;
  /** DEPRECATED. See payment_link on invoice */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  /** DEPRECATED. See payment_link on payment_promise */
  payment_promise?: Maybe<Scalars['uuid']>;
  /** Payment reference to be used for the payment. Not necessarily unique */
  payment_reference?: Maybe<Scalars['String']>;
  qr_codes?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  /** Unique payment link reconciliation key */
  reconciliation_key?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  short_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Payment_Link_Max_Fields = {
  __typename?: 'risolto_payment_link_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED. See payment_link on invoice */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. See payment_link on payment_promise */
  payment_promise?: Maybe<Scalars['uuid']>;
  /** Payment reference to be used for the payment. Not necessarily unique */
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** Unique payment link reconciliation key */
  reconciliation_key?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  short_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Payment_Link_Min_Fields = {
  __typename?: 'risolto_payment_link_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED. See payment_link on invoice */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. See payment_link on payment_promise */
  payment_promise?: Maybe<Scalars['uuid']>;
  /** Payment reference to be used for the payment. Not necessarily unique */
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** Unique payment link reconciliation key */
  reconciliation_key?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  short_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.payment_link" */
export type Risolto_Payment_Link_Mutation_Response = {
  __typename?: 'risolto_payment_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Link>;
};

/** input type for inserting object relation for remote table "risolto.payment_link" */
export type Risolto_Payment_Link_Obj_Rel_Insert_Input = {
  data: Risolto_Payment_Link_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Link_On_Conflict>;
};

/** on_conflict condition type for table "risolto.payment_link" */
export type Risolto_Payment_Link_On_Conflict = {
  constraint: Risolto_Payment_Link_Constraint;
  update_columns?: Array<Risolto_Payment_Link_Update_Column>;
  where?: Maybe<Risolto_Payment_Link_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_link". */
export type Risolto_Payment_Link_Order_By = {
  created_at?: Maybe<Order_By>;
  dunning_notices_aggregate?: Maybe<Risolto_Dunning_Notice_Aggregate_Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  qr_codes?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reconciliation_key?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  short_url?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_link */
export type Risolto_Payment_Link_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Payment_Link_Prepend_Input = {
  qr_codes?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.payment_link" */
export enum Risolto_Payment_Link_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  QrCodes = 'qr_codes',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  ReconciliationKey = 'reconciliation_key',
  /** column name */
  Reference = 'reference',
  /** column name */
  ShortUrl = 'short_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "risolto.payment_link" */
export type Risolto_Payment_Link_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED. See payment_link on invoice */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. See payment_link on payment_promise */
  payment_promise?: Maybe<Scalars['uuid']>;
  /** Payment reference to be used for the payment. Not necessarily unique */
  payment_reference?: Maybe<Scalars['String']>;
  qr_codes?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** Unique payment link reconciliation key */
  reconciliation_key?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  short_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_payment_link" */
export type Risolto_Payment_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Link_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED. See payment_link on invoice */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. See payment_link on payment_promise */
  payment_promise?: Maybe<Scalars['uuid']>;
  /** Payment reference to be used for the payment. Not necessarily unique */
  payment_reference?: Maybe<Scalars['String']>;
  qr_codes?: Maybe<Scalars['jsonb']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** Unique payment link reconciliation key */
  reconciliation_key?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  short_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.payment_link" */
export enum Risolto_Payment_Link_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  QrCodes = 'qr_codes',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  ReconciliationKey = 'reconciliation_key',
  /** column name */
  Reference = 'reference',
  /** column name */
  ShortUrl = 'short_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Risolto_Payment_Link_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Payment_Link_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Payment_Link_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Payment_Link_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Payment_Link_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Payment_Link_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Link_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Link_Bool_Exp;
};

/** aggregate max on columns */
export type Risolto_Payment_Max_Fields = {
  __typename?: 'risolto_payment_max_fields';
  amount_paid?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  payment_number?: Maybe<Scalars['String']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.payment" */
export type Risolto_Payment_Max_Order_By = {
  amount_paid?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  method?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_document?: Maybe<Order_By>;
  payment_number?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Payment_Min_Fields = {
  __typename?: 'risolto_payment_min_fields';
  amount_paid?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  payment_number?: Maybe<Scalars['String']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.payment" */
export type Risolto_Payment_Min_Order_By = {
  amount_paid?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  method?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_document?: Maybe<Order_By>;
  payment_number?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.payment" */
export type Risolto_Payment_Mutation_Response = {
  __typename?: 'risolto_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment>;
};

/** on_conflict condition type for table "risolto.payment" */
export type Risolto_Payment_On_Conflict = {
  constraint: Risolto_Payment_Constraint;
  update_columns?: Array<Risolto_Payment_Update_Column>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment". */
export type Risolto_Payment_Order_By = {
  amount_paid?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  is_refund?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  method?: Maybe<Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_document?: Maybe<Order_By>;
  payment_document_by_reference?: Maybe<Risolto_Payment_Document_Order_By>;
  payment_number?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Order_By>;
  payment_reference?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment */
export type Risolto_Payment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** columns and relationships of "risolto.payment_plan" */
export type Risolto_Payment_Plan = {
  __typename?: 'risolto_payment_plan';
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  amount_currency?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  approved_by_by_reference?: Maybe<Risolto_Person>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  canceled_by_by_reference?: Maybe<Risolto_Person>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  closing_email_sent_at?: Maybe<Scalars['timestamptz']>;
  conditions: Scalars['jsonb'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Flag indicating whether or not the payment plan can be modified by the debtor. */
  custom: Scalars['Boolean'];
  denied_at?: Maybe<Scalars['timestamptz']>;
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount: Scalars['numeric'];
  installments: Scalars['Int'];
  /** Payment plan interest */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group: Scalars['uuid'];
  /** An object relationship */
  invoice_group_by_reference: Risolto_Invoice_Group;
  is_open?: Maybe<Scalars['Boolean']>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  name: Scalars['String'];
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  paid: Scalars['Boolean'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An array relationship */
  payment_promises: Array<Risolto_Payment_Promise>;
  /** An aggregate relationship */
  payment_promises_aggregate: Risolto_Payment_Promise_Aggregate;
  /** DRAFT | OPEN | DONE */
  processing_status: Scalars['String'];
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  /** Random value used to find the payment plans from a public URL */
  reverse_link_id: Scalars['String'];
  reverse_link_url: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  total_amount: Scalars['numeric'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "risolto.payment_plan" */
export type Risolto_Payment_PlanActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_plan" */
export type Risolto_Payment_PlanActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_plan" */
export type Risolto_Payment_PlanConditionsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.payment_plan" */
export type Risolto_Payment_PlanPayment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_plan" */
export type Risolto_Payment_PlanPayment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};

/** aggregated selection of "risolto.payment_plan" */
export type Risolto_Payment_Plan_Aggregate = {
  __typename?: 'risolto_payment_plan_aggregate';
  aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Plan>;
};

export type Risolto_Payment_Plan_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Payment_Plan_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Payment_Plan_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Payment_Plan_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Payment_Plan_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Payment_Plan_Select_Column_Risolto_Payment_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Payment_Plan_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Payment_Plan_Select_Column_Risolto_Payment_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Payment_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.payment_plan" */
export type Risolto_Payment_Plan_Aggregate_Fields = {
  __typename?: 'risolto_payment_plan_aggregate_fields';
  avg?: Maybe<Risolto_Payment_Plan_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Plan_Max_Fields>;
  min?: Maybe<Risolto_Payment_Plan_Min_Fields>;
  stddev?: Maybe<Risolto_Payment_Plan_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Payment_Plan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Payment_Plan_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Payment_Plan_Sum_Fields>;
  var_pop?: Maybe<Risolto_Payment_Plan_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Payment_Plan_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Payment_Plan_Variance_Fields>;
};


/** aggregate fields of "risolto.payment_plan" */
export type Risolto_Payment_Plan_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Payment_Plan_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Payment_Plan_Max_Order_By>;
  min?: Maybe<Risolto_Payment_Plan_Min_Order_By>;
  stddev?: Maybe<Risolto_Payment_Plan_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Payment_Plan_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Payment_Plan_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Payment_Plan_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Payment_Plan_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Payment_Plan_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Payment_Plan_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Payment_Plan_Append_Input = {
  conditions?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Payment_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Plan_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Payment_Plan_Avg_Fields = {
  __typename?: 'risolto_payment_plan_avg_fields';
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['Float']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by avg() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Avg_Order_By = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.payment_plan". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Plan_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Plan_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Plan_Bool_Exp>>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  approved_at?: Maybe<Timestamptz_Comparison_Exp>;
  approved_by?: Maybe<Uuid_Comparison_Exp>;
  approved_by_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  canceled_at?: Maybe<Timestamptz_Comparison_Exp>;
  canceled_by?: Maybe<Uuid_Comparison_Exp>;
  canceled_by_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  closed_at?: Maybe<Timestamptz_Comparison_Exp>;
  closing_email_sent_at?: Maybe<Timestamptz_Comparison_Exp>;
  conditions?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom?: Maybe<Boolean_Comparison_Exp>;
  denied_at?: Maybe<Timestamptz_Comparison_Exp>;
  due_amount?: Maybe<Numeric_Comparison_Exp>;
  indemnification?: Maybe<Numeric_Comparison_Exp>;
  installment_amount?: Maybe<Numeric_Comparison_Exp>;
  installments?: Maybe<Int_Comparison_Exp>;
  interest?: Maybe<Numeric_Comparison_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  is_open?: Maybe<Boolean_Comparison_Exp>;
  last_email_to?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  original_open_amount?: Maybe<Numeric_Comparison_Exp>;
  paid?: Maybe<Boolean_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Bool_Exp>;
  processing_status?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  reverse_link_id?: Maybe<String_Comparison_Exp>;
  reverse_link_url?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  virtual_open_amount?: Maybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment_plan" */
export enum Risolto_Payment_Plan_Constraint {
  /** unique or primary key constraint on columns "reference" */
  PaymentPlanPkey = 'payment_plan_pkey',
  /** unique or primary key constraint on columns "recipient" */
  PaymentPlanUniqueOpen = 'payment_plan_unique_open'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Payment_Plan_Delete_At_Path_Input = {
  conditions?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Payment_Plan_Delete_Elem_Input = {
  conditions?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Payment_Plan_Delete_Key_Input = {
  conditions?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Inc_Input = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Insert_Input = {
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  amount_currency?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['uuid']>;
  approved_by_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  canceled_by_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  closing_email_sent_at?: Maybe<Scalars['timestamptz']>;
  conditions?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Flag indicating whether or not the payment plan can be modified by the debtor. */
  custom?: Maybe<Scalars['Boolean']>;
  denied_at?: Maybe<Scalars['timestamptz']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Boolean']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Arr_Rel_Insert_Input>;
  /** DRAFT | OPEN | DONE */
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  /** Random value used to find the payment plans from a public URL */
  reverse_link_id?: Maybe<Scalars['String']>;
  reverse_link_url?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Payment_Plan_Max_Fields = {
  __typename?: 'risolto_payment_plan_max_fields';
  amount_currency?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  closing_email_sent_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  denied_at?: Maybe<Scalars['timestamptz']>;
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DRAFT | OPEN | DONE */
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** Random value used to find the payment plans from a public URL */
  reverse_link_id?: Maybe<Scalars['String']>;
  reverse_link_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Max_Order_By = {
  amount_currency?: Maybe<Order_By>;
  approved_at?: Maybe<Order_By>;
  approved_by?: Maybe<Order_By>;
  canceled_at?: Maybe<Order_By>;
  canceled_by?: Maybe<Order_By>;
  closed_at?: Maybe<Order_By>;
  closing_email_sent_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  denied_at?: Maybe<Order_By>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  /** DRAFT | OPEN | DONE */
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** Random value used to find the payment plans from a public URL */
  reverse_link_id?: Maybe<Order_By>;
  reverse_link_url?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Payment_Plan_Min_Fields = {
  __typename?: 'risolto_payment_plan_min_fields';
  amount_currency?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  closing_email_sent_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  denied_at?: Maybe<Scalars['timestamptz']>;
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DRAFT | OPEN | DONE */
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** Random value used to find the payment plans from a public URL */
  reverse_link_id?: Maybe<Scalars['String']>;
  reverse_link_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Min_Order_By = {
  amount_currency?: Maybe<Order_By>;
  approved_at?: Maybe<Order_By>;
  approved_by?: Maybe<Order_By>;
  canceled_at?: Maybe<Order_By>;
  canceled_by?: Maybe<Order_By>;
  closed_at?: Maybe<Order_By>;
  closing_email_sent_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  denied_at?: Maybe<Order_By>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  /** DRAFT | OPEN | DONE */
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** Random value used to find the payment plans from a public URL */
  reverse_link_id?: Maybe<Order_By>;
  reverse_link_url?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Mutation_Response = {
  __typename?: 'risolto_payment_plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Plan>;
};

/** input type for inserting object relation for remote table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Obj_Rel_Insert_Input = {
  data: Risolto_Payment_Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Plan_On_Conflict>;
};

/** on_conflict condition type for table "risolto.payment_plan" */
export type Risolto_Payment_Plan_On_Conflict = {
  constraint: Risolto_Payment_Plan_Constraint;
  update_columns?: Array<Risolto_Payment_Plan_Update_Column>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_plan". */
export type Risolto_Payment_Plan_Order_By = {
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  amount_currency?: Maybe<Order_By>;
  approved_at?: Maybe<Order_By>;
  approved_by?: Maybe<Order_By>;
  approved_by_by_reference?: Maybe<Risolto_Person_Order_By>;
  canceled_at?: Maybe<Order_By>;
  canceled_by?: Maybe<Order_By>;
  canceled_by_by_reference?: Maybe<Risolto_Person_Order_By>;
  closed_at?: Maybe<Order_By>;
  closing_email_sent_at?: Maybe<Order_By>;
  conditions?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom?: Maybe<Order_By>;
  denied_at?: Maybe<Order_By>;
  due_amount?: Maybe<Order_By>;
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  interest?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_group_by_reference?: Maybe<Risolto_Invoice_Group_Order_By>;
  is_open?: Maybe<Order_By>;
  last_email_to?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  name?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  original_open_amount?: Maybe<Order_By>;
  paid?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Order_By>;
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  reverse_link_id?: Maybe<Order_By>;
  reverse_link_url?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  virtual_open_amount?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_plan */
export type Risolto_Payment_Plan_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Payment_Plan_Prepend_Input = {
  conditions?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.payment_plan" */
export enum Risolto_Payment_Plan_Select_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledBy = 'canceled_by',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ClosingEmailSentAt = 'closing_email_sent_at',
  /** column name */
  Conditions = 'conditions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Custom = 'custom',
  /** column name */
  DeniedAt = 'denied_at',
  /** column name */
  Indemnification = 'indemnification',
  /** column name */
  InstallmentAmount = 'installment_amount',
  /** column name */
  Installments = 'installments',
  /** column name */
  Interest = 'interest',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Name = 'name',
  /** column name */
  Paid = 'paid',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReverseLinkId = 'reverse_link_id',
  /** column name */
  ReverseLinkUrl = 'reverse_link_url',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_payment_plan_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.payment_plan" */
export enum Risolto_Payment_Plan_Select_Column_Risolto_Payment_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Custom = 'custom',
  /** column name */
  Paid = 'paid'
}

/** select "risolto_payment_plan_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.payment_plan" */
export enum Risolto_Payment_Plan_Select_Column_Risolto_Payment_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Custom = 'custom',
  /** column name */
  Paid = 'paid'
}

/** input type for updating data in table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Set_Input = {
  amount_currency?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  closing_email_sent_at?: Maybe<Scalars['timestamptz']>;
  conditions?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Flag indicating whether or not the payment plan can be modified by the debtor. */
  custom?: Maybe<Scalars['Boolean']>;
  denied_at?: Maybe<Scalars['timestamptz']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Boolean']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DRAFT | OPEN | DONE */
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** Random value used to find the payment plans from a public URL */
  reverse_link_id?: Maybe<Scalars['String']>;
  reverse_link_url?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Payment_Plan_Stddev_Fields = {
  __typename?: 'risolto_payment_plan_stddev_fields';
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['Float']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Stddev_Order_By = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Payment_Plan_Stddev_Pop_Fields = {
  __typename?: 'risolto_payment_plan_stddev_pop_fields';
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['Float']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by stddev_pop() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Stddev_Pop_Order_By = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Payment_Plan_Stddev_Samp_Fields = {
  __typename?: 'risolto_payment_plan_stddev_samp_fields';
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['Float']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by stddev_samp() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Stddev_Samp_Order_By = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_payment_plan" */
export type Risolto_Payment_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Plan_Stream_Cursor_Value_Input = {
  amount_currency?: Maybe<Scalars['String']>;
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  closing_email_sent_at?: Maybe<Scalars['timestamptz']>;
  conditions?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Flag indicating whether or not the payment plan can be modified by the debtor. */
  custom?: Maybe<Scalars['Boolean']>;
  denied_at?: Maybe<Scalars['timestamptz']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['numeric']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Boolean']>;
  participant?: Maybe<Scalars['uuid']>;
  /** DRAFT | OPEN | DONE */
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  /** Random value used to find the payment plans from a public URL */
  reverse_link_id?: Maybe<Scalars['String']>;
  reverse_link_url?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Payment_Plan_Sum_Fields = {
  __typename?: 'risolto_payment_plan_sum_fields';
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['numeric']>;
  installment_amount?: Maybe<Scalars['numeric']>;
  installments?: Maybe<Scalars['Int']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['numeric']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Sum_Order_By = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.payment_plan" */
export enum Risolto_Payment_Plan_Update_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledBy = 'canceled_by',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ClosingEmailSentAt = 'closing_email_sent_at',
  /** column name */
  Conditions = 'conditions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Custom = 'custom',
  /** column name */
  DeniedAt = 'denied_at',
  /** column name */
  Indemnification = 'indemnification',
  /** column name */
  InstallmentAmount = 'installment_amount',
  /** column name */
  Installments = 'installments',
  /** column name */
  Interest = 'interest',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Name = 'name',
  /** column name */
  Paid = 'paid',
  /** column name */
  Participant = 'participant',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReverseLinkId = 'reverse_link_id',
  /** column name */
  ReverseLinkUrl = 'reverse_link_url',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Payment_Plan_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Payment_Plan_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Payment_Plan_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Payment_Plan_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Payment_Plan_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Payment_Plan_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Payment_Plan_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Plan_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Payment_Plan_Var_Pop_Fields = {
  __typename?: 'risolto_payment_plan_var_pop_fields';
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['Float']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by var_pop() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Var_Pop_Order_By = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Payment_Plan_Var_Samp_Fields = {
  __typename?: 'risolto_payment_plan_var_samp_fields';
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['Float']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by var_samp() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Var_Samp_Order_By = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Payment_Plan_Variance_Fields = {
  __typename?: 'risolto_payment_plan_variance_fields';
  /** *experimental field! */
  due_amount?: Maybe<Scalars['numeric']>;
  /** Payment plan indemnification */
  indemnification?: Maybe<Scalars['Float']>;
  installment_amount?: Maybe<Scalars['Float']>;
  installments?: Maybe<Scalars['Float']>;
  /** Payment plan interest */
  interest?: Maybe<Scalars['Float']>;
  open_amount?: Maybe<Scalars['numeric']>;
  original_open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['Float']>;
  /** Sum of open amount of the payment promises. Differs from open_amount as it represent a more up-to-date (virtual) amount by also considering (online) payments and statement lines (PSD2/CODA) */
  virtual_open_amount?: Maybe<Scalars['numeric']>;
};

/** order by variance() on columns of table "risolto.payment_plan" */
export type Risolto_Payment_Plan_Variance_Order_By = {
  /** Payment plan indemnification */
  indemnification?: Maybe<Order_By>;
  installment_amount?: Maybe<Order_By>;
  installments?: Maybe<Order_By>;
  /** Payment plan interest */
  interest?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Payment_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_Promise = {
  __typename?: 'risolto_payment_promise';
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  amount_currency?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  due_date: Scalars['date'];
  email_endpoints?: Maybe<Scalars['json']>;
  invoice?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice_by_reference?: Maybe<Risolto_Invoice_Document>;
  /** An array relationship */
  invoice_group_payment_promises: Array<Risolto_Invoice_Group_Payment_Promise>;
  /** An aggregate relationship */
  invoice_group_payment_promises_aggregate: Risolto_Invoice_Group_Payment_Promise_Aggregate;
  last_dunning_actions?: Maybe<Array<Risolto_Virtual_Dunning_Action>>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  /** A computed field, executes function "risolto.payment_promise_mail_endpoints" */
  mail_endpoints?: Maybe<Scalars['json']>;
  open_amount: Scalars['numeric'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_confirmed_at?: Maybe<Scalars['timestamptz']>;
  payment_link?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_link_by_reference?: Maybe<Risolto_Payment_Link>;
  payment_plan?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_plan_by_reference?: Maybe<Risolto_Payment_Plan>;
  payment_received_at?: Maybe<Scalars['timestamptz']>;
  payment_reference?: Maybe<Scalars['String']>;
  /** An array relationship */
  payments: Array<Risolto_Payment>;
  /** An aggregate relationship */
  payments_aggregate: Risolto_Payment_Aggregate;
  processing_status: Scalars['String'];
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  /** An array relationship */
  statement_line_payment_promises: Array<Risolto_Statement_Line_Payment_Promise>;
  /** An aggregate relationship */
  statement_line_payment_promises_aggregate: Risolto_Statement_Line_Payment_Promise_Aggregate;
  status?: Maybe<Scalars['String']>;
  total_amount: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseEmail_EndpointsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseInvoice_Group_Payment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseInvoice_Group_Payment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseLast_Dunning_ActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseMail_EndpointsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromisePaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromisePayments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseStatement_Line_Payment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.payment_promise" */
export type Risolto_Payment_PromiseStatement_Line_Payment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};

/** aggregated selection of "risolto.payment_promise" */
export type Risolto_Payment_Promise_Aggregate = {
  __typename?: 'risolto_payment_promise_aggregate';
  aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Promise>;
};

export type Risolto_Payment_Promise_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Payment_Promise_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Payment_Promise_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.payment_promise" */
export type Risolto_Payment_Promise_Aggregate_Fields = {
  __typename?: 'risolto_payment_promise_aggregate_fields';
  avg?: Maybe<Risolto_Payment_Promise_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Promise_Max_Fields>;
  min?: Maybe<Risolto_Payment_Promise_Min_Fields>;
  stddev?: Maybe<Risolto_Payment_Promise_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Payment_Promise_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Payment_Promise_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Payment_Promise_Sum_Fields>;
  var_pop?: Maybe<Risolto_Payment_Promise_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Payment_Promise_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Payment_Promise_Variance_Fields>;
};


/** aggregate fields of "risolto.payment_promise" */
export type Risolto_Payment_Promise_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Payment_Promise_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Payment_Promise_Max_Order_By>;
  min?: Maybe<Risolto_Payment_Promise_Min_Order_By>;
  stddev?: Maybe<Risolto_Payment_Promise_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Payment_Promise_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Payment_Promise_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Payment_Promise_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Payment_Promise_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Payment_Promise_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Payment_Promise_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Payment_Promise_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Promise_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Payment_Promise_Avg_Fields = {
  __typename?: 'risolto_payment_promise_avg_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Avg_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.payment_promise". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Promise_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Promise_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Promise_Bool_Exp>>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  email_endpoints?: Maybe<Json_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  invoice_group_payment_promises?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
  invoice_group_payment_promises_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Promise_Aggregate_Bool_Exp>;
  last_dunning_actions?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
  last_email_to?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  mail_endpoints?: Maybe<Json_Comparison_Exp>;
  open_amount?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_confirmed_at?: Maybe<Timestamptz_Comparison_Exp>;
  payment_link?: Maybe<Uuid_Comparison_Exp>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Bool_Exp>;
  payment_plan?: Maybe<Uuid_Comparison_Exp>;
  payment_plan_by_reference?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  payment_received_at?: Maybe<Timestamptz_Comparison_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  payments?: Maybe<Risolto_Payment_Bool_Exp>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Bool_Exp>;
  processing_status?: Maybe<String_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  statement_line_payment_promises?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
  statement_line_payment_promises_aggregate?: Maybe<Risolto_Statement_Line_Payment_Promise_Aggregate_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  total_amount?: Maybe<Numeric_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment_promise" */
export enum Risolto_Payment_Promise_Constraint {
  /** unique or primary key constraint on columns "reference" */
  PaymentPromisePkey = 'payment_promise_pkey'
}

/** input type for incrementing numeric columns in table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Inc_Input = {
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Insert_Input = {
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_date?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  invoice_group_payment_promises?: Maybe<Risolto_Invoice_Group_Payment_Promise_Arr_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_confirmed_at?: Maybe<Scalars['timestamptz']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Obj_Rel_Insert_Input>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_plan_by_reference?: Maybe<Risolto_Payment_Plan_Obj_Rel_Insert_Input>;
  payment_received_at?: Maybe<Scalars['timestamptz']>;
  payment_reference?: Maybe<Scalars['String']>;
  payments?: Maybe<Risolto_Payment_Arr_Rel_Insert_Input>;
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line_payment_promises?: Maybe<Risolto_Statement_Line_Payment_Promise_Arr_Rel_Insert_Input>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Payment_Promise_Max_Fields = {
  __typename?: 'risolto_payment_promise_max_fields';
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_date?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_confirmed_at?: Maybe<Scalars['timestamptz']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_received_at?: Maybe<Scalars['timestamptz']>;
  payment_reference?: Maybe<Scalars['String']>;
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Max_Order_By = {
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_confirmed_at?: Maybe<Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_received_at?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Payment_Promise_Min_Fields = {
  __typename?: 'risolto_payment_promise_min_fields';
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_date?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_confirmed_at?: Maybe<Scalars['timestamptz']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_received_at?: Maybe<Scalars['timestamptz']>;
  payment_reference?: Maybe<Scalars['String']>;
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Min_Order_By = {
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_confirmed_at?: Maybe<Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_received_at?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Mutation_Response = {
  __typename?: 'risolto_payment_promise_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Promise>;
};

/** input type for inserting object relation for remote table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Obj_Rel_Insert_Input = {
  data: Risolto_Payment_Promise_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Promise_On_Conflict>;
};

/** on_conflict condition type for table "risolto.payment_promise" */
export type Risolto_Payment_Promise_On_Conflict = {
  constraint: Risolto_Payment_Promise_Constraint;
  update_columns?: Array<Risolto_Payment_Promise_Update_Column>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_promise". */
export type Risolto_Payment_Promise_Order_By = {
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  email_endpoints?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  invoice_group_payment_promises_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Promise_Aggregate_Order_By>;
  last_dunning_actions_aggregate?: Maybe<Risolto_Virtual_Dunning_Action_Aggregate_Order_By>;
  last_email_to?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  mail_endpoints?: Maybe<Order_By>;
  open_amount?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_confirmed_at?: Maybe<Order_By>;
  payment_link?: Maybe<Order_By>;
  payment_link_by_reference?: Maybe<Risolto_Payment_Link_Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_plan_by_reference?: Maybe<Risolto_Payment_Plan_Order_By>;
  payment_received_at?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Order_By>;
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  statement_line_payment_promises_aggregate?: Maybe<Risolto_Statement_Line_Payment_Promise_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_promise */
export type Risolto_Payment_Promise_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.payment_promise" */
export enum Risolto_Payment_Promise_Select_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentConfirmedAt = 'payment_confirmed_at',
  /** column name */
  PaymentLink = 'payment_link',
  /** column name */
  PaymentPlan = 'payment_plan',
  /** column name */
  PaymentReceivedAt = 'payment_received_at',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Set_Input = {
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_date?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_confirmed_at?: Maybe<Scalars['timestamptz']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_received_at?: Maybe<Scalars['timestamptz']>;
  payment_reference?: Maybe<Scalars['String']>;
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Payment_Promise_Stddev_Fields = {
  __typename?: 'risolto_payment_promise_stddev_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Stddev_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Payment_Promise_Stddev_Pop_Fields = {
  __typename?: 'risolto_payment_promise_stddev_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Stddev_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Payment_Promise_Stddev_Samp_Fields = {
  __typename?: 'risolto_payment_promise_stddev_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Stddev_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_payment_promise" */
export type Risolto_Payment_Promise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Promise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Promise_Stream_Cursor_Value_Input = {
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_date?: Maybe<Scalars['date']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  open_amount?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_confirmed_at?: Maybe<Scalars['timestamptz']>;
  payment_link?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_received_at?: Maybe<Scalars['timestamptz']>;
  payment_reference?: Maybe<Scalars['String']>;
  processing_status?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Payment_Promise_Sum_Fields = {
  __typename?: 'risolto_payment_promise_sum_fields';
  open_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Sum_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** update columns of table "risolto.payment_promise" */
export enum Risolto_Payment_Promise_Update_Column {
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  OpenAmount = 'open_amount',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentConfirmedAt = 'payment_confirmed_at',
  /** column name */
  PaymentLink = 'payment_link',
  /** column name */
  PaymentPlan = 'payment_plan',
  /** column name */
  PaymentReceivedAt = 'payment_received_at',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Payment_Promise_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Payment_Promise_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Promise_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Promise_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Payment_Promise_Var_Pop_Fields = {
  __typename?: 'risolto_payment_promise_var_pop_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Var_Pop_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Payment_Promise_Var_Samp_Fields = {
  __typename?: 'risolto_payment_promise_var_samp_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Var_Samp_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Payment_Promise_Variance_Fields = {
  __typename?: 'risolto_payment_promise_variance_fields';
  open_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.payment_promise" */
export type Risolto_Payment_Promise_Variance_Order_By = {
  open_amount?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
};

/** select columns of table "risolto.payment" */
export enum Risolto_Payment_Select_Column {
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  IsRefund = 'is_refund',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Method = 'method',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentDocument = 'payment_document',
  /** column name */
  PaymentNumber = 'payment_number',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_payment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.payment" */
export enum Risolto_Payment_Select_Column_Risolto_Payment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsRefund = 'is_refund'
}

/** select "risolto_payment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.payment" */
export enum Risolto_Payment_Select_Column_Risolto_Payment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsRefund = 'is_refund'
}

/** input type for updating data in table "risolto.payment" */
export type Risolto_Payment_Set_Input = {
  amount_paid?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  is_refund?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  payment_number?: Maybe<Scalars['String']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Payment_Stddev_Fields = {
  __typename?: 'risolto_payment_stddev_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.payment" */
export type Risolto_Payment_Stddev_Order_By = {
  amount_paid?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Payment_Stddev_Pop_Fields = {
  __typename?: 'risolto_payment_stddev_pop_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.payment" */
export type Risolto_Payment_Stddev_Pop_Order_By = {
  amount_paid?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Payment_Stddev_Samp_Fields = {
  __typename?: 'risolto_payment_stddev_samp_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.payment" */
export type Risolto_Payment_Stddev_Samp_Order_By = {
  amount_paid?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_payment" */
export type Risolto_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Stream_Cursor_Value_Input = {
  amount_paid?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  is_refund?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  method?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  payment_document?: Maybe<Scalars['uuid']>;
  payment_number?: Maybe<Scalars['String']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Payment_Sum_Fields = {
  __typename?: 'risolto_payment_sum_fields';
  amount_paid?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.payment" */
export type Risolto_Payment_Sum_Order_By = {
  amount_paid?: Maybe<Order_By>;
};

/** Outgoing payments used by, for example, the Payment Splitter */
export type Risolto_Payment_Transfer = {
  __typename?: 'risolto_payment_transfer';
  account_number: Scalars['String'];
  account_number_type: Scalars['String'];
  bank_identifier: Scalars['String'];
  bank_identifier_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  creditor_name: Scalars['String'];
  group_date: Scalars['date'];
  idempotency_key?: Maybe<Scalars['String']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An array relationship */
  payment_transfer_bulk_payments: Array<Risolto_Payment_Transfer_Bulk_Payment>;
  /** An aggregate relationship */
  payment_transfer_bulk_payments_aggregate: Risolto_Payment_Transfer_Bulk_Payment_Aggregate;
  /** An array relationship */
  payment_transfer_lines: Array<Risolto_Payment_Transfer_Line>;
  /** An aggregate relationship */
  payment_transfer_lines_aggregate: Risolto_Payment_Transfer_Line_Aggregate;
  reference: Scalars['uuid'];
  /** An array relationship */
  statement_lines: Array<Risolto_Statement_Line>;
  /** An aggregate relationship */
  statement_lines_aggregate: Risolto_Statement_Line_Aggregate;
  status: Risolto_Payment_Transfer_Status_Enum;
  updated_at: Scalars['timestamptz'];
};


/** Outgoing payments used by, for example, the Payment Splitter */
export type Risolto_Payment_TransferPayment_Transfer_Bulk_PaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
};


/** Outgoing payments used by, for example, the Payment Splitter */
export type Risolto_Payment_TransferPayment_Transfer_Bulk_Payments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
};


/** Outgoing payments used by, for example, the Payment Splitter */
export type Risolto_Payment_TransferPayment_Transfer_LinesArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


/** Outgoing payments used by, for example, the Payment Splitter */
export type Risolto_Payment_TransferPayment_Transfer_Lines_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


/** Outgoing payments used by, for example, the Payment Splitter */
export type Risolto_Payment_TransferStatement_LinesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


/** Outgoing payments used by, for example, the Payment Splitter */
export type Risolto_Payment_TransferStatement_Lines_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};

/** aggregated selection of "risolto.payment_transfer" */
export type Risolto_Payment_Transfer_Aggregate = {
  __typename?: 'risolto_payment_transfer_aggregate';
  aggregate?: Maybe<Risolto_Payment_Transfer_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Transfer>;
};

/** aggregate fields of "risolto.payment_transfer" */
export type Risolto_Payment_Transfer_Aggregate_Fields = {
  __typename?: 'risolto_payment_transfer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Transfer_Max_Fields>;
  min?: Maybe<Risolto_Payment_Transfer_Min_Fields>;
};


/** aggregate fields of "risolto.payment_transfer" */
export type Risolto_Payment_Transfer_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Transfer_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.payment_transfer". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Transfer_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Transfer_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Transfer_Bool_Exp>>;
  account_number?: Maybe<String_Comparison_Exp>;
  account_number_type?: Maybe<String_Comparison_Exp>;
  bank_identifier?: Maybe<String_Comparison_Exp>;
  bank_identifier_type?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  creditor_name?: Maybe<String_Comparison_Exp>;
  group_date?: Maybe<Date_Comparison_Exp>;
  idempotency_key?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_transfer_bulk_payments?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
  payment_transfer_bulk_payments_aggregate?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Aggregate_Bool_Exp>;
  payment_transfer_lines?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
  payment_transfer_lines_aggregate?: Maybe<Risolto_Payment_Transfer_Line_Aggregate_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  statement_lines?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  statement_lines_aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Bool_Exp>;
  status?: Maybe<Risolto_Payment_Transfer_Status_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** Represents an outgoing bulk payment at the payment service provider, part of a payment transfer */
export type Risolto_Payment_Transfer_Bulk_Payment = {
  __typename?: 'risolto_payment_transfer_bulk_payment';
  created_at: Scalars['timestamptz'];
  error_at?: Maybe<Scalars['timestamptz']>;
  external_account_id: Scalars['String'];
  external_bulk_payment_id: Scalars['uuid'];
  external_status?: Maybe<Scalars['String']>;
  external_system: Scalars['String'];
  finished_at?: Maybe<Scalars['timestamptz']>;
  idempotency_key: Scalars['String'];
  last_updated?: Maybe<Scalars['timestamptz']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_transfer: Scalars['uuid'];
  /** An object relationship */
  payment_transfer_by_reference: Risolto_Payment_Transfer;
  reference: Scalars['uuid'];
  short_description?: Maybe<Scalars['String']>;
  signing_link: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Aggregate = {
  __typename?: 'risolto_payment_transfer_bulk_payment_aggregate';
  aggregate?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Transfer_Bulk_Payment>;
};

export type Risolto_Payment_Transfer_Bulk_Payment_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Payment_Transfer_Bulk_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Aggregate_Fields = {
  __typename?: 'risolto_payment_transfer_bulk_payment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Max_Fields>;
  min?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Min_Fields>;
};


/** aggregate fields of "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Max_Order_By>;
  min?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Payment_Transfer_Bulk_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.payment_transfer_bulk_payment". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  error_at?: Maybe<Timestamptz_Comparison_Exp>;
  external_account_id?: Maybe<String_Comparison_Exp>;
  external_bulk_payment_id?: Maybe<Uuid_Comparison_Exp>;
  external_status?: Maybe<String_Comparison_Exp>;
  external_system?: Maybe<String_Comparison_Exp>;
  finished_at?: Maybe<Timestamptz_Comparison_Exp>;
  idempotency_key?: Maybe<String_Comparison_Exp>;
  last_updated?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_transfer?: Maybe<Uuid_Comparison_Exp>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  short_description?: Maybe<String_Comparison_Exp>;
  signing_link?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment_transfer_bulk_payment" */
export enum Risolto_Payment_Transfer_Bulk_Payment_Constraint {
  /** unique or primary key constraint on columns "participant", "external_bulk_payment_id", "legal_entity" */
  PaymentTransferBulkPaymentParticipantLegalEntityExteKey = 'payment_transfer_bulk_payment_participant_legal_entity_exte_key',
  /** unique or primary key constraint on columns "reference" */
  PaymentTransferBulkPaymentPkey = 'payment_transfer_bulk_payment_pkey'
}

/** input type for inserting data into table "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  error_at?: Maybe<Scalars['timestamptz']>;
  external_account_id?: Maybe<Scalars['String']>;
  external_bulk_payment_id?: Maybe<Scalars['uuid']>;
  external_status?: Maybe<Scalars['String']>;
  external_system?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  idempotency_key?: Maybe<Scalars['String']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  short_description?: Maybe<Scalars['String']>;
  signing_link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Payment_Transfer_Bulk_Payment_Max_Fields = {
  __typename?: 'risolto_payment_transfer_bulk_payment_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  error_at?: Maybe<Scalars['timestamptz']>;
  external_account_id?: Maybe<Scalars['String']>;
  external_bulk_payment_id?: Maybe<Scalars['uuid']>;
  external_status?: Maybe<Scalars['String']>;
  external_system?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  idempotency_key?: Maybe<Scalars['String']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  short_description?: Maybe<Scalars['String']>;
  signing_link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  error_at?: Maybe<Order_By>;
  external_account_id?: Maybe<Order_By>;
  external_bulk_payment_id?: Maybe<Order_By>;
  external_status?: Maybe<Order_By>;
  external_system?: Maybe<Order_By>;
  finished_at?: Maybe<Order_By>;
  idempotency_key?: Maybe<Order_By>;
  last_updated?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_transfer?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  short_description?: Maybe<Order_By>;
  signing_link?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Payment_Transfer_Bulk_Payment_Min_Fields = {
  __typename?: 'risolto_payment_transfer_bulk_payment_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  error_at?: Maybe<Scalars['timestamptz']>;
  external_account_id?: Maybe<Scalars['String']>;
  external_bulk_payment_id?: Maybe<Scalars['uuid']>;
  external_status?: Maybe<Scalars['String']>;
  external_system?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  idempotency_key?: Maybe<Scalars['String']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  short_description?: Maybe<Scalars['String']>;
  signing_link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  error_at?: Maybe<Order_By>;
  external_account_id?: Maybe<Order_By>;
  external_bulk_payment_id?: Maybe<Order_By>;
  external_status?: Maybe<Order_By>;
  external_system?: Maybe<Order_By>;
  finished_at?: Maybe<Order_By>;
  idempotency_key?: Maybe<Order_By>;
  last_updated?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_transfer?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  short_description?: Maybe<Order_By>;
  signing_link?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Mutation_Response = {
  __typename?: 'risolto_payment_transfer_bulk_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Transfer_Bulk_Payment>;
};

/** on_conflict condition type for table "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_On_Conflict = {
  constraint: Risolto_Payment_Transfer_Bulk_Payment_Constraint;
  update_columns?: Array<Risolto_Payment_Transfer_Bulk_Payment_Update_Column>;
  where?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_transfer_bulk_payment". */
export type Risolto_Payment_Transfer_Bulk_Payment_Order_By = {
  created_at?: Maybe<Order_By>;
  error_at?: Maybe<Order_By>;
  external_account_id?: Maybe<Order_By>;
  external_bulk_payment_id?: Maybe<Order_By>;
  external_status?: Maybe<Order_By>;
  external_system?: Maybe<Order_By>;
  finished_at?: Maybe<Order_By>;
  idempotency_key?: Maybe<Order_By>;
  last_updated?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_transfer?: Maybe<Order_By>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Order_By>;
  reference?: Maybe<Order_By>;
  short_description?: Maybe<Order_By>;
  signing_link?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_transfer_bulk_payment */
export type Risolto_Payment_Transfer_Bulk_Payment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.payment_transfer_bulk_payment" */
export enum Risolto_Payment_Transfer_Bulk_Payment_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorAt = 'error_at',
  /** column name */
  ExternalAccountId = 'external_account_id',
  /** column name */
  ExternalBulkPaymentId = 'external_bulk_payment_id',
  /** column name */
  ExternalStatus = 'external_status',
  /** column name */
  ExternalSystem = 'external_system',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  IdempotencyKey = 'idempotency_key',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentTransfer = 'payment_transfer',
  /** column name */
  Reference = 'reference',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  SigningLink = 'signing_link',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  error_at?: Maybe<Scalars['timestamptz']>;
  external_account_id?: Maybe<Scalars['String']>;
  external_bulk_payment_id?: Maybe<Scalars['uuid']>;
  external_status?: Maybe<Scalars['String']>;
  external_system?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  idempotency_key?: Maybe<Scalars['String']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  short_description?: Maybe<Scalars['String']>;
  signing_link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_payment_transfer_bulk_payment" */
export type Risolto_Payment_Transfer_Bulk_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Transfer_Bulk_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Transfer_Bulk_Payment_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  error_at?: Maybe<Scalars['timestamptz']>;
  external_account_id?: Maybe<Scalars['String']>;
  external_bulk_payment_id?: Maybe<Scalars['uuid']>;
  external_status?: Maybe<Scalars['String']>;
  external_system?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  idempotency_key?: Maybe<Scalars['String']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  short_description?: Maybe<Scalars['String']>;
  signing_link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.payment_transfer_bulk_payment" */
export enum Risolto_Payment_Transfer_Bulk_Payment_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ErrorAt = 'error_at',
  /** column name */
  ExternalAccountId = 'external_account_id',
  /** column name */
  ExternalBulkPaymentId = 'external_bulk_payment_id',
  /** column name */
  ExternalStatus = 'external_status',
  /** column name */
  ExternalSystem = 'external_system',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  IdempotencyKey = 'idempotency_key',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentTransfer = 'payment_transfer',
  /** column name */
  Reference = 'reference',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  SigningLink = 'signing_link',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Payment_Transfer_Bulk_Payment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp;
};

/** unique or primary key constraints on table "risolto.payment_transfer" */
export enum Risolto_Payment_Transfer_Constraint {
  /** unique or primary key constraint on columns "idempotency_key" */
  PaymentTransferIdempotencyKeyKey = 'payment_transfer_idempotency_key_key',
  /** unique or primary key constraint on columns "participant", "group_date", "legal_entity" */
  PaymentTransferParticipantLegalEntityGroupDateKey = 'payment_transfer_participant_legal_entity_group_date_key',
  /** unique or primary key constraint on columns "reference" */
  PaymentTransferPkey = 'payment_transfer_pkey'
}

/** input type for inserting data into table "risolto.payment_transfer" */
export type Risolto_Payment_Transfer_Insert_Input = {
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  creditor_name?: Maybe<Scalars['String']>;
  group_date?: Maybe<Scalars['date']>;
  idempotency_key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_transfer_bulk_payments?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Arr_Rel_Insert_Input>;
  payment_transfer_lines?: Maybe<Risolto_Payment_Transfer_Line_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  statement_lines?: Maybe<Risolto_Statement_Line_Arr_Rel_Insert_Input>;
  status?: Maybe<Risolto_Payment_Transfer_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Outgoing payment line, part of a payment transfer record */
export type Risolto_Payment_Transfer_Line = {
  __typename?: 'risolto_payment_transfer_line';
  amount: Scalars['numeric'];
  amount_currency: Scalars['String'];
  created_at: Scalars['timestamptz'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_reference: Scalars['String'];
  payment_reference_type: Scalars['String'];
  payment_transfer: Scalars['uuid'];
  /** An object relationship */
  payment_transfer_by_reference: Risolto_Payment_Transfer;
  reference: Scalars['uuid'];
  statement_line: Scalars['uuid'];
  /** An object relationship */
  statement_line_by_reference: Risolto_Statement_Line;
  type?: Maybe<Risolto_Payment_Transfer_Line_Type_Enum>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Aggregate = {
  __typename?: 'risolto_payment_transfer_line_aggregate';
  aggregate?: Maybe<Risolto_Payment_Transfer_Line_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Transfer_Line>;
};

export type Risolto_Payment_Transfer_Line_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Payment_Transfer_Line_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Payment_Transfer_Line_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Aggregate_Fields = {
  __typename?: 'risolto_payment_transfer_line_aggregate_fields';
  avg?: Maybe<Risolto_Payment_Transfer_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Transfer_Line_Max_Fields>;
  min?: Maybe<Risolto_Payment_Transfer_Line_Min_Fields>;
  stddev?: Maybe<Risolto_Payment_Transfer_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Payment_Transfer_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Payment_Transfer_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Payment_Transfer_Line_Sum_Fields>;
  var_pop?: Maybe<Risolto_Payment_Transfer_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Payment_Transfer_Line_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Payment_Transfer_Line_Variance_Fields>;
};


/** aggregate fields of "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Payment_Transfer_Line_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Payment_Transfer_Line_Max_Order_By>;
  min?: Maybe<Risolto_Payment_Transfer_Line_Min_Order_By>;
  stddev?: Maybe<Risolto_Payment_Transfer_Line_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Payment_Transfer_Line_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Payment_Transfer_Line_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Payment_Transfer_Line_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Payment_Transfer_Line_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Payment_Transfer_Line_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Payment_Transfer_Line_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Payment_Transfer_Line_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Transfer_Line_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Payment_Transfer_Line_Avg_Fields = {
  __typename?: 'risolto_payment_transfer_line_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Avg_Order_By = {
  amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.payment_transfer_line". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Transfer_Line_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Transfer_Line_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Transfer_Line_Bool_Exp>>;
  amount?: Maybe<Numeric_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_reference?: Maybe<String_Comparison_Exp>;
  payment_reference_type?: Maybe<String_Comparison_Exp>;
  payment_transfer?: Maybe<Uuid_Comparison_Exp>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  statement_line?: Maybe<Uuid_Comparison_Exp>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  type?: Maybe<Risolto_Payment_Transfer_Line_Type_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment_transfer_line" */
export enum Risolto_Payment_Transfer_Line_Constraint {
  /** unique or primary key constraint on columns "reference" */
  PaymentTransferLinePkey = 'payment_transfer_line_pkey'
}

/** input type for incrementing numeric columns in table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Inc_Input = {
  amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Insert_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_reference?: Maybe<Scalars['String']>;
  payment_reference_type?: Maybe<Scalars['String']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Obj_Rel_Insert_Input>;
  type?: Maybe<Risolto_Payment_Transfer_Line_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Payment_Transfer_Line_Max_Fields = {
  __typename?: 'risolto_payment_transfer_line_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  payment_reference_type?: Maybe<Scalars['String']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Max_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  payment_reference_type?: Maybe<Order_By>;
  payment_transfer?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Payment_Transfer_Line_Min_Fields = {
  __typename?: 'risolto_payment_transfer_line_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  payment_reference_type?: Maybe<Scalars['String']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Min_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_reference?: Maybe<Order_By>;
  payment_reference_type?: Maybe<Order_By>;
  payment_transfer?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Mutation_Response = {
  __typename?: 'risolto_payment_transfer_line_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Transfer_Line>;
};

/** on_conflict condition type for table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_On_Conflict = {
  constraint: Risolto_Payment_Transfer_Line_Constraint;
  update_columns?: Array<Risolto_Payment_Transfer_Line_Update_Column>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_transfer_line". */
export type Risolto_Payment_Transfer_Line_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_reference?: Maybe<Order_By>;
  payment_reference_type?: Maybe<Order_By>;
  payment_transfer?: Maybe<Order_By>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Order_By>;
  reference?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_transfer_line */
export type Risolto_Payment_Transfer_Line_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.payment_transfer_line" */
export enum Risolto_Payment_Transfer_Line_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  PaymentReferenceType = 'payment_reference_type',
  /** column name */
  PaymentTransfer = 'payment_transfer',
  /** column name */
  Reference = 'reference',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Set_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  payment_reference_type?: Maybe<Scalars['String']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  type?: Maybe<Risolto_Payment_Transfer_Line_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Payment_Transfer_Line_Stddev_Fields = {
  __typename?: 'risolto_payment_transfer_line_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Stddev_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Payment_Transfer_Line_Stddev_Pop_Fields = {
  __typename?: 'risolto_payment_transfer_line_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Stddev_Pop_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Payment_Transfer_Line_Stddev_Samp_Fields = {
  __typename?: 'risolto_payment_transfer_line_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Stddev_Samp_Order_By = {
  amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Transfer_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Transfer_Line_Stream_Cursor_Value_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_reference?: Maybe<Scalars['String']>;
  payment_reference_type?: Maybe<Scalars['String']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_line?: Maybe<Scalars['uuid']>;
  type?: Maybe<Risolto_Payment_Transfer_Line_Type_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Payment_Transfer_Line_Sum_Fields = {
  __typename?: 'risolto_payment_transfer_line_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Sum_Order_By = {
  amount?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type = {
  __typename?: 'risolto_payment_transfer_line_type';
  type: Scalars['String'];
};

/** aggregated selection of "risolto.payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type_Aggregate = {
  __typename?: 'risolto_payment_transfer_line_type_aggregate';
  aggregate?: Maybe<Risolto_Payment_Transfer_Line_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Transfer_Line_Type>;
};

/** aggregate fields of "risolto.payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type_Aggregate_Fields = {
  __typename?: 'risolto_payment_transfer_line_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Transfer_Line_Type_Max_Fields>;
  min?: Maybe<Risolto_Payment_Transfer_Line_Type_Min_Fields>;
};


/** aggregate fields of "risolto.payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.payment_transfer_line_type". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Transfer_Line_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Transfer_Line_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Bool_Exp>>;
  type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment_transfer_line_type" */
export enum Risolto_Payment_Transfer_Line_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  PaymentTransferLineTypePkey = 'payment_transfer_line_type_pkey'
}

export enum Risolto_Payment_Transfer_Line_Type_Enum {
  CostsAndInterests = 'COSTS_AND_INTERESTS',
  Other = 'OTHER',
  PrincipleAmount = 'PRINCIPLE_AMOUNT'
}

/** Boolean expression to compare columns of type "risolto_payment_transfer_line_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Payment_Transfer_Line_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Payment_Transfer_Line_Type_Enum>;
  _in?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Payment_Transfer_Line_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Enum>>;
};

/** input type for inserting data into table "risolto.payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type_Insert_Input = {
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Payment_Transfer_Line_Type_Max_Fields = {
  __typename?: 'risolto_payment_transfer_line_type_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Payment_Transfer_Line_Type_Min_Fields = {
  __typename?: 'risolto_payment_transfer_line_type_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type_Mutation_Response = {
  __typename?: 'risolto_payment_transfer_line_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Transfer_Line_Type>;
};

/** on_conflict condition type for table "risolto.payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type_On_Conflict = {
  constraint: Risolto_Payment_Transfer_Line_Type_Constraint;
  update_columns?: Array<Risolto_Payment_Transfer_Line_Type_Update_Column>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_transfer_line_type". */
export type Risolto_Payment_Transfer_Line_Type_Order_By = {
  type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_transfer_line_type */
export type Risolto_Payment_Transfer_Line_Type_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "risolto.payment_transfer_line_type" */
export enum Risolto_Payment_Transfer_Line_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "risolto.payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type_Set_Input = {
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_payment_transfer_line_type" */
export type Risolto_Payment_Transfer_Line_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Transfer_Line_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Transfer_Line_Type_Stream_Cursor_Value_Input = {
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.payment_transfer_line_type" */
export enum Risolto_Payment_Transfer_Line_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Risolto_Payment_Transfer_Line_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Transfer_Line_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Transfer_Line_Type_Bool_Exp;
};

/** update columns of table "risolto.payment_transfer_line" */
export enum Risolto_Payment_Transfer_Line_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  PaymentReferenceType = 'payment_reference_type',
  /** column name */
  PaymentTransfer = 'payment_transfer',
  /** column name */
  Reference = 'reference',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Payment_Transfer_Line_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Payment_Transfer_Line_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Transfer_Line_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Transfer_Line_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Payment_Transfer_Line_Var_Pop_Fields = {
  __typename?: 'risolto_payment_transfer_line_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Var_Pop_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Payment_Transfer_Line_Var_Samp_Fields = {
  __typename?: 'risolto_payment_transfer_line_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Var_Samp_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Payment_Transfer_Line_Variance_Fields = {
  __typename?: 'risolto_payment_transfer_line_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.payment_transfer_line" */
export type Risolto_Payment_Transfer_Line_Variance_Order_By = {
  amount?: Maybe<Order_By>;
};

/** aggregate max on columns */
export type Risolto_Payment_Transfer_Max_Fields = {
  __typename?: 'risolto_payment_transfer_max_fields';
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  creditor_name?: Maybe<Scalars['String']>;
  group_date?: Maybe<Scalars['date']>;
  idempotency_key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Payment_Transfer_Min_Fields = {
  __typename?: 'risolto_payment_transfer_min_fields';
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  creditor_name?: Maybe<Scalars['String']>;
  group_date?: Maybe<Scalars['date']>;
  idempotency_key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.payment_transfer" */
export type Risolto_Payment_Transfer_Mutation_Response = {
  __typename?: 'risolto_payment_transfer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Transfer>;
};

/** input type for inserting object relation for remote table "risolto.payment_transfer" */
export type Risolto_Payment_Transfer_Obj_Rel_Insert_Input = {
  data: Risolto_Payment_Transfer_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Payment_Transfer_On_Conflict>;
};

/** on_conflict condition type for table "risolto.payment_transfer" */
export type Risolto_Payment_Transfer_On_Conflict = {
  constraint: Risolto_Payment_Transfer_Constraint;
  update_columns?: Array<Risolto_Payment_Transfer_Update_Column>;
  where?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_transfer". */
export type Risolto_Payment_Transfer_Order_By = {
  account_number?: Maybe<Order_By>;
  account_number_type?: Maybe<Order_By>;
  bank_identifier?: Maybe<Order_By>;
  bank_identifier_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  creditor_name?: Maybe<Order_By>;
  group_date?: Maybe<Order_By>;
  idempotency_key?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_transfer_bulk_payments_aggregate?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Aggregate_Order_By>;
  payment_transfer_lines_aggregate?: Maybe<Risolto_Payment_Transfer_Line_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  statement_lines_aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_transfer */
export type Risolto_Payment_Transfer_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.payment_transfer" */
export enum Risolto_Payment_Transfer_Select_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AccountNumberType = 'account_number_type',
  /** column name */
  BankIdentifier = 'bank_identifier',
  /** column name */
  BankIdentifierType = 'bank_identifier_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditorName = 'creditor_name',
  /** column name */
  GroupDate = 'group_date',
  /** column name */
  IdempotencyKey = 'idempotency_key',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.payment_transfer" */
export type Risolto_Payment_Transfer_Set_Input = {
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  creditor_name?: Maybe<Scalars['String']>;
  group_date?: Maybe<Scalars['date']>;
  idempotency_key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  status?: Maybe<Risolto_Payment_Transfer_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Payment Transfer status enum */
export type Risolto_Payment_Transfer_Status = {
  __typename?: 'risolto_payment_transfer_status';
  status: Scalars['String'];
};

/** aggregated selection of "risolto.payment_transfer_status" */
export type Risolto_Payment_Transfer_Status_Aggregate = {
  __typename?: 'risolto_payment_transfer_status_aggregate';
  aggregate?: Maybe<Risolto_Payment_Transfer_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Payment_Transfer_Status>;
};

/** aggregate fields of "risolto.payment_transfer_status" */
export type Risolto_Payment_Transfer_Status_Aggregate_Fields = {
  __typename?: 'risolto_payment_transfer_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Payment_Transfer_Status_Max_Fields>;
  min?: Maybe<Risolto_Payment_Transfer_Status_Min_Fields>;
};


/** aggregate fields of "risolto.payment_transfer_status" */
export type Risolto_Payment_Transfer_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Payment_Transfer_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.payment_transfer_status". All fields are combined with a logical 'AND'. */
export type Risolto_Payment_Transfer_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Payment_Transfer_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Payment_Transfer_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Payment_Transfer_Status_Bool_Exp>>;
  status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.payment_transfer_status" */
export enum Risolto_Payment_Transfer_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  PaymentTransferStatusPkey = 'payment_transfer_status_pkey'
}

export enum Risolto_Payment_Transfer_Status_Enum {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Executing = 'EXECUTING'
}

/** Boolean expression to compare columns of type "risolto_payment_transfer_status_enum". All fields are combined with logical 'AND'. */
export type Risolto_Payment_Transfer_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Payment_Transfer_Status_Enum>;
  _in?: Maybe<Array<Risolto_Payment_Transfer_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Payment_Transfer_Status_Enum>;
  _nin?: Maybe<Array<Risolto_Payment_Transfer_Status_Enum>>;
};

/** input type for inserting data into table "risolto.payment_transfer_status" */
export type Risolto_Payment_Transfer_Status_Insert_Input = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Payment_Transfer_Status_Max_Fields = {
  __typename?: 'risolto_payment_transfer_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Payment_Transfer_Status_Min_Fields = {
  __typename?: 'risolto_payment_transfer_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.payment_transfer_status" */
export type Risolto_Payment_Transfer_Status_Mutation_Response = {
  __typename?: 'risolto_payment_transfer_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Payment_Transfer_Status>;
};

/** on_conflict condition type for table "risolto.payment_transfer_status" */
export type Risolto_Payment_Transfer_Status_On_Conflict = {
  constraint: Risolto_Payment_Transfer_Status_Constraint;
  update_columns?: Array<Risolto_Payment_Transfer_Status_Update_Column>;
  where?: Maybe<Risolto_Payment_Transfer_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.payment_transfer_status". */
export type Risolto_Payment_Transfer_Status_Order_By = {
  status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.payment_transfer_status */
export type Risolto_Payment_Transfer_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "risolto.payment_transfer_status" */
export enum Risolto_Payment_Transfer_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "risolto.payment_transfer_status" */
export type Risolto_Payment_Transfer_Status_Set_Input = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_payment_transfer_status" */
export type Risolto_Payment_Transfer_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Transfer_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Transfer_Status_Stream_Cursor_Value_Input = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.payment_transfer_status" */
export enum Risolto_Payment_Transfer_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Risolto_Payment_Transfer_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Transfer_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Transfer_Status_Bool_Exp;
};

/** Streaming cursor of the table "risolto_payment_transfer" */
export type Risolto_Payment_Transfer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Payment_Transfer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Payment_Transfer_Stream_Cursor_Value_Input = {
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  creditor_name?: Maybe<Scalars['String']>;
  group_date?: Maybe<Scalars['date']>;
  idempotency_key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  status?: Maybe<Risolto_Payment_Transfer_Status_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.payment_transfer" */
export enum Risolto_Payment_Transfer_Update_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AccountNumberType = 'account_number_type',
  /** column name */
  BankIdentifier = 'bank_identifier',
  /** column name */
  BankIdentifierType = 'bank_identifier_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditorName = 'creditor_name',
  /** column name */
  GroupDate = 'group_date',
  /** column name */
  IdempotencyKey = 'idempotency_key',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Payment_Transfer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Transfer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Transfer_Bool_Exp;
};

/** update columns of table "risolto.payment" */
export enum Risolto_Payment_Update_Column {
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  IsRefund = 'is_refund',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Method = 'method',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentDocument = 'payment_document',
  /** column name */
  PaymentNumber = 'payment_number',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  PaymentReference = 'payment_reference',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Payment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Payment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Payment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Payment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Payment_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Payment_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Payment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Payment_Var_Pop_Fields = {
  __typename?: 'risolto_payment_var_pop_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.payment" */
export type Risolto_Payment_Var_Pop_Order_By = {
  amount_paid?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Payment_Var_Samp_Fields = {
  __typename?: 'risolto_payment_var_samp_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.payment" */
export type Risolto_Payment_Var_Samp_Order_By = {
  amount_paid?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Payment_Variance_Fields = {
  __typename?: 'risolto_payment_variance_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.payment" */
export type Risolto_Payment_Variance_Order_By = {
  amount_paid?: Maybe<Order_By>;
};

/** A user of the risolto platform */
export type Risolto_Person = {
  __typename?: 'risolto_person';
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  /** An array relationship */
  actions_canceled: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_canceled_aggregate: Risolto_Action_Aggregate;
  /** An array relationship */
  actions_executed: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_executed_aggregate: Risolto_Action_Aggregate;
  created_at: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  invoice_disputes_resolved: Array<Risolto_Invoice_Dispute>;
  /** An aggregate relationship */
  invoice_disputes_resolved_aggregate: Risolto_Invoice_Dispute_Aggregate;
  last_login?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  notes: Array<Risolto_Note>;
  /** An aggregate relationship */
  notes_aggregate: Risolto_Note_Aggregate;
  /** An array relationship */
  participant_users: Array<Risolto_Participant_User>;
  /** An aggregate relationship */
  participant_users_aggregate: Risolto_Participant_User_Aggregate;
  reference: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};


/** A user of the risolto platform */
export type Risolto_PersonActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonActions_CanceledArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonActions_Canceled_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonActions_ExecutedArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonActions_Executed_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonInvoice_Disputes_ResolvedArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonInvoice_Disputes_Resolved_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonNotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonNotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonParticipant_UsersArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


/** A user of the risolto platform */
export type Risolto_PersonParticipant_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};

/** aggregated selection of "risolto.person" */
export type Risolto_Person_Aggregate = {
  __typename?: 'risolto_person_aggregate';
  aggregate?: Maybe<Risolto_Person_Aggregate_Fields>;
  nodes: Array<Risolto_Person>;
};

/** aggregate fields of "risolto.person" */
export type Risolto_Person_Aggregate_Fields = {
  __typename?: 'risolto_person_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Person_Max_Fields>;
  min?: Maybe<Risolto_Person_Min_Fields>;
};


/** aggregate fields of "risolto.person" */
export type Risolto_Person_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Person_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.person". All fields are combined with a logical 'AND'. */
export type Risolto_Person_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Person_Bool_Exp>>;
  _not?: Maybe<Risolto_Person_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Person_Bool_Exp>>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  actions_canceled?: Maybe<Risolto_Action_Bool_Exp>;
  actions_canceled_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  actions_executed?: Maybe<Risolto_Action_Bool_Exp>;
  actions_executed_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  invoice_disputes_resolved?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
  invoice_disputes_resolved_aggregate?: Maybe<Risolto_Invoice_Dispute_Aggregate_Bool_Exp>;
  last_login?: Maybe<Timestamptz_Comparison_Exp>;
  notes?: Maybe<Risolto_Note_Bool_Exp>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Bool_Exp>;
  participant_users?: Maybe<Risolto_Participant_User_Bool_Exp>;
  participant_users_aggregate?: Maybe<Risolto_Participant_User_Aggregate_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<String_Comparison_Exp>;
  username?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.person" */
export enum Risolto_Person_Constraint {
  /** unique or primary key constraint on columns "email" */
  PersonEmailKey = 'person_email_key',
  /** unique or primary key constraint on columns "external_id" */
  PersonExternalIdKey = 'person_external_id_key',
  /** unique or primary key constraint on columns "reference" */
  PersonPkey = 'person_pkey'
}

/** input type for inserting data into table "risolto.person" */
export type Risolto_Person_Insert_Input = {
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  actions_canceled?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  actions_executed?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  invoice_disputes_resolved?: Maybe<Risolto_Invoice_Dispute_Arr_Rel_Insert_Input>;
  last_login?: Maybe<Scalars['timestamptz']>;
  notes?: Maybe<Risolto_Note_Arr_Rel_Insert_Input>;
  participant_users?: Maybe<Risolto_Participant_User_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Person_Max_Fields = {
  __typename?: 'risolto_person_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Person_Min_Fields = {
  __typename?: 'risolto_person_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.person" */
export type Risolto_Person_Mutation_Response = {
  __typename?: 'risolto_person_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Person>;
};

/** input type for inserting object relation for remote table "risolto.person" */
export type Risolto_Person_Obj_Rel_Insert_Input = {
  data: Risolto_Person_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Person_On_Conflict>;
};

/** on_conflict condition type for table "risolto.person" */
export type Risolto_Person_On_Conflict = {
  constraint: Risolto_Person_Constraint;
  update_columns?: Array<Risolto_Person_Update_Column>;
  where?: Maybe<Risolto_Person_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.person". */
export type Risolto_Person_Order_By = {
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  actions_canceled_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  actions_executed_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  invoice_disputes_resolved_aggregate?: Maybe<Risolto_Invoice_Dispute_Aggregate_Order_By>;
  last_login?: Maybe<Order_By>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Order_By>;
  participant_users_aggregate?: Maybe<Risolto_Participant_User_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.person */
export type Risolto_Person_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.person" */
export enum Risolto_Person_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "risolto.person" */
export type Risolto_Person_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_person" */
export type Risolto_Person_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Person_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Person_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.person" */
export enum Risolto_Person_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  Username = 'username'
}

export type Risolto_Person_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Person_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Person_Bool_Exp;
};

/** columns and relationships of "risolto.platform_license_module" */
export type Risolto_Platform_License_Module = {
  __typename?: 'risolto_platform_license_module';
  platform_license_module: Scalars['String'];
};

/** aggregated selection of "risolto.platform_license_module" */
export type Risolto_Platform_License_Module_Aggregate = {
  __typename?: 'risolto_platform_license_module_aggregate';
  aggregate?: Maybe<Risolto_Platform_License_Module_Aggregate_Fields>;
  nodes: Array<Risolto_Platform_License_Module>;
};

/** aggregate fields of "risolto.platform_license_module" */
export type Risolto_Platform_License_Module_Aggregate_Fields = {
  __typename?: 'risolto_platform_license_module_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Platform_License_Module_Max_Fields>;
  min?: Maybe<Risolto_Platform_License_Module_Min_Fields>;
};


/** aggregate fields of "risolto.platform_license_module" */
export type Risolto_Platform_License_Module_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Platform_License_Module_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.platform_license_module". All fields are combined with a logical 'AND'. */
export type Risolto_Platform_License_Module_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Platform_License_Module_Bool_Exp>>;
  _not?: Maybe<Risolto_Platform_License_Module_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Platform_License_Module_Bool_Exp>>;
  platform_license_module?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.platform_license_module" */
export enum Risolto_Platform_License_Module_Constraint {
  /** unique or primary key constraint on columns "platform_license_module" */
  PlatformLicenseModulePkey = 'platform_license_module_pkey'
}

export enum Risolto_Platform_License_Module_Enum {
  Amber = 'AMBER',
  Core = 'CORE',
  HohrCvt = 'HOHR_CVT',
  Magda = 'MAGDA',
  Mailbox = 'MAILBOX',
  PaymentPlan = 'PAYMENT_PLAN',
  PaymentSplitting = 'PAYMENT_SPLITTING',
  ReferenceData = 'REFERENCE_DATA',
  Reporting = 'REPORTING'
}

/** Boolean expression to compare columns of type "risolto_platform_license_module_enum". All fields are combined with logical 'AND'. */
export type Risolto_Platform_License_Module_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Platform_License_Module_Enum>;
  _in?: Maybe<Array<Risolto_Platform_License_Module_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Platform_License_Module_Enum>;
  _nin?: Maybe<Array<Risolto_Platform_License_Module_Enum>>;
};

/** input type for inserting data into table "risolto.platform_license_module" */
export type Risolto_Platform_License_Module_Insert_Input = {
  platform_license_module?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Platform_License_Module_Max_Fields = {
  __typename?: 'risolto_platform_license_module_max_fields';
  platform_license_module?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Platform_License_Module_Min_Fields = {
  __typename?: 'risolto_platform_license_module_min_fields';
  platform_license_module?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.platform_license_module" */
export type Risolto_Platform_License_Module_Mutation_Response = {
  __typename?: 'risolto_platform_license_module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Platform_License_Module>;
};

/** input type for inserting object relation for remote table "risolto.platform_license_module" */
export type Risolto_Platform_License_Module_Obj_Rel_Insert_Input = {
  data: Risolto_Platform_License_Module_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Platform_License_Module_On_Conflict>;
};

/** on_conflict condition type for table "risolto.platform_license_module" */
export type Risolto_Platform_License_Module_On_Conflict = {
  constraint: Risolto_Platform_License_Module_Constraint;
  update_columns?: Array<Risolto_Platform_License_Module_Update_Column>;
  where?: Maybe<Risolto_Platform_License_Module_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.platform_license_module". */
export type Risolto_Platform_License_Module_Order_By = {
  platform_license_module?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.platform_license_module */
export type Risolto_Platform_License_Module_Pk_Columns_Input = {
  platform_license_module: Scalars['String'];
};

/** select columns of table "risolto.platform_license_module" */
export enum Risolto_Platform_License_Module_Select_Column {
  /** column name */
  PlatformLicenseModule = 'platform_license_module'
}

/** input type for updating data in table "risolto.platform_license_module" */
export type Risolto_Platform_License_Module_Set_Input = {
  platform_license_module?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_platform_license_module" */
export type Risolto_Platform_License_Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Platform_License_Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Platform_License_Module_Stream_Cursor_Value_Input = {
  platform_license_module?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.platform_license_module" */
export enum Risolto_Platform_License_Module_Update_Column {
  /** column name */
  PlatformLicenseModule = 'platform_license_module'
}

export type Risolto_Platform_License_Module_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Platform_License_Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Platform_License_Module_Bool_Exp;
};

/** columns and relationships of "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License = {
  __typename?: 'risolto_platform_participant_license';
  created_at: Scalars['timestamptz'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  platform_license_module: Risolto_Platform_License_Module_Enum;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Aggregate = {
  __typename?: 'risolto_platform_participant_license_aggregate';
  aggregate?: Maybe<Risolto_Platform_Participant_License_Aggregate_Fields>;
  nodes: Array<Risolto_Platform_Participant_License>;
};

export type Risolto_Platform_Participant_License_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Platform_Participant_License_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Platform_Participant_License_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Platform_Participant_License_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Aggregate_Fields = {
  __typename?: 'risolto_platform_participant_license_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Platform_Participant_License_Max_Fields>;
  min?: Maybe<Risolto_Platform_Participant_License_Min_Fields>;
};


/** aggregate fields of "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Platform_Participant_License_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Platform_Participant_License_Max_Order_By>;
  min?: Maybe<Risolto_Platform_Participant_License_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Platform_Participant_License_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Platform_Participant_License_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.platform_participant_license". All fields are combined with a logical 'AND'. */
export type Risolto_Platform_Participant_License_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Platform_Participant_License_Bool_Exp>>;
  _not?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Platform_Participant_License_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.platform_participant_license" */
export enum Risolto_Platform_Participant_License_Constraint {
  /** unique or primary key constraint on columns "participant", "platform_license_module" */
  PlatformParticipantLicenseParticipantPlatformLicenseModul = 'platform_participant_license_participant_platform_license_modul',
  /** unique or primary key constraint on columns "reference" */
  PlatformParticipantLicensePkey = 'platform_participant_license_pkey'
}

/** input type for inserting data into table "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Platform_Participant_License_Max_Fields = {
  __typename?: 'risolto_platform_participant_license_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Platform_Participant_License_Min_Fields = {
  __typename?: 'risolto_platform_participant_license_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Mutation_Response = {
  __typename?: 'risolto_platform_participant_license_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Platform_Participant_License>;
};

/** on_conflict condition type for table "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_On_Conflict = {
  constraint: Risolto_Platform_Participant_License_Constraint;
  update_columns?: Array<Risolto_Platform_Participant_License_Update_Column>;
  where?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.platform_participant_license". */
export type Risolto_Platform_Participant_License_Order_By = {
  created_at?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  platform_license_module?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.platform_participant_license */
export type Risolto_Platform_Participant_License_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.platform_participant_license" */
export enum Risolto_Platform_Participant_License_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Participant = 'participant',
  /** column name */
  PlatformLicenseModule = 'platform_license_module',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.platform_participant_license" */
export type Risolto_Platform_Participant_License_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_platform_participant_license" */
export type Risolto_Platform_Participant_License_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Platform_Participant_License_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Platform_Participant_License_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.platform_participant_license" */
export enum Risolto_Platform_Participant_License_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Participant = 'participant',
  /** column name */
  PlatformLicenseModule = 'platform_license_module',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Platform_Participant_License_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Platform_Participant_License_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Platform_Participant_License_Bool_Exp;
};

/** A 'permission' grants or denies a specific functionality in the system */
export type Risolto_Platform_Permission = {
  __typename?: 'risolto_platform_permission';
  created_at: Scalars['timestamptz'];
  name: Scalars['String'];
  platform_license_module: Risolto_Platform_License_Module_Enum;
  reference: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "risolto.platform_permission" */
export type Risolto_Platform_Permission_Aggregate = {
  __typename?: 'risolto_platform_permission_aggregate';
  aggregate?: Maybe<Risolto_Platform_Permission_Aggregate_Fields>;
  nodes: Array<Risolto_Platform_Permission>;
};

/** aggregate fields of "risolto.platform_permission" */
export type Risolto_Platform_Permission_Aggregate_Fields = {
  __typename?: 'risolto_platform_permission_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Platform_Permission_Max_Fields>;
  min?: Maybe<Risolto_Platform_Permission_Min_Fields>;
};


/** aggregate fields of "risolto.platform_permission" */
export type Risolto_Platform_Permission_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Platform_Permission_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.platform_permission". All fields are combined with a logical 'AND'. */
export type Risolto_Platform_Permission_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Platform_Permission_Bool_Exp>>;
  _not?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Platform_Permission_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.platform_permission" */
export enum Risolto_Platform_Permission_Constraint {
  /** unique or primary key constraint on columns "platform_license_module", "name" */
  PlatformPermissionNamePlatformLicenseModuleKey = 'platform_permission_name_platform_license_module_key',
  /** unique or primary key constraint on columns "reference" */
  PlatformPermissionPkey = 'platform_permission_pkey'
}

/** input type for inserting data into table "risolto.platform_permission" */
export type Risolto_Platform_Permission_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Platform_Permission_Max_Fields = {
  __typename?: 'risolto_platform_permission_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Platform_Permission_Min_Fields = {
  __typename?: 'risolto_platform_permission_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.platform_permission" */
export type Risolto_Platform_Permission_Mutation_Response = {
  __typename?: 'risolto_platform_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Platform_Permission>;
};

/** input type for inserting object relation for remote table "risolto.platform_permission" */
export type Risolto_Platform_Permission_Obj_Rel_Insert_Input = {
  data: Risolto_Platform_Permission_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Platform_Permission_On_Conflict>;
};

/** on_conflict condition type for table "risolto.platform_permission" */
export type Risolto_Platform_Permission_On_Conflict = {
  constraint: Risolto_Platform_Permission_Constraint;
  update_columns?: Array<Risolto_Platform_Permission_Update_Column>;
  where?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.platform_permission". */
export type Risolto_Platform_Permission_Order_By = {
  created_at?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  platform_license_module?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.platform_permission */
export type Risolto_Platform_Permission_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.platform_permission" */
export enum Risolto_Platform_Permission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  PlatformLicenseModule = 'platform_license_module',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.platform_permission" */
export type Risolto_Platform_Permission_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_platform_permission" */
export type Risolto_Platform_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Platform_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Platform_Permission_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.platform_permission" */
export enum Risolto_Platform_Permission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  PlatformLicenseModule = 'platform_license_module',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Platform_Permission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Platform_Permission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Platform_Permission_Bool_Exp;
};

/** A Role is a set of permissions */
export type Risolto_Platform_Role = {
  __typename?: 'risolto_platform_role';
  created_at: Scalars['timestamptz'];
  name: Scalars['String'];
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.platform_role" */
export type Risolto_Platform_Role_Aggregate = {
  __typename?: 'risolto_platform_role_aggregate';
  aggregate?: Maybe<Risolto_Platform_Role_Aggregate_Fields>;
  nodes: Array<Risolto_Platform_Role>;
};

/** aggregate fields of "risolto.platform_role" */
export type Risolto_Platform_Role_Aggregate_Fields = {
  __typename?: 'risolto_platform_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Platform_Role_Max_Fields>;
  min?: Maybe<Risolto_Platform_Role_Min_Fields>;
};


/** aggregate fields of "risolto.platform_role" */
export type Risolto_Platform_Role_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Platform_Role_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.platform_role". All fields are combined with a logical 'AND'. */
export type Risolto_Platform_Role_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Platform_Role_Bool_Exp>>;
  _not?: Maybe<Risolto_Platform_Role_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Platform_Role_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.platform_role" */
export enum Risolto_Platform_Role_Constraint {
  /** unique or primary key constraint on columns "reference" */
  RolePkey = 'role_pkey',
  /** unique or primary key constraint on columns "participant", "name" */
  UniquePlatformRoleParticipant = 'unique_platform_role_participant',
  /** unique or primary key constraint on columns "name" */
  UniquePlatformRoleSystem = 'unique_platform_role_system'
}

/** input type for inserting data into table "risolto.platform_role" */
export type Risolto_Platform_Role_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Platform_Role_Max_Fields = {
  __typename?: 'risolto_platform_role_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Platform_Role_Min_Fields = {
  __typename?: 'risolto_platform_role_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.platform_role" */
export type Risolto_Platform_Role_Mutation_Response = {
  __typename?: 'risolto_platform_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Platform_Role>;
};

/** input type for inserting object relation for remote table "risolto.platform_role" */
export type Risolto_Platform_Role_Obj_Rel_Insert_Input = {
  data: Risolto_Platform_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Platform_Role_On_Conflict>;
};

/** on_conflict condition type for table "risolto.platform_role" */
export type Risolto_Platform_Role_On_Conflict = {
  constraint: Risolto_Platform_Role_Constraint;
  update_columns?: Array<Risolto_Platform_Role_Update_Column>;
  where?: Maybe<Risolto_Platform_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.platform_role". */
export type Risolto_Platform_Role_Order_By = {
  created_at?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.platform_role_permission" */
export type Risolto_Platform_Role_Permission = {
  __typename?: 'risolto_platform_role_permission';
  created_at: Scalars['timestamptz'];
  grant_type: Risolto_Grant_Type_Enum;
  participant?: Maybe<Scalars['uuid']>;
  platform_permission: Scalars['uuid'];
  /** An object relationship */
  platform_permission_by_reference: Risolto_Platform_Permission;
  platform_role: Scalars['uuid'];
  /** An object relationship */
  platform_role_by_reference: Risolto_Platform_Role;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.platform_role_permission" */
export type Risolto_Platform_Role_Permission_Aggregate = {
  __typename?: 'risolto_platform_role_permission_aggregate';
  aggregate?: Maybe<Risolto_Platform_Role_Permission_Aggregate_Fields>;
  nodes: Array<Risolto_Platform_Role_Permission>;
};

/** aggregate fields of "risolto.platform_role_permission" */
export type Risolto_Platform_Role_Permission_Aggregate_Fields = {
  __typename?: 'risolto_platform_role_permission_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Platform_Role_Permission_Max_Fields>;
  min?: Maybe<Risolto_Platform_Role_Permission_Min_Fields>;
};


/** aggregate fields of "risolto.platform_role_permission" */
export type Risolto_Platform_Role_Permission_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Platform_Role_Permission_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.platform_role_permission". All fields are combined with a logical 'AND'. */
export type Risolto_Platform_Role_Permission_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Platform_Role_Permission_Bool_Exp>>;
  _not?: Maybe<Risolto_Platform_Role_Permission_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Platform_Role_Permission_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  grant_type?: Maybe<Risolto_Grant_Type_Enum_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  platform_permission?: Maybe<Uuid_Comparison_Exp>;
  platform_permission_by_reference?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
  platform_role?: Maybe<Uuid_Comparison_Exp>;
  platform_role_by_reference?: Maybe<Risolto_Platform_Role_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.platform_role_permission" */
export enum Risolto_Platform_Role_Permission_Constraint {
  /** unique or primary key constraint on columns "reference" */
  PlatformRolePermissionPkey = 'platform_role_permission_pkey',
  /** unique or primary key constraint on columns "platform_role", "participant", "platform_permission" */
  PlatformRolePermissionPlatformRolePlatformPermissionPart = 'platform_role_permission_platform_role_platform_permission_part',
  /** unique or primary key constraint on columns "platform_role", "platform_permission" */
  UniquePlatformPermission = 'unique_platform_permission',
  /** unique or primary key constraint on columns "platform_role", "participant", "platform_permission" */
  UniquePlatformPermissionParticipant = 'unique_platform_permission_participant',
  /** unique or primary key constraint on columns "platform_role", "grant_type", "platform_permission" */
  UniquePlatformRolePermission = 'unique_platform_role_permission',
  /** unique or primary key constraint on columns "platform_role", "participant", "grant_type", "platform_permission" */
  UniquePlatformRolePermissionParticipant = 'unique_platform_role_permission_participant'
}

/** input type for inserting data into table "risolto.platform_role_permission" */
export type Risolto_Platform_Role_Permission_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  grant_type?: Maybe<Risolto_Grant_Type_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_permission_by_reference?: Maybe<Risolto_Platform_Permission_Obj_Rel_Insert_Input>;
  platform_role?: Maybe<Scalars['uuid']>;
  platform_role_by_reference?: Maybe<Risolto_Platform_Role_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Platform_Role_Permission_Max_Fields = {
  __typename?: 'risolto_platform_role_permission_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_role?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Platform_Role_Permission_Min_Fields = {
  __typename?: 'risolto_platform_role_permission_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  participant?: Maybe<Scalars['uuid']>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_role?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.platform_role_permission" */
export type Risolto_Platform_Role_Permission_Mutation_Response = {
  __typename?: 'risolto_platform_role_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Platform_Role_Permission>;
};

/** on_conflict condition type for table "risolto.platform_role_permission" */
export type Risolto_Platform_Role_Permission_On_Conflict = {
  constraint: Risolto_Platform_Role_Permission_Constraint;
  update_columns?: Array<Risolto_Platform_Role_Permission_Update_Column>;
  where?: Maybe<Risolto_Platform_Role_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.platform_role_permission". */
export type Risolto_Platform_Role_Permission_Order_By = {
  created_at?: Maybe<Order_By>;
  grant_type?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  platform_permission?: Maybe<Order_By>;
  platform_permission_by_reference?: Maybe<Risolto_Platform_Permission_Order_By>;
  platform_role?: Maybe<Order_By>;
  platform_role_by_reference?: Maybe<Risolto_Platform_Role_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.platform_role_permission */
export type Risolto_Platform_Role_Permission_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.platform_role_permission" */
export enum Risolto_Platform_Role_Permission_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GrantType = 'grant_type',
  /** column name */
  Participant = 'participant',
  /** column name */
  PlatformPermission = 'platform_permission',
  /** column name */
  PlatformRole = 'platform_role',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.platform_role_permission" */
export type Risolto_Platform_Role_Permission_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  grant_type?: Maybe<Risolto_Grant_Type_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_role?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_platform_role_permission" */
export type Risolto_Platform_Role_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Platform_Role_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Platform_Role_Permission_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  grant_type?: Maybe<Risolto_Grant_Type_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_role?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.platform_role_permission" */
export enum Risolto_Platform_Role_Permission_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GrantType = 'grant_type',
  /** column name */
  Participant = 'participant',
  /** column name */
  PlatformPermission = 'platform_permission',
  /** column name */
  PlatformRole = 'platform_role',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Platform_Role_Permission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Platform_Role_Permission_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Platform_Role_Permission_Bool_Exp;
};

/** primary key columns input for table: risolto.platform_role */
export type Risolto_Platform_Role_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.platform_role" */
export enum Risolto_Platform_Role_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.platform_role" */
export type Risolto_Platform_Role_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_platform_role" */
export type Risolto_Platform_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Platform_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Platform_Role_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.platform_role" */
export enum Risolto_Platform_Role_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Platform_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Platform_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Platform_Role_Bool_Exp;
};

/** Audit table which logs who did what */
export type Risolto_Platform_Usage = {
  __typename?: 'risolto_platform_usage';
  created_at: Scalars['timestamptz'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  participant_user?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_user_by_reference?: Maybe<Risolto_Participant_User>;
  permission_checking_result: Scalars['String'];
  person: Scalars['uuid'];
  /** An object relationship */
  person_by_reference: Risolto_Person;
  person_external_id: Scalars['String'];
  platform_license_module: Risolto_Platform_License_Module_Enum;
  /** An object relationship */
  platform_license_module_by_reference: Risolto_Platform_License_Module;
  platform_permission?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  platform_permission_by_reference?: Maybe<Risolto_Platform_Permission>;
  platform_permission_name?: Maybe<Scalars['String']>;
  platform_role?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  username: Scalars['String'];
};

/** aggregated selection of "risolto.platform_usage" */
export type Risolto_Platform_Usage_Aggregate = {
  __typename?: 'risolto_platform_usage_aggregate';
  aggregate?: Maybe<Risolto_Platform_Usage_Aggregate_Fields>;
  nodes: Array<Risolto_Platform_Usage>;
};

/** aggregate fields of "risolto.platform_usage" */
export type Risolto_Platform_Usage_Aggregate_Fields = {
  __typename?: 'risolto_platform_usage_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Platform_Usage_Max_Fields>;
  min?: Maybe<Risolto_Platform_Usage_Min_Fields>;
};


/** aggregate fields of "risolto.platform_usage" */
export type Risolto_Platform_Usage_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Platform_Usage_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.platform_usage". All fields are combined with a logical 'AND'. */
export type Risolto_Platform_Usage_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Platform_Usage_Bool_Exp>>;
  _not?: Maybe<Risolto_Platform_Usage_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Platform_Usage_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  participant_user?: Maybe<Uuid_Comparison_Exp>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Bool_Exp>;
  permission_checking_result?: Maybe<String_Comparison_Exp>;
  person?: Maybe<Uuid_Comparison_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  person_external_id?: Maybe<String_Comparison_Exp>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum_Comparison_Exp>;
  platform_license_module_by_reference?: Maybe<Risolto_Platform_License_Module_Bool_Exp>;
  platform_permission?: Maybe<Uuid_Comparison_Exp>;
  platform_permission_by_reference?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
  platform_permission_name?: Maybe<String_Comparison_Exp>;
  platform_role?: Maybe<Uuid_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  username?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.platform_usage" */
export enum Risolto_Platform_Usage_Constraint {
  /** unique or primary key constraint on columns "reference" */
  PlatformUsagePkey = 'platform_usage_pkey'
}

export type Risolto_Platform_Usage_Export_Args = {
  p_legal_entity?: Maybe<Scalars['uuid']>;
  p_participant?: Maybe<Scalars['uuid']>;
  p_s3_bucket?: Maybe<Scalars['String']>;
  p_s3_key?: Maybe<Scalars['String']>;
  p_s3_region?: Maybe<Scalars['String']>;
  p_until?: Maybe<Scalars['date']>;
};

/** input type for inserting data into table "risolto.platform_usage" */
export type Risolto_Platform_Usage_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  participant_user?: Maybe<Scalars['uuid']>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Obj_Rel_Insert_Input>;
  permission_checking_result?: Maybe<Scalars['String']>;
  person?: Maybe<Scalars['uuid']>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  person_external_id?: Maybe<Scalars['String']>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  platform_license_module_by_reference?: Maybe<Risolto_Platform_License_Module_Obj_Rel_Insert_Input>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_permission_by_reference?: Maybe<Risolto_Platform_Permission_Obj_Rel_Insert_Input>;
  platform_permission_name?: Maybe<Scalars['String']>;
  platform_role?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Platform_Usage_Max_Fields = {
  __typename?: 'risolto_platform_usage_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  permission_checking_result?: Maybe<Scalars['String']>;
  person?: Maybe<Scalars['uuid']>;
  person_external_id?: Maybe<Scalars['String']>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_permission_name?: Maybe<Scalars['String']>;
  platform_role?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Platform_Usage_Min_Fields = {
  __typename?: 'risolto_platform_usage_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  permission_checking_result?: Maybe<Scalars['String']>;
  person?: Maybe<Scalars['uuid']>;
  person_external_id?: Maybe<Scalars['String']>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_permission_name?: Maybe<Scalars['String']>;
  platform_role?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.platform_usage" */
export type Risolto_Platform_Usage_Mutation_Response = {
  __typename?: 'risolto_platform_usage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Platform_Usage>;
};

/** on_conflict condition type for table "risolto.platform_usage" */
export type Risolto_Platform_Usage_On_Conflict = {
  constraint: Risolto_Platform_Usage_Constraint;
  update_columns?: Array<Risolto_Platform_Usage_Update_Column>;
  where?: Maybe<Risolto_Platform_Usage_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.platform_usage". */
export type Risolto_Platform_Usage_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  participant_user?: Maybe<Order_By>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Order_By>;
  permission_checking_result?: Maybe<Order_By>;
  person?: Maybe<Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  person_external_id?: Maybe<Order_By>;
  platform_license_module?: Maybe<Order_By>;
  platform_license_module_by_reference?: Maybe<Risolto_Platform_License_Module_Order_By>;
  platform_permission?: Maybe<Order_By>;
  platform_permission_by_reference?: Maybe<Risolto_Platform_Permission_Order_By>;
  platform_permission_name?: Maybe<Order_By>;
  platform_role?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  username?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.platform_usage */
export type Risolto_Platform_Usage_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.platform_usage" */
export enum Risolto_Platform_Usage_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  PermissionCheckingResult = 'permission_checking_result',
  /** column name */
  Person = 'person',
  /** column name */
  PersonExternalId = 'person_external_id',
  /** column name */
  PlatformLicenseModule = 'platform_license_module',
  /** column name */
  PlatformPermission = 'platform_permission',
  /** column name */
  PlatformPermissionName = 'platform_permission_name',
  /** column name */
  PlatformRole = 'platform_role',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "risolto.platform_usage" */
export type Risolto_Platform_Usage_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  permission_checking_result?: Maybe<Scalars['String']>;
  person?: Maybe<Scalars['uuid']>;
  person_external_id?: Maybe<Scalars['String']>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_permission_name?: Maybe<Scalars['String']>;
  platform_role?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_platform_usage" */
export type Risolto_Platform_Usage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Platform_Usage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Platform_Usage_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  permission_checking_result?: Maybe<Scalars['String']>;
  person?: Maybe<Scalars['uuid']>;
  person_external_id?: Maybe<Scalars['String']>;
  platform_license_module?: Maybe<Risolto_Platform_License_Module_Enum>;
  platform_permission?: Maybe<Scalars['uuid']>;
  platform_permission_name?: Maybe<Scalars['String']>;
  platform_role?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.platform_usage" */
export enum Risolto_Platform_Usage_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  PermissionCheckingResult = 'permission_checking_result',
  /** column name */
  Person = 'person',
  /** column name */
  PersonExternalId = 'person_external_id',
  /** column name */
  PlatformLicenseModule = 'platform_license_module',
  /** column name */
  PlatformPermission = 'platform_permission',
  /** column name */
  PlatformPermissionName = 'platform_permission_name',
  /** column name */
  PlatformRole = 'platform_role',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

export type Risolto_Platform_Usage_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Platform_Usage_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Platform_Usage_Bool_Exp;
};

export type Risolto_Proof_Of_Delivery_Barcode_Args = {
  _address?: Maybe<Scalars['String']>;
  _barcode?: Maybe<Scalars['String']>;
  _name?: Maybe<Scalars['String']>;
};

export type Risolto_Proof_Of_Delivery_Barcode_V2_Args = {
  _address?: Maybe<Scalars['String']>;
  _barcode?: Maybe<Scalars['String']>;
  _months?: Maybe<Scalars['smallint']>;
  _name?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.recipient" */
export type Risolto_Recipient = {
  __typename?: 'risolto_recipient';
  /** Participant assigned account id (UBL: SupplierAssignedAccountID) */
  account_id: Scalars['String'];
  /** An array relationship */
  accounting_documents: Array<Risolto_Accounting_Document>;
  /** An aggregate relationship */
  accounting_documents_aggregate: Risolto_Accounting_Document_Aggregate;
  /** An array relationship */
  actions: Array<Risolto_Action>;
  /** An aggregate relationship */
  actions_aggregate: Risolto_Action_Aggregate;
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  analytics_test_results: Array<Risolto_Analytics_Test_Result>;
  /** An aggregate relationship */
  analytics_test_results_aggregate: Risolto_Analytics_Test_Result_Aggregate;
  analytics_test_results_map?: Maybe<Scalars['jsonb']>;
  balance_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  bank_accounts: Array<Risolto_Bank_Account>;
  /** An aggregate relationship */
  bank_accounts_aggregate: Risolto_Bank_Account_Aggregate;
  category?: Maybe<Scalars['String']>;
  /** An array relationship */
  channel_endpoints: Array<Risolto_Channel_Endpoint>;
  /** An aggregate relationship */
  channel_endpoints_aggregate: Risolto_Channel_Endpoint_Aggregate;
  /** An array relationship */
  collections: Array<Risolto_Recipient_Collection>;
  /** An aggregate relationship */
  collections_aggregate: Risolto_Recipient_Collection_Aggregate;
  /** An array relationship */
  contacts: Array<Risolto_Contact>;
  /** An aggregate relationship */
  contacts_aggregate: Risolto_Contact_Aggregate;
  country_code?: Maybe<Risolto_Iso_Country_Code_Enum>;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  credit_limits: Array<Risolto_Credit_Limit>;
  /** An aggregate relationship */
  credit_limits_aggregate: Risolto_Credit_Limit_Aggregate;
  /** An array relationship */
  credit_notes: Array<Risolto_Credit_Note>;
  /** An aggregate relationship */
  credit_notes_aggregate: Risolto_Credit_Note_Aggregate;
  currency?: Maybe<Risolto_Currency_Enum>;
  /** null */
  custom_fields: Scalars['jsonb'];
  /** An array relationship */
  debit_notes: Array<Risolto_Debit_Note>;
  /** An aggregate relationship */
  debit_notes_aggregate: Risolto_Debit_Note_Aggregate;
  /** An array relationship */
  document_interchange_links: Array<Risolto_Document_Interchange_Link>;
  /** An aggregate relationship */
  document_interchange_links_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  dunning_exclude_until?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  dunning_excludes: Array<Risolto_Recipient_Dunning_Exclude>;
  /** An aggregate relationship */
  dunning_excludes_aggregate: Risolto_Recipient_Dunning_Exclude_Aggregate;
  /** DEPRECATED */
  dunning_in_progress: Scalars['Boolean'];
  dunning_is_dirty: Scalars['Boolean'];
  /** DEPRECATED */
  dunning_metadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  dunning_notices: Array<Risolto_Dunning_Notice>;
  /** An aggregate relationship */
  dunning_notices_aggregate: Risolto_Dunning_Notice_Aggregate;
  /** All email addresses for a recipient, including contact email addresses */
  email_addresses?: Maybe<Scalars['jsonb']>;
  /** External identifier, typically a technical id. For functional identifiers use the account_id */
  external_id?: Maybe<Scalars['String']>;
  in_collection?: Maybe<Scalars['Boolean']>;
  in_collection_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  invoice_disputes: Array<Risolto_Invoice_Dispute>;
  /** An aggregate relationship */
  invoice_disputes_aggregate: Risolto_Invoice_Dispute_Aggregate;
  /** An array relationship */
  invoice_documents: Array<Risolto_Invoice_Document>;
  /** An aggregate relationship */
  invoice_documents_aggregate: Risolto_Invoice_Document_Aggregate;
  /** An array relationship */
  invoice_group_credit_notes: Array<Risolto_Invoice_Group_Credit_Note>;
  /** An aggregate relationship */
  invoice_group_credit_notes_aggregate: Risolto_Invoice_Group_Credit_Note_Aggregate;
  /** An array relationship */
  invoice_group_debit_notes: Array<Risolto_Invoice_Group_Debit_Note>;
  /** An aggregate relationship */
  invoice_group_debit_notes_aggregate: Risolto_Invoice_Group_Debit_Note_Aggregate;
  /** An array relationship */
  invoice_group_invoices: Array<Risolto_Invoice_Group_Invoice>;
  /** An aggregate relationship */
  invoice_group_invoices_aggregate: Risolto_Invoice_Group_Invoice_Aggregate;
  /** An array relationship */
  invoice_group_payments: Array<Risolto_Invoice_Group_Payment>;
  /** An aggregate relationship */
  invoice_group_payments_aggregate: Risolto_Invoice_Group_Payment_Aggregate;
  /** An array relationship */
  invoice_groups: Array<Risolto_Invoice_Group>;
  /** An aggregate relationship */
  invoice_groups_aggregate: Risolto_Invoice_Group_Aggregate;
  language_code?: Maybe<Risolto_Language_Code_Enum>;
  /** Note: see also computed field 'last_dunning_run_at' (which _should_ be the same value) */
  last_dunning_at?: Maybe<Scalars['timestamptz']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  last_dunning_email_to?: Maybe<Scalars['String']>;
  last_dunning_run_at?: Maybe<Scalars['timestamptz']>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  /** A (legally) unique identifier for the recipient corresponding to the legal_id_type. For example: a VAT number or an ID (Identity Document) */
  legal_id?: Maybe<Scalars['String']>;
  /** The name of an identifier which uniquely identifies the recipient. For example: VAT, ID (Identity Document) */
  legal_id_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  message_recipients: Array<Risolto_Message_Recipient>;
  /** An aggregate relationship */
  message_recipients_aggregate: Risolto_Message_Recipient_Aggregate;
  most_used_dunning_email_to?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  notes: Array<Risolto_Note>;
  /** An aggregate relationship */
  notes_aggregate: Risolto_Note_Aggregate;
  /** An array relationship */
  open_balance_records: Array<Risolto_Open_Balance_Record>;
  /** An aggregate relationship */
  open_balance_records_aggregate: Risolto_Open_Balance_Record_Aggregate;
  origin: Risolto_Origin_Enum;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An array relationship */
  payment_documents: Array<Risolto_Payment_Document>;
  /** An aggregate relationship */
  payment_documents_aggregate: Risolto_Payment_Document_Aggregate;
  /** An array relationship */
  payment_plans: Array<Risolto_Payment_Plan>;
  /** An aggregate relationship */
  payment_plans_aggregate: Risolto_Payment_Plan_Aggregate;
  /** An array relationship */
  payment_promises: Array<Risolto_Payment_Promise>;
  /** An aggregate relationship */
  payment_promises_aggregate: Risolto_Payment_Promise_Aggregate;
  /** An array relationship */
  payments: Array<Risolto_Payment>;
  /** An aggregate relationship */
  payments_aggregate: Risolto_Payment_Aggregate;
  /** All postal address for the recipient (including contacts) */
  postal_addresses?: Maybe<Scalars['jsonb']>;
  prediction_is_dirty?: Maybe<Scalars['Boolean']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  preferred_invoicing_channel?: Maybe<Risolto_Channel_Enum>;
  raw_data?: Maybe<Scalars['String']>;
  /** An array relationship */
  recipient_attachments: Array<Risolto_Recipient_Attachment>;
  /** An aggregate relationship */
  recipient_attachments_aggregate: Risolto_Recipient_Attachment_Aggregate;
  /** An array relationship */
  recipient_dunning_runs: Array<Risolto_Recipient_Dunning_Run>;
  /** An aggregate relationship */
  recipient_dunning_runs_aggregate: Risolto_Recipient_Dunning_Run_Aggregate;
  /** An array relationship */
  recipient_merge_froms: Array<Risolto_Recipient_Merge>;
  /** An aggregate relationship */
  recipient_merge_froms_aggregate: Risolto_Recipient_Merge_Aggregate;
  /** An array relationship */
  recipient_merge_tos: Array<Risolto_Recipient_Merge>;
  /** An aggregate relationship */
  recipient_merge_tos_aggregate: Risolto_Recipient_Merge_Aggregate;
  /** An array relationship */
  recipient_tags: Array<Risolto_Recipient_Tag>;
  /** An aggregate relationship */
  recipient_tags_aggregate: Risolto_Recipient_Tag_Aggregate;
  /** An array relationship */
  recipient_users: Array<Risolto_Recipient_User>;
  /** An aggregate relationship */
  recipient_users_aggregate: Risolto_Recipient_User_Aggregate;
  reference: Scalars['uuid'];
  /** A computed field, executes function "risolto.recipient_short_code" */
  short_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  statement_lines: Array<Risolto_Statement_Line>;
  /** An aggregate relationship */
  statement_lines_aggregate: Risolto_Statement_Line_Aggregate;
  /** An array relationship */
  tags: Array<Risolto_View_Recipient_Tag>;
  /** An aggregate relationship */
  tags_aggregate: Risolto_View_Recipient_Tag_Aggregate;
  /** All telephone numbers for a recipient, including contact telephone numbers. */
  telephone_numbers?: Maybe<Scalars['jsonb']>;
  /** B2B | B2C */
  type?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['String']>;
  version_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientAccounting_DocumentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientAccounting_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientActionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientActions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientAddressArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientAnalytics_Test_ResultsArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Result_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Result_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientAnalytics_Test_Results_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Result_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Result_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientAnalytics_Test_Results_MapArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientBank_AccountsArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Account_Order_By>>;
  where?: Maybe<Risolto_Bank_Account_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientBank_Accounts_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Account_Order_By>>;
  where?: Maybe<Risolto_Bank_Account_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientChannel_EndpointsArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientChannel_Endpoints_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientCollectionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Collection_Order_By>>;
  where?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientCollections_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Collection_Order_By>>;
  where?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientContactsArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Order_By>>;
  where?: Maybe<Risolto_Contact_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientContacts_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Order_By>>;
  where?: Maybe<Risolto_Contact_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientCredit_LimitsArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientCredit_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientCredit_NotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientCredit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDebit_NotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDebit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDocument_Interchange_LinksArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDocument_Interchange_Links_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDunning_ExcludesArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDunning_Excludes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDunning_MetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDunning_NoticesArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientDunning_Notices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientEmail_AddressesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_DisputesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Disputes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_DocumentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Group_Credit_NotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Group_Credit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Group_Debit_NotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Group_Debit_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Group_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Group_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Group_PaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Group_Payments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_GroupsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientInvoice_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientMessage_RecipientsArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Recipient_Order_By>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientMessage_Recipients_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Recipient_Order_By>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientNotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientNotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientOpen_Balance_RecordsArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientOpen_Balance_Records_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPayment_DocumentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Document_Order_By>>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPayment_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Document_Order_By>>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPayment_PlansArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPayment_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPayment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPayment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPaymentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPayments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientPostal_AddressesArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_AttachmentsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Attachment_Order_By>>;
  where?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Attachments_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Attachment_Order_By>>;
  where?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Dunning_RunsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Dunning_Runs_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Merge_FromsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Merge_Order_By>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Merge_Froms_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Merge_Order_By>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Merge_TosArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Merge_Order_By>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Merge_Tos_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Merge_Order_By>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_TagsArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_UsersArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_User_Order_By>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientRecipient_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_User_Order_By>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientStatement_LinesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientStatement_Lines_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientTagsArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientTags_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient" */
export type Risolto_RecipientTelephone_NumbersArgs = {
  path?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.recipient_address" */
export type Risolto_Recipient_Address = {
  __typename?: 'risolto_recipient_address';
  city?: Maybe<Scalars['String']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.recipient_address" */
export type Risolto_Recipient_AddressEndpoint_DetailsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.recipient_address" */
export type Risolto_Recipient_Address_Aggregate = {
  __typename?: 'risolto_recipient_address_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Address_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_Address>;
};

/** aggregate fields of "risolto.recipient_address" */
export type Risolto_Recipient_Address_Aggregate_Fields = {
  __typename?: 'risolto_recipient_address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Address_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Address_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_address" */
export type Risolto_Recipient_Address_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Address_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Recipient_Address_Append_Input = {
  endpoint_details?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_address". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Address_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Address_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Address_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Address_Bool_Exp>>;
  city?: Maybe<String_Comparison_Exp>;
  endpoint_details?: Maybe<Jsonb_Comparison_Exp>;
  iso_country_code?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  street_box?: Maybe<String_Comparison_Exp>;
  street_name?: Maybe<String_Comparison_Exp>;
  street_name_number_box?: Maybe<String_Comparison_Exp>;
  street_number?: Maybe<String_Comparison_Exp>;
  zip?: Maybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Recipient_Address_Delete_At_Path_Input = {
  endpoint_details?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Recipient_Address_Delete_Elem_Input = {
  endpoint_details?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Recipient_Address_Delete_Key_Input = {
  endpoint_details?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.recipient_address" */
export type Risolto_Recipient_Address_Insert_Input = {
  city?: Maybe<Scalars['String']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Address_Max_Fields = {
  __typename?: 'risolto_recipient_address_max_fields';
  city?: Maybe<Scalars['String']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Recipient_Address_Min_Fields = {
  __typename?: 'risolto_recipient_address_min_fields';
  city?: Maybe<Scalars['String']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.recipient_address" */
export type Risolto_Recipient_Address_Mutation_Response = {
  __typename?: 'risolto_recipient_address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_Address>;
};

/** Ordering options when selecting data from "risolto.recipient_address". */
export type Risolto_Recipient_Address_Order_By = {
  city?: Maybe<Order_By>;
  endpoint_details?: Maybe<Order_By>;
  iso_country_code?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  street_box?: Maybe<Order_By>;
  street_name?: Maybe<Order_By>;
  street_name_number_box?: Maybe<Order_By>;
  street_number?: Maybe<Order_By>;
  zip?: Maybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Recipient_Address_Prepend_Input = {
  endpoint_details?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.recipient_address" */
export enum Risolto_Recipient_Address_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  EndpointDetails = 'endpoint_details',
  /** column name */
  IsoCountryCode = 'iso_country_code',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  StreetBox = 'street_box',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNameNumberBox = 'street_name_number_box',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "risolto.recipient_address" */
export type Risolto_Recipient_Address_Set_Input = {
  city?: Maybe<Scalars['String']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_recipient_address" */
export type Risolto_Recipient_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Address_Stream_Cursor_Value_Input = {
  city?: Maybe<Scalars['String']>;
  endpoint_details?: Maybe<Scalars['jsonb']>;
  iso_country_code?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  street_box?: Maybe<Scalars['String']>;
  street_name?: Maybe<Scalars['String']>;
  street_name_number_box?: Maybe<Scalars['String']>;
  street_number?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Risolto_Recipient_Address_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Recipient_Address_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Recipient_Address_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Recipient_Address_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Recipient_Address_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Recipient_Address_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Address_Bool_Exp;
};

/** aggregated selection of "risolto.recipient" */
export type Risolto_Recipient_Aggregate = {
  __typename?: 'risolto_recipient_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient>;
};

export type Risolto_Recipient_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Recipient_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Recipient_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Recipient_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Recipient_Select_Column_Risolto_Recipient_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Recipient_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Recipient_Select_Column_Risolto_Recipient_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Recipient_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient" */
export type Risolto_Recipient_Aggregate_Fields = {
  __typename?: 'risolto_recipient_aggregate_fields';
  avg?: Maybe<Risolto_Recipient_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Min_Fields>;
  stddev?: Maybe<Risolto_Recipient_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Recipient_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Recipient_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Recipient_Sum_Fields>;
  var_pop?: Maybe<Risolto_Recipient_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Recipient_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Recipient_Variance_Fields>;
};


/** aggregate fields of "risolto.recipient" */
export type Risolto_Recipient_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient" */
export type Risolto_Recipient_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Recipient_Append_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  /** null */
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  dunning_metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.recipient" */
export type Risolto_Recipient_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_On_Conflict>;
};

/** columns and relationships of "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment = {
  __typename?: 'risolto_recipient_attachment';
  attachment_type: Risolto_Document_Attachment_Type_Enum;
  created_at: Scalars['timestamptz'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.recipient_attachment" */
export type Risolto_Recipient_AttachmentMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Aggregate = {
  __typename?: 'risolto_recipient_attachment_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Attachment_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_Attachment>;
};

export type Risolto_Recipient_Attachment_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Recipient_Attachment_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_Attachment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Aggregate_Fields = {
  __typename?: 'risolto_recipient_attachment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Attachment_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Attachment_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Attachment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_Attachment_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_Attachment_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Recipient_Attachment_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_Attachment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_attachment". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Attachment_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Attachment_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Attachment_Bool_Exp>>;
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.recipient_attachment" */
export enum Risolto_Recipient_Attachment_Constraint {
  /** unique or primary key constraint on columns "participant", "recipient", "legal_entity", "name" */
  RecipientAttachmentParticipantLegalEntityRecipientNamKey = 'recipient_attachment_participant_legal_entity_recipient_nam_key',
  /** unique or primary key constraint on columns "reference" */
  RecipientAttachmentPkey = 'recipient_attachment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Recipient_Attachment_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Recipient_Attachment_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Recipient_Attachment_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Insert_Input = {
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Attachment_Max_Fields = {
  __typename?: 'risolto_recipient_attachment_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Recipient_Attachment_Min_Fields = {
  __typename?: 'risolto_recipient_attachment_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Mutation_Response = {
  __typename?: 'risolto_recipient_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_Attachment>;
};

/** on_conflict condition type for table "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_On_Conflict = {
  constraint: Risolto_Recipient_Attachment_Constraint;
  update_columns?: Array<Risolto_Recipient_Attachment_Update_Column>;
  where?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient_attachment". */
export type Risolto_Recipient_Attachment_Order_By = {
  attachment_type?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  metadata?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient_attachment */
export type Risolto_Recipient_Attachment_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Recipient_Attachment_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.recipient_attachment" */
export enum Risolto_Recipient_Attachment_Select_Column {
  /** column name */
  AttachmentType = 'attachment_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.recipient_attachment" */
export type Risolto_Recipient_Attachment_Set_Input = {
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_recipient_attachment" */
export type Risolto_Recipient_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Attachment_Stream_Cursor_Value_Input = {
  attachment_type?: Maybe<Risolto_Document_Attachment_Type_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.recipient_attachment" */
export enum Risolto_Recipient_Attachment_Update_Column {
  /** column name */
  AttachmentType = 'attachment_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Recipient_Attachment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Recipient_Attachment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Recipient_Attachment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Recipient_Attachment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Recipient_Attachment_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Recipient_Attachment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Attachment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Attachment_Bool_Exp;
};

/** aggregate avg on columns */
export type Risolto_Recipient_Avg_Fields = {
  __typename?: 'risolto_recipient_avg_fields';
  balance_amount?: Maybe<Scalars['numeric']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "risolto.recipient". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  accounting_documents?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
  accounting_documents_aggregate?: Maybe<Risolto_Accounting_Document_Aggregate_Bool_Exp>;
  actions?: Maybe<Risolto_Action_Bool_Exp>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Bool_Exp>;
  address?: Maybe<Jsonb_Comparison_Exp>;
  analytics_test_results?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
  analytics_test_results_aggregate?: Maybe<Risolto_Analytics_Test_Result_Aggregate_Bool_Exp>;
  analytics_test_results_map?: Maybe<Jsonb_Comparison_Exp>;
  balance_amount?: Maybe<Numeric_Comparison_Exp>;
  bank_accounts?: Maybe<Risolto_Bank_Account_Bool_Exp>;
  bank_accounts_aggregate?: Maybe<Risolto_Bank_Account_Aggregate_Bool_Exp>;
  category?: Maybe<String_Comparison_Exp>;
  channel_endpoints?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
  channel_endpoints_aggregate?: Maybe<Risolto_Channel_Endpoint_Aggregate_Bool_Exp>;
  collections?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
  collections_aggregate?: Maybe<Risolto_Recipient_Collection_Aggregate_Bool_Exp>;
  contacts?: Maybe<Risolto_Contact_Bool_Exp>;
  contacts_aggregate?: Maybe<Risolto_Contact_Aggregate_Bool_Exp>;
  country_code?: Maybe<Risolto_Iso_Country_Code_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  credit_limits?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
  credit_limits_aggregate?: Maybe<Risolto_Credit_Limit_Aggregate_Bool_Exp>;
  credit_notes?: Maybe<Risolto_Credit_Note_Bool_Exp>;
  credit_notes_aggregate?: Maybe<Risolto_Credit_Note_Aggregate_Bool_Exp>;
  currency?: Maybe<Risolto_Currency_Enum_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  debit_notes?: Maybe<Risolto_Debit_Note_Bool_Exp>;
  debit_notes_aggregate?: Maybe<Risolto_Debit_Note_Aggregate_Bool_Exp>;
  document_interchange_links?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  document_interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp>;
  due_balance_amount?: Maybe<Numeric_Comparison_Exp>;
  dunning_exclude_until?: Maybe<Timestamptz_Comparison_Exp>;
  dunning_excludes?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
  dunning_excludes_aggregate?: Maybe<Risolto_Recipient_Dunning_Exclude_Aggregate_Bool_Exp>;
  dunning_in_progress?: Maybe<Boolean_Comparison_Exp>;
  dunning_is_dirty?: Maybe<Boolean_Comparison_Exp>;
  dunning_metadata?: Maybe<Jsonb_Comparison_Exp>;
  dunning_notices?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  dunning_notices_aggregate?: Maybe<Risolto_Dunning_Notice_Aggregate_Bool_Exp>;
  email_addresses?: Maybe<Jsonb_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  in_collection?: Maybe<Boolean_Comparison_Exp>;
  in_collection_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice_disputes?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
  invoice_disputes_aggregate?: Maybe<Risolto_Invoice_Dispute_Aggregate_Bool_Exp>;
  invoice_documents?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  invoice_documents_aggregate?: Maybe<Risolto_Invoice_Document_Aggregate_Bool_Exp>;
  invoice_group_credit_notes?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
  invoice_group_credit_notes_aggregate?: Maybe<Risolto_Invoice_Group_Credit_Note_Aggregate_Bool_Exp>;
  invoice_group_debit_notes?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
  invoice_group_debit_notes_aggregate?: Maybe<Risolto_Invoice_Group_Debit_Note_Aggregate_Bool_Exp>;
  invoice_group_invoices?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
  invoice_group_invoices_aggregate?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Bool_Exp>;
  invoice_group_payments?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
  invoice_group_payments_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Aggregate_Bool_Exp>;
  invoice_groups?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
  invoice_groups_aggregate?: Maybe<Risolto_Invoice_Group_Aggregate_Bool_Exp>;
  language_code?: Maybe<Risolto_Language_Code_Enum_Comparison_Exp>;
  last_dunning_at?: Maybe<Timestamptz_Comparison_Exp>;
  last_dunning_costs?: Maybe<Numeric_Comparison_Exp>;
  last_dunning_email_to?: Maybe<String_Comparison_Exp>;
  last_dunning_run_at?: Maybe<Timestamptz_Comparison_Exp>;
  last_email_to?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  legal_id?: Maybe<String_Comparison_Exp>;
  legal_id_type?: Maybe<String_Comparison_Exp>;
  message_recipients?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
  message_recipients_aggregate?: Maybe<Risolto_Message_Recipient_Aggregate_Bool_Exp>;
  most_used_dunning_email_to?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  notes?: Maybe<Risolto_Note_Bool_Exp>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Bool_Exp>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Bool_Exp>;
  origin?: Maybe<Risolto_Origin_Enum_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_documents?: Maybe<Risolto_Payment_Document_Bool_Exp>;
  payment_documents_aggregate?: Maybe<Risolto_Payment_Document_Aggregate_Bool_Exp>;
  payment_plans?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
  payment_plans_aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Bool_Exp>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Bool_Exp>;
  payments?: Maybe<Risolto_Payment_Bool_Exp>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Bool_Exp>;
  postal_addresses?: Maybe<Jsonb_Comparison_Exp>;
  prediction_is_dirty?: Maybe<Boolean_Comparison_Exp>;
  prediction_stars?: Maybe<Numeric_Comparison_Exp>;
  preferred_invoicing_channel?: Maybe<Risolto_Channel_Enum_Comparison_Exp>;
  raw_data?: Maybe<String_Comparison_Exp>;
  recipient_attachments?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
  recipient_attachments_aggregate?: Maybe<Risolto_Recipient_Attachment_Aggregate_Bool_Exp>;
  recipient_dunning_runs?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
  recipient_dunning_runs_aggregate?: Maybe<Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp>;
  recipient_merge_froms?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
  recipient_merge_froms_aggregate?: Maybe<Risolto_Recipient_Merge_Aggregate_Bool_Exp>;
  recipient_merge_tos?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
  recipient_merge_tos_aggregate?: Maybe<Risolto_Recipient_Merge_Aggregate_Bool_Exp>;
  recipient_tags?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
  recipient_tags_aggregate?: Maybe<Risolto_Recipient_Tag_Aggregate_Bool_Exp>;
  recipient_users?: Maybe<Risolto_Recipient_User_Bool_Exp>;
  recipient_users_aggregate?: Maybe<Risolto_Recipient_User_Aggregate_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  short_code?: Maybe<String_Comparison_Exp>;
  statement_lines?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  statement_lines_aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Bool_Exp>;
  tags?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
  tags_aggregate?: Maybe<Risolto_View_Recipient_Tag_Aggregate_Bool_Exp>;
  telephone_numbers?: Maybe<Jsonb_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<String_Comparison_Exp>;
  version_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "risolto.recipient_collection" */
export type Risolto_Recipient_Collection = {
  __typename?: 'risolto_recipient_collection';
  closed_at?: Maybe<Scalars['timestamptz']>;
  closed_by?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  started_at: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.recipient_collection" */
export type Risolto_Recipient_CollectionCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Aggregate = {
  __typename?: 'risolto_recipient_collection_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Collection_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_Collection>;
};

export type Risolto_Recipient_Collection_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Recipient_Collection_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_Collection_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_Collection_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Aggregate_Fields = {
  __typename?: 'risolto_recipient_collection_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Collection_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Collection_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Collection_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_Collection_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_Collection_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Recipient_Collection_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_Collection_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_Collection_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_collection". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Collection_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Collection_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Collection_Bool_Exp>>;
  closed_at?: Maybe<Timestamptz_Comparison_Exp>;
  closed_by?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  started_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.recipient_collection" */
export enum Risolto_Recipient_Collection_Constraint {
  /** unique or primary key constraint on columns "reference" */
  RecipientCollectionPkey = 'recipient_collection_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Recipient_Collection_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Recipient_Collection_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Recipient_Collection_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Insert_Input = {
  closed_at?: Maybe<Scalars['timestamptz']>;
  closed_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Collection_Max_Fields = {
  __typename?: 'risolto_recipient_collection_max_fields';
  closed_at?: Maybe<Scalars['timestamptz']>;
  closed_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Max_Order_By = {
  closed_at?: Maybe<Order_By>;
  closed_by?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  started_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Recipient_Collection_Min_Fields = {
  __typename?: 'risolto_recipient_collection_min_fields';
  closed_at?: Maybe<Scalars['timestamptz']>;
  closed_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Min_Order_By = {
  closed_at?: Maybe<Order_By>;
  closed_by?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  started_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Mutation_Response = {
  __typename?: 'risolto_recipient_collection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_Collection>;
};

/** on_conflict condition type for table "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_On_Conflict = {
  constraint: Risolto_Recipient_Collection_Constraint;
  update_columns?: Array<Risolto_Recipient_Collection_Update_Column>;
  where?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient_collection". */
export type Risolto_Recipient_Collection_Order_By = {
  closed_at?: Maybe<Order_By>;
  closed_by?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  started_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient_collection */
export type Risolto_Recipient_Collection_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Recipient_Collection_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.recipient_collection" */
export enum Risolto_Recipient_Collection_Select_Column {
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ClosedBy = 'closed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.recipient_collection" */
export type Risolto_Recipient_Collection_Set_Input = {
  closed_at?: Maybe<Scalars['timestamptz']>;
  closed_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_recipient_collection" */
export type Risolto_Recipient_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Collection_Stream_Cursor_Value_Input = {
  closed_at?: Maybe<Scalars['timestamptz']>;
  closed_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.recipient_collection" */
export enum Risolto_Recipient_Collection_Update_Column {
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  ClosedBy = 'closed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Recipient_Collection_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Recipient_Collection_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Recipient_Collection_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Recipient_Collection_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Recipient_Collection_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Recipient_Collection_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Collection_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Collection_Bool_Exp;
};

/** columns and relationships of "risolto.recipient_communication" */
export type Risolto_Recipient_Communication = {
  __typename?: 'risolto_recipient_communication';
  communication: Scalars['uuid'];
  /** An object relationship */
  communication_by_reference: Risolto_Communication;
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Aggregate = {
  __typename?: 'risolto_recipient_communication_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Communication_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_Communication>;
};

export type Risolto_Recipient_Communication_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Recipient_Communication_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_Communication_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_Communication_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Aggregate_Fields = {
  __typename?: 'risolto_recipient_communication_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Communication_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Communication_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Communication_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_Communication_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_Communication_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_Communication_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_Communication_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_communication". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Communication_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Communication_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Communication_Bool_Exp>>;
  communication?: Maybe<Uuid_Comparison_Exp>;
  communication_by_reference?: Maybe<Risolto_Communication_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.recipient_communication" */
export enum Risolto_Recipient_Communication_Constraint {
  /** unique or primary key constraint on columns "reference" */
  RecipientCommunicationPkey = 'recipient_communication_pkey',
  /** unique or primary key constraint on columns "participant", "communication", "recipient" */
  RecipientCommunicationRecipientCommunicationParticipantKey = 'recipient_communication_recipient_communication_participant_key'
}

/** input type for inserting data into table "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Insert_Input = {
  communication?: Maybe<Scalars['uuid']>;
  communication_by_reference?: Maybe<Risolto_Communication_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Communication_Max_Fields = {
  __typename?: 'risolto_recipient_communication_max_fields';
  communication?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Max_Order_By = {
  communication?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Recipient_Communication_Min_Fields = {
  __typename?: 'risolto_recipient_communication_min_fields';
  communication?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Min_Order_By = {
  communication?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Mutation_Response = {
  __typename?: 'risolto_recipient_communication_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_Communication>;
};

/** on_conflict condition type for table "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_On_Conflict = {
  constraint: Risolto_Recipient_Communication_Constraint;
  update_columns?: Array<Risolto_Recipient_Communication_Update_Column>;
  where?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient_communication". */
export type Risolto_Recipient_Communication_Order_By = {
  communication?: Maybe<Order_By>;
  communication_by_reference?: Maybe<Risolto_Communication_Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient_communication */
export type Risolto_Recipient_Communication_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.recipient_communication" */
export enum Risolto_Recipient_Communication_Select_Column {
  /** column name */
  Communication = 'communication',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.recipient_communication" */
export type Risolto_Recipient_Communication_Set_Input = {
  communication?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_recipient_communication" */
export type Risolto_Recipient_Communication_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Communication_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Communication_Stream_Cursor_Value_Input = {
  communication?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.recipient_communication" */
export enum Risolto_Recipient_Communication_Update_Column {
  /** column name */
  Communication = 'communication',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Recipient_Communication_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Communication_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Communication_Bool_Exp;
};

/** unique or primary key constraints on table "risolto.recipient" */
export enum Risolto_Recipient_Constraint {
  /** unique or primary key constraint on columns "reference" */
  RecipientPkey1 = 'Recipient_pkey1',
  /** unique or primary key constraint on columns "account_id", "legal_entity" */
  RecipientLegalEntityRecipientReferenceKey = 'recipient_legal_entity_recipient_reference_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Recipient_Delete_At_Path_Input = {
  /** DEPRECATED */
  address?: Maybe<Array<Scalars['String']>>;
  /** null */
  custom_fields?: Maybe<Array<Scalars['String']>>;
  /** DEPRECATED */
  dunning_metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Recipient_Delete_Elem_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['Int']>;
  /** null */
  custom_fields?: Maybe<Scalars['Int']>;
  /** DEPRECATED */
  dunning_metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Recipient_Delete_Key_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['String']>;
  /** null */
  custom_fields?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  dunning_metadata?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude = {
  __typename?: 'risolto_recipient_dunning_exclude';
  created_at: Scalars['timestamptz'];
  exclude_from: Scalars['timestamptz'];
  exclude_until: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Aggregate = {
  __typename?: 'risolto_recipient_dunning_exclude_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Dunning_Exclude_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_Dunning_Exclude>;
};

export type Risolto_Recipient_Dunning_Exclude_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Recipient_Dunning_Exclude_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_Dunning_Exclude_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Aggregate_Fields = {
  __typename?: 'risolto_recipient_dunning_exclude_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Dunning_Exclude_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Dunning_Exclude_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_Dunning_Exclude_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_Dunning_Exclude_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_Dunning_Exclude_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_Dunning_Exclude_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_dunning_exclude". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Dunning_Exclude_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  exclude_from?: Maybe<Timestamptz_Comparison_Exp>;
  exclude_until?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.recipient_dunning_exclude" */
export enum Risolto_Recipient_Dunning_Exclude_Constraint {
  /** unique or primary key constraint on columns "reference" */
  RecipientDunningExcludePkey = 'recipient_dunning_exclude_pkey'
}

/** input type for inserting data into table "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  exclude_from?: Maybe<Scalars['timestamptz']>;
  exclude_until?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Dunning_Exclude_Max_Fields = {
  __typename?: 'risolto_recipient_dunning_exclude_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  exclude_from?: Maybe<Scalars['timestamptz']>;
  exclude_until?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  exclude_from?: Maybe<Order_By>;
  exclude_until?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Recipient_Dunning_Exclude_Min_Fields = {
  __typename?: 'risolto_recipient_dunning_exclude_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  exclude_from?: Maybe<Scalars['timestamptz']>;
  exclude_until?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  exclude_from?: Maybe<Order_By>;
  exclude_until?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Mutation_Response = {
  __typename?: 'risolto_recipient_dunning_exclude_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_Dunning_Exclude>;
};

/** on_conflict condition type for table "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_On_Conflict = {
  constraint: Risolto_Recipient_Dunning_Exclude_Constraint;
  update_columns?: Array<Risolto_Recipient_Dunning_Exclude_Update_Column>;
  where?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient_dunning_exclude". */
export type Risolto_Recipient_Dunning_Exclude_Order_By = {
  created_at?: Maybe<Order_By>;
  exclude_from?: Maybe<Order_By>;
  exclude_until?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient_dunning_exclude */
export type Risolto_Recipient_Dunning_Exclude_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.recipient_dunning_exclude" */
export enum Risolto_Recipient_Dunning_Exclude_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExcludeFrom = 'exclude_from',
  /** column name */
  ExcludeUntil = 'exclude_until',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  exclude_from?: Maybe<Scalars['timestamptz']>;
  exclude_until?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_recipient_dunning_exclude" */
export type Risolto_Recipient_Dunning_Exclude_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Dunning_Exclude_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Dunning_Exclude_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  exclude_from?: Maybe<Scalars['timestamptz']>;
  exclude_until?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.recipient_dunning_exclude" */
export enum Risolto_Recipient_Dunning_Exclude_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExcludeFrom = 'exclude_from',
  /** column name */
  ExcludeUntil = 'exclude_until',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Recipient_Dunning_Exclude_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Dunning_Exclude_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Dunning_Exclude_Bool_Exp;
};

/** columns and relationships of "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run = {
  __typename?: 'risolto_recipient_dunning_run';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  invoice_group_dunning_runs: Array<Risolto_Invoice_Group_Dunning_Run>;
  /** An aggregate relationship */
  invoice_group_dunning_runs_aggregate: Risolto_Invoice_Group_Dunning_Run_Aggregate;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An object relationship */
  participant_dunning_dunning_run_by_reference?: Maybe<Risolto_Participant_Dunning_Run>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  /** _100_STARTED | _200_DONE */
  processing_status: Risolto_Run_Processing_Status_Enum;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  test: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_RunInvoice_Group_Dunning_RunsArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


/** columns and relationships of "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_RunInvoice_Group_Dunning_Runs_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};

/** aggregated selection of "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Aggregate = {
  __typename?: 'risolto_recipient_dunning_run_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Dunning_Run_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_Dunning_Run>;
};

export type Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Recipient_Dunning_Run_Select_Column_Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Recipient_Dunning_Run_Select_Column_Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Aggregate_Fields = {
  __typename?: 'risolto_recipient_dunning_run_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Dunning_Run_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Dunning_Run_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_Dunning_Run_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_Dunning_Run_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_Dunning_Run_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_Dunning_Run_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_dunning_run". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Dunning_Run_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Dunning_Run_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Dunning_Run_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice_group_dunning_runs?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
  invoice_group_dunning_runs_aggregate?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  participant_dunning_dunning_run_by_reference?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
  participant_dunning_run?: Maybe<Uuid_Comparison_Exp>;
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  test?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.recipient_dunning_run" */
export enum Risolto_Recipient_Dunning_Run_Constraint {
  /** unique or primary key constraint on columns "reference" */
  RecipientDunningRunPkey = 'recipient_dunning_run_pkey'
}

/** input type for inserting data into table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice_group_dunning_runs?: Maybe<Risolto_Invoice_Group_Dunning_Run_Arr_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  participant_dunning_dunning_run_by_reference?: Maybe<Risolto_Participant_Dunning_Run_Obj_Rel_Insert_Input>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  /** _100_STARTED | _200_DONE */
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Dunning_Run_Max_Fields = {
  __typename?: 'risolto_recipient_dunning_run_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_dunning_run?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Recipient_Dunning_Run_Min_Fields = {
  __typename?: 'risolto_recipient_dunning_run_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_dunning_run?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Mutation_Response = {
  __typename?: 'risolto_recipient_dunning_run_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_Dunning_Run>;
};

/** input type for inserting object relation for remote table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Obj_Rel_Insert_Input = {
  data: Risolto_Recipient_Dunning_Run_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_Dunning_Run_On_Conflict>;
};

/** on_conflict condition type for table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_On_Conflict = {
  constraint: Risolto_Recipient_Dunning_Run_Constraint;
  update_columns?: Array<Risolto_Recipient_Dunning_Run_Update_Column>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient_dunning_run". */
export type Risolto_Recipient_Dunning_Run_Order_By = {
  created_at?: Maybe<Order_By>;
  invoice_group_dunning_runs_aggregate?: Maybe<Risolto_Invoice_Group_Dunning_Run_Aggregate_Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  participant_dunning_dunning_run_by_reference?: Maybe<Risolto_Participant_Dunning_Run_Order_By>;
  participant_dunning_run?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  test?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient_dunning_run */
export type Risolto_Recipient_Dunning_Run_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.recipient_dunning_run" */
export enum Risolto_Recipient_Dunning_Run_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantDunningRun = 'participant_dunning_run',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_recipient_dunning_run_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.recipient_dunning_run" */
export enum Risolto_Recipient_Dunning_Run_Select_Column_Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Test = 'test'
}

/** select "risolto_recipient_dunning_run_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.recipient_dunning_run" */
export enum Risolto_Recipient_Dunning_Run_Select_Column_Risolto_Recipient_Dunning_Run_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Test = 'test'
}

/** input type for updating data in table "risolto.recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  /** _100_STARTED | _200_DONE */
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_recipient_dunning_run" */
export type Risolto_Recipient_Dunning_Run_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Dunning_Run_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Dunning_Run_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_dunning_run?: Maybe<Scalars['uuid']>;
  /** _100_STARTED | _200_DONE */
  processing_status?: Maybe<Risolto_Run_Processing_Status_Enum>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  test?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.recipient_dunning_run" */
export enum Risolto_Recipient_Dunning_Run_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantDunningRun = 'participant_dunning_run',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Recipient_Dunning_Run_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Dunning_Run_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Dunning_Run_Bool_Exp;
};

export type Risolto_Recipient_Find_Similar_By_Name_Args = {
  q_participant?: Maybe<Scalars['uuid']>;
  q_recipient?: Maybe<Scalars['uuid']>;
};

/** input type for inserting data into table "risolto.recipient" */
export type Risolto_Recipient_Insert_Input = {
  /** Participant assigned account id (UBL: SupplierAssignedAccountID) */
  account_id?: Maybe<Scalars['String']>;
  accounting_documents?: Maybe<Risolto_Accounting_Document_Arr_Rel_Insert_Input>;
  actions?: Maybe<Risolto_Action_Arr_Rel_Insert_Input>;
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  analytics_test_results?: Maybe<Risolto_Analytics_Test_Result_Arr_Rel_Insert_Input>;
  bank_accounts?: Maybe<Risolto_Bank_Account_Arr_Rel_Insert_Input>;
  channel_endpoints?: Maybe<Risolto_Channel_Endpoint_Arr_Rel_Insert_Input>;
  collections?: Maybe<Risolto_Recipient_Collection_Arr_Rel_Insert_Input>;
  contacts?: Maybe<Risolto_Contact_Arr_Rel_Insert_Input>;
  country_code?: Maybe<Risolto_Iso_Country_Code_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_limits?: Maybe<Risolto_Credit_Limit_Arr_Rel_Insert_Input>;
  credit_notes?: Maybe<Risolto_Credit_Note_Arr_Rel_Insert_Input>;
  currency?: Maybe<Risolto_Currency_Enum>;
  /** null */
  custom_fields?: Maybe<Scalars['jsonb']>;
  debit_notes?: Maybe<Risolto_Debit_Note_Arr_Rel_Insert_Input>;
  document_interchange_links?: Maybe<Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input>;
  dunning_excludes?: Maybe<Risolto_Recipient_Dunning_Exclude_Arr_Rel_Insert_Input>;
  /** DEPRECATED */
  dunning_in_progress?: Maybe<Scalars['Boolean']>;
  dunning_is_dirty?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED */
  dunning_metadata?: Maybe<Scalars['jsonb']>;
  dunning_notices?: Maybe<Risolto_Dunning_Notice_Arr_Rel_Insert_Input>;
  /** External identifier, typically a technical id. For functional identifiers use the account_id */
  external_id?: Maybe<Scalars['String']>;
  invoice_disputes?: Maybe<Risolto_Invoice_Dispute_Arr_Rel_Insert_Input>;
  invoice_documents?: Maybe<Risolto_Invoice_Document_Arr_Rel_Insert_Input>;
  invoice_group_credit_notes?: Maybe<Risolto_Invoice_Group_Credit_Note_Arr_Rel_Insert_Input>;
  invoice_group_debit_notes?: Maybe<Risolto_Invoice_Group_Debit_Note_Arr_Rel_Insert_Input>;
  invoice_group_invoices?: Maybe<Risolto_Invoice_Group_Invoice_Arr_Rel_Insert_Input>;
  invoice_group_payments?: Maybe<Risolto_Invoice_Group_Payment_Arr_Rel_Insert_Input>;
  invoice_groups?: Maybe<Risolto_Invoice_Group_Arr_Rel_Insert_Input>;
  language_code?: Maybe<Risolto_Language_Code_Enum>;
  /** Note: see also computed field 'last_dunning_run_at' (which _should_ be the same value) */
  last_dunning_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  /** A (legally) unique identifier for the recipient corresponding to the legal_id_type. For example: a VAT number or an ID (Identity Document) */
  legal_id?: Maybe<Scalars['String']>;
  /** The name of an identifier which uniquely identifies the recipient. For example: VAT, ID (Identity Document) */
  legal_id_type?: Maybe<Scalars['String']>;
  message_recipients?: Maybe<Risolto_Message_Recipient_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Risolto_Note_Arr_Rel_Insert_Input>;
  open_balance_records?: Maybe<Risolto_Open_Balance_Record_Arr_Rel_Insert_Input>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_documents?: Maybe<Risolto_Payment_Document_Arr_Rel_Insert_Input>;
  payment_plans?: Maybe<Risolto_Payment_Plan_Arr_Rel_Insert_Input>;
  payment_promises?: Maybe<Risolto_Payment_Promise_Arr_Rel_Insert_Input>;
  payments?: Maybe<Risolto_Payment_Arr_Rel_Insert_Input>;
  prediction_is_dirty?: Maybe<Scalars['Boolean']>;
  preferred_invoicing_channel?: Maybe<Risolto_Channel_Enum>;
  raw_data?: Maybe<Scalars['String']>;
  recipient_attachments?: Maybe<Risolto_Recipient_Attachment_Arr_Rel_Insert_Input>;
  recipient_dunning_runs?: Maybe<Risolto_Recipient_Dunning_Run_Arr_Rel_Insert_Input>;
  recipient_merge_froms?: Maybe<Risolto_Recipient_Merge_Arr_Rel_Insert_Input>;
  recipient_merge_tos?: Maybe<Risolto_Recipient_Merge_Arr_Rel_Insert_Input>;
  recipient_tags?: Maybe<Risolto_Recipient_Tag_Arr_Rel_Insert_Input>;
  recipient_users?: Maybe<Risolto_Recipient_User_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  statement_lines?: Maybe<Risolto_Statement_Line_Arr_Rel_Insert_Input>;
  tags?: Maybe<Risolto_View_Recipient_Tag_Arr_Rel_Insert_Input>;
  /** B2B | B2C */
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  version_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Max_Fields = {
  __typename?: 'risolto_recipient_max_fields';
  /** Participant assigned account id (UBL: SupplierAssignedAccountID) */
  account_id?: Maybe<Scalars['String']>;
  balance_amount?: Maybe<Scalars['numeric']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  dunning_exclude_until?: Maybe<Scalars['timestamptz']>;
  /** External identifier, typically a technical id. For functional identifiers use the account_id */
  external_id?: Maybe<Scalars['String']>;
  in_collection_at?: Maybe<Scalars['timestamptz']>;
  /** Note: see also computed field 'last_dunning_run_at' (which _should_ be the same value) */
  last_dunning_at?: Maybe<Scalars['timestamptz']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  last_dunning_email_to?: Maybe<Scalars['String']>;
  last_dunning_run_at?: Maybe<Scalars['timestamptz']>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** A (legally) unique identifier for the recipient corresponding to the legal_id_type. For example: a VAT number or an ID (Identity Document) */
  legal_id?: Maybe<Scalars['String']>;
  /** The name of an identifier which uniquely identifies the recipient. For example: VAT, ID (Identity Document) */
  legal_id_type?: Maybe<Scalars['String']>;
  most_used_dunning_email_to?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "risolto.recipient_short_code" */
  short_code?: Maybe<Scalars['String']>;
  /** B2B | B2C */
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  version_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient" */
export type Risolto_Recipient_Max_Order_By = {
  /** Participant assigned account id (UBL: SupplierAssignedAccountID) */
  account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  /** External identifier, typically a technical id. For functional identifiers use the account_id */
  external_id?: Maybe<Order_By>;
  /** Note: see also computed field 'last_dunning_run_at' (which _should_ be the same value) */
  last_dunning_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  /** A (legally) unique identifier for the recipient corresponding to the legal_id_type. For example: a VAT number or an ID (Identity Document) */
  legal_id?: Maybe<Order_By>;
  /** The name of an identifier which uniquely identifies the recipient. For example: VAT, ID (Identity Document) */
  legal_id_type?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  raw_data?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** B2B | B2C */
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  version_at?: Maybe<Order_By>;
};

/** IMPORTANT: upon inserting a record into this table, all underlying records pointing to the old recipient will be moved to the new recipient! */
export type Risolto_Recipient_Merge = {
  __typename?: 'risolto_recipient_merge';
  created_at: Scalars['timestamptz'];
  failure_reason?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  merge_from_recipient: Scalars['uuid'];
  /** An object relationship */
  merge_from_recipient_by_reference: Risolto_Recipient;
  merge_to_recipient: Scalars['uuid'];
  /** An object relationship */
  merge_to_recipient_by_reference: Risolto_Recipient;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  retried_at?: Maybe<Scalars['timestamptz']>;
  succeeded: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Aggregate = {
  __typename?: 'risolto_recipient_merge_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Merge_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_Merge>;
};

export type Risolto_Recipient_Merge_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Recipient_Merge_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Recipient_Merge_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Recipient_Merge_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_Merge_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Recipient_Merge_Select_Column_Risolto_Recipient_Merge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Recipient_Merge_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Recipient_Merge_Select_Column_Risolto_Recipient_Merge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Recipient_Merge_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Aggregate_Fields = {
  __typename?: 'risolto_recipient_merge_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Merge_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Merge_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_Merge_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_Merge_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_Merge_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_Merge_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_merge". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Merge_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Merge_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Merge_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  failure_reason?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  merge_from_recipient?: Maybe<Uuid_Comparison_Exp>;
  merge_from_recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  merge_to_recipient?: Maybe<Uuid_Comparison_Exp>;
  merge_to_recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  retried_at?: Maybe<Timestamptz_Comparison_Exp>;
  succeeded?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.recipient_merge" */
export enum Risolto_Recipient_Merge_Constraint {
  /** unique or primary key constraint on columns "participant", "merge_from_recipient", "merge_to_recipient" */
  RecipientMergeParticipantMergeFromRecipientMergeToRecip = 'recipient_merge_participant_merge_from_recipient_merge_to_recip',
  /** unique or primary key constraint on columns "reference" */
  RecipientMergePkey = 'recipient_merge_pkey'
}

/** input type for inserting data into table "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  failure_reason?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  merge_from_recipient?: Maybe<Scalars['uuid']>;
  merge_from_recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  merge_to_recipient?: Maybe<Scalars['uuid']>;
  merge_to_recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  retried_at?: Maybe<Scalars['timestamptz']>;
  succeeded?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Merge_Max_Fields = {
  __typename?: 'risolto_recipient_merge_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  failure_reason?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  merge_from_recipient?: Maybe<Scalars['uuid']>;
  merge_to_recipient?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  retried_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  failure_reason?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  merge_from_recipient?: Maybe<Order_By>;
  merge_to_recipient?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  retried_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Recipient_Merge_Min_Fields = {
  __typename?: 'risolto_recipient_merge_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  failure_reason?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  merge_from_recipient?: Maybe<Scalars['uuid']>;
  merge_to_recipient?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  retried_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  failure_reason?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  merge_from_recipient?: Maybe<Order_By>;
  merge_to_recipient?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  retried_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Mutation_Response = {
  __typename?: 'risolto_recipient_merge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_Merge>;
};

/** on_conflict condition type for table "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_On_Conflict = {
  constraint: Risolto_Recipient_Merge_Constraint;
  update_columns?: Array<Risolto_Recipient_Merge_Update_Column>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient_merge". */
export type Risolto_Recipient_Merge_Order_By = {
  created_at?: Maybe<Order_By>;
  failure_reason?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  merge_from_recipient?: Maybe<Order_By>;
  merge_from_recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  merge_to_recipient?: Maybe<Order_By>;
  merge_to_recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  retried_at?: Maybe<Order_By>;
  succeeded?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient_merge */
export type Risolto_Recipient_Merge_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.recipient_merge" */
export enum Risolto_Recipient_Merge_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailureReason = 'failure_reason',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MergeFromRecipient = 'merge_from_recipient',
  /** column name */
  MergeToRecipient = 'merge_to_recipient',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  RetriedAt = 'retried_at',
  /** column name */
  Succeeded = 'succeeded',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_recipient_merge_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.recipient_merge" */
export enum Risolto_Recipient_Merge_Select_Column_Risolto_Recipient_Merge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Succeeded = 'succeeded'
}

/** select "risolto_recipient_merge_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.recipient_merge" */
export enum Risolto_Recipient_Merge_Select_Column_Risolto_Recipient_Merge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Succeeded = 'succeeded'
}

/** input type for updating data in table "risolto.recipient_merge" */
export type Risolto_Recipient_Merge_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  failure_reason?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  merge_from_recipient?: Maybe<Scalars['uuid']>;
  merge_to_recipient?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  retried_at?: Maybe<Scalars['timestamptz']>;
  succeeded?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_recipient_merge" */
export type Risolto_Recipient_Merge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Merge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Merge_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  failure_reason?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  merge_from_recipient?: Maybe<Scalars['uuid']>;
  merge_to_recipient?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  retried_at?: Maybe<Scalars['timestamptz']>;
  succeeded?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.recipient_merge" */
export enum Risolto_Recipient_Merge_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FailureReason = 'failure_reason',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MergeFromRecipient = 'merge_from_recipient',
  /** column name */
  MergeToRecipient = 'merge_to_recipient',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  RetriedAt = 'retried_at',
  /** column name */
  Succeeded = 'succeeded',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Recipient_Merge_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Merge_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Merge_Bool_Exp;
};

/** aggregate min on columns */
export type Risolto_Recipient_Min_Fields = {
  __typename?: 'risolto_recipient_min_fields';
  /** Participant assigned account id (UBL: SupplierAssignedAccountID) */
  account_id?: Maybe<Scalars['String']>;
  balance_amount?: Maybe<Scalars['numeric']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  dunning_exclude_until?: Maybe<Scalars['timestamptz']>;
  /** External identifier, typically a technical id. For functional identifiers use the account_id */
  external_id?: Maybe<Scalars['String']>;
  in_collection_at?: Maybe<Scalars['timestamptz']>;
  /** Note: see also computed field 'last_dunning_run_at' (which _should_ be the same value) */
  last_dunning_at?: Maybe<Scalars['timestamptz']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  last_dunning_email_to?: Maybe<Scalars['String']>;
  last_dunning_run_at?: Maybe<Scalars['timestamptz']>;
  last_email_to?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** A (legally) unique identifier for the recipient corresponding to the legal_id_type. For example: a VAT number or an ID (Identity Document) */
  legal_id?: Maybe<Scalars['String']>;
  /** The name of an identifier which uniquely identifies the recipient. For example: VAT, ID (Identity Document) */
  legal_id_type?: Maybe<Scalars['String']>;
  most_used_dunning_email_to?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "risolto.recipient_short_code" */
  short_code?: Maybe<Scalars['String']>;
  /** B2B | B2C */
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  version_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient" */
export type Risolto_Recipient_Min_Order_By = {
  /** Participant assigned account id (UBL: SupplierAssignedAccountID) */
  account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  /** External identifier, typically a technical id. For functional identifiers use the account_id */
  external_id?: Maybe<Order_By>;
  /** Note: see also computed field 'last_dunning_run_at' (which _should_ be the same value) */
  last_dunning_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  /** A (legally) unique identifier for the recipient corresponding to the legal_id_type. For example: a VAT number or an ID (Identity Document) */
  legal_id?: Maybe<Order_By>;
  /** The name of an identifier which uniquely identifies the recipient. For example: VAT, ID (Identity Document) */
  legal_id_type?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  raw_data?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  /** B2B | B2C */
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  version_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient" */
export type Risolto_Recipient_Mutation_Response = {
  __typename?: 'risolto_recipient_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient>;
};

/** input type for inserting object relation for remote table "risolto.recipient" */
export type Risolto_Recipient_Obj_Rel_Insert_Input = {
  data: Risolto_Recipient_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_On_Conflict>;
};

/** on_conflict condition type for table "risolto.recipient" */
export type Risolto_Recipient_On_Conflict = {
  constraint: Risolto_Recipient_Constraint;
  update_columns?: Array<Risolto_Recipient_Update_Column>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient". */
export type Risolto_Recipient_Order_By = {
  account_id?: Maybe<Order_By>;
  accounting_documents_aggregate?: Maybe<Risolto_Accounting_Document_Aggregate_Order_By>;
  actions_aggregate?: Maybe<Risolto_Action_Aggregate_Order_By>;
  address?: Maybe<Order_By>;
  analytics_test_results_aggregate?: Maybe<Risolto_Analytics_Test_Result_Aggregate_Order_By>;
  analytics_test_results_map?: Maybe<Order_By>;
  balance_amount?: Maybe<Order_By>;
  bank_accounts_aggregate?: Maybe<Risolto_Bank_Account_Aggregate_Order_By>;
  category?: Maybe<Order_By>;
  channel_endpoints_aggregate?: Maybe<Risolto_Channel_Endpoint_Aggregate_Order_By>;
  collections_aggregate?: Maybe<Risolto_Recipient_Collection_Aggregate_Order_By>;
  contacts_aggregate?: Maybe<Risolto_Contact_Aggregate_Order_By>;
  country_code?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  credit_limits_aggregate?: Maybe<Risolto_Credit_Limit_Aggregate_Order_By>;
  credit_notes_aggregate?: Maybe<Risolto_Credit_Note_Aggregate_Order_By>;
  currency?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  debit_notes_aggregate?: Maybe<Risolto_Debit_Note_Aggregate_Order_By>;
  document_interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Order_By>;
  due_balance_amount?: Maybe<Order_By>;
  dunning_exclude_until?: Maybe<Order_By>;
  dunning_excludes_aggregate?: Maybe<Risolto_Recipient_Dunning_Exclude_Aggregate_Order_By>;
  dunning_in_progress?: Maybe<Order_By>;
  dunning_is_dirty?: Maybe<Order_By>;
  dunning_metadata?: Maybe<Order_By>;
  dunning_notices_aggregate?: Maybe<Risolto_Dunning_Notice_Aggregate_Order_By>;
  email_addresses?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  in_collection?: Maybe<Order_By>;
  in_collection_at?: Maybe<Order_By>;
  invoice_disputes_aggregate?: Maybe<Risolto_Invoice_Dispute_Aggregate_Order_By>;
  invoice_documents_aggregate?: Maybe<Risolto_Invoice_Document_Aggregate_Order_By>;
  invoice_group_credit_notes_aggregate?: Maybe<Risolto_Invoice_Group_Credit_Note_Aggregate_Order_By>;
  invoice_group_debit_notes_aggregate?: Maybe<Risolto_Invoice_Group_Debit_Note_Aggregate_Order_By>;
  invoice_group_invoices_aggregate?: Maybe<Risolto_Invoice_Group_Invoice_Aggregate_Order_By>;
  invoice_group_payments_aggregate?: Maybe<Risolto_Invoice_Group_Payment_Aggregate_Order_By>;
  invoice_groups_aggregate?: Maybe<Risolto_Invoice_Group_Aggregate_Order_By>;
  language_code?: Maybe<Order_By>;
  last_dunning_at?: Maybe<Order_By>;
  last_dunning_costs?: Maybe<Order_By>;
  last_dunning_email_to?: Maybe<Order_By>;
  last_dunning_run_at?: Maybe<Order_By>;
  last_email_to?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  legal_id?: Maybe<Order_By>;
  legal_id_type?: Maybe<Order_By>;
  message_recipients_aggregate?: Maybe<Risolto_Message_Recipient_Aggregate_Order_By>;
  most_used_dunning_email_to?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Order_By>;
  open_balance_records_aggregate?: Maybe<Risolto_Open_Balance_Record_Aggregate_Order_By>;
  origin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_documents_aggregate?: Maybe<Risolto_Payment_Document_Aggregate_Order_By>;
  payment_plans_aggregate?: Maybe<Risolto_Payment_Plan_Aggregate_Order_By>;
  payment_promises_aggregate?: Maybe<Risolto_Payment_Promise_Aggregate_Order_By>;
  payments_aggregate?: Maybe<Risolto_Payment_Aggregate_Order_By>;
  postal_addresses?: Maybe<Order_By>;
  prediction_is_dirty?: Maybe<Order_By>;
  prediction_stars?: Maybe<Order_By>;
  preferred_invoicing_channel?: Maybe<Order_By>;
  raw_data?: Maybe<Order_By>;
  recipient_attachments_aggregate?: Maybe<Risolto_Recipient_Attachment_Aggregate_Order_By>;
  recipient_dunning_runs_aggregate?: Maybe<Risolto_Recipient_Dunning_Run_Aggregate_Order_By>;
  recipient_merge_froms_aggregate?: Maybe<Risolto_Recipient_Merge_Aggregate_Order_By>;
  recipient_merge_tos_aggregate?: Maybe<Risolto_Recipient_Merge_Aggregate_Order_By>;
  recipient_tags_aggregate?: Maybe<Risolto_Recipient_Tag_Aggregate_Order_By>;
  recipient_users_aggregate?: Maybe<Risolto_Recipient_User_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  short_code?: Maybe<Order_By>;
  statement_lines_aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Order_By>;
  tags_aggregate?: Maybe<Risolto_View_Recipient_Tag_Aggregate_Order_By>;
  telephone_numbers?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  version_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient */
export type Risolto_Recipient_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Recipient_Prepend_Input = {
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  /** null */
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  dunning_metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.recipient" */
export enum Risolto_Recipient_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Address = 'address',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DunningInProgress = 'dunning_in_progress',
  /** column name */
  DunningIsDirty = 'dunning_is_dirty',
  /** column name */
  DunningMetadata = 'dunning_metadata',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  LastDunningAt = 'last_dunning_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  LegalIdType = 'legal_id_type',
  /** column name */
  Name = 'name',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  PredictionIsDirty = 'prediction_is_dirty',
  /** column name */
  PreferredInvoicingChannel = 'preferred_invoicing_channel',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Reference = 'reference',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VersionAt = 'version_at'
}

/** select "risolto_recipient_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.recipient" */
export enum Risolto_Recipient_Select_Column_Risolto_Recipient_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DunningInProgress = 'dunning_in_progress',
  /** column name */
  DunningIsDirty = 'dunning_is_dirty',
  /** column name */
  PredictionIsDirty = 'prediction_is_dirty'
}

/** select "risolto_recipient_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.recipient" */
export enum Risolto_Recipient_Select_Column_Risolto_Recipient_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DunningInProgress = 'dunning_in_progress',
  /** column name */
  DunningIsDirty = 'dunning_is_dirty',
  /** column name */
  PredictionIsDirty = 'prediction_is_dirty'
}

/** input type for updating data in table "risolto.recipient" */
export type Risolto_Recipient_Set_Input = {
  /** Participant assigned account id (UBL: SupplierAssignedAccountID) */
  account_id?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  country_code?: Maybe<Risolto_Iso_Country_Code_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Risolto_Currency_Enum>;
  /** null */
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  dunning_in_progress?: Maybe<Scalars['Boolean']>;
  dunning_is_dirty?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED */
  dunning_metadata?: Maybe<Scalars['jsonb']>;
  /** External identifier, typically a technical id. For functional identifiers use the account_id */
  external_id?: Maybe<Scalars['String']>;
  language_code?: Maybe<Risolto_Language_Code_Enum>;
  /** Note: see also computed field 'last_dunning_run_at' (which _should_ be the same value) */
  last_dunning_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** A (legally) unique identifier for the recipient corresponding to the legal_id_type. For example: a VAT number or an ID (Identity Document) */
  legal_id?: Maybe<Scalars['String']>;
  /** The name of an identifier which uniquely identifies the recipient. For example: VAT, ID (Identity Document) */
  legal_id_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  prediction_is_dirty?: Maybe<Scalars['Boolean']>;
  preferred_invoicing_channel?: Maybe<Risolto_Channel_Enum>;
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  /** B2B | B2C */
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  version_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Recipient_Stddev_Fields = {
  __typename?: 'risolto_recipient_stddev_fields';
  balance_amount?: Maybe<Scalars['numeric']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Recipient_Stddev_Pop_Fields = {
  __typename?: 'risolto_recipient_stddev_pop_fields';
  balance_amount?: Maybe<Scalars['numeric']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Recipient_Stddev_Samp_Fields = {
  __typename?: 'risolto_recipient_stddev_samp_fields';
  balance_amount?: Maybe<Scalars['numeric']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "risolto_recipient" */
export type Risolto_Recipient_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Stream_Cursor_Value_Input = {
  /** Participant assigned account id (UBL: SupplierAssignedAccountID) */
  account_id?: Maybe<Scalars['String']>;
  /** DEPRECATED */
  address?: Maybe<Scalars['jsonb']>;
  country_code?: Maybe<Risolto_Iso_Country_Code_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Risolto_Currency_Enum>;
  /** null */
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** DEPRECATED */
  dunning_in_progress?: Maybe<Scalars['Boolean']>;
  dunning_is_dirty?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED */
  dunning_metadata?: Maybe<Scalars['jsonb']>;
  /** External identifier, typically a technical id. For functional identifiers use the account_id */
  external_id?: Maybe<Scalars['String']>;
  language_code?: Maybe<Risolto_Language_Code_Enum>;
  /** Note: see also computed field 'last_dunning_run_at' (which _should_ be the same value) */
  last_dunning_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** A (legally) unique identifier for the recipient corresponding to the legal_id_type. For example: a VAT number or an ID (Identity Document) */
  legal_id?: Maybe<Scalars['String']>;
  /** The name of an identifier which uniquely identifies the recipient. For example: VAT, ID (Identity Document) */
  legal_id_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<Risolto_Origin_Enum>;
  participant?: Maybe<Scalars['uuid']>;
  prediction_is_dirty?: Maybe<Scalars['Boolean']>;
  preferred_invoicing_channel?: Maybe<Risolto_Channel_Enum>;
  raw_data?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  /** B2B | B2C */
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  version_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Recipient_Sum_Fields = {
  __typename?: 'risolto_recipient_sum_fields';
  balance_amount?: Maybe<Scalars['numeric']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "risolto.recipient_tag" */
export type Risolto_Recipient_Tag = {
  __typename?: 'risolto_recipient_tag';
  can_remove?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  tag: Scalars['uuid'];
  /** An object relationship */
  tag_by_reference: Risolto_Tag;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Aggregate = {
  __typename?: 'risolto_recipient_tag_aggregate';
  aggregate?: Maybe<Risolto_Recipient_Tag_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_Tag>;
};

export type Risolto_Recipient_Tag_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Recipient_Tag_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Aggregate_Fields = {
  __typename?: 'risolto_recipient_tag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_Tag_Max_Fields>;
  min?: Maybe<Risolto_Recipient_Tag_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_Tag_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_Tag_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_Tag_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_tag". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_Tag_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_Tag_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_Tag_Bool_Exp>>;
  can_remove?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  tag?: Maybe<Uuid_Comparison_Exp>;
  tag_by_reference?: Maybe<Risolto_Tag_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.recipient_tag" */
export enum Risolto_Recipient_Tag_Constraint {
  /** unique or primary key constraint on columns "participant", "recipient", "tag" */
  RecipientTagParticipantRecipientTagKey = 'recipient_tag_participant_recipient_tag_key',
  /** unique or primary key constraint on columns "reference" */
  RecipientTagPkey = 'recipient_tag_pkey'
}

/** input type for inserting data into table "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  tag_by_reference?: Maybe<Risolto_Tag_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_Tag_Max_Fields = {
  __typename?: 'risolto_recipient_tag_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Recipient_Tag_Min_Fields = {
  __typename?: 'risolto_recipient_tag_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Mutation_Response = {
  __typename?: 'risolto_recipient_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_Tag>;
};

/** on_conflict condition type for table "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_On_Conflict = {
  constraint: Risolto_Recipient_Tag_Constraint;
  update_columns?: Array<Risolto_Recipient_Tag_Update_Column>;
  where?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient_tag". */
export type Risolto_Recipient_Tag_Order_By = {
  can_remove?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  tag_by_reference?: Maybe<Risolto_Tag_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient_tag */
export type Risolto_Recipient_Tag_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.recipient_tag" */
export enum Risolto_Recipient_Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.recipient_tag" */
export type Risolto_Recipient_Tag_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_recipient_tag" */
export type Risolto_Recipient_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_Tag_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.recipient_tag" */
export enum Risolto_Recipient_Tag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Recipient_Tag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Tag_Bool_Exp;
};

/** update columns of table "risolto.recipient" */
export enum Risolto_Recipient_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Address = 'address',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DunningInProgress = 'dunning_in_progress',
  /** column name */
  DunningIsDirty = 'dunning_is_dirty',
  /** column name */
  DunningMetadata = 'dunning_metadata',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  LanguageCode = 'language_code',
  /** column name */
  LastDunningAt = 'last_dunning_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  LegalIdType = 'legal_id_type',
  /** column name */
  Name = 'name',
  /** column name */
  Origin = 'origin',
  /** column name */
  Participant = 'participant',
  /** column name */
  PredictionIsDirty = 'prediction_is_dirty',
  /** column name */
  PreferredInvoicingChannel = 'preferred_invoicing_channel',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  Reference = 'reference',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VersionAt = 'version_at'
}

export type Risolto_Recipient_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Recipient_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Recipient_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Recipient_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Recipient_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Recipient_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_Bool_Exp;
};

/** columns and relationships of "risolto.recipient_user" */
export type Risolto_Recipient_User = {
  __typename?: 'risolto_recipient_user';
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  person: Scalars['uuid'];
  /** An object relationship */
  person_by_reference: Risolto_Person;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.recipient_user" */
export type Risolto_Recipient_User_Aggregate = {
  __typename?: 'risolto_recipient_user_aggregate';
  aggregate?: Maybe<Risolto_Recipient_User_Aggregate_Fields>;
  nodes: Array<Risolto_Recipient_User>;
};

export type Risolto_Recipient_User_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Recipient_User_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Recipient_User_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Recipient_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.recipient_user" */
export type Risolto_Recipient_User_Aggregate_Fields = {
  __typename?: 'risolto_recipient_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Recipient_User_Max_Fields>;
  min?: Maybe<Risolto_Recipient_User_Min_Fields>;
};


/** aggregate fields of "risolto.recipient_user" */
export type Risolto_Recipient_User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.recipient_user" */
export type Risolto_Recipient_User_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Recipient_User_Max_Order_By>;
  min?: Maybe<Risolto_Recipient_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.recipient_user" */
export type Risolto_Recipient_User_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Recipient_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Recipient_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.recipient_user". All fields are combined with a logical 'AND'. */
export type Risolto_Recipient_User_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Recipient_User_Bool_Exp>>;
  _not?: Maybe<Risolto_Recipient_User_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Recipient_User_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person?: Maybe<Uuid_Comparison_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.recipient_user" */
export enum Risolto_Recipient_User_Constraint {
  /** unique or primary key constraint on columns "reference" */
  RecipientUserPkey = 'recipient_user_pkey',
  /** unique or primary key constraint on columns "person", "recipient" */
  RecipientUserRecipientPersonKey = 'recipient_user_recipient_person_key'
}

/** input type for inserting data into table "risolto.recipient_user" */
export type Risolto_Recipient_User_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person?: Maybe<Scalars['uuid']>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Recipient_User_Max_Fields = {
  __typename?: 'risolto_recipient_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.recipient_user" */
export type Risolto_Recipient_User_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  person?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Recipient_User_Min_Fields = {
  __typename?: 'risolto_recipient_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.recipient_user" */
export type Risolto_Recipient_User_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  person?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.recipient_user" */
export type Risolto_Recipient_User_Mutation_Response = {
  __typename?: 'risolto_recipient_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Recipient_User>;
};

/** on_conflict condition type for table "risolto.recipient_user" */
export type Risolto_Recipient_User_On_Conflict = {
  constraint: Risolto_Recipient_User_Constraint;
  update_columns?: Array<Risolto_Recipient_User_Update_Column>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.recipient_user". */
export type Risolto_Recipient_User_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person?: Maybe<Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.recipient_user */
export type Risolto_Recipient_User_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.recipient_user" */
export enum Risolto_Recipient_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Person = 'person',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.recipient_user" */
export type Risolto_Recipient_User_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_recipient_user" */
export type Risolto_Recipient_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Recipient_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Recipient_User_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.recipient_user" */
export enum Risolto_Recipient_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Person = 'person',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Recipient_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Recipient_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Recipient_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Recipient_Var_Pop_Fields = {
  __typename?: 'risolto_recipient_var_pop_fields';
  balance_amount?: Maybe<Scalars['numeric']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** aggregate var_samp on columns */
export type Risolto_Recipient_Var_Samp_Fields = {
  __typename?: 'risolto_recipient_var_samp_fields';
  balance_amount?: Maybe<Scalars['numeric']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** aggregate variance on columns */
export type Risolto_Recipient_Variance_Fields = {
  __typename?: 'risolto_recipient_variance_fields';
  balance_amount?: Maybe<Scalars['numeric']>;
  due_balance_amount?: Maybe<Scalars['numeric']>;
  last_dunning_costs?: Maybe<Scalars['numeric']>;
  prediction_stars?: Maybe<Scalars['numeric']>;
};

/** Customer reference data */
export type Risolto_Reference_Data = {
  __typename?: 'risolto_reference_data';
  created_at: Scalars['timestamptz'];
  key: Scalars['String'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  reference_data: Scalars['jsonb'];
  reference_data_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** Customer reference data */
export type Risolto_Reference_DataReference_DataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.reference_data" */
export type Risolto_Reference_Data_Aggregate = {
  __typename?: 'risolto_reference_data_aggregate';
  aggregate?: Maybe<Risolto_Reference_Data_Aggregate_Fields>;
  nodes: Array<Risolto_Reference_Data>;
};

/** aggregate fields of "risolto.reference_data" */
export type Risolto_Reference_Data_Aggregate_Fields = {
  __typename?: 'risolto_reference_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Reference_Data_Max_Fields>;
  min?: Maybe<Risolto_Reference_Data_Min_Fields>;
};


/** aggregate fields of "risolto.reference_data" */
export type Risolto_Reference_Data_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Reference_Data_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Reference_Data_Append_Input = {
  reference_data?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.reference_data". All fields are combined with a logical 'AND'. */
export type Risolto_Reference_Data_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Reference_Data_Bool_Exp>>;
  _not?: Maybe<Risolto_Reference_Data_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Reference_Data_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  reference_data?: Maybe<Jsonb_Comparison_Exp>;
  reference_data_type?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.reference_data" */
export enum Risolto_Reference_Data_Constraint {
  /** unique or primary key constraint on columns "key", "reference_data_type", "legal_entity" */
  ReferenceDataLegalEntityReferenceDataTypeKeyKey = 'reference_data_legal_entity_reference_data_type_key_key',
  /** unique or primary key constraint on columns "key", "participant", "reference_data_type" */
  ReferenceDataParticipantReferenceDataTypeKeyKey = 'reference_data_participant_reference_data_type_key_key',
  /** unique or primary key constraint on columns "reference" */
  ReferenceDataPkey = 'reference_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Reference_Data_Delete_At_Path_Input = {
  reference_data?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Reference_Data_Delete_Elem_Input = {
  reference_data?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Reference_Data_Delete_Key_Input = {
  reference_data?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.reference_data" */
export type Risolto_Reference_Data_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  reference_data?: Maybe<Scalars['jsonb']>;
  reference_data_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Reference_Data_Max_Fields = {
  __typename?: 'risolto_reference_data_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  reference_data_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Reference_Data_Min_Fields = {
  __typename?: 'risolto_reference_data_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  reference_data_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.reference_data" */
export type Risolto_Reference_Data_Mutation_Response = {
  __typename?: 'risolto_reference_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Reference_Data>;
};

/** on_conflict condition type for table "risolto.reference_data" */
export type Risolto_Reference_Data_On_Conflict = {
  constraint: Risolto_Reference_Data_Constraint;
  update_columns?: Array<Risolto_Reference_Data_Update_Column>;
  where?: Maybe<Risolto_Reference_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.reference_data". */
export type Risolto_Reference_Data_Order_By = {
  created_at?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  reference_data?: Maybe<Order_By>;
  reference_data_type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.reference_data */
export type Risolto_Reference_Data_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Reference_Data_Prepend_Input = {
  reference_data?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.reference_data" */
export enum Risolto_Reference_Data_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Key = 'key',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReferenceData = 'reference_data',
  /** column name */
  ReferenceDataType = 'reference_data_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.reference_data" */
export type Risolto_Reference_Data_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  reference_data?: Maybe<Scalars['jsonb']>;
  reference_data_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_reference_data" */
export type Risolto_Reference_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Reference_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Reference_Data_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  key?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  reference_data?: Maybe<Scalars['jsonb']>;
  reference_data_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.reference_data" */
export enum Risolto_Reference_Data_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Key = 'key',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReferenceData = 'reference_data',
  /** column name */
  ReferenceDataType = 'reference_data_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Reference_Data_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Reference_Data_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Reference_Data_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Reference_Data_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Reference_Data_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Reference_Data_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Reference_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Reference_Data_Bool_Exp;
};

export type Risolto_Report_Action_Events_Args = {
  q_legal_entity?: Maybe<Scalars['uuid']>;
  q_month?: Maybe<Scalars['Int']>;
  q_participant?: Maybe<Scalars['uuid']>;
};

export type Risolto_Report_Action_Events_V2_Args = {
  q_legal_entity?: Maybe<Scalars['uuid']>;
  q_month?: Maybe<Scalars['Int']>;
  q_participant?: Maybe<Scalars['uuid']>;
  q_year?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "risolto.report_definition" */
export type Risolto_Report_Definition = {
  __typename?: 'risolto_report_definition';
  configuration?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  email_template_path?: Maybe<Scalars['String']>;
  frequency: Risolto_Frequency_Enum;
  frequency_expression?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  owner_by_reference?: Maybe<Risolto_Person>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  reference: Scalars['uuid'];
  /** An array relationship */
  report_executions: Array<Risolto_Report_Execution>;
  /** An aggregate relationship */
  report_executions_aggregate: Risolto_Report_Execution_Aggregate;
  report_id: Scalars['String'];
  report_template_path?: Maybe<Scalars['String']>;
  report_template_type?: Maybe<Risolto_Report_Template_Type_Enum>;
  report_type: Risolto_Report_Type_Enum;
  /** An array relationship */
  report_users: Array<Risolto_Report_User>;
  /** An aggregate relationship */
  report_users_aggregate: Risolto_Report_User_Aggregate;
  should_run?: Maybe<Scalars['Boolean']>;
  sql: Scalars['String'];
  transformer?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.report_definition" */
export type Risolto_Report_DefinitionConfigurationArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.report_definition" */
export type Risolto_Report_DefinitionReport_ExecutionsArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_Bool_Exp>;
};


/** columns and relationships of "risolto.report_definition" */
export type Risolto_Report_DefinitionReport_Executions_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_Bool_Exp>;
};


/** columns and relationships of "risolto.report_definition" */
export type Risolto_Report_DefinitionReport_UsersArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_User_Order_By>>;
  where?: Maybe<Risolto_Report_User_Bool_Exp>;
};


/** columns and relationships of "risolto.report_definition" */
export type Risolto_Report_DefinitionReport_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_User_Order_By>>;
  where?: Maybe<Risolto_Report_User_Bool_Exp>;
};

/** aggregated selection of "risolto.report_definition" */
export type Risolto_Report_Definition_Aggregate = {
  __typename?: 'risolto_report_definition_aggregate';
  aggregate?: Maybe<Risolto_Report_Definition_Aggregate_Fields>;
  nodes: Array<Risolto_Report_Definition>;
};

/** aggregate fields of "risolto.report_definition" */
export type Risolto_Report_Definition_Aggregate_Fields = {
  __typename?: 'risolto_report_definition_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Report_Definition_Max_Fields>;
  min?: Maybe<Risolto_Report_Definition_Min_Fields>;
};


/** aggregate fields of "risolto.report_definition" */
export type Risolto_Report_Definition_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Report_Definition_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Report_Definition_Append_Input = {
  configuration?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.report_definition". All fields are combined with a logical 'AND'. */
export type Risolto_Report_Definition_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Report_Definition_Bool_Exp>>;
  _not?: Maybe<Risolto_Report_Definition_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Report_Definition_Bool_Exp>>;
  configuration?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email_template_path?: Maybe<String_Comparison_Exp>;
  frequency?: Maybe<Risolto_Frequency_Enum_Comparison_Exp>;
  frequency_expression?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  owner?: Maybe<Uuid_Comparison_Exp>;
  owner_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  report_executions?: Maybe<Risolto_Report_Execution_Bool_Exp>;
  report_executions_aggregate?: Maybe<Risolto_Report_Execution_Aggregate_Bool_Exp>;
  report_id?: Maybe<String_Comparison_Exp>;
  report_template_path?: Maybe<String_Comparison_Exp>;
  report_template_type?: Maybe<Risolto_Report_Template_Type_Enum_Comparison_Exp>;
  report_type?: Maybe<Risolto_Report_Type_Enum_Comparison_Exp>;
  report_users?: Maybe<Risolto_Report_User_Bool_Exp>;
  report_users_aggregate?: Maybe<Risolto_Report_User_Aggregate_Bool_Exp>;
  should_run?: Maybe<Boolean_Comparison_Exp>;
  sql?: Maybe<String_Comparison_Exp>;
  transformer?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.report_definition" */
export enum Risolto_Report_Definition_Constraint {
  /** unique or primary key constraint on columns "name" */
  ReportDefinitionNameKey = 'report_definition_name_key',
  /** unique or primary key constraint on columns "reference" */
  ReportDefinitionPkey = 'report_definition_pkey',
  /** unique or primary key constraint on columns "report_id" */
  ReportDefinitionReportIdKey = 'report_definition_report_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Report_Definition_Delete_At_Path_Input = {
  configuration?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Report_Definition_Delete_Elem_Input = {
  configuration?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Report_Definition_Delete_Key_Input = {
  configuration?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.report_definition" */
export type Risolto_Report_Definition_Insert_Input = {
  configuration?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_template_path?: Maybe<Scalars['String']>;
  frequency?: Maybe<Risolto_Frequency_Enum>;
  frequency_expression?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  owner_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  report_executions?: Maybe<Risolto_Report_Execution_Arr_Rel_Insert_Input>;
  report_id?: Maybe<Scalars['String']>;
  report_template_path?: Maybe<Scalars['String']>;
  report_template_type?: Maybe<Risolto_Report_Template_Type_Enum>;
  report_type?: Maybe<Risolto_Report_Type_Enum>;
  report_users?: Maybe<Risolto_Report_User_Arr_Rel_Insert_Input>;
  sql?: Maybe<Scalars['String']>;
  transformer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Report_Definition_Max_Fields = {
  __typename?: 'risolto_report_definition_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email_template_path?: Maybe<Scalars['String']>;
  frequency_expression?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['String']>;
  report_template_path?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
  transformer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Report_Definition_Min_Fields = {
  __typename?: 'risolto_report_definition_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email_template_path?: Maybe<Scalars['String']>;
  frequency_expression?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['String']>;
  report_template_path?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
  transformer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.report_definition" */
export type Risolto_Report_Definition_Mutation_Response = {
  __typename?: 'risolto_report_definition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Report_Definition>;
};

/** input type for inserting object relation for remote table "risolto.report_definition" */
export type Risolto_Report_Definition_Obj_Rel_Insert_Input = {
  data: Risolto_Report_Definition_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Report_Definition_On_Conflict>;
};

/** on_conflict condition type for table "risolto.report_definition" */
export type Risolto_Report_Definition_On_Conflict = {
  constraint: Risolto_Report_Definition_Constraint;
  update_columns?: Array<Risolto_Report_Definition_Update_Column>;
  where?: Maybe<Risolto_Report_Definition_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.report_definition". */
export type Risolto_Report_Definition_Order_By = {
  configuration?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email_template_path?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  frequency_expression?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  owner?: Maybe<Order_By>;
  owner_by_reference?: Maybe<Risolto_Person_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  report_executions_aggregate?: Maybe<Risolto_Report_Execution_Aggregate_Order_By>;
  report_id?: Maybe<Order_By>;
  report_template_path?: Maybe<Order_By>;
  report_template_type?: Maybe<Order_By>;
  report_type?: Maybe<Order_By>;
  report_users_aggregate?: Maybe<Risolto_Report_User_Aggregate_Order_By>;
  should_run?: Maybe<Order_By>;
  sql?: Maybe<Order_By>;
  transformer?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.report_definition */
export type Risolto_Report_Definition_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Report_Definition_Prepend_Input = {
  configuration?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.report_definition" */
export enum Risolto_Report_Definition_Select_Column {
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailTemplatePath = 'email_template_path',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  FrequencyExpression = 'frequency_expression',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ReportTemplatePath = 'report_template_path',
  /** column name */
  ReportTemplateType = 'report_template_type',
  /** column name */
  ReportType = 'report_type',
  /** column name */
  Sql = 'sql',
  /** column name */
  Transformer = 'transformer',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.report_definition" */
export type Risolto_Report_Definition_Set_Input = {
  configuration?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_template_path?: Maybe<Scalars['String']>;
  frequency?: Maybe<Risolto_Frequency_Enum>;
  frequency_expression?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['String']>;
  report_template_path?: Maybe<Scalars['String']>;
  report_template_type?: Maybe<Risolto_Report_Template_Type_Enum>;
  report_type?: Maybe<Risolto_Report_Type_Enum>;
  sql?: Maybe<Scalars['String']>;
  transformer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_report_definition" */
export type Risolto_Report_Definition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Report_Definition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Report_Definition_Stream_Cursor_Value_Input = {
  configuration?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_template_path?: Maybe<Scalars['String']>;
  frequency?: Maybe<Risolto_Frequency_Enum>;
  frequency_expression?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['String']>;
  report_template_path?: Maybe<Scalars['String']>;
  report_template_type?: Maybe<Risolto_Report_Template_Type_Enum>;
  report_type?: Maybe<Risolto_Report_Type_Enum>;
  sql?: Maybe<Scalars['String']>;
  transformer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.report_definition" */
export enum Risolto_Report_Definition_Update_Column {
  /** column name */
  Configuration = 'configuration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailTemplatePath = 'email_template_path',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  FrequencyExpression = 'frequency_expression',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ReportTemplatePath = 'report_template_path',
  /** column name */
  ReportTemplateType = 'report_template_type',
  /** column name */
  ReportType = 'report_type',
  /** column name */
  Sql = 'sql',
  /** column name */
  Transformer = 'transformer',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Report_Definition_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Report_Definition_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Report_Definition_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Report_Definition_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Report_Definition_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Report_Definition_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Report_Definition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Report_Definition_Bool_Exp;
};

/** columns and relationships of "risolto.report_execution" */
export type Risolto_Report_Execution = {
  __typename?: 'risolto_report_execution';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  report_definition: Scalars['uuid'];
  /** An object relationship */
  report_definition_by_reference: Risolto_Report_Definition;
  report_path?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.report_execution" */
export type Risolto_Report_Execution_Aggregate = {
  __typename?: 'risolto_report_execution_aggregate';
  aggregate?: Maybe<Risolto_Report_Execution_Aggregate_Fields>;
  nodes: Array<Risolto_Report_Execution>;
};

export type Risolto_Report_Execution_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Report_Execution_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Report_Execution_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Report_Execution_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Report_Execution_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.report_execution" */
export type Risolto_Report_Execution_Aggregate_Fields = {
  __typename?: 'risolto_report_execution_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Report_Execution_Max_Fields>;
  min?: Maybe<Risolto_Report_Execution_Min_Fields>;
};


/** aggregate fields of "risolto.report_execution" */
export type Risolto_Report_Execution_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Report_Execution_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.report_execution" */
export type Risolto_Report_Execution_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Report_Execution_Max_Order_By>;
  min?: Maybe<Risolto_Report_Execution_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.report_execution" */
export type Risolto_Report_Execution_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Report_Execution_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Report_Execution_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.report_execution". All fields are combined with a logical 'AND'. */
export type Risolto_Report_Execution_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Report_Execution_Bool_Exp>>;
  _not?: Maybe<Risolto_Report_Execution_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Report_Execution_Bool_Exp>>;
  completed_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  report_definition?: Maybe<Uuid_Comparison_Exp>;
  report_definition_by_reference?: Maybe<Risolto_Report_Definition_Bool_Exp>;
  report_path?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.report_execution" */
export enum Risolto_Report_Execution_Constraint {
  /** unique or primary key constraint on columns "reference" */
  ReportExecutionPkey = 'report_execution_pkey'
}

/** input type for inserting data into table "risolto.report_execution" */
export type Risolto_Report_Execution_Insert_Input = {
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  report_definition_by_reference?: Maybe<Risolto_Report_Definition_Obj_Rel_Insert_Input>;
  report_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Report_Execution_Max_Fields = {
  __typename?: 'risolto_report_execution_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  report_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.report_execution" */
export type Risolto_Report_Execution_Max_Order_By = {
  completed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  report_definition?: Maybe<Order_By>;
  report_path?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Report_Execution_Min_Fields = {
  __typename?: 'risolto_report_execution_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  report_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.report_execution" */
export type Risolto_Report_Execution_Min_Order_By = {
  completed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  report_definition?: Maybe<Order_By>;
  report_path?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.report_execution" */
export type Risolto_Report_Execution_Mutation_Response = {
  __typename?: 'risolto_report_execution_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Report_Execution>;
};

/** input type for inserting object relation for remote table "risolto.report_execution" */
export type Risolto_Report_Execution_Obj_Rel_Insert_Input = {
  data: Risolto_Report_Execution_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Report_Execution_On_Conflict>;
};

/** on_conflict condition type for table "risolto.report_execution" */
export type Risolto_Report_Execution_On_Conflict = {
  constraint: Risolto_Report_Execution_Constraint;
  update_columns?: Array<Risolto_Report_Execution_Update_Column>;
  where?: Maybe<Risolto_Report_Execution_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.report_execution". */
export type Risolto_Report_Execution_Order_By = {
  completed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  report_definition?: Maybe<Order_By>;
  report_definition_by_reference?: Maybe<Risolto_Report_Definition_Order_By>;
  report_path?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.report_execution */
export type Risolto_Report_Execution_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.report_execution" */
export enum Risolto_Report_Execution_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReportDefinition = 'report_definition',
  /** column name */
  ReportPath = 'report_path',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.report_execution" */
export type Risolto_Report_Execution_Set_Input = {
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  report_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_report_execution" */
export type Risolto_Report_Execution_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Report_Execution_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Report_Execution_Stream_Cursor_Value_Input = {
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  report_path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.report_execution" */
export enum Risolto_Report_Execution_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReportDefinition = 'report_definition',
  /** column name */
  ReportPath = 'report_path',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Report_Execution_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Report_Execution_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Report_Execution_Bool_Exp;
};

/** columns and relationships of "risolto.report_execution_user" */
export type Risolto_Report_Execution_User = {
  __typename?: 'risolto_report_execution_user';
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  person: Scalars['uuid'];
  /** An object relationship */
  person_by_reference: Risolto_Person;
  reference: Scalars['uuid'];
  report_execution: Scalars['uuid'];
  /** An object relationship */
  report_execution_by_reference: Risolto_Report_Execution;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.report_execution_user" */
export type Risolto_Report_Execution_User_Aggregate = {
  __typename?: 'risolto_report_execution_user_aggregate';
  aggregate?: Maybe<Risolto_Report_Execution_User_Aggregate_Fields>;
  nodes: Array<Risolto_Report_Execution_User>;
};

/** aggregate fields of "risolto.report_execution_user" */
export type Risolto_Report_Execution_User_Aggregate_Fields = {
  __typename?: 'risolto_report_execution_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Report_Execution_User_Max_Fields>;
  min?: Maybe<Risolto_Report_Execution_User_Min_Fields>;
};


/** aggregate fields of "risolto.report_execution_user" */
export type Risolto_Report_Execution_User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Report_Execution_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.report_execution_user". All fields are combined with a logical 'AND'. */
export type Risolto_Report_Execution_User_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Report_Execution_User_Bool_Exp>>;
  _not?: Maybe<Risolto_Report_Execution_User_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Report_Execution_User_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person?: Maybe<Uuid_Comparison_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  report_execution?: Maybe<Uuid_Comparison_Exp>;
  report_execution_by_reference?: Maybe<Risolto_Report_Execution_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.report_execution_user" */
export enum Risolto_Report_Execution_User_Constraint {
  /** unique or primary key constraint on columns "participant", "person", "report_execution" */
  ReportExecutionUserParticipantPersonReportExecutionKey = 'report_execution_user_participant_person_report_execution_key',
  /** unique or primary key constraint on columns "reference" */
  ReportExecutionUserPkey = 'report_execution_user_pkey'
}

/** input type for inserting data into table "risolto.report_execution_user" */
export type Risolto_Report_Execution_User_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person?: Maybe<Scalars['uuid']>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  report_execution?: Maybe<Scalars['uuid']>;
  report_execution_by_reference?: Maybe<Risolto_Report_Execution_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Report_Execution_User_Max_Fields = {
  __typename?: 'risolto_report_execution_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_execution?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Report_Execution_User_Min_Fields = {
  __typename?: 'risolto_report_execution_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_execution?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.report_execution_user" */
export type Risolto_Report_Execution_User_Mutation_Response = {
  __typename?: 'risolto_report_execution_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Report_Execution_User>;
};

/** on_conflict condition type for table "risolto.report_execution_user" */
export type Risolto_Report_Execution_User_On_Conflict = {
  constraint: Risolto_Report_Execution_User_Constraint;
  update_columns?: Array<Risolto_Report_Execution_User_Update_Column>;
  where?: Maybe<Risolto_Report_Execution_User_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.report_execution_user". */
export type Risolto_Report_Execution_User_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person?: Maybe<Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  reference?: Maybe<Order_By>;
  report_execution?: Maybe<Order_By>;
  report_execution_by_reference?: Maybe<Risolto_Report_Execution_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.report_execution_user */
export type Risolto_Report_Execution_User_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.report_execution_user" */
export enum Risolto_Report_Execution_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Person = 'person',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReportExecution = 'report_execution',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.report_execution_user" */
export type Risolto_Report_Execution_User_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_execution?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_report_execution_user" */
export type Risolto_Report_Execution_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Report_Execution_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Report_Execution_User_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  person?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_execution?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.report_execution_user" */
export enum Risolto_Report_Execution_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Person = 'person',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReportExecution = 'report_execution',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Report_Execution_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Report_Execution_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Report_Execution_User_Bool_Exp;
};

export type Risolto_Report_Monthly_Delivery_V1_Args = {
  q_legal_entity?: Maybe<Scalars['uuid']>;
  q_month?: Maybe<Scalars['Int']>;
  q_participant?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "risolto.report_template_type" */
export type Risolto_Report_Template_Type = {
  __typename?: 'risolto_report_template_type';
  report_template_type: Scalars['String'];
};

/** aggregated selection of "risolto.report_template_type" */
export type Risolto_Report_Template_Type_Aggregate = {
  __typename?: 'risolto_report_template_type_aggregate';
  aggregate?: Maybe<Risolto_Report_Template_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Report_Template_Type>;
};

/** aggregate fields of "risolto.report_template_type" */
export type Risolto_Report_Template_Type_Aggregate_Fields = {
  __typename?: 'risolto_report_template_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Report_Template_Type_Max_Fields>;
  min?: Maybe<Risolto_Report_Template_Type_Min_Fields>;
};


/** aggregate fields of "risolto.report_template_type" */
export type Risolto_Report_Template_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Report_Template_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.report_template_type". All fields are combined with a logical 'AND'. */
export type Risolto_Report_Template_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Report_Template_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Report_Template_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Report_Template_Type_Bool_Exp>>;
  report_template_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.report_template_type" */
export enum Risolto_Report_Template_Type_Constraint {
  /** unique or primary key constraint on columns "report_template_type" */
  ReportTemplateTypePkey = 'report_template_type_pkey'
}

export enum Risolto_Report_Template_Type_Enum {
  Csv = 'CSV',
  Html = 'HTML',
  Xlsx = 'XLSX'
}

/** Boolean expression to compare columns of type "risolto_report_template_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Report_Template_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Report_Template_Type_Enum>;
  _in?: Maybe<Array<Risolto_Report_Template_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Report_Template_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Report_Template_Type_Enum>>;
};

/** input type for inserting data into table "risolto.report_template_type" */
export type Risolto_Report_Template_Type_Insert_Input = {
  report_template_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Report_Template_Type_Max_Fields = {
  __typename?: 'risolto_report_template_type_max_fields';
  report_template_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Report_Template_Type_Min_Fields = {
  __typename?: 'risolto_report_template_type_min_fields';
  report_template_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.report_template_type" */
export type Risolto_Report_Template_Type_Mutation_Response = {
  __typename?: 'risolto_report_template_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Report_Template_Type>;
};

/** on_conflict condition type for table "risolto.report_template_type" */
export type Risolto_Report_Template_Type_On_Conflict = {
  constraint: Risolto_Report_Template_Type_Constraint;
  update_columns?: Array<Risolto_Report_Template_Type_Update_Column>;
  where?: Maybe<Risolto_Report_Template_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.report_template_type". */
export type Risolto_Report_Template_Type_Order_By = {
  report_template_type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.report_template_type */
export type Risolto_Report_Template_Type_Pk_Columns_Input = {
  report_template_type: Scalars['String'];
};

/** select columns of table "risolto.report_template_type" */
export enum Risolto_Report_Template_Type_Select_Column {
  /** column name */
  ReportTemplateType = 'report_template_type'
}

/** input type for updating data in table "risolto.report_template_type" */
export type Risolto_Report_Template_Type_Set_Input = {
  report_template_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_report_template_type" */
export type Risolto_Report_Template_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Report_Template_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Report_Template_Type_Stream_Cursor_Value_Input = {
  report_template_type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.report_template_type" */
export enum Risolto_Report_Template_Type_Update_Column {
  /** column name */
  ReportTemplateType = 'report_template_type'
}

export type Risolto_Report_Template_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Report_Template_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Report_Template_Type_Bool_Exp;
};

/** columns and relationships of "risolto.report_type" */
export type Risolto_Report_Type = {
  __typename?: 'risolto_report_type';
  report_type: Scalars['String'];
};

/** aggregated selection of "risolto.report_type" */
export type Risolto_Report_Type_Aggregate = {
  __typename?: 'risolto_report_type_aggregate';
  aggregate?: Maybe<Risolto_Report_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Report_Type>;
};

/** aggregate fields of "risolto.report_type" */
export type Risolto_Report_Type_Aggregate_Fields = {
  __typename?: 'risolto_report_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Report_Type_Max_Fields>;
  min?: Maybe<Risolto_Report_Type_Min_Fields>;
};


/** aggregate fields of "risolto.report_type" */
export type Risolto_Report_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Report_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.report_type". All fields are combined with a logical 'AND'. */
export type Risolto_Report_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Report_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Report_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Report_Type_Bool_Exp>>;
  report_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.report_type" */
export enum Risolto_Report_Type_Constraint {
  /** unique or primary key constraint on columns "report_type" */
  ReportTypePkey = 'report_type_pkey'
}

export enum Risolto_Report_Type_Enum {
  LegalEntity = 'LEGAL_ENTITY',
  Participant = 'PARTICIPANT',
  ParticipantUser = 'PARTICIPANT_USER'
}

/** Boolean expression to compare columns of type "risolto_report_type_enum". All fields are combined with logical 'AND'. */
export type Risolto_Report_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Report_Type_Enum>;
  _in?: Maybe<Array<Risolto_Report_Type_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Report_Type_Enum>;
  _nin?: Maybe<Array<Risolto_Report_Type_Enum>>;
};

/** input type for inserting data into table "risolto.report_type" */
export type Risolto_Report_Type_Insert_Input = {
  report_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Report_Type_Max_Fields = {
  __typename?: 'risolto_report_type_max_fields';
  report_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Report_Type_Min_Fields = {
  __typename?: 'risolto_report_type_min_fields';
  report_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.report_type" */
export type Risolto_Report_Type_Mutation_Response = {
  __typename?: 'risolto_report_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Report_Type>;
};

/** on_conflict condition type for table "risolto.report_type" */
export type Risolto_Report_Type_On_Conflict = {
  constraint: Risolto_Report_Type_Constraint;
  update_columns?: Array<Risolto_Report_Type_Update_Column>;
  where?: Maybe<Risolto_Report_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.report_type". */
export type Risolto_Report_Type_Order_By = {
  report_type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.report_type */
export type Risolto_Report_Type_Pk_Columns_Input = {
  report_type: Scalars['String'];
};

/** select columns of table "risolto.report_type" */
export enum Risolto_Report_Type_Select_Column {
  /** column name */
  ReportType = 'report_type'
}

/** input type for updating data in table "risolto.report_type" */
export type Risolto_Report_Type_Set_Input = {
  report_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_report_type" */
export type Risolto_Report_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Report_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Report_Type_Stream_Cursor_Value_Input = {
  report_type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.report_type" */
export enum Risolto_Report_Type_Update_Column {
  /** column name */
  ReportType = 'report_type'
}

export type Risolto_Report_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Report_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Report_Type_Bool_Exp;
};

/** columns and relationships of "risolto.report_user" */
export type Risolto_Report_User = {
  __typename?: 'risolto_report_user';
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  participant_user: Scalars['uuid'];
  /** An object relationship */
  participant_user_by_reference: Risolto_Participant_User;
  reference: Scalars['uuid'];
  report_definition: Scalars['uuid'];
  /** An object relationship */
  report_definition_by_reference: Risolto_Report_Definition;
  skip_no_data?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.report_user" */
export type Risolto_Report_User_Aggregate = {
  __typename?: 'risolto_report_user_aggregate';
  aggregate?: Maybe<Risolto_Report_User_Aggregate_Fields>;
  nodes: Array<Risolto_Report_User>;
};

export type Risolto_Report_User_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Report_User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Report_User_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Report_User_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Report_User_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Report_User_Select_Column_Risolto_Report_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Report_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Report_User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Report_User_Select_Column_Risolto_Report_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Report_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Report_User_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Report_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Report_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.report_user" */
export type Risolto_Report_User_Aggregate_Fields = {
  __typename?: 'risolto_report_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Report_User_Max_Fields>;
  min?: Maybe<Risolto_Report_User_Min_Fields>;
};


/** aggregate fields of "risolto.report_user" */
export type Risolto_Report_User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Report_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.report_user" */
export type Risolto_Report_User_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Report_User_Max_Order_By>;
  min?: Maybe<Risolto_Report_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.report_user" */
export type Risolto_Report_User_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Report_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Report_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.report_user". All fields are combined with a logical 'AND'. */
export type Risolto_Report_User_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Report_User_Bool_Exp>>;
  _not?: Maybe<Risolto_Report_User_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Report_User_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  participant_user?: Maybe<Uuid_Comparison_Exp>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  report_definition?: Maybe<Uuid_Comparison_Exp>;
  report_definition_by_reference?: Maybe<Risolto_Report_Definition_Bool_Exp>;
  skip_no_data?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.report_user" */
export enum Risolto_Report_User_Constraint {
  /** unique or primary key constraint on columns "participant", "participant_user", "report_definition" */
  ReportUserParticipantParticipantUserReportDefinitionKey = 'report_user_participant_participant_user_report_definition_key',
  /** unique or primary key constraint on columns "reference" */
  ReportUserPkey = 'report_user_pkey'
}

/** input type for inserting data into table "risolto.report_user" */
export type Risolto_Report_User_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  participant_user?: Maybe<Scalars['uuid']>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  report_definition_by_reference?: Maybe<Risolto_Report_Definition_Obj_Rel_Insert_Input>;
  skip_no_data?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Report_User_Max_Fields = {
  __typename?: 'risolto_report_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.report_user" */
export type Risolto_Report_User_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_user?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  report_definition?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Report_User_Min_Fields = {
  __typename?: 'risolto_report_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.report_user" */
export type Risolto_Report_User_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_user?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  report_definition?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.report_user" */
export type Risolto_Report_User_Mutation_Response = {
  __typename?: 'risolto_report_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Report_User>;
};

/** on_conflict condition type for table "risolto.report_user" */
export type Risolto_Report_User_On_Conflict = {
  constraint: Risolto_Report_User_Constraint;
  update_columns?: Array<Risolto_Report_User_Update_Column>;
  where?: Maybe<Risolto_Report_User_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.report_user". */
export type Risolto_Report_User_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  participant_user?: Maybe<Order_By>;
  participant_user_by_reference?: Maybe<Risolto_Participant_User_Order_By>;
  reference?: Maybe<Order_By>;
  report_definition?: Maybe<Order_By>;
  report_definition_by_reference?: Maybe<Risolto_Report_Definition_Order_By>;
  skip_no_data?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.report_user */
export type Risolto_Report_User_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.report_user" */
export enum Risolto_Report_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReportDefinition = 'report_definition',
  /** column name */
  SkipNoData = 'skip_no_data',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_report_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.report_user" */
export enum Risolto_Report_User_Select_Column_Risolto_Report_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SkipNoData = 'skip_no_data'
}

/** select "risolto_report_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.report_user" */
export enum Risolto_Report_User_Select_Column_Risolto_Report_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SkipNoData = 'skip_no_data'
}

/** input type for updating data in table "risolto.report_user" */
export type Risolto_Report_User_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  skip_no_data?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_report_user" */
export type Risolto_Report_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Report_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Report_User_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  report_definition?: Maybe<Scalars['uuid']>;
  skip_no_data?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.report_user" */
export enum Risolto_Report_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReportDefinition = 'report_definition',
  /** column name */
  SkipNoData = 'skip_no_data',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Report_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Report_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Report_User_Bool_Exp;
};

/** columns and relationships of "risolto.run_processing_status" */
export type Risolto_Run_Processing_Status = {
  __typename?: 'risolto_run_processing_status';
  processing_status: Scalars['String'];
};

/** aggregated selection of "risolto.run_processing_status" */
export type Risolto_Run_Processing_Status_Aggregate = {
  __typename?: 'risolto_run_processing_status_aggregate';
  aggregate?: Maybe<Risolto_Run_Processing_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Run_Processing_Status>;
};

/** aggregate fields of "risolto.run_processing_status" */
export type Risolto_Run_Processing_Status_Aggregate_Fields = {
  __typename?: 'risolto_run_processing_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Run_Processing_Status_Max_Fields>;
  min?: Maybe<Risolto_Run_Processing_Status_Min_Fields>;
};


/** aggregate fields of "risolto.run_processing_status" */
export type Risolto_Run_Processing_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Run_Processing_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.run_processing_status". All fields are combined with a logical 'AND'. */
export type Risolto_Run_Processing_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Run_Processing_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Run_Processing_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Run_Processing_Status_Bool_Exp>>;
  processing_status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.run_processing_status" */
export enum Risolto_Run_Processing_Status_Constraint {
  /** unique or primary key constraint on columns "processing_status" */
  RunProcessingStatusPkey = 'run_processing_status_pkey'
}

export enum Risolto_Run_Processing_Status_Enum {
  '100Started' = '_100_STARTED',
  '200Done' = '_200_DONE'
}

/** Boolean expression to compare columns of type "risolto_run_processing_status_enum". All fields are combined with logical 'AND'. */
export type Risolto_Run_Processing_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Run_Processing_Status_Enum>;
  _in?: Maybe<Array<Risolto_Run_Processing_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Run_Processing_Status_Enum>;
  _nin?: Maybe<Array<Risolto_Run_Processing_Status_Enum>>;
};

/** input type for inserting data into table "risolto.run_processing_status" */
export type Risolto_Run_Processing_Status_Insert_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Run_Processing_Status_Max_Fields = {
  __typename?: 'risolto_run_processing_status_max_fields';
  processing_status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Run_Processing_Status_Min_Fields = {
  __typename?: 'risolto_run_processing_status_min_fields';
  processing_status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.run_processing_status" */
export type Risolto_Run_Processing_Status_Mutation_Response = {
  __typename?: 'risolto_run_processing_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Run_Processing_Status>;
};

/** on_conflict condition type for table "risolto.run_processing_status" */
export type Risolto_Run_Processing_Status_On_Conflict = {
  constraint: Risolto_Run_Processing_Status_Constraint;
  update_columns?: Array<Risolto_Run_Processing_Status_Update_Column>;
  where?: Maybe<Risolto_Run_Processing_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.run_processing_status". */
export type Risolto_Run_Processing_Status_Order_By = {
  processing_status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.run_processing_status */
export type Risolto_Run_Processing_Status_Pk_Columns_Input = {
  processing_status: Scalars['String'];
};

/** select columns of table "risolto.run_processing_status" */
export enum Risolto_Run_Processing_Status_Select_Column {
  /** column name */
  ProcessingStatus = 'processing_status'
}

/** input type for updating data in table "risolto.run_processing_status" */
export type Risolto_Run_Processing_Status_Set_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_run_processing_status" */
export type Risolto_Run_Processing_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Run_Processing_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Run_Processing_Status_Stream_Cursor_Value_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.run_processing_status" */
export enum Risolto_Run_Processing_Status_Update_Column {
  /** column name */
  ProcessingStatus = 'processing_status'
}

export type Risolto_Run_Processing_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Run_Processing_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Run_Processing_Status_Bool_Exp;
};

export type Risolto_Search2recid_Args = {
  company_id?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

/** Single Sign On Configuration table */
export type Risolto_Single_Sign_On = {
  __typename?: 'risolto_single_sign_on';
  created_at: Scalars['timestamptz'];
  custom_fields?: Maybe<Scalars['jsonb']>;
  domain: Scalars['String'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** Single Sign On Configuration table */
export type Risolto_Single_Sign_OnCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Aggregate = {
  __typename?: 'risolto_single_sign_on_aggregate';
  aggregate?: Maybe<Risolto_Single_Sign_On_Aggregate_Fields>;
  nodes: Array<Risolto_Single_Sign_On>;
};

export type Risolto_Single_Sign_On_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Single_Sign_On_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Single_Sign_On_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Single_Sign_On_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Aggregate_Fields = {
  __typename?: 'risolto_single_sign_on_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Single_Sign_On_Max_Fields>;
  min?: Maybe<Risolto_Single_Sign_On_Min_Fields>;
};


/** aggregate fields of "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Single_Sign_On_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Single_Sign_On_Max_Order_By>;
  min?: Maybe<Risolto_Single_Sign_On_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Single_Sign_On_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Single_Sign_On_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Single_Sign_On_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.single_sign_on". All fields are combined with a logical 'AND'. */
export type Risolto_Single_Sign_On_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Single_Sign_On_Bool_Exp>>;
  _not?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Single_Sign_On_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  domain?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.single_sign_on" */
export enum Risolto_Single_Sign_On_Constraint {
  /** unique or primary key constraint on columns "participant", "domain", "legal_entity" */
  SingleSignOnParticipantLegalEntityDomainKey = 'single_sign_on_participant_legal_entity_domain_key',
  /** unique or primary key constraint on columns "reference" */
  SingleSignOnPkey = 'single_sign_on_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Single_Sign_On_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Single_Sign_On_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Single_Sign_On_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  domain?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Single_Sign_On_Max_Fields = {
  __typename?: 'risolto_single_sign_on_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  domain?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  domain?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Single_Sign_On_Min_Fields = {
  __typename?: 'risolto_single_sign_on_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  domain?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  domain?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Mutation_Response = {
  __typename?: 'risolto_single_sign_on_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Single_Sign_On>;
};

/** on_conflict condition type for table "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_On_Conflict = {
  constraint: Risolto_Single_Sign_On_Constraint;
  update_columns?: Array<Risolto_Single_Sign_On_Update_Column>;
  where?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.single_sign_on". */
export type Risolto_Single_Sign_On_Order_By = {
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  domain?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.single_sign_on */
export type Risolto_Single_Sign_On_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Single_Sign_On_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.single_sign_on" */
export enum Risolto_Single_Sign_On_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Domain = 'domain',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.single_sign_on" */
export type Risolto_Single_Sign_On_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  domain?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_single_sign_on" */
export type Risolto_Single_Sign_On_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Single_Sign_On_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Single_Sign_On_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  domain?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.single_sign_on" */
export enum Risolto_Single_Sign_On_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Domain = 'domain',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Single_Sign_On_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Single_Sign_On_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Single_Sign_On_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Single_Sign_On_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Single_Sign_On_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Single_Sign_On_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Single_Sign_On_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Single_Sign_On_Bool_Exp;
};

/** columns and relationships of "risolto.statement" */
export type Risolto_Statement = {
  __typename?: 'risolto_statement';
  created_at: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  raw?: Maybe<Scalars['String']>;
  reference: Scalars['uuid'];
  /** An array relationship */
  statement_lines: Array<Risolto_Statement_Line>;
  /** An aggregate relationship */
  statement_lines_aggregate: Risolto_Statement_Line_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.statement" */
export type Risolto_StatementStatement_LinesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


/** columns and relationships of "risolto.statement" */
export type Risolto_StatementStatement_Lines_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};

/** columns and relationships of "risolto.statement_account" */
export type Risolto_Statement_Account = {
  __typename?: 'risolto_statement_account';
  account_currency: Scalars['String'];
  account_number: Scalars['String'];
  account_number_type: Risolto_Account_Number_Type_Enum;
  bank_identifier: Scalars['String'];
  bank_identifier_type: Risolto_Bank_Identifier_Type_Enum;
  closing_balance: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  custom_fields?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  name: Scalars['String'];
  opening_balance: Scalars['numeric'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  /** An array relationship */
  statement_lines: Array<Risolto_Statement_Line>;
  /** An aggregate relationship */
  statement_lines_aggregate: Risolto_Statement_Line_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.statement_account" */
export type Risolto_Statement_AccountCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.statement_account" */
export type Risolto_Statement_AccountStatement_LinesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_account" */
export type Risolto_Statement_AccountStatement_Lines_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};

/** aggregated selection of "risolto.statement_account" */
export type Risolto_Statement_Account_Aggregate = {
  __typename?: 'risolto_statement_account_aggregate';
  aggregate?: Maybe<Risolto_Statement_Account_Aggregate_Fields>;
  nodes: Array<Risolto_Statement_Account>;
};

/** aggregate fields of "risolto.statement_account" */
export type Risolto_Statement_Account_Aggregate_Fields = {
  __typename?: 'risolto_statement_account_aggregate_fields';
  avg?: Maybe<Risolto_Statement_Account_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Statement_Account_Max_Fields>;
  min?: Maybe<Risolto_Statement_Account_Min_Fields>;
  stddev?: Maybe<Risolto_Statement_Account_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Statement_Account_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Statement_Account_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Statement_Account_Sum_Fields>;
  var_pop?: Maybe<Risolto_Statement_Account_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Statement_Account_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Statement_Account_Variance_Fields>;
};


/** aggregate fields of "risolto.statement_account" */
export type Risolto_Statement_Account_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Statement_Account_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Statement_Account_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Risolto_Statement_Account_Avg_Fields = {
  __typename?: 'risolto_statement_account_avg_fields';
  closing_balance?: Maybe<Scalars['Float']>;
  opening_balance?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.statement_account". All fields are combined with a logical 'AND'. */
export type Risolto_Statement_Account_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Statement_Account_Bool_Exp>>;
  _not?: Maybe<Risolto_Statement_Account_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Statement_Account_Bool_Exp>>;
  account_currency?: Maybe<String_Comparison_Exp>;
  account_number?: Maybe<String_Comparison_Exp>;
  account_number_type?: Maybe<Risolto_Account_Number_Type_Enum_Comparison_Exp>;
  bank_identifier?: Maybe<String_Comparison_Exp>;
  bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum_Comparison_Exp>;
  closing_balance?: Maybe<Numeric_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  opening_balance?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  statement_lines?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  statement_lines_aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.statement_account" */
export enum Risolto_Statement_Account_Constraint {
  /** unique or primary key constraint on columns "reference" */
  StatementAccountPkey = 'statement_account_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Statement_Account_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Statement_Account_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Statement_Account_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.statement_account" */
export type Risolto_Statement_Account_Inc_Input = {
  closing_balance?: Maybe<Scalars['numeric']>;
  opening_balance?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.statement_account" */
export type Risolto_Statement_Account_Insert_Input = {
  account_currency?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Risolto_Account_Number_Type_Enum>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  closing_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  opening_balance?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  statement_lines?: Maybe<Risolto_Statement_Line_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Statement_Account_Max_Fields = {
  __typename?: 'risolto_statement_account_max_fields';
  account_currency?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  closing_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  opening_balance?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Statement_Account_Min_Fields = {
  __typename?: 'risolto_statement_account_min_fields';
  account_currency?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  bank_identifier?: Maybe<Scalars['String']>;
  closing_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  opening_balance?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.statement_account" */
export type Risolto_Statement_Account_Mutation_Response = {
  __typename?: 'risolto_statement_account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Statement_Account>;
};

/** on_conflict condition type for table "risolto.statement_account" */
export type Risolto_Statement_Account_On_Conflict = {
  constraint: Risolto_Statement_Account_Constraint;
  update_columns?: Array<Risolto_Statement_Account_Update_Column>;
  where?: Maybe<Risolto_Statement_Account_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.statement_account". */
export type Risolto_Statement_Account_Order_By = {
  account_currency?: Maybe<Order_By>;
  account_number?: Maybe<Order_By>;
  account_number_type?: Maybe<Order_By>;
  bank_identifier?: Maybe<Order_By>;
  bank_identifier_type?: Maybe<Order_By>;
  closing_balance?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  name?: Maybe<Order_By>;
  opening_balance?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  statement_lines_aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.statement_account */
export type Risolto_Statement_Account_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Statement_Account_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.statement_account" */
export enum Risolto_Statement_Account_Select_Column {
  /** column name */
  AccountCurrency = 'account_currency',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AccountNumberType = 'account_number_type',
  /** column name */
  BankIdentifier = 'bank_identifier',
  /** column name */
  BankIdentifierType = 'bank_identifier_type',
  /** column name */
  ClosingBalance = 'closing_balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningBalance = 'opening_balance',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.statement_account" */
export type Risolto_Statement_Account_Set_Input = {
  account_currency?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Risolto_Account_Number_Type_Enum>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  closing_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  opening_balance?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Statement_Account_Stddev_Fields = {
  __typename?: 'risolto_statement_account_stddev_fields';
  closing_balance?: Maybe<Scalars['Float']>;
  opening_balance?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Statement_Account_Stddev_Pop_Fields = {
  __typename?: 'risolto_statement_account_stddev_pop_fields';
  closing_balance?: Maybe<Scalars['Float']>;
  opening_balance?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Statement_Account_Stddev_Samp_Fields = {
  __typename?: 'risolto_statement_account_stddev_samp_fields';
  closing_balance?: Maybe<Scalars['Float']>;
  opening_balance?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_statement_account" */
export type Risolto_Statement_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Statement_Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Statement_Account_Stream_Cursor_Value_Input = {
  account_currency?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  account_number_type?: Maybe<Risolto_Account_Number_Type_Enum>;
  bank_identifier?: Maybe<Scalars['String']>;
  bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  closing_balance?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  opening_balance?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Statement_Account_Sum_Fields = {
  __typename?: 'risolto_statement_account_sum_fields';
  closing_balance?: Maybe<Scalars['numeric']>;
  opening_balance?: Maybe<Scalars['numeric']>;
};

/** update columns of table "risolto.statement_account" */
export enum Risolto_Statement_Account_Update_Column {
  /** column name */
  AccountCurrency = 'account_currency',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AccountNumberType = 'account_number_type',
  /** column name */
  BankIdentifier = 'bank_identifier',
  /** column name */
  BankIdentifierType = 'bank_identifier_type',
  /** column name */
  ClosingBalance = 'closing_balance',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningBalance = 'opening_balance',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Statement_Account_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Statement_Account_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Statement_Account_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Statement_Account_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Statement_Account_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Statement_Account_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Statement_Account_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Statement_Account_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Statement_Account_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Statement_Account_Var_Pop_Fields = {
  __typename?: 'risolto_statement_account_var_pop_fields';
  closing_balance?: Maybe<Scalars['Float']>;
  opening_balance?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Statement_Account_Var_Samp_Fields = {
  __typename?: 'risolto_statement_account_var_samp_fields';
  closing_balance?: Maybe<Scalars['Float']>;
  opening_balance?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Statement_Account_Variance_Fields = {
  __typename?: 'risolto_statement_account_variance_fields';
  closing_balance?: Maybe<Scalars['Float']>;
  opening_balance?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "risolto.statement" */
export type Risolto_Statement_Aggregate = {
  __typename?: 'risolto_statement_aggregate';
  aggregate?: Maybe<Risolto_Statement_Aggregate_Fields>;
  nodes: Array<Risolto_Statement>;
};

/** aggregate fields of "risolto.statement" */
export type Risolto_Statement_Aggregate_Fields = {
  __typename?: 'risolto_statement_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Statement_Max_Fields>;
  min?: Maybe<Risolto_Statement_Min_Fields>;
};


/** aggregate fields of "risolto.statement" */
export type Risolto_Statement_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Statement_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.statement". All fields are combined with a logical 'AND'. */
export type Risolto_Statement_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Statement_Bool_Exp>>;
  _not?: Maybe<Risolto_Statement_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Statement_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  raw?: Maybe<String_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  statement_lines?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  statement_lines_aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.statement" */
export enum Risolto_Statement_Constraint {
  /** unique or primary key constraint on columns "reference" */
  StatementPkey = 'statement_pkey'
}

/** input type for inserting data into table "risolto.statement" */
export type Risolto_Statement_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  raw?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  statement_lines?: Maybe<Risolto_Statement_Line_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_Line = {
  __typename?: 'risolto_statement_line';
  bank_transaction_code?: Maybe<Scalars['String']>;
  counterparty_account_number?: Maybe<Scalars['String']>;
  counterparty_account_number_type?: Maybe<Risolto_Account_Number_Type_Enum>;
  counterparty_address?: Maybe<Scalars['String']>;
  counterparty_bank_identifier?: Maybe<Scalars['String']>;
  counterparty_bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  counterparty_currency?: Maybe<Scalars['String']>;
  counterparty_name?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  custom_fields?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  document_interchange_links: Array<Risolto_Document_Interchange_Link>;
  /** An aggregate relationship */
  document_interchange_links_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in v1.1.0 */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_transfer?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer>;
  /** An array relationship */
  payment_transfer_lines: Array<Risolto_Payment_Transfer_Line>;
  /** An aggregate relationship */
  payment_transfer_lines_aggregate: Risolto_Payment_Transfer_Line_Aggregate;
  payment_transfer_lock?: Maybe<Scalars['timestamptz']>;
  /** Indicates whether the statement line was processed by the matcher. */
  processed_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference: Scalars['uuid'];
  statement?: Maybe<Scalars['uuid']>;
  statement_account?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  statement_by_reference?: Maybe<Risolto_Statement>;
  /** An array relationship */
  statement_line_dunning_notices: Array<Risolto_Statement_Line_Dunning_Notice>;
  /** An aggregate relationship */
  statement_line_dunning_notices_aggregate: Risolto_Statement_Line_Dunning_Notice_Aggregate;
  /** An array relationship */
  statement_line_invoices: Array<Risolto_Statement_Line_Invoice>;
  /** An aggregate relationship */
  statement_line_invoices_aggregate: Risolto_Statement_Line_Invoice_Aggregate;
  /** An array relationship */
  statement_line_payment_promises: Array<Risolto_Statement_Line_Payment_Promise>;
  /** An aggregate relationship */
  statement_line_payment_promises_aggregate: Risolto_Statement_Line_Payment_Promise_Aggregate;
  /** DEPRECATED. Will be removed in 2.0 */
  status?: Maybe<Risolto_Statement_Line_Status_Enum>;
  structured_message?: Maybe<Scalars['String']>;
  transaction_credit_amount?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_debit_amount?: Maybe<Scalars['numeric']>;
  transaction_reference?: Maybe<Scalars['String']>;
  unstructured_message?: Maybe<Scalars['String']>;
  unstructured_message_raw?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  value_date?: Maybe<Scalars['date']>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineDocument_Interchange_LinksArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineDocument_Interchange_Links_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LinePayment_Transfer_LinesArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LinePayment_Transfer_Lines_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineStatement_Line_Dunning_NoticesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineStatement_Line_Dunning_Notices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineStatement_Line_InvoicesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Invoice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineStatement_Line_Invoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Invoice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineStatement_Line_Payment_PromisesArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};


/** columns and relationships of "risolto.statement_line" */
export type Risolto_Statement_LineStatement_Line_Payment_Promises_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};

/** aggregated selection of "risolto.statement_line" */
export type Risolto_Statement_Line_Aggregate = {
  __typename?: 'risolto_statement_line_aggregate';
  aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Fields>;
  nodes: Array<Risolto_Statement_Line>;
};

export type Risolto_Statement_Line_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Statement_Line_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Statement_Line_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.statement_line" */
export type Risolto_Statement_Line_Aggregate_Fields = {
  __typename?: 'risolto_statement_line_aggregate_fields';
  avg?: Maybe<Risolto_Statement_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Statement_Line_Max_Fields>;
  min?: Maybe<Risolto_Statement_Line_Min_Fields>;
  stddev?: Maybe<Risolto_Statement_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Statement_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Statement_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Statement_Line_Sum_Fields>;
  var_pop?: Maybe<Risolto_Statement_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Statement_Line_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Statement_Line_Variance_Fields>;
};


/** aggregate fields of "risolto.statement_line" */
export type Risolto_Statement_Line_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.statement_line" */
export type Risolto_Statement_Line_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Statement_Line_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Statement_Line_Max_Order_By>;
  min?: Maybe<Risolto_Statement_Line_Min_Order_By>;
  stddev?: Maybe<Risolto_Statement_Line_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Statement_Line_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Statement_Line_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Statement_Line_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Statement_Line_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Statement_Line_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Statement_Line_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Statement_Line_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "risolto.statement_line" */
export type Risolto_Statement_Line_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Statement_Line_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Statement_Line_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Statement_Line_Avg_Fields = {
  __typename?: 'risolto_statement_line_avg_fields';
  transaction_credit_amount?: Maybe<Scalars['Float']>;
  transaction_debit_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Avg_Order_By = {
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.statement_line". All fields are combined with a logical 'AND'. */
export type Risolto_Statement_Line_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Statement_Line_Bool_Exp>>;
  _not?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Statement_Line_Bool_Exp>>;
  bank_transaction_code?: Maybe<String_Comparison_Exp>;
  counterparty_account_number?: Maybe<String_Comparison_Exp>;
  counterparty_account_number_type?: Maybe<Risolto_Account_Number_Type_Enum_Comparison_Exp>;
  counterparty_address?: Maybe<String_Comparison_Exp>;
  counterparty_bank_identifier?: Maybe<String_Comparison_Exp>;
  counterparty_bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum_Comparison_Exp>;
  counterparty_currency?: Maybe<String_Comparison_Exp>;
  counterparty_name?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  document_interchange_links?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
  document_interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Bool_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_transfer?: Maybe<Uuid_Comparison_Exp>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
  payment_transfer_lines?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
  payment_transfer_lines_aggregate?: Maybe<Risolto_Payment_Transfer_Line_Aggregate_Bool_Exp>;
  payment_transfer_lock?: Maybe<Timestamptz_Comparison_Exp>;
  processed_at?: Maybe<Timestamptz_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  statement?: Maybe<Uuid_Comparison_Exp>;
  statement_account?: Maybe<Uuid_Comparison_Exp>;
  statement_by_reference?: Maybe<Risolto_Statement_Bool_Exp>;
  statement_line_dunning_notices?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
  statement_line_dunning_notices_aggregate?: Maybe<Risolto_Statement_Line_Dunning_Notice_Aggregate_Bool_Exp>;
  statement_line_invoices?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
  statement_line_invoices_aggregate?: Maybe<Risolto_Statement_Line_Invoice_Aggregate_Bool_Exp>;
  statement_line_payment_promises?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
  statement_line_payment_promises_aggregate?: Maybe<Risolto_Statement_Line_Payment_Promise_Aggregate_Bool_Exp>;
  status?: Maybe<Risolto_Statement_Line_Status_Enum_Comparison_Exp>;
  structured_message?: Maybe<String_Comparison_Exp>;
  transaction_credit_amount?: Maybe<Numeric_Comparison_Exp>;
  transaction_date?: Maybe<Date_Comparison_Exp>;
  transaction_debit_amount?: Maybe<Numeric_Comparison_Exp>;
  transaction_reference?: Maybe<String_Comparison_Exp>;
  unstructured_message?: Maybe<String_Comparison_Exp>;
  unstructured_message_raw?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  value_date?: Maybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.statement_line" */
export enum Risolto_Statement_Line_Constraint {
  /** unique or primary key constraint on columns "participant", "external_id", "legal_entity" */
  StatementLineParticipantLegalEntityExternalIdKey = 'statement_line_participant_legal_entity_external_id_key',
  /** unique or primary key constraint on columns "reference" */
  StatementLinePkey = 'statement_line_pkey',
  /** unique or primary key constraint on columns "participant", "transaction_date", "transaction_reference", "transaction_debit_amount", "transaction_credit_amount", "unstructured_message", "structured_message", "legal_entity" */
  StatementLineTransactionReferenceTransactionDebitAmountT = 'statement_line_transaction_reference_transaction_debit_amount_t'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Statement_Line_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Statement_Line_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Statement_Line_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice = {
  __typename?: 'risolto_statement_line_dunning_notice';
  amount: Scalars['numeric'];
  amount_currency: Scalars['String'];
  created_at: Scalars['timestamptz'];
  dunning_notice: Scalars['uuid'];
  /** An object relationship */
  dunning_notice_by_reference: Risolto_Dunning_Notice;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  matching_score?: Maybe<Scalars['Int']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line: Scalars['uuid'];
  /** An object relationship */
  statement_line_by_reference: Risolto_Statement_Line;
  updated_at: Scalars['timestamptz'];
  value_date: Scalars['date'];
};

/** aggregated selection of "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Aggregate = {
  __typename?: 'risolto_statement_line_dunning_notice_aggregate';
  aggregate?: Maybe<Risolto_Statement_Line_Dunning_Notice_Aggregate_Fields>;
  nodes: Array<Risolto_Statement_Line_Dunning_Notice>;
};

export type Risolto_Statement_Line_Dunning_Notice_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Statement_Line_Dunning_Notice_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Statement_Line_Dunning_Notice_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Aggregate_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_aggregate_fields';
  avg?: Maybe<Risolto_Statement_Line_Dunning_Notice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Statement_Line_Dunning_Notice_Max_Fields>;
  min?: Maybe<Risolto_Statement_Line_Dunning_Notice_Min_Fields>;
  stddev?: Maybe<Risolto_Statement_Line_Dunning_Notice_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Statement_Line_Dunning_Notice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Statement_Line_Dunning_Notice_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Statement_Line_Dunning_Notice_Sum_Fields>;
  var_pop?: Maybe<Risolto_Statement_Line_Dunning_Notice_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Statement_Line_Dunning_Notice_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Statement_Line_Dunning_Notice_Variance_Fields>;
};


/** aggregate fields of "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Statement_Line_Dunning_Notice_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Statement_Line_Dunning_Notice_Max_Order_By>;
  min?: Maybe<Risolto_Statement_Line_Dunning_Notice_Min_Order_By>;
  stddev?: Maybe<Risolto_Statement_Line_Dunning_Notice_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Statement_Line_Dunning_Notice_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Statement_Line_Dunning_Notice_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Statement_Line_Dunning_Notice_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Statement_Line_Dunning_Notice_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Statement_Line_Dunning_Notice_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Statement_Line_Dunning_Notice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Statement_Line_Dunning_Notice_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Statement_Line_Dunning_Notice_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Statement_Line_Dunning_Notice_Avg_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Avg_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.statement_line_dunning_notice". All fields are combined with a logical 'AND'. */
export type Risolto_Statement_Line_Dunning_Notice_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>>;
  _not?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>>;
  amount?: Maybe<Numeric_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  dunning_notice?: Maybe<Uuid_Comparison_Exp>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  matching_score?: Maybe<Int_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  selected_at?: Maybe<Timestamptz_Comparison_Exp>;
  statement_line?: Maybe<Uuid_Comparison_Exp>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  value_date?: Maybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.statement_line_dunning_notice" */
export enum Risolto_Statement_Line_Dunning_Notice_Constraint {
  /** unique or primary key constraint on columns "participant", "dunning_notice", "statement_line" */
  StatementLineDunningNoticeParticipantStatementLineDuKey = 'statement_line_dunning_notice_participant_statement_line_du_key',
  /** unique or primary key constraint on columns "reference" */
  StatementLineDunningNoticePkey = 'statement_line_dunning_notice_pkey'
}

/** input type for incrementing numeric columns in table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Inc_Input = {
  amount?: Maybe<Scalars['numeric']>;
  matching_score?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Insert_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Risolto_Statement_Line_Dunning_Notice_Max_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Max_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Statement_Line_Dunning_Notice_Min_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Min_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Mutation_Response = {
  __typename?: 'risolto_statement_line_dunning_notice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Statement_Line_Dunning_Notice>;
};

/** on_conflict condition type for table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_On_Conflict = {
  constraint: Risolto_Statement_Line_Dunning_Notice_Constraint;
  update_columns?: Array<Risolto_Statement_Line_Dunning_Notice_Update_Column>;
  where?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.statement_line_dunning_notice". */
export type Risolto_Statement_Line_Dunning_Notice_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  dunning_notice_by_reference?: Maybe<Risolto_Dunning_Notice_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.statement_line_dunning_notice */
export type Risolto_Statement_Line_Dunning_Notice_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.statement_line_dunning_notice" */
export enum Risolto_Statement_Line_Dunning_Notice_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MatchingScore = 'matching_score',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  SelectedAt = 'selected_at',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueDate = 'value_date'
}

/** input type for updating data in table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Set_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type Risolto_Statement_Line_Dunning_Notice_Stddev_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Stddev_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Statement_Line_Dunning_Notice_Stddev_Pop_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Stddev_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Statement_Line_Dunning_Notice_Stddev_Samp_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Stddev_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Statement_Line_Dunning_Notice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Statement_Line_Dunning_Notice_Stream_Cursor_Value_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Risolto_Statement_Line_Dunning_Notice_Sum_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  matching_score?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Sum_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** update columns of table "risolto.statement_line_dunning_notice" */
export enum Risolto_Statement_Line_Dunning_Notice_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MatchingScore = 'matching_score',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  SelectedAt = 'selected_at',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueDate = 'value_date'
}

export type Risolto_Statement_Line_Dunning_Notice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Statement_Line_Dunning_Notice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Statement_Line_Dunning_Notice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Statement_Line_Dunning_Notice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Statement_Line_Dunning_Notice_Var_Pop_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Var_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Statement_Line_Dunning_Notice_Var_Samp_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Var_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Statement_Line_Dunning_Notice_Variance_Fields = {
  __typename?: 'risolto_statement_line_dunning_notice_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.statement_line_dunning_notice" */
export type Risolto_Statement_Line_Dunning_Notice_Variance_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** input type for incrementing numeric columns in table "risolto.statement_line" */
export type Risolto_Statement_Line_Inc_Input = {
  transaction_credit_amount?: Maybe<Scalars['numeric']>;
  transaction_debit_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.statement_line" */
export type Risolto_Statement_Line_Insert_Input = {
  bank_transaction_code?: Maybe<Scalars['String']>;
  counterparty_account_number?: Maybe<Scalars['String']>;
  counterparty_account_number_type?: Maybe<Risolto_Account_Number_Type_Enum>;
  counterparty_address?: Maybe<Scalars['String']>;
  counterparty_bank_identifier?: Maybe<Scalars['String']>;
  counterparty_bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  counterparty_currency?: Maybe<Scalars['String']>;
  counterparty_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  document_interchange_links?: Maybe<Risolto_Document_Interchange_Link_Arr_Rel_Insert_Input>;
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in v1.1.0 */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Obj_Rel_Insert_Input>;
  payment_transfer_lines?: Maybe<Risolto_Payment_Transfer_Line_Arr_Rel_Insert_Input>;
  payment_transfer_lock?: Maybe<Scalars['timestamptz']>;
  /** Indicates whether the statement line was processed by the matcher. */
  processed_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  statement?: Maybe<Scalars['uuid']>;
  statement_account?: Maybe<Scalars['uuid']>;
  statement_by_reference?: Maybe<Risolto_Statement_Obj_Rel_Insert_Input>;
  statement_line_dunning_notices?: Maybe<Risolto_Statement_Line_Dunning_Notice_Arr_Rel_Insert_Input>;
  statement_line_invoices?: Maybe<Risolto_Statement_Line_Invoice_Arr_Rel_Insert_Input>;
  statement_line_payment_promises?: Maybe<Risolto_Statement_Line_Payment_Promise_Arr_Rel_Insert_Input>;
  /** DEPRECATED. Will be removed in 2.0 */
  status?: Maybe<Risolto_Statement_Line_Status_Enum>;
  structured_message?: Maybe<Scalars['String']>;
  transaction_credit_amount?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_debit_amount?: Maybe<Scalars['numeric']>;
  transaction_reference?: Maybe<Scalars['String']>;
  unstructured_message?: Maybe<Scalars['String']>;
  unstructured_message_raw?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** columns and relationships of "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice = {
  __typename?: 'risolto_statement_line_invoice';
  amount: Scalars['numeric'];
  amount_currency: Risolto_Currency_Enum;
  created_at: Scalars['timestamptz'];
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  matching_score?: Maybe<Scalars['Int']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  reference: Scalars['uuid'];
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line: Scalars['uuid'];
  /** An object relationship */
  statement_line_by_reference: Risolto_Statement_Line;
  updated_at: Scalars['timestamptz'];
  value_date: Scalars['date'];
};

/** aggregated selection of "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Aggregate = {
  __typename?: 'risolto_statement_line_invoice_aggregate';
  aggregate?: Maybe<Risolto_Statement_Line_Invoice_Aggregate_Fields>;
  nodes: Array<Risolto_Statement_Line_Invoice>;
};

export type Risolto_Statement_Line_Invoice_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Statement_Line_Invoice_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Statement_Line_Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Aggregate_Fields = {
  __typename?: 'risolto_statement_line_invoice_aggregate_fields';
  avg?: Maybe<Risolto_Statement_Line_Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Statement_Line_Invoice_Max_Fields>;
  min?: Maybe<Risolto_Statement_Line_Invoice_Min_Fields>;
  stddev?: Maybe<Risolto_Statement_Line_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Statement_Line_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Statement_Line_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Statement_Line_Invoice_Sum_Fields>;
  var_pop?: Maybe<Risolto_Statement_Line_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Statement_Line_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Statement_Line_Invoice_Variance_Fields>;
};


/** aggregate fields of "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Statement_Line_Invoice_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Statement_Line_Invoice_Max_Order_By>;
  min?: Maybe<Risolto_Statement_Line_Invoice_Min_Order_By>;
  stddev?: Maybe<Risolto_Statement_Line_Invoice_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Statement_Line_Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Statement_Line_Invoice_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Statement_Line_Invoice_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Statement_Line_Invoice_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Statement_Line_Invoice_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Statement_Line_Invoice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Statement_Line_Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Statement_Line_Invoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Statement_Line_Invoice_Avg_Fields = {
  __typename?: 'risolto_statement_line_invoice_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Avg_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.statement_line_invoice". All fields are combined with a logical 'AND'. */
export type Risolto_Statement_Line_Invoice_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Statement_Line_Invoice_Bool_Exp>>;
  _not?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Statement_Line_Invoice_Bool_Exp>>;
  amount?: Maybe<Numeric_Comparison_Exp>;
  amount_currency?: Maybe<Risolto_Currency_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  matching_score?: Maybe<Int_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  selected_at?: Maybe<Timestamptz_Comparison_Exp>;
  statement_line?: Maybe<Uuid_Comparison_Exp>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  value_date?: Maybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.statement_line_invoice" */
export enum Risolto_Statement_Line_Invoice_Constraint {
  /** unique or primary key constraint on columns "participant", "recipient", "invoice", "statement_line" */
  StatementLineInvoiceParticipantStatementLineRecipientInv = 'statement_line_invoice_participant_statement_line_recipient_inv',
  /** unique or primary key constraint on columns "reference" */
  StatementLineInvoicePkey = 'statement_line_invoice_pkey'
}

/** input type for incrementing numeric columns in table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Inc_Input = {
  amount?: Maybe<Scalars['numeric']>;
  matching_score?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Insert_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Risolto_Statement_Line_Invoice_Max_Fields = {
  __typename?: 'risolto_statement_line_invoice_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Max_Order_By = {
  amount?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Statement_Line_Invoice_Min_Fields = {
  __typename?: 'risolto_statement_line_invoice_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Min_Order_By = {
  amount?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Mutation_Response = {
  __typename?: 'risolto_statement_line_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Statement_Line_Invoice>;
};

/** on_conflict condition type for table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_On_Conflict = {
  constraint: Risolto_Statement_Line_Invoice_Constraint;
  update_columns?: Array<Risolto_Statement_Line_Invoice_Update_Column>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.statement_line_invoice". */
export type Risolto_Statement_Line_Invoice_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.statement_line_invoice */
export type Risolto_Statement_Line_Invoice_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.statement_line_invoice" */
export enum Risolto_Statement_Line_Invoice_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MatchingScore = 'matching_score',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  SelectedAt = 'selected_at',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueDate = 'value_date'
}

/** input type for updating data in table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Set_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type Risolto_Statement_Line_Invoice_Stddev_Fields = {
  __typename?: 'risolto_statement_line_invoice_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Stddev_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Statement_Line_Invoice_Stddev_Pop_Fields = {
  __typename?: 'risolto_statement_line_invoice_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Stddev_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Statement_Line_Invoice_Stddev_Samp_Fields = {
  __typename?: 'risolto_statement_line_invoice_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Stddev_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Statement_Line_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Statement_Line_Invoice_Stream_Cursor_Value_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Risolto_Currency_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Risolto_Statement_Line_Invoice_Sum_Fields = {
  __typename?: 'risolto_statement_line_invoice_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  matching_score?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Sum_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** update columns of table "risolto.statement_line_invoice" */
export enum Risolto_Statement_Line_Invoice_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MatchingScore = 'matching_score',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  SelectedAt = 'selected_at',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueDate = 'value_date'
}

export type Risolto_Statement_Line_Invoice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Statement_Line_Invoice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Statement_Line_Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Statement_Line_Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Statement_Line_Invoice_Var_Pop_Fields = {
  __typename?: 'risolto_statement_line_invoice_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Var_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Statement_Line_Invoice_Var_Samp_Fields = {
  __typename?: 'risolto_statement_line_invoice_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Var_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Statement_Line_Invoice_Variance_Fields = {
  __typename?: 'risolto_statement_line_invoice_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.statement_line_invoice" */
export type Risolto_Statement_Line_Invoice_Variance_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate max on columns */
export type Risolto_Statement_Line_Max_Fields = {
  __typename?: 'risolto_statement_line_max_fields';
  bank_transaction_code?: Maybe<Scalars['String']>;
  counterparty_account_number?: Maybe<Scalars['String']>;
  counterparty_address?: Maybe<Scalars['String']>;
  counterparty_bank_identifier?: Maybe<Scalars['String']>;
  counterparty_currency?: Maybe<Scalars['String']>;
  counterparty_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in v1.1.0 */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  payment_transfer_lock?: Maybe<Scalars['timestamptz']>;
  /** Indicates whether the statement line was processed by the matcher. */
  processed_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement?: Maybe<Scalars['uuid']>;
  statement_account?: Maybe<Scalars['uuid']>;
  structured_message?: Maybe<Scalars['String']>;
  transaction_credit_amount?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_debit_amount?: Maybe<Scalars['numeric']>;
  transaction_reference?: Maybe<Scalars['String']>;
  unstructured_message?: Maybe<Scalars['String']>;
  unstructured_message_raw?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Max_Order_By = {
  bank_transaction_code?: Maybe<Order_By>;
  counterparty_account_number?: Maybe<Order_By>;
  counterparty_address?: Maybe<Order_By>;
  counterparty_bank_identifier?: Maybe<Order_By>;
  counterparty_currency?: Maybe<Order_By>;
  counterparty_name?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  /** DEPRECATED. Will be removed in v1.1.0 */
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_transfer?: Maybe<Order_By>;
  payment_transfer_lock?: Maybe<Order_By>;
  /** Indicates whether the statement line was processed by the matcher. */
  processed_at?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  statement?: Maybe<Order_By>;
  statement_account?: Maybe<Order_By>;
  structured_message?: Maybe<Order_By>;
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_date?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
  transaction_reference?: Maybe<Order_By>;
  unstructured_message?: Maybe<Order_By>;
  unstructured_message_raw?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Statement_Line_Min_Fields = {
  __typename?: 'risolto_statement_line_min_fields';
  bank_transaction_code?: Maybe<Scalars['String']>;
  counterparty_account_number?: Maybe<Scalars['String']>;
  counterparty_address?: Maybe<Scalars['String']>;
  counterparty_bank_identifier?: Maybe<Scalars['String']>;
  counterparty_currency?: Maybe<Scalars['String']>;
  counterparty_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in v1.1.0 */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  payment_transfer_lock?: Maybe<Scalars['timestamptz']>;
  /** Indicates whether the statement line was processed by the matcher. */
  processed_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement?: Maybe<Scalars['uuid']>;
  statement_account?: Maybe<Scalars['uuid']>;
  structured_message?: Maybe<Scalars['String']>;
  transaction_credit_amount?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_debit_amount?: Maybe<Scalars['numeric']>;
  transaction_reference?: Maybe<Scalars['String']>;
  unstructured_message?: Maybe<Scalars['String']>;
  unstructured_message_raw?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Min_Order_By = {
  bank_transaction_code?: Maybe<Order_By>;
  counterparty_account_number?: Maybe<Order_By>;
  counterparty_address?: Maybe<Order_By>;
  counterparty_bank_identifier?: Maybe<Order_By>;
  counterparty_currency?: Maybe<Order_By>;
  counterparty_name?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  /** DEPRECATED. Will be removed in v1.1.0 */
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_transfer?: Maybe<Order_By>;
  payment_transfer_lock?: Maybe<Order_By>;
  /** Indicates whether the statement line was processed by the matcher. */
  processed_at?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  statement?: Maybe<Order_By>;
  statement_account?: Maybe<Order_By>;
  structured_message?: Maybe<Order_By>;
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_date?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
  transaction_reference?: Maybe<Order_By>;
  unstructured_message?: Maybe<Order_By>;
  unstructured_message_raw?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.statement_line" */
export type Risolto_Statement_Line_Mutation_Response = {
  __typename?: 'risolto_statement_line_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Statement_Line>;
};

/** input type for inserting object relation for remote table "risolto.statement_line" */
export type Risolto_Statement_Line_Obj_Rel_Insert_Input = {
  data: Risolto_Statement_Line_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Statement_Line_On_Conflict>;
};

/** on_conflict condition type for table "risolto.statement_line" */
export type Risolto_Statement_Line_On_Conflict = {
  constraint: Risolto_Statement_Line_Constraint;
  update_columns?: Array<Risolto_Statement_Line_Update_Column>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.statement_line". */
export type Risolto_Statement_Line_Order_By = {
  bank_transaction_code?: Maybe<Order_By>;
  counterparty_account_number?: Maybe<Order_By>;
  counterparty_account_number_type?: Maybe<Order_By>;
  counterparty_address?: Maybe<Order_By>;
  counterparty_bank_identifier?: Maybe<Order_By>;
  counterparty_bank_identifier_type?: Maybe<Order_By>;
  counterparty_currency?: Maybe<Order_By>;
  counterparty_name?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  document_interchange_links_aggregate?: Maybe<Risolto_Document_Interchange_Link_Aggregate_Order_By>;
  external_id?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_transfer?: Maybe<Order_By>;
  payment_transfer_by_reference?: Maybe<Risolto_Payment_Transfer_Order_By>;
  payment_transfer_lines_aggregate?: Maybe<Risolto_Payment_Transfer_Line_Aggregate_Order_By>;
  payment_transfer_lock?: Maybe<Order_By>;
  processed_at?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  statement?: Maybe<Order_By>;
  statement_account?: Maybe<Order_By>;
  statement_by_reference?: Maybe<Risolto_Statement_Order_By>;
  statement_line_dunning_notices_aggregate?: Maybe<Risolto_Statement_Line_Dunning_Notice_Aggregate_Order_By>;
  statement_line_invoices_aggregate?: Maybe<Risolto_Statement_Line_Invoice_Aggregate_Order_By>;
  statement_line_payment_promises_aggregate?: Maybe<Risolto_Statement_Line_Payment_Promise_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  structured_message?: Maybe<Order_By>;
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_date?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
  transaction_reference?: Maybe<Order_By>;
  unstructured_message?: Maybe<Order_By>;
  unstructured_message_raw?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise = {
  __typename?: 'risolto_statement_line_payment_promise';
  amount: Scalars['numeric'];
  amount_currency: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  matching_score?: Maybe<Scalars['Int']>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  payment_promise: Scalars['uuid'];
  /** An object relationship */
  payment_promise_by_reference: Risolto_Payment_Promise;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  reference: Scalars['uuid'];
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line: Scalars['uuid'];
  /** An object relationship */
  statement_line_by_reference: Risolto_Statement_Line;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date: Scalars['date'];
};

/** aggregated selection of "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Aggregate = {
  __typename?: 'risolto_statement_line_payment_promise_aggregate';
  aggregate?: Maybe<Risolto_Statement_Line_Payment_Promise_Aggregate_Fields>;
  nodes: Array<Risolto_Statement_Line_Payment_Promise>;
};

export type Risolto_Statement_Line_Payment_Promise_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Statement_Line_Payment_Promise_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Statement_Line_Payment_Promise_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Aggregate_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_aggregate_fields';
  avg?: Maybe<Risolto_Statement_Line_Payment_Promise_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Statement_Line_Payment_Promise_Max_Fields>;
  min?: Maybe<Risolto_Statement_Line_Payment_Promise_Min_Fields>;
  stddev?: Maybe<Risolto_Statement_Line_Payment_Promise_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Statement_Line_Payment_Promise_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Statement_Line_Payment_Promise_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Statement_Line_Payment_Promise_Sum_Fields>;
  var_pop?: Maybe<Risolto_Statement_Line_Payment_Promise_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Statement_Line_Payment_Promise_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Statement_Line_Payment_Promise_Variance_Fields>;
};


/** aggregate fields of "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Statement_Line_Payment_Promise_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Statement_Line_Payment_Promise_Max_Order_By>;
  min?: Maybe<Risolto_Statement_Line_Payment_Promise_Min_Order_By>;
  stddev?: Maybe<Risolto_Statement_Line_Payment_Promise_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Statement_Line_Payment_Promise_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Statement_Line_Payment_Promise_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Statement_Line_Payment_Promise_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Statement_Line_Payment_Promise_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Statement_Line_Payment_Promise_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Statement_Line_Payment_Promise_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Statement_Line_Payment_Promise_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Statement_Line_Payment_Promise_On_Conflict>;
};

/** aggregate avg on columns */
export type Risolto_Statement_Line_Payment_Promise_Avg_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Avg_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.statement_line_payment_promise". All fields are combined with a logical 'AND'. */
export type Risolto_Statement_Line_Payment_Promise_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Bool_Exp>>;
  _not?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Bool_Exp>>;
  amount?: Maybe<Numeric_Comparison_Exp>;
  amount_currency?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  matching_score?: Maybe<Int_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  payment_promise?: Maybe<Uuid_Comparison_Exp>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  selected_at?: Maybe<Timestamptz_Comparison_Exp>;
  statement_line?: Maybe<Uuid_Comparison_Exp>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  value_date?: Maybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.statement_line_payment_promise" */
export enum Risolto_Statement_Line_Payment_Promise_Constraint {
  /** unique or primary key constraint on columns "payment_promise", "participant", "statement_line" */
  StatementLinePaymentPromiseParticipantStatementLinePayme = 'statement_line_payment_promise_participant_statement_line_payme',
  /** unique or primary key constraint on columns "reference" */
  StatementLinePaymentPromisePkey = 'statement_line_payment_promise_pkey'
}

/** input type for incrementing numeric columns in table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Inc_Input = {
  amount?: Maybe<Scalars['numeric']>;
  matching_score?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Insert_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  payment_promise?: Maybe<Scalars['uuid']>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Risolto_Statement_Line_Payment_Promise_Max_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Max_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Statement_Line_Payment_Promise_Min_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Min_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Mutation_Response = {
  __typename?: 'risolto_statement_line_payment_promise_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Statement_Line_Payment_Promise>;
};

/** on_conflict condition type for table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_On_Conflict = {
  constraint: Risolto_Statement_Line_Payment_Promise_Constraint;
  update_columns?: Array<Risolto_Statement_Line_Payment_Promise_Update_Column>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.statement_line_payment_promise". */
export type Risolto_Statement_Line_Payment_Promise_Order_By = {
  amount?: Maybe<Order_By>;
  amount_currency?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  matching_score?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  payment_promise?: Maybe<Order_By>;
  payment_promise_by_reference?: Maybe<Risolto_Payment_Promise_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  selected_at?: Maybe<Order_By>;
  statement_line?: Maybe<Order_By>;
  statement_line_by_reference?: Maybe<Risolto_Statement_Line_Order_By>;
  updated_at?: Maybe<Order_By>;
  value_date?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.statement_line_payment_promise */
export type Risolto_Statement_Line_Payment_Promise_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.statement_line_payment_promise" */
export enum Risolto_Statement_Line_Payment_Promise_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MatchingScore = 'matching_score',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  SelectedAt = 'selected_at',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueDate = 'value_date'
}

/** input type for updating data in table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Set_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type Risolto_Statement_Line_Payment_Promise_Stddev_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Stddev_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Statement_Line_Payment_Promise_Stddev_Pop_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Stddev_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Statement_Line_Payment_Promise_Stddev_Samp_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Stddev_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Statement_Line_Payment_Promise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Statement_Line_Payment_Promise_Stream_Cursor_Value_Input = {
  amount?: Maybe<Scalars['numeric']>;
  amount_currency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  matching_score?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  selected_at?: Maybe<Scalars['timestamptz']>;
  statement_line?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Risolto_Statement_Line_Payment_Promise_Sum_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  matching_score?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Sum_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** update columns of table "risolto.statement_line_payment_promise" */
export enum Risolto_Statement_Line_Payment_Promise_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountCurrency = 'amount_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MatchingScore = 'matching_score',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  SelectedAt = 'selected_at',
  /** column name */
  StatementLine = 'statement_line',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueDate = 'value_date'
}

export type Risolto_Statement_Line_Payment_Promise_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Statement_Line_Payment_Promise_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Statement_Line_Payment_Promise_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Statement_Line_Payment_Promise_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Statement_Line_Payment_Promise_Var_Pop_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Var_Pop_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Statement_Line_Payment_Promise_Var_Samp_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Var_Samp_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Statement_Line_Payment_Promise_Variance_Fields = {
  __typename?: 'risolto_statement_line_payment_promise_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  matching_score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.statement_line_payment_promise" */
export type Risolto_Statement_Line_Payment_Promise_Variance_Order_By = {
  amount?: Maybe<Order_By>;
  matching_score?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.statement_line */
export type Risolto_Statement_Line_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Statement_Line_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.statement_line" */
export enum Risolto_Statement_Line_Select_Column {
  /** column name */
  BankTransactionCode = 'bank_transaction_code',
  /** column name */
  CounterpartyAccountNumber = 'counterparty_account_number',
  /** column name */
  CounterpartyAccountNumberType = 'counterparty_account_number_type',
  /** column name */
  CounterpartyAddress = 'counterparty_address',
  /** column name */
  CounterpartyBankIdentifier = 'counterparty_bank_identifier',
  /** column name */
  CounterpartyBankIdentifierType = 'counterparty_bank_identifier_type',
  /** column name */
  CounterpartyCurrency = 'counterparty_currency',
  /** column name */
  CounterpartyName = 'counterparty_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentTransfer = 'payment_transfer',
  /** column name */
  PaymentTransferLock = 'payment_transfer_lock',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Statement = 'statement',
  /** column name */
  StatementAccount = 'statement_account',
  /** column name */
  Status = 'status',
  /** column name */
  StructuredMessage = 'structured_message',
  /** column name */
  TransactionCreditAmount = 'transaction_credit_amount',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionDebitAmount = 'transaction_debit_amount',
  /** column name */
  TransactionReference = 'transaction_reference',
  /** column name */
  UnstructuredMessage = 'unstructured_message',
  /** column name */
  UnstructuredMessageRaw = 'unstructured_message_raw',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueDate = 'value_date'
}

/** input type for updating data in table "risolto.statement_line" */
export type Risolto_Statement_Line_Set_Input = {
  bank_transaction_code?: Maybe<Scalars['String']>;
  counterparty_account_number?: Maybe<Scalars['String']>;
  counterparty_account_number_type?: Maybe<Risolto_Account_Number_Type_Enum>;
  counterparty_address?: Maybe<Scalars['String']>;
  counterparty_bank_identifier?: Maybe<Scalars['String']>;
  counterparty_bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  counterparty_currency?: Maybe<Scalars['String']>;
  counterparty_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in v1.1.0 */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  payment_transfer_lock?: Maybe<Scalars['timestamptz']>;
  /** Indicates whether the statement line was processed by the matcher. */
  processed_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement?: Maybe<Scalars['uuid']>;
  statement_account?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. Will be removed in 2.0 */
  status?: Maybe<Risolto_Statement_Line_Status_Enum>;
  structured_message?: Maybe<Scalars['String']>;
  transaction_credit_amount?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_debit_amount?: Maybe<Scalars['numeric']>;
  transaction_reference?: Maybe<Scalars['String']>;
  unstructured_message?: Maybe<Scalars['String']>;
  unstructured_message_raw?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

/** columns and relationships of "risolto.statement_line_status" */
export type Risolto_Statement_Line_Status = {
  __typename?: 'risolto_statement_line_status';
  status: Scalars['String'];
};

/** aggregated selection of "risolto.statement_line_status" */
export type Risolto_Statement_Line_Status_Aggregate = {
  __typename?: 'risolto_statement_line_status_aggregate';
  aggregate?: Maybe<Risolto_Statement_Line_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Statement_Line_Status>;
};

/** aggregate fields of "risolto.statement_line_status" */
export type Risolto_Statement_Line_Status_Aggregate_Fields = {
  __typename?: 'risolto_statement_line_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Statement_Line_Status_Max_Fields>;
  min?: Maybe<Risolto_Statement_Line_Status_Min_Fields>;
};


/** aggregate fields of "risolto.statement_line_status" */
export type Risolto_Statement_Line_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Statement_Line_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.statement_line_status". All fields are combined with a logical 'AND'. */
export type Risolto_Statement_Line_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Statement_Line_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Statement_Line_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Statement_Line_Status_Bool_Exp>>;
  status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.statement_line_status" */
export enum Risolto_Statement_Line_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  StatementLineStatusPkey = 'statement_line_status_pkey'
}

export enum Risolto_Statement_Line_Status_Enum {
  Matched = 'MATCHED',
  PartiallyMatched = 'PARTIALLY_MATCHED',
  Unmatched = 'UNMATCHED'
}

/** Boolean expression to compare columns of type "risolto_statement_line_status_enum". All fields are combined with logical 'AND'. */
export type Risolto_Statement_Line_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Statement_Line_Status_Enum>;
  _in?: Maybe<Array<Risolto_Statement_Line_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Statement_Line_Status_Enum>;
  _nin?: Maybe<Array<Risolto_Statement_Line_Status_Enum>>;
};

/** input type for inserting data into table "risolto.statement_line_status" */
export type Risolto_Statement_Line_Status_Insert_Input = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Statement_Line_Status_Max_Fields = {
  __typename?: 'risolto_statement_line_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Statement_Line_Status_Min_Fields = {
  __typename?: 'risolto_statement_line_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.statement_line_status" */
export type Risolto_Statement_Line_Status_Mutation_Response = {
  __typename?: 'risolto_statement_line_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Statement_Line_Status>;
};

/** on_conflict condition type for table "risolto.statement_line_status" */
export type Risolto_Statement_Line_Status_On_Conflict = {
  constraint: Risolto_Statement_Line_Status_Constraint;
  update_columns?: Array<Risolto_Statement_Line_Status_Update_Column>;
  where?: Maybe<Risolto_Statement_Line_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.statement_line_status". */
export type Risolto_Statement_Line_Status_Order_By = {
  status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.statement_line_status */
export type Risolto_Statement_Line_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "risolto.statement_line_status" */
export enum Risolto_Statement_Line_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "risolto.statement_line_status" */
export type Risolto_Statement_Line_Status_Set_Input = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_statement_line_status" */
export type Risolto_Statement_Line_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Statement_Line_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Statement_Line_Status_Stream_Cursor_Value_Input = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.statement_line_status" */
export enum Risolto_Statement_Line_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Risolto_Statement_Line_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Statement_Line_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Statement_Line_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Risolto_Statement_Line_Stddev_Fields = {
  __typename?: 'risolto_statement_line_stddev_fields';
  transaction_credit_amount?: Maybe<Scalars['Float']>;
  transaction_debit_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Stddev_Order_By = {
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Statement_Line_Stddev_Pop_Fields = {
  __typename?: 'risolto_statement_line_stddev_pop_fields';
  transaction_credit_amount?: Maybe<Scalars['Float']>;
  transaction_debit_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Stddev_Pop_Order_By = {
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Statement_Line_Stddev_Samp_Fields = {
  __typename?: 'risolto_statement_line_stddev_samp_fields';
  transaction_credit_amount?: Maybe<Scalars['Float']>;
  transaction_debit_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Stddev_Samp_Order_By = {
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_statement_line" */
export type Risolto_Statement_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Statement_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Statement_Line_Stream_Cursor_Value_Input = {
  bank_transaction_code?: Maybe<Scalars['String']>;
  counterparty_account_number?: Maybe<Scalars['String']>;
  counterparty_account_number_type?: Maybe<Risolto_Account_Number_Type_Enum>;
  counterparty_address?: Maybe<Scalars['String']>;
  counterparty_bank_identifier?: Maybe<Scalars['String']>;
  counterparty_bank_identifier_type?: Maybe<Risolto_Bank_Identifier_Type_Enum>;
  counterparty_currency?: Maybe<Scalars['String']>;
  counterparty_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  external_id?: Maybe<Scalars['String']>;
  /** DEPRECATED. Will be removed in v1.1.0 */
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_transfer?: Maybe<Scalars['uuid']>;
  payment_transfer_lock?: Maybe<Scalars['timestamptz']>;
  /** Indicates whether the statement line was processed by the matcher. */
  processed_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  statement?: Maybe<Scalars['uuid']>;
  statement_account?: Maybe<Scalars['uuid']>;
  /** DEPRECATED. Will be removed in 2.0 */
  status?: Maybe<Risolto_Statement_Line_Status_Enum>;
  structured_message?: Maybe<Scalars['String']>;
  transaction_credit_amount?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_debit_amount?: Maybe<Scalars['numeric']>;
  transaction_reference?: Maybe<Scalars['String']>;
  unstructured_message?: Maybe<Scalars['String']>;
  unstructured_message_raw?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value_date?: Maybe<Scalars['date']>;
};

export type Risolto_Statement_Line_Structured_Match_Args = {
  q_legal_entity?: Maybe<Scalars['uuid']>;
  q_participant?: Maybe<Scalars['uuid']>;
  q_statement_line?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_Statement_Line_Sum_Fields = {
  __typename?: 'risolto_statement_line_sum_fields';
  transaction_credit_amount?: Maybe<Scalars['numeric']>;
  transaction_debit_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Sum_Order_By = {
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
};

export type Risolto_Statement_Line_Unstructured_Match_Args = {
  q_legal_entity?: Maybe<Scalars['uuid']>;
  q_participant?: Maybe<Scalars['uuid']>;
  q_statement_line?: Maybe<Scalars['uuid']>;
};

/** update columns of table "risolto.statement_line" */
export enum Risolto_Statement_Line_Update_Column {
  /** column name */
  BankTransactionCode = 'bank_transaction_code',
  /** column name */
  CounterpartyAccountNumber = 'counterparty_account_number',
  /** column name */
  CounterpartyAccountNumberType = 'counterparty_account_number_type',
  /** column name */
  CounterpartyAddress = 'counterparty_address',
  /** column name */
  CounterpartyBankIdentifier = 'counterparty_bank_identifier',
  /** column name */
  CounterpartyBankIdentifierType = 'counterparty_bank_identifier_type',
  /** column name */
  CounterpartyCurrency = 'counterparty_currency',
  /** column name */
  CounterpartyName = 'counterparty_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentTransfer = 'payment_transfer',
  /** column name */
  PaymentTransferLock = 'payment_transfer_lock',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Statement = 'statement',
  /** column name */
  StatementAccount = 'statement_account',
  /** column name */
  Status = 'status',
  /** column name */
  StructuredMessage = 'structured_message',
  /** column name */
  TransactionCreditAmount = 'transaction_credit_amount',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionDebitAmount = 'transaction_debit_amount',
  /** column name */
  TransactionReference = 'transaction_reference',
  /** column name */
  UnstructuredMessage = 'unstructured_message',
  /** column name */
  UnstructuredMessageRaw = 'unstructured_message_raw',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValueDate = 'value_date'
}

export type Risolto_Statement_Line_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Statement_Line_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Statement_Line_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Statement_Line_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Statement_Line_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Statement_Line_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Statement_Line_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Statement_Line_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Statement_Line_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Statement_Line_Var_Pop_Fields = {
  __typename?: 'risolto_statement_line_var_pop_fields';
  transaction_credit_amount?: Maybe<Scalars['Float']>;
  transaction_debit_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Var_Pop_Order_By = {
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Statement_Line_Var_Samp_Fields = {
  __typename?: 'risolto_statement_line_var_samp_fields';
  transaction_credit_amount?: Maybe<Scalars['Float']>;
  transaction_debit_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Var_Samp_Order_By = {
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Statement_Line_Variance_Fields = {
  __typename?: 'risolto_statement_line_variance_fields';
  transaction_credit_amount?: Maybe<Scalars['Float']>;
  transaction_debit_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.statement_line" */
export type Risolto_Statement_Line_Variance_Order_By = {
  transaction_credit_amount?: Maybe<Order_By>;
  transaction_debit_amount?: Maybe<Order_By>;
};

/** aggregate max on columns */
export type Risolto_Statement_Max_Fields = {
  __typename?: 'risolto_statement_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  raw?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Statement_Min_Fields = {
  __typename?: 'risolto_statement_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  raw?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.statement" */
export type Risolto_Statement_Mutation_Response = {
  __typename?: 'risolto_statement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Statement>;
};

/** input type for inserting object relation for remote table "risolto.statement" */
export type Risolto_Statement_Obj_Rel_Insert_Input = {
  data: Risolto_Statement_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Statement_On_Conflict>;
};

/** on_conflict condition type for table "risolto.statement" */
export type Risolto_Statement_On_Conflict = {
  constraint: Risolto_Statement_Constraint;
  update_columns?: Array<Risolto_Statement_Update_Column>;
  where?: Maybe<Risolto_Statement_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.statement". */
export type Risolto_Statement_Order_By = {
  created_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  raw?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  statement_lines_aggregate?: Maybe<Risolto_Statement_Line_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.statement */
export type Risolto_Statement_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.statement" */
export enum Risolto_Statement_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Raw = 'raw',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.statement" */
export type Risolto_Statement_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  raw?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_statement" */
export type Risolto_Statement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Statement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Statement_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  raw?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.statement" */
export enum Risolto_Statement_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Raw = 'raw',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Statement_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Statement_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Statement_Bool_Exp;
};

/** columns and relationships of "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb = {
  __typename?: 'risolto_strigil_nbb';
  created_at: Scalars['timestamptz'];
  custom_fields?: Maybe<Scalars['jsonb']>;
  data_uri?: Maybe<Scalars['String']>;
  last_attempt_at?: Maybe<Scalars['timestamptz']>;
  legal_id: Scalars['String'];
  legal_id_type: Scalars['String'];
  nace?: Maybe<Scalars['String']>;
  next_prediction?: Maybe<Scalars['date']>;
  processing_status?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Enum>;
  reference: Scalars['uuid'];
  score?: Maybe<Scalars['numeric']>;
  succeeded_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.strigil_nbb" */
export type Risolto_Strigil_NbbCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb_Aggregate = {
  __typename?: 'risolto_strigil_nbb_aggregate';
  aggregate?: Maybe<Risolto_Strigil_Nbb_Aggregate_Fields>;
  nodes: Array<Risolto_Strigil_Nbb>;
};

/** aggregate fields of "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb_Aggregate_Fields = {
  __typename?: 'risolto_strigil_nbb_aggregate_fields';
  avg?: Maybe<Risolto_Strigil_Nbb_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Strigil_Nbb_Max_Fields>;
  min?: Maybe<Risolto_Strigil_Nbb_Min_Fields>;
  stddev?: Maybe<Risolto_Strigil_Nbb_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Strigil_Nbb_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Strigil_Nbb_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Strigil_Nbb_Sum_Fields>;
  var_pop?: Maybe<Risolto_Strigil_Nbb_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Strigil_Nbb_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Strigil_Nbb_Variance_Fields>;
};


/** aggregate fields of "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Strigil_Nbb_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Strigil_Nbb_Append_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Risolto_Strigil_Nbb_Avg_Fields = {
  __typename?: 'risolto_strigil_nbb_avg_fields';
  score?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.strigil_nbb". All fields are combined with a logical 'AND'. */
export type Risolto_Strigil_Nbb_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Strigil_Nbb_Bool_Exp>>;
  _not?: Maybe<Risolto_Strigil_Nbb_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Strigil_Nbb_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  data_uri?: Maybe<String_Comparison_Exp>;
  last_attempt_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_id?: Maybe<String_Comparison_Exp>;
  legal_id_type?: Maybe<String_Comparison_Exp>;
  nace?: Maybe<String_Comparison_Exp>;
  next_prediction?: Maybe<Date_Comparison_Exp>;
  processing_status?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Enum_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  score?: Maybe<Numeric_Comparison_Exp>;
  succeeded_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.strigil_nbb" */
export enum Risolto_Strigil_Nbb_Constraint {
  /** unique or primary key constraint on columns "legal_id" */
  StrigilNbbLegalIdKey = 'strigil_nbb_legal_id_key',
  /** unique or primary key constraint on columns "reference" */
  StrigilNbbPkey = 'strigil_nbb_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Strigil_Nbb_Delete_At_Path_Input = {
  custom_fields?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Strigil_Nbb_Delete_Elem_Input = {
  custom_fields?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Strigil_Nbb_Delete_Key_Input = {
  custom_fields?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb_Inc_Input = {
  score?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  data_uri?: Maybe<Scalars['String']>;
  last_attempt_at?: Maybe<Scalars['timestamptz']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nace?: Maybe<Scalars['String']>;
  next_prediction?: Maybe<Scalars['date']>;
  processing_status?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['numeric']>;
  succeeded_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Strigil_Nbb_Max_Fields = {
  __typename?: 'risolto_strigil_nbb_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  data_uri?: Maybe<Scalars['String']>;
  last_attempt_at?: Maybe<Scalars['timestamptz']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nace?: Maybe<Scalars['String']>;
  next_prediction?: Maybe<Scalars['date']>;
  reference?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['numeric']>;
  succeeded_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Strigil_Nbb_Min_Fields = {
  __typename?: 'risolto_strigil_nbb_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  data_uri?: Maybe<Scalars['String']>;
  last_attempt_at?: Maybe<Scalars['timestamptz']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nace?: Maybe<Scalars['String']>;
  next_prediction?: Maybe<Scalars['date']>;
  reference?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['numeric']>;
  succeeded_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb_Mutation_Response = {
  __typename?: 'risolto_strigil_nbb_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Strigil_Nbb>;
};

/** on_conflict condition type for table "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb_On_Conflict = {
  constraint: Risolto_Strigil_Nbb_Constraint;
  update_columns?: Array<Risolto_Strigil_Nbb_Update_Column>;
  where?: Maybe<Risolto_Strigil_Nbb_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.strigil_nbb". */
export type Risolto_Strigil_Nbb_Order_By = {
  created_at?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  data_uri?: Maybe<Order_By>;
  last_attempt_at?: Maybe<Order_By>;
  legal_id?: Maybe<Order_By>;
  legal_id_type?: Maybe<Order_By>;
  nace?: Maybe<Order_By>;
  next_prediction?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  succeeded_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.strigil_nbb */
export type Risolto_Strigil_Nbb_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Strigil_Nbb_Prepend_Input = {
  custom_fields?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "risolto.strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status = {
  __typename?: 'risolto_strigil_nbb_processing_status';
  processing_status: Scalars['String'];
};

/** aggregated selection of "risolto.strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status_Aggregate = {
  __typename?: 'risolto_strigil_nbb_processing_status_aggregate';
  aggregate?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Strigil_Nbb_Processing_Status>;
};

/** aggregate fields of "risolto.strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status_Aggregate_Fields = {
  __typename?: 'risolto_strigil_nbb_processing_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Max_Fields>;
  min?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Min_Fields>;
};


/** aggregate fields of "risolto.strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.strigil_nbb_processing_status". All fields are combined with a logical 'AND'. */
export type Risolto_Strigil_Nbb_Processing_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>>;
  processing_status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.strigil_nbb_processing_status" */
export enum Risolto_Strigil_Nbb_Processing_Status_Constraint {
  /** unique or primary key constraint on columns "processing_status" */
  StrigilNbbProcessingStatusPkey = 'strigil_nbb_processing_status_pkey'
}

export enum Risolto_Strigil_Nbb_Processing_Status_Enum {
  Done = 'DONE',
  Processing = 'PROCESSING'
}

/** Boolean expression to compare columns of type "risolto_strigil_nbb_processing_status_enum". All fields are combined with logical 'AND'. */
export type Risolto_Strigil_Nbb_Processing_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Enum>;
  _in?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Enum>;
  _nin?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Enum>>;
};

/** input type for inserting data into table "risolto.strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status_Insert_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Strigil_Nbb_Processing_Status_Max_Fields = {
  __typename?: 'risolto_strigil_nbb_processing_status_max_fields';
  processing_status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Strigil_Nbb_Processing_Status_Min_Fields = {
  __typename?: 'risolto_strigil_nbb_processing_status_min_fields';
  processing_status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status_Mutation_Response = {
  __typename?: 'risolto_strigil_nbb_processing_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Strigil_Nbb_Processing_Status>;
};

/** on_conflict condition type for table "risolto.strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status_On_Conflict = {
  constraint: Risolto_Strigil_Nbb_Processing_Status_Constraint;
  update_columns?: Array<Risolto_Strigil_Nbb_Processing_Status_Update_Column>;
  where?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.strigil_nbb_processing_status". */
export type Risolto_Strigil_Nbb_Processing_Status_Order_By = {
  processing_status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.strigil_nbb_processing_status */
export type Risolto_Strigil_Nbb_Processing_Status_Pk_Columns_Input = {
  processing_status: Scalars['String'];
};

/** select columns of table "risolto.strigil_nbb_processing_status" */
export enum Risolto_Strigil_Nbb_Processing_Status_Select_Column {
  /** column name */
  ProcessingStatus = 'processing_status'
}

/** input type for updating data in table "risolto.strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status_Set_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_strigil_nbb_processing_status" */
export type Risolto_Strigil_Nbb_Processing_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Strigil_Nbb_Processing_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Strigil_Nbb_Processing_Status_Stream_Cursor_Value_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.strigil_nbb_processing_status" */
export enum Risolto_Strigil_Nbb_Processing_Status_Update_Column {
  /** column name */
  ProcessingStatus = 'processing_status'
}

export type Risolto_Strigil_Nbb_Processing_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Strigil_Nbb_Processing_Status_Bool_Exp;
};

/** select columns of table "risolto.strigil_nbb" */
export enum Risolto_Strigil_Nbb_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DataUri = 'data_uri',
  /** column name */
  LastAttemptAt = 'last_attempt_at',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  LegalIdType = 'legal_id_type',
  /** column name */
  Nace = 'nace',
  /** column name */
  NextPrediction = 'next_prediction',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Reference = 'reference',
  /** column name */
  Score = 'score',
  /** column name */
  SucceededAt = 'succeeded_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.strigil_nbb" */
export type Risolto_Strigil_Nbb_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  data_uri?: Maybe<Scalars['String']>;
  last_attempt_at?: Maybe<Scalars['timestamptz']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nace?: Maybe<Scalars['String']>;
  next_prediction?: Maybe<Scalars['date']>;
  processing_status?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['numeric']>;
  succeeded_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Risolto_Strigil_Nbb_Stddev_Fields = {
  __typename?: 'risolto_strigil_nbb_stddev_fields';
  score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Strigil_Nbb_Stddev_Pop_Fields = {
  __typename?: 'risolto_strigil_nbb_stddev_pop_fields';
  score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Strigil_Nbb_Stddev_Samp_Fields = {
  __typename?: 'risolto_strigil_nbb_stddev_samp_fields';
  score?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_strigil_nbb" */
export type Risolto_Strigil_Nbb_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Strigil_Nbb_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Strigil_Nbb_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  data_uri?: Maybe<Scalars['String']>;
  last_attempt_at?: Maybe<Scalars['timestamptz']>;
  legal_id?: Maybe<Scalars['String']>;
  legal_id_type?: Maybe<Scalars['String']>;
  nace?: Maybe<Scalars['String']>;
  next_prediction?: Maybe<Scalars['date']>;
  processing_status?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Enum>;
  reference?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['numeric']>;
  succeeded_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_Strigil_Nbb_Sum_Fields = {
  __typename?: 'risolto_strigil_nbb_sum_fields';
  score?: Maybe<Scalars['numeric']>;
};

/** update columns of table "risolto.strigil_nbb" */
export enum Risolto_Strigil_Nbb_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  DataUri = 'data_uri',
  /** column name */
  LastAttemptAt = 'last_attempt_at',
  /** column name */
  LegalId = 'legal_id',
  /** column name */
  LegalIdType = 'legal_id_type',
  /** column name */
  Nace = 'nace',
  /** column name */
  NextPrediction = 'next_prediction',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  Reference = 'reference',
  /** column name */
  Score = 'score',
  /** column name */
  SucceededAt = 'succeeded_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Strigil_Nbb_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Strigil_Nbb_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Strigil_Nbb_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Strigil_Nbb_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Strigil_Nbb_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Strigil_Nbb_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Strigil_Nbb_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Strigil_Nbb_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Strigil_Nbb_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Strigil_Nbb_Var_Pop_Fields = {
  __typename?: 'risolto_strigil_nbb_var_pop_fields';
  score?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Strigil_Nbb_Var_Samp_Fields = {
  __typename?: 'risolto_strigil_nbb_var_samp_fields';
  score?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Strigil_Nbb_Variance_Fields = {
  __typename?: 'risolto_strigil_nbb_variance_fields';
  score?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.system_integration" */
export type Risolto_System_Integration = {
  __typename?: 'risolto_system_integration';
  created_at: Scalars['timestamptz'];
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  external_system: Scalars['String'];
  external_system_identifier: Scalars['String'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.system_integration" */
export type Risolto_System_Integration_Aggregate = {
  __typename?: 'risolto_system_integration_aggregate';
  aggregate?: Maybe<Risolto_System_Integration_Aggregate_Fields>;
  nodes: Array<Risolto_System_Integration>;
};

export type Risolto_System_Integration_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_System_Integration_Aggregate_Bool_Exp_Count>;
};

export type Risolto_System_Integration_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_System_Integration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.system_integration" */
export type Risolto_System_Integration_Aggregate_Fields = {
  __typename?: 'risolto_system_integration_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_System_Integration_Max_Fields>;
  min?: Maybe<Risolto_System_Integration_Min_Fields>;
};


/** aggregate fields of "risolto.system_integration" */
export type Risolto_System_Integration_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.system_integration" */
export type Risolto_System_Integration_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_System_Integration_Max_Order_By>;
  min?: Maybe<Risolto_System_Integration_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.system_integration" */
export type Risolto_System_Integration_Arr_Rel_Insert_Input = {
  data: Array<Risolto_System_Integration_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_System_Integration_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.system_integration". All fields are combined with a logical 'AND'. */
export type Risolto_System_Integration_Bool_Exp = {
  _and?: Maybe<Array<Risolto_System_Integration_Bool_Exp>>;
  _not?: Maybe<Risolto_System_Integration_Bool_Exp>;
  _or?: Maybe<Array<Risolto_System_Integration_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: Maybe<Timestamptz_Comparison_Exp>;
  external_system?: Maybe<String_Comparison_Exp>;
  external_system_identifier?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.system_integration" */
export enum Risolto_System_Integration_Constraint {
  /** unique or primary key constraint on columns "external_system_identifier", "external_system", "participant", "legal_entity" */
  SystemIntegrationExternalSystemExternalSystemIdentifierP = 'system_integration_external_system_external_system_identifier_p',
  /** unique or primary key constraint on columns "reference" */
  SystemIntegrationPkey = 'system_integration_pkey'
}

/** input type for inserting data into table "risolto.system_integration" */
export type Risolto_System_Integration_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  external_system?: Maybe<Scalars['String']>;
  external_system_identifier?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_System_Integration_Max_Fields = {
  __typename?: 'risolto_system_integration_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  external_system?: Maybe<Scalars['String']>;
  external_system_identifier?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.system_integration" */
export type Risolto_System_Integration_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  external_system?: Maybe<Order_By>;
  external_system_identifier?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_System_Integration_Min_Fields = {
  __typename?: 'risolto_system_integration_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  external_system?: Maybe<Scalars['String']>;
  external_system_identifier?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.system_integration" */
export type Risolto_System_Integration_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  external_system?: Maybe<Order_By>;
  external_system_identifier?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.system_integration" */
export type Risolto_System_Integration_Mutation_Response = {
  __typename?: 'risolto_system_integration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_System_Integration>;
};

/** on_conflict condition type for table "risolto.system_integration" */
export type Risolto_System_Integration_On_Conflict = {
  constraint: Risolto_System_Integration_Constraint;
  update_columns?: Array<Risolto_System_Integration_Update_Column>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.system_integration". */
export type Risolto_System_Integration_Order_By = {
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  external_system?: Maybe<Order_By>;
  external_system_identifier?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.system_integration */
export type Risolto_System_Integration_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.system_integration" */
export enum Risolto_System_Integration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  ExternalSystem = 'external_system',
  /** column name */
  ExternalSystemIdentifier = 'external_system_identifier',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.system_integration" */
export type Risolto_System_Integration_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  external_system?: Maybe<Scalars['String']>;
  external_system_identifier?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_system_integration" */
export type Risolto_System_Integration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_System_Integration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_System_Integration_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  external_system?: Maybe<Scalars['String']>;
  external_system_identifier?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.system_integration" */
export enum Risolto_System_Integration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  ExternalSystem = 'external_system',
  /** column name */
  ExternalSystemIdentifier = 'external_system_identifier',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_System_Integration_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_System_Integration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_System_Integration_Bool_Exp;
};

/** columns and relationships of "risolto.tag" */
export type Risolto_Tag = {
  __typename?: 'risolto_tag';
  auto_mapping?: Maybe<Scalars['String']>;
  auto_tagging?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  is_active?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  reference: Scalars['uuid'];
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "risolto.tag" */
export type Risolto_Tag_Aggregate = {
  __typename?: 'risolto_tag_aggregate';
  aggregate?: Maybe<Risolto_Tag_Aggregate_Fields>;
  nodes: Array<Risolto_Tag>;
};

export type Risolto_Tag_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_Tag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_Tag_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_Tag_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Tag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_Tag_Select_Column_Risolto_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Tag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_Tag_Select_Column_Risolto_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.tag" */
export type Risolto_Tag_Aggregate_Fields = {
  __typename?: 'risolto_tag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Tag_Max_Fields>;
  min?: Maybe<Risolto_Tag_Min_Fields>;
};


/** aggregate fields of "risolto.tag" */
export type Risolto_Tag_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.tag" */
export type Risolto_Tag_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Tag_Max_Order_By>;
  min?: Maybe<Risolto_Tag_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.tag" */
export type Risolto_Tag_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Tag_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.tag". All fields are combined with a logical 'AND'. */
export type Risolto_Tag_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Tag_Bool_Exp>>;
  _not?: Maybe<Risolto_Tag_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Tag_Bool_Exp>>;
  auto_mapping?: Maybe<String_Comparison_Exp>;
  auto_tagging?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deactivated_at?: Maybe<Timestamptz_Comparison_Exp>;
  is_active?: Maybe<Boolean_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  tag?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.tag" */
export enum Risolto_Tag_Constraint {
  /** unique or primary key constraint on columns "tag" */
  TagDefaultTags = 'tag_default_tags',
  /** unique or primary key constraint on columns "participant", "tag" */
  TagParticipantTags = 'tag_participant_tags',
  /** unique or primary key constraint on columns "reference" */
  TagPkey = 'tag_pkey',
  /** unique or primary key constraint on columns "participant", "tag" */
  UniqueParticipantTag = 'unique_participant_tag'
}

/** input type for inserting data into table "risolto.tag" */
export type Risolto_Tag_Insert_Input = {
  auto_mapping?: Maybe<Scalars['String']>;
  auto_tagging?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Tag_Max_Fields = {
  __typename?: 'risolto_tag_max_fields';
  auto_mapping?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.tag" */
export type Risolto_Tag_Max_Order_By = {
  auto_mapping?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Tag_Min_Fields = {
  __typename?: 'risolto_tag_min_fields';
  auto_mapping?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.tag" */
export type Risolto_Tag_Min_Order_By = {
  auto_mapping?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.tag" */
export type Risolto_Tag_Mutation_Response = {
  __typename?: 'risolto_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Tag>;
};

/** input type for inserting object relation for remote table "risolto.tag" */
export type Risolto_Tag_Obj_Rel_Insert_Input = {
  data: Risolto_Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Tag_On_Conflict>;
};

/** on_conflict condition type for table "risolto.tag" */
export type Risolto_Tag_On_Conflict = {
  constraint: Risolto_Tag_Constraint;
  update_columns?: Array<Risolto_Tag_Update_Column>;
  where?: Maybe<Risolto_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.tag". */
export type Risolto_Tag_Order_By = {
  auto_mapping?: Maybe<Order_By>;
  auto_tagging?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deactivated_at?: Maybe<Order_By>;
  is_active?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.tag */
export type Risolto_Tag_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.tag" */
export enum Risolto_Tag_Select_Column {
  /** column name */
  AutoMapping = 'auto_mapping',
  /** column name */
  AutoTagging = 'auto_tagging',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "risolto_tag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.tag" */
export enum Risolto_Tag_Select_Column_Risolto_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutoTagging = 'auto_tagging'
}

/** select "risolto_tag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.tag" */
export enum Risolto_Tag_Select_Column_Risolto_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutoTagging = 'auto_tagging'
}

/** input type for updating data in table "risolto.tag" */
export type Risolto_Tag_Set_Input = {
  auto_mapping?: Maybe<Scalars['String']>;
  auto_tagging?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_tag" */
export type Risolto_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Tag_Stream_Cursor_Value_Input = {
  auto_mapping?: Maybe<Scalars['String']>;
  auto_tagging?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deactivated_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.tag" */
export enum Risolto_Tag_Update_Column {
  /** column name */
  AutoMapping = 'auto_mapping',
  /** column name */
  AutoTagging = 'auto_tagging',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeactivatedAt = 'deactivated_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Tag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Tag_Bool_Exp;
};

/** columns and relationships of "risolto.task" */
export type Risolto_Task = {
  __typename?: 'risolto_task';
  assignee?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  assignee_by_reference?: Maybe<Risolto_Person>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  canceled_by_by_reference?: Maybe<Risolto_Person>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_by_reference?: Maybe<Risolto_Person>;
  due_date: Scalars['date'];
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  executed_by_by_reference?: Maybe<Risolto_Person>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  /** An array relationship */
  notes: Array<Risolto_Note>;
  /** An aggregate relationship */
  notes_aggregate: Risolto_Note_Aggregate;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  snooze_until?: Maybe<Scalars['date']>;
  source: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.task" */
export type Risolto_TaskNotesArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


/** columns and relationships of "risolto.task" */
export type Risolto_TaskNotes_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};

/** aggregated selection of "risolto.task" */
export type Risolto_Task_Aggregate = {
  __typename?: 'risolto_task_aggregate';
  aggregate?: Maybe<Risolto_Task_Aggregate_Fields>;
  nodes: Array<Risolto_Task>;
};

export type Risolto_Task_Aggregate_Bool_Exp = {
  count?: Maybe<Risolto_Task_Aggregate_Bool_Exp_Count>;
};

export type Risolto_Task_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_Task_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.task" */
export type Risolto_Task_Aggregate_Fields = {
  __typename?: 'risolto_task_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Task_Max_Fields>;
  min?: Maybe<Risolto_Task_Min_Fields>;
};


/** aggregate fields of "risolto.task" */
export type Risolto_Task_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Task_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.task" */
export type Risolto_Task_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Task_Max_Order_By>;
  min?: Maybe<Risolto_Task_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.task" */
export type Risolto_Task_Arr_Rel_Insert_Input = {
  data: Array<Risolto_Task_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Task_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risolto.task". All fields are combined with a logical 'AND'. */
export type Risolto_Task_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Task_Bool_Exp>>;
  _not?: Maybe<Risolto_Task_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Task_Bool_Exp>>;
  assignee?: Maybe<Uuid_Comparison_Exp>;
  assignee_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  canceled_at?: Maybe<Timestamptz_Comparison_Exp>;
  canceled_by?: Maybe<Uuid_Comparison_Exp>;
  canceled_by_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  executed_at?: Maybe<Timestamptz_Comparison_Exp>;
  executed_by?: Maybe<Uuid_Comparison_Exp>;
  executed_by_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  invoice_dispute?: Maybe<Uuid_Comparison_Exp>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  notes?: Maybe<Risolto_Note_Bool_Exp>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  snooze_until?: Maybe<Date_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.task" */
export enum Risolto_Task_Constraint {
  /** unique or primary key constraint on columns "reference" */
  TaskPkey = 'task_pkey'
}

/** input type for inserting data into table "risolto.task" */
export type Risolto_Task_Insert_Input = {
  assignee?: Maybe<Scalars['uuid']>;
  assignee_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  canceled_by_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  due_date?: Maybe<Scalars['date']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  executed_by_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  notes?: Maybe<Risolto_Note_Arr_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  snooze_until?: Maybe<Scalars['date']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Task_Max_Fields = {
  __typename?: 'risolto_task_max_fields';
  assignee?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  due_date?: Maybe<Scalars['date']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  snooze_until?: Maybe<Scalars['date']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "risolto.task" */
export type Risolto_Task_Max_Order_By = {
  assignee?: Maybe<Order_By>;
  canceled_at?: Maybe<Order_By>;
  canceled_by?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  executed_at?: Maybe<Order_By>;
  executed_by?: Maybe<Order_By>;
  invoice_dispute?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  snooze_until?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Task_Min_Fields = {
  __typename?: 'risolto_task_min_fields';
  assignee?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  due_date?: Maybe<Scalars['date']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  snooze_until?: Maybe<Scalars['date']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "risolto.task" */
export type Risolto_Task_Min_Order_By = {
  assignee?: Maybe<Order_By>;
  canceled_at?: Maybe<Order_By>;
  canceled_by?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  executed_at?: Maybe<Order_By>;
  executed_by?: Maybe<Order_By>;
  invoice_dispute?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  snooze_until?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.task" */
export type Risolto_Task_Mutation_Response = {
  __typename?: 'risolto_task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Task>;
};

/** input type for inserting object relation for remote table "risolto.task" */
export type Risolto_Task_Obj_Rel_Insert_Input = {
  data: Risolto_Task_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Risolto_Task_On_Conflict>;
};

/** on_conflict condition type for table "risolto.task" */
export type Risolto_Task_On_Conflict = {
  constraint: Risolto_Task_Constraint;
  update_columns?: Array<Risolto_Task_Update_Column>;
  where?: Maybe<Risolto_Task_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.task". */
export type Risolto_Task_Order_By = {
  assignee?: Maybe<Order_By>;
  assignee_by_reference?: Maybe<Risolto_Person_Order_By>;
  canceled_at?: Maybe<Order_By>;
  canceled_by?: Maybe<Order_By>;
  canceled_by_by_reference?: Maybe<Risolto_Person_Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_by_reference?: Maybe<Risolto_Person_Order_By>;
  due_date?: Maybe<Order_By>;
  executed_at?: Maybe<Order_By>;
  executed_by?: Maybe<Order_By>;
  executed_by_by_reference?: Maybe<Risolto_Person_Order_By>;
  invoice_dispute?: Maybe<Order_By>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  notes_aggregate?: Maybe<Risolto_Note_Aggregate_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  snooze_until?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.task */
export type Risolto_Task_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** select columns of table "risolto.task" */
export enum Risolto_Task_Select_Column {
  /** column name */
  Assignee = 'assignee',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledBy = 'canceled_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExecutedAt = 'executed_at',
  /** column name */
  ExecutedBy = 'executed_by',
  /** column name */
  InvoiceDispute = 'invoice_dispute',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  SnoozeUntil = 'snooze_until',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.task" */
export type Risolto_Task_Set_Input = {
  assignee?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  due_date?: Maybe<Scalars['date']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  snooze_until?: Maybe<Scalars['date']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.task_source" */
export type Risolto_Task_Source = {
  __typename?: 'risolto_task_source';
  source: Scalars['String'];
};

/** aggregated selection of "risolto.task_source" */
export type Risolto_Task_Source_Aggregate = {
  __typename?: 'risolto_task_source_aggregate';
  aggregate?: Maybe<Risolto_Task_Source_Aggregate_Fields>;
  nodes: Array<Risolto_Task_Source>;
};

/** aggregate fields of "risolto.task_source" */
export type Risolto_Task_Source_Aggregate_Fields = {
  __typename?: 'risolto_task_source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Task_Source_Max_Fields>;
  min?: Maybe<Risolto_Task_Source_Min_Fields>;
};


/** aggregate fields of "risolto.task_source" */
export type Risolto_Task_Source_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Task_Source_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.task_source". All fields are combined with a logical 'AND'. */
export type Risolto_Task_Source_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Task_Source_Bool_Exp>>;
  _not?: Maybe<Risolto_Task_Source_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Task_Source_Bool_Exp>>;
  source?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.task_source" */
export enum Risolto_Task_Source_Constraint {
  /** unique or primary key constraint on columns "source" */
  TaskSourcePkey = 'task_source_pkey'
}

/** input type for inserting data into table "risolto.task_source" */
export type Risolto_Task_Source_Insert_Input = {
  source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Task_Source_Max_Fields = {
  __typename?: 'risolto_task_source_max_fields';
  source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Task_Source_Min_Fields = {
  __typename?: 'risolto_task_source_min_fields';
  source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.task_source" */
export type Risolto_Task_Source_Mutation_Response = {
  __typename?: 'risolto_task_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Task_Source>;
};

/** on_conflict condition type for table "risolto.task_source" */
export type Risolto_Task_Source_On_Conflict = {
  constraint: Risolto_Task_Source_Constraint;
  update_columns?: Array<Risolto_Task_Source_Update_Column>;
  where?: Maybe<Risolto_Task_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.task_source". */
export type Risolto_Task_Source_Order_By = {
  source?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.task_source */
export type Risolto_Task_Source_Pk_Columns_Input = {
  source: Scalars['String'];
};

/** select columns of table "risolto.task_source" */
export enum Risolto_Task_Source_Select_Column {
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "risolto.task_source" */
export type Risolto_Task_Source_Set_Input = {
  source?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_task_source" */
export type Risolto_Task_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Task_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Task_Source_Stream_Cursor_Value_Input = {
  source?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.task_source" */
export enum Risolto_Task_Source_Update_Column {
  /** column name */
  Source = 'source'
}

export type Risolto_Task_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Task_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Task_Source_Bool_Exp;
};

/** columns and relationships of "risolto.task_status" */
export type Risolto_Task_Status = {
  __typename?: 'risolto_task_status';
  status: Scalars['String'];
};

/** aggregated selection of "risolto.task_status" */
export type Risolto_Task_Status_Aggregate = {
  __typename?: 'risolto_task_status_aggregate';
  aggregate?: Maybe<Risolto_Task_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Task_Status>;
};

/** aggregate fields of "risolto.task_status" */
export type Risolto_Task_Status_Aggregate_Fields = {
  __typename?: 'risolto_task_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Task_Status_Max_Fields>;
  min?: Maybe<Risolto_Task_Status_Min_Fields>;
};


/** aggregate fields of "risolto.task_status" */
export type Risolto_Task_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Task_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.task_status". All fields are combined with a logical 'AND'. */
export type Risolto_Task_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Task_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Task_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Task_Status_Bool_Exp>>;
  status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.task_status" */
export enum Risolto_Task_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  TaskStatusPkey = 'task_status_pkey'
}

/** input type for inserting data into table "risolto.task_status" */
export type Risolto_Task_Status_Insert_Input = {
  status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Task_Status_Max_Fields = {
  __typename?: 'risolto_task_status_max_fields';
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Task_Status_Min_Fields = {
  __typename?: 'risolto_task_status_min_fields';
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.task_status" */
export type Risolto_Task_Status_Mutation_Response = {
  __typename?: 'risolto_task_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Task_Status>;
};

/** on_conflict condition type for table "risolto.task_status" */
export type Risolto_Task_Status_On_Conflict = {
  constraint: Risolto_Task_Status_Constraint;
  update_columns?: Array<Risolto_Task_Status_Update_Column>;
  where?: Maybe<Risolto_Task_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.task_status". */
export type Risolto_Task_Status_Order_By = {
  status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.task_status */
export type Risolto_Task_Status_Pk_Columns_Input = {
  status: Scalars['String'];
};

/** select columns of table "risolto.task_status" */
export enum Risolto_Task_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "risolto.task_status" */
export type Risolto_Task_Status_Set_Input = {
  status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_task_status" */
export type Risolto_Task_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Task_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Task_Status_Stream_Cursor_Value_Input = {
  status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.task_status" */
export enum Risolto_Task_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Risolto_Task_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Task_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Task_Status_Bool_Exp;
};

/** Streaming cursor of the table "risolto_task" */
export type Risolto_Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Task_Stream_Cursor_Value_Input = {
  assignee?: Maybe<Scalars['uuid']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  canceled_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  due_date?: Maybe<Scalars['date']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  snooze_until?: Maybe<Scalars['date']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "risolto.task_type" */
export type Risolto_Task_Type = {
  __typename?: 'risolto_task_type';
  type: Scalars['String'];
};

/** aggregated selection of "risolto.task_type" */
export type Risolto_Task_Type_Aggregate = {
  __typename?: 'risolto_task_type_aggregate';
  aggregate?: Maybe<Risolto_Task_Type_Aggregate_Fields>;
  nodes: Array<Risolto_Task_Type>;
};

/** aggregate fields of "risolto.task_type" */
export type Risolto_Task_Type_Aggregate_Fields = {
  __typename?: 'risolto_task_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Task_Type_Max_Fields>;
  min?: Maybe<Risolto_Task_Type_Min_Fields>;
};


/** aggregate fields of "risolto.task_type" */
export type Risolto_Task_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Task_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.task_type". All fields are combined with a logical 'AND'. */
export type Risolto_Task_Type_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Task_Type_Bool_Exp>>;
  _not?: Maybe<Risolto_Task_Type_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Task_Type_Bool_Exp>>;
  type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.task_type" */
export enum Risolto_Task_Type_Constraint {
  /** unique or primary key constraint on columns "type" */
  TaskTypePkey = 'task_type_pkey'
}

/** input type for inserting data into table "risolto.task_type" */
export type Risolto_Task_Type_Insert_Input = {
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Task_Type_Max_Fields = {
  __typename?: 'risolto_task_type_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Task_Type_Min_Fields = {
  __typename?: 'risolto_task_type_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.task_type" */
export type Risolto_Task_Type_Mutation_Response = {
  __typename?: 'risolto_task_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Task_Type>;
};

/** on_conflict condition type for table "risolto.task_type" */
export type Risolto_Task_Type_On_Conflict = {
  constraint: Risolto_Task_Type_Constraint;
  update_columns?: Array<Risolto_Task_Type_Update_Column>;
  where?: Maybe<Risolto_Task_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.task_type". */
export type Risolto_Task_Type_Order_By = {
  type?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.task_type */
export type Risolto_Task_Type_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "risolto.task_type" */
export enum Risolto_Task_Type_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "risolto.task_type" */
export type Risolto_Task_Type_Set_Input = {
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_task_type" */
export type Risolto_Task_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Task_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Task_Type_Stream_Cursor_Value_Input = {
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.task_type" */
export enum Risolto_Task_Type_Update_Column {
  /** column name */
  Type = 'type'
}

export type Risolto_Task_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Task_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Task_Type_Bool_Exp;
};

/** update columns of table "risolto.task" */
export enum Risolto_Task_Update_Column {
  /** column name */
  Assignee = 'assignee',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CanceledBy = 'canceled_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExecutedAt = 'executed_at',
  /** column name */
  ExecutedBy = 'executed_by',
  /** column name */
  InvoiceDispute = 'invoice_dispute',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  SnoozeUntil = 'snooze_until',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Task_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Task_Bool_Exp;
};

/** columns and relationships of "risolto.tone_of_voice" */
export type Risolto_Tone_Of_Voice = {
  __typename?: 'risolto_tone_of_voice';
  tone_of_voice: Scalars['String'];
};

/** aggregated selection of "risolto.tone_of_voice" */
export type Risolto_Tone_Of_Voice_Aggregate = {
  __typename?: 'risolto_tone_of_voice_aggregate';
  aggregate?: Maybe<Risolto_Tone_Of_Voice_Aggregate_Fields>;
  nodes: Array<Risolto_Tone_Of_Voice>;
};

/** aggregate fields of "risolto.tone_of_voice" */
export type Risolto_Tone_Of_Voice_Aggregate_Fields = {
  __typename?: 'risolto_tone_of_voice_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Tone_Of_Voice_Max_Fields>;
  min?: Maybe<Risolto_Tone_Of_Voice_Min_Fields>;
};


/** aggregate fields of "risolto.tone_of_voice" */
export type Risolto_Tone_Of_Voice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Tone_Of_Voice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.tone_of_voice". All fields are combined with a logical 'AND'. */
export type Risolto_Tone_Of_Voice_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Tone_Of_Voice_Bool_Exp>>;
  _not?: Maybe<Risolto_Tone_Of_Voice_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Tone_Of_Voice_Bool_Exp>>;
  tone_of_voice?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.tone_of_voice" */
export enum Risolto_Tone_Of_Voice_Constraint {
  /** unique or primary key constraint on columns "tone_of_voice" */
  ToneOfVoicePkey = 'tone_of_voice_pkey'
}

export enum Risolto_Tone_Of_Voice_Enum {
  Friendly = 'FRIENDLY'
}

/** Boolean expression to compare columns of type "risolto_tone_of_voice_enum". All fields are combined with logical 'AND'. */
export type Risolto_Tone_Of_Voice_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Tone_Of_Voice_Enum>;
  _in?: Maybe<Array<Risolto_Tone_Of_Voice_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Tone_Of_Voice_Enum>;
  _nin?: Maybe<Array<Risolto_Tone_Of_Voice_Enum>>;
};

/** input type for inserting data into table "risolto.tone_of_voice" */
export type Risolto_Tone_Of_Voice_Insert_Input = {
  tone_of_voice?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Tone_Of_Voice_Max_Fields = {
  __typename?: 'risolto_tone_of_voice_max_fields';
  tone_of_voice?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Tone_Of_Voice_Min_Fields = {
  __typename?: 'risolto_tone_of_voice_min_fields';
  tone_of_voice?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.tone_of_voice" */
export type Risolto_Tone_Of_Voice_Mutation_Response = {
  __typename?: 'risolto_tone_of_voice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Tone_Of_Voice>;
};

/** on_conflict condition type for table "risolto.tone_of_voice" */
export type Risolto_Tone_Of_Voice_On_Conflict = {
  constraint: Risolto_Tone_Of_Voice_Constraint;
  update_columns?: Array<Risolto_Tone_Of_Voice_Update_Column>;
  where?: Maybe<Risolto_Tone_Of_Voice_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.tone_of_voice". */
export type Risolto_Tone_Of_Voice_Order_By = {
  tone_of_voice?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.tone_of_voice */
export type Risolto_Tone_Of_Voice_Pk_Columns_Input = {
  tone_of_voice: Scalars['String'];
};

/** select columns of table "risolto.tone_of_voice" */
export enum Risolto_Tone_Of_Voice_Select_Column {
  /** column name */
  ToneOfVoice = 'tone_of_voice'
}

/** input type for updating data in table "risolto.tone_of_voice" */
export type Risolto_Tone_Of_Voice_Set_Input = {
  tone_of_voice?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_tone_of_voice" */
export type Risolto_Tone_Of_Voice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Tone_Of_Voice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Tone_Of_Voice_Stream_Cursor_Value_Input = {
  tone_of_voice?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.tone_of_voice" */
export enum Risolto_Tone_Of_Voice_Update_Column {
  /** column name */
  ToneOfVoice = 'tone_of_voice'
}

export type Risolto_Tone_Of_Voice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Tone_Of_Voice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Tone_Of_Voice_Bool_Exp;
};

/** columns and relationships of "risolto.view_action_and_message" */
export type Risolto_View_Action_And_Message = {
  __typename?: 'risolto_view_action_and_message';
  action?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  action_by_reference?: Maybe<Risolto_Action>;
  archived_at?: Maybe<Scalars['timestamptz']>;
  assignee?: Maybe<Scalars['uuid']>;
  direction?: Maybe<Scalars['String']>;
  execution_type?: Maybe<Scalars['String']>;
  from_?: Maybe<Scalars['String']>;
  is_linked?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  message?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  message_by_reference?: Maybe<Risolto_Message>;
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  received_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.view_action_and_message" */
export type Risolto_View_Action_And_MessageMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

export type Risolto_View_Action_And_Message_Aggregate = {
  __typename?: 'risolto_view_action_and_message_aggregate';
  aggregate?: Maybe<Risolto_View_Action_And_Message_Aggregate_Fields>;
  nodes: Array<Risolto_View_Action_And_Message>;
};

/** aggregate fields of "risolto.view_action_and_message" */
export type Risolto_View_Action_And_Message_Aggregate_Fields = {
  __typename?: 'risolto_view_action_and_message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Action_And_Message_Max_Fields>;
  min?: Maybe<Risolto_View_Action_And_Message_Min_Fields>;
};


/** aggregate fields of "risolto.view_action_and_message" */
export type Risolto_View_Action_And_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.view_action_and_message". All fields are combined with a logical 'AND'. */
export type Risolto_View_Action_And_Message_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Action_And_Message_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Action_And_Message_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  archived_at?: Maybe<Timestamptz_Comparison_Exp>;
  assignee?: Maybe<Uuid_Comparison_Exp>;
  direction?: Maybe<String_Comparison_Exp>;
  execution_type?: Maybe<String_Comparison_Exp>;
  from_?: Maybe<String_Comparison_Exp>;
  is_linked?: Maybe<Boolean_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message?: Maybe<Uuid_Comparison_Exp>;
  message_by_reference?: Maybe<Risolto_Message_Bool_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  received_at?: Maybe<Timestamptz_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  subject?: Maybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_View_Action_And_Message_Max_Fields = {
  __typename?: 'risolto_view_action_and_message_max_fields';
  action?: Maybe<Scalars['uuid']>;
  archived_at?: Maybe<Scalars['timestamptz']>;
  assignee?: Maybe<Scalars['uuid']>;
  direction?: Maybe<Scalars['String']>;
  execution_type?: Maybe<Scalars['String']>;
  from_?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_View_Action_And_Message_Min_Fields = {
  __typename?: 'risolto_view_action_and_message_min_fields';
  action?: Maybe<Scalars['uuid']>;
  archived_at?: Maybe<Scalars['timestamptz']>;
  assignee?: Maybe<Scalars['uuid']>;
  direction?: Maybe<Scalars['String']>;
  execution_type?: Maybe<Scalars['String']>;
  from_?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "risolto.view_action_and_message". */
export type Risolto_View_Action_And_Message_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  archived_at?: Maybe<Order_By>;
  assignee?: Maybe<Order_By>;
  direction?: Maybe<Order_By>;
  execution_type?: Maybe<Order_By>;
  from_?: Maybe<Order_By>;
  is_linked?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message?: Maybe<Order_By>;
  message_by_reference?: Maybe<Risolto_Message_Order_By>;
  metadata?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  received_at?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  subject?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_action_and_message" */
export enum Risolto_View_Action_And_Message_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ArchivedAt = 'archived_at',
  /** column name */
  Assignee = 'assignee',
  /** column name */
  Direction = 'direction',
  /** column name */
  ExecutionType = 'execution_type',
  /** column name */
  From = 'from_',
  /** column name */
  IsLinked = 'is_linked',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Participant = 'participant',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Subject = 'subject'
}

/** Streaming cursor of the table "risolto_view_action_and_message" */
export type Risolto_View_Action_And_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Action_And_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Action_And_Message_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  archived_at?: Maybe<Scalars['timestamptz']>;
  assignee?: Maybe<Scalars['uuid']>;
  direction?: Maybe<Scalars['String']>;
  execution_type?: Maybe<Scalars['String']>;
  from_?: Maybe<Scalars['String']>;
  is_linked?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamptz']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  subject?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.view_credit_limit" */
export type Risolto_View_Credit_Limit = {
  __typename?: 'risolto_view_credit_limit';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "risolto.view_credit_limit" */
export type Risolto_View_Credit_LimitCustom_FieldsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.view_credit_limit" */
export type Risolto_View_Credit_Limit_Aggregate = {
  __typename?: 'risolto_view_credit_limit_aggregate';
  aggregate?: Maybe<Risolto_View_Credit_Limit_Aggregate_Fields>;
  nodes: Array<Risolto_View_Credit_Limit>;
};

/** aggregate fields of "risolto.view_credit_limit" */
export type Risolto_View_Credit_Limit_Aggregate_Fields = {
  __typename?: 'risolto_view_credit_limit_aggregate_fields';
  avg?: Maybe<Risolto_View_Credit_Limit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Credit_Limit_Max_Fields>;
  min?: Maybe<Risolto_View_Credit_Limit_Min_Fields>;
  stddev?: Maybe<Risolto_View_Credit_Limit_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_View_Credit_Limit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_View_Credit_Limit_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_View_Credit_Limit_Sum_Fields>;
  var_pop?: Maybe<Risolto_View_Credit_Limit_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_View_Credit_Limit_Var_Samp_Fields>;
  variance?: Maybe<Risolto_View_Credit_Limit_Variance_Fields>;
};


/** aggregate fields of "risolto.view_credit_limit" */
export type Risolto_View_Credit_Limit_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Credit_Limit_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_View_Credit_Limit_Avg_Fields = {
  __typename?: 'risolto_view_credit_limit_avg_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.view_credit_limit". All fields are combined with a logical 'AND'. */
export type Risolto_View_Credit_Limit_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Credit_Limit_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Credit_Limit_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Credit_Limit_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  credit_limit?: Maybe<Numeric_Comparison_Exp>;
  credit_limit_type?: Maybe<String_Comparison_Exp>;
  custom_fields?: Maybe<Jsonb_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  until?: Maybe<Timestamptz_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_View_Credit_Limit_Max_Fields = {
  __typename?: 'risolto_view_credit_limit_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_View_Credit_Limit_Min_Fields = {
  __typename?: 'risolto_view_credit_limit_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "risolto.view_credit_limit". */
export type Risolto_View_Credit_Limit_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  credit_limit?: Maybe<Order_By>;
  credit_limit_type?: Maybe<Order_By>;
  custom_fields?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  until?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_credit_limit" */
export enum Risolto_View_Credit_Limit_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreditLimit = 'credit_limit',
  /** column name */
  CreditLimitType = 'credit_limit_type',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Until = 'until',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Risolto_View_Credit_Limit_Stddev_Fields = {
  __typename?: 'risolto_view_credit_limit_stddev_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_View_Credit_Limit_Stddev_Pop_Fields = {
  __typename?: 'risolto_view_credit_limit_stddev_pop_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_View_Credit_Limit_Stddev_Samp_Fields = {
  __typename?: 'risolto_view_credit_limit_stddev_samp_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_view_credit_limit" */
export type Risolto_View_Credit_Limit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Credit_Limit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Credit_Limit_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  credit_limit?: Maybe<Scalars['numeric']>;
  credit_limit_type?: Maybe<Scalars['String']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  until?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Risolto_View_Credit_Limit_Sum_Fields = {
  __typename?: 'risolto_view_credit_limit_sum_fields';
  credit_limit?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Risolto_View_Credit_Limit_Var_Pop_Fields = {
  __typename?: 'risolto_view_credit_limit_var_pop_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_View_Credit_Limit_Var_Samp_Fields = {
  __typename?: 'risolto_view_credit_limit_var_samp_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_View_Credit_Limit_Variance_Fields = {
  __typename?: 'risolto_view_credit_limit_variance_fields';
  credit_limit?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.view_dashboard_aging_debt" */
export type Risolto_View_Dashboard_Aging_Debt = {
  __typename?: 'risolto_view_dashboard_aging_debt';
  aging_bucket?: Maybe<Scalars['String']>;
  amount_paid?: Maybe<Scalars['numeric']>;
  issue_month_year?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "risolto.view_dashboard_aging_debt" */
export type Risolto_View_Dashboard_Aging_Debt_Aggregate = {
  __typename?: 'risolto_view_dashboard_aging_debt_aggregate';
  aggregate?: Maybe<Risolto_View_Dashboard_Aging_Debt_Aggregate_Fields>;
  nodes: Array<Risolto_View_Dashboard_Aging_Debt>;
};

/** aggregate fields of "risolto.view_dashboard_aging_debt" */
export type Risolto_View_Dashboard_Aging_Debt_Aggregate_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_aggregate_fields';
  avg?: Maybe<Risolto_View_Dashboard_Aging_Debt_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Dashboard_Aging_Debt_Max_Fields>;
  min?: Maybe<Risolto_View_Dashboard_Aging_Debt_Min_Fields>;
  stddev?: Maybe<Risolto_View_Dashboard_Aging_Debt_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_View_Dashboard_Aging_Debt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_View_Dashboard_Aging_Debt_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_View_Dashboard_Aging_Debt_Sum_Fields>;
  var_pop?: Maybe<Risolto_View_Dashboard_Aging_Debt_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_View_Dashboard_Aging_Debt_Var_Samp_Fields>;
  variance?: Maybe<Risolto_View_Dashboard_Aging_Debt_Variance_Fields>;
};


/** aggregate fields of "risolto.view_dashboard_aging_debt" */
export type Risolto_View_Dashboard_Aging_Debt_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_View_Dashboard_Aging_Debt_Avg_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_avg_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.view_dashboard_aging_debt". All fields are combined with a logical 'AND'. */
export type Risolto_View_Dashboard_Aging_Debt_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Dashboard_Aging_Debt_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Bool_Exp>>;
  aging_bucket?: Maybe<String_Comparison_Exp>;
  amount_paid?: Maybe<Numeric_Comparison_Exp>;
  issue_month_year?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_View_Dashboard_Aging_Debt_Max_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_max_fields';
  aging_bucket?: Maybe<Scalars['String']>;
  amount_paid?: Maybe<Scalars['numeric']>;
  issue_month_year?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_View_Dashboard_Aging_Debt_Min_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_min_fields';
  aging_bucket?: Maybe<Scalars['String']>;
  amount_paid?: Maybe<Scalars['numeric']>;
  issue_month_year?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "risolto.view_dashboard_aging_debt". */
export type Risolto_View_Dashboard_Aging_Debt_Order_By = {
  aging_bucket?: Maybe<Order_By>;
  amount_paid?: Maybe<Order_By>;
  issue_month_year?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_dashboard_aging_debt" */
export enum Risolto_View_Dashboard_Aging_Debt_Select_Column {
  /** column name */
  AgingBucket = 'aging_bucket',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  IssueMonthYear = 'issue_month_year',
  /** column name */
  Participant = 'participant'
}

/** aggregate stddev on columns */
export type Risolto_View_Dashboard_Aging_Debt_Stddev_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_stddev_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_View_Dashboard_Aging_Debt_Stddev_Pop_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_stddev_pop_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_View_Dashboard_Aging_Debt_Stddev_Samp_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_stddev_samp_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_view_dashboard_aging_debt" */
export type Risolto_View_Dashboard_Aging_Debt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Dashboard_Aging_Debt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Dashboard_Aging_Debt_Stream_Cursor_Value_Input = {
  aging_bucket?: Maybe<Scalars['String']>;
  amount_paid?: Maybe<Scalars['numeric']>;
  issue_month_year?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_View_Dashboard_Aging_Debt_Sum_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_sum_fields';
  amount_paid?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Risolto_View_Dashboard_Aging_Debt_Var_Pop_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_var_pop_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_View_Dashboard_Aging_Debt_Var_Samp_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_var_samp_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_View_Dashboard_Aging_Debt_Variance_Fields = {
  __typename?: 'risolto_view_dashboard_aging_debt_variance_fields';
  amount_paid?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.view_dashboard_percentage_paying_within_30_days" */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days';
  invoice_count?: Maybe<Scalars['bigint']>;
  issue_month_year?: Maybe<Scalars['String']>;
  paid_over_30_days_after_issue_date?: Maybe<Scalars['Boolean']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "risolto.view_dashboard_percentage_paying_within_30_days" */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Aggregate = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_aggregate';
  aggregate?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Aggregate_Fields>;
  nodes: Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days>;
};

/** aggregate fields of "risolto.view_dashboard_percentage_paying_within_30_days" */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Aggregate_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_aggregate_fields';
  avg?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Max_Fields>;
  min?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Min_Fields>;
  stddev?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Sum_Fields>;
  var_pop?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Var_Samp_Fields>;
  variance?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Variance_Fields>;
};


/** aggregate fields of "risolto.view_dashboard_percentage_paying_within_30_days" */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Avg_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_avg_fields';
  invoice_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.view_dashboard_percentage_paying_within_30_days". All fields are combined with a logical 'AND'. */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp>>;
  invoice_count?: Maybe<Bigint_Comparison_Exp>;
  issue_month_year?: Maybe<String_Comparison_Exp>;
  paid_over_30_days_after_issue_date?: Maybe<Boolean_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Max_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_max_fields';
  invoice_count?: Maybe<Scalars['bigint']>;
  issue_month_year?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Min_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_min_fields';
  invoice_count?: Maybe<Scalars['bigint']>;
  issue_month_year?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "risolto.view_dashboard_percentage_paying_within_30_days". */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Order_By = {
  invoice_count?: Maybe<Order_By>;
  issue_month_year?: Maybe<Order_By>;
  paid_over_30_days_after_issue_date?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_dashboard_percentage_paying_within_30_days" */
export enum Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Select_Column {
  /** column name */
  InvoiceCount = 'invoice_count',
  /** column name */
  IssueMonthYear = 'issue_month_year',
  /** column name */
  PaidOver_30DaysAfterIssueDate = 'paid_over_30_days_after_issue_date',
  /** column name */
  Participant = 'participant'
}

/** aggregate stddev on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stddev_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_stddev_fields';
  invoice_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stddev_Pop_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_stddev_pop_fields';
  invoice_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stddev_Samp_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_stddev_samp_fields';
  invoice_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_view_dashboard_percentage_paying_within_30_days" */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stream_Cursor_Value_Input = {
  invoice_count?: Maybe<Scalars['bigint']>;
  issue_month_year?: Maybe<Scalars['String']>;
  paid_over_30_days_after_issue_date?: Maybe<Scalars['Boolean']>;
  participant?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Sum_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_sum_fields';
  invoice_count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Var_Pop_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_var_pop_fields';
  invoice_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Var_Samp_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_var_samp_fields';
  invoice_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Variance_Fields = {
  __typename?: 'risolto_view_dashboard_percentage_paying_within_30_days_variance_fields';
  invoice_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.view_dunning_notice_action_6m" */
export type Risolto_View_Dunning_Notice_Action_6m = {
  __typename?: 'risolto_view_dunning_notice_action_6m';
  account_id?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  debtor_legal_id?: Maybe<Scalars['String']>;
  debtor_legal_id_type?: Maybe<Scalars['String']>;
  debtor_type?: Maybe<Scalars['String']>;
  document_due_date?: Maybe<Scalars['date']>;
  document_issue_date?: Maybe<Scalars['date']>;
  document_number?: Maybe<Scalars['String']>;
  document_open_amount?: Maybe<Scalars['numeric']>;
  document_payment_reference?: Maybe<Scalars['String']>;
  document_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  dunning_notice_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_credit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_debit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_interest?: Maybe<Scalars['numeric']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_payment_link?: Maybe<Scalars['uuid']>;
  dunning_notice_payment_reference?: Maybe<Scalars['String']>;
  dunning_notice_principal_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_total_costs?: Maybe<Scalars['numeric']>;
  dunning_notice_type_code?: Maybe<Scalars['String']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_payment_link?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  primary_credit_note?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "risolto.view_dunning_notice_action_6m" */
export type Risolto_View_Dunning_Notice_Action_6m_Aggregate = {
  __typename?: 'risolto_view_dunning_notice_action_6m_aggregate';
  aggregate?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Aggregate_Fields>;
  nodes: Array<Risolto_View_Dunning_Notice_Action_6m>;
};

/** aggregate fields of "risolto.view_dunning_notice_action_6m" */
export type Risolto_View_Dunning_Notice_Action_6m_Aggregate_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_aggregate_fields';
  avg?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Max_Fields>;
  min?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Min_Fields>;
  stddev?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Sum_Fields>;
  var_pop?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Var_Samp_Fields>;
  variance?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Variance_Fields>;
};


/** aggregate fields of "risolto.view_dunning_notice_action_6m" */
export type Risolto_View_Dunning_Notice_Action_6m_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Avg_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_avg_fields';
  document_open_amount?: Maybe<Scalars['Float']>;
  document_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_charges?: Maybe<Scalars['Float']>;
  dunning_notice_credit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_debit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_interest?: Maybe<Scalars['Float']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['Float']>;
  dunning_notice_principal_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['Float']>;
  dunning_notice_total_costs?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.view_dunning_notice_action_6m". All fields are combined with a logical 'AND'. */
export type Risolto_View_Dunning_Notice_Action_6m_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Bool_Exp>>;
  account_id?: Maybe<String_Comparison_Exp>;
  action?: Maybe<Uuid_Comparison_Exp>;
  channel?: Maybe<String_Comparison_Exp>;
  channel_endpoint?: Maybe<Uuid_Comparison_Exp>;
  debtor_legal_id?: Maybe<String_Comparison_Exp>;
  debtor_legal_id_type?: Maybe<String_Comparison_Exp>;
  debtor_type?: Maybe<String_Comparison_Exp>;
  document_due_date?: Maybe<Date_Comparison_Exp>;
  document_issue_date?: Maybe<Date_Comparison_Exp>;
  document_number?: Maybe<String_Comparison_Exp>;
  document_open_amount?: Maybe<Numeric_Comparison_Exp>;
  document_payment_reference?: Maybe<String_Comparison_Exp>;
  document_total_amount?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice?: Maybe<Uuid_Comparison_Exp>;
  dunning_notice_charges?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_credit_amount?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_debit_amount?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_interest?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_invoice_open_amount?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_payment_link?: Maybe<Uuid_Comparison_Exp>;
  dunning_notice_payment_reference?: Maybe<String_Comparison_Exp>;
  dunning_notice_principal_amount?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_total_amount?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_total_amount_without_charges?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_total_costs?: Maybe<Numeric_Comparison_Exp>;
  dunning_notice_type_code?: Maybe<String_Comparison_Exp>;
  executed_at?: Maybe<Timestamptz_Comparison_Exp>;
  executed_by?: Maybe<Uuid_Comparison_Exp>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_group?: Maybe<Uuid_Comparison_Exp>;
  invoice_payment_link?: Maybe<Uuid_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  message_code?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  payment_plan?: Maybe<Uuid_Comparison_Exp>;
  payment_promise?: Maybe<Uuid_Comparison_Exp>;
  primary_credit_note?: Maybe<Uuid_Comparison_Exp>;
  primary_invoice?: Maybe<Uuid_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  start_time?: Maybe<Timestamptz_Comparison_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Max_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_max_fields';
  account_id?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  debtor_legal_id?: Maybe<Scalars['String']>;
  debtor_legal_id_type?: Maybe<Scalars['String']>;
  debtor_type?: Maybe<Scalars['String']>;
  document_due_date?: Maybe<Scalars['date']>;
  document_issue_date?: Maybe<Scalars['date']>;
  document_number?: Maybe<Scalars['String']>;
  document_open_amount?: Maybe<Scalars['numeric']>;
  document_payment_reference?: Maybe<Scalars['String']>;
  document_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  dunning_notice_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_credit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_debit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_interest?: Maybe<Scalars['numeric']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_payment_link?: Maybe<Scalars['uuid']>;
  dunning_notice_payment_reference?: Maybe<Scalars['String']>;
  dunning_notice_principal_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_total_costs?: Maybe<Scalars['numeric']>;
  dunning_notice_type_code?: Maybe<Scalars['String']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_payment_link?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  primary_credit_note?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Min_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_min_fields';
  account_id?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  debtor_legal_id?: Maybe<Scalars['String']>;
  debtor_legal_id_type?: Maybe<Scalars['String']>;
  debtor_type?: Maybe<Scalars['String']>;
  document_due_date?: Maybe<Scalars['date']>;
  document_issue_date?: Maybe<Scalars['date']>;
  document_number?: Maybe<Scalars['String']>;
  document_open_amount?: Maybe<Scalars['numeric']>;
  document_payment_reference?: Maybe<Scalars['String']>;
  document_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  dunning_notice_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_credit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_debit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_interest?: Maybe<Scalars['numeric']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_payment_link?: Maybe<Scalars['uuid']>;
  dunning_notice_payment_reference?: Maybe<Scalars['String']>;
  dunning_notice_principal_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_total_costs?: Maybe<Scalars['numeric']>;
  dunning_notice_type_code?: Maybe<Scalars['String']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_payment_link?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  primary_credit_note?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "risolto.view_dunning_notice_action_6m". */
export type Risolto_View_Dunning_Notice_Action_6m_Order_By = {
  account_id?: Maybe<Order_By>;
  action?: Maybe<Order_By>;
  channel?: Maybe<Order_By>;
  channel_endpoint?: Maybe<Order_By>;
  debtor_legal_id?: Maybe<Order_By>;
  debtor_legal_id_type?: Maybe<Order_By>;
  debtor_type?: Maybe<Order_By>;
  document_due_date?: Maybe<Order_By>;
  document_issue_date?: Maybe<Order_By>;
  document_number?: Maybe<Order_By>;
  document_open_amount?: Maybe<Order_By>;
  document_payment_reference?: Maybe<Order_By>;
  document_total_amount?: Maybe<Order_By>;
  dunning_notice?: Maybe<Order_By>;
  dunning_notice_charges?: Maybe<Order_By>;
  dunning_notice_credit_amount?: Maybe<Order_By>;
  dunning_notice_debit_amount?: Maybe<Order_By>;
  dunning_notice_interest?: Maybe<Order_By>;
  dunning_notice_invoice_open_amount?: Maybe<Order_By>;
  dunning_notice_payment_link?: Maybe<Order_By>;
  dunning_notice_payment_reference?: Maybe<Order_By>;
  dunning_notice_principal_amount?: Maybe<Order_By>;
  dunning_notice_total_amount?: Maybe<Order_By>;
  dunning_notice_total_amount_without_charges?: Maybe<Order_By>;
  dunning_notice_total_costs?: Maybe<Order_By>;
  dunning_notice_type_code?: Maybe<Order_By>;
  executed_at?: Maybe<Order_By>;
  executed_by?: Maybe<Order_By>;
  invoice?: Maybe<Order_By>;
  invoice_group?: Maybe<Order_By>;
  invoice_payment_link?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message_code?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  payment_plan?: Maybe<Order_By>;
  payment_promise?: Maybe<Order_By>;
  primary_credit_note?: Maybe<Order_By>;
  primary_invoice?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_dunning_notice_action_6m" */
export enum Risolto_View_Dunning_Notice_Action_6m_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Action = 'action',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  DebtorLegalId = 'debtor_legal_id',
  /** column name */
  DebtorLegalIdType = 'debtor_legal_id_type',
  /** column name */
  DebtorType = 'debtor_type',
  /** column name */
  DocumentDueDate = 'document_due_date',
  /** column name */
  DocumentIssueDate = 'document_issue_date',
  /** column name */
  DocumentNumber = 'document_number',
  /** column name */
  DocumentOpenAmount = 'document_open_amount',
  /** column name */
  DocumentPaymentReference = 'document_payment_reference',
  /** column name */
  DocumentTotalAmount = 'document_total_amount',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  DunningNoticeCharges = 'dunning_notice_charges',
  /** column name */
  DunningNoticeCreditAmount = 'dunning_notice_credit_amount',
  /** column name */
  DunningNoticeDebitAmount = 'dunning_notice_debit_amount',
  /** column name */
  DunningNoticeInterest = 'dunning_notice_interest',
  /** column name */
  DunningNoticeInvoiceOpenAmount = 'dunning_notice_invoice_open_amount',
  /** column name */
  DunningNoticePaymentLink = 'dunning_notice_payment_link',
  /** column name */
  DunningNoticePaymentReference = 'dunning_notice_payment_reference',
  /** column name */
  DunningNoticePrincipalAmount = 'dunning_notice_principal_amount',
  /** column name */
  DunningNoticeTotalAmount = 'dunning_notice_total_amount',
  /** column name */
  DunningNoticeTotalAmountWithoutCharges = 'dunning_notice_total_amount_without_charges',
  /** column name */
  DunningNoticeTotalCosts = 'dunning_notice_total_costs',
  /** column name */
  DunningNoticeTypeCode = 'dunning_notice_type_code',
  /** column name */
  ExecutedAt = 'executed_at',
  /** column name */
  ExecutedBy = 'executed_by',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  InvoiceGroup = 'invoice_group',
  /** column name */
  InvoicePaymentLink = 'invoice_payment_link',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Name = 'name',
  /** column name */
  Participant = 'participant',
  /** column name */
  PaymentPlan = 'payment_plan',
  /** column name */
  PaymentPromise = 'payment_promise',
  /** column name */
  PrimaryCreditNote = 'primary_credit_note',
  /** column name */
  PrimaryInvoice = 'primary_invoice',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Source = 'source',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  VReference = 'v_reference'
}

/** aggregate stddev on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Stddev_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_stddev_fields';
  document_open_amount?: Maybe<Scalars['Float']>;
  document_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_charges?: Maybe<Scalars['Float']>;
  dunning_notice_credit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_debit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_interest?: Maybe<Scalars['Float']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['Float']>;
  dunning_notice_principal_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['Float']>;
  dunning_notice_total_costs?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Stddev_Pop_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_stddev_pop_fields';
  document_open_amount?: Maybe<Scalars['Float']>;
  document_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_charges?: Maybe<Scalars['Float']>;
  dunning_notice_credit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_debit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_interest?: Maybe<Scalars['Float']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['Float']>;
  dunning_notice_principal_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['Float']>;
  dunning_notice_total_costs?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Stddev_Samp_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_stddev_samp_fields';
  document_open_amount?: Maybe<Scalars['Float']>;
  document_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_charges?: Maybe<Scalars['Float']>;
  dunning_notice_credit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_debit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_interest?: Maybe<Scalars['Float']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['Float']>;
  dunning_notice_principal_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['Float']>;
  dunning_notice_total_costs?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_view_dunning_notice_action_6m" */
export type Risolto_View_Dunning_Notice_Action_6m_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Dunning_Notice_Action_6m_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Dunning_Notice_Action_6m_Stream_Cursor_Value_Input = {
  account_id?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  channel_endpoint?: Maybe<Scalars['uuid']>;
  debtor_legal_id?: Maybe<Scalars['String']>;
  debtor_legal_id_type?: Maybe<Scalars['String']>;
  debtor_type?: Maybe<Scalars['String']>;
  document_due_date?: Maybe<Scalars['date']>;
  document_issue_date?: Maybe<Scalars['date']>;
  document_number?: Maybe<Scalars['String']>;
  document_open_amount?: Maybe<Scalars['numeric']>;
  document_payment_reference?: Maybe<Scalars['String']>;
  document_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  dunning_notice_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_credit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_debit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_interest?: Maybe<Scalars['numeric']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_payment_link?: Maybe<Scalars['uuid']>;
  dunning_notice_payment_reference?: Maybe<Scalars['String']>;
  dunning_notice_principal_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_total_costs?: Maybe<Scalars['numeric']>;
  dunning_notice_type_code?: Maybe<Scalars['String']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  executed_by?: Maybe<Scalars['uuid']>;
  invoice?: Maybe<Scalars['uuid']>;
  invoice_group?: Maybe<Scalars['uuid']>;
  invoice_payment_link?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  payment_plan?: Maybe<Scalars['uuid']>;
  payment_promise?: Maybe<Scalars['uuid']>;
  primary_credit_note?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Sum_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_sum_fields';
  document_open_amount?: Maybe<Scalars['numeric']>;
  document_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_credit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_debit_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_interest?: Maybe<Scalars['numeric']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_principal_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount?: Maybe<Scalars['numeric']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['numeric']>;
  dunning_notice_total_costs?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Var_Pop_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_var_pop_fields';
  document_open_amount?: Maybe<Scalars['Float']>;
  document_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_charges?: Maybe<Scalars['Float']>;
  dunning_notice_credit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_debit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_interest?: Maybe<Scalars['Float']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['Float']>;
  dunning_notice_principal_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['Float']>;
  dunning_notice_total_costs?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Var_Samp_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_var_samp_fields';
  document_open_amount?: Maybe<Scalars['Float']>;
  document_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_charges?: Maybe<Scalars['Float']>;
  dunning_notice_credit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_debit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_interest?: Maybe<Scalars['Float']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['Float']>;
  dunning_notice_principal_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['Float']>;
  dunning_notice_total_costs?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_View_Dunning_Notice_Action_6m_Variance_Fields = {
  __typename?: 'risolto_view_dunning_notice_action_6m_variance_fields';
  document_open_amount?: Maybe<Scalars['Float']>;
  document_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_charges?: Maybe<Scalars['Float']>;
  dunning_notice_credit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_debit_amount?: Maybe<Scalars['Float']>;
  dunning_notice_interest?: Maybe<Scalars['Float']>;
  dunning_notice_invoice_open_amount?: Maybe<Scalars['Float']>;
  dunning_notice_principal_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount?: Maybe<Scalars['Float']>;
  dunning_notice_total_amount_without_charges?: Maybe<Scalars['Float']>;
  dunning_notice_total_costs?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.view_invoice_features" */
export type Risolto_View_Invoice_Features = {
  __typename?: 'risolto_view_invoice_features';
  aging_bucket?: Maybe<Scalars['String']>;
  days_late?: Maybe<Scalars['Int']>;
  derived_paid_at?: Maybe<Scalars['date']>;
  issue_month_year?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "risolto.view_invoice_features" */
export type Risolto_View_Invoice_Features_Aggregate = {
  __typename?: 'risolto_view_invoice_features_aggregate';
  aggregate?: Maybe<Risolto_View_Invoice_Features_Aggregate_Fields>;
  nodes: Array<Risolto_View_Invoice_Features>;
};

/** aggregate fields of "risolto.view_invoice_features" */
export type Risolto_View_Invoice_Features_Aggregate_Fields = {
  __typename?: 'risolto_view_invoice_features_aggregate_fields';
  avg?: Maybe<Risolto_View_Invoice_Features_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Invoice_Features_Max_Fields>;
  min?: Maybe<Risolto_View_Invoice_Features_Min_Fields>;
  stddev?: Maybe<Risolto_View_Invoice_Features_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_View_Invoice_Features_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_View_Invoice_Features_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_View_Invoice_Features_Sum_Fields>;
  var_pop?: Maybe<Risolto_View_Invoice_Features_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_View_Invoice_Features_Var_Samp_Fields>;
  variance?: Maybe<Risolto_View_Invoice_Features_Variance_Fields>;
};


/** aggregate fields of "risolto.view_invoice_features" */
export type Risolto_View_Invoice_Features_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Invoice_Features_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_View_Invoice_Features_Avg_Fields = {
  __typename?: 'risolto_view_invoice_features_avg_fields';
  days_late?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.view_invoice_features". All fields are combined with a logical 'AND'. */
export type Risolto_View_Invoice_Features_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Invoice_Features_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Invoice_Features_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Invoice_Features_Bool_Exp>>;
  aging_bucket?: Maybe<String_Comparison_Exp>;
  days_late?: Maybe<Int_Comparison_Exp>;
  derived_paid_at?: Maybe<Date_Comparison_Exp>;
  issue_month_year?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_View_Invoice_Features_Max_Fields = {
  __typename?: 'risolto_view_invoice_features_max_fields';
  aging_bucket?: Maybe<Scalars['String']>;
  days_late?: Maybe<Scalars['Int']>;
  derived_paid_at?: Maybe<Scalars['date']>;
  issue_month_year?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_View_Invoice_Features_Min_Fields = {
  __typename?: 'risolto_view_invoice_features_min_fields';
  aging_bucket?: Maybe<Scalars['String']>;
  days_late?: Maybe<Scalars['Int']>;
  derived_paid_at?: Maybe<Scalars['date']>;
  issue_month_year?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "risolto.view_invoice_features". */
export type Risolto_View_Invoice_Features_Order_By = {
  aging_bucket?: Maybe<Order_By>;
  days_late?: Maybe<Order_By>;
  derived_paid_at?: Maybe<Order_By>;
  issue_month_year?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_invoice_features" */
export enum Risolto_View_Invoice_Features_Select_Column {
  /** column name */
  AgingBucket = 'aging_bucket',
  /** column name */
  DaysLate = 'days_late',
  /** column name */
  DerivedPaidAt = 'derived_paid_at',
  /** column name */
  IssueMonthYear = 'issue_month_year',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference'
}

/** aggregate stddev on columns */
export type Risolto_View_Invoice_Features_Stddev_Fields = {
  __typename?: 'risolto_view_invoice_features_stddev_fields';
  days_late?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_View_Invoice_Features_Stddev_Pop_Fields = {
  __typename?: 'risolto_view_invoice_features_stddev_pop_fields';
  days_late?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_View_Invoice_Features_Stddev_Samp_Fields = {
  __typename?: 'risolto_view_invoice_features_stddev_samp_fields';
  days_late?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_view_invoice_features" */
export type Risolto_View_Invoice_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Invoice_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Invoice_Features_Stream_Cursor_Value_Input = {
  aging_bucket?: Maybe<Scalars['String']>;
  days_late?: Maybe<Scalars['Int']>;
  derived_paid_at?: Maybe<Scalars['date']>;
  issue_month_year?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_View_Invoice_Features_Sum_Fields = {
  __typename?: 'risolto_view_invoice_features_sum_fields';
  days_late?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Risolto_View_Invoice_Features_Var_Pop_Fields = {
  __typename?: 'risolto_view_invoice_features_var_pop_fields';
  days_late?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_View_Invoice_Features_Var_Samp_Fields = {
  __typename?: 'risolto_view_invoice_features_var_samp_fields';
  days_late?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_View_Invoice_Features_Variance_Fields = {
  __typename?: 'risolto_view_invoice_features_variance_fields';
  days_late?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.view_legal_entity_template" */
export type Risolto_View_Legal_Entity_Template = {
  __typename?: 'risolto_view_legal_entity_template';
  default_template_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  source?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.view_legal_entity_template" */
export type Risolto_View_Legal_Entity_Template_Aggregate = {
  __typename?: 'risolto_view_legal_entity_template_aggregate';
  aggregate?: Maybe<Risolto_View_Legal_Entity_Template_Aggregate_Fields>;
  nodes: Array<Risolto_View_Legal_Entity_Template>;
};

/** aggregate fields of "risolto.view_legal_entity_template" */
export type Risolto_View_Legal_Entity_Template_Aggregate_Fields = {
  __typename?: 'risolto_view_legal_entity_template_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Legal_Entity_Template_Max_Fields>;
  min?: Maybe<Risolto_View_Legal_Entity_Template_Min_Fields>;
};


/** aggregate fields of "risolto.view_legal_entity_template" */
export type Risolto_View_Legal_Entity_Template_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Legal_Entity_Template_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.view_legal_entity_template". All fields are combined with a logical 'AND'. */
export type Risolto_View_Legal_Entity_Template_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Legal_Entity_Template_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Legal_Entity_Template_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Legal_Entity_Template_Bool_Exp>>;
  default_template_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  template_id?: Maybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_View_Legal_Entity_Template_Max_Fields = {
  __typename?: 'risolto_view_legal_entity_template_max_fields';
  default_template_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_View_Legal_Entity_Template_Min_Fields = {
  __typename?: 'risolto_view_legal_entity_template_min_fields';
  default_template_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "risolto.view_legal_entity_template". */
export type Risolto_View_Legal_Entity_Template_Order_By = {
  default_template_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  source?: Maybe<Order_By>;
  template_id?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_legal_entity_template" */
export enum Risolto_View_Legal_Entity_Template_Select_Column {
  /** column name */
  DefaultTemplateId = 'default_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Source = 'source',
  /** column name */
  TemplateId = 'template_id'
}

/** Streaming cursor of the table "risolto_view_legal_entity_template" */
export type Risolto_View_Legal_Entity_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Legal_Entity_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Legal_Entity_Template_Stream_Cursor_Value_Input = {
  default_template_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.view_platform_licence_permission" */
export type Risolto_View_Platform_Licence_Permission = {
  __typename?: 'risolto_view_platform_licence_permission';
  email?: Maybe<Scalars['String']>;
  grant_type?: Maybe<Scalars['String']>;
  license_module?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  participant_user_role?: Maybe<Scalars['uuid']>;
  permission?: Maybe<Scalars['uuid']>;
  permission_name?: Maybe<Scalars['String']>;
  person_external_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['uuid']>;
  role_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.view_platform_licence_permission" */
export type Risolto_View_Platform_Licence_Permission_Aggregate = {
  __typename?: 'risolto_view_platform_licence_permission_aggregate';
  aggregate?: Maybe<Risolto_View_Platform_Licence_Permission_Aggregate_Fields>;
  nodes: Array<Risolto_View_Platform_Licence_Permission>;
};

/** aggregate fields of "risolto.view_platform_licence_permission" */
export type Risolto_View_Platform_Licence_Permission_Aggregate_Fields = {
  __typename?: 'risolto_view_platform_licence_permission_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Platform_Licence_Permission_Max_Fields>;
  min?: Maybe<Risolto_View_Platform_Licence_Permission_Min_Fields>;
};


/** aggregate fields of "risolto.view_platform_licence_permission" */
export type Risolto_View_Platform_Licence_Permission_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.view_platform_licence_permission". All fields are combined with a logical 'AND'. */
export type Risolto_View_Platform_Licence_Permission_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Platform_Licence_Permission_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Bool_Exp>>;
  email?: Maybe<String_Comparison_Exp>;
  grant_type?: Maybe<String_Comparison_Exp>;
  license_module?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_user?: Maybe<Uuid_Comparison_Exp>;
  participant_user_role?: Maybe<Uuid_Comparison_Exp>;
  permission?: Maybe<Uuid_Comparison_Exp>;
  permission_name?: Maybe<String_Comparison_Exp>;
  person_external_id?: Maybe<String_Comparison_Exp>;
  role?: Maybe<Uuid_Comparison_Exp>;
  role_name?: Maybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Risolto_View_Platform_Licence_Permission_Max_Fields = {
  __typename?: 'risolto_view_platform_licence_permission_max_fields';
  email?: Maybe<Scalars['String']>;
  grant_type?: Maybe<Scalars['String']>;
  license_module?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  participant_user_role?: Maybe<Scalars['uuid']>;
  permission?: Maybe<Scalars['uuid']>;
  permission_name?: Maybe<Scalars['String']>;
  person_external_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['uuid']>;
  role_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_View_Platform_Licence_Permission_Min_Fields = {
  __typename?: 'risolto_view_platform_licence_permission_min_fields';
  email?: Maybe<Scalars['String']>;
  grant_type?: Maybe<Scalars['String']>;
  license_module?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  participant_user_role?: Maybe<Scalars['uuid']>;
  permission?: Maybe<Scalars['uuid']>;
  permission_name?: Maybe<Scalars['String']>;
  person_external_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['uuid']>;
  role_name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "risolto.view_platform_licence_permission". */
export type Risolto_View_Platform_Licence_Permission_Order_By = {
  email?: Maybe<Order_By>;
  grant_type?: Maybe<Order_By>;
  license_module?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_user?: Maybe<Order_By>;
  participant_user_role?: Maybe<Order_By>;
  permission?: Maybe<Order_By>;
  permission_name?: Maybe<Order_By>;
  person_external_id?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  role_name?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_platform_licence_permission" */
export enum Risolto_View_Platform_Licence_Permission_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  GrantType = 'grant_type',
  /** column name */
  LicenseModule = 'license_module',
  /** column name */
  Participant = 'participant',
  /** column name */
  ParticipantUser = 'participant_user',
  /** column name */
  ParticipantUserRole = 'participant_user_role',
  /** column name */
  Permission = 'permission',
  /** column name */
  PermissionName = 'permission_name',
  /** column name */
  PersonExternalId = 'person_external_id',
  /** column name */
  Role = 'role',
  /** column name */
  RoleName = 'role_name'
}

/** Streaming cursor of the table "risolto_view_platform_licence_permission" */
export type Risolto_View_Platform_Licence_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Platform_Licence_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Platform_Licence_Permission_Stream_Cursor_Value_Input = {
  email?: Maybe<Scalars['String']>;
  grant_type?: Maybe<Scalars['String']>;
  license_module?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_user?: Maybe<Scalars['uuid']>;
  participant_user_role?: Maybe<Scalars['uuid']>;
  permission?: Maybe<Scalars['uuid']>;
  permission_name?: Maybe<Scalars['String']>;
  person_external_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['uuid']>;
  role_name?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag = {
  __typename?: 'risolto_view_recipient_tag';
  can_remove?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tag_by_reference?: Maybe<Risolto_Tag>;
  tag_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Aggregate = {
  __typename?: 'risolto_view_recipient_tag_aggregate';
  aggregate?: Maybe<Risolto_View_Recipient_Tag_Aggregate_Fields>;
  nodes: Array<Risolto_View_Recipient_Tag>;
};

export type Risolto_View_Recipient_Tag_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Count>;
};

export type Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risolto_View_Recipient_Tag_Select_Column_Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risolto_View_Recipient_Tag_Select_Column_Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Risolto_View_Recipient_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Aggregate_Fields = {
  __typename?: 'risolto_view_recipient_tag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_View_Recipient_Tag_Max_Fields>;
  min?: Maybe<Risolto_View_Recipient_Tag_Min_Fields>;
};


/** aggregate fields of "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_View_Recipient_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_View_Recipient_Tag_Max_Order_By>;
  min?: Maybe<Risolto_View_Recipient_Tag_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Arr_Rel_Insert_Input = {
  data: Array<Risolto_View_Recipient_Tag_Insert_Input>;
};

/** Boolean expression to filter rows from the table "risolto.view_recipient_tag". All fields are combined with a logical 'AND'. */
export type Risolto_View_Recipient_Tag_Bool_Exp = {
  _and?: Maybe<Array<Risolto_View_Recipient_Tag_Bool_Exp>>;
  _not?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
  _or?: Maybe<Array<Risolto_View_Recipient_Tag_Bool_Exp>>;
  can_remove?: Maybe<Boolean_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  tag?: Maybe<Uuid_Comparison_Exp>;
  tag_by_reference?: Maybe<Risolto_Tag_Bool_Exp>;
  tag_name?: Maybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Insert_Input = {
  can_remove?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  tag_by_reference?: Maybe<Risolto_Tag_Obj_Rel_Insert_Input>;
  tag_name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_View_Recipient_Tag_Max_Fields = {
  __typename?: 'risolto_view_recipient_tag_max_fields';
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  tag_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Max_Order_By = {
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  tag_name?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_View_Recipient_Tag_Min_Fields = {
  __typename?: 'risolto_view_recipient_tag_min_fields';
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  tag_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "risolto.view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Min_Order_By = {
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  tag_name?: Maybe<Order_By>;
};

/** Ordering options when selecting data from "risolto.view_recipient_tag". */
export type Risolto_View_Recipient_Tag_Order_By = {
  can_remove?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  reference?: Maybe<Order_By>;
  tag?: Maybe<Order_By>;
  tag_by_reference?: Maybe<Risolto_Tag_Order_By>;
  tag_name?: Maybe<Order_By>;
};

/** select columns of table "risolto.view_recipient_tag" */
export enum Risolto_View_Recipient_Tag_Select_Column {
  /** column name */
  CanRemove = 'can_remove',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Reference = 'reference',
  /** column name */
  Tag = 'tag',
  /** column name */
  TagName = 'tag_name'
}

/** select "risolto_view_recipient_tag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risolto.view_recipient_tag" */
export enum Risolto_View_Recipient_Tag_Select_Column_Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CanRemove = 'can_remove'
}

/** select "risolto_view_recipient_tag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risolto.view_recipient_tag" */
export enum Risolto_View_Recipient_Tag_Select_Column_Risolto_View_Recipient_Tag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CanRemove = 'can_remove'
}

/** Streaming cursor of the table "risolto_view_recipient_tag" */
export type Risolto_View_Recipient_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_View_Recipient_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_View_Recipient_Tag_Stream_Cursor_Value_Input = {
  can_remove?: Maybe<Scalars['Boolean']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Scalars['uuid']>;
  tag_name?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note = {
  __typename?: 'risolto_virtual_action_and_note';
  action: Scalars['uuid'];
  /** An object relationship */
  action_by_reference: Risolto_Action;
  channel: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['uuid'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  message_code: Scalars['String'];
  metadata: Scalars['jsonb'];
  note: Scalars['uuid'];
  /** An object relationship */
  note_by_reference: Risolto_Note;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An object relationship */
  person_by_reference: Risolto_Person;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  status: Scalars['String'];
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  v_reference: Scalars['uuid'];
};


/** columns and relationships of "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_NoteMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note_Aggregate = {
  __typename?: 'risolto_virtual_action_and_note_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Action_And_Note_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Action_And_Note>;
};

/** aggregate fields of "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note_Aggregate_Fields = {
  __typename?: 'risolto_virtual_action_and_note_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Action_And_Note_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Action_And_Note_Min_Fields>;
};


/** aggregate fields of "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** columns and relationships of "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute';
  action: Scalars['uuid'];
  /** An object relationship */
  action_by_reference: Risolto_Action;
  channel: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['uuid'];
  invoice_dispute: Scalars['uuid'];
  /** An object relationship */
  invoice_dispute_by_reference: Risolto_Invoice_Dispute;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  message_code: Scalars['String'];
  metadata: Scalars['jsonb'];
  note: Scalars['uuid'];
  /** An object relationship */
  note_by_reference: Risolto_Note;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  /** An object relationship */
  person_by_reference: Risolto_Person;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  status: Scalars['String'];
  system_note: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  v_reference: Scalars['uuid'];
};


/** columns and relationships of "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_DisputeMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Aggregate = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Action_And_Note_And_Dispute>;
};

/** aggregate fields of "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Aggregate_Fields = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Min_Fields>;
};


/** aggregate fields of "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** columns and relationships of "risolto.virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_and_message';
  action?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  action_by_reference?: Maybe<Risolto_Action>;
  channel?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  message?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  message_by_reference?: Maybe<Risolto_Message>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  note_by_reference?: Maybe<Risolto_Note>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  /** An object relationship */
  person_by_reference?: Maybe<Risolto_Person>;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  v_reference: Scalars['uuid'];
};


/** columns and relationships of "risolto.virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_MessageMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Aggregate = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_and_message_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message>;
};

/** aggregate fields of "risolto.virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Aggregate_Fields = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_and_message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Min_Fields>;
};


/** aggregate fields of "risolto.virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_action_and_note_and_dispute_and_message". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  channel?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  invoice_dispute?: Maybe<Uuid_Comparison_Exp>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message?: Maybe<Uuid_Comparison_Exp>;
  message_by_reference?: Maybe<Risolto_Message_Bool_Exp>;
  message_code?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  note?: Maybe<Uuid_Comparison_Exp>;
  note_by_reference?: Maybe<Risolto_Note_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  system_note?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Insert_Input = {
  action?: Maybe<Scalars['uuid']>;
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message?: Maybe<Scalars['uuid']>;
  message_by_reference?: Maybe<Risolto_Message_Obj_Rel_Insert_Input>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  note_by_reference?: Maybe<Risolto_Note_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Max_Fields = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_and_message_max_fields';
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Min_Fields = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_and_message_min_fields';
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Mutation_Response = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_and_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message>;
};

/** Ordering options when selecting data from "risolto.virtual_action_and_note_and_dispute_and_message". */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  channel?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  invoice_dispute?: Maybe<Order_By>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message?: Maybe<Order_By>;
  message_by_reference?: Maybe<Risolto_Message_Order_By>;
  message_code?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  note_by_reference?: Maybe<Risolto_Note_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  status?: Maybe<Order_By>;
  system_note?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.virtual_action_and_note_and_dispute_and_message" */
export enum Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  InvoiceDispute = 'invoice_dispute',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Message = 'message',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Note = 'note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Status = 'status',
  /** column name */
  SystemNote = 'system_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Set_Input = {
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "risolto_virtual_action_and_note_and_dispute_and_message" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

export type Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_action_and_note_and_dispute". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  channel?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  invoice_dispute?: Maybe<Uuid_Comparison_Exp>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message_code?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  note?: Maybe<Uuid_Comparison_Exp>;
  note_by_reference?: Maybe<Risolto_Note_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  system_note?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_action_and_note_and_dispute" */
export enum Risolto_Virtual_Action_And_Note_And_Dispute_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualActionAndNoteAndDisputePkey = 'virtual_action_and_note_and_dispute_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Insert_Input = {
  action?: Maybe<Scalars['uuid']>;
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  note_by_reference?: Maybe<Risolto_Note_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Max_Fields = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_max_fields';
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Min_Fields = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_min_fields';
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Mutation_Response = {
  __typename?: 'risolto_virtual_action_and_note_and_dispute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Action_And_Note_And_Dispute>;
};

/** on_conflict condition type for table "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_On_Conflict = {
  constraint: Risolto_Virtual_Action_And_Note_And_Dispute_Constraint;
  update_columns?: Array<Risolto_Virtual_Action_And_Note_And_Dispute_Update_Column>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_action_and_note_and_dispute". */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  channel?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  invoice_dispute?: Maybe<Order_By>;
  invoice_dispute_by_reference?: Maybe<Risolto_Invoice_Dispute_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message_code?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  note_by_reference?: Maybe<Risolto_Note_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  status?: Maybe<Order_By>;
  system_note?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_action_and_note_and_dispute */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.virtual_action_and_note_and_dispute" */
export enum Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  InvoiceDispute = 'invoice_dispute',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Note = 'note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Status = 'status',
  /** column name */
  SystemNote = 'system_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Set_Input = {
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "risolto_virtual_action_and_note_and_dispute" */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Action_And_Note_And_Dispute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Action_And_Note_And_Dispute_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  invoice_dispute?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** update columns of table "risolto.virtual_action_and_note_and_dispute" */
export enum Risolto_Virtual_Action_And_Note_And_Dispute_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  InvoiceDispute = 'invoice_dispute',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Note = 'note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Status = 'status',
  /** column name */
  SystemNote = 'system_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Action_And_Note_And_Dispute_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Action_And_Note_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_action_and_note". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Action_And_Note_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Action_And_Note_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Action_And_Note_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  channel?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message_code?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  note?: Maybe<Uuid_Comparison_Exp>;
  note_by_reference?: Maybe<Risolto_Note_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  person_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  system_note?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_action_and_note" */
export enum Risolto_Virtual_Action_And_Note_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualActionAndNotePkey = 'virtual_action_and_note_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Virtual_Action_And_Note_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Virtual_Action_And_Note_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Virtual_Action_And_Note_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note_Insert_Input = {
  action?: Maybe<Scalars['uuid']>;
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  note_by_reference?: Maybe<Risolto_Note_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  person_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Action_And_Note_Max_Fields = {
  __typename?: 'risolto_virtual_action_and_note_max_fields';
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Action_And_Note_Min_Fields = {
  __typename?: 'risolto_virtual_action_and_note_min_fields';
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note_Mutation_Response = {
  __typename?: 'risolto_virtual_action_and_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Action_And_Note>;
};

/** on_conflict condition type for table "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note_On_Conflict = {
  constraint: Risolto_Virtual_Action_And_Note_Constraint;
  update_columns?: Array<Risolto_Virtual_Action_And_Note_Update_Column>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_action_and_note". */
export type Risolto_Virtual_Action_And_Note_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  channel?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message_code?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  note_by_reference?: Maybe<Risolto_Note_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  person_by_reference?: Maybe<Risolto_Person_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  status?: Maybe<Order_By>;
  system_note?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_action_and_note */
export type Risolto_Virtual_Action_And_Note_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Action_And_Note_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.virtual_action_and_note" */
export enum Risolto_Virtual_Action_And_Note_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Note = 'note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Status = 'status',
  /** column name */
  SystemNote = 'system_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note_Set_Input = {
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "risolto_virtual_action_and_note" */
export type Risolto_Virtual_Action_And_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Action_And_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Action_And_Note_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  note?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  system_note?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** update columns of table "risolto.virtual_action_and_note" */
export enum Risolto_Virtual_Action_And_Note_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Note = 'note',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  Status = 'status',
  /** column name */
  SystemNote = 'system_note',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Action_And_Note_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Virtual_Action_And_Note_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Virtual_Action_And_Note_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Virtual_Action_And_Note_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Virtual_Action_And_Note_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Virtual_Action_And_Note_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Action_And_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Action_And_Note_Bool_Exp;
};

export type Risolto_Virtual_Action_And_Note_V1_Args = {
  q_participant?: Maybe<Scalars['uuid']>;
  q_recipient?: Maybe<Scalars['uuid']>;
};

export type Risolto_Virtual_Action_And_Note_V3_Args = {
  q_participant?: Maybe<Scalars['uuid']>;
  q_recipient?: Maybe<Scalars['uuid']>;
  q_system_notes?: Maybe<Scalars['Boolean']>;
};

export type Risolto_Virtual_Action_And_Note_V4_Args = {
  q_participant?: Maybe<Scalars['uuid']>;
  q_recipient?: Maybe<Scalars['uuid']>;
  q_system_notes?: Maybe<Scalars['Boolean']>;
};

export type Risolto_Virtual_Action_And_Note_V5_Args = {
  q_participant?: Maybe<Scalars['uuid']>;
  q_recipient?: Maybe<Scalars['uuid']>;
  q_system_notes?: Maybe<Scalars['Boolean']>;
};

/** Virtual table (SETOF) used for the action grouping function(s) */
export type Risolto_Virtual_Action_Group = {
  __typename?: 'risolto_virtual_action_group';
  /** An object relationship */
  action_by_reference?: Maybe<Risolto_Action>;
  /** null */
  action_count: Scalars['bigint'];
  assignee?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  assignee_by_reference?: Maybe<Risolto_Person>;
  /** null */
  assignee_count: Scalars['bigint'];
  channel?: Maybe<Scalars['String']>;
  /** null */
  channel_count: Scalars['bigint'];
  due_date?: Maybe<Scalars['date']>;
  /** null */
  due_date_count: Scalars['bigint'];
  is_retry?: Maybe<Scalars['Boolean']>;
  last_updated_at?: Maybe<Scalars['timestamptz']>;
  message_code?: Maybe<Scalars['String']>;
  /** null */
  message_code_count: Scalars['bigint'];
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  recipient?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  recipient_by_reference?: Maybe<Risolto_Recipient>;
  /** null */
  recipient_count: Scalars['bigint'];
  reference?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  start_time_count: Scalars['bigint'];
  v_reference: Scalars['uuid'];
};

export type Risolto_Virtual_Action_Group_Aggregate = {
  __typename?: 'risolto_virtual_action_group_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Action_Group_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Action_Group>;
};

/** aggregate fields of "risolto.virtual_action_group" */
export type Risolto_Virtual_Action_Group_Aggregate_Fields = {
  __typename?: 'risolto_virtual_action_group_aggregate_fields';
  avg?: Maybe<Risolto_Virtual_Action_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Action_Group_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Action_Group_Min_Fields>;
  stddev?: Maybe<Risolto_Virtual_Action_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Virtual_Action_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Virtual_Action_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Virtual_Action_Group_Sum_Fields>;
  var_pop?: Maybe<Risolto_Virtual_Action_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Virtual_Action_Group_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Virtual_Action_Group_Variance_Fields>;
};


/** aggregate fields of "risolto.virtual_action_group" */
export type Risolto_Virtual_Action_Group_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Virtual_Action_Group_Avg_Fields = {
  __typename?: 'risolto_virtual_action_group_avg_fields';
  /** null */
  action_count?: Maybe<Scalars['Float']>;
  /** null */
  assignee_count?: Maybe<Scalars['Float']>;
  /** null */
  channel_count?: Maybe<Scalars['Float']>;
  /** null */
  due_date_count?: Maybe<Scalars['Float']>;
  /** null */
  message_code_count?: Maybe<Scalars['Float']>;
  /** null */
  recipient_count?: Maybe<Scalars['Float']>;
  start_time_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_action_group". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Action_Group_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Action_Group_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Action_Group_Bool_Exp>>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  action_count?: Maybe<Bigint_Comparison_Exp>;
  assignee?: Maybe<Uuid_Comparison_Exp>;
  assignee_by_reference?: Maybe<Risolto_Person_Bool_Exp>;
  assignee_count?: Maybe<Bigint_Comparison_Exp>;
  channel?: Maybe<String_Comparison_Exp>;
  channel_count?: Maybe<Bigint_Comparison_Exp>;
  due_date?: Maybe<Date_Comparison_Exp>;
  due_date_count?: Maybe<Bigint_Comparison_Exp>;
  is_retry?: Maybe<Boolean_Comparison_Exp>;
  last_updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  message_code?: Maybe<String_Comparison_Exp>;
  message_code_count?: Maybe<Bigint_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  recipient_count?: Maybe<Bigint_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  start_time?: Maybe<Timestamptz_Comparison_Exp>;
  start_time_count?: Maybe<Bigint_Comparison_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_action_group" */
export enum Risolto_Virtual_Action_Group_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualActionGroupPkey = 'virtual_action_group_pkey'
}

/** input type for incrementing numeric columns in table "risolto.virtual_action_group" */
export type Risolto_Virtual_Action_Group_Inc_Input = {
  /** null */
  action_count?: Maybe<Scalars['bigint']>;
  /** null */
  assignee_count?: Maybe<Scalars['bigint']>;
  /** null */
  channel_count?: Maybe<Scalars['bigint']>;
  /** null */
  due_date_count?: Maybe<Scalars['bigint']>;
  /** null */
  message_code_count?: Maybe<Scalars['bigint']>;
  /** null */
  recipient_count?: Maybe<Scalars['bigint']>;
  start_time_count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "risolto.virtual_action_group" */
export type Risolto_Virtual_Action_Group_Insert_Input = {
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  /** null */
  action_count?: Maybe<Scalars['bigint']>;
  assignee?: Maybe<Scalars['uuid']>;
  assignee_by_reference?: Maybe<Risolto_Person_Obj_Rel_Insert_Input>;
  /** null */
  assignee_count?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  /** null */
  channel_count?: Maybe<Scalars['bigint']>;
  due_date?: Maybe<Scalars['date']>;
  /** null */
  due_date_count?: Maybe<Scalars['bigint']>;
  is_retry?: Maybe<Scalars['Boolean']>;
  last_updated_at?: Maybe<Scalars['timestamptz']>;
  message_code?: Maybe<Scalars['String']>;
  /** null */
  message_code_count?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  /** null */
  recipient_count?: Maybe<Scalars['bigint']>;
  reference?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  start_time_count?: Maybe<Scalars['bigint']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Action_Group_Max_Fields = {
  __typename?: 'risolto_virtual_action_group_max_fields';
  /** null */
  action_count?: Maybe<Scalars['bigint']>;
  assignee?: Maybe<Scalars['uuid']>;
  /** null */
  assignee_count?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  /** null */
  channel_count?: Maybe<Scalars['bigint']>;
  due_date?: Maybe<Scalars['date']>;
  /** null */
  due_date_count?: Maybe<Scalars['bigint']>;
  last_updated_at?: Maybe<Scalars['timestamptz']>;
  message_code?: Maybe<Scalars['String']>;
  /** null */
  message_code_count?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** null */
  recipient_count?: Maybe<Scalars['bigint']>;
  reference?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  start_time_count?: Maybe<Scalars['bigint']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Action_Group_Min_Fields = {
  __typename?: 'risolto_virtual_action_group_min_fields';
  /** null */
  action_count?: Maybe<Scalars['bigint']>;
  assignee?: Maybe<Scalars['uuid']>;
  /** null */
  assignee_count?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  /** null */
  channel_count?: Maybe<Scalars['bigint']>;
  due_date?: Maybe<Scalars['date']>;
  /** null */
  due_date_count?: Maybe<Scalars['bigint']>;
  last_updated_at?: Maybe<Scalars['timestamptz']>;
  message_code?: Maybe<Scalars['String']>;
  /** null */
  message_code_count?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** null */
  recipient_count?: Maybe<Scalars['bigint']>;
  reference?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  start_time_count?: Maybe<Scalars['bigint']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_action_group" */
export type Risolto_Virtual_Action_Group_Mutation_Response = {
  __typename?: 'risolto_virtual_action_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Action_Group>;
};

/** on_conflict condition type for table "risolto.virtual_action_group" */
export type Risolto_Virtual_Action_Group_On_Conflict = {
  constraint: Risolto_Virtual_Action_Group_Constraint;
  update_columns?: Array<Risolto_Virtual_Action_Group_Update_Column>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_action_group". */
export type Risolto_Virtual_Action_Group_Order_By = {
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  action_count?: Maybe<Order_By>;
  assignee?: Maybe<Order_By>;
  assignee_by_reference?: Maybe<Risolto_Person_Order_By>;
  assignee_count?: Maybe<Order_By>;
  channel?: Maybe<Order_By>;
  channel_count?: Maybe<Order_By>;
  due_date?: Maybe<Order_By>;
  due_date_count?: Maybe<Order_By>;
  is_retry?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
  message_code?: Maybe<Order_By>;
  message_code_count?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  recipient_count?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  start_time_count?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_action_group */
export type Risolto_Virtual_Action_Group_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** select columns of table "risolto.virtual_action_group" */
export enum Risolto_Virtual_Action_Group_Select_Column {
  /** column name */
  ActionCount = 'action_count',
  /** column name */
  Assignee = 'assignee',
  /** column name */
  AssigneeCount = 'assignee_count',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelCount = 'channel_count',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  DueDateCount = 'due_date_count',
  /** column name */
  IsRetry = 'is_retry',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  MessageCodeCount = 'message_code_count',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RecipientCount = 'recipient_count',
  /** column name */
  Reference = 'reference',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  StartTimeCount = 'start_time_count',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_action_group" */
export type Risolto_Virtual_Action_Group_Set_Input = {
  /** null */
  action_count?: Maybe<Scalars['bigint']>;
  assignee?: Maybe<Scalars['uuid']>;
  /** null */
  assignee_count?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  /** null */
  channel_count?: Maybe<Scalars['bigint']>;
  due_date?: Maybe<Scalars['date']>;
  /** null */
  due_date_count?: Maybe<Scalars['bigint']>;
  is_retry?: Maybe<Scalars['Boolean']>;
  last_updated_at?: Maybe<Scalars['timestamptz']>;
  message_code?: Maybe<Scalars['String']>;
  /** null */
  message_code_count?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** null */
  recipient_count?: Maybe<Scalars['bigint']>;
  reference?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  start_time_count?: Maybe<Scalars['bigint']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Risolto_Virtual_Action_Group_Stddev_Fields = {
  __typename?: 'risolto_virtual_action_group_stddev_fields';
  /** null */
  action_count?: Maybe<Scalars['Float']>;
  /** null */
  assignee_count?: Maybe<Scalars['Float']>;
  /** null */
  channel_count?: Maybe<Scalars['Float']>;
  /** null */
  due_date_count?: Maybe<Scalars['Float']>;
  /** null */
  message_code_count?: Maybe<Scalars['Float']>;
  /** null */
  recipient_count?: Maybe<Scalars['Float']>;
  start_time_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Virtual_Action_Group_Stddev_Pop_Fields = {
  __typename?: 'risolto_virtual_action_group_stddev_pop_fields';
  /** null */
  action_count?: Maybe<Scalars['Float']>;
  /** null */
  assignee_count?: Maybe<Scalars['Float']>;
  /** null */
  channel_count?: Maybe<Scalars['Float']>;
  /** null */
  due_date_count?: Maybe<Scalars['Float']>;
  /** null */
  message_code_count?: Maybe<Scalars['Float']>;
  /** null */
  recipient_count?: Maybe<Scalars['Float']>;
  start_time_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Virtual_Action_Group_Stddev_Samp_Fields = {
  __typename?: 'risolto_virtual_action_group_stddev_samp_fields';
  /** null */
  action_count?: Maybe<Scalars['Float']>;
  /** null */
  assignee_count?: Maybe<Scalars['Float']>;
  /** null */
  channel_count?: Maybe<Scalars['Float']>;
  /** null */
  due_date_count?: Maybe<Scalars['Float']>;
  /** null */
  message_code_count?: Maybe<Scalars['Float']>;
  /** null */
  recipient_count?: Maybe<Scalars['Float']>;
  start_time_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_virtual_action_group" */
export type Risolto_Virtual_Action_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Action_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Action_Group_Stream_Cursor_Value_Input = {
  /** null */
  action_count?: Maybe<Scalars['bigint']>;
  assignee?: Maybe<Scalars['uuid']>;
  /** null */
  assignee_count?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  /** null */
  channel_count?: Maybe<Scalars['bigint']>;
  due_date?: Maybe<Scalars['date']>;
  /** null */
  due_date_count?: Maybe<Scalars['bigint']>;
  is_retry?: Maybe<Scalars['Boolean']>;
  last_updated_at?: Maybe<Scalars['timestamptz']>;
  message_code?: Maybe<Scalars['String']>;
  /** null */
  message_code_count?: Maybe<Scalars['bigint']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  /** null */
  recipient_count?: Maybe<Scalars['bigint']>;
  reference?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  start_time_count?: Maybe<Scalars['bigint']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_Virtual_Action_Group_Sum_Fields = {
  __typename?: 'risolto_virtual_action_group_sum_fields';
  /** null */
  action_count?: Maybe<Scalars['bigint']>;
  /** null */
  assignee_count?: Maybe<Scalars['bigint']>;
  /** null */
  channel_count?: Maybe<Scalars['bigint']>;
  /** null */
  due_date_count?: Maybe<Scalars['bigint']>;
  /** null */
  message_code_count?: Maybe<Scalars['bigint']>;
  /** null */
  recipient_count?: Maybe<Scalars['bigint']>;
  start_time_count?: Maybe<Scalars['bigint']>;
};

/** update columns of table "risolto.virtual_action_group" */
export enum Risolto_Virtual_Action_Group_Update_Column {
  /** column name */
  ActionCount = 'action_count',
  /** column name */
  Assignee = 'assignee',
  /** column name */
  AssigneeCount = 'assignee_count',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChannelCount = 'channel_count',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  DueDateCount = 'due_date_count',
  /** column name */
  IsRetry = 'is_retry',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  MessageCodeCount = 'message_code_count',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  RecipientCount = 'recipient_count',
  /** column name */
  Reference = 'reference',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  StartTimeCount = 'start_time_count',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Action_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Virtual_Action_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Action_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Action_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Virtual_Action_Group_Var_Pop_Fields = {
  __typename?: 'risolto_virtual_action_group_var_pop_fields';
  /** null */
  action_count?: Maybe<Scalars['Float']>;
  /** null */
  assignee_count?: Maybe<Scalars['Float']>;
  /** null */
  channel_count?: Maybe<Scalars['Float']>;
  /** null */
  due_date_count?: Maybe<Scalars['Float']>;
  /** null */
  message_code_count?: Maybe<Scalars['Float']>;
  /** null */
  recipient_count?: Maybe<Scalars['Float']>;
  start_time_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Virtual_Action_Group_Var_Samp_Fields = {
  __typename?: 'risolto_virtual_action_group_var_samp_fields';
  /** null */
  action_count?: Maybe<Scalars['Float']>;
  /** null */
  assignee_count?: Maybe<Scalars['Float']>;
  /** null */
  channel_count?: Maybe<Scalars['Float']>;
  /** null */
  due_date_count?: Maybe<Scalars['Float']>;
  /** null */
  message_code_count?: Maybe<Scalars['Float']>;
  /** null */
  recipient_count?: Maybe<Scalars['Float']>;
  start_time_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Virtual_Action_Group_Variance_Fields = {
  __typename?: 'risolto_virtual_action_group_variance_fields';
  /** null */
  action_count?: Maybe<Scalars['Float']>;
  /** null */
  assignee_count?: Maybe<Scalars['Float']>;
  /** null */
  channel_count?: Maybe<Scalars['Float']>;
  /** null */
  due_date_count?: Maybe<Scalars['Float']>;
  /** null */
  message_code_count?: Maybe<Scalars['Float']>;
  /** null */
  recipient_count?: Maybe<Scalars['Float']>;
  start_time_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats = {
  __typename?: 'risolto_virtual_dashboard_action_stats';
  action_count: Scalars['bigint'];
  channel: Risolto_Channel_Enum;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  status: Scalars['String'];
  v_reference: Scalars['uuid'];
};

export type Risolto_Virtual_Dashboard_Action_Stats_Aggregate = {
  __typename?: 'risolto_virtual_dashboard_action_stats_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Dashboard_Action_Stats>;
};

/** aggregate fields of "risolto.virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats_Aggregate_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_aggregate_fields';
  avg?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Min_Fields>;
  stddev?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Sum_Fields>;
  var_pop?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Variance_Fields>;
};


/** aggregate fields of "risolto.virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Avg_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_avg_fields';
  action_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_dashboard_action_stats". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>>;
  action_count?: Maybe<Bigint_Comparison_Exp>;
  channel?: Maybe<Risolto_Channel_Enum_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_dashboard_action_stats" */
export enum Risolto_Virtual_Dashboard_Action_Stats_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualDashboardActionCountPkey = 'virtual_dashboard_action_count_pkey'
}

/** input type for incrementing numeric columns in table "risolto.virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats_Inc_Input = {
  action_count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "risolto.virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats_Insert_Input = {
  action_count?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Risolto_Channel_Enum>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Max_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_max_fields';
  action_count?: Maybe<Scalars['bigint']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Min_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_min_fields';
  action_count?: Maybe<Scalars['bigint']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats_Mutation_Response = {
  __typename?: 'risolto_virtual_dashboard_action_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Dashboard_Action_Stats>;
};

/** on_conflict condition type for table "risolto.virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats_On_Conflict = {
  constraint: Risolto_Virtual_Dashboard_Action_Stats_Constraint;
  update_columns?: Array<Risolto_Virtual_Dashboard_Action_Stats_Update_Column>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_dashboard_action_stats". */
export type Risolto_Virtual_Dashboard_Action_Stats_Order_By = {
  action_count?: Maybe<Order_By>;
  channel?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  status?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_dashboard_action_stats */
export type Risolto_Virtual_Dashboard_Action_Stats_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** select columns of table "risolto.virtual_dashboard_action_stats" */
export enum Risolto_Virtual_Dashboard_Action_Stats_Select_Column {
  /** column name */
  ActionCount = 'action_count',
  /** column name */
  Channel = 'channel',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Status = 'status',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats_Set_Input = {
  action_count?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Risolto_Channel_Enum>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Stddev_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_stddev_fields';
  action_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Stddev_Pop_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_stddev_pop_fields';
  action_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Stddev_Samp_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_stddev_samp_fields';
  action_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_virtual_dashboard_action_stats" */
export type Risolto_Virtual_Dashboard_Action_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Dashboard_Action_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Dashboard_Action_Stats_Stream_Cursor_Value_Input = {
  action_count?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Risolto_Channel_Enum>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Sum_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_sum_fields';
  action_count?: Maybe<Scalars['bigint']>;
};

/** update columns of table "risolto.virtual_dashboard_action_stats" */
export enum Risolto_Virtual_Dashboard_Action_Stats_Update_Column {
  /** column name */
  ActionCount = 'action_count',
  /** column name */
  Channel = 'channel',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Status = 'status',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Dashboard_Action_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Var_Pop_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_var_pop_fields';
  action_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Var_Samp_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_var_samp_fields';
  action_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Virtual_Dashboard_Action_Stats_Variance_Fields = {
  __typename?: 'risolto_virtual_dashboard_action_stats_variance_fields';
  action_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt';
  m_0?: Maybe<Scalars['numeric']>;
  m_1?: Maybe<Scalars['numeric']>;
  m_10?: Maybe<Scalars['numeric']>;
  m_11?: Maybe<Scalars['numeric']>;
  m_12?: Maybe<Scalars['numeric']>;
  m_2?: Maybe<Scalars['numeric']>;
  m_3?: Maybe<Scalars['numeric']>;
  m_4?: Maybe<Scalars['numeric']>;
  m_5?: Maybe<Scalars['numeric']>;
  m_6?: Maybe<Scalars['numeric']>;
  m_7?: Maybe<Scalars['numeric']>;
  m_8?: Maybe<Scalars['numeric']>;
  m_9?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  result: Scalars['String'];
  v_reference: Scalars['uuid'];
};

export type Risolto_Virtual_Dashboard_Outstanding_Debt_Aggregate = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Dashboard_Outstanding_Debt>;
};

/** aggregate fields of "risolto.virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Aggregate_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_aggregate_fields';
  avg?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Min_Fields>;
  stddev?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Sum_Fields>;
  var_pop?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Variance_Fields>;
};


/** aggregate fields of "risolto.virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Avg_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_avg_fields';
  m_0?: Maybe<Scalars['Float']>;
  m_1?: Maybe<Scalars['Float']>;
  m_10?: Maybe<Scalars['Float']>;
  m_11?: Maybe<Scalars['Float']>;
  m_12?: Maybe<Scalars['Float']>;
  m_2?: Maybe<Scalars['Float']>;
  m_3?: Maybe<Scalars['Float']>;
  m_4?: Maybe<Scalars['Float']>;
  m_5?: Maybe<Scalars['Float']>;
  m_6?: Maybe<Scalars['Float']>;
  m_7?: Maybe<Scalars['Float']>;
  m_8?: Maybe<Scalars['Float']>;
  m_9?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_dashboard_outstanding_debt". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>>;
  m_0?: Maybe<Numeric_Comparison_Exp>;
  m_1?: Maybe<Numeric_Comparison_Exp>;
  m_10?: Maybe<Numeric_Comparison_Exp>;
  m_11?: Maybe<Numeric_Comparison_Exp>;
  m_12?: Maybe<Numeric_Comparison_Exp>;
  m_2?: Maybe<Numeric_Comparison_Exp>;
  m_3?: Maybe<Numeric_Comparison_Exp>;
  m_4?: Maybe<Numeric_Comparison_Exp>;
  m_5?: Maybe<Numeric_Comparison_Exp>;
  m_6?: Maybe<Numeric_Comparison_Exp>;
  m_7?: Maybe<Numeric_Comparison_Exp>;
  m_8?: Maybe<Numeric_Comparison_Exp>;
  m_9?: Maybe<Numeric_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  result?: Maybe<String_Comparison_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_dashboard_outstanding_debt" */
export enum Risolto_Virtual_Dashboard_Outstanding_Debt_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualDashboardOutstandingDebtPkey = 'virtual_dashboard_outstanding_debt_pkey'
}

/** input type for incrementing numeric columns in table "risolto.virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Inc_Input = {
  m_0?: Maybe<Scalars['numeric']>;
  m_1?: Maybe<Scalars['numeric']>;
  m_10?: Maybe<Scalars['numeric']>;
  m_11?: Maybe<Scalars['numeric']>;
  m_12?: Maybe<Scalars['numeric']>;
  m_2?: Maybe<Scalars['numeric']>;
  m_3?: Maybe<Scalars['numeric']>;
  m_4?: Maybe<Scalars['numeric']>;
  m_5?: Maybe<Scalars['numeric']>;
  m_6?: Maybe<Scalars['numeric']>;
  m_7?: Maybe<Scalars['numeric']>;
  m_8?: Maybe<Scalars['numeric']>;
  m_9?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "risolto.virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Insert_Input = {
  m_0?: Maybe<Scalars['numeric']>;
  m_1?: Maybe<Scalars['numeric']>;
  m_10?: Maybe<Scalars['numeric']>;
  m_11?: Maybe<Scalars['numeric']>;
  m_12?: Maybe<Scalars['numeric']>;
  m_2?: Maybe<Scalars['numeric']>;
  m_3?: Maybe<Scalars['numeric']>;
  m_4?: Maybe<Scalars['numeric']>;
  m_5?: Maybe<Scalars['numeric']>;
  m_6?: Maybe<Scalars['numeric']>;
  m_7?: Maybe<Scalars['numeric']>;
  m_8?: Maybe<Scalars['numeric']>;
  m_9?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  result?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Max_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_max_fields';
  m_0?: Maybe<Scalars['numeric']>;
  m_1?: Maybe<Scalars['numeric']>;
  m_10?: Maybe<Scalars['numeric']>;
  m_11?: Maybe<Scalars['numeric']>;
  m_12?: Maybe<Scalars['numeric']>;
  m_2?: Maybe<Scalars['numeric']>;
  m_3?: Maybe<Scalars['numeric']>;
  m_4?: Maybe<Scalars['numeric']>;
  m_5?: Maybe<Scalars['numeric']>;
  m_6?: Maybe<Scalars['numeric']>;
  m_7?: Maybe<Scalars['numeric']>;
  m_8?: Maybe<Scalars['numeric']>;
  m_9?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Min_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_min_fields';
  m_0?: Maybe<Scalars['numeric']>;
  m_1?: Maybe<Scalars['numeric']>;
  m_10?: Maybe<Scalars['numeric']>;
  m_11?: Maybe<Scalars['numeric']>;
  m_12?: Maybe<Scalars['numeric']>;
  m_2?: Maybe<Scalars['numeric']>;
  m_3?: Maybe<Scalars['numeric']>;
  m_4?: Maybe<Scalars['numeric']>;
  m_5?: Maybe<Scalars['numeric']>;
  m_6?: Maybe<Scalars['numeric']>;
  m_7?: Maybe<Scalars['numeric']>;
  m_8?: Maybe<Scalars['numeric']>;
  m_9?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Mutation_Response = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Dashboard_Outstanding_Debt>;
};

/** on_conflict condition type for table "risolto.virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_On_Conflict = {
  constraint: Risolto_Virtual_Dashboard_Outstanding_Debt_Constraint;
  update_columns?: Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Update_Column>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_dashboard_outstanding_debt". */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By = {
  m_0?: Maybe<Order_By>;
  m_1?: Maybe<Order_By>;
  m_10?: Maybe<Order_By>;
  m_11?: Maybe<Order_By>;
  m_12?: Maybe<Order_By>;
  m_2?: Maybe<Order_By>;
  m_3?: Maybe<Order_By>;
  m_4?: Maybe<Order_By>;
  m_5?: Maybe<Order_By>;
  m_6?: Maybe<Order_By>;
  m_7?: Maybe<Order_By>;
  m_8?: Maybe<Order_By>;
  m_9?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  result?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_dashboard_outstanding_debt */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** select columns of table "risolto.virtual_dashboard_outstanding_debt" */
export enum Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column {
  /** column name */
  M_0 = 'm_0',
  /** column name */
  M_1 = 'm_1',
  /** column name */
  M_10 = 'm_10',
  /** column name */
  M_11 = 'm_11',
  /** column name */
  M_12 = 'm_12',
  /** column name */
  M_2 = 'm_2',
  /** column name */
  M_3 = 'm_3',
  /** column name */
  M_4 = 'm_4',
  /** column name */
  M_5 = 'm_5',
  /** column name */
  M_6 = 'm_6',
  /** column name */
  M_7 = 'm_7',
  /** column name */
  M_8 = 'm_8',
  /** column name */
  M_9 = 'm_9',
  /** column name */
  Participant = 'participant',
  /** column name */
  Result = 'result',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Set_Input = {
  m_0?: Maybe<Scalars['numeric']>;
  m_1?: Maybe<Scalars['numeric']>;
  m_10?: Maybe<Scalars['numeric']>;
  m_11?: Maybe<Scalars['numeric']>;
  m_12?: Maybe<Scalars['numeric']>;
  m_2?: Maybe<Scalars['numeric']>;
  m_3?: Maybe<Scalars['numeric']>;
  m_4?: Maybe<Scalars['numeric']>;
  m_5?: Maybe<Scalars['numeric']>;
  m_6?: Maybe<Scalars['numeric']>;
  m_7?: Maybe<Scalars['numeric']>;
  m_8?: Maybe<Scalars['numeric']>;
  m_9?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Stddev_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_stddev_fields';
  m_0?: Maybe<Scalars['Float']>;
  m_1?: Maybe<Scalars['Float']>;
  m_10?: Maybe<Scalars['Float']>;
  m_11?: Maybe<Scalars['Float']>;
  m_12?: Maybe<Scalars['Float']>;
  m_2?: Maybe<Scalars['Float']>;
  m_3?: Maybe<Scalars['Float']>;
  m_4?: Maybe<Scalars['Float']>;
  m_5?: Maybe<Scalars['Float']>;
  m_6?: Maybe<Scalars['Float']>;
  m_7?: Maybe<Scalars['Float']>;
  m_8?: Maybe<Scalars['Float']>;
  m_9?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Stddev_Pop_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_stddev_pop_fields';
  m_0?: Maybe<Scalars['Float']>;
  m_1?: Maybe<Scalars['Float']>;
  m_10?: Maybe<Scalars['Float']>;
  m_11?: Maybe<Scalars['Float']>;
  m_12?: Maybe<Scalars['Float']>;
  m_2?: Maybe<Scalars['Float']>;
  m_3?: Maybe<Scalars['Float']>;
  m_4?: Maybe<Scalars['Float']>;
  m_5?: Maybe<Scalars['Float']>;
  m_6?: Maybe<Scalars['Float']>;
  m_7?: Maybe<Scalars['Float']>;
  m_8?: Maybe<Scalars['Float']>;
  m_9?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Stddev_Samp_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_stddev_samp_fields';
  m_0?: Maybe<Scalars['Float']>;
  m_1?: Maybe<Scalars['Float']>;
  m_10?: Maybe<Scalars['Float']>;
  m_11?: Maybe<Scalars['Float']>;
  m_12?: Maybe<Scalars['Float']>;
  m_2?: Maybe<Scalars['Float']>;
  m_3?: Maybe<Scalars['Float']>;
  m_4?: Maybe<Scalars['Float']>;
  m_5?: Maybe<Scalars['Float']>;
  m_6?: Maybe<Scalars['Float']>;
  m_7?: Maybe<Scalars['Float']>;
  m_8?: Maybe<Scalars['Float']>;
  m_9?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_virtual_dashboard_outstanding_debt" */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Dashboard_Outstanding_Debt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Stream_Cursor_Value_Input = {
  m_0?: Maybe<Scalars['numeric']>;
  m_1?: Maybe<Scalars['numeric']>;
  m_10?: Maybe<Scalars['numeric']>;
  m_11?: Maybe<Scalars['numeric']>;
  m_12?: Maybe<Scalars['numeric']>;
  m_2?: Maybe<Scalars['numeric']>;
  m_3?: Maybe<Scalars['numeric']>;
  m_4?: Maybe<Scalars['numeric']>;
  m_5?: Maybe<Scalars['numeric']>;
  m_6?: Maybe<Scalars['numeric']>;
  m_7?: Maybe<Scalars['numeric']>;
  m_8?: Maybe<Scalars['numeric']>;
  m_9?: Maybe<Scalars['numeric']>;
  participant?: Maybe<Scalars['uuid']>;
  result?: Maybe<Scalars['String']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Sum_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_sum_fields';
  m_0?: Maybe<Scalars['numeric']>;
  m_1?: Maybe<Scalars['numeric']>;
  m_10?: Maybe<Scalars['numeric']>;
  m_11?: Maybe<Scalars['numeric']>;
  m_12?: Maybe<Scalars['numeric']>;
  m_2?: Maybe<Scalars['numeric']>;
  m_3?: Maybe<Scalars['numeric']>;
  m_4?: Maybe<Scalars['numeric']>;
  m_5?: Maybe<Scalars['numeric']>;
  m_6?: Maybe<Scalars['numeric']>;
  m_7?: Maybe<Scalars['numeric']>;
  m_8?: Maybe<Scalars['numeric']>;
  m_9?: Maybe<Scalars['numeric']>;
};

/** update columns of table "risolto.virtual_dashboard_outstanding_debt" */
export enum Risolto_Virtual_Dashboard_Outstanding_Debt_Update_Column {
  /** column name */
  M_0 = 'm_0',
  /** column name */
  M_1 = 'm_1',
  /** column name */
  M_10 = 'm_10',
  /** column name */
  M_11 = 'm_11',
  /** column name */
  M_12 = 'm_12',
  /** column name */
  M_2 = 'm_2',
  /** column name */
  M_3 = 'm_3',
  /** column name */
  M_4 = 'm_4',
  /** column name */
  M_5 = 'm_5',
  /** column name */
  M_6 = 'm_6',
  /** column name */
  M_7 = 'm_7',
  /** column name */
  M_8 = 'm_8',
  /** column name */
  M_9 = 'm_9',
  /** column name */
  Participant = 'participant',
  /** column name */
  Result = 'result',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Dashboard_Outstanding_Debt_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Var_Pop_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_var_pop_fields';
  m_0?: Maybe<Scalars['Float']>;
  m_1?: Maybe<Scalars['Float']>;
  m_10?: Maybe<Scalars['Float']>;
  m_11?: Maybe<Scalars['Float']>;
  m_12?: Maybe<Scalars['Float']>;
  m_2?: Maybe<Scalars['Float']>;
  m_3?: Maybe<Scalars['Float']>;
  m_4?: Maybe<Scalars['Float']>;
  m_5?: Maybe<Scalars['Float']>;
  m_6?: Maybe<Scalars['Float']>;
  m_7?: Maybe<Scalars['Float']>;
  m_8?: Maybe<Scalars['Float']>;
  m_9?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Var_Samp_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_var_samp_fields';
  m_0?: Maybe<Scalars['Float']>;
  m_1?: Maybe<Scalars['Float']>;
  m_10?: Maybe<Scalars['Float']>;
  m_11?: Maybe<Scalars['Float']>;
  m_12?: Maybe<Scalars['Float']>;
  m_2?: Maybe<Scalars['Float']>;
  m_3?: Maybe<Scalars['Float']>;
  m_4?: Maybe<Scalars['Float']>;
  m_5?: Maybe<Scalars['Float']>;
  m_6?: Maybe<Scalars['Float']>;
  m_7?: Maybe<Scalars['Float']>;
  m_8?: Maybe<Scalars['Float']>;
  m_9?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Virtual_Dashboard_Outstanding_Debt_Variance_Fields = {
  __typename?: 'risolto_virtual_dashboard_outstanding_debt_variance_fields';
  m_0?: Maybe<Scalars['Float']>;
  m_1?: Maybe<Scalars['Float']>;
  m_10?: Maybe<Scalars['Float']>;
  m_11?: Maybe<Scalars['Float']>;
  m_12?: Maybe<Scalars['Float']>;
  m_2?: Maybe<Scalars['Float']>;
  m_3?: Maybe<Scalars['Float']>;
  m_4?: Maybe<Scalars['Float']>;
  m_5?: Maybe<Scalars['Float']>;
  m_6?: Maybe<Scalars['Float']>;
  m_7?: Maybe<Scalars['Float']>;
  m_8?: Maybe<Scalars['Float']>;
  m_9?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1 = {
  __typename?: 'risolto_virtual_demo_action_report_1';
  actions_executed: Scalars['Int'];
  channel: Scalars['String'];
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  month: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  v_reference: Scalars['uuid'];
  year: Scalars['String'];
};

export type Risolto_Virtual_Demo_Action_Report_1_Aggregate = {
  __typename?: 'risolto_virtual_demo_action_report_1_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Demo_Action_Report_1>;
};

/** aggregate fields of "risolto.virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1_Aggregate_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_aggregate_fields';
  avg?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Min_Fields>;
  stddev?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Sum_Fields>;
  var_pop?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Variance_Fields>;
};


/** aggregate fields of "risolto.virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Avg_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_avg_fields';
  actions_executed?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_demo_action_report_1". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Demo_Action_Report_1_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>>;
  actions_executed?: Maybe<Int_Comparison_Exp>;
  channel?: Maybe<String_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  month?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
  year?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_demo_action_report_1" */
export enum Risolto_Virtual_Demo_Action_Report_1_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualDemoActionReport_1Pkey = 'virtual_demo_action_report_1_pkey'
}

/** input type for incrementing numeric columns in table "risolto.virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1_Inc_Input = {
  actions_executed?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "risolto.virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1_Insert_Input = {
  actions_executed?: Maybe<Scalars['Int']>;
  channel?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  month?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  v_reference?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Max_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_max_fields';
  actions_executed?: Maybe<Scalars['Int']>;
  channel?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Min_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_min_fields';
  actions_executed?: Maybe<Scalars['Int']>;
  channel?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1_Mutation_Response = {
  __typename?: 'risolto_virtual_demo_action_report_1_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Demo_Action_Report_1>;
};

/** on_conflict condition type for table "risolto.virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1_On_Conflict = {
  constraint: Risolto_Virtual_Demo_Action_Report_1_Constraint;
  update_columns?: Array<Risolto_Virtual_Demo_Action_Report_1_Update_Column>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_demo_action_report_1". */
export type Risolto_Virtual_Demo_Action_Report_1_Order_By = {
  actions_executed?: Maybe<Order_By>;
  channel?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  month?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  v_reference?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_demo_action_report_1 */
export type Risolto_Virtual_Demo_Action_Report_1_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** select columns of table "risolto.virtual_demo_action_report_1" */
export enum Risolto_Virtual_Demo_Action_Report_1_Select_Column {
  /** column name */
  ActionsExecuted = 'actions_executed',
  /** column name */
  Channel = 'channel',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Month = 'month',
  /** column name */
  Participant = 'participant',
  /** column name */
  VReference = 'v_reference',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "risolto.virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1_Set_Input = {
  actions_executed?: Maybe<Scalars['Int']>;
  channel?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Stddev_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_stddev_fields';
  actions_executed?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Stddev_Pop_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_stddev_pop_fields';
  actions_executed?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Stddev_Samp_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_stddev_samp_fields';
  actions_executed?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_virtual_demo_action_report_1" */
export type Risolto_Virtual_Demo_Action_Report_1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Demo_Action_Report_1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Demo_Action_Report_1_Stream_Cursor_Value_Input = {
  actions_executed?: Maybe<Scalars['Int']>;
  channel?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Sum_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_sum_fields';
  actions_executed?: Maybe<Scalars['Int']>;
};

/** update columns of table "risolto.virtual_demo_action_report_1" */
export enum Risolto_Virtual_Demo_Action_Report_1_Update_Column {
  /** column name */
  ActionsExecuted = 'actions_executed',
  /** column name */
  Channel = 'channel',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Month = 'month',
  /** column name */
  Participant = 'participant',
  /** column name */
  VReference = 'v_reference',
  /** column name */
  Year = 'year'
}

export type Risolto_Virtual_Demo_Action_Report_1_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Demo_Action_Report_1_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Var_Pop_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_var_pop_fields';
  actions_executed?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Var_Samp_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_var_samp_fields';
  actions_executed?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Virtual_Demo_Action_Report_1_Variance_Fields = {
  __typename?: 'risolto_virtual_demo_action_report_1_variance_fields';
  actions_executed?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action = {
  __typename?: 'risolto_virtual_dunning_action';
  action: Scalars['uuid'];
  /** An object relationship */
  action_by_reference: Risolto_Action;
  executed_or_canceled_at?: Maybe<Scalars['timestamptz']>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  message_code: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  v_reference: Scalars['uuid'];
};

/** aggregated selection of "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Aggregate = {
  __typename?: 'risolto_virtual_dunning_action_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Dunning_Action_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Dunning_Action>;
};

/** aggregate fields of "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Aggregate_Fields = {
  __typename?: 'risolto_virtual_dunning_action_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Dunning_Action_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Dunning_Action_Min_Fields>;
};


/** aggregate fields of "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Virtual_Dunning_Action_Max_Order_By>;
  min?: Maybe<Risolto_Virtual_Dunning_Action_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_dunning_action". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Dunning_Action_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Dunning_Action_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Dunning_Action_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  executed_or_canceled_at?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  message_code?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_dunning_action" */
export enum Risolto_Virtual_Dunning_Action_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualDunningActionPkey = 'virtual_dunning_action_pkey'
}

/** input type for inserting data into table "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Insert_Input = {
  action?: Maybe<Scalars['uuid']>;
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  executed_or_canceled_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  message_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Dunning_Action_Max_Fields = {
  __typename?: 'risolto_virtual_dunning_action_max_fields';
  action?: Maybe<Scalars['uuid']>;
  executed_or_canceled_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Max_Order_By = {
  action?: Maybe<Order_By>;
  executed_or_canceled_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message_code?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Dunning_Action_Min_Fields = {
  __typename?: 'risolto_virtual_dunning_action_min_fields';
  action?: Maybe<Scalars['uuid']>;
  executed_or_canceled_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Min_Order_By = {
  action?: Maybe<Order_By>;
  executed_or_canceled_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  message_code?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Mutation_Response = {
  __typename?: 'risolto_virtual_dunning_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Dunning_Action>;
};

/** on_conflict condition type for table "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_On_Conflict = {
  constraint: Risolto_Virtual_Dunning_Action_Constraint;
  update_columns?: Array<Risolto_Virtual_Dunning_Action_Update_Column>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_dunning_action". */
export type Risolto_Virtual_Dunning_Action_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  executed_or_canceled_at?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  message_code?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_dunning_action */
export type Risolto_Virtual_Dunning_Action_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** select columns of table "risolto.virtual_dunning_action" */
export enum Risolto_Virtual_Dunning_Action_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ExecutedOrCanceledAt = 'executed_or_canceled_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Participant = 'participant',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Set_Input = {
  action?: Maybe<Scalars['uuid']>;
  executed_or_canceled_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "risolto_virtual_dunning_action" */
export type Risolto_Virtual_Dunning_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Dunning_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Dunning_Action_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  executed_or_canceled_at?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  message_code?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** update columns of table "risolto.virtual_dunning_action" */
export enum Risolto_Virtual_Dunning_Action_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ExecutedOrCanceledAt = 'executed_or_canceled_at',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  MessageCode = 'message_code',
  /** column name */
  Participant = 'participant',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Dunning_Action_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Dunning_Action_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Dunning_Action_Bool_Exp;
};

/** columns and relationships of "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event = {
  __typename?: 'risolto_virtual_interchange_event';
  channel_endpoint: Scalars['jsonb'];
  event_type: Scalars['String'];
  event_type_count: Scalars['bigint'];
  interchange: Scalars['uuid'];
  /** An object relationship */
  interchange_by_reference: Risolto_Document_Interchange;
  last_event_timestamp: Scalars['timestamptz'];
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  v_reference: Scalars['uuid'];
};


/** columns and relationships of "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_EventChannel_EndpointArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Aggregate = {
  __typename?: 'risolto_virtual_interchange_event_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Interchange_Event_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Interchange_Event>;
};

/** aggregate fields of "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Aggregate_Fields = {
  __typename?: 'risolto_virtual_interchange_event_aggregate_fields';
  avg?: Maybe<Risolto_Virtual_Interchange_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Interchange_Event_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Interchange_Event_Min_Fields>;
  stddev?: Maybe<Risolto_Virtual_Interchange_Event_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Virtual_Interchange_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Virtual_Interchange_Event_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Virtual_Interchange_Event_Sum_Fields>;
  var_pop?: Maybe<Risolto_Virtual_Interchange_Event_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Virtual_Interchange_Event_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Virtual_Interchange_Event_Variance_Fields>;
};


/** aggregate fields of "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Interchange_Event_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Virtual_Interchange_Event_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Virtual_Interchange_Event_Max_Order_By>;
  min?: Maybe<Risolto_Virtual_Interchange_Event_Min_Order_By>;
  stddev?: Maybe<Risolto_Virtual_Interchange_Event_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Virtual_Interchange_Event_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Virtual_Interchange_Event_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Virtual_Interchange_Event_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Virtual_Interchange_Event_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Virtual_Interchange_Event_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Virtual_Interchange_Event_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Interchange_Event_Append_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Risolto_Virtual_Interchange_Event_Avg_Fields = {
  __typename?: 'risolto_virtual_interchange_event_avg_fields';
  event_type_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Avg_Order_By = {
  event_type_count?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_interchange_event". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Interchange_Event_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Interchange_Event_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Interchange_Event_Bool_Exp>>;
  channel_endpoint?: Maybe<Jsonb_Comparison_Exp>;
  event_type?: Maybe<String_Comparison_Exp>;
  event_type_count?: Maybe<Bigint_Comparison_Exp>;
  interchange?: Maybe<Uuid_Comparison_Exp>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
  last_event_timestamp?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_interchange_event" */
export enum Risolto_Virtual_Interchange_Event_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualInterchangeEventPkey = 'virtual_interchange_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Virtual_Interchange_Event_Delete_At_Path_Input = {
  channel_endpoint?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Virtual_Interchange_Event_Delete_Elem_Input = {
  channel_endpoint?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Virtual_Interchange_Event_Delete_Key_Input = {
  channel_endpoint?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Inc_Input = {
  event_type_count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Insert_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
  event_type?: Maybe<Scalars['String']>;
  event_type_count?: Maybe<Scalars['bigint']>;
  interchange?: Maybe<Scalars['uuid']>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Obj_Rel_Insert_Input>;
  last_event_timestamp?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Interchange_Event_Max_Fields = {
  __typename?: 'risolto_virtual_interchange_event_max_fields';
  event_type?: Maybe<Scalars['String']>;
  event_type_count?: Maybe<Scalars['bigint']>;
  interchange?: Maybe<Scalars['uuid']>;
  last_event_timestamp?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Max_Order_By = {
  event_type?: Maybe<Order_By>;
  event_type_count?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  last_event_timestamp?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Interchange_Event_Min_Fields = {
  __typename?: 'risolto_virtual_interchange_event_min_fields';
  event_type?: Maybe<Scalars['String']>;
  event_type_count?: Maybe<Scalars['bigint']>;
  interchange?: Maybe<Scalars['uuid']>;
  last_event_timestamp?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Min_Order_By = {
  event_type?: Maybe<Order_By>;
  event_type_count?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  last_event_timestamp?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Mutation_Response = {
  __typename?: 'risolto_virtual_interchange_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Interchange_Event>;
};

/** on_conflict condition type for table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_On_Conflict = {
  constraint: Risolto_Virtual_Interchange_Event_Constraint;
  update_columns?: Array<Risolto_Virtual_Interchange_Event_Update_Column>;
  where?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_interchange_event". */
export type Risolto_Virtual_Interchange_Event_Order_By = {
  channel_endpoint?: Maybe<Order_By>;
  event_type?: Maybe<Order_By>;
  event_type_count?: Maybe<Order_By>;
  interchange?: Maybe<Order_By>;
  interchange_by_reference?: Maybe<Risolto_Document_Interchange_Order_By>;
  last_event_timestamp?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_interchange_event */
export type Risolto_Virtual_Interchange_Event_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Interchange_Event_Prepend_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.virtual_interchange_event" */
export enum Risolto_Virtual_Interchange_Event_Select_Column {
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  EventType = 'event_type',
  /** column name */
  EventTypeCount = 'event_type_count',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  LastEventTimestamp = 'last_event_timestamp',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Set_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
  event_type?: Maybe<Scalars['String']>;
  event_type_count?: Maybe<Scalars['bigint']>;
  interchange?: Maybe<Scalars['uuid']>;
  last_event_timestamp?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Risolto_Virtual_Interchange_Event_Stddev_Fields = {
  __typename?: 'risolto_virtual_interchange_event_stddev_fields';
  event_type_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Stddev_Order_By = {
  event_type_count?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Virtual_Interchange_Event_Stddev_Pop_Fields = {
  __typename?: 'risolto_virtual_interchange_event_stddev_pop_fields';
  event_type_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Stddev_Pop_Order_By = {
  event_type_count?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Virtual_Interchange_Event_Stddev_Samp_Fields = {
  __typename?: 'risolto_virtual_interchange_event_stddev_samp_fields';
  event_type_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Stddev_Samp_Order_By = {
  event_type_count?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Interchange_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Interchange_Event_Stream_Cursor_Value_Input = {
  channel_endpoint?: Maybe<Scalars['jsonb']>;
  event_type?: Maybe<Scalars['String']>;
  event_type_count?: Maybe<Scalars['bigint']>;
  interchange?: Maybe<Scalars['uuid']>;
  last_event_timestamp?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_Virtual_Interchange_Event_Sum_Fields = {
  __typename?: 'risolto_virtual_interchange_event_sum_fields';
  event_type_count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Sum_Order_By = {
  event_type_count?: Maybe<Order_By>;
};

/** update columns of table "risolto.virtual_interchange_event" */
export enum Risolto_Virtual_Interchange_Event_Update_Column {
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  EventType = 'event_type',
  /** column name */
  EventTypeCount = 'event_type_count',
  /** column name */
  Interchange = 'interchange',
  /** column name */
  LastEventTimestamp = 'last_event_timestamp',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Interchange_Event_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Virtual_Interchange_Event_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Virtual_Interchange_Event_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Virtual_Interchange_Event_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Virtual_Interchange_Event_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Virtual_Interchange_Event_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Virtual_Interchange_Event_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Interchange_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Interchange_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Virtual_Interchange_Event_Var_Pop_Fields = {
  __typename?: 'risolto_virtual_interchange_event_var_pop_fields';
  event_type_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Var_Pop_Order_By = {
  event_type_count?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Virtual_Interchange_Event_Var_Samp_Fields = {
  __typename?: 'risolto_virtual_interchange_event_var_samp_fields';
  event_type_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Var_Samp_Order_By = {
  event_type_count?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Virtual_Interchange_Event_Variance_Fields = {
  __typename?: 'risolto_virtual_interchange_event_variance_fields';
  event_type_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.virtual_interchange_event" */
export type Risolto_Virtual_Interchange_Event_Variance_Order_By = {
  event_type_count?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information';
  invoice: Scalars['uuid'];
  /** An object relationship */
  invoice_by_reference: Risolto_Invoice_Document;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  paid_at: Scalars['timestamptz'];
  paid_at_margin: Scalars['Int'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  v_reference: Scalars['uuid'];
};

/** aggregated selection of "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Aggregate = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Invoice_Derived_Payment_Information>;
};

/** aggregate fields of "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Aggregate_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_aggregate_fields';
  avg?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Min_Fields>;
  stddev?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Sum_Fields>;
  var_pop?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Variance_Fields>;
};


/** aggregate fields of "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Aggregate_Order_By = {
  avg?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Max_Order_By>;
  min?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Min_Order_By>;
  stddev?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Order_By>;
  stddev_pop?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Samp_Order_By>;
  sum?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Sum_Order_By>;
  var_pop?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Var_Pop_Order_By>;
  var_samp?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Var_Samp_Order_By>;
  variance?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Avg_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_avg_fields';
  paid_at_margin?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Avg_Order_By = {
  paid_at_margin?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_invoice_derived_payment_information". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>>;
  invoice?: Maybe<Uuid_Comparison_Exp>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  paid_at?: Maybe<Timestamptz_Comparison_Exp>;
  paid_at_margin?: Maybe<Int_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_invoice_derived_payment_information" */
export enum Risolto_Virtual_Invoice_Derived_Payment_Information_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualInvoiceDerivedInformationPkey = 'virtual_invoice_derived_information_pkey'
}

/** input type for incrementing numeric columns in table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Inc_Input = {
  paid_at_margin?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Insert_Input = {
  invoice?: Maybe<Scalars['uuid']>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  paid_at_margin?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Max_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_max_fields';
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  paid_at_margin?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Max_Order_By = {
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  paid_at?: Maybe<Order_By>;
  paid_at_margin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Min_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_min_fields';
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  paid_at_margin?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Min_Order_By = {
  invoice?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  paid_at?: Maybe<Order_By>;
  paid_at_margin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  recipient?: Maybe<Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** response of any mutation on the table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Mutation_Response = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Invoice_Derived_Payment_Information>;
};

/** on_conflict condition type for table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_On_Conflict = {
  constraint: Risolto_Virtual_Invoice_Derived_Payment_Information_Constraint;
  update_columns?: Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Update_Column>;
  where?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_invoice_derived_payment_information". */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Order_By = {
  invoice?: Maybe<Order_By>;
  invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  paid_at?: Maybe<Order_By>;
  paid_at_margin?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_invoice_derived_payment_information */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** select columns of table "risolto.virtual_invoice_derived_payment_information" */
export enum Risolto_Virtual_Invoice_Derived_Payment_Information_Select_Column {
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  PaidAtMargin = 'paid_at_margin',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Set_Input = {
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  paid_at_margin?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_stddev_fields';
  paid_at_margin?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Order_By = {
  paid_at_margin?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Pop_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_stddev_pop_fields';
  paid_at_margin?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Pop_Order_By = {
  paid_at_margin?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Samp_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_stddev_samp_fields';
  paid_at_margin?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Stddev_Samp_Order_By = {
  paid_at_margin?: Maybe<Order_By>;
};

/** Streaming cursor of the table "risolto_virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Invoice_Derived_Payment_Information_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Stream_Cursor_Value_Input = {
  invoice?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  paid_at_margin?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Sum_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_sum_fields';
  paid_at_margin?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Sum_Order_By = {
  paid_at_margin?: Maybe<Order_By>;
};

/** update columns of table "risolto.virtual_invoice_derived_payment_information" */
export enum Risolto_Virtual_Invoice_Derived_Payment_Information_Update_Column {
  /** column name */
  Invoice = 'invoice',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  PaidAtMargin = 'paid_at_margin',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Invoice_Derived_Payment_Information_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Var_Pop_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_var_pop_fields';
  paid_at_margin?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Var_Pop_Order_By = {
  paid_at_margin?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Var_Samp_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_var_samp_fields';
  paid_at_margin?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Var_Samp_Order_By = {
  paid_at_margin?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Variance_Fields = {
  __typename?: 'risolto_virtual_invoice_derived_payment_information_variance_fields';
  paid_at_margin?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "risolto.virtual_invoice_derived_payment_information" */
export type Risolto_Virtual_Invoice_Derived_Payment_Information_Variance_Order_By = {
  paid_at_margin?: Maybe<Order_By>;
};

/** columns and relationships of "risolto.virtual_invoicing_channel_endpoint" */
export type Risolto_Virtual_Invoicing_Channel_Endpoint = {
  __typename?: 'risolto_virtual_invoicing_channel_endpoint';
  channel_endpoint: Scalars['uuid'];
  /** An object relationship */
  channel_endpoint_by_reference: Risolto_Channel_Endpoint;
  contact?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contact_by_reference?: Maybe<Risolto_Contact>;
  legal_entity: Scalars['uuid'];
  /** An object relationship */
  legal_entity_by_reference: Risolto_Legal_Entity;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  v_reference: Scalars['uuid'];
};

export type Risolto_Virtual_Invoicing_Channel_Endpoint_Aggregate = {
  __typename?: 'risolto_virtual_invoicing_channel_endpoint_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Invoicing_Channel_Endpoint>;
};

/** aggregate fields of "risolto.virtual_invoicing_channel_endpoint" */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Aggregate_Fields = {
  __typename?: 'risolto_virtual_invoicing_channel_endpoint_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Min_Fields>;
};


/** aggregate fields of "risolto.virtual_invoicing_channel_endpoint" */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_invoicing_channel_endpoint". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>>;
  channel_endpoint?: Maybe<Uuid_Comparison_Exp>;
  channel_endpoint_by_reference?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
  contact?: Maybe<Uuid_Comparison_Exp>;
  contact_by_reference?: Maybe<Risolto_Contact_Bool_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_invoicing_channel_endpoint" */
export enum Risolto_Virtual_Invoicing_Channel_Endpoint_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualInvoicingChannelEndpointPkey = 'virtual_invoicing_channel_endpoint_pkey'
}

/** input type for inserting data into table "risolto.virtual_invoicing_channel_endpoint" */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Insert_Input = {
  channel_endpoint?: Maybe<Scalars['uuid']>;
  channel_endpoint_by_reference?: Maybe<Risolto_Channel_Endpoint_Obj_Rel_Insert_Input>;
  contact?: Maybe<Scalars['uuid']>;
  contact_by_reference?: Maybe<Risolto_Contact_Obj_Rel_Insert_Input>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Max_Fields = {
  __typename?: 'risolto_virtual_invoicing_channel_endpoint_max_fields';
  channel_endpoint?: Maybe<Scalars['uuid']>;
  contact?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Min_Fields = {
  __typename?: 'risolto_virtual_invoicing_channel_endpoint_min_fields';
  channel_endpoint?: Maybe<Scalars['uuid']>;
  contact?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_invoicing_channel_endpoint" */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Mutation_Response = {
  __typename?: 'risolto_virtual_invoicing_channel_endpoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Invoicing_Channel_Endpoint>;
};

/** on_conflict condition type for table "risolto.virtual_invoicing_channel_endpoint" */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_On_Conflict = {
  constraint: Risolto_Virtual_Invoicing_Channel_Endpoint_Constraint;
  update_columns?: Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Update_Column>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_invoicing_channel_endpoint". */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By = {
  channel_endpoint?: Maybe<Order_By>;
  channel_endpoint_by_reference?: Maybe<Risolto_Channel_Endpoint_Order_By>;
  contact?: Maybe<Order_By>;
  contact_by_reference?: Maybe<Risolto_Contact_Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_invoicing_channel_endpoint */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** select columns of table "risolto.virtual_invoicing_channel_endpoint" */
export enum Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column {
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  Contact = 'contact',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_invoicing_channel_endpoint" */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Set_Input = {
  channel_endpoint?: Maybe<Scalars['uuid']>;
  contact?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "risolto_virtual_invoicing_channel_endpoint" */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Invoicing_Channel_Endpoint_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Invoicing_Channel_Endpoint_Stream_Cursor_Value_Input = {
  channel_endpoint?: Maybe<Scalars['uuid']>;
  contact?: Maybe<Scalars['uuid']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** update columns of table "risolto.virtual_invoicing_channel_endpoint" */
export enum Risolto_Virtual_Invoicing_Channel_Endpoint_Update_Column {
  /** column name */
  ChannelEndpoint = 'channel_endpoint',
  /** column name */
  Contact = 'contact',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Invoicing_Channel_Endpoint_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp;
};

/** columns and relationships of "risolto.virtual_json" */
export type Risolto_Virtual_Json = {
  __typename?: 'risolto_virtual_json';
  data: Scalars['jsonb'];
  participant?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  participant_by_reference?: Maybe<Risolto_Participant>;
  v_reference: Scalars['uuid'];
};


/** columns and relationships of "risolto.virtual_json" */
export type Risolto_Virtual_JsonDataArgs = {
  path?: Maybe<Scalars['String']>;
};

export type Risolto_Virtual_Json_Aggregate = {
  __typename?: 'risolto_virtual_json_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Json_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Json>;
};

/** aggregate fields of "risolto.virtual_json" */
export type Risolto_Virtual_Json_Aggregate_Fields = {
  __typename?: 'risolto_virtual_json_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Json_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Json_Min_Fields>;
};


/** aggregate fields of "risolto.virtual_json" */
export type Risolto_Virtual_Json_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Json_Append_Input = {
  data?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_json". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Json_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Json_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Json_Bool_Exp>>;
  data?: Maybe<Jsonb_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_json" */
export enum Risolto_Virtual_Json_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualJsonPkey = 'virtual_json_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Virtual_Json_Delete_At_Path_Input = {
  data?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Virtual_Json_Delete_Elem_Input = {
  data?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Virtual_Json_Delete_Key_Input = {
  data?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.virtual_json" */
export type Risolto_Virtual_Json_Insert_Input = {
  data?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Json_Max_Fields = {
  __typename?: 'risolto_virtual_json_max_fields';
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Json_Min_Fields = {
  __typename?: 'risolto_virtual_json_min_fields';
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_json" */
export type Risolto_Virtual_Json_Mutation_Response = {
  __typename?: 'risolto_virtual_json_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Json>;
};

/** on_conflict condition type for table "risolto.virtual_json" */
export type Risolto_Virtual_Json_On_Conflict = {
  constraint: Risolto_Virtual_Json_Constraint;
  update_columns?: Array<Risolto_Virtual_Json_Update_Column>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_json". */
export type Risolto_Virtual_Json_Order_By = {
  data?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_json */
export type Risolto_Virtual_Json_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Virtual_Json_Prepend_Input = {
  data?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.virtual_json" */
export enum Risolto_Virtual_Json_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Participant = 'participant',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_json" */
export type Risolto_Virtual_Json_Set_Input = {
  data?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "risolto_virtual_json" */
export type Risolto_Virtual_Json_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Json_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Json_Stream_Cursor_Value_Input = {
  data?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** update columns of table "risolto.virtual_json" */
export enum Risolto_Virtual_Json_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Participant = 'participant',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Json_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Virtual_Json_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Virtual_Json_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Virtual_Json_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Virtual_Json_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Virtual_Json_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Json_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Json_Bool_Exp;
};

/** columns and relationships of "risolto.virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery = {
  __typename?: 'risolto_virtual_report_delivery';
  action: Scalars['uuid'];
  /** An object relationship */
  action_by_reference: Risolto_Action;
  dunning_notice?: Maybe<Scalars['uuid']>;
  event_count?: Maybe<Scalars['bigint']>;
  event_count_am?: Maybe<Scalars['bigint']>;
  event_count_pm?: Maybe<Scalars['bigint']>;
  event_type?: Maybe<Scalars['String']>;
  first_attachment_name?: Maybe<Scalars['String']>;
  first_event?: Maybe<Scalars['timestamptz']>;
  last_event?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  primary_invoice?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  primary_invoice_by_reference?: Maybe<Risolto_Invoice_Document>;
  recipient: Scalars['uuid'];
  /** An object relationship */
  recipient_by_reference: Risolto_Recipient;
  secondary_invoice?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  secondary_invoice_by_reference?: Maybe<Risolto_Invoice_Document>;
  v_reference: Scalars['uuid'];
};

export type Risolto_Virtual_Report_Delivery_Aggregate = {
  __typename?: 'risolto_virtual_report_delivery_aggregate';
  aggregate?: Maybe<Risolto_Virtual_Report_Delivery_Aggregate_Fields>;
  nodes: Array<Risolto_Virtual_Report_Delivery>;
};

/** aggregate fields of "risolto.virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery_Aggregate_Fields = {
  __typename?: 'risolto_virtual_report_delivery_aggregate_fields';
  avg?: Maybe<Risolto_Virtual_Report_Delivery_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Risolto_Virtual_Report_Delivery_Max_Fields>;
  min?: Maybe<Risolto_Virtual_Report_Delivery_Min_Fields>;
  stddev?: Maybe<Risolto_Virtual_Report_Delivery_Stddev_Fields>;
  stddev_pop?: Maybe<Risolto_Virtual_Report_Delivery_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risolto_Virtual_Report_Delivery_Stddev_Samp_Fields>;
  sum?: Maybe<Risolto_Virtual_Report_Delivery_Sum_Fields>;
  var_pop?: Maybe<Risolto_Virtual_Report_Delivery_Var_Pop_Fields>;
  var_samp?: Maybe<Risolto_Virtual_Report_Delivery_Var_Samp_Fields>;
  variance?: Maybe<Risolto_Virtual_Report_Delivery_Variance_Fields>;
};


/** aggregate fields of "risolto.virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Risolto_Virtual_Report_Delivery_Avg_Fields = {
  __typename?: 'risolto_virtual_report_delivery_avg_fields';
  event_count?: Maybe<Scalars['Float']>;
  event_count_am?: Maybe<Scalars['Float']>;
  event_count_pm?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "risolto.virtual_report_delivery". All fields are combined with a logical 'AND'. */
export type Risolto_Virtual_Report_Delivery_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Virtual_Report_Delivery_Bool_Exp>>;
  _not?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Virtual_Report_Delivery_Bool_Exp>>;
  action?: Maybe<Uuid_Comparison_Exp>;
  action_by_reference?: Maybe<Risolto_Action_Bool_Exp>;
  dunning_notice?: Maybe<Uuid_Comparison_Exp>;
  event_count?: Maybe<Bigint_Comparison_Exp>;
  event_count_am?: Maybe<Bigint_Comparison_Exp>;
  event_count_pm?: Maybe<Bigint_Comparison_Exp>;
  event_type?: Maybe<String_Comparison_Exp>;
  first_attachment_name?: Maybe<String_Comparison_Exp>;
  first_event?: Maybe<Timestamptz_Comparison_Exp>;
  last_event?: Maybe<Timestamptz_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  primary_invoice?: Maybe<Uuid_Comparison_Exp>;
  primary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  recipient?: Maybe<Uuid_Comparison_Exp>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Bool_Exp>;
  secondary_invoice?: Maybe<Uuid_Comparison_Exp>;
  secondary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
  v_reference?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.virtual_report_delivery" */
export enum Risolto_Virtual_Report_Delivery_Constraint {
  /** unique or primary key constraint on columns "v_reference" */
  VirtualReportDeliveryPkey = 'virtual_report_delivery_pkey'
}

/** input type for incrementing numeric columns in table "risolto.virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery_Inc_Input = {
  event_count?: Maybe<Scalars['bigint']>;
  event_count_am?: Maybe<Scalars['bigint']>;
  event_count_pm?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "risolto.virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery_Insert_Input = {
  action?: Maybe<Scalars['uuid']>;
  action_by_reference?: Maybe<Risolto_Action_Obj_Rel_Insert_Input>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  event_count?: Maybe<Scalars['bigint']>;
  event_count_am?: Maybe<Scalars['bigint']>;
  event_count_pm?: Maybe<Scalars['bigint']>;
  event_type?: Maybe<Scalars['String']>;
  first_attachment_name?: Maybe<Scalars['String']>;
  first_event?: Maybe<Scalars['timestamptz']>;
  last_event?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  primary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  recipient?: Maybe<Scalars['uuid']>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Obj_Rel_Insert_Input>;
  secondary_invoice?: Maybe<Scalars['uuid']>;
  secondary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Obj_Rel_Insert_Input>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Risolto_Virtual_Report_Delivery_Max_Fields = {
  __typename?: 'risolto_virtual_report_delivery_max_fields';
  action?: Maybe<Scalars['uuid']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  event_count?: Maybe<Scalars['bigint']>;
  event_count_am?: Maybe<Scalars['bigint']>;
  event_count_pm?: Maybe<Scalars['bigint']>;
  event_type?: Maybe<Scalars['String']>;
  first_attachment_name?: Maybe<Scalars['String']>;
  first_event?: Maybe<Scalars['timestamptz']>;
  last_event?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  secondary_invoice?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Risolto_Virtual_Report_Delivery_Min_Fields = {
  __typename?: 'risolto_virtual_report_delivery_min_fields';
  action?: Maybe<Scalars['uuid']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  event_count?: Maybe<Scalars['bigint']>;
  event_count_am?: Maybe<Scalars['bigint']>;
  event_count_pm?: Maybe<Scalars['bigint']>;
  event_type?: Maybe<Scalars['String']>;
  first_attachment_name?: Maybe<Scalars['String']>;
  first_event?: Maybe<Scalars['timestamptz']>;
  last_event?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  secondary_invoice?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "risolto.virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery_Mutation_Response = {
  __typename?: 'risolto_virtual_report_delivery_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Virtual_Report_Delivery>;
};

/** on_conflict condition type for table "risolto.virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery_On_Conflict = {
  constraint: Risolto_Virtual_Report_Delivery_Constraint;
  update_columns?: Array<Risolto_Virtual_Report_Delivery_Update_Column>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.virtual_report_delivery". */
export type Risolto_Virtual_Report_Delivery_Order_By = {
  action?: Maybe<Order_By>;
  action_by_reference?: Maybe<Risolto_Action_Order_By>;
  dunning_notice?: Maybe<Order_By>;
  event_count?: Maybe<Order_By>;
  event_count_am?: Maybe<Order_By>;
  event_count_pm?: Maybe<Order_By>;
  event_type?: Maybe<Order_By>;
  first_attachment_name?: Maybe<Order_By>;
  first_event?: Maybe<Order_By>;
  last_event?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  primary_invoice?: Maybe<Order_By>;
  primary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  recipient?: Maybe<Order_By>;
  recipient_by_reference?: Maybe<Risolto_Recipient_Order_By>;
  secondary_invoice?: Maybe<Order_By>;
  secondary_invoice_by_reference?: Maybe<Risolto_Invoice_Document_Order_By>;
  v_reference?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.virtual_report_delivery */
export type Risolto_Virtual_Report_Delivery_Pk_Columns_Input = {
  v_reference: Scalars['uuid'];
};

/** select columns of table "risolto.virtual_report_delivery" */
export enum Risolto_Virtual_Report_Delivery_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  EventCountAm = 'event_count_am',
  /** column name */
  EventCountPm = 'event_count_pm',
  /** column name */
  EventType = 'event_type',
  /** column name */
  FirstAttachmentName = 'first_attachment_name',
  /** column name */
  FirstEvent = 'first_event',
  /** column name */
  LastEvent = 'last_event',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PrimaryInvoice = 'primary_invoice',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  SecondaryInvoice = 'secondary_invoice',
  /** column name */
  VReference = 'v_reference'
}

/** input type for updating data in table "risolto.virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery_Set_Input = {
  action?: Maybe<Scalars['uuid']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  event_count?: Maybe<Scalars['bigint']>;
  event_count_am?: Maybe<Scalars['bigint']>;
  event_count_pm?: Maybe<Scalars['bigint']>;
  event_type?: Maybe<Scalars['String']>;
  first_attachment_name?: Maybe<Scalars['String']>;
  first_event?: Maybe<Scalars['timestamptz']>;
  last_event?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  secondary_invoice?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Risolto_Virtual_Report_Delivery_Stddev_Fields = {
  __typename?: 'risolto_virtual_report_delivery_stddev_fields';
  event_count?: Maybe<Scalars['Float']>;
  event_count_am?: Maybe<Scalars['Float']>;
  event_count_pm?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Risolto_Virtual_Report_Delivery_Stddev_Pop_Fields = {
  __typename?: 'risolto_virtual_report_delivery_stddev_pop_fields';
  event_count?: Maybe<Scalars['Float']>;
  event_count_am?: Maybe<Scalars['Float']>;
  event_count_pm?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Risolto_Virtual_Report_Delivery_Stddev_Samp_Fields = {
  __typename?: 'risolto_virtual_report_delivery_stddev_samp_fields';
  event_count?: Maybe<Scalars['Float']>;
  event_count_am?: Maybe<Scalars['Float']>;
  event_count_pm?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "risolto_virtual_report_delivery" */
export type Risolto_Virtual_Report_Delivery_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Virtual_Report_Delivery_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Virtual_Report_Delivery_Stream_Cursor_Value_Input = {
  action?: Maybe<Scalars['uuid']>;
  dunning_notice?: Maybe<Scalars['uuid']>;
  event_count?: Maybe<Scalars['bigint']>;
  event_count_am?: Maybe<Scalars['bigint']>;
  event_count_pm?: Maybe<Scalars['bigint']>;
  event_type?: Maybe<Scalars['String']>;
  first_attachment_name?: Maybe<Scalars['String']>;
  first_event?: Maybe<Scalars['timestamptz']>;
  last_event?: Maybe<Scalars['timestamptz']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  primary_invoice?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  secondary_invoice?: Maybe<Scalars['uuid']>;
  v_reference?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Risolto_Virtual_Report_Delivery_Sum_Fields = {
  __typename?: 'risolto_virtual_report_delivery_sum_fields';
  event_count?: Maybe<Scalars['bigint']>;
  event_count_am?: Maybe<Scalars['bigint']>;
  event_count_pm?: Maybe<Scalars['bigint']>;
};

/** update columns of table "risolto.virtual_report_delivery" */
export enum Risolto_Virtual_Report_Delivery_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  DunningNotice = 'dunning_notice',
  /** column name */
  EventCount = 'event_count',
  /** column name */
  EventCountAm = 'event_count_am',
  /** column name */
  EventCountPm = 'event_count_pm',
  /** column name */
  EventType = 'event_type',
  /** column name */
  FirstAttachmentName = 'first_attachment_name',
  /** column name */
  FirstEvent = 'first_event',
  /** column name */
  LastEvent = 'last_event',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Participant = 'participant',
  /** column name */
  PrimaryInvoice = 'primary_invoice',
  /** column name */
  Recipient = 'recipient',
  /** column name */
  SecondaryInvoice = 'secondary_invoice',
  /** column name */
  VReference = 'v_reference'
}

export type Risolto_Virtual_Report_Delivery_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Risolto_Virtual_Report_Delivery_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Virtual_Report_Delivery_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Virtual_Report_Delivery_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risolto_Virtual_Report_Delivery_Var_Pop_Fields = {
  __typename?: 'risolto_virtual_report_delivery_var_pop_fields';
  event_count?: Maybe<Scalars['Float']>;
  event_count_am?: Maybe<Scalars['Float']>;
  event_count_pm?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Risolto_Virtual_Report_Delivery_Var_Samp_Fields = {
  __typename?: 'risolto_virtual_report_delivery_var_samp_fields';
  event_count?: Maybe<Scalars['Float']>;
  event_count_am?: Maybe<Scalars['Float']>;
  event_count_pm?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Risolto_Virtual_Report_Delivery_Variance_Fields = {
  __typename?: 'risolto_virtual_report_delivery_variance_fields';
  event_count?: Maybe<Scalars['Float']>;
  event_count_am?: Maybe<Scalars['Float']>;
  event_count_pm?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "risolto.webhook" */
export type Risolto_Webhook = {
  __typename?: 'risolto_webhook';
  body?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  headers: Scalars['jsonb'];
  processed_at?: Maybe<Scalars['timestamptz']>;
  /** _100_OPEN | _200_PROCESSED */
  processing_status: Risolto_Webhook_Processing_Status_Enum;
  query_parameters?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['jsonb']>;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
};


/** columns and relationships of "risolto.webhook" */
export type Risolto_WebhookHeadersArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "risolto.webhook" */
export type Risolto_WebhookRawArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.webhook" */
export type Risolto_Webhook_Aggregate = {
  __typename?: 'risolto_webhook_aggregate';
  aggregate?: Maybe<Risolto_Webhook_Aggregate_Fields>;
  nodes: Array<Risolto_Webhook>;
};

/** aggregate fields of "risolto.webhook" */
export type Risolto_Webhook_Aggregate_Fields = {
  __typename?: 'risolto_webhook_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Webhook_Max_Fields>;
  min?: Maybe<Risolto_Webhook_Min_Fields>;
};


/** aggregate fields of "risolto.webhook" */
export type Risolto_Webhook_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Webhook_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Webhook_Append_Input = {
  headers?: Maybe<Scalars['jsonb']>;
  raw?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.webhook". All fields are combined with a logical 'AND'. */
export type Risolto_Webhook_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Webhook_Bool_Exp>>;
  _not?: Maybe<Risolto_Webhook_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Webhook_Bool_Exp>>;
  body?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  headers?: Maybe<Jsonb_Comparison_Exp>;
  processed_at?: Maybe<Timestamptz_Comparison_Exp>;
  processing_status?: Maybe<Risolto_Webhook_Processing_Status_Enum_Comparison_Exp>;
  query_parameters?: Maybe<String_Comparison_Exp>;
  raw?: Maybe<Jsonb_Comparison_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  url?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.webhook" */
export enum Risolto_Webhook_Constraint {
  /** unique or primary key constraint on columns "reference" */
  WebhookPkey = 'webhook_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Webhook_Delete_At_Path_Input = {
  headers?: Maybe<Array<Scalars['String']>>;
  raw?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Webhook_Delete_Elem_Input = {
  headers?: Maybe<Scalars['Int']>;
  raw?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Webhook_Delete_Key_Input = {
  headers?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.webhook" */
export type Risolto_Webhook_Insert_Input = {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  headers?: Maybe<Scalars['jsonb']>;
  processed_at?: Maybe<Scalars['timestamptz']>;
  /** _100_OPEN | _200_PROCESSED */
  processing_status?: Maybe<Risolto_Webhook_Processing_Status_Enum>;
  query_parameters?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['jsonb']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Webhook_Max_Fields = {
  __typename?: 'risolto_webhook_max_fields';
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  processed_at?: Maybe<Scalars['timestamptz']>;
  query_parameters?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Webhook_Min_Fields = {
  __typename?: 'risolto_webhook_min_fields';
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  processed_at?: Maybe<Scalars['timestamptz']>;
  query_parameters?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.webhook" */
export type Risolto_Webhook_Mutation_Response = {
  __typename?: 'risolto_webhook_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Webhook>;
};

/** on_conflict condition type for table "risolto.webhook" */
export type Risolto_Webhook_On_Conflict = {
  constraint: Risolto_Webhook_Constraint;
  update_columns?: Array<Risolto_Webhook_Update_Column>;
  where?: Maybe<Risolto_Webhook_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.webhook". */
export type Risolto_Webhook_Order_By = {
  body?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  headers?: Maybe<Order_By>;
  processed_at?: Maybe<Order_By>;
  processing_status?: Maybe<Order_By>;
  query_parameters?: Maybe<Order_By>;
  raw?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  url?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.webhook */
export type Risolto_Webhook_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Webhook_Prepend_Input = {
  headers?: Maybe<Scalars['jsonb']>;
  raw?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "risolto.webhook_processing_status" */
export type Risolto_Webhook_Processing_Status = {
  __typename?: 'risolto_webhook_processing_status';
  processing_status: Scalars['String'];
};

/** aggregated selection of "risolto.webhook_processing_status" */
export type Risolto_Webhook_Processing_Status_Aggregate = {
  __typename?: 'risolto_webhook_processing_status_aggregate';
  aggregate?: Maybe<Risolto_Webhook_Processing_Status_Aggregate_Fields>;
  nodes: Array<Risolto_Webhook_Processing_Status>;
};

/** aggregate fields of "risolto.webhook_processing_status" */
export type Risolto_Webhook_Processing_Status_Aggregate_Fields = {
  __typename?: 'risolto_webhook_processing_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Webhook_Processing_Status_Max_Fields>;
  min?: Maybe<Risolto_Webhook_Processing_Status_Min_Fields>;
};


/** aggregate fields of "risolto.webhook_processing_status" */
export type Risolto_Webhook_Processing_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Webhook_Processing_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "risolto.webhook_processing_status". All fields are combined with a logical 'AND'. */
export type Risolto_Webhook_Processing_Status_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Webhook_Processing_Status_Bool_Exp>>;
  _not?: Maybe<Risolto_Webhook_Processing_Status_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Webhook_Processing_Status_Bool_Exp>>;
  processing_status?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.webhook_processing_status" */
export enum Risolto_Webhook_Processing_Status_Constraint {
  /** unique or primary key constraint on columns "processing_status" */
  WebhookStatusPkey = 'webhook_status_pkey'
}

export enum Risolto_Webhook_Processing_Status_Enum {
  '100Open' = '_100_OPEN',
  '200Processed' = '_200_PROCESSED'
}

/** Boolean expression to compare columns of type "risolto_webhook_processing_status_enum". All fields are combined with logical 'AND'. */
export type Risolto_Webhook_Processing_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Risolto_Webhook_Processing_Status_Enum>;
  _in?: Maybe<Array<Risolto_Webhook_Processing_Status_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Risolto_Webhook_Processing_Status_Enum>;
  _nin?: Maybe<Array<Risolto_Webhook_Processing_Status_Enum>>;
};

/** input type for inserting data into table "risolto.webhook_processing_status" */
export type Risolto_Webhook_Processing_Status_Insert_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Risolto_Webhook_Processing_Status_Max_Fields = {
  __typename?: 'risolto_webhook_processing_status_max_fields';
  processing_status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Risolto_Webhook_Processing_Status_Min_Fields = {
  __typename?: 'risolto_webhook_processing_status_min_fields';
  processing_status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "risolto.webhook_processing_status" */
export type Risolto_Webhook_Processing_Status_Mutation_Response = {
  __typename?: 'risolto_webhook_processing_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Webhook_Processing_Status>;
};

/** on_conflict condition type for table "risolto.webhook_processing_status" */
export type Risolto_Webhook_Processing_Status_On_Conflict = {
  constraint: Risolto_Webhook_Processing_Status_Constraint;
  update_columns?: Array<Risolto_Webhook_Processing_Status_Update_Column>;
  where?: Maybe<Risolto_Webhook_Processing_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.webhook_processing_status". */
export type Risolto_Webhook_Processing_Status_Order_By = {
  processing_status?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.webhook_processing_status */
export type Risolto_Webhook_Processing_Status_Pk_Columns_Input = {
  processing_status: Scalars['String'];
};

/** select columns of table "risolto.webhook_processing_status" */
export enum Risolto_Webhook_Processing_Status_Select_Column {
  /** column name */
  ProcessingStatus = 'processing_status'
}

/** input type for updating data in table "risolto.webhook_processing_status" */
export type Risolto_Webhook_Processing_Status_Set_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_webhook_processing_status" */
export type Risolto_Webhook_Processing_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Webhook_Processing_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Webhook_Processing_Status_Stream_Cursor_Value_Input = {
  processing_status?: Maybe<Scalars['String']>;
};

/** update columns of table "risolto.webhook_processing_status" */
export enum Risolto_Webhook_Processing_Status_Update_Column {
  /** column name */
  ProcessingStatus = 'processing_status'
}

export type Risolto_Webhook_Processing_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Webhook_Processing_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Webhook_Processing_Status_Bool_Exp;
};

/** select columns of table "risolto.webhook" */
export enum Risolto_Webhook_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Headers = 'headers',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  QueryParameters = 'query_parameters',
  /** column name */
  Raw = 'raw',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "risolto.webhook" */
export type Risolto_Webhook_Set_Input = {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  headers?: Maybe<Scalars['jsonb']>;
  processed_at?: Maybe<Scalars['timestamptz']>;
  /** _100_OPEN | _200_PROCESSED */
  processing_status?: Maybe<Risolto_Webhook_Processing_Status_Enum>;
  query_parameters?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['jsonb']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "risolto_webhook" */
export type Risolto_Webhook_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Webhook_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Webhook_Stream_Cursor_Value_Input = {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  headers?: Maybe<Scalars['jsonb']>;
  processed_at?: Maybe<Scalars['timestamptz']>;
  /** _100_OPEN | _200_PROCESSED */
  processing_status?: Maybe<Risolto_Webhook_Processing_Status_Enum>;
  query_parameters?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['jsonb']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** columns and relationships of "risolto.webhook_subscription" */
export type Risolto_Webhook_Subscription = {
  __typename?: 'risolto_webhook_subscription';
  callback_url: Scalars['String'];
  created_at: Scalars['timestamptz'];
  entity: Scalars['String'];
  fields_filter?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity>;
  operation: Scalars['String'];
  participant: Scalars['uuid'];
  /** An object relationship */
  participant_by_reference: Risolto_Participant;
  reference: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "risolto.webhook_subscription" */
export type Risolto_Webhook_SubscriptionFields_FilterArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "risolto.webhook_subscription" */
export type Risolto_Webhook_Subscription_Aggregate = {
  __typename?: 'risolto_webhook_subscription_aggregate';
  aggregate?: Maybe<Risolto_Webhook_Subscription_Aggregate_Fields>;
  nodes: Array<Risolto_Webhook_Subscription>;
};

/** aggregate fields of "risolto.webhook_subscription" */
export type Risolto_Webhook_Subscription_Aggregate_Fields = {
  __typename?: 'risolto_webhook_subscription_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Risolto_Webhook_Subscription_Max_Fields>;
  min?: Maybe<Risolto_Webhook_Subscription_Min_Fields>;
};


/** aggregate fields of "risolto.webhook_subscription" */
export type Risolto_Webhook_Subscription_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Risolto_Webhook_Subscription_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Webhook_Subscription_Append_Input = {
  fields_filter?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "risolto.webhook_subscription". All fields are combined with a logical 'AND'. */
export type Risolto_Webhook_Subscription_Bool_Exp = {
  _and?: Maybe<Array<Risolto_Webhook_Subscription_Bool_Exp>>;
  _not?: Maybe<Risolto_Webhook_Subscription_Bool_Exp>;
  _or?: Maybe<Array<Risolto_Webhook_Subscription_Bool_Exp>>;
  callback_url?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  entity?: Maybe<String_Comparison_Exp>;
  fields_filter?: Maybe<Jsonb_Comparison_Exp>;
  legal_entity?: Maybe<Uuid_Comparison_Exp>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
  operation?: Maybe<String_Comparison_Exp>;
  participant?: Maybe<Uuid_Comparison_Exp>;
  participant_by_reference?: Maybe<Risolto_Participant_Bool_Exp>;
  reference?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "risolto.webhook_subscription" */
export enum Risolto_Webhook_Subscription_Constraint {
  /** unique or primary key constraint on columns "reference" */
  WebhookSubscriptionPkey = 'webhook_subscription_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Risolto_Webhook_Subscription_Delete_At_Path_Input = {
  fields_filter?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Risolto_Webhook_Subscription_Delete_Elem_Input = {
  fields_filter?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Risolto_Webhook_Subscription_Delete_Key_Input = {
  fields_filter?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "risolto.webhook_subscription" */
export type Risolto_Webhook_Subscription_Insert_Input = {
  callback_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entity?: Maybe<Scalars['String']>;
  fields_filter?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Obj_Rel_Insert_Input>;
  operation?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  participant_by_reference?: Maybe<Risolto_Participant_Obj_Rel_Insert_Input>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Risolto_Webhook_Subscription_Max_Fields = {
  __typename?: 'risolto_webhook_subscription_max_fields';
  callback_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entity?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  operation?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Risolto_Webhook_Subscription_Min_Fields = {
  __typename?: 'risolto_webhook_subscription_min_fields';
  callback_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entity?: Maybe<Scalars['String']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  operation?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "risolto.webhook_subscription" */
export type Risolto_Webhook_Subscription_Mutation_Response = {
  __typename?: 'risolto_webhook_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Risolto_Webhook_Subscription>;
};

/** on_conflict condition type for table "risolto.webhook_subscription" */
export type Risolto_Webhook_Subscription_On_Conflict = {
  constraint: Risolto_Webhook_Subscription_Constraint;
  update_columns?: Array<Risolto_Webhook_Subscription_Update_Column>;
  where?: Maybe<Risolto_Webhook_Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "risolto.webhook_subscription". */
export type Risolto_Webhook_Subscription_Order_By = {
  callback_url?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  entity?: Maybe<Order_By>;
  fields_filter?: Maybe<Order_By>;
  legal_entity?: Maybe<Order_By>;
  legal_entity_by_reference?: Maybe<Risolto_Legal_Entity_Order_By>;
  operation?: Maybe<Order_By>;
  participant?: Maybe<Order_By>;
  participant_by_reference?: Maybe<Risolto_Participant_Order_By>;
  reference?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: risolto.webhook_subscription */
export type Risolto_Webhook_Subscription_Pk_Columns_Input = {
  reference: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Risolto_Webhook_Subscription_Prepend_Input = {
  fields_filter?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "risolto.webhook_subscription" */
export enum Risolto_Webhook_Subscription_Select_Column {
  /** column name */
  CallbackUrl = 'callback_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Entity = 'entity',
  /** column name */
  FieldsFilter = 'fields_filter',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Operation = 'operation',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "risolto.webhook_subscription" */
export type Risolto_Webhook_Subscription_Set_Input = {
  callback_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entity?: Maybe<Scalars['String']>;
  fields_filter?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  operation?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "risolto_webhook_subscription" */
export type Risolto_Webhook_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risolto_Webhook_Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risolto_Webhook_Subscription_Stream_Cursor_Value_Input = {
  callback_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entity?: Maybe<Scalars['String']>;
  fields_filter?: Maybe<Scalars['jsonb']>;
  legal_entity?: Maybe<Scalars['uuid']>;
  operation?: Maybe<Scalars['String']>;
  participant?: Maybe<Scalars['uuid']>;
  reference?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "risolto.webhook_subscription" */
export enum Risolto_Webhook_Subscription_Update_Column {
  /** column name */
  CallbackUrl = 'callback_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Entity = 'entity',
  /** column name */
  FieldsFilter = 'fields_filter',
  /** column name */
  LegalEntity = 'legal_entity',
  /** column name */
  Operation = 'operation',
  /** column name */
  Participant = 'participant',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Risolto_Webhook_Subscription_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Webhook_Subscription_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Webhook_Subscription_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Webhook_Subscription_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Webhook_Subscription_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Webhook_Subscription_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Webhook_Subscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Webhook_Subscription_Bool_Exp;
};

/** update columns of table "risolto.webhook" */
export enum Risolto_Webhook_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Headers = 'headers',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ProcessingStatus = 'processing_status',
  /** column name */
  QueryParameters = 'query_parameters',
  /** column name */
  Raw = 'raw',
  /** column name */
  Reference = 'reference',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Risolto_Webhook_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Risolto_Webhook_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Risolto_Webhook_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Risolto_Webhook_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Risolto_Webhook_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Risolto_Webhook_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Risolto_Webhook_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risolto_Webhook_Bool_Exp;
};


export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "risolto.account_number_type" */
  risolto_account_number_type: Array<Risolto_Account_Number_Type>;
  /** fetch aggregated fields from the table: "risolto.account_number_type" */
  risolto_account_number_type_aggregate: Risolto_Account_Number_Type_Aggregate;
  /** fetch data from the table: "risolto.account_number_type" using primary key columns */
  risolto_account_number_type_by_pk?: Maybe<Risolto_Account_Number_Type>;
  /** fetch data from the table in a streaming manner: "risolto.account_number_type" */
  risolto_account_number_type_stream: Array<Risolto_Account_Number_Type>;
  /** fetch data from the table: "risolto.accounting_document" */
  risolto_accounting_document: Array<Risolto_Accounting_Document>;
  /** fetch aggregated fields from the table: "risolto.accounting_document" */
  risolto_accounting_document_aggregate: Risolto_Accounting_Document_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.accounting_document" */
  risolto_accounting_document_stream: Array<Risolto_Accounting_Document>;
  /** fetch data from the table: "risolto.action" */
  risolto_action: Array<Risolto_Action>;
  /** fetch aggregated fields from the table: "risolto.action" */
  risolto_action_aggregate: Risolto_Action_Aggregate;
  /** fetch data from the table: "risolto.action" using primary key columns */
  risolto_action_by_pk?: Maybe<Risolto_Action>;
  /** fetch data from the table: "risolto.action_execution_type" */
  risolto_action_execution_type: Array<Risolto_Action_Execution_Type>;
  /** fetch aggregated fields from the table: "risolto.action_execution_type" */
  risolto_action_execution_type_aggregate: Risolto_Action_Execution_Type_Aggregate;
  /** fetch data from the table: "risolto.action_execution_type" using primary key columns */
  risolto_action_execution_type_by_pk?: Maybe<Risolto_Action_Execution_Type>;
  /** fetch data from the table in a streaming manner: "risolto.action_execution_type" */
  risolto_action_execution_type_stream: Array<Risolto_Action_Execution_Type>;
  /** execute function "risolto.action_group_v10" which returns "risolto.virtual_action_group" */
  risolto_action_group_v10: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v10" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v10_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v11" which returns "risolto.virtual_action_group" */
  risolto_action_group_v11: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v11" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v11_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v12" which returns "risolto.virtual_action_group" */
  risolto_action_group_v12: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v12" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v12_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v2" which returns "risolto.virtual_action_group" */
  risolto_action_group_v2: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v2" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v2_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v5" which returns "risolto.virtual_action_group" */
  risolto_action_group_v5: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v5" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v5_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v6" which returns "risolto.virtual_action_group" */
  risolto_action_group_v6: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v6" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v6_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v7" which returns "risolto.virtual_action_group" */
  risolto_action_group_v7: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v7" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v7_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v8" which returns "risolto.virtual_action_group" */
  risolto_action_group_v8: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v8" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v8_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** execute function "risolto.action_group_v9" which returns "risolto.virtual_action_group" */
  risolto_action_group_v9: Array<Risolto_Virtual_Action_Group>;
  /** execute function "risolto.action_group_v9" and query aggregates on result of table type "risolto.virtual_action_group" */
  risolto_action_group_v9_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** fetch data from the table: "risolto.action_interchange" */
  risolto_action_interchange: Array<Risolto_Action_Interchange>;
  /** fetch aggregated fields from the table: "risolto.action_interchange" */
  risolto_action_interchange_aggregate: Risolto_Action_Interchange_Aggregate;
  /** fetch data from the table: "risolto.action_interchange" using primary key columns */
  risolto_action_interchange_by_pk?: Maybe<Risolto_Action_Interchange>;
  /** fetch data from the table in a streaming manner: "risolto.action_interchange" */
  risolto_action_interchange_stream: Array<Risolto_Action_Interchange>;
  /** fetch data from the table: "risolto.action_invoice" */
  risolto_action_invoice: Array<Risolto_Action_Invoice>;
  /** fetch aggregated fields from the table: "risolto.action_invoice" */
  risolto_action_invoice_aggregate: Risolto_Action_Invoice_Aggregate;
  /** fetch data from the table: "risolto.action_invoice" using primary key columns */
  risolto_action_invoice_by_pk?: Maybe<Risolto_Action_Invoice>;
  /** fetch data from the table in a streaming manner: "risolto.action_invoice" */
  risolto_action_invoice_stream: Array<Risolto_Action_Invoice>;
  /** fetch data from the table: "risolto.action_source" */
  risolto_action_source: Array<Risolto_Action_Source>;
  /** fetch aggregated fields from the table: "risolto.action_source" */
  risolto_action_source_aggregate: Risolto_Action_Source_Aggregate;
  /** fetch data from the table: "risolto.action_source" using primary key columns */
  risolto_action_source_by_pk?: Maybe<Risolto_Action_Source>;
  /** fetch data from the table in a streaming manner: "risolto.action_source" */
  risolto_action_source_stream: Array<Risolto_Action_Source>;
  /** fetch data from the table: "risolto.action_status" */
  risolto_action_status: Array<Risolto_Action_Status>;
  /** fetch aggregated fields from the table: "risolto.action_status" */
  risolto_action_status_aggregate: Risolto_Action_Status_Aggregate;
  /** fetch data from the table: "risolto.action_status" using primary key columns */
  risolto_action_status_by_pk?: Maybe<Risolto_Action_Status>;
  /** fetch data from the table in a streaming manner: "risolto.action_status" */
  risolto_action_status_stream: Array<Risolto_Action_Status>;
  /** fetch data from the table in a streaming manner: "risolto.action" */
  risolto_action_stream: Array<Risolto_Action>;
  /** fetch data from the table: "risolto.analytics_company_score" */
  risolto_analytics_company_score: Array<Risolto_Analytics_Company_Score>;
  /** fetch aggregated fields from the table: "risolto.analytics_company_score" */
  risolto_analytics_company_score_aggregate: Risolto_Analytics_Company_Score_Aggregate;
  /** fetch data from the table: "risolto.analytics_company_score" using primary key columns */
  risolto_analytics_company_score_by_pk?: Maybe<Risolto_Analytics_Company_Score>;
  /** fetch data from the table in a streaming manner: "risolto.analytics_company_score" */
  risolto_analytics_company_score_stream: Array<Risolto_Analytics_Company_Score>;
  /** fetch data from the table: "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features: Array<Risolto_Analytics_Invoice_Features>;
  /** fetch aggregated fields from the table: "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features_aggregate: Risolto_Analytics_Invoice_Features_Aggregate;
  /** execute function "risolto.analytics_invoice_features_by_date" which returns "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features_by_date: Array<Risolto_Analytics_Invoice_Features>;
  /** execute function "risolto.analytics_invoice_features_by_date" and query aggregates on result of table type "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features_by_date_aggregate: Risolto_Analytics_Invoice_Features_Aggregate;
  /** fetch data from the table: "risolto.analytics_invoice_features" using primary key columns */
  risolto_analytics_invoice_features_by_pk?: Maybe<Risolto_Analytics_Invoice_Features>;
  /** fetch data from the table in a streaming manner: "risolto.analytics_invoice_features" */
  risolto_analytics_invoice_features_stream: Array<Risolto_Analytics_Invoice_Features>;
  /** fetch data from the table: "risolto.analytics_invoice_prediction" */
  risolto_analytics_invoice_prediction: Array<Risolto_Analytics_Invoice_Prediction>;
  /** fetch aggregated fields from the table: "risolto.analytics_invoice_prediction" */
  risolto_analytics_invoice_prediction_aggregate: Risolto_Analytics_Invoice_Prediction_Aggregate;
  /** fetch data from the table: "risolto.analytics_invoice_prediction" using primary key columns */
  risolto_analytics_invoice_prediction_by_pk?: Maybe<Risolto_Analytics_Invoice_Prediction>;
  /** fetch data from the table in a streaming manner: "risolto.analytics_invoice_prediction" */
  risolto_analytics_invoice_prediction_stream: Array<Risolto_Analytics_Invoice_Prediction>;
  /** fetch data from the table: "risolto.analytics_test" */
  risolto_analytics_test: Array<Risolto_Analytics_Test>;
  /** fetch aggregated fields from the table: "risolto.analytics_test" */
  risolto_analytics_test_aggregate: Risolto_Analytics_Test_Aggregate;
  /** fetch data from the table: "risolto.analytics_test" using primary key columns */
  risolto_analytics_test_by_pk?: Maybe<Risolto_Analytics_Test>;
  /** fetch data from the table: "risolto.analytics_test_result" */
  risolto_analytics_test_result: Array<Risolto_Analytics_Test_Result>;
  /** fetch aggregated fields from the table: "risolto.analytics_test_result" */
  risolto_analytics_test_result_aggregate: Risolto_Analytics_Test_Result_Aggregate;
  /** fetch data from the table: "risolto.analytics_test_result" using primary key columns */
  risolto_analytics_test_result_by_pk?: Maybe<Risolto_Analytics_Test_Result>;
  /** fetch data from the table in a streaming manner: "risolto.analytics_test_result" */
  risolto_analytics_test_result_stream: Array<Risolto_Analytics_Test_Result>;
  /** fetch data from the table in a streaming manner: "risolto.analytics_test" */
  risolto_analytics_test_stream: Array<Risolto_Analytics_Test>;
  /** fetch data from the table: "risolto.api_accounting_document" */
  risolto_api_accounting_document: Array<Risolto_Api_Accounting_Document>;
  /** fetch aggregated fields from the table: "risolto.api_accounting_document" */
  risolto_api_accounting_document_aggregate: Risolto_Api_Accounting_Document_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.api_accounting_document" */
  risolto_api_accounting_document_stream: Array<Risolto_Api_Accounting_Document>;
  /** fetch data from the table: "risolto.api_app_client" */
  risolto_api_app_client: Array<Risolto_Api_App_Client>;
  /** fetch aggregated fields from the table: "risolto.api_app_client" */
  risolto_api_app_client_aggregate: Risolto_Api_App_Client_Aggregate;
  /** fetch data from the table: "risolto.api_app_client" using primary key columns */
  risolto_api_app_client_by_pk?: Maybe<Risolto_Api_App_Client>;
  /** fetch data from the table in a streaming manner: "risolto.api_app_client" */
  risolto_api_app_client_stream: Array<Risolto_Api_App_Client>;
  /** fetch data from the table: "risolto.api_payment_plan" */
  risolto_api_payment_plan: Array<Risolto_Api_Payment_Plan>;
  /** fetch aggregated fields from the table: "risolto.api_payment_plan" */
  risolto_api_payment_plan_aggregate: Risolto_Api_Payment_Plan_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.api_payment_plan" */
  risolto_api_payment_plan_stream: Array<Risolto_Api_Payment_Plan>;
  /** fetch data from the table: "risolto.api_payment_promise" */
  risolto_api_payment_promise: Array<Risolto_Api_Payment_Promise>;
  /** fetch aggregated fields from the table: "risolto.api_payment_promise" */
  risolto_api_payment_promise_aggregate: Risolto_Api_Payment_Promise_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.api_payment_promise" */
  risolto_api_payment_promise_stream: Array<Risolto_Api_Payment_Promise>;
  /** fetch data from the table: "risolto.attachment" */
  risolto_attachment: Array<Risolto_Attachment>;
  /** fetch aggregated fields from the table: "risolto.attachment" */
  risolto_attachment_aggregate: Risolto_Attachment_Aggregate;
  /** fetch data from the table: "risolto.attachment" using primary key columns */
  risolto_attachment_by_pk?: Maybe<Risolto_Attachment>;
  /** fetch data from the table: "risolto.attachment_scheme" */
  risolto_attachment_scheme: Array<Risolto_Attachment_Scheme>;
  /** fetch aggregated fields from the table: "risolto.attachment_scheme" */
  risolto_attachment_scheme_aggregate: Risolto_Attachment_Scheme_Aggregate;
  /** fetch data from the table: "risolto.attachment_scheme" using primary key columns */
  risolto_attachment_scheme_by_pk?: Maybe<Risolto_Attachment_Scheme>;
  /** fetch data from the table in a streaming manner: "risolto.attachment_scheme" */
  risolto_attachment_scheme_stream: Array<Risolto_Attachment_Scheme>;
  /** fetch data from the table in a streaming manner: "risolto.attachment" */
  risolto_attachment_stream: Array<Risolto_Attachment>;
  /** fetch data from the table: "risolto.bank_account" */
  risolto_bank_account: Array<Risolto_Bank_Account>;
  /** fetch aggregated fields from the table: "risolto.bank_account" */
  risolto_bank_account_aggregate: Risolto_Bank_Account_Aggregate;
  /** fetch data from the table: "risolto.bank_account" using primary key columns */
  risolto_bank_account_by_pk?: Maybe<Risolto_Bank_Account>;
  /** fetch data from the table in a streaming manner: "risolto.bank_account" */
  risolto_bank_account_stream: Array<Risolto_Bank_Account>;
  /** fetch data from the table: "risolto.bank_identifier_type" */
  risolto_bank_identifier_type: Array<Risolto_Bank_Identifier_Type>;
  /** fetch aggregated fields from the table: "risolto.bank_identifier_type" */
  risolto_bank_identifier_type_aggregate: Risolto_Bank_Identifier_Type_Aggregate;
  /** fetch data from the table: "risolto.bank_identifier_type" using primary key columns */
  risolto_bank_identifier_type_by_pk?: Maybe<Risolto_Bank_Identifier_Type>;
  /** fetch data from the table in a streaming manner: "risolto.bank_identifier_type" */
  risolto_bank_identifier_type_stream: Array<Risolto_Bank_Identifier_Type>;
  /** fetch data from the table: "risolto.blacklist" */
  risolto_blacklist: Array<Risolto_Blacklist>;
  /** fetch aggregated fields from the table: "risolto.blacklist" */
  risolto_blacklist_aggregate: Risolto_Blacklist_Aggregate;
  /** fetch data from the table: "risolto.blacklist" using primary key columns */
  risolto_blacklist_by_pk?: Maybe<Risolto_Blacklist>;
  /** fetch data from the table in a streaming manner: "risolto.blacklist" */
  risolto_blacklist_stream: Array<Risolto_Blacklist>;
  /** fetch data from the table: "risolto.channel" */
  risolto_channel: Array<Risolto_Channel>;
  /** fetch aggregated fields from the table: "risolto.channel" */
  risolto_channel_aggregate: Risolto_Channel_Aggregate;
  /** fetch data from the table: "risolto.channel" using primary key columns */
  risolto_channel_by_pk?: Maybe<Risolto_Channel>;
  /** fetch data from the table: "risolto.channel_endpoint" */
  risolto_channel_endpoint: Array<Risolto_Channel_Endpoint>;
  /** fetch aggregated fields from the table: "risolto.channel_endpoint" */
  risolto_channel_endpoint_aggregate: Risolto_Channel_Endpoint_Aggregate;
  /** fetch data from the table: "risolto.channel_endpoint" using primary key columns */
  risolto_channel_endpoint_by_pk?: Maybe<Risolto_Channel_Endpoint>;
  /** fetch data from the table in a streaming manner: "risolto.channel_endpoint" */
  risolto_channel_endpoint_stream: Array<Risolto_Channel_Endpoint>;
  /** fetch data from the table in a streaming manner: "risolto.channel" */
  risolto_channel_stream: Array<Risolto_Channel>;
  /** execute function "risolto.clid2recid" which returns "risolto.recipient" */
  risolto_clid2recid: Array<Risolto_Recipient>;
  /** execute function "risolto.clid2recid" and query aggregates on result of table type "risolto.recipient" */
  risolto_clid2recid_aggregate: Risolto_Recipient_Aggregate;
  /** execute function "risolto.clip2recid" which returns "risolto.channel_endpoint" */
  risolto_clip2recid: Array<Risolto_Channel_Endpoint>;
  /** execute function "risolto.clip2recid" and query aggregates on result of table type "risolto.channel_endpoint" */
  risolto_clip2recid_aggregate: Risolto_Channel_Endpoint_Aggregate;
  /** fetch data from the table: "risolto.communication" */
  risolto_communication: Array<Risolto_Communication>;
  /** fetch aggregated fields from the table: "risolto.communication" */
  risolto_communication_aggregate: Risolto_Communication_Aggregate;
  /** fetch data from the table: "risolto.communication" using primary key columns */
  risolto_communication_by_pk?: Maybe<Risolto_Communication>;
  /** fetch data from the table in a streaming manner: "risolto.communication" */
  risolto_communication_stream: Array<Risolto_Communication>;
  /** fetch data from the table: "risolto.communication_template" */
  risolto_communication_template: Array<Risolto_Communication_Template>;
  /** fetch aggregated fields from the table: "risolto.communication_template" */
  risolto_communication_template_aggregate: Risolto_Communication_Template_Aggregate;
  /** fetch data from the table: "risolto.communication_template" using primary key columns */
  risolto_communication_template_by_pk?: Maybe<Risolto_Communication_Template>;
  /** fetch data from the table in a streaming manner: "risolto.communication_template" */
  risolto_communication_template_stream: Array<Risolto_Communication_Template>;
  /** fetch data from the table: "risolto.communication_template_type" */
  risolto_communication_template_type: Array<Risolto_Communication_Template_Type>;
  /** fetch aggregated fields from the table: "risolto.communication_template_type" */
  risolto_communication_template_type_aggregate: Risolto_Communication_Template_Type_Aggregate;
  /** fetch data from the table: "risolto.communication_template_type" using primary key columns */
  risolto_communication_template_type_by_pk?: Maybe<Risolto_Communication_Template_Type>;
  /** fetch data from the table in a streaming manner: "risolto.communication_template_type" */
  risolto_communication_template_type_stream: Array<Risolto_Communication_Template_Type>;
  /** fetch data from the table: "risolto.contact" */
  risolto_contact: Array<Risolto_Contact>;
  /** fetch data from the table: "risolto.contact_address" */
  risolto_contact_address: Array<Risolto_Contact_Address>;
  /** fetch aggregated fields from the table: "risolto.contact_address" */
  risolto_contact_address_aggregate: Risolto_Contact_Address_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.contact_address" */
  risolto_contact_address_stream: Array<Risolto_Contact_Address>;
  /** fetch aggregated fields from the table: "risolto.contact" */
  risolto_contact_aggregate: Risolto_Contact_Aggregate;
  /** fetch data from the table: "risolto.contact" using primary key columns */
  risolto_contact_by_pk?: Maybe<Risolto_Contact>;
  /** fetch data from the table in a streaming manner: "risolto.contact" */
  risolto_contact_stream: Array<Risolto_Contact>;
  /** fetch data from the table: "risolto.contact_type" */
  risolto_contact_type: Array<Risolto_Contact_Type>;
  /** fetch aggregated fields from the table: "risolto.contact_type" */
  risolto_contact_type_aggregate: Risolto_Contact_Type_Aggregate;
  /** fetch data from the table: "risolto.contact_type" using primary key columns */
  risolto_contact_type_by_pk?: Maybe<Risolto_Contact_Type>;
  /** fetch data from the table in a streaming manner: "risolto.contact_type" */
  risolto_contact_type_stream: Array<Risolto_Contact_Type>;
  /** fetch data from the table: "risolto.content_disposition" */
  risolto_content_disposition: Array<Risolto_Content_Disposition>;
  /** fetch aggregated fields from the table: "risolto.content_disposition" */
  risolto_content_disposition_aggregate: Risolto_Content_Disposition_Aggregate;
  /** fetch data from the table: "risolto.content_disposition" using primary key columns */
  risolto_content_disposition_by_pk?: Maybe<Risolto_Content_Disposition>;
  /** fetch data from the table in a streaming manner: "risolto.content_disposition" */
  risolto_content_disposition_stream: Array<Risolto_Content_Disposition>;
  /** fetch data from the table: "risolto.credit_limit" */
  risolto_credit_limit: Array<Risolto_Credit_Limit>;
  /** fetch aggregated fields from the table: "risolto.credit_limit" */
  risolto_credit_limit_aggregate: Risolto_Credit_Limit_Aggregate;
  /** fetch data from the table: "risolto.credit_limit" using primary key columns */
  risolto_credit_limit_by_pk?: Maybe<Risolto_Credit_Limit>;
  /** fetch data from the table in a streaming manner: "risolto.credit_limit" */
  risolto_credit_limit_stream: Array<Risolto_Credit_Limit>;
  /** fetch data from the table: "risolto.credit_note" */
  risolto_credit_note: Array<Risolto_Credit_Note>;
  /** fetch aggregated fields from the table: "risolto.credit_note" */
  risolto_credit_note_aggregate: Risolto_Credit_Note_Aggregate;
  /** fetch data from the table: "risolto.credit_note_attachment" */
  risolto_credit_note_attachment: Array<Risolto_Credit_Note_Attachment>;
  /** fetch aggregated fields from the table: "risolto.credit_note_attachment" */
  risolto_credit_note_attachment_aggregate: Risolto_Credit_Note_Attachment_Aggregate;
  /** fetch data from the table: "risolto.credit_note_attachment" using primary key columns */
  risolto_credit_note_attachment_by_pk?: Maybe<Risolto_Credit_Note_Attachment>;
  /** fetch data from the table in a streaming manner: "risolto.credit_note_attachment" */
  risolto_credit_note_attachment_stream: Array<Risolto_Credit_Note_Attachment>;
  /** fetch data from the table: "risolto.credit_note" using primary key columns */
  risolto_credit_note_by_pk?: Maybe<Risolto_Credit_Note>;
  /** fetch data from the table in a streaming manner: "risolto.credit_note" */
  risolto_credit_note_stream: Array<Risolto_Credit_Note>;
  /** fetch data from the table: "risolto.currency" */
  risolto_currency: Array<Risolto_Currency>;
  /** fetch aggregated fields from the table: "risolto.currency" */
  risolto_currency_aggregate: Risolto_Currency_Aggregate;
  /** fetch data from the table: "risolto.currency" using primary key columns */
  risolto_currency_by_pk?: Maybe<Risolto_Currency>;
  /** fetch data from the table in a streaming manner: "risolto.currency" */
  risolto_currency_stream: Array<Risolto_Currency>;
  /** execute function "risolto.dashboard_actions_by_channel_and_status_count_v1" which returns "risolto.virtual_dashboard_action_stats" */
  risolto_dashboard_actions_by_channel_and_status_count_v1: Array<Risolto_Virtual_Dashboard_Action_Stats>;
  /** execute function "risolto.dashboard_actions_by_channel_and_status_count_v1" and query aggregates on result of table type "risolto.virtual_dashboard_action_stats" */
  risolto_dashboard_actions_by_channel_and_status_count_v1_aggregate: Risolto_Virtual_Dashboard_Action_Stats_Aggregate;
  /** execute function "risolto.dashboard_outstanding_debt" which returns "risolto.virtual_dashboard_outstanding_debt" */
  risolto_dashboard_outstanding_debt: Array<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** execute function "risolto.dashboard_outstanding_debt" and query aggregates on result of table type "risolto.virtual_dashboard_outstanding_debt" */
  risolto_dashboard_outstanding_debt_aggregate: Risolto_Virtual_Dashboard_Outstanding_Debt_Aggregate;
  /** execute function "risolto.dashboard_totals" which returns "risolto.virtual_json" */
  risolto_dashboard_totals: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.dashboard_totals" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_dashboard_totals_aggregate: Risolto_Virtual_Json_Aggregate;
  /** execute function "risolto.dashboard_totals_v2" which returns "risolto.virtual_json" */
  risolto_dashboard_totals_v2: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.dashboard_totals_v2" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_dashboard_totals_v2_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.debit_note" */
  risolto_debit_note: Array<Risolto_Debit_Note>;
  /** fetch aggregated fields from the table: "risolto.debit_note" */
  risolto_debit_note_aggregate: Risolto_Debit_Note_Aggregate;
  /** fetch data from the table: "risolto.debit_note_attachment" */
  risolto_debit_note_attachment: Array<Risolto_Debit_Note_Attachment>;
  /** fetch aggregated fields from the table: "risolto.debit_note_attachment" */
  risolto_debit_note_attachment_aggregate: Risolto_Debit_Note_Attachment_Aggregate;
  /** fetch data from the table: "risolto.debit_note_attachment" using primary key columns */
  risolto_debit_note_attachment_by_pk?: Maybe<Risolto_Debit_Note_Attachment>;
  /** fetch data from the table in a streaming manner: "risolto.debit_note_attachment" */
  risolto_debit_note_attachment_stream: Array<Risolto_Debit_Note_Attachment>;
  /** fetch data from the table: "risolto.debit_note" using primary key columns */
  risolto_debit_note_by_pk?: Maybe<Risolto_Debit_Note>;
  /** fetch data from the table in a streaming manner: "risolto.debit_note" */
  risolto_debit_note_stream: Array<Risolto_Debit_Note>;
  /** execute function "risolto.demo_action_report_1_v1" which returns "risolto.virtual_demo_action_report_1" */
  risolto_demo_action_report_1_v1: Array<Risolto_Virtual_Demo_Action_Report_1>;
  /** execute function "risolto.demo_action_report_1_v1" and query aggregates on result of table type "risolto.virtual_demo_action_report_1" */
  risolto_demo_action_report_1_v1_aggregate: Risolto_Virtual_Demo_Action_Report_1_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_mandate" */
  risolto_direct_debit_mandate: Array<Risolto_Direct_Debit_Mandate>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_mandate" */
  risolto_direct_debit_mandate_aggregate: Risolto_Direct_Debit_Mandate_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_mandate" using primary key columns */
  risolto_direct_debit_mandate_by_pk?: Maybe<Risolto_Direct_Debit_Mandate>;
  /** fetch data from the table in a streaming manner: "risolto.direct_debit_mandate" */
  risolto_direct_debit_mandate_stream: Array<Risolto_Direct_Debit_Mandate>;
  /** fetch data from the table: "risolto.direct_debit_provider" */
  risolto_direct_debit_provider: Array<Risolto_Direct_Debit_Provider>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_provider" */
  risolto_direct_debit_provider_aggregate: Risolto_Direct_Debit_Provider_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_provider" using primary key columns */
  risolto_direct_debit_provider_by_pk?: Maybe<Risolto_Direct_Debit_Provider>;
  /** fetch data from the table in a streaming manner: "risolto.direct_debit_provider" */
  risolto_direct_debit_provider_stream: Array<Risolto_Direct_Debit_Provider>;
  /** fetch data from the table: "risolto.direct_debit_scheme" */
  risolto_direct_debit_scheme: Array<Risolto_Direct_Debit_Scheme>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_scheme" */
  risolto_direct_debit_scheme_aggregate: Risolto_Direct_Debit_Scheme_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_scheme" using primary key columns */
  risolto_direct_debit_scheme_by_pk?: Maybe<Risolto_Direct_Debit_Scheme>;
  /** fetch data from the table in a streaming manner: "risolto.direct_debit_scheme" */
  risolto_direct_debit_scheme_stream: Array<Risolto_Direct_Debit_Scheme>;
  /** fetch data from the table: "risolto.direct_debit_sequence_type" */
  risolto_direct_debit_sequence_type: Array<Risolto_Direct_Debit_Sequence_Type>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_sequence_type" */
  risolto_direct_debit_sequence_type_aggregate: Risolto_Direct_Debit_Sequence_Type_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_sequence_type" using primary key columns */
  risolto_direct_debit_sequence_type_by_pk?: Maybe<Risolto_Direct_Debit_Sequence_Type>;
  /** fetch data from the table in a streaming manner: "risolto.direct_debit_sequence_type" */
  risolto_direct_debit_sequence_type_stream: Array<Risolto_Direct_Debit_Sequence_Type>;
  /** fetch data from the table: "risolto.direct_debit_transaction" */
  risolto_direct_debit_transaction: Array<Risolto_Direct_Debit_Transaction>;
  /** fetch aggregated fields from the table: "risolto.direct_debit_transaction" */
  risolto_direct_debit_transaction_aggregate: Risolto_Direct_Debit_Transaction_Aggregate;
  /** fetch data from the table: "risolto.direct_debit_transaction" using primary key columns */
  risolto_direct_debit_transaction_by_pk?: Maybe<Risolto_Direct_Debit_Transaction>;
  /** fetch data from the table in a streaming manner: "risolto.direct_debit_transaction" */
  risolto_direct_debit_transaction_stream: Array<Risolto_Direct_Debit_Transaction>;
  /** fetch data from the table: "risolto.dispute_code" */
  risolto_dispute_code: Array<Risolto_Dispute_Code>;
  /** fetch aggregated fields from the table: "risolto.dispute_code" */
  risolto_dispute_code_aggregate: Risolto_Dispute_Code_Aggregate;
  /** fetch data from the table: "risolto.dispute_code" using primary key columns */
  risolto_dispute_code_by_pk?: Maybe<Risolto_Dispute_Code>;
  /** fetch data from the table in a streaming manner: "risolto.dispute_code" */
  risolto_dispute_code_stream: Array<Risolto_Dispute_Code>;
  /** fetch data from the table: "risolto.document_attachment_type" */
  risolto_document_attachment_type: Array<Risolto_Document_Attachment_Type>;
  /** fetch aggregated fields from the table: "risolto.document_attachment_type" */
  risolto_document_attachment_type_aggregate: Risolto_Document_Attachment_Type_Aggregate;
  /** fetch data from the table: "risolto.document_attachment_type" using primary key columns */
  risolto_document_attachment_type_by_pk?: Maybe<Risolto_Document_Attachment_Type>;
  /** fetch data from the table in a streaming manner: "risolto.document_attachment_type" */
  risolto_document_attachment_type_stream: Array<Risolto_Document_Attachment_Type>;
  /** fetch data from the table: "risolto.document_interchange" */
  risolto_document_interchange: Array<Risolto_Document_Interchange>;
  /** fetch aggregated fields from the table: "risolto.document_interchange" */
  risolto_document_interchange_aggregate: Risolto_Document_Interchange_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_attachment" */
  risolto_document_interchange_attachment: Array<Risolto_Document_Interchange_Attachment>;
  /** fetch aggregated fields from the table: "risolto.document_interchange_attachment" */
  risolto_document_interchange_attachment_aggregate: Risolto_Document_Interchange_Attachment_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_attachment" using primary key columns */
  risolto_document_interchange_attachment_by_pk?: Maybe<Risolto_Document_Interchange_Attachment>;
  /** fetch data from the table in a streaming manner: "risolto.document_interchange_attachment" */
  risolto_document_interchange_attachment_stream: Array<Risolto_Document_Interchange_Attachment>;
  /** fetch data from the table: "risolto.document_interchange" using primary key columns */
  risolto_document_interchange_by_pk?: Maybe<Risolto_Document_Interchange>;
  /** fetch data from the table: "risolto.document_interchange_direction" */
  risolto_document_interchange_direction: Array<Risolto_Document_Interchange_Direction>;
  /** fetch aggregated fields from the table: "risolto.document_interchange_direction" */
  risolto_document_interchange_direction_aggregate: Risolto_Document_Interchange_Direction_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_direction" using primary key columns */
  risolto_document_interchange_direction_by_pk?: Maybe<Risolto_Document_Interchange_Direction>;
  /** fetch data from the table in a streaming manner: "risolto.document_interchange_direction" */
  risolto_document_interchange_direction_stream: Array<Risolto_Document_Interchange_Direction>;
  /** fetch data from the table: "risolto.document_interchange_event" */
  risolto_document_interchange_event: Array<Risolto_Document_Interchange_Event>;
  /** fetch aggregated fields from the table: "risolto.document_interchange_event" */
  risolto_document_interchange_event_aggregate: Risolto_Document_Interchange_Event_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_event" using primary key columns */
  risolto_document_interchange_event_by_pk?: Maybe<Risolto_Document_Interchange_Event>;
  /** fetch data from the table in a streaming manner: "risolto.document_interchange_event" */
  risolto_document_interchange_event_stream: Array<Risolto_Document_Interchange_Event>;
  /** fetch data from the table: "risolto.document_interchange_link" */
  risolto_document_interchange_link: Array<Risolto_Document_Interchange_Link>;
  /** fetch aggregated fields from the table: "risolto.document_interchange_link" */
  risolto_document_interchange_link_aggregate: Risolto_Document_Interchange_Link_Aggregate;
  /** fetch data from the table: "risolto.document_interchange_link" using primary key columns */
  risolto_document_interchange_link_by_pk?: Maybe<Risolto_Document_Interchange_Link>;
  /** fetch data from the table in a streaming manner: "risolto.document_interchange_link" */
  risolto_document_interchange_link_stream: Array<Risolto_Document_Interchange_Link>;
  /** fetch data from the table in a streaming manner: "risolto.document_interchange" */
  risolto_document_interchange_stream: Array<Risolto_Document_Interchange>;
  /** fetch data from the table: "risolto.dunning_notice" */
  risolto_dunning_notice: Array<Risolto_Dunning_Notice>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice" */
  risolto_dunning_notice_aggregate: Risolto_Dunning_Notice_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice" using primary key columns */
  risolto_dunning_notice_by_pk?: Maybe<Risolto_Dunning_Notice>;
  /** fetch data from the table: "risolto.dunning_notice_invoice" */
  risolto_dunning_notice_invoice: Array<Risolto_Dunning_Notice_Invoice>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice_invoice" */
  risolto_dunning_notice_invoice_aggregate: Risolto_Dunning_Notice_Invoice_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice_invoice" using primary key columns */
  risolto_dunning_notice_invoice_by_pk?: Maybe<Risolto_Dunning_Notice_Invoice>;
  /** fetch data from the table: "risolto.dunning_notice_invoice_relation" */
  risolto_dunning_notice_invoice_relation: Array<Risolto_Dunning_Notice_Invoice_Relation>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice_invoice_relation" */
  risolto_dunning_notice_invoice_relation_aggregate: Risolto_Dunning_Notice_Invoice_Relation_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice_invoice_relation" using primary key columns */
  risolto_dunning_notice_invoice_relation_by_pk?: Maybe<Risolto_Dunning_Notice_Invoice_Relation>;
  /** fetch data from the table in a streaming manner: "risolto.dunning_notice_invoice_relation" */
  risolto_dunning_notice_invoice_relation_stream: Array<Risolto_Dunning_Notice_Invoice_Relation>;
  /** fetch data from the table in a streaming manner: "risolto.dunning_notice_invoice" */
  risolto_dunning_notice_invoice_stream: Array<Risolto_Dunning_Notice_Invoice>;
  /** fetch data from the table: "risolto.dunning_notice_status" */
  risolto_dunning_notice_status: Array<Risolto_Dunning_Notice_Status>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice_status" */
  risolto_dunning_notice_status_aggregate: Risolto_Dunning_Notice_Status_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice_status" using primary key columns */
  risolto_dunning_notice_status_by_pk?: Maybe<Risolto_Dunning_Notice_Status>;
  /** fetch data from the table in a streaming manner: "risolto.dunning_notice_status" */
  risolto_dunning_notice_status_stream: Array<Risolto_Dunning_Notice_Status>;
  /** fetch data from the table in a streaming manner: "risolto.dunning_notice" */
  risolto_dunning_notice_stream: Array<Risolto_Dunning_Notice>;
  /** fetch data from the table: "risolto.dunning_notice_type_code" */
  risolto_dunning_notice_type_code: Array<Risolto_Dunning_Notice_Type_Code>;
  /** fetch aggregated fields from the table: "risolto.dunning_notice_type_code" */
  risolto_dunning_notice_type_code_aggregate: Risolto_Dunning_Notice_Type_Code_Aggregate;
  /** fetch data from the table: "risolto.dunning_notice_type_code" using primary key columns */
  risolto_dunning_notice_type_code_by_pk?: Maybe<Risolto_Dunning_Notice_Type_Code>;
  /** fetch data from the table in a streaming manner: "risolto.dunning_notice_type_code" */
  risolto_dunning_notice_type_code_stream: Array<Risolto_Dunning_Notice_Type_Code>;
  /** execute function "risolto.fe_recipient_accounting_document" which returns "risolto.virtual_json" */
  risolto_fe_recipient_accounting_document: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.fe_recipient_accounting_document" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_fe_recipient_accounting_document_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.frequency" */
  risolto_frequency: Array<Risolto_Frequency>;
  /** fetch aggregated fields from the table: "risolto.frequency" */
  risolto_frequency_aggregate: Risolto_Frequency_Aggregate;
  /** fetch data from the table: "risolto.frequency" using primary key columns */
  risolto_frequency_by_pk?: Maybe<Risolto_Frequency>;
  /** fetch data from the table in a streaming manner: "risolto.frequency" */
  risolto_frequency_stream: Array<Risolto_Frequency>;
  /** fetch data from the table: "risolto.grant_type" */
  risolto_grant_type: Array<Risolto_Grant_Type>;
  /** fetch aggregated fields from the table: "risolto.grant_type" */
  risolto_grant_type_aggregate: Risolto_Grant_Type_Aggregate;
  /** fetch data from the table: "risolto.grant_type" using primary key columns */
  risolto_grant_type_by_pk?: Maybe<Risolto_Grant_Type>;
  /** fetch data from the table in a streaming manner: "risolto.grant_type" */
  risolto_grant_type_stream: Array<Risolto_Grant_Type>;
  /** execute function "risolto.hohr_cvt_list_data" which returns "risolto.virtual_json" */
  risolto_hohr_cvt_list_data: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.hohr_cvt_list_data" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_hohr_cvt_list_data_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.invoice_collection" */
  risolto_invoice_collection: Array<Risolto_Invoice_Collection>;
  /** fetch aggregated fields from the table: "risolto.invoice_collection" */
  risolto_invoice_collection_aggregate: Risolto_Invoice_Collection_Aggregate;
  /** fetch data from the table: "risolto.invoice_collection" using primary key columns */
  risolto_invoice_collection_by_pk?: Maybe<Risolto_Invoice_Collection>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_collection" */
  risolto_invoice_collection_stream: Array<Risolto_Invoice_Collection>;
  /** fetch data from the table: "risolto.invoice_dispute" */
  risolto_invoice_dispute: Array<Risolto_Invoice_Dispute>;
  /** fetch aggregated fields from the table: "risolto.invoice_dispute" */
  risolto_invoice_dispute_aggregate: Risolto_Invoice_Dispute_Aggregate;
  /** fetch data from the table: "risolto.invoice_dispute" using primary key columns */
  risolto_invoice_dispute_by_pk?: Maybe<Risolto_Invoice_Dispute>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_dispute" */
  risolto_invoice_dispute_stream: Array<Risolto_Invoice_Dispute>;
  /** fetch data from the table: "risolto.invoice_document" */
  risolto_invoice_document: Array<Risolto_Invoice_Document>;
  /** fetch aggregated fields from the table: "risolto.invoice_document" */
  risolto_invoice_document_aggregate: Risolto_Invoice_Document_Aggregate;
  /** fetch data from the table: "risolto.invoice_document_attachment" */
  risolto_invoice_document_attachment: Array<Risolto_Invoice_Document_Attachment>;
  /** fetch aggregated fields from the table: "risolto.invoice_document_attachment" */
  risolto_invoice_document_attachment_aggregate: Risolto_Invoice_Document_Attachment_Aggregate;
  /** fetch data from the table: "risolto.invoice_document_attachment" using primary key columns */
  risolto_invoice_document_attachment_by_pk?: Maybe<Risolto_Invoice_Document_Attachment>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_document_attachment" */
  risolto_invoice_document_attachment_stream: Array<Risolto_Invoice_Document_Attachment>;
  /** fetch data from the table: "risolto.invoice_document" using primary key columns */
  risolto_invoice_document_by_pk?: Maybe<Risolto_Invoice_Document>;
  /** execute function "risolto.invoice_document_details_search" which returns "risolto.invoice_document" */
  risolto_invoice_document_details_search: Array<Risolto_Invoice_Document>;
  /** execute function "risolto.invoice_document_details_search10" which returns "risolto.invoice_document" */
  risolto_invoice_document_details_search10: Array<Risolto_Invoice_Document>;
  /** execute function "risolto.invoice_document_details_search100" which returns "risolto.invoice_document" */
  risolto_invoice_document_details_search100: Array<Risolto_Invoice_Document>;
  /** execute function "risolto.invoice_document_details_search100" and query aggregates on result of table type "risolto.invoice_document" */
  risolto_invoice_document_details_search100_aggregate: Risolto_Invoice_Document_Aggregate;
  /** execute function "risolto.invoice_document_details_search10" and query aggregates on result of table type "risolto.invoice_document" */
  risolto_invoice_document_details_search10_aggregate: Risolto_Invoice_Document_Aggregate;
  /** execute function "risolto.invoice_document_details_search" and query aggregates on result of table type "risolto.invoice_document" */
  risolto_invoice_document_details_search_aggregate: Risolto_Invoice_Document_Aggregate;
  /** fetch data from the table: "risolto.invoice_document_status" */
  risolto_invoice_document_status: Array<Risolto_Invoice_Document_Status>;
  /** fetch aggregated fields from the table: "risolto.invoice_document_status" */
  risolto_invoice_document_status_aggregate: Risolto_Invoice_Document_Status_Aggregate;
  /** fetch data from the table: "risolto.invoice_document_status" using primary key columns */
  risolto_invoice_document_status_by_pk?: Maybe<Risolto_Invoice_Document_Status>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_document_status" */
  risolto_invoice_document_status_stream: Array<Risolto_Invoice_Document_Status>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_document" */
  risolto_invoice_document_stream: Array<Risolto_Invoice_Document>;
  /** fetch data from the table: "risolto.invoice_group" */
  risolto_invoice_group: Array<Risolto_Invoice_Group>;
  /** fetch aggregated fields from the table: "risolto.invoice_group" */
  risolto_invoice_group_aggregate: Risolto_Invoice_Group_Aggregate;
  /** fetch data from the table: "risolto.invoice_group" using primary key columns */
  risolto_invoice_group_by_pk?: Maybe<Risolto_Invoice_Group>;
  /** fetch data from the table: "risolto.invoice_group_credit_note" */
  risolto_invoice_group_credit_note: Array<Risolto_Invoice_Group_Credit_Note>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_credit_note" */
  risolto_invoice_group_credit_note_aggregate: Risolto_Invoice_Group_Credit_Note_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_credit_note" using primary key columns */
  risolto_invoice_group_credit_note_by_pk?: Maybe<Risolto_Invoice_Group_Credit_Note>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_group_credit_note" */
  risolto_invoice_group_credit_note_stream: Array<Risolto_Invoice_Group_Credit_Note>;
  /** fetch data from the table: "risolto.invoice_group_debit_note" */
  risolto_invoice_group_debit_note: Array<Risolto_Invoice_Group_Debit_Note>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_debit_note" */
  risolto_invoice_group_debit_note_aggregate: Risolto_Invoice_Group_Debit_Note_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_debit_note" using primary key columns */
  risolto_invoice_group_debit_note_by_pk?: Maybe<Risolto_Invoice_Group_Debit_Note>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_group_debit_note" */
  risolto_invoice_group_debit_note_stream: Array<Risolto_Invoice_Group_Debit_Note>;
  /** fetch data from the table: "risolto.invoice_group_dunning_run" */
  risolto_invoice_group_dunning_run: Array<Risolto_Invoice_Group_Dunning_Run>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_dunning_run" */
  risolto_invoice_group_dunning_run_aggregate: Risolto_Invoice_Group_Dunning_Run_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_dunning_run" using primary key columns */
  risolto_invoice_group_dunning_run_by_pk?: Maybe<Risolto_Invoice_Group_Dunning_Run>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_group_dunning_run" */
  risolto_invoice_group_dunning_run_stream: Array<Risolto_Invoice_Group_Dunning_Run>;
  /** fetch data from the table: "risolto.invoice_group_invoice" */
  risolto_invoice_group_invoice: Array<Risolto_Invoice_Group_Invoice>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_invoice" */
  risolto_invoice_group_invoice_aggregate: Risolto_Invoice_Group_Invoice_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_invoice" using primary key columns */
  risolto_invoice_group_invoice_by_pk?: Maybe<Risolto_Invoice_Group_Invoice>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_group_invoice" */
  risolto_invoice_group_invoice_stream: Array<Risolto_Invoice_Group_Invoice>;
  /** fetch data from the table: "risolto.invoice_group_payment" */
  risolto_invoice_group_payment: Array<Risolto_Invoice_Group_Payment>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_payment" */
  risolto_invoice_group_payment_aggregate: Risolto_Invoice_Group_Payment_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_payment" using primary key columns */
  risolto_invoice_group_payment_by_pk?: Maybe<Risolto_Invoice_Group_Payment>;
  /** fetch data from the table: "risolto.invoice_group_payment_promise" */
  risolto_invoice_group_payment_promise: Array<Risolto_Invoice_Group_Payment_Promise>;
  /** fetch aggregated fields from the table: "risolto.invoice_group_payment_promise" */
  risolto_invoice_group_payment_promise_aggregate: Risolto_Invoice_Group_Payment_Promise_Aggregate;
  /** fetch data from the table: "risolto.invoice_group_payment_promise" using primary key columns */
  risolto_invoice_group_payment_promise_by_pk?: Maybe<Risolto_Invoice_Group_Payment_Promise>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_group_payment_promise" */
  risolto_invoice_group_payment_promise_stream: Array<Risolto_Invoice_Group_Payment_Promise>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_group_payment" */
  risolto_invoice_group_payment_stream: Array<Risolto_Invoice_Group_Payment>;
  /** fetch data from the table in a streaming manner: "risolto.invoice_group" */
  risolto_invoice_group_stream: Array<Risolto_Invoice_Group>;
  /** execute function "risolto.invoicing_channel_endpoints_v1" which returns "risolto.virtual_invoicing_channel_endpoint" */
  risolto_invoicing_channel_endpoints_v1: Array<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** execute function "risolto.invoicing_channel_endpoints_v1" and query aggregates on result of table type "risolto.virtual_invoicing_channel_endpoint" */
  risolto_invoicing_channel_endpoints_v1_aggregate: Risolto_Virtual_Invoicing_Channel_Endpoint_Aggregate;
  /** execute function "risolto.invoicing_channel_endpoints_v2" which returns "risolto.channel_endpoint" */
  risolto_invoicing_channel_endpoints_v2: Array<Risolto_Channel_Endpoint>;
  /** execute function "risolto.invoicing_channel_endpoints_v2" and query aggregates on result of table type "risolto.channel_endpoint" */
  risolto_invoicing_channel_endpoints_v2_aggregate: Risolto_Channel_Endpoint_Aggregate;
  /** fetch data from the table: "risolto.iso_country_code" */
  risolto_iso_country_code: Array<Risolto_Iso_Country_Code>;
  /** fetch aggregated fields from the table: "risolto.iso_country_code" */
  risolto_iso_country_code_aggregate: Risolto_Iso_Country_Code_Aggregate;
  /** fetch data from the table: "risolto.iso_country_code" using primary key columns */
  risolto_iso_country_code_by_pk?: Maybe<Risolto_Iso_Country_Code>;
  /** fetch data from the table in a streaming manner: "risolto.iso_country_code" */
  risolto_iso_country_code_stream: Array<Risolto_Iso_Country_Code>;
  /** fetch data from the table: "risolto.job" */
  risolto_job: Array<Risolto_Job>;
  /** fetch aggregated fields from the table: "risolto.job" */
  risolto_job_aggregate: Risolto_Job_Aggregate;
  /** fetch data from the table: "risolto.job" using primary key columns */
  risolto_job_by_pk?: Maybe<Risolto_Job>;
  /** fetch data from the table in a streaming manner: "risolto.job" */
  risolto_job_stream: Array<Risolto_Job>;
  /** fetch data from the table: "risolto.language_code" */
  risolto_language_code: Array<Risolto_Language_Code>;
  /** fetch aggregated fields from the table: "risolto.language_code" */
  risolto_language_code_aggregate: Risolto_Language_Code_Aggregate;
  /** fetch data from the table: "risolto.language_code" using primary key columns */
  risolto_language_code_by_pk?: Maybe<Risolto_Language_Code>;
  /** fetch data from the table in a streaming manner: "risolto.language_code" */
  risolto_language_code_stream: Array<Risolto_Language_Code>;
  /** fetch data from the table: "risolto.legal_entity" */
  risolto_legal_entity: Array<Risolto_Legal_Entity>;
  /** fetch aggregated fields from the table: "risolto.legal_entity" */
  risolto_legal_entity_aggregate: Risolto_Legal_Entity_Aggregate;
  /** fetch data from the table: "risolto.legal_entity" using primary key columns */
  risolto_legal_entity_by_pk?: Maybe<Risolto_Legal_Entity>;
  /** fetch data from the table in a streaming manner: "risolto.legal_entity" */
  risolto_legal_entity_stream: Array<Risolto_Legal_Entity>;
  /** fetch data from the table: "risolto.locale" */
  risolto_locale: Array<Risolto_Locale>;
  /** fetch aggregated fields from the table: "risolto.locale" */
  risolto_locale_aggregate: Risolto_Locale_Aggregate;
  /** fetch data from the table: "risolto.locale" using primary key columns */
  risolto_locale_by_pk?: Maybe<Risolto_Locale>;
  /** fetch data from the table in a streaming manner: "risolto.locale" */
  risolto_locale_stream: Array<Risolto_Locale>;
  /** fetch data from the table: "risolto.magda_cache" */
  risolto_magda_cache: Array<Risolto_Magda_Cache>;
  /** fetch aggregated fields from the table: "risolto.magda_cache" */
  risolto_magda_cache_aggregate: Risolto_Magda_Cache_Aggregate;
  /** fetch data from the table: "risolto.magda_cache" using primary key columns */
  risolto_magda_cache_by_pk?: Maybe<Risolto_Magda_Cache>;
  /** fetch data from the table in a streaming manner: "risolto.magda_cache" */
  risolto_magda_cache_stream: Array<Risolto_Magda_Cache>;
  /** fetch data from the table: "risolto.magda_service_audit_log" */
  risolto_magda_service_audit_log: Array<Risolto_Magda_Service_Audit_Log>;
  /** fetch aggregated fields from the table: "risolto.magda_service_audit_log" */
  risolto_magda_service_audit_log_aggregate: Risolto_Magda_Service_Audit_Log_Aggregate;
  /** fetch data from the table: "risolto.magda_service_audit_log" using primary key columns */
  risolto_magda_service_audit_log_by_pk?: Maybe<Risolto_Magda_Service_Audit_Log>;
  /** fetch data from the table in a streaming manner: "risolto.magda_service_audit_log" */
  risolto_magda_service_audit_log_stream: Array<Risolto_Magda_Service_Audit_Log>;
  /** execute function "risolto.mailbox_actions_and_messages" which returns "risolto.view_action_and_message" */
  risolto_mailbox_actions_and_messages: Array<Risolto_View_Action_And_Message>;
  /** execute function "risolto.mailbox_actions_and_messages" and query aggregates on result of table type "risolto.view_action_and_message" */
  risolto_mailbox_actions_and_messages_aggregate: Risolto_View_Action_And_Message_Aggregate;
  /** fetch data from the table: "risolto.materialized_view_definition" */
  risolto_materialized_view_definition: Array<Risolto_Materialized_View_Definition>;
  /** fetch aggregated fields from the table: "risolto.materialized_view_definition" */
  risolto_materialized_view_definition_aggregate: Risolto_Materialized_View_Definition_Aggregate;
  /** fetch data from the table: "risolto.materialized_view_definition" using primary key columns */
  risolto_materialized_view_definition_by_pk?: Maybe<Risolto_Materialized_View_Definition>;
  /** fetch data from the table in a streaming manner: "risolto.materialized_view_definition" */
  risolto_materialized_view_definition_stream: Array<Risolto_Materialized_View_Definition>;
  /** fetch data from the table: "risolto.message" */
  risolto_message: Array<Risolto_Message>;
  /** fetch aggregated fields from the table: "risolto.message" */
  risolto_message_aggregate: Risolto_Message_Aggregate;
  /** fetch data from the table: "risolto.message_assignee" */
  risolto_message_assignee: Array<Risolto_Message_Assignee>;
  /** fetch aggregated fields from the table: "risolto.message_assignee" */
  risolto_message_assignee_aggregate: Risolto_Message_Assignee_Aggregate;
  /** fetch data from the table: "risolto.message_assignee" using primary key columns */
  risolto_message_assignee_by_pk?: Maybe<Risolto_Message_Assignee>;
  /** fetch data from the table in a streaming manner: "risolto.message_assignee" */
  risolto_message_assignee_stream: Array<Risolto_Message_Assignee>;
  /** fetch data from the table: "risolto.message_attachment" */
  risolto_message_attachment: Array<Risolto_Message_Attachment>;
  /** fetch aggregated fields from the table: "risolto.message_attachment" */
  risolto_message_attachment_aggregate: Risolto_Message_Attachment_Aggregate;
  /** fetch data from the table: "risolto.message_attachment" using primary key columns */
  risolto_message_attachment_by_pk?: Maybe<Risolto_Message_Attachment>;
  /** fetch data from the table in a streaming manner: "risolto.message_attachment" */
  risolto_message_attachment_stream: Array<Risolto_Message_Attachment>;
  /** fetch data from the table: "risolto.message" using primary key columns */
  risolto_message_by_pk?: Maybe<Risolto_Message>;
  /** fetch data from the table: "risolto.message_label" */
  risolto_message_label: Array<Risolto_Message_Label>;
  /** fetch aggregated fields from the table: "risolto.message_label" */
  risolto_message_label_aggregate: Risolto_Message_Label_Aggregate;
  /** fetch data from the table: "risolto.message_label" using primary key columns */
  risolto_message_label_by_pk?: Maybe<Risolto_Message_Label>;
  /** fetch data from the table in a streaming manner: "risolto.message_label" */
  risolto_message_label_stream: Array<Risolto_Message_Label>;
  /** fetch data from the table: "risolto.message_message_label" */
  risolto_message_message_label: Array<Risolto_Message_Message_Label>;
  /** fetch aggregated fields from the table: "risolto.message_message_label" */
  risolto_message_message_label_aggregate: Risolto_Message_Message_Label_Aggregate;
  /** fetch data from the table: "risolto.message_message_label" using primary key columns */
  risolto_message_message_label_by_pk?: Maybe<Risolto_Message_Message_Label>;
  /** fetch data from the table in a streaming manner: "risolto.message_message_label" */
  risolto_message_message_label_stream: Array<Risolto_Message_Message_Label>;
  /** fetch data from the table: "risolto.message_recipient" */
  risolto_message_recipient: Array<Risolto_Message_Recipient>;
  /** fetch aggregated fields from the table: "risolto.message_recipient" */
  risolto_message_recipient_aggregate: Risolto_Message_Recipient_Aggregate;
  /** fetch data from the table: "risolto.message_recipient" using primary key columns */
  risolto_message_recipient_by_pk?: Maybe<Risolto_Message_Recipient>;
  /** fetch data from the table in a streaming manner: "risolto.message_recipient" */
  risolto_message_recipient_stream: Array<Risolto_Message_Recipient>;
  /** fetch data from the table in a streaming manner: "risolto.message" */
  risolto_message_stream: Array<Risolto_Message>;
  /** fetch data from the table: "risolto.mime_type" */
  risolto_mime_type: Array<Risolto_Mime_Type>;
  /** fetch aggregated fields from the table: "risolto.mime_type" */
  risolto_mime_type_aggregate: Risolto_Mime_Type_Aggregate;
  /** fetch data from the table: "risolto.mime_type" using primary key columns */
  risolto_mime_type_by_pk?: Maybe<Risolto_Mime_Type>;
  /** fetch data from the table in a streaming manner: "risolto.mime_type" */
  risolto_mime_type_stream: Array<Risolto_Mime_Type>;
  /** fetch data from the table: "risolto.note" */
  risolto_note: Array<Risolto_Note>;
  /** fetch aggregated fields from the table: "risolto.note" */
  risolto_note_aggregate: Risolto_Note_Aggregate;
  /** fetch data from the table: "risolto.note" using primary key columns */
  risolto_note_by_pk?: Maybe<Risolto_Note>;
  /** fetch data from the table: "risolto.note_category" */
  risolto_note_category: Array<Risolto_Note_Category>;
  /** fetch aggregated fields from the table: "risolto.note_category" */
  risolto_note_category_aggregate: Risolto_Note_Category_Aggregate;
  /** fetch data from the table: "risolto.note_category" using primary key columns */
  risolto_note_category_by_pk?: Maybe<Risolto_Note_Category>;
  /** fetch data from the table in a streaming manner: "risolto.note_category" */
  risolto_note_category_stream: Array<Risolto_Note_Category>;
  /** fetch data from the table: "risolto.note_invoice" */
  risolto_note_invoice: Array<Risolto_Note_Invoice>;
  /** fetch aggregated fields from the table: "risolto.note_invoice" */
  risolto_note_invoice_aggregate: Risolto_Note_Invoice_Aggregate;
  /** fetch data from the table: "risolto.note_invoice" using primary key columns */
  risolto_note_invoice_by_pk?: Maybe<Risolto_Note_Invoice>;
  /** fetch data from the table in a streaming manner: "risolto.note_invoice" */
  risolto_note_invoice_stream: Array<Risolto_Note_Invoice>;
  /** fetch data from the table in a streaming manner: "risolto.note" */
  risolto_note_stream: Array<Risolto_Note>;
  /** fetch data from the table: "risolto.open_balance" */
  risolto_open_balance: Array<Risolto_Open_Balance>;
  /** fetch aggregated fields from the table: "risolto.open_balance" */
  risolto_open_balance_aggregate: Risolto_Open_Balance_Aggregate;
  /** fetch data from the table: "risolto.open_balance" using primary key columns */
  risolto_open_balance_by_pk?: Maybe<Risolto_Open_Balance>;
  /** fetch data from the table: "risolto.open_balance_record" */
  risolto_open_balance_record: Array<Risolto_Open_Balance_Record>;
  /** fetch aggregated fields from the table: "risolto.open_balance_record" */
  risolto_open_balance_record_aggregate: Risolto_Open_Balance_Record_Aggregate;
  /** fetch data from the table: "risolto.open_balance_record" using primary key columns */
  risolto_open_balance_record_by_pk?: Maybe<Risolto_Open_Balance_Record>;
  /** fetch data from the table in a streaming manner: "risolto.open_balance_record" */
  risolto_open_balance_record_stream: Array<Risolto_Open_Balance_Record>;
  /** fetch data from the table in a streaming manner: "risolto.open_balance" */
  risolto_open_balance_stream: Array<Risolto_Open_Balance>;
  /** fetch data from the table: "risolto.origin" */
  risolto_origin: Array<Risolto_Origin>;
  /** fetch aggregated fields from the table: "risolto.origin" */
  risolto_origin_aggregate: Risolto_Origin_Aggregate;
  /** fetch data from the table: "risolto.origin" using primary key columns */
  risolto_origin_by_pk?: Maybe<Risolto_Origin>;
  /** fetch data from the table in a streaming manner: "risolto.origin" */
  risolto_origin_stream: Array<Risolto_Origin>;
  /** fetch data from the table: "risolto.participant" */
  risolto_participant: Array<Risolto_Participant>;
  /** fetch aggregated fields from the table: "risolto.participant" */
  risolto_participant_aggregate: Risolto_Participant_Aggregate;
  /** fetch data from the table: "risolto.participant_api_app_client" */
  risolto_participant_api_app_client: Array<Risolto_Participant_Api_App_Client>;
  /** fetch aggregated fields from the table: "risolto.participant_api_app_client" */
  risolto_participant_api_app_client_aggregate: Risolto_Participant_Api_App_Client_Aggregate;
  /** fetch data from the table: "risolto.participant_api_app_client" using primary key columns */
  risolto_participant_api_app_client_by_pk?: Maybe<Risolto_Participant_Api_App_Client>;
  /** fetch data from the table in a streaming manner: "risolto.participant_api_app_client" */
  risolto_participant_api_app_client_stream: Array<Risolto_Participant_Api_App_Client>;
  /** fetch data from the table: "risolto.participant" using primary key columns */
  risolto_participant_by_pk?: Maybe<Risolto_Participant>;
  /** fetch data from the table: "risolto.participant_dunning_run" */
  risolto_participant_dunning_run: Array<Risolto_Participant_Dunning_Run>;
  /** fetch aggregated fields from the table: "risolto.participant_dunning_run" */
  risolto_participant_dunning_run_aggregate: Risolto_Participant_Dunning_Run_Aggregate;
  /** fetch data from the table: "risolto.participant_dunning_run" using primary key columns */
  risolto_participant_dunning_run_by_pk?: Maybe<Risolto_Participant_Dunning_Run>;
  /** fetch data from the table in a streaming manner: "risolto.participant_dunning_run" */
  risolto_participant_dunning_run_stream: Array<Risolto_Participant_Dunning_Run>;
  /** fetch data from the table in a streaming manner: "risolto.participant" */
  risolto_participant_stream: Array<Risolto_Participant>;
  /** fetch data from the table: "risolto.participant_user" */
  risolto_participant_user: Array<Risolto_Participant_User>;
  /** fetch aggregated fields from the table: "risolto.participant_user" */
  risolto_participant_user_aggregate: Risolto_Participant_User_Aggregate;
  /** fetch data from the table: "risolto.participant_user" using primary key columns */
  risolto_participant_user_by_pk?: Maybe<Risolto_Participant_User>;
  /** fetch data from the table: "risolto.participant_user_role" */
  risolto_participant_user_role: Array<Risolto_Participant_User_Role>;
  /** fetch aggregated fields from the table: "risolto.participant_user_role" */
  risolto_participant_user_role_aggregate: Risolto_Participant_User_Role_Aggregate;
  /** fetch data from the table: "risolto.participant_user_role" using primary key columns */
  risolto_participant_user_role_by_pk?: Maybe<Risolto_Participant_User_Role>;
  /** fetch data from the table in a streaming manner: "risolto.participant_user_role" */
  risolto_participant_user_role_stream: Array<Risolto_Participant_User_Role>;
  /** fetch data from the table in a streaming manner: "risolto.participant_user" */
  risolto_participant_user_stream: Array<Risolto_Participant_User>;
  /** fetch data from the table: "risolto.payment" */
  risolto_payment: Array<Risolto_Payment>;
  /** fetch aggregated fields from the table: "risolto.payment" */
  risolto_payment_aggregate: Risolto_Payment_Aggregate;
  /** fetch data from the table: "risolto.payment" using primary key columns */
  risolto_payment_by_pk?: Maybe<Risolto_Payment>;
  /** fetch data from the table: "risolto.payment_document" */
  risolto_payment_document: Array<Risolto_Payment_Document>;
  /** fetch aggregated fields from the table: "risolto.payment_document" */
  risolto_payment_document_aggregate: Risolto_Payment_Document_Aggregate;
  /** fetch data from the table: "risolto.payment_document" using primary key columns */
  risolto_payment_document_by_pk?: Maybe<Risolto_Payment_Document>;
  /** fetch data from the table in a streaming manner: "risolto.payment_document" */
  risolto_payment_document_stream: Array<Risolto_Payment_Document>;
  /** fetch data from the table: "risolto.payment_link" */
  risolto_payment_link: Array<Risolto_Payment_Link>;
  /** fetch aggregated fields from the table: "risolto.payment_link" */
  risolto_payment_link_aggregate: Risolto_Payment_Link_Aggregate;
  /** fetch data from the table: "risolto.payment_link" using primary key columns */
  risolto_payment_link_by_pk?: Maybe<Risolto_Payment_Link>;
  /** fetch data from the table in a streaming manner: "risolto.payment_link" */
  risolto_payment_link_stream: Array<Risolto_Payment_Link>;
  /** fetch data from the table: "risolto.payment_plan" */
  risolto_payment_plan: Array<Risolto_Payment_Plan>;
  /** fetch aggregated fields from the table: "risolto.payment_plan" */
  risolto_payment_plan_aggregate: Risolto_Payment_Plan_Aggregate;
  /** fetch data from the table: "risolto.payment_plan" using primary key columns */
  risolto_payment_plan_by_pk?: Maybe<Risolto_Payment_Plan>;
  /** fetch data from the table in a streaming manner: "risolto.payment_plan" */
  risolto_payment_plan_stream: Array<Risolto_Payment_Plan>;
  /** fetch data from the table: "risolto.payment_promise" */
  risolto_payment_promise: Array<Risolto_Payment_Promise>;
  /** fetch aggregated fields from the table: "risolto.payment_promise" */
  risolto_payment_promise_aggregate: Risolto_Payment_Promise_Aggregate;
  /** fetch data from the table: "risolto.payment_promise" using primary key columns */
  risolto_payment_promise_by_pk?: Maybe<Risolto_Payment_Promise>;
  /** fetch data from the table in a streaming manner: "risolto.payment_promise" */
  risolto_payment_promise_stream: Array<Risolto_Payment_Promise>;
  /** fetch data from the table in a streaming manner: "risolto.payment" */
  risolto_payment_stream: Array<Risolto_Payment>;
  /** fetch data from the table: "risolto.payment_transfer" */
  risolto_payment_transfer: Array<Risolto_Payment_Transfer>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer" */
  risolto_payment_transfer_aggregate: Risolto_Payment_Transfer_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_bulk_payment" */
  risolto_payment_transfer_bulk_payment: Array<Risolto_Payment_Transfer_Bulk_Payment>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer_bulk_payment" */
  risolto_payment_transfer_bulk_payment_aggregate: Risolto_Payment_Transfer_Bulk_Payment_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_bulk_payment" using primary key columns */
  risolto_payment_transfer_bulk_payment_by_pk?: Maybe<Risolto_Payment_Transfer_Bulk_Payment>;
  /** fetch data from the table in a streaming manner: "risolto.payment_transfer_bulk_payment" */
  risolto_payment_transfer_bulk_payment_stream: Array<Risolto_Payment_Transfer_Bulk_Payment>;
  /** fetch data from the table: "risolto.payment_transfer" using primary key columns */
  risolto_payment_transfer_by_pk?: Maybe<Risolto_Payment_Transfer>;
  /** fetch data from the table: "risolto.payment_transfer_line" */
  risolto_payment_transfer_line: Array<Risolto_Payment_Transfer_Line>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer_line" */
  risolto_payment_transfer_line_aggregate: Risolto_Payment_Transfer_Line_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_line" using primary key columns */
  risolto_payment_transfer_line_by_pk?: Maybe<Risolto_Payment_Transfer_Line>;
  /** fetch data from the table in a streaming manner: "risolto.payment_transfer_line" */
  risolto_payment_transfer_line_stream: Array<Risolto_Payment_Transfer_Line>;
  /** fetch data from the table: "risolto.payment_transfer_line_type" */
  risolto_payment_transfer_line_type: Array<Risolto_Payment_Transfer_Line_Type>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer_line_type" */
  risolto_payment_transfer_line_type_aggregate: Risolto_Payment_Transfer_Line_Type_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_line_type" using primary key columns */
  risolto_payment_transfer_line_type_by_pk?: Maybe<Risolto_Payment_Transfer_Line_Type>;
  /** fetch data from the table in a streaming manner: "risolto.payment_transfer_line_type" */
  risolto_payment_transfer_line_type_stream: Array<Risolto_Payment_Transfer_Line_Type>;
  /** fetch data from the table: "risolto.payment_transfer_status" */
  risolto_payment_transfer_status: Array<Risolto_Payment_Transfer_Status>;
  /** fetch aggregated fields from the table: "risolto.payment_transfer_status" */
  risolto_payment_transfer_status_aggregate: Risolto_Payment_Transfer_Status_Aggregate;
  /** fetch data from the table: "risolto.payment_transfer_status" using primary key columns */
  risolto_payment_transfer_status_by_pk?: Maybe<Risolto_Payment_Transfer_Status>;
  /** fetch data from the table in a streaming manner: "risolto.payment_transfer_status" */
  risolto_payment_transfer_status_stream: Array<Risolto_Payment_Transfer_Status>;
  /** fetch data from the table in a streaming manner: "risolto.payment_transfer" */
  risolto_payment_transfer_stream: Array<Risolto_Payment_Transfer>;
  /** fetch data from the table: "risolto.person" */
  risolto_person: Array<Risolto_Person>;
  /** fetch aggregated fields from the table: "risolto.person" */
  risolto_person_aggregate: Risolto_Person_Aggregate;
  /** fetch data from the table: "risolto.person" using primary key columns */
  risolto_person_by_pk?: Maybe<Risolto_Person>;
  /** fetch data from the table in a streaming manner: "risolto.person" */
  risolto_person_stream: Array<Risolto_Person>;
  /** fetch data from the table: "risolto.platform_license_module" */
  risolto_platform_license_module: Array<Risolto_Platform_License_Module>;
  /** fetch aggregated fields from the table: "risolto.platform_license_module" */
  risolto_platform_license_module_aggregate: Risolto_Platform_License_Module_Aggregate;
  /** fetch data from the table: "risolto.platform_license_module" using primary key columns */
  risolto_platform_license_module_by_pk?: Maybe<Risolto_Platform_License_Module>;
  /** fetch data from the table in a streaming manner: "risolto.platform_license_module" */
  risolto_platform_license_module_stream: Array<Risolto_Platform_License_Module>;
  /** fetch data from the table: "risolto.platform_participant_license" */
  risolto_platform_participant_license: Array<Risolto_Platform_Participant_License>;
  /** fetch aggregated fields from the table: "risolto.platform_participant_license" */
  risolto_platform_participant_license_aggregate: Risolto_Platform_Participant_License_Aggregate;
  /** fetch data from the table: "risolto.platform_participant_license" using primary key columns */
  risolto_platform_participant_license_by_pk?: Maybe<Risolto_Platform_Participant_License>;
  /** fetch data from the table in a streaming manner: "risolto.platform_participant_license" */
  risolto_platform_participant_license_stream: Array<Risolto_Platform_Participant_License>;
  /** fetch data from the table: "risolto.platform_permission" */
  risolto_platform_permission: Array<Risolto_Platform_Permission>;
  /** fetch aggregated fields from the table: "risolto.platform_permission" */
  risolto_platform_permission_aggregate: Risolto_Platform_Permission_Aggregate;
  /** fetch data from the table: "risolto.platform_permission" using primary key columns */
  risolto_platform_permission_by_pk?: Maybe<Risolto_Platform_Permission>;
  /** fetch data from the table in a streaming manner: "risolto.platform_permission" */
  risolto_platform_permission_stream: Array<Risolto_Platform_Permission>;
  /** fetch data from the table: "risolto.platform_role" */
  risolto_platform_role: Array<Risolto_Platform_Role>;
  /** fetch aggregated fields from the table: "risolto.platform_role" */
  risolto_platform_role_aggregate: Risolto_Platform_Role_Aggregate;
  /** fetch data from the table: "risolto.platform_role" using primary key columns */
  risolto_platform_role_by_pk?: Maybe<Risolto_Platform_Role>;
  /** fetch data from the table: "risolto.platform_role_permission" */
  risolto_platform_role_permission: Array<Risolto_Platform_Role_Permission>;
  /** fetch aggregated fields from the table: "risolto.platform_role_permission" */
  risolto_platform_role_permission_aggregate: Risolto_Platform_Role_Permission_Aggregate;
  /** fetch data from the table: "risolto.platform_role_permission" using primary key columns */
  risolto_platform_role_permission_by_pk?: Maybe<Risolto_Platform_Role_Permission>;
  /** fetch data from the table in a streaming manner: "risolto.platform_role_permission" */
  risolto_platform_role_permission_stream: Array<Risolto_Platform_Role_Permission>;
  /** fetch data from the table in a streaming manner: "risolto.platform_role" */
  risolto_platform_role_stream: Array<Risolto_Platform_Role>;
  /** fetch data from the table: "risolto.platform_usage" */
  risolto_platform_usage: Array<Risolto_Platform_Usage>;
  /** fetch aggregated fields from the table: "risolto.platform_usage" */
  risolto_platform_usage_aggregate: Risolto_Platform_Usage_Aggregate;
  /** fetch data from the table: "risolto.platform_usage" using primary key columns */
  risolto_platform_usage_by_pk?: Maybe<Risolto_Platform_Usage>;
  /** fetch data from the table in a streaming manner: "risolto.platform_usage" */
  risolto_platform_usage_stream: Array<Risolto_Platform_Usage>;
  /** execute function "risolto.proof_of_delivery_barcode" which returns "risolto.virtual_json" */
  risolto_proof_of_delivery_barcode: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.proof_of_delivery_barcode" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_proof_of_delivery_barcode_aggregate: Risolto_Virtual_Json_Aggregate;
  /** execute function "risolto.proof_of_delivery_barcode_v2" which returns "risolto.virtual_json" */
  risolto_proof_of_delivery_barcode_v2: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.proof_of_delivery_barcode_v2" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_proof_of_delivery_barcode_v2_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.recipient" */
  risolto_recipient: Array<Risolto_Recipient>;
  /** fetch data from the table: "risolto.recipient_address" */
  risolto_recipient_address: Array<Risolto_Recipient_Address>;
  /** fetch aggregated fields from the table: "risolto.recipient_address" */
  risolto_recipient_address_aggregate: Risolto_Recipient_Address_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.recipient_address" */
  risolto_recipient_address_stream: Array<Risolto_Recipient_Address>;
  /** fetch aggregated fields from the table: "risolto.recipient" */
  risolto_recipient_aggregate: Risolto_Recipient_Aggregate;
  /** fetch data from the table: "risolto.recipient_attachment" */
  risolto_recipient_attachment: Array<Risolto_Recipient_Attachment>;
  /** fetch aggregated fields from the table: "risolto.recipient_attachment" */
  risolto_recipient_attachment_aggregate: Risolto_Recipient_Attachment_Aggregate;
  /** fetch data from the table: "risolto.recipient_attachment" using primary key columns */
  risolto_recipient_attachment_by_pk?: Maybe<Risolto_Recipient_Attachment>;
  /** fetch data from the table in a streaming manner: "risolto.recipient_attachment" */
  risolto_recipient_attachment_stream: Array<Risolto_Recipient_Attachment>;
  /** fetch data from the table: "risolto.recipient" using primary key columns */
  risolto_recipient_by_pk?: Maybe<Risolto_Recipient>;
  /** fetch data from the table: "risolto.recipient_collection" */
  risolto_recipient_collection: Array<Risolto_Recipient_Collection>;
  /** fetch aggregated fields from the table: "risolto.recipient_collection" */
  risolto_recipient_collection_aggregate: Risolto_Recipient_Collection_Aggregate;
  /** fetch data from the table: "risolto.recipient_collection" using primary key columns */
  risolto_recipient_collection_by_pk?: Maybe<Risolto_Recipient_Collection>;
  /** fetch data from the table in a streaming manner: "risolto.recipient_collection" */
  risolto_recipient_collection_stream: Array<Risolto_Recipient_Collection>;
  /** fetch data from the table: "risolto.recipient_communication" */
  risolto_recipient_communication: Array<Risolto_Recipient_Communication>;
  /** fetch aggregated fields from the table: "risolto.recipient_communication" */
  risolto_recipient_communication_aggregate: Risolto_Recipient_Communication_Aggregate;
  /** fetch data from the table: "risolto.recipient_communication" using primary key columns */
  risolto_recipient_communication_by_pk?: Maybe<Risolto_Recipient_Communication>;
  /** fetch data from the table in a streaming manner: "risolto.recipient_communication" */
  risolto_recipient_communication_stream: Array<Risolto_Recipient_Communication>;
  /** fetch data from the table: "risolto.recipient_dunning_exclude" */
  risolto_recipient_dunning_exclude: Array<Risolto_Recipient_Dunning_Exclude>;
  /** fetch aggregated fields from the table: "risolto.recipient_dunning_exclude" */
  risolto_recipient_dunning_exclude_aggregate: Risolto_Recipient_Dunning_Exclude_Aggregate;
  /** fetch data from the table: "risolto.recipient_dunning_exclude" using primary key columns */
  risolto_recipient_dunning_exclude_by_pk?: Maybe<Risolto_Recipient_Dunning_Exclude>;
  /** fetch data from the table in a streaming manner: "risolto.recipient_dunning_exclude" */
  risolto_recipient_dunning_exclude_stream: Array<Risolto_Recipient_Dunning_Exclude>;
  /** fetch data from the table: "risolto.recipient_dunning_run" */
  risolto_recipient_dunning_run: Array<Risolto_Recipient_Dunning_Run>;
  /** fetch aggregated fields from the table: "risolto.recipient_dunning_run" */
  risolto_recipient_dunning_run_aggregate: Risolto_Recipient_Dunning_Run_Aggregate;
  /** fetch data from the table: "risolto.recipient_dunning_run" using primary key columns */
  risolto_recipient_dunning_run_by_pk?: Maybe<Risolto_Recipient_Dunning_Run>;
  /** fetch data from the table in a streaming manner: "risolto.recipient_dunning_run" */
  risolto_recipient_dunning_run_stream: Array<Risolto_Recipient_Dunning_Run>;
  /** execute function "risolto.recipient_find_similar_by_name" which returns "risolto.virtual_json" */
  risolto_recipient_find_similar_by_name: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.recipient_find_similar_by_name" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_recipient_find_similar_by_name_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.recipient_merge" */
  risolto_recipient_merge: Array<Risolto_Recipient_Merge>;
  /** fetch aggregated fields from the table: "risolto.recipient_merge" */
  risolto_recipient_merge_aggregate: Risolto_Recipient_Merge_Aggregate;
  /** fetch data from the table: "risolto.recipient_merge" using primary key columns */
  risolto_recipient_merge_by_pk?: Maybe<Risolto_Recipient_Merge>;
  /** fetch data from the table in a streaming manner: "risolto.recipient_merge" */
  risolto_recipient_merge_stream: Array<Risolto_Recipient_Merge>;
  /** fetch data from the table in a streaming manner: "risolto.recipient" */
  risolto_recipient_stream: Array<Risolto_Recipient>;
  /** fetch data from the table: "risolto.recipient_tag" */
  risolto_recipient_tag: Array<Risolto_Recipient_Tag>;
  /** fetch aggregated fields from the table: "risolto.recipient_tag" */
  risolto_recipient_tag_aggregate: Risolto_Recipient_Tag_Aggregate;
  /** fetch data from the table: "risolto.recipient_tag" using primary key columns */
  risolto_recipient_tag_by_pk?: Maybe<Risolto_Recipient_Tag>;
  /** fetch data from the table in a streaming manner: "risolto.recipient_tag" */
  risolto_recipient_tag_stream: Array<Risolto_Recipient_Tag>;
  /** fetch data from the table: "risolto.recipient_user" */
  risolto_recipient_user: Array<Risolto_Recipient_User>;
  /** fetch aggregated fields from the table: "risolto.recipient_user" */
  risolto_recipient_user_aggregate: Risolto_Recipient_User_Aggregate;
  /** fetch data from the table: "risolto.recipient_user" using primary key columns */
  risolto_recipient_user_by_pk?: Maybe<Risolto_Recipient_User>;
  /** fetch data from the table in a streaming manner: "risolto.recipient_user" */
  risolto_recipient_user_stream: Array<Risolto_Recipient_User>;
  /** fetch data from the table: "risolto.reference_data" */
  risolto_reference_data: Array<Risolto_Reference_Data>;
  /** fetch aggregated fields from the table: "risolto.reference_data" */
  risolto_reference_data_aggregate: Risolto_Reference_Data_Aggregate;
  /** fetch data from the table: "risolto.reference_data" using primary key columns */
  risolto_reference_data_by_pk?: Maybe<Risolto_Reference_Data>;
  /** fetch data from the table in a streaming manner: "risolto.reference_data" */
  risolto_reference_data_stream: Array<Risolto_Reference_Data>;
  /** execute function "risolto.report_action_events" which returns "risolto.virtual_report_delivery" */
  risolto_report_action_events: Array<Risolto_Virtual_Report_Delivery>;
  /** execute function "risolto.report_action_events" and query aggregates on result of table type "risolto.virtual_report_delivery" */
  risolto_report_action_events_aggregate: Risolto_Virtual_Report_Delivery_Aggregate;
  /** execute function "risolto.report_action_events_v2" which returns "risolto.virtual_report_delivery" */
  risolto_report_action_events_v2: Array<Risolto_Virtual_Report_Delivery>;
  /** execute function "risolto.report_action_events_v2" and query aggregates on result of table type "risolto.virtual_report_delivery" */
  risolto_report_action_events_v2_aggregate: Risolto_Virtual_Report_Delivery_Aggregate;
  /** fetch data from the table: "risolto.report_definition" */
  risolto_report_definition: Array<Risolto_Report_Definition>;
  /** fetch aggregated fields from the table: "risolto.report_definition" */
  risolto_report_definition_aggregate: Risolto_Report_Definition_Aggregate;
  /** fetch data from the table: "risolto.report_definition" using primary key columns */
  risolto_report_definition_by_pk?: Maybe<Risolto_Report_Definition>;
  /** fetch data from the table in a streaming manner: "risolto.report_definition" */
  risolto_report_definition_stream: Array<Risolto_Report_Definition>;
  /** fetch data from the table: "risolto.report_execution" */
  risolto_report_execution: Array<Risolto_Report_Execution>;
  /** fetch aggregated fields from the table: "risolto.report_execution" */
  risolto_report_execution_aggregate: Risolto_Report_Execution_Aggregate;
  /** fetch data from the table: "risolto.report_execution" using primary key columns */
  risolto_report_execution_by_pk?: Maybe<Risolto_Report_Execution>;
  /** fetch data from the table in a streaming manner: "risolto.report_execution" */
  risolto_report_execution_stream: Array<Risolto_Report_Execution>;
  /** fetch data from the table: "risolto.report_execution_user" */
  risolto_report_execution_user: Array<Risolto_Report_Execution_User>;
  /** fetch aggregated fields from the table: "risolto.report_execution_user" */
  risolto_report_execution_user_aggregate: Risolto_Report_Execution_User_Aggregate;
  /** fetch data from the table: "risolto.report_execution_user" using primary key columns */
  risolto_report_execution_user_by_pk?: Maybe<Risolto_Report_Execution_User>;
  /** fetch data from the table in a streaming manner: "risolto.report_execution_user" */
  risolto_report_execution_user_stream: Array<Risolto_Report_Execution_User>;
  /** execute function "risolto.report_monthly_delivery_v1" which returns "risolto.virtual_report_delivery" */
  risolto_report_monthly_delivery_v1: Array<Risolto_Virtual_Report_Delivery>;
  /** execute function "risolto.report_monthly_delivery_v1" and query aggregates on result of table type "risolto.virtual_report_delivery" */
  risolto_report_monthly_delivery_v1_aggregate: Risolto_Virtual_Report_Delivery_Aggregate;
  /** fetch data from the table: "risolto.report_template_type" */
  risolto_report_template_type: Array<Risolto_Report_Template_Type>;
  /** fetch aggregated fields from the table: "risolto.report_template_type" */
  risolto_report_template_type_aggregate: Risolto_Report_Template_Type_Aggregate;
  /** fetch data from the table: "risolto.report_template_type" using primary key columns */
  risolto_report_template_type_by_pk?: Maybe<Risolto_Report_Template_Type>;
  /** fetch data from the table in a streaming manner: "risolto.report_template_type" */
  risolto_report_template_type_stream: Array<Risolto_Report_Template_Type>;
  /** fetch data from the table: "risolto.report_type" */
  risolto_report_type: Array<Risolto_Report_Type>;
  /** fetch aggregated fields from the table: "risolto.report_type" */
  risolto_report_type_aggregate: Risolto_Report_Type_Aggregate;
  /** fetch data from the table: "risolto.report_type" using primary key columns */
  risolto_report_type_by_pk?: Maybe<Risolto_Report_Type>;
  /** fetch data from the table in a streaming manner: "risolto.report_type" */
  risolto_report_type_stream: Array<Risolto_Report_Type>;
  /** fetch data from the table: "risolto.report_user" */
  risolto_report_user: Array<Risolto_Report_User>;
  /** fetch aggregated fields from the table: "risolto.report_user" */
  risolto_report_user_aggregate: Risolto_Report_User_Aggregate;
  /** fetch data from the table: "risolto.report_user" using primary key columns */
  risolto_report_user_by_pk?: Maybe<Risolto_Report_User>;
  /** fetch data from the table in a streaming manner: "risolto.report_user" */
  risolto_report_user_stream: Array<Risolto_Report_User>;
  /** fetch data from the table: "risolto.run_processing_status" */
  risolto_run_processing_status: Array<Risolto_Run_Processing_Status>;
  /** fetch aggregated fields from the table: "risolto.run_processing_status" */
  risolto_run_processing_status_aggregate: Risolto_Run_Processing_Status_Aggregate;
  /** fetch data from the table: "risolto.run_processing_status" using primary key columns */
  risolto_run_processing_status_by_pk?: Maybe<Risolto_Run_Processing_Status>;
  /** fetch data from the table in a streaming manner: "risolto.run_processing_status" */
  risolto_run_processing_status_stream: Array<Risolto_Run_Processing_Status>;
  /** execute function "risolto.search2recid" which returns "risolto.recipient" */
  risolto_search2recid: Array<Risolto_Recipient>;
  /** execute function "risolto.search2recid" and query aggregates on result of table type "risolto.recipient" */
  risolto_search2recid_aggregate: Risolto_Recipient_Aggregate;
  /** fetch data from the table: "risolto.single_sign_on" */
  risolto_single_sign_on: Array<Risolto_Single_Sign_On>;
  /** fetch aggregated fields from the table: "risolto.single_sign_on" */
  risolto_single_sign_on_aggregate: Risolto_Single_Sign_On_Aggregate;
  /** fetch data from the table: "risolto.single_sign_on" using primary key columns */
  risolto_single_sign_on_by_pk?: Maybe<Risolto_Single_Sign_On>;
  /** fetch data from the table in a streaming manner: "risolto.single_sign_on" */
  risolto_single_sign_on_stream: Array<Risolto_Single_Sign_On>;
  /** fetch data from the table: "risolto.statement" */
  risolto_statement: Array<Risolto_Statement>;
  /** fetch data from the table: "risolto.statement_account" */
  risolto_statement_account: Array<Risolto_Statement_Account>;
  /** fetch aggregated fields from the table: "risolto.statement_account" */
  risolto_statement_account_aggregate: Risolto_Statement_Account_Aggregate;
  /** fetch data from the table: "risolto.statement_account" using primary key columns */
  risolto_statement_account_by_pk?: Maybe<Risolto_Statement_Account>;
  /** fetch data from the table in a streaming manner: "risolto.statement_account" */
  risolto_statement_account_stream: Array<Risolto_Statement_Account>;
  /** fetch aggregated fields from the table: "risolto.statement" */
  risolto_statement_aggregate: Risolto_Statement_Aggregate;
  /** fetch data from the table: "risolto.statement" using primary key columns */
  risolto_statement_by_pk?: Maybe<Risolto_Statement>;
  /** fetch data from the table: "risolto.statement_line" */
  risolto_statement_line: Array<Risolto_Statement_Line>;
  /** fetch aggregated fields from the table: "risolto.statement_line" */
  risolto_statement_line_aggregate: Risolto_Statement_Line_Aggregate;
  /** fetch data from the table: "risolto.statement_line" using primary key columns */
  risolto_statement_line_by_pk?: Maybe<Risolto_Statement_Line>;
  /** fetch data from the table: "risolto.statement_line_dunning_notice" */
  risolto_statement_line_dunning_notice: Array<Risolto_Statement_Line_Dunning_Notice>;
  /** fetch aggregated fields from the table: "risolto.statement_line_dunning_notice" */
  risolto_statement_line_dunning_notice_aggregate: Risolto_Statement_Line_Dunning_Notice_Aggregate;
  /** fetch data from the table: "risolto.statement_line_dunning_notice" using primary key columns */
  risolto_statement_line_dunning_notice_by_pk?: Maybe<Risolto_Statement_Line_Dunning_Notice>;
  /** fetch data from the table in a streaming manner: "risolto.statement_line_dunning_notice" */
  risolto_statement_line_dunning_notice_stream: Array<Risolto_Statement_Line_Dunning_Notice>;
  /** fetch data from the table: "risolto.statement_line_invoice" */
  risolto_statement_line_invoice: Array<Risolto_Statement_Line_Invoice>;
  /** fetch aggregated fields from the table: "risolto.statement_line_invoice" */
  risolto_statement_line_invoice_aggregate: Risolto_Statement_Line_Invoice_Aggregate;
  /** fetch data from the table: "risolto.statement_line_invoice" using primary key columns */
  risolto_statement_line_invoice_by_pk?: Maybe<Risolto_Statement_Line_Invoice>;
  /** fetch data from the table in a streaming manner: "risolto.statement_line_invoice" */
  risolto_statement_line_invoice_stream: Array<Risolto_Statement_Line_Invoice>;
  /** fetch data from the table: "risolto.statement_line_payment_promise" */
  risolto_statement_line_payment_promise: Array<Risolto_Statement_Line_Payment_Promise>;
  /** fetch aggregated fields from the table: "risolto.statement_line_payment_promise" */
  risolto_statement_line_payment_promise_aggregate: Risolto_Statement_Line_Payment_Promise_Aggregate;
  /** fetch data from the table: "risolto.statement_line_payment_promise" using primary key columns */
  risolto_statement_line_payment_promise_by_pk?: Maybe<Risolto_Statement_Line_Payment_Promise>;
  /** fetch data from the table in a streaming manner: "risolto.statement_line_payment_promise" */
  risolto_statement_line_payment_promise_stream: Array<Risolto_Statement_Line_Payment_Promise>;
  /** fetch data from the table: "risolto.statement_line_status" */
  risolto_statement_line_status: Array<Risolto_Statement_Line_Status>;
  /** fetch aggregated fields from the table: "risolto.statement_line_status" */
  risolto_statement_line_status_aggregate: Risolto_Statement_Line_Status_Aggregate;
  /** fetch data from the table: "risolto.statement_line_status" using primary key columns */
  risolto_statement_line_status_by_pk?: Maybe<Risolto_Statement_Line_Status>;
  /** fetch data from the table in a streaming manner: "risolto.statement_line_status" */
  risolto_statement_line_status_stream: Array<Risolto_Statement_Line_Status>;
  /** fetch data from the table in a streaming manner: "risolto.statement_line" */
  risolto_statement_line_stream: Array<Risolto_Statement_Line>;
  /** execute function "risolto.statement_line_structured_match" which returns "risolto.virtual_json" */
  risolto_statement_line_structured_match: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.statement_line_structured_match" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_statement_line_structured_match_aggregate: Risolto_Virtual_Json_Aggregate;
  /** execute function "risolto.statement_line_unstructured_match" which returns "risolto.virtual_json" */
  risolto_statement_line_unstructured_match: Array<Risolto_Virtual_Json>;
  /** execute function "risolto.statement_line_unstructured_match" and query aggregates on result of table type "risolto.virtual_json" */
  risolto_statement_line_unstructured_match_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.statement" */
  risolto_statement_stream: Array<Risolto_Statement>;
  /** fetch data from the table: "risolto.strigil_nbb" */
  risolto_strigil_nbb: Array<Risolto_Strigil_Nbb>;
  /** fetch aggregated fields from the table: "risolto.strigil_nbb" */
  risolto_strigil_nbb_aggregate: Risolto_Strigil_Nbb_Aggregate;
  /** fetch data from the table: "risolto.strigil_nbb" using primary key columns */
  risolto_strigil_nbb_by_pk?: Maybe<Risolto_Strigil_Nbb>;
  /** fetch data from the table: "risolto.strigil_nbb_processing_status" */
  risolto_strigil_nbb_processing_status: Array<Risolto_Strigil_Nbb_Processing_Status>;
  /** fetch aggregated fields from the table: "risolto.strigil_nbb_processing_status" */
  risolto_strigil_nbb_processing_status_aggregate: Risolto_Strigil_Nbb_Processing_Status_Aggregate;
  /** fetch data from the table: "risolto.strigil_nbb_processing_status" using primary key columns */
  risolto_strigil_nbb_processing_status_by_pk?: Maybe<Risolto_Strigil_Nbb_Processing_Status>;
  /** fetch data from the table in a streaming manner: "risolto.strigil_nbb_processing_status" */
  risolto_strigil_nbb_processing_status_stream: Array<Risolto_Strigil_Nbb_Processing_Status>;
  /** fetch data from the table in a streaming manner: "risolto.strigil_nbb" */
  risolto_strigil_nbb_stream: Array<Risolto_Strigil_Nbb>;
  /** fetch data from the table: "risolto.system_integration" */
  risolto_system_integration: Array<Risolto_System_Integration>;
  /** fetch aggregated fields from the table: "risolto.system_integration" */
  risolto_system_integration_aggregate: Risolto_System_Integration_Aggregate;
  /** fetch data from the table: "risolto.system_integration" using primary key columns */
  risolto_system_integration_by_pk?: Maybe<Risolto_System_Integration>;
  /** fetch data from the table in a streaming manner: "risolto.system_integration" */
  risolto_system_integration_stream: Array<Risolto_System_Integration>;
  /** fetch data from the table: "risolto.tag" */
  risolto_tag: Array<Risolto_Tag>;
  /** fetch aggregated fields from the table: "risolto.tag" */
  risolto_tag_aggregate: Risolto_Tag_Aggregate;
  /** fetch data from the table: "risolto.tag" using primary key columns */
  risolto_tag_by_pk?: Maybe<Risolto_Tag>;
  /** fetch data from the table in a streaming manner: "risolto.tag" */
  risolto_tag_stream: Array<Risolto_Tag>;
  /** fetch data from the table: "risolto.task" */
  risolto_task: Array<Risolto_Task>;
  /** fetch aggregated fields from the table: "risolto.task" */
  risolto_task_aggregate: Risolto_Task_Aggregate;
  /** fetch data from the table: "risolto.task" using primary key columns */
  risolto_task_by_pk?: Maybe<Risolto_Task>;
  /** fetch data from the table: "risolto.task_source" */
  risolto_task_source: Array<Risolto_Task_Source>;
  /** fetch aggregated fields from the table: "risolto.task_source" */
  risolto_task_source_aggregate: Risolto_Task_Source_Aggregate;
  /** fetch data from the table: "risolto.task_source" using primary key columns */
  risolto_task_source_by_pk?: Maybe<Risolto_Task_Source>;
  /** fetch data from the table in a streaming manner: "risolto.task_source" */
  risolto_task_source_stream: Array<Risolto_Task_Source>;
  /** fetch data from the table: "risolto.task_status" */
  risolto_task_status: Array<Risolto_Task_Status>;
  /** fetch aggregated fields from the table: "risolto.task_status" */
  risolto_task_status_aggregate: Risolto_Task_Status_Aggregate;
  /** fetch data from the table: "risolto.task_status" using primary key columns */
  risolto_task_status_by_pk?: Maybe<Risolto_Task_Status>;
  /** fetch data from the table in a streaming manner: "risolto.task_status" */
  risolto_task_status_stream: Array<Risolto_Task_Status>;
  /** fetch data from the table in a streaming manner: "risolto.task" */
  risolto_task_stream: Array<Risolto_Task>;
  /** fetch data from the table: "risolto.task_type" */
  risolto_task_type: Array<Risolto_Task_Type>;
  /** fetch aggregated fields from the table: "risolto.task_type" */
  risolto_task_type_aggregate: Risolto_Task_Type_Aggregate;
  /** fetch data from the table: "risolto.task_type" using primary key columns */
  risolto_task_type_by_pk?: Maybe<Risolto_Task_Type>;
  /** fetch data from the table in a streaming manner: "risolto.task_type" */
  risolto_task_type_stream: Array<Risolto_Task_Type>;
  /** fetch data from the table: "risolto.tone_of_voice" */
  risolto_tone_of_voice: Array<Risolto_Tone_Of_Voice>;
  /** fetch aggregated fields from the table: "risolto.tone_of_voice" */
  risolto_tone_of_voice_aggregate: Risolto_Tone_Of_Voice_Aggregate;
  /** fetch data from the table: "risolto.tone_of_voice" using primary key columns */
  risolto_tone_of_voice_by_pk?: Maybe<Risolto_Tone_Of_Voice>;
  /** fetch data from the table in a streaming manner: "risolto.tone_of_voice" */
  risolto_tone_of_voice_stream: Array<Risolto_Tone_Of_Voice>;
  /** fetch data from the table: "risolto.view_action_and_message" */
  risolto_view_action_and_message: Array<Risolto_View_Action_And_Message>;
  /** fetch aggregated fields from the table: "risolto.view_action_and_message" */
  risolto_view_action_and_message_aggregate: Risolto_View_Action_And_Message_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_action_and_message" */
  risolto_view_action_and_message_stream: Array<Risolto_View_Action_And_Message>;
  /** fetch data from the table: "risolto.view_credit_limit" */
  risolto_view_credit_limit: Array<Risolto_View_Credit_Limit>;
  /** fetch aggregated fields from the table: "risolto.view_credit_limit" */
  risolto_view_credit_limit_aggregate: Risolto_View_Credit_Limit_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_credit_limit" */
  risolto_view_credit_limit_stream: Array<Risolto_View_Credit_Limit>;
  /** fetch data from the table: "risolto.view_dashboard_aging_debt" */
  risolto_view_dashboard_aging_debt: Array<Risolto_View_Dashboard_Aging_Debt>;
  /** fetch aggregated fields from the table: "risolto.view_dashboard_aging_debt" */
  risolto_view_dashboard_aging_debt_aggregate: Risolto_View_Dashboard_Aging_Debt_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_dashboard_aging_debt" */
  risolto_view_dashboard_aging_debt_stream: Array<Risolto_View_Dashboard_Aging_Debt>;
  /** fetch data from the table: "risolto.view_dashboard_percentage_paying_within_30_days" */
  risolto_view_dashboard_percentage_paying_within_30_days: Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days>;
  /** fetch aggregated fields from the table: "risolto.view_dashboard_percentage_paying_within_30_days" */
  risolto_view_dashboard_percentage_paying_within_30_days_aggregate: Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_dashboard_percentage_paying_within_30_days" */
  risolto_view_dashboard_percentage_paying_within_30_days_stream: Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days>;
  /** fetch data from the table: "risolto.view_dunning_notice_action_6m" */
  risolto_view_dunning_notice_action_6m: Array<Risolto_View_Dunning_Notice_Action_6m>;
  /** fetch aggregated fields from the table: "risolto.view_dunning_notice_action_6m" */
  risolto_view_dunning_notice_action_6m_aggregate: Risolto_View_Dunning_Notice_Action_6m_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_dunning_notice_action_6m" */
  risolto_view_dunning_notice_action_6m_stream: Array<Risolto_View_Dunning_Notice_Action_6m>;
  /** fetch data from the table: "risolto.view_invoice_features" */
  risolto_view_invoice_features: Array<Risolto_View_Invoice_Features>;
  /** fetch aggregated fields from the table: "risolto.view_invoice_features" */
  risolto_view_invoice_features_aggregate: Risolto_View_Invoice_Features_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_invoice_features" */
  risolto_view_invoice_features_stream: Array<Risolto_View_Invoice_Features>;
  /** fetch data from the table: "risolto.view_legal_entity_template" */
  risolto_view_legal_entity_template: Array<Risolto_View_Legal_Entity_Template>;
  /** fetch aggregated fields from the table: "risolto.view_legal_entity_template" */
  risolto_view_legal_entity_template_aggregate: Risolto_View_Legal_Entity_Template_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_legal_entity_template" */
  risolto_view_legal_entity_template_stream: Array<Risolto_View_Legal_Entity_Template>;
  /** fetch data from the table: "risolto.view_platform_licence_permission" */
  risolto_view_platform_licence_permission: Array<Risolto_View_Platform_Licence_Permission>;
  /** fetch aggregated fields from the table: "risolto.view_platform_licence_permission" */
  risolto_view_platform_licence_permission_aggregate: Risolto_View_Platform_Licence_Permission_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_platform_licence_permission" */
  risolto_view_platform_licence_permission_stream: Array<Risolto_View_Platform_Licence_Permission>;
  /** fetch data from the table: "risolto.view_recipient_tag" */
  risolto_view_recipient_tag: Array<Risolto_View_Recipient_Tag>;
  /** fetch aggregated fields from the table: "risolto.view_recipient_tag" */
  risolto_view_recipient_tag_aggregate: Risolto_View_Recipient_Tag_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.view_recipient_tag" */
  risolto_view_recipient_tag_stream: Array<Risolto_View_Recipient_Tag>;
  /** fetch data from the table: "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note: Array<Risolto_Virtual_Action_And_Note>;
  /** fetch aggregated fields from the table: "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_aggregate: Risolto_Virtual_Action_And_Note_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_and_dispute: Array<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** fetch aggregated fields from the table: "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_and_dispute_aggregate: Risolto_Virtual_Action_And_Note_And_Dispute_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_and_dispute_and_message: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message>;
  /** fetch aggregated fields from the table: "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_and_dispute_and_message_aggregate: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Aggregate;
  /** fetch data from the table in a streaming manner: "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_and_dispute_and_message_stream: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message>;
  /** fetch data from the table: "risolto.virtual_action_and_note_and_dispute" using primary key columns */
  risolto_virtual_action_and_note_and_dispute_by_pk?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_and_dispute_stream: Array<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** fetch data from the table: "risolto.virtual_action_and_note" using primary key columns */
  risolto_virtual_action_and_note_by_pk?: Maybe<Risolto_Virtual_Action_And_Note>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_stream: Array<Risolto_Virtual_Action_And_Note>;
  /** execute function "risolto.virtual_action_and_note_v1" which returns "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_v1: Array<Risolto_Virtual_Action_And_Note>;
  /** execute function "risolto.virtual_action_and_note_v1" and query aggregates on result of table type "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_v1_aggregate: Risolto_Virtual_Action_And_Note_Aggregate;
  /** execute function "risolto.virtual_action_and_note_v3" which returns "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_v3: Array<Risolto_Virtual_Action_And_Note>;
  /** execute function "risolto.virtual_action_and_note_v3" and query aggregates on result of table type "risolto.virtual_action_and_note" */
  risolto_virtual_action_and_note_v3_aggregate: Risolto_Virtual_Action_And_Note_Aggregate;
  /** execute function "risolto.virtual_action_and_note_v4" which returns "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_v4: Array<Risolto_Virtual_Action_And_Note_And_Dispute>;
  /** execute function "risolto.virtual_action_and_note_v4" and query aggregates on result of table type "risolto.virtual_action_and_note_and_dispute" */
  risolto_virtual_action_and_note_v4_aggregate: Risolto_Virtual_Action_And_Note_And_Dispute_Aggregate;
  /** execute function "risolto.virtual_action_and_note_v5" which returns "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_v5: Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message>;
  /** execute function "risolto.virtual_action_and_note_v5" and query aggregates on result of table type "risolto.virtual_action_and_note_and_dispute_and_message" */
  risolto_virtual_action_and_note_v5_aggregate: Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_group" */
  risolto_virtual_action_group: Array<Risolto_Virtual_Action_Group>;
  /** fetch aggregated fields from the table: "risolto.virtual_action_group" */
  risolto_virtual_action_group_aggregate: Risolto_Virtual_Action_Group_Aggregate;
  /** fetch data from the table: "risolto.virtual_action_group" using primary key columns */
  risolto_virtual_action_group_by_pk?: Maybe<Risolto_Virtual_Action_Group>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_action_group" */
  risolto_virtual_action_group_stream: Array<Risolto_Virtual_Action_Group>;
  /** fetch data from the table: "risolto.virtual_dashboard_action_stats" */
  risolto_virtual_dashboard_action_stats: Array<Risolto_Virtual_Dashboard_Action_Stats>;
  /** fetch aggregated fields from the table: "risolto.virtual_dashboard_action_stats" */
  risolto_virtual_dashboard_action_stats_aggregate: Risolto_Virtual_Dashboard_Action_Stats_Aggregate;
  /** fetch data from the table: "risolto.virtual_dashboard_action_stats" using primary key columns */
  risolto_virtual_dashboard_action_stats_by_pk?: Maybe<Risolto_Virtual_Dashboard_Action_Stats>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_dashboard_action_stats" */
  risolto_virtual_dashboard_action_stats_stream: Array<Risolto_Virtual_Dashboard_Action_Stats>;
  /** fetch data from the table: "risolto.virtual_dashboard_outstanding_debt" */
  risolto_virtual_dashboard_outstanding_debt: Array<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** fetch aggregated fields from the table: "risolto.virtual_dashboard_outstanding_debt" */
  risolto_virtual_dashboard_outstanding_debt_aggregate: Risolto_Virtual_Dashboard_Outstanding_Debt_Aggregate;
  /** fetch data from the table: "risolto.virtual_dashboard_outstanding_debt" using primary key columns */
  risolto_virtual_dashboard_outstanding_debt_by_pk?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_dashboard_outstanding_debt" */
  risolto_virtual_dashboard_outstanding_debt_stream: Array<Risolto_Virtual_Dashboard_Outstanding_Debt>;
  /** fetch data from the table: "risolto.virtual_demo_action_report_1" */
  risolto_virtual_demo_action_report_1: Array<Risolto_Virtual_Demo_Action_Report_1>;
  /** fetch aggregated fields from the table: "risolto.virtual_demo_action_report_1" */
  risolto_virtual_demo_action_report_1_aggregate: Risolto_Virtual_Demo_Action_Report_1_Aggregate;
  /** fetch data from the table: "risolto.virtual_demo_action_report_1" using primary key columns */
  risolto_virtual_demo_action_report_1_by_pk?: Maybe<Risolto_Virtual_Demo_Action_Report_1>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_demo_action_report_1" */
  risolto_virtual_demo_action_report_1_stream: Array<Risolto_Virtual_Demo_Action_Report_1>;
  /** fetch data from the table: "risolto.virtual_dunning_action" */
  risolto_virtual_dunning_action: Array<Risolto_Virtual_Dunning_Action>;
  /** fetch aggregated fields from the table: "risolto.virtual_dunning_action" */
  risolto_virtual_dunning_action_aggregate: Risolto_Virtual_Dunning_Action_Aggregate;
  /** fetch data from the table: "risolto.virtual_dunning_action" using primary key columns */
  risolto_virtual_dunning_action_by_pk?: Maybe<Risolto_Virtual_Dunning_Action>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_dunning_action" */
  risolto_virtual_dunning_action_stream: Array<Risolto_Virtual_Dunning_Action>;
  /** fetch data from the table: "risolto.virtual_interchange_event" */
  risolto_virtual_interchange_event: Array<Risolto_Virtual_Interchange_Event>;
  /** fetch aggregated fields from the table: "risolto.virtual_interchange_event" */
  risolto_virtual_interchange_event_aggregate: Risolto_Virtual_Interchange_Event_Aggregate;
  /** fetch data from the table: "risolto.virtual_interchange_event" using primary key columns */
  risolto_virtual_interchange_event_by_pk?: Maybe<Risolto_Virtual_Interchange_Event>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_interchange_event" */
  risolto_virtual_interchange_event_stream: Array<Risolto_Virtual_Interchange_Event>;
  /** fetch data from the table: "risolto.virtual_invoice_derived_payment_information" */
  risolto_virtual_invoice_derived_payment_information: Array<Risolto_Virtual_Invoice_Derived_Payment_Information>;
  /** fetch aggregated fields from the table: "risolto.virtual_invoice_derived_payment_information" */
  risolto_virtual_invoice_derived_payment_information_aggregate: Risolto_Virtual_Invoice_Derived_Payment_Information_Aggregate;
  /** fetch data from the table: "risolto.virtual_invoice_derived_payment_information" using primary key columns */
  risolto_virtual_invoice_derived_payment_information_by_pk?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_invoice_derived_payment_information" */
  risolto_virtual_invoice_derived_payment_information_stream: Array<Risolto_Virtual_Invoice_Derived_Payment_Information>;
  /** fetch data from the table: "risolto.virtual_invoicing_channel_endpoint" */
  risolto_virtual_invoicing_channel_endpoint: Array<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** fetch aggregated fields from the table: "risolto.virtual_invoicing_channel_endpoint" */
  risolto_virtual_invoicing_channel_endpoint_aggregate: Risolto_Virtual_Invoicing_Channel_Endpoint_Aggregate;
  /** fetch data from the table: "risolto.virtual_invoicing_channel_endpoint" using primary key columns */
  risolto_virtual_invoicing_channel_endpoint_by_pk?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_invoicing_channel_endpoint" */
  risolto_virtual_invoicing_channel_endpoint_stream: Array<Risolto_Virtual_Invoicing_Channel_Endpoint>;
  /** fetch data from the table: "risolto.virtual_json" */
  risolto_virtual_json: Array<Risolto_Virtual_Json>;
  /** fetch aggregated fields from the table: "risolto.virtual_json" */
  risolto_virtual_json_aggregate: Risolto_Virtual_Json_Aggregate;
  /** fetch data from the table: "risolto.virtual_json" using primary key columns */
  risolto_virtual_json_by_pk?: Maybe<Risolto_Virtual_Json>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_json" */
  risolto_virtual_json_stream: Array<Risolto_Virtual_Json>;
  /** fetch data from the table: "risolto.virtual_report_delivery" */
  risolto_virtual_report_delivery: Array<Risolto_Virtual_Report_Delivery>;
  /** fetch aggregated fields from the table: "risolto.virtual_report_delivery" */
  risolto_virtual_report_delivery_aggregate: Risolto_Virtual_Report_Delivery_Aggregate;
  /** fetch data from the table: "risolto.virtual_report_delivery" using primary key columns */
  risolto_virtual_report_delivery_by_pk?: Maybe<Risolto_Virtual_Report_Delivery>;
  /** fetch data from the table in a streaming manner: "risolto.virtual_report_delivery" */
  risolto_virtual_report_delivery_stream: Array<Risolto_Virtual_Report_Delivery>;
  /** fetch data from the table: "risolto.webhook" */
  risolto_webhook: Array<Risolto_Webhook>;
  /** fetch aggregated fields from the table: "risolto.webhook" */
  risolto_webhook_aggregate: Risolto_Webhook_Aggregate;
  /** fetch data from the table: "risolto.webhook" using primary key columns */
  risolto_webhook_by_pk?: Maybe<Risolto_Webhook>;
  /** fetch data from the table: "risolto.webhook_processing_status" */
  risolto_webhook_processing_status: Array<Risolto_Webhook_Processing_Status>;
  /** fetch aggregated fields from the table: "risolto.webhook_processing_status" */
  risolto_webhook_processing_status_aggregate: Risolto_Webhook_Processing_Status_Aggregate;
  /** fetch data from the table: "risolto.webhook_processing_status" using primary key columns */
  risolto_webhook_processing_status_by_pk?: Maybe<Risolto_Webhook_Processing_Status>;
  /** fetch data from the table in a streaming manner: "risolto.webhook_processing_status" */
  risolto_webhook_processing_status_stream: Array<Risolto_Webhook_Processing_Status>;
  /** fetch data from the table in a streaming manner: "risolto.webhook" */
  risolto_webhook_stream: Array<Risolto_Webhook>;
  /** fetch data from the table: "risolto.webhook_subscription" */
  risolto_webhook_subscription: Array<Risolto_Webhook_Subscription>;
  /** fetch aggregated fields from the table: "risolto.webhook_subscription" */
  risolto_webhook_subscription_aggregate: Risolto_Webhook_Subscription_Aggregate;
  /** fetch data from the table: "risolto.webhook_subscription" using primary key columns */
  risolto_webhook_subscription_by_pk?: Maybe<Risolto_Webhook_Subscription>;
  /** fetch data from the table in a streaming manner: "risolto.webhook_subscription" */
  risolto_webhook_subscription_stream: Array<Risolto_Webhook_Subscription>;
};


export type Subscription_RootRisolto_Account_Number_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Account_Number_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Account_Number_Type_Order_By>>;
  where?: Maybe<Risolto_Account_Number_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Account_Number_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Account_Number_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Account_Number_Type_Order_By>>;
  where?: Maybe<Risolto_Account_Number_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Account_Number_Type_By_PkArgs = {
  account_number_type: Scalars['String'];
};


export type Subscription_RootRisolto_Account_Number_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Account_Number_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Account_Number_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Accounting_DocumentArgs = {
  distinct_on?: Maybe<Array<Risolto_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Accounting_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Accounting_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Accounting_Document_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Accounting_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_ActionArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Order_By>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Action_Execution_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Execution_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Execution_Type_Order_By>>;
  where?: Maybe<Risolto_Action_Execution_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Execution_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Execution_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Execution_Type_Order_By>>;
  where?: Maybe<Risolto_Action_Execution_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Execution_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootRisolto_Action_Execution_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Action_Execution_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Action_Execution_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V10Args = {
  args: Risolto_Action_Group_V10_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V10_AggregateArgs = {
  args: Risolto_Action_Group_V10_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V11Args = {
  args: Risolto_Action_Group_V11_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V11_AggregateArgs = {
  args: Risolto_Action_Group_V11_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V12Args = {
  args: Risolto_Action_Group_V12_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V12_AggregateArgs = {
  args: Risolto_Action_Group_V12_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V2Args = {
  args: Risolto_Action_Group_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V2_AggregateArgs = {
  args: Risolto_Action_Group_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V5Args = {
  args: Risolto_Action_Group_V5_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V5_AggregateArgs = {
  args: Risolto_Action_Group_V5_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V6Args = {
  args: Risolto_Action_Group_V6_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V6_AggregateArgs = {
  args: Risolto_Action_Group_V6_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V7Args = {
  args: Risolto_Action_Group_V7_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V7_AggregateArgs = {
  args: Risolto_Action_Group_V7_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V8Args = {
  args: Risolto_Action_Group_V8_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V8_AggregateArgs = {
  args: Risolto_Action_Group_V8_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V9Args = {
  args: Risolto_Action_Group_V9_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Group_V9_AggregateArgs = {
  args: Risolto_Action_Group_V9_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_InterchangeArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Interchange_Order_By>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Interchange_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Interchange_Order_By>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Interchange_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Action_Interchange_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Action_Interchange_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Action_Interchange_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Invoice_Order_By>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Invoice_Order_By>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Action_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Action_Invoice_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Action_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_SourceArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Source_Order_By>>;
  where?: Maybe<Risolto_Action_Source_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Source_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Source_Order_By>>;
  where?: Maybe<Risolto_Action_Source_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Source_By_PkArgs = {
  source: Scalars['String'];
};


export type Subscription_RootRisolto_Action_Source_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Action_Source_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Action_Source_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Status_Order_By>>;
  where?: Maybe<Risolto_Action_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Action_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Action_Status_Order_By>>;
  where?: Maybe<Risolto_Action_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootRisolto_Action_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Action_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Action_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Action_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Action_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Action_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Company_ScoreArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Company_Score_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Company_Score_Order_By>>;
  where?: Maybe<Risolto_Analytics_Company_Score_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Company_Score_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Company_Score_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Company_Score_Order_By>>;
  where?: Maybe<Risolto_Analytics_Company_Score_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Company_Score_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Analytics_Company_Score_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Analytics_Company_Score_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Analytics_Company_Score_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Invoice_FeaturesArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Invoice_Features_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Invoice_Features_By_DateArgs = {
  args: Risolto_Analytics_Invoice_Features_By_Date_Args;
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Invoice_Features_By_Date_AggregateArgs = {
  args: Risolto_Analytics_Invoice_Features_By_Date_Args;
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Invoice_Features_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Analytics_Invoice_Features_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Analytics_Invoice_Features_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Analytics_Invoice_Features_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Invoice_PredictionArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Invoice_Prediction_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Invoice_Prediction_Order_By>>;
  where?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Invoice_Prediction_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Analytics_Invoice_Prediction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Analytics_Invoice_Prediction_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Analytics_Invoice_Prediction_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_TestArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Test_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Test_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Analytics_Test_ResultArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Result_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Result_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Test_Result_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Analytics_Test_Result_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Analytics_Test_Result_Order_By>>;
  where?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Test_Result_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Analytics_Test_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Analytics_Test_Result_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Analytics_Test_Result_Bool_Exp>;
};


export type Subscription_RootRisolto_Analytics_Test_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Analytics_Test_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Analytics_Test_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Accounting_DocumentArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Api_Accounting_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Accounting_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Accounting_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Accounting_Document_Order_By>>;
  where?: Maybe<Risolto_Api_Accounting_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Accounting_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Api_Accounting_Document_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Api_Accounting_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_App_ClientArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Api_App_Client_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_App_Client_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Api_App_Client_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_App_Client_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Api_App_Client_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Api_App_Client_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Api_App_Client_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Payment_PlanArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Plan_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Payment_Plan_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Plan_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Payment_Plan_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Api_Payment_Plan_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Api_Payment_Plan_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Payment_PromiseArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Payment_Promise_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Api_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Api_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Api_Payment_Promise_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Api_Payment_Promise_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Api_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Attachment_Order_By>>;
  where?: Maybe<Risolto_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Attachment_Order_By>>;
  where?: Maybe<Risolto_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Attachment_SchemeArgs = {
  distinct_on?: Maybe<Array<Risolto_Attachment_Scheme_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Attachment_Scheme_Order_By>>;
  where?: Maybe<Risolto_Attachment_Scheme_Bool_Exp>;
};


export type Subscription_RootRisolto_Attachment_Scheme_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Attachment_Scheme_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Attachment_Scheme_Order_By>>;
  where?: Maybe<Risolto_Attachment_Scheme_Bool_Exp>;
};


export type Subscription_RootRisolto_Attachment_Scheme_By_PkArgs = {
  scheme: Scalars['String'];
};


export type Subscription_RootRisolto_Attachment_Scheme_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Attachment_Scheme_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Attachment_Scheme_Bool_Exp>;
};


export type Subscription_RootRisolto_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Attachment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Bank_AccountArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Account_Order_By>>;
  where?: Maybe<Risolto_Bank_Account_Bool_Exp>;
};


export type Subscription_RootRisolto_Bank_Account_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Account_Order_By>>;
  where?: Maybe<Risolto_Bank_Account_Bool_Exp>;
};


export type Subscription_RootRisolto_Bank_Account_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Bank_Account_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Bank_Account_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Bank_Account_Bool_Exp>;
};


export type Subscription_RootRisolto_Bank_Identifier_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Identifier_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Identifier_Type_Order_By>>;
  where?: Maybe<Risolto_Bank_Identifier_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Bank_Identifier_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Bank_Identifier_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Bank_Identifier_Type_Order_By>>;
  where?: Maybe<Risolto_Bank_Identifier_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Bank_Identifier_Type_By_PkArgs = {
  bank_identifier_type: Scalars['String'];
};


export type Subscription_RootRisolto_Bank_Identifier_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Bank_Identifier_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Bank_Identifier_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_BlacklistArgs = {
  distinct_on?: Maybe<Array<Risolto_Blacklist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Blacklist_Order_By>>;
  where?: Maybe<Risolto_Blacklist_Bool_Exp>;
};


export type Subscription_RootRisolto_Blacklist_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Blacklist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Blacklist_Order_By>>;
  where?: Maybe<Risolto_Blacklist_Bool_Exp>;
};


export type Subscription_RootRisolto_Blacklist_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Blacklist_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Blacklist_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Blacklist_Bool_Exp>;
};


export type Subscription_RootRisolto_ChannelArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Order_By>>;
  where?: Maybe<Risolto_Channel_Bool_Exp>;
};


export type Subscription_RootRisolto_Channel_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Order_By>>;
  where?: Maybe<Risolto_Channel_Bool_Exp>;
};


export type Subscription_RootRisolto_Channel_By_PkArgs = {
  channel: Scalars['String'];
};


export type Subscription_RootRisolto_Channel_EndpointArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Channel_Endpoint_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Channel_Endpoint_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Channel_Endpoint_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Channel_Endpoint_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Channel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Channel_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Channel_Bool_Exp>;
};


export type Subscription_RootRisolto_Clid2recidArgs = {
  args: Risolto_Clid2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Clid2recid_AggregateArgs = {
  args: Risolto_Clid2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Clip2recidArgs = {
  args: Risolto_Clip2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Clip2recid_AggregateArgs = {
  args: Risolto_Clip2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_CommunicationArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Order_By>>;
  where?: Maybe<Risolto_Communication_Bool_Exp>;
};


export type Subscription_RootRisolto_Communication_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Order_By>>;
  where?: Maybe<Risolto_Communication_Bool_Exp>;
};


export type Subscription_RootRisolto_Communication_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Communication_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Communication_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Communication_Bool_Exp>;
};


export type Subscription_RootRisolto_Communication_TemplateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Bool_Exp>;
};


export type Subscription_RootRisolto_Communication_Template_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Bool_Exp>;
};


export type Subscription_RootRisolto_Communication_Template_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Communication_Template_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Communication_Template_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Communication_Template_Bool_Exp>;
};


export type Subscription_RootRisolto_Communication_Template_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Type_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Communication_Template_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Communication_Template_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Communication_Template_Type_Order_By>>;
  where?: Maybe<Risolto_Communication_Template_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Communication_Template_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootRisolto_Communication_Template_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Communication_Template_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Communication_Template_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_ContactArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Order_By>>;
  where?: Maybe<Risolto_Contact_Bool_Exp>;
};


export type Subscription_RootRisolto_Contact_AddressArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Address_Order_By>>;
  where?: Maybe<Risolto_Contact_Address_Bool_Exp>;
};


export type Subscription_RootRisolto_Contact_Address_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Address_Order_By>>;
  where?: Maybe<Risolto_Contact_Address_Bool_Exp>;
};


export type Subscription_RootRisolto_Contact_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Contact_Address_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Contact_Address_Bool_Exp>;
};


export type Subscription_RootRisolto_Contact_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Order_By>>;
  where?: Maybe<Risolto_Contact_Bool_Exp>;
};


export type Subscription_RootRisolto_Contact_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Contact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Contact_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Contact_Bool_Exp>;
};


export type Subscription_RootRisolto_Contact_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Type_Order_By>>;
  where?: Maybe<Risolto_Contact_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Contact_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Contact_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Contact_Type_Order_By>>;
  where?: Maybe<Risolto_Contact_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Contact_Type_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Contact_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Contact_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Contact_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Content_DispositionArgs = {
  distinct_on?: Maybe<Array<Risolto_Content_Disposition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Content_Disposition_Order_By>>;
  where?: Maybe<Risolto_Content_Disposition_Bool_Exp>;
};


export type Subscription_RootRisolto_Content_Disposition_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Content_Disposition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Content_Disposition_Order_By>>;
  where?: Maybe<Risolto_Content_Disposition_Bool_Exp>;
};


export type Subscription_RootRisolto_Content_Disposition_By_PkArgs = {
  content_disposition: Scalars['String'];
};


export type Subscription_RootRisolto_Content_Disposition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Content_Disposition_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Content_Disposition_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_LimitArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_Limit_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_Limit_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Credit_Limit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Credit_Limit_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Credit_Limit_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_Note_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Attachment_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_Note_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Credit_Note_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Credit_Note_Attachment_Order_By>>;
  where?: Maybe<Risolto_Credit_Note_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_Note_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Credit_Note_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Credit_Note_Attachment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Credit_Note_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Credit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Credit_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Credit_Note_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Credit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_CurrencyArgs = {
  distinct_on?: Maybe<Array<Risolto_Currency_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Currency_Order_By>>;
  where?: Maybe<Risolto_Currency_Bool_Exp>;
};


export type Subscription_RootRisolto_Currency_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Currency_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Currency_Order_By>>;
  where?: Maybe<Risolto_Currency_Bool_Exp>;
};


export type Subscription_RootRisolto_Currency_By_PkArgs = {
  currency: Scalars['String'];
};


export type Subscription_RootRisolto_Currency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Currency_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Currency_Bool_Exp>;
};


export type Subscription_RootRisolto_Dashboard_Actions_By_Channel_And_Status_Count_V1Args = {
  args: Risolto_Dashboard_Actions_By_Channel_And_Status_Count_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Subscription_RootRisolto_Dashboard_Actions_By_Channel_And_Status_Count_V1_AggregateArgs = {
  args: Risolto_Dashboard_Actions_By_Channel_And_Status_Count_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Subscription_RootRisolto_Dashboard_Outstanding_DebtArgs = {
  args: Risolto_Dashboard_Outstanding_Debt_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Subscription_RootRisolto_Dashboard_Outstanding_Debt_AggregateArgs = {
  args: Risolto_Dashboard_Outstanding_Debt_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Subscription_RootRisolto_Dashboard_TotalsArgs = {
  args: Risolto_Dashboard_Totals_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Dashboard_Totals_AggregateArgs = {
  args: Risolto_Dashboard_Totals_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Dashboard_Totals_V2Args = {
  args: Risolto_Dashboard_Totals_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Dashboard_Totals_V2_AggregateArgs = {
  args: Risolto_Dashboard_Totals_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Debit_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Debit_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Debit_Note_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Attachment_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Debit_Note_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Debit_Note_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Debit_Note_Attachment_Order_By>>;
  where?: Maybe<Risolto_Debit_Note_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Debit_Note_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Debit_Note_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Debit_Note_Attachment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Debit_Note_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Debit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Debit_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Debit_Note_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Debit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Demo_Action_Report_1_V1Args = {
  args: Risolto_Demo_Action_Report_1_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Order_By>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Subscription_RootRisolto_Demo_Action_Report_1_V1_AggregateArgs = {
  args: Risolto_Demo_Action_Report_1_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Order_By>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_MandateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Mandate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Mandate_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Mandate_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Mandate_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Mandate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Mandate_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Mandate_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Mandate_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Direct_Debit_Mandate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Direct_Debit_Mandate_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Direct_Debit_Mandate_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_ProviderArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Provider_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Provider_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Provider_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Provider_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Provider_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Provider_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Provider_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Provider_By_PkArgs = {
  provider: Scalars['String'];
};


export type Subscription_RootRisolto_Direct_Debit_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Direct_Debit_Provider_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Direct_Debit_Provider_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_SchemeArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Scheme_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Scheme_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Scheme_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Scheme_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Scheme_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Scheme_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Scheme_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Scheme_By_PkArgs = {
  scheme: Scalars['String'];
};


export type Subscription_RootRisolto_Direct_Debit_Scheme_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Direct_Debit_Scheme_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Direct_Debit_Scheme_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Sequence_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Sequence_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Sequence_Type_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Sequence_Type_By_PkArgs = {
  sequence_type: Scalars['String'];
};


export type Subscription_RootRisolto_Direct_Debit_Sequence_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Direct_Debit_Sequence_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Direct_Debit_Sequence_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_TransactionArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Transaction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Transaction_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Transaction_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Transaction_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Direct_Debit_Transaction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Direct_Debit_Transaction_Order_By>>;
  where?: Maybe<Risolto_Direct_Debit_Transaction_Bool_Exp>;
};


export type Subscription_RootRisolto_Direct_Debit_Transaction_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Direct_Debit_Transaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Direct_Debit_Transaction_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Direct_Debit_Transaction_Bool_Exp>;
};


export type Subscription_RootRisolto_Dispute_CodeArgs = {
  distinct_on?: Maybe<Array<Risolto_Dispute_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dispute_Code_Order_By>>;
  where?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Dispute_Code_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dispute_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dispute_Code_Order_By>>;
  where?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Dispute_Code_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Dispute_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Dispute_Code_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Dispute_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Attachment_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Attachment_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Attachment_Type_Order_By>>;
  where?: Maybe<Risolto_Document_Attachment_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Attachment_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Attachment_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Attachment_Type_Order_By>>;
  where?: Maybe<Risolto_Document_Attachment_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Attachment_Type_By_PkArgs = {
  attachment_type: Scalars['String'];
};


export type Subscription_RootRisolto_Document_Attachment_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Document_Attachment_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Document_Attachment_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_InterchangeArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Attachment_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Attachment_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Document_Interchange_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Document_Interchange_Attachment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Document_Interchange_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Document_Interchange_DirectionArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Direction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Direction_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Direction_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_Direction_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Direction_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Direction_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Direction_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_Direction_By_PkArgs = {
  direction: Scalars['String'];
};


export type Subscription_RootRisolto_Document_Interchange_Direction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Document_Interchange_Direction_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Document_Interchange_Direction_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_EventArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_Event_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_Event_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Document_Interchange_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Document_Interchange_Event_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Document_Interchange_Event_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_LinkArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_Link_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Document_Interchange_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Document_Interchange_Link_Order_By>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_Link_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Document_Interchange_Link_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Document_Interchange_Link_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Document_Interchange_Link_Bool_Exp>;
};


export type Subscription_RootRisolto_Document_Interchange_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Document_Interchange_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Document_Interchange_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_NoticeArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Dunning_Notice_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Dunning_Notice_Invoice_RelationArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Invoice_Relation_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Invoice_Relation_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Invoice_Relation_By_PkArgs = {
  relation: Scalars['String'];
};


export type Subscription_RootRisolto_Dunning_Notice_Invoice_Relation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Dunning_Notice_Invoice_Relation_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Relation_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Dunning_Notice_Invoice_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Dunning_Notice_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Status_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Status_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootRisolto_Dunning_Notice_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Dunning_Notice_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Dunning_Notice_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Dunning_Notice_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Dunning_Notice_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Type_CodeArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Type_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Type_Code_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Dunning_Notice_Type_Code_Order_By>>;
  where?: Maybe<Risolto_Dunning_Notice_Type_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Dunning_Notice_Type_Code_By_PkArgs = {
  type_code: Scalars['String'];
};


export type Subscription_RootRisolto_Dunning_Notice_Type_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Dunning_Notice_Type_Code_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Dunning_Notice_Type_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Fe_Recipient_Accounting_DocumentArgs = {
  args: Risolto_Fe_Recipient_Accounting_Document_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Fe_Recipient_Accounting_Document_AggregateArgs = {
  args: Risolto_Fe_Recipient_Accounting_Document_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_FrequencyArgs = {
  distinct_on?: Maybe<Array<Risolto_Frequency_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Frequency_Order_By>>;
  where?: Maybe<Risolto_Frequency_Bool_Exp>;
};


export type Subscription_RootRisolto_Frequency_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Frequency_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Frequency_Order_By>>;
  where?: Maybe<Risolto_Frequency_Bool_Exp>;
};


export type Subscription_RootRisolto_Frequency_By_PkArgs = {
  frequency: Scalars['String'];
};


export type Subscription_RootRisolto_Frequency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Frequency_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Frequency_Bool_Exp>;
};


export type Subscription_RootRisolto_Grant_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Grant_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Grant_Type_Order_By>>;
  where?: Maybe<Risolto_Grant_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Grant_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Grant_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Grant_Type_Order_By>>;
  where?: Maybe<Risolto_Grant_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Grant_Type_By_PkArgs = {
  grant_type: Scalars['String'];
};


export type Subscription_RootRisolto_Grant_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Grant_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Grant_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Hohr_Cvt_List_DataArgs = {
  args: Risolto_Hohr_Cvt_List_Data_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Hohr_Cvt_List_Data_AggregateArgs = {
  args: Risolto_Hohr_Cvt_List_Data_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_CollectionArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Collection_Order_By>>;
  where?: Maybe<Risolto_Invoice_Collection_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Collection_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Collection_Order_By>>;
  where?: Maybe<Risolto_Invoice_Collection_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Collection_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Collection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Collection_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Collection_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_DisputeArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Dispute_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Dispute_Order_By>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Dispute_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Dispute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Dispute_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Dispute_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_DocumentArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Attachment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Attachment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Document_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Document_Attachment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Document_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Document_Details_SearchArgs = {
  args: Risolto_Invoice_Document_Details_Search_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Details_Search10Args = {
  args: Risolto_Invoice_Document_Details_Search10_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Details_Search100Args = {
  args: Risolto_Invoice_Document_Details_Search100_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Details_Search100_AggregateArgs = {
  args: Risolto_Invoice_Document_Details_Search100_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Details_Search10_AggregateArgs = {
  args: Risolto_Invoice_Document_Details_Search10_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Details_Search_AggregateArgs = {
  args: Risolto_Invoice_Document_Details_Search_Args;
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Status_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Document_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Document_Status_Order_By>>;
  where?: Maybe<Risolto_Invoice_Document_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootRisolto_Invoice_Document_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Document_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Document_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Document_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_GroupArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Group_Credit_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Credit_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Credit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Credit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Group_Credit_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Group_Credit_Note_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Group_Credit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Debit_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Debit_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Debit_Note_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Debit_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Group_Debit_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Group_Debit_Note_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Group_Debit_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Dunning_RunArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Dunning_Run_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Group_Dunning_Run_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Group_Dunning_Run_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Group_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Invoice_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Group_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Group_Invoice_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Group_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_PaymentArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Payment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Group_Payment_PromiseArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Payment_Promise_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Invoice_Group_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Invoice_Group_Payment_Promise_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Group_Payment_Promise_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_Payment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Group_Payment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Group_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoice_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Invoice_Group_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Invoice_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoicing_Channel_Endpoints_V1Args = {
  args: Risolto_Invoicing_Channel_Endpoints_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoicing_Channel_Endpoints_V1_AggregateArgs = {
  args: Risolto_Invoicing_Channel_Endpoints_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoicing_Channel_Endpoints_V2Args = {
  args: Risolto_Invoicing_Channel_Endpoints_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Invoicing_Channel_Endpoints_V2_AggregateArgs = {
  args: Risolto_Invoicing_Channel_Endpoints_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Iso_Country_CodeArgs = {
  distinct_on?: Maybe<Array<Risolto_Iso_Country_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Iso_Country_Code_Order_By>>;
  where?: Maybe<Risolto_Iso_Country_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Iso_Country_Code_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Iso_Country_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Iso_Country_Code_Order_By>>;
  where?: Maybe<Risolto_Iso_Country_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Iso_Country_Code_By_PkArgs = {
  country_code: Scalars['String'];
};


export type Subscription_RootRisolto_Iso_Country_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Iso_Country_Code_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Iso_Country_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_JobArgs = {
  distinct_on?: Maybe<Array<Risolto_Job_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Job_Order_By>>;
  where?: Maybe<Risolto_Job_Bool_Exp>;
};


export type Subscription_RootRisolto_Job_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Job_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Job_Order_By>>;
  where?: Maybe<Risolto_Job_Bool_Exp>;
};


export type Subscription_RootRisolto_Job_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Job_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Job_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Job_Bool_Exp>;
};


export type Subscription_RootRisolto_Language_CodeArgs = {
  distinct_on?: Maybe<Array<Risolto_Language_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Language_Code_Order_By>>;
  where?: Maybe<Risolto_Language_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Language_Code_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Language_Code_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Language_Code_Order_By>>;
  where?: Maybe<Risolto_Language_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Language_Code_By_PkArgs = {
  language_code: Scalars['String'];
};


export type Subscription_RootRisolto_Language_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Language_Code_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Language_Code_Bool_Exp>;
};


export type Subscription_RootRisolto_Legal_EntityArgs = {
  distinct_on?: Maybe<Array<Risolto_Legal_Entity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Legal_Entity_Order_By>>;
  where?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
};


export type Subscription_RootRisolto_Legal_Entity_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Legal_Entity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Legal_Entity_Order_By>>;
  where?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
};


export type Subscription_RootRisolto_Legal_Entity_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Legal_Entity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Legal_Entity_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Legal_Entity_Bool_Exp>;
};


export type Subscription_RootRisolto_LocaleArgs = {
  distinct_on?: Maybe<Array<Risolto_Locale_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Locale_Order_By>>;
  where?: Maybe<Risolto_Locale_Bool_Exp>;
};


export type Subscription_RootRisolto_Locale_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Locale_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Locale_Order_By>>;
  where?: Maybe<Risolto_Locale_Bool_Exp>;
};


export type Subscription_RootRisolto_Locale_By_PkArgs = {
  locale: Scalars['String'];
};


export type Subscription_RootRisolto_Locale_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Locale_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Locale_Bool_Exp>;
};


export type Subscription_RootRisolto_Magda_CacheArgs = {
  distinct_on?: Maybe<Array<Risolto_Magda_Cache_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Magda_Cache_Order_By>>;
  where?: Maybe<Risolto_Magda_Cache_Bool_Exp>;
};


export type Subscription_RootRisolto_Magda_Cache_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Magda_Cache_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Magda_Cache_Order_By>>;
  where?: Maybe<Risolto_Magda_Cache_Bool_Exp>;
};


export type Subscription_RootRisolto_Magda_Cache_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Magda_Cache_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Magda_Cache_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Magda_Cache_Bool_Exp>;
};


export type Subscription_RootRisolto_Magda_Service_Audit_LogArgs = {
  distinct_on?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Order_By>>;
  where?: Maybe<Risolto_Magda_Service_Audit_Log_Bool_Exp>;
};


export type Subscription_RootRisolto_Magda_Service_Audit_Log_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Magda_Service_Audit_Log_Order_By>>;
  where?: Maybe<Risolto_Magda_Service_Audit_Log_Bool_Exp>;
};


export type Subscription_RootRisolto_Magda_Service_Audit_Log_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Magda_Service_Audit_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Magda_Service_Audit_Log_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Magda_Service_Audit_Log_Bool_Exp>;
};


export type Subscription_RootRisolto_Mailbox_Actions_And_MessagesArgs = {
  args: Risolto_Mailbox_Actions_And_Messages_Args;
  distinct_on?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Action_And_Message_Order_By>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Mailbox_Actions_And_Messages_AggregateArgs = {
  args: Risolto_Mailbox_Actions_And_Messages_Args;
  distinct_on?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Action_And_Message_Order_By>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Materialized_View_DefinitionArgs = {
  distinct_on?: Maybe<Array<Risolto_Materialized_View_Definition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Materialized_View_Definition_Order_By>>;
  where?: Maybe<Risolto_Materialized_View_Definition_Bool_Exp>;
};


export type Subscription_RootRisolto_Materialized_View_Definition_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Materialized_View_Definition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Materialized_View_Definition_Order_By>>;
  where?: Maybe<Risolto_Materialized_View_Definition_Bool_Exp>;
};


export type Subscription_RootRisolto_Materialized_View_Definition_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Materialized_View_Definition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Materialized_View_Definition_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Materialized_View_Definition_Bool_Exp>;
};


export type Subscription_RootRisolto_MessageArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Order_By>>;
  where?: Maybe<Risolto_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Order_By>>;
  where?: Maybe<Risolto_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_AssigneeArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Assignee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Assignee_Order_By>>;
  where?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Assignee_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Assignee_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Assignee_Order_By>>;
  where?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Assignee_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Message_Assignee_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Message_Assignee_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Message_Assignee_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Attachment_Order_By>>;
  where?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Attachment_Order_By>>;
  where?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Message_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Message_Attachment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Message_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Message_LabelArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Label_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Label_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Label_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Label_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Message_Label_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Message_Label_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Message_Label_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Message_LabelArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Message_Label_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Message_Label_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Message_Label_Order_By>>;
  where?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Message_Label_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Message_Message_Label_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Message_Message_Label_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Message_Message_Label_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_RecipientArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Recipient_Order_By>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Recipient_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Message_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Message_Recipient_Order_By>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_Recipient_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Message_Recipient_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Message_Recipient_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Message_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Message_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Mime_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Mime_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Mime_Type_Order_By>>;
  where?: Maybe<Risolto_Mime_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Mime_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Mime_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Mime_Type_Order_By>>;
  where?: Maybe<Risolto_Mime_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Mime_Type_By_PkArgs = {
  mime_type: Scalars['String'];
};


export type Subscription_RootRisolto_Mime_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Mime_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Mime_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Order_By>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Note_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Note_CategoryArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Category_Order_By>>;
  where?: Maybe<Risolto_Note_Category_Bool_Exp>;
};


export type Subscription_RootRisolto_Note_Category_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Category_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Category_Order_By>>;
  where?: Maybe<Risolto_Note_Category_Bool_Exp>;
};


export type Subscription_RootRisolto_Note_Category_By_PkArgs = {
  category: Scalars['String'];
};


export type Subscription_RootRisolto_Note_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Note_Category_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Note_Category_Bool_Exp>;
};


export type Subscription_RootRisolto_Note_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Invoice_Order_By>>;
  where?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Note_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Note_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Note_Invoice_Order_By>>;
  where?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Note_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Note_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Note_Invoice_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Note_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Note_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Open_BalanceArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Bool_Exp>;
};


export type Subscription_RootRisolto_Open_Balance_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Bool_Exp>;
};


export type Subscription_RootRisolto_Open_Balance_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Open_Balance_RecordArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


export type Subscription_RootRisolto_Open_Balance_Record_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Open_Balance_Record_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Open_Balance_Record_Order_By>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


export type Subscription_RootRisolto_Open_Balance_Record_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Open_Balance_Record_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Open_Balance_Record_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Open_Balance_Record_Bool_Exp>;
};


export type Subscription_RootRisolto_Open_Balance_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Open_Balance_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Open_Balance_Bool_Exp>;
};


export type Subscription_RootRisolto_OriginArgs = {
  distinct_on?: Maybe<Array<Risolto_Origin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Origin_Order_By>>;
  where?: Maybe<Risolto_Origin_Bool_Exp>;
};


export type Subscription_RootRisolto_Origin_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Origin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Origin_Order_By>>;
  where?: Maybe<Risolto_Origin_Bool_Exp>;
};


export type Subscription_RootRisolto_Origin_By_PkArgs = {
  origin: Scalars['String'];
};


export type Subscription_RootRisolto_Origin_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Origin_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Origin_Bool_Exp>;
};


export type Subscription_RootRisolto_ParticipantArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Order_By>>;
  where?: Maybe<Risolto_Participant_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Order_By>>;
  where?: Maybe<Risolto_Participant_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_Api_App_ClientArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_Api_App_Client_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Api_App_Client_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Api_App_Client_Order_By>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_Api_App_Client_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Participant_Api_App_Client_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Participant_Api_App_Client_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Participant_Api_App_Client_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Participant_Dunning_RunArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_Dunning_Run_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Participant_Dunning_Run_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Participant_Dunning_Run_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Participant_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Participant_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Participant_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_UserArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Participant_User_RoleArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Role_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_User_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Participant_User_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Participant_User_Role_Order_By>>;
  where?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_User_Role_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Participant_User_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Participant_User_Role_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Participant_User_Role_Bool_Exp>;
};


export type Subscription_RootRisolto_Participant_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Participant_User_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Participant_User_Bool_Exp>;
};


export type Subscription_RootRisolto_PaymentArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Payment_DocumentArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Document_Order_By>>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Document_Order_By>>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Document_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Payment_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Document_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Document_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_LinkArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Link_Order_By>>;
  where?: Maybe<Risolto_Payment_Link_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Link_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Link_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Link_Order_By>>;
  where?: Maybe<Risolto_Payment_Link_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Link_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Payment_Link_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Link_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Link_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_PlanArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Plan_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Plan_Order_By>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Plan_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Payment_Plan_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Plan_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Plan_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_PromiseArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Promise_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Payment_Promise_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Promise_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_TransferArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Bulk_PaymentArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Bulk_Payment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Bulk_Payment_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Bulk_Payment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Payment_Transfer_Bulk_Payment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Transfer_Bulk_Payment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Transfer_Bulk_Payment_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Payment_Transfer_LineArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Line_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Line_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Payment_Transfer_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Transfer_Line_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Line_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Line_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Line_Type_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Line_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootRisolto_Payment_Transfer_Line_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Transfer_Line_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Transfer_Line_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Status_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Payment_Transfer_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Payment_Transfer_Status_Order_By>>;
  where?: Maybe<Risolto_Payment_Transfer_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootRisolto_Payment_Transfer_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Transfer_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Transfer_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Payment_Transfer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Payment_Transfer_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Payment_Transfer_Bool_Exp>;
};


export type Subscription_RootRisolto_PersonArgs = {
  distinct_on?: Maybe<Array<Risolto_Person_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Person_Order_By>>;
  where?: Maybe<Risolto_Person_Bool_Exp>;
};


export type Subscription_RootRisolto_Person_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Person_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Person_Order_By>>;
  where?: Maybe<Risolto_Person_Bool_Exp>;
};


export type Subscription_RootRisolto_Person_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Person_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Person_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Person_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_License_ModuleArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_License_Module_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_License_Module_Order_By>>;
  where?: Maybe<Risolto_Platform_License_Module_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_License_Module_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_License_Module_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_License_Module_Order_By>>;
  where?: Maybe<Risolto_Platform_License_Module_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_License_Module_By_PkArgs = {
  platform_license_module: Scalars['String'];
};


export type Subscription_RootRisolto_Platform_License_Module_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Platform_License_Module_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Platform_License_Module_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Participant_LicenseArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Participant_License_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Participant_License_Order_By>>;
  where?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Participant_License_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Participant_License_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Participant_License_Order_By>>;
  where?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Participant_License_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Platform_Participant_License_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Platform_Participant_License_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Platform_Participant_License_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_PermissionArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Permission_Order_By>>;
  where?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Permission_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Permission_Order_By>>;
  where?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Permission_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Platform_Permission_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Platform_Permission_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Platform_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_RoleArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Role_Order_By>>;
  where?: Maybe<Risolto_Platform_Role_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Role_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Role_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Role_Order_By>>;
  where?: Maybe<Risolto_Platform_Role_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Role_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Platform_Role_PermissionArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Role_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Role_Permission_Order_By>>;
  where?: Maybe<Risolto_Platform_Role_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Role_Permission_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Role_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Role_Permission_Order_By>>;
  where?: Maybe<Risolto_Platform_Role_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Role_Permission_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Platform_Role_Permission_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Platform_Role_Permission_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Platform_Role_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Platform_Role_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Platform_Role_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_UsageArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Usage_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Usage_Order_By>>;
  where?: Maybe<Risolto_Platform_Usage_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Usage_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Platform_Usage_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Platform_Usage_Order_By>>;
  where?: Maybe<Risolto_Platform_Usage_Bool_Exp>;
};


export type Subscription_RootRisolto_Platform_Usage_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Platform_Usage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Platform_Usage_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Platform_Usage_Bool_Exp>;
};


export type Subscription_RootRisolto_Proof_Of_Delivery_BarcodeArgs = {
  args: Risolto_Proof_Of_Delivery_Barcode_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Proof_Of_Delivery_Barcode_AggregateArgs = {
  args: Risolto_Proof_Of_Delivery_Barcode_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Proof_Of_Delivery_Barcode_V2Args = {
  args: Risolto_Proof_Of_Delivery_Barcode_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Proof_Of_Delivery_Barcode_V2_AggregateArgs = {
  args: Risolto_Proof_Of_Delivery_Barcode_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_RecipientArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_AddressArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Address_Order_By>>;
  where?: Maybe<Risolto_Recipient_Address_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Address_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Address_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Address_Order_By>>;
  where?: Maybe<Risolto_Recipient_Address_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Address_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Address_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_AttachmentArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Attachment_Order_By>>;
  where?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Attachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Attachment_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Attachment_Order_By>>;
  where?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Attachment_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Attachment_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Attachment_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_CollectionArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Collection_Order_By>>;
  where?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Collection_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Collection_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Collection_Order_By>>;
  where?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Collection_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_Collection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Collection_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Collection_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_CommunicationArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Communication_Order_By>>;
  where?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Communication_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Communication_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Communication_Order_By>>;
  where?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Communication_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_Communication_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Communication_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Communication_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Dunning_ExcludeArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Dunning_Exclude_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Exclude_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Dunning_Exclude_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_Dunning_Exclude_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Dunning_Exclude_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Dunning_Exclude_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Dunning_RunArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Dunning_Run_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Dunning_Run_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Dunning_Run_Order_By>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Dunning_Run_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_Dunning_Run_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Dunning_Run_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Dunning_Run_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Find_Similar_By_NameArgs = {
  args: Risolto_Recipient_Find_Similar_By_Name_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Find_Similar_By_Name_AggregateArgs = {
  args: Risolto_Recipient_Find_Similar_By_Name_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_MergeArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Merge_Order_By>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Merge_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Merge_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Merge_Order_By>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Merge_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_Merge_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Merge_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Merge_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_TagArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_Tag_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_Tag_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_UserArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_User_Order_By>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Recipient_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_User_Order_By>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Recipient_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Recipient_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Recipient_User_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Recipient_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Reference_DataArgs = {
  distinct_on?: Maybe<Array<Risolto_Reference_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Reference_Data_Order_By>>;
  where?: Maybe<Risolto_Reference_Data_Bool_Exp>;
};


export type Subscription_RootRisolto_Reference_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Reference_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Reference_Data_Order_By>>;
  where?: Maybe<Risolto_Reference_Data_Bool_Exp>;
};


export type Subscription_RootRisolto_Reference_Data_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Reference_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Reference_Data_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Reference_Data_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Action_EventsArgs = {
  args: Risolto_Report_Action_Events_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Action_Events_AggregateArgs = {
  args: Risolto_Report_Action_Events_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Action_Events_V2Args = {
  args: Risolto_Report_Action_Events_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Action_Events_V2_AggregateArgs = {
  args: Risolto_Report_Action_Events_V2_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_DefinitionArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Definition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Definition_Order_By>>;
  where?: Maybe<Risolto_Report_Definition_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Definition_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Definition_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Definition_Order_By>>;
  where?: Maybe<Risolto_Report_Definition_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Definition_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Report_Definition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Report_Definition_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Report_Definition_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_ExecutionArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Execution_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Execution_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Report_Execution_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Report_Execution_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Report_Execution_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Execution_UserArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_User_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Execution_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Execution_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Execution_User_Order_By>>;
  where?: Maybe<Risolto_Report_Execution_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Execution_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Report_Execution_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Report_Execution_User_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Report_Execution_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Monthly_Delivery_V1Args = {
  args: Risolto_Report_Monthly_Delivery_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Monthly_Delivery_V1_AggregateArgs = {
  args: Risolto_Report_Monthly_Delivery_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Template_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Template_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Template_Type_Order_By>>;
  where?: Maybe<Risolto_Report_Template_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Template_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Template_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Template_Type_Order_By>>;
  where?: Maybe<Risolto_Report_Template_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Template_Type_By_PkArgs = {
  report_template_type: Scalars['String'];
};


export type Subscription_RootRisolto_Report_Template_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Report_Template_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Report_Template_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Type_Order_By>>;
  where?: Maybe<Risolto_Report_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_Type_Order_By>>;
  where?: Maybe<Risolto_Report_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_Type_By_PkArgs = {
  report_type: Scalars['String'];
};


export type Subscription_RootRisolto_Report_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Report_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Report_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_UserArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_User_Order_By>>;
  where?: Maybe<Risolto_Report_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Report_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Report_User_Order_By>>;
  where?: Maybe<Risolto_Report_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Report_User_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Report_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Report_User_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Report_User_Bool_Exp>;
};


export type Subscription_RootRisolto_Run_Processing_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Run_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Run_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Run_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Run_Processing_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Run_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Run_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Run_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Run_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


export type Subscription_RootRisolto_Run_Processing_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Run_Processing_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Run_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Search2recidArgs = {
  args: Risolto_Search2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Search2recid_AggregateArgs = {
  args: Risolto_Search2recid_Args;
  distinct_on?: Maybe<Array<Risolto_Recipient_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Recipient_Order_By>>;
  where?: Maybe<Risolto_Recipient_Bool_Exp>;
};


export type Subscription_RootRisolto_Single_Sign_OnArgs = {
  distinct_on?: Maybe<Array<Risolto_Single_Sign_On_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Single_Sign_On_Order_By>>;
  where?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
};


export type Subscription_RootRisolto_Single_Sign_On_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Single_Sign_On_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Single_Sign_On_Order_By>>;
  where?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
};


export type Subscription_RootRisolto_Single_Sign_On_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Single_Sign_On_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Single_Sign_On_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Single_Sign_On_Bool_Exp>;
};


export type Subscription_RootRisolto_StatementArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Order_By>>;
  where?: Maybe<Risolto_Statement_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_AccountArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Account_Order_By>>;
  where?: Maybe<Risolto_Statement_Account_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Account_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Account_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Account_Order_By>>;
  where?: Maybe<Risolto_Statement_Account_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Account_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Statement_Account_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Statement_Account_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Statement_Account_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Order_By>>;
  where?: Maybe<Risolto_Statement_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Statement_LineArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Statement_Line_Dunning_NoticeArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Dunning_Notice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Dunning_Notice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Dunning_Notice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Statement_Line_Dunning_Notice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Statement_Line_Dunning_Notice_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Statement_Line_Dunning_Notice_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_InvoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Invoice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Invoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Invoice_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Invoice_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Statement_Line_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Statement_Line_Invoice_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Statement_Line_Invoice_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Payment_PromiseArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Payment_Promise_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Payment_Promise_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Payment_Promise_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Statement_Line_Payment_Promise_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Statement_Line_Payment_Promise_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Statement_Line_Payment_Promise_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Status_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Statement_Line_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Statement_Line_Status_Order_By>>;
  where?: Maybe<Risolto_Statement_Line_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootRisolto_Statement_Line_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Statement_Line_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Statement_Line_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Statement_Line_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Statement_Line_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Structured_MatchArgs = {
  args: Risolto_Statement_Line_Structured_Match_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Structured_Match_AggregateArgs = {
  args: Risolto_Statement_Line_Structured_Match_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Unstructured_MatchArgs = {
  args: Risolto_Statement_Line_Unstructured_Match_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_Line_Unstructured_Match_AggregateArgs = {
  args: Risolto_Statement_Line_Unstructured_Match_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Statement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Statement_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Statement_Bool_Exp>;
};


export type Subscription_RootRisolto_Strigil_NbbArgs = {
  distinct_on?: Maybe<Array<Risolto_Strigil_Nbb_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Strigil_Nbb_Order_By>>;
  where?: Maybe<Risolto_Strigil_Nbb_Bool_Exp>;
};


export type Subscription_RootRisolto_Strigil_Nbb_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Strigil_Nbb_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Strigil_Nbb_Order_By>>;
  where?: Maybe<Risolto_Strigil_Nbb_Bool_Exp>;
};


export type Subscription_RootRisolto_Strigil_Nbb_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Strigil_Nbb_Processing_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Strigil_Nbb_Processing_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Strigil_Nbb_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Strigil_Nbb_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


export type Subscription_RootRisolto_Strigil_Nbb_Processing_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Strigil_Nbb_Processing_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Strigil_Nbb_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Strigil_Nbb_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Strigil_Nbb_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Strigil_Nbb_Bool_Exp>;
};


export type Subscription_RootRisolto_System_IntegrationArgs = {
  distinct_on?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_System_Integration_Order_By>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};


export type Subscription_RootRisolto_System_Integration_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_System_Integration_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_System_Integration_Order_By>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};


export type Subscription_RootRisolto_System_Integration_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_System_Integration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_System_Integration_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_System_Integration_Bool_Exp>;
};


export type Subscription_RootRisolto_TagArgs = {
  distinct_on?: Maybe<Array<Risolto_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tag_Order_By>>;
  where?: Maybe<Risolto_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tag_Order_By>>;
  where?: Maybe<Risolto_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_Tag_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Tag_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_TaskArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Order_By>>;
  where?: Maybe<Risolto_Task_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Order_By>>;
  where?: Maybe<Risolto_Task_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Task_SourceArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Source_Order_By>>;
  where?: Maybe<Risolto_Task_Source_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_Source_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Source_Order_By>>;
  where?: Maybe<Risolto_Task_Source_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_Source_By_PkArgs = {
  source: Scalars['String'];
};


export type Subscription_RootRisolto_Task_Source_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Task_Source_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Task_Source_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Status_Order_By>>;
  where?: Maybe<Risolto_Task_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Status_Order_By>>;
  where?: Maybe<Risolto_Task_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_Status_By_PkArgs = {
  status: Scalars['String'];
};


export type Subscription_RootRisolto_Task_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Task_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Task_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Task_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Task_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_TypeArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Type_Order_By>>;
  where?: Maybe<Risolto_Task_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Task_Type_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Task_Type_Order_By>>;
  where?: Maybe<Risolto_Task_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Task_Type_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootRisolto_Task_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Task_Type_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Task_Type_Bool_Exp>;
};


export type Subscription_RootRisolto_Tone_Of_VoiceArgs = {
  distinct_on?: Maybe<Array<Risolto_Tone_Of_Voice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tone_Of_Voice_Order_By>>;
  where?: Maybe<Risolto_Tone_Of_Voice_Bool_Exp>;
};


export type Subscription_RootRisolto_Tone_Of_Voice_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Tone_Of_Voice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Tone_Of_Voice_Order_By>>;
  where?: Maybe<Risolto_Tone_Of_Voice_Bool_Exp>;
};


export type Subscription_RootRisolto_Tone_Of_Voice_By_PkArgs = {
  tone_of_voice: Scalars['String'];
};


export type Subscription_RootRisolto_Tone_Of_Voice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Tone_Of_Voice_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Tone_Of_Voice_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Action_And_MessageArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Action_And_Message_Order_By>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Action_And_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Action_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Action_And_Message_Order_By>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Action_And_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Action_And_Message_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Action_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Credit_LimitArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_View_Credit_Limit_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Credit_Limit_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Credit_Limit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Credit_Limit_Order_By>>;
  where?: Maybe<Risolto_View_Credit_Limit_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Credit_Limit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Credit_Limit_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Credit_Limit_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dashboard_Aging_DebtArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Order_By>>;
  where?: Maybe<Risolto_View_Dashboard_Aging_Debt_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dashboard_Aging_Debt_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dashboard_Aging_Debt_Order_By>>;
  where?: Maybe<Risolto_View_Dashboard_Aging_Debt_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dashboard_Aging_Debt_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Dashboard_Aging_Debt_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Dashboard_Aging_Debt_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dashboard_Percentage_Paying_Within_30_DaysArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Order_By>>;
  where?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dashboard_Percentage_Paying_Within_30_Days_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Order_By>>;
  where?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dashboard_Percentage_Paying_Within_30_Days_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Dashboard_Percentage_Paying_Within_30_Days_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dunning_Notice_Action_6mArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Order_By>>;
  where?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dunning_Notice_Action_6m_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Dunning_Notice_Action_6m_Order_By>>;
  where?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Dunning_Notice_Action_6m_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Dunning_Notice_Action_6m_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Dunning_Notice_Action_6m_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Invoice_FeaturesArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_View_Invoice_Features_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Invoice_Features_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Invoice_Features_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Invoice_Features_Order_By>>;
  where?: Maybe<Risolto_View_Invoice_Features_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Invoice_Features_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Invoice_Features_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Invoice_Features_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Legal_Entity_TemplateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Legal_Entity_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Legal_Entity_Template_Order_By>>;
  where?: Maybe<Risolto_View_Legal_Entity_Template_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Legal_Entity_Template_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Legal_Entity_Template_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Legal_Entity_Template_Order_By>>;
  where?: Maybe<Risolto_View_Legal_Entity_Template_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Legal_Entity_Template_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Legal_Entity_Template_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Legal_Entity_Template_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Platform_Licence_PermissionArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Order_By>>;
  where?: Maybe<Risolto_View_Platform_Licence_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Platform_Licence_Permission_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Platform_Licence_Permission_Order_By>>;
  where?: Maybe<Risolto_View_Platform_Licence_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Platform_Licence_Permission_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Platform_Licence_Permission_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Platform_Licence_Permission_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Recipient_TagArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Recipient_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_View_Recipient_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_View_Recipient_Tag_Order_By>>;
  where?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_View_Recipient_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_View_Recipient_Tag_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_View_Recipient_Tag_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_NoteArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_And_DisputeArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_And_Dispute_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_And_Dispute_And_MessageArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_And_Dispute_And_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_And_Dispute_And_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_And_Dispute_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_And_Dispute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Action_And_Note_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_V1Args = {
  args: Risolto_Virtual_Action_And_Note_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_V1_AggregateArgs = {
  args: Risolto_Virtual_Action_And_Note_V1_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_V3Args = {
  args: Risolto_Virtual_Action_And_Note_V3_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_V3_AggregateArgs = {
  args: Risolto_Virtual_Action_And_Note_V3_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_V4Args = {
  args: Risolto_Virtual_Action_And_Note_V4_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_V4_AggregateArgs = {
  args: Risolto_Virtual_Action_And_Note_V4_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_V5Args = {
  args: Risolto_Virtual_Action_And_Note_V5_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_And_Note_V5_AggregateArgs = {
  args: Risolto_Virtual_Action_And_Note_V5_Args;
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_And_Note_And_Dispute_And_Message_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_GroupArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Action_Group_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Action_Group_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Action_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Action_Group_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Action_Group_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dashboard_Action_StatsArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dashboard_Action_Stats_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Action_Stats_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dashboard_Action_Stats_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Dashboard_Action_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Dashboard_Action_Stats_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Action_Stats_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dashboard_Outstanding_DebtArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dashboard_Outstanding_Debt_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dashboard_Outstanding_Debt_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dashboard_Outstanding_Debt_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Dashboard_Outstanding_Debt_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Dashboard_Outstanding_Debt_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Demo_Action_Report_1Args = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Order_By>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Demo_Action_Report_1_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Demo_Action_Report_1_Order_By>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Demo_Action_Report_1_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Demo_Action_Report_1_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Demo_Action_Report_1_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Demo_Action_Report_1_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dunning_ActionArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dunning_Action_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Dunning_Action_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Dunning_Action_Order_By>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Dunning_Action_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Dunning_Action_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Dunning_Action_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Dunning_Action_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Interchange_EventArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Interchange_Event_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Interchange_Event_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Interchange_Event_Order_By>>;
  where?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Interchange_Event_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Interchange_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Interchange_Event_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Interchange_Event_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Invoice_Derived_Payment_InformationArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Invoice_Derived_Payment_Information_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoice_Derived_Payment_Information_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Invoice_Derived_Payment_Information_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Invoice_Derived_Payment_Information_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Invoice_Derived_Payment_Information_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Invoicing_Channel_EndpointArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Invoicing_Channel_Endpoint_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Invoicing_Channel_Endpoint_Order_By>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Invoicing_Channel_Endpoint_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Invoicing_Channel_Endpoint_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Invoicing_Channel_Endpoint_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_JsonArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Json_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Json_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Json_Order_By>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Json_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Json_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Json_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Json_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Report_DeliveryArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Report_Delivery_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Virtual_Report_Delivery_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Virtual_Report_Delivery_Order_By>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_Virtual_Report_Delivery_By_PkArgs = {
  v_reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Virtual_Report_Delivery_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Virtual_Report_Delivery_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Virtual_Report_Delivery_Bool_Exp>;
};


export type Subscription_RootRisolto_WebhookArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Order_By>>;
  where?: Maybe<Risolto_Webhook_Bool_Exp>;
};


export type Subscription_RootRisolto_Webhook_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Order_By>>;
  where?: Maybe<Risolto_Webhook_Bool_Exp>;
};


export type Subscription_RootRisolto_Webhook_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Webhook_Processing_StatusArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Webhook_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Webhook_Processing_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Processing_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Processing_Status_Order_By>>;
  where?: Maybe<Risolto_Webhook_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Webhook_Processing_Status_By_PkArgs = {
  processing_status: Scalars['String'];
};


export type Subscription_RootRisolto_Webhook_Processing_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Webhook_Processing_Status_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Webhook_Processing_Status_Bool_Exp>;
};


export type Subscription_RootRisolto_Webhook_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Webhook_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Webhook_Bool_Exp>;
};


export type Subscription_RootRisolto_Webhook_SubscriptionArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Subscription_Order_By>>;
  where?: Maybe<Risolto_Webhook_Subscription_Bool_Exp>;
};


export type Subscription_RootRisolto_Webhook_Subscription_AggregateArgs = {
  distinct_on?: Maybe<Array<Risolto_Webhook_Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Risolto_Webhook_Subscription_Order_By>>;
  where?: Maybe<Risolto_Webhook_Subscription_Bool_Exp>;
};


export type Subscription_RootRisolto_Webhook_Subscription_By_PkArgs = {
  reference: Scalars['uuid'];
};


export type Subscription_RootRisolto_Webhook_Subscription_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Risolto_Webhook_Subscription_Stream_Cursor_Input>>;
  where?: Maybe<Risolto_Webhook_Subscription_Bool_Exp>;
};


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

export type GetCreditNotesQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetCreditNotesQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_credit_note_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_credit_note_aggregate_fields' }
      & Pick<Risolto_Credit_Note_Aggregate_Fields, 'count'>
    )> }
  ), risolto_credit_note: Array<(
    { __typename?: 'risolto_credit_note' }
    & Pick<Risolto_Credit_Note, 'reference' | 'created_at' | 'participant' | 'amount_currency' | 'processing_status' | 'status' | 'custom_fields' | 'origin' | 'credit_note_number' | 'total_amount' | 'open_amount' | 'due_date' | 'due_amount' | 'issue_date' | 'file_references'>
    & { interchange_links: Array<(
      { __typename?: 'risolto_document_interchange_link' }
      & { interchange_by_reference: (
        { __typename?: 'risolto_document_interchange' }
        & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
        & { interchange_events?: Maybe<Array<(
          { __typename?: 'risolto_virtual_interchange_event' }
          & Pick<Risolto_Virtual_Interchange_Event, 'event_type' | 'last_event_timestamp'>
        )>> }
      ) }
    )> }
  )> }
);

export type GetDebitNotesQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetDebitNotesQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_debit_note_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_debit_note_aggregate_fields' }
      & Pick<Risolto_Debit_Note_Aggregate_Fields, 'count'>
    )> }
  ), risolto_debit_note: Array<(
    { __typename?: 'risolto_debit_note' }
    & Pick<Risolto_Debit_Note, 'reference' | 'created_at' | 'participant' | 'amount_currency' | 'processing_status' | 'custom_fields' | 'origin' | 'debit_note_number' | 'total_amount' | 'open_amount' | 'due_date' | 'issue_date'>
  )> }
);

export type ReactivateEndpointMutationVariables = Exact<{
  participant: Scalars['uuid'];
  reference: Scalars['uuid'];
}>;


export type ReactivateEndpointMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_channel_endpoint?: Maybe<(
    { __typename?: 'risolto_channel_endpoint_mutation_response' }
    & Pick<Risolto_Channel_Endpoint_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'reference'>
    )> }
  )> }
);

export type DeactivateEndpointMutationVariables = Exact<{
  participant: Scalars['uuid'];
  reference: Scalars['uuid'];
  deactivated_by: Scalars['String'];
}>;


export type DeactivateEndpointMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_channel_endpoint?: Maybe<(
    { __typename?: 'risolto_channel_endpoint_mutation_response' }
    & Pick<Risolto_Channel_Endpoint_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'reference'>
    )> }
  )> }
);

export type ActionsGetQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  status?: Maybe<Array<Risolto_Action_Status_Enum> | Risolto_Action_Status_Enum>;
  execution_type?: Maybe<Array<Risolto_Action_Execution_Type_Enum> | Risolto_Action_Execution_Type_Enum>;
  participant: Scalars['uuid'];
  invoice?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Risolto_Channel_Enum>;
  recipientRef?: Maybe<Scalars['uuid']>;
  orderBy?: Maybe<Array<Risolto_Action_Order_By> | Risolto_Action_Order_By>;
}>;


export type ActionsGetQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_action_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_action_aggregate_fields' }
      & Pick<Risolto_Action_Aggregate_Fields, 'count'>
    )> }
  ), actions: Array<(
    { __typename?: 'risolto_action' }
    & Pick<Risolto_Action, 'reference' | 'metadata' | 'message_code' | 'participant' | 'legal_entity' | 'execution_type' | 'status' | 'channel' | 'source' | 'executed_at' | 'original_action' | 'retry_count' | 'start_time' | 'due_date' | 'recipient' | 'created_at' | 'assignee'>
    & { action_invoices: Array<(
      { __typename?: 'risolto_action_invoice' }
      & Pick<Risolto_Action_Invoice, 'reference' | 'relation'>
      & { invoice_by_reference: (
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
        & { recipient_by_reference?: Maybe<(
          { __typename?: 'risolto_recipient' }
          & Pick<Risolto_Recipient, 'reference' | 'name'>
        )>, legal_entity_by_reference: (
          { __typename?: 'risolto_legal_entity' }
          & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
        ), participant_by_reference: (
          { __typename?: 'risolto_participant' }
          & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
        ), interchange_links: Array<(
          { __typename?: 'risolto_document_interchange_link' }
          & { interchange_by_reference: (
            { __typename?: 'risolto_document_interchange' }
            & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
          ) }
        )> }
      ) }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id' | 'custom_fields'>
    )>, legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name'>
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )> }
  )> }
);

export type ActionsGetInvoiceActionsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  status?: Maybe<Array<Risolto_Action_Status_Enum> | Risolto_Action_Status_Enum>;
  execution_type?: Maybe<Array<Risolto_Action_Execution_Type_Enum> | Risolto_Action_Execution_Type_Enum>;
  participant: Scalars['uuid'];
  invoice?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Risolto_Channel_Enum>;
  recipientRef?: Maybe<Scalars['uuid']>;
  orderBy?: Maybe<Array<Risolto_Action_Order_By> | Risolto_Action_Order_By>;
}>;


export type ActionsGetInvoiceActionsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_action_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_action_aggregate_fields' }
      & Pick<Risolto_Action_Aggregate_Fields, 'count'>
    )> }
  ), actions: Array<(
    { __typename?: 'risolto_action' }
    & Pick<Risolto_Action, 'reference' | 'metadata' | 'message_code' | 'participant' | 'legal_entity' | 'execution_type' | 'status' | 'channel' | 'source' | 'original_action' | 'retry_count' | 'executed_at' | 'start_time' | 'due_date' | 'recipient' | 'created_at' | 'assignee'>
    & { action_invoices: Array<(
      { __typename?: 'risolto_action_invoice' }
      & Pick<Risolto_Action_Invoice, 'invoice' | 'relation'>
      & { invoice_by_reference: (
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
        & { recipient_by_reference?: Maybe<(
          { __typename?: 'risolto_recipient' }
          & Pick<Risolto_Recipient, 'reference' | 'name'>
        )>, legal_entity_by_reference: (
          { __typename?: 'risolto_legal_entity' }
          & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
        ), participant_by_reference: (
          { __typename?: 'risolto_participant' }
          & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
        ), interchange_links: Array<(
          { __typename?: 'risolto_document_interchange_link' }
          & { interchange_by_reference: (
            { __typename?: 'risolto_document_interchange' }
            & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
          ) }
        )> }
      ) }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id'>
    )>, legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name'>
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )> }
  )> }
);

export type ActionsGetParticipantActionAggregateQueryVariables = Exact<{
  actionType?: Maybe<Array<Risolto_Action_Execution_Type_Enum> | Risolto_Action_Execution_Type_Enum>;
  status?: Maybe<Array<Risolto_Action_Status_Enum> | Risolto_Action_Status_Enum>;
}>;


export type ActionsGetParticipantActionAggregateQuery = (
  { __typename?: 'query_root' }
  & { risolto_action_aggregate: (
    { __typename?: 'risolto_action_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_action_aggregate_fields' }
      & Pick<Risolto_Action_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type ActionsGetActionQueryVariables = Exact<{
  action: Scalars['uuid'];
  participant: Scalars['uuid'];
}>;


export type ActionsGetActionQuery = (
  { __typename?: 'query_root' }
  & { action: Array<(
    { __typename?: 'risolto_action' }
    & Pick<Risolto_Action, 'reference' | 'metadata' | 'channel' | 'message_code' | 'participant' | 'legal_entity' | 'recipient' | 'execution_type' | 'status' | 'source' | 'due_date' | 'original_action' | 'retry_count' | 'created_at' | 'assignee' | 'channel_endpoint'>
    & { participant_by_reference: (
      { __typename?: 'risolto_participant' }
      & Pick<Risolto_Participant, 'name'>
    ), legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'company_id' | 'company_id_type' | 'registration_name'>
      & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'reference' | 'account_id'>
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )>, channel_endpoint_by_reference?: Maybe<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'last_failed_delivery_at' | 'last_failed_delivery_type' | 'locale' | 'priority'>
    )> }
  )> }
);

export type ActionsUpdateActionAssigneeMutationVariables = Exact<{
  actionRef: Scalars['uuid'];
  personRef?: Maybe<Scalars['uuid']>;
}>;


export type ActionsUpdateActionAssigneeMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_action?: Maybe<(
    { __typename?: 'risolto_action_mutation_response' }
    & { updated_count: Risolto_Action_Mutation_Response['affected_rows'] }
    & { updated: Array<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'reference'>
      & { assignee_by_reference?: Maybe<(
        { __typename?: 'risolto_person' }
        & Pick<Risolto_Person, 'username'>
      )> }
    )> }
  )> }
);

export type ActionsUpdateActionMetadataMutationVariables = Exact<{
  action: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  channel: Risolto_Channel_Enum;
}>;


export type ActionsUpdateActionMetadataMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_action?: Maybe<(
    { __typename?: 'risolto_action_mutation_response' }
    & { updated_count: Risolto_Action_Mutation_Response['affected_rows'] }
    & { updated: Array<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'reference' | 'metadata'>
    )> }
  )> }
);

export type ActionsAddMutationVariables = Exact<{
  channel?: Maybe<Risolto_Channel_Enum>;
  executionType?: Maybe<Risolto_Action_Execution_Type_Enum>;
  legalEntity?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  participant?: Maybe<Scalars['uuid']>;
  status?: Maybe<Risolto_Action_Status_Enum>;
  startTime?: Maybe<Scalars['timestamptz']>;
  exectutedAt?: Maybe<Scalars['timestamptz']>;
  source?: Maybe<Risolto_Action_Source_Enum>;
  messageCode?: Maybe<Scalars['String']>;
  primaryInvoice: Scalars['uuid'];
  invoiceGroupInvoices: Array<Risolto_Invoice_Group_Invoice_Insert_Input> | Risolto_Invoice_Group_Invoice_Insert_Input;
}>;


export type ActionsAddMutation = (
  { __typename?: 'mutation_root' }
  & { insert_risolto_action?: Maybe<(
    { __typename?: 'risolto_action_mutation_response' }
    & Pick<Risolto_Action_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'reference'>
    )> }
  )> }
);

export type ActionsFragmentDetailsFieldsFragment = (
  { __typename?: 'risolto_action' }
  & Pick<Risolto_Action, 'status' | 'channel' | 'recipient' | 'reference' | 'metadata' | 'message_code' | 'participant' | 'primary_invoice' | 'legal_entity' | 'execution_type' | 'source' | 'executed_at' | 'original_action' | 'retry_count' | 'start_time' | 'due_date' | 'created_at' | 'assignee' | 'channel_endpoint'>
  & { recipient_by_reference?: Maybe<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'address' | 'balance_amount' | 'dunning_metadata' | 'last_dunning_at' | 'legal_id' | 'legal_id_type' | 'name' | 'account_id' | 'type' | 'updated_by' | 'participant' | 'reference' | 'legal_entity'>
    & { legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
    ) }
  )>, primary_invoice_by_reference?: Maybe<(
    { __typename?: 'risolto_invoice_document' }
    & Pick<Risolto_Invoice_Document, 'invoice_number'>
  )>, action_invoices: Array<(
    { __typename?: 'risolto_action_invoice' }
    & Pick<Risolto_Action_Invoice, 'reference' | 'relation'>
    & { invoice_by_reference: (
      { __typename?: 'risolto_invoice_document' }
      & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
      & { recipient_by_reference?: Maybe<(
        { __typename?: 'risolto_recipient' }
        & Pick<Risolto_Recipient, 'reference' | 'name'>
      )>, legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
      ), participant_by_reference: (
        { __typename?: 'risolto_participant' }
        & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
      ), interchange_links: Array<(
        { __typename?: 'risolto_document_interchange_link' }
        & { interchange_by_reference: (
          { __typename?: 'risolto_document_interchange' }
          & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
        ) }
      )> }
    ) }
  )>, legal_entity_by_reference?: Maybe<(
    { __typename?: 'risolto_legal_entity' }
    & Pick<Risolto_Legal_Entity, 'registration_name'>
    & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
  )>, assignee_by_reference?: Maybe<(
    { __typename?: 'risolto_person' }
    & Pick<Risolto_Person, 'username'>
  )>, channel_endpoint_by_reference?: Maybe<(
    { __typename?: 'risolto_channel_endpoint' }
    & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'last_failed_delivery_at' | 'last_failed_delivery_type' | 'locale' | 'priority'>
  )> }
);

export type ActionsAddManualActionInvoiceCopyMutationVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity?: Maybe<Scalars['uuid']>;
  recipient: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  invoice: Scalars['uuid'];
  channelEndpoint?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
}>;


export type ActionsAddManualActionInvoiceCopyMutation = (
  { __typename?: 'mutation_root' }
  & { action?: Maybe<(
    { __typename?: 'risolto_action' }
    & ActionsFragmentDetailsFieldsFragment
  )> }
);

export type ActionsGetSendInvoiceCopyDataQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity: Scalars['uuid'];
  recipient: Scalars['uuid'];
  invoices: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ActionsGetSendInvoiceCopyDataQuery = (
  { __typename?: 'query_root' }
  & { legal_entity: Array<(
    { __typename?: 'risolto_legal_entity' }
    & { communication: Risolto_Legal_Entity['processing_details'] }
  )>, recipient: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'language_code'>
  )>, channel_endpoints: Array<(
    { __typename?: 'risolto_virtual_invoicing_channel_endpoint' }
    & { channel_endpoint: (
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'reference' | 'endpoint' | 'locale'>
    ) }
  )>, invoices: Array<(
    { __typename?: 'risolto_invoice_document' }
    & { attachments: Risolto_Invoice_Document['file_references'] }
  )> }
);

export type ActionsGetNextActionsV2QueryVariables = Exact<{
  reference?: Maybe<Scalars['uuid']>;
  participant: Scalars['uuid'];
  recipient?: Maybe<Scalars['uuid']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  channels?: Maybe<Array<Risolto_Channel_Enum> | Risolto_Channel_Enum>;
  statuses?: Maybe<Array<Risolto_Action_Status_Enum> | Risolto_Action_Status_Enum>;
  searchTerm: Scalars['String'];
  msgCode?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  orderBy?: Maybe<Array<Risolto_Action_Order_By> | Risolto_Action_Order_By>;
}>;


export type ActionsGetNextActionsV2Query = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_action_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_action_aggregate_fields' }
      & Pick<Risolto_Action_Aggregate_Fields, 'count'>
    )> }
  ), risolto_action: Array<(
    { __typename?: 'risolto_action' }
    & Pick<Risolto_Action, 'status' | 'channel' | 'recipient' | 'reference' | 'metadata' | 'message_code' | 'is_retry' | 'participant' | 'primary_invoice' | 'legal_entity' | 'execution_type' | 'source' | 'executed_at' | 'original_action' | 'retry_count' | 'start_time' | 'due_date' | 'created_at' | 'assignee' | 'channel_endpoint'>
    & { recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'address' | 'balance_amount' | 'dunning_metadata' | 'last_dunning_at' | 'legal_id' | 'legal_id_type' | 'name' | 'account_id' | 'type' | 'updated_by' | 'participant' | 'reference' | 'legal_entity'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
      ) }
    )>, primary_invoice_by_reference?: Maybe<(
      { __typename?: 'risolto_invoice_document' }
      & Pick<Risolto_Invoice_Document, 'invoice_number'>
    )>, action_invoices: Array<(
      { __typename?: 'risolto_action_invoice' }
      & Pick<Risolto_Action_Invoice, 'reference' | 'relation'>
      & { invoice_by_reference: (
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
        & { recipient_by_reference?: Maybe<(
          { __typename?: 'risolto_recipient' }
          & Pick<Risolto_Recipient, 'reference' | 'name'>
        )>, legal_entity_by_reference: (
          { __typename?: 'risolto_legal_entity' }
          & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
        ), participant_by_reference: (
          { __typename?: 'risolto_participant' }
          & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
        ), interchange_links: Array<(
          { __typename?: 'risolto_document_interchange_link' }
          & { interchange_by_reference: (
            { __typename?: 'risolto_document_interchange' }
            & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
          ) }
        )> }
      ) }
    )>, legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name'>
      & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )>, channel_endpoint_by_reference?: Maybe<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'last_failed_delivery_at' | 'last_failed_delivery_type' | 'locale' | 'priority'>
    )> }
  )> }
);

export type ActionsGetNextActionsQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  channels?: Maybe<Array<Risolto_Channel_Enum> | Risolto_Channel_Enum>;
  statuses?: Maybe<Array<Risolto_Action_Status_Enum> | Risolto_Action_Status_Enum>;
  searchTerm: Scalars['String'];
}>;


export type ActionsGetNextActionsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_action_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_action_aggregate_fields' }
      & Pick<Risolto_Action_Aggregate_Fields, 'count'>
    )> }
  ), risolto_action: Array<(
    { __typename?: 'risolto_action' }
    & Pick<Risolto_Action, 'status' | 'channel' | 'recipient' | 'reference' | 'metadata' | 'message_code' | 'participant' | 'legal_entity' | 'execution_type' | 'source' | 'executed_at' | 'original_action' | 'retry_count' | 'start_time' | 'due_date' | 'created_at' | 'assignee'>
    & { recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'participant' | 'reference' | 'address' | 'balance_amount' | 'dunning_metadata' | 'last_dunning_at' | 'legal_id' | 'legal_id_type' | 'name' | 'type' | 'updated_by' | 'legal_entity' | 'account_id'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
      ) }
    )>, action_invoices: Array<(
      { __typename?: 'risolto_action_invoice' }
      & Pick<Risolto_Action_Invoice, 'reference' | 'relation'>
      & { invoice_by_reference: (
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
        & { recipient_by_reference?: Maybe<(
          { __typename?: 'risolto_recipient' }
          & Pick<Risolto_Recipient, 'reference' | 'name'>
        )>, legal_entity_by_reference: (
          { __typename?: 'risolto_legal_entity' }
          & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
        ), participant_by_reference: (
          { __typename?: 'risolto_participant' }
          & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
        ), interchange_links: Array<(
          { __typename?: 'risolto_document_interchange_link' }
          & { interchange_by_reference: (
            { __typename?: 'risolto_document_interchange' }
            & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
          ) }
        )> }
      ) }
    )>, legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name'>
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )> }
  )> }
);

export type ActionsAddInvoiceCopyMailMutationVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity?: Maybe<Scalars['uuid']>;
  recipient: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  invoice: Scalars['uuid'];
  channelEndpoint?: Maybe<Scalars['uuid']>;
  start_time: Scalars['timestamptz'];
}>;


export type ActionsAddInvoiceCopyMailMutation = (
  { __typename?: 'mutation_root' }
  & { action?: Maybe<(
    { __typename?: 'risolto_action' }
    & ActionsFragmentDetailsFieldsFragment
  )> }
);

export type ActionsAddManualActionMutationVariables = Exact<{
  channel?: Maybe<Risolto_Channel_Enum>;
  status?: Maybe<Risolto_Action_Status_Enum>;
  legalEntity?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  participant?: Maybe<Scalars['uuid']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  assignee?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  primaryInvoice: Scalars['uuid'];
  invoiceGroupInvoices: Array<Risolto_Invoice_Group_Invoice_Insert_Input> | Risolto_Invoice_Group_Invoice_Insert_Input;
}>;


export type ActionsAddManualActionMutation = (
  { __typename?: 'mutation_root' }
  & { insert_risolto_action?: Maybe<(
    { __typename?: 'risolto_action_mutation_response' }
    & Pick<Risolto_Action_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'reference'>
    )> }
  )> }
);

export type ActionsGetSendInvoiceCopyMailDataQueryVariables = Exact<{
  recipient: Scalars['uuid'];
  invoices: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ActionsGetSendInvoiceCopyMailDataQuery = (
  { __typename?: 'query_root' }
  & { recipient?: Maybe<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'reference' | 'name' | 'participant' | 'language_code'>
    & { legal_entity: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference'>
      & { address: Risolto_Legal_Entity['processing_details'], default_postal_provider: Risolto_Legal_Entity['processing_details'], communication_postal_provider: Risolto_Legal_Entity['processing_details'] }
      & { communication_templates: Array<(
        { __typename?: 'risolto_communication_template' }
        & Pick<Risolto_Communication_Template, 'template_id'>
      )> }
    ), channel_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'reference'>
      & { address: Risolto_Channel_Endpoint['endpoint_details'] }
      & { contact?: Maybe<(
        { __typename?: 'risolto_contact' }
        & Pick<Risolto_Contact, 'first_name' | 'last_name'>
      )> }
    )>, invoices: Array<(
      { __typename?: 'risolto_invoice_document' }
      & { attachments: Risolto_Invoice_Document['file_references'] }
    )> }
  )> }
);

export type ActionsGetSendCreditNoteCopyMailDataQueryVariables = Exact<{
  recipient: Scalars['uuid'];
  creditNotes: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ActionsGetSendCreditNoteCopyMailDataQuery = (
  { __typename?: 'query_root' }
  & { recipient?: Maybe<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'reference' | 'name' | 'participant' | 'language_code'>
    & { legal_entity: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference'>
      & { address: Risolto_Legal_Entity['processing_details'], default_postal_provider: Risolto_Legal_Entity['processing_details'], communication_postal_provider: Risolto_Legal_Entity['processing_details'] }
      & { communication_templates: Array<(
        { __typename?: 'risolto_communication_template' }
        & Pick<Risolto_Communication_Template, 'template_id'>
      )> }
    ), channel_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'reference'>
      & { address: Risolto_Channel_Endpoint['endpoint_details'] }
      & { contact?: Maybe<(
        { __typename?: 'risolto_contact' }
        & Pick<Risolto_Contact, 'first_name' | 'last_name'>
      )> }
    )>, credit_notes: Array<(
      { __typename?: 'risolto_credit_note' }
      & { attachments: Risolto_Credit_Note['file_references'] }
    )> }
  )> }
);

export type ActionsAddCreditNoteCopyMailMutationVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity?: Maybe<Scalars['uuid']>;
  recipient: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  creditNote: Scalars['uuid'];
  channelEndpoint?: Maybe<Scalars['uuid']>;
  start_time: Scalars['timestamptz'];
}>;


export type ActionsAddCreditNoteCopyMailMutation = (
  { __typename?: 'mutation_root' }
  & { action?: Maybe<(
    { __typename?: 'risolto_action' }
    & ActionsFragmentDetailsFieldsFragment
  )> }
);

export type ActionsGetSendCreditNoteCopyDataQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity: Scalars['uuid'];
  recipient: Scalars['uuid'];
  creditNotes: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ActionsGetSendCreditNoteCopyDataQuery = (
  { __typename?: 'query_root' }
  & { legal_entity: Array<(
    { __typename?: 'risolto_legal_entity' }
    & { communication: Risolto_Legal_Entity['processing_details'] }
  )>, channel_endpoints: Array<(
    { __typename?: 'risolto_virtual_invoicing_channel_endpoint' }
    & { channel_endpoint: (
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'reference' | 'endpoint' | 'locale'>
    ) }
  )>, credit_notes: Array<(
    { __typename?: 'risolto_credit_note' }
    & { attachments: Risolto_Credit_Note['file_references'] }
  )> }
);

export type ActionsAddManualActionCreditNoteCopyMutationVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity?: Maybe<Scalars['uuid']>;
  recipient: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  creditNote: Scalars['uuid'];
  channelEndpoint?: Maybe<Scalars['uuid']>;
  start_time?: Maybe<Scalars['timestamptz']>;
}>;


export type ActionsAddManualActionCreditNoteCopyMutation = (
  { __typename?: 'mutation_root' }
  & { action?: Maybe<(
    { __typename?: 'risolto_action' }
    & ActionsFragmentDetailsFieldsFragment
  )> }
);

export type ActionsUpdateChannelEndpointMutationVariables = Exact<{
  action: Scalars['uuid'];
  channelEndpoint: Scalars['uuid'];
}>;


export type ActionsUpdateChannelEndpointMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_action?: Maybe<(
    { __typename?: 'risolto_action_mutation_response' }
    & { updated_count: Risolto_Action_Mutation_Response['affected_rows'] }
    & { updated: Array<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'reference' | 'channel_endpoint'>
    )> }
  )> }
);

export type GqlActionsGrouped_GetAllWorklistItemsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  isDueDate: Scalars['Boolean'];
  isStartTime: Scalars['Boolean'];
  isChannel: Scalars['Boolean'];
  isRecipient: Scalars['Boolean'];
  isMessageCode: Scalars['Boolean'];
  isReference: Scalars['Boolean'];
  isAssignee: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By> | Risolto_Virtual_Action_Group_Order_By>;
  statuses?: Maybe<Scalars['_text']>;
  participants?: Maybe<Scalars['_uuid']>;
  startTimeFrom?: Maybe<Scalars['timestamp']>;
  startTimeUntil?: Maybe<Scalars['timestamp']>;
}>;


export type GqlActionsGrouped_GetAllWorklistItemsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_virtual_action_group_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_virtual_action_group_aggregate_fields' }
      & Pick<Risolto_Virtual_Action_Group_Aggregate_Fields, 'count'>
    )> }
  ), actions: Array<(
    { __typename?: 'risolto_virtual_action_group' }
    & Pick<Risolto_Virtual_Action_Group, 'v_reference' | 'reference' | 'action_count' | 'due_date' | 'due_date_count' | 'channel' | 'channel_count' | 'recipient' | 'recipient_count' | 'start_time' | 'start_time_count' | 'assignee_count' | 'message_code' | 'message_code_count'>
    & { action_by_reference?: Maybe<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'source' | 'channel_endpoint' | 'status' | 'original_action' | 'retry_count' | 'participant' | 'metadata' | 'reference' | 'execution_type' | 'recipient' | 'message_code' | 'channel' | 'due_date' | 'start_time' | 'assignee' | 'legal_entity'>
      & { channel_endpoint_by_reference?: Maybe<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'last_failed_delivery_at' | 'last_failed_delivery_type' | 'locale' | 'priority'>
      )>, action_invoices: Array<(
        { __typename?: 'risolto_action_invoice' }
        & Pick<Risolto_Action_Invoice, 'relation' | 'invoice'>
        & { invoice_by_reference: (
          { __typename?: 'risolto_invoice_document' }
          & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
          & { recipient_by_reference?: Maybe<(
            { __typename?: 'risolto_recipient' }
            & Pick<Risolto_Recipient, 'reference' | 'name'>
          )>, legal_entity_by_reference: (
            { __typename?: 'risolto_legal_entity' }
            & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
          ), participant_by_reference: (
            { __typename?: 'risolto_participant' }
            & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
          ), interchange_links: Array<(
            { __typename?: 'risolto_document_interchange_link' }
            & { interchange_by_reference: (
              { __typename?: 'risolto_document_interchange' }
              & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
            ) }
          )> }
        ) }
      )>, recipient_by_reference?: Maybe<(
        { __typename?: 'risolto_recipient' }
        & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id' | 'participant'>
      )>, legal_entity_by_reference?: Maybe<(
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name' | 'company_id' | 'company_id_type'>
        & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
      )>, assignee_by_reference?: Maybe<(
        { __typename?: 'risolto_person' }
        & Pick<Risolto_Person, 'reference' | 'username'>
      )> }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'name' | 'reference' | 'type' | 'participant' | 'legal_id_type' | 'legal_id' | 'legal_entity' | 'account_id'>
      & { contacts: Array<(
        { __typename?: 'risolto_contact' }
        & Pick<Risolto_Contact, 'reference' | 'first_name' | 'last_name'>
      )>, invoice_documents_aggregate: (
        { __typename?: 'risolto_invoice_document_aggregate' }
        & { aggregate?: Maybe<(
          { __typename?: 'risolto_invoice_document_aggregate_fields' }
          & { sum?: Maybe<(
            { __typename?: 'risolto_invoice_document_sum_fields' }
            & Pick<Risolto_Invoice_Document_Sum_Fields, 'open_amount' | 'total_amount'>
          )> }
        )> }
      ) }
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )> }
  )> }
);

export type GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  isDueDate: Scalars['Boolean'];
  isStartTime: Scalars['Boolean'];
  isChannel: Scalars['Boolean'];
  isRecipient: Scalars['Boolean'];
  isMessageCode: Scalars['Boolean'];
  isAssignee: Scalars['Boolean'];
  isReference: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By> | Risolto_Virtual_Action_Group_Order_By>;
  statuses?: Maybe<Scalars['_text']>;
  participants?: Maybe<Scalars['_uuid']>;
  startTimeFrom?: Maybe<Scalars['timestamp']>;
  startTimeUntil?: Maybe<Scalars['timestamp']>;
}>;


export type GqlActionsGrouped_GetunassignedWorklistItemsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_virtual_action_group_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_virtual_action_group_aggregate_fields' }
      & Pick<Risolto_Virtual_Action_Group_Aggregate_Fields, 'count'>
    )> }
  ), actions: Array<(
    { __typename?: 'risolto_virtual_action_group' }
    & Pick<Risolto_Virtual_Action_Group, 'v_reference' | 'reference' | 'action_count' | 'due_date' | 'due_date_count' | 'channel' | 'channel_count' | 'recipient' | 'recipient_count' | 'start_time' | 'start_time_count' | 'assignee_count' | 'message_code' | 'message_code_count'>
    & { action_by_reference?: Maybe<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'source' | 'channel_endpoint' | 'status' | 'original_action' | 'retry_count' | 'participant' | 'metadata' | 'reference' | 'execution_type' | 'recipient' | 'message_code' | 'channel' | 'due_date' | 'start_time' | 'assignee' | 'legal_entity'>
      & { channel_endpoint_by_reference?: Maybe<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'last_failed_delivery_at' | 'last_failed_delivery_type' | 'locale' | 'priority'>
      )>, action_invoices: Array<(
        { __typename?: 'risolto_action_invoice' }
        & Pick<Risolto_Action_Invoice, 'relation' | 'invoice'>
        & { invoice_by_reference: (
          { __typename?: 'risolto_invoice_document' }
          & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
          & { recipient_by_reference?: Maybe<(
            { __typename?: 'risolto_recipient' }
            & Pick<Risolto_Recipient, 'reference' | 'name'>
          )>, legal_entity_by_reference: (
            { __typename?: 'risolto_legal_entity' }
            & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
          ), participant_by_reference: (
            { __typename?: 'risolto_participant' }
            & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
          ), interchange_links: Array<(
            { __typename?: 'risolto_document_interchange_link' }
            & { interchange_by_reference: (
              { __typename?: 'risolto_document_interchange' }
              & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
            ) }
          )> }
        ) }
      )>, recipient_by_reference?: Maybe<(
        { __typename?: 'risolto_recipient' }
        & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id' | 'participant'>
      )>, legal_entity_by_reference?: Maybe<(
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name' | 'company_id' | 'company_id_type'>
        & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
      )>, assignee_by_reference?: Maybe<(
        { __typename?: 'risolto_person' }
        & Pick<Risolto_Person, 'reference' | 'username'>
      )> }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'name' | 'reference' | 'type' | 'participant' | 'legal_id_type' | 'legal_id' | 'legal_entity' | 'account_id'>
      & { contacts: Array<(
        { __typename?: 'risolto_contact' }
        & Pick<Risolto_Contact, 'reference' | 'first_name' | 'last_name'>
      )>, invoice_documents_aggregate: (
        { __typename?: 'risolto_invoice_document_aggregate' }
        & { aggregate?: Maybe<(
          { __typename?: 'risolto_invoice_document_aggregate_fields' }
          & { sum?: Maybe<(
            { __typename?: 'risolto_invoice_document_sum_fields' }
            & Pick<Risolto_Invoice_Document_Sum_Fields, 'open_amount' | 'total_amount'>
          )> }
        )> }
      ) }
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )> }
  )> }
);

export type GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  isDueDate: Scalars['Boolean'];
  isStartTime: Scalars['Boolean'];
  isChannel: Scalars['Boolean'];
  isRecipient: Scalars['Boolean'];
  isMessageCode: Scalars['Boolean'];
  isReference: Scalars['Boolean'];
  isAssignee: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By> | Risolto_Virtual_Action_Group_Order_By>;
  statuses?: Maybe<Scalars['_text']>;
  assignee: Scalars['uuid'];
  participants?: Maybe<Scalars['_uuid']>;
  startTimeFrom?: Maybe<Scalars['timestamp']>;
  startTimeUntil?: Maybe<Scalars['timestamp']>;
}>;


export type GqlActionsGrouped_GetAssignedWorklistItemsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_virtual_action_group_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_virtual_action_group_aggregate_fields' }
      & Pick<Risolto_Virtual_Action_Group_Aggregate_Fields, 'count'>
    )> }
  ), actions: Array<(
    { __typename?: 'risolto_virtual_action_group' }
    & Pick<Risolto_Virtual_Action_Group, 'v_reference' | 'reference' | 'action_count' | 'due_date' | 'due_date_count' | 'channel' | 'channel_count' | 'recipient' | 'recipient_count' | 'start_time' | 'start_time_count' | 'assignee_count' | 'message_code' | 'message_code_count'>
    & { action_by_reference?: Maybe<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'source' | 'channel_endpoint' | 'status' | 'original_action' | 'retry_count' | 'participant' | 'metadata' | 'reference' | 'execution_type' | 'recipient' | 'message_code' | 'channel' | 'due_date' | 'start_time' | 'assignee' | 'legal_entity'>
      & { channel_endpoint_by_reference?: Maybe<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'last_failed_delivery_at' | 'last_failed_delivery_type' | 'locale' | 'priority'>
      )>, action_invoices: Array<(
        { __typename?: 'risolto_action_invoice' }
        & Pick<Risolto_Action_Invoice, 'relation' | 'invoice'>
        & { invoice_by_reference: (
          { __typename?: 'risolto_invoice_document' }
          & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
          & { recipient_by_reference?: Maybe<(
            { __typename?: 'risolto_recipient' }
            & Pick<Risolto_Recipient, 'reference' | 'name'>
          )>, legal_entity_by_reference: (
            { __typename?: 'risolto_legal_entity' }
            & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
          ), participant_by_reference: (
            { __typename?: 'risolto_participant' }
            & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
          ), interchange_links: Array<(
            { __typename?: 'risolto_document_interchange_link' }
            & { interchange_by_reference: (
              { __typename?: 'risolto_document_interchange' }
              & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
            ) }
          )> }
        ) }
      )>, recipient_by_reference?: Maybe<(
        { __typename?: 'risolto_recipient' }
        & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id' | 'participant'>
      )>, legal_entity_by_reference?: Maybe<(
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name' | 'company_id' | 'company_id_type'>
        & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
      )>, assignee_by_reference?: Maybe<(
        { __typename?: 'risolto_person' }
        & Pick<Risolto_Person, 'reference' | 'username'>
      )> }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'name' | 'reference' | 'type' | 'participant' | 'legal_id_type' | 'legal_id' | 'legal_entity' | 'account_id'>
      & { contacts: Array<(
        { __typename?: 'risolto_contact' }
        & Pick<Risolto_Contact, 'reference' | 'first_name' | 'last_name'>
      )>, invoice_documents_aggregate: (
        { __typename?: 'risolto_invoice_document_aggregate' }
        & { aggregate?: Maybe<(
          { __typename?: 'risolto_invoice_document_aggregate_fields' }
          & { sum?: Maybe<(
            { __typename?: 'risolto_invoice_document_sum_fields' }
            & Pick<Risolto_Invoice_Document_Sum_Fields, 'open_amount' | 'total_amount'>
          )> }
        )> }
      ) }
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )> }
  )> }
);

export type GetStatementLinesQueryVariables = Exact<{
  status?: Maybe<Array<Risolto_Statement_Line_Status_Enum> | Risolto_Statement_Line_Status_Enum>;
  startDate?: Maybe<Scalars['date']>;
  endDate?: Maybe<Scalars['date']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  participantRef: Scalars['uuid'];
}>;


export type GetStatementLinesQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_statement_line_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_statement_line_aggregate_fields' }
      & Pick<Risolto_Statement_Line_Aggregate_Fields, 'count'>
    )> }
  ), statements: Array<(
    { __typename?: 'risolto_statement_line' }
    & Pick<Risolto_Statement_Line, 'reference' | 'counterparty_account_number' | 'counterparty_account_number_type' | 'counterparty_address' | 'counterparty_bank_identifier' | 'counterparty_bank_identifier_type' | 'counterparty_currency' | 'counterparty_name' | 'invoice' | 'legal_entity' | 'recipient' | 'structured_message' | 'transaction_credit_amount' | 'transaction_date' | 'transaction_debit_amount' | 'transaction_reference' | 'unstructured_message'>
    & { recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'reference' | 'name'>
      & { channel_endpoints: Array<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'channel'>
        & { contact_by_reference?: Maybe<(
          { __typename?: 'risolto_contact' }
          & Pick<Risolto_Contact, 'first_name' | 'last_name'>
        )> }
      )> }
    )> }
  )> }
);

export type GetContactsQueryVariables = Exact<{
  recipient: Scalars['uuid'];
  participant: Scalars['uuid'];
}>;


export type GetContactsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_contact_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_contact_aggregate_fields' }
      & Pick<Risolto_Contact_Aggregate_Fields, 'count'>
    )> }
  ), contacts: Array<(
    { __typename?: 'risolto_contact' }
    & Pick<Risolto_Contact, 'legal_entity' | 'participant' | 'first_name' | 'last_name' | 'full_name' | 'reference' | 'recipient'>
    & { channel_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'channel' | 'endpoint' | 'reference'>
    )> }
  )> }
);

export type GetContactQueryVariables = Exact<{
  reference: Scalars['uuid'];
  participant?: Maybe<Scalars['uuid']>;
}>;


export type GetContactQuery = (
  { __typename?: 'query_root' }
  & { contact: Array<(
    { __typename?: 'risolto_contact' }
    & Pick<Risolto_Contact, 'legal_entity' | 'participant' | 'first_name' | 'last_name' | 'reference' | 'recipient'>
    & { channel_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'endpoint_details' | 'channel' | 'deactivated_at' | 'deactivated_by' | 'endpoint' | 'reference'>
    )> }
  )> }
);

export type GqlDashboard_AgingBalanceQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legal_entity?: Maybe<Scalars['uuid']>;
  today: Scalars['date'];
  today_minus_30: Scalars['date'];
  today_minus_60: Scalars['date'];
  today_minus_90: Scalars['date'];
  issue_date_from: Scalars['date'];
  issue_date_until: Scalars['date'];
}>;


export type GqlDashboard_AgingBalanceQuery = (
  { __typename?: 'query_root' }
  & { not_overdue: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount'>
      )> }
    )> }
  ), days30: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount'>
      )> }
    )> }
  ), days60: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount'>
      )> }
    )> }
  ), days90: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount'>
      )> }
    )> }
  ), days90plus: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount'>
      )> }
    )> }
  ) }
);

export type GqlDashboard_AgingBalanceRecipientQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
  today: Scalars['date'];
  today_minus_30: Scalars['date'];
  today_minus_60: Scalars['date'];
  today_minus_90: Scalars['date'];
}>;


export type GqlDashboard_AgingBalanceRecipientQuery = (
  { __typename?: 'query_root' }
  & { not_overdue: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount' | 'total_amount'>
      )> }
    )> }
  ), days30: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount' | 'total_amount'>
      )> }
    )> }
  ), days60: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount' | 'total_amount'>
      )> }
    )> }
  ), days90: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount' | 'total_amount'>
      )> }
    )> }
  ), days90plus: (
    { __typename?: 'risolto_accounting_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_accounting_document_aggregate_fields' }
      & { sum?: Maybe<(
        { __typename?: 'risolto_accounting_document_sum_fields' }
        & Pick<Risolto_Accounting_Document_Sum_Fields, 'open_amount' | 'total_amount'>
      )> }
    )> }
  ) }
);

export type InsertActionInvoiceMutationVariables = Exact<{
  action: Scalars['uuid'];
  invoice: Scalars['uuid'];
  legal_entity: Scalars['uuid'];
  participant: Scalars['uuid'];
  relation: Scalars['String'];
}>;


export type InsertActionInvoiceMutation = (
  { __typename?: 'mutation_root' }
  & { insert_risolto_action_invoice?: Maybe<(
    { __typename?: 'risolto_action_invoice_mutation_response' }
    & Pick<Risolto_Action_Invoice_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_action_invoice' }
      & Pick<Risolto_Action_Invoice, 'reference'>
    )> }
  )> }
);

export type GqlInvoices_GetInvoiceInterchangeLinksQueryVariables = Exact<{
  participantRef: Scalars['uuid'];
  invoice: Scalars['uuid'];
}>;


export type GqlInvoices_GetInvoiceInterchangeLinksQuery = (
  { __typename?: 'query_root' }
  & { invoice: Array<(
    { __typename?: 'risolto_invoice_document' }
    & Pick<Risolto_Invoice_Document, 'reference' | 'dunning_status' | 'derived_paid_at'>
    & { file_references: Risolto_Invoice_Document['attachments'] }
    & { actions: Array<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'reference'>
      & { action_interchanges: Array<(
        { __typename?: 'risolto_action_interchange' }
        & Pick<Risolto_Action_Interchange, 'reference'>
        & { interchange_by_reference: (
          { __typename?: 'risolto_document_interchange' }
          & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
          & { interchange_events?: Maybe<Array<(
            { __typename?: 'risolto_virtual_interchange_event' }
            & Pick<Risolto_Virtual_Interchange_Event, 'event_type' | 'event_type_count' | 'last_event_timestamp'>
            & { email: Risolto_Virtual_Interchange_Event['channel_endpoint'], postal_mail: Risolto_Virtual_Interchange_Event['channel_endpoint'] }
          )>> }
        ) }
      )> }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'participant' | 'reference' | 'name' | 'legal_entity'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
      ) }
    )>, invoice_dispute: Array<(
      { __typename?: 'risolto_invoice_dispute' }
      & Pick<Risolto_Invoice_Dispute, 'reference' | 'until'>
    )>, legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
    ), participant_by_reference: (
      { __typename?: 'risolto_participant' }
      & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
    ) }
  )> }
);

export type GqlInvoices_GetInvoiceQueryVariables = Exact<{
  invoice: Scalars['uuid'];
}>;


export type GqlInvoices_GetInvoiceQuery = (
  { __typename?: 'query_root' }
  & { invoice: Array<(
    { __typename?: 'risolto_invoice_document' }
    & Pick<Risolto_Invoice_Document, 'processing_due_date' | 'invoice_number' | 'amount_currency' | 'dunning_started' | 'earliest_dunning_time' | 'earliest_submission_time' | 'issue_date' | 'due_date' | 'reference' | 'payment_reference' | 'file_reference' | 'file_references' | 'legal_entity' | 'total_amount' | 'open_amount' | 'participant' | 'recipient' | 'dunning_status' | 'custom_fields' | 'attachments'>
    & { legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name' | 'reference' | 'participant' | 'address' | 'company_id' | 'company_id_type'>
    ), interchange_links: Array<(
      { __typename?: 'risolto_document_interchange_link' }
      & Pick<Risolto_Document_Interchange_Link, 'reference'>
      & { interchange_by_reference: (
        { __typename?: 'risolto_document_interchange' }
        & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
        & { interchange_events?: Maybe<Array<(
          { __typename?: 'risolto_virtual_interchange_event' }
          & Pick<Risolto_Virtual_Interchange_Event, 'event_type' | 'event_type_count' | 'last_event_timestamp'>
          & { email: Risolto_Virtual_Interchange_Event['channel_endpoint'], postal_mail: Risolto_Virtual_Interchange_Event['channel_endpoint'] }
        )>> }
      ) }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'preferred_invoicing_channel' | 'legal_entity' | 'participant' | 'reference' | 'type' | 'legal_id' | 'legal_id_type' | 'address' | 'name' | 'account_id'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference'>
      ) }
    )>, actions: Array<(
      { __typename?: 'risolto_action_invoice' }
      & { action_by_reference: (
        { __typename?: 'risolto_action' }
        & Pick<Risolto_Action, 'reference' | 'message_code'>
      ) }
    )>, total_actions: (
      { __typename?: 'risolto_action_invoice_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_action_invoice_aggregate_fields' }
        & Pick<Risolto_Action_Invoice_Aggregate_Fields, 'count'>
      )> }
    ) }
  )> }
);

export type GqlInvoices_GetInvoicesQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  participantRef: Scalars['uuid'];
  status?: Maybe<Array<Risolto_Invoice_Document_Status_Enum> | Risolto_Invoice_Document_Status_Enum>;
  orderBy?: Maybe<Array<Risolto_Invoice_Document_Order_By> | Risolto_Invoice_Document_Order_By>;
  searchTerm: Scalars['String'];
  searchAmount_min: Scalars['numeric'];
  searchAmount_max: Scalars['numeric'];
  today: Scalars['date'];
}>;


export type GqlInvoices_GetInvoicesQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_invoice_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_invoice_document_aggregate_fields' }
      & Pick<Risolto_Invoice_Document_Aggregate_Fields, 'count'>
    )> }
  ), invoices: Array<(
    { __typename?: 'risolto_invoice_document' }
    & Pick<Risolto_Invoice_Document, 'processing_due_date' | 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'file_reference' | 'file_references' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
    & { total_actions: (
      { __typename?: 'risolto_action_invoice_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_action_invoice_aggregate_fields' }
        & Pick<Risolto_Action_Invoice_Aggregate_Fields, 'count'>
      )> }
    ), total_open_actions: (
      { __typename?: 'risolto_action_invoice_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_action_invoice_aggregate_fields' }
        & Pick<Risolto_Action_Invoice_Aggregate_Fields, 'count'>
      )> }
    ), recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'participant' | 'reference' | 'name' | 'account_id' | 'legal_entity'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
      ) }
    )>, legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
    ), participant_by_reference: (
      { __typename?: 'risolto_participant' }
      & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
    ), invoice_dispute: Array<(
      { __typename?: 'risolto_invoice_dispute' }
      & Pick<Risolto_Invoice_Dispute, 'reference' | 'until'>
    )> }
  )> }
);

export type GqlInvoices_GetInvoicesForRecipientQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  participantRef: Scalars['uuid'];
  recipient: Scalars['uuid'];
  status?: Maybe<Array<Risolto_Invoice_Document_Status_Enum> | Risolto_Invoice_Document_Status_Enum>;
  orderBy?: Maybe<Array<Risolto_Invoice_Document_Order_By> | Risolto_Invoice_Document_Order_By>;
  searchTerm: Scalars['String'];
  searchAmount_min: Scalars['numeric'];
  searchAmount_max: Scalars['numeric'];
  today: Scalars['date'];
}>;


export type GqlInvoices_GetInvoicesForRecipientQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_invoice_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_invoice_document_aggregate_fields' }
      & Pick<Risolto_Invoice_Document_Aggregate_Fields, 'count'>
    )> }
  ), invoices: Array<(
    { __typename?: 'risolto_invoice_document' }
    & Pick<Risolto_Invoice_Document, 'processing_due_date' | 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'file_reference' | 'file_references' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
    & { recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'participant' | 'reference' | 'name' | 'account_id' | 'legal_entity'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
      ) }
    )>, legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
    ), participant_by_reference: (
      { __typename?: 'risolto_participant' }
      & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
    ), invoice_dispute: Array<(
      { __typename?: 'risolto_invoice_dispute' }
      & Pick<Risolto_Invoice_Dispute, 'reference' | 'until'>
    )> }
  )> }
);

export type GqlInvoices_FindInvoicesQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
}>;


export type GqlInvoices_FindInvoicesQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_invoice_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_invoice_document_aggregate_fields' }
      & Pick<Risolto_Invoice_Document_Aggregate_Fields, 'count'>
    )> }
  ), invoices: Array<(
    { __typename?: 'risolto_invoice_document' }
    & Pick<Risolto_Invoice_Document, 'reference' | 'recipient' | 'processing_due_date' | 'invoice_number' | 'status' | 'payment_reference' | 'open_amount' | 'total_amount'>
    & { recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id'>
      & { bank_accounts: Array<(
        { __typename?: 'risolto_bank_account' }
        & Pick<Risolto_Bank_Account, 'account_number'>
      )> }
    )> }
  )> }
);

export type GqlInvoices_ActionsByInvoiceQueryVariables = Exact<{
  invoice: Scalars['uuid'];
}>;


export type GqlInvoices_ActionsByInvoiceQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_action_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_action_aggregate_fields' }
      & Pick<Risolto_Action_Aggregate_Fields, 'count'>
    )> }
  ), actions: Array<(
    { __typename?: 'risolto_action' }
    & { action_invoices: Array<(
      { __typename?: 'risolto_action_invoice' }
      & Pick<Risolto_Action_Invoice, 'action' | 'invoice'>
      & { action_by_reference: (
        { __typename?: 'risolto_action' }
        & Pick<Risolto_Action, 'status' | 'channel' | 'source' | 'recipient' | 'participant' | 'metadata'>
      ), invoice_by_reference: (
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'reference' | 'invoice_number' | 'processing_due_date'>
      ) }
    )> }
  )> }
);

export type GetLegalEntitiesQueryVariables = Exact<{
  participant?: Maybe<Scalars['uuid']>;
}>;


export type GetLegalEntitiesQuery = (
  { __typename?: 'query_root' }
  & { legal_entities: Array<(
    { __typename?: 'risolto_legal_entity' }
    & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name' | 'company_id' | 'logical_id'>
  )> }
);

export type FindInvoicePaymentTriggerQueryVariables = Exact<{
  recipient: Scalars['uuid'];
}>;


export type FindInvoicePaymentTriggerQuery = (
  { __typename?: 'query_root' }
  & { risolto_recipient: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'account_id'>
    & { invoice_documents: Array<(
      { __typename?: 'risolto_invoice_document' }
      & Pick<Risolto_Invoice_Document, 'due_date' | 'invoice_number' | 'status'>
      & { action_invoices: Array<(
        { __typename?: 'risolto_action_invoice' }
        & { action_by_reference: (
          { __typename?: 'risolto_action' }
          & Pick<Risolto_Action, 'reference' | 'channel' | 'message_code' | 'executed_at' | 'updated_at'>
          & { action_invoices: Array<(
            { __typename?: 'risolto_action_invoice' }
            & Pick<Risolto_Action_Invoice, 'reference' | 'invoice'>
            & { invoice_by_reference: (
              { __typename?: 'risolto_invoice_document' }
              & Pick<Risolto_Invoice_Document, 'invoice_number'>
            ) }
          )> }
        ) }
      )> }
    )> }
  )> }
);

export type Risolto_NotesQueryVariables = Exact<{
  participant?: Maybe<Scalars['uuid']>;
  recipientRef?: Maybe<Scalars['uuid']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type Risolto_NotesQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_note_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_note_aggregate_fields' }
      & Pick<Risolto_Note_Aggregate_Fields, 'count'>
    )> }
  ), notes: Array<(
    { __typename?: 'risolto_note' }
    & Pick<Risolto_Note, 'reference' | 'note' | 'created_by' | 'created_at'>
    & { person_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'reference' | 'external_id' | 'username'>
    )>, note_invoices: Array<(
      { __typename?: 'risolto_note_invoice' }
      & Pick<Risolto_Note_Invoice, 'reference'>
      & { invoice_by_reference: (
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'reference' | 'invoice_number'>
      ) }
    )> }
  )> }
);

export type GetInvoiceNotesQueryVariables = Exact<{
  participant: Scalars['uuid'];
  invoice: Scalars['uuid'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetInvoiceNotesQuery = (
  { __typename?: 'query_root' }
  & { notes: Array<(
    { __typename?: 'risolto_note_invoice' }
    & Pick<Risolto_Note_Invoice, 'note'>
    & { note_by_reference: (
      { __typename?: 'risolto_note' }
      & Pick<Risolto_Note, 'reference' | 'note' | 'created_at' | 'created_by'>
      & { person_by_reference?: Maybe<(
        { __typename?: 'risolto_person' }
        & Pick<Risolto_Person, 'reference' | 'external_id' | 'username'>
      )> }
    ) }
  )>, total: (
    { __typename?: 'risolto_note_invoice_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_note_invoice_aggregate_fields' }
      & Pick<Risolto_Note_Invoice_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type Insert_Risolto_NoteMutationVariables = Exact<{
  note: Scalars['String'];
  category?: Maybe<Risolto_Note_Category_Enum>;
  participant: Scalars['uuid'];
  invoice?: Maybe<Scalars['uuid']>;
  recipient: Scalars['uuid'];
  legal_entity: Scalars['uuid'];
  created_by: Scalars['uuid'];
  action?: Maybe<Scalars['uuid']>;
}>;


export type Insert_Risolto_NoteMutation = (
  { __typename?: 'mutation_root' }
  & { result?: Maybe<(
    { __typename?: 'risolto_note_mutation_response' }
    & { updated_count: Risolto_Note_Mutation_Response['affected_rows'] }
    & { returning: Array<(
      { __typename?: 'risolto_note' }
      & Pick<Risolto_Note, 'reference' | 'note'>
    )> }
  )> }
);

export type InsertInvoiceNoteMutationVariables = Exact<{
  note: Scalars['uuid'];
  invoice: Scalars['uuid'];
  participant: Scalars['uuid'];
  legalEntity: Scalars['uuid'];
}>;


export type InsertInvoiceNoteMutation = (
  { __typename?: 'mutation_root' }
  & { insert_risolto_note_invoice?: Maybe<(
    { __typename?: 'risolto_note_invoice_mutation_response' }
    & Pick<Risolto_Note_Invoice_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_note_invoice' }
      & Pick<Risolto_Note_Invoice, 'reference'>
    )> }
  )> }
);

export type Update_Risolto_NoteMutationVariables = Exact<{
  noteRef: Scalars['uuid'];
  newNote: Scalars['String'];
}>;


export type Update_Risolto_NoteMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_note?: Maybe<(
    { __typename?: 'risolto_note_mutation_response' }
    & { updated_count: Risolto_Note_Mutation_Response['affected_rows'] }
    & { updated: Array<(
      { __typename?: 'risolto_note' }
      & Pick<Risolto_Note, 'note' | 'reference'>
    )> }
  )> }
);

export type Delete_Risolto_NoteMutationVariables = Exact<{
  noteRef: Scalars['uuid'];
}>;


export type Delete_Risolto_NoteMutation = (
  { __typename?: 'mutation_root' }
  & { delete_risolto_note?: Maybe<(
    { __typename?: 'risolto_note_mutation_response' }
    & { deleted: Risolto_Note_Mutation_Response['affected_rows'] }
  )> }
);

export type DeleteInvoiceNoteMutationVariables = Exact<{
  note: Scalars['uuid'];
}>;


export type DeleteInvoiceNoteMutation = (
  { __typename?: 'mutation_root' }
  & { delete_risolto_note_invoice?: Maybe<(
    { __typename?: 'risolto_note_invoice_mutation_response' }
    & Pick<Risolto_Note_Invoice_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_note_invoice' }
      & Pick<Risolto_Note_Invoice, 'reference'>
    )> }
  )>, delete_risolto_note?: Maybe<(
    { __typename?: 'risolto_note_mutation_response' }
    & Pick<Risolto_Note_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_note' }
      & Pick<Risolto_Note, 'reference'>
    )> }
  )> }
);

export type GqlParticipantsGetParticipantsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type GqlParticipantsGetParticipantsQuery = (
  { __typename?: 'query_root' }
  & { risolto_participant: Array<(
    { __typename?: 'risolto_participant' }
    & Pick<Risolto_Participant, 'name' | 'reference'>
  )>, risolto_participant_aggregate: (
    { __typename?: 'risolto_participant_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_participant_aggregate_fields' }
      & Pick<Risolto_Participant_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type GqlParticipantsGetParticipantQueryVariables = Exact<{
  partRef: Scalars['uuid'];
}>;


export type GqlParticipantsGetParticipantQuery = (
  { __typename?: 'query_root' }
  & { risolto_participant: Array<(
    { __typename?: 'risolto_participant' }
    & Pick<Risolto_Participant, 'name' | 'reference'>
  )> }
);

export type GqlParticipantsGetParticipantDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type GqlParticipantsGetParticipantDetailsQuery = (
  { __typename?: 'query_root' }
  & { participant: Array<(
    { __typename?: 'risolto_participant' }
    & Pick<Risolto_Participant, 'name' | 'reference'>
    & { legal_entities: Array<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'logical_id' | 'registration_name' | 'processing_details'>
    )> }
  )> }
);

export type GetParticipantsForUserQueryVariables = Exact<{
  externalId?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  license_module: Risolto_Platform_License_Module_Enum;
}>;


export type GetParticipantsForUserQuery = (
  { __typename?: 'query_root' }
  & { risolto_participant: Array<(
    { __typename?: 'risolto_participant' }
    & Pick<Risolto_Participant, 'logical_id' | 'name' | 'reference' | 'user_interface_details'>
    & { legal_entities: Array<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'logical_id' | 'registration_name'>
    )> }
  )> }
);

export type GetPaymentDocumentQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetPaymentDocumentQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_payment_document_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_payment_document_aggregate_fields' }
      & Pick<Risolto_Payment_Document_Aggregate_Fields, 'count'>
    )> }
  ), payment_documents: Array<(
    { __typename?: 'risolto_payment_document' }
    & Pick<Risolto_Payment_Document, 'reference' | 'created_at' | 'payment_number' | 'participant' | 'amount_currency' | 'processing_status' | 'custom_fields' | 'origin' | 'total_amount' | 'open_amount' | 'issue_date'>
  )> }
);

export type GqlPaymentPlan_PaymentPlansQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
}>;


export type GqlPaymentPlan_PaymentPlansQuery = (
  { __typename?: 'query_root' }
  & { paymentPlans: Array<(
    { __typename?: 'risolto_payment_plan' }
    & Pick<Risolto_Payment_Plan, 'reference' | 'name' | 'total_amount' | 'status' | 'is_open' | 'amount_currency'>
    & { open_amount: Risolto_Payment_Plan['virtual_open_amount'] }
    & { payment_promises: Array<(
      { __typename?: 'risolto_payment_promise' }
      & Pick<Risolto_Payment_Promise, 'reference' | 'payment_reference' | 'status' | 'due_date' | 'total_amount' | 'open_amount' | 'amount_currency'>
    )> }
  )> }
);

export type GqlPeople_GetParticipantUsersQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legal_entity?: Maybe<Scalars['uuid']>;
}>;


export type GqlPeople_GetParticipantUsersQuery = (
  { __typename?: 'query_root' }
  & { participantUsers: Array<(
    { __typename?: 'risolto_participant_user' }
    & { person_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'reference' | 'username' | 'email'>
    )> }
  )> }
);

export type GqlPeople_GetPersonByExternalIdQueryVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type GqlPeople_GetPersonByExternalIdQuery = (
  { __typename?: 'query_root' }
  & { risolto_person: Array<(
    { __typename?: 'risolto_person' }
    & Pick<Risolto_Person, 'reference' | 'username'>
  )> }
);

export type GqlPeople_GetParticipantByPersonQueryVariables = Exact<{
  personRef: Scalars['uuid'];
}>;


export type GqlPeople_GetParticipantByPersonQuery = (
  { __typename?: 'query_root' }
  & { risolto_participant_user: Array<(
    { __typename?: 'risolto_participant_user' }
    & Pick<Risolto_Participant_User, 'reference' | 'participant'>
  )> }
);

export type GqlRecipients_GetRecipientsQueryVariables = Exact<{
  partRef: Scalars['uuid'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Array<Risolto_Recipient_Order_By> | Risolto_Recipient_Order_By>;
}>;


export type GqlRecipients_GetRecipientsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_recipient_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_recipient_aggregate_fields' }
      & Pick<Risolto_Recipient_Aggregate_Fields, 'count'>
    )> }
  ), recipients: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'balance_amount' | 'due_balance_amount' | 'name' | 'reference' | 'type' | 'participant' | 'legal_id_type' | 'legal_id' | 'legal_entity' | 'account_id'>
    & { legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
    ), contacts: Array<(
      { __typename?: 'risolto_contact' }
      & Pick<Risolto_Contact, 'reference' | 'first_name' | 'last_name'>
    )>, invoice_documents_aggregate: (
      { __typename?: 'risolto_invoice_document_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_invoice_document_aggregate_fields' }
        & { sum?: Maybe<(
          { __typename?: 'risolto_invoice_document_sum_fields' }
          & Pick<Risolto_Invoice_Document_Sum_Fields, 'open_amount' | 'total_amount'>
        )> }
      )> }
    ) }
  )> }
);

export type GqlRecipients_GetRecipientQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
}>;


export type GqlRecipients_GetRecipientQuery = (
  { __typename?: 'query_root' }
  & { risolto_recipient: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'in_collection' | 'last_dunning_run_at' | 'name' | 'account_id' | 'participant' | 'legal_entity' | 'address' | 'language_code' | 'preferred_invoicing_channel' | 'balance_amount' | 'due_balance_amount' | 'reference' | 'custom_fields' | 'legal_id_type' | 'legal_id' | 'type' | 'dunning_is_dirty'>
    & { participant_by_reference: (
      { __typename?: 'risolto_participant' }
      & Pick<Risolto_Participant, 'reference'>
    ), legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name' | 'company_id' | 'company_id_type'>
    ), email_main_contact: Array<(
      { __typename?: 'risolto_contact' }
      & Pick<Risolto_Contact, 'reference'>
      & { channel_endpoints: Array<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'endpoint'>
      )> }
    )>, postal_main_contact: Array<(
      { __typename?: 'risolto_contact' }
      & Pick<Risolto_Contact, 'reference'>
      & { channel_endpoints: Array<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'endpoint_details'>
      )> }
    )>, phone_main_contact: Array<(
      { __typename?: 'risolto_contact' }
      & Pick<Risolto_Contact, 'reference'>
      & { channel_endpoints: Array<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'endpoint'>
      )> }
    )>, sms_main_contact: Array<(
      { __typename?: 'risolto_contact' }
      & Pick<Risolto_Contact, 'reference'>
      & { channel_endpoints: Array<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'endpoint'>
      )> }
    )>, contacts: Array<(
      { __typename?: 'risolto_contact' }
      & Pick<Risolto_Contact, 'reference' | 'first_name' | 'last_name'>
    )>, main_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at'>
    )>, channel_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'channel'>
      & { contact_by_reference?: Maybe<(
        { __typename?: 'risolto_contact' }
        & Pick<Risolto_Contact, 'first_name' | 'last_name'>
      )> }
    )>, currentActions: Array<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'reference' | 'start_time'>
    )>, totalCurrentActions: (
      { __typename?: 'risolto_action_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_action_aggregate_fields' }
        & Pick<Risolto_Action_Aggregate_Fields, 'count'>
      )> }
    ), invoice_documents_aggregate: (
      { __typename?: 'risolto_invoice_document_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_invoice_document_aggregate_fields' }
        & { sum?: Maybe<(
          { __typename?: 'risolto_invoice_document_sum_fields' }
          & Pick<Risolto_Invoice_Document_Sum_Fields, 'open_amount' | 'total_amount'>
        )> }
      )> }
    ), total_open: (
      { __typename?: 'risolto_invoice_document_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_invoice_document_aggregate_fields' }
        & { sum?: Maybe<(
          { __typename?: 'risolto_invoice_document_sum_fields' }
          & Pick<Risolto_Invoice_Document_Sum_Fields, 'total_amount' | 'open_amount'>
        )> }
      )> }
    ), total_paid: (
      { __typename?: 'risolto_invoice_document_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_invoice_document_aggregate_fields' }
        & { sum?: Maybe<(
          { __typename?: 'risolto_invoice_document_sum_fields' }
          & Pick<Risolto_Invoice_Document_Sum_Fields, 'total_amount' | 'open_amount'>
        )> }
      )> }
    ), total_rfs: (
      { __typename?: 'risolto_invoice_document_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_invoice_document_aggregate_fields' }
        & { sum?: Maybe<(
          { __typename?: 'risolto_invoice_document_sum_fields' }
          & Pick<Risolto_Invoice_Document_Sum_Fields, 'total_amount' | 'open_amount'>
        )> }
      )> }
    ) }
  )> }
);

export type GetTemplatesQueryVariables = Exact<{
  legalEntityFilter?: Maybe<Array<Risolto_Communication_Template_Bool_Exp> | Risolto_Communication_Template_Bool_Exp>;
  participant?: Maybe<Scalars['uuid']>;
  channels?: Maybe<Array<Risolto_Channel_Enum> | Risolto_Channel_Enum>;
  searchTerm?: Maybe<Scalars['String']>;
  locales?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  toneOfVoices?: Maybe<Array<Risolto_Tone_Of_Voice_Enum> | Risolto_Tone_Of_Voice_Enum>;
  orderBy?: Maybe<Array<Risolto_Communication_Template_Order_By> | Risolto_Communication_Template_Order_By>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetTemplatesQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_communication_template_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_communication_template_aggregate_fields' }
      & Pick<Risolto_Communication_Template_Aggregate_Fields, 'count'>
    )> }
  ), templates: Array<(
    { __typename?: 'risolto_communication_template' }
    & Pick<Risolto_Communication_Template, 'reference' | 'participant' | 'legal_entity' | 'template_id' | 'channel' | 'document_name' | 'tone_of_voice' | 'type' | 'locale'>
    & { legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
    )> }
  )> }
);

export type GetTemplateQueryVariables = Exact<{
  reference?: Maybe<Scalars['uuid']>;
}>;


export type GetTemplateQuery = (
  { __typename?: 'query_root' }
  & { template: Array<(
    { __typename?: 'risolto_communication_template' }
    & Pick<Risolto_Communication_Template, 'reference' | 'participant' | 'legal_entity' | 'template_id' | 'subject_template' | 'channel' | 'document_name' | 'tone_of_voice' | 'type' | 'locale' | 'template_renderer_version' | 'document_template'>
    & { legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
    )> }
  )> }
);

export type UpdateCommunicationTemplateMutationVariables = Exact<{
  document_template?: Maybe<Scalars['jsonb']>;
  template_reference?: Maybe<Scalars['uuid']>;
  subject_template?: Maybe<Scalars['String']>;
}>;


export type UpdateCommunicationTemplateMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_communication_template?: Maybe<(
    { __typename?: 'risolto_communication_template_mutation_response' }
    & Pick<Risolto_Communication_Template_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename?: 'risolto_communication_template' }
      & Pick<Risolto_Communication_Template, 'reference'>
    )> }
  )> }
);

export type GetActionQueryVariables = Exact<{
  ref: Scalars['uuid'];
}>;


export type GetActionQuery = (
  { __typename?: 'query_root' }
  & { risolto_action: Array<(
    { __typename?: 'risolto_action' }
    & Pick<Risolto_Action, 'status' | 'assignee' | 'channel' | 'recipient' | 'reference' | 'metadata' | 'message_code' | 'participant' | 'primary_invoice' | 'legal_entity' | 'execution_type' | 'source' | 'executed_at' | 'original_action' | 'retry_count' | 'start_time' | 'due_date' | 'created_at' | 'channel_endpoint' | 'canceled_at' | 'updated_at'>
    & { assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'reference' | 'username'>
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'address' | 'balance_amount' | 'dunning_metadata' | 'last_dunning_at' | 'legal_id' | 'legal_id_type' | 'name' | 'type' | 'updated_by' | 'participant' | 'reference' | 'legal_entity' | 'account_id'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
      ) }
    )>, primary_invoice_by_reference?: Maybe<(
      { __typename?: 'risolto_invoice_document' }
      & Pick<Risolto_Invoice_Document, 'invoice_number'>
    )>, action_invoices: Array<(
      { __typename?: 'risolto_action_invoice' }
      & Pick<Risolto_Action_Invoice, 'reference' | 'relation'>
      & { invoice_by_reference: (
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
        & { recipient_by_reference?: Maybe<(
          { __typename?: 'risolto_recipient' }
          & Pick<Risolto_Recipient, 'reference' | 'name'>
        )>, legal_entity_by_reference: (
          { __typename?: 'risolto_legal_entity' }
          & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
        ), participant_by_reference: (
          { __typename?: 'risolto_participant' }
          & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
        ), interchange_links: Array<(
          { __typename?: 'risolto_document_interchange_link' }
          & { interchange_by_reference: (
            { __typename?: 'risolto_document_interchange' }
            & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
          ) }
        )> }
      ) }
    )>, legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name'>
      & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
    )>, channel_endpoint_by_reference?: Maybe<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'last_failed_delivery_at' | 'last_failed_delivery_type' | 'locale' | 'priority'>
    )> }
  )> }
);

export type ComponentsTimelineNote_UpdateNoteMutationVariables = Exact<{
  reference: Scalars['uuid'];
  note: Scalars['String'];
}>;


export type ComponentsTimelineNote_UpdateNoteMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_note?: Maybe<(
    { __typename?: 'risolto_note_mutation_response' }
    & { updated_count: Risolto_Note_Mutation_Response['affected_rows'] }
    & { updated: Array<(
      { __typename?: 'risolto_note' }
      & Pick<Risolto_Note, 'reference' | 'note'>
    )> }
  )> }
);

export type ComponentsActionTable_UserInterfaceDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ComponentsActionTable_UserInterfaceDetailsQuery = (
  { __typename?: 'query_root' }
  & { userInterfaceDetails: Array<(
    { __typename?: 'risolto_participant' }
    & { custom_field_definitions: Risolto_Participant['user_interface_details'], disallowed_channels: Risolto_Participant['user_interface_details'], disallowed_message_codes: Risolto_Participant['user_interface_details'] }
  )> }
);

export type GetNextActionsV3TotalQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntityFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
  recipient?: Maybe<Scalars['uuid']>;
  channels?: Maybe<Array<Risolto_Channel_Enum> | Risolto_Channel_Enum>;
  statuses?: Maybe<Array<Risolto_Action_Status_Enum> | Risolto_Action_Status_Enum>;
  msgCode?: Maybe<Scalars['String']>;
  executionTypes?: Maybe<Array<Risolto_Action_Execution_Type_Enum> | Risolto_Action_Execution_Type_Enum>;
  assigneeFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
  statusAndDateFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
  searchTermFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
  retryFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
}>;


export type GetNextActionsV3TotalQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_action_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_action_aggregate_fields' }
      & Pick<Risolto_Action_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type GetNextActionsV3QueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntityFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
  recipient?: Maybe<Scalars['uuid']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  channels?: Maybe<Array<Risolto_Channel_Enum> | Risolto_Channel_Enum>;
  statuses?: Maybe<Array<Risolto_Action_Status_Enum> | Risolto_Action_Status_Enum>;
  msgCode?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Array<Risolto_Action_Order_By> | Risolto_Action_Order_By>;
  executionTypes?: Maybe<Array<Risolto_Action_Execution_Type_Enum> | Risolto_Action_Execution_Type_Enum>;
  assigneeFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
  statusAndDateFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
  searchTermFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
  retryFilter?: Maybe<Array<Risolto_Action_Bool_Exp> | Risolto_Action_Bool_Exp>;
}>;


export type GetNextActionsV3Query = (
  { __typename?: 'query_root' }
  & { availableActions: Array<(
    { __typename?: 'risolto_action' }
    & Pick<Risolto_Action, 'reference' | 'status' | 'channel' | 'message_code' | 'is_retry' | 'execution_type' | 'source' | 'retry_count' | 'original_action' | 'start_time' | 'created_at' | 'executed_at' | 'canceled_at' | 'updated_at' | 'due_date' | 'metadata' | 'assignee' | 'recipient' | 'participant' | 'primary_invoice' | 'legal_entity' | 'custom_fields'>
    & { assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'reference' | 'username'>
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id' | 'legal_id' | 'legal_id_type' | 'type'>
    )>, primary_invoice_by_reference?: Maybe<(
      { __typename?: 'risolto_invoice_document' }
      & Pick<Risolto_Invoice_Document, 'invoice_number'>
    )>, legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name'>
      & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
    )> }
  )> }
);

export type ComponentsContacts_GetContactsQueryVariables = Exact<{
  recipient: Scalars['uuid'];
  participant: Scalars['uuid'];
}>;


export type ComponentsContacts_GetContactsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_contact_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_contact_aggregate_fields' }
      & Pick<Risolto_Contact_Aggregate_Fields, 'count'>
    )> }
  ), contacts: Array<(
    { __typename?: 'risolto_contact' }
    & Pick<Risolto_Contact, 'legal_entity' | 'locale' | 'participant' | 'first_name' | 'last_name' | 'full_name' | 'reference' | 'recipient' | 'custom_fields' | 'origin'>
    & { contact_type_by_reference?: Maybe<(
      { __typename?: 'risolto_contact_type' }
      & Pick<Risolto_Contact_Type, 'reference' | 'contact_type'>
    )>, channel_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'in_action' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'channel' | 'endpoint' | 'reference' | 'origin' | 'locale'>
    )> }
  )> }
);

export type ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity: Scalars['uuid'];
  recipient: Scalars['uuid'];
  invoices?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type ComponentsInvoiceDisputes_InvoiceDisputesQuery = (
  { __typename?: 'query_root' }
  & { invoice_disputes: Array<(
    { __typename?: 'risolto_invoice_dispute' }
    & Pick<Risolto_Invoice_Dispute, 'participant' | 'legal_entity' | 'reference' | 'until' | 'dispute_code'>
    & { dispute_code_by_reference: (
      { __typename?: 'risolto_dispute_code' }
      & Pick<Risolto_Dispute_Code, 'reference' | 'code' | 'default_assignee' | 'default_days_to_suspend'>
    ), tasks: Array<(
      { __typename?: 'risolto_task' }
      & Pick<Risolto_Task, 'participant' | 'legal_entity' | 'reference' | 'due_date' | 'assignee'>
      & { assignee_by_reference?: Maybe<(
        { __typename?: 'risolto_person' }
        & Pick<Risolto_Person, 'reference' | 'username'>
      )>, notes: Array<(
        { __typename?: 'risolto_note' }
        & Pick<Risolto_Note, 'note'>
      )> }
    )>, invoice: (
      { __typename?: 'risolto_invoice_document' }
      & Pick<Risolto_Invoice_Document, 'reference' | 'invoice_number' | 'open_amount' | 'total_amount' | 'amount_currency' | 'attachments' | 'custom_fields' | 'payment_reference'>
    ) }
  )> }
);

export type CancelInvoiceDisputeMutationVariables = Exact<{
  participant: Scalars['uuid'];
  legal_entity?: Maybe<Scalars['uuid']>;
  references: Array<Scalars['uuid']> | Scalars['uuid'];
  resolved_at: Scalars['timestamptz'];
  canceled_by: Scalars['uuid'];
}>;


export type CancelInvoiceDisputeMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_invoice_dispute?: Maybe<(
    { __typename?: 'risolto_invoice_dispute_mutation_response' }
    & Pick<Risolto_Invoice_Dispute_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename: 'risolto_invoice_dispute' }
      & Pick<Risolto_Invoice_Dispute, 'reference' | 'resolved_at'>
    )> }
  )>, update_risolto_task?: Maybe<(
    { __typename?: 'risolto_task_mutation_response' }
    & Pick<Risolto_Task_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename: 'risolto_task' }
      & Pick<Risolto_Task, 'reference' | 'status'>
    )> }
  )> }
);

export type AssignInvoiceDisputeMutationVariables = Exact<{
  participant: Scalars['uuid'];
  legal_entity?: Maybe<Scalars['uuid']>;
  references: Array<Scalars['uuid']> | Scalars['uuid'];
  assignee?: Maybe<Scalars['uuid']>;
}>;


export type AssignInvoiceDisputeMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_task?: Maybe<(
    { __typename?: 'risolto_task_mutation_response' }
    & Pick<Risolto_Task_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename: 'risolto_task' }
      & Pick<Risolto_Task, 'reference' | 'status'>
    )> }
  )> }
);

export type ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ComponentsInvoiceDisputes_UserInterfaceDetailsQuery = (
  { __typename?: 'query_root' }
  & { userInterfaceDetails: Array<(
    { __typename?: 'risolto_participant' }
    & { custom_field_definitions: Risolto_Participant['user_interface_details'] }
  )> }
);

export type DetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
}>;


export type DetailsQuery = (
  { __typename?: 'query_root' }
  & { recipient: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'legal_entity' | 'language_code' | 'preferred_invoicing_channel'>
    & { main_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'reference' | 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'origin' | 'locale'>
    )> }
  )> }
);

export type Actions_Grouped_TotalQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  isDueDate: Scalars['Boolean'];
  isStartTime: Scalars['Boolean'];
  isChannel: Scalars['Boolean'];
  isRecipient: Scalars['Boolean'];
  isMessageCode: Scalars['Boolean'];
  isReference: Scalars['Boolean'];
  isAssignee: Scalars['Boolean'];
  statuses?: Maybe<Scalars['_text']>;
  executionTypes?: Maybe<Scalars['_text']>;
  participants?: Maybe<Scalars['_uuid']>;
  legalEntities?: Maybe<Scalars['_uuid']>;
  startTimeFrom?: Maybe<Scalars['timestamp']>;
  startTimeUntil?: Maybe<Scalars['timestamp']>;
}>;


export type Actions_Grouped_TotalQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_virtual_action_group_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_virtual_action_group_aggregate_fields' }
      & Pick<Risolto_Virtual_Action_Group_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type Actions_GroupedQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  isDueDate: Scalars['Boolean'];
  isStartTime: Scalars['Boolean'];
  isChannel: Scalars['Boolean'];
  isRecipient: Scalars['Boolean'];
  isMessageCode: Scalars['Boolean'];
  isReference: Scalars['Boolean'];
  isAssignee: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: Maybe<Array<Risolto_Virtual_Action_Group_Order_By> | Risolto_Virtual_Action_Group_Order_By>;
  statuses?: Maybe<Scalars['_text']>;
  executionTypes?: Maybe<Scalars['_text']>;
  participants?: Maybe<Scalars['_uuid']>;
  legalEntities?: Maybe<Scalars['_uuid']>;
  startTimeFrom?: Maybe<Scalars['timestamp']>;
  startTimeUntil?: Maybe<Scalars['timestamp']>;
}>;


export type Actions_GroupedQuery = (
  { __typename?: 'query_root' }
  & { actions: Array<(
    { __typename?: 'risolto_virtual_action_group' }
    & Pick<Risolto_Virtual_Action_Group, 'v_reference' | 'reference' | 'action_count' | 'due_date' | 'due_date_count' | 'channel' | 'channel_count' | 'recipient' | 'recipient_count' | 'start_time' | 'start_time_count' | 'assignee_count' | 'message_code' | 'is_retry' | 'message_code_count'>
    & { action_by_reference?: Maybe<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'is_retry' | 'source' | 'channel_endpoint' | 'status' | 'original_action' | 'retry_count' | 'participant' | 'metadata' | 'reference' | 'execution_type' | 'recipient' | 'message_code' | 'channel' | 'due_date' | 'start_time' | 'assignee' | 'legal_entity' | 'custom_fields'>
      & { channel_endpoint_by_reference?: Maybe<(
        { __typename?: 'risolto_channel_endpoint' }
        & Pick<Risolto_Channel_Endpoint, 'channel' | 'endpoint' | 'endpoint_details' | 'deactivated_at' | 'deactivated_by' | 'last_failed_delivery_at' | 'last_failed_delivery_type' | 'locale' | 'priority'>
      )>, action_invoices: Array<(
        { __typename?: 'risolto_action_invoice' }
        & Pick<Risolto_Action_Invoice, 'relation' | 'invoice'>
        & { invoice_by_reference: (
          { __typename?: 'risolto_invoice_document' }
          & Pick<Risolto_Invoice_Document, 'invoice_number' | 'open_amount' | 'total_amount' | 'payment_reference' | 'due_date' | 'issue_date' | 'status' | 'recipient' | 'legal_entity' | 'participant' | 'reference' | 'amount_currency'>
          & { recipient_by_reference?: Maybe<(
            { __typename?: 'risolto_recipient' }
            & Pick<Risolto_Recipient, 'reference' | 'name'>
          )>, legal_entity_by_reference: (
            { __typename?: 'risolto_legal_entity' }
            & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name'>
          ), participant_by_reference: (
            { __typename?: 'risolto_participant' }
            & Pick<Risolto_Participant, 'name' | 'reference' | 'logical_id'>
          ), interchange_links: Array<(
            { __typename?: 'risolto_document_interchange_link' }
            & { interchange_by_reference: (
              { __typename?: 'risolto_document_interchange' }
              & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
            ) }
          )> }
        ) }
      )>, recipient_by_reference?: Maybe<(
        { __typename?: 'risolto_recipient' }
        & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id' | 'participant'>
      )>, legal_entity_by_reference?: Maybe<(
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name' | 'company_id' | 'company_id_type'>
        & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
      )>, assignee_by_reference?: Maybe<(
        { __typename?: 'risolto_person' }
        & Pick<Risolto_Person, 'reference' | 'username'>
      )> }
    )>, recipient_by_reference?: Maybe<(
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'name' | 'reference' | 'type' | 'participant' | 'legal_id_type' | 'legal_id' | 'legal_entity' | 'account_id'>
      & { contacts: Array<(
        { __typename?: 'risolto_contact' }
        & Pick<Risolto_Contact, 'reference' | 'first_name' | 'last_name'>
      )>, invoice_documents_aggregate: (
        { __typename?: 'risolto_invoice_document_aggregate' }
        & { aggregate?: Maybe<(
          { __typename?: 'risolto_invoice_document_aggregate_fields' }
          & { sum?: Maybe<(
            { __typename?: 'risolto_invoice_document_sum_fields' }
            & Pick<Risolto_Invoice_Document_Sum_Fields, 'open_amount' | 'total_amount'>
          )> }
        )> }
      ) }
    )>, assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )> }
  )> }
);

export type ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery = (
  { __typename?: 'query_root' }
  & { templates: Array<(
    { __typename?: 'risolto_communication_template' }
    & Pick<Risolto_Communication_Template, 'template_id' | 'channel' | 'document_name' | 'locale' | 'legal_entity' | 'participant' | 'subject_template' | 'template_query' | 'template_renderer_version' | 'ui_template_configuration'>
  )> }
);

export type Unnamed_1_QueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type Unnamed_1_Query = (
  { __typename?: 'query_root' }
  & { dispute_codes: Array<(
    { __typename?: 'risolto_dispute_code' }
    & Pick<Risolto_Dispute_Code, 'reference' | 'code' | 'default_assignee' | 'default_days_to_suspend'>
  )> }
);

export type ViewsCreditNotes_DetailQueryVariables = Exact<{
  credit_note: Scalars['uuid'];
}>;


export type ViewsCreditNotes_DetailQuery = (
  { __typename?: 'query_root' }
  & { creditNote: Array<(
    { __typename?: 'risolto_credit_note' }
    & Pick<Risolto_Credit_Note, 'credit_note_number' | 'amount_currency' | 'issue_date' | 'due_date' | 'reference' | 'file_references' | 'legal_entity' | 'total_amount' | 'open_amount' | 'participant' | 'recipient' | 'dunning_status' | 'custom_fields'>
    & { legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name' | 'reference' | 'participant' | 'address' | 'company_id' | 'company_id_type'>
    ), interchange_links: Array<(
      { __typename?: 'risolto_document_interchange_link' }
      & Pick<Risolto_Document_Interchange_Link, 'reference'>
      & { interchange_by_reference: (
        { __typename?: 'risolto_document_interchange' }
        & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
        & { interchange_events?: Maybe<Array<(
          { __typename?: 'risolto_virtual_interchange_event' }
          & Pick<Risolto_Virtual_Interchange_Event, 'event_type' | 'event_type_count' | 'last_event_timestamp'>
          & { email: Risolto_Virtual_Interchange_Event['channel_endpoint'], postal_mail: Risolto_Virtual_Interchange_Event['channel_endpoint'] }
        )>> }
      ) }
    )>, recipient_by_reference: (
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'preferred_invoicing_channel' | 'legal_entity' | 'participant' | 'reference' | 'legal_id' | 'legal_id_type' | 'address' | 'name' | 'account_id'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference'>
      ) }
    ) }
  )> }
);

export type ViewsCreditNotes_UserInterfaceDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ViewsCreditNotes_UserInterfaceDetailsQuery = (
  { __typename?: 'query_root' }
  & { userInterfaceDetails: Array<(
    { __typename?: 'risolto_participant' }
    & { custom_field_definitions: Risolto_Participant['user_interface_details'] }
  )> }
);

export type ViewsDebitNotes_DetailQueryVariables = Exact<{
  debit_note: Scalars['uuid'];
}>;


export type ViewsDebitNotes_DetailQuery = (
  { __typename?: 'query_root' }
  & { debitNote: Array<(
    { __typename?: 'risolto_debit_note' }
    & Pick<Risolto_Debit_Note, 'debit_note_number' | 'amount_currency' | 'issue_date' | 'due_date' | 'reference' | 'file_references' | 'legal_entity' | 'total_amount' | 'open_amount' | 'participant' | 'recipient' | 'dunning_status' | 'custom_fields'>
    & { legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name' | 'reference' | 'participant' | 'address' | 'company_id' | 'company_id_type'>
    )>, interchange_links: Array<(
      { __typename?: 'risolto_document_interchange_link' }
      & Pick<Risolto_Document_Interchange_Link, 'reference'>
      & { interchange_by_reference: (
        { __typename?: 'risolto_document_interchange' }
        & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
        & { interchange_events?: Maybe<Array<(
          { __typename?: 'risolto_virtual_interchange_event' }
          & Pick<Risolto_Virtual_Interchange_Event, 'event_type' | 'event_type_count' | 'last_event_timestamp'>
          & { email: Risolto_Virtual_Interchange_Event['channel_endpoint'], postal_mail: Risolto_Virtual_Interchange_Event['channel_endpoint'] }
        )>> }
      ) }
    )>, recipient_by_reference: (
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'preferred_invoicing_channel' | 'legal_entity' | 'participant' | 'reference' | 'legal_id' | 'legal_id_type' | 'address' | 'name' | 'account_id'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference'>
      ) }
    ) }
  )> }
);

export type ViewsDebitNotes_UserInterfaceDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ViewsDebitNotes_UserInterfaceDetailsQuery = (
  { __typename?: 'query_root' }
  & { userInterfaceDetails: Array<(
    { __typename?: 'risolto_participant' }
    & { custom_field_definitions: Risolto_Participant['user_interface_details'] }
  )> }
);

export type ViewsDialogsActionDetail__LanguagesQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity: Scalars['uuid'];
  channel: Risolto_Channel_Enum;
  templateId: Scalars['String'];
}>;


export type ViewsDialogsActionDetail__LanguagesQuery = (
  { __typename?: 'query_root' }
  & { custom: Array<(
    { __typename?: 'risolto_communication_template' }
    & Pick<Risolto_Communication_Template, 'template_id' | 'participant' | 'locale'>
  )>, generic: Array<(
    { __typename?: 'risolto_communication_template' }
    & Pick<Risolto_Communication_Template, 'template_id' | 'participant' | 'locale'>
  )> }
);

export type TemplatesQueryVariables = Exact<{
  participant: Scalars['uuid'];
  channel: Risolto_Channel_Enum;
}>;


export type TemplatesQuery = (
  { __typename?: 'query_root' }
  & { risolto_communication_template: Array<(
    { __typename?: 'risolto_communication_template' }
    & Pick<Risolto_Communication_Template, 'template_id'>
  )> }
);

export type ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ViewsDialogsActionDetail_UserInterfaceDetailsQuery = (
  { __typename?: 'query_root' }
  & { userInterfaceDetails: Array<(
    { __typename?: 'risolto_participant' }
    & { custom_field_definitions: Risolto_Participant['user_interface_details'], disallowed_channels: Risolto_Participant['user_interface_details'], disallowed_message_codes: Risolto_Participant['user_interface_details'] }
  )> }
);

export type ViewsDialogsActionDetail_RecipientRecordQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
  today: Scalars['date'];
}>;


export type ViewsDialogsActionDetail_RecipientRecordQuery = (
  { __typename?: 'query_root' }
  & { risolto_recipient: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'reference' | 'name' | 'last_dunning_costs'>
    & { legal_entity: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference'>
    ), payment_plans: Array<(
      { __typename?: 'risolto_payment_plan' }
      & { invoice_group_by_reference: (
        { __typename?: 'risolto_invoice_group' }
        & { invoice_group_invoices: Array<(
          { __typename?: 'risolto_invoice_group_invoice' }
          & Pick<Risolto_Invoice_Group_Invoice, 'invoice'>
        )>, invoice_group_credit_notes: Array<(
          { __typename?: 'risolto_invoice_group_credit_note' }
          & Pick<Risolto_Invoice_Group_Credit_Note, 'credit_note'>
        )>, invoice_group_debit_notes: Array<(
          { __typename?: 'risolto_invoice_group_debit_note' }
          & Pick<Risolto_Invoice_Group_Debit_Note, 'debit_note'>
        )>, invoice_group_payments: Array<(
          { __typename?: 'risolto_invoice_group_payment' }
          & Pick<Risolto_Invoice_Group_Payment, 'payment'>
        )> }
      ) }
    )>, invoice_documents: Array<(
      { __typename?: 'risolto_invoice_document' }
      & Pick<Risolto_Invoice_Document, 'reference' | 'invoice_number' | 'open_amount' | 'due_date' | 'file_references'>
      & { invoice_dispute: Array<(
        { __typename?: 'risolto_invoice_dispute' }
        & Pick<Risolto_Invoice_Dispute, 'reference' | 'until'>
        & { dispute_code_by_reference: (
          { __typename?: 'risolto_dispute_code' }
          & Pick<Risolto_Dispute_Code, 'code'>
        ) }
      )> }
    )>, credit_notes: Array<(
      { __typename?: 'risolto_credit_note' }
      & Pick<Risolto_Credit_Note, 'reference' | 'credit_note_number' | 'issue_date' | 'open_amount' | 'file_references'>
    )>, debit_notes: Array<(
      { __typename?: 'risolto_debit_note' }
      & Pick<Risolto_Debit_Note, 'reference' | 'debit_note_number' | 'issue_date' | 'open_amount'>
    )>, payment_documents: Array<(
      { __typename?: 'risolto_payment_document' }
      & Pick<Risolto_Payment_Document, 'reference' | 'payment_number' | 'issue_date' | 'open_amount'>
    )> }
  )> }
);

export type ViewsDialogsActionDetail_DunningNoticeQueryVariables = Exact<{
  participant: Scalars['uuid'];
  action: Scalars['uuid'];
}>;


export type ViewsDialogsActionDetail_DunningNoticeQuery = (
  { __typename?: 'query_root' }
  & { risolto_action: Array<(
    { __typename?: 'risolto_action' }
    & Pick<Risolto_Action, 'reference' | 'metadata'>
    & { dunning_notice_by_reference?: Maybe<(
      { __typename?: 'risolto_dunning_notice' }
      & Pick<Risolto_Dunning_Notice, 'charges' | 'interest'>
      & { invoice_group_by_reference?: Maybe<(
        { __typename?: 'risolto_invoice_group' }
        & { invoice_group_credit_notes: Array<(
          { __typename?: 'risolto_invoice_group_credit_note' }
          & Pick<Risolto_Invoice_Group_Credit_Note, 'credit_note'>
        )>, invoice_group_debit_notes: Array<(
          { __typename?: 'risolto_invoice_group_debit_note' }
          & Pick<Risolto_Invoice_Group_Debit_Note, 'debit_note'>
        )>, invoice_group_invoices: Array<(
          { __typename?: 'risolto_invoice_group_invoice' }
          & Pick<Risolto_Invoice_Group_Invoice, 'invoice'>
        )>, invoice_group_payments: Array<(
          { __typename?: 'risolto_invoice_group_payment' }
          & Pick<Risolto_Invoice_Group_Payment, 'payment'>
        )> }
      )> }
    )> }
  )> }
);

export type ViewsDialogsActionDetail_EmailAddressFromQueryVariables = Exact<{
  participant: Scalars['uuid'];
  action: Scalars['uuid'];
}>;


export type ViewsDialogsActionDetail_EmailAddressFromQuery = (
  { __typename?: 'query_root' }
  & { risolto_action: Array<(
    { __typename?: 'risolto_action' }
    & { channel_from: Risolto_Action['metadata'] }
    & { legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & { outbound_channel_communication_email_addresses: Risolto_Legal_Entity['processing_details'] }
    )> }
  )> }
);

export type ViewsInvoiceDisputes_DisputeCodesQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ViewsInvoiceDisputes_DisputeCodesQuery = (
  { __typename?: 'query_root' }
  & { disputeCodes: Array<(
    { __typename?: 'risolto_dispute_code' }
    & Pick<Risolto_Dispute_Code, 'reference' | 'code' | 'default_assignee' | 'default_days_to_suspend'>
  )> }
);

export type ViewsInvoiceDisputes_AssignInvoiceDisputeMutationVariables = Exact<{
  participant: Scalars['uuid'];
  legal_entity?: Maybe<Scalars['uuid']>;
  references: Array<Scalars['uuid']> | Scalars['uuid'];
  assignee?: Maybe<Scalars['uuid']>;
}>;


export type ViewsInvoiceDisputes_AssignInvoiceDisputeMutation = (
  { __typename?: 'mutation_root' }
  & { update_risolto_task?: Maybe<(
    { __typename?: 'risolto_task_mutation_response' }
    & Pick<Risolto_Task_Mutation_Response, 'affected_rows'>
    & { returning: Array<(
      { __typename: 'risolto_task' }
      & Pick<Risolto_Task, 'reference' | 'status'>
    )> }
  )> }
);

export type ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables = Exact<{
  recipient: Scalars['uuid'];
}>;


export type ViewsInvoiceDisputesRecipient_RecipientRecordQuery = (
  { __typename?: 'query_root' }
  & { recipientRecord?: Maybe<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'reference' | 'name' | 'legal_entity' | 'custom_fields'>
  )> }
);

export type ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables = Exact<{
  recipient: Scalars['uuid'];
}>;


export type ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery = (
  { __typename?: 'query_root' }
  & { recipientAttachments: Array<(
    { __typename?: 'risolto_recipient_attachment' }
    & Pick<Risolto_Recipient_Attachment, 'metadata'>
  )> }
);

export type ViewsInvoiceDisputes_TasksQueryVariables = Exact<{
  where: Risolto_Task_Bool_Exp;
}>;


export type ViewsInvoiceDisputes_TasksQuery = (
  { __typename?: 'query_root' }
  & { tasks: Array<(
    { __typename?: 'risolto_task' }
    & Pick<Risolto_Task, 'reference' | 'due_date' | 'status'>
    & { assignee_by_reference?: Maybe<(
      { __typename?: 'risolto_person' }
      & Pick<Risolto_Person, 'username'>
    )>, invoice_dispute_by_reference?: Maybe<(
      { __typename?: 'risolto_invoice_dispute' }
      & Pick<Risolto_Invoice_Dispute, 'reference' | 'from' | 'until' | 'resolved_at'>
      & { dispute_code_by_reference: (
        { __typename?: 'risolto_dispute_code' }
        & Pick<Risolto_Dispute_Code, 'code'>
      ), invoice: (
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'reference' | 'invoice_number' | 'issue_date' | 'due_date' | 'open_amount' | 'amount_currency'>
      ), recipient: (
        { __typename?: 'risolto_recipient' }
        & Pick<Risolto_Recipient, 'reference' | 'legal_entity' | 'name' | 'currency'>
      ) }
    )> }
  )> }
);

export type ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ViewsInvoiceDisputes_UserInterfaceDetailsQuery = (
  { __typename?: 'query_root' }
  & { userInterfaceDetails: Array<(
    { __typename?: 'risolto_participant' }
    & { contact_allow_edit: Risolto_Participant['user_interface_details'], recipient_allow_edit: Risolto_Participant['user_interface_details'], custom_field_definitions: Risolto_Participant['user_interface_details'], credit_note_custom_field_definitions: Risolto_Participant['user_interface_details'], debit_note_custom_field_definitions: Risolto_Participant['user_interface_details'], payment_document_custom_field_definitions: Risolto_Participant['user_interface_details'] }
  )> }
);

export type ViewsInvoices_UserInterfaceDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ViewsInvoices_UserInterfaceDetailsQuery = (
  { __typename?: 'query_root' }
  & { userInterfaceDetails: Array<(
    { __typename?: 'risolto_participant' }
    & { custom_field_definitions: Risolto_Participant['user_interface_details'] }
  )> }
);

export type ComponentsMessagesTable_MessagesTotalQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntity?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  assignees?: Maybe<Scalars['_uuid']>;
  dateStart?: Maybe<Scalars['timestamptz']>;
  dateEnd?: Maybe<Scalars['timestamptz']>;
  archivedIsNull?: Maybe<Scalars['Boolean']>;
  direction?: Maybe<Scalars['String']>;
  isLinked?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
}>;


export type ComponentsMessagesTable_MessagesTotalQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_view_action_and_message_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_view_action_and_message_aggregate_fields' }
      & Pick<Risolto_View_Action_And_Message_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type ComponentsMessagesTable_MessagesQueryVariables = Exact<{
  participant: Scalars['uuid'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  legalEntity?: Maybe<Scalars['uuid']>;
  recipient?: Maybe<Scalars['uuid']>;
  assignees?: Maybe<Scalars['_uuid']>;
  dateStart?: Maybe<Scalars['timestamptz']>;
  dateEnd?: Maybe<Scalars['timestamptz']>;
  archivedIsNull?: Maybe<Scalars['Boolean']>;
  direction?: Maybe<Scalars['String']>;
  isLinked?: Maybe<Scalars['Boolean']>;
  searchTerm?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Array<Risolto_View_Action_And_Message_Order_By> | Risolto_View_Action_And_Message_Order_By>;
}>;


export type ComponentsMessagesTable_MessagesQuery = (
  { __typename?: 'query_root' }
  & { messages: Array<(
    { __typename?: 'risolto_view_action_and_message' }
    & Pick<Risolto_View_Action_And_Message, 'reference' | 'message' | 'action' | 'from_' | 'subject' | 'direction' | 'received_at' | 'archived_at' | 'metadata' | 'is_linked'>
    & { action_by_reference?: Maybe<(
      { __typename?: 'risolto_action' }
      & Pick<Risolto_Action, 'reference' | 'status' | 'channel' | 'message_code' | 'is_retry' | 'execution_type' | 'source' | 'retry_count' | 'original_action' | 'start_time' | 'created_at' | 'executed_at' | 'canceled_at' | 'updated_at' | 'due_date' | 'metadata' | 'assignee' | 'recipient' | 'participant' | 'primary_invoice' | 'legal_entity' | 'custom_fields'>
      & { assignee_by_reference?: Maybe<(
        { __typename?: 'risolto_person' }
        & Pick<Risolto_Person, 'reference' | 'username'>
      )>, recipient_by_reference?: Maybe<(
        { __typename?: 'risolto_recipient' }
        & Pick<Risolto_Recipient, 'reference' | 'name' | 'account_id' | 'legal_id' | 'legal_id_type' | 'type'>
      )>, primary_invoice_by_reference?: Maybe<(
        { __typename?: 'risolto_invoice_document' }
        & Pick<Risolto_Invoice_Document, 'invoice_number'>
      )>, legal_entity_by_reference?: Maybe<(
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'registration_name'>
        & { outbound_channel: Risolto_Legal_Entity['processing_details'] }
      )>, action_interchanges: Array<(
        { __typename?: 'risolto_action_interchange' }
        & { interchange_by_reference: (
          { __typename?: 'risolto_document_interchange' }
          & { interchange_events?: Maybe<Array<(
            { __typename?: 'risolto_virtual_interchange_event' }
            & Pick<Risolto_Virtual_Interchange_Event, 'event_type' | 'last_event_timestamp'>
          )>> }
        ) }
      )> }
    )>, message_by_reference?: Maybe<(
      { __typename?: 'risolto_message' }
      & { message_recipients: Array<(
        { __typename?: 'risolto_message_recipient' }
        & { recipient_by_reference: (
          { __typename?: 'risolto_recipient' }
          & Pick<Risolto_Recipient, 'reference' | 'account_id' | 'name'>
        ) }
      )>, message_assignees: Array<(
        { __typename?: 'risolto_message_assignee' }
        & { person_by_reference: (
          { __typename?: 'risolto_person' }
          & Pick<Risolto_Person, 'reference' | 'username'>
        ) }
      )>, message_attachments: Array<(
        { __typename?: 'risolto_message_attachment' }
        & Pick<Risolto_Message_Attachment, 'reference'>
      )> }
    )> }
  )> }
);

export type Risolto_Participant_AggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type Risolto_Participant_AggregateQuery = (
  { __typename?: 'query_root' }
  & { risolto_participant_aggregate: (
    { __typename?: 'risolto_participant_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_participant_aggregate_fields' }
      & Pick<Risolto_Participant_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type ViewPaymentPlanCreate_RecipientRecordQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
}>;


export type ViewPaymentPlanCreate_RecipientRecordQuery = (
  { __typename?: 'query_root' }
  & { risolto_recipient: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'reference' | 'name' | 'currency'>
    & { legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference'>
      & { payment_plan_conditions: Risolto_Legal_Entity['processing_details'] }
    ), invoice_documents: Array<(
      { __typename?: 'risolto_invoice_document' }
      & Pick<Risolto_Invoice_Document, 'reference' | 'invoice_number' | 'open_amount' | 'due_date' | 'amount_currency'>
    )>, credit_notes: Array<(
      { __typename?: 'risolto_credit_note' }
      & Pick<Risolto_Credit_Note, 'reference' | 'credit_note_number' | 'issue_date' | 'open_amount' | 'amount_currency'>
    )>, debit_notes: Array<(
      { __typename?: 'risolto_debit_note' }
      & Pick<Risolto_Debit_Note, 'reference' | 'debit_note_number' | 'issue_date' | 'open_amount' | 'amount_currency'>
    )>, payment_documents: Array<(
      { __typename?: 'risolto_payment_document' }
      & Pick<Risolto_Payment_Document, 'reference' | 'payment_number' | 'issue_date' | 'open_amount' | 'amount_currency'>
    )> }
  )> }
);

export type ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables = Exact<{
  participant: Scalars['uuid'];
  paymentPlan: Scalars['uuid'];
}>;


export type ViewPaymentPlanEdit_PaymentPlanRecordQuery = (
  { __typename?: 'query_root' }
  & { risolto_payment_plan: Array<(
    { __typename?: 'risolto_payment_plan' }
    & Pick<Risolto_Payment_Plan, 'reference' | 'total_amount' | 'open_amount' | 'due_amount' | 'amount_currency' | 'conditions' | 'status' | 'canceled_at' | 'legal_entity' | 'recipient'>
    & { recipient_by_reference: (
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'name' | 'currency'>
    ), payment_promises: Array<(
      { __typename?: 'risolto_payment_promise' }
      & Pick<Risolto_Payment_Promise, 'reference' | 'payment_reference' | 'due_date' | 'total_amount' | 'open_amount' | 'amount_currency'>
    )>, invoice_group_by_reference: (
      { __typename?: 'risolto_invoice_group' }
      & { invoice_group_invoices: Array<(
        { __typename?: 'risolto_invoice_group_invoice' }
        & { invoice_by_reference: (
          { __typename?: 'risolto_invoice_document' }
          & Pick<Risolto_Invoice_Document, 'reference' | 'invoice_number' | 'due_date' | 'open_amount' | 'amount_currency'>
        ) }
      )>, invoice_group_credit_notes: Array<(
        { __typename?: 'risolto_invoice_group_credit_note' }
        & { credit_note_by_reference: (
          { __typename?: 'risolto_credit_note' }
          & Pick<Risolto_Credit_Note, 'reference' | 'credit_note_number' | 'issue_date' | 'open_amount' | 'amount_currency'>
        ) }
      )>, invoice_group_debit_notes: Array<(
        { __typename?: 'risolto_invoice_group_debit_note' }
        & { debit_note_by_reference: (
          { __typename?: 'risolto_debit_note' }
          & Pick<Risolto_Debit_Note, 'reference' | 'debit_note_number' | 'issue_date' | 'open_amount' | 'amount_currency'>
        ) }
      )>, invoice_group_payments: Array<(
        { __typename?: 'risolto_invoice_group_payment' }
        & { payment_by_reference: (
          { __typename?: 'risolto_payment_document' }
          & Pick<Risolto_Payment_Document, 'reference' | 'payment_number' | 'issue_date' | 'open_amount' | 'amount_currency'>
        ) }
      )> }
    ) }
  )> }
);

export type ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables = Exact<{
  payment_transfer: Scalars['uuid'];
  participant: Scalars['uuid'];
}>;


export type ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery = (
  { __typename?: 'query_root' }
  & { records: Array<(
    { __typename?: 'risolto_payment_transfer_bulk_payment' }
    & Pick<Risolto_Payment_Transfer_Bulk_Payment, 'external_account_id' | 'external_status' | 'external_system' | 'idempotency_key' | 'short_description' | 'signing_link' | 'created_at' | 'error_at' | 'finished_at' | 'last_updated' | 'updated_at' | 'external_bulk_payment_id' | 'legal_entity' | 'participant' | 'payment_transfer' | 'reference'>
  )> }
);

export type ViewsBulkPayments_GetBulkPaymentsQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legal_entity: Scalars['uuid'];
}>;


export type ViewsBulkPayments_GetBulkPaymentsQuery = (
  { __typename?: 'query_root' }
  & { created: Array<(
    { __typename?: 'risolto_payment_transfer' }
    & Pick<Risolto_Payment_Transfer, 'reference' | 'group_date'>
    & { total_amount: (
      { __typename?: 'risolto_payment_transfer_line_aggregate' }
      & { aggregate?: Maybe<(
        { __typename?: 'risolto_payment_transfer_line_aggregate_fields' }
        & Pick<Risolto_Payment_Transfer_Line_Aggregate_Fields, 'count'>
        & { sum?: Maybe<(
          { __typename?: 'risolto_payment_transfer_line_sum_fields' }
          & Pick<Risolto_Payment_Transfer_Line_Sum_Fields, 'amount'>
        )> }
      )> }
    ) }
  )>, executed: Array<(
    { __typename?: 'risolto_payment_transfer_bulk_payment' }
    & Pick<Risolto_Payment_Transfer_Bulk_Payment, 'short_description' | 'signing_link' | 'created_at' | 'error_at' | 'finished_at' | 'last_updated' | 'updated_at' | 'legal_entity' | 'participant' | 'payment_transfer' | 'reference'>
    & { details: (
      { __typename?: 'risolto_payment_transfer' }
      & { total_amount: (
        { __typename?: 'risolto_payment_transfer_line_aggregate' }
        & { aggregate?: Maybe<(
          { __typename?: 'risolto_payment_transfer_line_aggregate_fields' }
          & Pick<Risolto_Payment_Transfer_Line_Aggregate_Fields, 'count'>
          & { sum?: Maybe<(
            { __typename?: 'risolto_payment_transfer_line_sum_fields' }
            & Pick<Risolto_Payment_Transfer_Line_Sum_Fields, 'amount'>
          )> }
        )> }
      ) }
    ) }
  )> }
);

export type ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables = Exact<{
  reference: Scalars['uuid'];
  participant: Scalars['uuid'];
}>;


export type ViewsBulkPayment_GetPaymentTransferConfigurationQuery = (
  { __typename?: 'query_root' }
  & { legal_entity: Array<(
    { __typename?: 'risolto_legal_entity' }
    & Pick<Risolto_Legal_Entity, 'reference' | 'participant'>
    & { payment_transfer_configuration: Risolto_Legal_Entity['processing_details'] }
  )> }
);

export type ViewsPaymentTransfer_PaymentTransfersQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legal_entity: Scalars['uuid'];
}>;


export type ViewsPaymentTransfer_PaymentTransfersQuery = (
  { __typename?: 'query_root' }
  & { records: Array<(
    { __typename?: 'risolto_payment_transfer' }
    & Pick<Risolto_Payment_Transfer, 'reference' | 'group_date' | 'account_number' | 'account_number_type' | 'bank_identifier' | 'bank_identifier_type' | 'creditor_name' | 'status' | 'created_at' | 'updated_at' | 'legal_entity' | 'participant' | 'idempotency_key'>
  )> }
);

export type ViewsPaymentDocuments_DetailQueryVariables = Exact<{
  payment_document: Scalars['uuid'];
}>;


export type ViewsPaymentDocuments_DetailQuery = (
  { __typename?: 'query_root' }
  & { paymentDocument: Array<(
    { __typename?: 'risolto_payment_document' }
    & Pick<Risolto_Payment_Document, 'payment_number' | 'amount_currency' | 'issue_date' | 'due_date' | 'reference' | 'file_references' | 'legal_entity' | 'total_amount' | 'open_amount' | 'participant' | 'recipient' | 'dunning_status' | 'custom_fields'>
    & { legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name' | 'reference' | 'participant' | 'address' | 'company_id' | 'company_id_type'>
    )>, interchange_links: Array<(
      { __typename?: 'risolto_document_interchange_link' }
      & Pick<Risolto_Document_Interchange_Link, 'reference'>
      & { interchange_by_reference: (
        { __typename?: 'risolto_document_interchange' }
        & Pick<Risolto_Document_Interchange, 'reference' | 'channel' | 'direction'>
        & { interchange_events?: Maybe<Array<(
          { __typename?: 'risolto_virtual_interchange_event' }
          & Pick<Risolto_Virtual_Interchange_Event, 'event_type' | 'event_type_count' | 'last_event_timestamp'>
          & { email: Risolto_Virtual_Interchange_Event['channel_endpoint'], postal_mail: Risolto_Virtual_Interchange_Event['channel_endpoint'] }
        )>> }
      ) }
    )>, recipient_by_reference: (
      { __typename?: 'risolto_recipient' }
      & Pick<Risolto_Recipient, 'preferred_invoicing_channel' | 'legal_entity' | 'participant' | 'reference' | 'legal_id' | 'legal_id_type' | 'address' | 'name' | 'account_id'>
      & { legal_entity_by_reference: (
        { __typename?: 'risolto_legal_entity' }
        & Pick<Risolto_Legal_Entity, 'reference'>
      ) }
    ) }
  )> }
);

export type ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables = Exact<{
  participant: Scalars['uuid'];
}>;


export type ViewsPaymentDocuments_UserInterfaceDetailsQuery = (
  { __typename?: 'query_root' }
  & { userInterfaceDetails: Array<(
    { __typename?: 'risolto_participant' }
    & { custom_field_definitions: Risolto_Participant['user_interface_details'] }
  )> }
);

export type ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables = Exact<{
  recipient: Scalars['uuid'];
}>;


export type ViewsRecipientRecipientDetail_RecipientAttachmentsQuery = (
  { __typename?: 'query_root' }
  & { recipientAttachments: Array<(
    { __typename?: 'risolto_recipient_attachment' }
    & Pick<Risolto_Recipient_Attachment, 'metadata'>
  )> }
);

export type ViewsRecipient_RecipientsTotalQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntityFilter?: Maybe<Array<Risolto_Recipient_Bool_Exp> | Risolto_Recipient_Bool_Exp>;
  searchTermFilter?: Maybe<Array<Risolto_Recipient_Bool_Exp> | Risolto_Recipient_Bool_Exp>;
  tagsFilter?: Maybe<Array<Risolto_Recipient_Bool_Exp> | Risolto_Recipient_Bool_Exp>;
  customFieldsFilter?: Maybe<Array<Risolto_Recipient_Bool_Exp> | Risolto_Recipient_Bool_Exp>;
}>;


export type ViewsRecipient_RecipientsTotalQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_recipient_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_recipient_aggregate_fields' }
      & Pick<Risolto_Recipient_Aggregate_Fields, 'count'>
    )> }
  ) }
);

export type ViewsRecipient_RecipientsQueryVariables = Exact<{
  participant: Scalars['uuid'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  legalEntityFilter?: Maybe<Array<Risolto_Recipient_Bool_Exp> | Risolto_Recipient_Bool_Exp>;
  searchTermFilter?: Maybe<Array<Risolto_Recipient_Bool_Exp> | Risolto_Recipient_Bool_Exp>;
  tagsFilter?: Maybe<Array<Risolto_Recipient_Bool_Exp> | Risolto_Recipient_Bool_Exp>;
  customFieldsFilter?: Maybe<Array<Risolto_Recipient_Bool_Exp> | Risolto_Recipient_Bool_Exp>;
  orderBy?: Maybe<Array<Risolto_Recipient_Order_By> | Risolto_Recipient_Order_By>;
}>;


export type ViewsRecipient_RecipientsQuery = (
  { __typename?: 'query_root' }
  & { recipients: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'name' | 'reference' | 'type' | 'participant' | 'legal_id_type' | 'legal_id' | 'legal_entity' | 'account_id'>
  )> }
);

export type ViewsRecipient_RecipientQueryVariables = Exact<{
  participant: Scalars['uuid'];
  recipient: Scalars['uuid'];
}>;


export type ViewsRecipient_RecipientQuery = (
  { __typename?: 'query_root' }
  & { risolto_recipient: Array<(
    { __typename?: 'risolto_recipient' }
    & Pick<Risolto_Recipient, 'last_dunning_costs' | 'in_collection' | 'last_dunning_run_at' | 'name' | 'account_id' | 'participant' | 'legal_entity' | 'address' | 'due_balance_amount' | 'balance_amount' | 'currency' | 'reference' | 'custom_fields' | 'legal_id_type' | 'legal_id' | 'type' | 'dunning_is_dirty' | 'prediction_stars'>
    & { participant_by_reference: (
      { __typename?: 'risolto_participant' }
      & Pick<Risolto_Participant, 'reference'>
    ), legal_entity_by_reference: (
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'reference' | 'registration_name' | 'company_id' | 'company_id_type'>
      & { payment_plan: Risolto_Legal_Entity['processing_details'] }
    ), contacts: Array<(
      { __typename?: 'risolto_contact' }
      & Pick<Risolto_Contact, 'reference' | 'first_name' | 'last_name'>
    )>, channel_endpoints: Array<(
      { __typename?: 'risolto_channel_endpoint' }
      & Pick<Risolto_Channel_Endpoint, 'channel'>
      & { contact_by_reference?: Maybe<(
        { __typename?: 'risolto_contact' }
        & Pick<Risolto_Contact, 'first_name' | 'last_name'>
      )> }
    )>, tags: Array<(
      { __typename?: 'risolto_view_recipient_tag' }
      & Pick<Risolto_View_Recipient_Tag, 'tag' | 'tag_name' | 'can_remove'>
    )>, collections: Array<(
      { __typename?: 'risolto_recipient_collection' }
      & Pick<Risolto_Recipient_Collection, 'custom_fields'>
    )>, message_recipients: Array<(
      { __typename?: 'risolto_message_recipient' }
      & Pick<Risolto_Message_Recipient, 'reference'>
    )> }
  )> }
);

export type ViewsReports_ReportsQueryVariables = Exact<{
  participant: Scalars['uuid'];
  legalEntityFilter?: Maybe<Array<Risolto_Report_Execution_Bool_Exp> | Risolto_Report_Execution_Bool_Exp>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type ViewsReports_ReportsQuery = (
  { __typename?: 'query_root' }
  & { total: (
    { __typename?: 'risolto_report_execution_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'risolto_report_execution_aggregate_fields' }
      & Pick<Risolto_Report_Execution_Aggregate_Fields, 'count'>
    )> }
  ), reports: Array<(
    { __typename?: 'risolto_report_execution' }
    & Pick<Risolto_Report_Execution, 'reference' | 'report_path' | 'completed_at'>
    & { legal_entity_by_reference?: Maybe<(
      { __typename?: 'risolto_legal_entity' }
      & Pick<Risolto_Legal_Entity, 'registration_name'>
    )>, report_definition_by_reference: (
      { __typename?: 'risolto_report_definition' }
      & Pick<Risolto_Report_Definition, 'name' | 'report_template_type'>
    ) }
  )> }
);

export const ActionsFragmentDetailsFields = gql`
    fragment actionsFragmentDetailsFields on risolto_action {
  status
  channel
  recipient
  recipient_by_reference {
    address
    balance_amount
    dunning_metadata
    last_dunning_at
    legal_id
    legal_id_type
    name
    account_id
    type
    updated_by
    participant
    reference
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
  }
  reference
  metadata
  message_code
  participant
  primary_invoice
  primary_invoice_by_reference {
    invoice_number
  }
  action_invoices {
    reference
    relation
    invoice_by_reference {
      invoice_number
      open_amount
      total_amount
      payment_reference
      due_date
      issue_date
      status
      recipient
      recipient_by_reference {
        reference
        name
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
      participant
      participant_by_reference {
        name
        reference
        logical_id
      }
      reference
      amount_currency
      interchange_links {
        interchange_by_reference {
          reference
          channel
          direction
        }
      }
    }
  }
  legal_entity
  execution_type
  source
  executed_at
  original_action
  retry_count
  start_time
  due_date
  recipient
  recipient_by_reference {
    reference
    name
    account_id
    participant
  }
  legal_entity_by_reference {
    registration_name
    outbound_channel: processing_details(path: "outbound_channel")
  }
  created_at
  assignee
  assignee_by_reference {
    username
  }
  channel_endpoint
  channel_endpoint_by_reference {
    channel
    endpoint
    endpoint_details
    deactivated_at
    deactivated_by
    last_failed_delivery_at
    last_failed_delivery_type
    locale
    priority
  }
}
    `;
export const GetCreditNotes = gql`
    query getCreditNotes($participant: uuid!, $recipient: uuid!, $offset: Int, $limit: Int) {
  total: risolto_credit_note_aggregate(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
  ) {
    aggregate {
      count
    }
  }
  risolto_credit_note(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
    limit: $limit
    offset: $offset
    order_by: {is_open: desc, issue_date: desc_nulls_last}
  ) {
    reference
    created_at
    interchange_links {
      interchange_by_reference {
        reference
        channel
        direction
        interchange_events {
          event_type
          last_event_timestamp
        }
      }
    }
    participant
    amount_currency
    processing_status
    status
    custom_fields
    origin
    credit_note_number
    total_amount
    open_amount
    due_date
    due_amount
    issue_date
    file_references
  }
}
    `;
export const GetDebitNotes = gql`
    query getDebitNotes($participant: uuid!, $recipient: uuid!, $offset: Int, $limit: Int) {
  total: risolto_debit_note_aggregate(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
  ) {
    aggregate {
      count
    }
  }
  risolto_debit_note(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
    limit: $limit
    offset: $offset
    order_by: {is_open: desc, issue_date: desc_nulls_last}
  ) {
    reference
    created_at
    participant
    amount_currency
    processing_status
    custom_fields
    origin
    debit_note_number
    total_amount
    open_amount
    due_date
    issue_date
  }
}
    `;
export const ReactivateEndpoint = gql`
    mutation reactivateEndpoint($participant: uuid!, $reference: uuid!) {
  update_risolto_channel_endpoint(
    where: {reference: {_eq: $reference}, participant: {_eq: $participant}}
    _set: {deactivated_at: null, deactivated_by: "NULL"}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;
export const DeactivateEndpoint = gql`
    mutation deactivateEndpoint($participant: uuid!, $reference: uuid!, $deactivated_by: String!) {
  update_risolto_channel_endpoint(
    where: {reference: {_eq: $reference}, participant: {_eq: $participant}}
    _set: {deactivated_at: "now()", deactivated_by: $deactivated_by}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;
export const ActionsGet = gql`
    query actionsGet($limit: Int = 10, $offset: Int = 0, $status: [risolto_action_status_enum!], $execution_type: [risolto_action_execution_type_enum!], $participant: uuid!, $invoice: uuid, $channel: risolto_channel_enum, $recipientRef: uuid, $orderBy: [risolto_action_order_by!]) {
  total: risolto_action_aggregate(
    order_by: $orderBy
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipientRef}, status: {_in: $status}, execution_type: {_in: $execution_type}, channel: {_eq: $channel}}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action(
    order_by: {updated_at: desc}
    limit: $limit
    offset: $offset
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipientRef}, status: {_in: $status}, execution_type: {_in: $execution_type}, channel: {_eq: $channel}}
  ) {
    reference
    metadata
    message_code
    participant
    action_invoices {
      reference
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    status
    channel
    source
    executed_at
    original_action
    retry_count
    start_time
    due_date
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      custom_fields
    }
    legal_entity_by_reference {
      registration_name
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
  }
}
    `;
export const ActionsGetInvoiceActions = gql`
    query actionsGetInvoiceActions($limit: Int = 10, $offset: Int = 0, $status: [risolto_action_status_enum!], $execution_type: [risolto_action_execution_type_enum!], $participant: uuid!, $invoice: uuid, $channel: risolto_channel_enum, $recipientRef: uuid, $orderBy: [risolto_action_order_by!]) {
  total: risolto_action_aggregate(
    where: {participant: {_eq: $participant}, action_invoices: {invoice_by_reference: {reference: {_eq: $invoice}}}, recipient: {_eq: $recipientRef}, status: {_in: $status}, execution_type: {_in: $execution_type}, channel: {_eq: $channel}}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action(
    order_by: {updated_at: desc}
    limit: $limit
    offset: $offset
    where: {participant: {_eq: $participant}, action_invoices: {invoice_by_reference: {reference: {_eq: $invoice}}}, recipient: {_eq: $recipientRef}, status: {_in: $status}, execution_type: {_in: $execution_type}, channel: {_eq: $channel}}
  ) {
    reference
    metadata
    message_code
    participant
    action_invoices {
      invoice
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    status
    channel
    source
    original_action
    retry_count
    executed_at
    start_time
    due_date
    recipient
    recipient_by_reference {
      reference
      name
      account_id
    }
    legal_entity_by_reference {
      registration_name
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
  }
}
    `;
export const ActionsGetParticipantActionAggregate = gql`
    query actionsGetParticipantActionAggregate($actionType: [risolto_action_execution_type_enum!], $status: [risolto_action_status_enum!]) {
  risolto_action_aggregate(
    where: {execution_type: {_in: $actionType}, status: {_in: $status}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const ActionsGetAction = gql`
    query actionsGetAction($action: uuid!, $participant: uuid!) {
  action: risolto_action(
    where: {reference: {_eq: $action}, participant: {_eq: $participant}}
  ) {
    reference
    metadata
    channel
    message_code
    participant
    participant_by_reference {
      name
    }
    legal_entity
    legal_entity_by_reference {
      company_id
      company_id_type
      registration_name
      outbound_channel: processing_details(path: "outbound_channel")
    }
    recipient
    recipient_by_reference {
      reference
      account_id
    }
    execution_type
    status
    source
    due_date
    original_action
    retry_count
    created_at
    assignee
    assignee_by_reference {
      username
    }
    channel_endpoint
    channel_endpoint_by_reference {
      channel
      endpoint
      endpoint_details
      deactivated_at
      deactivated_by
      last_failed_delivery_at
      last_failed_delivery_type
      locale
      priority
    }
  }
}
    `;
export const ActionsUpdateActionAssignee = gql`
    mutation actionsUpdateActionAssignee($actionRef: uuid!, $personRef: uuid) {
  update_risolto_action(
    where: {reference: {_eq: $actionRef}}
    _set: {assignee: $personRef}
  ) {
    updated_count: affected_rows
    updated: returning {
      reference
      assignee_by_reference {
        username
      }
    }
  }
}
    `;
export const ActionsUpdateActionMetadata = gql`
    mutation actionsUpdateActionMetadata($action: uuid!, $metadata: jsonb!, $channel: risolto_channel_enum!) {
  update_risolto_action(
    where: {reference: {_eq: $action}}
    _set: {metadata: $metadata, channel: $channel}
  ) {
    updated_count: affected_rows
    updated: returning {
      reference
      metadata
    }
  }
}
    `;
export const ActionsAdd = gql`
    mutation actionsAdd($channel: risolto_channel_enum, $executionType: risolto_action_execution_type_enum, $legalEntity: uuid, $recipient: uuid, $metadata: jsonb, $participant: uuid, $status: risolto_action_status_enum, $startTime: timestamptz, $exectutedAt: timestamptz, $source: risolto_action_source_enum, $messageCode: String, $primaryInvoice: uuid!, $invoiceGroupInvoices: [risolto_invoice_group_invoice_insert_input!]!) {
  insert_risolto_action(
    objects: {channel: $channel, execution_type: $executionType, metadata: $metadata, legal_entity: $legalEntity, participant: $participant, status: $status, start_time: $startTime, executed_at: $exectutedAt, recipient: $recipient, message_code: $messageCode, source: $source, primary_invoice: $primaryInvoice, dunning_notice_by_reference: {data: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, type_code: _100_REMINDER, charges: 0, principal_amount: 0, interest: 0, invoice_group_by_reference: {data: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, invoice_group_invoices: {data: $invoiceGroupInvoices}}}}}}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;
export const ActionsAddManualActionInvoiceCopy = gql`
    mutation actionsAddManualActionInvoiceCopy($participant: uuid!, $legalEntity: uuid, $recipient: uuid!, $metadata: jsonb!, $invoice: uuid!, $channelEndpoint: uuid, $start_time: timestamptz) {
  action: insert_risolto_action_one(
    object: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, channel_endpoint: $channelEndpoint, channel: EMAIL, source: MANUAL, status: OPEN, metadata: $metadata, primary_invoice: $invoice, execution_type: MANUAL, message_code: "invoiceCopy", start_time: $start_time, action_invoices: {data: [{participant: $participant, legal_entity: $legalEntity, invoice: $invoice, relation: "PRIMARY"}], on_conflict: {constraint: action_invoice_action_invoice_key, update_columns: []}}}
  ) {
    ...actionsFragmentDetailsFields
  }
}
    ${ActionsFragmentDetailsFields}`;
export const ActionsGetSendInvoiceCopyData = gql`
    query actionsGetSendInvoiceCopyData($participant: uuid!, $legalEntity: uuid!, $recipient: uuid!, $invoices: [uuid!]!) {
  legal_entity: risolto_legal_entity(where: {reference: {_eq: $legalEntity}}) {
    communication: processing_details(path: "outbound_channel.communication")
  }
  recipient: risolto_recipient(where: {reference: {_eq: $recipient}}) {
    language_code
  }
  channel_endpoints: risolto_invoicing_channel_endpoints_v1(
    args: {q_participant: $participant, q_legal_entity: $legalEntity, q_recipient: $recipient, q_channels: "{EMAIL}"}
    where: {channel_endpoint_by_reference: {deactivated_at: {_is_null: true}}}
    limit: 1
  ) {
    channel_endpoint: channel_endpoint_by_reference {
      reference
      endpoint
      locale
    }
  }
  invoices: risolto_invoice_document(where: {reference: {_in: $invoices}}) {
    attachments: file_references
  }
}
    `;
export const ActionsGetNextActionsV2 = gql`
    query actionsGetNextActionsV2($reference: uuid, $participant: uuid!, $recipient: uuid, $limit: Int, $offset: Int, $channels: [risolto_channel_enum!], $statuses: [risolto_action_status_enum!], $searchTerm: String!, $msgCode: String, $invoices: [uuid!], $orderBy: [risolto_action_order_by!]) {
  total: risolto_action_aggregate(
    where: {_and: [{_or: [{primary_invoice: {_in: $invoices}}]}, {_or: [{message_code: {_ilike: $searchTerm}}, {recipient_by_reference: {name: {_ilike: $searchTerm}}}, {recipient_by_reference: {account_id: {_ilike: $searchTerm}}}]}, {channel: {_in: $channels}}, {participant: {_eq: $participant}}, {recipient: {_eq: $recipient}}, {status: {_in: $statuses}}, {message_code: {_eq: $msgCode}}, {reference: {_eq: $reference}}]}
    order_by: $orderBy
  ) {
    aggregate {
      count
    }
  }
  risolto_action(
    where: {_and: [{_or: [{primary_invoice: {_in: $invoices}}]}, {_or: [{message_code: {_ilike: $searchTerm}}, {recipient_by_reference: {name: {_ilike: $searchTerm}}}, {recipient_by_reference: {account_id: {_ilike: $searchTerm}}}]}, {channel: {_in: $channels}}, {participant: {_eq: $participant}}, {recipient: {_eq: $recipient}}, {status: {_in: $statuses}}, {message_code: {_eq: $msgCode}}, {reference: {_eq: $reference}}]}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    status
    channel
    recipient
    recipient_by_reference {
      address
      balance_amount
      dunning_metadata
      last_dunning_at
      legal_id
      legal_id_type
      name
      account_id
      type
      updated_by
      participant
      reference
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
    }
    reference
    metadata
    message_code
    is_retry
    participant
    primary_invoice
    primary_invoice_by_reference {
      invoice_number
    }
    action_invoices {
      reference
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    source
    executed_at
    original_action
    retry_count
    start_time
    due_date
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      participant
    }
    legal_entity_by_reference {
      registration_name
      outbound_channel: processing_details(path: "outbound_channel")
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
    channel_endpoint
    channel_endpoint_by_reference {
      channel
      endpoint
      endpoint_details
      deactivated_at
      deactivated_by
      last_failed_delivery_at
      last_failed_delivery_type
      locale
      priority
    }
  }
}
    `;
export const ActionsGetNextActions = gql`
    query actionsGetNextActions($participant: uuid!, $recipient: uuid!, $limit: Int, $offset: Int, $channels: [risolto_channel_enum!], $statuses: [risolto_action_status_enum!], $searchTerm: String!) {
  total: risolto_action_aggregate(
    where: {message_code: {_ilike: $searchTerm}, channel: {_in: $channels}, participant: {_eq: $participant}, recipient: {_eq: $recipient}, status: {_in: $statuses}}
    order_by: {start_time: asc_nulls_last}
  ) {
    aggregate {
      count
    }
  }
  risolto_action(
    where: {message_code: {_ilike: $searchTerm}, channel: {_in: $channels}, participant: {_eq: $participant}, recipient: {_eq: $recipient}, status: {_in: $statuses}}
    order_by: {start_time: asc_nulls_last}
    limit: $limit
    offset: $offset
  ) {
    status
    channel
    recipient
    recipient_by_reference {
      participant
      reference
      address
      balance_amount
      dunning_metadata
      last_dunning_at
      legal_id
      legal_id_type
      name
      type
      updated_by
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
      account_id
    }
    reference
    metadata
    message_code
    participant
    action_invoices {
      reference
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    source
    executed_at
    original_action
    retry_count
    start_time
    due_date
    recipient
    recipient_by_reference {
      name
      account_id
      reference
    }
    legal_entity_by_reference {
      registration_name
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
  }
}
    `;
export const ActionsAddInvoiceCopyMail = gql`
    mutation actionsAddInvoiceCopyMail($participant: uuid!, $legalEntity: uuid, $recipient: uuid!, $metadata: jsonb!, $invoice: uuid!, $channelEndpoint: uuid, $start_time: timestamptz!) {
  action: insert_risolto_action_one(
    object: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, channel_endpoint: $channelEndpoint, channel: MAIL, source: MANUAL, status: OPEN, metadata: $metadata, primary_invoice: $invoice, execution_type: MANUAL, message_code: "Invoice Copy", start_time: $start_time}
  ) {
    ...actionsFragmentDetailsFields
  }
}
    ${ActionsFragmentDetailsFields}`;
export const ActionsAddManualAction = gql`
    mutation actionsAddManualAction($channel: risolto_channel_enum, $status: risolto_action_status_enum, $legalEntity: uuid, $recipient: uuid, $participant: uuid, $startTime: timestamptz, $assignee: uuid, $metadata: jsonb, $primaryInvoice: uuid!, $invoiceGroupInvoices: [risolto_invoice_group_invoice_insert_input!]!) {
  insert_risolto_action(
    objects: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, execution_type: MANUAL, status: $status, source: MANUAL, start_time: $startTime, channel: $channel, assignee: $assignee, metadata: $metadata, message_code: "scheduled manual action", primary_invoice: $primaryInvoice, dunning_notice_by_reference: {data: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, type_code: _100_REMINDER, charges: 0, principal_amount: 0, interest: 0, invoice_group_by_reference: {data: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, invoice_group_invoices: {data: $invoiceGroupInvoices}}}}}}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;
export const ActionsGetSendInvoiceCopyMailData = gql`
    query actionsGetSendInvoiceCopyMailData($recipient: uuid!, $invoices: [uuid!]!) {
  recipient: risolto_recipient_by_pk(reference: $recipient) {
    reference
    name
    participant
    language_code
    legal_entity: legal_entity_by_reference {
      reference
      address: processing_details(path: "postal_address")
      default_postal_provider: processing_details(
        path: "outbound_channel.postal_provider"
      )
      communication_postal_provider: processing_details(
        path: "outbound_channel.communication.postal_provider"
      )
      communication_templates(
        where: {channel: {_eq: MAIL}, template_id: {_eq: "invoice_copy"}}
      ) {
        template_id
      }
    }
    channel_endpoints(
      where: {channel: {_eq: "MAIL"}, deactivated_at: {_is_null: true}}
    ) {
      reference
      address: endpoint_details
      contact: contact_by_reference {
        first_name
        last_name
      }
    }
    invoices: invoice_documents(where: {reference: {_in: $invoices}}) {
      attachments: file_references
    }
  }
}
    `;
export const ActionsGetSendCreditNoteCopyMailData = gql`
    query actionsGetSendCreditNoteCopyMailData($recipient: uuid!, $creditNotes: [uuid!]!) {
  recipient: risolto_recipient_by_pk(reference: $recipient) {
    reference
    name
    participant
    language_code
    legal_entity: legal_entity_by_reference {
      reference
      address: processing_details(path: "postal_address")
      default_postal_provider: processing_details(
        path: "outbound_channel.postal_provider"
      )
      communication_postal_provider: processing_details(
        path: "outbound_channel.communication.postal_provider"
      )
      communication_templates(
        where: {channel: {_eq: MAIL}, template_id: {_eq: "credit_note_copy"}}
      ) {
        template_id
      }
    }
    channel_endpoints(
      where: {channel: {_eq: "MAIL"}, deactivated_at: {_is_null: true}}
    ) {
      reference
      address: endpoint_details
      contact: contact_by_reference {
        first_name
        last_name
      }
    }
    credit_notes: credit_notes(where: {reference: {_in: $creditNotes}}) {
      attachments: file_references
    }
  }
}
    `;
export const ActionsAddCreditNoteCopyMail = gql`
    mutation actionsAddCreditNoteCopyMail($participant: uuid!, $legalEntity: uuid, $recipient: uuid!, $metadata: jsonb!, $creditNote: uuid!, $channelEndpoint: uuid, $start_time: timestamptz!) {
  action: insert_risolto_action_one(
    object: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, channel_endpoint: $channelEndpoint, channel: MAIL, source: MANUAL, status: OPEN, metadata: $metadata, credit_note: $creditNote, execution_type: MANUAL, message_code: "credit_note_copy", start_time: $start_time}
  ) {
    ...actionsFragmentDetailsFields
  }
}
    ${ActionsFragmentDetailsFields}`;
export const ActionsGetSendCreditNoteCopyData = gql`
    query actionsGetSendCreditNoteCopyData($participant: uuid!, $legalEntity: uuid!, $recipient: uuid!, $creditNotes: [uuid!]!) {
  legal_entity: risolto_legal_entity(where: {reference: {_eq: $legalEntity}}) {
    communication: processing_details(path: "outbound_channel.communication")
  }
  channel_endpoints: risolto_invoicing_channel_endpoints_v1(
    args: {q_participant: $participant, q_legal_entity: $legalEntity, q_recipient: $recipient, q_channels: "{EMAIL}"}
    where: {channel_endpoint_by_reference: {deactivated_at: {_is_null: true}}}
    limit: 1
  ) {
    channel_endpoint: channel_endpoint_by_reference {
      reference
      endpoint
      locale
    }
  }
  credit_notes: risolto_credit_note(where: {reference: {_in: $creditNotes}}) {
    attachments: file_references
  }
}
    `;
export const ActionsAddManualActionCreditNoteCopy = gql`
    mutation actionsAddManualActionCreditNoteCopy($participant: uuid!, $legalEntity: uuid, $recipient: uuid!, $metadata: jsonb!, $creditNote: uuid!, $channelEndpoint: uuid, $start_time: timestamptz) {
  action: insert_risolto_action_one(
    object: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, channel_endpoint: $channelEndpoint, channel: EMAIL, source: MANUAL, status: OPEN, metadata: $metadata, execution_type: MANUAL, message_code: "credit_note_copy", start_time: $start_time, credit_note: $creditNote}
  ) {
    ...actionsFragmentDetailsFields
  }
}
    ${ActionsFragmentDetailsFields}`;
export const ActionsUpdateChannelEndpoint = gql`
    mutation actionsUpdateChannelEndpoint($action: uuid!, $channelEndpoint: uuid!) {
  update_risolto_action(
    where: {reference: {_eq: $action}}
    _set: {channel_endpoint: $channelEndpoint}
  ) {
    updated_count: affected_rows
    updated: returning {
      reference
      channel_endpoint
    }
  }
}
    `;
export const GqlActionsGrouped_GetAllWorklistItems = gql`
    query gqlActionsGrouped_getAllWorklistItems($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isReference: Boolean!, $isAssignee: Boolean!, $limit: Int!, $offset: Int!, $orderBy: [risolto_virtual_action_group_order_by!], $statuses: _text, $participants: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  total: risolto_action_group_v10_aggregate(
    args: {search_term: $searchTerm, group_reference: $isReference, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action_group_v10(
    args: {search_term: $searchTerm, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, group_reference: $isReference, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    v_reference
    reference
    action_by_reference {
      source
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      status
      original_action
      retry_count
      participant
      metadata
      action_invoices(order_by: {invoice_by_reference: {issue_date: desc_nulls_last}}) {
        relation
        invoice
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      status
      reference
      execution_type
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        reference
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
        company_id
        company_id_type
      }
      message_code
      channel
      due_date
      start_time
      assignee
      assignee_by_reference {
        reference
        username
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
        company_id
        company_id_type
      }
    }
    action_count
    due_date
    due_date_count
    channel
    channel_count
    recipient
    recipient_by_reference {
      name
      reference
      type
      participant
      legal_id_type
      legal_id
      legal_entity
      account_id
      contacts {
        reference
        first_name
        last_name
      }
      invoice_documents_aggregate {
        aggregate {
          sum {
            open_amount
            total_amount
          }
        }
      }
    }
    recipient_count
    assignee_by_reference {
      username
    }
    start_time
    start_time_count
    assignee_count
    message_code
    message_code_count
  }
}
    `;
export const GqlActionsGrouped_GetunassignedWorklistItems = gql`
    query gqlActionsGrouped_getunassignedWorklistItems($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isAssignee: Boolean!, $isReference: Boolean!, $limit: Int!, $offset: Int!, $orderBy: [risolto_virtual_action_group_order_by!], $statuses: _text, $participants: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  total: risolto_action_group_v10_aggregate(
    args: {search_term: $searchTerm, group_reference: $isReference, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action_group_v10(
    where: {assignee: {_is_null: true}}
    args: {search_term: $searchTerm, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, group_reference: $isReference, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    v_reference
    reference
    action_by_reference {
      source
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      status
      original_action
      retry_count
      participant
      metadata
      action_invoices(order_by: {invoice_by_reference: {issue_date: desc_nulls_last}}) {
        relation
        invoice
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      status
      reference
      execution_type
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        reference
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
        company_id
        company_id_type
      }
      message_code
      channel
      due_date
      start_time
      assignee
      assignee_by_reference {
        reference
        username
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
        company_id
        company_id_type
      }
    }
    action_count
    due_date
    due_date_count
    channel
    channel_count
    recipient
    recipient_by_reference {
      name
      reference
      type
      participant
      legal_id_type
      legal_id
      legal_entity
      account_id
      contacts {
        reference
        first_name
        last_name
      }
      invoice_documents_aggregate {
        aggregate {
          sum {
            open_amount
            total_amount
          }
        }
      }
    }
    recipient_count
    assignee_by_reference {
      username
    }
    start_time
    start_time_count
    assignee_count
    message_code
    message_code_count
  }
}
    `;
export const GqlActionsGrouped_GetAssignedWorklistItems = gql`
    query gqlActionsGrouped_getAssignedWorklistItems($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isReference: Boolean!, $isAssignee: Boolean!, $limit: Int!, $offset: Int!, $orderBy: [risolto_virtual_action_group_order_by!], $statuses: _text, $assignee: uuid!, $participants: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  total: risolto_action_group_v10_aggregate(
    args: {search_term: $searchTerm, group_reference: $isReference, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action_group_v10(
    where: {assignee: {_eq: $assignee}}
    args: {search_term: $searchTerm, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, group_reference: $isReference, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    v_reference
    reference
    action_by_reference {
      source
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      status
      original_action
      retry_count
      participant
      metadata
      action_invoices(order_by: {invoice_by_reference: {issue_date: desc_nulls_last}}) {
        relation
        invoice
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      status
      reference
      execution_type
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        reference
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
        company_id
        company_id_type
      }
      message_code
      channel
      due_date
      start_time
      assignee
      assignee_by_reference {
        reference
        username
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
        company_id
        company_id_type
      }
    }
    action_count
    due_date
    due_date_count
    channel
    channel_count
    recipient
    recipient_by_reference {
      name
      reference
      type
      participant
      legal_id_type
      legal_id
      legal_entity
      account_id
      contacts {
        reference
        first_name
        last_name
      }
      invoice_documents_aggregate {
        aggregate {
          sum {
            open_amount
            total_amount
          }
        }
      }
    }
    recipient_count
    assignee_by_reference {
      username
    }
    start_time
    start_time_count
    assignee_count
    message_code
    message_code_count
  }
}
    `;
export const GetStatementLines = gql`
    query getStatementLines($status: [risolto_statement_line_status_enum!], $startDate: date, $endDate: date, $limit: Int = 10, $offset: Int = 0, $participantRef: uuid!) {
  total: risolto_statement_line_aggregate(
    limit: $limit
    offset: $offset
    where: {_and: [{status: {_in: $status}}, {participant: {_eq: $participantRef}}, {transaction_date: {_gte: $startDate}}, {transaction_date: {_lte: $endDate}}]}
  ) {
    aggregate {
      count
    }
  }
  statements: risolto_statement_line(
    limit: $limit
    offset: $offset
    where: {_and: [{status: {_in: $status}}, {participant: {_eq: $participantRef}}, {transaction_date: {_gte: $startDate}}, {transaction_date: {_lte: $endDate}}]}
  ) {
    reference
    counterparty_account_number
    counterparty_account_number_type
    counterparty_address
    counterparty_bank_identifier
    counterparty_bank_identifier_type
    counterparty_currency
    counterparty_name
    invoice
    recipient_by_reference {
      reference
      name
      channel_endpoints {
        channel
        contact_by_reference {
          first_name
          last_name
        }
      }
    }
    legal_entity
    recipient
    structured_message
    transaction_credit_amount
    transaction_date
    transaction_debit_amount
    transaction_reference
    unstructured_message
  }
}
    `;
export const GetContacts = gql`
    query getContacts($recipient: uuid!, $participant: uuid!) {
  total: risolto_contact_aggregate(
    where: {_and: {recipient: {_eq: $recipient}, participant: {_eq: $participant}}}
  ) {
    aggregate {
      count
    }
  }
  contacts: risolto_contact(
    where: {_and: {recipient: {_eq: $recipient}, participant: {_eq: $participant}}}
  ) {
    legal_entity
    participant
    first_name
    last_name
    full_name
    reference
    recipient
    channel_endpoints {
      endpoint_details
      deactivated_at
      deactivated_by
      channel
      endpoint
      reference
    }
  }
}
    `;
export const GetContact = gql`
    query getContact($reference: uuid!, $participant: uuid) {
  contact: risolto_contact(
    where: {reference: {_eq: $reference}, participant: {_eq: $participant}}
  ) {
    legal_entity
    participant
    first_name
    last_name
    reference
    recipient
    channel_endpoints {
      endpoint_details
      channel
      deactivated_at
      deactivated_by
      endpoint
      reference
    }
  }
}
    `;
export const GqlDashboard_AgingBalance = gql`
    query gqlDashboard_agingBalance($participant: uuid!, $legal_entity: uuid, $today: date!, $today_minus_30: date!, $today_minus_60: date!, $today_minus_90: date!, $issue_date_from: date!, $issue_date_until: date!) {
  not_overdue: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], due_date: {_gt: $today}, document_type: {_in: ["INVOICE", "CREDIT_NOTE", "DEBIT_NOTE"]}, _and: [{issue_date: {_gte: $issue_date_from}}, {issue_date: {_lt: $issue_date_until}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
  days30: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], _and: [{_or: [{_and: [{due_date: {_lte: $today}}, {due_date: {_gte: $today_minus_30}}]}, {due_date: {_is_null: true}}]}, {issue_date: {_lte: $issue_date_until}}, {issue_date: {_gte: $issue_date_from}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
  days60: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], _and: [{_or: [{_and: [{due_date: {_lt: $today_minus_30}}, {due_date: {_gte: $today_minus_60}}]}, {due_date: {_is_null: true}}]}, {issue_date: {_lt: $issue_date_until}}, {issue_date: {_gte: $issue_date_from}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
  days90: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], _and: [{_or: [{_and: [{due_date: {_lt: $today_minus_60}}, {due_date: {_gte: $today_minus_90}}]}, {due_date: {_is_null: true}}]}, {issue_date: {_lt: $issue_date_until}}, {issue_date: {_gte: $issue_date_from}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
  days90plus: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], _and: [{_or: [{_and: [{due_date: {_lt: $today_minus_90}}]}, {due_date: {_is_null: true}}]}, {issue_date: {_lt: $issue_date_until}}, {issue_date: {_gte: $issue_date_from}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
}
    `;
export const GqlDashboard_AgingBalanceRecipient = gql`
    query gqlDashboard_agingBalanceRecipient($participant: uuid!, $recipient: uuid!, $today: date!, $today_minus_30: date!, $today_minus_60: date!, $today_minus_90: date!) {
  not_overdue: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, due_date: {_gt: $today}}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
  days30: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, _or: [{_and: [{due_date: {_lt: $today_minus_30}}, {due_date: {_gte: $today_minus_60}}]}, {due_date: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
  days60: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, _or: [{_and: [{due_date: {_lt: $today_minus_30}}, {due_date: {_gte: $today_minus_60}}]}, {due_date: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
  days90: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, _or: [{_and: [{due_date: {_lt: $today_minus_60}}, {due_date: {_gte: $today_minus_90}}]}, {due_date: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
  days90plus: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, _or: [{_and: [{due_date: {_lt: $today_minus_90}}]}, {due_date: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
}
    `;
export const InsertActionInvoice = gql`
    mutation insertActionInvoice($action: uuid!, $invoice: uuid!, $legal_entity: uuid!, $participant: uuid!, $relation: String!) {
  insert_risolto_action_invoice(
    objects: {relation: $relation, action: $action, invoice: $invoice, legal_entity: $legal_entity, participant: $participant}
  ) {
    returning {
      reference
    }
    affected_rows
  }
}
    `;
export const GqlInvoices_GetInvoiceInterchangeLinks = gql`
    query gqlInvoices_getInvoiceInterchangeLinks($participantRef: uuid!, $invoice: uuid!) {
  invoice: risolto_invoice_document(
    where: {_and: [{reference: {_eq: $invoice}}, {participant: {_eq: $participantRef}}]}
  ) {
    reference
    actions(where: {executed_at: {_is_null: false}}) {
      reference
      action_interchanges {
        reference
        interchange_by_reference {
          reference
          interchange_events {
            event_type
            event_type_count
            last_event_timestamp
            email: channel_endpoint(path: "$.email")
            postal_mail: channel_endpoint(path: "postal_mail")
          }
          channel
          direction
        }
      }
    }
    dunning_status
    recipient_by_reference {
      participant
      reference
      name
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
    }
    invoice_dispute: disputes(
      where: {resolved_at: {_is_null: true}}
      order_by: {until: desc}
      limit: 1
    ) {
      reference
      until
    }
    legal_entity_by_reference {
      reference
      registration_name
    }
    participant_by_reference {
      name
      reference
      logical_id
    }
    file_references: attachments
    derived_paid_at
  }
}
    `;
export const GqlInvoices_GetInvoice = gql`
    query gqlInvoices_getInvoice($invoice: uuid!) {
  invoice: risolto_invoice_document(where: {reference: {_eq: $invoice}}) {
    processing_due_date
    invoice_number
    amount_currency
    dunning_started
    earliest_dunning_time
    earliest_submission_time
    issue_date
    due_date
    reference
    payment_reference
    file_reference
    file_references
    legal_entity
    legal_entity_by_reference {
      registration_name
      reference
      participant
      address
      company_id
      company_id_type
    }
    total_amount
    open_amount
    amount_currency
    participant
    interchange_links {
      reference
      interchange_by_reference {
        interchange_events {
          event_type
          event_type_count
          last_event_timestamp
          email: channel_endpoint(path: "$.email")
          postal_mail: channel_endpoint(path: "postal_mail")
        }
        reference
        channel
        direction
      }
    }
    recipient
    recipient_by_reference {
      preferred_invoicing_channel
      legal_entity
      legal_entity_by_reference {
        reference
      }
      participant
      reference
      type
      legal_id
      legal_id_type
      address
      name
      account_id
    }
    actions: action_invoices {
      action_by_reference {
        reference
        message_code
      }
    }
    dunning_status
    total_actions: action_invoices_aggregate {
      aggregate {
        count
      }
    }
    custom_fields
    attachments
  }
}
    `;
export const GqlInvoices_GetInvoices = gql`
    query gqlInvoices_getInvoices($limit: Int = 10, $offset: Int = 0, $participantRef: uuid!, $status: [risolto_invoice_document_status_enum!], $orderBy: [risolto_invoice_document_order_by!], $searchTerm: String!, $searchAmount_min: numeric!, $searchAmount_max: numeric!, $today: date!) {
  total: risolto_invoice_document_aggregate(
    where: {participant: {_eq: $participantRef}, status: {_in: $status}, _or: [{recipient_by_reference: {_or: [{name: {_ilike: $searchTerm}}, {legal_id: {_ilike: $searchTerm}}, {account_id: {_ilike: $searchTerm}}]}}, {_and: [{open_amount: {_gt: $searchAmount_min}}, {open_amount: {_lt: $searchAmount_max}}]}, {_and: [{total_amount: {_gt: $searchAmount_min}}, {total_amount: {_lt: $searchAmount_max}}]}, {invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}]}
  ) {
    aggregate {
      count
    }
  }
  invoices: risolto_invoice_document(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: {participant: {_eq: $participantRef}, status: {_in: $status}, _or: [{recipient_by_reference: {_or: [{name: {_ilike: $searchTerm}}, {legal_id: {_ilike: $searchTerm}}, {account_id: {_ilike: $searchTerm}}]}}, {_and: [{open_amount: {_gt: $searchAmount_min}}, {open_amount: {_lt: $searchAmount_max}}]}, {_and: [{total_amount: {_gt: $searchAmount_min}}, {total_amount: {_lt: $searchAmount_max}}]}, {invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}]}
  ) {
    total_actions: action_invoices_aggregate {
      aggregate {
        count
      }
    }
    total_open_actions: action_invoices_aggregate(
      where: {invoice_by_reference: {status: {_eq: OPEN}}}
    ) {
      aggregate {
        count
      }
    }
    processing_due_date
    invoice_number
    open_amount
    total_amount
    payment_reference
    due_date
    file_reference
    file_references
    issue_date
    status
    recipient
    recipient_by_reference {
      participant
      reference
      name
      account_id
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
    }
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    processing_due_date
    participant
    participant_by_reference {
      name
      reference
      logical_id
    }
    reference
    amount_currency
    invoice_dispute: disputes(
      where: {until: {_gte: $today}}
      order_by: {until: desc}
      limit: 1
    ) {
      reference
      until
    }
  }
}
    `;
export const GqlInvoices_GetInvoicesForRecipient = gql`
    query gqlInvoices_getInvoicesForRecipient($limit: Int = 10, $offset: Int = 0, $participantRef: uuid!, $recipient: uuid!, $status: [risolto_invoice_document_status_enum!], $orderBy: [risolto_invoice_document_order_by!], $searchTerm: String!, $searchAmount_min: numeric!, $searchAmount_max: numeric!, $today: date!) {
  total: risolto_invoice_document_aggregate(
    where: {participant: {_eq: $participantRef}, recipient: {_eq: $recipient}, status: {_in: $status}, _or: [{_and: [{open_amount: {_gt: $searchAmount_min}}, {open_amount: {_lt: $searchAmount_max}}]}, {_and: [{total_amount: {_gt: $searchAmount_min}}, {total_amount: {_lt: $searchAmount_max}}]}, {invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}]}
  ) {
    aggregate {
      count
    }
  }
  invoices: risolto_invoice_document(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: {participant: {_eq: $participantRef}, recipient: {_eq: $recipient}, status: {_in: $status}, _or: [{_and: [{open_amount: {_gt: $searchAmount_min}}, {open_amount: {_lt: $searchAmount_max}}]}, {_and: [{total_amount: {_gt: $searchAmount_min}}, {total_amount: {_lt: $searchAmount_max}}]}, {invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}]}
  ) {
    processing_due_date
    invoice_number
    open_amount
    total_amount
    payment_reference
    due_date
    file_reference
    file_references
    issue_date
    status
    recipient
    recipient_by_reference {
      participant
      reference
      name
      account_id
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
    }
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    processing_due_date
    participant
    participant_by_reference {
      name
      reference
      logical_id
    }
    reference
    amount_currency
    invoice_dispute: disputes(
      where: {until: {_gte: $today}, resolved_at: {_is_null: true}}
      order_by: {until: desc}
      limit: 1
    ) {
      reference
      until
    }
  }
}
    `;
export const GqlInvoices_FindInvoices = gql`
    query gqlInvoices_findInvoices($searchTerm: String, $amount: numeric) {
  total: risolto_invoice_document_aggregate(
    where: {_or: [{invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}, {total_amount: {_eq: $amount}}, {open_amount: {_eq: $amount}}, {recipient_by_reference: {bank_accounts: {account_number: {_ilike: $searchTerm}}}}, {recipient_by_reference: {name: {_ilike: $searchTerm}}}, {recipient_by_reference: {account_id: {_ilike: $searchTerm}}}]}
  ) {
    aggregate {
      count
    }
  }
  invoices: risolto_invoice_document(
    where: {_or: [{invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}, {total_amount: {_eq: $amount}}, {open_amount: {_eq: $amount}}, {recipient_by_reference: {bank_accounts: {account_number: {_ilike: $searchTerm}}}}, {recipient_by_reference: {name: {_ilike: $searchTerm}}}, {recipient_by_reference: {account_id: {_ilike: $searchTerm}}}]}
  ) {
    reference
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      bank_accounts {
        account_number
      }
    }
    processing_due_date
    invoice_number
    status
    payment_reference
    open_amount
    total_amount
  }
}
    `;
export const GqlInvoices_ActionsByInvoice = gql`
    query gqlInvoices_actionsByInvoice($invoice: uuid!) {
  total: risolto_action_aggregate(
    where: {action_invoices: {invoice: {_eq: $invoice}}}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action(where: {action_invoices: {invoice: {_eq: $invoice}}}) {
    action_invoices {
      action
      action_by_reference {
        status
        channel
        source
        recipient
        participant
        metadata
      }
      invoice
      invoice_by_reference {
        reference
        invoice_number
        processing_due_date
      }
    }
  }
}
    `;
export const GetLegalEntities = gql`
    query getLegalEntities($participant: uuid) {
  legal_entities: risolto_legal_entity(where: {participant: {_eq: $participant}}) {
    reference
    registration_name
    company_id
    logical_id
  }
}
    `;
export const FindInvoicePaymentTrigger = gql`
    query findInvoicePaymentTrigger($recipient: uuid!) {
  risolto_recipient(
    limit: 100
    where: {reference: {_eq: $recipient}, invoice_documents: {status: {_eq: PAID}, reference: {_is_null: false}, action_invoices: {action_by_reference: {reference: {_is_null: false}}}}}
  ) {
    invoice_documents(where: {status: {_eq: PAID}}) {
      due_date
      invoice_number
      status
      action_invoices(
        order_by: {action_by_reference: {confirmed_at: desc_nulls_last}}
        limit: 1
      ) {
        action_by_reference {
          reference
          channel
          message_code
          executed_at
          updated_at
          action_invoices {
            reference
            invoice
            invoice_by_reference {
              invoice_number
            }
          }
        }
      }
    }
    account_id
  }
}
    `;
export const Risolto_Notes = gql`
    query risolto_notes($participant: uuid, $recipientRef: uuid, $limit: Int = 10, $offset: Int = 0) {
  total: risolto_note_aggregate(
    order_by: {created_at: desc}
    where: {recipient: {_eq: $recipientRef}, participant: {_eq: $participant}}
    limit: $limit
    offset: $offset
  ) {
    aggregate {
      count
    }
  }
  notes: risolto_note(
    order_by: {created_at: desc}
    where: {recipient: {_eq: $recipientRef}, participant: {_eq: $participant}}
    limit: $limit
    offset: $offset
  ) {
    reference
    note
    created_by
    created_at
    person_by_reference {
      reference
      external_id
      username
    }
    note_invoices {
      reference
      invoice_by_reference {
        reference
        invoice_number
      }
    }
  }
}
    `;
export const GetInvoiceNotes = gql`
    query getInvoiceNotes($participant: uuid!, $invoice: uuid!, $limit: Int = 10, $offset: Int = 0) {
  notes: risolto_note_invoice(
    where: {_and: [{invoice: {_eq: $invoice}}, {participant: {_eq: $participant}}]}
    limit: $limit
    offset: $offset
    order_by: {note_by_reference: {created_at: desc}}
  ) {
    note
    note_by_reference {
      reference
      note
      created_at
      created_by
      person_by_reference {
        reference
        external_id
        username
      }
    }
  }
  total: risolto_note_invoice_aggregate(
    where: {_and: [{invoice: {_eq: $invoice}}, {participant: {_eq: $participant}}]}
    limit: $limit
    offset: $offset
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const Insert_Risolto_Note = gql`
    mutation insert_risolto_note($note: String!, $category: risolto_note_category_enum, $participant: uuid!, $invoice: uuid, $recipient: uuid!, $legal_entity: uuid!, $created_by: uuid!, $action: uuid) {
  result: insert_risolto_note(
    objects: {note: $note, participant: $participant, category: $category, recipient: $recipient, legal_entity: $legal_entity, created_by: $created_by, invoice_document: $invoice, action: $action}
  ) {
    updated_count: affected_rows
    returning {
      reference
      note
    }
  }
}
    `;
export const InsertInvoiceNote = gql`
    mutation insertInvoiceNote($note: uuid!, $invoice: uuid!, $participant: uuid!, $legalEntity: uuid!) {
  insert_risolto_note_invoice(
    objects: {invoice: $invoice, note: $note, legal_entity: $legalEntity, participant: $participant}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;
export const Update_Risolto_Note = gql`
    mutation update_risolto_note($noteRef: uuid!, $newNote: String!) {
  update_risolto_note(where: {reference: {_eq: $noteRef}}, _set: {note: $newNote}) {
    updated_count: affected_rows
    updated: returning {
      note
      reference
    }
  }
}
    `;
export const Delete_Risolto_Note = gql`
    mutation delete_risolto_note($noteRef: uuid!) {
  delete_risolto_note(where: {reference: {_eq: $noteRef}}) {
    deleted: affected_rows
  }
}
    `;
export const DeleteInvoiceNote = gql`
    mutation deleteInvoiceNote($note: uuid!) {
  delete_risolto_note_invoice(where: {note: {_eq: $note}}) {
    returning {
      reference
    }
    affected_rows
  }
  delete_risolto_note(where: {reference: {_eq: $note}}) {
    returning {
      reference
    }
    affected_rows
  }
}
    `;
export const GqlParticipantsGetParticipants = gql`
    query gqlParticipantsGetParticipants($limit: Int = 10, $offset: Int = 0, $searchTerm: String) {
  risolto_participant(
    limit: $limit
    offset: $offset
    where: {name: {_ilike: $searchTerm}}
  ) {
    name
    reference
  }
  risolto_participant_aggregate {
    aggregate {
      count
    }
  }
}
    `;
export const GqlParticipantsGetParticipant = gql`
    query gqlParticipantsGetParticipant($partRef: uuid!) {
  risolto_participant(where: {reference: {_eq: $partRef}}) {
    name
    reference
  }
}
    `;
export const GqlParticipantsGetParticipantDetails = gql`
    query gqlParticipantsGetParticipantDetails($participant: uuid!) {
  participant: risolto_participant(where: {reference: {_eq: $participant}}) {
    name
    reference
    legal_entities {
      reference
      logical_id
      registration_name
      processing_details
    }
  }
}
    `;
export const GetParticipantsForUser = gql`
    query getParticipantsForUser($externalId: [String!], $license_module: risolto_platform_license_module_enum!) {
  risolto_participant(
    where: {_and: [{platform_participant_licenses: {platform_license_module: {_eq: $license_module}}}, {participant_users: {person_by_reference: {external_id: {_in: $externalId}}}}]}
  ) {
    logical_id
    name
    reference
    user_interface_details
    legal_entities {
      reference
      logical_id
      registration_name
    }
  }
}
    `;
export const GetPaymentDocument = gql`
    query getPaymentDocument($participant: uuid!, $recipient: uuid!, $offset: Int, $limit: Int) {
  total: risolto_payment_document_aggregate(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
  ) {
    aggregate {
      count
    }
  }
  payment_documents: risolto_payment_document(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
    limit: $limit
    offset: $offset
    order_by: {is_open: desc, issue_date: desc_nulls_last}
  ) {
    reference
    created_at
    payment_number
    participant
    amount_currency
    processing_status
    custom_fields
    origin
    total_amount
    open_amount
    issue_date
  }
}
    `;
export const GqlPaymentPlan_PaymentPlans = gql`
    query gqlPaymentPlan_paymentPlans($participant: uuid!, $recipient: uuid!) {
  paymentPlans: risolto_payment_plan(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
    order_by: {created_at: desc}
  ) {
    reference
    name
    total_amount
    open_amount: virtual_open_amount
    status
    is_open
    amount_currency
    payment_promises(order_by: {due_date: asc}) {
      reference
      payment_reference
      status
      due_date
      total_amount
      open_amount
      amount_currency
    }
  }
}
    `;
export const GqlPeople_GetParticipantUsers = gql`
    query gqlPeople_getParticipantUsers($participant: uuid!, $legal_entity: uuid) {
  participantUsers: risolto_participant_user(
    where: {_and: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, internal: {_eq: false}, deactivated_at: {_is_null: true}}}
  ) {
    person_by_reference {
      reference
      username
      email
    }
  }
}
    `;
export const GqlPeople_GetPersonByExternalId = gql`
    query gqlPeople_getPersonByExternalId($externalId: String!) {
  risolto_person(where: {external_id: {_eq: $externalId}}) {
    reference
    username
  }
}
    `;
export const GqlPeople_GetParticipantByPerson = gql`
    query gqlPeople_getParticipantByPerson($personRef: uuid!) {
  risolto_participant_user(where: {person: {_eq: $personRef}}) {
    reference
    participant
  }
}
    `;
export const GqlRecipients_GetRecipients = gql`
    query gqlRecipients_getRecipients($partRef: uuid!, $limit: Int = 10, $offset: Int = 0, $searchTerm: String, $orderBy: [risolto_recipient_order_by!]) {
  total: risolto_recipient_aggregate(
    where: {_or: [{name: {_ilike: $searchTerm}}, {account_id: {_ilike: $searchTerm}}, {channel_endpoints: {_and: [{channel: {_eq: "EMAIL"}}, {endpoint: {_ilike: $searchTerm}}]}}], participant: {_eq: $partRef}}
    order_by: $orderBy
  ) {
    aggregate {
      count
    }
  }
  recipients: risolto_recipient(
    limit: $limit
    offset: $offset
    where: {_or: [{name: {_ilike: $searchTerm}}, {account_id: {_ilike: $searchTerm}}, {channel_endpoints: {_and: [{channel: {_eq: "EMAIL"}}, {endpoint: {_ilike: $searchTerm}}]}}], participant: {_eq: $partRef}}
    order_by: $orderBy
  ) {
    balance_amount
    due_balance_amount
    name
    reference
    type
    participant
    legal_id_type
    legal_id
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    account_id
    contacts {
      reference
      first_name
      last_name
    }
    invoice_documents_aggregate {
      aggregate {
        sum {
          open_amount
          total_amount
        }
      }
    }
  }
}
    `;
export const GqlRecipients_GetRecipient = gql`
    query gqlRecipients_getRecipient($participant: uuid!, $recipient: uuid!) {
  risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    in_collection
    last_dunning_run_at
    name
    account_id
    participant
    participant_by_reference {
      reference
    }
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
      company_id
      company_id_type
    }
    address
    language_code
    email_main_contact: contacts(
      where: {identifier: {_eq: "main"}, dunning: {_eq: true}, invoicing: {_eq: true}}
    ) {
      reference
      channel_endpoints(where: {channel: {_eq: "EMAIL"}}) {
        endpoint
      }
    }
    postal_main_contact: contacts(
      where: {identifier: {_eq: "main"}, dunning: {_eq: true}, invoicing: {_eq: true}}
    ) {
      reference
      channel_endpoints(where: {channel: {_eq: "MAIL"}}) {
        endpoint_details
      }
    }
    phone_main_contact: contacts(
      where: {identifier: {_eq: "main"}, dunning: {_eq: true}, invoicing: {_eq: true}}
    ) {
      reference
      channel_endpoints(where: {channel: {_eq: "PHONE"}}) {
        endpoint
      }
    }
    sms_main_contact: contacts(
      where: {identifier: {_eq: "main"}, dunning: {_eq: true}, invoicing: {_eq: true}}
    ) {
      reference
      channel_endpoints(where: {channel: {_eq: "SMS"}}) {
        endpoint
      }
    }
    contacts {
      reference
      first_name
      last_name
    }
    main_endpoints: channel_endpoints(
      where: {contact: {_is_null: true}, channel: {_neq: "SMS"}}
      order_by: {deactivated_at: asc_nulls_first, channel: asc}
    ) {
      channel
      endpoint
      endpoint_details
      deactivated_at
    }
    channel_endpoints {
      channel
      contact_by_reference {
        first_name
        last_name
      }
    }
    preferred_invoicing_channel
    balance_amount
    due_balance_amount
    reference
    custom_fields
    legal_id_type
    legal_id
    type
    dunning_is_dirty
    currentActions: actions(
      where: {status: {_eq: OPEN}}
      limit: 2
      order_by: {start_time: desc_nulls_last}
    ) {
      reference
      start_time
    }
    totalCurrentActions: actions_aggregate(where: {status: {_eq: OPEN}}) {
      aggregate {
        count
      }
    }
    invoice_documents_aggregate {
      aggregate {
        sum {
          open_amount
          total_amount
        }
      }
    }
    total_open: invoice_documents_aggregate(where: {status: {_eq: OPEN}}) {
      aggregate {
        sum {
          total_amount
          open_amount
        }
      }
    }
    total_paid: invoice_documents_aggregate(where: {status: {_eq: PAID}}) {
      aggregate {
        sum {
          total_amount
          open_amount
        }
      }
    }
    total_rfs: invoice_documents_aggregate(
      where: {status: {_eq: READY_FOR_SUBMISSION}}
    ) {
      aggregate {
        sum {
          total_amount
          open_amount
        }
      }
    }
  }
}
    `;
export const GetTemplates = gql`
    query getTemplates($legalEntityFilter: [risolto_communication_template_bool_exp!], $participant: uuid, $channels: [risolto_channel_enum!], $searchTerm: String, $locales: [String!], $toneOfVoices: [risolto_tone_of_voice_enum!], $orderBy: [risolto_communication_template_order_by!], $limit: Int!, $offset: Int!) {
  total: risolto_communication_template_aggregate(
    order_by: $orderBy
    where: {_and: [{participant: {_eq: $participant}}, {channel: {_in: $channels}}, {locale: {_in: $locales}}, {tone_of_voice: {_in: $toneOfVoices}}, {_and: $legalEntityFilter}, {_or: [{template_id: {_ilike: $searchTerm}}, {locale: {_ilike: $searchTerm}}, {legal_entity_by_reference: {registration_name: {_ilike: $searchTerm}}}]}]}
  ) {
    aggregate {
      count
    }
  }
  templates: risolto_communication_template(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: {_and: [{participant: {_eq: $participant}}, {channel: {_in: $channels}}, {locale: {_in: $locales}}, {tone_of_voice: {_in: $toneOfVoices}}, {_and: $legalEntityFilter}, {_or: [{template_id: {_ilike: $searchTerm}}, {locale: {_ilike: $searchTerm}}, {legal_entity_by_reference: {registration_name: {_ilike: $searchTerm}}}]}]}
  ) {
    reference
    participant
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    template_id
    channel
    document_name
    tone_of_voice
    type
    locale
  }
}
    `;
export const GetTemplate = gql`
    query getTemplate($reference: uuid) {
  template: risolto_communication_template(where: {reference: {_eq: $reference}}) {
    reference
    participant
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    template_id
    subject_template
    channel
    document_name
    tone_of_voice
    type
    locale
    template_renderer_version
    document_template
  }
}
    `;
export const UpdateCommunicationTemplate = gql`
    mutation updateCommunicationTemplate($document_template: jsonb, $template_reference: uuid, $subject_template: String) {
  update_risolto_communication_template(
    where: {reference: {_eq: $template_reference}}
    _set: {document_template: $document_template, subject_template: $subject_template}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;
export const GetAction = gql`
    query getAction($ref: uuid!) {
  risolto_action(where: {reference: {_eq: $ref}}) {
    status
    assignee
    assignee_by_reference {
      reference
      username
    }
    channel
    recipient
    recipient_by_reference {
      address
      balance_amount
      dunning_metadata
      last_dunning_at
      legal_id
      legal_id_type
      name
      type
      updated_by
      participant
      reference
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
      account_id
    }
    reference
    metadata
    message_code
    participant
    primary_invoice
    primary_invoice_by_reference {
      invoice_number
    }
    action_invoices {
      reference
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    source
    executed_at
    original_action
    retry_count
    start_time
    due_date
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      participant
    }
    legal_entity_by_reference {
      registration_name
      outbound_channel: processing_details(path: "outbound_channel")
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
    channel_endpoint
    channel_endpoint_by_reference {
      channel
      endpoint
      endpoint_details
      deactivated_at
      deactivated_by
      last_failed_delivery_at
      last_failed_delivery_type
      locale
      priority
    }
    executed_at
    canceled_at
    updated_at
    due_date
  }
}
    `;
export const ComponentsTimelineNote_UpdateNote = gql`
    mutation ComponentsTimelineNote_updateNote($reference: uuid!, $note: String!) {
  update_risolto_note(where: {reference: {_eq: $reference}}, _set: {note: $note}) {
    updated_count: affected_rows
    updated: returning {
      reference
      note
    }
  }
}
    `;
export const ComponentsActionTable_UserInterfaceDetails = gql`
    query ComponentsActionTable_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "action.custom_field_definitions"
    )
    disallowed_channels: user_interface_details(path: "action.disallowed_channels")
    disallowed_message_codes: user_interface_details(
      path: "action.disallowed_message_codes"
    )
  }
}
    `;
export const GetNextActionsV3Total = gql`
    query getNextActionsV3Total($participant: uuid!, $legalEntityFilter: [risolto_action_bool_exp!], $recipient: uuid, $channels: [risolto_channel_enum!], $statuses: [risolto_action_status_enum!], $msgCode: String, $executionTypes: [risolto_action_execution_type_enum!], $assigneeFilter: [risolto_action_bool_exp!], $statusAndDateFilter: [risolto_action_bool_exp!], $searchTermFilter: [risolto_action_bool_exp!], $retryFilter: [risolto_action_bool_exp!]) {
  total: risolto_action_aggregate(
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}, {recipient: {_eq: $recipient}}, {channel: {_in: $channels}}, {status: {_in: $statuses}}, {message_code: {_eq: $msgCode}}, {execution_type: {_in: $executionTypes}}, {_and: $assigneeFilter}, {_and: $statusAndDateFilter}, {_and: $searchTermFilter}, {_and: $retryFilter}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const GetNextActionsV3 = gql`
    query getNextActionsV3($participant: uuid!, $legalEntityFilter: [risolto_action_bool_exp!], $recipient: uuid, $limit: Int, $offset: Int, $channels: [risolto_channel_enum!], $statuses: [risolto_action_status_enum!], $msgCode: String, $orderBy: [risolto_action_order_by!], $executionTypes: [risolto_action_execution_type_enum!], $assigneeFilter: [risolto_action_bool_exp!], $statusAndDateFilter: [risolto_action_bool_exp!], $searchTermFilter: [risolto_action_bool_exp!], $retryFilter: [risolto_action_bool_exp!]) {
  availableActions: risolto_action(
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}, {recipient: {_eq: $recipient}}, {channel: {_in: $channels}}, {status: {_in: $statuses}}, {message_code: {_eq: $msgCode}}, {execution_type: {_in: $executionTypes}}, {_and: $assigneeFilter}, {_and: $statusAndDateFilter}, {_and: $searchTermFilter}, {_and: $retryFilter}]}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    reference
    status
    channel
    message_code
    is_retry
    execution_type
    source
    retry_count
    original_action
    start_time
    created_at
    executed_at
    canceled_at
    updated_at
    due_date
    metadata
    assignee
    assignee_by_reference {
      reference
      username
    }
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      legal_id
      legal_id_type
      name
      type
    }
    participant
    primary_invoice
    primary_invoice_by_reference {
      invoice_number
    }
    recipient
    legal_entity
    legal_entity_by_reference {
      registration_name
      outbound_channel: processing_details(path: "outbound_channel")
    }
    custom_fields
  }
}
    `;
export const ComponentsContacts_GetContacts = gql`
    query componentsContacts_getContacts($recipient: uuid!, $participant: uuid!) {
  total: risolto_contact_aggregate(
    where: {_and: [{recipient: {_eq: $recipient}}, {participant: {_eq: $participant}}, {deactivated_at: {_is_null: true}}]}
  ) {
    aggregate {
      count
    }
  }
  contacts: risolto_contact(
    where: {_and: [{recipient: {_eq: $recipient}}, {participant: {_eq: $participant}}, {deactivated_at: {_is_null: true}}]}
  ) {
    legal_entity
    locale
    participant
    first_name
    last_name
    full_name
    reference
    recipient
    contact_type_by_reference {
      reference
      contact_type
    }
    channel_endpoints(where: {channel: {_neq: "SMS"}}) {
      in_action
      endpoint_details
      deactivated_at
      deactivated_by
      channel
      endpoint
      reference
      origin
      locale
    }
    custom_fields
    origin
  }
}
    `;
export const ComponentsInvoiceDisputes_InvoiceDisputes = gql`
    query ComponentsInvoiceDisputes_invoiceDisputes($participant: uuid!, $legalEntity: uuid!, $recipient: uuid!, $invoices: [uuid!]) {
  invoice_disputes: risolto_invoice_dispute(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legalEntity}, recipient: {_eq: $recipient}, invoice: {_in: $invoices}, resolved_at: {_is_null: true}}
    order_by: {until: asc}
  ) {
    participant
    legal_entity
    reference
    until
    dispute_code
    dispute_code_by_reference {
      reference
      code
      default_assignee
      default_days_to_suspend
    }
    tasks(where: {type: {_eq: "DISPUTE"}, status: {_eq: "OPEN"}}, limit: 1) {
      participant
      legal_entity
      reference
      due_date
      assignee
      assignee_by_reference {
        reference
        username
      }
      notes(limit: 1) {
        note
      }
    }
    invoice: invoice_by_reference {
      reference
      invoice_number
      open_amount
      total_amount
      amount_currency
      attachments
      custom_fields
      payment_reference
    }
  }
}
    `;
export const CancelInvoiceDispute = gql`
    mutation cancelInvoiceDispute($participant: uuid!, $legal_entity: uuid, $references: [uuid!]!, $resolved_at: timestamptz!, $canceled_by: uuid!) {
  update_risolto_invoice_dispute(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, reference: {_in: $references}}
    _set: {resolved_at: $resolved_at}
  ) {
    affected_rows
    returning {
      __typename
      reference
      resolved_at
    }
  }
  update_risolto_task(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, invoice_dispute: {_in: $references}}
    _set: {status: "DONE", canceled_at: $resolved_at, canceled_by: $canceled_by}
  ) {
    affected_rows
    returning {
      __typename
      reference
      status
    }
  }
}
    `;
export const AssignInvoiceDispute = gql`
    mutation assignInvoiceDispute($participant: uuid!, $legal_entity: uuid, $references: [uuid!]!, $assignee: uuid) {
  update_risolto_task(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, invoice_dispute: {_in: $references}}
    _set: {assignee: $assignee}
  ) {
    affected_rows
    returning {
      __typename
      reference
      status
    }
  }
}
    `;
export const ComponentsInvoiceDisputes_UserInterfaceDetails = gql`
    query ComponentsInvoiceDisputes_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "invoice.custom_field_definitions"
    )
  }
}
    `;
export const Details = gql`
    query details($participant: uuid!, $recipient: uuid!) {
  recipient: risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    legal_entity
    language_code
    preferred_invoicing_channel
    main_endpoints: channel_endpoints(
      where: {contact: {_is_null: true}, channel: {_neq: "SMS"}, deactivated_at: {_is_null: true}}
      order_by: [{channel: asc}]
    ) {
      reference
      channel
      endpoint
      endpoint_details
      deactivated_at
      origin
      locale
    }
  }
}
    `;
export const Actions_Grouped_Total = gql`
    query actions_grouped_total($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isReference: Boolean!, $isAssignee: Boolean!, $statuses: _text, $executionTypes: _text, $participants: _uuid, $legalEntities: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  total: risolto_action_group_v12_aggregate(
    where: {}
    args: {search_term: $searchTerm, group_reference: $isReference, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, statuses: $statuses, execution_types: $executionTypes, participants: $participants, legal_entities: $legalEntities, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const Actions_Grouped = gql`
    query actions_grouped($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isReference: Boolean!, $isAssignee: Boolean!, $limit: Int!, $offset: Int!, $orderBy: [risolto_virtual_action_group_order_by!], $statuses: _text, $executionTypes: _text, $participants: _uuid, $legalEntities: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  actions: risolto_action_group_v12(
    where: {}
    args: {search_term: $searchTerm, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, group_reference: $isReference, statuses: $statuses, execution_types: $executionTypes, participants: $participants, legal_entities: $legalEntities, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    v_reference
    reference
    action_by_reference {
      is_retry
      source
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      status
      original_action
      retry_count
      participant
      metadata
      action_invoices(order_by: {invoice_by_reference: {issue_date: desc_nulls_last}}) {
        relation
        invoice
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      status
      reference
      execution_type
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        reference
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
        company_id
        company_id_type
      }
      message_code
      channel
      due_date
      start_time
      assignee
      assignee_by_reference {
        reference
        username
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
        company_id
        company_id_type
      }
      custom_fields
    }
    action_count
    due_date
    due_date_count
    channel
    channel_count
    recipient
    recipient_by_reference {
      name
      reference
      type
      participant
      legal_id_type
      legal_id
      legal_entity
      account_id
      contacts {
        reference
        first_name
        last_name
      }
      invoice_documents_aggregate {
        aggregate {
          sum {
            open_amount
            total_amount
          }
        }
      }
    }
    recipient_count
    assignee_by_reference {
      username
    }
    start_time
    start_time_count
    assignee_count
    message_code
    is_retry
    message_code_count
  }
}
    `;
export const ComponentsDialogsAttachmentTemplatesDialog__Templates = gql`
    query componentsDialogsAttachmentTemplatesDialog__templates($participant: uuid!) {
  templates: risolto_communication_template(
    where: {participant: {_eq: $participant}, ui_template_configuration: {_is_null: false}}
  ) {
    template_id
    channel
    document_name
    locale
    legal_entity
    participant
    subject_template
    template_query
    template_renderer_version
    ui_template_configuration
  }
}
    `;

export const ViewsCreditNotes_Detail = gql`
    query viewsCreditNotes_detail($credit_note: uuid!) {
  creditNote: risolto_credit_note(where: {reference: {_eq: $credit_note}}) {
    credit_note_number
    amount_currency
    issue_date
    due_date
    reference
    file_references
    legal_entity
    legal_entity_by_reference {
      registration_name
      reference
      participant
      address
      company_id
      company_id_type
    }
    total_amount
    open_amount
    amount_currency
    participant
    interchange_links {
      reference
      interchange_by_reference {
        interchange_events {
          event_type
          event_type_count
          last_event_timestamp
          email: channel_endpoint(path: "$.email")
          postal_mail: channel_endpoint(path: "postal_mail")
        }
        reference
        channel
        direction
      }
    }
    recipient
    recipient_by_reference {
      preferred_invoicing_channel
      legal_entity
      legal_entity_by_reference {
        reference
      }
      participant
      reference
      legal_id
      legal_id_type
      address
      name
      account_id
    }
    dunning_status
    custom_fields
  }
}
    `;
export const ViewsCreditNotes_UserInterfaceDetails = gql`
    query ViewsCreditNotes_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "credit_note.custom_field_definitions"
    )
  }
}
    `;
export const ViewsDebitNotes_Detail = gql`
    query viewsDebitNotes_detail($debit_note: uuid!) {
  debitNote: risolto_debit_note(where: {reference: {_eq: $debit_note}}) {
    debit_note_number
    amount_currency
    issue_date
    due_date
    reference
    file_references
    legal_entity
    legal_entity_by_reference {
      registration_name
      reference
      participant
      address
      company_id
      company_id_type
    }
    total_amount
    open_amount
    amount_currency
    participant
    interchange_links {
      reference
      interchange_by_reference {
        interchange_events {
          event_type
          event_type_count
          last_event_timestamp
          email: channel_endpoint(path: "$.email")
          postal_mail: channel_endpoint(path: "postal_mail")
        }
        reference
        channel
        direction
      }
    }
    recipient
    recipient_by_reference {
      preferred_invoicing_channel
      legal_entity
      legal_entity_by_reference {
        reference
      }
      participant
      reference
      legal_id
      legal_id_type
      address
      name
      account_id
    }
    dunning_status
    custom_fields
  }
}
    `;
export const ViewsDebitNotes_UserInterfaceDetails = gql`
    query ViewsDebitNotes_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "debit_note.custom_field_definitions"
    )
  }
}
    `;
export const ViewsDialogsActionDetail__Languages = gql`
    query viewsDialogsActionDetail__languages($participant: uuid!, $legalEntity: uuid!, $channel: risolto_channel_enum!, $templateId: String!) {
  custom: risolto_communication_template(
    where: {template_id: {_eq: $templateId}, channel: {_eq: $channel}, participant: {_eq: $participant}, legal_entity: {_eq: $legalEntity}}
  ) {
    template_id
    participant
    locale
  }
  generic: risolto_communication_template(
    where: {template_id: {_eq: $templateId}, channel: {_eq: $channel}, participant: {_is_null: true}}
  ) {
    template_id
    participant
    locale
  }
}
    `;
export const Templates = gql`
    query templates($participant: uuid!, $channel: risolto_channel_enum!) {
  risolto_communication_template(
    distinct_on: template_id
    where: {channel: {_eq: $channel}, _and: {_or: [{participant: {_eq: $participant}}, {participant: {_is_null: true}}]}}
  ) {
    template_id
  }
}
    `;
export const ViewsDialogsActionDetail_UserInterfaceDetails = gql`
    query ViewsDialogsActionDetail_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "action.custom_field_definitions"
    )
    disallowed_channels: user_interface_details(path: "action.disallowed_channels")
    disallowed_message_codes: user_interface_details(
      path: "action.disallowed_message_codes"
    )
  }
}
    `;
export const ViewsDialogsActionDetail_RecipientRecord = gql`
    query ViewsDialogsActionDetail_recipientRecord($participant: uuid!, $recipient: uuid!, $today: date!) {
  risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    reference
    name
    last_dunning_costs
    legal_entity: legal_entity_by_reference {
      reference
    }
    payment_plans {
      invoice_group_by_reference {
        invoice_group_invoices {
          invoice
        }
        invoice_group_credit_notes {
          credit_note
        }
        invoice_group_debit_notes {
          debit_note
        }
        invoice_group_payments {
          payment
        }
      }
    }
    invoice_documents {
      reference
      invoice_number
      open_amount
      due_date
      file_references
      invoice_dispute: disputes(
        where: {until: {_gte: $today}, resolved_at: {_is_null: true}}
        order_by: {until: desc}
        limit: 1
      ) {
        reference
        until
        dispute_code_by_reference {
          code
        }
      }
    }
    credit_notes {
      reference
      credit_note_number
      issue_date
      open_amount
      file_references
    }
    debit_notes {
      reference
      debit_note_number
      issue_date
      open_amount
    }
    payment_documents {
      reference
      payment_number
      issue_date
      open_amount
    }
  }
}
    `;
export const ViewsDialogsActionDetail_DunningNotice = gql`
    query ViewsDialogsActionDetail_dunningNotice($participant: uuid!, $action: uuid!) {
  risolto_action(
    where: {reference: {_eq: $action}, participant: {_eq: $participant}}
  ) {
    reference
    metadata
    dunning_notice_by_reference {
      charges
      interest
      invoice_group_by_reference {
        invoice_group_credit_notes {
          credit_note
        }
        invoice_group_debit_notes {
          debit_note
        }
        invoice_group_invoices {
          invoice
        }
        invoice_group_payments {
          payment
        }
      }
    }
  }
}
    `;
export const ViewsDialogsActionDetail_EmailAddressFrom = gql`
    query ViewsDialogsActionDetail_emailAddressFrom($participant: uuid!, $action: uuid!) {
  risolto_action(
    where: {participant: {_eq: $participant}, reference: {_eq: $action}}
  ) {
    legal_entity_by_reference {
      outbound_channel_communication_email_addresses: processing_details(
        path: "outbound_channel.communication.email_addresses"
      )
    }
    channel_from: metadata(path: "channels[0]._from")
  }
}
    `;
export const ViewsInvoiceDisputes_DisputeCodes = gql`
    query ViewsInvoiceDisputes_disputeCodes($participant: uuid!) {
  disputeCodes: risolto_dispute_code(
    distinct_on: [code]
    where: {_and: [{_or: [{participant: {_eq: $participant}}, {participant: {_is_null: true}}]}]}
    order_by: [{code: asc}, {participant: desc_nulls_last}]
  ) {
    reference
    code
    default_assignee
    default_days_to_suspend
  }
}
    `;
export const ViewsInvoiceDisputes_AssignInvoiceDispute = gql`
    mutation ViewsInvoiceDisputes_assignInvoiceDispute($participant: uuid!, $legal_entity: uuid, $references: [uuid!]!, $assignee: uuid) {
  update_risolto_task(
    where: {participant: {_eq: $participant}, invoice_dispute: {_in: $references}}
    _set: {assignee: $assignee}
  ) {
    affected_rows
    returning {
      __typename
      reference
      status
    }
  }
}
    `;
export const ViewsInvoiceDisputesRecipient_RecipientRecord = gql`
    query ViewsInvoiceDisputesRecipient_recipientRecord($recipient: uuid!) {
  recipientRecord: risolto_recipient_by_pk(reference: $recipient) {
    reference
    name
    legal_entity
    custom_fields
  }
}
    `;
export const ViewsInvoiceDisputesRecipient_RecipientAttachments = gql`
    query ViewsInvoiceDisputesRecipient_recipientAttachments($recipient: uuid!) {
  recipientAttachments: risolto_recipient_attachment(
    where: {recipient: {_eq: $recipient}}
  ) {
    metadata
  }
}
    `;
export const ViewsInvoiceDisputes_Tasks = gql`
    query ViewsInvoiceDisputes_tasks($where: risolto_task_bool_exp!) {
  tasks: risolto_task(where: $where, order_by: {due_date: asc, created_at: asc}) {
    reference
    assignee_by_reference {
      username
    }
    due_date
    status
    invoice_dispute_by_reference {
      reference
      dispute_code_by_reference {
        code
      }
      invoice: invoice_by_reference {
        reference
        invoice_number
        issue_date
        due_date
        open_amount
        amount_currency
      }
      recipient: recipient_by_reference {
        reference
        legal_entity
        name
        currency
      }
      from
      until
      resolved_at
    }
  }
}
    `;
export const ViewsInvoiceDisputes_UserInterfaceDetails = gql`
    query ViewsInvoiceDisputes_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    contact_allow_edit: user_interface_details(path: "contact.allow_edit")
    recipient_allow_edit: user_interface_details(path: "recipient.allow_edit")
    custom_field_definitions: user_interface_details(
      path: "recipient.custom_field_definitions"
    )
    credit_note_custom_field_definitions: user_interface_details(
      path: "credit_note.custom_field_definitions"
    )
    debit_note_custom_field_definitions: user_interface_details(
      path: "debit_note.custom_field_definitions"
    )
    payment_document_custom_field_definitions: user_interface_details(
      path: "payment_document.custom_field_definitions"
    )
  }
}
    `;
export const ViewsInvoices_UserInterfaceDetails = gql`
    query ViewsInvoices_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "invoice.custom_field_definitions"
    )
  }
}
    `;
export const ComponentsMessagesTable_MessagesTotal = gql`
    query ComponentsMessagesTable_messagesTotal($participant: uuid!, $legalEntity: uuid, $recipient: uuid, $assignees: _uuid, $dateStart: timestamptz, $dateEnd: timestamptz, $archivedIsNull: Boolean, $direction: String, $isLinked: Boolean, $searchTerm: String) {
  total: risolto_mailbox_actions_and_messages_aggregate(
    args: {p_participant: $participant, p_legal_entity: $legalEntity, p_recipient: $recipient, p_assignees: $assignees, p_date_start: $dateStart, p_date_end: $dateEnd, p_archived_is_null: $archivedIsNull, p_direction: $direction, p_is_linked: $isLinked, p_search_term: $searchTerm, p_limit: 999999999}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const ComponentsMessagesTable_Messages = gql`
    query ComponentsMessagesTable_messages($participant: uuid!, $limit: Int = 10, $offset: Int = 0, $legalEntity: uuid, $recipient: uuid, $assignees: _uuid, $dateStart: timestamptz, $dateEnd: timestamptz, $archivedIsNull: Boolean, $direction: String, $isLinked: Boolean, $searchTerm: String, $orderBy: [risolto_view_action_and_message_order_by!]) {
  messages: risolto_mailbox_actions_and_messages(
    args: {p_participant: $participant, p_legal_entity: $legalEntity, p_recipient: $recipient, p_assignees: $assignees, p_date_start: $dateStart, p_date_end: $dateEnd, p_archived_is_null: $archivedIsNull, p_direction: $direction, p_is_linked: $isLinked, p_search_term: $searchTerm, p_limit: $limit, p_offset: $offset}
    order_by: $orderBy
  ) {
    reference
    message
    action
    from_
    subject
    direction
    received_at
    archived_at
    metadata
    is_linked
    action_by_reference {
      reference
      status
      channel
      message_code
      is_retry
      execution_type
      source
      retry_count
      original_action
      start_time
      created_at
      executed_at
      canceled_at
      updated_at
      due_date
      metadata
      assignee
      assignee_by_reference {
        reference
        username
      }
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        legal_id
        legal_id_type
        name
        type
      }
      participant
      primary_invoice
      primary_invoice_by_reference {
        invoice_number
      }
      recipient
      legal_entity
      legal_entity_by_reference {
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
      }
      custom_fields
      action_interchanges(order_by: {created_at: desc}) {
        interchange_by_reference {
          interchange_events(order_by: {last_event_timestamp: desc}) {
            event_type
            last_event_timestamp
          }
        }
      }
    }
    message_by_reference {
      message_recipients {
        recipient_by_reference {
          reference
          account_id
          name
        }
      }
      message_assignees {
        person_by_reference {
          reference
          username
        }
      }
      message_attachments {
        reference
      }
    }
  }
}
    `;
export const Risolto_Participant_Aggregate = gql`
    query risolto_participant_aggregate {
  risolto_participant_aggregate {
    aggregate {
      count
    }
  }
}
    `;
export const ViewPaymentPlanCreate_RecipientRecord = gql`
    query ViewPaymentPlanCreate_recipientRecord($participant: uuid!, $recipient: uuid!) {
  risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    reference
    name
    currency
    legal_entity_by_reference {
      reference
      payment_plan_conditions: processing_details(path: "payment_plan.conditions")
    }
    invoice_documents(where: {open_amount: {_gt: 0.00}}) {
      reference
      invoice_number
      open_amount
      due_date
      amount_currency
    }
    credit_notes(where: {open_amount: {_gt: 0.00}}) {
      reference
      credit_note_number
      issue_date
      open_amount
      amount_currency
    }
    debit_notes(where: {open_amount: {_gt: 0.00}}) {
      reference
      debit_note_number
      issue_date
      open_amount
      amount_currency
    }
    payment_documents(where: {open_amount: {_gt: 0.00}}) {
      reference
      payment_number
      issue_date
      open_amount
      amount_currency
    }
  }
}
    `;
export const ViewPaymentPlanEdit_PaymentPlanRecord = gql`
    query ViewPaymentPlanEdit_paymentPlanRecord($participant: uuid!, $paymentPlan: uuid!) {
  risolto_payment_plan(
    where: {reference: {_eq: $paymentPlan}, participant: {_eq: $participant}}
  ) {
    reference
    total_amount
    open_amount
    due_amount
    amount_currency
    conditions
    status
    canceled_at
    legal_entity
    recipient
    recipient_by_reference {
      name
      currency
    }
    payment_promises(order_by: {due_date: asc}) {
      reference
      payment_reference
      due_date
      total_amount
      open_amount
      amount_currency
    }
    invoice_group_by_reference {
      invoice_group_invoices {
        invoice_by_reference {
          reference
          invoice_number
          due_date
          open_amount
          amount_currency
        }
      }
      invoice_group_credit_notes {
        credit_note_by_reference {
          reference
          credit_note_number
          issue_date
          open_amount
          amount_currency
        }
      }
      invoice_group_debit_notes {
        debit_note_by_reference {
          reference
          debit_note_number
          issue_date
          open_amount
          amount_currency
        }
      }
      invoice_group_payments {
        payment_by_reference {
          reference
          payment_number
          issue_date
          open_amount
          amount_currency
        }
      }
    }
  }
}
    `;
export const ViewsPaymentTransfer_GetPaymentTransferBulkPayment = gql`
    query ViewsPaymentTransfer_GetPaymentTransferBulkPayment($payment_transfer: uuid!, $participant: uuid!) {
  records: risolto_payment_transfer_bulk_payment(
    where: {payment_transfer: {_eq: $payment_transfer}, participant: {_eq: $participant}}
  ) {
    external_account_id
    external_status
    external_system
    idempotency_key
    short_description
    signing_link
    created_at
    error_at
    finished_at
    last_updated
    updated_at
    external_bulk_payment_id
    legal_entity
    participant
    payment_transfer
    reference
  }
}
    `;
export const ViewsBulkPayments_GetBulkPayments = gql`
    query ViewsBulkPayments_GetBulkPayments($participant: uuid!, $legal_entity: uuid!) {
  created: risolto_payment_transfer(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, status: {_eq: CREATED}}
    order_by: {created_at: desc}
  ) {
    reference
    group_date
    total_amount: payment_transfer_lines_aggregate {
      aggregate {
        sum {
          amount
        }
        count
      }
    }
  }
  executed: risolto_payment_transfer_bulk_payment(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}}
    order_by: {created_at: desc}
  ) {
    short_description
    signing_link
    created_at
    error_at
    finished_at
    last_updated
    updated_at
    legal_entity
    participant
    payment_transfer
    reference
    details: payment_transfer_by_reference {
      total_amount: payment_transfer_lines_aggregate {
        aggregate {
          sum {
            amount
          }
          count
        }
      }
    }
  }
}
    `;
export const ViewsBulkPayment_GetPaymentTransferConfiguration = gql`
    query ViewsBulkPayment_GetPaymentTransferConfiguration($reference: uuid!, $participant: uuid!) {
  legal_entity: risolto_legal_entity(
    where: {reference: {_eq: $reference}, participant: {_eq: $participant}}
  ) {
    reference
    participant
    payment_transfer_configuration: processing_details(path: "payment_transfer")
  }
}
    `;
export const ViewsPaymentTransfer_PaymentTransfers = gql`
    query ViewsPaymentTransfer_PaymentTransfers($participant: uuid!, $legal_entity: uuid!) {
  records: risolto_payment_transfer(
    order_by: {group_date: desc}
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}}
  ) {
    reference
    group_date
    account_number
    account_number_type
    bank_identifier
    bank_identifier_type
    creditor_name
    status
    created_at
    updated_at
    legal_entity
    participant
    reference
    idempotency_key
  }
}
    `;
export const ViewsPaymentDocuments_Detail = gql`
    query viewsPaymentDocuments_detail($payment_document: uuid!) {
  paymentDocument: risolto_payment_document(
    where: {reference: {_eq: $payment_document}}
  ) {
    payment_number
    amount_currency
    issue_date
    due_date
    reference
    file_references
    legal_entity
    legal_entity_by_reference {
      registration_name
      reference
      participant
      address
      company_id
      company_id_type
    }
    total_amount
    open_amount
    amount_currency
    participant
    interchange_links {
      reference
      interchange_by_reference {
        interchange_events {
          event_type
          event_type_count
          last_event_timestamp
          email: channel_endpoint(path: "$.email")
          postal_mail: channel_endpoint(path: "postal_mail")
        }
        reference
        channel
        direction
      }
    }
    recipient
    recipient_by_reference {
      preferred_invoicing_channel
      legal_entity
      legal_entity_by_reference {
        reference
      }
      participant
      reference
      legal_id
      legal_id_type
      address
      name
      account_id
    }
    dunning_status
    custom_fields
  }
}
    `;
export const ViewsPaymentDocuments_UserInterfaceDetails = gql`
    query ViewsPaymentDocuments_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "payment_document.custom_field_definitions"
    )
  }
}
    `;
export const ViewsRecipientRecipientDetail_RecipientAttachments = gql`
    query ViewsRecipientRecipientDetail_recipientAttachments($recipient: uuid!) {
  recipientAttachments: risolto_recipient_attachment(
    where: {recipient: {_eq: $recipient}}
  ) {
    metadata
  }
}
    `;
export const ViewsRecipient_RecipientsTotal = gql`
    query ViewsRecipient_recipientsTotal($participant: uuid!, $legalEntityFilter: [risolto_recipient_bool_exp!], $searchTermFilter: [risolto_recipient_bool_exp!], $tagsFilter: [risolto_recipient_bool_exp!], $customFieldsFilter: [risolto_recipient_bool_exp!]) {
  total: risolto_recipient_aggregate(
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}, {_and: $searchTermFilter}, {_and: $tagsFilter}, {_and: $customFieldsFilter}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const ViewsRecipient_Recipients = gql`
    query ViewsRecipient_recipients($participant: uuid!, $limit: Int = 10, $offset: Int = 0, $legalEntityFilter: [risolto_recipient_bool_exp!], $searchTermFilter: [risolto_recipient_bool_exp!], $tagsFilter: [risolto_recipient_bool_exp!], $customFieldsFilter: [risolto_recipient_bool_exp!], $orderBy: [risolto_recipient_order_by!]) {
  recipients: risolto_recipient(
    limit: $limit
    offset: $offset
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}, {_and: $searchTermFilter}, {_and: $tagsFilter}, {_and: $customFieldsFilter}]}
    order_by: $orderBy
  ) {
    name
    reference
    type
    participant
    legal_id_type
    legal_id
    legal_entity
    account_id
  }
}
    `;
export const ViewsRecipient_Recipient = gql`
    query ViewsRecipient_recipient($participant: uuid!, $recipient: uuid!) {
  risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    last_dunning_costs
    in_collection
    last_dunning_run_at
    name
    account_id
    participant
    participant_by_reference {
      reference
    }
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
      company_id
      company_id_type
      payment_plan: processing_details(path: "payment_plan")
	  account_overview: processing_details(path: "account_overview")
    }
    address
    contacts {
      reference
      first_name
      last_name
    }
    channel_endpoints(where: {deactivated_at: {_is_null: true}}) {
      channel
      contact_by_reference {
        first_name
        last_name
      }
    }
    due_balance_amount
    balance_amount
    currency
    reference
    custom_fields
    legal_id_type
    legal_id
    type
    dunning_is_dirty
    prediction_stars
    tags {
      tag
      tag_name
      can_remove
    }
    collections {
      custom_fields
    }
    message_recipients(
      where: {message_by_reference: {archived_at: {_is_null: true}}}
    ) {
      reference
    }
  }
}
    `;
export const ViewsReports_Reports = gql`
    query ViewsReports_reports($participant: uuid!, $legalEntityFilter: [risolto_report_execution_bool_exp!], $limit: Int = 10, $offset: Int = 0) {
  total: risolto_report_execution_aggregate(
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}]}
  ) {
    aggregate {
      count
    }
  }
  reports: risolto_report_execution(
    limit: $limit
    offset: $offset
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}]}
  ) {
    reference
    legal_entity_by_reference {
      registration_name
    }
    report_definition_by_reference {
      name
      report_template_type
    }
    report_path
    completed_at
  }
}
    `;
export const ActionsFragmentDetailsFieldsFragmentDoc = gql`
    fragment actionsFragmentDetailsFields on risolto_action {
  status
  channel
  recipient
  recipient_by_reference {
    address
    balance_amount
    dunning_metadata
    last_dunning_at
    legal_id
    legal_id_type
    name
    account_id
    type
    updated_by
    participant
    reference
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
  }
  reference
  metadata
  message_code
  participant
  primary_invoice
  primary_invoice_by_reference {
    invoice_number
  }
  action_invoices {
    reference
    relation
    invoice_by_reference {
      invoice_number
      open_amount
      total_amount
      payment_reference
      due_date
      issue_date
      status
      recipient
      recipient_by_reference {
        reference
        name
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
      participant
      participant_by_reference {
        name
        reference
        logical_id
      }
      reference
      amount_currency
      interchange_links {
        interchange_by_reference {
          reference
          channel
          direction
        }
      }
    }
  }
  legal_entity
  execution_type
  source
  executed_at
  original_action
  retry_count
  start_time
  due_date
  recipient
  recipient_by_reference {
    reference
    name
    account_id
    participant
  }
  legal_entity_by_reference {
    registration_name
    outbound_channel: processing_details(path: "outbound_channel")
  }
  created_at
  assignee
  assignee_by_reference {
    username
  }
  channel_endpoint
  channel_endpoint_by_reference {
    channel
    endpoint
    endpoint_details
    deactivated_at
    deactivated_by
    last_failed_delivery_at
    last_failed_delivery_type
    locale
    priority
  }
}
    `;
export const GetCreditNotesDocument = gql`
    query getCreditNotes($participant: uuid!, $recipient: uuid!, $offset: Int, $limit: Int) {
  total: risolto_credit_note_aggregate(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
  ) {
    aggregate {
      count
    }
  }
  risolto_credit_note(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
    limit: $limit
    offset: $offset
    order_by: {is_open: desc, issue_date: desc_nulls_last}
  ) {
    reference
    created_at
    interchange_links {
      interchange_by_reference {
        reference
        channel
        direction
        interchange_events {
          event_type
          last_event_timestamp
        }
      }
    }
    participant
    amount_currency
    processing_status
    status
    custom_fields
    origin
    credit_note_number
    total_amount
    open_amount
    due_date
    due_amount
    issue_date
    file_references
  }
}
    `;

/**
 * __useGetCreditNotesQuery__
 *
 * To run a query within a Vue component, call `useGetCreditNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCreditNotesQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useGetCreditNotesQuery(variables: GetCreditNotesQueryVariables | VueCompositionApi.Ref<GetCreditNotesQueryVariables> | ReactiveFunction<GetCreditNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCreditNotesQuery, GetCreditNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCreditNotesQuery, GetCreditNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCreditNotesQuery, GetCreditNotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCreditNotesQuery, GetCreditNotesQueryVariables>(GetCreditNotesDocument, variables, options);
}
export function useGetCreditNotesLazyQuery(variables: GetCreditNotesQueryVariables | VueCompositionApi.Ref<GetCreditNotesQueryVariables> | ReactiveFunction<GetCreditNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCreditNotesQuery, GetCreditNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCreditNotesQuery, GetCreditNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCreditNotesQuery, GetCreditNotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCreditNotesQuery, GetCreditNotesQueryVariables>(GetCreditNotesDocument, variables, options);
}
export type GetCreditNotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCreditNotesQuery, GetCreditNotesQueryVariables>;
export const GetDebitNotesDocument = gql`
    query getDebitNotes($participant: uuid!, $recipient: uuid!, $offset: Int, $limit: Int) {
  total: risolto_debit_note_aggregate(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
  ) {
    aggregate {
      count
    }
  }
  risolto_debit_note(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
    limit: $limit
    offset: $offset
    order_by: {is_open: desc, issue_date: desc_nulls_last}
  ) {
    reference
    created_at
    participant
    amount_currency
    processing_status
    custom_fields
    origin
    debit_note_number
    total_amount
    open_amount
    due_date
    issue_date
  }
}
    `;

/**
 * __useGetDebitNotesQuery__
 *
 * To run a query within a Vue component, call `useGetDebitNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebitNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDebitNotesQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useGetDebitNotesQuery(variables: GetDebitNotesQueryVariables | VueCompositionApi.Ref<GetDebitNotesQueryVariables> | ReactiveFunction<GetDebitNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetDebitNotesQuery, GetDebitNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDebitNotesQuery, GetDebitNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDebitNotesQuery, GetDebitNotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetDebitNotesQuery, GetDebitNotesQueryVariables>(GetDebitNotesDocument, variables, options);
}
export function useGetDebitNotesLazyQuery(variables: GetDebitNotesQueryVariables | VueCompositionApi.Ref<GetDebitNotesQueryVariables> | ReactiveFunction<GetDebitNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetDebitNotesQuery, GetDebitNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetDebitNotesQuery, GetDebitNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetDebitNotesQuery, GetDebitNotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetDebitNotesQuery, GetDebitNotesQueryVariables>(GetDebitNotesDocument, variables, options);
}
export type GetDebitNotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetDebitNotesQuery, GetDebitNotesQueryVariables>;
export const ReactivateEndpointDocument = gql`
    mutation reactivateEndpoint($participant: uuid!, $reference: uuid!) {
  update_risolto_channel_endpoint(
    where: {reference: {_eq: $reference}, participant: {_eq: $participant}}
    _set: {deactivated_at: null, deactivated_by: "NULL"}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;

/**
 * __useReactivateEndpointMutation__
 *
 * To run a mutation, you first call `useReactivateEndpointMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReactivateEndpointMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReactivateEndpointMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     reference: // value for 'reference'
 *   },
 * });
 */
export function useReactivateEndpointMutation(options: VueApolloComposable.UseMutationOptions<ReactivateEndpointMutation, ReactivateEndpointMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReactivateEndpointMutation, ReactivateEndpointMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReactivateEndpointMutation, ReactivateEndpointMutationVariables>(ReactivateEndpointDocument, options);
}
export type ReactivateEndpointMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReactivateEndpointMutation, ReactivateEndpointMutationVariables>;
export const DeactivateEndpointDocument = gql`
    mutation deactivateEndpoint($participant: uuid!, $reference: uuid!, $deactivated_by: String!) {
  update_risolto_channel_endpoint(
    where: {reference: {_eq: $reference}, participant: {_eq: $participant}}
    _set: {deactivated_at: "now()", deactivated_by: $deactivated_by}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;

/**
 * __useDeactivateEndpointMutation__
 *
 * To run a mutation, you first call `useDeactivateEndpointMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateEndpointMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateEndpointMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     reference: // value for 'reference'
 *     deactivated_by: // value for 'deactivated_by'
 *   },
 * });
 */
export function useDeactivateEndpointMutation(options: VueApolloComposable.UseMutationOptions<DeactivateEndpointMutation, DeactivateEndpointMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeactivateEndpointMutation, DeactivateEndpointMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeactivateEndpointMutation, DeactivateEndpointMutationVariables>(DeactivateEndpointDocument, options);
}
export type DeactivateEndpointMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeactivateEndpointMutation, DeactivateEndpointMutationVariables>;
export const ActionsGetDocument = gql`
    query actionsGet($limit: Int = 10, $offset: Int = 0, $status: [risolto_action_status_enum!], $execution_type: [risolto_action_execution_type_enum!], $participant: uuid!, $invoice: uuid, $channel: risolto_channel_enum, $recipientRef: uuid, $orderBy: [risolto_action_order_by!]) {
  total: risolto_action_aggregate(
    order_by: $orderBy
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipientRef}, status: {_in: $status}, execution_type: {_in: $execution_type}, channel: {_eq: $channel}}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action(
    order_by: {updated_at: desc}
    limit: $limit
    offset: $offset
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipientRef}, status: {_in: $status}, execution_type: {_in: $execution_type}, channel: {_eq: $channel}}
  ) {
    reference
    metadata
    message_code
    participant
    action_invoices {
      reference
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    status
    channel
    source
    executed_at
    original_action
    retry_count
    start_time
    due_date
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      custom_fields
    }
    legal_entity_by_reference {
      registration_name
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
  }
}
    `;

/**
 * __useActionsGetQuery__
 *
 * To run a query within a Vue component, call `useActionsGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetQuery({
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   status: // value for 'status'
 *   execution_type: // value for 'execution_type'
 *   participant: // value for 'participant'
 *   invoice: // value for 'invoice'
 *   channel: // value for 'channel'
 *   recipientRef: // value for 'recipientRef'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useActionsGetQuery(variables: ActionsGetQueryVariables | VueCompositionApi.Ref<ActionsGetQueryVariables> | ReactiveFunction<ActionsGetQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetQuery, ActionsGetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetQuery, ActionsGetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetQuery, ActionsGetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetQuery, ActionsGetQueryVariables>(ActionsGetDocument, variables, options);
}
export function useActionsGetLazyQuery(variables: ActionsGetQueryVariables | VueCompositionApi.Ref<ActionsGetQueryVariables> | ReactiveFunction<ActionsGetQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetQuery, ActionsGetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetQuery, ActionsGetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetQuery, ActionsGetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetQuery, ActionsGetQueryVariables>(ActionsGetDocument, variables, options);
}
export type ActionsGetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetQuery, ActionsGetQueryVariables>;
export const ActionsGetInvoiceActionsDocument = gql`
    query actionsGetInvoiceActions($limit: Int = 10, $offset: Int = 0, $status: [risolto_action_status_enum!], $execution_type: [risolto_action_execution_type_enum!], $participant: uuid!, $invoice: uuid, $channel: risolto_channel_enum, $recipientRef: uuid, $orderBy: [risolto_action_order_by!]) {
  total: risolto_action_aggregate(
    where: {participant: {_eq: $participant}, action_invoices: {invoice_by_reference: {reference: {_eq: $invoice}}}, recipient: {_eq: $recipientRef}, status: {_in: $status}, execution_type: {_in: $execution_type}, channel: {_eq: $channel}}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action(
    order_by: {updated_at: desc}
    limit: $limit
    offset: $offset
    where: {participant: {_eq: $participant}, action_invoices: {invoice_by_reference: {reference: {_eq: $invoice}}}, recipient: {_eq: $recipientRef}, status: {_in: $status}, execution_type: {_in: $execution_type}, channel: {_eq: $channel}}
  ) {
    reference
    metadata
    message_code
    participant
    action_invoices {
      invoice
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    status
    channel
    source
    original_action
    retry_count
    executed_at
    start_time
    due_date
    recipient
    recipient_by_reference {
      reference
      name
      account_id
    }
    legal_entity_by_reference {
      registration_name
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
  }
}
    `;

/**
 * __useActionsGetInvoiceActionsQuery__
 *
 * To run a query within a Vue component, call `useActionsGetInvoiceActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetInvoiceActionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetInvoiceActionsQuery({
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   status: // value for 'status'
 *   execution_type: // value for 'execution_type'
 *   participant: // value for 'participant'
 *   invoice: // value for 'invoice'
 *   channel: // value for 'channel'
 *   recipientRef: // value for 'recipientRef'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useActionsGetInvoiceActionsQuery(variables: ActionsGetInvoiceActionsQueryVariables | VueCompositionApi.Ref<ActionsGetInvoiceActionsQueryVariables> | ReactiveFunction<ActionsGetInvoiceActionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables>(ActionsGetInvoiceActionsDocument, variables, options);
}
export function useActionsGetInvoiceActionsLazyQuery(variables: ActionsGetInvoiceActionsQueryVariables | VueCompositionApi.Ref<ActionsGetInvoiceActionsQueryVariables> | ReactiveFunction<ActionsGetInvoiceActionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables>(ActionsGetInvoiceActionsDocument, variables, options);
}
export type ActionsGetInvoiceActionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetInvoiceActionsQuery, ActionsGetInvoiceActionsQueryVariables>;
export const ActionsGetParticipantActionAggregateDocument = gql`
    query actionsGetParticipantActionAggregate($actionType: [risolto_action_execution_type_enum!], $status: [risolto_action_status_enum!]) {
  risolto_action_aggregate(
    where: {execution_type: {_in: $actionType}, status: {_in: $status}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useActionsGetParticipantActionAggregateQuery__
 *
 * To run a query within a Vue component, call `useActionsGetParticipantActionAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetParticipantActionAggregateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetParticipantActionAggregateQuery({
 *   actionType: // value for 'actionType'
 *   status: // value for 'status'
 * });
 */
export function useActionsGetParticipantActionAggregateQuery(variables: ActionsGetParticipantActionAggregateQueryVariables | VueCompositionApi.Ref<ActionsGetParticipantActionAggregateQueryVariables> | ReactiveFunction<ActionsGetParticipantActionAggregateQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables>(ActionsGetParticipantActionAggregateDocument, variables, options);
}
export function useActionsGetParticipantActionAggregateLazyQuery(variables: ActionsGetParticipantActionAggregateQueryVariables | VueCompositionApi.Ref<ActionsGetParticipantActionAggregateQueryVariables> | ReactiveFunction<ActionsGetParticipantActionAggregateQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables>(ActionsGetParticipantActionAggregateDocument, variables, options);
}
export type ActionsGetParticipantActionAggregateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetParticipantActionAggregateQuery, ActionsGetParticipantActionAggregateQueryVariables>;
export const ActionsGetActionDocument = gql`
    query actionsGetAction($action: uuid!, $participant: uuid!) {
  action: risolto_action(
    where: {reference: {_eq: $action}, participant: {_eq: $participant}}
  ) {
    reference
    metadata
    channel
    message_code
    participant
    participant_by_reference {
      name
    }
    legal_entity
    legal_entity_by_reference {
      company_id
      company_id_type
      registration_name
      outbound_channel: processing_details(path: "outbound_channel")
    }
    recipient
    recipient_by_reference {
      reference
      account_id
    }
    execution_type
    status
    source
    due_date
    original_action
    retry_count
    created_at
    assignee
    assignee_by_reference {
      username
    }
    channel_endpoint
    channel_endpoint_by_reference {
      channel
      endpoint
      endpoint_details
      deactivated_at
      deactivated_by
      last_failed_delivery_at
      last_failed_delivery_type
      locale
      priority
    }
  }
}
    `;

/**
 * __useActionsGetActionQuery__
 *
 * To run a query within a Vue component, call `useActionsGetActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetActionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetActionQuery({
 *   action: // value for 'action'
 *   participant: // value for 'participant'
 * });
 */
export function useActionsGetActionQuery(variables: ActionsGetActionQueryVariables | VueCompositionApi.Ref<ActionsGetActionQueryVariables> | ReactiveFunction<ActionsGetActionQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetActionQuery, ActionsGetActionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetActionQuery, ActionsGetActionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetActionQuery, ActionsGetActionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetActionQuery, ActionsGetActionQueryVariables>(ActionsGetActionDocument, variables, options);
}
export function useActionsGetActionLazyQuery(variables: ActionsGetActionQueryVariables | VueCompositionApi.Ref<ActionsGetActionQueryVariables> | ReactiveFunction<ActionsGetActionQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetActionQuery, ActionsGetActionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetActionQuery, ActionsGetActionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetActionQuery, ActionsGetActionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetActionQuery, ActionsGetActionQueryVariables>(ActionsGetActionDocument, variables, options);
}
export type ActionsGetActionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetActionQuery, ActionsGetActionQueryVariables>;
export const ActionsUpdateActionAssigneeDocument = gql`
    mutation actionsUpdateActionAssignee($actionRef: uuid!, $personRef: uuid) {
  update_risolto_action(
    where: {reference: {_eq: $actionRef}}
    _set: {assignee: $personRef}
  ) {
    updated_count: affected_rows
    updated: returning {
      reference
      assignee_by_reference {
        username
      }
    }
  }
}
    `;

/**
 * __useActionsUpdateActionAssigneeMutation__
 *
 * To run a mutation, you first call `useActionsUpdateActionAssigneeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsUpdateActionAssigneeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsUpdateActionAssigneeMutation({
 *   variables: {
 *     actionRef: // value for 'actionRef'
 *     personRef: // value for 'personRef'
 *   },
 * });
 */
export function useActionsUpdateActionAssigneeMutation(options: VueApolloComposable.UseMutationOptions<ActionsUpdateActionAssigneeMutation, ActionsUpdateActionAssigneeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsUpdateActionAssigneeMutation, ActionsUpdateActionAssigneeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsUpdateActionAssigneeMutation, ActionsUpdateActionAssigneeMutationVariables>(ActionsUpdateActionAssigneeDocument, options);
}
export type ActionsUpdateActionAssigneeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsUpdateActionAssigneeMutation, ActionsUpdateActionAssigneeMutationVariables>;
export const ActionsUpdateActionMetadataDocument = gql`
    mutation actionsUpdateActionMetadata($action: uuid!, $metadata: jsonb!, $channel: risolto_channel_enum!) {
  update_risolto_action(
    where: {reference: {_eq: $action}}
    _set: {metadata: $metadata, channel: $channel}
  ) {
    updated_count: affected_rows
    updated: returning {
      reference
      metadata
    }
  }
}
    `;

/**
 * __useActionsUpdateActionMetadataMutation__
 *
 * To run a mutation, you first call `useActionsUpdateActionMetadataMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsUpdateActionMetadataMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsUpdateActionMetadataMutation({
 *   variables: {
 *     action: // value for 'action'
 *     metadata: // value for 'metadata'
 *     channel: // value for 'channel'
 *   },
 * });
 */
export function useActionsUpdateActionMetadataMutation(options: VueApolloComposable.UseMutationOptions<ActionsUpdateActionMetadataMutation, ActionsUpdateActionMetadataMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsUpdateActionMetadataMutation, ActionsUpdateActionMetadataMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsUpdateActionMetadataMutation, ActionsUpdateActionMetadataMutationVariables>(ActionsUpdateActionMetadataDocument, options);
}
export type ActionsUpdateActionMetadataMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsUpdateActionMetadataMutation, ActionsUpdateActionMetadataMutationVariables>;
export const ActionsAddDocument = gql`
    mutation actionsAdd($channel: risolto_channel_enum, $executionType: risolto_action_execution_type_enum, $legalEntity: uuid, $recipient: uuid, $metadata: jsonb, $participant: uuid, $status: risolto_action_status_enum, $startTime: timestamptz, $exectutedAt: timestamptz, $source: risolto_action_source_enum, $messageCode: String, $primaryInvoice: uuid!, $invoiceGroupInvoices: [risolto_invoice_group_invoice_insert_input!]!) {
  insert_risolto_action(
    objects: {channel: $channel, execution_type: $executionType, metadata: $metadata, legal_entity: $legalEntity, participant: $participant, status: $status, start_time: $startTime, executed_at: $exectutedAt, recipient: $recipient, message_code: $messageCode, source: $source, primary_invoice: $primaryInvoice, dunning_notice_by_reference: {data: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, type_code: _100_REMINDER, charges: 0, principal_amount: 0, interest: 0, invoice_group_by_reference: {data: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, invoice_group_invoices: {data: $invoiceGroupInvoices}}}}}}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;

/**
 * __useActionsAddMutation__
 *
 * To run a mutation, you first call `useActionsAddMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsAddMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsAddMutation({
 *   variables: {
 *     channel: // value for 'channel'
 *     executionType: // value for 'executionType'
 *     legalEntity: // value for 'legalEntity'
 *     recipient: // value for 'recipient'
 *     metadata: // value for 'metadata'
 *     participant: // value for 'participant'
 *     status: // value for 'status'
 *     startTime: // value for 'startTime'
 *     exectutedAt: // value for 'exectutedAt'
 *     source: // value for 'source'
 *     messageCode: // value for 'messageCode'
 *     primaryInvoice: // value for 'primaryInvoice'
 *     invoiceGroupInvoices: // value for 'invoiceGroupInvoices'
 *   },
 * });
 */
export function useActionsAddMutation(options: VueApolloComposable.UseMutationOptions<ActionsAddMutation, ActionsAddMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsAddMutation, ActionsAddMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsAddMutation, ActionsAddMutationVariables>(ActionsAddDocument, options);
}
export type ActionsAddMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsAddMutation, ActionsAddMutationVariables>;
export const ActionsAddManualActionInvoiceCopyDocument = gql`
    mutation actionsAddManualActionInvoiceCopy($participant: uuid!, $legalEntity: uuid, $recipient: uuid!, $metadata: jsonb!, $invoice: uuid!, $channelEndpoint: uuid, $start_time: timestamptz) {
  action: insert_risolto_action_one(
    object: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, channel_endpoint: $channelEndpoint, channel: EMAIL, source: MANUAL, status: OPEN, metadata: $metadata, primary_invoice: $invoice, execution_type: MANUAL, message_code: "invoiceCopy", start_time: $start_time, action_invoices: {data: [{participant: $participant, legal_entity: $legalEntity, invoice: $invoice, relation: "PRIMARY"}], on_conflict: {constraint: action_invoice_action_invoice_key, update_columns: []}}}
  ) {
    ...actionsFragmentDetailsFields
  }
}
    ${ActionsFragmentDetailsFieldsFragmentDoc}`;

/**
 * __useActionsAddManualActionInvoiceCopyMutation__
 *
 * To run a mutation, you first call `useActionsAddManualActionInvoiceCopyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsAddManualActionInvoiceCopyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsAddManualActionInvoiceCopyMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     legalEntity: // value for 'legalEntity'
 *     recipient: // value for 'recipient'
 *     metadata: // value for 'metadata'
 *     invoice: // value for 'invoice'
 *     channelEndpoint: // value for 'channelEndpoint'
 *     start_time: // value for 'start_time'
 *   },
 * });
 */
export function useActionsAddManualActionInvoiceCopyMutation(options: VueApolloComposable.UseMutationOptions<ActionsAddManualActionInvoiceCopyMutation, ActionsAddManualActionInvoiceCopyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsAddManualActionInvoiceCopyMutation, ActionsAddManualActionInvoiceCopyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsAddManualActionInvoiceCopyMutation, ActionsAddManualActionInvoiceCopyMutationVariables>(ActionsAddManualActionInvoiceCopyDocument, options);
}
export type ActionsAddManualActionInvoiceCopyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsAddManualActionInvoiceCopyMutation, ActionsAddManualActionInvoiceCopyMutationVariables>;
export const ActionsGetSendInvoiceCopyDataDocument = gql`
    query actionsGetSendInvoiceCopyData($participant: uuid!, $legalEntity: uuid!, $recipient: uuid!, $invoices: [uuid!]!) {
  legal_entity: risolto_legal_entity(where: {reference: {_eq: $legalEntity}}) {
    communication: processing_details(path: "outbound_channel.communication")
  }
  recipient: risolto_recipient(where: {reference: {_eq: $recipient}}) {
    language_code
  }
  channel_endpoints: risolto_invoicing_channel_endpoints_v1(
    args: {q_participant: $participant, q_legal_entity: $legalEntity, q_recipient: $recipient, q_channels: "{EMAIL}"}
    where: {channel_endpoint_by_reference: {deactivated_at: {_is_null: true}}}
    limit: 1
  ) {
    channel_endpoint: channel_endpoint_by_reference {
      reference
      endpoint
      locale
    }
  }
  invoices: risolto_invoice_document(where: {reference: {_in: $invoices}}) {
    attachments: file_references
  }
}
    `;

/**
 * __useActionsGetSendInvoiceCopyDataQuery__
 *
 * To run a query within a Vue component, call `useActionsGetSendInvoiceCopyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetSendInvoiceCopyDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetSendInvoiceCopyDataQuery({
 *   participant: // value for 'participant'
 *   legalEntity: // value for 'legalEntity'
 *   recipient: // value for 'recipient'
 *   invoices: // value for 'invoices'
 * });
 */
export function useActionsGetSendInvoiceCopyDataQuery(variables: ActionsGetSendInvoiceCopyDataQueryVariables | VueCompositionApi.Ref<ActionsGetSendInvoiceCopyDataQueryVariables> | ReactiveFunction<ActionsGetSendInvoiceCopyDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables>(ActionsGetSendInvoiceCopyDataDocument, variables, options);
}
export function useActionsGetSendInvoiceCopyDataLazyQuery(variables: ActionsGetSendInvoiceCopyDataQueryVariables | VueCompositionApi.Ref<ActionsGetSendInvoiceCopyDataQueryVariables> | ReactiveFunction<ActionsGetSendInvoiceCopyDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables>(ActionsGetSendInvoiceCopyDataDocument, variables, options);
}
export type ActionsGetSendInvoiceCopyDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetSendInvoiceCopyDataQuery, ActionsGetSendInvoiceCopyDataQueryVariables>;
export const ActionsGetNextActionsV2Document = gql`
    query actionsGetNextActionsV2($reference: uuid, $participant: uuid!, $recipient: uuid, $limit: Int, $offset: Int, $channels: [risolto_channel_enum!], $statuses: [risolto_action_status_enum!], $searchTerm: String!, $msgCode: String, $invoices: [uuid!], $orderBy: [risolto_action_order_by!]) {
  total: risolto_action_aggregate(
    where: {_and: [{_or: [{primary_invoice: {_in: $invoices}}]}, {_or: [{message_code: {_ilike: $searchTerm}}, {recipient_by_reference: {name: {_ilike: $searchTerm}}}, {recipient_by_reference: {account_id: {_ilike: $searchTerm}}}]}, {channel: {_in: $channels}}, {participant: {_eq: $participant}}, {recipient: {_eq: $recipient}}, {status: {_in: $statuses}}, {message_code: {_eq: $msgCode}}, {reference: {_eq: $reference}}]}
    order_by: $orderBy
  ) {
    aggregate {
      count
    }
  }
  risolto_action(
    where: {_and: [{_or: [{primary_invoice: {_in: $invoices}}]}, {_or: [{message_code: {_ilike: $searchTerm}}, {recipient_by_reference: {name: {_ilike: $searchTerm}}}, {recipient_by_reference: {account_id: {_ilike: $searchTerm}}}]}, {channel: {_in: $channels}}, {participant: {_eq: $participant}}, {recipient: {_eq: $recipient}}, {status: {_in: $statuses}}, {message_code: {_eq: $msgCode}}, {reference: {_eq: $reference}}]}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    status
    channel
    recipient
    recipient_by_reference {
      address
      balance_amount
      dunning_metadata
      last_dunning_at
      legal_id
      legal_id_type
      name
      account_id
      type
      updated_by
      participant
      reference
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
    }
    reference
    metadata
    message_code
    is_retry
    participant
    primary_invoice
    primary_invoice_by_reference {
      invoice_number
    }
    action_invoices {
      reference
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    source
    executed_at
    original_action
    retry_count
    start_time
    due_date
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      participant
    }
    legal_entity_by_reference {
      registration_name
      outbound_channel: processing_details(path: "outbound_channel")
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
    channel_endpoint
    channel_endpoint_by_reference {
      channel
      endpoint
      endpoint_details
      deactivated_at
      deactivated_by
      last_failed_delivery_at
      last_failed_delivery_type
      locale
      priority
    }
  }
}
    `;

/**
 * __useActionsGetNextActionsV2Query__
 *
 * To run a query within a Vue component, call `useActionsGetNextActionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetNextActionsV2Query` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetNextActionsV2Query({
 *   reference: // value for 'reference'
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   channels: // value for 'channels'
 *   statuses: // value for 'statuses'
 *   searchTerm: // value for 'searchTerm'
 *   msgCode: // value for 'msgCode'
 *   invoices: // value for 'invoices'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useActionsGetNextActionsV2Query(variables: ActionsGetNextActionsV2QueryVariables | VueCompositionApi.Ref<ActionsGetNextActionsV2QueryVariables> | ReactiveFunction<ActionsGetNextActionsV2QueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables>(ActionsGetNextActionsV2Document, variables, options);
}
export function useActionsGetNextActionsV2LazyQuery(variables: ActionsGetNextActionsV2QueryVariables | VueCompositionApi.Ref<ActionsGetNextActionsV2QueryVariables> | ReactiveFunction<ActionsGetNextActionsV2QueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables>(ActionsGetNextActionsV2Document, variables, options);
}
export type ActionsGetNextActionsV2QueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetNextActionsV2Query, ActionsGetNextActionsV2QueryVariables>;
export const ActionsGetNextActionsDocument = gql`
    query actionsGetNextActions($participant: uuid!, $recipient: uuid!, $limit: Int, $offset: Int, $channels: [risolto_channel_enum!], $statuses: [risolto_action_status_enum!], $searchTerm: String!) {
  total: risolto_action_aggregate(
    where: {message_code: {_ilike: $searchTerm}, channel: {_in: $channels}, participant: {_eq: $participant}, recipient: {_eq: $recipient}, status: {_in: $statuses}}
    order_by: {start_time: asc_nulls_last}
  ) {
    aggregate {
      count
    }
  }
  risolto_action(
    where: {message_code: {_ilike: $searchTerm}, channel: {_in: $channels}, participant: {_eq: $participant}, recipient: {_eq: $recipient}, status: {_in: $statuses}}
    order_by: {start_time: asc_nulls_last}
    limit: $limit
    offset: $offset
  ) {
    status
    channel
    recipient
    recipient_by_reference {
      participant
      reference
      address
      balance_amount
      dunning_metadata
      last_dunning_at
      legal_id
      legal_id_type
      name
      type
      updated_by
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
      account_id
    }
    reference
    metadata
    message_code
    participant
    action_invoices {
      reference
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    source
    executed_at
    original_action
    retry_count
    start_time
    due_date
    recipient
    recipient_by_reference {
      name
      account_id
      reference
    }
    legal_entity_by_reference {
      registration_name
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
  }
}
    `;

/**
 * __useActionsGetNextActionsQuery__
 *
 * To run a query within a Vue component, call `useActionsGetNextActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetNextActionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetNextActionsQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   channels: // value for 'channels'
 *   statuses: // value for 'statuses'
 *   searchTerm: // value for 'searchTerm'
 * });
 */
export function useActionsGetNextActionsQuery(variables: ActionsGetNextActionsQueryVariables | VueCompositionApi.Ref<ActionsGetNextActionsQueryVariables> | ReactiveFunction<ActionsGetNextActionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables>(ActionsGetNextActionsDocument, variables, options);
}
export function useActionsGetNextActionsLazyQuery(variables: ActionsGetNextActionsQueryVariables | VueCompositionApi.Ref<ActionsGetNextActionsQueryVariables> | ReactiveFunction<ActionsGetNextActionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables>(ActionsGetNextActionsDocument, variables, options);
}
export type ActionsGetNextActionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetNextActionsQuery, ActionsGetNextActionsQueryVariables>;
export const ActionsAddInvoiceCopyMailDocument = gql`
    mutation actionsAddInvoiceCopyMail($participant: uuid!, $legalEntity: uuid, $recipient: uuid!, $metadata: jsonb!, $invoice: uuid!, $channelEndpoint: uuid, $start_time: timestamptz!) {
  action: insert_risolto_action_one(
    object: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, channel_endpoint: $channelEndpoint, channel: MAIL, source: MANUAL, status: OPEN, metadata: $metadata, primary_invoice: $invoice, execution_type: MANUAL, message_code: "Invoice Copy", start_time: $start_time}
  ) {
    ...actionsFragmentDetailsFields
  }
}
    ${ActionsFragmentDetailsFieldsFragmentDoc}`;

/**
 * __useActionsAddInvoiceCopyMailMutation__
 *
 * To run a mutation, you first call `useActionsAddInvoiceCopyMailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsAddInvoiceCopyMailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsAddInvoiceCopyMailMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     legalEntity: // value for 'legalEntity'
 *     recipient: // value for 'recipient'
 *     metadata: // value for 'metadata'
 *     invoice: // value for 'invoice'
 *     channelEndpoint: // value for 'channelEndpoint'
 *     start_time: // value for 'start_time'
 *   },
 * });
 */
export function useActionsAddInvoiceCopyMailMutation(options: VueApolloComposable.UseMutationOptions<ActionsAddInvoiceCopyMailMutation, ActionsAddInvoiceCopyMailMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsAddInvoiceCopyMailMutation, ActionsAddInvoiceCopyMailMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsAddInvoiceCopyMailMutation, ActionsAddInvoiceCopyMailMutationVariables>(ActionsAddInvoiceCopyMailDocument, options);
}
export type ActionsAddInvoiceCopyMailMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsAddInvoiceCopyMailMutation, ActionsAddInvoiceCopyMailMutationVariables>;
export const ActionsAddManualActionDocument = gql`
    mutation actionsAddManualAction($channel: risolto_channel_enum, $status: risolto_action_status_enum, $legalEntity: uuid, $recipient: uuid, $participant: uuid, $startTime: timestamptz, $assignee: uuid, $metadata: jsonb, $primaryInvoice: uuid!, $invoiceGroupInvoices: [risolto_invoice_group_invoice_insert_input!]!) {
  insert_risolto_action(
    objects: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, execution_type: MANUAL, status: $status, source: MANUAL, start_time: $startTime, channel: $channel, assignee: $assignee, metadata: $metadata, message_code: "scheduled manual action", primary_invoice: $primaryInvoice, dunning_notice_by_reference: {data: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, type_code: _100_REMINDER, charges: 0, principal_amount: 0, interest: 0, invoice_group_by_reference: {data: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, invoice_group_invoices: {data: $invoiceGroupInvoices}}}}}}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;

/**
 * __useActionsAddManualActionMutation__
 *
 * To run a mutation, you first call `useActionsAddManualActionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsAddManualActionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsAddManualActionMutation({
 *   variables: {
 *     channel: // value for 'channel'
 *     status: // value for 'status'
 *     legalEntity: // value for 'legalEntity'
 *     recipient: // value for 'recipient'
 *     participant: // value for 'participant'
 *     startTime: // value for 'startTime'
 *     assignee: // value for 'assignee'
 *     metadata: // value for 'metadata'
 *     primaryInvoice: // value for 'primaryInvoice'
 *     invoiceGroupInvoices: // value for 'invoiceGroupInvoices'
 *   },
 * });
 */
export function useActionsAddManualActionMutation(options: VueApolloComposable.UseMutationOptions<ActionsAddManualActionMutation, ActionsAddManualActionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsAddManualActionMutation, ActionsAddManualActionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsAddManualActionMutation, ActionsAddManualActionMutationVariables>(ActionsAddManualActionDocument, options);
}
export type ActionsAddManualActionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsAddManualActionMutation, ActionsAddManualActionMutationVariables>;
export const ActionsGetSendInvoiceCopyMailDataDocument = gql`
    query actionsGetSendInvoiceCopyMailData($recipient: uuid!, $invoices: [uuid!]!) {
  recipient: risolto_recipient_by_pk(reference: $recipient) {
    reference
    name
    participant
    language_code
    legal_entity: legal_entity_by_reference {
      reference
      address: processing_details(path: "postal_address")
      default_postal_provider: processing_details(
        path: "outbound_channel.postal_provider"
      )
      communication_postal_provider: processing_details(
        path: "outbound_channel.communication.postal_provider"
      )
      communication_templates(
        where: {channel: {_eq: MAIL}, template_id: {_eq: "invoice_copy"}}
      ) {
        template_id
      }
    }
    channel_endpoints(
      where: {channel: {_eq: "MAIL"}, deactivated_at: {_is_null: true}}
    ) {
      reference
      address: endpoint_details
      contact: contact_by_reference {
        first_name
        last_name
      }
    }
    invoices: invoice_documents(where: {reference: {_in: $invoices}}) {
      attachments: file_references
    }
  }
}
    `;

/**
 * __useActionsGetSendInvoiceCopyMailDataQuery__
 *
 * To run a query within a Vue component, call `useActionsGetSendInvoiceCopyMailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetSendInvoiceCopyMailDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetSendInvoiceCopyMailDataQuery({
 *   recipient: // value for 'recipient'
 *   invoices: // value for 'invoices'
 * });
 */
export function useActionsGetSendInvoiceCopyMailDataQuery(variables: ActionsGetSendInvoiceCopyMailDataQueryVariables | VueCompositionApi.Ref<ActionsGetSendInvoiceCopyMailDataQueryVariables> | ReactiveFunction<ActionsGetSendInvoiceCopyMailDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables>(ActionsGetSendInvoiceCopyMailDataDocument, variables, options);
}
export function useActionsGetSendInvoiceCopyMailDataLazyQuery(variables: ActionsGetSendInvoiceCopyMailDataQueryVariables | VueCompositionApi.Ref<ActionsGetSendInvoiceCopyMailDataQueryVariables> | ReactiveFunction<ActionsGetSendInvoiceCopyMailDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables>(ActionsGetSendInvoiceCopyMailDataDocument, variables, options);
}
export type ActionsGetSendInvoiceCopyMailDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetSendInvoiceCopyMailDataQuery, ActionsGetSendInvoiceCopyMailDataQueryVariables>;
export const ActionsGetSendCreditNoteCopyMailDataDocument = gql`
    query actionsGetSendCreditNoteCopyMailData($recipient: uuid!, $creditNotes: [uuid!]!) {
  recipient: risolto_recipient_by_pk(reference: $recipient) {
    reference
    name
    participant
    language_code
    legal_entity: legal_entity_by_reference {
      reference
      address: processing_details(path: "postal_address")
      default_postal_provider: processing_details(
        path: "outbound_channel.postal_provider"
      )
      communication_postal_provider: processing_details(
        path: "outbound_channel.communication.postal_provider"
      )
      communication_templates(
        where: {channel: {_eq: MAIL}, template_id: {_eq: "credit_note_copy"}}
      ) {
        template_id
      }
    }
    channel_endpoints(
      where: {channel: {_eq: "MAIL"}, deactivated_at: {_is_null: true}}
    ) {
      reference
      address: endpoint_details
      contact: contact_by_reference {
        first_name
        last_name
      }
    }
    credit_notes: credit_notes(where: {reference: {_in: $creditNotes}}) {
      attachments: file_references
    }
  }
}
    `;

/**
 * __useActionsGetSendCreditNoteCopyMailDataQuery__
 *
 * To run a query within a Vue component, call `useActionsGetSendCreditNoteCopyMailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetSendCreditNoteCopyMailDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetSendCreditNoteCopyMailDataQuery({
 *   recipient: // value for 'recipient'
 *   creditNotes: // value for 'creditNotes'
 * });
 */
export function useActionsGetSendCreditNoteCopyMailDataQuery(variables: ActionsGetSendCreditNoteCopyMailDataQueryVariables | VueCompositionApi.Ref<ActionsGetSendCreditNoteCopyMailDataQueryVariables> | ReactiveFunction<ActionsGetSendCreditNoteCopyMailDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables>(ActionsGetSendCreditNoteCopyMailDataDocument, variables, options);
}
export function useActionsGetSendCreditNoteCopyMailDataLazyQuery(variables: ActionsGetSendCreditNoteCopyMailDataQueryVariables | VueCompositionApi.Ref<ActionsGetSendCreditNoteCopyMailDataQueryVariables> | ReactiveFunction<ActionsGetSendCreditNoteCopyMailDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables>(ActionsGetSendCreditNoteCopyMailDataDocument, variables, options);
}
export type ActionsGetSendCreditNoteCopyMailDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetSendCreditNoteCopyMailDataQuery, ActionsGetSendCreditNoteCopyMailDataQueryVariables>;
export const ActionsAddCreditNoteCopyMailDocument = gql`
    mutation actionsAddCreditNoteCopyMail($participant: uuid!, $legalEntity: uuid, $recipient: uuid!, $metadata: jsonb!, $creditNote: uuid!, $channelEndpoint: uuid, $start_time: timestamptz!) {
  action: insert_risolto_action_one(
    object: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, channel_endpoint: $channelEndpoint, channel: MAIL, source: MANUAL, status: OPEN, metadata: $metadata, credit_note: $creditNote, execution_type: MANUAL, message_code: "credit_note_copy", start_time: $start_time}
  ) {
    ...actionsFragmentDetailsFields
  }
}
    ${ActionsFragmentDetailsFieldsFragmentDoc}`;

/**
 * __useActionsAddCreditNoteCopyMailMutation__
 *
 * To run a mutation, you first call `useActionsAddCreditNoteCopyMailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsAddCreditNoteCopyMailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsAddCreditNoteCopyMailMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     legalEntity: // value for 'legalEntity'
 *     recipient: // value for 'recipient'
 *     metadata: // value for 'metadata'
 *     creditNote: // value for 'creditNote'
 *     channelEndpoint: // value for 'channelEndpoint'
 *     start_time: // value for 'start_time'
 *   },
 * });
 */
export function useActionsAddCreditNoteCopyMailMutation(options: VueApolloComposable.UseMutationOptions<ActionsAddCreditNoteCopyMailMutation, ActionsAddCreditNoteCopyMailMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsAddCreditNoteCopyMailMutation, ActionsAddCreditNoteCopyMailMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsAddCreditNoteCopyMailMutation, ActionsAddCreditNoteCopyMailMutationVariables>(ActionsAddCreditNoteCopyMailDocument, options);
}
export type ActionsAddCreditNoteCopyMailMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsAddCreditNoteCopyMailMutation, ActionsAddCreditNoteCopyMailMutationVariables>;
export const ActionsGetSendCreditNoteCopyDataDocument = gql`
    query actionsGetSendCreditNoteCopyData($participant: uuid!, $legalEntity: uuid!, $recipient: uuid!, $creditNotes: [uuid!]!) {
  legal_entity: risolto_legal_entity(where: {reference: {_eq: $legalEntity}}) {
    communication: processing_details(path: "outbound_channel.communication")
  }
  channel_endpoints: risolto_invoicing_channel_endpoints_v1(
    args: {q_participant: $participant, q_legal_entity: $legalEntity, q_recipient: $recipient, q_channels: "{EMAIL}"}
    where: {channel_endpoint_by_reference: {deactivated_at: {_is_null: true}}}
    limit: 1
  ) {
    channel_endpoint: channel_endpoint_by_reference {
      reference
      endpoint
      locale
    }
  }
  credit_notes: risolto_credit_note(where: {reference: {_in: $creditNotes}}) {
    attachments: file_references
  }
}
    `;

/**
 * __useActionsGetSendCreditNoteCopyDataQuery__
 *
 * To run a query within a Vue component, call `useActionsGetSendCreditNoteCopyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsGetSendCreditNoteCopyDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionsGetSendCreditNoteCopyDataQuery({
 *   participant: // value for 'participant'
 *   legalEntity: // value for 'legalEntity'
 *   recipient: // value for 'recipient'
 *   creditNotes: // value for 'creditNotes'
 * });
 */
export function useActionsGetSendCreditNoteCopyDataQuery(variables: ActionsGetSendCreditNoteCopyDataQueryVariables | VueCompositionApi.Ref<ActionsGetSendCreditNoteCopyDataQueryVariables> | ReactiveFunction<ActionsGetSendCreditNoteCopyDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables>(ActionsGetSendCreditNoteCopyDataDocument, variables, options);
}
export function useActionsGetSendCreditNoteCopyDataLazyQuery(variables: ActionsGetSendCreditNoteCopyDataQueryVariables | VueCompositionApi.Ref<ActionsGetSendCreditNoteCopyDataQueryVariables> | ReactiveFunction<ActionsGetSendCreditNoteCopyDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables>(ActionsGetSendCreditNoteCopyDataDocument, variables, options);
}
export type ActionsGetSendCreditNoteCopyDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionsGetSendCreditNoteCopyDataQuery, ActionsGetSendCreditNoteCopyDataQueryVariables>;
export const ActionsAddManualActionCreditNoteCopyDocument = gql`
    mutation actionsAddManualActionCreditNoteCopy($participant: uuid!, $legalEntity: uuid, $recipient: uuid!, $metadata: jsonb!, $creditNote: uuid!, $channelEndpoint: uuid, $start_time: timestamptz) {
  action: insert_risolto_action_one(
    object: {participant: $participant, legal_entity: $legalEntity, recipient: $recipient, channel_endpoint: $channelEndpoint, channel: EMAIL, source: MANUAL, status: OPEN, metadata: $metadata, execution_type: MANUAL, message_code: "credit_note_copy", start_time: $start_time, credit_note: $creditNote}
  ) {
    ...actionsFragmentDetailsFields
  }
}
    ${ActionsFragmentDetailsFieldsFragmentDoc}`;

/**
 * __useActionsAddManualActionCreditNoteCopyMutation__
 *
 * To run a mutation, you first call `useActionsAddManualActionCreditNoteCopyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsAddManualActionCreditNoteCopyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsAddManualActionCreditNoteCopyMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     legalEntity: // value for 'legalEntity'
 *     recipient: // value for 'recipient'
 *     metadata: // value for 'metadata'
 *     creditNote: // value for 'creditNote'
 *     channelEndpoint: // value for 'channelEndpoint'
 *     start_time: // value for 'start_time'
 *   },
 * });
 */
export function useActionsAddManualActionCreditNoteCopyMutation(options: VueApolloComposable.UseMutationOptions<ActionsAddManualActionCreditNoteCopyMutation, ActionsAddManualActionCreditNoteCopyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsAddManualActionCreditNoteCopyMutation, ActionsAddManualActionCreditNoteCopyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsAddManualActionCreditNoteCopyMutation, ActionsAddManualActionCreditNoteCopyMutationVariables>(ActionsAddManualActionCreditNoteCopyDocument, options);
}
export type ActionsAddManualActionCreditNoteCopyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsAddManualActionCreditNoteCopyMutation, ActionsAddManualActionCreditNoteCopyMutationVariables>;
export const ActionsUpdateChannelEndpointDocument = gql`
    mutation actionsUpdateChannelEndpoint($action: uuid!, $channelEndpoint: uuid!) {
  update_risolto_action(
    where: {reference: {_eq: $action}}
    _set: {channel_endpoint: $channelEndpoint}
  ) {
    updated_count: affected_rows
    updated: returning {
      reference
      channel_endpoint
    }
  }
}
    `;

/**
 * __useActionsUpdateChannelEndpointMutation__
 *
 * To run a mutation, you first call `useActionsUpdateChannelEndpointMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActionsUpdateChannelEndpointMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActionsUpdateChannelEndpointMutation({
 *   variables: {
 *     action: // value for 'action'
 *     channelEndpoint: // value for 'channelEndpoint'
 *   },
 * });
 */
export function useActionsUpdateChannelEndpointMutation(options: VueApolloComposable.UseMutationOptions<ActionsUpdateChannelEndpointMutation, ActionsUpdateChannelEndpointMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActionsUpdateChannelEndpointMutation, ActionsUpdateChannelEndpointMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActionsUpdateChannelEndpointMutation, ActionsUpdateChannelEndpointMutationVariables>(ActionsUpdateChannelEndpointDocument, options);
}
export type ActionsUpdateChannelEndpointMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActionsUpdateChannelEndpointMutation, ActionsUpdateChannelEndpointMutationVariables>;
export const GqlActionsGrouped_GetAllWorklistItemsDocument = gql`
    query gqlActionsGrouped_getAllWorklistItems($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isReference: Boolean!, $isAssignee: Boolean!, $limit: Int!, $offset: Int!, $orderBy: [risolto_virtual_action_group_order_by!], $statuses: _text, $participants: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  total: risolto_action_group_v10_aggregate(
    args: {search_term: $searchTerm, group_reference: $isReference, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action_group_v10(
    args: {search_term: $searchTerm, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, group_reference: $isReference, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    v_reference
    reference
    action_by_reference {
      source
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      status
      original_action
      retry_count
      participant
      metadata
      action_invoices(order_by: {invoice_by_reference: {issue_date: desc_nulls_last}}) {
        relation
        invoice
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      status
      reference
      execution_type
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        reference
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
        company_id
        company_id_type
      }
      message_code
      channel
      due_date
      start_time
      assignee
      assignee_by_reference {
        reference
        username
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
        company_id
        company_id_type
      }
    }
    action_count
    due_date
    due_date_count
    channel
    channel_count
    recipient
    recipient_by_reference {
      name
      reference
      type
      participant
      legal_id_type
      legal_id
      legal_entity
      account_id
      contacts {
        reference
        first_name
        last_name
      }
      invoice_documents_aggregate {
        aggregate {
          sum {
            open_amount
            total_amount
          }
        }
      }
    }
    recipient_count
    assignee_by_reference {
      username
    }
    start_time
    start_time_count
    assignee_count
    message_code
    message_code_count
  }
}
    `;

/**
 * __useGqlActionsGrouped_GetAllWorklistItemsQuery__
 *
 * To run a query within a Vue component, call `useGqlActionsGrouped_GetAllWorklistItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlActionsGrouped_GetAllWorklistItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlActionsGrouped_GetAllWorklistItemsQuery({
 *   searchTerm: // value for 'searchTerm'
 *   isDueDate: // value for 'isDueDate'
 *   isStartTime: // value for 'isStartTime'
 *   isChannel: // value for 'isChannel'
 *   isRecipient: // value for 'isRecipient'
 *   isMessageCode: // value for 'isMessageCode'
 *   isReference: // value for 'isReference'
 *   isAssignee: // value for 'isAssignee'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   orderBy: // value for 'orderBy'
 *   statuses: // value for 'statuses'
 *   participants: // value for 'participants'
 *   startTimeFrom: // value for 'startTimeFrom'
 *   startTimeUntil: // value for 'startTimeUntil'
 * });
 */
export function useGqlActionsGrouped_GetAllWorklistItemsQuery(variables: GqlActionsGrouped_GetAllWorklistItemsQueryVariables | VueCompositionApi.Ref<GqlActionsGrouped_GetAllWorklistItemsQueryVariables> | ReactiveFunction<GqlActionsGrouped_GetAllWorklistItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables>(GqlActionsGrouped_GetAllWorklistItemsDocument, variables, options);
}
export function useGqlActionsGrouped_GetAllWorklistItemsLazyQuery(variables: GqlActionsGrouped_GetAllWorklistItemsQueryVariables | VueCompositionApi.Ref<GqlActionsGrouped_GetAllWorklistItemsQueryVariables> | ReactiveFunction<GqlActionsGrouped_GetAllWorklistItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables>(GqlActionsGrouped_GetAllWorklistItemsDocument, variables, options);
}
export type GqlActionsGrouped_GetAllWorklistItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlActionsGrouped_GetAllWorklistItemsQuery, GqlActionsGrouped_GetAllWorklistItemsQueryVariables>;
export const GqlActionsGrouped_GetunassignedWorklistItemsDocument = gql`
    query gqlActionsGrouped_getunassignedWorklistItems($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isAssignee: Boolean!, $isReference: Boolean!, $limit: Int!, $offset: Int!, $orderBy: [risolto_virtual_action_group_order_by!], $statuses: _text, $participants: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  total: risolto_action_group_v10_aggregate(
    args: {search_term: $searchTerm, group_reference: $isReference, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action_group_v10(
    where: {assignee: {_is_null: true}}
    args: {search_term: $searchTerm, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, group_reference: $isReference, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    v_reference
    reference
    action_by_reference {
      source
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      status
      original_action
      retry_count
      participant
      metadata
      action_invoices(order_by: {invoice_by_reference: {issue_date: desc_nulls_last}}) {
        relation
        invoice
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      status
      reference
      execution_type
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        reference
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
        company_id
        company_id_type
      }
      message_code
      channel
      due_date
      start_time
      assignee
      assignee_by_reference {
        reference
        username
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
        company_id
        company_id_type
      }
    }
    action_count
    due_date
    due_date_count
    channel
    channel_count
    recipient
    recipient_by_reference {
      name
      reference
      type
      participant
      legal_id_type
      legal_id
      legal_entity
      account_id
      contacts {
        reference
        first_name
        last_name
      }
      invoice_documents_aggregate {
        aggregate {
          sum {
            open_amount
            total_amount
          }
        }
      }
    }
    recipient_count
    assignee_by_reference {
      username
    }
    start_time
    start_time_count
    assignee_count
    message_code
    message_code_count
  }
}
    `;

/**
 * __useGqlActionsGrouped_GetunassignedWorklistItemsQuery__
 *
 * To run a query within a Vue component, call `useGqlActionsGrouped_GetunassignedWorklistItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlActionsGrouped_GetunassignedWorklistItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlActionsGrouped_GetunassignedWorklistItemsQuery({
 *   searchTerm: // value for 'searchTerm'
 *   isDueDate: // value for 'isDueDate'
 *   isStartTime: // value for 'isStartTime'
 *   isChannel: // value for 'isChannel'
 *   isRecipient: // value for 'isRecipient'
 *   isMessageCode: // value for 'isMessageCode'
 *   isAssignee: // value for 'isAssignee'
 *   isReference: // value for 'isReference'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   orderBy: // value for 'orderBy'
 *   statuses: // value for 'statuses'
 *   participants: // value for 'participants'
 *   startTimeFrom: // value for 'startTimeFrom'
 *   startTimeUntil: // value for 'startTimeUntil'
 * });
 */
export function useGqlActionsGrouped_GetunassignedWorklistItemsQuery(variables: GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables | VueCompositionApi.Ref<GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables> | ReactiveFunction<GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>(GqlActionsGrouped_GetunassignedWorklistItemsDocument, variables, options);
}
export function useGqlActionsGrouped_GetunassignedWorklistItemsLazyQuery(variables: GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables | VueCompositionApi.Ref<GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables> | ReactiveFunction<GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>(GqlActionsGrouped_GetunassignedWorklistItemsDocument, variables, options);
}
export type GqlActionsGrouped_GetunassignedWorklistItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlActionsGrouped_GetunassignedWorklistItemsQuery, GqlActionsGrouped_GetunassignedWorklistItemsQueryVariables>;
export const GqlActionsGrouped_GetAssignedWorklistItemsDocument = gql`
    query gqlActionsGrouped_getAssignedWorklistItems($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isReference: Boolean!, $isAssignee: Boolean!, $limit: Int!, $offset: Int!, $orderBy: [risolto_virtual_action_group_order_by!], $statuses: _text, $assignee: uuid!, $participants: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  total: risolto_action_group_v10_aggregate(
    args: {search_term: $searchTerm, group_reference: $isReference, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action_group_v10(
    where: {assignee: {_eq: $assignee}}
    args: {search_term: $searchTerm, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, group_reference: $isReference, statuses: $statuses, participants: $participants, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    v_reference
    reference
    action_by_reference {
      source
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      status
      original_action
      retry_count
      participant
      metadata
      action_invoices(order_by: {invoice_by_reference: {issue_date: desc_nulls_last}}) {
        relation
        invoice
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      status
      reference
      execution_type
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        reference
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
        company_id
        company_id_type
      }
      message_code
      channel
      due_date
      start_time
      assignee
      assignee_by_reference {
        reference
        username
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
        company_id
        company_id_type
      }
    }
    action_count
    due_date
    due_date_count
    channel
    channel_count
    recipient
    recipient_by_reference {
      name
      reference
      type
      participant
      legal_id_type
      legal_id
      legal_entity
      account_id
      contacts {
        reference
        first_name
        last_name
      }
      invoice_documents_aggregate {
        aggregate {
          sum {
            open_amount
            total_amount
          }
        }
      }
    }
    recipient_count
    assignee_by_reference {
      username
    }
    start_time
    start_time_count
    assignee_count
    message_code
    message_code_count
  }
}
    `;

/**
 * __useGqlActionsGrouped_GetAssignedWorklistItemsQuery__
 *
 * To run a query within a Vue component, call `useGqlActionsGrouped_GetAssignedWorklistItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlActionsGrouped_GetAssignedWorklistItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlActionsGrouped_GetAssignedWorklistItemsQuery({
 *   searchTerm: // value for 'searchTerm'
 *   isDueDate: // value for 'isDueDate'
 *   isStartTime: // value for 'isStartTime'
 *   isChannel: // value for 'isChannel'
 *   isRecipient: // value for 'isRecipient'
 *   isMessageCode: // value for 'isMessageCode'
 *   isReference: // value for 'isReference'
 *   isAssignee: // value for 'isAssignee'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   orderBy: // value for 'orderBy'
 *   statuses: // value for 'statuses'
 *   assignee: // value for 'assignee'
 *   participants: // value for 'participants'
 *   startTimeFrom: // value for 'startTimeFrom'
 *   startTimeUntil: // value for 'startTimeUntil'
 * });
 */
export function useGqlActionsGrouped_GetAssignedWorklistItemsQuery(variables: GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables | VueCompositionApi.Ref<GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables> | ReactiveFunction<GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>(GqlActionsGrouped_GetAssignedWorklistItemsDocument, variables, options);
}
export function useGqlActionsGrouped_GetAssignedWorklistItemsLazyQuery(variables: GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables | VueCompositionApi.Ref<GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables> | ReactiveFunction<GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>(GqlActionsGrouped_GetAssignedWorklistItemsDocument, variables, options);
}
export type GqlActionsGrouped_GetAssignedWorklistItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlActionsGrouped_GetAssignedWorklistItemsQuery, GqlActionsGrouped_GetAssignedWorklistItemsQueryVariables>;
export const GetStatementLinesDocument = gql`
    query getStatementLines($status: [risolto_statement_line_status_enum!], $startDate: date, $endDate: date, $limit: Int = 10, $offset: Int = 0, $participantRef: uuid!) {
  total: risolto_statement_line_aggregate(
    limit: $limit
    offset: $offset
    where: {_and: [{status: {_in: $status}}, {participant: {_eq: $participantRef}}, {transaction_date: {_gte: $startDate}}, {transaction_date: {_lte: $endDate}}]}
  ) {
    aggregate {
      count
    }
  }
  statements: risolto_statement_line(
    limit: $limit
    offset: $offset
    where: {_and: [{status: {_in: $status}}, {participant: {_eq: $participantRef}}, {transaction_date: {_gte: $startDate}}, {transaction_date: {_lte: $endDate}}]}
  ) {
    reference
    counterparty_account_number
    counterparty_account_number_type
    counterparty_address
    counterparty_bank_identifier
    counterparty_bank_identifier_type
    counterparty_currency
    counterparty_name
    invoice
    recipient_by_reference {
      reference
      name
      channel_endpoints {
        channel
        contact_by_reference {
          first_name
          last_name
        }
      }
    }
    legal_entity
    recipient
    structured_message
    transaction_credit_amount
    transaction_date
    transaction_debit_amount
    transaction_reference
    unstructured_message
  }
}
    `;

/**
 * __useGetStatementLinesQuery__
 *
 * To run a query within a Vue component, call `useGetStatementLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatementLinesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStatementLinesQuery({
 *   status: // value for 'status'
 *   startDate: // value for 'startDate'
 *   endDate: // value for 'endDate'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   participantRef: // value for 'participantRef'
 * });
 */
export function useGetStatementLinesQuery(variables: GetStatementLinesQueryVariables | VueCompositionApi.Ref<GetStatementLinesQueryVariables> | ReactiveFunction<GetStatementLinesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStatementLinesQuery, GetStatementLinesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStatementLinesQuery, GetStatementLinesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStatementLinesQuery, GetStatementLinesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStatementLinesQuery, GetStatementLinesQueryVariables>(GetStatementLinesDocument, variables, options);
}
export function useGetStatementLinesLazyQuery(variables: GetStatementLinesQueryVariables | VueCompositionApi.Ref<GetStatementLinesQueryVariables> | ReactiveFunction<GetStatementLinesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStatementLinesQuery, GetStatementLinesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStatementLinesQuery, GetStatementLinesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStatementLinesQuery, GetStatementLinesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetStatementLinesQuery, GetStatementLinesQueryVariables>(GetStatementLinesDocument, variables, options);
}
export type GetStatementLinesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStatementLinesQuery, GetStatementLinesQueryVariables>;
export const GetContactsDocument = gql`
    query getContacts($recipient: uuid!, $participant: uuid!) {
  total: risolto_contact_aggregate(
    where: {_and: {recipient: {_eq: $recipient}, participant: {_eq: $participant}}}
  ) {
    aggregate {
      count
    }
  }
  contacts: risolto_contact(
    where: {_and: {recipient: {_eq: $recipient}, participant: {_eq: $participant}}}
  ) {
    legal_entity
    participant
    first_name
    last_name
    full_name
    reference
    recipient
    channel_endpoints {
      endpoint_details
      deactivated_at
      deactivated_by
      channel
      endpoint
      reference
    }
  }
}
    `;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a Vue component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContactsQuery({
 *   recipient: // value for 'recipient'
 *   participant: // value for 'participant'
 * });
 */
export function useGetContactsQuery(variables: GetContactsQueryVariables | VueCompositionApi.Ref<GetContactsQueryVariables> | ReactiveFunction<GetContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, variables, options);
}
export function useGetContactsLazyQuery(variables: GetContactsQueryVariables | VueCompositionApi.Ref<GetContactsQueryVariables> | ReactiveFunction<GetContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContactsQuery, GetContactsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, variables, options);
}
export type GetContactsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContactsQuery, GetContactsQueryVariables>;
export const GetContactDocument = gql`
    query getContact($reference: uuid!, $participant: uuid) {
  contact: risolto_contact(
    where: {reference: {_eq: $reference}, participant: {_eq: $participant}}
  ) {
    legal_entity
    participant
    first_name
    last_name
    reference
    recipient
    channel_endpoints {
      endpoint_details
      channel
      deactivated_at
      deactivated_by
      endpoint
      reference
    }
  }
}
    `;

/**
 * __useGetContactQuery__
 *
 * To run a query within a Vue component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContactQuery({
 *   reference: // value for 'reference'
 *   participant: // value for 'participant'
 * });
 */
export function useGetContactQuery(variables: GetContactQueryVariables | VueCompositionApi.Ref<GetContactQueryVariables> | ReactiveFunction<GetContactQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContactQuery, GetContactQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContactQuery, GetContactQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContactQuery, GetContactQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, variables, options);
}
export function useGetContactLazyQuery(variables: GetContactQueryVariables | VueCompositionApi.Ref<GetContactQueryVariables> | ReactiveFunction<GetContactQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetContactQuery, GetContactQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetContactQuery, GetContactQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetContactQuery, GetContactQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, variables, options);
}
export type GetContactQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetContactQuery, GetContactQueryVariables>;
export const GqlDashboard_AgingBalanceDocument = gql`
    query gqlDashboard_agingBalance($participant: uuid!, $legal_entity: uuid, $today: date!, $today_minus_30: date!, $today_minus_60: date!, $today_minus_90: date!, $issue_date_from: date!, $issue_date_until: date!) {
  not_overdue: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], due_date: {_gt: $today}, document_type: {_in: ["INVOICE", "CREDIT_NOTE", "DEBIT_NOTE"]}, _and: [{issue_date: {_gte: $issue_date_from}}, {issue_date: {_lt: $issue_date_until}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
  days30: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], _and: [{_or: [{_and: [{due_date: {_lte: $today}}, {due_date: {_gte: $today_minus_30}}]}, {due_date: {_is_null: true}}]}, {issue_date: {_lte: $issue_date_until}}, {issue_date: {_gte: $issue_date_from}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
  days60: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], _and: [{_or: [{_and: [{due_date: {_lt: $today_minus_30}}, {due_date: {_gte: $today_minus_60}}]}, {due_date: {_is_null: true}}]}, {issue_date: {_lt: $issue_date_until}}, {issue_date: {_gte: $issue_date_from}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
  days90: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], _and: [{_or: [{_and: [{due_date: {_lt: $today_minus_60}}, {due_date: {_gte: $today_minus_90}}]}, {due_date: {_is_null: true}}]}, {issue_date: {_lt: $issue_date_until}}, {issue_date: {_gte: $issue_date_from}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
  days90plus: risolto_accounting_document_aggregate(
    where: {participant: {_eq: $participant}, _or: [{legal_entity: {_eq: $legal_entity}}, {legal_entity: {_is_null: true}}], _and: [{_or: [{_and: [{due_date: {_lt: $today_minus_90}}]}, {due_date: {_is_null: true}}]}, {issue_date: {_lt: $issue_date_until}}, {issue_date: {_gte: $issue_date_from}}]}
  ) {
    aggregate {
      sum {
        open_amount
      }
    }
  }
}
    `;

/**
 * __useGqlDashboard_AgingBalanceQuery__
 *
 * To run a query within a Vue component, call `useGqlDashboard_AgingBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlDashboard_AgingBalanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlDashboard_AgingBalanceQuery({
 *   participant: // value for 'participant'
 *   legal_entity: // value for 'legal_entity'
 *   today: // value for 'today'
 *   today_minus_30: // value for 'today_minus_30'
 *   today_minus_60: // value for 'today_minus_60'
 *   today_minus_90: // value for 'today_minus_90'
 *   issue_date_from: // value for 'issue_date_from'
 *   issue_date_until: // value for 'issue_date_until'
 * });
 */
export function useGqlDashboard_AgingBalanceQuery(variables: GqlDashboard_AgingBalanceQueryVariables | VueCompositionApi.Ref<GqlDashboard_AgingBalanceQueryVariables> | ReactiveFunction<GqlDashboard_AgingBalanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables>(GqlDashboard_AgingBalanceDocument, variables, options);
}
export function useGqlDashboard_AgingBalanceLazyQuery(variables: GqlDashboard_AgingBalanceQueryVariables | VueCompositionApi.Ref<GqlDashboard_AgingBalanceQueryVariables> | ReactiveFunction<GqlDashboard_AgingBalanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables>(GqlDashboard_AgingBalanceDocument, variables, options);
}
export type GqlDashboard_AgingBalanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlDashboard_AgingBalanceQuery, GqlDashboard_AgingBalanceQueryVariables>;
export const GqlDashboard_AgingBalanceRecipientDocument = gql`
    query gqlDashboard_agingBalanceRecipient($participant: uuid!, $recipient: uuid!, $today: date!, $today_minus_30: date!, $today_minus_60: date!, $today_minus_90: date!) {
  not_overdue: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, due_date: {_gt: $today}}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
  days30: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, _or: [{_and: [{due_date: {_lt: $today_minus_30}}, {due_date: {_gte: $today_minus_60}}]}, {due_date: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
  days60: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, _or: [{_and: [{due_date: {_lt: $today_minus_30}}, {due_date: {_gte: $today_minus_60}}]}, {due_date: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
  days90: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, _or: [{_and: [{due_date: {_lt: $today_minus_60}}, {due_date: {_gte: $today_minus_90}}]}, {due_date: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
  days90plus: risolto_accounting_document_aggregate(
    where: {recipient: {_eq: $recipient}, participant: {_eq: $participant}, _or: [{_and: [{due_date: {_lt: $today_minus_90}}]}, {due_date: {_is_null: true}}]}
  ) {
    aggregate {
      sum {
        open_amount
        total_amount
      }
    }
  }
}
    `;

/**
 * __useGqlDashboard_AgingBalanceRecipientQuery__
 *
 * To run a query within a Vue component, call `useGqlDashboard_AgingBalanceRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlDashboard_AgingBalanceRecipientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlDashboard_AgingBalanceRecipientQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 *   today: // value for 'today'
 *   today_minus_30: // value for 'today_minus_30'
 *   today_minus_60: // value for 'today_minus_60'
 *   today_minus_90: // value for 'today_minus_90'
 * });
 */
export function useGqlDashboard_AgingBalanceRecipientQuery(variables: GqlDashboard_AgingBalanceRecipientQueryVariables | VueCompositionApi.Ref<GqlDashboard_AgingBalanceRecipientQueryVariables> | ReactiveFunction<GqlDashboard_AgingBalanceRecipientQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables>(GqlDashboard_AgingBalanceRecipientDocument, variables, options);
}
export function useGqlDashboard_AgingBalanceRecipientLazyQuery(variables: GqlDashboard_AgingBalanceRecipientQueryVariables | VueCompositionApi.Ref<GqlDashboard_AgingBalanceRecipientQueryVariables> | ReactiveFunction<GqlDashboard_AgingBalanceRecipientQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables>(GqlDashboard_AgingBalanceRecipientDocument, variables, options);
}
export type GqlDashboard_AgingBalanceRecipientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlDashboard_AgingBalanceRecipientQuery, GqlDashboard_AgingBalanceRecipientQueryVariables>;
export const InsertActionInvoiceDocument = gql`
    mutation insertActionInvoice($action: uuid!, $invoice: uuid!, $legal_entity: uuid!, $participant: uuid!, $relation: String!) {
  insert_risolto_action_invoice(
    objects: {relation: $relation, action: $action, invoice: $invoice, legal_entity: $legal_entity, participant: $participant}
  ) {
    returning {
      reference
    }
    affected_rows
  }
}
    `;

/**
 * __useInsertActionInvoiceMutation__
 *
 * To run a mutation, you first call `useInsertActionInvoiceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertActionInvoiceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertActionInvoiceMutation({
 *   variables: {
 *     action: // value for 'action'
 *     invoice: // value for 'invoice'
 *     legal_entity: // value for 'legal_entity'
 *     participant: // value for 'participant'
 *     relation: // value for 'relation'
 *   },
 * });
 */
export function useInsertActionInvoiceMutation(options: VueApolloComposable.UseMutationOptions<InsertActionInvoiceMutation, InsertActionInvoiceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertActionInvoiceMutation, InsertActionInvoiceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertActionInvoiceMutation, InsertActionInvoiceMutationVariables>(InsertActionInvoiceDocument, options);
}
export type InsertActionInvoiceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertActionInvoiceMutation, InsertActionInvoiceMutationVariables>;
export const GqlInvoices_GetInvoiceInterchangeLinksDocument = gql`
    query gqlInvoices_getInvoiceInterchangeLinks($participantRef: uuid!, $invoice: uuid!) {
  invoice: risolto_invoice_document(
    where: {_and: [{reference: {_eq: $invoice}}, {participant: {_eq: $participantRef}}]}
  ) {
    reference
    actions(where: {executed_at: {_is_null: false}}) {
      reference
      action_interchanges {
        reference
        interchange_by_reference {
          reference
          interchange_events {
            event_type
            event_type_count
            last_event_timestamp
            email: channel_endpoint(path: "$.email")
            postal_mail: channel_endpoint(path: "postal_mail")
          }
          channel
          direction
        }
      }
    }
    dunning_status
    recipient_by_reference {
      participant
      reference
      name
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
    }
    invoice_dispute: disputes(
      where: {resolved_at: {_is_null: true}}
      order_by: {until: desc}
      limit: 1
    ) {
      reference
      until
    }
    legal_entity_by_reference {
      reference
      registration_name
    }
    participant_by_reference {
      name
      reference
      logical_id
    }
    file_references: attachments
    derived_paid_at
  }
}
    `;

/**
 * __useGqlInvoices_GetInvoiceInterchangeLinksQuery__
 *
 * To run a query within a Vue component, call `useGqlInvoices_GetInvoiceInterchangeLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlInvoices_GetInvoiceInterchangeLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlInvoices_GetInvoiceInterchangeLinksQuery({
 *   participantRef: // value for 'participantRef'
 *   invoice: // value for 'invoice'
 * });
 */
export function useGqlInvoices_GetInvoiceInterchangeLinksQuery(variables: GqlInvoices_GetInvoiceInterchangeLinksQueryVariables | VueCompositionApi.Ref<GqlInvoices_GetInvoiceInterchangeLinksQueryVariables> | ReactiveFunction<GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>(GqlInvoices_GetInvoiceInterchangeLinksDocument, variables, options);
}
export function useGqlInvoices_GetInvoiceInterchangeLinksLazyQuery(variables: GqlInvoices_GetInvoiceInterchangeLinksQueryVariables | VueCompositionApi.Ref<GqlInvoices_GetInvoiceInterchangeLinksQueryVariables> | ReactiveFunction<GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>(GqlInvoices_GetInvoiceInterchangeLinksDocument, variables, options);
}
export type GqlInvoices_GetInvoiceInterchangeLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlInvoices_GetInvoiceInterchangeLinksQuery, GqlInvoices_GetInvoiceInterchangeLinksQueryVariables>;
export const GqlInvoices_GetInvoiceDocument = gql`
    query gqlInvoices_getInvoice($invoice: uuid!) {
  invoice: risolto_invoice_document(where: {reference: {_eq: $invoice}}) {
    processing_due_date
    invoice_number
    amount_currency
    dunning_started
    earliest_dunning_time
    earliest_submission_time
    issue_date
    due_date
    reference
    payment_reference
    file_reference
    file_references
    legal_entity
    legal_entity_by_reference {
      registration_name
      reference
      participant
      address
      company_id
      company_id_type
    }
    total_amount
    open_amount
    amount_currency
    participant
    interchange_links {
      reference
      interchange_by_reference {
        interchange_events {
          event_type
          event_type_count
          last_event_timestamp
          email: channel_endpoint(path: "$.email")
          postal_mail: channel_endpoint(path: "postal_mail")
        }
        reference
        channel
        direction
      }
    }
    recipient
    recipient_by_reference {
      preferred_invoicing_channel
      legal_entity
      legal_entity_by_reference {
        reference
      }
      participant
      reference
      type
      legal_id
      legal_id_type
      address
      name
      account_id
    }
    actions: action_invoices {
      action_by_reference {
        reference
        message_code
      }
    }
    dunning_status
    total_actions: action_invoices_aggregate {
      aggregate {
        count
      }
    }
    custom_fields
    attachments
  }
}
    `;

/**
 * __useGqlInvoices_GetInvoiceQuery__
 *
 * To run a query within a Vue component, call `useGqlInvoices_GetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlInvoices_GetInvoiceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlInvoices_GetInvoiceQuery({
 *   invoice: // value for 'invoice'
 * });
 */
export function useGqlInvoices_GetInvoiceQuery(variables: GqlInvoices_GetInvoiceQueryVariables | VueCompositionApi.Ref<GqlInvoices_GetInvoiceQueryVariables> | ReactiveFunction<GqlInvoices_GetInvoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables>(GqlInvoices_GetInvoiceDocument, variables, options);
}
export function useGqlInvoices_GetInvoiceLazyQuery(variables: GqlInvoices_GetInvoiceQueryVariables | VueCompositionApi.Ref<GqlInvoices_GetInvoiceQueryVariables> | ReactiveFunction<GqlInvoices_GetInvoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables>(GqlInvoices_GetInvoiceDocument, variables, options);
}
export type GqlInvoices_GetInvoiceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlInvoices_GetInvoiceQuery, GqlInvoices_GetInvoiceQueryVariables>;
export const GqlInvoices_GetInvoicesDocument = gql`
    query gqlInvoices_getInvoices($limit: Int = 10, $offset: Int = 0, $participantRef: uuid!, $status: [risolto_invoice_document_status_enum!], $orderBy: [risolto_invoice_document_order_by!], $searchTerm: String!, $searchAmount_min: numeric!, $searchAmount_max: numeric!, $today: date!) {
  total: risolto_invoice_document_aggregate(
    where: {participant: {_eq: $participantRef}, status: {_in: $status}, _or: [{recipient_by_reference: {_or: [{name: {_ilike: $searchTerm}}, {legal_id: {_ilike: $searchTerm}}, {account_id: {_ilike: $searchTerm}}]}}, {_and: [{open_amount: {_gt: $searchAmount_min}}, {open_amount: {_lt: $searchAmount_max}}]}, {_and: [{total_amount: {_gt: $searchAmount_min}}, {total_amount: {_lt: $searchAmount_max}}]}, {invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}]}
  ) {
    aggregate {
      count
    }
  }
  invoices: risolto_invoice_document(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: {participant: {_eq: $participantRef}, status: {_in: $status}, _or: [{recipient_by_reference: {_or: [{name: {_ilike: $searchTerm}}, {legal_id: {_ilike: $searchTerm}}, {account_id: {_ilike: $searchTerm}}]}}, {_and: [{open_amount: {_gt: $searchAmount_min}}, {open_amount: {_lt: $searchAmount_max}}]}, {_and: [{total_amount: {_gt: $searchAmount_min}}, {total_amount: {_lt: $searchAmount_max}}]}, {invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}]}
  ) {
    total_actions: action_invoices_aggregate {
      aggregate {
        count
      }
    }
    total_open_actions: action_invoices_aggregate(
      where: {invoice_by_reference: {status: {_eq: OPEN}}}
    ) {
      aggregate {
        count
      }
    }
    processing_due_date
    invoice_number
    open_amount
    total_amount
    payment_reference
    due_date
    file_reference
    file_references
    issue_date
    status
    recipient
    recipient_by_reference {
      participant
      reference
      name
      account_id
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
    }
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    processing_due_date
    participant
    participant_by_reference {
      name
      reference
      logical_id
    }
    reference
    amount_currency
    invoice_dispute: disputes(
      where: {until: {_gte: $today}}
      order_by: {until: desc}
      limit: 1
    ) {
      reference
      until
    }
  }
}
    `;

/**
 * __useGqlInvoices_GetInvoicesQuery__
 *
 * To run a query within a Vue component, call `useGqlInvoices_GetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlInvoices_GetInvoicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlInvoices_GetInvoicesQuery({
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   participantRef: // value for 'participantRef'
 *   status: // value for 'status'
 *   orderBy: // value for 'orderBy'
 *   searchTerm: // value for 'searchTerm'
 *   searchAmount_min: // value for 'searchAmount_min'
 *   searchAmount_max: // value for 'searchAmount_max'
 *   today: // value for 'today'
 * });
 */
export function useGqlInvoices_GetInvoicesQuery(variables: GqlInvoices_GetInvoicesQueryVariables | VueCompositionApi.Ref<GqlInvoices_GetInvoicesQueryVariables> | ReactiveFunction<GqlInvoices_GetInvoicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables>(GqlInvoices_GetInvoicesDocument, variables, options);
}
export function useGqlInvoices_GetInvoicesLazyQuery(variables: GqlInvoices_GetInvoicesQueryVariables | VueCompositionApi.Ref<GqlInvoices_GetInvoicesQueryVariables> | ReactiveFunction<GqlInvoices_GetInvoicesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables>(GqlInvoices_GetInvoicesDocument, variables, options);
}
export type GqlInvoices_GetInvoicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlInvoices_GetInvoicesQuery, GqlInvoices_GetInvoicesQueryVariables>;
export const GqlInvoices_GetInvoicesForRecipientDocument = gql`
    query gqlInvoices_getInvoicesForRecipient($limit: Int = 10, $offset: Int = 0, $participantRef: uuid!, $recipient: uuid!, $status: [risolto_invoice_document_status_enum!], $orderBy: [risolto_invoice_document_order_by!], $searchTerm: String!, $searchAmount_min: numeric!, $searchAmount_max: numeric!, $today: date!) {
  total: risolto_invoice_document_aggregate(
    where: {participant: {_eq: $participantRef}, recipient: {_eq: $recipient}, status: {_in: $status}, _or: [{_and: [{open_amount: {_gt: $searchAmount_min}}, {open_amount: {_lt: $searchAmount_max}}]}, {_and: [{total_amount: {_gt: $searchAmount_min}}, {total_amount: {_lt: $searchAmount_max}}]}, {invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}]}
  ) {
    aggregate {
      count
    }
  }
  invoices: risolto_invoice_document(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: {participant: {_eq: $participantRef}, recipient: {_eq: $recipient}, status: {_in: $status}, _or: [{_and: [{open_amount: {_gt: $searchAmount_min}}, {open_amount: {_lt: $searchAmount_max}}]}, {_and: [{total_amount: {_gt: $searchAmount_min}}, {total_amount: {_lt: $searchAmount_max}}]}, {invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}]}
  ) {
    processing_due_date
    invoice_number
    open_amount
    total_amount
    payment_reference
    due_date
    file_reference
    file_references
    issue_date
    status
    recipient
    recipient_by_reference {
      participant
      reference
      name
      account_id
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
    }
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    processing_due_date
    participant
    participant_by_reference {
      name
      reference
      logical_id
    }
    reference
    amount_currency
    invoice_dispute: disputes(
      where: {until: {_gte: $today}, resolved_at: {_is_null: true}}
      order_by: {until: desc}
      limit: 1
    ) {
      reference
      until
    }
  }
}
    `;

/**
 * __useGqlInvoices_GetInvoicesForRecipientQuery__
 *
 * To run a query within a Vue component, call `useGqlInvoices_GetInvoicesForRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlInvoices_GetInvoicesForRecipientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlInvoices_GetInvoicesForRecipientQuery({
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   participantRef: // value for 'participantRef'
 *   recipient: // value for 'recipient'
 *   status: // value for 'status'
 *   orderBy: // value for 'orderBy'
 *   searchTerm: // value for 'searchTerm'
 *   searchAmount_min: // value for 'searchAmount_min'
 *   searchAmount_max: // value for 'searchAmount_max'
 *   today: // value for 'today'
 * });
 */
export function useGqlInvoices_GetInvoicesForRecipientQuery(variables: GqlInvoices_GetInvoicesForRecipientQueryVariables | VueCompositionApi.Ref<GqlInvoices_GetInvoicesForRecipientQueryVariables> | ReactiveFunction<GqlInvoices_GetInvoicesForRecipientQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables>(GqlInvoices_GetInvoicesForRecipientDocument, variables, options);
}
export function useGqlInvoices_GetInvoicesForRecipientLazyQuery(variables: GqlInvoices_GetInvoicesForRecipientQueryVariables | VueCompositionApi.Ref<GqlInvoices_GetInvoicesForRecipientQueryVariables> | ReactiveFunction<GqlInvoices_GetInvoicesForRecipientQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables>(GqlInvoices_GetInvoicesForRecipientDocument, variables, options);
}
export type GqlInvoices_GetInvoicesForRecipientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlInvoices_GetInvoicesForRecipientQuery, GqlInvoices_GetInvoicesForRecipientQueryVariables>;
export const GqlInvoices_FindInvoicesDocument = gql`
    query gqlInvoices_findInvoices($searchTerm: String, $amount: numeric) {
  total: risolto_invoice_document_aggregate(
    where: {_or: [{invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}, {total_amount: {_eq: $amount}}, {open_amount: {_eq: $amount}}, {recipient_by_reference: {bank_accounts: {account_number: {_ilike: $searchTerm}}}}, {recipient_by_reference: {name: {_ilike: $searchTerm}}}, {recipient_by_reference: {account_id: {_ilike: $searchTerm}}}]}
  ) {
    aggregate {
      count
    }
  }
  invoices: risolto_invoice_document(
    where: {_or: [{invoice_number: {_ilike: $searchTerm}}, {payment_reference: {_ilike: $searchTerm}}, {total_amount: {_eq: $amount}}, {open_amount: {_eq: $amount}}, {recipient_by_reference: {bank_accounts: {account_number: {_ilike: $searchTerm}}}}, {recipient_by_reference: {name: {_ilike: $searchTerm}}}, {recipient_by_reference: {account_id: {_ilike: $searchTerm}}}]}
  ) {
    reference
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      bank_accounts {
        account_number
      }
    }
    processing_due_date
    invoice_number
    status
    payment_reference
    open_amount
    total_amount
  }
}
    `;

/**
 * __useGqlInvoices_FindInvoicesQuery__
 *
 * To run a query within a Vue component, call `useGqlInvoices_FindInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlInvoices_FindInvoicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlInvoices_FindInvoicesQuery({
 *   searchTerm: // value for 'searchTerm'
 *   amount: // value for 'amount'
 * });
 */
export function useGqlInvoices_FindInvoicesQuery(variables: GqlInvoices_FindInvoicesQueryVariables | VueCompositionApi.Ref<GqlInvoices_FindInvoicesQueryVariables> | ReactiveFunction<GqlInvoices_FindInvoicesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables>(GqlInvoices_FindInvoicesDocument, variables, options);
}
export function useGqlInvoices_FindInvoicesLazyQuery(variables: GqlInvoices_FindInvoicesQueryVariables | VueCompositionApi.Ref<GqlInvoices_FindInvoicesQueryVariables> | ReactiveFunction<GqlInvoices_FindInvoicesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables>(GqlInvoices_FindInvoicesDocument, variables, options);
}
export type GqlInvoices_FindInvoicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlInvoices_FindInvoicesQuery, GqlInvoices_FindInvoicesQueryVariables>;
export const GqlInvoices_ActionsByInvoiceDocument = gql`
    query gqlInvoices_actionsByInvoice($invoice: uuid!) {
  total: risolto_action_aggregate(
    where: {action_invoices: {invoice: {_eq: $invoice}}}
  ) {
    aggregate {
      count
    }
  }
  actions: risolto_action(where: {action_invoices: {invoice: {_eq: $invoice}}}) {
    action_invoices {
      action
      action_by_reference {
        status
        channel
        source
        recipient
        participant
        metadata
      }
      invoice
      invoice_by_reference {
        reference
        invoice_number
        processing_due_date
      }
    }
  }
}
    `;

/**
 * __useGqlInvoices_ActionsByInvoiceQuery__
 *
 * To run a query within a Vue component, call `useGqlInvoices_ActionsByInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlInvoices_ActionsByInvoiceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlInvoices_ActionsByInvoiceQuery({
 *   invoice: // value for 'invoice'
 * });
 */
export function useGqlInvoices_ActionsByInvoiceQuery(variables: GqlInvoices_ActionsByInvoiceQueryVariables | VueCompositionApi.Ref<GqlInvoices_ActionsByInvoiceQueryVariables> | ReactiveFunction<GqlInvoices_ActionsByInvoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables>(GqlInvoices_ActionsByInvoiceDocument, variables, options);
}
export function useGqlInvoices_ActionsByInvoiceLazyQuery(variables: GqlInvoices_ActionsByInvoiceQueryVariables | VueCompositionApi.Ref<GqlInvoices_ActionsByInvoiceQueryVariables> | ReactiveFunction<GqlInvoices_ActionsByInvoiceQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables>(GqlInvoices_ActionsByInvoiceDocument, variables, options);
}
export type GqlInvoices_ActionsByInvoiceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlInvoices_ActionsByInvoiceQuery, GqlInvoices_ActionsByInvoiceQueryVariables>;
export const GetLegalEntitiesDocument = gql`
    query getLegalEntities($participant: uuid) {
  legal_entities: risolto_legal_entity(where: {participant: {_eq: $participant}}) {
    reference
    registration_name
    company_id
    logical_id
  }
}
    `;

/**
 * __useGetLegalEntitiesQuery__
 *
 * To run a query within a Vue component, call `useGetLegalEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegalEntitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLegalEntitiesQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useGetLegalEntitiesQuery(variables: GetLegalEntitiesQueryVariables | VueCompositionApi.Ref<GetLegalEntitiesQueryVariables> | ReactiveFunction<GetLegalEntitiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables>(GetLegalEntitiesDocument, variables, options);
}
export function useGetLegalEntitiesLazyQuery(variables: GetLegalEntitiesQueryVariables | VueCompositionApi.Ref<GetLegalEntitiesQueryVariables> | ReactiveFunction<GetLegalEntitiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables>(GetLegalEntitiesDocument, variables, options);
}
export type GetLegalEntitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetLegalEntitiesQuery, GetLegalEntitiesQueryVariables>;
export const FindInvoicePaymentTriggerDocument = gql`
    query findInvoicePaymentTrigger($recipient: uuid!) {
  risolto_recipient(
    limit: 100
    where: {reference: {_eq: $recipient}, invoice_documents: {status: {_eq: PAID}, reference: {_is_null: false}, action_invoices: {action_by_reference: {reference: {_is_null: false}}}}}
  ) {
    invoice_documents(where: {status: {_eq: PAID}}) {
      due_date
      invoice_number
      status
      action_invoices(
        order_by: {action_by_reference: {confirmed_at: desc_nulls_last}}
        limit: 1
      ) {
        action_by_reference {
          reference
          channel
          message_code
          executed_at
          updated_at
          action_invoices {
            reference
            invoice
            invoice_by_reference {
              invoice_number
            }
          }
        }
      }
    }
    account_id
  }
}
    `;

/**
 * __useFindInvoicePaymentTriggerQuery__
 *
 * To run a query within a Vue component, call `useFindInvoicePaymentTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindInvoicePaymentTriggerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFindInvoicePaymentTriggerQuery({
 *   recipient: // value for 'recipient'
 * });
 */
export function useFindInvoicePaymentTriggerQuery(variables: FindInvoicePaymentTriggerQueryVariables | VueCompositionApi.Ref<FindInvoicePaymentTriggerQueryVariables> | ReactiveFunction<FindInvoicePaymentTriggerQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables>(FindInvoicePaymentTriggerDocument, variables, options);
}
export function useFindInvoicePaymentTriggerLazyQuery(variables: FindInvoicePaymentTriggerQueryVariables | VueCompositionApi.Ref<FindInvoicePaymentTriggerQueryVariables> | ReactiveFunction<FindInvoicePaymentTriggerQueryVariables>, options: VueApolloComposable.UseQueryOptions<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables>(FindInvoicePaymentTriggerDocument, variables, options);
}
export type FindInvoicePaymentTriggerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FindInvoicePaymentTriggerQuery, FindInvoicePaymentTriggerQueryVariables>;
export const Risolto_NotesDocument = gql`
    query risolto_notes($participant: uuid, $recipientRef: uuid, $limit: Int = 10, $offset: Int = 0) {
  total: risolto_note_aggregate(
    order_by: {created_at: desc}
    where: {recipient: {_eq: $recipientRef}, participant: {_eq: $participant}}
    limit: $limit
    offset: $offset
  ) {
    aggregate {
      count
    }
  }
  notes: risolto_note(
    order_by: {created_at: desc}
    where: {recipient: {_eq: $recipientRef}, participant: {_eq: $participant}}
    limit: $limit
    offset: $offset
  ) {
    reference
    note
    created_by
    created_at
    person_by_reference {
      reference
      external_id
      username
    }
    note_invoices {
      reference
      invoice_by_reference {
        reference
        invoice_number
      }
    }
  }
}
    `;

/**
 * __useRisolto_NotesQuery__
 *
 * To run a query within a Vue component, call `useRisolto_NotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRisolto_NotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRisolto_NotesQuery({
 *   participant: // value for 'participant'
 *   recipientRef: // value for 'recipientRef'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useRisolto_NotesQuery(variables: Risolto_NotesQueryVariables | VueCompositionApi.Ref<Risolto_NotesQueryVariables> | ReactiveFunction<Risolto_NotesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Risolto_NotesQuery, Risolto_NotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Risolto_NotesQuery, Risolto_NotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Risolto_NotesQuery, Risolto_NotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Risolto_NotesQuery, Risolto_NotesQueryVariables>(Risolto_NotesDocument, variables, options);
}
export function useRisolto_NotesLazyQuery(variables: Risolto_NotesQueryVariables | VueCompositionApi.Ref<Risolto_NotesQueryVariables> | ReactiveFunction<Risolto_NotesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Risolto_NotesQuery, Risolto_NotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Risolto_NotesQuery, Risolto_NotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Risolto_NotesQuery, Risolto_NotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Risolto_NotesQuery, Risolto_NotesQueryVariables>(Risolto_NotesDocument, variables, options);
}
export type Risolto_NotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Risolto_NotesQuery, Risolto_NotesQueryVariables>;
export const GetInvoiceNotesDocument = gql`
    query getInvoiceNotes($participant: uuid!, $invoice: uuid!, $limit: Int = 10, $offset: Int = 0) {
  notes: risolto_note_invoice(
    where: {_and: [{invoice: {_eq: $invoice}}, {participant: {_eq: $participant}}]}
    limit: $limit
    offset: $offset
    order_by: {note_by_reference: {created_at: desc}}
  ) {
    note
    note_by_reference {
      reference
      note
      created_at
      created_by
      person_by_reference {
        reference
        external_id
        username
      }
    }
  }
  total: risolto_note_invoice_aggregate(
    where: {_and: [{invoice: {_eq: $invoice}}, {participant: {_eq: $participant}}]}
    limit: $limit
    offset: $offset
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetInvoiceNotesQuery__
 *
 * To run a query within a Vue component, call `useGetInvoiceNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInvoiceNotesQuery({
 *   participant: // value for 'participant'
 *   invoice: // value for 'invoice'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useGetInvoiceNotesQuery(variables: GetInvoiceNotesQueryVariables | VueCompositionApi.Ref<GetInvoiceNotesQueryVariables> | ReactiveFunction<GetInvoiceNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables>(GetInvoiceNotesDocument, variables, options);
}
export function useGetInvoiceNotesLazyQuery(variables: GetInvoiceNotesQueryVariables | VueCompositionApi.Ref<GetInvoiceNotesQueryVariables> | ReactiveFunction<GetInvoiceNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables>(GetInvoiceNotesDocument, variables, options);
}
export type GetInvoiceNotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInvoiceNotesQuery, GetInvoiceNotesQueryVariables>;
export const Insert_Risolto_NoteDocument = gql`
    mutation insert_risolto_note($note: String!, $category: risolto_note_category_enum, $participant: uuid!, $invoice: uuid, $recipient: uuid!, $legal_entity: uuid!, $created_by: uuid!, $action: uuid) {
  result: insert_risolto_note(
    objects: {note: $note, participant: $participant, category: $category, recipient: $recipient, legal_entity: $legal_entity, created_by: $created_by, invoice_document: $invoice, action: $action}
  ) {
    updated_count: affected_rows
    returning {
      reference
      note
    }
  }
}
    `;

/**
 * __useInsert_Risolto_NoteMutation__
 *
 * To run a mutation, you first call `useInsert_Risolto_NoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Risolto_NoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsert_Risolto_NoteMutation({
 *   variables: {
 *     note: // value for 'note'
 *     category: // value for 'category'
 *     participant: // value for 'participant'
 *     invoice: // value for 'invoice'
 *     recipient: // value for 'recipient'
 *     legal_entity: // value for 'legal_entity'
 *     created_by: // value for 'created_by'
 *     action: // value for 'action'
 *   },
 * });
 */
export function useInsert_Risolto_NoteMutation(options: VueApolloComposable.UseMutationOptions<Insert_Risolto_NoteMutation, Insert_Risolto_NoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Insert_Risolto_NoteMutation, Insert_Risolto_NoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Insert_Risolto_NoteMutation, Insert_Risolto_NoteMutationVariables>(Insert_Risolto_NoteDocument, options);
}
export type Insert_Risolto_NoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Insert_Risolto_NoteMutation, Insert_Risolto_NoteMutationVariables>;
export const InsertInvoiceNoteDocument = gql`
    mutation insertInvoiceNote($note: uuid!, $invoice: uuid!, $participant: uuid!, $legalEntity: uuid!) {
  insert_risolto_note_invoice(
    objects: {invoice: $invoice, note: $note, legal_entity: $legalEntity, participant: $participant}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;

/**
 * __useInsertInvoiceNoteMutation__
 *
 * To run a mutation, you first call `useInsertInvoiceNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertInvoiceNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertInvoiceNoteMutation({
 *   variables: {
 *     note: // value for 'note'
 *     invoice: // value for 'invoice'
 *     participant: // value for 'participant'
 *     legalEntity: // value for 'legalEntity'
 *   },
 * });
 */
export function useInsertInvoiceNoteMutation(options: VueApolloComposable.UseMutationOptions<InsertInvoiceNoteMutation, InsertInvoiceNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<InsertInvoiceNoteMutation, InsertInvoiceNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<InsertInvoiceNoteMutation, InsertInvoiceNoteMutationVariables>(InsertInvoiceNoteDocument, options);
}
export type InsertInvoiceNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<InsertInvoiceNoteMutation, InsertInvoiceNoteMutationVariables>;
export const Update_Risolto_NoteDocument = gql`
    mutation update_risolto_note($noteRef: uuid!, $newNote: String!) {
  update_risolto_note(where: {reference: {_eq: $noteRef}}, _set: {note: $newNote}) {
    updated_count: affected_rows
    updated: returning {
      note
      reference
    }
  }
}
    `;

/**
 * __useUpdate_Risolto_NoteMutation__
 *
 * To run a mutation, you first call `useUpdate_Risolto_NoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Risolto_NoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdate_Risolto_NoteMutation({
 *   variables: {
 *     noteRef: // value for 'noteRef'
 *     newNote: // value for 'newNote'
 *   },
 * });
 */
export function useUpdate_Risolto_NoteMutation(options: VueApolloComposable.UseMutationOptions<Update_Risolto_NoteMutation, Update_Risolto_NoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Update_Risolto_NoteMutation, Update_Risolto_NoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Update_Risolto_NoteMutation, Update_Risolto_NoteMutationVariables>(Update_Risolto_NoteDocument, options);
}
export type Update_Risolto_NoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Update_Risolto_NoteMutation, Update_Risolto_NoteMutationVariables>;
export const Delete_Risolto_NoteDocument = gql`
    mutation delete_risolto_note($noteRef: uuid!) {
  delete_risolto_note(where: {reference: {_eq: $noteRef}}) {
    deleted: affected_rows
  }
}
    `;

/**
 * __useDelete_Risolto_NoteMutation__
 *
 * To run a mutation, you first call `useDelete_Risolto_NoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Risolto_NoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDelete_Risolto_NoteMutation({
 *   variables: {
 *     noteRef: // value for 'noteRef'
 *   },
 * });
 */
export function useDelete_Risolto_NoteMutation(options: VueApolloComposable.UseMutationOptions<Delete_Risolto_NoteMutation, Delete_Risolto_NoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Delete_Risolto_NoteMutation, Delete_Risolto_NoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Delete_Risolto_NoteMutation, Delete_Risolto_NoteMutationVariables>(Delete_Risolto_NoteDocument, options);
}
export type Delete_Risolto_NoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Delete_Risolto_NoteMutation, Delete_Risolto_NoteMutationVariables>;
export const DeleteInvoiceNoteDocument = gql`
    mutation deleteInvoiceNote($note: uuid!) {
  delete_risolto_note_invoice(where: {note: {_eq: $note}}) {
    returning {
      reference
    }
    affected_rows
  }
  delete_risolto_note(where: {reference: {_eq: $note}}) {
    returning {
      reference
    }
    affected_rows
  }
}
    `;

/**
 * __useDeleteInvoiceNoteMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteInvoiceNoteMutation({
 *   variables: {
 *     note: // value for 'note'
 *   },
 * });
 */
export function useDeleteInvoiceNoteMutation(options: VueApolloComposable.UseMutationOptions<DeleteInvoiceNoteMutation, DeleteInvoiceNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteInvoiceNoteMutation, DeleteInvoiceNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteInvoiceNoteMutation, DeleteInvoiceNoteMutationVariables>(DeleteInvoiceNoteDocument, options);
}
export type DeleteInvoiceNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteInvoiceNoteMutation, DeleteInvoiceNoteMutationVariables>;
export const GqlParticipantsGetParticipantsDocument = gql`
    query gqlParticipantsGetParticipants($limit: Int = 10, $offset: Int = 0, $searchTerm: String) {
  risolto_participant(
    limit: $limit
    offset: $offset
    where: {name: {_ilike: $searchTerm}}
  ) {
    name
    reference
  }
  risolto_participant_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGqlParticipantsGetParticipantsQuery__
 *
 * To run a query within a Vue component, call `useGqlParticipantsGetParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlParticipantsGetParticipantsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlParticipantsGetParticipantsQuery({
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   searchTerm: // value for 'searchTerm'
 * });
 */
export function useGqlParticipantsGetParticipantsQuery(variables: GqlParticipantsGetParticipantsQueryVariables | VueCompositionApi.Ref<GqlParticipantsGetParticipantsQueryVariables> | ReactiveFunction<GqlParticipantsGetParticipantsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables>(GqlParticipantsGetParticipantsDocument, variables, options);
}
export function useGqlParticipantsGetParticipantsLazyQuery(variables: GqlParticipantsGetParticipantsQueryVariables | VueCompositionApi.Ref<GqlParticipantsGetParticipantsQueryVariables> | ReactiveFunction<GqlParticipantsGetParticipantsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables>(GqlParticipantsGetParticipantsDocument, variables, options);
}
export type GqlParticipantsGetParticipantsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlParticipantsGetParticipantsQuery, GqlParticipantsGetParticipantsQueryVariables>;
export const GqlParticipantsGetParticipantDocument = gql`
    query gqlParticipantsGetParticipant($partRef: uuid!) {
  risolto_participant(where: {reference: {_eq: $partRef}}) {
    name
    reference
  }
}
    `;

/**
 * __useGqlParticipantsGetParticipantQuery__
 *
 * To run a query within a Vue component, call `useGqlParticipantsGetParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlParticipantsGetParticipantQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlParticipantsGetParticipantQuery({
 *   partRef: // value for 'partRef'
 * });
 */
export function useGqlParticipantsGetParticipantQuery(variables: GqlParticipantsGetParticipantQueryVariables | VueCompositionApi.Ref<GqlParticipantsGetParticipantQueryVariables> | ReactiveFunction<GqlParticipantsGetParticipantQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables>(GqlParticipantsGetParticipantDocument, variables, options);
}
export function useGqlParticipantsGetParticipantLazyQuery(variables: GqlParticipantsGetParticipantQueryVariables | VueCompositionApi.Ref<GqlParticipantsGetParticipantQueryVariables> | ReactiveFunction<GqlParticipantsGetParticipantQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables>(GqlParticipantsGetParticipantDocument, variables, options);
}
export type GqlParticipantsGetParticipantQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlParticipantsGetParticipantQuery, GqlParticipantsGetParticipantQueryVariables>;
export const GqlParticipantsGetParticipantDetailsDocument = gql`
    query gqlParticipantsGetParticipantDetails($participant: uuid!) {
  participant: risolto_participant(where: {reference: {_eq: $participant}}) {
    name
    reference
    legal_entities {
      reference
      logical_id
      registration_name
      processing_details
    }
  }
}
    `;

/**
 * __useGqlParticipantsGetParticipantDetailsQuery__
 *
 * To run a query within a Vue component, call `useGqlParticipantsGetParticipantDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlParticipantsGetParticipantDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlParticipantsGetParticipantDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useGqlParticipantsGetParticipantDetailsQuery(variables: GqlParticipantsGetParticipantDetailsQueryVariables | VueCompositionApi.Ref<GqlParticipantsGetParticipantDetailsQueryVariables> | ReactiveFunction<GqlParticipantsGetParticipantDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables>(GqlParticipantsGetParticipantDetailsDocument, variables, options);
}
export function useGqlParticipantsGetParticipantDetailsLazyQuery(variables: GqlParticipantsGetParticipantDetailsQueryVariables | VueCompositionApi.Ref<GqlParticipantsGetParticipantDetailsQueryVariables> | ReactiveFunction<GqlParticipantsGetParticipantDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables>(GqlParticipantsGetParticipantDetailsDocument, variables, options);
}
export type GqlParticipantsGetParticipantDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlParticipantsGetParticipantDetailsQuery, GqlParticipantsGetParticipantDetailsQueryVariables>;
export const GetParticipantsForUserDocument = gql`
    query getParticipantsForUser($externalId: [String!], $license_module: risolto_platform_license_module_enum!) {
  risolto_participant(
    where: {_and: [{platform_participant_licenses: {platform_license_module: {_eq: $license_module}}}, {participant_users: {person_by_reference: {external_id: {_in: $externalId}}}}]}
  ) {
    logical_id
    name
    reference
    user_interface_details
    legal_entities {
      reference
      logical_id
      registration_name
    }
  }
}
    `;

/**
 * __useGetParticipantsForUserQuery__
 *
 * To run a query within a Vue component, call `useGetParticipantsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsForUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetParticipantsForUserQuery({
 *   externalId: // value for 'externalId'
 *   license_module: // value for 'license_module'
 * });
 */
export function useGetParticipantsForUserQuery(variables: GetParticipantsForUserQueryVariables | VueCompositionApi.Ref<GetParticipantsForUserQueryVariables> | ReactiveFunction<GetParticipantsForUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables>(GetParticipantsForUserDocument, variables, options);
}
export function useGetParticipantsForUserLazyQuery(variables: GetParticipantsForUserQueryVariables | VueCompositionApi.Ref<GetParticipantsForUserQueryVariables> | ReactiveFunction<GetParticipantsForUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables>(GetParticipantsForUserDocument, variables, options);
}
export type GetParticipantsForUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetParticipantsForUserQuery, GetParticipantsForUserQueryVariables>;
export const GetPaymentDocumentDocument = gql`
    query getPaymentDocument($participant: uuid!, $recipient: uuid!, $offset: Int, $limit: Int) {
  total: risolto_payment_document_aggregate(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
  ) {
    aggregate {
      count
    }
  }
  payment_documents: risolto_payment_document(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
    limit: $limit
    offset: $offset
    order_by: {is_open: desc, issue_date: desc_nulls_last}
  ) {
    reference
    created_at
    payment_number
    participant
    amount_currency
    processing_status
    custom_fields
    origin
    total_amount
    open_amount
    issue_date
  }
}
    `;

/**
 * __useGetPaymentDocumentQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentDocumentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentDocumentQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 *   offset: // value for 'offset'
 *   limit: // value for 'limit'
 * });
 */
export function useGetPaymentDocumentQuery(variables: GetPaymentDocumentQueryVariables | VueCompositionApi.Ref<GetPaymentDocumentQueryVariables> | ReactiveFunction<GetPaymentDocumentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables>(GetPaymentDocumentDocument, variables, options);
}
export function useGetPaymentDocumentLazyQuery(variables: GetPaymentDocumentQueryVariables | VueCompositionApi.Ref<GetPaymentDocumentQueryVariables> | ReactiveFunction<GetPaymentDocumentQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables>(GetPaymentDocumentDocument, variables, options);
}
export type GetPaymentDocumentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetPaymentDocumentQuery, GetPaymentDocumentQueryVariables>;
export const GqlPaymentPlan_PaymentPlansDocument = gql`
    query gqlPaymentPlan_paymentPlans($participant: uuid!, $recipient: uuid!) {
  paymentPlans: risolto_payment_plan(
    where: {participant: {_eq: $participant}, recipient: {_eq: $recipient}}
    order_by: {created_at: desc}
  ) {
    reference
    name
    total_amount
    open_amount: virtual_open_amount
    status
    is_open
    amount_currency
    payment_promises(order_by: {due_date: asc}) {
      reference
      payment_reference
      status
      due_date
      total_amount
      open_amount
      amount_currency
    }
  }
}
    `;

/**
 * __useGqlPaymentPlan_PaymentPlansQuery__
 *
 * To run a query within a Vue component, call `useGqlPaymentPlan_PaymentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlPaymentPlan_PaymentPlansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlPaymentPlan_PaymentPlansQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 * });
 */
export function useGqlPaymentPlan_PaymentPlansQuery(variables: GqlPaymentPlan_PaymentPlansQueryVariables | VueCompositionApi.Ref<GqlPaymentPlan_PaymentPlansQueryVariables> | ReactiveFunction<GqlPaymentPlan_PaymentPlansQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables>(GqlPaymentPlan_PaymentPlansDocument, variables, options);
}
export function useGqlPaymentPlan_PaymentPlansLazyQuery(variables: GqlPaymentPlan_PaymentPlansQueryVariables | VueCompositionApi.Ref<GqlPaymentPlan_PaymentPlansQueryVariables> | ReactiveFunction<GqlPaymentPlan_PaymentPlansQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables>(GqlPaymentPlan_PaymentPlansDocument, variables, options);
}
export type GqlPaymentPlan_PaymentPlansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlPaymentPlan_PaymentPlansQuery, GqlPaymentPlan_PaymentPlansQueryVariables>;
export const GqlPeople_GetParticipantUsersDocument = gql`
    query gqlPeople_getParticipantUsers($participant: uuid!, $legal_entity: uuid) {
  participantUsers: risolto_participant_user(
    where: {_and: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, internal: {_eq: false}, deactivated_at: {_is_null: true}}}
  ) {
    person_by_reference {
      reference
      username
      email
    }
  }
}
    `;

/**
 * __useGqlPeople_GetParticipantUsersQuery__
 *
 * To run a query within a Vue component, call `useGqlPeople_GetParticipantUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlPeople_GetParticipantUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlPeople_GetParticipantUsersQuery({
 *   participant: // value for 'participant'
 *   legal_entity: // value for 'legal_entity'
 * });
 */
export function useGqlPeople_GetParticipantUsersQuery(variables: GqlPeople_GetParticipantUsersQueryVariables | VueCompositionApi.Ref<GqlPeople_GetParticipantUsersQueryVariables> | ReactiveFunction<GqlPeople_GetParticipantUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables>(GqlPeople_GetParticipantUsersDocument, variables, options);
}
export function useGqlPeople_GetParticipantUsersLazyQuery(variables: GqlPeople_GetParticipantUsersQueryVariables | VueCompositionApi.Ref<GqlPeople_GetParticipantUsersQueryVariables> | ReactiveFunction<GqlPeople_GetParticipantUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables>(GqlPeople_GetParticipantUsersDocument, variables, options);
}
export type GqlPeople_GetParticipantUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlPeople_GetParticipantUsersQuery, GqlPeople_GetParticipantUsersQueryVariables>;
export const GqlPeople_GetPersonByExternalIdDocument = gql`
    query gqlPeople_getPersonByExternalId($externalId: String!) {
  risolto_person(where: {external_id: {_eq: $externalId}}) {
    reference
    username
  }
}
    `;

/**
 * __useGqlPeople_GetPersonByExternalIdQuery__
 *
 * To run a query within a Vue component, call `useGqlPeople_GetPersonByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlPeople_GetPersonByExternalIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlPeople_GetPersonByExternalIdQuery({
 *   externalId: // value for 'externalId'
 * });
 */
export function useGqlPeople_GetPersonByExternalIdQuery(variables: GqlPeople_GetPersonByExternalIdQueryVariables | VueCompositionApi.Ref<GqlPeople_GetPersonByExternalIdQueryVariables> | ReactiveFunction<GqlPeople_GetPersonByExternalIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables>(GqlPeople_GetPersonByExternalIdDocument, variables, options);
}
export function useGqlPeople_GetPersonByExternalIdLazyQuery(variables: GqlPeople_GetPersonByExternalIdQueryVariables | VueCompositionApi.Ref<GqlPeople_GetPersonByExternalIdQueryVariables> | ReactiveFunction<GqlPeople_GetPersonByExternalIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables>(GqlPeople_GetPersonByExternalIdDocument, variables, options);
}
export type GqlPeople_GetPersonByExternalIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlPeople_GetPersonByExternalIdQuery, GqlPeople_GetPersonByExternalIdQueryVariables>;
export const GqlPeople_GetParticipantByPersonDocument = gql`
    query gqlPeople_getParticipantByPerson($personRef: uuid!) {
  risolto_participant_user(where: {person: {_eq: $personRef}}) {
    reference
    participant
  }
}
    `;

/**
 * __useGqlPeople_GetParticipantByPersonQuery__
 *
 * To run a query within a Vue component, call `useGqlPeople_GetParticipantByPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlPeople_GetParticipantByPersonQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlPeople_GetParticipantByPersonQuery({
 *   personRef: // value for 'personRef'
 * });
 */
export function useGqlPeople_GetParticipantByPersonQuery(variables: GqlPeople_GetParticipantByPersonQueryVariables | VueCompositionApi.Ref<GqlPeople_GetParticipantByPersonQueryVariables> | ReactiveFunction<GqlPeople_GetParticipantByPersonQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables>(GqlPeople_GetParticipantByPersonDocument, variables, options);
}
export function useGqlPeople_GetParticipantByPersonLazyQuery(variables: GqlPeople_GetParticipantByPersonQueryVariables | VueCompositionApi.Ref<GqlPeople_GetParticipantByPersonQueryVariables> | ReactiveFunction<GqlPeople_GetParticipantByPersonQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables>(GqlPeople_GetParticipantByPersonDocument, variables, options);
}
export type GqlPeople_GetParticipantByPersonQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlPeople_GetParticipantByPersonQuery, GqlPeople_GetParticipantByPersonQueryVariables>;
export const GqlRecipients_GetRecipientsDocument = gql`
    query gqlRecipients_getRecipients($partRef: uuid!, $limit: Int = 10, $offset: Int = 0, $searchTerm: String, $orderBy: [risolto_recipient_order_by!]) {
  total: risolto_recipient_aggregate(
    where: {_or: [{name: {_ilike: $searchTerm}}, {account_id: {_ilike: $searchTerm}}, {channel_endpoints: {_and: [{channel: {_eq: "EMAIL"}}, {endpoint: {_ilike: $searchTerm}}]}}], participant: {_eq: $partRef}}
    order_by: $orderBy
  ) {
    aggregate {
      count
    }
  }
  recipients: risolto_recipient(
    limit: $limit
    offset: $offset
    where: {_or: [{name: {_ilike: $searchTerm}}, {account_id: {_ilike: $searchTerm}}, {channel_endpoints: {_and: [{channel: {_eq: "EMAIL"}}, {endpoint: {_ilike: $searchTerm}}]}}], participant: {_eq: $partRef}}
    order_by: $orderBy
  ) {
    balance_amount
    due_balance_amount
    name
    reference
    type
    participant
    legal_id_type
    legal_id
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    account_id
    contacts {
      reference
      first_name
      last_name
    }
    invoice_documents_aggregate {
      aggregate {
        sum {
          open_amount
          total_amount
        }
      }
    }
  }
}
    `;

/**
 * __useGqlRecipients_GetRecipientsQuery__
 *
 * To run a query within a Vue component, call `useGqlRecipients_GetRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlRecipients_GetRecipientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlRecipients_GetRecipientsQuery({
 *   partRef: // value for 'partRef'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   searchTerm: // value for 'searchTerm'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useGqlRecipients_GetRecipientsQuery(variables: GqlRecipients_GetRecipientsQueryVariables | VueCompositionApi.Ref<GqlRecipients_GetRecipientsQueryVariables> | ReactiveFunction<GqlRecipients_GetRecipientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables>(GqlRecipients_GetRecipientsDocument, variables, options);
}
export function useGqlRecipients_GetRecipientsLazyQuery(variables: GqlRecipients_GetRecipientsQueryVariables | VueCompositionApi.Ref<GqlRecipients_GetRecipientsQueryVariables> | ReactiveFunction<GqlRecipients_GetRecipientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables>(GqlRecipients_GetRecipientsDocument, variables, options);
}
export type GqlRecipients_GetRecipientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlRecipients_GetRecipientsQuery, GqlRecipients_GetRecipientsQueryVariables>;
export const GqlRecipients_GetRecipientDocument = gql`
    query gqlRecipients_getRecipient($participant: uuid!, $recipient: uuid!) {
  risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    in_collection
    last_dunning_run_at
    name
    account_id
    participant
    participant_by_reference {
      reference
    }
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
      company_id
      company_id_type
    }
    address
    language_code
    email_main_contact: contacts(
      where: {identifier: {_eq: "main"}, dunning: {_eq: true}, invoicing: {_eq: true}}
    ) {
      reference
      channel_endpoints(where: {channel: {_eq: "EMAIL"}}) {
        endpoint
      }
    }
    postal_main_contact: contacts(
      where: {identifier: {_eq: "main"}, dunning: {_eq: true}, invoicing: {_eq: true}}
    ) {
      reference
      channel_endpoints(where: {channel: {_eq: "MAIL"}}) {
        endpoint_details
      }
    }
    phone_main_contact: contacts(
      where: {identifier: {_eq: "main"}, dunning: {_eq: true}, invoicing: {_eq: true}}
    ) {
      reference
      channel_endpoints(where: {channel: {_eq: "PHONE"}}) {
        endpoint
      }
    }
    sms_main_contact: contacts(
      where: {identifier: {_eq: "main"}, dunning: {_eq: true}, invoicing: {_eq: true}}
    ) {
      reference
      channel_endpoints(where: {channel: {_eq: "SMS"}}) {
        endpoint
      }
    }
    contacts {
      reference
      first_name
      last_name
    }
    main_endpoints: channel_endpoints(
      where: {contact: {_is_null: true}, channel: {_neq: "SMS"}}
      order_by: {deactivated_at: asc_nulls_first, channel: asc}
    ) {
      channel
      endpoint
      endpoint_details
      deactivated_at
    }
    channel_endpoints {
      channel
      contact_by_reference {
        first_name
        last_name
      }
    }
    preferred_invoicing_channel
    balance_amount
    due_balance_amount
    reference
    custom_fields
    legal_id_type
    legal_id
    type
    dunning_is_dirty
    currentActions: actions(
      where: {status: {_eq: OPEN}}
      limit: 2
      order_by: {start_time: desc_nulls_last}
    ) {
      reference
      start_time
    }
    totalCurrentActions: actions_aggregate(where: {status: {_eq: OPEN}}) {
      aggregate {
        count
      }
    }
    invoice_documents_aggregate {
      aggregate {
        sum {
          open_amount
          total_amount
        }
      }
    }
    total_open: invoice_documents_aggregate(where: {status: {_eq: OPEN}}) {
      aggregate {
        sum {
          total_amount
          open_amount
        }
      }
    }
    total_paid: invoice_documents_aggregate(where: {status: {_eq: PAID}}) {
      aggregate {
        sum {
          total_amount
          open_amount
        }
      }
    }
    total_rfs: invoice_documents_aggregate(
      where: {status: {_eq: READY_FOR_SUBMISSION}}
    ) {
      aggregate {
        sum {
          total_amount
          open_amount
        }
      }
    }
  }
}
    `;

/**
 * __useGqlRecipients_GetRecipientQuery__
 *
 * To run a query within a Vue component, call `useGqlRecipients_GetRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGqlRecipients_GetRecipientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGqlRecipients_GetRecipientQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 * });
 */
export function useGqlRecipients_GetRecipientQuery(variables: GqlRecipients_GetRecipientQueryVariables | VueCompositionApi.Ref<GqlRecipients_GetRecipientQueryVariables> | ReactiveFunction<GqlRecipients_GetRecipientQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables>(GqlRecipients_GetRecipientDocument, variables, options);
}
export function useGqlRecipients_GetRecipientLazyQuery(variables: GqlRecipients_GetRecipientQueryVariables | VueCompositionApi.Ref<GqlRecipients_GetRecipientQueryVariables> | ReactiveFunction<GqlRecipients_GetRecipientQueryVariables>, options: VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables>(GqlRecipients_GetRecipientDocument, variables, options);
}
export type GqlRecipients_GetRecipientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GqlRecipients_GetRecipientQuery, GqlRecipients_GetRecipientQueryVariables>;
export const GetTemplatesDocument = gql`
    query getTemplates($legalEntityFilter: [risolto_communication_template_bool_exp!], $participant: uuid, $channels: [risolto_channel_enum!], $searchTerm: String, $locales: [String!], $toneOfVoices: [risolto_tone_of_voice_enum!], $orderBy: [risolto_communication_template_order_by!], $limit: Int!, $offset: Int!) {
  total: risolto_communication_template_aggregate(
    order_by: $orderBy
    where: {_and: [{participant: {_eq: $participant}}, {channel: {_in: $channels}}, {locale: {_in: $locales}}, {tone_of_voice: {_in: $toneOfVoices}}, {_and: $legalEntityFilter}, {_or: [{template_id: {_ilike: $searchTerm}}, {locale: {_ilike: $searchTerm}}, {legal_entity_by_reference: {registration_name: {_ilike: $searchTerm}}}]}]}
  ) {
    aggregate {
      count
    }
  }
  templates: risolto_communication_template(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: {_and: [{participant: {_eq: $participant}}, {channel: {_in: $channels}}, {locale: {_in: $locales}}, {tone_of_voice: {_in: $toneOfVoices}}, {_and: $legalEntityFilter}, {_or: [{template_id: {_ilike: $searchTerm}}, {locale: {_ilike: $searchTerm}}, {legal_entity_by_reference: {registration_name: {_ilike: $searchTerm}}}]}]}
  ) {
    reference
    participant
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    template_id
    channel
    document_name
    tone_of_voice
    type
    locale
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTemplatesQuery({
 *   legalEntityFilter: // value for 'legalEntityFilter'
 *   participant: // value for 'participant'
 *   channels: // value for 'channels'
 *   searchTerm: // value for 'searchTerm'
 *   locales: // value for 'locales'
 *   toneOfVoices: // value for 'toneOfVoices'
 *   orderBy: // value for 'orderBy'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useGetTemplatesQuery(variables: GetTemplatesQueryVariables | VueCompositionApi.Ref<GetTemplatesQueryVariables> | ReactiveFunction<GetTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, variables, options);
}
export function useGetTemplatesLazyQuery(variables: GetTemplatesQueryVariables | VueCompositionApi.Ref<GetTemplatesQueryVariables> | ReactiveFunction<GetTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTemplatesQuery, GetTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, variables, options);
}
export type GetTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetTemplateDocument = gql`
    query getTemplate($reference: uuid) {
  template: risolto_communication_template(where: {reference: {_eq: $reference}}) {
    reference
    participant
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
    }
    template_id
    subject_template
    channel
    document_name
    tone_of_voice
    type
    locale
    template_renderer_version
    document_template
  }
}
    `;

/**
 * __useGetTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTemplateQuery({
 *   reference: // value for 'reference'
 * });
 */
export function useGetTemplateQuery(variables: GetTemplateQueryVariables | VueCompositionApi.Ref<GetTemplateQueryVariables> | ReactiveFunction<GetTemplateQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetTemplateQuery, GetTemplateQueryVariables>(GetTemplateDocument, variables, options);
}
export function useGetTemplateLazyQuery(variables: GetTemplateQueryVariables | VueCompositionApi.Ref<GetTemplateQueryVariables> | ReactiveFunction<GetTemplateQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTemplateQuery, GetTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetTemplateQuery, GetTemplateQueryVariables>(GetTemplateDocument, variables, options);
}
export type GetTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetTemplateQuery, GetTemplateQueryVariables>;
export const UpdateCommunicationTemplateDocument = gql`
    mutation updateCommunicationTemplate($document_template: jsonb, $template_reference: uuid, $subject_template: String) {
  update_risolto_communication_template(
    where: {reference: {_eq: $template_reference}}
    _set: {document_template: $document_template, subject_template: $subject_template}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;

/**
 * __useUpdateCommunicationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateCommunicationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunicationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCommunicationTemplateMutation({
 *   variables: {
 *     document_template: // value for 'document_template'
 *     template_reference: // value for 'template_reference'
 *     subject_template: // value for 'subject_template'
 *   },
 * });
 */
export function useUpdateCommunicationTemplateMutation(options: VueApolloComposable.UseMutationOptions<UpdateCommunicationTemplateMutation, UpdateCommunicationTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCommunicationTemplateMutation, UpdateCommunicationTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCommunicationTemplateMutation, UpdateCommunicationTemplateMutationVariables>(UpdateCommunicationTemplateDocument, options);
}
export type UpdateCommunicationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCommunicationTemplateMutation, UpdateCommunicationTemplateMutationVariables>;
export const GetActionDocument = gql`
    query getAction($ref: uuid!) {
  risolto_action(where: {reference: {_eq: $ref}}) {
    status
    assignee
    assignee_by_reference {
      reference
      username
    }
    channel
    recipient
    recipient_by_reference {
      address
      balance_amount
      dunning_metadata
      last_dunning_at
      legal_id
      legal_id_type
      name
      type
      updated_by
      participant
      reference
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
      }
      account_id
    }
    reference
    metadata
    message_code
    participant
    primary_invoice
    primary_invoice_by_reference {
      invoice_number
    }
    action_invoices {
      reference
      relation
      invoice_by_reference {
        invoice_number
        open_amount
        total_amount
        payment_reference
        due_date
        issue_date
        status
        recipient
        recipient_by_reference {
          reference
          name
        }
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
        participant
        participant_by_reference {
          name
          reference
          logical_id
        }
        reference
        amount_currency
        interchange_links {
          interchange_by_reference {
            reference
            channel
            direction
          }
        }
      }
    }
    legal_entity
    execution_type
    source
    executed_at
    original_action
    retry_count
    start_time
    due_date
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      participant
    }
    legal_entity_by_reference {
      registration_name
      outbound_channel: processing_details(path: "outbound_channel")
    }
    created_at
    assignee
    assignee_by_reference {
      username
    }
    channel_endpoint
    channel_endpoint_by_reference {
      channel
      endpoint
      endpoint_details
      deactivated_at
      deactivated_by
      last_failed_delivery_at
      last_failed_delivery_type
      locale
      priority
    }
    executed_at
    canceled_at
    updated_at
    due_date
  }
}
    `;

/**
 * __useGetActionQuery__
 *
 * To run a query within a Vue component, call `useGetActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetActionQuery({
 *   ref: // value for 'ref'
 * });
 */
export function useGetActionQuery(variables: GetActionQueryVariables | VueCompositionApi.Ref<GetActionQueryVariables> | ReactiveFunction<GetActionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetActionQuery, GetActionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetActionQuery, GetActionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetActionQuery, GetActionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetActionQuery, GetActionQueryVariables>(GetActionDocument, variables, options);
}
export function useGetActionLazyQuery(variables: GetActionQueryVariables | VueCompositionApi.Ref<GetActionQueryVariables> | ReactiveFunction<GetActionQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetActionQuery, GetActionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetActionQuery, GetActionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetActionQuery, GetActionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetActionQuery, GetActionQueryVariables>(GetActionDocument, variables, options);
}
export type GetActionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetActionQuery, GetActionQueryVariables>;
export const ComponentsTimelineNote_UpdateNoteDocument = gql`
    mutation ComponentsTimelineNote_updateNote($reference: uuid!, $note: String!) {
  update_risolto_note(where: {reference: {_eq: $reference}}, _set: {note: $note}) {
    updated_count: affected_rows
    updated: returning {
      reference
      note
    }
  }
}
    `;

/**
 * __useComponentsTimelineNote_UpdateNoteMutation__
 *
 * To run a mutation, you first call `useComponentsTimelineNote_UpdateNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useComponentsTimelineNote_UpdateNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useComponentsTimelineNote_UpdateNoteMutation({
 *   variables: {
 *     reference: // value for 'reference'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useComponentsTimelineNote_UpdateNoteMutation(options: VueApolloComposable.UseMutationOptions<ComponentsTimelineNote_UpdateNoteMutation, ComponentsTimelineNote_UpdateNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ComponentsTimelineNote_UpdateNoteMutation, ComponentsTimelineNote_UpdateNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ComponentsTimelineNote_UpdateNoteMutation, ComponentsTimelineNote_UpdateNoteMutationVariables>(ComponentsTimelineNote_UpdateNoteDocument, options);
}
export type ComponentsTimelineNote_UpdateNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ComponentsTimelineNote_UpdateNoteMutation, ComponentsTimelineNote_UpdateNoteMutationVariables>;
export const ComponentsActionTable_UserInterfaceDetailsDocument = gql`
    query ComponentsActionTable_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "action.custom_field_definitions"
    )
    disallowed_channels: user_interface_details(path: "action.disallowed_channels")
    disallowed_message_codes: user_interface_details(
      path: "action.disallowed_message_codes"
    )
  }
}
    `;

/**
 * __useComponentsActionTable_UserInterfaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useComponentsActionTable_UserInterfaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentsActionTable_UserInterfaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useComponentsActionTable_UserInterfaceDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useComponentsActionTable_UserInterfaceDetailsQuery(variables: ComponentsActionTable_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ComponentsActionTable_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ComponentsActionTable_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables>(ComponentsActionTable_UserInterfaceDetailsDocument, variables, options);
}
export function useComponentsActionTable_UserInterfaceDetailsLazyQuery(variables: ComponentsActionTable_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ComponentsActionTable_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ComponentsActionTable_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables>(ComponentsActionTable_UserInterfaceDetailsDocument, variables, options);
}
export type ComponentsActionTable_UserInterfaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ComponentsActionTable_UserInterfaceDetailsQuery, ComponentsActionTable_UserInterfaceDetailsQueryVariables>;
export const GetNextActionsV3TotalDocument = gql`
    query getNextActionsV3Total($participant: uuid!, $legalEntityFilter: [risolto_action_bool_exp!], $recipient: uuid, $channels: [risolto_channel_enum!], $statuses: [risolto_action_status_enum!], $msgCode: String, $executionTypes: [risolto_action_execution_type_enum!], $assigneeFilter: [risolto_action_bool_exp!], $statusAndDateFilter: [risolto_action_bool_exp!], $searchTermFilter: [risolto_action_bool_exp!], $retryFilter: [risolto_action_bool_exp!]) {
  total: risolto_action_aggregate(
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}, {recipient: {_eq: $recipient}}, {channel: {_in: $channels}}, {status: {_in: $statuses}}, {message_code: {_eq: $msgCode}}, {execution_type: {_in: $executionTypes}}, {_and: $assigneeFilter}, {_and: $statusAndDateFilter}, {_and: $searchTermFilter}, {_and: $retryFilter}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetNextActionsV3TotalQuery__
 *
 * To run a query within a Vue component, call `useGetNextActionsV3TotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextActionsV3TotalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNextActionsV3TotalQuery({
 *   participant: // value for 'participant'
 *   legalEntityFilter: // value for 'legalEntityFilter'
 *   recipient: // value for 'recipient'
 *   channels: // value for 'channels'
 *   statuses: // value for 'statuses'
 *   msgCode: // value for 'msgCode'
 *   executionTypes: // value for 'executionTypes'
 *   assigneeFilter: // value for 'assigneeFilter'
 *   statusAndDateFilter: // value for 'statusAndDateFilter'
 *   searchTermFilter: // value for 'searchTermFilter'
 *   retryFilter: // value for 'retryFilter'
 * });
 */
export function useGetNextActionsV3TotalQuery(variables: GetNextActionsV3TotalQueryVariables | VueCompositionApi.Ref<GetNextActionsV3TotalQueryVariables> | ReactiveFunction<GetNextActionsV3TotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables>(GetNextActionsV3TotalDocument, variables, options);
}
export function useGetNextActionsV3TotalLazyQuery(variables: GetNextActionsV3TotalQueryVariables | VueCompositionApi.Ref<GetNextActionsV3TotalQueryVariables> | ReactiveFunction<GetNextActionsV3TotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables>(GetNextActionsV3TotalDocument, variables, options);
}
export type GetNextActionsV3TotalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetNextActionsV3TotalQuery, GetNextActionsV3TotalQueryVariables>;
export const GetNextActionsV3Document = gql`
    query getNextActionsV3($participant: uuid!, $legalEntityFilter: [risolto_action_bool_exp!], $recipient: uuid, $limit: Int, $offset: Int, $channels: [risolto_channel_enum!], $statuses: [risolto_action_status_enum!], $msgCode: String, $orderBy: [risolto_action_order_by!], $executionTypes: [risolto_action_execution_type_enum!], $assigneeFilter: [risolto_action_bool_exp!], $statusAndDateFilter: [risolto_action_bool_exp!], $searchTermFilter: [risolto_action_bool_exp!], $retryFilter: [risolto_action_bool_exp!]) {
  availableActions: risolto_action(
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}, {recipient: {_eq: $recipient}}, {channel: {_in: $channels}}, {status: {_in: $statuses}}, {message_code: {_eq: $msgCode}}, {execution_type: {_in: $executionTypes}}, {_and: $assigneeFilter}, {_and: $statusAndDateFilter}, {_and: $searchTermFilter}, {_and: $retryFilter}]}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    reference
    status
    channel
    message_code
    is_retry
    execution_type
    source
    retry_count
    original_action
    start_time
    created_at
    executed_at
    canceled_at
    updated_at
    due_date
    metadata
    assignee
    assignee_by_reference {
      reference
      username
    }
    recipient
    recipient_by_reference {
      reference
      name
      account_id
      legal_id
      legal_id_type
      name
      type
    }
    participant
    primary_invoice
    primary_invoice_by_reference {
      invoice_number
    }
    recipient
    legal_entity
    legal_entity_by_reference {
      registration_name
      outbound_channel: processing_details(path: "outbound_channel")
    }
    custom_fields
  }
}
    `;

/**
 * __useGetNextActionsV3Query__
 *
 * To run a query within a Vue component, call `useGetNextActionsV3Query` and pass it any options that fit your needs.
 * When your component renders, `useGetNextActionsV3Query` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNextActionsV3Query({
 *   participant: // value for 'participant'
 *   legalEntityFilter: // value for 'legalEntityFilter'
 *   recipient: // value for 'recipient'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   channels: // value for 'channels'
 *   statuses: // value for 'statuses'
 *   msgCode: // value for 'msgCode'
 *   orderBy: // value for 'orderBy'
 *   executionTypes: // value for 'executionTypes'
 *   assigneeFilter: // value for 'assigneeFilter'
 *   statusAndDateFilter: // value for 'statusAndDateFilter'
 *   searchTermFilter: // value for 'searchTermFilter'
 *   retryFilter: // value for 'retryFilter'
 * });
 */
export function useGetNextActionsV3Query(variables: GetNextActionsV3QueryVariables | VueCompositionApi.Ref<GetNextActionsV3QueryVariables> | ReactiveFunction<GetNextActionsV3QueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNextActionsV3Query, GetNextActionsV3QueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextActionsV3Query, GetNextActionsV3QueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextActionsV3Query, GetNextActionsV3QueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetNextActionsV3Query, GetNextActionsV3QueryVariables>(GetNextActionsV3Document, variables, options);
}
export function useGetNextActionsV3LazyQuery(variables: GetNextActionsV3QueryVariables | VueCompositionApi.Ref<GetNextActionsV3QueryVariables> | ReactiveFunction<GetNextActionsV3QueryVariables>, options: VueApolloComposable.UseQueryOptions<GetNextActionsV3Query, GetNextActionsV3QueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextActionsV3Query, GetNextActionsV3QueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextActionsV3Query, GetNextActionsV3QueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetNextActionsV3Query, GetNextActionsV3QueryVariables>(GetNextActionsV3Document, variables, options);
}
export type GetNextActionsV3QueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetNextActionsV3Query, GetNextActionsV3QueryVariables>;
export const ComponentsContacts_GetContactsDocument = gql`
    query componentsContacts_getContacts($recipient: uuid!, $participant: uuid!) {
  total: risolto_contact_aggregate(
    where: {_and: [{recipient: {_eq: $recipient}}, {participant: {_eq: $participant}}, {deactivated_at: {_is_null: true}}]}
  ) {
    aggregate {
      count
    }
  }
  contacts: risolto_contact(
    where: {_and: [{recipient: {_eq: $recipient}}, {participant: {_eq: $participant}}, {deactivated_at: {_is_null: true}}]}
  ) {
    legal_entity
    locale
    participant
    first_name
    last_name
    full_name
    reference
    recipient
    contact_type_by_reference {
      reference
      contact_type
    }
    channel_endpoints(where: {channel: {_neq: "SMS"}}) {
      in_action
      endpoint_details
      deactivated_at
      deactivated_by
      channel
      endpoint
      reference
      origin
      locale
    }
    custom_fields
    origin
  }
}
    `;

/**
 * __useComponentsContacts_GetContactsQuery__
 *
 * To run a query within a Vue component, call `useComponentsContacts_GetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentsContacts_GetContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useComponentsContacts_GetContactsQuery({
 *   recipient: // value for 'recipient'
 *   participant: // value for 'participant'
 * });
 */
export function useComponentsContacts_GetContactsQuery(variables: ComponentsContacts_GetContactsQueryVariables | VueCompositionApi.Ref<ComponentsContacts_GetContactsQueryVariables> | ReactiveFunction<ComponentsContacts_GetContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables>(ComponentsContacts_GetContactsDocument, variables, options);
}
export function useComponentsContacts_GetContactsLazyQuery(variables: ComponentsContacts_GetContactsQueryVariables | VueCompositionApi.Ref<ComponentsContacts_GetContactsQueryVariables> | ReactiveFunction<ComponentsContacts_GetContactsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables>(ComponentsContacts_GetContactsDocument, variables, options);
}
export type ComponentsContacts_GetContactsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ComponentsContacts_GetContactsQuery, ComponentsContacts_GetContactsQueryVariables>;
export const ComponentsInvoiceDisputes_InvoiceDisputesDocument = gql`
    query ComponentsInvoiceDisputes_invoiceDisputes($participant: uuid!, $legalEntity: uuid!, $recipient: uuid!, $invoices: [uuid!]) {
  invoice_disputes: risolto_invoice_dispute(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legalEntity}, recipient: {_eq: $recipient}, invoice: {_in: $invoices}, resolved_at: {_is_null: true}}
    order_by: {until: asc}
  ) {
    participant
    legal_entity
    reference
    until
    dispute_code
    dispute_code_by_reference {
      reference
      code
      default_assignee
      default_days_to_suspend
    }
    tasks(where: {type: {_eq: "DISPUTE"}, status: {_eq: "OPEN"}}, limit: 1) {
      participant
      legal_entity
      reference
      due_date
      assignee
      assignee_by_reference {
        reference
        username
      }
      notes(limit: 1) {
        note
      }
    }
    invoice: invoice_by_reference {
      reference
      invoice_number
      open_amount
      total_amount
      amount_currency
      attachments
      custom_fields
      payment_reference
    }
  }
}
    `;

/**
 * __useComponentsInvoiceDisputes_InvoiceDisputesQuery__
 *
 * To run a query within a Vue component, call `useComponentsInvoiceDisputes_InvoiceDisputesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentsInvoiceDisputes_InvoiceDisputesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useComponentsInvoiceDisputes_InvoiceDisputesQuery({
 *   participant: // value for 'participant'
 *   legalEntity: // value for 'legalEntity'
 *   recipient: // value for 'recipient'
 *   invoices: // value for 'invoices'
 * });
 */
export function useComponentsInvoiceDisputes_InvoiceDisputesQuery(variables: ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables | VueCompositionApi.Ref<ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables> | ReactiveFunction<ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>(ComponentsInvoiceDisputes_InvoiceDisputesDocument, variables, options);
}
export function useComponentsInvoiceDisputes_InvoiceDisputesLazyQuery(variables: ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables | VueCompositionApi.Ref<ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables> | ReactiveFunction<ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>(ComponentsInvoiceDisputes_InvoiceDisputesDocument, variables, options);
}
export type ComponentsInvoiceDisputes_InvoiceDisputesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ComponentsInvoiceDisputes_InvoiceDisputesQuery, ComponentsInvoiceDisputes_InvoiceDisputesQueryVariables>;
export const CancelInvoiceDisputeDocument = gql`
    mutation cancelInvoiceDispute($participant: uuid!, $legal_entity: uuid, $references: [uuid!]!, $resolved_at: timestamptz!, $canceled_by: uuid!) {
  update_risolto_invoice_dispute(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, reference: {_in: $references}}
    _set: {resolved_at: $resolved_at}
  ) {
    affected_rows
    returning {
      __typename
      reference
      resolved_at
    }
  }
  update_risolto_task(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, invoice_dispute: {_in: $references}}
    _set: {status: "DONE", canceled_at: $resolved_at, canceled_by: $canceled_by}
  ) {
    affected_rows
    returning {
      __typename
      reference
      status
    }
  }
}
    `;

/**
 * __useCancelInvoiceDisputeMutation__
 *
 * To run a mutation, you first call `useCancelInvoiceDisputeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvoiceDisputeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelInvoiceDisputeMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     legal_entity: // value for 'legal_entity'
 *     references: // value for 'references'
 *     resolved_at: // value for 'resolved_at'
 *     canceled_by: // value for 'canceled_by'
 *   },
 * });
 */
export function useCancelInvoiceDisputeMutation(options: VueApolloComposable.UseMutationOptions<CancelInvoiceDisputeMutation, CancelInvoiceDisputeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelInvoiceDisputeMutation, CancelInvoiceDisputeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelInvoiceDisputeMutation, CancelInvoiceDisputeMutationVariables>(CancelInvoiceDisputeDocument, options);
}
export type CancelInvoiceDisputeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelInvoiceDisputeMutation, CancelInvoiceDisputeMutationVariables>;
export const AssignInvoiceDisputeDocument = gql`
    mutation assignInvoiceDispute($participant: uuid!, $legal_entity: uuid, $references: [uuid!]!, $assignee: uuid) {
  update_risolto_task(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, invoice_dispute: {_in: $references}}
    _set: {assignee: $assignee}
  ) {
    affected_rows
    returning {
      __typename
      reference
      status
    }
  }
}
    `;

/**
 * __useAssignInvoiceDisputeMutation__
 *
 * To run a mutation, you first call `useAssignInvoiceDisputeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignInvoiceDisputeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignInvoiceDisputeMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     legal_entity: // value for 'legal_entity'
 *     references: // value for 'references'
 *     assignee: // value for 'assignee'
 *   },
 * });
 */
export function useAssignInvoiceDisputeMutation(options: VueApolloComposable.UseMutationOptions<AssignInvoiceDisputeMutation, AssignInvoiceDisputeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AssignInvoiceDisputeMutation, AssignInvoiceDisputeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AssignInvoiceDisputeMutation, AssignInvoiceDisputeMutationVariables>(AssignInvoiceDisputeDocument, options);
}
export type AssignInvoiceDisputeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AssignInvoiceDisputeMutation, AssignInvoiceDisputeMutationVariables>;
export const ComponentsInvoiceDisputes_UserInterfaceDetailsDocument = gql`
    query ComponentsInvoiceDisputes_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "invoice.custom_field_definitions"
    )
  }
}
    `;

/**
 * __useComponentsInvoiceDisputes_UserInterfaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useComponentsInvoiceDisputes_UserInterfaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentsInvoiceDisputes_UserInterfaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useComponentsInvoiceDisputes_UserInterfaceDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useComponentsInvoiceDisputes_UserInterfaceDetailsQuery(variables: ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>(ComponentsInvoiceDisputes_UserInterfaceDetailsDocument, variables, options);
}
export function useComponentsInvoiceDisputes_UserInterfaceDetailsLazyQuery(variables: ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>(ComponentsInvoiceDisputes_UserInterfaceDetailsDocument, variables, options);
}
export type ComponentsInvoiceDisputes_UserInterfaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ComponentsInvoiceDisputes_UserInterfaceDetailsQuery, ComponentsInvoiceDisputes_UserInterfaceDetailsQueryVariables>;
export const DetailsDocument = gql`
    query details($participant: uuid!, $recipient: uuid!) {
  recipient: risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    legal_entity
    language_code
    preferred_invoicing_channel
    main_endpoints: channel_endpoints(
      where: {contact: {_is_null: true}, channel: {_neq: "SMS"}, deactivated_at: {_is_null: true}}
      order_by: [{channel: asc}]
    ) {
      reference
      channel
      endpoint
      endpoint_details
      deactivated_at
      origin
      locale
    }
  }
}
    `;

/**
 * __useDetailsQuery__
 *
 * To run a query within a Vue component, call `useDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDetailsQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 * });
 */
export function useDetailsQuery(variables: DetailsQueryVariables | VueCompositionApi.Ref<DetailsQueryVariables> | ReactiveFunction<DetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<DetailsQuery, DetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DetailsQuery, DetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DetailsQuery, DetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DetailsQuery, DetailsQueryVariables>(DetailsDocument, variables, options);
}
export function useDetailsLazyQuery(variables: DetailsQueryVariables | VueCompositionApi.Ref<DetailsQueryVariables> | ReactiveFunction<DetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<DetailsQuery, DetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DetailsQuery, DetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DetailsQuery, DetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DetailsQuery, DetailsQueryVariables>(DetailsDocument, variables, options);
}
export type DetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DetailsQuery, DetailsQueryVariables>;
export const Actions_Grouped_TotalDocument = gql`
    query actions_grouped_total($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isReference: Boolean!, $isAssignee: Boolean!, $statuses: _text, $executionTypes: _text, $participants: _uuid, $legalEntities: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  total: risolto_action_group_v12_aggregate(
    where: {}
    args: {search_term: $searchTerm, group_reference: $isReference, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, statuses: $statuses, execution_types: $executionTypes, participants: $participants, legal_entities: $legalEntities, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useActions_Grouped_TotalQuery__
 *
 * To run a query within a Vue component, call `useActions_Grouped_TotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useActions_Grouped_TotalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActions_Grouped_TotalQuery({
 *   searchTerm: // value for 'searchTerm'
 *   isDueDate: // value for 'isDueDate'
 *   isStartTime: // value for 'isStartTime'
 *   isChannel: // value for 'isChannel'
 *   isRecipient: // value for 'isRecipient'
 *   isMessageCode: // value for 'isMessageCode'
 *   isReference: // value for 'isReference'
 *   isAssignee: // value for 'isAssignee'
 *   statuses: // value for 'statuses'
 *   executionTypes: // value for 'executionTypes'
 *   participants: // value for 'participants'
 *   legalEntities: // value for 'legalEntities'
 *   startTimeFrom: // value for 'startTimeFrom'
 *   startTimeUntil: // value for 'startTimeUntil'
 * });
 */
export function useActions_Grouped_TotalQuery(variables: Actions_Grouped_TotalQueryVariables | VueCompositionApi.Ref<Actions_Grouped_TotalQueryVariables> | ReactiveFunction<Actions_Grouped_TotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables>(Actions_Grouped_TotalDocument, variables, options);
}
export function useActions_Grouped_TotalLazyQuery(variables: Actions_Grouped_TotalQueryVariables | VueCompositionApi.Ref<Actions_Grouped_TotalQueryVariables> | ReactiveFunction<Actions_Grouped_TotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables>(Actions_Grouped_TotalDocument, variables, options);
}
export type Actions_Grouped_TotalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Actions_Grouped_TotalQuery, Actions_Grouped_TotalQueryVariables>;
export const Actions_GroupedDocument = gql`
    query actions_grouped($searchTerm: String, $isDueDate: Boolean!, $isStartTime: Boolean!, $isChannel: Boolean!, $isRecipient: Boolean!, $isMessageCode: Boolean!, $isReference: Boolean!, $isAssignee: Boolean!, $limit: Int!, $offset: Int!, $orderBy: [risolto_virtual_action_group_order_by!], $statuses: _text, $executionTypes: _text, $participants: _uuid, $legalEntities: _uuid, $startTimeFrom: timestamp, $startTimeUntil: timestamp) {
  actions: risolto_action_group_v12(
    where: {}
    args: {search_term: $searchTerm, group_due_date: $isDueDate, group_start_time: $isStartTime, group_channel: $isChannel, group_recipient: $isRecipient, group_message_code: $isMessageCode, group_assignee: $isAssignee, group_reference: $isReference, statuses: $statuses, execution_types: $executionTypes, participants: $participants, legal_entities: $legalEntities, start_time_from: $startTimeFrom, start_time_until: $startTimeUntil}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    v_reference
    reference
    action_by_reference {
      is_retry
      source
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      status
      original_action
      retry_count
      participant
      metadata
      action_invoices(order_by: {invoice_by_reference: {issue_date: desc_nulls_last}}) {
        relation
        invoice
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      status
      reference
      execution_type
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        reference
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
        company_id
        company_id_type
      }
      message_code
      channel
      due_date
      start_time
      assignee
      assignee_by_reference {
        reference
        username
      }
      legal_entity
      legal_entity_by_reference {
        reference
        registration_name
        company_id
        company_id_type
      }
      custom_fields
    }
    action_count
    due_date
    due_date_count
    channel
    channel_count
    recipient
    recipient_by_reference {
      name
      reference
      type
      participant
      legal_id_type
      legal_id
      legal_entity
      account_id
      contacts {
        reference
        first_name
        last_name
      }
      invoice_documents_aggregate {
        aggregate {
          sum {
            open_amount
            total_amount
          }
        }
      }
    }
    recipient_count
    assignee_by_reference {
      username
    }
    start_time
    start_time_count
    assignee_count
    message_code
    is_retry
    message_code_count
  }
}
    `;

/**
 * __useActions_GroupedQuery__
 *
 * To run a query within a Vue component, call `useActions_GroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useActions_GroupedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActions_GroupedQuery({
 *   searchTerm: // value for 'searchTerm'
 *   isDueDate: // value for 'isDueDate'
 *   isStartTime: // value for 'isStartTime'
 *   isChannel: // value for 'isChannel'
 *   isRecipient: // value for 'isRecipient'
 *   isMessageCode: // value for 'isMessageCode'
 *   isReference: // value for 'isReference'
 *   isAssignee: // value for 'isAssignee'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   orderBy: // value for 'orderBy'
 *   statuses: // value for 'statuses'
 *   executionTypes: // value for 'executionTypes'
 *   participants: // value for 'participants'
 *   legalEntities: // value for 'legalEntities'
 *   startTimeFrom: // value for 'startTimeFrom'
 *   startTimeUntil: // value for 'startTimeUntil'
 * });
 */
export function useActions_GroupedQuery(variables: Actions_GroupedQueryVariables | VueCompositionApi.Ref<Actions_GroupedQueryVariables> | ReactiveFunction<Actions_GroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<Actions_GroupedQuery, Actions_GroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Actions_GroupedQuery, Actions_GroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Actions_GroupedQuery, Actions_GroupedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Actions_GroupedQuery, Actions_GroupedQueryVariables>(Actions_GroupedDocument, variables, options);
}
export function useActions_GroupedLazyQuery(variables: Actions_GroupedQueryVariables | VueCompositionApi.Ref<Actions_GroupedQueryVariables> | ReactiveFunction<Actions_GroupedQueryVariables>, options: VueApolloComposable.UseQueryOptions<Actions_GroupedQuery, Actions_GroupedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Actions_GroupedQuery, Actions_GroupedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Actions_GroupedQuery, Actions_GroupedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Actions_GroupedQuery, Actions_GroupedQueryVariables>(Actions_GroupedDocument, variables, options);
}
export type Actions_GroupedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Actions_GroupedQuery, Actions_GroupedQueryVariables>;
export const ComponentsDialogsAttachmentTemplatesDialog__TemplatesDocument = gql`
    query componentsDialogsAttachmentTemplatesDialog__templates($participant: uuid!) {
  templates: risolto_communication_template(
    where: {participant: {_eq: $participant}, ui_template_configuration: {_is_null: false}}
  ) {
    template_id
    channel
    document_name
    locale
    legal_entity
    participant
    subject_template
    template_query
    template_renderer_version
    ui_template_configuration
  }
}
    `;

/**
 * __useComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery__
 *
 * To run a query within a Vue component, call `useComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery(variables: ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables | VueCompositionApi.Ref<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables> | ReactiveFunction<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>(ComponentsDialogsAttachmentTemplatesDialog__TemplatesDocument, variables, options);
}
export function useComponentsDialogsAttachmentTemplatesDialog__TemplatesLazyQuery(variables: ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables | VueCompositionApi.Ref<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables> | ReactiveFunction<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>(ComponentsDialogsAttachmentTemplatesDialog__TemplatesDocument, variables, options);
}
export type ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ComponentsDialogsAttachmentTemplatesDialog__TemplatesQuery, ComponentsDialogsAttachmentTemplatesDialog__TemplatesQueryVariables>;
export const Document = gql`
    query ($participant: uuid!) {
  dispute_codes: risolto_dispute_code(
    distinct_on: [code]
    where: {_or: [{participant: {_eq: $participant}}, {participant: {_is_null: true}}]}
    order_by: [{code: asc}, {participant: desc_nulls_last}]
  ) {
    reference
    code
    default_assignee
    default_days_to_suspend
  }
}
    `;
export const ViewsCreditNotes_DetailDocument = gql`
    query viewsCreditNotes_detail($credit_note: uuid!) {
  creditNote: risolto_credit_note(where: {reference: {_eq: $credit_note}}) {
    credit_note_number
    amount_currency
    issue_date
    due_date
    reference
    file_references
    legal_entity
    legal_entity_by_reference {
      registration_name
      reference
      participant
      address
      company_id
      company_id_type
    }
    total_amount
    open_amount
    amount_currency
    participant
    interchange_links {
      reference
      interchange_by_reference {
        interchange_events {
          event_type
          event_type_count
          last_event_timestamp
          email: channel_endpoint(path: "$.email")
          postal_mail: channel_endpoint(path: "postal_mail")
        }
        reference
        channel
        direction
      }
    }
    recipient
    recipient_by_reference {
      preferred_invoicing_channel
      legal_entity
      legal_entity_by_reference {
        reference
      }
      participant
      reference
      legal_id
      legal_id_type
      address
      name
      account_id
    }
    dunning_status
    custom_fields
  }
}
    `;

/**
 * __useViewsCreditNotes_DetailQuery__
 *
 * To run a query within a Vue component, call `useViewsCreditNotes_DetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsCreditNotes_DetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsCreditNotes_DetailQuery({
 *   credit_note: // value for 'credit_note'
 * });
 */
export function useViewsCreditNotes_DetailQuery(variables: ViewsCreditNotes_DetailQueryVariables | VueCompositionApi.Ref<ViewsCreditNotes_DetailQueryVariables> | ReactiveFunction<ViewsCreditNotes_DetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables>(ViewsCreditNotes_DetailDocument, variables, options);
}
export function useViewsCreditNotes_DetailLazyQuery(variables: ViewsCreditNotes_DetailQueryVariables | VueCompositionApi.Ref<ViewsCreditNotes_DetailQueryVariables> | ReactiveFunction<ViewsCreditNotes_DetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables>(ViewsCreditNotes_DetailDocument, variables, options);
}
export type ViewsCreditNotes_DetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsCreditNotes_DetailQuery, ViewsCreditNotes_DetailQueryVariables>;
export const ViewsCreditNotes_UserInterfaceDetailsDocument = gql`
    query ViewsCreditNotes_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "credit_note.custom_field_definitions"
    )
  }
}
    `;

/**
 * __useViewsCreditNotes_UserInterfaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useViewsCreditNotes_UserInterfaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsCreditNotes_UserInterfaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsCreditNotes_UserInterfaceDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useViewsCreditNotes_UserInterfaceDetailsQuery(variables: ViewsCreditNotes_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsCreditNotes_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsCreditNotes_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables>(ViewsCreditNotes_UserInterfaceDetailsDocument, variables, options);
}
export function useViewsCreditNotes_UserInterfaceDetailsLazyQuery(variables: ViewsCreditNotes_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsCreditNotes_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsCreditNotes_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables>(ViewsCreditNotes_UserInterfaceDetailsDocument, variables, options);
}
export type ViewsCreditNotes_UserInterfaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsCreditNotes_UserInterfaceDetailsQuery, ViewsCreditNotes_UserInterfaceDetailsQueryVariables>;
export const ViewsDebitNotes_DetailDocument = gql`
    query viewsDebitNotes_detail($debit_note: uuid!) {
  debitNote: risolto_debit_note(where: {reference: {_eq: $debit_note}}) {
    debit_note_number
    amount_currency
    issue_date
    due_date
    reference
    file_references
    legal_entity
    legal_entity_by_reference {
      registration_name
      reference
      participant
      address
      company_id
      company_id_type
    }
    total_amount
    open_amount
    amount_currency
    participant
    interchange_links {
      reference
      interchange_by_reference {
        interchange_events {
          event_type
          event_type_count
          last_event_timestamp
          email: channel_endpoint(path: "$.email")
          postal_mail: channel_endpoint(path: "postal_mail")
        }
        reference
        channel
        direction
      }
    }
    recipient
    recipient_by_reference {
      preferred_invoicing_channel
      legal_entity
      legal_entity_by_reference {
        reference
      }
      participant
      reference
      legal_id
      legal_id_type
      address
      name
      account_id
    }
    dunning_status
    custom_fields
  }
}
    `;

/**
 * __useViewsDebitNotes_DetailQuery__
 *
 * To run a query within a Vue component, call `useViewsDebitNotes_DetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsDebitNotes_DetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsDebitNotes_DetailQuery({
 *   debit_note: // value for 'debit_note'
 * });
 */
export function useViewsDebitNotes_DetailQuery(variables: ViewsDebitNotes_DetailQueryVariables | VueCompositionApi.Ref<ViewsDebitNotes_DetailQueryVariables> | ReactiveFunction<ViewsDebitNotes_DetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables>(ViewsDebitNotes_DetailDocument, variables, options);
}
export function useViewsDebitNotes_DetailLazyQuery(variables: ViewsDebitNotes_DetailQueryVariables | VueCompositionApi.Ref<ViewsDebitNotes_DetailQueryVariables> | ReactiveFunction<ViewsDebitNotes_DetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables>(ViewsDebitNotes_DetailDocument, variables, options);
}
export type ViewsDebitNotes_DetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsDebitNotes_DetailQuery, ViewsDebitNotes_DetailQueryVariables>;
export const ViewsDebitNotes_UserInterfaceDetailsDocument = gql`
    query ViewsDebitNotes_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "debit_note.custom_field_definitions"
    )
  }
}
    `;

/**
 * __useViewsDebitNotes_UserInterfaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useViewsDebitNotes_UserInterfaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsDebitNotes_UserInterfaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsDebitNotes_UserInterfaceDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useViewsDebitNotes_UserInterfaceDetailsQuery(variables: ViewsDebitNotes_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsDebitNotes_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsDebitNotes_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables>(ViewsDebitNotes_UserInterfaceDetailsDocument, variables, options);
}
export function useViewsDebitNotes_UserInterfaceDetailsLazyQuery(variables: ViewsDebitNotes_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsDebitNotes_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsDebitNotes_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables>(ViewsDebitNotes_UserInterfaceDetailsDocument, variables, options);
}
export type ViewsDebitNotes_UserInterfaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsDebitNotes_UserInterfaceDetailsQuery, ViewsDebitNotes_UserInterfaceDetailsQueryVariables>;
export const ViewsDialogsActionDetail__LanguagesDocument = gql`
    query viewsDialogsActionDetail__languages($participant: uuid!, $legalEntity: uuid!, $channel: risolto_channel_enum!, $templateId: String!) {
  custom: risolto_communication_template(
    where: {template_id: {_eq: $templateId}, channel: {_eq: $channel}, participant: {_eq: $participant}, legal_entity: {_eq: $legalEntity}}
  ) {
    template_id
    participant
    locale
  }
  generic: risolto_communication_template(
    where: {template_id: {_eq: $templateId}, channel: {_eq: $channel}, participant: {_is_null: true}}
  ) {
    template_id
    participant
    locale
  }
}
    `;

/**
 * __useViewsDialogsActionDetail__LanguagesQuery__
 *
 * To run a query within a Vue component, call `useViewsDialogsActionDetail__LanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsDialogsActionDetail__LanguagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsDialogsActionDetail__LanguagesQuery({
 *   participant: // value for 'participant'
 *   legalEntity: // value for 'legalEntity'
 *   channel: // value for 'channel'
 *   templateId: // value for 'templateId'
 * });
 */
export function useViewsDialogsActionDetail__LanguagesQuery(variables: ViewsDialogsActionDetail__LanguagesQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail__LanguagesQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail__LanguagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables>(ViewsDialogsActionDetail__LanguagesDocument, variables, options);
}
export function useViewsDialogsActionDetail__LanguagesLazyQuery(variables: ViewsDialogsActionDetail__LanguagesQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail__LanguagesQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail__LanguagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables>(ViewsDialogsActionDetail__LanguagesDocument, variables, options);
}
export type ViewsDialogsActionDetail__LanguagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsDialogsActionDetail__LanguagesQuery, ViewsDialogsActionDetail__LanguagesQueryVariables>;
export const TemplatesDocument = gql`
    query templates($participant: uuid!, $channel: risolto_channel_enum!) {
  risolto_communication_template(
    distinct_on: template_id
    where: {channel: {_eq: $channel}, _and: {_or: [{participant: {_eq: $participant}}, {participant: {_is_null: true}}]}}
  ) {
    template_id
  }
}
    `;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a Vue component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTemplatesQuery({
 *   participant: // value for 'participant'
 *   channel: // value for 'channel'
 * });
 */
export function useTemplatesQuery(variables: TemplatesQueryVariables | VueCompositionApi.Ref<TemplatesQueryVariables> | ReactiveFunction<TemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<TemplatesQuery, TemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TemplatesQuery, TemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TemplatesQuery, TemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, variables, options);
}
export function useTemplatesLazyQuery(variables: TemplatesQueryVariables | VueCompositionApi.Ref<TemplatesQueryVariables> | ReactiveFunction<TemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<TemplatesQuery, TemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TemplatesQuery, TemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TemplatesQuery, TemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, variables, options);
}
export type TemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TemplatesQuery, TemplatesQueryVariables>;
export const ViewsDialogsActionDetail_UserInterfaceDetailsDocument = gql`
    query ViewsDialogsActionDetail_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "action.custom_field_definitions"
    )
    disallowed_channels: user_interface_details(path: "action.disallowed_channels")
    disallowed_message_codes: user_interface_details(
      path: "action.disallowed_message_codes"
    )
  }
}
    `;

/**
 * __useViewsDialogsActionDetail_UserInterfaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useViewsDialogsActionDetail_UserInterfaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsDialogsActionDetail_UserInterfaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsDialogsActionDetail_UserInterfaceDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useViewsDialogsActionDetail_UserInterfaceDetailsQuery(variables: ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>(ViewsDialogsActionDetail_UserInterfaceDetailsDocument, variables, options);
}
export function useViewsDialogsActionDetail_UserInterfaceDetailsLazyQuery(variables: ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>(ViewsDialogsActionDetail_UserInterfaceDetailsDocument, variables, options);
}
export type ViewsDialogsActionDetail_UserInterfaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsDialogsActionDetail_UserInterfaceDetailsQuery, ViewsDialogsActionDetail_UserInterfaceDetailsQueryVariables>;
export const ViewsDialogsActionDetail_RecipientRecordDocument = gql`
    query ViewsDialogsActionDetail_recipientRecord($participant: uuid!, $recipient: uuid!, $today: date!) {
  risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    reference
    name
    last_dunning_costs
    legal_entity: legal_entity_by_reference {
      reference
    }
    payment_plans {
      invoice_group_by_reference {
        invoice_group_invoices {
          invoice
        }
        invoice_group_credit_notes {
          credit_note
        }
        invoice_group_debit_notes {
          debit_note
        }
        invoice_group_payments {
          payment
        }
      }
    }
    invoice_documents {
      reference
      invoice_number
      open_amount
      due_date
      file_references
      invoice_dispute: disputes(
        where: {until: {_gte: $today}, resolved_at: {_is_null: true}}
        order_by: {until: desc}
        limit: 1
      ) {
        reference
        until
        dispute_code_by_reference {
          code
        }
      }
    }
    credit_notes {
      reference
      credit_note_number
      issue_date
      open_amount
      file_references
    }
    debit_notes {
      reference
      debit_note_number
      issue_date
      open_amount
    }
    payment_documents {
      reference
      payment_number
      issue_date
      open_amount
    }
  }
}
    `;

/**
 * __useViewsDialogsActionDetail_RecipientRecordQuery__
 *
 * To run a query within a Vue component, call `useViewsDialogsActionDetail_RecipientRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsDialogsActionDetail_RecipientRecordQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsDialogsActionDetail_RecipientRecordQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 *   today: // value for 'today'
 * });
 */
export function useViewsDialogsActionDetail_RecipientRecordQuery(variables: ViewsDialogsActionDetail_RecipientRecordQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail_RecipientRecordQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail_RecipientRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables>(ViewsDialogsActionDetail_RecipientRecordDocument, variables, options);
}
export function useViewsDialogsActionDetail_RecipientRecordLazyQuery(variables: ViewsDialogsActionDetail_RecipientRecordQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail_RecipientRecordQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail_RecipientRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables>(ViewsDialogsActionDetail_RecipientRecordDocument, variables, options);
}
export type ViewsDialogsActionDetail_RecipientRecordQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsDialogsActionDetail_RecipientRecordQuery, ViewsDialogsActionDetail_RecipientRecordQueryVariables>;
export const ViewsDialogsActionDetail_DunningNoticeDocument = gql`
    query ViewsDialogsActionDetail_dunningNotice($participant: uuid!, $action: uuid!) {
  risolto_action(
    where: {reference: {_eq: $action}, participant: {_eq: $participant}}
  ) {
    reference
    metadata
    dunning_notice_by_reference {
      charges
      interest
      invoice_group_by_reference {
        invoice_group_credit_notes {
          credit_note
        }
        invoice_group_debit_notes {
          debit_note
        }
        invoice_group_invoices {
          invoice
        }
        invoice_group_payments {
          payment
        }
      }
    }
  }
}
    `;

/**
 * __useViewsDialogsActionDetail_DunningNoticeQuery__
 *
 * To run a query within a Vue component, call `useViewsDialogsActionDetail_DunningNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsDialogsActionDetail_DunningNoticeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsDialogsActionDetail_DunningNoticeQuery({
 *   participant: // value for 'participant'
 *   action: // value for 'action'
 * });
 */
export function useViewsDialogsActionDetail_DunningNoticeQuery(variables: ViewsDialogsActionDetail_DunningNoticeQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail_DunningNoticeQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail_DunningNoticeQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables>(ViewsDialogsActionDetail_DunningNoticeDocument, variables, options);
}
export function useViewsDialogsActionDetail_DunningNoticeLazyQuery(variables: ViewsDialogsActionDetail_DunningNoticeQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail_DunningNoticeQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail_DunningNoticeQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables>(ViewsDialogsActionDetail_DunningNoticeDocument, variables, options);
}
export type ViewsDialogsActionDetail_DunningNoticeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsDialogsActionDetail_DunningNoticeQuery, ViewsDialogsActionDetail_DunningNoticeQueryVariables>;
export const ViewsDialogsActionDetail_EmailAddressFromDocument = gql`
    query ViewsDialogsActionDetail_emailAddressFrom($participant: uuid!, $action: uuid!) {
  risolto_action(
    where: {participant: {_eq: $participant}, reference: {_eq: $action}}
  ) {
    legal_entity_by_reference {
      outbound_channel_communication_email_addresses: processing_details(
        path: "outbound_channel.communication.email_addresses"
      )
    }
    channel_from: metadata(path: "channels[0]._from")
  }
}
    `;

/**
 * __useViewsDialogsActionDetail_EmailAddressFromQuery__
 *
 * To run a query within a Vue component, call `useViewsDialogsActionDetail_EmailAddressFromQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsDialogsActionDetail_EmailAddressFromQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsDialogsActionDetail_EmailAddressFromQuery({
 *   participant: // value for 'participant'
 *   action: // value for 'action'
 * });
 */
export function useViewsDialogsActionDetail_EmailAddressFromQuery(variables: ViewsDialogsActionDetail_EmailAddressFromQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail_EmailAddressFromQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail_EmailAddressFromQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables>(ViewsDialogsActionDetail_EmailAddressFromDocument, variables, options);
}
export function useViewsDialogsActionDetail_EmailAddressFromLazyQuery(variables: ViewsDialogsActionDetail_EmailAddressFromQueryVariables | VueCompositionApi.Ref<ViewsDialogsActionDetail_EmailAddressFromQueryVariables> | ReactiveFunction<ViewsDialogsActionDetail_EmailAddressFromQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables>(ViewsDialogsActionDetail_EmailAddressFromDocument, variables, options);
}
export type ViewsDialogsActionDetail_EmailAddressFromQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsDialogsActionDetail_EmailAddressFromQuery, ViewsDialogsActionDetail_EmailAddressFromQueryVariables>;
export const ViewsInvoiceDisputes_DisputeCodesDocument = gql`
    query ViewsInvoiceDisputes_disputeCodes($participant: uuid!) {
  disputeCodes: risolto_dispute_code(
    distinct_on: [code]
    where: {_and: [{_or: [{participant: {_eq: $participant}}, {participant: {_is_null: true}}]}]}
    order_by: [{code: asc}, {participant: desc_nulls_last}]
  ) {
    reference
    code
    default_assignee
    default_days_to_suspend
  }
}
    `;

/**
 * __useViewsInvoiceDisputes_DisputeCodesQuery__
 *
 * To run a query within a Vue component, call `useViewsInvoiceDisputes_DisputeCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsInvoiceDisputes_DisputeCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsInvoiceDisputes_DisputeCodesQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useViewsInvoiceDisputes_DisputeCodesQuery(variables: ViewsInvoiceDisputes_DisputeCodesQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputes_DisputeCodesQueryVariables> | ReactiveFunction<ViewsInvoiceDisputes_DisputeCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables>(ViewsInvoiceDisputes_DisputeCodesDocument, variables, options);
}
export function useViewsInvoiceDisputes_DisputeCodesLazyQuery(variables: ViewsInvoiceDisputes_DisputeCodesQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputes_DisputeCodesQueryVariables> | ReactiveFunction<ViewsInvoiceDisputes_DisputeCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables>(ViewsInvoiceDisputes_DisputeCodesDocument, variables, options);
}
export type ViewsInvoiceDisputes_DisputeCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsInvoiceDisputes_DisputeCodesQuery, ViewsInvoiceDisputes_DisputeCodesQueryVariables>;
export const ViewsInvoiceDisputes_AssignInvoiceDisputeDocument = gql`
    mutation ViewsInvoiceDisputes_assignInvoiceDispute($participant: uuid!, $legal_entity: uuid, $references: [uuid!]!, $assignee: uuid) {
  update_risolto_task(
    where: {participant: {_eq: $participant}, invoice_dispute: {_in: $references}}
    _set: {assignee: $assignee}
  ) {
    affected_rows
    returning {
      __typename
      reference
      status
    }
  }
}
    `;

/**
 * __useViewsInvoiceDisputes_AssignInvoiceDisputeMutation__
 *
 * To run a mutation, you first call `useViewsInvoiceDisputes_AssignInvoiceDisputeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useViewsInvoiceDisputes_AssignInvoiceDisputeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useViewsInvoiceDisputes_AssignInvoiceDisputeMutation({
 *   variables: {
 *     participant: // value for 'participant'
 *     legal_entity: // value for 'legal_entity'
 *     references: // value for 'references'
 *     assignee: // value for 'assignee'
 *   },
 * });
 */
export function useViewsInvoiceDisputes_AssignInvoiceDisputeMutation(options: VueApolloComposable.UseMutationOptions<ViewsInvoiceDisputes_AssignInvoiceDisputeMutation, ViewsInvoiceDisputes_AssignInvoiceDisputeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ViewsInvoiceDisputes_AssignInvoiceDisputeMutation, ViewsInvoiceDisputes_AssignInvoiceDisputeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ViewsInvoiceDisputes_AssignInvoiceDisputeMutation, ViewsInvoiceDisputes_AssignInvoiceDisputeMutationVariables>(ViewsInvoiceDisputes_AssignInvoiceDisputeDocument, options);
}
export type ViewsInvoiceDisputes_AssignInvoiceDisputeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ViewsInvoiceDisputes_AssignInvoiceDisputeMutation, ViewsInvoiceDisputes_AssignInvoiceDisputeMutationVariables>;
export const ViewsInvoiceDisputesRecipient_RecipientRecordDocument = gql`
    query ViewsInvoiceDisputesRecipient_recipientRecord($recipient: uuid!) {
  recipientRecord: risolto_recipient_by_pk(reference: $recipient) {
    reference
    name
    legal_entity
    custom_fields
  }
}
    `;

/**
 * __useViewsInvoiceDisputesRecipient_RecipientRecordQuery__
 *
 * To run a query within a Vue component, call `useViewsInvoiceDisputesRecipient_RecipientRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsInvoiceDisputesRecipient_RecipientRecordQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsInvoiceDisputesRecipient_RecipientRecordQuery({
 *   recipient: // value for 'recipient'
 * });
 */
export function useViewsInvoiceDisputesRecipient_RecipientRecordQuery(variables: ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables> | ReactiveFunction<ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>(ViewsInvoiceDisputesRecipient_RecipientRecordDocument, variables, options);
}
export function useViewsInvoiceDisputesRecipient_RecipientRecordLazyQuery(variables: ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables> | ReactiveFunction<ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>(ViewsInvoiceDisputesRecipient_RecipientRecordDocument, variables, options);
}
export type ViewsInvoiceDisputesRecipient_RecipientRecordQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsInvoiceDisputesRecipient_RecipientRecordQuery, ViewsInvoiceDisputesRecipient_RecipientRecordQueryVariables>;
export const ViewsInvoiceDisputesRecipient_RecipientAttachmentsDocument = gql`
    query ViewsInvoiceDisputesRecipient_recipientAttachments($recipient: uuid!) {
  recipientAttachments: risolto_recipient_attachment(
    where: {recipient: {_eq: $recipient}}
  ) {
    metadata
  }
}
    `;

/**
 * __useViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery__
 *
 * To run a query within a Vue component, call `useViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery({
 *   recipient: // value for 'recipient'
 * });
 */
export function useViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery(variables: ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables> | ReactiveFunction<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>(ViewsInvoiceDisputesRecipient_RecipientAttachmentsDocument, variables, options);
}
export function useViewsInvoiceDisputesRecipient_RecipientAttachmentsLazyQuery(variables: ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables> | ReactiveFunction<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>(ViewsInvoiceDisputesRecipient_RecipientAttachmentsDocument, variables, options);
}
export type ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsInvoiceDisputesRecipient_RecipientAttachmentsQuery, ViewsInvoiceDisputesRecipient_RecipientAttachmentsQueryVariables>;
export const ViewsInvoiceDisputes_TasksDocument = gql`
    query ViewsInvoiceDisputes_tasks($where: risolto_task_bool_exp!) {
  tasks: risolto_task(where: $where, order_by: {due_date: asc, created_at: asc}) {
    reference
    assignee_by_reference {
      username
    }
    due_date
    status
    invoice_dispute_by_reference {
      reference
      dispute_code_by_reference {
        code
      }
      invoice: invoice_by_reference {
        reference
        invoice_number
        issue_date
        due_date
        open_amount
        amount_currency
      }
      recipient: recipient_by_reference {
        reference
		account_id
        legal_entity
        name
        currency
      }
      from
      until
      resolved_at
    }
  }
}
    `;

/**
 * __useViewsInvoiceDisputes_TasksQuery__
 *
 * To run a query within a Vue component, call `useViewsInvoiceDisputes_TasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsInvoiceDisputes_TasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsInvoiceDisputes_TasksQuery({
 *   where: // value for 'where'
 * });
 */
export function useViewsInvoiceDisputes_TasksQuery(variables: ViewsInvoiceDisputes_TasksQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputes_TasksQueryVariables> | ReactiveFunction<ViewsInvoiceDisputes_TasksQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables>(ViewsInvoiceDisputes_TasksDocument, variables, options);
}
export function useViewsInvoiceDisputes_TasksLazyQuery(variables: ViewsInvoiceDisputes_TasksQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputes_TasksQueryVariables> | ReactiveFunction<ViewsInvoiceDisputes_TasksQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables>(ViewsInvoiceDisputes_TasksDocument, variables, options);
}
export type ViewsInvoiceDisputes_TasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsInvoiceDisputes_TasksQuery, ViewsInvoiceDisputes_TasksQueryVariables>;
export const ViewsInvoiceDisputes_UserInterfaceDetailsDocument = gql`
    query ViewsInvoiceDisputes_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    contact_allow_edit: user_interface_details(path: "contact.allow_edit")
    recipient_allow_edit: user_interface_details(path: "recipient.allow_edit")
    custom_field_definitions: user_interface_details(
      path: "recipient.custom_field_definitions"
    )
    credit_note_custom_field_definitions: user_interface_details(
      path: "credit_note.custom_field_definitions"
    )
    debit_note_custom_field_definitions: user_interface_details(
      path: "debit_note.custom_field_definitions"
    )
    payment_document_custom_field_definitions: user_interface_details(
      path: "payment_document.custom_field_definitions"
    )
  }
}
    `;

/**
 * __useViewsInvoiceDisputes_UserInterfaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useViewsInvoiceDisputes_UserInterfaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsInvoiceDisputes_UserInterfaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsInvoiceDisputes_UserInterfaceDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useViewsInvoiceDisputes_UserInterfaceDetailsQuery(variables: ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>(ViewsInvoiceDisputes_UserInterfaceDetailsDocument, variables, options);
}
export function useViewsInvoiceDisputes_UserInterfaceDetailsLazyQuery(variables: ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>(ViewsInvoiceDisputes_UserInterfaceDetailsDocument, variables, options);
}
export type ViewsInvoiceDisputes_UserInterfaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsInvoiceDisputes_UserInterfaceDetailsQuery, ViewsInvoiceDisputes_UserInterfaceDetailsQueryVariables>;
export const ViewsInvoices_UserInterfaceDetailsDocument = gql`
    query ViewsInvoices_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "invoice.custom_field_definitions"
    )
  }
}
    `;

/**
 * __useViewsInvoices_UserInterfaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useViewsInvoices_UserInterfaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsInvoices_UserInterfaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsInvoices_UserInterfaceDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useViewsInvoices_UserInterfaceDetailsQuery(variables: ViewsInvoices_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsInvoices_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsInvoices_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables>(ViewsInvoices_UserInterfaceDetailsDocument, variables, options);
}
export function useViewsInvoices_UserInterfaceDetailsLazyQuery(variables: ViewsInvoices_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsInvoices_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsInvoices_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables>(ViewsInvoices_UserInterfaceDetailsDocument, variables, options);
}
export type ViewsInvoices_UserInterfaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsInvoices_UserInterfaceDetailsQuery, ViewsInvoices_UserInterfaceDetailsQueryVariables>;
export const ComponentsMessagesTable_MessagesTotalDocument = gql`
    query ComponentsMessagesTable_messagesTotal($participant: uuid!, $legalEntity: uuid, $recipient: uuid, $assignees: _uuid, $dateStart: timestamptz, $dateEnd: timestamptz, $archivedIsNull: Boolean, $direction: String, $isLinked: Boolean, $searchTerm: String) {
  total: risolto_mailbox_actions_and_messages_aggregate(
    args: {p_participant: $participant, p_legal_entity: $legalEntity, p_recipient: $recipient, p_assignees: $assignees, p_date_start: $dateStart, p_date_end: $dateEnd, p_archived_is_null: $archivedIsNull, p_direction: $direction, p_is_linked: $isLinked, p_search_term: $searchTerm, p_limit: 999999999}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useComponentsMessagesTable_MessagesTotalQuery__
 *
 * To run a query within a Vue component, call `useComponentsMessagesTable_MessagesTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentsMessagesTable_MessagesTotalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useComponentsMessagesTable_MessagesTotalQuery({
 *   participant: // value for 'participant'
 *   legalEntity: // value for 'legalEntity'
 *   recipient: // value for 'recipient'
 *   assignees: // value for 'assignees'
 *   dateStart: // value for 'dateStart'
 *   dateEnd: // value for 'dateEnd'
 *   archivedIsNull: // value for 'archivedIsNull'
 *   direction: // value for 'direction'
 *   isLinked: // value for 'isLinked'
 *   searchTerm: // value for 'searchTerm'
 * });
 */
export function useComponentsMessagesTable_MessagesTotalQuery(variables: ComponentsMessagesTable_MessagesTotalQueryVariables | VueCompositionApi.Ref<ComponentsMessagesTable_MessagesTotalQueryVariables> | ReactiveFunction<ComponentsMessagesTable_MessagesTotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables>(ComponentsMessagesTable_MessagesTotalDocument, variables, options);
}
export function useComponentsMessagesTable_MessagesTotalLazyQuery(variables: ComponentsMessagesTable_MessagesTotalQueryVariables | VueCompositionApi.Ref<ComponentsMessagesTable_MessagesTotalQueryVariables> | ReactiveFunction<ComponentsMessagesTable_MessagesTotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables>(ComponentsMessagesTable_MessagesTotalDocument, variables, options);
}
export type ComponentsMessagesTable_MessagesTotalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ComponentsMessagesTable_MessagesTotalQuery, ComponentsMessagesTable_MessagesTotalQueryVariables>;
export const ComponentsMessagesTable_MessagesDocument = gql`
    query ComponentsMessagesTable_messages($participant: uuid!, $limit: Int = 10, $offset: Int = 0, $legalEntity: uuid, $recipient: uuid, $assignees: _uuid, $dateStart: timestamptz, $dateEnd: timestamptz, $archivedIsNull: Boolean, $direction: String, $isLinked: Boolean, $searchTerm: String, $orderBy: [risolto_view_action_and_message_order_by!]) {
  messages: risolto_mailbox_actions_and_messages(
    args: {p_participant: $participant, p_legal_entity: $legalEntity, p_recipient: $recipient, p_assignees: $assignees, p_date_start: $dateStart, p_date_end: $dateEnd, p_archived_is_null: $archivedIsNull, p_direction: $direction, p_is_linked: $isLinked, p_search_term: $searchTerm, p_limit: $limit, p_offset: $offset}
    order_by: $orderBy
  ) {
    reference
    message
    action
    from_
    subject
    direction
    received_at
    archived_at
    metadata
    is_linked
    action_by_reference {
      reference
      status
      channel
      message_code
      is_retry
      execution_type
      source
      retry_count
      original_action
      start_time
      created_at
      executed_at
      canceled_at
      updated_at
      due_date
      metadata
      assignee
      assignee_by_reference {
        reference
        username
      }
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        legal_id
        legal_id_type
        name
        type
      }
      participant
      primary_invoice
      primary_invoice_by_reference {
        invoice_number
      }
      recipient
      legal_entity
      legal_entity_by_reference {
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
      }
      custom_fields
      action_interchanges(order_by: {created_at: desc}) {
        interchange_by_reference {
          interchange_events(order_by: {last_event_timestamp: desc}) {
            event_type
            last_event_timestamp
          }
        }
      }
    }
    message_by_reference {
      message_recipients {
        recipient_by_reference {
          reference
          account_id
          name
        }
      }
      message_assignees {
        person_by_reference {
          reference
          username
        }
      }
      message_attachments {
        reference
      }
    }
  }
}
    `;

/**
 * __useComponentsMessagesTable_MessagesQuery__
 *
 * To run a query within a Vue component, call `useComponentsMessagesTable_MessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComponentsMessagesTable_MessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useComponentsMessagesTable_MessagesQuery({
 *   participant: // value for 'participant'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   legalEntity: // value for 'legalEntity'
 *   recipient: // value for 'recipient'
 *   assignees: // value for 'assignees'
 *   dateStart: // value for 'dateStart'
 *   dateEnd: // value for 'dateEnd'
 *   archivedIsNull: // value for 'archivedIsNull'
 *   direction: // value for 'direction'
 *   isLinked: // value for 'isLinked'
 *   searchTerm: // value for 'searchTerm'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useComponentsMessagesTable_MessagesQuery(variables: ComponentsMessagesTable_MessagesQueryVariables | VueCompositionApi.Ref<ComponentsMessagesTable_MessagesQueryVariables> | ReactiveFunction<ComponentsMessagesTable_MessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables>(ComponentsMessagesTable_MessagesDocument, variables, options);
}
export function useComponentsMessagesTable_MessagesLazyQuery(variables: ComponentsMessagesTable_MessagesQueryVariables | VueCompositionApi.Ref<ComponentsMessagesTable_MessagesQueryVariables> | ReactiveFunction<ComponentsMessagesTable_MessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables>(ComponentsMessagesTable_MessagesDocument, variables, options);
}
export type ComponentsMessagesTable_MessagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ComponentsMessagesTable_MessagesQuery, ComponentsMessagesTable_MessagesQueryVariables>;
export const Risolto_Participant_AggregateDocument = gql`
    query risolto_participant_aggregate {
  risolto_participant_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useRisolto_Participant_AggregateQuery__
 *
 * To run a query within a Vue component, call `useRisolto_Participant_AggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRisolto_Participant_AggregateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRisolto_Participant_AggregateQuery();
 */
export function useRisolto_Participant_AggregateQuery(options: VueApolloComposable.UseQueryOptions<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables>(Risolto_Participant_AggregateDocument, {}, options);
}
export function useRisolto_Participant_AggregateLazyQuery(options: VueApolloComposable.UseQueryOptions<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables>(Risolto_Participant_AggregateDocument, {}, options);
}
export type Risolto_Participant_AggregateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Risolto_Participant_AggregateQuery, Risolto_Participant_AggregateQueryVariables>;
export const ViewPaymentPlanCreate_RecipientRecordDocument = gql`
    query ViewPaymentPlanCreate_recipientRecord($participant: uuid!, $recipient: uuid!) {
  risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    reference
    name
    currency
    legal_entity_by_reference {
      reference
      payment_plan_conditions: processing_details(path: "payment_plan.conditions")
    }
    invoice_documents(where: {open_amount: {_gt: 0.00}}) {
      reference
      invoice_number
      open_amount
      due_date
      amount_currency
    }
    credit_notes(where: {open_amount: {_gt: 0.00}}) {
      reference
      credit_note_number
      issue_date
      open_amount
      amount_currency
    }
    debit_notes(where: {open_amount: {_gt: 0.00}}) {
      reference
      debit_note_number
      issue_date
      open_amount
      amount_currency
    }
    payment_documents(where: {open_amount: {_gt: 0.00}}) {
      reference
      payment_number
      issue_date
      open_amount
      amount_currency
    }
  }
}
    `;

/**
 * __useViewPaymentPlanCreate_RecipientRecordQuery__
 *
 * To run a query within a Vue component, call `useViewPaymentPlanCreate_RecipientRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewPaymentPlanCreate_RecipientRecordQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewPaymentPlanCreate_RecipientRecordQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 * });
 */
export function useViewPaymentPlanCreate_RecipientRecordQuery(variables: ViewPaymentPlanCreate_RecipientRecordQueryVariables | VueCompositionApi.Ref<ViewPaymentPlanCreate_RecipientRecordQueryVariables> | ReactiveFunction<ViewPaymentPlanCreate_RecipientRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables>(ViewPaymentPlanCreate_RecipientRecordDocument, variables, options);
}
export function useViewPaymentPlanCreate_RecipientRecordLazyQuery(variables: ViewPaymentPlanCreate_RecipientRecordQueryVariables | VueCompositionApi.Ref<ViewPaymentPlanCreate_RecipientRecordQueryVariables> | ReactiveFunction<ViewPaymentPlanCreate_RecipientRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables>(ViewPaymentPlanCreate_RecipientRecordDocument, variables, options);
}
export type ViewPaymentPlanCreate_RecipientRecordQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewPaymentPlanCreate_RecipientRecordQuery, ViewPaymentPlanCreate_RecipientRecordQueryVariables>;
export const ViewPaymentPlanEdit_PaymentPlanRecordDocument = gql`
    query ViewPaymentPlanEdit_paymentPlanRecord($participant: uuid!, $paymentPlan: uuid!) {
  risolto_payment_plan(
    where: {reference: {_eq: $paymentPlan}, participant: {_eq: $participant}}
  ) {
    reference
    total_amount
    open_amount
    due_amount
    amount_currency
    conditions
    status
    canceled_at
    legal_entity
    recipient
    recipient_by_reference {
      name
      currency
    }
    payment_promises(order_by: {due_date: asc}) {
      reference
      payment_reference
      due_date
      total_amount
      open_amount
      amount_currency
    }
    invoice_group_by_reference {
      invoice_group_invoices {
        invoice_by_reference {
          reference
          invoice_number
          due_date
          open_amount
          amount_currency
        }
      }
      invoice_group_credit_notes {
        credit_note_by_reference {
          reference
          credit_note_number
          issue_date
          open_amount
          amount_currency
        }
      }
      invoice_group_debit_notes {
        debit_note_by_reference {
          reference
          debit_note_number
          issue_date
          open_amount
          amount_currency
        }
      }
      invoice_group_payments {
        payment_by_reference {
          reference
          payment_number
          issue_date
          open_amount
          amount_currency
        }
      }
    }
  }
}
    `;

/**
 * __useViewPaymentPlanEdit_PaymentPlanRecordQuery__
 *
 * To run a query within a Vue component, call `useViewPaymentPlanEdit_PaymentPlanRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewPaymentPlanEdit_PaymentPlanRecordQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewPaymentPlanEdit_PaymentPlanRecordQuery({
 *   participant: // value for 'participant'
 *   paymentPlan: // value for 'paymentPlan'
 * });
 */
export function useViewPaymentPlanEdit_PaymentPlanRecordQuery(variables: ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables | VueCompositionApi.Ref<ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables> | ReactiveFunction<ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>(ViewPaymentPlanEdit_PaymentPlanRecordDocument, variables, options);
}
export function useViewPaymentPlanEdit_PaymentPlanRecordLazyQuery(variables: ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables | VueCompositionApi.Ref<ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables> | ReactiveFunction<ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>(ViewPaymentPlanEdit_PaymentPlanRecordDocument, variables, options);
}
export type ViewPaymentPlanEdit_PaymentPlanRecordQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewPaymentPlanEdit_PaymentPlanRecordQuery, ViewPaymentPlanEdit_PaymentPlanRecordQueryVariables>;
export const ViewsPaymentTransfer_GetPaymentTransferBulkPaymentDocument = gql`
    query ViewsPaymentTransfer_GetPaymentTransferBulkPayment($payment_transfer: uuid!, $participant: uuid!) {
  records: risolto_payment_transfer_bulk_payment(
    where: {payment_transfer: {_eq: $payment_transfer}, participant: {_eq: $participant}}
  ) {
    external_account_id
    external_status
    external_system
    idempotency_key
    short_description
    signing_link
    created_at
    error_at
    finished_at
    last_updated
    updated_at
    external_bulk_payment_id
    legal_entity
    participant
    payment_transfer
    reference
  }
}
    `;

/**
 * __useViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery__
 *
 * To run a query within a Vue component, call `useViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery({
 *   payment_transfer: // value for 'payment_transfer'
 *   participant: // value for 'participant'
 * });
 */
export function useViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery(variables: ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables | VueCompositionApi.Ref<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables> | ReactiveFunction<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>(ViewsPaymentTransfer_GetPaymentTransferBulkPaymentDocument, variables, options);
}
export function useViewsPaymentTransfer_GetPaymentTransferBulkPaymentLazyQuery(variables: ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables | VueCompositionApi.Ref<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables> | ReactiveFunction<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>(ViewsPaymentTransfer_GetPaymentTransferBulkPaymentDocument, variables, options);
}
export type ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQuery, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables>;
export const ViewsBulkPayments_GetBulkPaymentsDocument = gql`
    query ViewsBulkPayments_GetBulkPayments($participant: uuid!, $legal_entity: uuid!) {
  created: risolto_payment_transfer(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}, status: {_eq: CREATED}}
    order_by: {created_at: desc}
  ) {
    reference
    group_date
    total_amount: payment_transfer_lines_aggregate {
      aggregate {
        sum {
          amount
        }
        count
      }
    }
  }
  executed: risolto_payment_transfer_bulk_payment(
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}}
    order_by: {created_at: desc}
  ) {
    short_description
    signing_link
    created_at
    error_at
    finished_at
    last_updated
    updated_at
    legal_entity
    participant
    payment_transfer
    reference
    details: payment_transfer_by_reference {
      total_amount: payment_transfer_lines_aggregate {
        aggregate {
          sum {
            amount
          }
          count
        }
      }
    }
  }
}
    `;

/**
 * __useViewsBulkPayments_GetBulkPaymentsQuery__
 *
 * To run a query within a Vue component, call `useViewsBulkPayments_GetBulkPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsBulkPayments_GetBulkPaymentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsBulkPayments_GetBulkPaymentsQuery({
 *   participant: // value for 'participant'
 *   legal_entity: // value for 'legal_entity'
 * });
 */
export function useViewsBulkPayments_GetBulkPaymentsQuery(variables: ViewsBulkPayments_GetBulkPaymentsQueryVariables | VueCompositionApi.Ref<ViewsBulkPayments_GetBulkPaymentsQueryVariables> | ReactiveFunction<ViewsBulkPayments_GetBulkPaymentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables>(ViewsBulkPayments_GetBulkPaymentsDocument, variables, options);
}
export function useViewsBulkPayments_GetBulkPaymentsLazyQuery(variables: ViewsBulkPayments_GetBulkPaymentsQueryVariables | VueCompositionApi.Ref<ViewsBulkPayments_GetBulkPaymentsQueryVariables> | ReactiveFunction<ViewsBulkPayments_GetBulkPaymentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables>(ViewsBulkPayments_GetBulkPaymentsDocument, variables, options);
}
export type ViewsBulkPayments_GetBulkPaymentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsBulkPayments_GetBulkPaymentsQuery, ViewsBulkPayments_GetBulkPaymentsQueryVariables>;
export const ViewsBulkPayment_GetPaymentTransferConfigurationDocument = gql`
    query ViewsBulkPayment_GetPaymentTransferConfiguration($reference: uuid!, $participant: uuid!) {
  legal_entity: risolto_legal_entity(
    where: {reference: {_eq: $reference}, participant: {_eq: $participant}}
  ) {
    reference
    participant
    payment_transfer_configuration: processing_details(path: "payment_transfer")
  }
}
    `;

/**
 * __useViewsBulkPayment_GetPaymentTransferConfigurationQuery__
 *
 * To run a query within a Vue component, call `useViewsBulkPayment_GetPaymentTransferConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsBulkPayment_GetPaymentTransferConfigurationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsBulkPayment_GetPaymentTransferConfigurationQuery({
 *   reference: // value for 'reference'
 *   participant: // value for 'participant'
 * });
 */
export function useViewsBulkPayment_GetPaymentTransferConfigurationQuery(variables: ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables | VueCompositionApi.Ref<ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables> | ReactiveFunction<ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>(ViewsBulkPayment_GetPaymentTransferConfigurationDocument, variables, options);
}
export function useViewsBulkPayment_GetPaymentTransferConfigurationLazyQuery(variables: ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables | VueCompositionApi.Ref<ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables> | ReactiveFunction<ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>(ViewsBulkPayment_GetPaymentTransferConfigurationDocument, variables, options);
}
export type ViewsBulkPayment_GetPaymentTransferConfigurationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsBulkPayment_GetPaymentTransferConfigurationQuery, ViewsBulkPayment_GetPaymentTransferConfigurationQueryVariables>;
export const ViewsPaymentTransfer_PaymentTransfersDocument = gql`
    query ViewsPaymentTransfer_PaymentTransfers($participant: uuid!, $legal_entity: uuid!) {
  records: risolto_payment_transfer(
    order_by: {group_date: desc}
    where: {participant: {_eq: $participant}, legal_entity: {_eq: $legal_entity}}
  ) {
    reference
    group_date
    account_number
    account_number_type
    bank_identifier
    bank_identifier_type
    creditor_name
    status
    created_at
    updated_at
    legal_entity
    participant
    reference
    idempotency_key
  }
}
    `;

/**
 * __useViewsPaymentTransfer_PaymentTransfersQuery__
 *
 * To run a query within a Vue component, call `useViewsPaymentTransfer_PaymentTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsPaymentTransfer_PaymentTransfersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsPaymentTransfer_PaymentTransfersQuery({
 *   participant: // value for 'participant'
 *   legal_entity: // value for 'legal_entity'
 * });
 */
export function useViewsPaymentTransfer_PaymentTransfersQuery(variables: ViewsPaymentTransfer_PaymentTransfersQueryVariables | VueCompositionApi.Ref<ViewsPaymentTransfer_PaymentTransfersQueryVariables> | ReactiveFunction<ViewsPaymentTransfer_PaymentTransfersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables>(ViewsPaymentTransfer_PaymentTransfersDocument, variables, options);
}
export function useViewsPaymentTransfer_PaymentTransfersLazyQuery(variables: ViewsPaymentTransfer_PaymentTransfersQueryVariables | VueCompositionApi.Ref<ViewsPaymentTransfer_PaymentTransfersQueryVariables> | ReactiveFunction<ViewsPaymentTransfer_PaymentTransfersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables>(ViewsPaymentTransfer_PaymentTransfersDocument, variables, options);
}
export type ViewsPaymentTransfer_PaymentTransfersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsPaymentTransfer_PaymentTransfersQuery, ViewsPaymentTransfer_PaymentTransfersQueryVariables>;
export const ViewsPaymentDocuments_DetailDocument = gql`
    query viewsPaymentDocuments_detail($payment_document: uuid!) {
  paymentDocument: risolto_payment_document(
    where: {reference: {_eq: $payment_document}}
  ) {
    payment_number
    amount_currency
    issue_date
    due_date
    reference
    file_references
    legal_entity
    legal_entity_by_reference {
      registration_name
      reference
      participant
      address
      company_id
      company_id_type
    }
    total_amount
    open_amount
    amount_currency
    participant
    interchange_links {
      reference
      interchange_by_reference {
        interchange_events {
          event_type
          event_type_count
          last_event_timestamp
          email: channel_endpoint(path: "$.email")
          postal_mail: channel_endpoint(path: "postal_mail")
        }
        reference
        channel
        direction
      }
    }
    recipient
    recipient_by_reference {
      preferred_invoicing_channel
      legal_entity
      legal_entity_by_reference {
        reference
      }
      participant
      reference
      legal_id
      legal_id_type
      address
      name
      account_id
    }
    dunning_status
    custom_fields
  }
}
    `;

/**
 * __useViewsPaymentDocuments_DetailQuery__
 *
 * To run a query within a Vue component, call `useViewsPaymentDocuments_DetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsPaymentDocuments_DetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsPaymentDocuments_DetailQuery({
 *   payment_document: // value for 'payment_document'
 * });
 */
export function useViewsPaymentDocuments_DetailQuery(variables: ViewsPaymentDocuments_DetailQueryVariables | VueCompositionApi.Ref<ViewsPaymentDocuments_DetailQueryVariables> | ReactiveFunction<ViewsPaymentDocuments_DetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables>(ViewsPaymentDocuments_DetailDocument, variables, options);
}
export function useViewsPaymentDocuments_DetailLazyQuery(variables: ViewsPaymentDocuments_DetailQueryVariables | VueCompositionApi.Ref<ViewsPaymentDocuments_DetailQueryVariables> | ReactiveFunction<ViewsPaymentDocuments_DetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables>(ViewsPaymentDocuments_DetailDocument, variables, options);
}
export type ViewsPaymentDocuments_DetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsPaymentDocuments_DetailQuery, ViewsPaymentDocuments_DetailQueryVariables>;
export const ViewsPaymentDocuments_UserInterfaceDetailsDocument = gql`
    query ViewsPaymentDocuments_userInterfaceDetails($participant: uuid!) {
  userInterfaceDetails: risolto_participant(
    where: {reference: {_eq: $participant}}
  ) {
    custom_field_definitions: user_interface_details(
      path: "payment_document.custom_field_definitions"
    )
  }
}
    `;

/**
 * __useViewsPaymentDocuments_UserInterfaceDetailsQuery__
 *
 * To run a query within a Vue component, call `useViewsPaymentDocuments_UserInterfaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsPaymentDocuments_UserInterfaceDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsPaymentDocuments_UserInterfaceDetailsQuery({
 *   participant: // value for 'participant'
 * });
 */
export function useViewsPaymentDocuments_UserInterfaceDetailsQuery(variables: ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>(ViewsPaymentDocuments_UserInterfaceDetailsDocument, variables, options);
}
export function useViewsPaymentDocuments_UserInterfaceDetailsLazyQuery(variables: ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables | VueCompositionApi.Ref<ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables> | ReactiveFunction<ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>(ViewsPaymentDocuments_UserInterfaceDetailsDocument, variables, options);
}
export type ViewsPaymentDocuments_UserInterfaceDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsPaymentDocuments_UserInterfaceDetailsQuery, ViewsPaymentDocuments_UserInterfaceDetailsQueryVariables>;
export const ViewsRecipientRecipientDetail_RecipientAttachmentsDocument = gql`
    query ViewsRecipientRecipientDetail_recipientAttachments($recipient: uuid!) {
  recipientAttachments: risolto_recipient_attachment(
    where: {recipient: {_eq: $recipient}}
  ) {
    metadata
  }
}
    `;

/**
 * __useViewsRecipientRecipientDetail_RecipientAttachmentsQuery__
 *
 * To run a query within a Vue component, call `useViewsRecipientRecipientDetail_RecipientAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsRecipientRecipientDetail_RecipientAttachmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsRecipientRecipientDetail_RecipientAttachmentsQuery({
 *   recipient: // value for 'recipient'
 * });
 */
export function useViewsRecipientRecipientDetail_RecipientAttachmentsQuery(variables: ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables | VueCompositionApi.Ref<ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables> | ReactiveFunction<ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>(ViewsRecipientRecipientDetail_RecipientAttachmentsDocument, variables, options);
}
export function useViewsRecipientRecipientDetail_RecipientAttachmentsLazyQuery(variables: ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables | VueCompositionApi.Ref<ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables> | ReactiveFunction<ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>(ViewsRecipientRecipientDetail_RecipientAttachmentsDocument, variables, options);
}
export type ViewsRecipientRecipientDetail_RecipientAttachmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsRecipientRecipientDetail_RecipientAttachmentsQuery, ViewsRecipientRecipientDetail_RecipientAttachmentsQueryVariables>;
export const ViewsRecipient_RecipientsTotalDocument = gql`
    query ViewsRecipient_recipientsTotal($participant: uuid!, $legalEntityFilter: [risolto_recipient_bool_exp!], $searchTermFilter: [risolto_recipient_bool_exp!], $tagsFilter: [risolto_recipient_bool_exp!], $customFieldsFilter: [risolto_recipient_bool_exp!]) {
  total: risolto_recipient_aggregate(
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}, {_and: $searchTermFilter}, {_and: $tagsFilter}, {_and: $customFieldsFilter}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useViewsRecipient_RecipientsTotalQuery__
 *
 * To run a query within a Vue component, call `useViewsRecipient_RecipientsTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsRecipient_RecipientsTotalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsRecipient_RecipientsTotalQuery({
 *   participant: // value for 'participant'
 *   legalEntityFilter: // value for 'legalEntityFilter'
 *   searchTermFilter: // value for 'searchTermFilter'
 *   tagsFilter: // value for 'tagsFilter'
 *   customFieldsFilter: // value for 'customFieldsFilter'
 * });
 */
export function useViewsRecipient_RecipientsTotalQuery(variables: ViewsRecipient_RecipientsTotalQueryVariables | VueCompositionApi.Ref<ViewsRecipient_RecipientsTotalQueryVariables> | ReactiveFunction<ViewsRecipient_RecipientsTotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables>(ViewsRecipient_RecipientsTotalDocument, variables, options);
}
export function useViewsRecipient_RecipientsTotalLazyQuery(variables: ViewsRecipient_RecipientsTotalQueryVariables | VueCompositionApi.Ref<ViewsRecipient_RecipientsTotalQueryVariables> | ReactiveFunction<ViewsRecipient_RecipientsTotalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables>(ViewsRecipient_RecipientsTotalDocument, variables, options);
}
export type ViewsRecipient_RecipientsTotalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsRecipient_RecipientsTotalQuery, ViewsRecipient_RecipientsTotalQueryVariables>;
export const ViewsRecipient_RecipientsDocument = gql`
    query ViewsRecipient_recipients($participant: uuid!, $limit: Int = 10, $offset: Int = 0, $legalEntityFilter: [risolto_recipient_bool_exp!], $searchTermFilter: [risolto_recipient_bool_exp!], $tagsFilter: [risolto_recipient_bool_exp!], $customFieldsFilter: [risolto_recipient_bool_exp!], $orderBy: [risolto_recipient_order_by!]) {
  recipients: risolto_recipient(
    limit: $limit
    offset: $offset
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}, {_and: $searchTermFilter}, {_and: $tagsFilter}, {_and: $customFieldsFilter}]}
    order_by: $orderBy
  ) {
    name
    reference
    type
    participant
    legal_id_type
    legal_id
    legal_entity
    account_id
  }
}
    `;

/**
 * __useViewsRecipient_RecipientsQuery__
 *
 * To run a query within a Vue component, call `useViewsRecipient_RecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsRecipient_RecipientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsRecipient_RecipientsQuery({
 *   participant: // value for 'participant'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 *   legalEntityFilter: // value for 'legalEntityFilter'
 *   searchTermFilter: // value for 'searchTermFilter'
 *   tagsFilter: // value for 'tagsFilter'
 *   customFieldsFilter: // value for 'customFieldsFilter'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useViewsRecipient_RecipientsQuery(variables: ViewsRecipient_RecipientsQueryVariables | VueCompositionApi.Ref<ViewsRecipient_RecipientsQueryVariables> | ReactiveFunction<ViewsRecipient_RecipientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables>(ViewsRecipient_RecipientsDocument, variables, options);
}
export function useViewsRecipient_RecipientsLazyQuery(variables: ViewsRecipient_RecipientsQueryVariables | VueCompositionApi.Ref<ViewsRecipient_RecipientsQueryVariables> | ReactiveFunction<ViewsRecipient_RecipientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables>(ViewsRecipient_RecipientsDocument, variables, options);
}
export type ViewsRecipient_RecipientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsRecipient_RecipientsQuery, ViewsRecipient_RecipientsQueryVariables>;
export const ViewsRecipient_RecipientDocument = gql`
    query ViewsRecipient_recipient($participant: uuid!, $recipient: uuid!) {
  risolto_recipient(
    where: {reference: {_eq: $recipient}, participant: {_eq: $participant}}
  ) {
    last_dunning_costs
    in_collection
    last_dunning_run_at
    name
    account_id
    participant
    participant_by_reference {
      reference
    }
    legal_entity
    legal_entity_by_reference {
      reference
      registration_name
      company_id
      company_id_type
      payment_plan: processing_details(path: "payment_plan")
    }
    address
    contacts {
      reference
      first_name
      last_name
    }
    channel_endpoints(where: {deactivated_at: {_is_null: true}}) {
      channel
      contact_by_reference {
        first_name
        last_name
      }
    }
    due_balance_amount
    balance_amount
    currency
    reference
    custom_fields
    legal_id_type
    legal_id
    type
    dunning_is_dirty
    prediction_stars
    tags {
      tag
      tag_name
      can_remove
    }
    collections {
      custom_fields
    }
    message_recipients(
      where: {message_by_reference: {archived_at: {_is_null: true}}}
    ) {
      reference
    }
  }
}
    `;

/**
 * __useViewsRecipient_RecipientQuery__
 *
 * To run a query within a Vue component, call `useViewsRecipient_RecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsRecipient_RecipientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsRecipient_RecipientQuery({
 *   participant: // value for 'participant'
 *   recipient: // value for 'recipient'
 * });
 */
export function useViewsRecipient_RecipientQuery(variables: ViewsRecipient_RecipientQueryVariables | VueCompositionApi.Ref<ViewsRecipient_RecipientQueryVariables> | ReactiveFunction<ViewsRecipient_RecipientQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables>(ViewsRecipient_RecipientDocument, variables, options);
}
export function useViewsRecipient_RecipientLazyQuery(variables: ViewsRecipient_RecipientQueryVariables | VueCompositionApi.Ref<ViewsRecipient_RecipientQueryVariables> | ReactiveFunction<ViewsRecipient_RecipientQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables>(ViewsRecipient_RecipientDocument, variables, options);
}
export type ViewsRecipient_RecipientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsRecipient_RecipientQuery, ViewsRecipient_RecipientQueryVariables>;
export const ViewsReports_ReportsDocument = gql`
    query ViewsReports_reports($participant: uuid!, $legalEntityFilter: [risolto_report_execution_bool_exp!], $limit: Int = 10, $offset: Int = 0) {
  total: risolto_report_execution_aggregate(
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}]}
  ) {
    aggregate {
      count
    }
  }
  reports: risolto_report_execution(
    limit: $limit
    offset: $offset
    where: {_and: [{participant: {_eq: $participant}}, {_and: $legalEntityFilter}]}
  ) {
    reference
    legal_entity_by_reference {
      registration_name
    }
    report_definition_by_reference {
      name
      report_template_type
    }
    report_path
    completed_at
  }
}
    `;

/**
 * __useViewsReports_ReportsQuery__
 *
 * To run a query within a Vue component, call `useViewsReports_ReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsReports_ReportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewsReports_ReportsQuery({
 *   participant: // value for 'participant'
 *   legalEntityFilter: // value for 'legalEntityFilter'
 *   limit: // value for 'limit'
 *   offset: // value for 'offset'
 * });
 */
export function useViewsReports_ReportsQuery(variables: ViewsReports_ReportsQueryVariables | VueCompositionApi.Ref<ViewsReports_ReportsQueryVariables> | ReactiveFunction<ViewsReports_ReportsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables>(ViewsReports_ReportsDocument, variables, options);
}
export function useViewsReports_ReportsLazyQuery(variables: ViewsReports_ReportsQueryVariables | VueCompositionApi.Ref<ViewsReports_ReportsQueryVariables> | ReactiveFunction<ViewsReports_ReportsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables>(ViewsReports_ReportsDocument, variables, options);
}
export type ViewsReports_ReportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewsReports_ReportsQuery, ViewsReports_ReportsQueryVariables>;